import React__default, { createElement, Fragment, Component, useState, useRef, useEffect, createContext, createRef, useContext, forwardRef, Children, isValidElement, cloneElement, useCallback } from 'react';
import Measure from 'react-measure';
import { Link as Link$1 } from 'react-router-dom';
import ReactDOM from 'react-dom';
import { debounce } from 'throttle-debounce';
import FocusTrap from 'focus-trap-react';
import { useSwipeable } from 'react-swipeable';
import AnimateHeight from 'react-animate-height';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import 'intersection-observer';
import Parser from 'html-react-parser';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/**
 * Takes a number and returns an array counting up to that number.
 * @param amount number
 * @returns number[]
 */
var count = function (amount) {
    var rangeArr = [];
    for (var i = 0; i < amount; i++) {
        rangeArr.push(i);
    }
    return rangeArr;
};

var isInBrowser = function () { return !!(typeof window !== 'undefined' && window.document && window.document.createElement); };

/**
 * Asserts the type of a variable by checking if the given property exists on the given variable
 * @param varToBeChecked Variable to assert type of
 * @param propertyToCheckFor Function checks for the existence of this property
 * @return boolean, but also asserts type for the TS compiler
 */
var isOfType = function (varToBeChecked, propertyToCheckFor) {
    return varToBeChecked[propertyToCheckFor] !== undefined;
};

/**
 * Checks if a point is within a Client Rect
 * @param clientRect the clientRect to check the point against
 * @param x the horizontal coordinate to check
 * @param y the vertical coordinate to check
 * @returns boolean
 */
var isPointInClientRect = function (clientRect, x, y) {
    var top = clientRect.top, left = clientRect.left, right = clientRect.right, bottom = clientRect.bottom;
    return top < y && y < bottom && left < x && x < right;
};

var joinClasses = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(function (c) { return Boolean(c); }).join(' ');
};

/**
 * Creates an array with numbers ranging from <from> to <to>
 * @param from number to start from
 * @param to number to end before
 * @returns an array of numbers
 */
var range = function (from, to) {
    var rangeArr = [];
    for (var i = from; i < to; i++) {
        rangeArr.push(i);
    }
    return rangeArr;
};

var _SuppressedError$1 = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var animations = createCommonjsModule(function (module) {
  module.exports.animationEasings = {};
  // This is the most common easing curve.
  module.exports.animationEasings.animateEaseInOut = 'cubic-bezier(0.4, 0, 0.2, 1)';
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  module.exports.animationEasings.animateEaseOut = 'cubic-bezier(0.0, 0, 0.2, 1)';
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  module.exports.animationEasings.animateEaseIn = 'cubic-bezier(0.4, 0, 1, 1)';
  // The sharp curve is used by objects that may return to the screen at any time.
  module.exports.animationEasings.animateEaseSharp = 'cubic-bezier(0.4, 0, 0.6, 1)';
  module.exports.animationDurations = {};
  module.exports.animationDurations.animateDurationMicro = 180;
  module.exports.animationDurations.animateDurationNormal = 300;
  module.exports.animationDurations.animateDurationMacro = 500;
  module.exports.animationDurations.animateDurationShortest = 150;
  module.exports.animationDurations.animateDurationShorter = 200;
  module.exports.animationDurations.animateDurationShort = 250;
  // most basic recommended timing
  module.exports.animationDurations.animateDurationStandard = 300;
  // this is to be used in complex animations
  module.exports.animationDurations.animateDurationComplex = 375;
  // recommended when something is entering screen
  module.exports.animationDurations.animateDurationEnter = 225;
  // recommended when something is leaving screen
  module.exports.animationDurations.animateDurationLeave = 195;
});

var mqSmallScreenMaxWidthLimit = 599;
var mqMediumScreenMinWidthLimit = 600;
var mqMediumScreenMaxWidthLimit = 959;
var mqLargeScreenMinWidthLimit = 960;
var breakpoints = {
  mqSmallScreenMaxWidthLimit: mqSmallScreenMaxWidthLimit,
  mqMediumScreenMinWidthLimit: mqMediumScreenMinWidthLimit,
  mqMediumScreenMaxWidthLimit: mqMediumScreenMaxWidthLimit,
  mqLargeScreenMinWidthLimit: mqLargeScreenMinWidthLimit
};

var columnCountSm = 4;
var columnCountMd = 12;
var columnCountLg = 12;
var columns = {
  columnCountSm: columnCountSm,
  columnCountMd: columnCountMd,
  columnCountLg: columnCountLg
};

var pageBgColor = '#FFFFFF';
var rootFontSize = 16;
var minTargetSize = 44;
var base = {
  pageBgColor: pageBgColor,
  rootFontSize: rootFontSize,
  minTargetSize: minTargetSize
};

var titleFontEn = 'UniqloProBold, system-ui, -apple-system, sans-serif';
var titleFontJa = '"ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "Hiragino Sans", "Noto Sans CJK JP", Osaka, Meiryo, メイリオ, "MS PGothic", "ＭＳ Ｐゴシック", YuGothic, "Yu Gothic", "Hiragino Sans GB", Helvetica Neue, HelveticaNeue , Helvetica, Noto Sans, Roboto,Arial, "Arial Unicode MS", sans-serif';
var regularFontEn = 'UniqloProRegular, sans-serif';
var lightFontEn = 'UniqloProLight, system-ui, -apple-system, sans-serif';
var bodyFontEn = "'Twemoji Country Flags','Helvetica Neue', Helvetica, Arial, system-ui, -apple-system, sans-serif";
var bodyFontJa = '"Twemoji Country Flags","ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "Hiragino Sans", "Noto Sans CJK JP", Osaka, Meiryo, メイリオ, "MS PGothic", "ＭＳ Ｐゴシック", YuGothic, "Yu Gothic", "Hiragino Sans GB", Helvetica Neue, HelveticaNeue , Helvetica, Noto Sans, Roboto,Arial, "Arial Unicode MS", sans-serif';
var bodyFontTh = '"Twemoji Country Flags","Leelawadee UI","Segoe UI",Thonburi,"Helvetica Neue",Helvetica,Arial,-apple-system,system-ui,sans-serif';
var font = {
  titleFontEn: titleFontEn,
  titleFontJa: titleFontJa,
  regularFontEn: regularFontEn,
  lightFontEn: lightFontEn,
  bodyFontEn: bodyFontEn,
  bodyFontJa: bodyFontJa,
  bodyFontTh: bodyFontTh
};

var FONT_WEIGHT_LIGHT = 300;
var FONT_WEIGHT_REGULAR = 400;
var FONT_WEIGHT_MEDIUM = 500;
var FONT_WEIGHT_SEMI_BOLD = 600;
var FONT_WEIGHT_BOLD = 700;
var FONT_WEIGHT_EXTRA_BOLD = 800;
var fontWeightLight = FONT_WEIGHT_LIGHT;
var fontWeightRegular = FONT_WEIGHT_REGULAR;
var fontWeightMedium = FONT_WEIGHT_MEDIUM;
var fontWeightSemiBold = FONT_WEIGHT_SEMI_BOLD;
var fontWeightBold = FONT_WEIGHT_BOLD;
var fontWeightExtraBold = FONT_WEIGHT_EXTRA_BOLD;
var fontWeight = {
  fontWeightLight: fontWeightLight,
  fontWeightRegular: fontWeightRegular,
  fontWeightMedium: fontWeightMedium,
  fontWeightSemiBold: fontWeightSemiBold,
  fontWeightBold: fontWeightBold,
  fontWeightExtraBold: fontWeightExtraBold
};

var gridSizeLg = 1200;
var gridSizeLgLimitWithFixedMargin = 1248;
var gridSizeLgLimitWithAutoMargin = 1249;
var grid = {
  gridSizeLg: gridSizeLg,
  gridSizeLgLimitWithFixedMargin: gridSizeLgLimitWithFixedMargin,
  gridSizeLgLimitWithAutoMargin: gridSizeLgLimitWithAutoMargin
};

var line_height_01 = 1;
var line_height_02 = 1.1;
var line_height_03 = 1.2;
var line_height_04 = 1.4;
var line_height_05 = 1.5;
var line_height_04_minus_1 = 1.3;
var lineHeight = {
  line_height_01: line_height_01,
  line_height_02: line_height_02,
  line_height_03: line_height_03,
  line_height_04: line_height_04,
  line_height_05: line_height_05,
  line_height_04_minus_1: line_height_04_minus_1
};

var rootFontSize$1 = base.rootFontSize;
var letterSpacingUniqloPro = rootFontSize$1 / 40;
var letterSpacing = {
  letterSpacingUniqloPro: letterSpacingUniqloPro
};

var BORDER_PRIMARY_OUTLINE_COLOR = '#000000';
var BORDER_PRIMARY_OUTLINE_HOVER_COLOR = '#2A2A2A';
var BORDER_NOTICEABLE_COLOR = '#005DB5';
var BORDER_NOTICEABLE_HOVER_COLOR = '#006ED7';
var BORDER_INTERACTIVE_OUTLINE_COLOR = '#767676';
var BORDER_INTERACTIVE_OUTLINE_HOVER_COLOR = '#5D5D5D';
var BORDER_LINES_COLOR = '#DADADA';
var BORDER_LINES_HOVER_COLOR = '#DADADA';
var BORDER_FOCUS_COLOR = '#005DB5';
var BORDER_FOCUS_HOVER_COLOR = '#006ED7';
var BORDER_ERROR_COLOR = '#EE0000';
var BORDER_ERROR_HOVER_COLOR = '#DD3535';
var BORDER_BACKGROUND_COLOR = '#000000';
var BORDER_SECONDARY_COLOR = '#6A6A6A';
var BORDER_SELECTED_COLOR = '#000000';
var BORDER_SELECTED_HOVER_COLOR = '#2A2A2A';
var borderPrimaryOutlineColor = BORDER_PRIMARY_OUTLINE_COLOR;
var borderPrimaryOutlineHoverColor = BORDER_PRIMARY_OUTLINE_HOVER_COLOR;
var borderNoticeableColor = BORDER_NOTICEABLE_COLOR;
var borderNoticeableHoverColor = BORDER_NOTICEABLE_HOVER_COLOR;
var borderInteractiveOutlineColor = BORDER_INTERACTIVE_OUTLINE_COLOR;
var borderInteractiveOutlineHoverColor = BORDER_INTERACTIVE_OUTLINE_HOVER_COLOR;
var borderLinesColor = BORDER_LINES_COLOR;
var borderLinesHoverColor = BORDER_LINES_HOVER_COLOR;
var borderFocusColor = BORDER_FOCUS_COLOR;
var borderFocusHoverColor = BORDER_FOCUS_HOVER_COLOR;
var borderErrorColor = BORDER_ERROR_COLOR;
var borderErrorHoverColor = BORDER_ERROR_HOVER_COLOR;
var borderBackgroundColor = BORDER_BACKGROUND_COLOR;
var borderSecondaryColor = BORDER_SECONDARY_COLOR;
var borderSelectedColor = BORDER_SELECTED_COLOR;
var borderSelectedHoverColor = BORDER_SELECTED_HOVER_COLOR;
var border = {
  borderPrimaryOutlineColor: borderPrimaryOutlineColor,
  borderPrimaryOutlineHoverColor: borderPrimaryOutlineHoverColor,
  borderNoticeableColor: borderNoticeableColor,
  borderNoticeableHoverColor: borderNoticeableHoverColor,
  borderInteractiveOutlineColor: borderInteractiveOutlineColor,
  borderInteractiveOutlineHoverColor: borderInteractiveOutlineHoverColor,
  borderLinesColor: borderLinesColor,
  borderLinesHoverColor: borderLinesHoverColor,
  borderFocusColor: borderFocusColor,
  borderFocusHoverColor: borderFocusHoverColor,
  borderErrorColor: borderErrorColor,
  borderErrorHoverColor: borderErrorHoverColor,
  borderBackgroundColor: borderBackgroundColor,
  borderSecondaryColor: borderSecondaryColor,
  borderSelectedColor: borderSelectedColor,
  borderSelectedHoverColor: borderSelectedHoverColor
};

var FILL_ATTENTION_COLOR = '#EE0000';
var FILL_ATTENTION_HOVER_COLOR = '#EF5555';
var FILL_PRIMARY_COLOR = '#000000';
var FILL_PRIMARY_FLOATING_COLOR = 'rgba(0, 0, 0, 0.9)';
var FILL_PRIMARY_HOVER_COLOR = '#2A2A2A';
var FILL_PROMOTIONAL_COLOR = '#FF0000';
var FILL_PROMOTIONAL_HOVER_COLOR = '#EE3535';
var FILL_SECONDARY_COLOR = '#FFFFFF';
var FILL_SECONDARY_FLOATING_COLOR = 'rgba(255, 255, 255, 0.9)';
var FILL_SECONDARY_HOVER_COLOR = '#FFFFFF';
var FILL_TERTIARY_COLOR = '#474747';
var FILL_NOTICEABLE_COLOR = '#005DB5';
var FILL_NOTICEABLE_HOVER_COLOR = '#006ED7';
var FILL_INTERACTIVE_COLOR = '#949494';
var FILL_INTERACTIVE_HOVER_COLOR = '#BCBCBC';
var FILL_DISABLED_COLOR = '#DADADA';
var FILL_DISABLED_HOVER_COLOR = '#DADADA';
var FILL_ERROR_COLOR = '#EE0000';
var FILL_ERROR_HOVER_COLOR = '#EF5555';
var FILL_SELECTED_COLOR = '#000000';
var FILL_SELECTED_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_TAB_COLOR = '#000000';
var FILL_BACKGROUND_COLOR = '#F4F4F4';
var FILL_BACKGROUND_HOVER_COLOR = '#F4F4F4';
var FILL_BACKGROUND_BALLOON_TIP_COLOR = 'rgba(0, 0, 0, 0.85)';
var FILL_SELECTED_TAB_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_STAR_COLOR = '#000000';
var FILL_SELECTED_STAR_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_HEART_COLOR = '#EE0000';
var FILL_SELECTED_HEART_HOVER_COLOR = '#DD3535';
var FILL_POSITIVE_COLOR = '#00AB0F';
var FILL_BACKGROUND_SELECTED_COLOR = '#F4F4F4';
var FILL_OVERLAY_COLOR = 'rgba(0, 0, 0, 0.5)';
var FILL_SKELETON_COLOR = '#F4F4F4';
var FILL_SKELETON_HIGHLIGHT_COLOR = '#FAFAFA';
var fillAttentionColor = FILL_ATTENTION_COLOR;
var fillAttentionHoverColor = FILL_ATTENTION_HOVER_COLOR;
var fillPrimaryColor = FILL_PRIMARY_COLOR;
var fillPrimaryFloatingColor = FILL_PRIMARY_FLOATING_COLOR;
var fillPrimaryHoverColor = FILL_PRIMARY_HOVER_COLOR;
var fillPromotionalColor = FILL_PROMOTIONAL_COLOR;
var fillPromotionalHoverColor = FILL_PROMOTIONAL_HOVER_COLOR;
var fillSecondaryColor = FILL_SECONDARY_COLOR;
var fillSecondaryFloatingColor = FILL_SECONDARY_FLOATING_COLOR;
var fillSecondaryHoverColor = FILL_SECONDARY_HOVER_COLOR;
var fillTertiaryColor = FILL_TERTIARY_COLOR;
var fillNoticeableColor = FILL_NOTICEABLE_COLOR;
var fillNoticeableHoverColor = FILL_NOTICEABLE_HOVER_COLOR;
var fillInteractiveColor = FILL_INTERACTIVE_COLOR;
var fillInteractiveHoverColor = FILL_INTERACTIVE_HOVER_COLOR;
var fillDisabledColor = FILL_DISABLED_COLOR;
var fillDisabledHoverColor = FILL_DISABLED_HOVER_COLOR;
var fillErrorColor = FILL_ERROR_COLOR;
var fillErrorHoverColor = FILL_ERROR_HOVER_COLOR;
var fillSelectedColor = FILL_SELECTED_COLOR;
var fillSelectedHoverColor = FILL_SELECTED_HOVER_COLOR;
var fillSelectedTabColor = FILL_SELECTED_TAB_COLOR;
var fillBackgroundColor = FILL_BACKGROUND_COLOR;
var fillBackgroundHoverColor = FILL_BACKGROUND_HOVER_COLOR;
var fillBackgroundBalloonTipColor = FILL_BACKGROUND_BALLOON_TIP_COLOR;
var fillSelectedTabHoverColor = FILL_SELECTED_TAB_HOVER_COLOR;
var fillSelectedStarColor = FILL_SELECTED_STAR_COLOR;
var fillSelectedStarHoverColor = FILL_SELECTED_STAR_HOVER_COLOR;
var fillSelectedHeartColor = FILL_SELECTED_HEART_COLOR;
var fillSelectedHeartHoverColor = FILL_SELECTED_HEART_HOVER_COLOR;
var fillPositiveColor = FILL_POSITIVE_COLOR;
var fillBackgroundSelectedColor = FILL_BACKGROUND_SELECTED_COLOR;
var fillOverlayColor = FILL_OVERLAY_COLOR;
var fillSkeletonColor = FILL_SKELETON_COLOR;
var fillSkeletonHighlightColor = FILL_SKELETON_HIGHLIGHT_COLOR;
var fill = {
  fillAttentionColor: fillAttentionColor,
  fillAttentionHoverColor: fillAttentionHoverColor,
  fillPrimaryColor: fillPrimaryColor,
  fillPrimaryFloatingColor: fillPrimaryFloatingColor,
  fillPrimaryHoverColor: fillPrimaryHoverColor,
  fillPromotionalColor: fillPromotionalColor,
  fillPromotionalHoverColor: fillPromotionalHoverColor,
  fillSecondaryColor: fillSecondaryColor,
  fillSecondaryFloatingColor: fillSecondaryFloatingColor,
  fillSecondaryHoverColor: fillSecondaryHoverColor,
  fillTertiaryColor: fillTertiaryColor,
  fillNoticeableColor: fillNoticeableColor,
  fillNoticeableHoverColor: fillNoticeableHoverColor,
  fillInteractiveColor: fillInteractiveColor,
  fillInteractiveHoverColor: fillInteractiveHoverColor,
  fillDisabledColor: fillDisabledColor,
  fillDisabledHoverColor: fillDisabledHoverColor,
  fillErrorColor: fillErrorColor,
  fillErrorHoverColor: fillErrorHoverColor,
  fillSelectedColor: fillSelectedColor,
  fillSelectedHoverColor: fillSelectedHoverColor,
  fillSelectedTabColor: fillSelectedTabColor,
  fillBackgroundColor: fillBackgroundColor,
  fillBackgroundHoverColor: fillBackgroundHoverColor,
  fillBackgroundBalloonTipColor: fillBackgroundBalloonTipColor,
  fillSelectedTabHoverColor: fillSelectedTabHoverColor,
  fillSelectedStarColor: fillSelectedStarColor,
  fillSelectedStarHoverColor: fillSelectedStarHoverColor,
  fillSelectedHeartColor: fillSelectedHeartColor,
  fillSelectedHeartHoverColor: fillSelectedHeartHoverColor,
  fillPositiveColor: fillPositiveColor,
  fillBackgroundSelectedColor: fillBackgroundSelectedColor,
  fillOverlayColor: fillOverlayColor,
  fillSkeletonColor: fillSkeletonColor,
  fillSkeletonHighlightColor: fillSkeletonHighlightColor
};

var TEXT_PRIMARY_DARK_COLOR = '#000000';
var TEXT_PRIMARY_DARK_HOVER_COLOR = '#2A2A2A';
var TEXT_PRIMARY_LIGHT_COLOR = '#FFFFFF';
var TEXT_PRIMARY_LIGHT_HOVER_COLOR = '#FFFFFF';
var TEXT_SECONDARY_COLOR = '#6A6A6A';
var TEXT_SECONDARY_HOVER_COLOR = '#919191';
var TEXT_NOTICEABLE_COLOR = '#005DB5';
var TEXT_NOTICEABLE_HOVER_COLOR = '#006ED7';
var TEXT_DISABLED_COLOR = '#ABABAB';
var TEXT_DISABLED_HOVER_COLOR = '#ABABAB';
var TEXT_ERROR_COLOR = '#EE0000';
var TEXT_ERROR_HOVER_COLOR = '#EF5555';
var TEXT_PROMOTIONAL_COLOR = '#EE0000';
var TEXT_PROMOTIONAL_HOVER_COLOR = '#EF5555';
var TEXT_PLACEHOLDER_COLOR = '#767676';
var TEXT_PLACEHOLDER_HOVER_COLOR = '#767676';
var TEXT_TERTIARY_COLOR = '#767676';
var TEXT_SELECTED_TAB_NAVIGATION_COLOR = '#000000';
var TEXT_POSITIVE_COLOR = '#008A24';
var TEXT_NOTICEABLE_BLUE_COLOR = '#005DB5';
var TEXT_NOTICEABLE_BLUE_HOVER_COLOR = '#006ED7';
var TEXT_NOTICEABLE_BLACK_COLOR = '#000000';
var textPrimaryDarkColor = TEXT_PRIMARY_DARK_COLOR;
var textPrimaryDarkHoverColor = TEXT_PRIMARY_DARK_HOVER_COLOR;
var textPrimaryLightColor = TEXT_PRIMARY_LIGHT_COLOR;
var textPrimaryLightHoverColor = TEXT_PRIMARY_LIGHT_HOVER_COLOR;
var textSecondaryColor = TEXT_SECONDARY_COLOR;
var textSecondaryHoverColor = TEXT_SECONDARY_HOVER_COLOR;
var textNoticeableColor = TEXT_NOTICEABLE_COLOR;
var textNoticeableHoverColor = TEXT_NOTICEABLE_HOVER_COLOR;
var textDisabledColor = TEXT_DISABLED_COLOR;
var textDisabledHoverColor = TEXT_DISABLED_HOVER_COLOR;
var textErrorColor = TEXT_ERROR_COLOR;
var textErrorHoverColor = TEXT_ERROR_HOVER_COLOR;
var textPromotionalColor = TEXT_PROMOTIONAL_COLOR;
var textPromotionalHoverColor = TEXT_PROMOTIONAL_HOVER_COLOR;
var textPlaceholderColor = TEXT_PLACEHOLDER_COLOR;
var textPlaceholderHoverColor = TEXT_PLACEHOLDER_HOVER_COLOR;
var textTertiaryColor = TEXT_TERTIARY_COLOR;
var textSelectedTabNavigationColor = TEXT_SELECTED_TAB_NAVIGATION_COLOR;
var textPositiveColor = TEXT_POSITIVE_COLOR;
var textNoticeableBlueColor = TEXT_NOTICEABLE_BLUE_COLOR;
var textNoticeableBlueHoverColor = TEXT_NOTICEABLE_BLUE_HOVER_COLOR;
var textNoticeableBlackColor = TEXT_NOTICEABLE_BLACK_COLOR;
var text = {
  textPrimaryDarkColor: textPrimaryDarkColor,
  textPrimaryDarkHoverColor: textPrimaryDarkHoverColor,
  textPrimaryLightColor: textPrimaryLightColor,
  textPrimaryLightHoverColor: textPrimaryLightHoverColor,
  textSecondaryColor: textSecondaryColor,
  textSecondaryHoverColor: textSecondaryHoverColor,
  textNoticeableColor: textNoticeableColor,
  textNoticeableHoverColor: textNoticeableHoverColor,
  textDisabledColor: textDisabledColor,
  textDisabledHoverColor: textDisabledHoverColor,
  textErrorColor: textErrorColor,
  textErrorHoverColor: textErrorHoverColor,
  textPromotionalColor: textPromotionalColor,
  textPromotionalHoverColor: textPromotionalHoverColor,
  textPlaceholderColor: textPlaceholderColor,
  textPlaceholderHoverColor: textPlaceholderHoverColor,
  textTertiaryColor: textTertiaryColor,
  textSelectedTabNavigationColor: textSelectedTabNavigationColor,
  textPositiveColor: textPositiveColor,
  textNoticeableBlueColor: textNoticeableBlueColor,
  textNoticeableBlueHoverColor: textNoticeableBlueHoverColor,
  textNoticeableBlackColor: textNoticeableBlackColor
};

var EFFECTS_BOX_SHADOW_COLOR = '#1B1B1B';
var effectsBoxShadowColor = EFFECTS_BOX_SHADOW_COLOR;
var effects = {
  effectsBoxShadowColor: effectsBoxShadowColor
};

var UI_ATTENTION_DEFAULT_COLOR = '#FF0000';
var UI_ATTENTION_HOVER_COLOR = '#FF5959';
var UI_PRIMARY_DEFAULT_COLOR = '#1B1B1B';
var UI_PRIMARY_HOVER_COLOR = '#6A6A6A';
var UI_SECONDARY_DEFAULT_OUTLINE_COLOR = '#1B1B1B';
var UI_SECONDARY_DEFAULT_BACKGROUND_COLOR = '#FFFFFF';
var UI_SECONDARY_DEFAULT_HOVER_COLOR = '#6A6A6A';
var UI_GLOBAL_BACKGROUND_COLOR = '#F4F4F4';
var UI_GLOBAL_ERROR_COLOR = '#CC0000';
var UI_GLOBAL_FOCUS_COLOR = '#006ED7';
var UI_GLOBAL_FOCUS_ERROR_COLOR = '#CC0000';
var UI_GLOBAL_DISABLED_COLOR = '#DADADA';
var UI_GLOBAL_BORDER_COLOR = '#DADADA';
var UI_GLOBAL_INTERACTIVE_COLOR = '#ABABAB';
var UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR = '#F7F7F7';
var UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR = '#FFFFFF';
var SUPPORTING_GENDER_WOMEN_COLOR = '#FF0000';
var SUPPORTING_GENDER_MEN_COLOR = '#000082';
var SUPPORTING_GENDER_KIDS_COLOR = '#50B4F0';
var SUPPORTING_GENDER_BABY_COLOR = '#96C800';
var SUPPORTING_GENDER_GIRLS_COLOR = '#EB64A5';
var SUPPORTING_GENDER_BOYS_COLOR = '#0091D7';
var COLOR_YELLOW = '#ebbe00';
var uiAttentionDefaultColor = UI_ATTENTION_DEFAULT_COLOR;
var uiAttentionHoverColor = UI_ATTENTION_HOVER_COLOR;
var uiPrimaryDefaultColor = UI_PRIMARY_DEFAULT_COLOR;
var uiPrimaryHoverColor = UI_PRIMARY_HOVER_COLOR;
var uiSecondaryDefaultOutlineColor = UI_SECONDARY_DEFAULT_OUTLINE_COLOR;
var uiSecondaryDefaultBackgroundColor = UI_SECONDARY_DEFAULT_BACKGROUND_COLOR;
var uiSecondaryDefaultHoverColor = UI_SECONDARY_DEFAULT_HOVER_COLOR;
var uiGlobalBackgroundColor = UI_GLOBAL_BACKGROUND_COLOR;
var uiGlobalErrorColor = UI_GLOBAL_ERROR_COLOR;
var uiGlobalFocusColor = UI_GLOBAL_FOCUS_COLOR;
var uiGlobalFocusErrorColor = UI_GLOBAL_FOCUS_ERROR_COLOR;
var uiGlobalDisabledColor = UI_GLOBAL_DISABLED_COLOR;
var uiGlobalBorderColor = UI_GLOBAL_BORDER_COLOR;
var uiGlobalInteractiveColor = UI_GLOBAL_INTERACTIVE_COLOR;
var uiFormInputsBackgroundPassiveColor = UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR;
var uiFormInputsBackgroundActiveColor = UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR;
var supportingGenderWomenColor = SUPPORTING_GENDER_WOMEN_COLOR;
var supportingGenderMenColor = SUPPORTING_GENDER_MEN_COLOR;
var supportingGenderKidsColor = SUPPORTING_GENDER_KIDS_COLOR;
var supportingGenderBabyColor = SUPPORTING_GENDER_BABY_COLOR;
var supportingGenderGirlsColor = SUPPORTING_GENDER_GIRLS_COLOR;
var supportingGenderBoysColor = SUPPORTING_GENDER_BOYS_COLOR;
var colorYellow = COLOR_YELLOW;
var additionals = {
  uiAttentionDefaultColor: uiAttentionDefaultColor,
  uiAttentionHoverColor: uiAttentionHoverColor,
  uiPrimaryDefaultColor: uiPrimaryDefaultColor,
  uiPrimaryHoverColor: uiPrimaryHoverColor,
  uiSecondaryDefaultOutlineColor: uiSecondaryDefaultOutlineColor,
  uiSecondaryDefaultBackgroundColor: uiSecondaryDefaultBackgroundColor,
  uiSecondaryDefaultHoverColor: uiSecondaryDefaultHoverColor,
  uiGlobalBackgroundColor: uiGlobalBackgroundColor,
  uiGlobalErrorColor: uiGlobalErrorColor,
  uiGlobalFocusColor: uiGlobalFocusColor,
  uiGlobalFocusErrorColor: uiGlobalFocusErrorColor,
  uiGlobalDisabledColor: uiGlobalDisabledColor,
  uiGlobalBorderColor: uiGlobalBorderColor,
  uiGlobalInteractiveColor: uiGlobalInteractiveColor,
  uiFormInputsBackgroundPassiveColor: uiFormInputsBackgroundPassiveColor,
  uiFormInputsBackgroundActiveColor: uiFormInputsBackgroundActiveColor,
  supportingGenderWomenColor: supportingGenderWomenColor,
  supportingGenderMenColor: supportingGenderMenColor,
  supportingGenderKidsColor: supportingGenderKidsColor,
  supportingGenderBabyColor: supportingGenderBabyColor,
  supportingGenderGirlsColor: supportingGenderGirlsColor,
  supportingGenderBoysColor: supportingGenderBoysColor,
  colorYellow: colorYellow
};

var color = {
  border: border,
  fill: fill,
  text: text,
  effects: effects,
  additionals: additionals
};

var DISPLAY1_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY1_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY2_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY2_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY3_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY3_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY4_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY4_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY5_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY5_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DYNAMIC_COLOR_DISABLED = color.text.textDisabledColor;
var DYNAMIC_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var TITLE_COLOR_DISABLED = color.text.textDisabledColor;
var TITLE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var TITLE_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var FLAG_COLOR_SECONDARY = color.text.textSecondaryColor;
var BADGE_LARGE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BADGE_SMALL_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BADGE_LARGE_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var BADGE_SMALL_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var CAPTION_STANDARD_COLOR_ERROR = color.text.textErrorColor;
var CAPTION_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var CAPTION_STANDARD_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var CAPTION_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var CAPTION_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var CAPTION_EMPHASIZED_COLOR_ERROR = color.text.textErrorColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_EMPHASIZED_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var CAPTION_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_PRIMARY_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_PRIMARY_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_PRIMARY_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_PRIMARY_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_SECONDARY_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_SECONDARY_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_SECONDARY_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_SECONDARY_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_SECONDARY_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_SECONDARY_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_TERTIARY_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_TERTIARY_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_SUPPORTIVE_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_SUPPORTIVE_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_SUPPORTIVE_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var BODY_STANDARD_COLOR_PLACEHOLDER = color.text.textPlaceholderColor;
var BODY_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var BODY_STANDARD_COLOR_ERROR = color.text.textErrorColor;
var BODY_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BODY_STANDARD_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var BODY_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var BODY_STANDARD_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var BODY_EMPHASIZED_COLOR_PLACEHOLDER = color.text.textPlaceholderColor;
var BODY_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var BODY_EMPHASIZED_COLOR_ERROR = color.text.textErrorColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BODY_EMPHASIZED_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var BODY_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var PRICE_SMALL_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_SMALL_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var PRICE_MEDIUM_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_MEDIUM_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var PRICE_LARGE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_LARGE_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var HINT_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var HINT_COLOR_SECONDARY = color.text.textSecondaryColor;
var HINT_COLOR_DISABLED = color.text.textDisabledColor;
var HINT_COLOR_ERROR = color.text.textErrorColor;
var PILL_FORM_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PILL_FORM_COLOR_PLACEHOLDER = color.text.textPlaceholderColor;
var PILL_FORM_COLOR_DISABLED = color.text.textDisabledColor;
var display1_ColorDisabled = DISPLAY1_COLOR_DISABLED;
var display1_ColorPrimaryDark = DISPLAY1_COLOR_PRIMARY_DARK;
var display2_ColorDisabled = DISPLAY2_COLOR_DISABLED;
var display2_ColorPrimaryDark = DISPLAY2_COLOR_PRIMARY_DARK;
var display3_ColorDisabled = DISPLAY3_COLOR_DISABLED;
var display3_ColorPrimaryDark = DISPLAY3_COLOR_PRIMARY_DARK;
var display4_ColorDisabled = DISPLAY4_COLOR_DISABLED;
var display4_ColorPrimaryDark = DISPLAY4_COLOR_PRIMARY_DARK;
var display5_ColorDisabled = DISPLAY5_COLOR_DISABLED;
var display5_ColorPrimaryDark = DISPLAY5_COLOR_PRIMARY_DARK;
var dynamic_ColorDisabled = DYNAMIC_COLOR_DISABLED;
var dynamic_ColorPrimaryDark = DYNAMIC_COLOR_PRIMARY_DARK;
var titleColorDisabled = TITLE_COLOR_DISABLED;
var titleColorPrimaryDark = TITLE_COLOR_PRIMARY_DARK;
var titleColorPromotional = TITLE_COLOR_PROMOTIONAL;
var flagColorSecondary = FLAG_COLOR_SECONDARY;
var badgeLargeColorPrimaryDark = BADGE_LARGE_COLOR_PRIMARY_DARK;
var badgeSmallColorPrimaryDark = BADGE_SMALL_COLOR_PRIMARY_DARK;
var badgeLargeColorPrimaryLight = BADGE_LARGE_COLOR_PRIMARY_LIGHT;
var badgeSmallColorPrimaryLight = BADGE_SMALL_COLOR_PRIMARY_LIGHT;
var captionStandardColorDisabled = CAPTION_STANDARD_COLOR_DISABLED;
var captionStandardColorError = CAPTION_STANDARD_COLOR_ERROR;
var captionStandardColorPrimaryDark = CAPTION_STANDARD_COLOR_PRIMARY_DARK;
var captionStandardColorPrimaryLight = CAPTION_STANDARD_COLOR_PRIMARY_LIGHT;
var captionStandardColorPromotional = CAPTION_STANDARD_COLOR_PROMOTIONAL;
var captionStandardColorSecondary = CAPTION_STANDARD_COLOR_SECONDARY;
var captionEmphasizedColorDisabled = CAPTION_EMPHASIZED_COLOR_DISABLED;
var captionEmphasizedColorError = CAPTION_EMPHASIZED_COLOR_ERROR;
var captionEmphasizedColorPrimaryDark = CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK;
var captionEmphasizedColorPrimaryLight = CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT;
var captionEmphasizedColorPromotional = CAPTION_EMPHASIZED_COLOR_PROMOTIONAL;
var captionEmphasizedColorSecondary = CAPTION_EMPHASIZED_COLOR_SECONDARY;
var labelPrimaryColorPrimaryDark = LABEL_PRIMARY_COLOR_PRIMARY_DARK;
var labelPrimaryColorPrimaryLight = LABEL_PRIMARY_COLOR_PRIMARY_LIGHT;
var labelPrimaryColorDisabled = LABEL_PRIMARY_COLOR_DISABLED;
var labelPrimaryColorSecondary = LABEL_PRIMARY_COLOR_SECONDARY;
var labelPrimaryColorPrimaryHover = LABEL_PRIMARY_COLOR_PRIMARY_HOVER;
var labelPrimaryColorInteractive = LABEL_PRIMARY_COLOR_INTERACTIVE;
var labelSecondaryColorPrimaryDark = LABEL_SECONDARY_COLOR_PRIMARY_DARK;
var labelSecondaryColorPrimaryLight = LABEL_SECONDARY_COLOR_PRIMARY_LIGHT;
var labelSecondaryColorDisabled = LABEL_SECONDARY_COLOR_DISABLED;
var labelSecondaryColorSecondary = LABEL_SECONDARY_COLOR_SECONDARY;
var labelSecondaryColorPrimaryHover = LABEL_SECONDARY_COLOR_PRIMARY_HOVER;
var labelSecondaryColorInteractive = LABEL_SECONDARY_COLOR_INTERACTIVE;
var labelTertiaryStandardColorPrimaryDark = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK;
var labelTertiaryStandardColorPrimaryLight = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT;
var labelTertiaryStandardColorDisabled = LABEL_TERTIARY_STANDARD_COLOR_DISABLED;
var labelTertiaryStandardColorSecondary = LABEL_TERTIARY_STANDARD_COLOR_SECONDARY;
var labelTertiaryStandardColorPrimaryHover = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER;
var labelTertiaryStandardColorInteractive = LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE;
var labelTertiaryEmphasizedColorPrimaryDark = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK;
var labelTertiaryEmphasizedColorPrimaryLight = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT;
var labelTertiaryEmphasizedColorDisabled = LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED;
var labelTertiaryEmphasizedColorSecondary = LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY;
var labelTertiaryEmphasizedColorPrimaryHover = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER;
var labelTertiaryEmphasizedColorInteractive = LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE;
var labelSupportiveColorPrimaryDark = LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK;
var labelSupportiveColorPrimaryLight = LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT;
var labelSupportiveColorDisabled = LABEL_SUPPORTIVE_COLOR_DISABLED;
var labelSupportiveColorSecondary = LABEL_SUPPORTIVE_COLOR_SECONDARY;
var labelSupportiveColorPrimaryHover = LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER;
var labelSupportiveColorInteractive = LABEL_SUPPORTIVE_COLOR_INTERACTIVE;
var bodyStandardColorPlaceholder = BODY_STANDARD_COLOR_PLACEHOLDER;
var bodyStandardColorDisabled = BODY_STANDARD_COLOR_DISABLED;
var bodyStandardColorError = BODY_STANDARD_COLOR_ERROR;
var bodyStandardColorPrimaryDark = BODY_STANDARD_COLOR_PRIMARY_DARK;
var bodyStandardColorPromotional = BODY_STANDARD_COLOR_PROMOTIONAL;
var bodyStandardColorSecondary = BODY_STANDARD_COLOR_SECONDARY;
var bodyStandardColorPrimaryHover = BODY_STANDARD_COLOR_PRIMARY_HOVER;
var bodyEmphasizedColorPlaceholder = BODY_EMPHASIZED_COLOR_PLACEHOLDER;
var bodyEmphasizedColorDisabled = BODY_EMPHASIZED_COLOR_DISABLED;
var bodyEmphasizedColorError = BODY_EMPHASIZED_COLOR_ERROR;
var bodyEmphasizedColorPrimaryDark = BODY_EMPHASIZED_COLOR_PRIMARY_DARK;
var bodyEmphasizedColorPromotional = BODY_EMPHASIZED_COLOR_PROMOTIONAL;
var bodyEmphasizedColorSecondary = BODY_EMPHASIZED_COLOR_SECONDARY;
var bodyEmphasizedColorPrimaryHover = BODY_EMPHASIZED_COLOR_PRIMARY_HOVER;
var priceSmallColorPrimaryDark = PRICE_SMALL_COLOR_PRIMARY_DARK;
var priceSmallColorPromotional = PRICE_SMALL_COLOR_PROMOTIONAL;
var priceMediumColorPrimaryDark = PRICE_MEDIUM_COLOR_PRIMARY_DARK;
var priceMediumColorPromotional = PRICE_MEDIUM_COLOR_PROMOTIONAL;
var priceLargeColorPrimaryDark = PRICE_LARGE_COLOR_PRIMARY_DARK;
var priceLargeColorPromotional = PRICE_LARGE_COLOR_PROMOTIONAL;
var hintColorPrimaryDark = HINT_COLOR_PRIMARY_DARK;
var hintColorSecondary = HINT_COLOR_SECONDARY;
var hintColorDisabled = HINT_COLOR_DISABLED;
var hintColorError = HINT_COLOR_ERROR;
var pillFormColorPrimaryDark = PILL_FORM_COLOR_PRIMARY_DARK;
var pillFormColorPlaceholder = PILL_FORM_COLOR_PLACEHOLDER;
var pillFormColorDisabled = PILL_FORM_COLOR_DISABLED;
var typographyColor = {
  display1_ColorDisabled: display1_ColorDisabled,
  display1_ColorPrimaryDark: display1_ColorPrimaryDark,
  display2_ColorDisabled: display2_ColorDisabled,
  display2_ColorPrimaryDark: display2_ColorPrimaryDark,
  display3_ColorDisabled: display3_ColorDisabled,
  display3_ColorPrimaryDark: display3_ColorPrimaryDark,
  display4_ColorDisabled: display4_ColorDisabled,
  display4_ColorPrimaryDark: display4_ColorPrimaryDark,
  display5_ColorDisabled: display5_ColorDisabled,
  display5_ColorPrimaryDark: display5_ColorPrimaryDark,
  dynamic_ColorDisabled: dynamic_ColorDisabled,
  dynamic_ColorPrimaryDark: dynamic_ColorPrimaryDark,
  titleColorDisabled: titleColorDisabled,
  titleColorPrimaryDark: titleColorPrimaryDark,
  titleColorPromotional: titleColorPromotional,
  flagColorSecondary: flagColorSecondary,
  badgeLargeColorPrimaryDark: badgeLargeColorPrimaryDark,
  badgeSmallColorPrimaryDark: badgeSmallColorPrimaryDark,
  badgeLargeColorPrimaryLight: badgeLargeColorPrimaryLight,
  badgeSmallColorPrimaryLight: badgeSmallColorPrimaryLight,
  captionStandardColorDisabled: captionStandardColorDisabled,
  captionStandardColorError: captionStandardColorError,
  captionStandardColorPrimaryDark: captionStandardColorPrimaryDark,
  captionStandardColorPrimaryLight: captionStandardColorPrimaryLight,
  captionStandardColorPromotional: captionStandardColorPromotional,
  captionStandardColorSecondary: captionStandardColorSecondary,
  captionEmphasizedColorDisabled: captionEmphasizedColorDisabled,
  captionEmphasizedColorError: captionEmphasizedColorError,
  captionEmphasizedColorPrimaryDark: captionEmphasizedColorPrimaryDark,
  captionEmphasizedColorPrimaryLight: captionEmphasizedColorPrimaryLight,
  captionEmphasizedColorPromotional: captionEmphasizedColorPromotional,
  captionEmphasizedColorSecondary: captionEmphasizedColorSecondary,
  labelPrimaryColorPrimaryDark: labelPrimaryColorPrimaryDark,
  labelPrimaryColorPrimaryLight: labelPrimaryColorPrimaryLight,
  labelPrimaryColorDisabled: labelPrimaryColorDisabled,
  labelPrimaryColorSecondary: labelPrimaryColorSecondary,
  labelPrimaryColorPrimaryHover: labelPrimaryColorPrimaryHover,
  labelPrimaryColorInteractive: labelPrimaryColorInteractive,
  labelSecondaryColorPrimaryDark: labelSecondaryColorPrimaryDark,
  labelSecondaryColorPrimaryLight: labelSecondaryColorPrimaryLight,
  labelSecondaryColorDisabled: labelSecondaryColorDisabled,
  labelSecondaryColorSecondary: labelSecondaryColorSecondary,
  labelSecondaryColorPrimaryHover: labelSecondaryColorPrimaryHover,
  labelSecondaryColorInteractive: labelSecondaryColorInteractive,
  labelTertiaryStandardColorPrimaryDark: labelTertiaryStandardColorPrimaryDark,
  labelTertiaryStandardColorPrimaryLight: labelTertiaryStandardColorPrimaryLight,
  labelTertiaryStandardColorDisabled: labelTertiaryStandardColorDisabled,
  labelTertiaryStandardColorSecondary: labelTertiaryStandardColorSecondary,
  labelTertiaryStandardColorPrimaryHover: labelTertiaryStandardColorPrimaryHover,
  labelTertiaryStandardColorInteractive: labelTertiaryStandardColorInteractive,
  labelTertiaryEmphasizedColorPrimaryDark: labelTertiaryEmphasizedColorPrimaryDark,
  labelTertiaryEmphasizedColorPrimaryLight: labelTertiaryEmphasizedColorPrimaryLight,
  labelTertiaryEmphasizedColorDisabled: labelTertiaryEmphasizedColorDisabled,
  labelTertiaryEmphasizedColorSecondary: labelTertiaryEmphasizedColorSecondary,
  labelTertiaryEmphasizedColorPrimaryHover: labelTertiaryEmphasizedColorPrimaryHover,
  labelTertiaryEmphasizedColorInteractive: labelTertiaryEmphasizedColorInteractive,
  labelSupportiveColorPrimaryDark: labelSupportiveColorPrimaryDark,
  labelSupportiveColorPrimaryLight: labelSupportiveColorPrimaryLight,
  labelSupportiveColorDisabled: labelSupportiveColorDisabled,
  labelSupportiveColorSecondary: labelSupportiveColorSecondary,
  labelSupportiveColorPrimaryHover: labelSupportiveColorPrimaryHover,
  labelSupportiveColorInteractive: labelSupportiveColorInteractive,
  bodyStandardColorPlaceholder: bodyStandardColorPlaceholder,
  bodyStandardColorDisabled: bodyStandardColorDisabled,
  bodyStandardColorError: bodyStandardColorError,
  bodyStandardColorPrimaryDark: bodyStandardColorPrimaryDark,
  bodyStandardColorPromotional: bodyStandardColorPromotional,
  bodyStandardColorSecondary: bodyStandardColorSecondary,
  bodyStandardColorPrimaryHover: bodyStandardColorPrimaryHover,
  bodyEmphasizedColorPlaceholder: bodyEmphasizedColorPlaceholder,
  bodyEmphasizedColorDisabled: bodyEmphasizedColorDisabled,
  bodyEmphasizedColorError: bodyEmphasizedColorError,
  bodyEmphasizedColorPrimaryDark: bodyEmphasizedColorPrimaryDark,
  bodyEmphasizedColorPromotional: bodyEmphasizedColorPromotional,
  bodyEmphasizedColorSecondary: bodyEmphasizedColorSecondary,
  bodyEmphasizedColorPrimaryHover: bodyEmphasizedColorPrimaryHover,
  priceSmallColorPrimaryDark: priceSmallColorPrimaryDark,
  priceSmallColorPromotional: priceSmallColorPromotional,
  priceMediumColorPrimaryDark: priceMediumColorPrimaryDark,
  priceMediumColorPromotional: priceMediumColorPromotional,
  priceLargeColorPrimaryDark: priceLargeColorPrimaryDark,
  priceLargeColorPromotional: priceLargeColorPromotional,
  hintColorPrimaryDark: hintColorPrimaryDark,
  hintColorSecondary: hintColorSecondary,
  hintColorDisabled: hintColorDisabled,
  hintColorError: hintColorError,
  pillFormColorPrimaryDark: pillFormColorPrimaryDark,
  pillFormColorPlaceholder: pillFormColorPlaceholder,
  pillFormColorDisabled: pillFormColorDisabled
};

var rootFontSize$2 = base.rootFontSize;
var SPACING_01 = rootFontSize$2 * 0.25;
var SPACING_02 = rootFontSize$2 * 0.5;
var SPACING_03 = rootFontSize$2 * 0.75;
var SPACING_04 = rootFontSize$2;
var SPACING_05 = rootFontSize$2 * 1.5;
var SPACING_06 = rootFontSize$2 * 2;
var SPACING_07 = rootFontSize$2 * 3.25;
var SPACING_08 = rootFontSize$2 * 5.5;
var SPACING_HALF_GUTTER = rootFontSize$2 * 0.75;
var SPACING_GUTTER = SPACING_HALF_GUTTER * 2;
var SPACING_COLUMN_INSET = rootFontSize$2 * 1.5;
var spacing_01 = SPACING_01;
var spacing_02 = SPACING_02;
var spacing_03 = SPACING_03;
var spacing_04 = SPACING_04;
var spacing_05 = SPACING_05;
var spacing_06 = SPACING_06;
var spacing_07 = SPACING_07;
var spacing_08 = SPACING_08;
var spacingNegative_01 = SPACING_01 * -1;
var spacingNegative_02 = SPACING_02 * -1;
var spacingNegative_03 = SPACING_03 * -1;
var spacingNegative_04 = SPACING_04 * -1;
var spacingNegative_05 = SPACING_05 * -1;
var spacingNegative_06 = SPACING_06 * -1;
var spacingNegative_07 = SPACING_07 * -1;
var spacingNegative_08 = SPACING_08 * -1;
var spacingHalfGutter = SPACING_HALF_GUTTER;
var spacingGutter = SPACING_GUTTER;
var spacingColumnInset = SPACING_COLUMN_INSET;
var spacingRowGap = SPACING_HALF_GUTTER;
var spacingRowGapAtLarge = SPACING_GUTTER + SPACING_COLUMN_INSET;
var spacingGridMarginAtMedium = rootFontSize$2 * 1.5;
var spacingGridMarginAtLarge = rootFontSize$2 * 3;
var spacingGridMarginAtExtraLarge = 'auto';
var spacingGutterSm = rootFontSize$2;
var spacingGutterMd = SPACING_GUTTER;
var spacingGutterLg = SPACING_GUTTER;
var spacingInsetSm = rootFontSize$2;
var spacingInsetMd = rootFontSize$2;
var spacingInsetLg = rootFontSize$2 * 1.5;
var spacingOutsetSm = rootFontSize$2;
var spacingOutsetMd = rootFontSize$2 * 0.75;
var spacingOutsetLg = rootFontSize$2 * 0.75;
var spacing = {
  spacing_01: spacing_01,
  spacing_02: spacing_02,
  spacing_03: spacing_03,
  spacing_04: spacing_04,
  spacing_05: spacing_05,
  spacing_06: spacing_06,
  spacing_07: spacing_07,
  spacing_08: spacing_08,
  spacingNegative_01: spacingNegative_01,
  spacingNegative_02: spacingNegative_02,
  spacingNegative_03: spacingNegative_03,
  spacingNegative_04: spacingNegative_04,
  spacingNegative_05: spacingNegative_05,
  spacingNegative_06: spacingNegative_06,
  spacingNegative_07: spacingNegative_07,
  spacingNegative_08: spacingNegative_08,
  spacingHalfGutter: spacingHalfGutter,
  spacingGutter: spacingGutter,
  spacingColumnInset: spacingColumnInset,
  spacingRowGap: spacingRowGap,
  spacingRowGapAtLarge: spacingRowGapAtLarge,
  spacingGridMarginAtMedium: spacingGridMarginAtMedium,
  spacingGridMarginAtLarge: spacingGridMarginAtLarge,
  spacingGridMarginAtExtraLarge: spacingGridMarginAtExtraLarge,
  spacingGutterSm: spacingGutterSm,
  spacingGutterMd: spacingGutterMd,
  spacingGutterLg: spacingGutterLg,
  spacingInsetSm: spacingInsetSm,
  spacingInsetMd: spacingInsetMd,
  spacingInsetLg: spacingInsetLg,
  spacingOutsetSm: spacingOutsetSm,
  spacingOutsetMd: spacingOutsetMd,
  spacingOutsetLg: spacingOutsetLg
};

var rootFontSize$3 = base.rootFontSize;
var typeScaleLatinMinus_2 = rootFontSize$3 * 0.75;
var typeScaleLatinMinus_1 = rootFontSize$3 * 0.875;
var typeScaleLatinBase = rootFontSize$3 * 1;
var typeScaleLatinPlus_1 = rootFontSize$3 * 1.125;
var typeScaleLatinPlus_2 = rootFontSize$3 * 1.25;
var typeScaleLatinPlus_3 = rootFontSize$3 * 1.5;
var typeScaleLatinPlus_4 = rootFontSize$3 * 1.75;
var typeScaleLatinPlus_5 = rootFontSize$3 * 2;
var typeScaleLatinPlus_6 = rootFontSize$3 * 2.25;
var typeScaleLatinPlus_7 = rootFontSize$3 * 2.625;
var typeScaleLatinPlus_8 = rootFontSize$3 * 3;
var typeScaleLatinPlus_9 = rootFontSize$3 * 3.375;
var typeScaleLatinPlus_10 = rootFontSize$3 * 3.75;
var typeScaleCjkMinus_2 = 11;
var typeScaleCjkMinus_1 = 13;
var typeScaleCjkBase = 15;
var typeScaleCjkPlus_1 = 17;
var typeScaleCjkPlus_2 = 19;
var typeScaleCjkPlus_3 = 22;
var typeScaleCjkPlus_4 = 26;
var typeScaleCjkPlus_5 = 30;
var typeScaleCjkPlus_6 = 36;
var typeScaleCjkPlus_7 = 40;
var typeScaleCjkPlus_8 = 45;
var typeScaleCjkPlus_9 = 51;
var typeScaleCjkPlus_10 = 56;
var typeScale = {
  typeScaleLatinMinus_2: typeScaleLatinMinus_2,
  typeScaleLatinMinus_1: typeScaleLatinMinus_1,
  typeScaleLatinBase: typeScaleLatinBase,
  typeScaleLatinPlus_1: typeScaleLatinPlus_1,
  typeScaleLatinPlus_2: typeScaleLatinPlus_2,
  typeScaleLatinPlus_3: typeScaleLatinPlus_3,
  typeScaleLatinPlus_4: typeScaleLatinPlus_4,
  typeScaleLatinPlus_5: typeScaleLatinPlus_5,
  typeScaleLatinPlus_6: typeScaleLatinPlus_6,
  typeScaleLatinPlus_7: typeScaleLatinPlus_7,
  typeScaleLatinPlus_8: typeScaleLatinPlus_8,
  typeScaleLatinPlus_9: typeScaleLatinPlus_9,
  typeScaleLatinPlus_10: typeScaleLatinPlus_10,
  typeScaleCjkMinus_2: typeScaleCjkMinus_2,
  typeScaleCjkMinus_1: typeScaleCjkMinus_1,
  typeScaleCjkBase: typeScaleCjkBase,
  typeScaleCjkPlus_1: typeScaleCjkPlus_1,
  typeScaleCjkPlus_2: typeScaleCjkPlus_2,
  typeScaleCjkPlus_3: typeScaleCjkPlus_3,
  typeScaleCjkPlus_4: typeScaleCjkPlus_4,
  typeScaleCjkPlus_5: typeScaleCjkPlus_5,
  typeScaleCjkPlus_6: typeScaleCjkPlus_6,
  typeScaleCjkPlus_7: typeScaleCjkPlus_7,
  typeScaleCjkPlus_8: typeScaleCjkPlus_8,
  typeScaleCjkPlus_9: typeScaleCjkPlus_9,
  typeScaleCjkPlus_10: typeScaleCjkPlus_10
};

var Z_INDEX_BASE_00 = 0;
var Z_INDEX_BASE_01 = 2;
var Z_INDEX_BASE_02 = 4;
var Z_INDEX_BASE_03 = 6;
var Z_INDEX_BASE_04 = 8;
var Z_INDEX_FLAT_00 = 10;
var Z_INDEX_FLAT_01 = 12;
var Z_INDEX_FLAT_02 = 14;
var Z_INDEX_FLAT_03 = 16;
var Z_INDEX_FLAT_04 = 18;
var Z_INDEX_OVERAY_00 = 20;
var Z_INDEX_OVERAY_01 = 22;
var Z_INDEX_OVERAY_02 = 24;
var Z_INDEX_OVERAY_03 = 26;
var Z_INDEX_OVERAY_04 = 28;
var Z_INDEX_FLOATING_00 = 30;
var Z_INDEX_FLOATING_01 = 32;
var Z_INDEX_FLOATING_02 = 34;
var Z_INDEX_FLOATING_03 = 36;
var Z_INDEX_FLOATING_04 = 38;
var Z_INDEX_HEADER_00 = 40;
var Z_INDEX_HEADER_01 = 42;
var Z_INDEX_HEADER_02 = 44;
var Z_INDEX_HEADER_03 = 46;
var Z_INDEX_HEADER_04 = 48;
var Z_INDEX_MODAL_00 = 50;
var Z_INDEX_MODAL_01 = 52;
var Z_INDEX_MODAL_02 = 54;
var Z_INDEX_MODAL_03 = 56;
var Z_INDEX_MODAL_04 = 58;
var zIndexBase_00 = Z_INDEX_BASE_00;
var zIndexBase_01 = Z_INDEX_BASE_01;
var zIndexBase_02 = Z_INDEX_BASE_02;
var zIndexBase_03 = Z_INDEX_BASE_03;
var zIndexBase_04 = Z_INDEX_BASE_04;
var zIndexFlat_00 = Z_INDEX_FLAT_00;
var zIndexFlat_01 = Z_INDEX_FLAT_01;
var zIndexFlat_02 = Z_INDEX_FLAT_02;
var zIndexFlat_03 = Z_INDEX_FLAT_03;
var zIndexFlat_04 = Z_INDEX_FLAT_04;
var zIndexOverlay_00 = Z_INDEX_OVERAY_00;
var zIndexOverlay_01 = Z_INDEX_OVERAY_01;
var zIndexOverlay_02 = Z_INDEX_OVERAY_02;
var zIndexOverlay_03 = Z_INDEX_OVERAY_03;
var zIndexOverlay_04 = Z_INDEX_OVERAY_04;
var zIndexFloating_00 = Z_INDEX_FLOATING_00;
var zIndexFloating_01 = Z_INDEX_FLOATING_01;
var zIndexFloating_02 = Z_INDEX_FLOATING_02;
var zIndexFloating_03 = Z_INDEX_FLOATING_03;
var zIndexFloating_04 = Z_INDEX_FLOATING_04;
var zIndexHeader_00 = Z_INDEX_HEADER_00;
var zIndexHeader_01 = Z_INDEX_HEADER_01;
var zIndexHeader_02 = Z_INDEX_HEADER_02;
var zIndexHeader_03 = Z_INDEX_HEADER_03;
var zIndexHeader_04 = Z_INDEX_HEADER_04;
var zIndexModal_00 = Z_INDEX_MODAL_00;
var zIndexModal_01 = Z_INDEX_MODAL_01;
var zIndexModal_02 = Z_INDEX_MODAL_02;
var zIndexModal_03 = Z_INDEX_MODAL_03;
var zIndexModal_04 = Z_INDEX_MODAL_04;
var zIndex = {
  zIndexBase_00: zIndexBase_00,
  zIndexBase_01: zIndexBase_01,
  zIndexBase_02: zIndexBase_02,
  zIndexBase_03: zIndexBase_03,
  zIndexBase_04: zIndexBase_04,
  zIndexFlat_00: zIndexFlat_00,
  zIndexFlat_01: zIndexFlat_01,
  zIndexFlat_02: zIndexFlat_02,
  zIndexFlat_03: zIndexFlat_03,
  zIndexFlat_04: zIndexFlat_04,
  zIndexOverlay_00: zIndexOverlay_00,
  zIndexOverlay_01: zIndexOverlay_01,
  zIndexOverlay_02: zIndexOverlay_02,
  zIndexOverlay_03: zIndexOverlay_03,
  zIndexOverlay_04: zIndexOverlay_04,
  zIndexFloating_00: zIndexFloating_00,
  zIndexFloating_01: zIndexFloating_01,
  zIndexFloating_02: zIndexFloating_02,
  zIndexFloating_03: zIndexFloating_03,
  zIndexFloating_04: zIndexFloating_04,
  zIndexHeader_00: zIndexHeader_00,
  zIndexHeader_01: zIndexHeader_01,
  zIndexHeader_02: zIndexHeader_02,
  zIndexHeader_03: zIndexHeader_03,
  zIndexHeader_04: zIndexHeader_04,
  zIndexModal_00: zIndexModal_00,
  zIndexModal_01: zIndexModal_01,
  zIndexModal_02: zIndexModal_02,
  zIndexModal_03: zIndexModal_03,
  zIndexModal_04: zIndexModal_04
};

var SHADOW_FLOATING = '0px 2px 4px rgba(0, 0, 0, 0.2)';
var SHADOW_FLOATING_ER = '0px 0px 10px rgba(0, 0, 0, 0.1)';
var SHADOW_BUTTON_BLACK = '0px 0px 0px 0px #00000000';
var SHADOW_BUTTON_PRIMARY = '0px 0px 0px 0px #00000000';
var SHADOW_OTHER = '0px 2px 2px rgba(0, 0, 0, 0.6)';
var SHADOW_CHIP = '0px 0px 4px rgba(0, 0, 0, 0.8)';
var SHADOW_TEXT_ICON_ER = '0px 1px 1px rgba(0, 0, 0, 0.6)';
var SHADOW_TEXT_WHITE_ER = '1px 1px 1.5px #000000CC';
var SHADOW_TEXT_RED_ER = '1px 1px 1.5px #0000004D';
var SHADOW_BOTTOM_NAVIGATION_ER = '0px 0px 20px rgba(0, 0, 0, 0.1)';
var shadow_floating = SHADOW_FLOATING;
var shadow_floating_er = SHADOW_FLOATING_ER;
var shadow_button_black = SHADOW_BUTTON_BLACK;
var shadow_button_primary = SHADOW_BUTTON_PRIMARY;
var shadow_other = SHADOW_OTHER;
var shadow_chip = SHADOW_CHIP;
var shadow_text_icon_er = SHADOW_TEXT_ICON_ER;
var shadow_text_white_er = SHADOW_TEXT_WHITE_ER;
var shadow_text_red_er = SHADOW_TEXT_RED_ER;
var shadow_bottom_navigation_er = SHADOW_BOTTOM_NAVIGATION_ER;
var shadow = {
  shadow_floating: shadow_floating,
  shadow_floating_er: shadow_floating_er,
  shadow_button_black: shadow_button_black,
  shadow_button_primary: shadow_button_primary,
  shadow_other: shadow_other,
  shadow_chip: shadow_chip,
  shadow_text_icon_er: shadow_text_icon_er,
  shadow_text_white_er: shadow_text_white_er,
  shadow_text_red_er: shadow_text_red_er,
  shadow_bottom_navigation_er: shadow_bottom_navigation_er
};

var BORDER_RADIUS_PILL = '999px';
var BORDER_RADIUS_ROUND = '0';
var BORDER_RADIUS_BUTTON_H_32 = '0';
var BORDER_RADIUS_BUTTON_H_40 = '0';
var BORDER_RADIUS_BUTTON_H_50 = '0';
var BORDER_RADIUS_BUTTON_H_52 = '0';
var BORDER_RADIUS_CHIP_LONG_TEXT = '0';
var BORDER_RADIUS_OBJECT_15 = '15';
var BORDER_RADIUS_OBJECT_8 = '8';
var border_radius_pill = BORDER_RADIUS_PILL;
var border_radius_round = BORDER_RADIUS_ROUND;
var border_radius_button_h_32 = BORDER_RADIUS_BUTTON_H_32;
var border_radius_button_h_40 = BORDER_RADIUS_BUTTON_H_40;
var border_radius_button_h_50 = BORDER_RADIUS_BUTTON_H_50;
var border_radius_button_h_52 = BORDER_RADIUS_BUTTON_H_52;
var border_radius_chip_long_text = BORDER_RADIUS_CHIP_LONG_TEXT;
var border_radius_object_15 = BORDER_RADIUS_OBJECT_15;
var border_radius_object_8 = BORDER_RADIUS_OBJECT_8;
var borderRadius = {
  border_radius_pill: border_radius_pill,
  border_radius_round: border_radius_round,
  border_radius_button_h_32: border_radius_button_h_32,
  border_radius_button_h_40: border_radius_button_h_40,
  border_radius_button_h_50: border_radius_button_h_50,
  border_radius_button_h_52: border_radius_button_h_52,
  border_radius_chip_long_text: border_radius_chip_long_text,
  border_radius_object_15: border_radius_object_15,
  border_radius_object_8: border_radius_object_8
};

var BLUR_OBJECT_15 = '7.5px';
var BLUR_OBJECT_150 = '25px';
var blur_object_15 = BLUR_OBJECT_15;
var blur_object_150 = BLUR_OBJECT_150;
var blur = {
  blur_object_15: blur_object_15,
  blur_object_150: blur_object_150
};

var animationDurations = animations.animationDurations,
  animationEasings = animations.animationEasings;
var rootFontSize$4 = base.rootFontSize,
  pageBgColor$1 = base.pageBgColor,
  minTargetSize$1 = base.minTargetSize;
var designTokens = {
  animationDurations: animationDurations,
  animationEasings: animationEasings,
  breakpoints: breakpoints,
  columns: columns,
  dtColor: color,
  font: font,
  fontWeight: fontWeight,
  grid: grid,
  lineHeight: lineHeight,
  letterSpacing: letterSpacing,
  typographyColor: typographyColor,
  rootFontSize: rootFontSize$4,
  pageBgColor: pageBgColor$1,
  minTargetSize: minTargetSize$1,
  spacing: spacing,
  typeScale: typeScale,
  zIndex: zIndex,
  shadow: shadow,
  borderRadius: borderRadius,
  blur: blur
};
var designTokens_2 = designTokens.animationEasings;
var designTokens_3 = designTokens.breakpoints;
var designTokens_15 = designTokens.spacing;

var productTileChipWidth = 16;
var productTileChipMargin = 6;
var productTileERChipWidth = 18;
var productTileERChipMargin = 8;
var productTileChipSmallWidth = 10;
var productTileChipSmallMargin = 4;

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var _SuppressedError$2 = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var styles = {"actionable-content":"fr-ec-actionable-content","actionableContent":"fr-ec-actionable-content","actionable-content--with-link-text":"fr-ec-actionable-content--with-link-text","actionableContentWithLinkText":"fr-ec-actionable-content--with-link-text","actionable-content__content--default":"fr-ec-actionable-content__content--default","actionableContentContentDefault":"fr-ec-actionable-content__content--default","actionable-content__content--button-icon":"fr-ec-actionable-content__content--button-icon","actionableContentContentButtonIcon":"fr-ec-actionable-content__content--button-icon","actionable-content__content--link-text":"fr-ec-actionable-content__content--link-text","actionableContentContentLinkText":"fr-ec-actionable-content__content--link-text","actionable-content__actions--default":"fr-ec-actionable-content__actions--default","actionableContentActionsDefault":"fr-ec-actionable-content__actions--default","actionable-content__actions--button-icon":"fr-ec-actionable-content__actions--button-icon","actionableContentActionsButtonIcon":"fr-ec-actionable-content__actions--button-icon","actionable-content__actions--link-text":"fr-ec-actionable-content__actions--link-text","actionableContentActionsLinkText":"fr-ec-actionable-content__actions--link-text","product-tile__horizontal_spacing":"fr-ec-product-tile__horizontal_spacing","productTileHorizontalSpacing":"fr-ec-product-tile__horizontal_spacing","product-tile__image":"fr-ec-product-tile__image","productTileImage":"fr-ec-product-tile__image","actionable-content__actions--right-default":"fr-ec-actionable-content__actions--right-default","actionableContentActionsRightDefault":"fr-ec-actionable-content__actions--right-default"};

var ActionableContent = function ActionableContent(_a) {
  var className = _a.className,
    content = _a.content,
    actions = _a.actions,
    _b = _a.actionsPosition,
    actionsPosition = _b === void 0 ? 'right' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'default' : _c,
    props = __rest$1(_a, ["className", "content", "actions", "actionsPosition", "variant"]);
  var actionChild = actions;
  return /*#__PURE__*/createElement(Fragment, null, actions !== undefined && (/*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles.actionableContent, variant === 'link-text' && styles.actionableContentWithLinkText, className)
  }, props), /*#__PURE__*/createElement("div", {
    className: styles["actionable-content__content--".concat(variant)]
  }, content), variant === 'default' || variant === 'link-text' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'CoreLinkText' || variant === 'link-text' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'LinkText' || variant === 'button-icon' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'CoreButtonIcon' || variant === 'button-icon' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'ButtonIcon' ? (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles["actionable-content__actions--".concat(variant)], actionsPosition === 'right' && variant === 'default' ? styles.actionableContentActionsRightDefault : '')
  }, actions)) : null)));
};
ActionableContent.displayName = 'CoreActionableContent';

var styles$1 = {"badge-text":"fr-ec-badge-text","badgeText":"fr-ec-badge-text","badge-text--large":"fr-ec-badge-text--large","badgeTextLarge":"fr-ec-badge-text--large","badge-text--small":"fr-ec-badge-text--small","badgeTextSmall":"fr-ec-badge-text--small","badge-text--large-color-primary-dark":"fr-ec-badge-text--large-color-primary-dark","badgeTextLargeColorPrimaryDark":"fr-ec-badge-text--large-color-primary-dark","badge-text--small-color-primary-dark":"fr-ec-badge-text--small-color-primary-dark","badgeTextSmallColorPrimaryDark":"fr-ec-badge-text--small-color-primary-dark","badge-text--large-color-primary-light":"fr-ec-badge-text--large-color-primary-light","badgeTextLargeColorPrimaryLight":"fr-ec-badge-text--large-color-primary-light","badge-text--small-color-primary-light":"fr-ec-badge-text--small-color-primary-light","badgeTextSmallColorPrimaryLight":"fr-ec-badge-text--small-color-primary-light"};

var BadgeText = function BadgeText(_a) {
  var Element = _a.element,
    _b = _a.variant,
    variant = _b === void 0 ? 'large' : _b,
    _c = _a.color,
    color = _c === void 0 ? 'primary-dark' : _c,
    className = _a.className,
    props = __rest$1(_a, ["element", "variant", "color", "className"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$1.badgeText, styles$1["badge-text--".concat(variant)], styles$1["badge-text--".concat(variant, "-color-").concat(color)], className)
  }, props));
};
BadgeText.displayName = 'CoreBadgeText';

var SvgComponent = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.8129 13.7902C21.4753 12.8404 21.8667 11.6884 21.8667 10.4453C21.8667 7.20996 19.2349 4.57812 16 4.57812C12.7651 4.57812 10.1338 7.20996 10.1338 10.4453C10.1338 11.6884 10.5251 12.8404 11.1874 13.7903L6.9668 16.7676V25.6211H25.0332V16.7676L20.8129 13.7902ZM16 6.17773C18.3525 6.17773 20.2671 8.0918 20.2671 10.4453C20.2671 12.7979 18.3525 14.7119 16 14.7119C13.6475 14.7119 11.7334 12.7979 11.7334 10.4453C11.7334 8.0918 13.6475 6.17773 16 6.17773ZM23.4336 24.0215H8.56641V17.5977L12.28 14.9772C13.2932 15.8104 14.589 16.3115 16 16.3115C17.4111 16.3115 18.7071 15.8103 19.7203 14.9772L23.4336 17.5977V24.0215Z"
  }));
};

var SvgComponent$1 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.275 14.2279C21.1689 13.2188 21.7168 11.8964 21.7168 10.4453C21.7168 7.29297 19.1523 4.72754 16 4.72754C12.8477 4.72754 10.2822 7.29297 10.2822 10.4453C10.2822 11.8963 10.8302 13.2186 11.7243 14.2277L7.11621 17.4785V25.4717H24.8838V17.4785L20.275 14.2279Z"
  }));
};

var SvgComponent$2 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M6.6000055,18.4 C6.7710055,17.348 7.0910055,16.279 7.7360055,15.608 C8.6030055,14.713 9.9330055,14.106 12.0000055,14.099 C14.1180055,14.106 15.4420055,14.716 16.2930055,15.603 C16.9300055,16.27 17.2350055,17.341 17.4000055,18.4 L6.6000055,18.4 Z M11.9930055,5.603 C12.1060055,5.603 12.2190055,5.608 12.3330055,5.619 C13.2500055,5.708 14.0780055,6.149 14.6630055,6.86 C15.2480055,7.571 15.5220055,8.469 15.4330055,9.385 C15.2610055,11.162 13.7880055,12.503 12.0070055,12.503 C11.8950055,12.503 11.7820055,12.497 11.6670055,12.486 C10.7500055,12.398 9.9220055,11.957 9.3370055,11.245 C8.7510055,10.534 8.4780055,9.637 8.5660055,8.72 C8.7390055,6.943 10.2120055,5.603 11.9930055,5.603 L11.9930055,5.603 Z M17.2910055,14.281 C16.7390055,13.699 16.0480055,13.239 15.2460055,12.907 C16.2210055,12.087 16.8960055,10.909 17.0290055,9.54 C17.2980055,6.763 15.2650055,4.293 12.4870055,4.024 C12.3220055,4.008 12.1570055,4 11.9940055,4 C9.4240055,4 7.2250055,5.954 6.9720055,8.565 C6.8050055,10.287 7.5250055,11.888 8.7570055,12.922 C7.9710055,13.252 7.2910055,13.706 6.7430055,14.277 C5.5410055,15.526 4.9980055,17.224 5,19 L5,20 L19.0000113,20 L19,19 C19.0020055,17.234 18.4860055,15.536 17.2910055,14.281 L17.2910055,14.281 Z"
  })));
};

var SvgComponent$3 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.39 13.4599C18.17 13.4599 17.95 13.4899 17.75 13.5499L15.45 11.9999L17.75 10.4499C17.95 10.5099 18.17 10.5399 18.39 10.5399C19.68 10.5399 20.74 9.48986 20.74 8.19986C20.74 6.90986 19.68 5.85986 18.39 5.85986C17.1 5.85986 16.05 6.90986 16.05 8.19986C16.05 8.78986 16.27 9.33986 16.65 9.74986L14.36 11.2799L7.68005 6.77986C7.17005 6.43986 6.57005 6.24986 5.95005 6.24986C4.91005 6.24986 3.95005 6.76986 3.38005 7.62986L3.05005 8.12986L8.80005 11.9999L3.05005 15.8799L3.38005 16.3699C3.95005 17.2399 4.91005 17.7499 5.95005 17.7499C6.57005 17.7499 7.17005 17.5699 7.68005 17.2199L14.37 12.7199L16.65 14.2499C16.27 14.6599 16.05 15.2099 16.05 15.7999C16.05 17.0899 17.1 18.1399 18.39 18.1399C19.68 18.1399 20.74 17.0899 20.74 15.7999C20.74 14.5099 19.68 13.4599 18.39 13.4599ZM18.39 7.04986C19.02 7.04986 19.5401 7.56986 19.5401 8.19986C19.5401 8.82986 19.02 9.33986 18.39 9.33986C17.76 9.33986 17.25 8.82986 17.25 8.19986C17.25 7.56986 17.76 7.04986 18.39 7.04986ZM7.01005 16.2199C6.34005 16.6799 5.40005 16.6299 4.79005 16.1499L9.88005 12.7199L11.05 13.5099L7.01005 16.2199ZM12.13 12.7899L4.79005 7.84986C5.40005 7.36986 6.34005 7.31986 7.01005 7.77986L13.29 11.9999L12.13 12.7899ZM18.39 16.9499C17.76 16.9499 17.25 16.4299 17.25 15.7999C17.25 15.1699 17.76 14.6599 18.39 14.6599C19.02 14.6599 19.5401 15.1699 19.5401 15.7999C19.5401 16.4299 19.02 16.9499 18.39 16.9499Z"
  }));
};

var SvgComponent$4 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("polygon", {
    points: "12 15 18 9 6 9"
  })));
};

var SvgComponent$5 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.7618727,19.420875 L4.23887267,19.420875 C3.68087267,19.420875 3.16987267,19.115875 2.90487267,18.625875 C2.63887267,18.135875 2.66387267,17.539875 2.96987267,17.072875 L10.7318727,5.222875 C11.2928727,4.364875 12.7068727,4.363875 13.2688727,5.223875 L21.0308727,17.072875 C21.3358727,17.539875 21.3608727,18.135875 21.0958727,18.625875 C20.8308727,19.115875 20.3198727,19.420875 19.7618727,19.420875 Z M12.0138727,6.044875 L4.22487267,17.895875 L19.7618727,17.920875 L19.7708727,17.920875 L12.0138727,6.044875 Z M10.8566727,13.663475 L10.8566727,9.172475 L12.8566727,9.172475 L12.8566727,13.663475 L10.8566727,13.663475 Z M10.8566727,17.171475 L10.8566727,15.171475 L12.8566727,15.171475 L12.8566727,17.171475 L10.8566727,17.171475 Z"
  })));
};

var SvgComponent$6 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M14.39,8.58 L15.42,9.61 L13.03,12 L15.42,14.39 L14.39,15.42 L12,13.03 L9.61,15.42 L8.58,14.39 L10.97,12 L8.58,9.61 L9.61,8.58 L12,10.97 L14.39,8.58 Z M12,4 C14.1217319,4 16.1565632,4.84285472 17.6568542,6.34314575 C19.1571453,7.84343678 20,9.87826808 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M12,18.55 C13.737168,18.55 15.4031861,17.8599127 16.6315494,16.6315494 C17.8599127,15.4031861 18.55,13.737168 18.55,12 C18.55,8.38253489 15.6174651,5.45 12,5.45 C8.38253489,5.45 5.45,8.38253489 5.45,12 C5.45,15.6174651 8.38253489,18.55 12,18.55 Z"
  })));
};

var SvgComponent$7 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.45069 17.5004C8.27869 17.5004 8.95069 18.1714 8.95069 19.0004C8.95069 19.8284 8.27869 20.5004 7.45069 20.5004C6.62268 20.5004 5.95069 19.8284 5.95069 19.0004C5.95069 18.1714 6.62268 17.5004 7.45069 17.5004ZM16.9507 17.5004C17.7787 17.5004 18.4507 18.1714 18.4507 19.0004C18.4507 19.8284 17.7787 20.5004 16.9507 20.5004C16.1227 20.5004 15.4507 19.8284 15.4507 19.0004C15.4507 18.1714 16.1227 17.5004 16.9507 17.5004ZM7.11311 3.5V6.49162H21L18.8252 15.5H5.77535V4.70284H2V3.5H7.11311ZM19.3412 7.69446H7.11311V14.2972H17.7464L19.3412 7.69446Z"
  }));
};

var SvgComponent$8 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90039 13.599V16.2L8.36739 13.6H14.6004V4.40002H2.40039V13.599H4.90039ZM6.10039 12.4H3.60039V5.60002H13.4004V12.4H7.96739L6.10039 13.799V12.4ZM16.5004 11.1V9.90002H21.6004V18.6H18.6004V21.885L15.0964 18.6H9.90039V15.5H11.1004V17.4H15.5714L17.4004 19.115V17.4H20.4004V11.1H16.5004Z"
  }));
};

var SvgComponent$9 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("polygon", {
    points: "10.5326966 16.78 10.5326966 16.78 10.5193258 16.78 6 11.9044248 7.71146067 10.0436283 10.5326966 13.0872566 16.1751685 7 17.9 8.84637168"
  })));
};

var SvgComponent$a = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40625 12C3.40625 16.743 7.26425 20.6 12.0063 20.6C16.7483 20.6 20.6063 16.743 20.6063 12C20.6063 7.25702 16.7483 3.40002 12.0063 3.40002C7.26425 3.40002 3.40625 7.25702 3.40625 12ZM4.60625 12C4.60625 7.92002 7.92525 4.60002 12.0063 4.60002C16.0872 4.60002 19.4062 7.92002 19.4062 12C19.4062 16.08 16.0872 19.4 12.0063 19.4C7.92525 19.4 4.60625 16.08 4.60625 12ZM7.10156 12.186L10.7426 15.813L16.8896 9.67103L15.9006 8.68103L10.7416 13.835L8.08956 11.193L7.10156 12.186Z"
  }));
};

var SvgComponent$b = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("polygon", {
    points: "17.664 9 12 13.541 6.336 9 5 10.387 12 16 19.001 10.387"
  })));
};

var SvgComponent$c = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.517 6.56494L14.483 7.43494L10.375 11.9999L14.483 16.5649L13.517 17.4349L8.62598 11.9999L13.517 6.56494Z"
  }));
};

var SvgComponent$d = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.89 23.17L12.78 22.17L18.32 16L12.78 9.82996L13.89 8.82996L20.34 16L13.89 23.17Z"
  }));
};

var SvgComponent$e = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("polygon", {
    transform: "translate(12.000500, 12.500000) rotate(-90.000000) translate(-12.000500, -12.500000)",
    points: "17.664 9 12 13.541 6.336 9 5 10.387 12 16 19.001 10.387"
  })));
};

var SvgComponent$f = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("polygon", {
    transform: "translate(12.000500, 12.500000) scale(1, -1) translate(-12.000500, -12.500000)",
    points: "17.664 9 12 13.541 6.336 9 5 10.387 12 16 19.001 10.387"
  })));
};

var SvgComponent$g = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.9999 2.8999C6.9799 2.8999 2.8999 6.9799 2.8999 11.9999C2.8999 17.0199 6.9799 21.0999 11.9999 21.0999C17.0199 21.0999 21.0999 17.0199 21.0999 11.9999C21.0999 6.9799 17.0199 2.8999 11.9999 2.8999ZM11.9999 19.8999C7.6399 19.8999 4.0999 16.3599 4.0999 11.9999C4.0999 7.6399 7.6399 4.0999 11.9999 4.0999C16.3599 4.0999 19.8999 7.6399 19.8999 11.9999C19.8999 16.3599 16.3599 19.8999 11.9999 19.8999Z"
  }));
};

var SvgComponent$h = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M24.6357 8.63672L23.3633 7.36328L15.9995 14.7271L8.63574 7.36328L7.36328 8.63672L14.7266 16L7.36328 23.3633L8.63574 24.6367L15.9995 17.2729L23.3633 24.6367L24.6357 23.3633L17.2725 16L24.6357 8.63672Z"
  }));
};

var SvgComponent$i = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.8238 6.09603L17.9048 5.17603L11.9998 11.081L6.09576 5.17603L5.17676 6.09603L11.0808 12L5.17676 17.904L6.09576 18.824L11.9998 12.919L17.9048 18.824L18.8238 17.904L12.9198 12L18.8238 6.09603Z"
  }));
};

var SvgComponent$j = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M15.9949 8.925L15.0759 8.005L11.9999 11.081L8.92388 8.005L8.00488 8.925L11.0809 12L8.00488 15.075L8.92388 15.995L11.9999 12.919L15.0759 15.995L15.9949 15.075L12.9199 12L15.9949 8.925Z"
  }));
};

var SvgComponent$k = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M20.23,3 C20.6552593,3 21,3.34474074 21,3.77 L21,16.94 C21,17.3652593 20.6552593,17.71 20.23,17.71 L17.71,17.71 L17.71,20.23 C17.71,20.6552593 17.3652593,21 16.94,21 L3.77,21 C3.34474074,21 3,20.6552593 3,20.23 L3,7.06 C3,6.63474074 3.34474074,6.29 3.77,6.29 L6.29,6.29 L6.29,3.77 C6.29,3.34474074 6.63474074,3 7.06,3 L20.23,3 Z M16.17,19.46 L16.17,7.83 L4.54,7.83 L4.54,19.46 L16.17,19.46 Z M19.46,16.17 L19.46,4.54 L7.83,4.54 L7.83,6.29 L16.94,6.29 C17.3652593,6.29 17.71,6.63474074 17.71,7.06 L17.71,16.17 L19.46,16.17 Z"
  })));
};

var SvgComponent$l = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1004 9.5929L20.6994 9.7339V9.7329C19.7394 10.0699 19.0934 10.9799 19.0934 11.9989C19.0934 13.0179 19.7394 13.9279 20.6994 14.2649L21.1004 14.4059V18.5989H2.90039V5.3999H21.1004V9.5929ZM19.9004 17.3999V15.2289C18.6844 14.6289 17.8934 13.3799 17.8934 11.9999C17.8934 10.6199 18.6844 9.3719 19.9004 8.7709V6.5999H9.05039V7.7499H7.95039V6.5999H4.10039V17.3999H7.95039V16.2489H9.05039V17.3999H19.9004ZM9.04922 9.2489H7.94922V11.2489H9.04922V9.2489ZM9.04922 12.7489H7.94922V14.7489H9.04922V12.7489Z"
  }));
};

var SvgComponent$m = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50039 4.8999H18.5004C19.9334 4.8999 21.1004 6.0659 21.1004 7.4999V16.4999C21.1004 17.9339 19.9344 19.0999 18.5004 19.0999H5.50039C4.06739 19.0999 2.90039 17.9339 2.90039 16.4999V7.4999C2.90039 6.0659 4.06639 4.8999 5.50039 4.8999ZM18.5004 6.0989H5.50039C4.72839 6.0989 4.10039 6.7279 4.10039 7.4989V8.9769H19.9004V7.4989C19.9004 6.7279 19.2724 6.0989 18.5004 6.0989ZM5.50039 17.8999H18.5004C19.2724 17.8999 19.9004 17.2709 19.9004 16.4999V11.9779H4.10039V16.4999C4.10039 17.2709 4.72839 17.8999 5.50039 17.8999ZM5.5 14.4999H10V15.7799H5.5V14.4999Z"
  }));
};

var SvgComponent$n = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.9999 2.8999C6.9799 2.8999 2.8999 6.9799 2.8999 11.9999C2.8999 17.0199 6.9799 21.0999 11.9999 21.0999C17.0199 21.0999 21.0999 17.0199 21.0999 11.9999C21.0999 6.9799 17.0199 2.8999 11.9999 2.8999ZM11.9999 19.8999C7.6399 19.8999 4.0999 16.3599 4.0999 11.9999C4.0999 7.6399 7.6399 4.0999 11.9999 4.0999C16.3599 4.0999 19.8999 7.6399 19.8999 11.9999C19.8999 16.3599 16.3599 19.8999 11.9999 19.8999ZM15.1099 8.0399L11.9999 11.1499L8.8899 8.0399L8.0399 8.8899L11.1499 11.9999L8.0399 15.1099L8.8899 15.9599L11.9999 12.8499L15.1099 15.9599L15.9599 15.1099L12.8499 11.9999L15.9599 8.8899L15.1099 8.0399Z"
  }));
};

var SvgComponent$o = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6496 5.90004H13.3496V4.34204H10.6496V5.90204H4.34961V7.10204H5.89861V19.601H18.1006V7.10104H19.6496V5.90204V5.90004ZM7.09961 18.401V7.10204H16.8996V18.402H7.09961V18.401ZM10.5 9.35004H9.5V16.5H10.5V9.35004ZM13.5 9.35004H14.5V16.5H13.5V9.35004Z"
  }));
};

var SvgComponent$p = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M19.6 14V20.6H4.4V14H5.6V19.4H18.4V14H19.6ZM17.88 8.97L17.06 8.09L12.6 12.22V3H11.4V12.23L6.95 8.11L6.13 8.99L12 14.42L17.88 8.97Z"
  }));
};

var SvgComponent$q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.9719 3.323L6.34094 16.54L6.58394 21.476L10.9799 19.218L18.6109 6.001L13.9719 3.323ZM14.3739 4.825L17.1069 6.403L16.3819 7.659L13.6489 6.08L14.3739 4.825ZM7.87494 16.082L13.1489 6.947L15.8819 8.526L10.6079 17.661L7.87494 16.082ZM7.46394 16.999L10.0189 18.474L7.59794 19.718L7.46394 16.999Z"
  }));
};

var SvgComponent$r = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M8.53 11.34C6.59 11.34 4.92 10.2 4.12 8.56H8.72V7.06H3.67C3.64 6.85 3.61 6.64 3.61 6.42C3.61 6.2 3.65 5.99 3.67 5.78H8.71V4.28H4.11C4.91 2.64 6.58 1.5 8.52 1.5C9.85 1.5 11.06 2.04 11.95 2.9L13.01 1.84C11.85 0.71 10.27 0 8.52 0C5.73 0 3.35 1.79 2.47 4.28H0V5.78H2.14C2.12 5.99 2.11 6.2 2.11 6.42C2.11 6.64 2.12 6.85 2.14 7.06H0V8.56H2.48C3.36 11.05 5.74 12.84 8.53 12.84C10.28 12.84 11.86 12.14 13.02 11L11.96 9.94C11.07 10.81 9.86 11.34 8.53 11.34Z"
  }));
};

var SvgComponent$s = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57617 13.5759L10.4242 14.4239L16.4002 8.4479V11.9999H17.6002V6.3999H12.0002V7.5999H15.5512L9.57617 13.5759ZM6.40039 17.5999H16.6004V13.9999H15.4004V16.3999H7.60039V8.5999H10.0004V7.3999H6.40039V17.5999Z"
  }));
};

var SvgComponent$t = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9201 17.0801L17.0201 16.1801L15.6301 14.7901L14.7801 13.9401L10.0501 9.21008L9.21008 8.37008L8.15008 7.30008L7.21008 6.36008L4.42008 3.58008L3.58008 4.42008L6.08008 6.92008C4.12008 8.02008 2.50008 9.66008 1.46008 11.7201L1.33008 12.0001L1.46008 12.2701C3.42008 16.1701 7.45008 18.6001 12.0001 18.6001C13.6901 18.6001 15.3101 18.2501 16.7801 17.6201L19.5801 20.4201L20.4301 19.5701L17.9201 17.0801ZM9.23008 10.0801L13.9201 14.7701C13.3701 15.1501 12.7201 15.4001 12.0001 15.4001C10.1201 15.4001 8.60008 13.8801 8.60008 12.0001C8.60008 11.2801 8.84008 10.6301 9.23008 10.0801ZM12.0001 17.4001C8.02008 17.4001 4.47008 15.3401 2.68008 12.0001C3.66008 10.1801 5.17008 8.76008 6.98008 7.83008L8.37008 9.22008C7.77008 9.99008 7.40008 10.9501 7.40008 12.0001C7.40008 14.5401 9.46008 16.6001 12.0001 16.6001C13.0501 16.6001 14.0101 16.2301 14.7901 15.6301L15.8601 16.7001C14.6501 17.1501 13.3501 17.4001 12.0001 17.4001ZM22.54 11.7301C20.58 7.83008 16.55 5.40009 12 5.40009C10.77 5.40009 9.57996 5.58009 8.45996 5.92009L9.44996 6.91009C10.27 6.72009 11.12 6.60009 12 6.60009C15.98 6.60009 19.53 8.66009 21.32 12.0001C20.54 13.4501 19.42 14.6401 18.08 15.5401L18.96 16.4201C20.45 15.3601 21.69 13.9501 22.53 12.2701L22.67 12.0001L22.54 11.7301ZM16.6003 12.0001C16.6003 12.6101 16.4703 13.1901 16.2603 13.7201L15.3103 12.7601C15.3603 12.5201 15.4003 12.2601 15.4003 12.0001C15.4003 10.1201 13.8803 8.60009 12.0003 8.60009C11.7403 8.60009 11.4803 8.64008 11.2303 8.69008L10.2803 7.74009C10.8203 7.52009 11.3903 7.40009 12.0003 7.40009C14.5403 7.40009 16.6003 9.46009 16.6003 12.0001Z"
  }));
};

var SvgComponent$u = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46008 12.2699C3.42008 16.1699 7.45008 18.5999 12.0001 18.5999C16.5501 18.5999 20.5801 16.1699 22.5401 12.2699L22.6701 11.9999L22.5401 11.7299C20.5801 7.8299 16.5501 5.3999 12.0001 5.3999C7.45008 5.3999 3.42008 7.8299 1.46008 11.7299L1.33008 11.9999L1.46008 12.2699ZM12.0001 17.3999C8.02008 17.3999 4.48008 15.3399 2.68008 11.9999C4.47008 8.6599 8.02008 6.5999 12.0001 6.5999C15.9801 6.5999 19.5201 8.6599 21.3201 11.9999C19.5301 15.3399 15.9801 17.3999 12.0001 17.3999ZM7.40039 11.9999C7.40039 14.5399 9.46039 16.5999 12.0004 16.5999C14.5404 16.5999 16.6004 14.5399 16.6004 11.9999C16.6004 9.4599 14.5404 7.3999 12.0004 7.3999C9.46039 7.3999 7.40039 9.4599 7.40039 11.9999ZM8.60039 11.9999C8.60039 10.1199 10.1204 8.5999 12.0004 8.5999C13.8804 8.5999 15.4004 10.1199 15.4004 11.9999C15.4004 13.8799 13.8804 15.3999 12.0004 15.3999C10.1204 15.3999 8.60039 13.8799 8.60039 11.9999Z"
  }));
};

var SvgComponent$v = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16H4V14.6H20V16zM20 7.99998H4V6.59998H20V7.99998z"
  }));
};

var SvgComponent$w = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 21.5L6 3.5H4.5V21.5H6ZM8.27 13.0401C8.12316 12.8988 8.04013 12.7039 8.04 12.5001C8.05236 12.3236 8.12674 12.1571 8.25 12.0301L11.61 8.6001L12.68 9.6001L10.61 11.7201H19.5V13.2201H10.55L12.7 15.3301L11.7 16.4001L8.27 13.0401Z"
  }));
};

var SvgComponent$x = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M8.878,9.82662672 C8.242,9.82662672 7.728,9.30762672 7.728,8.66762672 C7.728,8.02862672 8.242,7.50962672 8.878,7.50962672 C9.513,7.50962672 10.028,8.02862672 10.028,8.66762672 C10.027,9.30862672 9.511,9.82662672 8.875,9.82662672 L8.878,9.82662672 Z M11.475,8.13162672 C11.179,6.68662672 9.776,5.75762672 8.342,6.05562672 C7.305,6.27162672 6.494,7.08762672 6.28,8.13162672 L3.75,8.13162672 C3.336,8.13162672 3,8.46962672 3,8.88662672 C3,9.30362672 3.336,9.64162672 3.75,9.64162672 L6.412,9.64162672 C6.941,11.0106267 8.474,11.6886267 9.833,11.1556267 C10.524,10.8856267 11.068,10.3356267 11.337,9.64162672 L21,9.64162672 L21,8.13162672 L11.475,8.13162672 Z M15.551,15.4896267 C14.915,15.4896267 14.4,14.9716267 14.4,14.3316267 C14.4,13.6916267 14.915,13.1726267 15.551,13.1726267 C16.186,13.1726267 16.701,13.6916267 16.701,14.3316267 C16.7,14.9706267 16.186,15.4886267 15.551,15.4896267 L15.551,15.4896267 Z M15.551,11.6626267 C14.415,11.6646267 13.409,12.3976267 13.05,13.4816267 C12.955,13.4396267 12.854,13.4176267 12.75,13.4166267 L3.75,13.4166267 C3.336,13.4166267 3,13.7546267 3,14.1716267 C3,14.5886267 3.336,14.9276267 3.75,14.9276267 L12.75,14.9276267 C12.821,14.9236267 12.892,14.9096267 12.959,14.8846267 C13.26,16.3246267 14.664,17.2456267 16.094,16.9426267 C17.106,16.7276267 17.899,15.9406267 18.129,14.9276267 L21,14.9276267 L21,13.4166267 L18.031,13.4166267 C17.652,12.3656267 16.661,11.6646267 15.551,11.6626267 L15.551,11.6626267 Z"
  })));
};

var SvgComponent$y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.4899 4.95977C15.9799 5.69977 14.4199 5.31977 12.7699 4.91977C10.9899 4.47977 9.1399 4.02977 7.2299 4.95977L6.8999 5.12977V20.4998H8.0999V14.2998C9.5099 13.7598 10.9599 14.0998 12.4799 14.4798C13.4999 14.7298 14.5299 14.9798 15.5899 14.9798C16.3899 14.9798 17.1999 14.8298 18.0199 14.4298L18.3499 14.2598V4.53977L17.4899 4.95977Z"
  }));
};

var SvgComponent$z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.4899 4.95977C15.9799 5.70977 14.4199 5.31977 12.7699 4.91977C10.9799 4.47977 9.13989 4.02977 7.22989 4.95977L6.88989 5.12977V20.4998H8.08989V14.2998C9.49989 13.7598 10.9499 14.0998 12.4699 14.4798C13.4899 14.7298 14.5199 14.9798 15.5799 14.9798C16.3799 14.9798 17.1899 14.8298 18.0099 14.4298L18.3499 14.2698V4.53977L17.4899 4.95977ZM17.1499 13.4998C15.7399 14.0398 14.2899 13.6798 12.7599 13.3098C11.7399 13.0598 10.7099 12.8098 9.64989 12.8098C9.12989 12.8098 8.60989 12.8698 8.08989 13.0198V5.89977C9.49989 5.35977 10.9499 5.71977 12.4799 6.08977C13.9899 6.45977 15.5499 6.83977 17.1499 6.37977V13.4998Z"
  }));
};

var SvgComponent$A = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.06 18.0598L6.80998 12.4298C6.05998 11.4598 5.60998 10.3098 5.49998 9.07982C5.19998 5.51982 8.15998 2.14982 11.73 2.00982C15.44 1.85982 18.51 4.83982 18.51 8.50982C18.51 9.94982 18.04 11.3198 17.17 12.4398C17.15 12.4898 17.08 12.5798 17.01 12.6598L12.93 18.0598L12.39 18.7698L11.99 19.2898L11.59 18.7598L11.06 18.0598ZM10.8 5.14982C10.72 5.05982 10.6 5.02982 10.49 5.06982L7.62998 6.20982L8.41998 8.18982L9.42998 7.85982V11.6798H14.57V7.85982L15.57 8.18982L16.37 6.20982L13.5 5.06982C13.39 5.02982 13.27 5.05982 13.19 5.14982C12.89 5.46982 12.47 5.66982 12 5.66982C11.53 5.66982 11.1 5.46982 10.8 5.14982ZM16.7298 15.02H18.3498L20.7098 21.5H3.27979L5.63978 15.02H7.25979L8.01979 16.02H6.34978L4.70979 20.5H19.2798L17.6398 16.02H15.9698L16.7298 15.02Z"
  }));
};

var SvgComponent$B = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.3624,18.5249 L4.6374,18.5249 C3.9764,18.5249 3.4384,17.9739 3.4384,17.2959 L3.4384,10.6629 L20.5614,10.6629 L20.5614,17.2959 C20.5614,17.9739 20.0244,18.5249 19.3624,18.5249 M4.6374,5.4749 L19.3624,5.4749 C20.0244,5.4749 20.5614,6.0259 20.5614,6.7049 L20.5614,9.6789 L3.4384,9.6789 L3.4384,6.7049 C3.4384,6.0259 3.9764,5.4749 4.6374,5.4749 M19.3624,3.9999 C20.8174,3.9999 22.0004,5.2129 22.0004,6.7049 L22.0004,17.2959 C22.0004,18.7869 20.8174,19.9999 19.3624,19.9999 L4.6374,19.9999 C3.1824,19.9999 2.0004,18.7869 2.0004,17.2959 L2.0004,6.7049 C2.0004,5.2129 3.1824,3.9999 4.6374,3.9999 L19.3624,3.9999 Z M6.315,15.976 L8.171,15.976 L8.171,12.874 L6.315,12.874 L6.315,15.976 Z M9.25,15.976 L10.178,15.976 L10.178,12.874 L9.25,12.874 L9.25,15.976 Z M11.256,15.976 L13.351,15.976 L13.351,12.874 L11.256,12.874 L11.256,15.976 Z M17.02,15.976 L17.685,15.976 L17.685,12.874 L17.02,12.874 L17.02,15.976 Z M14.44,15.976 L16.023,15.976 L16.023,12.874 L14.44,12.874 L14.44,15.976 Z"
  })));
};

var SvgComponent$C = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M21.5055025,11.5 L21.5055025,5.75 C21.5055025,5.612 21.3939133,5.5 21.2564195,5.5 L10.2180608,5.5 L10.2180608,8.44 C10.2180608,8.716 9.99488248,8.94 9.71989493,8.94 C9.44490739,8.94 9.22172909,8.716 9.22172909,8.44 L9.22172909,5.5 L2.74358045,5.5 C2.60608668,5.5 2.49449753,5.612 2.49449753,5.75 L2.49449753,11.5 L3.74190481,11.5 C4.01689235,11.5 4.24007065,11.724 4.24007065,12 C4.24007065,12.276 4.01689235,12.5 3.74190481,12.5 L2.49449753,12.5 L2.49449753,18.25 C2.49449753,18.388 2.60608668,18.5 2.74358045,18.5 L9.22172909,18.5 L9.22172909,16.44 C9.22172909,16.164 9.44490739,15.94 9.71989493,15.94 C9.99488248,15.94 10.2180608,16.164 10.2180608,16.44 L10.2180608,18.5 L21.2564195,18.5 C21.3939133,18.5 21.5055025,18.388 21.5055025,18.25 L21.5055025,12.5 L16.6942167,12.5 C16.4192292,12.5 16.1960509,12.276 16.1960509,12 C16.1960509,11.724 16.4192292,11.5 16.6942167,11.5 L21.5055025,11.5 Z M21.2564195,4 C22.2178796,4 23,4.785 23,5.75 L23,18.25 C23,19.215 22.2178796,20 21.2564195,20 L2.74358045,20 C1.78212037,20 1,19.215 1,18.25 L1,5.75 C1,4.785 1.78212037,4 2.74358045,4 L21.2564195,4 Z M13.4550428,12.5972 C13.8715094,12.4242 14.3158734,11.9932 14.3158734,11.3042 C14.3158734,10.6142 13.8715094,10.1832 13.4550428,10.0102 C13.0365835,9.8362 12.4188578,9.8272 11.935637,10.3132 L10.9472759,11.3042 L11.935637,12.2942 C12.4198542,12.7812 13.0375798,12.7702 13.4550428,12.5972 Z M8.07883701,12.2942 L9.06719804,11.3042 L8.07883701,10.3132 C7.7799375,10.0122 7.42823242,9.9012 7.10641728,9.9012 C6.90715094,9.9012 6.71784792,9.9442 6.55943119,10.0102 C6.14296454,10.1832 5.69860061,10.6142 5.69860061,11.3042 C5.69860061,11.9932 6.14296454,12.4242 6.55943119,12.5972 C6.97390517,12.7712 7.59461981,12.7812 8.07883701,12.2942 Z M13.9502196,8.8082 C14.9744486,9.2342 15.6121009,10.1902 15.6121009,11.3042 C15.6121009,12.4162 14.9744486,13.3722 13.9502196,13.7982 C13.6064852,13.9412 13.2527875,14.0112 12.9040714,14.0112 C12.6111499,14.0112 12.3242063,13.9512 12.0482225,13.8542 L12.8024455,15.1032 C12.9877632,15.4102 12.8901227,15.8102 12.5842489,15.9962 C12.4796341,16.0592 12.3630633,16.0902 12.2494815,16.0902 C12.0302885,16.0902 11.8160772,15.9782 11.6945247,15.7772 L9.98780852,12.9492 L8.28109234,15.7772 C8.15953988,15.9782 7.94532856,16.0902 7.72613559,16.0902 C7.61255378,16.0902 7.4969793,16.0592 7.39136814,15.9962 C7.08549432,15.8102 6.98785381,15.4102 7.1731715,15.1032 L7.91842761,13.8692 C7.65639237,13.9552 7.38738282,14.0112 7.11040261,14.0112 C6.76069019,14.0112 6.40699244,13.9412 6.063258,13.7982 C5.03902903,13.3722 4.40237308,12.4162 4.40237308,11.3042 C4.40237308,10.1902 5.03902903,9.2352 6.063258,8.8082 C7.08748698,8.3822 8.21035279,8.6072 8.99546216,9.3942 L10.0077352,10.4092 L11.0190118,9.3942 C11.8031249,8.6082 12.923998,8.3822 13.9502196,8.8082 Z"
  })));
};

var SvgComponent$D = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 3.44995C7.28605 3.44995 3.45105 7.28495 3.45105 12C3.45105 16.715 7.28605 20.5499 12.001 20.5499C16.7161 20.5499 20.55 16.715 20.55 12C20.55 7.28495 16.715 3.44995 12 3.44995ZM15.4871 11.5H12.499V9.27595C13.345 9.22695 14.166 9.05695 14.945 8.77195C15.255 9.63795 15.4411 10.555 15.4871 11.501V11.5ZM9.05305 8.77095C9.83205 9.05595 10.653 9.22695 11.499 9.27595V11.501H8.51105C8.55705 10.554 8.74305 9.63795 9.05305 8.77195V8.77095ZM11.499 8.17595C10.805 8.12995 10.132 7.98895 9.49105 7.75995C9.98905 6.75995 10.66 5.84595 11.499 5.06595V8.17595ZM8.51305 12.5H11.499V14.725C10.659 14.773 9.84305 14.942 9.06905 15.224C8.75505 14.36 8.56405 13.446 8.51305 12.5ZM11.499 15.824V18.885C10.672 18.116 10.008 17.217 9.51205 16.233C10.147 16.008 10.813 15.87 11.499 15.824ZM12.499 15.824C13.185 15.869 13.851 16.007 14.486 16.232C13.99 17.215 13.326 18.115 12.499 18.884V15.824ZM12.499 14.724V12.499H15.484C15.4331 13.444 15.2421 14.358 14.9281 15.222C14.154 14.94 13.34 14.772 12.499 14.724ZM12.499 8.17495V5.06695C13.338 5.84595 14.009 6.75995 14.507 7.75995C13.866 7.98895 13.193 8.12895 12.499 8.17495ZM13.545 4.71195C14.8 4.97795 15.936 5.56395 16.872 6.37595C16.425 6.76395 15.941 7.09695 15.425 7.36495C14.9471 6.39395 14.314 5.50195 13.545 4.71195ZM8.57405 7.36395C8.05805 7.09595 7.57405 6.76495 7.12705 6.37695C8.06205 5.56495 9.19805 4.97995 10.452 4.71295C9.68305 5.50195 9.05105 6.39295 8.57405 7.36395ZM8.14105 8.37495C7.78005 9.36495 7.55705 10.413 7.51005 11.499H4.57505C4.68605 9.84595 5.33305 8.33995 6.35005 7.15595C6.89905 7.64195 7.50005 8.05095 8.14105 8.37595V8.37495ZM7.51205 12.499C7.56705 13.571 7.79905 14.617 8.16905 15.609C7.51705 15.936 6.90805 16.35 6.35105 16.843C5.33305 15.658 4.68605 14.152 4.57505 12.499H7.51305H7.51205ZM8.60705 16.618C9.09705 17.604 9.74205 18.509 10.521 19.301C9.23905 19.042 8.07905 18.449 7.12705 17.622C7.58405 17.226 8.07805 16.889 8.60705 16.618ZM15.39 16.618C15.9191 16.889 16.415 17.225 16.872 17.622C15.919 18.449 14.758 19.043 13.476 19.302C14.255 18.509 14.9001 17.604 15.39 16.618ZM15.8291 15.609C16.199 14.617 16.4311 13.571 16.4851 12.499H19.424C19.313 14.152 18.666 15.658 17.649 16.843C17.0911 16.35 16.4811 15.937 15.8291 15.609ZM16.4881 11.499C16.4401 10.414 16.2181 9.36595 15.857 8.37695C16.4991 8.05195 17.0981 7.64195 17.6481 7.15595C18.6651 8.34095 19.313 9.84695 19.424 11.5H16.4881V11.499Z"
  }));
};

var SvgComponent$E = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16 17.0693C19.33 17.0693 22.03 14.3593 22.03 11.0393C22.03 7.71928 19.32 5.00928 16 5.00928C12.68 5.00928 9.97003 7.71928 9.97003 11.0393C9.97003 14.3593 12.68 17.0693 16 17.0693ZM16 6.39928C18.55 6.39928 20.63 8.47928 20.63 11.0293C20.63 13.5793 18.55 15.6593 16 15.6593C13.45 15.6593 11.37 13.5793 11.37 11.0293C11.37 8.47928 13.45 6.39928 16 6.39928ZM16 19.6693C11.39 19.6693 7.51003 22.7993 6.34003 27.0393H7.80003C8.93003 23.5793 12.18 21.0693 16.01 21.0693C19.84 21.0693 23.09 23.5793 24.22 27.0393H25.68C24.51 22.7993 20.63 19.6693 16.02 19.6693H16Z"
  }));
};

var SvgComponent$F = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16 17.0693C19.3 17.0693 22 14.3693 22 11.0693C22 7.76934 19.3 5.06934 16 5.06934C12.7 5.06934 9.99999 7.76934 9.99999 11.0693C9.99999 14.3693 12.7 17.0693 16 17.0693ZM16 19.6693C11.4 19.6693 7.49999 22.7693 6.29999 27.0693H25.6C24.5 22.7693 20.6 19.6693 16 19.6693Z"
  }));
};

var SvgComponent$G = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40039 8.00002C7.40039 10.537 9.46339 12.6 12.0004 12.6C14.5374 12.6 16.6004 10.537 16.6004 8.00002C16.6004 5.46302 14.5374 3.40002 12.0004 3.40002C9.46339 3.40002 7.40039 5.46302 7.40039 8.00002ZM8.60039 8.00002C8.60039 6.12502 10.1254 4.60002 12.0004 4.60002C13.8754 4.60002 15.4004 6.12502 15.4004 8.00002C15.4004 9.87502 13.8754 11.4 12.0004 11.4C10.1254 11.4 8.60039 9.87502 8.60039 8.00002ZM12.0007 15.6C9.16973 15.6 6.76673 17.448 5.92473 20H4.67773C5.55873 16.778 8.50473 14.4 12.0017 14.4C15.4987 14.4 18.4447 16.778 19.3257 20H18.0767C17.2337 17.448 14.8317 15.6 12.0007 15.6Z"
  }));
};

var SvgComponent$H = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.4 13.3693C17.8 13.3693 17.3 13.5693 16.9 13.8693C16.5 13.5693 15.7 13.0693 14.7 12.3693C15.7 11.6693 16.4 11.1693 16.8 10.8693C17.2 11.1693 17.7 11.3693 18.3 11.3693C19.6 11.3693 20.7 10.2693 20.7 8.96934C20.7 7.66934 19.6 6.56934 18.3 6.56934C17 6.56934 16 7.66934 16 9.06934C16 9.36934 16.1 9.66934 16.2 9.96934C15.7 10.2693 14.8 10.8693 13.7 11.6693C11.5 10.1693 8.90002 8.36934 7.20002 7.26934C6.90002 6.96934 6.10002 6.56934 5.30002 6.56934C4.00002 6.56934 3.50002 7.16934 3.30002 7.66934C3.00002 8.56934 3.60002 9.26934 3.90002 9.46934L8.20002 12.3693L3.90002 15.2693C3.60002 15.4693 3.00002 16.1693 3.30002 16.9693C3.50002 17.4693 4.00002 18.0693 5.30002 18.0693C6.10002 18.0693 6.80002 17.7693 7.20002 17.4693C8.90002 16.3693 11.5 14.5693 13.7 13.0693C14.8 13.7693 15.7 14.4693 16.2 14.7693C16.1 15.0693 16 15.3693 16 15.7693C16 17.0693 17.1 18.1693 18.4 18.1693C19.7 18.1693 20.8 17.0693 20.8 15.7693C20.8 14.4693 19.7 13.3693 18.4 13.3693ZM18.4 7.86934C19.1 7.86934 19.6 8.36934 19.6 9.06934C19.6 9.76934 19.1 10.2693 18.4 10.2693C17.7 10.2693 17.2 9.76934 17.2 9.06934C17.2 8.36934 17.7 7.86934 18.4 7.86934ZM6.50002 16.4693C6.10002 16.7693 5.60002 16.8693 5.20002 16.8693C4.70002 16.8693 4.40002 16.7693 4.40002 16.5693C4.30002 16.3693 4.60002 16.1693 4.60002 16.1693L9.30002 12.9693L10.5 13.7693C9.00002 14.8693 7.60002 15.7693 6.50002 16.4693ZM11.5 13.1693L9.60002 11.8693L4.60002 8.46934C4.60002 8.46934 4.40002 8.26934 4.40002 8.06934C4.50002 7.86934 4.70002 7.76934 5.30002 7.76934C5.80002 7.76934 6.30002 8.06934 6.50002 8.16934C8.10002 9.26934 10.5 10.8693 12.6 12.2693C12.3 12.6693 11.9 12.8693 11.5 13.1693ZM18.4 16.9693C17.7 16.9693 17.2 16.4693 17.2 15.7693C17.2 15.0693 17.7 14.5693 18.4 14.5693C19.1 14.5693 19.6 15.0693 19.6 15.7693C19.6 16.4693 19.1 16.9693 18.4 16.9693Z"
  }));
};

var SvgComponent$I = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17 11L11.987 15.5L7 11H17Z"
  }));
};

var SvgComponent$J = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0518 16.108L14.2138 4.96498C13.7368 4.18898 12.9088 3.72498 11.9978 3.72498C11.0868 3.72498 10.2578 4.18898 9.78179 4.96498L2.94879 16.104C2.43179 16.916 2.39979 17.906 2.86379 18.75C3.32779 19.594 4.17979 20.099 5.14279 20.099H18.8558C19.8188 20.099 20.6708 19.595 21.1348 18.75C21.5968 17.907 21.5668 16.92 21.0518 16.108ZM20.0828 18.173C19.8328 18.628 19.3748 18.9 18.8558 18.9H5.14279C4.62379 18.9 4.16479 18.629 3.91479 18.173C3.66479 17.718 3.68279 17.186 3.96579 16.739L10.8048 5.59298C11.0618 5.17398 11.5078 4.92498 11.9988 4.92498C12.4898 4.92498 12.9358 5.17398 13.1918 5.59198L20.0318 16.739C20.0318 16.739 20.0348 16.745 20.0368 16.748C20.3158 17.186 20.3328 17.718 20.0828 18.173ZM12.7992 9H11.1992V14.5H12.7992V9ZM11.1992 15.9H12.7992V17.5H11.1992V15.9Z"
  }));
};

var SvgComponent$K = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7356 6.71401C19.3146 6.71401 19.8576 6.97101 20.2246 7.42001C20.5916 7.86901 20.7366 8.45301 20.6206 9.02101L19.5286 14.378C19.3156 15.423 18.3876 16.182 17.3206 16.182H7.83956C6.59656 16.182 5.58556 15.171 5.58556 13.928V4.60601H2.32656C1.99556 4.60601 1.72656 4.33701 1.72656 4.00601C1.72656 3.67501 1.99456 3.40601 2.32656 3.40601H6.18556C6.51656 3.40601 6.78556 3.67501 6.78556 4.00601V6.71401H18.7356ZM17.3196 14.983C17.8176 14.983 18.2516 14.627 18.3516 14.139L19.4426 8.78101C19.4866 8.56801 19.4326 8.34801 19.2946 8.17901C19.1566 8.01001 18.9526 7.91301 18.7346 7.91301H6.78456V13.928C6.78456 14.509 7.25756 14.983 7.83856 14.983H17.3196ZM7.86689 21.295C8.78037 21.295 9.52089 20.5545 9.52089 19.641C9.52089 18.7275 8.78037 17.987 7.86689 17.987C6.95341 17.987 6.21289 18.7275 6.21289 19.641C6.21289 20.5545 6.95341 21.295 7.86689 21.295ZM17.2751 21.295C18.1886 21.295 18.9291 20.5545 18.9291 19.641C18.9291 18.7275 18.1886 17.987 17.2751 17.987C16.3616 17.987 15.6211 18.7275 15.6211 19.641C15.6211 20.5545 16.3616 21.295 17.2751 21.295Z"
  }));
};

var SvgComponent$L = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.0002 16.414L6.79325 12.207C6.40225 11.816 6.40225 11.184 6.79325 10.793C7.18425 10.402 7.81625 10.402 8.20725 10.793L11.0002 13.586L16.2932 8.29301C16.6842 7.90201 17.3163 7.90201 17.7073 8.29301C18.0983 8.68401 18.0983 9.31601 17.7073 9.70701L11.0002 16.414Z"
  }));
};

var SvgComponent$M = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.9995 16.3319L6.59348 12.0079C6.31348 11.7829 6.26748 11.3739 6.49248 11.0939C6.71548 10.8149 7.12348 10.7679 7.40648 10.9919L12.0005 14.6679L16.5945 10.9919C16.8765 10.7679 17.2855 10.8139 17.5085 11.0939C17.7335 11.3739 17.6875 11.7829 17.4075 12.0079L12.0015 16.3319H11.9995Z"
  }));
};

var SvgComponent$N = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.5 17.65C13.309 17.65 13.12 17.566 12.992 17.406L8.66699 12L12.992 6.59403C13.215 6.31503 13.625 6.26903 13.906 6.49203C14.186 6.71703 14.232 7.12603 14.007 7.40603L10.332 12L14.007 16.594C14.232 16.874 14.186 17.283 13.906 17.508C13.786 17.604 13.642 17.65 13.5 17.65Z"
  }));
};

var SvgComponent$O = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.89 23.17L12.78 22.17L18.32 16L12.78 9.82996L13.89 8.82996L20.34 16L13.89 23.17Z"
  }));
};

var SvgComponent$P = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M10.4995 17.6499C10.3575 17.6499 10.2135 17.6029 10.0935 17.5069C9.81348 17.2819 9.76748 16.8729 9.99248 16.5929L13.6675 11.9989L9.99248 7.40488C9.76748 7.12488 9.81348 6.71588 10.0935 6.49088C10.3755 6.26688 10.7845 6.31288 11.0075 6.59288L15.3325 11.9989L11.0075 17.4049C10.8795 17.5649 10.6905 17.6499 10.4995 17.6499Z"
  }));
};

var SvgComponent$Q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.9985 13.15C16.8565 13.15 16.7125 13.103 16.5925 13.007L11.9985 9.33099L7.40453 13.007C7.12253 13.232 6.71453 13.186 6.49053 12.905C6.26553 12.625 6.31153 12.216 6.59153 11.991L11.9975 7.66699L17.4035 11.991C17.6835 12.216 17.7295 12.625 17.5045 12.905C17.3765 13.065 17.1875 13.149 16.9965 13.149L16.9985 13.15Z"
  }));
};

var SvgComponent$R = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.3 16.3693L24 9.66934C24.4 9.26934 24.4 8.76934 24 8.36934C23.6 7.96934 23.1 7.96934 22.7 8.36934L16 15.0693L9.30001 8.36934C8.90001 8.06934 8.40001 8.06934 8.00001 8.36934C7.70001 8.76934 7.70001 9.26934 8.00001 9.66934L14.7 16.3693L8.00001 23.0693C7.60001 23.4693 7.60001 23.9693 8.00001 24.3693C8.20001 24.5693 8.40001 24.6693 8.60001 24.6693C8.80001 24.6693 9.10001 24.5693 9.20001 24.3693L15.9 17.6693L22.6 24.3693C22.8 24.5693 23 24.6693 23.2 24.6693C23.4 24.6693 23.7 24.5693 23.8 24.3693C24.2 23.9693 24.2 23.4693 23.8 23.0693L17.3 16.3693Z"
  }));
};

var SvgComponent$S = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.8238 6.09603L17.9048 5.17603L11.9998 11.081L6.09576 5.17603L5.17676 6.09603L11.0808 12L5.17676 17.904L6.09576 18.824L11.9998 12.919L17.9048 18.824L18.8238 17.904L12.9198 12L18.8238 6.09603Z"
  }));
};

var SvgComponent$T = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M15.9949 8.925L15.0759 8.005L11.9999 11.081L8.92388 8.005L8.00488 8.925L11.0809 12L8.00488 15.075L8.92388 15.995L11.9999 12.919L15.0759 15.995L15.9949 15.075L12.9199 12L15.9949 8.925Z"
  }));
};

var SvgComponent$U = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9992 15.45V16.55C18.4052 16.55 19.5492 15.406 19.5492 14V7.49995C19.5492 6.09395 18.4052 4.94995 16.9992 4.94995H10.4992C9.09322 4.94995 7.94922 6.09395 7.94922 7.49995H9.04922C9.04922 6.69995 9.70022 6.04995 10.4992 6.04995H16.9992C17.7982 6.04995 18.4492 6.69995 18.4492 7.49995V14C18.4492 14.8 17.7982 15.45 16.9992 15.45ZM6.49922 20.55H12.9992C14.4052 20.55 15.5492 19.406 15.5492 18V11.5C15.5492 10.094 14.4052 8.94995 12.9992 8.94995H6.49922C5.09322 8.94995 3.94922 10.094 3.94922 11.5V18C3.94922 19.406 5.09322 20.55 6.49922 20.55ZM5.04922 11.5C5.04922 10.7 5.70022 10.05 6.49922 10.05H12.9992C13.7982 10.05 14.4492 10.7 14.4492 11.5V18C14.4492 18.8 13.7982 19.45 12.9992 19.45H6.49922C5.70022 19.45 5.04922 18.8 5.04922 18V11.5Z"
  }));
};

var SvgComponent$V = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1004 9.5929L20.6994 9.7339V9.7329C19.7394 10.0699 19.0934 10.9799 19.0934 11.9989C19.0934 13.0179 19.7394 13.9279 20.6994 14.2649L21.1004 14.4059V18.5989H2.90039V5.3999H21.1004V9.5929ZM19.9004 17.3999V15.2289C18.6844 14.6289 17.8934 13.3799 17.8934 11.9999C17.8934 10.6199 18.6844 9.3719 19.9004 8.7709V6.5999H9.05039V7.7499H7.95039V6.5999H4.10039V17.3999H7.95039V16.2489H9.05039V17.3999H19.9004ZM9.04922 9.2489H7.94922V11.2489H9.04922V9.2489ZM9.04922 12.7489H7.94922V14.7489H9.04922V12.7489Z"
  }));
};

var SvgComponent$W = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50039 4.8999H18.5004C19.9334 4.8999 21.1004 6.0659 21.1004 7.4999V16.4999C21.1004 17.9339 19.9344 19.0999 18.5004 19.0999H5.50039C4.06739 19.0999 2.90039 17.9339 2.90039 16.4999V7.4999C2.90039 6.0659 4.06639 4.8999 5.50039 4.8999ZM18.5004 6.0989H5.50039C4.72839 6.0989 4.10039 6.7279 4.10039 7.4989V8.9769H19.9004V7.4989C19.9004 6.7279 19.2724 6.0989 18.5004 6.0989ZM5.50039 17.8999H18.5004C19.2724 17.8999 19.9004 17.2709 19.9004 16.4999V11.9779H4.10039V16.4999C4.10039 17.2709 4.72839 17.8999 5.50039 17.8999ZM5.5 14.4999H10V15.7799H5.5V14.4999Z"
  }));
};

var SvgComponent$X = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0004 6.12495H14.5504V5.49995C14.5504 4.64595 13.8554 3.94995 13.0004 3.94995H11.0004C10.1464 3.94995 9.45039 4.64495 9.45039 5.49995V6.12495H5.00039C4.66839 6.12495 4.40039 6.39395 4.40039 6.72495C4.40039 7.05595 4.66939 7.32495 5.00039 7.32495H5.92439C5.9217 7.33842 5.91809 7.35156 5.9145 7.36465C5.90743 7.39044 5.90039 7.4161 5.90039 7.44395V17.501C5.90039 18.935 7.06739 20.101 8.50039 20.101H15.5004C16.9344 20.101 18.1004 18.935 18.1004 17.501V7.44295C18.1004 7.4151 18.0934 7.38944 18.0863 7.36365C18.0827 7.35056 18.0791 7.33742 18.0764 7.32395H19.0004C19.3324 7.32395 19.6004 7.05495 19.6004 6.72395C19.6004 6.39295 19.3314 6.12495 19.0004 6.12495ZM10.5504 5.49995C10.5504 5.25195 10.7524 5.04995 11.0004 5.04995H13.0004C13.2484 5.04995 13.4504 5.25195 13.4504 5.49995V6.12495H10.5504V5.49995ZM16.9004 7.44295V17.5C16.9004 18.271 16.2724 18.9 15.5004 18.9H8.50039C7.72839 18.9 7.10039 18.271 7.10039 17.5V7.44295C7.10039 7.4151 7.09335 7.38944 7.08628 7.36365L7.08628 7.36364C7.08269 7.35055 7.07908 7.33742 7.07639 7.32395H16.9244C16.9217 7.33742 16.9181 7.35056 16.9145 7.36365C16.9074 7.38944 16.9004 7.4151 16.9004 7.44295ZM10.2004 16.55C10.5044 16.55 10.7504 16.304 10.7504 16V10.5C10.7504 10.196 10.5044 9.94995 10.2004 9.94995C9.89639 9.94995 9.65039 10.196 9.65039 10.5V16C9.65039 16.304 9.89639 16.55 10.2004 16.55ZM14.35 16C14.35 16.304 14.104 16.55 13.8 16.55C13.496 16.55 13.25 16.304 13.25 16V10.5C13.25 10.196 13.496 9.94995 13.8 9.94995C14.104 9.94995 14.35 10.196 14.35 10.5V16Z"
  }));
};

var SvgComponent$Y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M7.63999 9.91C7.40999 9.71 7.38999 9.36 7.58999 9.13C7.78999 8.9 8.13999 8.88 8.36999 9.08L11.41 11.74V4.5C11.41 4.17 11.68 3.9 12.01 3.9C12.34 3.9 12.61 4.17 12.61 4.5V11.74L15.65 9.08C15.88 8.88 16.23 8.9 16.43 9.13C16.63 9.36 16.61 9.71 16.38 9.91L12.38 13.41C12.28 13.5 12.15 13.55 12.02 13.55C11.89 13.55 11.76 13.51 11.66 13.41L7.65999 9.91H7.63999ZM19 12.9C18.67 12.9 18.4 13.17 18.4 13.5V17.51C18.4 18.28 17.77 18.91 17 18.91H6.99999C6.22999 18.91 5.59999 18.28 5.59999 17.51V13.5C5.59999 13.17 5.32999 12.9 4.99999 12.9C4.66999 12.9 4.39999 13.17 4.39999 13.5V17.51C4.39999 18.94 5.56999 20.11 6.99999 20.11H17C18.43 20.11 19.6 18.94 19.6 17.51V13.5C19.6 13.17 19.33 12.9 19 12.9Z"
  }));
};

var SvgComponent$Z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.9719 3.323L6.34094 16.54L6.58394 21.476L10.9799 19.218L18.6109 6.001L13.9719 3.323ZM14.3739 4.825L17.1069 6.403L16.3819 7.659L13.6489 6.08L14.3739 4.825ZM7.87494 16.082L13.1489 6.947L15.8819 8.526L10.6079 17.661L7.87494 16.082ZM7.46394 16.999L10.0189 18.474L7.59794 19.718L7.46394 16.999Z"
  }));
};

var SvgComponent$_ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M8.53 11.34C6.59 11.34 4.92 10.2 4.12 8.56H8.72V7.06H3.67C3.64 6.85 3.61 6.64 3.61 6.42C3.61 6.2 3.65 5.99 3.67 5.78H8.71V4.28H4.11C4.91 2.64 6.58 1.5 8.52 1.5C9.85 1.5 11.06 2.04 11.95 2.9L13.01 1.84C11.85 0.71 10.27 0 8.52 0C5.73 0 3.35 1.79 2.47 4.28H0V5.78H2.14C2.12 5.99 2.11 6.2 2.11 6.42C2.11 6.64 2.12 6.85 2.14 7.06H0V8.56H2.48C3.36 11.05 5.74 12.84 8.53 12.84C10.28 12.84 11.86 12.14 13.02 11L11.96 9.94C11.07 10.81 9.86 11.34 8.53 11.34Z"
  }));
};

var SvgComponent$$ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4009 6.9999C12.4009 6.6689 12.6689 6.3999 13.0009 6.3999H18.0999V11.5009C18.0999 11.8319 17.8309 12.1009 17.4999 12.1009C17.1689 12.1009 16.8999 11.8319 16.8999 11.5009V8.4489L12.9239 12.4249C12.8069 12.5419 12.6529 12.6009 12.4999 12.6009C12.3469 12.6009 12.1929 12.5419 12.0759 12.4249C11.8419 12.1909 11.8419 11.8099 12.0759 11.5769L16.0529 7.5999H13.0009C12.6699 7.5999 12.4009 7.3309 12.4009 6.9999ZM15.4004 14.4999C15.4004 14.1689 15.6684 13.8999 16.0004 13.8999C16.3314 13.8999 16.6004 14.1689 16.6004 14.4999V15.4999C16.6004 16.9339 15.4344 18.0999 14.0004 18.0999H9.00039C7.56739 18.0999 6.40039 16.9339 6.40039 15.4999V10.4999C6.40039 9.0659 7.56639 7.8999 9.00039 7.8999H10.0004C10.3314 7.8999 10.6004 8.1689 10.6004 8.4999C10.6004 8.8309 10.3324 9.0999 10.0004 9.0999H9.00039C8.22839 9.0999 7.60039 9.7289 7.60039 10.4999V15.4999C7.60039 16.2709 8.22839 16.8999 9.00039 16.8999H14.0004C14.7724 16.8999 15.4004 16.2709 15.4004 15.4999V14.4999Z"
  }));
};

var SvgComponent$10 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.6 17.5688L16.7 16.6687L15.4 15.3688L14.6 14.5688L9.80002 9.76875L8.90002 8.86875L7.80002 7.76875L6.90002 6.86875L4.60002 4.56875C4.30002 4.26875 3.90002 4.26875 3.70002 4.56875C3.50002 4.86875 3.40002 5.26875 3.70002 5.46875L5.70002 7.46875C4.30002 8.36875 3.00002 9.46875 2.10002 10.8688C1.50002 11.7688 1.50002 12.8688 2.10002 13.6688C4.20002 16.8688 7.90002 18.8688 12 18.8688C13.5 18.8688 15 18.5688 16.3 18.0688L18.3 20.1687C18.4 20.2688 18.6 20.3687 18.8 20.3687C19 20.3687 19.1 20.2688 19.3 20.1687C19.6 19.8687 19.6 19.4688 19.3 19.2688L17.6 17.5688ZM9.00002 10.7687L13.5 15.2688C13 15.4688 12.5 15.6688 12 15.6688C10.1 15.6688 8.60002 14.1687 8.60002 12.2687C8.60002 11.7687 8.70002 11.2687 9.00002 10.7687ZM12 17.6687C8.30002 17.6687 5.00002 15.9688 3.10002 13.0688C2.80002 12.5688 2.80002 11.9688 3.10002 11.5687C4.00002 10.1687 5.20002 9.16875 6.50002 8.36875L8.10002 9.96875C7.70002 10.6688 7.40002 11.4688 7.40002 12.3688C7.40002 14.8688 9.50002 16.9688 12 16.9688C12.9 16.9688 13.7 16.6687 14.4 16.2688L15.4 17.2688C14.3 17.4688 13.2 17.6687 12 17.6687ZM16.1 14.2688C16.4 13.6687 16.6 12.9688 16.6 12.2687C16.6 9.76875 14.5 7.66875 12 7.66875C11.3 7.66875 10.6 7.86875 10 8.16875L10.9 9.06875C11.2 8.96875 11.6 8.86875 12 8.86875C13.9 8.86875 15.4 10.3687 15.4 12.2687C15.4 12.6687 15.3 12.9688 15.2 13.3688L16.1 14.2688ZM21.9 10.8688C19.8 7.66875 16.1 5.66875 12 5.66875C10.7 5.66875 9.40002 5.86875 8.20002 6.26875L9.20002 7.26875C10.1 7.06875 11 6.86875 12 6.86875C15.7 6.86875 19 8.56875 20.9 11.4688C21.2 11.9688 21.2 12.5688 20.9 12.9688C20.1 14.1688 19.1 15.1688 17.9 15.8688L18.8 16.7688C20 15.9688 21.1 14.8688 21.9 13.5688C22.4 12.8688 22.4 11.7688 21.9 10.8688Z"
  }));
};

var SvgComponent$11 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M21.9 10.9695C19.8 7.76953 16.1 5.76953 12 5.76953C7.90002 5.76953 4.20002 7.66953 2.10002 10.9695C1.50002 11.8695 1.50002 12.9695 2.10002 13.7695C4.20002 16.9695 7.90002 18.9695 12 18.9695C16.1 18.9695 19.8 17.0695 21.9 13.7695C22.4 12.9695 22.4 11.7695 21.9 10.9695ZM20.9 13.1695C19 16.0695 15.7 17.7695 12 17.7695C8.30002 17.7695 5.00002 16.0695 3.10002 13.1695C2.80002 12.6695 2.80002 12.0695 3.10002 11.6695C5.00002 8.66953 8.30002 6.96953 12 6.96953C15.7 6.96953 19 8.66953 20.9 11.5695C21.2 12.0695 21.2 12.6695 20.9 13.1695ZM12 7.76953C9.50002 7.76953 7.40002 9.86953 7.40002 12.3695C7.40002 14.8695 9.50002 16.9695 12 16.9695C14.5 16.9695 16.6 14.8695 16.6 12.3695C16.6 9.86953 14.5 7.76953 12 7.76953ZM12 15.7695C10.1 15.7695 8.60002 14.2695 8.60002 12.3695C8.60002 10.4695 10.1 8.96953 12 8.96953C13.9 8.96953 15.4 10.4695 15.4 12.3695C15.4 14.2695 13.9 15.7695 12 15.7695Z"
  }));
};

var SvgComponent$12 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49961 9.14998H18.4996C18.8586 9.14998 19.1496 8.85898 19.1496 8.49998C19.1496 8.14098 18.8586 7.84998 18.4996 7.84998H5.49961C5.14061 7.84998 4.84961 8.14098 4.84961 8.49998C4.84961 8.85898 5.14061 9.14998 5.49961 9.14998ZM5.49961 17.15H18.4996C18.8586 17.15 19.1496 16.859 19.1496 16.5C19.1496 16.141 18.8586 15.85 18.4996 15.85H5.49961C5.14061 15.85 4.84961 16.141 4.84961 16.5C4.84961 16.859 5.14061 17.15 5.49961 17.15Z"
  }));
};

var SvgComponent$13 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40039 5.00002C5.40039 4.66902 5.66839 4.40002 6.00039 4.40002C6.33139 4.40002 6.60039 4.66902 6.60039 5.00002V19C6.60039 19.331 6.33139 19.6 6.00039 19.6C5.66939 19.6 5.40039 19.331 5.40039 19V5.00002ZM11.3284 11.45H19.0004L19.0014 11.449C19.3054 11.449 19.5514 11.695 19.5514 11.999C19.5514 12.303 19.3054 12.549 19.0014 12.549H11.3294L13.3904 14.611C13.6054 14.826 13.6054 15.173 13.3904 15.388C13.2834 15.495 13.1424 15.549 13.0014 15.549C12.8604 15.549 12.7194 15.495 12.6124 15.388L9.61242 12.388C9.39742 12.173 9.39742 11.826 9.61242 11.611L12.6124 8.61102C12.8264 8.39602 13.1754 8.39602 13.3894 8.61102C13.6044 8.82602 13.6044 9.17302 13.3894 9.38802L11.3284 11.45Z"
  }));
};

var SvgComponent$14 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.216 8.42198H3.6C3.269 8.42198 3 8.15298 3 7.82198C3 7.49098 3.268 7.22198 3.6 7.22198H6.216C6.493 5.93798 7.635 4.97198 9 4.97198C10.365 4.97198 11.507 5.93798 11.784 7.22198H20.4C20.731 7.22198 21 7.49098 21 7.82198C21 8.15298 20.732 8.42198 20.4 8.42198H11.784C11.507 9.70598 10.365 10.672 9 10.672C7.635 10.672 6.493 9.70598 6.216 8.42198ZM10.65 7.82198C10.65 6.91198 9.91 6.17198 9 6.17198C8.09 6.17198 7.35 6.91198 7.35 7.82198C7.35 8.73198 8.09 9.47198 9 9.47198C9.91 9.47198 10.65 8.73198 10.65 7.82198ZM17.784 15.623H20.4C20.731 15.623 21 15.892 21 16.223C21 16.554 20.732 16.823 20.4 16.823H17.784C17.507 18.107 16.365 19.073 15 19.073C13.635 19.073 12.493 18.107 12.216 16.823H3.6C3.269 16.823 3 16.554 3 16.223C3 15.892 3.268 15.623 3.6 15.623H12.216C12.493 14.339 13.635 13.373 15 13.373C16.365 13.373 17.507 14.339 17.784 15.623ZM13.35 16.223C13.35 17.133 14.09 17.873 15 17.873C15.91 17.873 16.65 17.133 16.65 16.223C16.65 15.313 15.91 14.573 15 14.573C14.09 14.573 13.35 15.313 13.35 16.223Z"
  }));
};

var SvgComponent$15 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18 5.56904C17.8 5.36904 17.5 5.36904 17.2 5.46904C15.8 5.96904 14.3 5.66904 12.8 5.26904C11.2 4.86904 9.50002 4.46904 7.70002 5.16904C7.20002 5.26904 6.90002 5.76904 6.90002 6.26904V20.969C6.90002 21.269 7.20002 21.569 7.50002 21.569C7.80002 21.569 8.10002 21.269 8.10002 20.969V14.469C9.50002 13.969 11 14.269 12.5 14.669C13.5 14.869 14.6 15.169 15.6 15.169C16.2 15.169 16.9 15.069 17.6 14.869C18.1 14.669 18.4 14.269 18.4 13.769V6.26904C18.3 5.96904 18.2 5.66904 18 5.56904Z"
  }));
};

var SvgComponent$16 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18 5.56915C17.8 5.36915 17.5 5.36915 17.1 5.46915C15.7 5.96915 14.2 5.66915 12.7 5.26915C11.1 4.86915 9.40002 4.46915 7.60002 5.06915C7.20002 5.26915 6.90002 5.76915 6.90002 6.26915V13.6691V20.9691C6.90002 21.2691 7.20002 21.5691 7.50002 21.5691C7.80002 21.5691 8.10002 21.2691 8.10002 20.9691V14.4691C9.50002 13.9691 10.9 14.2691 12.5 14.6691C13.5 14.8691 14.6 15.1691 15.6 15.1691C16.2 15.1691 16.9 15.0691 17.6 14.8691C18.1 14.6691 18.4 14.2691 18.4 13.7691V6.26915C18.4 5.96915 18.2 5.66915 18 5.56915ZM17.1 13.6691C15.7 14.1691 14.3 13.8691 12.7 13.4691C11.7 13.2691 10.6 12.9691 9.60002 12.9691C9.10002 12.9691 8.60002 13.0691 8.00002 13.1691V6.26915C9.40002 5.76915 10.9 6.06915 12.4 6.46915C13.9 6.86915 15.5 7.16915 17.1 6.76915C17.2 6.76915 17.1 13.6691 17.1 13.6691Z"
  }));
};

var SvgComponent$17 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4051 18.221C12.1901 18.472 11.8091 18.472 11.5941 18.221H11.5931C10.4811 16.921 7.41406 13.32 6.71806 12.314C5.89806 11.129 5.41406 9.755 5.41406 8.394V8.384C5.44606 6.67 6.14706 5.064 7.38906 3.862C8.62906 2.661 10.2661 2 11.9991 2C13.7321 2 15.3691 2.661 16.6091 3.862C17.8511 5.065 18.5521 6.671 18.5841 8.384V8.394C18.5841 9.755 18.1011 11.128 17.2801 12.314C16.5841 13.32 13.5181 16.921 12.4051 18.221ZM10.7901 5.697C10.7901 5.697 10.1011 5.758 9.98006 5.829H9.97806L7.70406 7.15L8.40706 9.001L9.65906 8.642L9.50806 12.625H14.4821L14.3311 8.642L15.5831 9.001L16.2861 7.15L14.0121 5.829C13.8911 5.759 13.2021 5.697 13.2021 5.697C13.2021 5.697 13.0711 6.89 11.9961 6.89C10.9221 6.89 10.7901 5.697 10.7901 5.697ZM15.4068 17.007C15.7648 16.581 16.1218 16.156 16.4668 15.74C18.5758 16.412 19.9148 17.566 19.9148 18.931C19.9148 21.108 16.5128 22.75 12.0018 22.75C7.49084 22.75 4.08984 21.109 4.08984 18.931C4.08984 17.566 5.42684 16.411 7.53584 15.74C7.88084 16.156 8.23684 16.581 8.59584 17.007C6.70084 17.484 5.58884 18.302 5.58884 18.931C5.58884 19.876 8.08584 21.25 12.0008 21.25C15.9158 21.25 18.4138 19.876 18.4138 18.931C18.4138 18.302 17.3018 17.484 15.4068 17.007Z"
  }));
};

var SvgComponent$18 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5004 4.90002H5.50039C4.06639 4.90002 2.90039 6.06602 2.90039 7.50002V16.5C2.90039 17.934 4.06739 19.1 5.50039 19.1H18.5004C19.9344 19.1 21.1004 17.934 21.1004 16.5V7.50002C21.1004 6.06602 19.9334 4.90002 18.5004 4.90002ZM19.9004 16.5C19.9004 17.271 19.2724 17.9 18.5004 17.9H5.50039C4.72839 17.9 4.10039 17.271 4.10039 16.5V10.1H19.9004V16.5ZM4.10039 8.90002V7.50002C4.10039 6.72902 4.72839 6.10002 5.50039 6.10002H18.5004C19.2724 6.10002 19.9004 6.72902 19.9004 7.50002V8.90002H4.10039ZM9.14116 12.468H7.28516V15.279H9.14116V12.468ZM12.0547 12.468H14.1487V15.279H12.0547V12.468ZM11.1214 12.468H10.1934V15.279H11.1214V12.468ZM15.1211 12.468H16.7141V15.279H15.1211V12.468Z"
  }));
};

var SvgComponent$19 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.7504 3.65002H6.25039C4.81639 3.65002 3.65039 4.81602 3.65039 6.25002V17.75C3.65039 19.184 4.81739 20.35 6.25039 20.35H17.7504C19.1844 20.35 20.3504 19.184 20.3504 17.75V6.25002C20.3504 4.81602 19.1834 3.65002 17.7504 3.65002ZM19.1504 6.25002V11.52H16.8264C17.0054 11.404 17.1724 11.274 17.3184 11.127C17.7104 10.736 17.9254 10.216 17.9254 9.66202C17.9254 9.10802 17.7104 8.58802 17.3194 8.19702C16.5374 7.41402 15.1714 7.41402 14.3894 8.19702C14.2454 8.34102 14.1174 8.50602 14.0024 8.68202V4.84902H17.7504C18.5224 4.84902 19.1504 5.47902 19.1504 6.25002ZM10.2764 10.49C10.0554 10.269 9.93339 9.97502 9.93339 9.66202C9.93339 9.34902 10.0554 9.05502 10.2764 8.83402C10.4974 8.61202 10.7914 8.49002 11.1044 8.49002C11.4174 8.49002 11.7114 8.61202 11.9334 8.83402C12.5934 9.49302 12.8554 10.785 12.9544 11.512C12.2284 11.413 10.9364 11.151 10.2764 10.491V10.49ZM14.0054 11.511C14.1044 10.784 14.3664 9.49202 15.0264 8.83302C15.2474 8.61102 15.5424 8.48902 15.8554 8.48902C16.1684 8.48902 16.4624 8.61102 16.6844 8.83302C16.9054 9.05402 17.0274 9.34802 17.0274 9.66102C17.0274 9.97402 16.9054 10.268 16.6844 10.489C16.0244 11.149 14.7324 11.412 14.0064 11.51L14.0054 11.511ZM6.25039 4.85002H13.0004V8.76002C12.8744 8.55502 12.7344 8.36202 12.5694 8.19802C11.7874 7.41502 10.4214 7.41502 9.64039 8.19802C9.24839 8.58902 9.03339 9.10902 9.03339 9.66302C9.03339 10.217 9.24839 10.737 9.63939 11.128C9.78539 11.274 9.95239 11.404 10.1314 11.521H4.85039V6.25002C4.85039 5.47902 5.47839 4.85002 6.25039 4.85002ZM4.85039 17.75V12.52H11.8584C10.5344 13.674 9.65639 15.137 9.60839 15.217L10.4684 15.727C10.4804 15.707 11.5424 13.938 13.0024 12.882L13.0044 19.151H6.25039C5.47839 19.151 4.85039 18.521 4.85039 17.75ZM17.7504 19.15H14.0054L14.0034 13.498C15.1254 14.449 16.6954 15.013 16.9334 15.094L17.2584 14.149C16.6464 13.938 15.2194 13.312 14.4194 12.519H19.1494V17.749C19.1494 18.52 18.5214 19.149 17.7494 19.149L17.7504 19.15Z"
  }));
};

var SvgComponent$1a = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 3.3999C7.25802 3.3999 3.40002 7.2579 3.40002 11.9999C3.40002 16.7419 7.25802 20.5999 12 20.5999C16.742 20.5999 20.6 16.7429 20.6 11.9999C20.6 7.2569 16.742 3.3999 12 3.3999ZM11.5 5.1399V7.6209C10.762 7.5999 10.046 7.5369 9.37602 7.4279C9.94402 6.4599 10.671 5.6599 11.5 5.1399ZM11.5 8.6209V11.4999H8.15902C8.22002 10.4039 8.48202 9.3299 8.90802 8.3549C9.72202 8.5049 10.595 8.5959 11.5 8.6209ZM11.5 12.4999V15.3789C10.633 15.4029 9.79402 15.4859 9.00902 15.6259C8.55902 14.7349 8.23002 13.6879 8.15202 12.4999H11.5ZM11.5 16.3789V18.7379C10.942 18.2649 10.198 17.5309 9.54602 16.5459C10.166 16.4529 10.824 16.3979 11.5 16.3789ZM12.5 18.7389V16.3789C13.176 16.3979 13.834 16.4529 14.455 16.5459C13.803 17.5309 13.058 18.2659 12.5 18.7389ZM12.5 15.3799V12.5009H15.848C15.77 13.6889 15.442 14.7359 14.991 15.6269C14.206 15.4869 13.366 15.4039 12.499 15.3799H12.5ZM12.5 11.5009V8.6219C13.404 8.5969 14.278 8.5069 15.092 8.3559C15.518 9.3309 15.78 10.4049 15.841 11.5009H12.5ZM12.5 7.6219V5.1409C13.329 5.6619 14.056 6.4609 14.624 7.4299C13.954 7.5389 13.238 7.6009 12.5 7.6219ZM13.77 4.8229C15.071 5.1439 16.239 5.8049 17.168 6.7139C16.725 6.9099 16.22 7.0759 15.668 7.2129C15.161 6.2739 14.515 5.4539 13.77 4.8229ZM8.33102 7.2129C7.77902 7.0759 7.27502 6.9099 6.83102 6.7139C7.76002 5.8049 8.92802 5.1439 10.23 4.8229C9.48402 5.4539 8.83802 6.2739 8.33102 7.2129ZM7.89502 8.1289C7.46202 9.1769 7.19202 10.3269 7.13602 11.4999H4.62502C4.72602 9.9989 5.27402 8.6219 6.14002 7.4979C6.65102 7.7469 7.24602 7.9569 7.89502 8.1289ZM7.14902 12.4999C7.22302 13.7629 7.55002 14.8799 8.00602 15.8429C7.31302 16.0199 6.67902 16.2389 6.14002 16.5019C5.27402 15.3769 4.72602 13.9999 4.62502 12.4999H7.14902ZM8.49302 16.7469C9.15602 17.8389 9.94202 18.6819 10.581 19.2609C9.13702 18.9789 7.84402 18.2769 6.83102 17.2869C7.31802 17.0719 7.87702 16.8899 8.49302 16.7469ZM15.507 16.7469C16.122 16.8899 16.681 17.0719 17.168 17.2859C16.156 18.2759 14.863 18.9779 13.419 19.2599C14.058 18.6809 14.844 17.8389 15.507 16.7469ZM15.993 15.8429C16.449 14.8799 16.776 13.7629 16.85 12.4999H19.374C19.273 13.9999 18.725 15.3769 17.859 16.5019C17.319 16.2389 16.686 16.0199 15.993 15.8429ZM16.863 11.4999C16.807 10.3269 16.537 9.1769 16.104 8.1289C16.753 7.9569 17.349 7.7479 17.859 7.4989C18.725 8.6239 19.273 9.9999 19.374 11.5009L16.863 11.4999Z"
  }));
};

var SvgComponent$1b = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.9992 20.96L10.6612 19.666C8.74322 17.824 5.53322 14.742 4.10622 12.955C3.14522 11.75 2.69922 10.544 2.69922 9.15997C2.69922 6.32097 5.12122 3.92297 7.98822 3.92297C10.1052 3.92297 11.3552 5.11097 11.9992 6.01297C12.6432 5.11097 13.8932 3.92297 16.0102 3.92297C18.8762 3.92297 21.2982 6.32097 21.2982 9.15997C21.2982 10.545 20.8522 11.751 19.8912 12.955C18.4682 14.738 15.2642 17.815 13.3492 19.654L11.9992 20.96Z"
  }));
};

var SvgComponent$1c = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.0102 3.9231C13.8932 3.9231 12.6432 5.1111 11.9992 6.0131C11.3552 5.1111 10.1052 3.9231 7.98822 3.9231C5.12122 3.9231 2.69922 6.3211 2.69922 9.1601C2.69922 10.5451 3.14622 11.7501 4.10722 12.9551C5.53222 14.7401 8.73922 17.8201 10.6552 19.6601L11.9992 20.9601L13.3342 19.6681C15.2532 17.8261 18.4642 14.7421 19.8912 12.9551C20.8512 11.7511 21.2992 10.5451 21.2992 9.1601C21.2992 6.3211 18.8782 3.9231 16.0102 3.9231ZM18.9542 12.2071C17.5772 13.9321 14.2772 17.1011 12.5042 18.8031L12.0002 19.2891L11.4872 18.7951C9.71622 17.0951 6.42122 13.9301 5.04622 12.2071C4.25422 11.2131 3.90022 10.2731 3.90022 9.1601C3.90022 6.9721 5.77322 5.1221 7.98922 5.1221C9.28422 5.1221 10.1452 5.7151 10.6882 6.3031L12.0002 7.6181L13.3102 6.3051C13.8522 5.7171 14.7142 5.1221 16.0112 5.1221C18.2282 5.1221 20.1002 6.9721 20.1002 9.1601C20.1002 10.2731 19.7462 11.2131 18.9542 12.2071Z"
  }));
};

var SvgComponent$1d = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.029 3 3 7.029 3 12C3 16.971 7.029 21 12 21C16.971 21 21 16.971 21 12C21 7.029 16.971 3 12 3ZM12 19.8C7.699 19.8 4.2 16.301 4.2 12C4.2 7.699 7.699 4.2 12 4.2C16.301 4.2 19.8 7.699 19.8 12C19.8 16.301 16.301 19.8 12 19.8ZM12.7992 15.26H11.1992V16.86H12.7992V15.26ZM9.33594 9.96395C9.33594 8.43895 10.5469 7.19995 12.0359 7.19995V7.20095C13.5499 7.20095 14.7359 8.37095 14.7359 9.86495C14.7359 11.1018 13.8931 12.0268 13.2771 12.7028L13.2769 12.703C13.1049 12.89 12.8749 13.142 12.8009 13.269V14H11.2009V13.191C11.2009 12.603 11.6149 12.149 12.0939 11.624L12.0951 11.6227C12.5828 11.087 13.1359 10.4795 13.1359 9.86395C13.1359 9.24795 12.6729 8.79995 12.0359 8.79995C11.4299 8.79995 10.9359 9.32195 10.9359 9.96395H9.33594Z"
  }));
};

var SvgComponent$1e = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.3 11.9689L18.3 6.36895C16.9 5.26895 15 5.26895 13.7 6.36895L6.69999 11.9689C5.79999 12.6689 5.29999 13.7689 5.29999 14.8689V26.3689C5.29999 26.7689 5.59999 27.0689 5.99999 27.0689H13C13.4 27.0689 13.7 26.7689 13.7 26.3689V20.0689H18.3V26.3689C18.3 26.7689 18.6 27.0689 19 27.0689H26C26.4 27.0689 26.7 26.7689 26.7 26.3689V14.7689C26.7 13.6689 26.2 12.6689 25.3 11.9689ZM25.3 25.6689H19.7V19.3689C19.7 18.9689 19.4 18.6689 19 18.6689H13C12.6 18.6689 12.3 18.9689 12.3 19.3689V25.6689H6.69999V14.7689C6.69999 14.0689 6.99999 13.3689 7.59999 12.9689L14.6 7.36895C15.4 6.66895 16.6 6.66895 17.5 7.36895L24.5 12.9689C25 13.3689 25.4 14.0689 25.4 14.7689L25.3 25.6689Z"
  }));
};

var SvgComponent$1f = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.3 11.8692L18.3 6.2692C17 5.2692 15 5.2692 13.7 6.3692L6.69999 11.9692C5.79999 12.6692 5.29999 13.7692 5.29999 14.8692V26.3692C5.29999 26.7692 5.59999 27.0692 5.99999 27.0692H12.8C13.2 27.0692 13.5 26.7692 13.5 26.3692V20.0692H18.6V26.3692C18.6 26.7692 18.9 27.0692 19.3 27.0692H26C26.4 27.0692 26.7 26.7692 26.7 26.3692V14.7692C26.7 13.6692 26.2 12.6692 25.3 11.8692Z"
  }));
};

var SvgComponent$1g = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.3 11.5001L18.3 5.90006C17 4.90006 15 4.90006 13.7 6.00006L6.70005 11.6001C5.80005 12.3001 5.30005 13.4001 5.30005 14.5001V26.0001C5.30005 26.4001 5.60005 26.7001 6.00005 26.7001H12.8C13.2 26.7001 13.5 26.4001 13.5 26.0001V19.7001H18.6V26.0001C18.6 26.4001 18.9 26.7001 19.3 26.7001H26C26.4 26.7001 26.7001 26.4001 26.7001 26.0001V14.4001C26.7001 13.3001 26.2 12.3001 25.3 11.5001Z"
  }));
};

var SvgComponent$1h = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.3 11.5001L18.3 5.90006C17 4.90006 15 4.90006 13.7 6.00006L6.70005 11.6001C5.80005 12.3001 5.30005 13.4001 5.30005 14.5001V26.0001C5.30005 26.4001 5.60005 26.7001 6.00005 26.7001H12.8C13.2 26.7001 13.5 26.4001 13.5 26.0001V19.7001H18.6V26.0001C18.6 26.4001 18.9 26.7001 19.3 26.7001H26C26.4 26.7001 26.7001 26.4001 26.7001 26.0001V14.4001C26.7001 13.3001 26.2 12.3001 25.3 11.5001Z"
  }));
};

var SvgComponent$1i = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z"
  }));
};

var SvgComponent$1j = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.029 3 3 7.029 3 12C3 16.971 7.029 21 12 21C16.971 21 21 16.971 21 12C21 7.029 16.971 3 12 3ZM12 19.8C7.699 19.8 4.2 16.301 4.2 12C4.2 7.699 7.699 4.2 12 4.2C16.301 4.2 19.8 7.699 19.8 12C19.8 16.301 16.301 19.8 12 19.8ZM12.7992 10.5H11.1992V16.5H12.7992V10.5ZM11.1992 7.5H12.7992V9.1H11.1992V7.5Z"
  }));
};

var SvgComponent$1k = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M4.2998 3.89893V19.1789H16.7798L19.6998 22.0189V3.89893H4.2998ZM18.4998 19.1789L17.2698 17.9789H5.4998V5.09893H18.4998V19.1789ZM9.4498 7.71893H8.0098V14.8089H9.4498V7.71893ZM13.6098 14.9189C13.7598 14.9189 13.8998 14.8989 14.0898 14.8689L14.5598 16.2489H15.9798L15.2798 14.2289C15.7498 13.7689 15.9798 13.2189 15.9798 12.5589V10.0389C15.9798 8.71893 14.9198 7.66893 13.5998 7.66893C12.2798 7.66893 11.2198 8.71893 11.2198 10.0389V12.5589C11.2198 13.8589 12.3098 14.9289 13.6098 14.9289V14.9189ZM12.6598 10.0389C12.6598 9.50893 13.0798 9.08893 13.5998 9.08893C14.1198 9.08893 14.5398 9.46893 14.5398 10.0389V12.5589C14.5398 13.0889 14.1198 13.5089 13.5998 13.5089C13.0798 13.5089 12.6598 13.0789 12.6598 12.5589V10.0389Z"
  }));
};

var SvgComponent$1l = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20 19.3221H3.99997C3.00697 19.3221 2.19897 18.5141 2.19897 17.5221C2.19897 16.8811 2.54397 16.2841 3.09797 15.9631L8.61097 12.0411C8.88197 11.8501 9.25597 11.9121 9.44797 12.1831C9.63997 12.4541 9.57597 12.8281 9.30597 13.0201L3.74597 16.9721C3.51397 17.1091 3.39897 17.3081 3.39897 17.5221C3.39897 17.8531 3.66797 18.1231 3.99897 18.1231H20C20.331 18.1231 20.6 17.8531 20.6 17.5221C20.6 17.3081 20.485 17.1091 20.3 17.0021L11.392 11.3271C11.219 11.2171 11.114 11.0261 11.114 10.8211V9.07908C11.114 8.76408 11.358 8.50308 11.672 8.48008C11.827 8.46708 13.216 8.30808 13.216 6.83408C13.216 6.00608 12.542 5.33108 11.714 5.33108C10.886 5.33108 10.212 6.00608 10.212 6.83408C10.212 7.16508 9.94298 7.43408 9.61198 7.43408C9.28098 7.43408 9.01197 7.16508 9.01197 6.83408C9.01197 5.34408 10.224 4.13208 11.714 4.13208C13.204 4.13208 14.416 5.34408 14.416 6.83408C14.416 8.55908 13.243 9.32408 12.314 9.57908V10.4921L20.921 15.9761C21.454 16.2831 21.799 16.8791 21.799 17.5211C21.799 18.5131 20.991 19.3211 19.999 19.3211L20 19.3221Z"
  }));
};

var SvgComponent$1m = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 2.90002C13.8378 2.90002 15.5748 3.60202 16.8908 4.87602L16.8918 4.87502C18.2118 6.15302 18.9568 7.86102 18.9908 9.68302C18.9908 11.118 18.5158 12.552 17.6188 13.85C16.7904 15.0464 12.6883 20.1038 12.47 20.373L12.4668 20.377C12.3528 20.518 12.1818 20.599 12.0008 20.599C11.8198 20.599 11.6488 20.518 11.5348 20.377C11.3588 20.161 7.21577 15.053 6.38277 13.85C5.48477 12.553 5.00977 11.118 5.00977 9.70402C5.04377 7.86102 5.78877 6.15302 7.10877 4.87602C8.42477 3.60102 10.1618 2.90002 11.9998 2.90002ZM11.9998 19.046C13.1318 17.645 15.9848 14.101 16.6308 13.167C17.3778 12.087 17.7898 10.856 17.7898 9.70402C17.7618 8.20302 17.1458 6.79402 16.0558 5.73702C14.9658 4.68102 13.5248 4.09902 11.9998 4.09902C10.4748 4.09902 9.03377 4.68102 7.94377 5.73702C6.85377 6.79402 6.23777 8.20302 6.20977 9.70502C6.20977 10.856 6.62077 12.087 7.36877 13.167C8.01477 14.101 10.8668 17.645 11.9998 19.046ZM9.40039 9.50295C9.40039 8.06895 10.5664 6.90295 12.0004 6.90295C13.4334 6.90295 14.6004 8.06895 14.6004 9.50295C14.6004 10.937 13.4334 12.103 12.0004 12.103C10.5674 12.103 9.40039 10.937 9.40039 9.50295ZM10.6004 9.50295C10.6004 10.274 11.2284 10.903 12.0004 10.903C12.7724 10.903 13.4004 10.274 13.4004 9.50295C13.4004 8.73195 12.7724 8.10295 12.0004 8.10295C11.2284 8.10295 10.6004 8.73195 10.6004 9.50295Z"
  }));
};

var SvgComponent$1n = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1504 9.89998H17.5004C18.6584 9.89998 19.6004 10.842 19.6004 12V18.5C19.6004 19.659 18.6584 20.6 17.5004 20.6H6.50039C5.34239 20.6 4.40039 19.658 4.40039 18.5V12C4.40039 10.841 5.34239 9.89998 6.50039 9.89998H7.85039V6.99998C7.85039 4.71198 9.71239 2.84998 12.0004 2.84998C14.2884 2.84998 16.1504 4.71198 16.1504 6.99998V9.89998ZM12.0004 4.14998C10.4294 4.14998 9.15039 5.42898 9.15039 6.99998V9.89998H14.8504V6.99998C14.8504 5.42798 13.5714 4.14998 12.0004 4.14998ZM17.5004 19.4C17.9964 19.4 18.4004 18.996 18.4004 18.5V12C18.4004 11.504 17.9964 11.1 17.5004 11.1H6.50039C6.00439 11.1 5.60039 11.504 5.60039 12V18.5C5.60039 18.996 6.00439 19.4 6.50039 19.4H17.5004ZM13.2623 15.2661C13.2623 15.9636 12.6969 16.5291 11.9993 16.5291C11.3018 16.5291 10.7363 15.9636 10.7363 15.2661C10.7363 14.5685 11.3018 14.0031 11.9993 14.0031C12.6969 14.0031 13.2623 14.5685 13.2623 15.2661Z"
  }));
};

var SvgComponent$1o = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4996 6.6501H5.49961C5.14061 6.6501 4.84961 6.3591 4.84961 6.0001C4.84961 5.6411 5.14061 5.3501 5.49961 5.3501H18.4996C18.8586 5.3501 19.1496 5.6411 19.1496 6.0001C19.1496 6.3591 18.8586 6.6501 18.4996 6.6501ZM18.4996 12.6491H5.49961C5.14061 12.6491 4.84961 12.3581 4.84961 11.9991C4.84961 11.6401 5.14061 11.3491 5.49961 11.3491H18.4996C18.8586 11.3491 19.1496 11.6401 19.1496 11.9991C19.1496 12.3581 18.8586 12.6491 18.4996 12.6491ZM5.49961 18.6501H18.4996C18.8586 18.6501 19.1496 18.3591 19.1496 18.0001C19.1496 17.6411 18.8586 17.3501 18.4996 17.3501H5.49961C5.14061 17.3501 4.84961 17.6411 4.84961 18.0001C4.84961 18.3591 5.14061 18.6501 5.49961 18.6501Z"
  }));
};

var SvgComponent$1p = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.4996 12.65H7.49961C7.14061 12.65 6.84961 12.359 6.84961 12C6.84961 11.641 7.14061 11.35 7.49961 11.35H16.4996C16.8586 11.35 17.1496 11.641 17.1496 12C17.1496 12.359 16.8586 12.65 16.4996 12.65Z"
  }));
};

var SvgComponent$1q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 75 75",
    width: 24,
    height: 24,
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M58.16,66.67a1.39,1.39,0,0,0-1,.42,1.32,1.32,0,0,0,0,1.93,1.36,1.36,0,0,0,1,.39,1.34,1.34,0,0,0,1-.39,1.33,1.33,0,0,0,.42-1,1.29,1.29,0,0,0-.42-1A1.34,1.34,0,0,0,58.16,66.67Zm0-8.1a1.41,1.41,0,0,0-1,.39,1.09,1.09,0,0,0-.42,1,3.32,3.32,0,0,0,.1.8c0,.13.06.27.1.42s.11.47.17.74.22.93.35,1.58c0,.15.06.33.09.5s0,.11,0,.17c.09.49.19,1,.29,1.67h.56c.1-.62.2-1.18.29-1.67a1,1,0,0,1,0-.17c0-.18.06-.35.09-.5.13-.62.25-1.14.37-1.56,0-.26.11-.51.17-.76s.06-.25.08-.37a5.13,5.13,0,0,0,.12-.85,1.29,1.29,0,0,0-.42-1A1.36,1.36,0,0,0,58.18,58.57Zm10.5,6.15L68.24,64l-.72-1.24-.92-1.57-1.35-2.32-2-3.38-.3-.51-1-1.66a4.49,4.49,0,0,0-1.46-1.51,4.45,4.45,0,0,0-6.24,1.51l-.42.73-.54.93-.88,1.52-1.38,2.37-1.35,2.32-.92,1.57L48.12,64l-.44.76-1.5,2.58A4.44,4.44,0,0,0,50,74H66.33a4.44,4.44,0,0,0,3.85-6.66Zm-.92,5.62a1.61,1.61,0,0,1-1.43.81H50a1.63,1.63,0,0,1-1.42-2.44l1.5-2.57,1.17-2,.1-.18L53,61.15l.52-.91,2.27-3.89,1-1.66a1.62,1.62,0,0,1,1.42-.81,1.93,1.93,0,0,1,.42,0,1.62,1.62,0,0,1,1,.76l1,1.66.06.11,2.21,3.78.52.91L65,64l.1.18,1.17,2,1.49,2.57A1.57,1.57,0,0,1,67.76,70.34ZM46.38,37.6,33,29.76l.11,15.48ZM69.38,11H5.62a1.41,1.41,0,0,0-1.41,1.41v50.1A1.41,1.41,0,0,0,5.62,64H44.87l1.64-2.81H7V55.52H49.78l1.64-2.81H7V22.3H68V57.93l2.79,4.8a1.1,1.1,0,0,0,0-.18V12.45A1.41,1.41,0,0,0,69.38,11ZM68,19.48H7V13.86H68Z",
    fillRule: "evenodd"
  }))));
};

var SvgComponent$1r = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m19.17,18.11c-1-1.09-1.13-3.05-1.13-4.83v-2.63c0-3.1-2.48-5.83-5.44-6.17v-1.98h-1.2v1.98c-2.96.33-5.44,3.07-5.44,6.17v2.63c0,1.78-.13,3.74-1.13,4.83-.16.17-.2.43-.11.65s.31.36.55.36h4c.22,1.31,1.36,2.31,2.73,2.31s2.51-1,2.73-2.31h4c.24,0,.45-.14.55-.36s.05-.47-.11-.65Zm-7.17,2.12c-.71,0-1.3-.47-1.5-1.11h3c-.2.64-.79,1.11-1.5,1.11Zm0-2.31h-5.61c.66-1.34.77-3.06.77-4.63v-2.63c0-2.62,2.31-5,4.84-5s4.84,2.38,4.84,5v2.63c0,1.58.11,3.29.77,4.63h-5.61Z"
  }));
};

var SvgComponent$1s = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.21,17 C18.2949379,16.1674062 17.7602099,14.9967855 17.73,13.76 L17.73,10.1 C17.7345835,7.21079815 15.5945232,4.76684925 12.73,4.39 L12.73,3.73 C12.7628643,3.45065151 12.6323114,3.17727078 12.3943942,3.02723399 C12.156477,2.87719719 11.853523,2.87719719 11.6156058,3.02723399 C11.3776886,3.17727078 11.2471357,3.45065151 11.28,3.73 L11.28,4.4 C8.41547684,4.77684925 6.2754165,7.22079815 6.28,10.11 L6.28,13.78 C6.24181022,15.0112789 5.70382438,16.173906 4.79,17 C4.60731091,17.145645 4.50063173,17.3663606 4.5,17.6 C4.5,18.0031679 4.82683213,18.33 5.23,18.33 L8.73,18.33 C8.94740021,19.9419204 10.3771648,21.1093428 12,21 C13.6161071,21.1103312 15.0431008,19.953899 15.27,18.35 L18.77,18.35 C18.9662659,18.3473657 19.1534448,18.2668637 19.2903501,18.1262075 C19.4272555,17.9855513 19.5026702,17.7962655 19.5,17.6 C19.5055874,17.3649709 19.3976417,17.141635 19.21,17 L19.21,17 Z M12,19.54 C11.1964503,19.6187343 10.4483712,19.121408 10.21,18.35 L13.79,18.35 C13.5653607,19.1315666 12.8076025,19.6353276 12,19.54 L12,19.54 Z M15.33,16.89 L6.79,16.89 C7.37025101,15.9541225 7.69121664,14.8807858 7.72,13.78 L7.72,10.1 C7.72,7.73345985 9.63845985,5.815 12.005,5.815 C14.3715402,5.815 16.29,7.73345985 16.29,10.1 L16.29,13.77 C16.3187834,14.8707858 16.639749,15.9441225 17.22,16.88 L15.33,16.89 Z"
  })));
};

var SvgComponent$1t = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3162 6.05902L13.2992 4.28802C13.0342 4.22202 12.7542 4.22302 12.4882 4.29102L3.67122 6.58102C2.95122 6.76802 2.44922 7.41802 2.44922 8.16102V16.818C2.44922 17.539 2.93222 18.183 3.62422 18.385L10.6562 20.439C10.8062 20.482 10.9592 20.504 11.1132 20.504C11.2692 20.504 11.4242 20.482 11.5742 20.437L20.3792 17.843C21.0682 17.64 21.5492 16.996 21.5492 16.278V7.64202C21.5492 6.89302 21.0422 6.24202 20.3172 6.05902H20.3162ZM12.7652 5.35502C12.8082 5.34302 12.8532 5.33702 12.8982 5.33702C12.9412 5.33702 12.9852 5.34302 13.0282 5.35402L18.9862 6.85802L11.0992 8.92202L5.00622 7.37102L12.7652 5.35502ZM3.54922 16.818V8.16102C3.54922 8.08202 3.57122 8.01002 3.60322 7.94202L10.6532 9.73502V19.292L3.93222 17.329C3.70622 17.264 3.54922 17.054 3.54922 16.818ZM20.4492 16.278C20.4492 16.512 20.2922 16.722 20.0672 16.789L11.5532 19.297V9.73302L20.3942 7.42002C20.4262 7.48902 20.4492 7.56202 20.4492 7.64202V16.278ZM16.1033 12.99L16.1022 12.9903V12.99H16.1033ZM16.1022 12.9903V12.999C16.1172 13.119 16.1283 13.249 16.1283 13.382C16.1243 14.677 15.3613 15.923 14.4253 16.168C13.4923 16.413 12.7362 15.566 12.7403 14.27C12.7443 12.975 13.5072 11.73 14.4403 11.485C15.0673 11.32 15.6123 11.646 15.9043 12.271L15.9102 12.285L15.1783 12.477L15.1753 12.474C14.9783 12.286 14.7233 12.207 14.4383 12.282C14.1322 12.362 13.8523 12.61 13.6483 12.941C13.4462 13.272 13.3223 13.69 13.3203 14.118C13.3193 14.545 13.4412 14.9 13.6413 15.125C13.8442 15.349 14.1233 15.45 14.4293 15.37C14.9483 15.234 15.3823 14.635 15.5103 13.942L14.4273 14.226L14.4293 13.429L16.1022 12.9903ZM18.7808 13.17L18.7888 10.647L18.7898 10.646V10.634L19.3658 10.483L19.3578 13.02C19.3548 14.045 18.7518 15.033 18.0108 15.227C17.2698 15.421 16.6718 14.748 16.6758 13.723L16.6828 11.187L17.2588 11.036L17.2508 13.572C17.2498 13.862 17.3368 14.105 17.4738 14.26C17.6108 14.414 17.8028 14.484 18.0128 14.429C18.4358 14.318 18.7788 13.756 18.7808 13.17Z"
  }));
};

var SvgComponent$1u = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 7.029 7.029 3 12 3C16.971 3 21 7.029 21 12C21 16.971 16.971 21 12 21C7.029 21 3 16.971 3 12ZM4.2 12C4.2 16.301 7.699 19.8 12 19.8C16.301 19.8 19.8 16.301 19.8 12C19.8 7.699 16.301 4.2 12 4.2C7.699 4.2 4.2 7.699 4.2 12ZM11.1 7.48206H12.673C14.286 7.48206 15.598 8.88106 15.598 10.6011C15.598 12.3211 14.286 13.7191 12.673 13.7191H11.1V16.8601H9.5V7.48206H11.1ZM11.1 12.1191H12.673C13.403 12.1191 13.998 11.4381 13.998 10.6011C13.998 9.76406 13.403 9.08206 12.673 9.08206H11.1V12.1191Z"
  }));
};

var SvgComponent$1v = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.029 3 3 7.029 3 12C3 16.971 7.029 21 12 21C16.971 21 21 16.971 21 12C21 7.029 16.971 3 12 3ZM12 19.8C7.699 19.8 4.2 16.301 4.2 12C4.2 7.699 7.699 4.2 12 4.2C16.301 4.2 19.8 7.699 19.8 12C19.8 16.301 16.301 19.8 12 19.8ZM10.6496 8.5H9.34961V15.5H10.6496V8.5ZM13.3496 8.5H14.6496V15.5H13.3496V8.5Z"
  }));
};

var SvgComponent$1w = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M10.4558553,3.4719535 L9.06485529,3.8199535 C8.13485529,4.0619535 7.36285529,4.6949535 6.89185529,5.5989535 C6.38685529,6.5689535 6.31185529,7.7179535 6.68685529,8.7509535 C8.07385529,12.5719535 10.0228553,16.1009535 12.4818553,19.2409535 C13.1078553,20.0419535 14.0258553,20.5139535 14.9978553,20.5349535 C15.9618553,20.5459535 16.9078553,20.1269535 17.5698553,19.3539535 L18.5108553,18.2539535 C18.5668553,18.1879535 18.5608553,18.0729535 18.4968553,18.0079535 C17.7678553,17.2509535 17.0648553,16.4419535 16.4078553,15.6019535 L16.3828553,15.5789535 C16.3628553,15.5609535 16.3328553,15.5569535 16.3088553,15.5689535 L16.2978553,15.5749535 L14.3418553,17.2329535 C14.1888553,17.3629535 13.9938553,17.4239535 13.7908553,17.3999535 C13.5918553,17.3769535 13.4128553,17.2719535 13.2928553,17.1109535 C11.4368553,14.6009535 9.90885529,11.8339535 8.74885529,8.8839535 C8.60485529,8.5199535 8.77285529,8.1059535 9.12785529,7.9469535 L11.4268553,6.9099535 C11.4828553,6.8849535 11.5178553,6.7849535 11.4848553,6.6879535 C11.1168553,5.6769535 10.7938553,4.6279535 10.5218553,3.5749535 C10.5108553,3.5279535 10.4858553,3.4899535 10.4558553,3.4719535 M15.0678553,21.9999535 C15.0338553,21.9999535 14.9998553,21.9989535 14.9658553,21.9989535 C13.5598553,21.9679535 12.2378553,21.2929535 11.3418553,20.1469535 C8.78785529,16.8859535 6.76285529,13.2209535 5.32385529,9.2539535 C4.80885529,7.8339535 4.91185529,6.2539535 5.60585529,4.9189535 C6.26085529,3.6629535 7.38785529,2.7459535 8.69985529,2.4029535 L10.0538553,2.0489535 C10.4418553,1.9469535 10.8478553,2.0059535 11.1938553,2.2109535 C11.5588553,2.4289535 11.8198553,2.7829535 11.9288553,3.2099535 C12.1868553,4.2159535 12.4958553,5.2179535 12.8478553,6.1859535 C13.1428553,6.9999535 12.7778553,7.9039535 12.0178553,8.2459535 L10.3618553,8.9929535 C11.3378553,11.3389535 12.5598553,13.5589535 14.0028553,15.6079535 L15.3648553,14.4549535 L15.3648553,14.4549535 C15.6818553,14.1859535 16.0838553,14.0609535 16.4888553,14.1019535 C16.9058553,14.1449535 17.2818553,14.3559535 17.5478553,14.6949535 C18.1738553,15.4959535 18.8438553,16.2669535 19.5388553,16.9879535 C20.1248553,17.5979535 20.1558553,18.5739535 19.6088553,19.2109535 L18.6678553,20.3099535 C17.7458553,21.3879535 16.4378553,21.9999535 15.0678553,21.9999535"
  }))));
};

var SvgComponent$1x = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8 12C19.8 7.699 16.301 4.2 12 4.2C7.699 4.2 4.2 7.699 4.2 12C4.2 16.301 7.699 19.8 12 19.8C16.301 19.8 19.8 16.301 19.8 12ZM3 12C3 7.029 7.029 3 12 3C16.971 3 21 7.029 21 12C21 16.971 16.971 21 12 21C7.029 21 3 16.971 3 12ZM16 11.9999L10 7.99292V15.9929L16 11.9999Z"
  }));
};

var SvgComponent$1y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.65 18H11.35V12.65H6V11.35H11.35V6H12.65V11.35H18V12.65H12.65V18Z"
  }));
};

var SvgComponent$1z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.46,18.5 L12,18.5 C12.0541371,19.0156254 12.1821125,19.5207914 12.38,20 L6.7,20 C6.49577901,20.0001634 6.30032235,19.9170411 6.15877495,19.7698318 C6.01722756,19.6226225 5.94183109,19.4240576 5.95,19.22 L5.95,11.99 L5.25,12.51 C4.91542533,12.7595652 4.44219304,12.6925984 4.19,12.36 L1.65,9 C1.4339922,8.67800617 1.49902614,8.24444658 1.8,8 L6.28,4.65 C7.13970363,4.21943728 8.08850933,3.99679334 9.05,4 L9.39,4 C9.66012234,3.99727261 9.91139129,4.13813551 10.05,4.37 C10.12,4.48 10.35,4.71 10.52,4.89 L10.71,5.09 C11.4855115,5.62911067 12.5144885,5.62911067 13.29,5.09 L13.48,4.89 C13.6526011,4.72213275 13.8161648,4.54521691 13.97,4.36 C14.1157625,4.14702578 14.3522997,4.01397362 14.61,4 L14.95,4 C15.9114481,3.99716582 16.8601688,4.2197898 17.72,4.65 L22.2,8 C22.5009739,8.24444658 22.5660078,8.67800617 22.35,9 L19.84,12.37 C19.587807,12.7025984 19.1145747,12.7695652 18.78,12.52 L18.08,12 L18.08,12.5 L17.58,12.5 C17.2443403,12.5032411 16.9096548,12.5367097 16.58,12.6 L16.58,10.52 C16.5813309,10.2350076 16.7440731,9.97539491 17,9.85 C17.245667,9.71551722 17.5453883,9.72704496 17.78,9.88 L19.08,10.88 L20.71,8.72 L16.84,5.85 C16.2532788,5.62162693 15.6295928,5.50299101 15,5.5 L14.54,5.92 L14.34,6.13 L14.22,6.24 C12.8770731,7.22212913 11.0529269,7.22212913 9.71,6.24 L9.59,6.13 L9.39,5.92 L9,5.5 C8.38054837,5.50706957 7.76743182,5.62562802 7.19,5.85 L3.32,8.72 L4.91,10.92 L6.21,9.92 C6.43931587,9.75022298 6.74440425,9.72318983 7,9.85 C7.26519158,9.96065501 7.44384672,10.2131025 7.46,10.5 L7.46,18.5 Z M21.78,20.72 C22.0553589,21.0155098 22.0472339,21.4760097 21.7616218,21.7616218 C21.4760097,22.0472339 21.0155098,22.0553589 20.72,21.78 L19.12,20.18 C17.7928573,21.1168343 15.996978,21.0237897 14.7737562,19.9548207 C13.5505343,18.8858518 13.217711,17.1186312 13.9682838,15.6779346 C14.7188565,14.2372379 16.3578584,13.4972969 17.9348653,13.8871884 C19.5118723,14.2770799 20.6172449,15.6955266 20.61,17.32 C20.6085414,17.9356489 20.4428425,18.5397593 20.13,19.07 L21.78,20.72 Z M15.11,17.32 C15.11,18.4245695 16.0054305,19.32 17.11,19.32 C18.2145695,19.32 19.11,18.4245695 19.11,17.32 C19.11,16.2154305 18.2145695,15.32 17.11,15.32 C16.0054305,15.32 15.11,16.2154305 15.11,17.32 Z"
  })));
};

var SvgComponent$1A = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 54,
    height: 43,
    viewBox: "0 0 54 43",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("g", {
    transform: "translate(-78.000000, -69.000000) translate(78.000000, 69.000000)"
  }, /*#__PURE__*/createElement("path", {
    d: "M52.51,42.46 L1.51,42.46 C0.889826994,42.4545115 0.39,41.9501973 0.39,41.33 L0.39,1.25 C0.39,0.952957531 0.507999661,0.668081149 0.718040405,0.458040405 C0.928081149,0.247999661 1.21295753,0.13 1.51,0.13 L52.51,0.13 C52.8070425,0.13 53.0919189,0.247999661 53.3019596,0.458040405 C53.5120003,0.668081149 53.63,0.952957531 53.63,1.25 L53.63,41.33 C53.63,41.9501973 53.130173,42.4545115 52.51,42.46 Z M2.62,40.21 L51.38,40.21 L51.38,2.38 L2.62,2.38 L2.62,40.21 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M35.39,34.5 L18.61,34.5 C17.9881817,34.494569 17.485431,33.9918183 17.48,33.37 L17.48,21.84 L15.59,22.22 C15.0361532,22.3263796 14.4877606,22.0117978 14.3,21.48 C12,14.61 12,14.08 12.66,13.6 C15.22,10.65 20.6,8.76999822 23.25,8.76999822 C23.6687586,8.76925844 24.0535915,9.00015815 24.25,9.37 C24.7360901,10.460511 25.7556981,11.2185838 26.94,11.37 C28.1687021,11.2193852 29.2432759,10.4705532 29.81,9.37 C30.0204704,9.02168812 30.4033152,8.81495196 30.81,8.83 C33.46,8.83 38.81,10.71 41.4,13.67 C42.09,14.14 42.1,14.67 39.76,21.54 C39.5722394,22.0717978 39.0238468,22.3863796 38.47,22.28 L36.58,21.9 L36.58,33.43 C36.5423917,34.0519353 36.0124208,34.5284637 35.39,34.5 Z M19.73,32.25 L34.27,32.25 L34.27,20.47 C34.2694541,20.1340747 34.4197194,19.815643 34.6793659,19.6025003 C34.9390124,19.3893577 35.2806188,19.3040141 35.61,19.37 L37.88,19.82 C38.55,17.82 39.21,15.71 39.42,14.82 C37.1473274,12.801572 34.3363662,11.4881686 31.33,11.04 C30.363099,12.5879514 28.6749782,13.5375193 26.85,13.56 C25.1255271,13.4380739 23.5621672,12.5022861 22.64,11.04 C19.6435512,11.491507 16.8431301,12.8048558 14.58,14.82 C14.79,15.69 15.45,17.82 16.11,19.82 L18.39,19.37 C18.7193812,19.3040141 19.0609876,19.3893577 19.3206341,19.6025003 C19.5802806,19.815643 19.7305459,20.1340747 19.73,20.47 L19.73,32.25 Z"
  }), /*#__PURE__*/createElement("polygon", {
    points: "17.53 20 19.25 17.9 19.71 20.57"
  }), /*#__PURE__*/createElement("polygon", {
    points: "34.29 20.57 34.75 17.9 36.47 20"
  })))));
};

var SvgComponent$1B = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M4.64,12 C4.61748005,9.15057789 6.24395235,6.5448957 8.81368713,5.31356445 C11.3834219,4.0822332 14.4333106,4.44715909 16.64,6.25 L6.25,16.59 C5.20581511,15.2882515 4.63776937,13.6687919 4.64,12 Z M12,19.36 C10.3299994,19.3593961 8.71041029,18.7877765 7.41,17.74 L17.75,7.41 C19.5528409,9.61668941 19.9177668,12.6665781 18.6864355,15.2363129 C17.4551043,17.8060476 14.8494221,19.43252 12,19.41 L12,19.36 Z"
  })));
};

var SvgComponent$1C = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9.5C1.5 6.877 3.627 4.75 6.25 4.75C8.873 4.75 11 6.877 11 9.5C11 10.366 10.752 11.166 10.347 11.865L10.364 11.875L5.673 20H2.786L6.114 14.236C3.555 14.162 1.5 12.077 1.5 9.5ZM17.75 4.75C20.373 4.75 22.5 6.877 22.5 9.5C22.5 10.366 22.252 11.166 21.847 11.865L21.864 11.875L17.173 20H14.286L17.614 14.236C15.055 14.162 13 12.077 13 9.5C13 6.877 15.127 4.75 17.75 4.75Z"
  }));
};

var SvgComponent$1D = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 19.25C3.627 19.25 1.5 17.123 1.5 14.5H1.501C1.501 13.634 1.749 12.834 2.154 12.135L2.137 12.125L6.827 4H9.714L6.386 9.764C8.945 9.838 11 11.923 11 14.5C11 17.123 8.873 19.25 6.25 19.25ZM22.5 14.5C22.5 17.123 20.373 19.25 17.75 19.25C15.127 19.25 13 17.123 13 14.5C13 13.634 13.248 12.834 13.653 12.135L13.636 12.125L18.327 4H21.214L17.886 9.764C20.445 9.838 22.5 11.923 22.5 14.5Z"
  }));
};

var SvgComponent$1E = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
  }));
};

var SvgComponent$1F = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
  }));
};

var SvgComponent$1G = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M7.49989 6.90002C7.16789 6.90002 6.89989 7.16902 6.89989 7.50002C6.89989 7.83102 7.16889 8.10002 7.49989 8.10002H15.0519L5.57589 17.576C5.34189 17.809 5.34189 18.19 5.57589 18.424C5.69289 18.541 5.84689 18.6 5.99989 18.6C6.15289 18.6 6.30689 18.541 6.42389 18.424L15.8999 8.94802V16.5C15.8999 16.831 16.1689 17.1 16.4999 17.1C16.8309 17.1 17.0999 16.831 17.0999 16.5V6.90002H7.49989Z"
  }));
};

var SvgComponent$1H = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.295 19.3269L17.431 16.464C18.569 15.0949 19.255 13.3379 19.255 11.4229C19.255 7.06695 15.711 3.52295 11.355 3.52295C6.99896 3.52295 3.45496 7.06595 3.45496 11.4229C3.45496 15.7799 6.99896 19.3219 11.355 19.3219C13.293 19.3219 15.067 18.6179 16.443 17.4559L19.305 20.3169C19.442 20.4539 19.621 20.5219 19.8 20.5219C19.979 20.5219 20.158 20.4539 20.295 20.3169C20.568 20.0439 20.568 19.5999 20.295 19.3269ZM4.85496 11.4229C4.85496 7.83895 7.77096 4.92295 11.355 4.92295C14.939 4.92295 17.855 7.83895 17.855 11.4229C17.855 15.007 14.939 17.922 11.355 17.922C7.77096 17.922 4.85496 15.007 4.85496 11.4229Z"
  }));
};

var SvgComponent$1I = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M26.89 26.2993L22.92 22.3293C24.49 20.5193 25.44 18.1693 25.44 15.5993C25.44 9.91932 20.82 5.29932 15.14 5.29932C9.46003 5.29932 4.84003 9.91932 4.84003 15.5993C4.84003 21.2793 9.46003 25.8993 15.14 25.8993C17.74 25.8993 20.12 24.9193 21.93 23.3193L25.9 27.2893C26.04 27.4293 26.22 27.4993 26.4 27.4993C26.58 27.4993 26.76 27.4293 26.9 27.2893C27.17 27.0193 27.17 26.5693 26.9 26.2993H26.89ZM15.14 24.4993C10.23 24.4993 6.24003 20.5093 6.24003 15.5993C6.24003 10.6893 10.23 6.69932 15.14 6.69932C20.05 6.69932 24.04 10.6893 24.04 15.5993C24.04 20.5093 20.05 24.4993 15.14 24.4993Z"
  }));
};

var SvgComponent$1J = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.2237 19.3981L17.2927 16.4671C18.4517 15.1061 19.1547 13.3461 19.1547 11.4221C19.1547 7.12107 15.6557 3.62207 11.3547 3.62207C7.05369 3.62207 3.55469 7.12207 3.55469 11.4231C3.55469 15.7241 7.05369 19.2221 11.3547 19.2221C13.3007 19.2221 15.0787 18.5011 16.4467 17.3181L19.3757 20.2461C19.4927 20.3631 19.6467 20.4221 19.7997 20.4221C19.9527 20.4221 20.1067 20.3631 20.2237 20.2461C20.4577 20.0121 20.4577 19.6321 20.2237 19.3981ZM4.75469 11.4231C4.75469 7.78307 7.71469 4.82207 11.3547 4.82207C14.9947 4.82207 17.9547 7.78307 17.9547 11.4231C17.9547 15.0631 14.9937 18.0231 11.3547 18.0231C7.71569 18.0231 4.75469 15.0621 4.75469 11.4231Z"
  }));
};

var SvgComponent$1K = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M22.25,21.54 C22.2500133,21.8069582 22.1432849,22.0628394 21.9535801,22.2506659 C21.7638754,22.4384924 21.5069449,22.5426696 21.24,22.54 L11.16,22.54 C10.6077153,22.54 10.16,22.0922847 10.16,21.54 L10.16,16.92 L22.25,16.92 L22.25,21.54 Z M11.17,21.54 L21.21,21.52 L21.21,17.93 L20.47,17.93 L20.47,18.72 C20.47,18.9961424 20.2461424,19.22 19.97,19.22 C19.6938576,19.22 19.47,18.9961424 19.47,18.72 L19.47,17.93 L18.58,17.93 L18.58,19.8 C18.58,20.0761424 18.3561424,20.3 18.08,20.3 C17.8038576,20.3 17.58,20.0761424 17.58,19.8 L17.58,17.91 L16.69,17.91 L16.69,18.7 C16.69,18.9761424 16.4661424,19.2 16.19,19.2 C15.9138576,19.2 15.69,18.9761424 15.69,18.7 L15.69,17.91 L14.8,17.91 L14.8,19.78 C14.8,20.0561424 14.5761424,20.28 14.3,20.28 C14.0238576,20.28 13.8,20.0561424 13.8,19.78 L13.8,17.9 L12.91,17.9 L12.91,18.69 C12.91,18.9661424 12.6861424,19.19 12.41,19.19 C12.1338576,19.19 11.91,18.9661424 11.91,18.69 L11.91,17.9 L11.17,17.9 L11.17,21.54 Z M22.31,8.79 C22.59937,9.04909443 22.6468109,9.48468785 22.42,9.8 L20,13.05 C19.8813184,13.214917 19.6984812,13.3220119 19.4965888,13.3448677 C19.2946964,13.3677234 19.0925452,13.3042121 18.94,13.17 L18.49,12.77 L18.49,15.4 L17.02,15.4 L17.02,11.12 C17.0193436,10.8291273 17.1869311,10.5641053 17.45,10.44 C17.7110789,10.3239037 18.0158901,10.3707977 18.23,10.56 L19.3,11.51 L20.82,9.51 L18.61,7.51 C17.9623258,6.93281582 17.1445589,6.58184288 16.28,6.51 L14,8.83 C13.8899863,8.93818218 13.7440975,9.00223089 13.59,9.01 C13.4205522,9.00976099 13.2583444,8.94127328 13.14,8.82 L12.26,7.91 L12.26,9.72 C12.3471853,9.63157011 12.4658244,9.5812384 12.59,9.58 C12.8661424,9.58 13.09,9.80385763 13.09,10.08 C13.09,10.3561424 12.8661424,10.58 12.59,10.58 C12.4658244,10.5787616 12.3471853,10.5284299 12.26,10.44 L12.26,12 C12.3471853,11.9115701 12.4658244,11.8612384 12.59,11.86 C12.8661424,11.86 13.09,12.0838576 13.09,12.36 C13.09,12.6361424 12.8661424,12.86 12.59,12.86 C12.4658244,12.8587616 12.3471853,12.8084299 12.26,12.72 L12.26,14.28 C12.3471853,14.1915701 12.4658244,14.1412384 12.59,14.14 C12.8661424,14.14 13.09,14.3638576 13.09,14.64 C13.09,14.9161424 12.8661424,15.14 12.59,15.14 C12.4658244,15.1387616 12.3471853,15.0884299 12.26,15 L12.26,15.45 L11.26,15.45 L11.26,7.9 L10.38,8.81 C10.2521327,8.91651107 10.0955093,8.98264096 9.93,9 C9.75757471,8.99456345 9.59492163,8.91865868 9.48,8.79 L7.28,6.55 C6.61920845,6.6977857 6.00674766,7.01089768 5.5,7.46 L3.29,9.46 L4.9,11.53 L5.9,10.63 C6.11511152,10.4417471 6.42121645,10.3985785 6.68,10.52 C6.93917421,10.6469765 7.10249662,10.9114033 7.1,11.2 L7.1,19.38 L8.5,19.38 L8.5,20.86 L6.35,20.86 C5.94521985,20.8545295 5.61996304,20.5248171 5.62,20.12 L5.62,12.79 L5.18,13.16 C5.02828235,13.2906817 4.82899648,13.3522792 4.63,13.33 C4.43053183,13.3062444 4.24966742,13.2013431 4.13,13.04 L1.71,9.79 C1.48673309,9.47905114 1.52958018,9.05058019 1.81,8.79 L4.53,6.37 C5.28866009,5.69544292 6.22007204,5.24531818 7.22,5.07 L8.56,3.74 C8.67526875,3.62024745 8.83379428,3.55179324 9,3.55 L14.48,3.55 C14.6412909,3.55178072 14.7955384,3.61634942 14.91,3.73 L16.21,5 C17.4572641,5.05640992 18.6471658,5.54013848 19.58,6.37 L22.31,8.79 Z M12.95,4.85 L10.55,4.85 L11.75,6.08 L12.95,4.85 Z M9.95,7.45 L10.6,6.75 L9,5.11 L8.31,5.8 L9.95,7.45 Z M13.6,7.45 L15.22,5.8 L14.51,5.11 L12.92,6.74 L13.6,7.45 Z"
  })));
};

var SvgComponent$1L = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M8.36799 8.41998L11.408 5.75898V13C11.408 13.331 11.677 13.6 12.008 13.6C12.339 13.6 12.608 13.331 12.608 13V5.75798L15.65 8.41898C15.754 8.50998 15.883 8.55498 16.012 8.55498C16.165 8.55498 16.317 8.49198 16.426 8.36698C16.626 8.13798 16.603 7.79098 16.374 7.59098L12.37 4.08798C12.162 3.90598 11.853 3.90598 11.645 4.08798L7.64299 7.59098C7.41399 7.79098 7.39199 8.13898 7.59099 8.36698C7.79099 8.59598 8.13899 8.61598 8.36699 8.41898L8.36799 8.41998Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19 12.9C18.668 12.9 18.4 13.169 18.4 13.5V17.515C18.4 18.286 17.772 18.915 17 18.915H6.99999C6.22799 18.915 5.59999 18.286 5.59999 17.515V13.5C5.59999 13.169 5.33099 12.9 4.99999 12.9C4.66899 12.9 4.39999 13.169 4.39999 13.5V17.515C4.39999 18.949 5.56699 20.115 6.99999 20.115H17C18.434 20.115 19.6 18.949 19.6 17.515V13.5C19.6 13.169 19.331 12.9 19 12.9Z"
  }));
};

var SvgComponent$1M = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M3 8.40002V14C3 15.434 4.166 16.6 5.6 16.6H18.4C19.834 16.6 21 15.434 21 14V8.40002H3ZM19.8 14C19.8 14.772 19.172 15.4 18.4 15.4H5.6C4.828 15.4 4.2 14.772 4.2 14V9.60003H6.322V11.091C6.322 11.395 6.568 11.641 6.872 11.641C7.176 11.641 7.422 11.395 7.422 11.091V9.60003H8.887V12.662C8.887 12.966 9.133 13.212 9.437 13.212C9.741 13.212 9.987 12.966 9.987 12.662V9.60003H11.451V11.091C11.451 11.395 11.697 11.641 12.001 11.641C12.305 11.641 12.551 11.395 12.551 11.091V9.60003H14.016V12.662C14.016 12.966 14.262 13.212 14.566 13.212C14.87 13.212 15.116 12.966 15.116 12.662V9.60003H16.581V11.091C16.581 11.395 16.827 11.641 17.131 11.641C17.435 11.641 17.681 11.395 17.681 11.091V9.60003H19.803V14H19.8Z"
  }));
};

var SvgComponent$1N = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6009 6.36105L21.2859 9.04605C21.7049 9.46505 21.7049 10.146 21.2859 10.565L19.2359 13.071C18.9179 13.385 18.4639 13.381 18.1879 13.103L18.1779 13.094V17.865C18.1779 18.379 17.7599 18.7971 17.2459 18.7971H13.2469V17.7971H17.2459L17.1779 10.765L18.6719 12.1851L20.5449 9.89505C20.6069 9.82905 20.6069 9.78205 20.5779 9.75305L17.8929 7.06805C17.4649 6.64105 16.9109 6.38505 16.3149 6.33505C15.9159 6.75105 14.8669 7.68305 13.5029 7.68305C12.1389 7.68305 11.0899 6.75105 10.6899 6.33505C10.0979 6.38605 9.53289 6.64705 9.11189 7.06805L7.78489 8.35805L7.08789 7.64105L8.40989 6.35605C9.07189 5.69305 9.95989 5.32605 10.9039 5.32605H11.1409L11.2919 5.51105C11.3009 5.52305 12.2669 6.68305 13.5029 6.68305C14.7374 6.68305 15.7015 5.52588 15.7139 5.5111L15.7139 5.51105L15.8639 5.32605H16.1019C17.0469 5.32605 17.9339 5.69305 18.6009 6.36105ZM13.3015 11.47C13.5115 11.681 13.6245 11.96 13.6205 12.256C13.6165 12.553 13.4955 12.828 13.2805 13.032L11.7465 14.487C11.7125 14.519 11.6935 14.564 11.6935 14.611V18.019C11.6935 18.447 11.3445 18.796 10.9155 18.796H5.10354C4.67454 18.796 4.32554 18.448 4.32554 18.019V14.611C4.32554 14.564 4.30654 14.519 4.27354 14.488L2.73854 13.031C2.52354 12.828 2.40254 12.553 2.39854 12.256C2.39454 11.96 2.50754 11.681 2.71754 11.47L4.18054 10.008C4.77854 9.40898 5.57454 9.07898 6.42154 9.07898H6.70354L6.84954 9.31998C6.84961 9.32007 6.8499 9.3205 6.8504 9.32127C6.87269 9.35513 7.31829 10.032 8.01054 10.032C8.71854 10.032 9.16854 9.32398 9.17254 9.31698L9.31954 9.08198L9.59854 9.07898C10.4455 9.07898 11.2415 9.40898 11.8395 10.008L13.3015 11.47ZM11.0595 13.762L12.5925 12.307C12.6335 12.268 12.6235 12.208 12.5945 12.177C12.5655 12.146 11.1325 10.715 11.1325 10.715C10.7805 10.363 10.3285 10.147 9.84054 10.093C9.55054 10.443 8.92654 11.032 8.01054 11.032C7.09454 11.032 6.47154 10.444 6.18054 10.093C5.69254 10.147 5.24054 10.362 4.88854 10.715C4.88854 10.715 3.46754 12.135 3.42654 12.177C3.38654 12.218 3.39354 12.274 3.42854 12.307C3.46454 12.341 4.96254 13.763 4.96254 13.763C5.19354 13.981 5.32654 14.292 5.32654 14.612V17.798H10.6935V14.612C10.6935 14.291 10.8275 13.982 11.0595 13.762Z"
  }));
};

var SvgComponent$1O = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M21.96 18.79H2.04004V19.79H21.96V18.79zM7 3.70996H6V15.68H7V3.70996z"
  }), /*#__PURE__*/createElement("path", {
    d: "M6.48998 16.3998L2.34998 12.2598 3.04998 11.5498 6.48998 14.9898 9.93998 11.5498 10.65 12.2598 6.48998 16.3998zM18.0601 3.70996H17.0601V15.66H18.0601V3.70996z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.55 16.4301L13.41 12.2901L14.11 11.5801L17.55 15.0201L21 11.5801L21.71 12.2901L17.55 16.4301Z"
  }));
};

var SvgComponent$1P = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.4759 1.95805L14.6839 8.75205H21.8279C22.3119 8.75205 22.5139 9.37205 22.1219 9.65705L16.3419 13.8561L18.5499 20.6501C18.6999 21.1111 18.1719 21.4941 17.7809 21.2091L12.0009 17.0101L6.22088 21.2091C5.82888 21.4941 5.30188 21.1111 5.45188 20.6501L7.65988 13.8561L1.87888 9.65705C1.48688 9.37205 1.68888 8.75205 2.17288 8.75205H9.31688L11.5249 1.95805C11.6749 1.49705 12.3259 1.49705 12.4759 1.95805Z"
  }));
};

var SvgComponent$1Q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.5249 1.95801L9.31688 8.75201H2.17288C1.68888 8.75201 1.48688 9.37201 1.87888 9.65601L7.65888 13.855L5.45088 20.649C5.30088 21.11 5.82888 21.493 6.21988 21.208L11.9939 17.013V1.61401C11.7959 1.61601 11.5989 1.73001 11.5249 1.95801Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21.8261 8.75304H14.6821L12.4751 1.95804C12.3991 1.72504 12.1961 1.61204 11.9941 1.61404V17.014L12.0001 17.01L17.7801 21.209C18.1721 21.494 18.6991 21.111 18.5491 20.65L16.3411 13.856L22.1211 9.65704C22.5131 9.37204 22.3101 8.75304 21.8261 8.75304Z"
  }));
};

var SvgComponent$1R = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.393 14.5429L23.5 9.37993H14.715L12 1.02393L9.285 9.37993H0.5L7.607 14.5429L4.893 22.8989L12 17.7349L19.107 22.8989L16.393 14.5429Z"
  }));
};

var SvgComponent$1S = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM13.4999 12.9999H10.4999V10.9999H13.4999V12.9999Z"
  }));
};

var SvgComponent$1T = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM15.7099 14.2899L14.2999 15.6999L12.0099 13.4099L9.71991 15.6999L8.30991 14.2899L10.5999 11.9999L8.30991 9.7099L9.71991 8.2999L12.0099 10.5899L14.2999 8.2999L15.7099 9.7099L13.4199 11.9999L15.7099 14.2899Z"
  }));
};

var SvgComponent$1U = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM10.8599 15.9799L7.28991 12.4199L8.69991 10.9999L10.8499 13.1499L15.2799 8.7199L16.6899 10.1299L10.8399 15.9699L10.8599 15.9799Z"
  }));
};

var SvgComponent$1V = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49844 4.90002H18.4984C19.9314 4.90002 21.0984 6.06602 21.0984 7.50002V17.998C21.0984 18.88 20.3804 19.598 19.4984 19.598H4.49844C3.61644 19.598 2.89844 18.88 2.89844 17.998V7.50002C2.89844 6.06602 4.06444 4.90002 5.49844 4.90002ZM15.9504 18.398V13.549H12.5504V18.398H15.9504ZM8.05044 18.398H11.4504V13.549H8.05044V18.398ZM19.4984 18.398C19.7194 18.398 19.8984 18.219 19.8984 17.998V7.50002C19.8984 6.72902 19.2704 6.10002 18.4984 6.10002H5.49844C4.72644 6.10002 4.09844 6.72902 4.09844 7.50002V17.998C4.09844 18.218 4.27744 18.398 4.49844 18.398H6.95044V13C6.95044 12.696 7.19644 12.45 7.50044 12.45H16.5004C16.8044 12.45 17.0504 12.696 17.0504 13V18.398H19.4984ZM15.0176 7.75H18.0176V10.75H15.0176V7.75Z"
  }));
};

var SvgComponent$1W = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18 11.3501H6V12.6511H18V11.3501Z"
  }));
};

var SvgComponent$1X = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 12 12",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM2.50049 6.06781L5.37293 8.93962L5.40658 8.97327L9.49955 4.88029L8.11926 3.5L5.40626 6.213L3.88078 4.68752L2.50049 6.06781Z"
  }));
};

var SvgComponent$1Y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0324 7.80103H18.5004H18.5014C19.9344 7.80103 21.1004 8.96703 21.1004 10.401V17.3C21.1004 18.734 19.9344 19.9 18.5004 19.9H5.50039C4.06739 19.9 2.90039 18.734 2.90039 17.3V10.401C2.90039 8.96703 4.06639 7.80103 5.50039 7.80103H6.96839L7.57539 5.97903C7.92939 4.91603 8.92039 4.20203 10.0414 4.20203H13.9584C15.0794 4.20203 16.0714 4.91603 16.4254 5.97903L17.0324 7.80103ZM18.4994 18.7C19.2714 18.7 19.8994 18.071 19.8994 17.3L19.8984 10.401C19.8984 9.63003 19.2704 9.00103 18.4994 9.00103H16.5994C16.3414 9.00103 16.1124 8.83503 16.0304 8.59003L15.2864 6.35903C15.0964 5.78703 14.5624 5.40203 13.9584 5.40203H10.0414C9.43739 5.40203 8.90339 5.78703 8.71339 6.35903L7.96839 8.59103C7.88639 8.83603 7.65739 9.00103 7.39939 9.00103H5.49939C4.72739 9.00103 4.09939 9.63003 4.09939 10.401V17.3C4.09939 18.071 4.72739 18.7 5.49939 18.7H18.4994ZM14.3417 10.459C15.4987 11.617 15.6097 13.423 14.6907 14.715L16.1087 16.134C16.3237 16.349 16.3237 16.696 16.1087 16.911C16.0017 17.018 15.8607 17.072 15.7197 17.072C15.5787 17.072 15.4377 17.018 15.3307 16.911L13.9127 15.493C13.3407 15.9 12.6727 16.112 11.9997 16.112C11.1517 16.112 10.3037 15.789 9.6577 15.143C8.3667 13.852 8.3667 11.75 9.6577 10.459C10.9497 9.16797 13.0497 9.16797 14.3417 10.459ZM10.4357 11.237C9.5737 12.099 9.5737 13.504 10.4357 14.366C11.2977 15.228 12.7007 15.227 13.5627 14.366C14.4247 13.503 14.4247 12.099 13.5627 11.237C13.1317 10.807 12.5657 10.591 11.9997 10.591C11.4337 10.591 10.8677 10.806 10.4357 11.237Z"
  }));
};

var SvgComponent$1Z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2074 3.95604L19.7074 7.36604C20.5664 7.81704 21.1004 8.69904 21.1004 9.66904V19C21.1004 19.882 20.3824 20.6 19.5004 20.6H4.50039C3.61839 20.6 2.90039 19.882 2.90039 19V9.66804C2.90039 8.69904 3.43439 7.81704 4.29239 7.36604L10.7924 3.95604C11.5484 3.56104 12.4514 3.56104 13.2074 3.95604ZM9.05039 19.4H14.9504V15.549H9.05039V19.4ZM19.5004 19.4C19.7204 19.4 19.9004 19.221 19.9004 19H19.9024V9.66904C19.9024 9.14704 19.6154 8.67104 19.1524 8.42904L12.6524 5.01904C12.4484 4.91304 12.2244 4.85904 12.0014 4.85904C11.7784 4.85904 11.5544 4.91304 11.3504 5.01904L4.85039 8.42904C4.38739 8.67104 4.10039 9.14704 4.10039 9.66804V19C4.10039 19.22 4.27939 19.4 4.50039 19.4H7.95039V15C7.95039 14.696 8.19639 14.45 8.50039 14.45H15.5004C15.8044 14.45 16.0504 14.696 16.0504 15V19.4H19.5004ZM7 10.5H9V12.5H7V10.5ZM11 10.5H13V12.5H11V10.5ZM17 10.5H15V12.5H17V10.5Z"
  }));
};

var SvgComponent$1_ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9958 20.5001L19.7098 12.5901C20.5898 11.5401 21.0488 10.1891 20.9958 8.79612C20.9448 7.40212 20.3828 6.09212 19.4168 5.10812C18.4508 4.12512 17.1698 3.55312 15.8078 3.50312C14.4388 3.45112 13.1278 4.05412 12.0958 4.96312L11.9958 5.05312L11.8938 4.96312C10.9128 4.09912 9.6728 3.50112 8.3818 3.50112C8.3148 3.50112 8.2468 3.50212 8.1798 3.50612C6.8168 3.55612 5.5358 4.12912 4.5708 5.11412C2.5948 7.13612 2.4668 10.4291 4.2788 12.6111L11.9958 20.5001Z"
  }))));
};

var SvgComponent$1$ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23254 4.93861C9.23984 4.89569 10.2176 5.25233 10.9828 5.92576L11.9951 6.81992L13.0085 5.92576C13.7727 5.25131 14.7616 4.89467 15.7577 4.93861C16.7661 4.9754 17.7154 5.39744 18.4306 6.12605C19.1449 6.85364 19.559 7.82137 19.5987 8.85144C19.6374 9.88049 19.2975 10.8789 18.6412 11.6616L18.5446 11.7761L11.9951 18.4736L5.34904 11.6616C4.69277 10.8779 4.35294 9.88049 4.39262 8.85144C4.43128 7.82137 4.84641 6.85466 5.55965 6.12605C6.27494 5.39744 7.22423 4.9754 8.23254 4.93861ZM4.27866 12.612L11.9951 20.5L19.7096 12.5905C20.5897 11.54 21.0486 10.1901 20.9957 8.79626C20.9438 7.4024 20.3821 6.09233 19.4166 5.10825C18.451 4.12416 17.169 3.55395 15.8076 3.50387C14.4381 3.45176 13.1276 3.92694 12.0959 4.83642L11.9951 4.92533L11.8944 4.83642C10.9126 3.9719 9.67226 3.50183 8.38109 3.50183C8.31394 3.50183 8.24679 3.50285 8.17964 3.50592C6.81623 3.55701 5.53524 4.12927 4.57067 5.11438C2.59475 7.13568 2.46655 10.4292 4.27866 12.612Z"
  }))));
};

var SvgComponent$20 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,19.42 C13.9679064,19.42 15.8552124,18.6382522 17.2467323,17.2467323 C18.6382522,15.8552124 19.42,13.9679064 19.42,12 C19.42,7.90204716 16.0979528,4.58 12,4.58 C7.90204716,4.58 4.58,7.90204716 4.58,12 C4.58,16.0979528 7.90204716,19.42 12,19.42 Z M12.14,7 C14.07,7 15.28,7.92 15.28,9.45 C15.2922252,9.99488698 15.1035792,10.5252314 14.75,10.94 C14.4905652,11.2226854 14.1906348,11.4653258 13.86,11.66 C13.5327273,11.8212295 13.2482969,12.0576837 13.03,12.35 C12.9165555,12.550954 12.8419245,12.7714546 12.81,13 C12.7754694,13.1713466 12.7553987,13.345292 12.75,13.52 L10.85,13.52 C10.7378491,12.616272 11.0222957,11.7082311 11.63,11.03 C12.07,10.59 13.07,10.35 13.07,9.59 C13.07,9.07 12.7,8.76 12.07,8.76 C11.6664399,8.73641604 11.2824608,8.93608517 11.07,9.28 C10.9540843,9.47406205 10.8887534,9.69412415 10.88,9.92 L8.72,9.92 C8.75652516,9.24779793 8.98948058,8.60108587 9.39,8.06 C10.0987622,7.30832529 11.1100887,6.9185049 12.14,7 Z M10.71,15.12 L12.9,15.12 L12.9,17.31 L10.71,17.31 L10.71,15.12 Z"
  })));
};

var SvgComponent$21 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.7998 25.1377L17.7002 25.1299V19.6309H14.2998V25.1309H6.20068L6.2002 13.4561L16 5.28809L25.7998 13.4561V25.1377ZM19.2998 23.5322L24.2002 23.5361V14.2061L16 7.37012L7.7998 14.2061L7.80029 23.5312H12.7002V18.0312H19.2998V23.5322Z"
  }));
};

var SvgComponent$22 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.7995 25.138L18.4995 25.1302V18.6667H13.4995V25.1302H6.19922V13.4557L15.9993 5.28775L25.7995 13.4557V25.138Z"
  }));
};

var SvgComponent$23 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.7997 25.1377L17.7001 25.1299V19.6309H14.2997V25.1309H6.20056L6.20007 13.4561L15.9999 5.28809L25.7997 13.4561V25.1377ZM19.2997 23.5322L24.2001 23.5361V14.2061L15.9999 7.37012L7.79968 14.2061L7.80017 23.5312H12.7001V18.0312H19.2997V23.5322Z"
  }));
};

var SvgComponent$24 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.8 25.1379L18.5 25.13V18.6665H13.5V25.13H6.19971V13.4556L15.9998 5.2876L25.8 13.4556V25.1379Z"
  }));
};

var SvgComponent$25 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,4.584 C7.911,4.584 4.584,7.911 4.584,12 C4.584,16.089 7.911,19.416 12,19.416 C16.089,19.416 19.416,16.089 19.416,12 C19.416,7.911 16.089,4.584 12,4.584 Z M12,21 C7.037,21 3,16.963 3,12 C3,7.037 7.037,3 12,3 C16.963,3 21,7.037 21,12 C21,16.963 16.963,21 12,21 Z M10.906,17.198 L10.906,10.632 L13.094,10.632 L13.094,17.198 L10.906,17.198 Z M12.1157,9.2642 L11.8847,9.2642 C11.3437,9.2642 10.9057,8.8262 10.9057,8.2852 L10.9057,8.0542 C10.9057,7.5132 11.3437,7.0752 11.8847,7.0752 L12.1157,7.0752 C12.6567,7.0752 13.0947,7.5132 13.0947,8.0542 L13.0947,8.2852 C13.0947,8.8262 12.6567,9.2642 12.1157,9.2642 Z"
  })));
};

var SvgComponent$26 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m4.3,3.53v15.28h12.48l2.92,2.84V3.53H4.3Zm14.2,15.28l-1.23-1.2H5.5V4.73h13v14.08ZM9.45,7.35h-1.44v7.09h1.44v-7.09Zm4.16,7.2c.15,0,.29-.02.48-.05l.47,1.38h1.42l-.7-2.02c.47-.46.7-1.01.7-1.67v-2.52c0-1.32-1.06-2.37-2.38-2.37s-2.38,1.05-2.38,2.37v2.52c0,1.3,1.09,2.37,2.39,2.37Zm-.95-4.88c0-.53.42-.95.94-.95s.94.38.94.95v2.52c0,.53-.42.95-.94.95s-.94-.43-.94-.95v-2.52Z"
  }));
};

var SvgComponent$27 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.6009 11.562V10.478C12.8709 10.25 13.3559 9.83402 13.8509 9.37602C14.2739 8.98502 14.7389 8.26602 14.5389 7.02902C14.4489 6.40002 13.8099 4.76502 11.8549 4.83702C9.7829 4.89502 9.2349 6.61902 9.2349 7.52402L10.4349 7.52802C10.4379 7.28602 10.5239 6.07502 11.8879 6.03702C13.1589 6.03402 13.3429 7.15402 13.3589 7.25202C13.4159 7.60602 13.4439 8.11902 13.0359 8.49602C12.3189 9.15802 11.6229 9.73102 11.6189 9.73502L11.3999 9.91502V11.561L3.3999 15.632V18.6H20.5999V15.632L12.6009 11.562ZM19.3989 17.4H4.5999V16.368L11.9999 12.602L19.3999 16.368L19.3989 17.4Z"
  }));
};

var SvgComponent$28 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C15.6912326,2.86941428 18.8059022,5.72156175 19,9.41 C18.9982191,10.1663341 18.8557978,10.9157415 18.58,11.62 L18.51,11.78 C18.47,11.89 18.41,12.02 18.34,12.14 L12.61,20.67 C12.4766023,20.8711045 12.2513254,20.992005 12.01,20.992005 C11.7686746,20.992005 11.5433977,20.8711045 11.41,20.67 L5.72,12.21 C5.61,12.02 5.55,11.89 5.5,11.77 L5.44,11.64 C5.1516915,10.9352541 5.00228592,10.181435 5,9.42 C5.19408173,5.73006445 8.30707874,2.87500148 12,3 Z M17.24,11.05 L17.24,11.06 C17.4366768,10.5424543 17.5383065,9.99365372 17.54,9.44 C17.3785231,6.53535348 14.9059405,4.30378075 12,4.44 L11.98,4.44 C9.10830659,4.34896874 6.69092081,6.57083067 6.54,9.44 C6.54382188,10.0060067 6.65583302,10.5660624 6.87,11.09 L6.87,11.21 L7,11.48 L12,19 L17.08,11.39 L17.17,11.19 L17.24,11.05 Z M12.11,6.55 C13.4920203,6.65622167 14.5731166,7.78469678 14.62,9.17 C14.627323,9.92189516 14.3275544,10.644229 13.79,11.17 C13.3116686,11.6379199 12.6691413,11.8999562 12,11.9 C11.3219138,11.9105415 10.6673514,11.6515937 10.18,11.18 C9.65788704,10.6725016 9.35924114,9.9780599 9.35,9.25 C9.3592204,8.49141779 9.6769529,7.76929847 10.23,7.25 C10.7371891,6.77359355 11.414744,6.52131245 12.11,6.55 Z M12.82,10.11 L12.82,10.12 C13.0500429,9.87006002 13.1722171,9.53947084 13.16,9.2 C13.1361107,8.56263483 12.6361895,8.04547497 12,8 C11.7182367,8.00664536 11.449773,8.12118985 11.25,8.32 C10.9934147,8.55874748 10.8423112,8.88973609 10.83,9.24 C10.8420815,9.56964368 10.981948,9.88165345 11.22,10.11 C11.4324118,10.3266944 11.72684,10.4430118 12.03,10.43 C12.325216,10.43162 12.6091327,10.3166158 12.82,10.11 Z"
  })));
};

var SvgComponent$29 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.548,18.554 L18.548,11.058 L6.451,11.058 L6.451,18.554 C6.451,19.098 6.892,19.54 7.432,19.54 L17.567,19.54 C18.108,19.54 18.548,19.098 18.548,18.554 Z M9.839,6.869 L9.839,9.599 L15.161,9.599 L15.161,6.869 C15.161,5.54 13.967,4.459 12.5,4.459 C11.032,4.459 9.839,5.54 9.839,6.869 Z M19.274,9.599 C19.674,9.599 20,9.926 20,10.329 L20,18.554 C20,19.903 18.908,21 17.567,21 L7.432,21 C6.091,21 5,19.903 5,18.554 L5,10.329 C5,9.926 5.325,9.599 5.725,9.599 L8.387,9.599 L8.387,6.869 C8.387,4.735 10.232,3 12.5,3 C14.768,3 16.612,4.735 16.612,6.869 L16.612,9.599 L19.274,9.599 Z M12.4997,16.7591 C11.6977,16.7591 11.0477,16.1061 11.0477,15.3001 C11.0477,14.4931 11.6977,13.8401 12.4997,13.8401 C13.3017,13.8401 13.9517,14.4931 13.9517,15.3001 C13.9517,16.1061 13.3017,16.7591 12.4997,16.7591 Z"
  })));
};

var SvgComponent$2a = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 5.3501H4.5V6.6511H19.5V5.3501ZM19.5 17.3501H4.5V18.6511H19.5V17.3501ZM4.5 11.3501H19.5V12.6511H4.5V11.3501Z"
  }));
};

var SvgComponent$2b = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("rect", {
    x: 5.5,
    y: 11,
    width: 13,
    height: 2
  })));
};

var SvgComponent$2c = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 75 75",
    width: 24,
    height: 24,
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M58.16,66.67a1.39,1.39,0,0,0-1,.42,1.32,1.32,0,0,0,0,1.93,1.36,1.36,0,0,0,1,.39,1.34,1.34,0,0,0,1-.39,1.33,1.33,0,0,0,.42-1,1.29,1.29,0,0,0-.42-1A1.34,1.34,0,0,0,58.16,66.67Zm0-8.1a1.41,1.41,0,0,0-1,.39,1.09,1.09,0,0,0-.42,1,3.32,3.32,0,0,0,.1.8c0,.13.06.27.1.42s.11.47.17.74.22.93.35,1.58c0,.15.06.33.09.5s0,.11,0,.17c.09.49.19,1,.29,1.67h.56c.1-.62.2-1.18.29-1.67a1,1,0,0,1,0-.17c0-.18.06-.35.09-.5.13-.62.25-1.14.37-1.56,0-.26.11-.51.17-.76s.06-.25.08-.37a5.13,5.13,0,0,0,.12-.85,1.29,1.29,0,0,0-.42-1A1.36,1.36,0,0,0,58.18,58.57Zm10.5,6.15L68.24,64l-.72-1.24-.92-1.57-1.35-2.32-2-3.38-.3-.51-1-1.66a4.49,4.49,0,0,0-1.46-1.51,4.45,4.45,0,0,0-6.24,1.51l-.42.73-.54.93-.88,1.52-1.38,2.37-1.35,2.32-.92,1.57L48.12,64l-.44.76-1.5,2.58A4.44,4.44,0,0,0,50,74H66.33a4.44,4.44,0,0,0,3.85-6.66Zm-.92,5.62a1.61,1.61,0,0,1-1.43.81H50a1.63,1.63,0,0,1-1.42-2.44l1.5-2.57,1.17-2,.1-.18L53,61.15l.52-.91,2.27-3.89,1-1.66a1.62,1.62,0,0,1,1.42-.81,1.93,1.93,0,0,1,.42,0,1.62,1.62,0,0,1,1,.76l1,1.66.06.11,2.21,3.78.52.91L65,64l.1.18,1.17,2,1.49,2.57A1.57,1.57,0,0,1,67.76,70.34ZM46.38,37.6,33,29.76l.11,15.48ZM69.38,11H5.62a1.41,1.41,0,0,0-1.41,1.41v50.1A1.41,1.41,0,0,0,5.62,64H44.87l1.64-2.81H7V55.52H49.78l1.64-2.81H7V22.3H68V57.93l2.79,4.8a1.1,1.1,0,0,0,0-.18V12.45A1.41,1.41,0,0,0,69.38,11ZM68,19.48H7V13.86H68Z",
    fillRule: "evenodd"
  }))));
};

var SvgComponent$2d = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m19.17,18.11c-1-1.09-1.13-3.05-1.13-4.83v-2.63c0-3.1-2.48-5.83-5.44-6.17v-1.98h-1.2v1.98c-2.96.33-5.44,3.07-5.44,6.17v2.63c0,1.78-.13,3.74-1.13,4.83-.16.17-.2.43-.11.65s.31.36.55.36h4c.22,1.31,1.36,2.31,2.73,2.31s2.51-1,2.73-2.31h4c.24,0,.45-.14.55-.36s.05-.47-.11-.65Zm-7.17,2.12c-.71,0-1.3-.47-1.5-1.11h3c-.2.64-.79,1.11-1.5,1.11Zm0-2.31h-5.61c.66-1.34.77-3.06.77-4.63v-2.63c0-2.62,2.31-5,4.84-5s4.84,2.38,4.84,5v2.63c0,1.58.11,3.29.77,4.63h-5.61Z"
  }));
};

var SvgComponent$2e = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.21,17 C18.2949379,16.1674062 17.7602099,14.9967855 17.73,13.76 L17.73,10.1 C17.7345835,7.21079815 15.5945232,4.76684925 12.73,4.39 L12.73,3.73 C12.7628643,3.45065151 12.6323114,3.17727078 12.3943942,3.02723399 C12.156477,2.87719719 11.853523,2.87719719 11.6156058,3.02723399 C11.3776886,3.17727078 11.2471357,3.45065151 11.28,3.73 L11.28,4.4 C8.41547684,4.77684925 6.2754165,7.22079815 6.28,10.11 L6.28,13.78 C6.24181022,15.0112789 5.70382438,16.173906 4.79,17 C4.60731091,17.145645 4.50063173,17.3663606 4.5,17.6 C4.5,18.0031679 4.82683213,18.33 5.23,18.33 L8.73,18.33 C8.94740021,19.9419204 10.3771648,21.1093428 12,21 C13.6161071,21.1103312 15.0431008,19.953899 15.27,18.35 L18.77,18.35 C18.9662659,18.3473657 19.1534448,18.2668637 19.2903501,18.1262075 C19.4272555,17.9855513 19.5026702,17.7962655 19.5,17.6 C19.5055874,17.3649709 19.3976417,17.141635 19.21,17 L19.21,17 Z M12,19.54 C11.1964503,19.6187343 10.4483712,19.121408 10.21,18.35 L13.79,18.35 C13.5653607,19.1315666 12.8076025,19.6353276 12,19.54 L12,19.54 Z M15.33,16.89 L6.79,16.89 C7.37025101,15.9541225 7.69121664,14.8807858 7.72,13.78 L7.72,10.1 C7.72,7.73345985 9.63845985,5.815 12.005,5.815 C14.3715402,5.815 16.29,7.73345985 16.29,10.1 L16.29,13.77 C16.3187834,14.8707858 16.639749,15.9441225 17.22,16.88 L15.33,16.89 Z"
  })));
};

var SvgComponent$2f = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8722 2.70297L17.5732 1.71997V2.85897L14.0752 3.78197L8.54922 4.40897V6.49997H7.44922V3.42697L13.8722 2.70297ZM17.5745 5.12701L13.6695 6.03701L12.1025 7.47601H10.8555V8.57501H12.5305L14.2015 7.04301L17.5745 6.25801V5.12701ZM14.9842 8.50003H13.8842V9.95003H10.0332V8.02503C10.0332 7.26103 10.4862 6.56903 11.1852 6.26003L10.7422 5.25403C9.64322 5.73703 8.93322 6.82503 8.93322 8.02503V9.95003H5.44922V22.05H18.5492V9.95003H14.9832L14.9842 8.50003ZM17.4502 20.95H6.55022V11.05H17.4502V20.95ZM15.9563 17.624H14.1562V19.424H15.9563V17.624ZM11.4551 17.624H13.2551V19.424H11.4551V17.624Z"
  }));
};

var SvgComponent$2g = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M11.6328,12.6025 L13.3388,12.6025 C13.8438,12.6025 14.2288,12.4835 14.4938,12.2465 C14.7588,12.0085 14.8918,11.6685 14.8918,11.2275 C14.8918,10.7735 14.7578,10.4075 14.4898,10.1265 C14.2238,9.8475 13.8548,9.7025 13.3828,9.6945 L11.6328,9.6945 L11.6328,12.6025 Z M11.6328,14.1485 L11.6328,17.4135 L9.7248,17.4135 L9.7248,8.1475 L13.3388,8.1475 C14.0338,8.1475 14.6468,8.2755 15.1748,8.5295 C15.7028,8.7845 16.1098,9.1455 16.3938,9.6145 C16.6778,10.0835 16.8198,10.6175 16.8198,11.2155 C16.8198,12.1235 16.5088,12.8385 15.8878,13.3625 C15.2658,13.8865 14.4048,14.1485 13.3068,14.1485 L11.6328,14.1485 Z M12.5,5.457 C8.616,5.457 5.457,8.616 5.457,12.5 C5.457,16.384 8.616,19.543 12.5,19.543 C16.384,19.543 19.543,16.384 19.543,12.5 C19.543,8.616 16.384,5.457 12.5,5.457 Z M12.5,21 C7.813,21 4,17.187 4,12.5 C4,7.812 7.813,4 12.5,4 C17.187,4 21,7.812 21,12.5 C21,17.187 17.187,21 12.5,21 Z"
  }))));
};

var SvgComponent$2h = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 11.9999C3.40039 7.2579 7.25839 3.3999 12.0004 3.3999C16.7424 3.3999 20.6004 7.2569 20.6004 11.9999C20.6004 16.7429 16.7424 20.5999 12.0004 20.5999C7.25839 20.5999 3.40039 16.7419 3.40039 11.9999ZM4.60039 11.9999C4.60039 16.0799 7.91939 19.3999 12.0004 19.3999C16.0814 19.3999 19.4004 16.0799 19.4004 11.9999C19.4004 7.9199 16.0814 4.5999 12.0004 4.5999C7.91939 4.5999 4.60039 7.9199 4.60039 11.9999ZM10.6004 8.49988H9.40039V15.4999H10.6004V8.49988ZM14.6004 8.49988H13.4004V15.4999H14.6004V8.49988Z"
  }));
};

var SvgComponent$2i = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M10.4558553,3.4719535 L9.06485529,3.8199535 C8.13485529,4.0619535 7.36285529,4.6949535 6.89185529,5.5989535 C6.38685529,6.5689535 6.31185529,7.7179535 6.68685529,8.7509535 C8.07385529,12.5719535 10.0228553,16.1009535 12.4818553,19.2409535 C13.1078553,20.0419535 14.0258553,20.5139535 14.9978553,20.5349535 C15.9618553,20.5459535 16.9078553,20.1269535 17.5698553,19.3539535 L18.5108553,18.2539535 C18.5668553,18.1879535 18.5608553,18.0729535 18.4968553,18.0079535 C17.7678553,17.2509535 17.0648553,16.4419535 16.4078553,15.6019535 L16.3828553,15.5789535 C16.3628553,15.5609535 16.3328553,15.5569535 16.3088553,15.5689535 L16.2978553,15.5749535 L14.3418553,17.2329535 C14.1888553,17.3629535 13.9938553,17.4239535 13.7908553,17.3999535 C13.5918553,17.3769535 13.4128553,17.2719535 13.2928553,17.1109535 C11.4368553,14.6009535 9.90885529,11.8339535 8.74885529,8.8839535 C8.60485529,8.5199535 8.77285529,8.1059535 9.12785529,7.9469535 L11.4268553,6.9099535 C11.4828553,6.8849535 11.5178553,6.7849535 11.4848553,6.6879535 C11.1168553,5.6769535 10.7938553,4.6279535 10.5218553,3.5749535 C10.5108553,3.5279535 10.4858553,3.4899535 10.4558553,3.4719535 M15.0678553,21.9999535 C15.0338553,21.9999535 14.9998553,21.9989535 14.9658553,21.9989535 C13.5598553,21.9679535 12.2378553,21.2929535 11.3418553,20.1469535 C8.78785529,16.8859535 6.76285529,13.2209535 5.32385529,9.2539535 C4.80885529,7.8339535 4.91185529,6.2539535 5.60585529,4.9189535 C6.26085529,3.6629535 7.38785529,2.7459535 8.69985529,2.4029535 L10.0538553,2.0489535 C10.4418553,1.9469535 10.8478553,2.0059535 11.1938553,2.2109535 C11.5588553,2.4289535 11.8198553,2.7829535 11.9288553,3.2099535 C12.1868553,4.2159535 12.4958553,5.2179535 12.8478553,6.1859535 C13.1428553,6.9999535 12.7778553,7.9039535 12.0178553,8.2459535 L10.3618553,8.9929535 C11.3378553,11.3389535 12.5598553,13.5589535 14.0028553,15.6079535 L15.3648553,14.4549535 L15.3648553,14.4549535 C15.6818553,14.1859535 16.0838553,14.0609535 16.4888553,14.1019535 C16.9058553,14.1449535 17.2818553,14.3559535 17.5478553,14.6949535 C18.1738553,15.4959535 18.8438553,16.2669535 19.5388553,16.9879535 C20.1248553,17.5979535 20.1558553,18.5739535 19.6088553,19.2109535 L18.6678553,20.3099535 C17.7458553,21.3879535 16.4378553,21.9999535 15.0678553,21.9999535"
  }))));
};

var SvgComponent$2j = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 11.9999C3.40039 7.2579 7.25839 3.3999 12.0004 3.3999C16.7424 3.3999 20.6004 7.2569 20.6004 11.9999C20.6004 16.7429 16.7424 20.5999 12.0004 20.5999C7.25839 20.5999 3.40039 16.7419 3.40039 11.9999ZM4.60039 11.9999C4.60039 16.0799 7.91939 19.3999 12.0004 19.3999C16.0814 19.3999 19.4004 16.0799 19.4004 11.9999C19.4004 7.9199 16.0814 4.5999 12.0004 4.5999C7.91939 4.5999 4.60039 7.9199 4.60039 11.9999ZM15.25 11.9999L10.25 15.4999V8.49988L15.25 11.9999Z"
  }));
};

var SvgComponent$2k = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.8129 13.7902C21.4753 12.8404 21.8667 11.6884 21.8667 10.4453C21.8667 7.20996 19.2349 4.57812 16 4.57812C12.7651 4.57812 10.1338 7.20996 10.1338 10.4453C10.1338 11.6884 10.5251 12.8404 11.1874 13.7903L6.9668 16.7676V25.6211H25.0332V16.7676L20.8129 13.7902ZM16 6.17773C18.3525 6.17773 20.2671 8.0918 20.2671 10.4453C20.2671 12.7979 18.3525 14.7119 16 14.7119C13.6475 14.7119 11.7334 12.7979 11.7334 10.4453C11.7334 8.0918 13.6475 6.17773 16 6.17773ZM23.4336 24.0215H8.56641V17.5977L12.28 14.9772C13.2932 15.8104 14.589 16.3115 16 16.3115C17.4111 16.3115 18.7071 15.8103 19.7203 14.9772L23.4336 17.5977V24.0215Z"
  }));
};

var SvgComponent$2l = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.275 14.2279C21.1689 13.2188 21.7168 11.8964 21.7168 10.4453C21.7168 7.29297 19.1523 4.72754 16 4.72754C12.8477 4.72754 10.2822 7.29297 10.2822 10.4453C10.2822 11.8963 10.8302 13.2186 11.7243 14.2277L7.11621 17.4785V25.4717H24.8838V17.4785L20.275 14.2279Z"
  }));
};

var SvgComponent$2m = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.3 21.7C19.6 20.1 18.7 18.8 17.4 18C16 17.1 14.2 16.6 12 16.6C9.8 16.6 7.9 17.1 6.5 18C5.3 18.8 4.4 19.9 3.8 21.3L3.7 21.6L2.8 21.3L2.9 21C3.6 19.4 4.6 18.1 5.9 17.2C7.5 16.2 9.5 15.6 12 15.6C14.5 15.6 16.4 16.1 17.9 17.1C19.4 18 20.5 19.4 21.2 21.2L20.3 21.7ZM11.9 14.2C10.3 14.2 8.8 13.6 7.6 12.5C6.5 11.3 5.9 9.79999 5.9 8.29999C5.9 6.79999 6.5 5.19999 7.7 4.09999C8.8 2.89999 10.3 2.29999 11.9 2.29999C13.5 2.29999 15 2.89999 16.2 3.99999C17.3 5.19999 17.9 6.69999 17.9 8.29999C17.9 9.89999 17.3 11.4 16.1 12.5C15 13.6 13.5 14.2 11.9 14.2ZM11.9 3.29999C10.5 3.29999 9.3 3.79999 8.3 4.79999C7.4 5.69999 6.8 6.89999 6.8 8.29999C6.8 9.69999 7.3 10.9 8.3 11.8C9.3 12.7 10.5 13.3 11.9 13.3C13.3 13.3 14.5 12.8 15.5 11.8C16.5 10.9 17 9.59999 17 8.29999C17 6.99999 16.5 5.69999 15.5 4.79999C14.5 3.79999 13.3 3.29999 11.9 3.29999Z"
  }));
};

var SvgComponent$2n = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.39 13.4599C18.17 13.4599 17.95 13.4899 17.75 13.5499L15.45 11.9999L17.75 10.4499C17.95 10.5099 18.17 10.5399 18.39 10.5399C19.68 10.5399 20.74 9.48986 20.74 8.19986C20.74 6.90986 19.68 5.85986 18.39 5.85986C17.1 5.85986 16.05 6.90986 16.05 8.19986C16.05 8.78986 16.27 9.33986 16.65 9.74986L14.36 11.2799L7.68005 6.77986C7.17005 6.43986 6.57005 6.24986 5.95005 6.24986C4.91005 6.24986 3.95005 6.76986 3.38005 7.62986L3.05005 8.12986L8.80005 11.9999L3.05005 15.8799L3.38005 16.3699C3.95005 17.2399 4.91005 17.7499 5.95005 17.7499C6.57005 17.7499 7.17005 17.5699 7.68005 17.2199L14.37 12.7199L16.65 14.2499C16.27 14.6599 16.05 15.2099 16.05 15.7999C16.05 17.0899 17.1 18.1399 18.39 18.1399C19.68 18.1399 20.74 17.0899 20.74 15.7999C20.74 14.5099 19.68 13.4599 18.39 13.4599ZM18.39 7.04986C19.02 7.04986 19.5401 7.56986 19.5401 8.19986C19.5401 8.82986 19.02 9.33986 18.39 9.33986C17.76 9.33986 17.25 8.82986 17.25 8.19986C17.25 7.56986 17.76 7.04986 18.39 7.04986ZM7.01005 16.2199C6.34005 16.6799 5.40005 16.6299 4.79005 16.1499L9.88005 12.7199L11.05 13.5099L7.01005 16.2199ZM12.13 12.7899L4.79005 7.84986C5.40005 7.36986 6.34005 7.31986 7.01005 7.77986L13.29 11.9999L12.13 12.7899ZM18.39 16.9499C17.76 16.9499 17.25 16.4299 17.25 15.7999C17.25 15.1699 17.76 14.6599 18.39 14.6599C19.02 14.6599 19.5401 15.1699 19.5401 15.7999C19.5401 16.4299 19.02 16.9499 18.39 16.9499Z"
  }));
};

var SvgComponent$2o = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("polygon", {
    points: "12 15 18 9 6 9"
  })));
};

var SvgComponent$2p = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.7618727,19.420875 L4.23887267,19.420875 C3.68087267,19.420875 3.16987267,19.115875 2.90487267,18.625875 C2.63887267,18.135875 2.66387267,17.539875 2.96987267,17.072875 L10.7318727,5.222875 C11.2928727,4.364875 12.7068727,4.363875 13.2688727,5.223875 L21.0308727,17.072875 C21.3358727,17.539875 21.3608727,18.135875 21.0958727,18.625875 C20.8308727,19.115875 20.3198727,19.420875 19.7618727,19.420875 Z M12.0138727,6.044875 L4.22487267,17.895875 L19.7618727,17.920875 L19.7708727,17.920875 L12.0138727,6.044875 Z M10.8566727,13.663475 L10.8566727,9.172475 L12.8566727,9.172475 L12.8566727,13.663475 L10.8566727,13.663475 Z M10.8566727,17.171475 L10.8566727,15.171475 L12.8566727,15.171475 L12.8566727,17.171475 L10.8566727,17.171475 Z"
  })));
};

var SvgComponent$2q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.13644 15.1165L15.2164 8.0365L15.9236 8.74361L8.84355 15.8236L8.13644 15.1165Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2164 15.8236L8.13644 8.74361L8.84355 8.0365L15.9236 15.1165L15.2164 15.8236Z"
  }));
};

var SvgComponent$2r = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M19.15 15.04H5.07V2.96997H2V1.96997H6.07V14.04H18.39L20.72 5.77997H8.62V4.77997H22.04L19.15 15.04zM6.79 18.5699C7.48 18.5699 8.03 19.1299 8.03 19.8099 8.03 20.4899 7.47 21.0499 6.79 21.0499 6.11 21.0499 5.55 20.4899 5.55 19.8099 5.55 19.1299 6.11 18.5699 6.79 18.5699zM6.79 17.5699C5.55 17.5699 4.55 18.5699 4.55 19.8099 4.55 21.0499 5.55 22.0499 6.79 22.0499 8.03 22.0499 9.03 21.0499 9.03 19.8099 9.03 18.5699 8.03 17.5699 6.79 17.5699zM17.39 18.5699C18.08 18.5699 18.63 19.1299 18.63 19.8099 18.63 20.4899 18.07 21.0499 17.39 21.0499 16.71 21.0499 16.15 20.4899 16.15 19.8099 16.15 19.1299 16.71 18.5699 17.39 18.5699zM17.39 17.5699C16.15 17.5699 15.15 18.5699 15.15 19.8099 15.15 21.0499 16.15 22.0499 17.39 22.0499 18.63 22.0499 19.63 21.0499 19.63 19.8099 19.63 18.5699 18.63 17.5699 17.39 17.5699z"
  }));
};

var SvgComponent$2s = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M10.58 15.78L6.56 11.46L7.24 10.72L10.58 14.31L16.75 7.67001L17.43 8.40001L10.58 15.78Z"
  }));
};

var SvgComponent$2t = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 15.02L18.64 9.69L17.94 8.98L12 13.74L6.06 8.98L5.36 9.69L12 15.02Z"
  }));
};

var SvgComponent$2u = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M14.63 4.45002L15.41 5.08002L9.87003 11.99L15.41 18.89L14.63 19.52L8.59003 11.99L14.63 4.45002Z"
  }));
};

var SvgComponent$2v = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.89 23.17L12.78 22.17L18.32 16L12.78 9.82996L13.89 8.82996L20.34 16L13.89 23.17Z"
  }));
};

var SvgComponent$2w = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M15.02 12L9.69 5.35999L8.98 6.05999L13.74 12L8.98 17.94L9.69 18.64L15.02 12Z"
  }));
};

var SvgComponent$2x = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.19 9.3L5.53999 14.62L6.23999 15.34L12.19 10.58L18.13 15.34L18.83 14.62L12.19 9.3Z"
  }));
};

var SvgComponent$2y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M24.6357 8.63672L23.3633 7.36328L15.9995 14.7271L8.63574 7.36328L7.36328 8.63672L14.7266 16L7.36328 23.3633L8.63574 24.6367L15.9995 17.2729L23.3633 24.6367L24.6357 23.3633L17.2725 16L24.6357 8.63672Z"
  }));
};

var SvgComponent$2z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.8238 6.09603L17.9048 5.17603L11.9998 11.081L6.09576 5.17603L5.17676 6.09603L11.0808 12L5.17676 17.904L6.09576 18.824L11.9998 12.919L17.9048 18.824L18.8238 17.904L12.9198 12L18.8238 6.09603Z"
  }));
};

var SvgComponent$2A = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M15.9949 8.925L15.0759 8.005L11.9999 11.081L8.92388 8.005L8.00488 8.925L11.0809 12L8.00488 15.075L8.92388 15.995L11.9999 12.919L15.0759 15.995L15.9949 15.075L12.9199 12L15.9949 8.925Z"
  }));
};

var SvgComponent$2B = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M20.23,3 C20.6552593,3 21,3.34474074 21,3.77 L21,16.94 C21,17.3652593 20.6552593,17.71 20.23,17.71 L17.71,17.71 L17.71,20.23 C17.71,20.6552593 17.3652593,21 16.94,21 L3.77,21 C3.34474074,21 3,20.6552593 3,20.23 L3,7.06 C3,6.63474074 3.34474074,6.29 3.77,6.29 L6.29,6.29 L6.29,3.77 C6.29,3.34474074 6.63474074,3 7.06,3 L20.23,3 Z M16.17,19.46 L16.17,7.83 L4.54,7.83 L4.54,19.46 L16.17,19.46 Z M19.46,16.17 L19.46,4.54 L7.83,4.54 L7.83,6.29 L16.94,6.29 C17.3652593,6.29 17.71,6.63474074 17.71,7.06 L17.71,16.17 L19.46,16.17 Z"
  })));
};

var SvgComponent$2C = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1004 9.5929L20.6994 9.7339V9.7329C19.7394 10.0699 19.0934 10.9799 19.0934 11.9989C19.0934 13.0179 19.7394 13.9279 20.6994 14.2649L21.1004 14.4059V18.5989H2.90039V5.3999H21.1004V9.5929ZM19.9004 17.3999V15.2289C18.6844 14.6289 17.8934 13.3799 17.8934 11.9999C17.8934 10.6199 18.6844 9.3719 19.9004 8.7709V6.5999H9.05039V7.7499H7.95039V6.5999H4.10039V17.3999H7.95039V16.2489H9.05039V17.3999H19.9004ZM9.04922 9.2489H7.94922V11.2489H9.04922V9.2489ZM9.04922 12.7489H7.94922V14.7489H9.04922V12.7489Z"
  }));
};

var SvgComponent$2D = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M19.65 6.00009H13.35V4.34009H10.65V6.00009H4.34998V7.00009H5.99998V13.8801H6.99998V7.00009H17V18.5001H6.99998V15.3801H5.99998V19.5001H18V7.00009H19.65V6.00009ZM13.5 9.35009V16.5001H14.5V9.35009H13.5ZM9.49998 9.35009V16.5001H10.5V9.35009H9.49998Z"
  }));
};

var SvgComponent$2E = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M19.51 20.5H4.48V14H5.48V19.5H18.5V14H19.5V20.5H19.51ZM11.99 14.23L6.17 8.41L6.88 7.7L11.5 12.32V2.5H12.5V12.32L17.12 7.7L17.83 8.41L12 14.24L11.99 14.23Z"
  }));
};

var SvgComponent$2F = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.9719 3.323L6.34094 16.54L6.58394 21.476L10.9799 19.218L18.6109 6.001L13.9719 3.323ZM14.3739 4.825L17.1069 6.403L16.3819 7.659L13.6489 6.08L14.3739 4.825ZM7.87494 16.082L13.1489 6.947L15.8819 8.526L10.6079 17.661L7.87494 16.082ZM7.46394 16.999L10.0189 18.474L7.59794 19.718L7.46394 16.999Z"
  }));
};

var SvgComponent$2G = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M8.53 11.34C6.59 11.34 4.92 10.2 4.12 8.56H8.72V7.06H3.67C3.64 6.85 3.61 6.64 3.61 6.42C3.61 6.2 3.65 5.99 3.67 5.78H8.71V4.28H4.11C4.91 2.64 6.58 1.5 8.52 1.5C9.85 1.5 11.06 2.04 11.95 2.9L13.01 1.84C11.85 0.71 10.27 0 8.52 0C5.73 0 3.35 1.79 2.47 4.28H0V5.78H2.14C2.12 5.99 2.11 6.2 2.11 6.42C2.11 6.64 2.12 6.85 2.14 7.06H0V8.56H2.48C3.36 11.05 5.74 12.84 8.53 12.84C10.28 12.84 11.86 12.14 13.02 11L11.96 9.94C11.07 10.81 9.86 11.34 8.53 11.34Z"
  }));
};

var SvgComponent$2H = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.77 12.21H17.77V6.22998H11.79V5.22998H18.77V12.21Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.9166 5.38039L10.2374 13.0596L10.9445 13.7667L18.6237 6.0875L17.9166 5.38039Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.23 18.77H5.22998V6.75H9.97998V7.75H6.22998V17.77H16.23V14.02H17.23V18.77Z"
  }));
};

var SvgComponent$2I = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9201 17.0801L17.0201 16.1801L15.6301 14.7901L14.7801 13.9401L10.0501 9.21008L9.21008 8.37008L8.15008 7.30008L7.21008 6.36008L4.42008 3.58008L3.58008 4.42008L6.08008 6.92008C4.12008 8.02008 2.50008 9.66008 1.46008 11.7201L1.33008 12.0001L1.46008 12.2701C3.42008 16.1701 7.45008 18.6001 12.0001 18.6001C13.6901 18.6001 15.3101 18.2501 16.7801 17.6201L19.5801 20.4201L20.4301 19.5701L17.9201 17.0801ZM9.23008 10.0801L13.9201 14.7701C13.3701 15.1501 12.7201 15.4001 12.0001 15.4001C10.1201 15.4001 8.60008 13.8801 8.60008 12.0001C8.60008 11.2801 8.84008 10.6301 9.23008 10.0801ZM12.0001 17.4001C8.02008 17.4001 4.47008 15.3401 2.68008 12.0001C3.66008 10.1801 5.17008 8.76008 6.98008 7.83008L8.37008 9.22008C7.77008 9.99008 7.40008 10.9501 7.40008 12.0001C7.40008 14.5401 9.46008 16.6001 12.0001 16.6001C13.0501 16.6001 14.0101 16.2301 14.7901 15.6301L15.8601 16.7001C14.6501 17.1501 13.3501 17.4001 12.0001 17.4001ZM22.54 11.7301C20.58 7.83008 16.55 5.40009 12 5.40009C10.77 5.40009 9.57996 5.58009 8.45996 5.92009L9.44996 6.91009C10.27 6.72009 11.12 6.60009 12 6.60009C15.98 6.60009 19.53 8.66009 21.32 12.0001C20.54 13.4501 19.42 14.6401 18.08 15.5401L18.96 16.4201C20.45 15.3601 21.69 13.9501 22.53 12.2701L22.67 12.0001L22.54 11.7301ZM16.6003 12.0001C16.6003 12.6101 16.4703 13.1901 16.2603 13.7201L15.3103 12.7601C15.3603 12.5201 15.4003 12.2601 15.4003 12.0001C15.4003 10.1201 13.8803 8.60009 12.0003 8.60009C11.7403 8.60009 11.4803 8.64008 11.2303 8.69008L10.2803 7.74009C10.8203 7.52009 11.3903 7.40009 12.0003 7.40009C14.5403 7.40009 16.6003 9.46009 16.6003 12.0001Z"
  }));
};

var SvgComponent$2J = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46008 12.2699C3.42008 16.1699 7.45008 18.5999 12.0001 18.5999C16.5501 18.5999 20.5801 16.1699 22.5401 12.2699L22.6701 11.9999L22.5401 11.7299C20.5801 7.8299 16.5501 5.3999 12.0001 5.3999C7.45008 5.3999 3.42008 7.8299 1.46008 11.7299L1.33008 11.9999L1.46008 12.2699ZM12.0001 17.3999C8.02008 17.3999 4.48008 15.3399 2.68008 11.9999C4.47008 8.6599 8.02008 6.5999 12.0001 6.5999C15.9801 6.5999 19.5201 8.6599 21.3201 11.9999C19.5301 15.3399 15.9801 17.3999 12.0001 17.3999ZM7.40039 11.9999C7.40039 14.5399 9.46039 16.5999 12.0004 16.5999C14.5404 16.5999 16.6004 14.5399 16.6004 11.9999C16.6004 9.4599 14.5404 7.3999 12.0004 7.3999C9.46039 7.3999 7.40039 9.4599 7.40039 11.9999ZM8.60039 11.9999C8.60039 10.1199 10.1204 8.5999 12.0004 8.5999C13.8804 8.5999 15.4004 10.1199 15.4004 11.9999C15.4004 13.8799 13.8804 15.3999 12.0004 15.3999C10.1204 15.3999 8.60039 13.8799 8.60039 11.9999Z"
  }));
};

var SvgComponent$2K = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16H4V14.6H20V16zM20 7.99998H4V6.59998H20V7.99998z"
  }));
};

var SvgComponent$2L = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M8.11001 12.49C8.11001 12.62 8.16001 12.75 8.26001 12.84L11.7 16.28L12.41 15.57L9.82001 12.98H19.45V11.98H9.82001L12.39 9.40995L11.68 8.69995L8.25001 12.13C8.16001 12.22 8.10001 12.35 8.10001 12.48L8.11001 12.49Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75 21.5V3.5H5.75V21.5H4.75Z"
  }));
};

var SvgComponent$2M = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M21 8.78003H11.86V9.78003H21V8.78003zM8.87999 11.55C7.50999 11.55 6.39999 10.44 6.39999 9.07003 6.39999 7.70003 7.50999 6.59003 8.87999 6.59003 10.25 6.59003 11.36 7.70003 11.36 9.07003 11.36 10.44 10.25 11.55 8.87999 11.55zM8.87999 7.59003C8.05999 7.59003 7.39999 8.25003 7.39999 9.07003 7.39999 9.89003 8.06999 10.55 8.87999 10.55 9.68999 10.55 10.36 9.89003 10.36 9.07003 10.36 8.25003 9.68999 7.59003 8.87999 7.59003zM5.9 8.78003H3V9.78003H5.9V8.78003zM12.64 13.89H3V14.89H12.64V13.89zM15.62 16.96C14.25 16.96 13.14 15.85 13.14 14.48 13.14 13.11 14.25 12 15.62 12 16.99 12 18.1 13.11 18.1 14.48 18.1 15.85 16.99 16.96 15.62 16.96zM15.62 13C14.8 13 14.14 13.67 14.14 14.48 14.14 15.29 14.81 15.96 15.62 15.96 16.43 15.96 17.1 15.29 17.1 14.48 17.1 13.67 16.43 13 15.62 13zM21 13.89H18.6V14.89H21V13.89z"
  }));
};

var SvgComponent$2N = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.4899 4.95977C15.9799 5.69977 14.4199 5.31977 12.7699 4.91977C10.9899 4.47977 9.1399 4.02977 7.2299 4.95977L6.8999 5.12977V20.4998H8.0999V14.2998C9.5099 13.7598 10.9599 14.0998 12.4799 14.4798C13.4999 14.7298 14.5299 14.9798 15.5899 14.9798C16.3899 14.9798 17.1999 14.8298 18.0199 14.4298L18.3499 14.2598V4.53977L17.4899 4.95977Z"
  }));
};

var SvgComponent$2O = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.4899 4.95977C15.9799 5.70977 14.4199 5.31977 12.7699 4.91977C10.9799 4.47977 9.13989 4.02977 7.22989 4.95977L6.88989 5.12977V20.4998H8.08989V14.2998C9.49989 13.7598 10.9499 14.0998 12.4699 14.4798C13.4899 14.7298 14.5199 14.9798 15.5799 14.9798C16.3799 14.9798 17.1899 14.8298 18.0099 14.4298L18.3499 14.2698V4.53977L17.4899 4.95977ZM17.1499 13.4998C15.7399 14.0398 14.2899 13.6798 12.7599 13.3098C11.7399 13.0598 10.7099 12.8098 9.64989 12.8098C9.12989 12.8098 8.60989 12.8698 8.08989 13.0198V5.89977C9.49989 5.35977 10.9499 5.71977 12.4799 6.08977C13.9899 6.45977 15.5499 6.83977 17.1499 6.37977V13.4998Z"
  }));
};

var SvgComponent$2P = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.06 18.0598L6.80998 12.4298C6.05998 11.4598 5.60998 10.3098 5.49998 9.07982C5.19998 5.51982 8.15998 2.14982 11.73 2.00982C15.44 1.85982 18.51 4.83982 18.51 8.50982C18.51 9.94982 18.04 11.3198 17.17 12.4398C17.15 12.4898 17.08 12.5798 17.01 12.6598L12.93 18.0598L12.39 18.7698L11.99 19.2898L11.59 18.7598L11.06 18.0598ZM10.8 5.14982C10.72 5.05982 10.6 5.02982 10.49 5.06982L7.62998 6.20982L8.41998 8.18982L9.42998 7.85982V11.6798H14.57V7.85982L15.57 8.18982L16.37 6.20982L13.5 5.06982C13.39 5.02982 13.27 5.05982 13.19 5.14982C12.89 5.46982 12.47 5.66982 12 5.66982C11.53 5.66982 11.1 5.46982 10.8 5.14982ZM16.7298 15.02H18.3498L20.7098 21.5H3.27979L5.63978 15.02H7.25979L8.01979 16.02H6.34978L4.70979 20.5H19.2798L17.6398 16.02H15.9698L16.7298 15.02Z"
  }));
};

var SvgComponent$2Q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M19.61 5.55005C20.16 5.55005 20.61 6.00005 20.61 6.55005V17.44C20.61 17.99 20.16 18.44 19.61 18.44H5C4.45 18.44 4 17.99 4 17.44V6.55005C4 6.00005 4.45 5.55005 5 5.55005H19.61ZM19.61 4.55005H5C3.9 4.55005 3 5.45005 3 6.55005V17.44C3 18.54 3.9 19.44 5 19.44H19.61C20.71 19.44 21.61 18.54 21.61 17.44V6.55005C21.61 5.45005 20.71 4.55005 19.61 4.55005Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.54 10.8H3V9.80005H19.54V10.8Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M7.81 12.87H6.31V15.97H7.81V12.87zM9.81 12.87H8.81V15.97H9.81V12.87zM12.81 12.87H10.81V15.97H12.81V12.87zM15.43 12.87H13.93V15.97H15.43V12.87zM17.43 12.87H16.43V15.97H17.43V12.87z"
  }));
};

var SvgComponent$2R = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M21.5055025,11.5 L21.5055025,5.75 C21.5055025,5.612 21.3939133,5.5 21.2564195,5.5 L10.2180608,5.5 L10.2180608,8.44 C10.2180608,8.716 9.99488248,8.94 9.71989493,8.94 C9.44490739,8.94 9.22172909,8.716 9.22172909,8.44 L9.22172909,5.5 L2.74358045,5.5 C2.60608668,5.5 2.49449753,5.612 2.49449753,5.75 L2.49449753,11.5 L3.74190481,11.5 C4.01689235,11.5 4.24007065,11.724 4.24007065,12 C4.24007065,12.276 4.01689235,12.5 3.74190481,12.5 L2.49449753,12.5 L2.49449753,18.25 C2.49449753,18.388 2.60608668,18.5 2.74358045,18.5 L9.22172909,18.5 L9.22172909,16.44 C9.22172909,16.164 9.44490739,15.94 9.71989493,15.94 C9.99488248,15.94 10.2180608,16.164 10.2180608,16.44 L10.2180608,18.5 L21.2564195,18.5 C21.3939133,18.5 21.5055025,18.388 21.5055025,18.25 L21.5055025,12.5 L16.6942167,12.5 C16.4192292,12.5 16.1960509,12.276 16.1960509,12 C16.1960509,11.724 16.4192292,11.5 16.6942167,11.5 L21.5055025,11.5 Z M21.2564195,4 C22.2178796,4 23,4.785 23,5.75 L23,18.25 C23,19.215 22.2178796,20 21.2564195,20 L2.74358045,20 C1.78212037,20 1,19.215 1,18.25 L1,5.75 C1,4.785 1.78212037,4 2.74358045,4 L21.2564195,4 Z M13.4550428,12.5972 C13.8715094,12.4242 14.3158734,11.9932 14.3158734,11.3042 C14.3158734,10.6142 13.8715094,10.1832 13.4550428,10.0102 C13.0365835,9.8362 12.4188578,9.8272 11.935637,10.3132 L10.9472759,11.3042 L11.935637,12.2942 C12.4198542,12.7812 13.0375798,12.7702 13.4550428,12.5972 Z M8.07883701,12.2942 L9.06719804,11.3042 L8.07883701,10.3132 C7.7799375,10.0122 7.42823242,9.9012 7.10641728,9.9012 C6.90715094,9.9012 6.71784792,9.9442 6.55943119,10.0102 C6.14296454,10.1832 5.69860061,10.6142 5.69860061,11.3042 C5.69860061,11.9932 6.14296454,12.4242 6.55943119,12.5972 C6.97390517,12.7712 7.59461981,12.7812 8.07883701,12.2942 Z M13.9502196,8.8082 C14.9744486,9.2342 15.6121009,10.1902 15.6121009,11.3042 C15.6121009,12.4162 14.9744486,13.3722 13.9502196,13.7982 C13.6064852,13.9412 13.2527875,14.0112 12.9040714,14.0112 C12.6111499,14.0112 12.3242063,13.9512 12.0482225,13.8542 L12.8024455,15.1032 C12.9877632,15.4102 12.8901227,15.8102 12.5842489,15.9962 C12.4796341,16.0592 12.3630633,16.0902 12.2494815,16.0902 C12.0302885,16.0902 11.8160772,15.9782 11.6945247,15.7772 L9.98780852,12.9492 L8.28109234,15.7772 C8.15953988,15.9782 7.94532856,16.0902 7.72613559,16.0902 C7.61255378,16.0902 7.4969793,16.0592 7.39136814,15.9962 C7.08549432,15.8102 6.98785381,15.4102 7.1731715,15.1032 L7.91842761,13.8692 C7.65639237,13.9552 7.38738282,14.0112 7.11040261,14.0112 C6.76069019,14.0112 6.40699244,13.9412 6.063258,13.7982 C5.03902903,13.3722 4.40237308,12.4162 4.40237308,11.3042 C4.40237308,10.1902 5.03902903,9.2352 6.063258,8.8082 C7.08748698,8.3822 8.21035279,8.6072 8.99546216,9.3942 L10.0077352,10.4092 L11.0190118,9.3942 C11.8031249,8.6082 12.923998,8.3822 13.9502196,8.8082 Z"
  })));
};

var SvgComponent$2S = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 20C10.4178 20 8.87103 19.5308 7.55544 18.6518C6.23985 17.7727 5.21447 16.5233 4.60897 15.0615C4.00347 13.5997 3.84504 11.9911 4.15372 10.4393C4.4624 8.88743 5.22433 7.46197 6.34315 6.34315C7.46197 5.22433 8.88743 4.4624 10.4393 4.15372C11.9911 3.84504 13.5997 4.00347 15.0615 4.60897C16.5233 5.21447 17.7727 6.23985 18.6518 7.55544C19.5308 8.87103 20 10.4178 20 12C20 14.1217 19.1571 16.1566 17.6569 17.6569C16.1566 19.1571 14.1217 20 12 20ZM12 5.05C10.6155 5.05 9.26216 5.46055 8.11101 6.22972C6.95987 6.99889 6.06266 8.09214 5.53285 9.37122C5.00303 10.6503 4.86441 12.0578 5.13451 13.4156C5.4046 14.7735 6.07129 16.0208 7.05026 16.9998C8.02922 17.9787 9.2765 18.6454 10.6344 18.9155C11.9922 19.1856 13.3997 19.047 14.6788 18.5172C15.9579 17.9873 17.0511 17.0901 17.8203 15.939C18.5895 14.7879 19 13.4345 19 12.05C19 10.1935 18.2625 8.41301 16.9498 7.10026C15.637 5.7875 13.8565 5.05 12 5.05Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12.52 4.54004H11.52V19.47H12.52V4.54004Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19.26 9.69995H4.75V10.7H19.26V9.69995zM8.53996 14.02H4.95996V15.02H8.53996V14.02zM19.02 14.03H9.96997V15.03H19.02V14.03z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 20C9.45997 20 7.46997 16.51 7.46997 12C7.46997 7.49 9.46997 4 12 4C14.53 4 16.52 7.49 16.52 12C16.52 16.51 14.53 20 12 20ZM12 5C10.09 5 8.46997 8.19 8.46997 12C8.46997 15.81 10.09 19 12 19C13.91 19 15.52 15.81 15.52 12C15.52 8.19 13.9 5 12 5Z"
  }));
};

var SvgComponent$2T = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9958 20.5001L19.7098 12.5901C20.5898 11.5401 21.0488 10.1891 20.9958 8.79612C20.9448 7.40212 20.3828 6.09212 19.4168 5.10812C18.4508 4.12512 17.1698 3.55312 15.8078 3.50312C14.4388 3.45112 13.1278 4.05412 12.0958 4.96312L11.9958 5.05312L11.8938 4.96312C10.9128 4.09912 9.6728 3.50112 8.3818 3.50112C8.3148 3.50112 8.2468 3.50212 8.1798 3.50612C6.8168 3.55612 5.5358 4.12912 4.5708 5.11412C2.5948 7.13612 2.4668 10.4291 4.2788 12.6111L11.9958 20.5001Z"
  }))));
};

var SvgComponent$2U = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.9999L4.91003 12.8799C3.92566 11.8921 3.37292 10.5544 3.37292 9.15989C3.37292 7.76536 3.92566 6.42768 4.91003 5.43989C5.88587 4.56031 7.15699 4.08019 8.47066 4.09501C9.78432 4.10984 11.0443 4.61851 12 5.51989C12.9374 4.715 14.1003 4.21909 15.33 4.09989C16.0166 4.03569 16.7088 4.12236 17.3583 4.35384C18.0078 4.58531 18.5988 4.95598 19.09 5.43989C20.0744 6.42768 20.6271 7.76536 20.6271 9.15989C20.6271 10.5544 20.0744 11.8921 19.09 12.8799L12 19.9999ZM8.22003 5.08989C7.73767 5.08282 7.25882 5.17304 6.8121 5.35517C6.36539 5.53729 5.95996 5.80758 5.62003 6.14989C4.83102 6.94905 4.3886 8.02687 4.3886 9.14989C4.3886 10.2729 4.83102 11.3507 5.62003 12.1499L12 18.5599L18.38 12.1799C19.169 11.3807 19.6115 10.3029 19.6115 9.17989C19.6115 8.05687 19.169 6.97905 18.38 6.17989C17.9902 5.7918 17.5184 5.49601 16.9992 5.31431C16.4801 5.1326 15.9268 5.06958 15.38 5.12989C14.2224 5.24262 13.1403 5.75537 12.32 6.57989L12 6.90989L11.65 6.54989C10.7376 5.63928 9.50882 5.11622 8.22003 5.08989Z"
  }));
};

var SvgComponent$2V = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,19.42 C13.9679064,19.42 15.8552124,18.6382522 17.2467323,17.2467323 C18.6382522,15.8552124 19.42,13.9679064 19.42,12 C19.42,7.90204716 16.0979528,4.58 12,4.58 C7.90204716,4.58 4.58,7.90204716 4.58,12 C4.58,16.0979528 7.90204716,19.42 12,19.42 Z M12.14,7 C14.07,7 15.28,7.92 15.28,9.45 C15.2922252,9.99488698 15.1035792,10.5252314 14.75,10.94 C14.4905652,11.2226854 14.1906348,11.4653258 13.86,11.66 C13.5327273,11.8212295 13.2482969,12.0576837 13.03,12.35 C12.9165555,12.550954 12.8419245,12.7714546 12.81,13 C12.7754694,13.1713466 12.7553987,13.345292 12.75,13.52 L10.85,13.52 C10.7378491,12.616272 11.0222957,11.7082311 11.63,11.03 C12.07,10.59 13.07,10.35 13.07,9.59 C13.07,9.07 12.7,8.76 12.07,8.76 C11.6664399,8.73641604 11.2824608,8.93608517 11.07,9.28 C10.9540843,9.47406205 10.8887534,9.69412415 10.88,9.92 L8.72,9.92 C8.75652516,9.24779793 8.98948058,8.60108587 9.39,8.06 C10.0987622,7.30832529 11.1100887,6.9185049 12.14,7 Z M10.71,15.12 L12.9,15.12 L12.9,17.31 L10.71,17.31 L10.71,15.12 Z"
  })));
};

var SvgComponent$2W = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.7998 25.1377L17.7002 25.1299V19.6309H14.2998V25.1309H6.20068L6.2002 13.4561L16 5.28809L25.7998 13.4561V25.1377ZM19.2998 23.5322L24.2002 23.5361V14.2061L16 7.37012L7.7998 14.2061L7.80029 23.5312H12.7002V18.0312H19.2998V23.5322Z"
  }));
};

var SvgComponent$2X = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.7995 25.138L18.4995 25.1302V18.6667H13.4995V25.1302H6.19922V13.4557L15.9993 5.28775L25.7995 13.4557V25.138Z"
  }));
};

var SvgComponent$2Y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 6C4.65685 6 6 4.65685 6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6Z"
  }));
};

var SvgComponent$2Z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4ZM12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 7.03 16.97 3 12 3Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 17.36V10.36H12.75V17.36H11.25Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M13.03 8.07996C13.03 8.63224 12.5823 9.07996 12.03 9.07996C11.4777 9.07996 11.03 8.63224 11.03 8.07996C11.03 7.52767 11.4777 7.07996 12.03 7.07996C12.5823 7.07996 13.03 7.52767 13.03 8.07996Z"
  }));
};

var SvgComponent$2_ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m4.3,3.53v15.28h12.48l2.92,2.84V3.53H4.3Zm14.2,15.28l-1.23-1.2H5.5V4.73h13v14.08ZM9.45,7.35h-1.44v7.09h1.44v-7.09Zm4.16,7.2c.15,0,.29-.02.48-.05l.47,1.38h1.42l-.7-2.02c.47-.46.7-1.01.7-1.67v-2.52c0-1.32-1.06-2.37-2.38-2.37s-2.38,1.05-2.38,2.37v2.52c0,1.3,1.09,2.37,2.39,2.37Zm-.95-4.88c0-.53.42-.95.94-.95s.94.38.94.95v2.52c0,.53-.42.95-.94.95s-.94-.43-.94-.95v-2.52Z"
  }));
};

var SvgComponent$2$ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M21 18.8899H3V15.9599L11.5 11.6299V9.85993L11.68 9.70993C11.68 9.70993 12.43 9.08993 13.19 8.38993C13.73 7.88993 13.61 7.17993 13.58 6.94993C13.58 6.87993 13.35 5.47993 11.88 5.53993C10.27 5.57993 10.2 7.08993 10.2 7.25993H9.2C9.2 6.33993 9.75 4.59993 11.85 4.53993C13.84 4.47993 14.47 6.11993 14.56 6.74993C14.76 8.00993 14.3 8.72993 13.87 9.11993C13.31 9.62993 12.77 10.0999 12.5 10.3299V12.2399L4 16.5699V17.8899H20V16.5699L13.69 13.3599L14.14 12.4699L21 15.9599V18.8899Z"
  }));
};

var SvgComponent$30 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("circle", {
    cx: 12.5,
    cy: 11.5,
    r: 1.5
  }));
};

var SvgComponent$31 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.99 7.55005C12.91 7.55005 13.67 8.30005 13.67 9.23005C13.67 10.16 12.92 10.91 11.99 10.91C11.06 10.91 10.31 10.16 10.31 9.23005C10.31 8.30005 11.06 7.55005 11.99 7.55005ZM11.99 6.55005C10.51 6.55005 9.31 7.75005 9.31 9.23005C9.31 10.71 10.51 11.91 11.99 11.91C13.47 11.91 14.67 10.71 14.67 9.23005C14.67 7.75005 13.47 6.55005 11.99 6.55005Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M19 9.37001C19 5.86001 15.86 3.01001 11.99 3.01001C8.12 3.01001 4.98 5.86001 4.98 9.37001C4.98 10.22 5.17 11.04 5.5 11.78C5.64 12.08 5.8 12.37 5.99 12.65L11.39 20.65C11.54 20.87 11.78 20.98 12.02 20.98C12.26 20.98 12.47 20.87 12.62 20.67L11.44 18.92L7.13 12.53L6.83 12.09C6.67 11.85 6.53 11.6 6.42 11.36C6.13 10.72 5.99 10.05 5.99 9.36001C5.99 6.40001 8.69 4.00001 12 4.00001C15.31 4.00001 18.01 6.41001 18.01 9.36001C18.01 10.25 17.76 11.13 17.28 11.91L12.65 18.84L13.25 19.74L13.61 19.2L18.14 12.44C18.7 11.53 19.01 10.48 19.01 9.37001H19Z"
  }));
};

var SvgComponent$32 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.548,18.554 L18.548,11.058 L6.451,11.058 L6.451,18.554 C6.451,19.098 6.892,19.54 7.432,19.54 L17.567,19.54 C18.108,19.54 18.548,19.098 18.548,18.554 Z M9.839,6.869 L9.839,9.599 L15.161,9.599 L15.161,6.869 C15.161,5.54 13.967,4.459 12.5,4.459 C11.032,4.459 9.839,5.54 9.839,6.869 Z M19.274,9.599 C19.674,9.599 20,9.926 20,10.329 L20,18.554 C20,19.903 18.908,21 17.567,21 L7.432,21 C6.091,21 5,19.903 5,18.554 L5,10.329 C5,9.926 5.325,9.599 5.725,9.599 L8.387,9.599 L8.387,6.869 C8.387,4.735 10.232,3 12.5,3 C14.768,3 16.612,4.735 16.612,6.869 L16.612,9.599 L19.274,9.599 Z M12.4997,16.7591 C11.6977,16.7591 11.0477,16.1061 11.0477,15.3001 C11.0477,14.4931 11.6977,13.8401 12.4997,13.8401 C13.3017,13.8401 13.9517,14.4931 13.9517,15.3001 C13.9517,16.1061 13.3017,16.7591 12.4997,16.7591 Z"
  })));
};

var SvgComponent$33 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.99 4.75H3V5.75H20.99V4.75zM20.99 11.5H3V12.5H20.99V11.5zM20.99 18.25H3V19.25H20.99V18.25z"
  }));
};

var SvgComponent$34 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18 11.5H6V12.5H18V11.5Z"
  }));
};

var SvgComponent$35 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 75 75",
    width: 24,
    height: 24,
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M58.16,66.67a1.39,1.39,0,0,0-1,.42,1.32,1.32,0,0,0,0,1.93,1.36,1.36,0,0,0,1,.39,1.34,1.34,0,0,0,1-.39,1.33,1.33,0,0,0,.42-1,1.29,1.29,0,0,0-.42-1A1.34,1.34,0,0,0,58.16,66.67Zm0-8.1a1.41,1.41,0,0,0-1,.39,1.09,1.09,0,0,0-.42,1,3.32,3.32,0,0,0,.1.8c0,.13.06.27.1.42s.11.47.17.74.22.93.35,1.58c0,.15.06.33.09.5s0,.11,0,.17c.09.49.19,1,.29,1.67h.56c.1-.62.2-1.18.29-1.67a1,1,0,0,1,0-.17c0-.18.06-.35.09-.5.13-.62.25-1.14.37-1.56,0-.26.11-.51.17-.76s.06-.25.08-.37a5.13,5.13,0,0,0,.12-.85,1.29,1.29,0,0,0-.42-1A1.36,1.36,0,0,0,58.18,58.57Zm10.5,6.15L68.24,64l-.72-1.24-.92-1.57-1.35-2.32-2-3.38-.3-.51-1-1.66a4.49,4.49,0,0,0-1.46-1.51,4.45,4.45,0,0,0-6.24,1.51l-.42.73-.54.93-.88,1.52-1.38,2.37-1.35,2.32-.92,1.57L48.12,64l-.44.76-1.5,2.58A4.44,4.44,0,0,0,50,74H66.33a4.44,4.44,0,0,0,3.85-6.66Zm-.92,5.62a1.61,1.61,0,0,1-1.43.81H50a1.63,1.63,0,0,1-1.42-2.44l1.5-2.57,1.17-2,.1-.18L53,61.15l.52-.91,2.27-3.89,1-1.66a1.62,1.62,0,0,1,1.42-.81,1.93,1.93,0,0,1,.42,0,1.62,1.62,0,0,1,1,.76l1,1.66.06.11,2.21,3.78.52.91L65,64l.1.18,1.17,2,1.49,2.57A1.57,1.57,0,0,1,67.76,70.34ZM46.38,37.6,33,29.76l.11,15.48ZM69.38,11H5.62a1.41,1.41,0,0,0-1.41,1.41v50.1A1.41,1.41,0,0,0,5.62,64H44.87l1.64-2.81H7V55.52H49.78l1.64-2.81H7V22.3H68V57.93l2.79,4.8a1.1,1.1,0,0,0,0-.18V12.45A1.41,1.41,0,0,0,69.38,11ZM68,19.48H7V13.86H68Z",
    fillRule: "evenodd"
  }))));
};

var SvgComponent$36 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m19.17,18.11c-1-1.09-1.13-3.05-1.13-4.83v-2.63c0-3.1-2.48-5.83-5.44-6.17v-1.98h-1.2v1.98c-2.96.33-5.44,3.07-5.44,6.17v2.63c0,1.78-.13,3.74-1.13,4.83-.16.17-.2.43-.11.65s.31.36.55.36h4c.22,1.31,1.36,2.31,2.73,2.31s2.51-1,2.73-2.31h4c.24,0,.45-.14.55-.36s.05-.47-.11-.65Zm-7.17,2.12c-.71,0-1.3-.47-1.5-1.11h3c-.2.64-.79,1.11-1.5,1.11Zm0-2.31h-5.61c.66-1.34.77-3.06.77-4.63v-2.63c0-2.62,2.31-5,4.84-5s4.84,2.38,4.84,5v2.63c0,1.58.11,3.29.77,4.63h-5.61Z"
  }));
};

var SvgComponent$37 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.21,17 C18.2949379,16.1674062 17.7602099,14.9967855 17.73,13.76 L17.73,10.1 C17.7345835,7.21079815 15.5945232,4.76684925 12.73,4.39 L12.73,3.73 C12.7628643,3.45065151 12.6323114,3.17727078 12.3943942,3.02723399 C12.156477,2.87719719 11.853523,2.87719719 11.6156058,3.02723399 C11.3776886,3.17727078 11.2471357,3.45065151 11.28,3.73 L11.28,4.4 C8.41547684,4.77684925 6.2754165,7.22079815 6.28,10.11 L6.28,13.78 C6.24181022,15.0112789 5.70382438,16.173906 4.79,17 C4.60731091,17.145645 4.50063173,17.3663606 4.5,17.6 C4.5,18.0031679 4.82683213,18.33 5.23,18.33 L8.73,18.33 C8.94740021,19.9419204 10.3771648,21.1093428 12,21 C13.6161071,21.1103312 15.0431008,19.953899 15.27,18.35 L18.77,18.35 C18.9662659,18.3473657 19.1534448,18.2668637 19.2903501,18.1262075 C19.4272555,17.9855513 19.5026702,17.7962655 19.5,17.6 C19.5055874,17.3649709 19.3976417,17.141635 19.21,17 L19.21,17 Z M12,19.54 C11.1964503,19.6187343 10.4483712,19.121408 10.21,18.35 L13.79,18.35 C13.5653607,19.1315666 12.8076025,19.6353276 12,19.54 L12,19.54 Z M15.33,16.89 L6.79,16.89 C7.37025101,15.9541225 7.69121664,14.8807858 7.72,13.78 L7.72,10.1 C7.72,7.73345985 9.63845985,5.815 12.005,5.815 C14.3715402,5.815 16.29,7.73345985 16.29,10.1 L16.29,13.77 C16.3187834,14.8707858 16.639749,15.9441225 17.22,16.88 L15.33,16.89 Z"
  })));
};

var SvgComponent$38 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.45 3.5H6.45C4.79 3.5 3.45 4.84 3.45 6.5V17.5C3.45 19.16 4.79 20.5 6.45 20.5H14.11V19.5H6.45C5.35 19.5 4.45 18.6 4.45 17.5V6.5C4.45 5.4 5.35 4.5 6.45 4.5H17.45C18.55 4.5 19.45 5.4 19.45 6.5V17.5C19.45 18.6 18.55 19.5 17.45 19.5H15.45V20.5H17.45C19.11 20.5 20.45 19.16 20.45 17.5V6.5C20.45 4.84 19.11 3.5 17.45 3.5Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M15.3 11.47C15.08 11.88 14.74 12.21 14.26 12.47C13.78 12.72 13.17 12.85 12.43 12.85H10.79V16.52H9.31V7.47998H12.43C13.12 7.47998 13.71 7.59998 14.19 7.83998C14.67 8.07998 15.03 8.39998 15.27 8.80998C15.51 9.21998 15.63 9.66998 15.63 10.18C15.63 10.64 15.52 11.07 15.3 11.48V11.47ZM13.69 11.26C13.97 11 14.11 10.64 14.11 10.17C14.11 9.17998 13.55 8.68998 12.43 8.68998H10.79V11.64H12.43C12.99 11.64 13.41 11.51 13.69 11.26Z"
  }));
};

var SvgComponent$39 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M14.13 8.5H13.13V15.5H14.13V8.5zM10.87 8.5H9.87V15.5H10.87V8.5z"
  }));
};

var SvgComponent$3a = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M10.4558553,3.4719535 L9.06485529,3.8199535 C8.13485529,4.0619535 7.36285529,4.6949535 6.89185529,5.5989535 C6.38685529,6.5689535 6.31185529,7.7179535 6.68685529,8.7509535 C8.07385529,12.5719535 10.0228553,16.1009535 12.4818553,19.2409535 C13.1078553,20.0419535 14.0258553,20.5139535 14.9978553,20.5349535 C15.9618553,20.5459535 16.9078553,20.1269535 17.5698553,19.3539535 L18.5108553,18.2539535 C18.5668553,18.1879535 18.5608553,18.0729535 18.4968553,18.0079535 C17.7678553,17.2509535 17.0648553,16.4419535 16.4078553,15.6019535 L16.3828553,15.5789535 C16.3628553,15.5609535 16.3328553,15.5569535 16.3088553,15.5689535 L16.2978553,15.5749535 L14.3418553,17.2329535 C14.1888553,17.3629535 13.9938553,17.4239535 13.7908553,17.3999535 C13.5918553,17.3769535 13.4128553,17.2719535 13.2928553,17.1109535 C11.4368553,14.6009535 9.90885529,11.8339535 8.74885529,8.8839535 C8.60485529,8.5199535 8.77285529,8.1059535 9.12785529,7.9469535 L11.4268553,6.9099535 C11.4828553,6.8849535 11.5178553,6.7849535 11.4848553,6.6879535 C11.1168553,5.6769535 10.7938553,4.6279535 10.5218553,3.5749535 C10.5108553,3.5279535 10.4858553,3.4899535 10.4558553,3.4719535 M15.0678553,21.9999535 C15.0338553,21.9999535 14.9998553,21.9989535 14.9658553,21.9989535 C13.5598553,21.9679535 12.2378553,21.2929535 11.3418553,20.1469535 C8.78785529,16.8859535 6.76285529,13.2209535 5.32385529,9.2539535 C4.80885529,7.8339535 4.91185529,6.2539535 5.60585529,4.9189535 C6.26085529,3.6629535 7.38785529,2.7459535 8.69985529,2.4029535 L10.0538553,2.0489535 C10.4418553,1.9469535 10.8478553,2.0059535 11.1938553,2.2109535 C11.5588553,2.4289535 11.8198553,2.7829535 11.9288553,3.2099535 C12.1868553,4.2159535 12.4958553,5.2179535 12.8478553,6.1859535 C13.1428553,6.9999535 12.7778553,7.9039535 12.0178553,8.2459535 L10.3618553,8.9929535 C11.3378553,11.3389535 12.5598553,13.5589535 14.0028553,15.6079535 L15.3648553,14.4549535 L15.3648553,14.4549535 C15.6818553,14.1859535 16.0838553,14.0609535 16.4888553,14.1019535 C16.9058553,14.1449535 17.2818553,14.3559535 17.5478553,14.6949535 C18.1738553,15.4959535 18.8438553,16.2669535 19.5388553,16.9879535 C20.1248553,17.5979535 20.1558553,18.5739535 19.6088553,19.2109535 L18.6678553,20.3099535 C17.7458553,21.3879535 16.4378553,21.9999535 15.0678553,21.9999535"
  }))));
};

var SvgComponent$3b = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 5C15.86 5 19 8.14 19 12C19 15.86 15.86 19 12 19C8.14 19 5 15.86 5 12C5 8.14 8.14 5 12 5ZM12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.17 15.6598L15.66 11.9998L10.17 8.33984V15.6498V15.6598Z"
  }));
};

var SvgComponent$3c = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.65 18H11.35V12.65H6V11.35H11.35V6H12.65V11.35H18V12.65H12.65V18Z"
  }));
};

var SvgComponent$3d = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.46,18.5 L12,18.5 C12.0541371,19.0156254 12.1821125,19.5207914 12.38,20 L6.7,20 C6.49577901,20.0001634 6.30032235,19.9170411 6.15877495,19.7698318 C6.01722756,19.6226225 5.94183109,19.4240576 5.95,19.22 L5.95,11.99 L5.25,12.51 C4.91542533,12.7595652 4.44219304,12.6925984 4.19,12.36 L1.65,9 C1.4339922,8.67800617 1.49902614,8.24444658 1.8,8 L6.28,4.65 C7.13970363,4.21943728 8.08850933,3.99679334 9.05,4 L9.39,4 C9.66012234,3.99727261 9.91139129,4.13813551 10.05,4.37 C10.12,4.48 10.35,4.71 10.52,4.89 L10.71,5.09 C11.4855115,5.62911067 12.5144885,5.62911067 13.29,5.09 L13.48,4.89 C13.6526011,4.72213275 13.8161648,4.54521691 13.97,4.36 C14.1157625,4.14702578 14.3522997,4.01397362 14.61,4 L14.95,4 C15.9114481,3.99716582 16.8601688,4.2197898 17.72,4.65 L22.2,8 C22.5009739,8.24444658 22.5660078,8.67800617 22.35,9 L19.84,12.37 C19.587807,12.7025984 19.1145747,12.7695652 18.78,12.52 L18.08,12 L18.08,12.5 L17.58,12.5 C17.2443403,12.5032411 16.9096548,12.5367097 16.58,12.6 L16.58,10.52 C16.5813309,10.2350076 16.7440731,9.97539491 17,9.85 C17.245667,9.71551722 17.5453883,9.72704496 17.78,9.88 L19.08,10.88 L20.71,8.72 L16.84,5.85 C16.2532788,5.62162693 15.6295928,5.50299101 15,5.5 L14.54,5.92 L14.34,6.13 L14.22,6.24 C12.8770731,7.22212913 11.0529269,7.22212913 9.71,6.24 L9.59,6.13 L9.39,5.92 L9,5.5 C8.38054837,5.50706957 7.76743182,5.62562802 7.19,5.85 L3.32,8.72 L4.91,10.92 L6.21,9.92 C6.43931587,9.75022298 6.74440425,9.72318983 7,9.85 C7.26519158,9.96065501 7.44384672,10.2131025 7.46,10.5 L7.46,18.5 Z M21.78,20.72 C22.0553589,21.0155098 22.0472339,21.4760097 21.7616218,21.7616218 C21.4760097,22.0472339 21.0155098,22.0553589 20.72,21.78 L19.12,20.18 C17.7928573,21.1168343 15.996978,21.0237897 14.7737562,19.9548207 C13.5505343,18.8858518 13.217711,17.1186312 13.9682838,15.6779346 C14.7188565,14.2372379 16.3578584,13.4972969 17.9348653,13.8871884 C19.5118723,14.2770799 20.6172449,15.6955266 20.61,17.32 C20.6085414,17.9356489 20.4428425,18.5397593 20.13,19.07 L21.78,20.72 Z M15.11,17.32 C15.11,18.4245695 16.0054305,19.32 17.11,19.32 C18.2145695,19.32 19.11,18.4245695 19.11,17.32 C19.11,16.2154305 18.2145695,15.32 17.11,15.32 C16.0054305,15.32 15.11,16.2154305 15.11,17.32 Z"
  })));
};

var SvgComponent$3e = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 54,
    height: 43,
    viewBox: "0 0 54 43",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("g", {
    transform: "translate(-78.000000, -69.000000) translate(78.000000, 69.000000)"
  }, /*#__PURE__*/createElement("path", {
    d: "M52.51,42.46 L1.51,42.46 C0.889826994,42.4545115 0.39,41.9501973 0.39,41.33 L0.39,1.25 C0.39,0.952957531 0.507999661,0.668081149 0.718040405,0.458040405 C0.928081149,0.247999661 1.21295753,0.13 1.51,0.13 L52.51,0.13 C52.8070425,0.13 53.0919189,0.247999661 53.3019596,0.458040405 C53.5120003,0.668081149 53.63,0.952957531 53.63,1.25 L53.63,41.33 C53.63,41.9501973 53.130173,42.4545115 52.51,42.46 Z M2.62,40.21 L51.38,40.21 L51.38,2.38 L2.62,2.38 L2.62,40.21 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M35.39,34.5 L18.61,34.5 C17.9881817,34.494569 17.485431,33.9918183 17.48,33.37 L17.48,21.84 L15.59,22.22 C15.0361532,22.3263796 14.4877606,22.0117978 14.3,21.48 C12,14.61 12,14.08 12.66,13.6 C15.22,10.65 20.6,8.76999822 23.25,8.76999822 C23.6687586,8.76925844 24.0535915,9.00015815 24.25,9.37 C24.7360901,10.460511 25.7556981,11.2185838 26.94,11.37 C28.1687021,11.2193852 29.2432759,10.4705532 29.81,9.37 C30.0204704,9.02168812 30.4033152,8.81495196 30.81,8.83 C33.46,8.83 38.81,10.71 41.4,13.67 C42.09,14.14 42.1,14.67 39.76,21.54 C39.5722394,22.0717978 39.0238468,22.3863796 38.47,22.28 L36.58,21.9 L36.58,33.43 C36.5423917,34.0519353 36.0124208,34.5284637 35.39,34.5 Z M19.73,32.25 L34.27,32.25 L34.27,20.47 C34.2694541,20.1340747 34.4197194,19.815643 34.6793659,19.6025003 C34.9390124,19.3893577 35.2806188,19.3040141 35.61,19.37 L37.88,19.82 C38.55,17.82 39.21,15.71 39.42,14.82 C37.1473274,12.801572 34.3363662,11.4881686 31.33,11.04 C30.363099,12.5879514 28.6749782,13.5375193 26.85,13.56 C25.1255271,13.4380739 23.5621672,12.5022861 22.64,11.04 C19.6435512,11.491507 16.8431301,12.8048558 14.58,14.82 C14.79,15.69 15.45,17.82 16.11,19.82 L18.39,19.37 C18.7193812,19.3040141 19.0609876,19.3893577 19.3206341,19.6025003 C19.5802806,19.815643 19.7305459,20.1340747 19.73,20.47 L19.73,32.25 Z"
  }), /*#__PURE__*/createElement("polygon", {
    points: "17.53 20 19.25 17.9 19.71 20.57"
  }), /*#__PURE__*/createElement("polygon", {
    points: "34.29 20.57 34.75 17.9 36.47 20"
  })))));
};

var SvgComponent$3f = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M4.64,12 C4.61748005,9.15057789 6.24395235,6.5448957 8.81368713,5.31356445 C11.3834219,4.0822332 14.4333106,4.44715909 16.64,6.25 L6.25,16.59 C5.20581511,15.2882515 4.63776937,13.6687919 4.64,12 Z M12,19.36 C10.3299994,19.3593961 8.71041029,18.7877765 7.41,17.74 L17.75,7.41 C19.5528409,9.61668941 19.9177668,12.6665781 18.6864355,15.2363129 C17.4551043,17.8060476 14.8494221,19.43252 12,19.41 L12,19.36 Z"
  })));
};

var SvgComponent$3g = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M14 4V11H18.37C18.37 14.69 16.41 17.7 14 17.7V20.37C17.86 20.37 21 16.17 21 11V4H14ZM3 11H7.37C7.37 14.69 5.41 17.7 3 17.7V20.37C6.86 20.37 10 16.17 10 11V4H3V11Z"
  }));
};

var SvgComponent$3h = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M3 13.37V20.37H10V13.37H5.63C5.63 9.68 7.59 6.67 10 6.67V4C6.14 4 3 8.2 3 13.37ZM21 6.67V4C17.14 4 14 8.2 14 13.37V20.37H21V13.37H16.63C16.63 9.68 18.59 6.67 21 6.67Z"
  }));
};

var SvgComponent$3i = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M12 17C14.7614 17 17 14.7614 17 12C17 9.23858 14.7614 7 12 7C9.23858 7 7 9.23858 7 12C7 14.7614 9.23858 17 12 17Z"
  }));
};

var SvgComponent$3j = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z"
  }));
};

var SvgComponent$3k = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M6.48 5.5C6.2 5.5 5.98 5.72 5.98 6C5.98 6.28 6.2 6.5 6.48 6.5H16.79L5.45 17.84C5.25 18.04 5.25 18.35 5.45 18.55C5.55 18.65 5.68 18.7 5.8 18.7C5.92 18.7 6.06 18.65 6.15 18.55L17.5 7.21V17.52C17.5 17.8 17.72 18.02 18 18.02C18.28 18.02 18.5 17.8 18.5 17.52V5.5H6.48Z"
  }));
};

var SvgComponent$3l = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M27.8276 28.5752L21.7378 22.4863C19.979 23.9619 17.7129 24.8516 15.2427 24.8516C9.66309 24.8516 5.12402 20.3125 5.12402 14.7334C5.12402 9.1543 9.66309 4.61523 15.2427 4.61523C20.8223 4.61523 25.3613 9.1543 25.3613 14.7334C25.3613 17.124 24.5283 19.3232 23.1367 21.0566L29.2417 27.1611L27.8276 28.5752ZM15.2427 6.61523C10.7661 6.61523 7.12402 10.2568 7.12402 14.7334C7.12402 19.21 10.7661 22.8516 15.2427 22.8516C19.7192 22.8516 23.3613 19.21 23.3613 14.7334C23.3613 10.2568 19.7192 6.61523 15.2427 6.61523Z"
  }));
};

var SvgComponent$3m = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M10.19 4C13.58 4 16.34 6.76 16.34 10.15 16.34 13.54 13.58 16.3 10.19 16.3 6.79999 16.3 4.03999 13.54 4.03999 10.15 4.03999 6.76 6.79999 4 10.19 4zM10.19 3C6.23999 3 3.03999 6.2 3.03999 10.15 3.03999 14.1 6.23999 17.3 10.19 17.3 14.14 17.3 17.34 14.1 17.34 10.15 17.34 6.2 14.14 3 10.19 3zM16.466 15.4992L15.7417 16.1887 20.3131 20.9907 21.0373 20.3012 16.466 15.4992z"
  }));
};

var SvgComponent$3n = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M22.25,21.54 C22.2500133,21.8069582 22.1432849,22.0628394 21.9535801,22.2506659 C21.7638754,22.4384924 21.5069449,22.5426696 21.24,22.54 L11.16,22.54 C10.6077153,22.54 10.16,22.0922847 10.16,21.54 L10.16,16.92 L22.25,16.92 L22.25,21.54 Z M11.17,21.54 L21.21,21.52 L21.21,17.93 L20.47,17.93 L20.47,18.72 C20.47,18.9961424 20.2461424,19.22 19.97,19.22 C19.6938576,19.22 19.47,18.9961424 19.47,18.72 L19.47,17.93 L18.58,17.93 L18.58,19.8 C18.58,20.0761424 18.3561424,20.3 18.08,20.3 C17.8038576,20.3 17.58,20.0761424 17.58,19.8 L17.58,17.91 L16.69,17.91 L16.69,18.7 C16.69,18.9761424 16.4661424,19.2 16.19,19.2 C15.9138576,19.2 15.69,18.9761424 15.69,18.7 L15.69,17.91 L14.8,17.91 L14.8,19.78 C14.8,20.0561424 14.5761424,20.28 14.3,20.28 C14.0238576,20.28 13.8,20.0561424 13.8,19.78 L13.8,17.9 L12.91,17.9 L12.91,18.69 C12.91,18.9661424 12.6861424,19.19 12.41,19.19 C12.1338576,19.19 11.91,18.9661424 11.91,18.69 L11.91,17.9 L11.17,17.9 L11.17,21.54 Z M22.31,8.79 C22.59937,9.04909443 22.6468109,9.48468785 22.42,9.8 L20,13.05 C19.8813184,13.214917 19.6984812,13.3220119 19.4965888,13.3448677 C19.2946964,13.3677234 19.0925452,13.3042121 18.94,13.17 L18.49,12.77 L18.49,15.4 L17.02,15.4 L17.02,11.12 C17.0193436,10.8291273 17.1869311,10.5641053 17.45,10.44 C17.7110789,10.3239037 18.0158901,10.3707977 18.23,10.56 L19.3,11.51 L20.82,9.51 L18.61,7.51 C17.9623258,6.93281582 17.1445589,6.58184288 16.28,6.51 L14,8.83 C13.8899863,8.93818218 13.7440975,9.00223089 13.59,9.01 C13.4205522,9.00976099 13.2583444,8.94127328 13.14,8.82 L12.26,7.91 L12.26,9.72 C12.3471853,9.63157011 12.4658244,9.5812384 12.59,9.58 C12.8661424,9.58 13.09,9.80385763 13.09,10.08 C13.09,10.3561424 12.8661424,10.58 12.59,10.58 C12.4658244,10.5787616 12.3471853,10.5284299 12.26,10.44 L12.26,12 C12.3471853,11.9115701 12.4658244,11.8612384 12.59,11.86 C12.8661424,11.86 13.09,12.0838576 13.09,12.36 C13.09,12.6361424 12.8661424,12.86 12.59,12.86 C12.4658244,12.8587616 12.3471853,12.8084299 12.26,12.72 L12.26,14.28 C12.3471853,14.1915701 12.4658244,14.1412384 12.59,14.14 C12.8661424,14.14 13.09,14.3638576 13.09,14.64 C13.09,14.9161424 12.8661424,15.14 12.59,15.14 C12.4658244,15.1387616 12.3471853,15.0884299 12.26,15 L12.26,15.45 L11.26,15.45 L11.26,7.9 L10.38,8.81 C10.2521327,8.91651107 10.0955093,8.98264096 9.93,9 C9.75757471,8.99456345 9.59492163,8.91865868 9.48,8.79 L7.28,6.55 C6.61920845,6.6977857 6.00674766,7.01089768 5.5,7.46 L3.29,9.46 L4.9,11.53 L5.9,10.63 C6.11511152,10.4417471 6.42121645,10.3985785 6.68,10.52 C6.93917421,10.6469765 7.10249662,10.9114033 7.1,11.2 L7.1,19.38 L8.5,19.38 L8.5,20.86 L6.35,20.86 C5.94521985,20.8545295 5.61996304,20.5248171 5.62,20.12 L5.62,12.79 L5.18,13.16 C5.02828235,13.2906817 4.82899648,13.3522792 4.63,13.33 C4.43053183,13.3062444 4.24966742,13.2013431 4.13,13.04 L1.71,9.79 C1.48673309,9.47905114 1.52958018,9.05058019 1.81,8.79 L4.53,6.37 C5.28866009,5.69544292 6.22007204,5.24531818 7.22,5.07 L8.56,3.74 C8.67526875,3.62024745 8.83379428,3.55179324 9,3.55 L14.48,3.55 C14.6412909,3.55178072 14.7955384,3.61634942 14.91,3.73 L16.21,5 C17.4572641,5.05640992 18.6471658,5.54013848 19.58,6.37 L22.31,8.79 Z M12.95,4.85 L10.55,4.85 L11.75,6.08 L12.95,4.85 Z M9.95,7.45 L10.6,6.75 L9,5.11 L8.31,5.8 L9.95,7.45 Z M13.6,7.45 L15.22,5.8 L14.51,5.11 L12.92,6.74 L13.6,7.45 Z"
  })));
};

var SvgComponent$3o = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m19.5,20.5H4.48v-6.5h1v5.5h13.02v-5.5h1v6.5Zm-7.01-6h-1V4.69l-4.62,4.62-.71-.71,5.83-5.83,5.82,5.82-.71.71-4.62-4.62v9.82Z"
  }));
};

var SvgComponent$3p = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20 9V15.46H4.03V9H20ZM21 8H3.03V15.46C3.03 16.01 3.48 16.46 4.03 16.46H20C20.55 16.46 21 16.01 21 15.46V8Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33 8.12C6.60614 8.12 6.83 8.34385 6.83 8.62V11.48C6.83 11.7561 6.60614 11.98 6.33 11.98 6.05386 11.98 5.83 11.7561 5.83 11.48V8.62C5.83 8.34385 6.05386 8.12 6.33 8.12zM9.17 8.12C9.44614 8.12 9.67 8.34385 9.67 8.62V13.11C9.67 13.3861 9.44614 13.61 9.17 13.61 8.89386 13.61 8.67 13.3861 8.67 13.11V8.62C8.67 8.34385 8.89386 8.12 9.17 8.12zM12 8.12C12.2761 8.12 12.5 8.34385 12.5 8.62V11.5C12.5 11.7761 12.2761 12 12 12 11.7239 12 11.5 11.7761 11.5 11.5V8.62C11.5 8.34385 11.7239 8.12 12 8.12zM14.82 8.12C15.0961 8.12 15.32 8.34385 15.32 8.62V13.12C15.32 13.3961 15.0961 13.62 14.82 13.62 14.5439 13.62 14.32 13.3961 14.32 13.12V8.62C14.32 8.34385 14.5439 8.12 14.82 8.12zM17.65 8.12C17.9261 8.12 18.15 8.34385 18.15 8.62V11.52C18.15 11.7961 17.9261 12.02 17.65 12.02 17.3739 12.02 17.15 11.7961 17.15 11.52V8.62C17.15 8.34385 17.3739 8.12 17.65 8.12z"
  }));
};

var SvgComponent$3q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.32 18.98H4.83001C4.55001 18.98 4.33001 18.76 4.33001 18.48V14.81L2.14001 12.64C1.95001 12.45 1.94001 12.15 2.12001 11.95L4.07001 9.77004C4.15001 9.69004 4.61001 9.26004 5.09001 9.05004C5.57001 8.84004 6.31001 8.78004 6.40001 8.77004C6.53001 8.76004 6.65001 8.78004 6.75001 8.88004C6.85001 8.98004 6.91001 9.11004 6.94001 9.27004C7.00001 9.54004 7.44001 9.86004 8.07001 9.86004C8.70001 9.86004 9.14001 9.54004 9.20001 9.27004C9.24001 9.10004 9.30001 8.96004 9.40001 8.87004C9.50001 8.78004 9.60001 8.76004 9.73001 8.77004C9.81001 8.77004 10.56 8.84004 11.04 9.05004C11.52 9.26004 11.98 9.69004 12.03 9.74004L14.01 11.95C14.19 12.15 14.18 12.45 13.99 12.64L11.8 14.81V18.48C11.8 18.76 11.58 18.98 11.3 18.98H11.32ZM5.33001 17.98H10.82V14.6C10.82 14.47 10.87 14.34 10.97 14.25L12.97 12.26L11.34 10.44C11.26 10.37 10.93 10.09 10.66 9.97004C10.52 9.91004 10.3 9.86004 10.09 9.82004C9.80001 10.43 9.02001 10.86 8.08001 10.86C7.14001 10.86 6.37001 10.43 6.07001 9.82004C5.86001 9.85004 5.64001 9.90004 5.50001 9.97004C5.23001 10.09 4.89001 10.38 4.79001 10.47L3.19001 12.27L5.19001 14.26C5.28001 14.35 5.34001 14.48 5.34001 14.61V17.99L5.33001 17.98Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21.42 8.81004L19 6.39004C19 6.39004 18.35 5.64004 17.63 5.31004C16.89 4.97004 16.07 5.01004 16.04 5.01004C15.78 5.03004 15.66 5.22004 15.57 5.50004C15.53 5.73004 14.75 6.57004 13.65 6.57004C12.66 6.57004 11.79 5.75004 11.73 5.51004C11.62 5.24004 11.52 5.03004 11.26 5.01004C11.22 5.01004 10.41 4.96004 9.67001 5.31004C8.95001 5.64004 8.32001 6.36004 8.32001 6.37004L6.82001 7.93004L7.53001 8.64004L9.05001 7.05004C9.05001 7.05004 9.56001 6.46004 10.09 6.22004C10.36 6.10004 10.66 6.05004 10.88 6.03004C11.29 6.79004 12.48 7.58004 13.65 7.58004C14.95 7.58004 16.05 6.77004 16.43 6.03004C16.65 6.05004 16.94 6.10004 17.21 6.22004C17.73 6.46004 18.24 7.05004 18.27 7.08004L20.74 9.55004C20.81 9.61004 20.89 9.72004 20.89 9.75004C20.89 9.80004 20.79 9.93004 20.67 10.02L18.75 11.84L17.78 10.87V17.99H12.95V18.99H18.28C18.56 18.99 18.78 18.77 18.78 18.49V13.2L21.32 10.79C21.41 10.72 21.84 10.36 21.89 9.84004C21.93 9.29004 21.47 8.87004 21.42 8.83004V8.81004Z"
  }));
};

var SvgComponent$3r = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M21.96 18.79H2.04004V19.79H21.96V18.79zM7 3.70996H6V15.68H7V3.70996z"
  }), /*#__PURE__*/createElement("path", {
    d: "M6.48998 16.3998L2.34998 12.2598 3.04998 11.5498 6.48998 14.9898 9.93998 11.5498 10.65 12.2598 6.48998 16.3998zM18.0601 3.70996H17.0601V15.66H18.0601V3.70996z"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.55 16.4301L13.41 12.2901L14.11 11.5801L17.55 15.0201L21 11.5801L21.71 12.2901L17.55 16.4301Z"
  }));
};

var SvgComponent$3s = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
    transform: "translate(-88.000000, -1419.000000) translate(60.000000, 1403.000000) translate(28.000000, 16.000000)"
  }, /*#__PURE__*/createElement("polygon", {
    points: "4.52727273 24 7.34181818 14.9345455 0 9.21818182 9.12 9.21818182 12.0109091 0 14.88 9.21818182 24 9.21818182 16.68 14.9345455 19.4727273 24 12.0109091 18.3927273"
  })))))))));
};

var SvgComponent$3t = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
    transform: "translate(-188.000000, -1419.000000) translate(60.000000, 1403.000000) translate(100.000000, 0.000000) translate(28.000000, 16.000000)"
  }, /*#__PURE__*/createElement("polygon", {
    points: "12 18.3927273 12 0 9.12 9.19636364 0 9.19636364 7.34181818 14.9236364 4.52727273 24"
  }), /*#__PURE__*/createElement("polygon", {
    points: "12 18.3927273 12 0 14.88 9.19636364 24 9.19636364 16.6581818 14.9236364 19.4727273 24"
  }))))))));
};

var SvgComponent$3u = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.393 14.5429L23.5 9.37993H14.715L12 1.02393L9.285 9.37993H0.5L7.607 14.5429L4.893 22.8989L12 17.7349L19.107 22.8989L16.393 14.5429Z"
  }));
};

var SvgComponent$3v = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM13.4999 12.9999H10.4999V10.9999H13.4999V12.9999Z"
  }));
};

var SvgComponent$3w = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM15.7099 14.2899L14.2999 15.6999L12.0099 13.4099L9.71991 15.6999L8.30991 14.2899L10.5999 11.9999L8.30991 9.7099L9.71991 8.2999L12.0099 10.5899L14.2999 8.2999L15.7099 9.7099L13.4199 11.9999L15.7099 14.2899Z"
  }));
};

var SvgComponent$3x = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM10.8599 15.9799L7.28991 12.4199L8.69991 10.9999L10.8499 13.1499L15.2799 8.7199L16.6899 10.1299L10.8399 15.9699L10.8599 15.9799Z"
  }));
};

var SvgComponent$3y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.29 12.75V19H6.71001V12.75H17.29ZM17.29 11.75H6.71001C6.16001 11.75 5.71001 12.2 5.71001 12.75V19C5.71001 19.55 6.16001 20 6.71001 20H17.29C17.84 20 18.29 19.55 18.29 19V12.75C18.29 12.2 17.84 11.75 17.29 11.75Z"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 20V11.75H12.5V20H11.5Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M18.57 6.67004H15.64V9.58004H18.57V6.67004Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M21 4H3C2.45 4 2 4.45 2 5V14.94H3V5H21V19H3V16.81H2V19C2 19.55 2.45 20 3 20H21C21.55 20 22 19.55 22 19V5C22 4.45 21.55 4 21 4Z"
  }));
};

var SvgComponent$3z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18 11.5H6V12.5H18V11.5Z"
  }));
};

var SvgComponent$3A = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 12 12",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM2.50049 6.06781L5.37293 8.93962L5.40658 8.97327L9.49955 4.88029L8.11926 3.5L5.40626 6.213L3.88078 4.68752L2.50049 6.06781Z"
  }));
};

var SvgComponent$3B = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.272 1.67187L18.0014 6.0362L22.3839 6.0362L22.3839 22.327L1.61328 22.327L1.61328 6.0362L5.99512 6.0362L8.71672 1.67187L15.272 1.67187ZM14.4105 3.2266L9.57939 3.2266L6.85779 7.59093L3.16801 7.59093L3.16801 20.7722L20.8291 20.7722L20.8291 7.59093L17.14 7.59093L14.4105 3.2266ZM11.3237 8.27693C12.5655 8.17142 13.7743 8.55492 14.7274 9.35809L14.913 9.52297C15.7561 10.3119 16.2707 11.3703 16.3697 12.5293C16.4647 13.6429 16.1647 14.7292 15.5229 15.629L17.8582 17.9643L16.7589 19.0638L14.4232 16.7282C13.6219 17.2977 12.6718 17.5903 11.7168 17.5903C10.6547 17.5903 9.58745 17.2306 8.71359 16.4943C6.74624 14.8362 6.49448 11.8867 8.15244 9.91924C8.95561 8.96619 10.0819 8.38297 11.3237 8.27693ZM11.7258 9.81445C11.6362 9.81445 11.5462 9.81839 11.4559 9.82606C10.6279 9.89665 9.87684 10.2856 9.34139 10.9211C8.23577 12.233 8.40368 14.1998 9.71556 15.3053C11.0274 16.4112 12.9942 16.2431 14.0997 14.9312C14.6352 14.2956 14.8913 13.4895 14.8206 12.6616C14.7499 11.8335 14.361 11.0826 13.7255 10.547L13.5517 10.4105C13.0187 10.0212 12.3845 9.81445 11.7258 9.81445Z"
  }));
};

var SvgComponent$3C = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4 3.09998L21.14 8.26998C21.3633 8.40125 21.5003 8.64099 21.5 8.89998V20.27C21.5 20.6731 21.1732 21 20.77 21H3.23C2.82683 21 2.5 20.6731 2.5 20.27V8.89998C2.49975 8.64099 2.63674 8.40125 2.86 8.26998L11.66 3.09998C11.8884 2.9657 12.1716 2.9657 12.4 3.09998ZM16.73 19.54L16.74 14.64H7.27V19.54H16.73ZM20.04 19.54H18.16V13.21H5.84V19.54H4V9.31998L12 4.57998L20 9.31998L20.04 19.54ZM9.21 9.99998H5.5V12H9.21V9.99998ZM10.14 9.99998H13.85V12H10.14V9.99998ZM18.5 9.99998H14.79V12H18.5V9.99998Z"
  })));
};

var SvgComponent$3D = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.65 18H11.35V12.65H6V11.35H11.35V6H12.65V11.35H18V12.65H12.65V18Z"
  }));
};

var SvgComponent$3E = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.46,18.5 L12,18.5 C12.0541371,19.0156254 12.1821125,19.5207914 12.38,20 L6.7,20 C6.49577901,20.0001634 6.30032235,19.9170411 6.15877495,19.7698318 C6.01722756,19.6226225 5.94183109,19.4240576 5.95,19.22 L5.95,11.99 L5.25,12.51 C4.91542533,12.7595652 4.44219304,12.6925984 4.19,12.36 L1.65,9 C1.4339922,8.67800617 1.49902614,8.24444658 1.8,8 L6.28,4.65 C7.13970363,4.21943728 8.08850933,3.99679334 9.05,4 L9.39,4 C9.66012234,3.99727261 9.91139129,4.13813551 10.05,4.37 C10.12,4.48 10.35,4.71 10.52,4.89 L10.71,5.09 C11.4855115,5.62911067 12.5144885,5.62911067 13.29,5.09 L13.48,4.89 C13.6526011,4.72213275 13.8161648,4.54521691 13.97,4.36 C14.1157625,4.14702578 14.3522997,4.01397362 14.61,4 L14.95,4 C15.9114481,3.99716582 16.8601688,4.2197898 17.72,4.65 L22.2,8 C22.5009739,8.24444658 22.5660078,8.67800617 22.35,9 L19.84,12.37 C19.587807,12.7025984 19.1145747,12.7695652 18.78,12.52 L18.08,12 L18.08,12.5 L17.58,12.5 C17.2443403,12.5032411 16.9096548,12.5367097 16.58,12.6 L16.58,10.52 C16.5813309,10.2350076 16.7440731,9.97539491 17,9.85 C17.245667,9.71551722 17.5453883,9.72704496 17.78,9.88 L19.08,10.88 L20.71,8.72 L16.84,5.85 C16.2532788,5.62162693 15.6295928,5.50299101 15,5.5 L14.54,5.92 L14.34,6.13 L14.22,6.24 C12.8770731,7.22212913 11.0529269,7.22212913 9.71,6.24 L9.59,6.13 L9.39,5.92 L9,5.5 C8.38054837,5.50706957 7.76743182,5.62562802 7.19,5.85 L3.32,8.72 L4.91,10.92 L6.21,9.92 C6.43931587,9.75022298 6.74440425,9.72318983 7,9.85 C7.26519158,9.96065501 7.44384672,10.2131025 7.46,10.5 L7.46,18.5 Z M21.78,20.72 C22.0553589,21.0155098 22.0472339,21.4760097 21.7616218,21.7616218 C21.4760097,22.0472339 21.0155098,22.0553589 20.72,21.78 L19.12,20.18 C17.7928573,21.1168343 15.996978,21.0237897 14.7737562,19.9548207 C13.5505343,18.8858518 13.217711,17.1186312 13.9682838,15.6779346 C14.7188565,14.2372379 16.3578584,13.4972969 17.9348653,13.8871884 C19.5118723,14.2770799 20.6172449,15.6955266 20.61,17.32 C20.6085414,17.9356489 20.4428425,18.5397593 20.13,19.07 L21.78,20.72 Z M15.11,17.32 C15.11,18.4245695 16.0054305,19.32 17.11,19.32 C18.2145695,19.32 19.11,18.4245695 19.11,17.32 C19.11,16.2154305 18.2145695,15.32 17.11,15.32 C16.0054305,15.32 15.11,16.2154305 15.11,17.32 Z"
  })));
};

var SvgComponent$3F = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 54,
    height: 43,
    viewBox: "0 0 54 43",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("g", {
    transform: "translate(-78.000000, -69.000000) translate(78.000000, 69.000000)"
  }, /*#__PURE__*/createElement("path", {
    d: "M52.51,42.46 L1.51,42.46 C0.889826994,42.4545115 0.39,41.9501973 0.39,41.33 L0.39,1.25 C0.39,0.952957531 0.507999661,0.668081149 0.718040405,0.458040405 C0.928081149,0.247999661 1.21295753,0.13 1.51,0.13 L52.51,0.13 C52.8070425,0.13 53.0919189,0.247999661 53.3019596,0.458040405 C53.5120003,0.668081149 53.63,0.952957531 53.63,1.25 L53.63,41.33 C53.63,41.9501973 53.130173,42.4545115 52.51,42.46 Z M2.62,40.21 L51.38,40.21 L51.38,2.38 L2.62,2.38 L2.62,40.21 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M35.39,34.5 L18.61,34.5 C17.9881817,34.494569 17.485431,33.9918183 17.48,33.37 L17.48,21.84 L15.59,22.22 C15.0361532,22.3263796 14.4877606,22.0117978 14.3,21.48 C12,14.61 12,14.08 12.66,13.6 C15.22,10.65 20.6,8.76999822 23.25,8.76999822 C23.6687586,8.76925844 24.0535915,9.00015815 24.25,9.37 C24.7360901,10.460511 25.7556981,11.2185838 26.94,11.37 C28.1687021,11.2193852 29.2432759,10.4705532 29.81,9.37 C30.0204704,9.02168812 30.4033152,8.81495196 30.81,8.83 C33.46,8.83 38.81,10.71 41.4,13.67 C42.09,14.14 42.1,14.67 39.76,21.54 C39.5722394,22.0717978 39.0238468,22.3863796 38.47,22.28 L36.58,21.9 L36.58,33.43 C36.5423917,34.0519353 36.0124208,34.5284637 35.39,34.5 Z M19.73,32.25 L34.27,32.25 L34.27,20.47 C34.2694541,20.1340747 34.4197194,19.815643 34.6793659,19.6025003 C34.9390124,19.3893577 35.2806188,19.3040141 35.61,19.37 L37.88,19.82 C38.55,17.82 39.21,15.71 39.42,14.82 C37.1473274,12.801572 34.3363662,11.4881686 31.33,11.04 C30.363099,12.5879514 28.6749782,13.5375193 26.85,13.56 C25.1255271,13.4380739 23.5621672,12.5022861 22.64,11.04 C19.6435512,11.491507 16.8431301,12.8048558 14.58,14.82 C14.79,15.69 15.45,17.82 16.11,19.82 L18.39,19.37 C18.7193812,19.3040141 19.0609876,19.3893577 19.3206341,19.6025003 C19.5802806,19.815643 19.7305459,20.1340747 19.73,20.47 L19.73,32.25 Z"
  }), /*#__PURE__*/createElement("polygon", {
    points: "17.53 20 19.25 17.9 19.71 20.57"
  }), /*#__PURE__*/createElement("polygon", {
    points: "34.29 20.57 34.75 17.9 36.47 20"
  })))));
};

var SvgComponent$3G = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M4.64,12 C4.61748005,9.15057789 6.24395235,6.5448957 8.81368713,5.31356445 C11.3834219,4.0822332 14.4333106,4.44715909 16.64,6.25 L6.25,16.59 C5.20581511,15.2882515 4.63776937,13.6687919 4.64,12 Z M12,19.36 C10.3299994,19.3593961 8.71041029,18.7877765 7.41,17.74 L17.75,7.41 C19.5528409,9.61668941 19.9177668,12.6665781 18.6864355,15.2363129 C17.4551043,17.8060476 14.8494221,19.43252 12,19.41 L12,19.36 Z"
  })));
};

var SvgComponent$3H = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M11.521,20.043 C6.822,20.043 3,16.221 3,11.521 C3,6.822 6.822,3 11.521,3 C16.22,3 20.042,6.822 20.042,11.521 C20.042,16.221 16.22,20.043 11.521,20.043 Z M11.521,4.5 C7.649,4.5 4.5,7.65 4.5,11.521 C4.5,15.393 7.649,18.543 11.521,18.543 C15.393,18.543 18.542,15.393 18.542,11.521 C18.542,7.65 15.393,4.5 11.521,4.5 Z M10.4419,13.0537 C10.4419,12.2057 10.5189,11.2447 11.1839,10.6767 C11.6259,10.2987 12.5559,10.0307 12.5559,9.3037 C12.5559,8.8057 12.2049,8.5107 11.6059,8.5107 C11.1559,8.5107 10.8249,8.6797 10.6349,9.0067 C10.5349,9.1757 10.4949,9.2867 10.4549,9.6157 L8.3949,9.6157 C8.4949,8.8657 8.6539,8.2787 9.0349,7.8337 C9.6149,7.1357 10.5049,6.7767 11.6559,6.7767 C13.4959,6.7767 14.6469,7.6977 14.6469,9.1567 C14.6469,9.6857 14.4909,10.1897 14.1469,10.5817 C13.9059,10.8567 13.6089,11.0787 13.3039,11.2677 C13.0129,11.4487 12.6979,11.6217 12.5099,11.9307 C12.3959,12.1177 12.3419,12.3357 12.3039,12.5517 C12.2969,12.5927 12.2199,13.0537 12.2459,13.0537 L10.4419,13.0537 Z M10.4415,16.2665 L10.4415,14.4695 L12.2495,14.4695 L12.2495,16.2665 L10.4415,16.2665 Z"
  })));
};

var SvgComponent$3I = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.56H5.78C5.78 14.2 4.09 17.15 2 17.15V20.55C6.17 20.55 9.55 16.08 9.55 10.56V3H2V10.56ZM14.4473 10.56H18.2273C18.2273 14.2 16.5373 17.15 14.4473 17.15V20.55C18.6173 20.55 21.9973 16.08 21.9973 10.56V3H14.4473V10.56Z"
  }));
};

var SvgComponent$3J = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55391 13.4402H5.77391C5.77391 9.80019 7.46391 6.8502 9.55391 6.8502V3.4502C5.38391 3.4502 2.00391 7.9202 2.00391 13.4402V21.0002H9.55391V13.4402ZM21.9992 13.4402H18.2192C18.2192 9.80019 19.9092 6.8502 21.9992 6.8502V3.4502C17.8292 3.4502 14.4492 7.9202 14.4492 13.4402V21.0002H21.9992V13.4402Z"
  }));
};

var SvgComponent$3K = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M6.71446938,5 C6.24133498,5 5.85734183,5.384 5.85734183,5.85714286 C5.85734183,6.33028571 6.24133498,6.71428571 6.71446938,6.71428571 L16.0737665,6.71428571 L5.25135265,17.5368571 C4.91621578,17.872 4.91621578,18.4137143 5.25135265,18.7488571 C5.41849253,18.916 5.63791718,19 5.85734183,19 C6.07676649,19 6.29619114,18.916 6.46333101,18.7488571 L17.2857449,7.92628571 L17.2857449,17.2857143 C17.2857449,17.7597143 17.6688809,18.1428571 18.1428724,18.1428571 C18.616864,18.1428571 19,17.7597143 19,17.2857143 L19,5 L6.71446938,5 Z"
  }))));
};

var SvgComponent$3L = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.295 19.3269L17.431 16.464C18.569 15.0949 19.255 13.3379 19.255 11.4229C19.255 7.06695 15.711 3.52295 11.355 3.52295C6.99896 3.52295 3.45496 7.06595 3.45496 11.4229C3.45496 15.7799 6.99896 19.3219 11.355 19.3219C13.293 19.3219 15.067 18.6179 16.443 17.4559L19.305 20.3169C19.442 20.4539 19.621 20.5219 19.8 20.5219C19.979 20.5219 20.158 20.4539 20.295 20.3169C20.568 20.0439 20.568 19.5999 20.295 19.3269ZM4.85496 11.4229C4.85496 7.83895 7.77096 4.92295 11.355 4.92295C14.939 4.92295 17.855 7.83895 17.855 11.4229C17.855 15.007 14.939 17.922 11.355 17.922C7.77096 17.922 4.85496 15.007 4.85496 11.4229Z"
  }));
};

var SvgComponent$3M = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M27.8276 28.5752L21.7378 22.4863C19.979 23.9619 17.7129 24.8516 15.2427 24.8516C9.66309 24.8516 5.12402 20.3125 5.12402 14.7334C5.12402 9.1543 9.66309 4.61523 15.2427 4.61523C20.8223 4.61523 25.3613 9.1543 25.3613 14.7334C25.3613 17.124 24.5283 19.3232 23.1367 21.0566L29.2417 27.1611L27.8276 28.5752ZM15.2427 6.61523C10.7661 6.61523 7.12402 10.2568 7.12402 14.7334C7.12402 19.21 10.7661 22.8516 15.2427 22.8516C19.7192 22.8516 23.3613 19.21 23.3613 14.7334C23.3613 10.2568 19.7192 6.61523 15.2427 6.61523Z"
  }));
};

var SvgComponent$3N = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5361 16.9016C7.10868 16.9016 4.31975 14.1127 4.31975 10.6852C4.31975 7.25774 7.10868 4.4688 10.5361 4.4688C13.9636 4.4688 16.7525 7.25774 16.7525 10.6852C16.7525 14.1127 13.9636 16.9016 10.5361 16.9016ZM16.3877 15.4295C17.4396 14.134 18.0723 12.4843 18.0723 10.6852C18.0723 6.52314 14.6982 3.15002 10.5361 3.15002C6.37409 3.15002 3 6.52314 3 10.6852C3 14.8473 6.37409 18.2204 10.5361 18.2204C12.41 18.2204 14.1198 17.5324 15.4386 16.4009L20.0393 21.0035L21 20.0418L16.3877 15.4295Z"
  }));
};

var SvgComponent$3O = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M22.25,21.54 C22.2500133,21.8069582 22.1432849,22.0628394 21.9535801,22.2506659 C21.7638754,22.4384924 21.5069449,22.5426696 21.24,22.54 L11.16,22.54 C10.6077153,22.54 10.16,22.0922847 10.16,21.54 L10.16,16.92 L22.25,16.92 L22.25,21.54 Z M11.17,21.54 L21.21,21.52 L21.21,17.93 L20.47,17.93 L20.47,18.72 C20.47,18.9961424 20.2461424,19.22 19.97,19.22 C19.6938576,19.22 19.47,18.9961424 19.47,18.72 L19.47,17.93 L18.58,17.93 L18.58,19.8 C18.58,20.0761424 18.3561424,20.3 18.08,20.3 C17.8038576,20.3 17.58,20.0761424 17.58,19.8 L17.58,17.91 L16.69,17.91 L16.69,18.7 C16.69,18.9761424 16.4661424,19.2 16.19,19.2 C15.9138576,19.2 15.69,18.9761424 15.69,18.7 L15.69,17.91 L14.8,17.91 L14.8,19.78 C14.8,20.0561424 14.5761424,20.28 14.3,20.28 C14.0238576,20.28 13.8,20.0561424 13.8,19.78 L13.8,17.9 L12.91,17.9 L12.91,18.69 C12.91,18.9661424 12.6861424,19.19 12.41,19.19 C12.1338576,19.19 11.91,18.9661424 11.91,18.69 L11.91,17.9 L11.17,17.9 L11.17,21.54 Z M22.31,8.79 C22.59937,9.04909443 22.6468109,9.48468785 22.42,9.8 L20,13.05 C19.8813184,13.214917 19.6984812,13.3220119 19.4965888,13.3448677 C19.2946964,13.3677234 19.0925452,13.3042121 18.94,13.17 L18.49,12.77 L18.49,15.4 L17.02,15.4 L17.02,11.12 C17.0193436,10.8291273 17.1869311,10.5641053 17.45,10.44 C17.7110789,10.3239037 18.0158901,10.3707977 18.23,10.56 L19.3,11.51 L20.82,9.51 L18.61,7.51 C17.9623258,6.93281582 17.1445589,6.58184288 16.28,6.51 L14,8.83 C13.8899863,8.93818218 13.7440975,9.00223089 13.59,9.01 C13.4205522,9.00976099 13.2583444,8.94127328 13.14,8.82 L12.26,7.91 L12.26,9.72 C12.3471853,9.63157011 12.4658244,9.5812384 12.59,9.58 C12.8661424,9.58 13.09,9.80385763 13.09,10.08 C13.09,10.3561424 12.8661424,10.58 12.59,10.58 C12.4658244,10.5787616 12.3471853,10.5284299 12.26,10.44 L12.26,12 C12.3471853,11.9115701 12.4658244,11.8612384 12.59,11.86 C12.8661424,11.86 13.09,12.0838576 13.09,12.36 C13.09,12.6361424 12.8661424,12.86 12.59,12.86 C12.4658244,12.8587616 12.3471853,12.8084299 12.26,12.72 L12.26,14.28 C12.3471853,14.1915701 12.4658244,14.1412384 12.59,14.14 C12.8661424,14.14 13.09,14.3638576 13.09,14.64 C13.09,14.9161424 12.8661424,15.14 12.59,15.14 C12.4658244,15.1387616 12.3471853,15.0884299 12.26,15 L12.26,15.45 L11.26,15.45 L11.26,7.9 L10.38,8.81 C10.2521327,8.91651107 10.0955093,8.98264096 9.93,9 C9.75757471,8.99456345 9.59492163,8.91865868 9.48,8.79 L7.28,6.55 C6.61920845,6.6977857 6.00674766,7.01089768 5.5,7.46 L3.29,9.46 L4.9,11.53 L5.9,10.63 C6.11511152,10.4417471 6.42121645,10.3985785 6.68,10.52 C6.93917421,10.6469765 7.10249662,10.9114033 7.1,11.2 L7.1,19.38 L8.5,19.38 L8.5,20.86 L6.35,20.86 C5.94521985,20.8545295 5.61996304,20.5248171 5.62,20.12 L5.62,12.79 L5.18,13.16 C5.02828235,13.2906817 4.82899648,13.3522792 4.63,13.33 C4.43053183,13.3062444 4.24966742,13.2013431 4.13,13.04 L1.71,9.79 C1.48673309,9.47905114 1.52958018,9.05058019 1.81,8.79 L4.53,6.37 C5.28866009,5.69544292 6.22007204,5.24531818 7.22,5.07 L8.56,3.74 C8.67526875,3.62024745 8.83379428,3.55179324 9,3.55 L14.48,3.55 C14.6412909,3.55178072 14.7955384,3.61634942 14.91,3.73 L16.21,5 C17.4572641,5.05640992 18.6471658,5.54013848 19.58,6.37 L22.31,8.79 Z M12.95,4.85 L10.55,4.85 L11.75,6.08 L12.95,4.85 Z M9.95,7.45 L10.6,6.75 L9,5.11 L8.31,5.8 L9.95,7.45 Z M13.6,7.45 L15.22,5.8 L14.51,5.11 L12.92,6.74 L13.6,7.45 Z"
  })));
};

var SvgComponent$3P = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 14.5V5.27403L6.93905 9.40903L6.12305 8.52803L12 3.08203L17.864 8.51603L17.049 9.39603L12.6 5.27403V14.5H11.4ZM18.4004 19.4V14H19.6004V20.6H4.40039V14H5.60039V19.4H18.4004Z"
  }));
};

var SvgComponent$3Q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M4.49803828,14.8732652 L4.51728867,9.53215626 L5.61193601,9.53565633 L5.60756092,10.7108053 C5.60581089,11.1334389 5.94006771,11.4755709 6.35395115,11.477321 C6.76695958,11.478196 7.10384145,11.138689 7.10559149,10.7169304 L7.10996658,9.54178146 L8.43474361,9.54615655 L8.42424339,12.3383385 C8.42249336,12.7592221 8.7576252,13.1022291 9.17063362,13.1039791 C9.58451707,13.1048542 9.92052393,12.7644722 9.92227396,12.3435886 L9.93277418,9.55228167 L11.2584262,9.55753178 L11.2540511,10.7326808 C11.2523011,11.1544394 11.5865579,11.4965713 12.0004414,11.4983214 C12.4134498,11.5000714 12.7503317,11.1596895 12.7520817,10.7379309 L12.7564568,9.56278189 L14.0821088,9.568032 L14.0716086,12.359339 C14.0698586,12.7802225 14.4032404,13.1232295 14.8179989,13.1249796 C15.2310073,13.1267296 15.5678892,12.7863477 15.5696392,12.3654641 L15.5801394,9.5732821 L16.9049164,9.57853221 L16.9005414,10.7536812 C16.8987913,11.1754398 17.2330481,11.5184468 17.6460566,11.5193218 C18.05994,11.5210718 18.3968219,11.1815649 18.3985719,10.7598063 L18.402947,9.58465733 L19.4967193,9.58815741 L19.4774689,14.9301414 L4.49803828,14.8732652 Z M21,8.06825139 L3.02538323,8 L3.00000771,14.8680151 C2.99738266,15.7115324 3.66502128,16.3966713 4.49278817,16.4001714 L19.4713438,16.4570476 C20.2991107,16.4596726 20.9719994,15.7797837 20.9754995,14.9362665 L21,8.06825139 Z"
  })));
};

var SvgComponent$3R = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M10.7231429,17.8413274 L10.7191416,14.3436786 L11.0442502,14.0098079 L12.8448515,12.2398227 L12.8278458,12.222894 L12.8068388,12.1946796 C12.5397496,11.925702 11.8385154,11.2090555 10.9842301,10.3776703 C10.6351135,10.0390971 10.376027,9.98454924 10.1659569,9.95069193 C9.78582991,10.4021228 9.14261511,10.9334946 8.20130075,10.9560661 L8.03324462,10.961709 L7.9592199,10.9560661 C7.83317781,10.9532447 7.70213404,10.938197 7.5510836,10.9081016 C6.81683839,10.7660889 6.30266668,10.3137176 5.99656445,9.95069193 C5.78749463,9.98454924 5.52940844,10.0390971 5.18129219,10.3776703 C4.14394575,11.3849254 3.35368184,12.2040844 3.34767983,12.2106677 L3.30466547,12.2257154 L5.11927147,14.0098079 L5.4313757,14.3135832 L5.44438005,14.7640736 L5.43937838,17.8356845 L10.7231429,17.8413274 Z M17.7274821,17.8648394 L17.7224804,12.7984684 L17.7064751,10.8300416 L18.7368192,11.7883918 C19.422048,11.1150074 20.3903714,10.1632406 20.7594947,9.79739352 C20.709478,9.68641677 20.5954399,9.52747548 20.5244162,9.45787989 L20.4874038,9.42026065 C20.2093109,9.13529491 19.2089769,8.10923015 17.9635609,6.89883112 C17.3613598,6.31291146 16.8912028,6.2367325 16.5130765,6.17560124 L16.3290151,6.14644633 C15.8528561,6.78503292 15.0325821,7.53929867 13.8061725,7.5675131 L13.7191435,7.56939406 L13.6461191,7.56092973 L13.5840984,7.57033454 L13.4970693,7.5675131 C12.2716601,7.53929867 11.4513861,6.78503292 10.9752271,6.14644633 L10.7911657,6.17560124 C10.4130394,6.2367325 9.9438827,6.31291146 9.34168159,6.89883112 C8.20330141,8.0029558 7.26998973,8.95566304 6.97189017,9.26225984 C7.27899273,9.62434502 7.62110698,9.81244122 7.99223092,9.82090555 C7.99323126,9.82090555 8.02224095,9.81714362 8.06525531,9.81620314 C8.14728271,9.81808411 8.17829306,9.82184603 8.17829306,9.82184603 C9.01457234,9.80209593 9.48973103,8.82869811 9.49373236,8.8192933 L9.50573637,8.79484079 L9.53374573,8.79201935 C9.53374573,8.79201935 9.67179183,8.77979309 9.84484962,8.77979309 C9.99289907,8.77979309 10.1199415,8.7891979 10.2249766,8.80706704 L10.3150066,8.82211474 C10.6541199,8.87666264 11.2213093,8.96882977 11.8645241,9.59236867 C12.9028709,10.6024453 13.7161425,11.4441757 13.7241451,11.4526401 C13.7531548,11.4808545 14.4533887,12.1683461 14.026246,12.7260513 C14.0032384,12.7552062 12.1116066,14.6126562 11.9255445,14.7932285 L11.9415498,17.8582561 L17.7274821,17.8648394 Z M8.35135086,18.9887142 L8.35135086,18.9736665 L4.24898083,18.9689641 L4.24898083,14.7621927 C4.01190166,14.5693941 2.1662853,12.764611 2.13727561,12.7260513 C1.71113329,12.1683461 2.41036681,11.4808545 2.44137717,11.4516996 C2.4483795,11.4441757 3.26065077,10.6024453 4.29999787,9.59236867 C4.85918461,9.04971114 5.35735098,8.90581755 5.77048895,8.83622195 C5.83150933,8.74029289 5.90153272,8.67163778 5.90153272,8.67163778 C5.91153606,8.66129249 7.03090988,7.50261991 8.45938694,6.11352949 C9.33968092,5.25863227 10.1189412,5.13260782 10.5830962,5.05830982 L10.7071376,5.03761924 C10.8481847,5.01222625 11.0232432,5 11.226311,5 C11.4623898,5 11.6524533,5.01692866 11.6524533,5.01692866 L11.6794623,5.0197501 L11.6924667,5.04326213 C11.6984687,5.05736934 12.3566885,6.40601908 13.52908,6.43329303 C13.52908,6.43329303 13.5700937,6.42859062 13.6301137,6.42576918 L13.6891335,6.42576918 L13.7811642,6.43329303 C14.9495544,6.40601908 15.6067739,5.05736934 15.6127759,5.04326213 L15.6237796,5.0197501 L15.6527892,5.01692866 C15.6527892,5.01692866 15.8418524,5 16.0779312,5 C16.2819994,5 16.4560575,5.01222625 16.5971046,5.03761924 L16.721146,5.05830982 C17.1863014,5.13260782 17.9645613,5.25863227 18.8438549,6.11352949 C20.2743326,7.50261991 21.3927061,8.66129249 21.4047101,8.67257826 C21.4137132,8.68104259 22.3960412,9.64785705 21.8178481,10.4040038 C21.7888384,10.4425635 19.2149789,12.9668145 18.9288833,13.2470778 L18.9468893,19 L8.35135086,18.9887142 Z"
  })));
};

var SvgComponent$3S = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1311 12.497L10.3531 11.72L7.95008 14.123V5H6.75008V14.123L4.35808 11.73L3.58008 12.508L7.35008 16.277L11.1311 12.497ZM21.2422 18.85H3.24219V20.151H21.2422V18.85ZM19.6539 11.72L20.4319 12.497L16.6509 16.277L12.8809 12.508L13.6599 11.73L16.0509 14.122V5H17.2509V14.123L19.6539 11.72Z"
  }));
};

var SvgComponent$3T = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
    transform: "translate(-88.000000, -1419.000000) translate(60.000000, 1403.000000) translate(28.000000, 16.000000)"
  }, /*#__PURE__*/createElement("polygon", {
    points: "4.52727273 24 7.34181818 14.9345455 0 9.21818182 9.12 9.21818182 12.0109091 0 14.88 9.21818182 24 9.21818182 16.68 14.9345455 19.4727273 24 12.0109091 18.3927273"
  })))))))));
};

var SvgComponent$3U = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
    transform: "translate(-188.000000, -1419.000000) translate(60.000000, 1403.000000) translate(100.000000, 0.000000) translate(28.000000, 16.000000)"
  }, /*#__PURE__*/createElement("polygon", {
    points: "12 18.3927273 12 0 9.12 9.19636364 0 9.19636364 7.34181818 14.9236364 4.52727273 24"
  }), /*#__PURE__*/createElement("polygon", {
    points: "12 18.3927273 12 0 14.88 9.19636364 24 9.19636364 16.6581818 14.9236364 19.4727273 24"
  }))))))));
};

var SvgComponent$3V = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.393 14.5429L23.5 9.37993H14.715L12 1.02393L9.285 9.37993H0.5L7.607 14.5429L4.893 22.8989L12 17.7349L19.107 22.8989L16.393 14.5429Z"
  }));
};

var SvgComponent$3W = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM13.4999 12.9999H10.4999V10.9999H13.4999V12.9999Z"
  }));
};

var SvgComponent$3X = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM15.7099 14.2899L14.2999 15.6999L12.0099 13.4099L9.71991 15.6999L8.30991 14.2899L10.5999 11.9999L8.30991 9.7099L9.71991 8.2999L12.0099 10.5899L14.2999 8.2999L15.7099 9.7099L13.4199 11.9999L15.7099 14.2899Z"
  }));
};

var SvgComponent$3Y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM10.8599 15.9799L7.28991 12.4199L8.69991 10.9999L10.8499 13.1499L15.2799 8.7199L16.6899 10.1299L10.8399 15.9699L10.8599 15.9799Z"
  }));
};

var SvgComponent$3Z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M21.27,4 C21.6731679,4 22,4.32683213 22,4.73 L22,19.27 C22,19.6731679 21.6731679,20 21.27,20 L2.73,20 C2.32683213,20 2,19.6731679 2,19.27 L2,4.73 C2,4.32683213 2.32683213,4 2.73,4 L21.27,4 Z M7.17,18.55 L11.51,18.54 L11.51,13.21 L7.17,13.21 L7.17,18.55 Z M12.49,18.55 L16.83,18.54 L16.83,13.21 L12.49,13.21 L12.49,18.55 Z M20.49,18.55 L20.54,5.45 L3.46,5.45 L3.46,18.54 L5.71,18.54 L5.71,12.48 C5.71,12.0768321 6.03683213,11.75 6.44,11.75 L17.56,11.75 C17.9631679,11.75 18.29,12.0768321 18.29,12.48 L18.29,18.55 L20.49,18.55 Z M15.64,6.67 L18.57,6.67 L18.57,9.58 L15.64,9.58 L15.64,6.67 Z"
  })));
};

var SvgComponent$3_ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18 11.3501H6V12.6511H18V11.3501Z"
  }));
};

var SvgComponent$3$ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.165,10.5 L14.415,10.5 C14.6563395,9.61504089 14.8417064,8.71576104 14.97,7.8075 C15.0825,6.735 15.12,5.1375 14.52,4.4625 C14.1432567,3.97731453 13.550505,3.71043579 12.9375,3.75 C11.505,3.75 11.5392097,5.30990801 11.1117097,6.59990801 C10.9617097,7.04990801 9.375,10.4925 9.1275,10.8375 C8.94,11.025 8.2125,11.5875 7.7475,12 L3,12 L3,21.75 L16.785,21.75 C17.4953761,21.8142693 18.2009969,21.5841585 18.7369137,21.113459 C19.2728306,20.6427596 19.592068,19.9727304 19.62,19.26 C19.613535,19.0407677 19.5884447,18.8224818 19.545,18.6075 C19.8480161,18.2205054 20.0094616,17.7414622 20.0025,17.25 C20.0086957,17.0691877 19.9961285,16.8882203 19.965,16.71 C20.3605532,16.2838873 20.5802583,15.7239072 20.58,15.1425 C20.5772488,14.8907729 20.5521502,14.6397872 20.505,14.3925 C20.8191843,13.9889674 20.9929944,13.493872 21,12.9825 C21,11.565 19.815,10.5 18.165,10.5 Z M7.5,20.25 L4.5,20.25 L4.5,13.5 L7.5,13.5 L7.5,20.25 Z M19.0425,15.255 C19.0177965,15.7070735 18.7210058,16.0988373 18.2925,16.245 C18.6119843,16.5306294 18.7274978,16.9808358 18.585,17.385 C18.5083763,17.7949443 18.2244065,18.1357081 17.835,18.285 C18.1664504,18.5294344 18.2976663,18.9627521 18.1575,19.35 C18.0675,19.8 17.745,20.25 16.785,20.25 L9,20.25 L9,12.915 C9.43529065,12.5761629 10.3081461,11.3261164 10.7073305,10.9454061 C11.1829334,10.1243152 12.1962336,7.84685037 12.4425,6.9304764 C12.9248543,5.43112564 12.8079778,5.1525 12.99,5.1525 C13.9261498,5.1525 13.665,6.51 13.5525,7.62 C13.2952911,9.10628816 12.9241976,10.5706028 12.4425,12 L18.3375,12 C18.6279934,11.9708056 18.9176319,12.0630068 19.1377911,12.2547584 C19.3579503,12.44651 19.4890396,12.720749 19.5,13.0125 C19.5177103,13.5435763 19.1661612,14.0164565 18.6525,14.1525 C18.9858485,14.4128802 19.1379741,14.8429274 19.0425,15.255 Z"
  })), /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.49999163,12 L7.49999163,21.7461449 L9,21.7461449 L8.99999205,10.9535636 C9.05403991,10.9067711 9.09762464,10.8673754 9.1275,10.8375 C9.375,10.4925 11.1,7.0725 11.25,6.6225 C11.6775,5.3325 11.505,3.75 12.9375,3.75 C13.550505,3.71043579 14.0262737,4.28756022 14.3141545,4.81189939 C14.6776142,5.38087311 14.7488459,6.16729267 14.7125115,6.98350721 C14.7011163,7.23948823 14.6791412,7.49839979 14.6522824,7.75445349 C14.5239887,8.66271452 14.0470647,9.61118581 13.8057253,10.4961449 L18.165,10.5 C19.815,10.5 20.625,11.565 20.625,12.9825 C20.6179944,13.493872 20.4441843,13.9889674 20.13,14.3925 C20.1771502,14.6397872 20.2022488,14.8907729 20.205,15.1425 C20.2052583,15.7239072 19.9855532,16.2838873 19.59,16.71 C19.6211285,16.8882203 19.6336957,17.0691877 19.6275,17.25 C19.6344616,17.7414622 19.4730161,18.2205054 19.17,18.6075 C19.2134447,18.8224818 19.238535,19.0407677 19.245,19.26 C19.217068,19.9727304 18.8978308,20.6427596 18.361914,21.113459 C17.8259972,21.5841585 17.4953761,21.8142693 16.785,21.75 L3,21.75 L3,12 L7.49999163,12 Z"
  })));
};

var SvgComponent$40 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.8129 13.7902C21.4753 12.8404 21.8667 11.6884 21.8667 10.4453C21.8667 7.20996 19.2349 4.57812 16 4.57812C12.7651 4.57812 10.1338 7.20996 10.1338 10.4453C10.1338 11.6884 10.5251 12.8404 11.1874 13.7903L6.9668 16.7676V25.6211H25.0332V16.7676L20.8129 13.7902ZM16 6.17773C18.3525 6.17773 20.2671 8.0918 20.2671 10.4453C20.2671 12.7979 18.3525 14.7119 16 14.7119C13.6475 14.7119 11.7334 12.7979 11.7334 10.4453C11.7334 8.0918 13.6475 6.17773 16 6.17773ZM23.4336 24.0215H8.56641V17.5977L12.28 14.9772C13.2932 15.8104 14.589 16.3115 16 16.3115C17.4111 16.3115 18.7071 15.8103 19.7203 14.9772L23.4336 17.5977V24.0215Z"
  }));
};

var SvgComponent$41 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M20.275 14.2279C21.1689 13.2188 21.7168 11.8964 21.7168 10.4453C21.7168 7.29297 19.1523 4.72754 16 4.72754C12.8477 4.72754 10.2822 7.29297 10.2822 10.4453C10.2822 11.8963 10.8302 13.2186 11.7243 14.2277L7.11621 17.4785V25.4717H24.8838V17.4785L20.275 14.2279Z"
  }));
};

var SvgComponent$42 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 11.6C9.60202 11.6 7.65002 9.64902 7.65002 7.25002 7.65002 4.85102 9.60202 2.90002 12 2.90002 14.398 2.90002 16.35 4.85102 16.35 7.25002 16.35 9.64902 14.398 11.6 12 11.6zM12 4.10002C10.263 4.10002 8.85002 5.51302 8.85002 7.25002 8.85002 8.98702 10.263 10.4 12 10.4 13.737 10.4 15.15 8.98702 15.15 7.25002 15.15 5.51302 13.737 4.10002 12 4.10002zM19.611 21.111H4.38898V20.5C4.38898 16.736 5.29298 12.889 12 12.889 18.707 12.889 19.611 16.737 19.611 20.5V21.111zM5.61998 19.888H18.379C18.264 16.304 17.039 14.111 12 14.111 6.96098 14.111 5.73498 16.304 5.61998 19.888z"
  }));
};

var SvgComponent$43 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.39 13.4599C18.17 13.4599 17.95 13.4899 17.75 13.5499L15.45 11.9999L17.75 10.4499C17.95 10.5099 18.17 10.5399 18.39 10.5399C19.68 10.5399 20.74 9.48986 20.74 8.19986C20.74 6.90986 19.68 5.85986 18.39 5.85986C17.1 5.85986 16.05 6.90986 16.05 8.19986C16.05 8.78986 16.27 9.33986 16.65 9.74986L14.36 11.2799L7.68005 6.77986C7.17005 6.43986 6.57005 6.24986 5.95005 6.24986C4.91005 6.24986 3.95005 6.76986 3.38005 7.62986L3.05005 8.12986L8.80005 11.9999L3.05005 15.8799L3.38005 16.3699C3.95005 17.2399 4.91005 17.7499 5.95005 17.7499C6.57005 17.7499 7.17005 17.5699 7.68005 17.2199L14.37 12.7199L16.65 14.2499C16.27 14.6599 16.05 15.2099 16.05 15.7999C16.05 17.0899 17.1 18.1399 18.39 18.1399C19.68 18.1399 20.74 17.0899 20.74 15.7999C20.74 14.5099 19.68 13.4599 18.39 13.4599ZM18.39 7.04986C19.02 7.04986 19.5401 7.56986 19.5401 8.19986C19.5401 8.82986 19.02 9.33986 18.39 9.33986C17.76 9.33986 17.25 8.82986 17.25 8.19986C17.25 7.56986 17.76 7.04986 18.39 7.04986ZM7.01005 16.2199C6.34005 16.6799 5.40005 16.6299 4.79005 16.1499L9.88005 12.7199L11.05 13.5099L7.01005 16.2199ZM12.13 12.7899L4.79005 7.84986C5.40005 7.36986 6.34005 7.31986 7.01005 7.77986L13.29 11.9999L12.13 12.7899ZM18.39 16.9499C17.76 16.9499 17.25 16.4299 17.25 15.7999C17.25 15.1699 17.76 14.6599 18.39 14.6599C19.02 14.6599 19.5401 15.1699 19.5401 15.7999C19.5401 16.4299 19.02 16.9499 18.39 16.9499Z"
  }));
};

var SvgComponent$44 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 10H17L12 15L7 10Z"
  }));
};

var SvgComponent$45 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0009 3.362L1.92188 19.601H22.0789L12.0009 3.362ZM12.0009 5.637L19.9219 18.401H4.07888L12.0009 5.637ZM12.7992 9.5H11.1992V14.4H12.7992V9.5ZM11.1992 15.4H12.7992V17H11.1992V15.4Z"
  }));
};

var SvgComponent$46 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M14.39,8.58 L15.42,9.61 L13.03,12 L15.42,14.39 L14.39,15.42 L12,13.03 L9.61,15.42 L8.58,14.39 L10.97,12 L8.58,9.61 L9.61,8.58 L12,10.97 L14.39,8.58 Z M12,4 C14.1217319,4 16.1565632,4.84285472 17.6568542,6.34314575 C19.1571453,7.84343678 20,9.87826808 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M12,18.55 C13.737168,18.55 15.4031861,17.8599127 16.6315494,16.6315494 C17.8599127,15.4031861 18.55,13.737168 18.55,12 C18.55,8.38253489 15.6174651,5.45 12,5.45 C8.38253489,5.45 5.45,8.38253489 5.45,12 C5.45,15.6174651 8.38253489,18.55 12,18.55 Z"
  })));
};

var SvgComponent$47 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04381 6.56598L7.03981 3.50598H2.00781V4.70498H5.84181L5.85581 15.459H18.7528L20.9928 6.56498L7.04381 6.56598ZM17.8178 14.26H7.05481L7.04681 7.76498H19.4538L17.8188 14.26H17.8178ZM16.9688 20.502C17.7972 20.502 18.4688 19.8304 18.4688 19.002C18.4688 18.1736 17.7972 17.502 16.9688 17.502C16.1403 17.502 15.4688 18.1736 15.4688 19.002C15.4688 19.8304 16.1403 20.502 16.9688 20.502ZM8.95312 19.002C8.95312 19.8304 8.28155 20.502 7.45312 20.502C6.6247 20.502 5.95312 19.8304 5.95312 19.002C5.95312 18.1736 6.6247 17.502 7.45312 17.502C8.28155 17.502 8.95312 18.1736 8.95312 19.002Z"
  }));
};

var SvgComponent$48 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90039 13.599V16.2L8.36739 13.6H14.6004V4.40002H2.40039V13.599H4.90039ZM6.10039 12.4H3.60039V5.60002H13.4004V12.4H7.96739L6.10039 13.799V12.4ZM16.5004 11.1V9.90002H21.6004V18.6H18.6004V21.885L15.0964 18.6H9.90039V15.5H11.1004V17.4H15.5714L17.4004 19.115V17.4H20.4004V11.1H16.5004Z"
  }));
};

var SvgComponent$49 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11 16.414L6.04999 11.465L7.46399 10.051L11 13.586L17.364 7.22205L18.778 8.63605L11 16.414Z"
  }));
};

var SvgComponent$4a = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40625 12C3.40625 16.743 7.26425 20.6 12.0063 20.6C16.7483 20.6 20.6063 16.743 20.6063 12C20.6063 7.25702 16.7483 3.40002 12.0063 3.40002C7.26425 3.40002 3.40625 7.25702 3.40625 12ZM4.60625 12C4.60625 7.92002 7.92525 4.60002 12.0063 4.60002C16.0872 4.60002 19.4062 7.92002 19.4062 12C19.4062 16.08 16.0872 19.4 12.0063 19.4C7.92525 19.4 4.60625 16.08 4.60625 12ZM7.10156 12.186L10.7426 15.813L16.8896 9.67103L15.9006 8.68103L10.7416 13.835L8.08956 11.193L7.10156 12.186Z"
  }));
};

var SvgComponent$4b = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 15.3319L6.59399 11.0079L7.40599 9.99194L12 13.6679L16.594 9.99194L17.406 11.0079L12 15.3319Z"
  }));
};

var SvgComponent$4c = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.517 6.56494L14.483 7.43494L10.375 11.9999L14.483 16.5649L13.517 17.4349L8.62598 11.9999L13.517 6.56494Z"
  }));
};

var SvgComponent$4d = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.89 23.17L12.78 22.17L18.32 16L12.78 9.82996L13.89 8.82996L20.34 16L13.89 23.17Z"
  }));
};

var SvgComponent$4e = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.483 17.4349L10.517 16.5649L14.625 11.9999L10.517 7.43494L11.483 6.56494L16.374 11.9999L11.483 17.4349Z"
  }));
};

var SvgComponent$4f = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 8.66797L17.406 12.992L16.594 14.008L12 10.332L7.40599 14.008L6.59399 12.992L12 8.66797Z"
  }));
};

var SvgComponent$4g = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.9999 2.8999C6.9799 2.8999 2.8999 6.9799 2.8999 11.9999C2.8999 17.0199 6.9799 21.0999 11.9999 21.0999C17.0199 21.0999 21.0999 17.0199 21.0999 11.9999C21.0999 6.9799 17.0199 2.8999 11.9999 2.8999ZM11.9999 19.8999C7.6399 19.8999 4.0999 16.3599 4.0999 11.9999C4.0999 7.6399 7.6399 4.0999 11.9999 4.0999C16.3599 4.0999 19.8999 7.6399 19.8999 11.9999C19.8999 16.3599 16.3599 19.8999 11.9999 19.8999Z"
  }));
};

var SvgComponent$4h = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M24.6357 8.63672L23.3633 7.36328L15.9995 14.7271L8.63574 7.36328L7.36328 8.63672L14.7266 16L7.36328 23.3633L8.63574 24.6367L15.9995 17.2729L23.3633 24.6367L24.6357 23.3633L17.2725 16L24.6357 8.63672Z"
  }));
};

var SvgComponent$4i = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18.8238 6.09603L17.9048 5.17603L11.9998 11.081L6.09576 5.17603L5.17676 6.09603L11.0808 12L5.17676 17.904L6.09576 18.824L11.9998 12.919L17.9048 18.824L18.8238 17.904L12.9198 12L18.8238 6.09603Z"
  }));
};

var SvgComponent$4j = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M15.9949 8.925L15.0759 8.005L11.9999 11.081L8.92388 8.005L8.00488 8.925L11.0809 12L8.00488 15.075L8.92388 15.995L11.9999 12.919L15.0759 15.995L15.9949 15.075L12.9199 12L15.9949 8.925Z"
  }));
};

var SvgComponent$4k = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M20.23,3 C20.6552593,3 21,3.34474074 21,3.77 L21,16.94 C21,17.3652593 20.6552593,17.71 20.23,17.71 L17.71,17.71 L17.71,20.23 C17.71,20.6552593 17.3652593,21 16.94,21 L3.77,21 C3.34474074,21 3,20.6552593 3,20.23 L3,7.06 C3,6.63474074 3.34474074,6.29 3.77,6.29 L6.29,6.29 L6.29,3.77 C6.29,3.34474074 6.63474074,3 7.06,3 L20.23,3 Z M16.17,19.46 L16.17,7.83 L4.54,7.83 L4.54,19.46 L16.17,19.46 Z M19.46,16.17 L19.46,4.54 L7.83,4.54 L7.83,6.29 L16.94,6.29 C17.3652593,6.29 17.71,6.63474074 17.71,7.06 L17.71,16.17 L19.46,16.17 Z"
  })));
};

var SvgComponent$4l = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1004 9.5929L20.6994 9.7339V9.7329C19.7394 10.0699 19.0934 10.9799 19.0934 11.9989C19.0934 13.0179 19.7394 13.9279 20.6994 14.2649L21.1004 14.4059V18.5989H2.90039V5.3999H21.1004V9.5929ZM19.9004 17.3999V15.2289C18.6844 14.6289 17.8934 13.3799 17.8934 11.9999C17.8934 10.6199 18.6844 9.3719 19.9004 8.7709V6.5999H9.05039V7.7499H7.95039V6.5999H4.10039V17.3999H7.95039V16.2489H9.05039V17.3999H19.9004ZM9.04922 9.2489H7.94922V11.2489H9.04922V9.2489ZM9.04922 12.7489H7.94922V14.7489H9.04922V12.7489Z"
  }));
};

var SvgComponent$4m = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.50039 4.8999H18.5004C19.9334 4.8999 21.1004 6.0659 21.1004 7.4999V16.4999C21.1004 17.9339 19.9344 19.0999 18.5004 19.0999H5.50039C4.06739 19.0999 2.90039 17.9339 2.90039 16.4999V7.4999C2.90039 6.0659 4.06639 4.8999 5.50039 4.8999ZM18.5004 6.0989H5.50039C4.72839 6.0989 4.10039 6.7279 4.10039 7.4989V8.9769H19.9004V7.4989C19.9004 6.7279 19.2724 6.0989 18.5004 6.0989ZM5.50039 17.8999H18.5004C19.2724 17.8999 19.9004 17.2709 19.9004 16.4999V11.9779H4.10039V16.4999C4.10039 17.2709 4.72839 17.8999 5.50039 17.8999ZM5.5 14.4999H10V15.7799H5.5V14.4999Z"
  }));
};

var SvgComponent$4n = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11.9999 2.8999C6.9799 2.8999 2.8999 6.9799 2.8999 11.9999C2.8999 17.0199 6.9799 21.0999 11.9999 21.0999C17.0199 21.0999 21.0999 17.0199 21.0999 11.9999C21.0999 6.9799 17.0199 2.8999 11.9999 2.8999ZM11.9999 19.8999C7.6399 19.8999 4.0999 16.3599 4.0999 11.9999C4.0999 7.6399 7.6399 4.0999 11.9999 4.0999C16.3599 4.0999 19.8999 7.6399 19.8999 11.9999C19.8999 16.3599 16.3599 19.8999 11.9999 19.8999ZM15.1099 8.0399L11.9999 11.1499L8.8899 8.0399L8.0399 8.8899L11.1499 11.9999L8.0399 15.1099L8.8899 15.9599L11.9999 12.8499L15.1099 15.9599L15.9599 15.1099L12.8499 11.9999L15.9599 8.8899L15.1099 8.0399Z"
  }));
};

var SvgComponent$4o = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6496 5.90004H13.3496V4.34204H10.6496V5.90204H4.34961V7.10204H5.89861V19.601H18.1006V7.10104H19.6496V5.90204V5.90004ZM7.09961 18.401V7.10204H16.8996V18.402H7.09961V18.401ZM10.5 9.35004H9.5V16.5H10.5V9.35004ZM13.5 9.35004H14.5V16.5H13.5V9.35004Z"
  }));
};

var SvgComponent$4p = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M19.6 14V20.6H4.4V14H5.6V19.4H18.4V14H19.6ZM17.88 8.97L17.06 8.09L12.6 12.22V3H11.4V12.23L6.95 8.11L6.13 8.99L12 14.42L17.88 8.97Z"
  }));
};

var SvgComponent$4q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M13.9719 3.323L6.34094 16.54L6.58394 21.476L10.9799 19.218L18.6109 6.001L13.9719 3.323ZM14.3739 4.825L17.1069 6.403L16.3819 7.659L13.6489 6.08L14.3739 4.825ZM7.87494 16.082L13.1489 6.947L15.8819 8.526L10.6079 17.661L7.87494 16.082ZM7.46394 16.999L10.0189 18.474L7.59794 19.718L7.46394 16.999Z"
  }));
};

var SvgComponent$4r = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M8.53 11.34C6.59 11.34 4.92 10.2 4.12 8.56H8.72V7.06H3.67C3.64 6.85 3.61 6.64 3.61 6.42C3.61 6.2 3.65 5.99 3.67 5.78H8.71V4.28H4.11C4.91 2.64 6.58 1.5 8.52 1.5C9.85 1.5 11.06 2.04 11.95 2.9L13.01 1.84C11.85 0.71 10.27 0 8.52 0C5.73 0 3.35 1.79 2.47 4.28H0V5.78H2.14C2.12 5.99 2.11 6.2 2.11 6.42C2.11 6.64 2.12 6.85 2.14 7.06H0V8.56H2.48C3.36 11.05 5.74 12.84 8.53 12.84C10.28 12.84 11.86 12.14 13.02 11L11.96 9.94C11.07 10.81 9.86 11.34 8.53 11.34Z"
  }));
};

var SvgComponent$4s = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.57617 13.5759L10.4242 14.4239L16.4002 8.4479V11.9999H17.6002V6.3999H12.0002V7.5999H15.5512L9.57617 13.5759ZM6.40039 17.5999H16.6004V13.9999H15.4004V16.3999H7.60039V8.5999H10.0004V7.3999H6.40039V17.5999Z"
  }));
};

var SvgComponent$4t = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9201 17.0801L17.0201 16.1801L15.6301 14.7901L14.7801 13.9401L10.0501 9.21008L9.21008 8.37008L8.15008 7.30008L7.21008 6.36008L4.42008 3.58008L3.58008 4.42008L6.08008 6.92008C4.12008 8.02008 2.50008 9.66008 1.46008 11.7201L1.33008 12.0001L1.46008 12.2701C3.42008 16.1701 7.45008 18.6001 12.0001 18.6001C13.6901 18.6001 15.3101 18.2501 16.7801 17.6201L19.5801 20.4201L20.4301 19.5701L17.9201 17.0801ZM9.23008 10.0801L13.9201 14.7701C13.3701 15.1501 12.7201 15.4001 12.0001 15.4001C10.1201 15.4001 8.60008 13.8801 8.60008 12.0001C8.60008 11.2801 8.84008 10.6301 9.23008 10.0801ZM12.0001 17.4001C8.02008 17.4001 4.47008 15.3401 2.68008 12.0001C3.66008 10.1801 5.17008 8.76008 6.98008 7.83008L8.37008 9.22008C7.77008 9.99008 7.40008 10.9501 7.40008 12.0001C7.40008 14.5401 9.46008 16.6001 12.0001 16.6001C13.0501 16.6001 14.0101 16.2301 14.7901 15.6301L15.8601 16.7001C14.6501 17.1501 13.3501 17.4001 12.0001 17.4001ZM22.54 11.7301C20.58 7.83008 16.55 5.40009 12 5.40009C10.77 5.40009 9.57996 5.58009 8.45996 5.92009L9.44996 6.91009C10.27 6.72009 11.12 6.60009 12 6.60009C15.98 6.60009 19.53 8.66009 21.32 12.0001C20.54 13.4501 19.42 14.6401 18.08 15.5401L18.96 16.4201C20.45 15.3601 21.69 13.9501 22.53 12.2701L22.67 12.0001L22.54 11.7301ZM16.6003 12.0001C16.6003 12.6101 16.4703 13.1901 16.2603 13.7201L15.3103 12.7601C15.3603 12.5201 15.4003 12.2601 15.4003 12.0001C15.4003 10.1201 13.8803 8.60009 12.0003 8.60009C11.7403 8.60009 11.4803 8.64008 11.2303 8.69008L10.2803 7.74009C10.8203 7.52009 11.3903 7.40009 12.0003 7.40009C14.5403 7.40009 16.6003 9.46009 16.6003 12.0001Z"
  }));
};

var SvgComponent$4u = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.46008 12.2699C3.42008 16.1699 7.45008 18.5999 12.0001 18.5999C16.5501 18.5999 20.5801 16.1699 22.5401 12.2699L22.6701 11.9999L22.5401 11.7299C20.5801 7.8299 16.5501 5.3999 12.0001 5.3999C7.45008 5.3999 3.42008 7.8299 1.46008 11.7299L1.33008 11.9999L1.46008 12.2699ZM12.0001 17.3999C8.02008 17.3999 4.48008 15.3399 2.68008 11.9999C4.47008 8.6599 8.02008 6.5999 12.0001 6.5999C15.9801 6.5999 19.5201 8.6599 21.3201 11.9999C19.5301 15.3399 15.9801 17.3999 12.0001 17.3999ZM7.40039 11.9999C7.40039 14.5399 9.46039 16.5999 12.0004 16.5999C14.5404 16.5999 16.6004 14.5399 16.6004 11.9999C16.6004 9.4599 14.5404 7.3999 12.0004 7.3999C9.46039 7.3999 7.40039 9.4599 7.40039 11.9999ZM8.60039 11.9999C8.60039 10.1199 10.1204 8.5999 12.0004 8.5999C13.8804 8.5999 15.4004 10.1199 15.4004 11.9999C15.4004 13.8799 13.8804 15.3999 12.0004 15.3999C10.1204 15.3999 8.60039 13.8799 8.60039 11.9999Z"
  }));
};

var SvgComponent$4v = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 7.34998H19.5V8.65098H4.5V7.34998ZM4.5 15.35H19.5V16.651H4.5V15.35Z"
  }));
};

var SvgComponent$4w = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40039 4H5.60039V20H4.40039V4ZM8.15039 12L11.9674 15.815L12.8154 14.968L10.4484 12.6H19.9994V11.4H10.4484L12.8044 9.04301L11.9554 8.19501L8.15039 12Z"
  }));
};

var SvgComponent$4x = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.47 8.6C6.741 9.746 7.773 10.6 9 10.6C10.227 10.6 11.259 9.746 11.53 8.6H21V7.401H11.53C11.259 6.255 10.227 5.401 9 5.401C7.773 5.401 6.741 6.255 6.47 7.401H3V8.6H6.47ZM7.6 8C7.6 7.229 8.228 6.6 9 6.6C9.772 6.6 10.4 7.229 10.4 8C10.4 8.771 9.772 9.4 9 9.4C8.228 9.4 7.6 8.771 7.6 8ZM12.47 16.6C12.741 17.746 13.773 18.6 15 18.6C16.227 18.6 17.259 17.746 17.53 16.6H21V15.401H17.53C17.259 14.255 16.227 13.401 15 13.401C13.773 13.401 12.741 14.255 12.47 15.401H3V16.6H12.47ZM13.6 16C13.6 15.229 14.228 14.6 15 14.6C15.772 14.6 16.4 15.229 16.4 16C16.4 16.771 15.772 17.4 15 17.4C14.228 17.4 13.6 16.771 13.6 16Z"
  }));
};

var SvgComponent$4y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.4899 4.95977C15.9799 5.69977 14.4199 5.31977 12.7699 4.91977C10.9899 4.47977 9.1399 4.02977 7.2299 4.95977L6.8999 5.12977V20.4998H8.0999V14.2998C9.5099 13.7598 10.9599 14.0998 12.4799 14.4798C13.4999 14.7298 14.5299 14.9798 15.5899 14.9798C16.3899 14.9798 17.1999 14.8298 18.0199 14.4298L18.3499 14.2598V4.53977L17.4899 4.95977Z"
  }));
};

var SvgComponent$4z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M17.4899 4.95977C15.9799 5.70977 14.4199 5.31977 12.7699 4.91977C10.9799 4.47977 9.13989 4.02977 7.22989 4.95977L6.88989 5.12977V20.4998H8.08989V14.2998C9.49989 13.7598 10.9499 14.0998 12.4699 14.4798C13.4899 14.7298 14.5199 14.9798 15.5799 14.9798C16.3799 14.9798 17.1899 14.8298 18.0099 14.4298L18.3499 14.2698V4.53977L17.4899 4.95977ZM17.1499 13.4998C15.7399 14.0398 14.2899 13.6798 12.7599 13.3098C11.7399 13.0598 10.7099 12.8098 9.64989 12.8098C9.12989 12.8098 8.60989 12.8698 8.08989 13.0198V5.89977C9.49989 5.35977 10.9499 5.71977 12.4799 6.08977C13.9899 6.45977 15.5499 6.83977 17.1499 6.37977V13.4998Z"
  }));
};

var SvgComponent$4A = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.376 3.784C17.554 4.937 18.22 6.476 18.25 8.118V8.128C18.25 9.432 17.791 10.748 17.012 11.885C16.201 13.069 12 18 12 18C12 18 7.799 13.069 6.988 11.885C6.209 10.749 5.75 9.433 5.75 8.128V8.118C5.78 6.476 6.445 4.937 7.624 3.784C8.801 2.634 10.355 2 12 2C13.645 2 15.199 2.633 16.376 3.784ZM15.5842 8.7095L14.334 8.366V12.183H9.662V8.366L8.41 8.71L7.707 6.936L10.591 5.543C10.591 5.543 10.947 6.792 11.997 6.792C13.047 6.792 13.403 5.543 13.403 5.543L16.287 6.936L15.5842 8.7095ZM18.4494 16.248L20.1994 20.728C20.2884 20.958 20.2594 21.219 20.1194 21.423C19.9794 21.628 19.7484 21.75 19.5004 21.75H4.50044C4.25344 21.75 4.02144 21.628 3.88144 21.423C3.74044 21.219 3.71144 20.958 3.80144 20.728L5.55144 16.247C5.66444 15.959 5.94144 15.77 6.25044 15.77H8.25544C8.67744 16.279 9.10144 16.786 9.50844 17.27H6.76244L5.59844 20.251H18.4014L17.2374 17.27H14.4914C14.8854 16.802 15.3134 16.29 15.7444 15.77H17.7504C18.0594 15.77 18.3374 15.96 18.4494 16.248Z"
  }));
};

var SvgComponent$4B = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.3624,18.5249 L4.6374,18.5249 C3.9764,18.5249 3.4384,17.9739 3.4384,17.2959 L3.4384,10.6629 L20.5614,10.6629 L20.5614,17.2959 C20.5614,17.9739 20.0244,18.5249 19.3624,18.5249 M4.6374,5.4749 L19.3624,5.4749 C20.0244,5.4749 20.5614,6.0259 20.5614,6.7049 L20.5614,9.6789 L3.4384,9.6789 L3.4384,6.7049 C3.4384,6.0259 3.9764,5.4749 4.6374,5.4749 M19.3624,3.9999 C20.8174,3.9999 22.0004,5.2129 22.0004,6.7049 L22.0004,17.2959 C22.0004,18.7869 20.8174,19.9999 19.3624,19.9999 L4.6374,19.9999 C3.1824,19.9999 2.0004,18.7869 2.0004,17.2959 L2.0004,6.7049 C2.0004,5.2129 3.1824,3.9999 4.6374,3.9999 L19.3624,3.9999 Z M6.315,15.976 L8.171,15.976 L8.171,12.874 L6.315,12.874 L6.315,15.976 Z M9.25,15.976 L10.178,15.976 L10.178,12.874 L9.25,12.874 L9.25,15.976 Z M11.256,15.976 L13.351,15.976 L13.351,12.874 L11.256,12.874 L11.256,15.976 Z M17.02,15.976 L17.685,15.976 L17.685,12.874 L17.02,12.874 L17.02,15.976 Z M14.44,15.976 L16.023,15.976 L16.023,12.874 L14.44,12.874 L14.44,15.976 Z"
  })));
};

var SvgComponent$4C = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M21.5055025,11.5 L21.5055025,5.75 C21.5055025,5.612 21.3939133,5.5 21.2564195,5.5 L10.2180608,5.5 L10.2180608,8.44 C10.2180608,8.716 9.99488248,8.94 9.71989493,8.94 C9.44490739,8.94 9.22172909,8.716 9.22172909,8.44 L9.22172909,5.5 L2.74358045,5.5 C2.60608668,5.5 2.49449753,5.612 2.49449753,5.75 L2.49449753,11.5 L3.74190481,11.5 C4.01689235,11.5 4.24007065,11.724 4.24007065,12 C4.24007065,12.276 4.01689235,12.5 3.74190481,12.5 L2.49449753,12.5 L2.49449753,18.25 C2.49449753,18.388 2.60608668,18.5 2.74358045,18.5 L9.22172909,18.5 L9.22172909,16.44 C9.22172909,16.164 9.44490739,15.94 9.71989493,15.94 C9.99488248,15.94 10.2180608,16.164 10.2180608,16.44 L10.2180608,18.5 L21.2564195,18.5 C21.3939133,18.5 21.5055025,18.388 21.5055025,18.25 L21.5055025,12.5 L16.6942167,12.5 C16.4192292,12.5 16.1960509,12.276 16.1960509,12 C16.1960509,11.724 16.4192292,11.5 16.6942167,11.5 L21.5055025,11.5 Z M21.2564195,4 C22.2178796,4 23,4.785 23,5.75 L23,18.25 C23,19.215 22.2178796,20 21.2564195,20 L2.74358045,20 C1.78212037,20 1,19.215 1,18.25 L1,5.75 C1,4.785 1.78212037,4 2.74358045,4 L21.2564195,4 Z M13.4550428,12.5972 C13.8715094,12.4242 14.3158734,11.9932 14.3158734,11.3042 C14.3158734,10.6142 13.8715094,10.1832 13.4550428,10.0102 C13.0365835,9.8362 12.4188578,9.8272 11.935637,10.3132 L10.9472759,11.3042 L11.935637,12.2942 C12.4198542,12.7812 13.0375798,12.7702 13.4550428,12.5972 Z M8.07883701,12.2942 L9.06719804,11.3042 L8.07883701,10.3132 C7.7799375,10.0122 7.42823242,9.9012 7.10641728,9.9012 C6.90715094,9.9012 6.71784792,9.9442 6.55943119,10.0102 C6.14296454,10.1832 5.69860061,10.6142 5.69860061,11.3042 C5.69860061,11.9932 6.14296454,12.4242 6.55943119,12.5972 C6.97390517,12.7712 7.59461981,12.7812 8.07883701,12.2942 Z M13.9502196,8.8082 C14.9744486,9.2342 15.6121009,10.1902 15.6121009,11.3042 C15.6121009,12.4162 14.9744486,13.3722 13.9502196,13.7982 C13.6064852,13.9412 13.2527875,14.0112 12.9040714,14.0112 C12.6111499,14.0112 12.3242063,13.9512 12.0482225,13.8542 L12.8024455,15.1032 C12.9877632,15.4102 12.8901227,15.8102 12.5842489,15.9962 C12.4796341,16.0592 12.3630633,16.0902 12.2494815,16.0902 C12.0302885,16.0902 11.8160772,15.9782 11.6945247,15.7772 L9.98780852,12.9492 L8.28109234,15.7772 C8.15953988,15.9782 7.94532856,16.0902 7.72613559,16.0902 C7.61255378,16.0902 7.4969793,16.0592 7.39136814,15.9962 C7.08549432,15.8102 6.98785381,15.4102 7.1731715,15.1032 L7.91842761,13.8692 C7.65639237,13.9552 7.38738282,14.0112 7.11040261,14.0112 C6.76069019,14.0112 6.40699244,13.9412 6.063258,13.7982 C5.03902903,13.3722 4.40237308,12.4162 4.40237308,11.3042 C4.40237308,10.1902 5.03902903,9.2352 6.063258,8.8082 C7.08748698,8.3822 8.21035279,8.6072 8.99546216,9.3942 L10.0077352,10.4092 L11.0190118,9.3942 C11.8031249,8.6082 12.923998,8.3822 13.9502196,8.8082 Z"
  })));
};

var SvgComponent$4D = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 3.44995C7.28605 3.44995 3.45105 7.28495 3.45105 12C3.45105 16.715 7.28605 20.5499 12.001 20.5499C16.7161 20.5499 20.55 16.715 20.55 12C20.55 7.28495 16.715 3.44995 12 3.44995ZM15.4871 11.5H12.499V9.27595C13.345 9.22695 14.166 9.05695 14.945 8.77195C15.255 9.63795 15.4411 10.555 15.4871 11.501V11.5ZM9.05305 8.77095C9.83205 9.05595 10.653 9.22695 11.499 9.27595V11.501H8.51105C8.55705 10.554 8.74305 9.63795 9.05305 8.77195V8.77095ZM11.499 8.17595C10.805 8.12995 10.132 7.98895 9.49105 7.75995C9.98905 6.75995 10.66 5.84595 11.499 5.06595V8.17595ZM8.51305 12.5H11.499V14.725C10.659 14.773 9.84305 14.942 9.06905 15.224C8.75505 14.36 8.56405 13.446 8.51305 12.5ZM11.499 15.824V18.885C10.672 18.116 10.008 17.217 9.51205 16.233C10.147 16.008 10.813 15.87 11.499 15.824ZM12.499 15.824C13.185 15.869 13.851 16.007 14.486 16.232C13.99 17.215 13.326 18.115 12.499 18.884V15.824ZM12.499 14.724V12.499H15.484C15.4331 13.444 15.2421 14.358 14.9281 15.222C14.154 14.94 13.34 14.772 12.499 14.724ZM12.499 8.17495V5.06695C13.338 5.84595 14.009 6.75995 14.507 7.75995C13.866 7.98895 13.193 8.12895 12.499 8.17495ZM13.545 4.71195C14.8 4.97795 15.936 5.56395 16.872 6.37595C16.425 6.76395 15.941 7.09695 15.425 7.36495C14.9471 6.39395 14.314 5.50195 13.545 4.71195ZM8.57405 7.36395C8.05805 7.09595 7.57405 6.76495 7.12705 6.37695C8.06205 5.56495 9.19805 4.97995 10.452 4.71295C9.68305 5.50195 9.05105 6.39295 8.57405 7.36395ZM8.14105 8.37495C7.78005 9.36495 7.55705 10.413 7.51005 11.499H4.57505C4.68605 9.84595 5.33305 8.33995 6.35005 7.15595C6.89905 7.64195 7.50005 8.05095 8.14105 8.37595V8.37495ZM7.51205 12.499C7.56705 13.571 7.79905 14.617 8.16905 15.609C7.51705 15.936 6.90805 16.35 6.35105 16.843C5.33305 15.658 4.68605 14.152 4.57505 12.499H7.51305H7.51205ZM8.60705 16.618C9.09705 17.604 9.74205 18.509 10.521 19.301C9.23905 19.042 8.07905 18.449 7.12705 17.622C7.58405 17.226 8.07805 16.889 8.60705 16.618ZM15.39 16.618C15.9191 16.889 16.415 17.225 16.872 17.622C15.919 18.449 14.758 19.043 13.476 19.302C14.255 18.509 14.9001 17.604 15.39 16.618ZM15.8291 15.609C16.199 14.617 16.4311 13.571 16.4851 12.499H19.424C19.313 14.152 18.666 15.658 17.649 16.843C17.0911 16.35 16.4811 15.937 15.8291 15.609ZM16.4881 11.499C16.4401 10.414 16.2181 9.36595 15.857 8.37695C16.4991 8.05195 17.0981 7.64195 17.6481 7.15595C18.6651 8.34095 19.313 9.84695 19.424 11.5H16.4881V11.499Z"
  }));
};

var SvgComponent$4E = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 20.47L4.689 12.97C3.657 11.938 3.086 10.594 3.086 9.19205C3.086 6.08805 5.439 3.74805 8.56 3.74805C10.018 3.74805 11.235 4.53205 12 5.19205C12.766 4.53205 13.983 3.74805 15.441 3.74805C18.561 3.74805 20.914 6.08905 20.914 9.19205C20.914 10.594 20.343 11.938 19.306 12.975L12 20.47Z"
  }));
};

var SvgComponent$4F = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12 20.47L4.689 12.97C3.657 11.938 3.086 10.594 3.086 9.19205C3.086 6.08805 5.439 3.74805 8.56 3.74805C10.018 3.74805 11.235 4.53205 12 5.19205C12.766 4.53205 13.983 3.74805 15.441 3.74805C18.561 3.74805 20.914 6.08905 20.914 9.19205C20.914 10.594 20.343 11.938 19.306 12.975L12 20.47ZM8.56 4.94705C6.123 4.94705 4.287 6.77205 4.287 9.19205C4.287 10.274 4.733 11.316 5.544 12.128L12.001 18.752L18.453 12.133C19.269 11.318 19.715 10.275 19.715 9.19305C19.715 6.77305 17.878 4.94805 15.442 4.94805C14.108 4.94805 12.98 5.88005 12.426 6.43505L12.001 6.86105L11.576 6.43505C11.022 5.87905 9.895 4.94705 8.56 4.94705Z"
  }));
};

var SvgComponent$4G = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C16.9705627,3 21,7.02943725 21,12 C21,16.9705627 16.9705627,21 12,21 C7.02943725,21 3,16.9705627 3,12 C3,7.02943725 7.02943725,3 12,3 Z M12,19.42 C13.9679064,19.42 15.8552124,18.6382522 17.2467323,17.2467323 C18.6382522,15.8552124 19.42,13.9679064 19.42,12 C19.42,7.90204716 16.0979528,4.58 12,4.58 C7.90204716,4.58 4.58,7.90204716 4.58,12 C4.58,16.0979528 7.90204716,19.42 12,19.42 Z M12.14,7 C14.07,7 15.28,7.92 15.28,9.45 C15.2922252,9.99488698 15.1035792,10.5252314 14.75,10.94 C14.4905652,11.2226854 14.1906348,11.4653258 13.86,11.66 C13.5327273,11.8212295 13.2482969,12.0576837 13.03,12.35 C12.9165555,12.550954 12.8419245,12.7714546 12.81,13 C12.7754694,13.1713466 12.7553987,13.345292 12.75,13.52 L10.85,13.52 C10.7378491,12.616272 11.0222957,11.7082311 11.63,11.03 C12.07,10.59 13.07,10.35 13.07,9.59 C13.07,9.07 12.7,8.76 12.07,8.76 C11.6664399,8.73641604 11.2824608,8.93608517 11.07,9.28 C10.9540843,9.47406205 10.8887534,9.69412415 10.88,9.92 L8.72,9.92 C8.75652516,9.24779793 8.98948058,8.60108587 9.39,8.06 C10.0987622,7.30832529 11.1100887,6.9185049 12.14,7 Z M10.71,15.12 L12.9,15.12 L12.9,17.31 L10.71,17.31 L10.71,15.12 Z"
  })));
};

var SvgComponent$4H = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.7998 25.1377L17.7002 25.1299V19.6309H14.2998V25.1309H6.20068L6.2002 13.4561L16 5.28809L25.7998 13.4561V25.1377ZM19.2998 23.5322L24.2002 23.5361V14.2061L16 7.37012L7.7998 14.2061L7.80029 23.5312H12.7002V18.0312H19.2998V23.5322Z"
  }));
};

var SvgComponent$4I = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.7995 25.138L18.4995 25.1302V18.6667H13.4995V25.1302H6.19922V13.4557L15.9993 5.28775L25.7995 13.4557V25.138Z"
  }));
};

var SvgComponent$4J = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.3 11.5998L18.3 5.9998C16.9 4.8998 15 4.8998 13.7 5.9998L6.70005 11.5998C5.80005 12.2998 5.30005 13.3998 5.30005 14.4998V25.9998C5.30005 26.3998 5.60005 26.6998 6.00005 26.6998H13C13.4 26.6998 13.7 26.3998 13.7 25.9998V19.6998H18.3V25.9998C18.3 26.3998 18.6 26.6998 19 26.6998H26C26.4 26.6998 26.7001 26.3998 26.7001 25.9998V14.3998C26.7001 13.2998 26.2 12.2998 25.3 11.5998ZM25.3 25.2998H19.7V18.9998C19.7 18.5998 19.4 18.2998 19 18.2998H13C12.6 18.2998 12.3 18.5998 12.3 18.9998V25.2998H6.70005V14.3998C6.70005 13.6998 7.00005 12.9998 7.60005 12.5998L14.6 6.9998C15.4 6.2998 16.6 6.2998 17.5 6.9998L24.5 12.5998C25 12.9998 25.4 13.6998 25.4 14.3998L25.3 25.2998Z"
  }));
};

var SvgComponent$4K = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M25.8 25.1379L18.5 25.13V18.6665H13.5V25.13H6.19971V13.4556L15.9998 5.2876L25.8 13.4556V25.1379Z"
  }));
};

var SvgComponent$4L = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 3.40002C7.25839 3.40002 3.40039 7.25802 3.40039 12C3.40039 16.742 7.25839 20.6 12.0004 20.6C16.7424 20.6 20.6004 16.743 20.6004 12C20.6004 7.25702 16.7424 3.40002 12.0004 3.40002ZM12.0004 19.4C7.91939 19.4 4.60039 16.08 4.60039 12C4.60039 7.92002 7.91939 4.60002 12.0004 4.60002C16.0814 4.60002 19.4004 7.92002 19.4004 12C19.4004 16.08 16.0814 19.4 12.0004 19.4ZM12.7992 10.5H11.1992V16.5H12.7992V10.5ZM11.1992 7.5H12.7992V9.1H11.1992V7.5Z"
  }));
};

var SvgComponent$4M = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m4.3,3.53v15.28h12.48l2.92,2.84V3.53H4.3Zm14.2,15.28l-1.23-1.2H5.5V4.73h13v14.08ZM9.45,7.35h-1.44v7.09h1.44v-7.09Zm4.16,7.2c.15,0,.29-.02.48-.05l.47,1.38h1.42l-.7-2.02c.47-.46.7-1.01.7-1.67v-2.52c0-1.32-1.06-2.37-2.38-2.37s-2.38,1.05-2.38,2.37v2.52c0,1.3,1.09,2.37,2.39,2.37Zm-.95-4.88c0-.53.42-.95.94-.95s.94.38.94.95v2.52c0,.53-.42.95-.94.95s-.94-.43-.94-.95v-2.52Z"
  }));
};

var SvgComponent$4N = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.601 11.562V10.478C12.871 10.25 13.356 9.83402 13.851 9.37602C14.274 8.98502 14.739 8.26602 14.539 7.02902C14.449 6.40002 13.81 4.76502 11.855 4.83702C9.78302 4.89502 9.23502 6.61902 9.23502 7.52402L10.435 7.52802C10.438 7.28602 10.524 6.07502 11.888 6.03702C13.159 6.03402 13.343 7.15402 13.359 7.25202C13.416 7.60602 13.444 8.11902 13.036 8.49602C12.319 9.15802 11.623 9.73102 11.619 9.73502L11.4 9.91502V11.561L3.40002 15.632V18.6H20.6V15.632L12.601 11.562ZM19.399 17.4H4.60002V16.368L12 12.602L19.4 16.368L19.399 17.4Z"
  }));
};

var SvgComponent$4O = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6413 13.343L12.0043 21.051L17.3603 13.352C18.1743 12.229 18.6043 10.896 18.6043 9.50002C18.6043 5.86002 15.6433 2.90002 12.0043 2.90002C8.3653 2.90002 5.4043 5.86002 5.4043 9.50002C5.4043 10.897 5.8343 12.229 6.6413 13.343ZM6.6043 9.50002C6.6043 6.52302 9.0263 4.10002 12.0043 4.10002C14.9823 4.10002 17.4033 6.52202 17.4033 9.50002C17.4033 10.641 17.0523 11.73 16.3813 12.657L12.0043 18.949L7.6203 12.648C6.9553 11.73 6.6043 10.642 6.6043 9.50002ZM9.44922 9.50001C9.44922 10.906 10.5932 12.05 11.9992 12.05C13.4052 12.05 14.5492 10.906 14.5492 9.50001C14.5492 8.09401 13.4052 6.95001 11.9992 6.95001C10.5932 6.95001 9.44922 8.09401 9.44922 9.50001ZM10.5492 9.50001C10.5492 8.70001 11.2002 8.05001 11.9992 8.05001C12.7982 8.05001 13.4492 8.70001 13.4492 9.50001C13.4492 10.3 12.7982 10.95 11.9992 10.95C11.2002 10.95 10.5492 10.3 10.5492 9.50001Z"
  }));
};

var SvgComponent$4P = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1004 7.50002V9.90002H18.6004V20.099H5.40039V9.90002H7.90039V7.54602C7.90039 5.23902 9.73939 3.40002 12.0004 3.40002C14.2614 3.40002 16.1004 5.23902 16.1004 7.50002ZM12.0004 4.60002C10.4014 4.60002 9.10039 5.90102 9.10039 7.50002V9.90102H14.9004V7.54702C14.9004 5.90202 13.5994 4.60002 12.0004 4.60002ZM6.60039 11.099V18.9H17.4004V11.099H6.60039ZM11.25 13H12.75V17H11.25V13Z"
  }));
};

var SvgComponent$4Q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5 5.3501H4.5V6.6511H19.5V5.3501ZM19.5 17.3501H4.5V18.6511H19.5V17.3501ZM4.5 11.3501H19.5V12.6511H4.5V11.3501Z"
  }));
};

var SvgComponent$4R = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("rect", {
    x: 5.5,
    y: 11,
    width: 13,
    height: 2
  })));
};

var SvgComponent$4S = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 75 75",
    width: 24,
    height: 24,
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M58.16,66.67a1.39,1.39,0,0,0-1,.42,1.32,1.32,0,0,0,0,1.93,1.36,1.36,0,0,0,1,.39,1.34,1.34,0,0,0,1-.39,1.33,1.33,0,0,0,.42-1,1.29,1.29,0,0,0-.42-1A1.34,1.34,0,0,0,58.16,66.67Zm0-8.1a1.41,1.41,0,0,0-1,.39,1.09,1.09,0,0,0-.42,1,3.32,3.32,0,0,0,.1.8c0,.13.06.27.1.42s.11.47.17.74.22.93.35,1.58c0,.15.06.33.09.5s0,.11,0,.17c.09.49.19,1,.29,1.67h.56c.1-.62.2-1.18.29-1.67a1,1,0,0,1,0-.17c0-.18.06-.35.09-.5.13-.62.25-1.14.37-1.56,0-.26.11-.51.17-.76s.06-.25.08-.37a5.13,5.13,0,0,0,.12-.85,1.29,1.29,0,0,0-.42-1A1.36,1.36,0,0,0,58.18,58.57Zm10.5,6.15L68.24,64l-.72-1.24-.92-1.57-1.35-2.32-2-3.38-.3-.51-1-1.66a4.49,4.49,0,0,0-1.46-1.51,4.45,4.45,0,0,0-6.24,1.51l-.42.73-.54.93-.88,1.52-1.38,2.37-1.35,2.32-.92,1.57L48.12,64l-.44.76-1.5,2.58A4.44,4.44,0,0,0,50,74H66.33a4.44,4.44,0,0,0,3.85-6.66Zm-.92,5.62a1.61,1.61,0,0,1-1.43.81H50a1.63,1.63,0,0,1-1.42-2.44l1.5-2.57,1.17-2,.1-.18L53,61.15l.52-.91,2.27-3.89,1-1.66a1.62,1.62,0,0,1,1.42-.81,1.93,1.93,0,0,1,.42,0,1.62,1.62,0,0,1,1,.76l1,1.66.06.11,2.21,3.78.52.91L65,64l.1.18,1.17,2,1.49,2.57A1.57,1.57,0,0,1,67.76,70.34ZM46.38,37.6,33,29.76l.11,15.48ZM69.38,11H5.62a1.41,1.41,0,0,0-1.41,1.41v50.1A1.41,1.41,0,0,0,5.62,64H44.87l1.64-2.81H7V55.52H49.78l1.64-2.81H7V22.3H68V57.93l2.79,4.8a1.1,1.1,0,0,0,0-.18V12.45A1.41,1.41,0,0,0,69.38,11ZM68,19.48H7V13.86H68Z",
    fillRule: "evenodd"
  }))));
};

var SvgComponent$4T = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "m19.17,18.11c-1-1.09-1.13-3.05-1.13-4.83v-2.63c0-3.1-2.48-5.83-5.44-6.17v-1.98h-1.2v1.98c-2.96.33-5.44,3.07-5.44,6.17v2.63c0,1.78-.13,3.74-1.13,4.83-.16.17-.2.43-.11.65s.31.36.55.36h4c.22,1.31,1.36,2.31,2.73,2.31s2.51-1,2.73-2.31h4c.24,0,.45-.14.55-.36s.05-.47-.11-.65Zm-7.17,2.12c-.71,0-1.3-.47-1.5-1.11h3c-.2.64-.79,1.11-1.5,1.11Zm0-2.31h-5.61c.66-1.34.77-3.06.77-4.63v-2.63c0-2.62,2.31-5,4.84-5s4.84,2.38,4.84,5v2.63c0,1.58.11,3.29.77,4.63h-5.61Z"
  }));
};

var SvgComponent$4U = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M19.21,17 C18.2949379,16.1674062 17.7602099,14.9967855 17.73,13.76 L17.73,10.1 C17.7345835,7.21079815 15.5945232,4.76684925 12.73,4.39 L12.73,3.73 C12.7628643,3.45065151 12.6323114,3.17727078 12.3943942,3.02723399 C12.156477,2.87719719 11.853523,2.87719719 11.6156058,3.02723399 C11.3776886,3.17727078 11.2471357,3.45065151 11.28,3.73 L11.28,4.4 C8.41547684,4.77684925 6.2754165,7.22079815 6.28,10.11 L6.28,13.78 C6.24181022,15.0112789 5.70382438,16.173906 4.79,17 C4.60731091,17.145645 4.50063173,17.3663606 4.5,17.6 C4.5,18.0031679 4.82683213,18.33 5.23,18.33 L8.73,18.33 C8.94740021,19.9419204 10.3771648,21.1093428 12,21 C13.6161071,21.1103312 15.0431008,19.953899 15.27,18.35 L18.77,18.35 C18.9662659,18.3473657 19.1534448,18.2668637 19.2903501,18.1262075 C19.4272555,17.9855513 19.5026702,17.7962655 19.5,17.6 C19.5055874,17.3649709 19.3976417,17.141635 19.21,17 L19.21,17 Z M12,19.54 C11.1964503,19.6187343 10.4483712,19.121408 10.21,18.35 L13.79,18.35 C13.5653607,19.1315666 12.8076025,19.6353276 12,19.54 L12,19.54 Z M15.33,16.89 L6.79,16.89 C7.37025101,15.9541225 7.69121664,14.8807858 7.72,13.78 L7.72,10.1 C7.72,7.73345985 9.63845985,5.815 12.005,5.815 C14.3715402,5.815 16.29,7.73345985 16.29,10.1 L16.29,13.77 C16.3187834,14.8707858 16.639749,15.9441225 17.22,16.88 L15.33,16.89 Z"
  })));
};

var SvgComponent$4V = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8722 2.70297L17.5732 1.71997V2.85897L14.0752 3.78197L8.54922 4.40897V6.49997H7.44922V3.42697L13.8722 2.70297ZM17.5745 5.12701L13.6695 6.03701L12.1025 7.47601H10.8555V8.57501H12.5305L14.2015 7.04301L17.5745 6.25801V5.12701ZM14.9842 8.50003H13.8842V9.95003H10.0332V8.02503C10.0332 7.26103 10.4862 6.56903 11.1852 6.26003L10.7422 5.25403C9.64322 5.73703 8.93322 6.82503 8.93322 8.02503V9.95003H5.44922V22.05H18.5492V9.95003H14.9832L14.9842 8.50003ZM17.4502 20.95H6.55022V11.05H17.4502V20.95ZM15.9563 17.624H14.1562V19.424H15.9563V17.624ZM11.4551 17.624H13.2551V19.424H11.4551V17.624Z"
  }));
};

var SvgComponent$4W = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 12C3.40039 7.25802 7.25839 3.40002 12.0004 3.40002C16.7424 3.40002 20.6004 7.25702 20.6004 12C20.6004 16.743 16.7424 20.6 12.0004 20.6C7.25839 20.6 3.40039 16.742 3.40039 12ZM4.60039 12C4.60039 16.08 7.91939 19.4 12.0004 19.4C16.0814 19.4 19.4004 16.08 19.4004 12C19.4004 7.92002 16.0814 4.60002 12.0004 4.60002C7.91939 4.60002 4.60039 7.92002 4.60039 12ZM10.6176 7.48003H12.6726V7.47803C14.2296 7.47803 15.4976 8.83203 15.4976 10.497C15.4976 12.162 14.2306 13.516 12.6726 13.516H10.9996V16.858H9.59961V7.48003H10.6176ZM10.9996 12.117H12.6726C13.4586 12.117 14.0976 11.391 14.0976 10.499C14.0976 9.60703 13.4586 8.88103 12.6726 8.88103H10.9996V12.117Z"
  }));
};

var SvgComponent$4X = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 11.9999C3.40039 7.2579 7.25839 3.3999 12.0004 3.3999C16.7424 3.3999 20.6004 7.2569 20.6004 11.9999C20.6004 16.7429 16.7424 20.5999 12.0004 20.5999C7.25839 20.5999 3.40039 16.7419 3.40039 11.9999ZM4.60039 11.9999C4.60039 16.0799 7.91939 19.3999 12.0004 19.3999C16.0814 19.3999 19.4004 16.0799 19.4004 11.9999C19.4004 7.9199 16.0814 4.5999 12.0004 4.5999C7.91939 4.5999 4.60039 7.9199 4.60039 11.9999ZM10.6004 8.49988H9.40039V15.4999H10.6004V8.49988ZM14.6004 8.49988H13.4004V15.4999H14.6004V8.49988Z"
  }));
};

var SvgComponent$4Y = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("path", {
    d: "M10.4558553,3.4719535 L9.06485529,3.8199535 C8.13485529,4.0619535 7.36285529,4.6949535 6.89185529,5.5989535 C6.38685529,6.5689535 6.31185529,7.7179535 6.68685529,8.7509535 C8.07385529,12.5719535 10.0228553,16.1009535 12.4818553,19.2409535 C13.1078553,20.0419535 14.0258553,20.5139535 14.9978553,20.5349535 C15.9618553,20.5459535 16.9078553,20.1269535 17.5698553,19.3539535 L18.5108553,18.2539535 C18.5668553,18.1879535 18.5608553,18.0729535 18.4968553,18.0079535 C17.7678553,17.2509535 17.0648553,16.4419535 16.4078553,15.6019535 L16.3828553,15.5789535 C16.3628553,15.5609535 16.3328553,15.5569535 16.3088553,15.5689535 L16.2978553,15.5749535 L14.3418553,17.2329535 C14.1888553,17.3629535 13.9938553,17.4239535 13.7908553,17.3999535 C13.5918553,17.3769535 13.4128553,17.2719535 13.2928553,17.1109535 C11.4368553,14.6009535 9.90885529,11.8339535 8.74885529,8.8839535 C8.60485529,8.5199535 8.77285529,8.1059535 9.12785529,7.9469535 L11.4268553,6.9099535 C11.4828553,6.8849535 11.5178553,6.7849535 11.4848553,6.6879535 C11.1168553,5.6769535 10.7938553,4.6279535 10.5218553,3.5749535 C10.5108553,3.5279535 10.4858553,3.4899535 10.4558553,3.4719535 M15.0678553,21.9999535 C15.0338553,21.9999535 14.9998553,21.9989535 14.9658553,21.9989535 C13.5598553,21.9679535 12.2378553,21.2929535 11.3418553,20.1469535 C8.78785529,16.8859535 6.76285529,13.2209535 5.32385529,9.2539535 C4.80885529,7.8339535 4.91185529,6.2539535 5.60585529,4.9189535 C6.26085529,3.6629535 7.38785529,2.7459535 8.69985529,2.4029535 L10.0538553,2.0489535 C10.4418553,1.9469535 10.8478553,2.0059535 11.1938553,2.2109535 C11.5588553,2.4289535 11.8198553,2.7829535 11.9288553,3.2099535 C12.1868553,4.2159535 12.4958553,5.2179535 12.8478553,6.1859535 C13.1428553,6.9999535 12.7778553,7.9039535 12.0178553,8.2459535 L10.3618553,8.9929535 C11.3378553,11.3389535 12.5598553,13.5589535 14.0028553,15.6079535 L15.3648553,14.4549535 L15.3648553,14.4549535 C15.6818553,14.1859535 16.0838553,14.0609535 16.4888553,14.1019535 C16.9058553,14.1449535 17.2818553,14.3559535 17.5478553,14.6949535 C18.1738553,15.4959535 18.8438553,16.2669535 19.5388553,16.9879535 C20.1248553,17.5979535 20.1558553,18.5739535 19.6088553,19.2109535 L18.6678553,20.3099535 C17.7458553,21.3879535 16.4378553,21.9999535 15.0678553,21.9999535"
  }))));
};

var SvgComponent$4Z = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 11.9999C3.40039 7.2579 7.25839 3.3999 12.0004 3.3999C16.7424 3.3999 20.6004 7.2569 20.6004 11.9999C20.6004 16.7429 16.7424 20.5999 12.0004 20.5999C7.25839 20.5999 3.40039 16.7419 3.40039 11.9999ZM4.60039 11.9999C4.60039 16.0799 7.91939 19.3999 12.0004 19.3999C16.0814 19.3999 19.4004 16.0799 19.4004 11.9999C19.4004 7.9199 16.0814 4.5999 12.0004 4.5999C7.91939 4.5999 4.60039 7.9199 4.60039 11.9999ZM15.25 11.9999L10.25 15.4999V8.49988L15.25 11.9999Z"
  }));
};

var SvgComponent$4_ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.65 18H11.35V12.65H6V11.35H11.35V6H12.65V11.35H18V12.65H12.65V18Z"
  }));
};

var SvgComponent$4$ = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.46,18.5 L12,18.5 C12.0541371,19.0156254 12.1821125,19.5207914 12.38,20 L6.7,20 C6.49577901,20.0001634 6.30032235,19.9170411 6.15877495,19.7698318 C6.01722756,19.6226225 5.94183109,19.4240576 5.95,19.22 L5.95,11.99 L5.25,12.51 C4.91542533,12.7595652 4.44219304,12.6925984 4.19,12.36 L1.65,9 C1.4339922,8.67800617 1.49902614,8.24444658 1.8,8 L6.28,4.65 C7.13970363,4.21943728 8.08850933,3.99679334 9.05,4 L9.39,4 C9.66012234,3.99727261 9.91139129,4.13813551 10.05,4.37 C10.12,4.48 10.35,4.71 10.52,4.89 L10.71,5.09 C11.4855115,5.62911067 12.5144885,5.62911067 13.29,5.09 L13.48,4.89 C13.6526011,4.72213275 13.8161648,4.54521691 13.97,4.36 C14.1157625,4.14702578 14.3522997,4.01397362 14.61,4 L14.95,4 C15.9114481,3.99716582 16.8601688,4.2197898 17.72,4.65 L22.2,8 C22.5009739,8.24444658 22.5660078,8.67800617 22.35,9 L19.84,12.37 C19.587807,12.7025984 19.1145747,12.7695652 18.78,12.52 L18.08,12 L18.08,12.5 L17.58,12.5 C17.2443403,12.5032411 16.9096548,12.5367097 16.58,12.6 L16.58,10.52 C16.5813309,10.2350076 16.7440731,9.97539491 17,9.85 C17.245667,9.71551722 17.5453883,9.72704496 17.78,9.88 L19.08,10.88 L20.71,8.72 L16.84,5.85 C16.2532788,5.62162693 15.6295928,5.50299101 15,5.5 L14.54,5.92 L14.34,6.13 L14.22,6.24 C12.8770731,7.22212913 11.0529269,7.22212913 9.71,6.24 L9.59,6.13 L9.39,5.92 L9,5.5 C8.38054837,5.50706957 7.76743182,5.62562802 7.19,5.85 L3.32,8.72 L4.91,10.92 L6.21,9.92 C6.43931587,9.75022298 6.74440425,9.72318983 7,9.85 C7.26519158,9.96065501 7.44384672,10.2131025 7.46,10.5 L7.46,18.5 Z M21.78,20.72 C22.0553589,21.0155098 22.0472339,21.4760097 21.7616218,21.7616218 C21.4760097,22.0472339 21.0155098,22.0553589 20.72,21.78 L19.12,20.18 C17.7928573,21.1168343 15.996978,21.0237897 14.7737562,19.9548207 C13.5505343,18.8858518 13.217711,17.1186312 13.9682838,15.6779346 C14.7188565,14.2372379 16.3578584,13.4972969 17.9348653,13.8871884 C19.5118723,14.2770799 20.6172449,15.6955266 20.61,17.32 C20.6085414,17.9356489 20.4428425,18.5397593 20.13,19.07 L21.78,20.72 Z M15.11,17.32 C15.11,18.4245695 16.0054305,19.32 17.11,19.32 C18.2145695,19.32 19.11,18.4245695 19.11,17.32 C19.11,16.2154305 18.2145695,15.32 17.11,15.32 C16.0054305,15.32 15.11,16.2154305 15.11,17.32 Z"
  })));
};

var SvgComponent$50 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 54,
    height: 43,
    viewBox: "0 0 54 43",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/createElement("g", {
    transform: "translate(-78.000000, -69.000000) translate(78.000000, 69.000000)"
  }, /*#__PURE__*/createElement("path", {
    d: "M52.51,42.46 L1.51,42.46 C0.889826994,42.4545115 0.39,41.9501973 0.39,41.33 L0.39,1.25 C0.39,0.952957531 0.507999661,0.668081149 0.718040405,0.458040405 C0.928081149,0.247999661 1.21295753,0.13 1.51,0.13 L52.51,0.13 C52.8070425,0.13 53.0919189,0.247999661 53.3019596,0.458040405 C53.5120003,0.668081149 53.63,0.952957531 53.63,1.25 L53.63,41.33 C53.63,41.9501973 53.130173,42.4545115 52.51,42.46 Z M2.62,40.21 L51.38,40.21 L51.38,2.38 L2.62,2.38 L2.62,40.21 Z"
  }), /*#__PURE__*/createElement("path", {
    d: "M35.39,34.5 L18.61,34.5 C17.9881817,34.494569 17.485431,33.9918183 17.48,33.37 L17.48,21.84 L15.59,22.22 C15.0361532,22.3263796 14.4877606,22.0117978 14.3,21.48 C12,14.61 12,14.08 12.66,13.6 C15.22,10.65 20.6,8.76999822 23.25,8.76999822 C23.6687586,8.76925844 24.0535915,9.00015815 24.25,9.37 C24.7360901,10.460511 25.7556981,11.2185838 26.94,11.37 C28.1687021,11.2193852 29.2432759,10.4705532 29.81,9.37 C30.0204704,9.02168812 30.4033152,8.81495196 30.81,8.83 C33.46,8.83 38.81,10.71 41.4,13.67 C42.09,14.14 42.1,14.67 39.76,21.54 C39.5722394,22.0717978 39.0238468,22.3863796 38.47,22.28 L36.58,21.9 L36.58,33.43 C36.5423917,34.0519353 36.0124208,34.5284637 35.39,34.5 Z M19.73,32.25 L34.27,32.25 L34.27,20.47 C34.2694541,20.1340747 34.4197194,19.815643 34.6793659,19.6025003 C34.9390124,19.3893577 35.2806188,19.3040141 35.61,19.37 L37.88,19.82 C38.55,17.82 39.21,15.71 39.42,14.82 C37.1473274,12.801572 34.3363662,11.4881686 31.33,11.04 C30.363099,12.5879514 28.6749782,13.5375193 26.85,13.56 C25.1255271,13.4380739 23.5621672,12.5022861 22.64,11.04 C19.6435512,11.491507 16.8431301,12.8048558 14.58,14.82 C14.79,15.69 15.45,17.82 16.11,19.82 L18.39,19.37 C18.7193812,19.3040141 19.0609876,19.3893577 19.3206341,19.6025003 C19.5802806,19.815643 19.7305459,20.1340747 19.73,20.47 L19.73,32.25 Z"
  }), /*#__PURE__*/createElement("polygon", {
    points: "17.53 20 19.25 17.9 19.71 20.57"
  }), /*#__PURE__*/createElement("polygon", {
    points: "34.29 20.57 34.75 17.9 36.47 20"
  })))));
};

var SvgComponent$51 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M12,3 C7.02943725,3 3,7.02943725 3,12 C3,16.9705627 7.02943725,21 12,21 C16.9705627,21 21,16.9705627 21,12 C21,7.02943725 16.9705627,3 12,3 Z M4.64,12 C4.61748005,9.15057789 6.24395235,6.5448957 8.81368713,5.31356445 C11.3834219,4.0822332 14.4333106,4.44715909 16.64,6.25 L6.25,16.59 C5.20581511,15.2882515 4.63776937,13.6687919 4.64,12 Z M12,19.36 C10.3299994,19.3593961 8.71041029,18.7877765 7.41,17.74 L17.75,7.41 C19.5528409,9.61668941 19.9177668,12.6665781 18.6864355,15.2363129 C17.4551043,17.8060476 14.8494221,19.43252 12,19.41 L12,19.36 Z"
  })));
};

var SvgComponent$52 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10.56H5.78C5.78 14.2 4.09 17.15 2 17.15V20.55C6.17 20.55 9.55 16.08 9.55 10.56V3H2V10.56ZM14.4473 10.56H18.2273C18.2273 14.2 16.5373 17.15 14.4473 17.15V20.55C18.6173 20.55 21.9973 16.08 21.9973 10.56V3H14.4473V10.56Z"
  }));
};

var SvgComponent$53 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55391 13.4402H5.77391C5.77391 9.80019 7.46391 6.8502 9.55391 6.8502V3.4502C5.38391 3.4502 2.00391 7.9202 2.00391 13.4402V21.0002H9.55391V13.4402ZM21.9992 13.4402H18.2192C18.2192 9.80019 19.9092 6.8502 21.9992 6.8502V3.4502C17.8292 3.4502 14.4492 7.9202 14.4492 13.4402V21.0002H21.9992V13.4402Z"
  }));
};

var SvgComponent$54 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M6.42399 18.424L5.57599 17.576L15.552 7.60002H6.99999V6.40002H17.6V17H16.4V8.44802L6.42399 18.424Z"
  }));
};

var SvgComponent$55 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M27.8276 28.5752L21.7378 22.4863C19.979 23.9619 17.7129 24.8516 15.2427 24.8516C9.66309 24.8516 5.12402 20.3125 5.12402 14.7334C5.12402 9.1543 9.66309 4.61523 15.2427 4.61523C20.8223 4.61523 25.3613 9.1543 25.3613 14.7334C25.3613 17.124 24.5283 19.3232 23.1367 21.0566L29.2417 27.1611L27.8276 28.5752ZM15.2427 6.61523C10.7661 6.61523 7.12402 10.2568 7.12402 14.7334C7.12402 19.21 10.7661 22.8516 15.2427 22.8516C19.7192 22.8516 23.3613 19.21 23.3613 14.7334C23.3613 10.2568 19.7192 6.61523 15.2427 6.61523Z"
  }));
};

var SvgComponent$56 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.151 15.3031C17.225 14.0131 17.871 12.3561 17.871 10.5501C17.871 6.44806 14.534 3.11206 10.432 3.11206C6.33002 3.11206 2.99402 6.44806 2.99402 10.5501C2.99402 14.6521 6.33102 17.9881 10.433 17.9881C12.298 17.9881 14.005 17.2991 15.312 16.1601L19.977 20.8251L20.826 19.9771L16.152 15.3021L16.151 15.3031ZM10.432 16.7891C6.99202 16.7891 4.19302 13.9901 4.19302 10.5501C4.19302 7.11006 6.99202 4.31106 10.432 4.31106C13.872 4.31106 16.671 7.11006 16.671 10.5501C16.671 13.9901 13.872 16.7891 10.432 16.7891Z"
  }));
};

var SvgComponent$57 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M22.25,21.54 C22.2500133,21.8069582 22.1432849,22.0628394 21.9535801,22.2506659 C21.7638754,22.4384924 21.5069449,22.5426696 21.24,22.54 L11.16,22.54 C10.6077153,22.54 10.16,22.0922847 10.16,21.54 L10.16,16.92 L22.25,16.92 L22.25,21.54 Z M11.17,21.54 L21.21,21.52 L21.21,17.93 L20.47,17.93 L20.47,18.72 C20.47,18.9961424 20.2461424,19.22 19.97,19.22 C19.6938576,19.22 19.47,18.9961424 19.47,18.72 L19.47,17.93 L18.58,17.93 L18.58,19.8 C18.58,20.0761424 18.3561424,20.3 18.08,20.3 C17.8038576,20.3 17.58,20.0761424 17.58,19.8 L17.58,17.91 L16.69,17.91 L16.69,18.7 C16.69,18.9761424 16.4661424,19.2 16.19,19.2 C15.9138576,19.2 15.69,18.9761424 15.69,18.7 L15.69,17.91 L14.8,17.91 L14.8,19.78 C14.8,20.0561424 14.5761424,20.28 14.3,20.28 C14.0238576,20.28 13.8,20.0561424 13.8,19.78 L13.8,17.9 L12.91,17.9 L12.91,18.69 C12.91,18.9661424 12.6861424,19.19 12.41,19.19 C12.1338576,19.19 11.91,18.9661424 11.91,18.69 L11.91,17.9 L11.17,17.9 L11.17,21.54 Z M22.31,8.79 C22.59937,9.04909443 22.6468109,9.48468785 22.42,9.8 L20,13.05 C19.8813184,13.214917 19.6984812,13.3220119 19.4965888,13.3448677 C19.2946964,13.3677234 19.0925452,13.3042121 18.94,13.17 L18.49,12.77 L18.49,15.4 L17.02,15.4 L17.02,11.12 C17.0193436,10.8291273 17.1869311,10.5641053 17.45,10.44 C17.7110789,10.3239037 18.0158901,10.3707977 18.23,10.56 L19.3,11.51 L20.82,9.51 L18.61,7.51 C17.9623258,6.93281582 17.1445589,6.58184288 16.28,6.51 L14,8.83 C13.8899863,8.93818218 13.7440975,9.00223089 13.59,9.01 C13.4205522,9.00976099 13.2583444,8.94127328 13.14,8.82 L12.26,7.91 L12.26,9.72 C12.3471853,9.63157011 12.4658244,9.5812384 12.59,9.58 C12.8661424,9.58 13.09,9.80385763 13.09,10.08 C13.09,10.3561424 12.8661424,10.58 12.59,10.58 C12.4658244,10.5787616 12.3471853,10.5284299 12.26,10.44 L12.26,12 C12.3471853,11.9115701 12.4658244,11.8612384 12.59,11.86 C12.8661424,11.86 13.09,12.0838576 13.09,12.36 C13.09,12.6361424 12.8661424,12.86 12.59,12.86 C12.4658244,12.8587616 12.3471853,12.8084299 12.26,12.72 L12.26,14.28 C12.3471853,14.1915701 12.4658244,14.1412384 12.59,14.14 C12.8661424,14.14 13.09,14.3638576 13.09,14.64 C13.09,14.9161424 12.8661424,15.14 12.59,15.14 C12.4658244,15.1387616 12.3471853,15.0884299 12.26,15 L12.26,15.45 L11.26,15.45 L11.26,7.9 L10.38,8.81 C10.2521327,8.91651107 10.0955093,8.98264096 9.93,9 C9.75757471,8.99456345 9.59492163,8.91865868 9.48,8.79 L7.28,6.55 C6.61920845,6.6977857 6.00674766,7.01089768 5.5,7.46 L3.29,9.46 L4.9,11.53 L5.9,10.63 C6.11511152,10.4417471 6.42121645,10.3985785 6.68,10.52 C6.93917421,10.6469765 7.10249662,10.9114033 7.1,11.2 L7.1,19.38 L8.5,19.38 L8.5,20.86 L6.35,20.86 C5.94521985,20.8545295 5.61996304,20.5248171 5.62,20.12 L5.62,12.79 L5.18,13.16 C5.02828235,13.2906817 4.82899648,13.3522792 4.63,13.33 C4.43053183,13.3062444 4.24966742,13.2013431 4.13,13.04 L1.71,9.79 C1.48673309,9.47905114 1.52958018,9.05058019 1.81,8.79 L4.53,6.37 C5.28866009,5.69544292 6.22007204,5.24531818 7.22,5.07 L8.56,3.74 C8.67526875,3.62024745 8.83379428,3.55179324 9,3.55 L14.48,3.55 C14.6412909,3.55178072 14.7955384,3.61634942 14.91,3.73 L16.21,5 C17.4572641,5.05640992 18.6471658,5.54013848 19.58,6.37 L22.31,8.79 Z M12.95,4.85 L10.55,4.85 L11.75,6.08 L12.95,4.85 Z M9.95,7.45 L10.6,6.75 L9,5.11 L8.31,5.8 L9.95,7.45 Z M13.6,7.45 L15.22,5.8 L14.51,5.11 L12.92,6.74 L13.6,7.45 Z"
  })));
};

var SvgComponent$58 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4 14.5V5.27403L6.93905 9.40903L6.12305 8.52803L12 3.08203L17.864 8.51603L17.049 9.39603L12.6 5.27403V14.5H11.4ZM18.4004 19.4V14H19.6004V20.6H4.40039V14H5.60039V19.4H18.4004Z"
  }));
};

var SvgComponent$59 = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M2.40002 9.40002V17.599H21.6V9.40002H2.40002ZM20.4 16.4H3.60002V10.599H5.45002V12.999H6.55002V10.599H8.45002V13.999H9.55002V10.599H11.45V12.999H12.55V10.599H14.45V13.999H15.55V10.599H17.45V12.999H18.55V10.599H20.4V16.4Z"
  }));
};

var SvgComponent$5a = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4318 5.409C17.8675 5.52292 18.2672 5.75368 18.5871 6.07334L18.5878 6.074L22.3528 9.847L18.7948 13.405V19.088H13.2448V17.988H17.6948V11.033L18.6538 11.99L20.7968 9.847L17.8078 6.85C17.6258 6.667 17.3988 6.536 17.1508 6.472L16.2398 6.232C15.6738 7.154 14.6708 7.727 13.5638 7.727C12.4568 7.727 11.4518 7.151 10.8878 6.224L9.97477 6.469C9.72977 6.535 9.50477 6.665 9.32477 6.846L7.78777 8.387L7.00977 7.61L8.54677 6.069C8.86277 5.753 9.25777 5.524 9.68977 5.407L11.4988 4.922L11.6838 5.367C12.0018 6.133 12.7408 6.628 13.5658 6.628C14.3908 6.628 15.1298 6.136 15.4488 5.375L15.6338 4.934L17.4318 5.409ZM10.5125 9.009C10.9475 9.124 11.3465 9.354 11.6645 9.673L14.3205 12.34L11.7935 14.866V19.089H4.17348V14.866L1.64648 12.34L4.30248 9.674C4.62148 9.354 5.01948 9.124 5.45448 9.009L6.50848 8.729L6.70248 9.148C6.93348 9.647 7.43548 9.969 7.98348 9.969C8.53148 9.969 9.03348 9.647 9.26448 9.148L9.45848 8.729L10.5125 9.009ZM10.6945 17.989V14.411H10.6955L12.7685 12.338L10.8875 10.449C10.7065 10.268 10.4805 10.137 10.2325 10.071L10.0275 10.017C9.56048 10.668 8.80048 11.068 7.98548 11.068C7.17048 11.068 6.41048 10.667 5.94348 10.017L5.73848 10.071C5.49048 10.138 5.26448 10.268 5.08248 10.45L3.20148 12.338L5.27448 14.411V17.989H10.6945Z"
  }));
};

var SvgComponent$5b = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1311 12.497L10.3531 11.72L7.95008 14.123V5H6.75008V14.123L4.35808 11.73L3.58008 12.508L7.35008 16.277L11.1311 12.497ZM21.2422 18.85H3.24219V20.151H21.2422V18.85ZM19.6539 11.72L20.4319 12.497L16.6509 16.277L12.8809 12.508L13.6599 11.73L16.0509 14.122V5H17.2509V14.123L19.6539 11.72Z"
  }));
};

var SvgComponent$5c = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
    transform: "translate(-88.000000, -1419.000000) translate(60.000000, 1403.000000) translate(28.000000, 16.000000)"
  }, /*#__PURE__*/createElement("polygon", {
    points: "4.52727273 24 7.34181818 14.9345455 0 9.21818182 9.12 9.21818182 12.0109091 0 14.88 9.21818182 24 9.21818182 16.68 14.9345455 19.4727273 24 12.0109091 18.3927273"
  })))))))));
};

var SvgComponent$5d = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", null, /*#__PURE__*/createElement("g", {
    transform: "translate(-188.000000, -1419.000000) translate(60.000000, 1403.000000) translate(100.000000, 0.000000) translate(28.000000, 16.000000)"
  }, /*#__PURE__*/createElement("polygon", {
    points: "12 18.3927273 12 0 9.12 9.19636364 0 9.19636364 7.34181818 14.9236364 4.52727273 24"
  }), /*#__PURE__*/createElement("polygon", {
    points: "12 18.3927273 12 0 14.88 9.19636364 24 9.19636364 16.6581818 14.9236364 19.4727273 24"
  }))))))));
};

var SvgComponent$5e = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M16.393 14.5429L23.5 9.37993H14.715L12 1.02393L9.285 9.37993H0.5L7.607 14.5429L4.893 22.8989L12 17.7349L19.107 22.8989L16.393 14.5429Z"
  }));
};

var SvgComponent$5f = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM13.4999 12.9999H10.4999V10.9999H13.4999V12.9999Z"
  }));
};

var SvgComponent$5g = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM15.7099 14.2899L14.2999 15.6999L12.0099 13.4099L9.71991 15.6999L8.30991 14.2899L10.5999 11.9999L8.30991 9.7099L9.71991 8.2999L12.0099 10.5899L14.2999 8.2999L15.7099 9.7099L13.4199 11.9999L15.7099 14.2899Z"
  }));
};

var SvgComponent$5h = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M12.0099 3.3999C7.26991 3.3999 3.40991 7.2599 3.40991 11.9999C3.40991 16.7399 7.26991 20.5999 12.0099 20.5999C16.7499 20.5999 20.6099 16.7399 20.6099 11.9999C20.6099 7.2599 16.7499 3.3999 12.0099 3.3999ZM10.8599 15.9799L7.28991 12.4199L8.69991 10.9999L10.8499 13.1499L15.2799 8.7199L16.6899 10.1299L10.8399 15.9699L10.8599 15.9799Z"
  }));
};

var SvgComponent$5i = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.90039 19.5999V5.39893H21.1004V19.5999H2.90039ZM12.5504 18.4009H16.4504V14.0489H12.5504V18.4009ZM7.54939 18.4009H11.4504V14.0489H7.54939V18.4009ZM17.5494 18.4009H19.8994L19.9004 18.4019V6.59893H4.10039V18.4009H6.45039V12.9499H17.5494V18.4009ZM15.75 8.24994H18.25V10.7499H15.75V8.24994Z"
  }));
};

var SvgComponent$5j = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M18 11.3501H6V12.6511H18V11.3501Z"
  }));
};

var SvgComponent$5k = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M18.165,10.5 L14.415,10.5 C14.6563395,9.61504089 14.8417064,8.71576104 14.97,7.8075 C15.0825,6.735 15.12,5.1375 14.52,4.4625 C14.1432567,3.97731453 13.550505,3.71043579 12.9375,3.75 C11.505,3.75 11.5392097,5.30990801 11.1117097,6.59990801 C10.9617097,7.04990801 9.375,10.4925 9.1275,10.8375 C8.94,11.025 8.2125,11.5875 7.7475,12 L3,12 L3,21.75 L16.785,21.75 C17.4953761,21.8142693 18.2009969,21.5841585 18.7369137,21.113459 C19.2728306,20.6427596 19.592068,19.9727304 19.62,19.26 C19.613535,19.0407677 19.5884447,18.8224818 19.545,18.6075 C19.8480161,18.2205054 20.0094616,17.7414622 20.0025,17.25 C20.0086957,17.0691877 19.9961285,16.8882203 19.965,16.71 C20.3605532,16.2838873 20.5802583,15.7239072 20.58,15.1425 C20.5772488,14.8907729 20.5521502,14.6397872 20.505,14.3925 C20.8191843,13.9889674 20.9929944,13.493872 21,12.9825 C21,11.565 19.815,10.5 18.165,10.5 Z M7.5,20.25 L4.5,20.25 L4.5,13.5 L7.5,13.5 L7.5,20.25 Z M19.0425,15.255 C19.0177965,15.7070735 18.7210058,16.0988373 18.2925,16.245 C18.6119843,16.5306294 18.7274978,16.9808358 18.585,17.385 C18.5083763,17.7949443 18.2244065,18.1357081 17.835,18.285 C18.1664504,18.5294344 18.2976663,18.9627521 18.1575,19.35 C18.0675,19.8 17.745,20.25 16.785,20.25 L9,20.25 L9,12.915 C9.43529065,12.5761629 10.3081461,11.3261164 10.7073305,10.9454061 C11.1829334,10.1243152 12.1962336,7.84685037 12.4425,6.9304764 C12.9248543,5.43112564 12.8079778,5.1525 12.99,5.1525 C13.9261498,5.1525 13.665,6.51 13.5525,7.62 C13.2952911,9.10628816 12.9241976,10.5706028 12.4425,12 L18.3375,12 C18.6279934,11.9708056 18.9176319,12.0630068 19.1377911,12.2547584 C19.3579503,12.44651 19.4890396,12.720749 19.5,13.0125 C19.5177103,13.5435763 19.1661612,14.0164565 18.6525,14.1525 C18.9858485,14.4128802 19.1379741,14.8429274 19.0425,15.255 Z"
  })), /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M7.49999163,12 L7.49999163,21.7461449 L9,21.7461449 L8.99999205,10.9535636 C9.05403991,10.9067711 9.09762464,10.8673754 9.1275,10.8375 C9.375,10.4925 11.1,7.0725 11.25,6.6225 C11.6775,5.3325 11.505,3.75 12.9375,3.75 C13.550505,3.71043579 14.0262737,4.28756022 14.3141545,4.81189939 C14.6776142,5.38087311 14.7488459,6.16729267 14.7125115,6.98350721 C14.7011163,7.23948823 14.6791412,7.49839979 14.6522824,7.75445349 C14.5239887,8.66271452 14.0470647,9.61118581 13.8057253,10.4961449 L18.165,10.5 C19.815,10.5 20.625,11.565 20.625,12.9825 C20.6179944,13.493872 20.4441843,13.9889674 20.13,14.3925 C20.1771502,14.6397872 20.2022488,14.8907729 20.205,15.1425 C20.2052583,15.7239072 19.9855532,16.2838873 19.59,16.71 C19.6211285,16.8882203 19.6336957,17.0691877 19.6275,17.25 C19.6344616,17.7414622 19.4730161,18.2205054 19.17,18.6075 C19.2134447,18.8224818 19.238535,19.0407677 19.245,19.26 C19.217068,19.9727304 18.8978308,20.6427596 18.361914,21.113459 C17.8259972,21.5841585 17.4953761,21.8142693 16.785,21.75 L3,21.75 L3,12 L7.49999163,12 Z"
  })));
};

var SvgComponent$5l = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 50,
    height: 50,
    viewBox: "0 0 12 12",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM2.50049 6.06781L5.37293 8.93962L5.40658 8.97327L9.49955 4.88029L8.11926 3.5L5.40626 6.213L3.88078 4.68752L2.50049 6.06781Z"
  }));
};

var SvgComponent$5m = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6844 3.40002L16.9734 7.16302H20.6004V20.6H3.40039V7.16302H7.02739L9.31639 3.40002H14.6844ZM4.60039 19.4H19.4004L19.4014 8.36202H16.2994L14.0104 4.59902H9.99139L7.70239 8.36202H4.60039V19.4ZM11.763 9.01099C13.862 9.01099 15.57 10.719 15.57 12.818L15.569 12.819C15.569 13.67 15.288 14.457 14.814 15.091L16.985 17.263L16.207 18.04L14.037 15.869C13.402 16.343 12.615 16.624 11.763 16.624C9.66503 16.624 7.95703 14.917 7.95703 12.818C7.95703 10.719 9.66403 9.01099 11.763 9.01099ZM9.05603 12.818C9.05603 14.31 10.271 15.524 11.763 15.524C13.256 15.524 14.47 14.31 14.47 12.818C14.47 11.326 13.256 10.111 11.763 10.111C10.27 10.111 9.05603 11.326 9.05603 12.818Z"
  }));
};

var SvgComponent$5n = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.40039 8.66699L12.0004 3.29199L20.6004 8.66699V19.6H3.40039V8.66699ZM8.05039 15.049V18.4H15.9504V15.049H8.05039ZM17.0504 18.4H19.4004V9.33299L12.0004 4.70799L4.60039 9.33299V18.4H6.95039V13.95H17.0504V18.4ZM7 9.90002H9.3V12.2H7V9.90002ZM13.1672 9.90002H10.8672V12.2H13.1672V9.90002ZM14.6992 9.90002H16.9992V12.2H14.6992V9.90002Z"
  }));
};

var SvgComponent$5o = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 50,
    height: 50,
    viewBox: "0 0 12 12",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6C12 9.31371 9.31371 12 6 12C2.68629 12 0 9.31371 0 6C0 2.68629 2.68629 0 6 0C9.31371 0 12 2.68629 12 6ZM2.50049 6.06781L5.37293 8.93962L5.40658 8.97327L9.49955 4.88029L8.11926 3.5L5.40626 6.213L3.88078 4.68752L2.50049 6.06781Z"
  }));
};

var SvgComponent$5p = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.272 1.67187L18.0014 6.0362L22.3839 6.0362L22.3839 22.327L1.61328 22.327L1.61328 6.0362L5.99512 6.0362L8.71672 1.67187L15.272 1.67187ZM14.4105 3.2266L9.57939 3.2266L6.85779 7.59093L3.16801 7.59093L3.16801 20.7722L20.8291 20.7722L20.8291 7.59093L17.14 7.59093L14.4105 3.2266ZM11.3237 8.27693C12.5655 8.17142 13.7743 8.55492 14.7274 9.35809L14.913 9.52297C15.7561 10.3119 16.2707 11.3703 16.3697 12.5293C16.4647 13.6429 16.1647 14.7292 15.5229 15.629L17.8582 17.9643L16.7589 19.0638L14.4232 16.7282C13.6219 17.2977 12.6718 17.5903 11.7168 17.5903C10.6547 17.5903 9.58745 17.2306 8.71359 16.4943C6.74624 14.8362 6.49448 11.8867 8.15244 9.91924C8.95561 8.96619 10.0819 8.38297 11.3237 8.27693ZM11.7258 9.81445C11.6362 9.81445 11.5462 9.81839 11.4559 9.82606C10.6279 9.89665 9.87684 10.2856 9.34139 10.9211C8.23577 12.233 8.40368 14.1998 9.71556 15.3053C11.0274 16.4112 12.9942 16.2431 14.0997 14.9312C14.6352 14.2956 14.8913 13.4895 14.8206 12.6616C14.7499 11.8335 14.361 11.0826 13.7255 10.547L13.5517 10.4105C13.0187 10.0212 12.3845 9.81445 11.7258 9.81445Z"
  }));
};

var SvgComponent$5q = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest$1(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign$1({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/createElement("path", {
    d: "M21.14,8.27 C21.3632608,8.40127015 21.5002535,8.64100742 21.5,8.9 L21.5,20.27 C21.5,20.6731679 21.1731679,21 20.77,21 L3.23,21 C2.82683213,21 2.5,20.6731679 2.5,20.27 L2.5,8.9 C2.49974651,8.64100742 2.63673924,8.40127015 2.86,8.27 L11.66,3.1 C11.8883902,2.96571375 12.1716098,2.96571375 12.4,3.1 L21.14,8.27 Z M16.73,19.54 L16.74,14.64 L7.27,14.64 L7.27,19.54 L16.73,19.54 Z M20.04,19.54 L20,9.32 L12,4.58 L4,9.32 L4,19.54 L5.84,19.54 L5.84,13.21 L18.16,13.21 L18.16,19.54 L20.04,19.54 Z M5.5,10 L9.21,10 L9.21,12 L5.5,12 L5.5,10 Z M10.14,10 L13.85,10 L13.85,12 L10.14,12 L10.14,10 Z M14.79,10 L18.5,10 L18.5,12 L14.79,12 L14.79,10 Z",
    fillRule: "nonzero"
  })));
};

var iconMap = {
  'account-sharp-32': SvgComponent,
  'account-sharp-filled-32': SvgComponent$1,
  'account': SvgComponent$2,
  'alteration': SvgComponent$3,
  'arrow-down': SvgComponent$4,
  'attention': SvgComponent$5,
  'cancel': SvgComponent$6,
  'cart': SvgComponent$7,
  'chat': SvgComponent$8,
  'check-large': SvgComponent$9,
  'check-mark': SvgComponent$a,
  'chevron-down': SvgComponent$b,
  'chevron-left': SvgComponent$c,
  'chevron-right-32': SvgComponent$d,
  'chevron-right': SvgComponent$e,
  'chevron-up': SvgComponent$f,
  'circle': SvgComponent$g,
  'close_big-resize-32': SvgComponent$h,
  'close-big': SvgComponent$i,
  'close': SvgComponent$j,
  'copy': SvgComponent$k,
  'coupon': SvgComponent$l,
  'credit-card': SvgComponent$m,
  'cross-mark': SvgComponent$n,
  'delete': SvgComponent$o,
  'download': SvgComponent$p,
  'edit': SvgComponent$q,
  'euro': SvgComponent$r,
  'external-link': SvgComponent$s,
  'eye-hide': SvgComponent$t,
  'eye-show': SvgComponent$u,
  'feature-menu': SvgComponent$v,
  'filter-opened': SvgComponent$w,
  'filter': SvgComponent$x,
  'flag-filled': SvgComponent$y,
  'flag': SvgComponent$z,
  'floor-map': SvgComponent$A,
  'gift-card': SvgComponent$B,
  'gift': SvgComponent$C,
  'global': SvgComponent$D,
  'gu-ec-account-sharp-32': SvgComponent$E,
  'gu-ec-account-sharp-filled-32': SvgComponent$F,
  'gu-ec-account': SvgComponent$G,
  'gu-ec-alteration': SvgComponent$H,
  'gu-ec-arrow-down': SvgComponent$I,
  'gu-ec-attention': SvgComponent$J,
  'gu-ec-cart': SvgComponent$K,
  'gu-ec-check-large': SvgComponent$L,
  'gu-ec-chevron-down': SvgComponent$M,
  'gu-ec-chevron-left': SvgComponent$N,
  'gu-ec-chevron-right-32': SvgComponent$O,
  'gu-ec-chevron-right': SvgComponent$P,
  'gu-ec-chevron-up': SvgComponent$Q,
  'gu-ec-close_big-resize-32': SvgComponent$R,
  'gu-ec-close-big': SvgComponent$S,
  'gu-ec-close': SvgComponent$T,
  'gu-ec-copy': SvgComponent$U,
  'gu-ec-coupon': SvgComponent$V,
  'gu-ec-credit-card': SvgComponent$W,
  'gu-ec-delete': SvgComponent$X,
  'gu-ec-download': SvgComponent$Y,
  'gu-ec-edit': SvgComponent$Z,
  'gu-ec-euro': SvgComponent$_,
  'gu-ec-external-link': SvgComponent$$,
  'gu-ec-eye-hide': SvgComponent$10,
  'gu-ec-eye-show': SvgComponent$11,
  'gu-ec-feature-menu': SvgComponent$12,
  'gu-ec-filter-opened': SvgComponent$13,
  'gu-ec-filter': SvgComponent$14,
  'gu-ec-flag-filled': SvgComponent$15,
  'gu-ec-flag': SvgComponent$16,
  'gu-ec-floor-map': SvgComponent$17,
  'gu-ec-gift-card': SvgComponent$18,
  'gu-ec-gift': SvgComponent$19,
  'gu-ec-global': SvgComponent$1a,
  'gu-ec-heart-filled': SvgComponent$1b,
  'gu-ec-heart': SvgComponent$1c,
  'gu-ec-help': SvgComponent$1d,
  'gu-ec-home-resize-32': SvgComponent$1e,
  'gu-ec-home-resize-filled-32': SvgComponent$1f,
  'gu-ec-home-v2_32': SvgComponent$1g,
  'gu-ec-home-v2-filled_32': SvgComponent$1h,
  'gu-ec-indicator-carousel': SvgComponent$1i,
  'gu-ec-information': SvgComponent$1j,
  'gu-ec-iqchat-light': SvgComponent$1k,
  'gu-ec-item': SvgComponent$1l,
  'gu-ec-location': SvgComponent$1m,
  'gu-ec-lock-locked': SvgComponent$1n,
  'gu-ec-menu': SvgComponent$1o,
  'gu-ec-minus': SvgComponent$1p,
  'gu-ec-no-video': SvgComponent$1q,
  'gu-ec-notification-resize': SvgComponent$1r,
  'gu-ec-notification': SvgComponent$1s,
  'gu-ec-o2o': SvgComponent$1t,
  'gu-ec-parking': SvgComponent$1u,
  'gu-ec-pause': SvgComponent$1v,
  'gu-ec-phone': SvgComponent$1w,
  'gu-ec-play': SvgComponent$1x,
  'gu-ec-plus': SvgComponent$1y,
  'gu-ec-product-search': SvgComponent$1z,
  'gu-ec-product': SvgComponent$1A,
  'gu-ec-prohibited': SvgComponent$1B,
  'gu-ec-quotation-end': SvgComponent$1C,
  'gu-ec-quotation-start': SvgComponent$1D,
  'gu-ec-radio-circle-checked': SvgComponent$1E,
  'gu-ec-radio-circle': SvgComponent$1F,
  'gu-ec-rise': SvgComponent$1G,
  'gu-ec-search-form': SvgComponent$1H,
  'gu-ec-search-resize-32': SvgComponent$1I,
  'gu-ec-search': SvgComponent$1J,
  'gu-ec-semi-order': SvgComponent$1K,
  'gu-ec-share': SvgComponent$1L,
  'gu-ec-size-chart': SvgComponent$1M,
  'gu-ec-size': SvgComponent$1N,
  'gu-ec-sort': SvgComponent$1O,
  'gu-ec-star-filled': SvgComponent$1P,
  'gu-ec-star-half-filled': SvgComponent$1Q,
  'gu-ec-star': SvgComponent$1R,
  'gu-ec-state-default': SvgComponent$1S,
  'gu-ec-state-ng': SvgComponent$1T,
  'gu-ec-state-ok': SvgComponent$1U,
  'gu-ec-store': SvgComponent$1V,
  'gu-ec-subtract': SvgComponent$1W,
  'gu-ec-verified-badge': SvgComponent$1X,
  'gu-ec-visual-search': SvgComponent$1Y,
  'gu-ec-warehouse': SvgComponent$1Z,
  'heart-filled': SvgComponent$1_,
  'heart': SvgComponent$1$,
  'help': SvgComponent$20,
  'home-resize-32': SvgComponent$21,
  'home-resize-filled-32': SvgComponent$22,
  'home-v2_32': SvgComponent$23,
  'home-v2-filled_32': SvgComponent$24,
  'information': SvgComponent$25,
  'iqchat-light': SvgComponent$26,
  'item': SvgComponent$27,
  'location': SvgComponent$28,
  'lock-locked': SvgComponent$29,
  'menu': SvgComponent$2a,
  'minus': SvgComponent$2b,
  'no-video': SvgComponent$2c,
  'notification-resize': SvgComponent$2d,
  'notification': SvgComponent$2e,
  'o2o': SvgComponent$2f,
  'parking': SvgComponent$2g,
  'pause': SvgComponent$2h,
  'phone': SvgComponent$2i,
  'play': SvgComponent$2j,
  'plst-ec-account-sharp-32': SvgComponent$2k,
  'plst-ec-account-sharp-filled-32': SvgComponent$2l,
  'plst-ec-account': SvgComponent$2m,
  'plst-ec-alteration': SvgComponent$2n,
  'plst-ec-arrow-down': SvgComponent$2o,
  'plst-ec-attention': SvgComponent$2p,
  'plst-ec-cancel': SvgComponent$2q,
  'plst-ec-cart': SvgComponent$2r,
  'plst-ec-check-large': SvgComponent$2s,
  'plst-ec-chevron-down': SvgComponent$2t,
  'plst-ec-chevron-left': SvgComponent$2u,
  'plst-ec-chevron-right-32': SvgComponent$2v,
  'plst-ec-chevron-right': SvgComponent$2w,
  'plst-ec-chevron-up': SvgComponent$2x,
  'plst-ec-close_big-resize-32': SvgComponent$2y,
  'plst-ec-close-big': SvgComponent$2z,
  'plst-ec-close': SvgComponent$2A,
  'plst-ec-copy': SvgComponent$2B,
  'plst-ec-coupon': SvgComponent$2C,
  'plst-ec-delete': SvgComponent$2D,
  'plst-ec-download': SvgComponent$2E,
  'plst-ec-edit': SvgComponent$2F,
  'plst-ec-euro': SvgComponent$2G,
  'plst-ec-external-link': SvgComponent$2H,
  'plst-ec-eye-hide': SvgComponent$2I,
  'plst-ec-eye-show': SvgComponent$2J,
  'plst-ec-feature-menu': SvgComponent$2K,
  'plst-ec-filter-opened': SvgComponent$2L,
  'plst-ec-filter': SvgComponent$2M,
  'plst-ec-flag-filled': SvgComponent$2N,
  'plst-ec-flag': SvgComponent$2O,
  'plst-ec-floor-map': SvgComponent$2P,
  'plst-ec-gift-card': SvgComponent$2Q,
  'plst-ec-gift': SvgComponent$2R,
  'plst-ec-global': SvgComponent$2S,
  'plst-ec-heart-filled': SvgComponent$2T,
  'plst-ec-heart': SvgComponent$2U,
  'plst-ec-help': SvgComponent$2V,
  'plst-ec-home-resize-32': SvgComponent$2W,
  'plst-ec-home-resize-filled-32': SvgComponent$2X,
  'plst-ec-indicator-carousel': SvgComponent$2Y,
  'plst-ec-information': SvgComponent$2Z,
  'plst-ec-iqchat-light': SvgComponent$2_,
  'plst-ec-item': SvgComponent$2$,
  'plst-ec-list-disc': SvgComponent$30,
  'plst-ec-location': SvgComponent$31,
  'plst-ec-lock-locked': SvgComponent$32,
  'plst-ec-menu': SvgComponent$33,
  'plst-ec-minus': SvgComponent$34,
  'plst-ec-no-video': SvgComponent$35,
  'plst-ec-notification-resize': SvgComponent$36,
  'plst-ec-notification': SvgComponent$37,
  'plst-ec-parking': SvgComponent$38,
  'plst-ec-pause': SvgComponent$39,
  'plst-ec-phone': SvgComponent$3a,
  'plst-ec-play': SvgComponent$3b,
  'plst-ec-plus': SvgComponent$3c,
  'plst-ec-product-search': SvgComponent$3d,
  'plst-ec-product': SvgComponent$3e,
  'plst-ec-prohibited': SvgComponent$3f,
  'plst-ec-quotation-end': SvgComponent$3g,
  'plst-ec-quotation-start': SvgComponent$3h,
  'plst-ec-radio-circle-checked': SvgComponent$3i,
  'plst-ec-radio-circle': SvgComponent$3j,
  'plst-ec-rise': SvgComponent$3k,
  'plst-ec-search-resize-32': SvgComponent$3l,
  'plst-ec-search': SvgComponent$3m,
  'plst-ec-semi-order': SvgComponent$3n,
  'plst-ec-share': SvgComponent$3o,
  'plst-ec-size-chart': SvgComponent$3p,
  'plst-ec-size': SvgComponent$3q,
  'plst-ec-sort': SvgComponent$3r,
  'plst-ec-star-filled': SvgComponent$3s,
  'plst-ec-star-half-filled': SvgComponent$3t,
  'plst-ec-star': SvgComponent$3u,
  'plst-ec-state-default': SvgComponent$3v,
  'plst-ec-state-ng': SvgComponent$3w,
  'plst-ec-state-ok': SvgComponent$3x,
  'plst-ec-store': SvgComponent$3y,
  'plst-ec-subtract': SvgComponent$3z,
  'plst-ec-verified-badge': SvgComponent$3A,
  'plst-ec-visual-search': SvgComponent$3B,
  'plst-ec-warehouse': SvgComponent$3C,
  'plus': SvgComponent$3D,
  'product-search': SvgComponent$3E,
  'product': SvgComponent$3F,
  'prohibited': SvgComponent$3G,
  'question': SvgComponent$3H,
  'quotation-end': SvgComponent$3I,
  'quotation-start': SvgComponent$3J,
  'rise': SvgComponent$3K,
  'search-form': SvgComponent$3L,
  'search-resize-32': SvgComponent$3M,
  'search': SvgComponent$3N,
  'semi-order': SvgComponent$3O,
  'share': SvgComponent$3P,
  'size-chart': SvgComponent$3Q,
  'size': SvgComponent$3R,
  'sort': SvgComponent$3S,
  'star-filled': SvgComponent$3T,
  'star-half-filled': SvgComponent$3U,
  'star': SvgComponent$3V,
  'state-default': SvgComponent$3W,
  'state-ng': SvgComponent$3X,
  'state-ok': SvgComponent$3Y,
  'store': SvgComponent$3Z,
  'subtract': SvgComponent$3_,
  'thumbs-up-toggle': SvgComponent$3$,
  'uq-ec-account-sharp-32': SvgComponent$40,
  'uq-ec-account-sharp-filled-32': SvgComponent$41,
  'uq-ec-account': SvgComponent$42,
  'uq-ec-alteration': SvgComponent$43,
  'uq-ec-arrow-down': SvgComponent$44,
  'uq-ec-attention': SvgComponent$45,
  'uq-ec-cancel': SvgComponent$46,
  'uq-ec-cart': SvgComponent$47,
  'uq-ec-chat': SvgComponent$48,
  'uq-ec-check-large': SvgComponent$49,
  'uq-ec-check-mark': SvgComponent$4a,
  'uq-ec-chevron-down': SvgComponent$4b,
  'uq-ec-chevron-left': SvgComponent$4c,
  'uq-ec-chevron-right-32': SvgComponent$4d,
  'uq-ec-chevron-right': SvgComponent$4e,
  'uq-ec-chevron-up': SvgComponent$4f,
  'uq-ec-circle': SvgComponent$4g,
  'uq-ec-close_big-resize-32': SvgComponent$4h,
  'uq-ec-close-big': SvgComponent$4i,
  'uq-ec-close': SvgComponent$4j,
  'uq-ec-copy': SvgComponent$4k,
  'uq-ec-coupon': SvgComponent$4l,
  'uq-ec-credit-card': SvgComponent$4m,
  'uq-ec-cross-mark': SvgComponent$4n,
  'uq-ec-delete': SvgComponent$4o,
  'uq-ec-download': SvgComponent$4p,
  'uq-ec-edit': SvgComponent$4q,
  'uq-ec-euro': SvgComponent$4r,
  'uq-ec-external-link': SvgComponent$4s,
  'uq-ec-eye-hide': SvgComponent$4t,
  'uq-ec-eye-show': SvgComponent$4u,
  'uq-ec-feature-menu': SvgComponent$4v,
  'uq-ec-filter-opened': SvgComponent$4w,
  'uq-ec-filter': SvgComponent$4x,
  'uq-ec-flag-filled': SvgComponent$4y,
  'uq-ec-flag': SvgComponent$4z,
  'uq-ec-floor-map': SvgComponent$4A,
  'uq-ec-gift-card': SvgComponent$4B,
  'uq-ec-gift': SvgComponent$4C,
  'uq-ec-global': SvgComponent$4D,
  'uq-ec-heart-filled': SvgComponent$4E,
  'uq-ec-heart': SvgComponent$4F,
  'uq-ec-help': SvgComponent$4G,
  'uq-ec-home-resize-32': SvgComponent$4H,
  'uq-ec-home-resize-filled-32': SvgComponent$4I,
  'uq-ec-home-v2_32': SvgComponent$4J,
  'uq-ec-home-v2-filled_32': SvgComponent$4K,
  'uq-ec-information': SvgComponent$4L,
  'uq-ec-iqchat-light': SvgComponent$4M,
  'uq-ec-item': SvgComponent$4N,
  'uq-ec-location': SvgComponent$4O,
  'uq-ec-lock-locked': SvgComponent$4P,
  'uq-ec-menu': SvgComponent$4Q,
  'uq-ec-minus': SvgComponent$4R,
  'uq-ec-no-video': SvgComponent$4S,
  'uq-ec-notification-resize': SvgComponent$4T,
  'uq-ec-notification': SvgComponent$4U,
  'uq-ec-o2o': SvgComponent$4V,
  'uq-ec-parking': SvgComponent$4W,
  'uq-ec-pause': SvgComponent$4X,
  'uq-ec-phone': SvgComponent$4Y,
  'uq-ec-play': SvgComponent$4Z,
  'uq-ec-plus': SvgComponent$4_,
  'uq-ec-product-search': SvgComponent$4$,
  'uq-ec-product': SvgComponent$50,
  'uq-ec-prohibited': SvgComponent$51,
  'uq-ec-quotation-end': SvgComponent$52,
  'uq-ec-quotation-start': SvgComponent$53,
  'uq-ec-rise': SvgComponent$54,
  'uq-ec-search-resize-32': SvgComponent$55,
  'uq-ec-search': SvgComponent$56,
  'uq-ec-semi-order': SvgComponent$57,
  'uq-ec-share': SvgComponent$58,
  'uq-ec-size-chart': SvgComponent$59,
  'uq-ec-size': SvgComponent$5a,
  'uq-ec-sort': SvgComponent$5b,
  'uq-ec-star-filled': SvgComponent$5c,
  'uq-ec-star-half-filled': SvgComponent$5d,
  'uq-ec-star': SvgComponent$5e,
  'uq-ec-state-default': SvgComponent$5f,
  'uq-ec-state-ng': SvgComponent$5g,
  'uq-ec-state-ok': SvgComponent$5h,
  'uq-ec-store': SvgComponent$5i,
  'uq-ec-subtract': SvgComponent$5j,
  'uq-ec-thumbs-up-toggle': SvgComponent$5k,
  'uq-ec-verified-badge': SvgComponent$5l,
  'uq-ec-visual-search': SvgComponent$5m,
  'uq-ec-warehouse': SvgComponent$5n,
  'verified-badge': SvgComponent$5o,
  'visual-search': SvgComponent$5p,
  'warehouse': SvgComponent$5q
};

var styles$2 = {"icon":"fr-ec-icon","icon--default":"fr-ec-icon--default","iconDefault":"fr-ec-icon--default","icon--inline":"fr-ec-icon--inline","iconInline":"fr-ec-icon--inline","icon--fill":"fr-ec-icon--fill","iconFill":"fr-ec-icon--fill","icon--dot":"fr-ec-icon--dot","iconDot":"fr-ec-icon--dot"};

var Icon = /** @class */function (_super) {
  __extends(Icon, _super);
  function Icon(props) {
    var _this = _super.call(this, props) || this;
    _this.setDynamicIcons = function (iconName) {
      var size = _this.props.size;
      if (size && parseInt(size, 0) >= 28) {
        switch (iconName) {
          case 'close-big':
            return 'close_big-resize-32';
          case 'notification':
            return 'notification-resize';
          case 'search':
            return 'search-resize-32';
          case 'chevron-right':
            return 'chevron-right-32';
          default:
            return iconName;
        }
      }
      return iconName;
    };
    return _this;
  }
  Icon.prototype.render = function () {
    var _a = this.props,
      _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      size = _a.size,
      className = _a.className,
      _c = _a.title,
      title = _c === void 0 ? '' : _c,
      showRedDot = _a.showRedDot,
      color = _a.color,
      name = _a.name;
    var dynamicIconName = this.setDynamicIcons(name);
    var iconExists = typeof iconMap[dynamicIconName] === 'function';
    if (!iconExists) {
      var fallbackElement = /*#__PURE__*/createElement("span", {
        className: joinClasses(styles$2.icon, styles$2["icon--".concat(variant)], className)
      });
      if (!showRedDot) {
        return fallbackElement;
      }
      return /*#__PURE__*/createElement("div", {
        className: styles$2.iconDot
      }, fallbackElement, showRedDot && /*#__PURE__*/createElement(Badge, {
        variant: "dot",
        content: 1
      }));
    }
    var IconComponent = iconMap[dynamicIconName];
    var sizeStyles = size ? {
      width: size,
      height: size
    } : undefined;
    var colorStyles = color ? {
      fill: color
    } : undefined;
    var iconStyles = __assign$1(__assign$1({}, sizeStyles), colorStyles);
    var IconComp = /*#__PURE__*/createElement(IconComponent, {
      className: joinClasses(styles$2.icon, styles$2["icon--".concat(variant)], className),
      style: iconStyles,
      title: title,
      role: title === '' ? 'presentation' : undefined
    });
    if (!showRedDot) {
      return IconComp;
    }
    return /*#__PURE__*/createElement("div", {
      className: styles$2.iconDot
    }, IconComp, showRedDot && /*#__PURE__*/createElement(Badge, {
      variant: "dot",
      content: 1
    }));
  };
  Icon.displayName = 'CoreIcon';
  Icon.defaultProps = {
    title: '',
    variant: 'default'
  };
  return Icon;
}(Component);

var styles$1$1 = {"badge":"fr-ec-badge","badge--icon-container":"fr-ec-badge--icon-container","badgeIconContainer":"fr-ec-badge--icon-container","badge__icon":"fr-ec-badge__icon","badgeIcon":"fr-ec-badge__icon","badge--dot":"fr-ec-badge--dot","badgeDot":"fr-ec-badge--dot"};

var Badge = function Badge(_a) {
  var content = _a.content,
    _b = _a.className,
    className = _b === void 0 ? '' : _b,
    iconBrand = _a.iconBrand,
    _c = _a.variant,
    variant = _c === void 0 ? "numeric" : _c,
    props = __rest$1(_a, ["content", "className", "iconBrand", "variant"]);
  var children = '';
  if (typeof content === 'number') {
    children = /*#__PURE__*/createElement(BadgeText, {
      element: "span",
      variant: "small",
      color: "primary-light"
    }, content > 999 ? '999+' : content);
  } else if (typeof content === 'string') {
    children = /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand).concat(content) : content,
      variant: "inline",
      className: styles$1$1.badgeIcon
    });
  }
  var badgeClassName = typeof content === 'string' ? styles$1$1.badgeIconContainer : '';
  var isDot = variant === 'dot';
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$1$1.badge, badgeClassName, isDot && styles$1$1.badgeDot, className)
  }, props), !isDot && children);
};
Badge.displayName = 'CoreBadge';

var spacingStyles = {"mb-spacing-01":"fr-ec-mb-spacing-01","mbSpacing01":"fr-ec-mb-spacing-01","mb-spacing-02":"fr-ec-mb-spacing-02","mbSpacing02":"fr-ec-mb-spacing-02","mb-spacing-03":"fr-ec-mb-spacing-03","mbSpacing03":"fr-ec-mb-spacing-03","mb-spacing-04":"fr-ec-mb-spacing-04","mbSpacing04":"fr-ec-mb-spacing-04","mb-spacing-05":"fr-ec-mb-spacing-05","mbSpacing05":"fr-ec-mb-spacing-05","mb-spacing-06":"fr-ec-mb-spacing-06","mbSpacing06":"fr-ec-mb-spacing-06","mb-spacing-07":"fr-ec-mb-spacing-07","mbSpacing07":"fr-ec-mb-spacing-07","mb-spacing-08":"fr-ec-mb-spacing-08","mbSpacing08":"fr-ec-mb-spacing-08","mb-spacing-01-sm":"fr-ec-mb-spacing-01-sm","mbSpacing01Sm":"fr-ec-mb-spacing-01-sm","mb-spacing-02-sm":"fr-ec-mb-spacing-02-sm","mbSpacing02Sm":"fr-ec-mb-spacing-02-sm","mb-spacing-03-sm":"fr-ec-mb-spacing-03-sm","mbSpacing03Sm":"fr-ec-mb-spacing-03-sm","mb-spacing-04-sm":"fr-ec-mb-spacing-04-sm","mbSpacing04Sm":"fr-ec-mb-spacing-04-sm","mb-spacing-05-sm":"fr-ec-mb-spacing-05-sm","mbSpacing05Sm":"fr-ec-mb-spacing-05-sm","mb-spacing-06-sm":"fr-ec-mb-spacing-06-sm","mbSpacing06Sm":"fr-ec-mb-spacing-06-sm","mb-spacing-07-sm":"fr-ec-mb-spacing-07-sm","mbSpacing07Sm":"fr-ec-mb-spacing-07-sm","mb-spacing-08-sm":"fr-ec-mb-spacing-08-sm","mbSpacing08Sm":"fr-ec-mb-spacing-08-sm","mb-spacing-01-md":"fr-ec-mb-spacing-01-md","mbSpacing01Md":"fr-ec-mb-spacing-01-md","mb-spacing-02-md":"fr-ec-mb-spacing-02-md","mbSpacing02Md":"fr-ec-mb-spacing-02-md","mb-spacing-03-md":"fr-ec-mb-spacing-03-md","mbSpacing03Md":"fr-ec-mb-spacing-03-md","mb-spacing-04-md":"fr-ec-mb-spacing-04-md","mbSpacing04Md":"fr-ec-mb-spacing-04-md","mb-spacing-05-md":"fr-ec-mb-spacing-05-md","mbSpacing05Md":"fr-ec-mb-spacing-05-md","mb-spacing-06-md":"fr-ec-mb-spacing-06-md","mbSpacing06Md":"fr-ec-mb-spacing-06-md","mb-spacing-07-md":"fr-ec-mb-spacing-07-md","mbSpacing07Md":"fr-ec-mb-spacing-07-md","mb-spacing-08-md":"fr-ec-mb-spacing-08-md","mbSpacing08Md":"fr-ec-mb-spacing-08-md","mb-spacing-01-lg":"fr-ec-mb-spacing-01-lg","mbSpacing01Lg":"fr-ec-mb-spacing-01-lg","mb-spacing-02-lg":"fr-ec-mb-spacing-02-lg","mbSpacing02Lg":"fr-ec-mb-spacing-02-lg","mb-spacing-03-lg":"fr-ec-mb-spacing-03-lg","mbSpacing03Lg":"fr-ec-mb-spacing-03-lg","mb-spacing-04-lg":"fr-ec-mb-spacing-04-lg","mbSpacing04Lg":"fr-ec-mb-spacing-04-lg","mb-spacing-05-lg":"fr-ec-mb-spacing-05-lg","mbSpacing05Lg":"fr-ec-mb-spacing-05-lg","mb-spacing-06-lg":"fr-ec-mb-spacing-06-lg","mbSpacing06Lg":"fr-ec-mb-spacing-06-lg","mb-spacing-07-lg":"fr-ec-mb-spacing-07-lg","mbSpacing07Lg":"fr-ec-mb-spacing-07-lg","mb-spacing-08-lg":"fr-ec-mb-spacing-08-lg","mbSpacing08Lg":"fr-ec-mb-spacing-08-lg","mt-spacing-01":"fr-ec-mt-spacing-01","mtSpacing01":"fr-ec-mt-spacing-01","mt-spacing-02":"fr-ec-mt-spacing-02","mtSpacing02":"fr-ec-mt-spacing-02","mt-spacing-03":"fr-ec-mt-spacing-03","mtSpacing03":"fr-ec-mt-spacing-03","mt-spacing-04":"fr-ec-mt-spacing-04","mtSpacing04":"fr-ec-mt-spacing-04","mt-spacing-05":"fr-ec-mt-spacing-05","mtSpacing05":"fr-ec-mt-spacing-05","mt-spacing-06":"fr-ec-mt-spacing-06","mtSpacing06":"fr-ec-mt-spacing-06","mt-spacing-07":"fr-ec-mt-spacing-07","mtSpacing07":"fr-ec-mt-spacing-07","mt-spacing-08":"fr-ec-mt-spacing-08","mtSpacing08":"fr-ec-mt-spacing-08","mt-spacing-01-sm":"fr-ec-mt-spacing-01-sm","mtSpacing01Sm":"fr-ec-mt-spacing-01-sm","mt-spacing-02-sm":"fr-ec-mt-spacing-02-sm","mtSpacing02Sm":"fr-ec-mt-spacing-02-sm","mt-spacing-03-sm":"fr-ec-mt-spacing-03-sm","mtSpacing03Sm":"fr-ec-mt-spacing-03-sm","mt-spacing-04-sm":"fr-ec-mt-spacing-04-sm","mtSpacing04Sm":"fr-ec-mt-spacing-04-sm","mt-spacing-05-sm":"fr-ec-mt-spacing-05-sm","mtSpacing05Sm":"fr-ec-mt-spacing-05-sm","mt-spacing-06-sm":"fr-ec-mt-spacing-06-sm","mtSpacing06Sm":"fr-ec-mt-spacing-06-sm","mt-spacing-07-sm":"fr-ec-mt-spacing-07-sm","mtSpacing07Sm":"fr-ec-mt-spacing-07-sm","mt-spacing-08-sm":"fr-ec-mt-spacing-08-sm","mtSpacing08Sm":"fr-ec-mt-spacing-08-sm","mt-spacing-01-md":"fr-ec-mt-spacing-01-md","mtSpacing01Md":"fr-ec-mt-spacing-01-md","mt-spacing-02-md":"fr-ec-mt-spacing-02-md","mtSpacing02Md":"fr-ec-mt-spacing-02-md","mt-spacing-03-md":"fr-ec-mt-spacing-03-md","mtSpacing03Md":"fr-ec-mt-spacing-03-md","mt-spacing-04-md":"fr-ec-mt-spacing-04-md","mtSpacing04Md":"fr-ec-mt-spacing-04-md","mt-spacing-05-md":"fr-ec-mt-spacing-05-md","mtSpacing05Md":"fr-ec-mt-spacing-05-md","mt-spacing-06-md":"fr-ec-mt-spacing-06-md","mtSpacing06Md":"fr-ec-mt-spacing-06-md","mt-spacing-07-md":"fr-ec-mt-spacing-07-md","mtSpacing07Md":"fr-ec-mt-spacing-07-md","mt-spacing-08-md":"fr-ec-mt-spacing-08-md","mtSpacing08Md":"fr-ec-mt-spacing-08-md","mt-spacing-01-lg":"fr-ec-mt-spacing-01-lg","mtSpacing01Lg":"fr-ec-mt-spacing-01-lg","mt-spacing-02-lg":"fr-ec-mt-spacing-02-lg","mtSpacing02Lg":"fr-ec-mt-spacing-02-lg","mt-spacing-03-lg":"fr-ec-mt-spacing-03-lg","mtSpacing03Lg":"fr-ec-mt-spacing-03-lg","mt-spacing-04-lg":"fr-ec-mt-spacing-04-lg","mtSpacing04Lg":"fr-ec-mt-spacing-04-lg","mt-spacing-05-lg":"fr-ec-mt-spacing-05-lg","mtSpacing05Lg":"fr-ec-mt-spacing-05-lg","mt-spacing-06-lg":"fr-ec-mt-spacing-06-lg","mtSpacing06Lg":"fr-ec-mt-spacing-06-lg","mt-spacing-07-lg":"fr-ec-mt-spacing-07-lg","mtSpacing07Lg":"fr-ec-mt-spacing-07-lg","mt-spacing-08-lg":"fr-ec-mt-spacing-08-lg","mtSpacing08Lg":"fr-ec-mt-spacing-08-lg"};

var styles$3 = {"content-alignment":"fr-ec-content-alignment","contentAlignment":"fr-ec-content-alignment","content-alignment--direction-row":"fr-ec-content-alignment--direction-row","contentAlignmentDirectionRow":"fr-ec-content-alignment--direction-row","content-alignment--direction-column":"fr-ec-content-alignment--direction-column","contentAlignmentDirectionColumn":"fr-ec-content-alignment--direction-column","content-alignment--content-flex-start":"fr-ec-content-alignment--content-flex-start","contentAlignmentContentFlexStart":"fr-ec-content-alignment--content-flex-start","content-alignment--content-flex-end":"fr-ec-content-alignment--content-flex-end","contentAlignmentContentFlexEnd":"fr-ec-content-alignment--content-flex-end","content-alignment--content-space-between":"fr-ec-content-alignment--content-space-between","contentAlignmentContentSpaceBetween":"fr-ec-content-alignment--content-space-between","content-alignment--content-center":"fr-ec-content-alignment--content-center","contentAlignmentContentCenter":"fr-ec-content-alignment--content-center","content-alignment--alignment-flex-start":"fr-ec-content-alignment--alignment-flex-start","contentAlignmentAlignmentFlexStart":"fr-ec-content-alignment--alignment-flex-start","content-alignment--alignment-flex-end":"fr-ec-content-alignment--alignment-flex-end","contentAlignmentAlignmentFlexEnd":"fr-ec-content-alignment--alignment-flex-end","content-alignment--alignment-center":"fr-ec-content-alignment--alignment-center","contentAlignmentAlignmentCenter":"fr-ec-content-alignment--alignment-center","content-alignment--alignment-stretch":"fr-ec-content-alignment--alignment-stretch","contentAlignmentAlignmentStretch":"fr-ec-content-alignment--alignment-stretch","content-alignment--alignment-baseline":"fr-ec-content-alignment--alignment-baseline","contentAlignmentAlignmentBaseline":"fr-ec-content-alignment--alignment-baseline","content-alignment--fluid-height":"fr-ec-content-alignment--fluid-height","contentAlignmentFluidHeight":"fr-ec-content-alignment--fluid-height","content-alignment--gap-4":"fr-ec-content-alignment--gap-4","contentAlignmentGap4":"fr-ec-content-alignment--gap-4","content-alignment--gap-8":"fr-ec-content-alignment--gap-8","contentAlignmentGap8":"fr-ec-content-alignment--gap-8","content-alignment--gap-16":"fr-ec-content-alignment--gap-16","contentAlignmentGap16":"fr-ec-content-alignment--gap-16","content-alignment--gap-32":"fr-ec-content-alignment--gap-32","contentAlignmentGap32":"fr-ec-content-alignment--gap-32"};

var ContentAlignment = function ContentAlignment(_a) {
  var Element = _a.element,
    direction = _a.direction,
    _b = _a.justifyContent,
    justifyContent = _b === void 0 ? 'flex-start' : _b,
    _c = _a.alignment,
    alignment = _c === void 0 ? 'stretch' : _c,
    className = _a.className,
    children = _a.children,
    _d = _a.fluidHeight,
    fluidHeight = _d === void 0 ? false : _d,
    gap = _a.gap,
    props = __rest$1(_a, ["element", "direction", "justifyContent", "alignment", "className", "children", "fluidHeight", "gap"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$3.contentAlignment, styles$3["content-alignment--direction-".concat(direction)], styles$3["content-alignment--content-".concat(justifyContent)], styles$3["content-alignment--alignment-".concat(alignment)], fluidHeight && styles$3.contentAlignmentFluidHeight, gap && styles$3["content-alignment--gap-".concat(gap)], className)
    }, props), children)
  );
};
ContentAlignment.displayName = 'CoreContentAlignment';
ContentAlignment.defaultProps = {
  alignment: 'stretch',
  fluidHeight: false,
  justifyContent: 'flex-start'
};

var textAlignStyles = {"text-align-center":"fr-ec-text-align-center","textAlignCenter":"fr-ec-text-align-center","text-align-left":"fr-ec-text-align-left","textAlignLeft":"fr-ec-text-align-left","text-align-right":"fr-ec-text-align-right","textAlignRight":"fr-ec-text-align-right"};

var textTransformStyles = {"text-transform-all-caps":"fr-ec-text-transform-all-caps","textTransformAllCaps":"fr-ec-text-transform-all-caps","text-transform-normal":"fr-ec-text-transform-normal","textTransformNormal":"fr-ec-text-transform-normal"};

var typographyStyles = {"body--standard":"fr-ec-body--standard","bodyStandard":"fr-ec-body--standard","body--standard-emphasized":"fr-ec-body--standard-emphasized","bodyStandardEmphasized":"fr-ec-body--standard-emphasized","body--small":"fr-ec-body--small","bodySmall":"fr-ec-body--small","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","body--small-emphasized":"fr-ec-body--small-emphasized","bodySmallEmphasized":"fr-ec-body--small-emphasized","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","body--extra-small":"fr-ec-body--extra-small","bodyExtraSmall":"fr-ec-body--extra-small","display--display1":"fr-ec-display--display1","displayDisplay1":"fr-ec-display--display1","display--display2":"fr-ec-display--display2","displayDisplay2":"fr-ec-display--display2","display--display3":"fr-ec-display--display3","displayDisplay3":"fr-ec-display--display3","display--display4":"fr-ec-display--display4","displayDisplay4":"fr-ec-display--display4","display--display5":"fr-ec-display--display5","displayDisplay5":"fr-ec-display--display5","display--display1-er":"fr-ec-display--display1-er","displayDisplay1Er":"fr-ec-display--display1-er","display--display1-media-banner-title":"fr-ec-display--display1-media-banner-title","displayDisplay1MediaBannerTitle":"fr-ec-display--display1-media-banner-title","label--large":"fr-ec-label--large","labelLarge":"fr-ec-label--large","label--standard":"fr-ec-label--standard","labelStandard":"fr-ec-label--standard","label--standard-emphasized":"fr-ec-label--standard-emphasized","labelStandardEmphasized":"fr-ec-label--standard-emphasized","label--small":"fr-ec-label--small","labelSmall":"fr-ec-label--small","label--small-emphasized":"fr-ec-label--small-emphasized","labelSmallEmphasized":"fr-ec-label--small-emphasized","label--extra-small":"fr-ec-label--extra-small","labelExtraSmall":"fr-ec-label--extra-small","strikethrough":"fr-ec-strikethrough","title--large":"fr-ec-title--large","titleLarge":"fr-ec-title--large","title--large-underlined":"fr-ec-title--large-underlined","titleLargeUnderlined":"fr-ec-title--large-underlined","title--large-emphasized":"fr-ec-title--large-emphasized","titleLargeEmphasized":"fr-ec-title--large-emphasized","title--standard":"fr-ec-title--standard","titleStandard":"fr-ec-title--standard","title--standard-emphasized":"fr-ec-title--standard-emphasized","titleStandardEmphasized":"fr-ec-title--standard-emphasized","title--small":"fr-ec-title--small","titleSmall":"fr-ec-title--small","title--small-emphasized":"fr-ec-title--small-emphasized","titleSmallEmphasized":"fr-ec-title--small-emphasized","title--media-banner-product-name":"fr-ec-title--media-banner-product-name","titleMediaBannerProductName":"fr-ec-title--media-banner-product-name","title--media-banner-category-name":"fr-ec-title--media-banner-category-name","titleMediaBannerCategoryName":"fr-ec-title--media-banner-category-name","title--product-tile":"fr-ec-title--product-tile","titleProductTile":"fr-ec-title--product-tile","title--product-tile-horizontal":"fr-ec-title--product-tile-horizontal","titleProductTileHorizontal":"fr-ec-title--product-tile-horizontal","flag--large":"fr-ec-flag--large","flagLarge":"fr-ec-flag--large","flag--standard":"fr-ec-flag--standard","flagStandard":"fr-ec-flag--standard","flag--product-tile":"fr-ec-flag--product-tile","flagProductTile":"fr-ec-flag--product-tile","caption--standard":"fr-ec-caption--standard","captionStandard":"fr-ec-caption--standard","caption--emphasized":"fr-ec-caption--emphasized","captionEmphasized":"fr-ec-caption--emphasized","caption--media-banner-copyright":"fr-ec-caption--media-banner-copyright","captionMediaBannerCopyright":"fr-ec-caption--media-banner-copyright","caption--small":"fr-ec-caption--small","captionSmall":"fr-ec-caption--small","caption--extra-small":"fr-ec-caption--extra-small","captionExtraSmall":"fr-ec-caption--extra-small","caption--large":"fr-ec-caption--large","captionLarge":"fr-ec-caption--large","button--large":"fr-ec-button--large","buttonLarge":"fr-ec-button--large","button--small":"fr-ec-button--small","buttonSmall":"fr-ec-button--small","button--emphasized":"fr-ec-button--emphasized","buttonEmphasized":"fr-ec-button--emphasized","button--small-emphasized":"fr-ec-button--small-emphasized","buttonSmallEmphasized":"fr-ec-button--small-emphasized","breadcrumb--standard":"fr-ec-breadcrumb--standard","breadcrumbStandard":"fr-ec-breadcrumb--standard","breadcrumb--underlined":"fr-ec-breadcrumb--underlined","breadcrumbUnderlined":"fr-ec-breadcrumb--underlined","hint-text--standard":"fr-ec-hint-text--standard","hintTextStandard":"fr-ec-hint-text--standard","tab--standard":"fr-ec-tab--standard","tabStandard":"fr-ec-tab--standard","tab--small":"fr-ec-tab--small","tabSmall":"fr-ec-tab--small","form--text":"fr-ec-form--text","formText":"fr-ec-form--text","gender--standard":"fr-ec-gender--standard","genderStandard":"fr-ec-gender--standard","gender--small":"fr-ec-gender--small","genderSmall":"fr-ec-gender--small","chip--standard":"fr-ec-chip--standard","chipStandard":"fr-ec-chip--standard","rating-average":"fr-ec-rating-average","ratingAverage":"fr-ec-rating-average","rating-average-product-tile":"fr-ec-rating-average-product-tile","ratingAverageProductTile":"fr-ec-rating-average-product-tile","rating-count-product-tile":"fr-ec-rating-count-product-tile","ratingCountProductTile":"fr-ec-rating-count-product-tile","pill-form--standard":"fr-ec-pill-form--standard","pillFormStandard":"fr-ec-pill-form--standard","pill-form--emphasized":"fr-ec-pill-form--emphasized","pillFormEmphasized":"fr-ec-pill-form--emphasized","class-item":"fr-ec-class-item","classItem":"fr-ec-class-item"};

var styles$4 = {"show-for-sr":"fr-ec-show-for-sr","showForSr":"fr-ec-show-for-sr","add-word-break":"fr-ec-add-word-break","addWordBreak":"fr-ec-add-word-break","page-wrapper":"fr-ec-page-wrapper","pageWrapper":"fr-ec-page-wrapper","page-wrapper__first-child":"fr-ec-page-wrapper__first-child","pageWrapperFirstChild":"fr-ec-page-wrapper__first-child"};

var addWordBreak = function addWordBreak(isTrue) {
  return isTrue ? styles$4.addWordBreak : '';
};

var bodyStyles = {"body":"fr-ec-body","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","body--color-placeholder":"fr-ec-body--color-placeholder","bodyColorPlaceholder":"fr-ec-body--color-placeholder","body--color-disabled":"fr-ec-body--color-disabled","bodyColorDisabled":"fr-ec-body--color-disabled","body--color-error":"fr-ec-body--color-error","bodyColorError":"fr-ec-body--color-error","body--color-primary-dark":"fr-ec-body--color-primary-dark","bodyColorPrimaryDark":"fr-ec-body--color-primary-dark","body--color-promotional":"fr-ec-body--color-promotional","bodyColorPromotional":"fr-ec-body--color-promotional","body--color-secondary":"fr-ec-body--color-secondary","bodyColorSecondary":"fr-ec-body--color-secondary"};

var testId = {
  'data-testid': 'CoreBody'
};
var bodyStyles$1 = {
  small: 'bodySmall',
  'small-emphasized': 'bodySmallEmphasized',
  'small-underlined': 'bodySmallUnderlined',
  standard: 'bodyStandard',
  'standard-emphasized': 'bodyStandardEmphasized',
  underlined: 'bodyUnderlined',
  'extra-small': 'bodyExtraSmall'
};
var alignmentClass = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var getText = function getText(text) {
  return text && text.replace(/\\n|\n/g, '\n');
};
var Body = function Body(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'standard' : _b,
    _c = _a.color,
    color = _c === void 0 ? 'primary-dark' : _c,
    _d = _a.element,
    Element = _d === void 0 ? 'div' : _d,
    _e = _a.textAlign,
    textAlign = _e === void 0 ? 'left' : _e,
    className = _a.className,
    _f = _a.textTransform,
    textTransform = _f === void 0 ? 'normal' : _f,
    _g = _a.wordBreak,
    wordBreak = _g === void 0 ? 'none' : _g,
    strikethrough = _a.strikethrough,
    children = _a.children,
    props = __rest$1(_a, ["variant", "color", "element", "textAlign", "className", "textTransform", "wordBreak", "strikethrough", "children"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(bodyStyles.body, bodyStyles["body--color-".concat(color)], variant === 'underlined' && bodyStyles.bodyUnderlined, variant === 'small-underlined' && bodyStyles.bodySmallUnderlined, typographyStyles[bodyStyles$1[variant]], textAlignStyles[alignmentClass[textAlign]], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className),
    children: typeof children === 'string' ? getText(children) : children,
    "aria-disabled": color === 'disabled'
  }, props, testId));
};
Body.displayName = 'CoreBody';

var styles$5 = {"caption":"fr-ec-caption","caption--color-primary-dark":"fr-ec-caption--color-primary-dark","captionColorPrimaryDark":"fr-ec-caption--color-primary-dark","caption--color-primary-light":"fr-ec-caption--color-primary-light","captionColorPrimaryLight":"fr-ec-caption--color-primary-light","caption--color-secondary":"fr-ec-caption--color-secondary","captionColorSecondary":"fr-ec-caption--color-secondary","caption--color-error":"fr-ec-caption--color-error","captionColorError":"fr-ec-caption--color-error","caption--color-disabled":"fr-ec-caption--color-disabled","captionColorDisabled":"fr-ec-caption--color-disabled"};

var alignmentClass$1 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var getText$1 = function getText(text) {
  return text && text.replace(/\\n|\n/g, '\n');
};
var Caption = function Caption(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'standard' : _c,
    _d = _a.color,
    color = _d === void 0 ? 'primary-dark' : _d,
    _e = _a.textAlign,
    textAlign = _e === void 0 ? 'left' : _e,
    _f = _a.textTransform,
    textTransform = _f === void 0 ? 'normal' : _f,
    className = _a.className,
    _g = _a.wordBreak,
    wordBreak = _g === void 0 ? 'none' : _g,
    strikethrough = _a.strikethrough,
    children = _a.children,
    props = __rest$1(_a, ["element", "variant", "color", "textAlign", "textTransform", "className", "wordBreak", "strikethrough", "children"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$5.caption, color === 'disabled' ? styles$5['caption--color-disabled'] : styles$5["caption--color-".concat(color)], textAlignStyles[alignmentClass$1[textAlign]], className, typographyStyles["caption--".concat(variant)], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough),
    children: typeof children === 'string' ? getText$1(children) : children,
    "aria-disabled": color === 'disabled'
  }, props));
};
Caption.displayName = 'CoreCaption';

var styles$6 = {"title":"fr-ec-title","title--color-primary-dark":"fr-ec-title--color-primary-dark","titleColorPrimaryDark":"fr-ec-title--color-primary-dark","title--color-primary-light":"fr-ec-title--color-primary-light","titleColorPrimaryLight":"fr-ec-title--color-primary-light","title--color-disabled":"fr-ec-title--color-disabled","titleColorDisabled":"fr-ec-title--color-disabled","title--color-promotional":"fr-ec-title--color-promotional","titleColorPromotional":"fr-ec-title--color-promotional"};

var testId$1 = {
  'data-testid': 'CoreTitle'
};
var alignmentClass$2 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Title = function Title(_a) {
  var Element = _a.element,
    _b = _a.color,
    color = _b === void 0 ? 'primary-dark' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'standard' : _c,
    _d = _a.textAlign,
    textAlign = _d === void 0 ? 'left' : _d,
    className = _a.className,
    _e = _a.textTransform,
    textTransform = _e === void 0 ? 'normal' : _e,
    _f = _a.wordBreak,
    wordBreak = _f === void 0 ? 'none' : _f,
    strikethrough = _a.strikethrough,
    props = __rest$1(_a, ["element", "color", "variant", "textAlign", "className", "textTransform", "wordBreak", "strikethrough"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$6.title, styles$6["title--color-".concat(color)], typographyStyles["title--".concat(variant)], textAlignStyles[alignmentClass$2[textAlign]], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className),
    "aria-disabled": color === 'disabled'
  }, props, testId$1));
};
Title.displayName = 'CoreTitle';

var STAR_SIZE = '14px';
var STAR_SIZE_LARGE = '24px';

var styles$7 = {"star--full":"fr-ec-star--full","starFull":"fr-ec-star--full","star--empty":"fr-ec-star--empty","starEmpty":"fr-ec-star--empty","star--half":"fr-ec-star--half","starHalf":"fr-ec-star--half"};

// *0.5 : ave 0.0-0.7
// ★1.0 : ave 0.8-1.2
// ★1.5 : ave 1.3-1.7
// ★2.0 : ave 1.8-2.2
// ★2.5 : ave 2.3-2.7
// ★3.0 : ave 2.8-3.2
// ★3.5 : ave 3.3-3.7
// ★4.0 : ave 3.8-4.2
// ★4.5 : ave 4.3-4.7
// ★5.0 : ave 4.8-5.0
var Star = function Star(_a) {
  var position = _a.position,
    value = _a.value,
    _b = _a.size,
    size = _b === void 0 ? 'small' : _b,
    className = _a.className,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["position", "value", "size", "className", "iconBrand"]);
  var starSize = size === 'large' ? STAR_SIZE_LARGE : STAR_SIZE;
  var emptyStarIcon = /*#__PURE__*/createElement(Icon, __assign$1({
    name: iconBrand ? "".concat(iconBrand, "star-filled") : 'star-filled',
    size: starSize,
    className: joinClasses(styles$7.starEmpty, className)
  }, props));
  var halfStarIcon = /*#__PURE__*/createElement(Icon, __assign$1({
    name: iconBrand ? "".concat(iconBrand, "star-half-filled") : 'star-half-filled',
    size: starSize,
    className: joinClasses(styles$7.starHalf, className)
  }, props));
  var fullStarIcon = /*#__PURE__*/createElement(Icon, __assign$1({
    name: iconBrand ? "".concat(iconBrand, "star-filled") : 'star-filled',
    size: starSize,
    className: joinClasses(styles$7.starFull, className)
  }, props));
  var fixedValue = Number(value.toFixed(1));
  if (position === 0 && fixedValue === 0) {
    return emptyStarIcon;
  }
  if (position === 0 && fixedValue < 0.7) {
    return halfStarIcon;
  }
  if (fixedValue < position + 0.3) {
    return emptyStarIcon;
  }
  if (fixedValue <= position + 0.7) {
    return halfStarIcon;
  }
  return fullStarIcon;
};
Star.defaultProps = {
  size: 'small'
};

var styles$8 = {"rating-static":"fr-ec-rating-static","ratingStatic":"fr-ec-rating-static","rating-static__item--small":"fr-ec-rating-static__item--small","ratingStaticItemSmall":"fr-ec-rating-static__item--small","rating-static__item--large":"fr-ec-rating-static__item--large","ratingStaticItemLarge":"fr-ec-rating-static__item--large","rating-static__reviews":"fr-ec-rating-static__reviews","ratingStaticReviews":"fr-ec-rating-static__reviews","rating-static__average-value":"fr-ec-rating-static__average-value","ratingStaticAverageValue":"fr-ec-rating-static__average-value","rating-static__count-product-tile":"fr-ec-rating-static__count-product-tile","ratingStaticCountProductTile":"fr-ec-rating-static__count-product-tile"};

var renderFiveStars = function renderFiveStars(value, variant, iconBrand) {
  if (variant === void 0) {
    variant = 'small';
  }
  return count(5).map(function (i) {
    return /*#__PURE__*/createElement(Star, {
      key: i,
      position: i,
      size: variant,
      value: value,
      iconBrand: iconBrand,
      className: styles$8["rating-static__item--".concat(variant)]
    });
  });
};
var renderOneStar = function renderOneStar(value, variant, iconBrand) {
  return /*#__PURE__*/createElement(Star, {
    position: 0,
    size: 'small',
    value: value,
    iconBrand: iconBrand
  });
};
var RatingStatic = function RatingStatic(_a) {
  var value = _a.value,
    ariaLabel = _a.ariaLabel,
    children = _a.children,
    className = _a.className,
    _b = _a.variant,
    variant = _b === void 0 ? 'small' : _b,
    iconBrand = _a.iconBrand,
    averageValue = _a.averageValue,
    props = __rest$1(_a, ["value", "ariaLabel", "children", "className", "variant", "iconBrand", "averageValue"]);
  return /*#__PURE__*/createElement(Fragment, null, typeof value === 'number' && (/*#__PURE__*/createElement("div", __assign$1({
    role: "figure",
    className: joinClasses(styles$8.ratingStatic, className),
    "aria-label": ariaLabel || "".concat(value, " out of 5 stars")
  }, props), variant === 'oneStar' ? renderOneStar(value, variant, iconBrand) : renderFiveStars(value, variant, iconBrand), averageValue !== undefined && variant !== 'oneStar' && (/*#__PURE__*/createElement("div", {
    className: joinClasses(typographyStyles.ratingAverage, styles$8.ratingStaticAverageValue)
  }, averageValue)), averageValue !== undefined && variant === 'oneStar' && (/*#__PURE__*/createElement("div", {
    className: joinClasses(typographyStyles.ratingAverageProductTile, styles$8.ratingStaticAverageValue)
  }, averageValue)), children && (/*#__PURE__*/createElement("div", {
    className: variant === 'oneStar' ? joinClasses(styles$8.ratingStaticCountProductTile, typographyStyles.captionExtraSmall) : styles$8.ratingStaticReviews
  }, children)))));
};
RatingStatic.defaultProps = {
  variant: 'small'
};
RatingStatic.displayName = 'CoreRatingStatic';

var styles$9 = {"review":"fr-ec-review","review__grey-text":"fr-ec-review__grey-text","reviewGreyText":"fr-ec-review__grey-text","review__header":"fr-ec-review__header","reviewHeader":"fr-ec-review__header","review__purchase--information":"fr-ec-review__purchase--information","reviewPurchaseInformation":"fr-ec-review__purchase--information","review__user-nickname":"fr-ec-review__user-nickname","reviewUserNickname":"fr-ec-review__user-nickname","review__user-info":"fr-ec-review__user-info","reviewUserInfo":"fr-ec-review__user-info","review__title":"fr-ec-review__title","reviewTitle":"fr-ec-review__title","review__content":"fr-ec-review__content","reviewContent":"fr-ec-review__content","actionable-content":"fr-ec-actionable-content","actionableContent":"fr-ec-actionable-content","review__date":"fr-ec-review__date","reviewDate":"fr-ec-review__date","rating":"fr-ec-rating","actionable-content__actions--default":"fr-ec-actionable-content__actions--default","actionableContentActionsDefault":"fr-ec-actionable-content__actions--default"};

var Review = function Review(_a) {
  var title = _a.title,
    date = _a.date,
    rating = _a.rating,
    purchaseInformation = _a.purchaseInformation,
    content = _a.content,
    customerInformation = _a.customerInformation,
    reviewFeedbackSection = _a.reviewFeedbackSection,
    className = _a.className,
    header = _a.header,
    reviewDetailsSection = _a.reviewDetailsSection,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["title", "date", "rating", "purchaseInformation", "content", "customerInformation", "reviewFeedbackSection", "className", "header", "reviewDetailsSection", "iconBrand"]);
  return /*#__PURE__*/createElement("section", __assign$1({
    className: joinClasses(styles$9.review, className)
  }, props), /*#__PURE__*/createElement(ActionableContent, {
    actionsPosition: "left",
    content: /*#__PURE__*/createElement(Fragment, null, header && (/*#__PURE__*/createElement(Title, {
      element: "h1",
      className: joinClasses(styles$9.reviewHeader, typeof rating === 'number' && spacingStyles.mbSpacing02)
    }, header))),
    actions: /*#__PURE__*/createElement(Caption, {
      element: "span",
      className: joinClasses(styles$9.reviewGreyText, styles$9.reviewDate)
    }, date)
  }), /*#__PURE__*/createElement(RatingStatic, {
    value: rating,
    iconBrand: iconBrand,
    ariaLabel: "rating",
    className: styles$9.rating
  }), purchaseInformation && purchaseInformation.length > 0 && purchaseInformation.map(function (purchaseInfo, index) {
    return purchaseInformation.length === index + 1 ? (/*#__PURE__*/createElement(Caption, {
      element: "p",
      key: index,
      className: joinClasses(styles$9.reviewPurchaseInformation, spacingStyles.mbSpacing04)
    }, "".concat(purchaseInfo.term, ": ").concat(purchaseInfo.description))) : (/*#__PURE__*/createElement(Caption, {
      element: "p",
      key: index,
      className: styles$9.reviewPurchaseInformation
    }, "".concat(purchaseInfo.term, ": ").concat(purchaseInfo.description)));
  }), title && (/*#__PURE__*/createElement(Title, {
    element: "h1",
    className: joinClasses(styles$9.reviewTitle, spacingStyles.mbSpacing02)
  }, title)), /*#__PURE__*/createElement(Body, {
    className: joinClasses(styles$9.reviewContent, spacingStyles.mbSpacing04),
    element: "p",
    wordBreak: "break-word"
  }, content), /*#__PURE__*/createElement("div", {
    className: spacingStyles.mbSpacing04
  }, (customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.nickname) && (/*#__PURE__*/createElement(Caption, {
    className: styles$9.reviewUserNickname,
    element: "span",
    variant: "standard",
    color: "secondary"
  }, customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.nickname)), customerInformation.spec.map(function (data, index) {
    return /*#__PURE__*/createElement(Caption, {
      key: index,
      className: joinClasses(styles$9.reviewUserInfo, styles$9.reviewGreyText),
      element: "span"
    }, data);
  })), reviewDetailsSection, /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    justifyContent: "flex-end"
  }, reviewFeedbackSection));
};
Review.displayName = 'CoreReview';

var styles$a = {"badge-ranking":"fr-ec-badge-ranking","badgeRanking":"fr-ec-badge-ranking"};

var BadgeRanking = function BadgeRanking(_a) {
  var rank = _a.rank,
    _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? "Rank ".concat(rank) : _b,
    className = _a.className,
    props = __rest$1(_a, ["rank", "ariaLabel", "className"]);
  return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
    element: 'div',
    justifyContent: 'center',
    direction: 'row',
    alignment: 'center',
    className: joinClasses(styles$a.badgeRanking, spacingStyles.mbSpacing03, className),
    "aria-label": ariaLabel
  }, props), rank);
};
BadgeRanking.displayName = 'CoreBadgeRanking';

var interactionsStyles = {"link-nav-text-base":"fr-ec-link-nav-text-base","linkNavTextBase":"fr-ec-link-nav-text-base","borderIn":"fr-ec-borderIn","link-nav-text-base--selected":"fr-ec-link-nav-text-base--selected","linkNavTextBaseSelected":"fr-ec-link-nav-text-base--selected","cursor-pointer":"fr-ec-cursor-pointer","cursorPointer":"fr-ec-cursor-pointer","scroll-disabled":"fr-ec-scroll-disabled","scrollDisabled":"fr-ec-scroll-disabled"};

var resetStyles = {"fieldset-reset":"fr-ec-fieldset-reset","fieldsetReset":"fr-ec-fieldset-reset","mark-reset":"fr-ec-mark-reset","markReset":"fr-ec-mark-reset","button-reset":"fr-ec-button-reset","buttonReset":"fr-ec-button-reset","textinput-reset":"fr-ec-textinput-reset","textinputReset":"fr-ec-textinput-reset","max-width-reset":"fr-ec-max-width-reset","maxWidthReset":"fr-ec-max-width-reset"};

var styles$b = {"breadcrumb":"fr-ec-breadcrumb","breadcrumb--underlined":"fr-ec-breadcrumb--underlined","breadcrumbUnderlined":"fr-ec-breadcrumb--underlined","breadcrumb--disabled":"fr-ec-breadcrumb--disabled","breadcrumbDisabled":"fr-ec-breadcrumb--disabled"};

var Breadcrumb = function Breadcrumb(_a) {
  var Element = _a.element,
    _b = _a.variant,
    variant = _b === void 0 ? 'underlined' : _b,
    className = _a.className,
    children = _a.children,
    disabled = _a.disabled,
    ariaLabel = _a.ariaLabel,
    href = _a.href,
    to = _a.to,
    _c = _a.textTransform,
    textTransform = _c === void 0 ? 'normal' : _c,
    _d = _a.gaCategory,
    gaCategory = _d === void 0 ? '' : _d,
    _e = _a.gaLabel,
    gaLabel = _e === void 0 ? '' : _e,
    gaAction = _a.gaAction,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    _f = _a.wordBreak,
    wordBreak = _f === void 0 ? 'none' : _f,
    props = __rest$1(_a, ["element", "variant", "className", "children", "disabled", "ariaLabel", "href", "to", "textTransform", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "wordBreak"]);
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var onClickHandler = function onClickHandler(e) {
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$b.breadcrumb, typographyStyles["breadcrumb--".concat(variant)], disabled && styles$b.breadcrumbDisabled, interactionsStyles.cursorPointer, Element === 'button' && resetStyles.buttonReset, textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), className),
      onClick: onClickHandler,
      role: "link",
      "aria-label": ariaLabel || children,
      "aria-disabled": disabled,
      disabled: disabled
    }, !disabled ? {
      href: href,
      to: to
    } : {}, props, gaProps), children)
  );
};
Breadcrumb.displayName = 'CoreBreadcrumb';
Breadcrumb.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$c = {"breadcrumb-group":"fr-ec-breadcrumb-group","breadcrumbGroup":"fr-ec-breadcrumb-group","breadcrumb-group__item":"fr-ec-breadcrumb-group__item","breadcrumbGroupItem":"fr-ec-breadcrumb-group__item","breadcrumb-group-overlay":"fr-ec-breadcrumb-group-overlay","breadcrumbGroupOverlay":"fr-ec-breadcrumb-group-overlay"};

var BreadcrumbGroup = function BreadcrumbGroup(_a) {
  var children = _a.children,
    props = __rest$1(_a, ["children"]);
  var _b = useState(true),
    showOverlay = _b[0],
    setShowOverlay = _b[1];
  var _c = useState(0),
    parentWidth = _c[0],
    setParentWidth = _c[1];
  var _d = useState(false),
    isScrollEnable = _d[0],
    setIsScrollEnable = _d[1];
  var olElement = useRef(null);
  var childLength = React__default.Children.toArray(children).length;
  useEffect(function () {
    var element = olElement.current;
    setIsScrollEnable(element.scrollWidth > element.clientWidth);
    if (element.scrollLeft + element.offsetWidth >= element.scrollWidth - 10) {
      setShowOverlay(false);
    } else {
      setShowOverlay(true);
    }
  }, [parentWidth]);
  var onScroll = function onScroll(event) {
    var target = event.target.closest(".".concat(styles$c.breadcrumbGroup));
    if (target) {
      if (target.scrollLeft + target.offsetWidth >= target.scrollWidth - 10) {
        setShowOverlay(false);
      } else {
        setShowOverlay(true);
      }
    }
  };
  var showOverlayElement = isScrollEnable && showOverlay && parentWidth < designTokens_3.mqMediumScreenMaxWidthLimit;
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: function onResize(contentRect) {
      if (contentRect.bounds) {
        setParentWidth(contentRect.bounds.width);
      }
    }
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", __assign$1({}, props, {
      ref: measureRef
    }), showOverlayElement && /*#__PURE__*/React__default.createElement("div", {
      className: styles$c.breadcrumbGroupOverlay
    }), /*#__PURE__*/React__default.createElement("ol", {
      ref: olElement,
      className: styles$c.breadcrumbGroup,
      onTouchMove: onScroll
    }, React__default.Children.map(children, function (child, i) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: styles$c.breadcrumbGroupItem,
        key: i
      }, /*#__PURE__*/React__default.cloneElement(child, __assign$1({}, i === childLength - 1 ? {
        disabled: true,
        element: 'a'
      } : {})));
    })));
  });
};
BreadcrumbGroup.displayName = 'CoreBreadcrumbGroup';

var CmsBreadcrumbs = function CmsBreadcrumbs(_a) {
  var items = _a.items,
    className = _a.className,
    props = __rest$1(_a, ["items", "className"]);
  return /*#__PURE__*/createElement(BreadcrumbGroup, __assign$1({
    className: className
  }, props), items);
};
CmsBreadcrumbs.displayName = 'CoreCmsBreadcrumbs';

var isInBrowser$1 = function isInBrowser() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};

var styles$d = {"visibility--show-sm":"fr-ec-visibility--show-sm","visibilityShowSm":"fr-ec-visibility--show-sm","visibility--hide-sm":"fr-ec-visibility--hide-sm","visibilityHideSm":"fr-ec-visibility--hide-sm","visibility--show-md":"fr-ec-visibility--show-md","visibilityShowMd":"fr-ec-visibility--show-md","visibility--hide-md":"fr-ec-visibility--hide-md","visibilityHideMd":"fr-ec-visibility--hide-md","visibility--show-lg":"fr-ec-visibility--show-lg","visibilityShowLg":"fr-ec-visibility--show-lg","visibility--hide-lg":"fr-ec-visibility--hide-lg","visibilityHideLg":"fr-ec-visibility--hide-lg"};

var withVisibility = function withVisibility(component) {
  var Component = component;
  var WrapperComponent = function WrapperComponent(_a) {
    var _b = _a.visible,
      visible = _b === void 0 ? true : _b,
      className = _a.className,
      props = __rest$1(_a, ["visible", "className"]);
    var getVisibleClasses = function getVisibleClasses(visibleProp) {
      if (typeof visibleProp === 'boolean') {
        if (visibleProp) {
          return joinClasses(styles$d.visibilityShowSm, styles$d.visibilityShowMd, styles$d.visibilityShowLg);
        } else {
          return joinClasses(styles$d.visibilityHideSm, styles$d.visibilityHideMd, styles$d.visibilityHideLg);
        }
      }
      return joinClasses.apply(void 0, Object.keys(visibleProp).reduce(function (acc, size) {
        var visibilityClassName = visibleProp[size] ? styles$d["visibility--show-".concat(size)] : styles$d["visibility--hide-".concat(size)];
        return __spreadArray(__spreadArray([], acc, true), [visibilityClassName], false);
      }, []));
    };
    var visibilityClasses = getVisibleClasses(visible);
    /**
     * Have to do this to allow props to be spread on `Component` because TypeScript 3.2^ has an issue
     * with spreading generics - https://github.com/Microsoft/TypeScript/issues/28938
     */
    return /*#__PURE__*/createElement(Component, __assign$1({
      className: joinClasses(className, visibilityClasses)
    }, props));
  };
  WrapperComponent.displayName = Component.displayName;
  return WrapperComponent;
};

var BP_SMALL = 'sm';
var BP_MEDIUM = 'md';
var BP_LARGE = 'lg';
var getCurrentMediaQueryBreakpoint = function getCurrentMediaQueryBreakpoint() {
  if (typeof window === 'undefined' && typeof document === 'undefined') {
    return BP_SMALL;
  }
  var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  if (width < designTokens_3.mqMediumScreenMinWidthLimit) {
    return BP_SMALL;
  } else if (width < designTokens_3.mqLargeScreenMinWidthLimit) {
    return BP_MEDIUM;
  }
  return BP_LARGE;
};

var DIRECTION_TOP = 'top';
var DIRECTION_BOTTOM = 'bottom';
var DIRECTION_START = 'start';
var DIRECTION_END = 'end';
var DIRECTION_START_TOP = 'startTop';
var DIRECTION_END_TOP = 'endTop';
var DIRECTION_TOP_LEFT = 'topLeft';
var DIRECTION_BOTTOM_LEFT = 'bottomLeft';
var DIRECTION_START_BOTTOM = 'startBottom';
var DIRECTION_END_BOTTOM = 'endBottom';
var DIRECTION_TOP_RIGHT = 'topRight';
var DIRECTION_BOTTOM_RIGHT = 'bottomRight';

var getBrowser = function getBrowser() {
  if (typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Firefox') !== -1) {
    return 'firefox';
  } else {
    return 'none';
  }
};

var KEYCODE;
(function (KEYCODE) {
  KEYCODE[KEYCODE["TAB"] = 9] = "TAB";
  KEYCODE[KEYCODE["ENTER"] = 13] = "ENTER";
  KEYCODE[KEYCODE["ESC"] = 27] = "ESC";
  KEYCODE[KEYCODE["SPACE"] = 32] = "SPACE";
  KEYCODE[KEYCODE["LEFT"] = 37] = "LEFT";
  KEYCODE[KEYCODE["UP"] = 38] = "UP";
  KEYCODE[KEYCODE["RIGHT"] = 39] = "RIGHT";
  KEYCODE[KEYCODE["DOWN"] = 40] = "DOWN";
})(KEYCODE || (KEYCODE = {}));

var styles$1$2 = {"tooltip-clone":"fr-ec-tooltip-clone","tooltipClone":"fr-ec-tooltip-clone","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","with-clone--wrapper":"fr-ec-with-clone--wrapper","withCloneWrapper":"fr-ec-with-clone--wrapper"};

var WithClonedTooltip = function WithClonedTooltip(component) {
  var _a;
  var Component = component;
  var cloneAnchor;
  if (isInBrowser$1()) {
    cloneAnchor = document.body.appendChild(document.createElement('div'));
  }
  return _a = /** @class */function (_super) {
    __extends(WrapperComponent, _super);
    function WrapperComponent(props) {
      var _this = _super.call(this, props) || this;
      _this.onResize = function () {
        if (_this.props.isPopper && isInBrowser$1() && _this.originalRef.current) {
          var rect = _this.originalRef.current.getBoundingClientRect();
          _this.setState({
            clonePosition: {
              left: rect.left + window.scrollX,
              top: rect.top + window.scrollY
            }
          });
        }
      };
      _this.getClonePortal = function () {
        var clonePosition = _this.state.clonePosition;
        var clone = /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: 'inline-block',
            left: clonePosition.left,
            position: 'fixed',
            top: clonePosition.top,
            zIndex: 700
          },
          "aria-hidden": true,
          tabIndex: -1
        }, /*#__PURE__*/React__default.createElement(Component, __assign$1({
          className: joinClasses(_this.props.className, styles$1$2.tooltipClone)
        }, _this.props, {
          id: "".concat(_this.props.id, "-clone")
        })));
        return /*#__PURE__*/ReactDOM.createPortal(clone, cloneAnchor);
      };
      _this.originalRef = /*#__PURE__*/createRef();
      _this.state = {
        clonePosition: {
          top: 0,
          left: 0
        }
      };
      return _this;
    }
    WrapperComponent.prototype.componentDidMount = function () {
      this.onResize();
    };
    WrapperComponent.prototype.componentDidUpdate = function (prevProps) {
      var isPopper = this.props.isPopper;
      if (prevProps.isPopper !== isPopper) {
        this.onResize();
        var originalBubbleEl_1 = document.getElementById("".concat(this.props.id, "-bubble"));
        var cloneBubbleEl_1 = document.getElementById("".concat(this.props.id, "-clone-bubble"));
        var originalButtonEl = document.getElementById(this.props.id);
        var clonebuttonEl = document.getElementById("".concat(this.props.id, "-clone"));
        if (clonebuttonEl) {
          clonebuttonEl.setAttribute('tabIndex', '-1');
        }
        var handleFocus = function handleFocus() {
          if (cloneBubbleEl_1 && originalBubbleEl_1) {
            cloneBubbleEl_1.classList.remove('uq-uikit-tooltip__bubble--hidden');
            var originalBubbleStyles = originalBubbleEl_1.getAttribute('style');
            var originalBubbleClass = originalBubbleEl_1.getAttribute('class');
            if (originalBubbleStyles && originalBubbleClass) {
              cloneBubbleEl_1.setAttribute('style', originalBubbleStyles);
              cloneBubbleEl_1.setAttribute('class', originalBubbleClass);
            }
          }
        };
        var handleBlur = function handleBlur() {
          if (cloneBubbleEl_1) {
            cloneBubbleEl_1.classList.add('uq-uikit-tooltip__bubble--hidden');
          }
        };
        if (originalButtonEl) {
          originalButtonEl.addEventListener('focus', handleFocus);
          originalButtonEl.addEventListener('blur', handleBlur);
        }
      }
    };
    WrapperComponent.prototype.componentWillUnmount = function () {
      if (isInBrowser$1() && this.props.isPopper && cloneAnchor && document.body.contains(cloneAnchor)) {
        document.body.removeChild(cloneAnchor);
      }
    };
    WrapperComponent.prototype.render = function () {
      var _this = this;
      var isPopper = this.props.isPopper;
      return isPopper ? (/*#__PURE__*/React__default.createElement(Measure, {
        onResize: debounce(100, this.onResize)
      }, function (_a) {
        var measureRef = _a.measureRef;
        return /*#__PURE__*/React__default.createElement("div", {
          ref: measureRef
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$1$2.withCloneWrapper,
          ref: _this.originalRef
        }, /*#__PURE__*/React__default.createElement(Component, __assign$1({}, _this.props))), _this.getClonePortal());
      })) : (/*#__PURE__*/React__default.createElement(Component, __assign$1({}, this.props)));
    };
    return WrapperComponent;
  }(React__default.Component), _a.displayName = Component.displayName, _a;
};

var DeviceType;
(function (DeviceType) {
  DeviceType["Mobile"] = "Mobile";
  DeviceType["Tablet"] = "Tablet";
  DeviceType["Desktop"] = "Desktop";
})(DeviceType || (DeviceType = {}));
var DeviceTypeContext = /*#__PURE__*/createContext(DeviceType.Mobile);

var isViewport = function isViewport(component) {
  var Component = component;
  var WrapperComponent = function WrapperComponent(_a) {
    var _b = _a.visible,
      visible = _b === void 0 ? {
        sm: true,
        md: true,
        lg: true
      } : _b,
      className = _a.className,
      props = __rest$1(_a, ["visible", "className"]);
    var deviceType = useContext(DeviceTypeContext);
    var getWindowWidth = function getWindowWidth() {
      if (isInBrowser$1()) {
        return window.innerWidth;
      } else {
        return deviceType === DeviceType.Desktop ? 1199 : deviceType === DeviceType.Tablet ? 959 : 599;
      }
    };
    var _c = useState(getWindowWidth()),
      viewportWidth = _c[0],
      setViewportWidth = _c[1];
    var shouldRender = function shouldRender(visibility, width) {
      if (_typeof(visibility) === 'object' && width !== null) {
        if (visibility.sm && width < designTokens_3.mqMediumScreenMinWidthLimit) {
          return true;
        }
        if (visibility.md && width > designTokens_3.mqSmallScreenMaxWidthLimit && width < designTokens_3.mqLargeScreenMinWidthLimit) {
          return true;
        }
        if (visibility.lg && width > designTokens_3.mqMediumScreenMaxWidthLimit) {
          return true;
        }
      }
      return false;
    };
    useEffect(function () {
      function handleResize() {
        var getWidth = getWindowWidth();
        setViewportWidth(getWidth);
      }
      window.addEventListener('resize', debounce(100, handleResize));
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }, []);
    var shouldRenderChildren = shouldRender(visible, viewportWidth);
    /**
     * Have to do this to allow props to be spread on `Component` because TypeScript 3.2^ has an issue
     * with spreading generics - https://github.com/Microsoft/TypeScript/issues/28938
     */
    return shouldRenderChildren ? /*#__PURE__*/createElement(Component, __assign$1({
      className: joinClasses(className)
    }, props)) : null;
  };
  WrapperComponent.displayName = Component.displayName;
  return WrapperComponent;
};

var getViewportWidth = function getViewportWidth() {
  var deviceType = useContext(DeviceTypeContext);
  var getWindowWidth = function getWindowWidth() {
    if (isInBrowser$1()) {
      return window.innerWidth || 0;
    } else {
      return deviceType === DeviceType.Desktop ? 1199 : deviceType === DeviceType.Tablet ? 959 : 599;
    }
  };
  var _a = useState(getWindowWidth()),
    width = _a[0],
    setWidth = _a[1];
  useEffect(function () {
    var handleWindowResize = function handleWindowResize() {
      return setWidth(getWindowWidth());
    };
    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return width;
};

var isTouchDevice = function isTouchDevice(method) {
  if (method === 'touchPoints') {
    return typeof window !== 'undefined' ? 'ontouchstart' in window || navigator.maxTouchPoints > 0 : true;
  } else if (method === 'userAgent') {
    var userAgent = typeof window === 'undefined' ? '' : navigator.userAgent;
    return Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i) || userAgent.includes('Mac') && 'ontouchend' in document);
  } else {
    return false;
  }
};

var isAbsoluteUrl = function isAbsoluteUrl(url) {
  var absoluteUrlPattern = /^((https?:)?\/\/|#)/;
  return absoluteUrlPattern.test(url) ? true : false;
};

var getOS = function getOS() {
  var userAgent = typeof window === 'undefined' ? '' : navigator.userAgent;
  if (Boolean(userAgent.match(/Android/i))) {
    return 'android';
  } else if (Boolean(userAgent.match(/iPhone|iPad|iPod/i))) {
    return 'iOS';
  } else {
    return 'none';
  }
};

var isKeyboardOpen = function isKeyboardOpen() {
  var _a;
  var minKeyboardHeight = 300;
  var _b = useState(undefined),
    isKeyboardOpenState = _b[0],
    setIsKeyboardOpenState = _b[1];
  var _c = useState(isInBrowser$1() ? (window.outerWidth - 10) / window.innerWidth : undefined),
    zoomState = _c[0],
    setZoomState = _c[1];
  var _d = useState(isTouchDevice('touchPoints')),
    isTouchDevices = _d[0],
    setTouchDevices = _d[1];
  var _e = useState(isInBrowser$1() ? (_a = window.visualViewport) === null || _a === void 0 ? void 0 : _a.height : undefined),
    visualViewPortHeight = _e[0],
    setVisualViewPortHeight = _e[1];
  var prevZoomState = useRef();
  var prevViewportHeightState = useRef();
  useEffect(function () {
    prevZoomState.current = zoomState;
  }, [zoomState]);
  useEffect(function () {
    prevViewportHeightState.current = visualViewPortHeight;
  }, [visualViewPortHeight]);
  useEffect(function () {
    var listener = function listener() {
      // In chrome window.innerWidth won't change on pinch zoom
      // It is based on layout viewport
      // For pinch zoom releted layout changes use visual viewport
      var windowInnerWidth = window.visualViewport ? window.visualViewport.width : window.innerWidth;
      var newZoomLevel = (window.outerWidth - 10) / windowInnerWidth;
      var newState = window.screen.height - minKeyboardHeight * newZoomLevel > window.visualViewport.height;
      var newVisualViewPortHeight = window.visualViewport.height;
      setTouchDevices(isTouchDevice('touchPoints'));
      if (prevZoomState.current !== newZoomLevel) {
        setZoomState(newZoomLevel);
      }
      if (prevViewportHeightState.current !== newVisualViewPortHeight) {
        setVisualViewPortHeight(window.visualViewport.height);
      }
      if (isKeyboardOpenState !== newState && isTouchDevices) {
        if (Math.round(zoomState * 100) === Math.round(newZoomLevel * 100)) {
          setIsKeyboardOpenState(newState);
        }
      }
    };
    if (isInBrowser$1()) {
      if (typeof window.visualViewport !== 'undefined') {
        window.visualViewport.addEventListener('resize', listener);
      }
    }
    return function () {
      if (isInBrowser$1()) {
        if (typeof window.visualViewport !== 'undefined') {
          window.visualViewport.removeEventListener('resize', listener);
        }
      }
    };
  }, [zoomState, visualViewPortHeight]);
  return isKeyboardOpenState;
};

var buttonStyles = {"button":"fr-ec-button","button--text-wrap":"fr-ec-button--text-wrap","buttonTextWrap":"fr-ec-button--text-wrap","button--small":"fr-ec-button--small","buttonSmall":"fr-ec-button--small","collection-list-horizontal":"fr-ec-collection-list-horizontal","collectionListHorizontal":"fr-ec-collection-list-horizontal","button--media-position-left":"fr-ec-button--media-position-left","buttonMediaPositionLeft":"fr-ec-button--media-position-left","button--media-position-right":"fr-ec-button--media-position-right","buttonMediaPositionRight":"fr-ec-button--media-position-right","button--media-position-left-en":"fr-ec-button--media-position-left-en","buttonMediaPositionLeftEn":"fr-ec-button--media-position-left-en","button--media-position-right-en":"fr-ec-button--media-position-right-en","buttonMediaPositionRightEn":"fr-ec-button--media-position-right-en","button--media-position-right-ja":"fr-ec-button--media-position-right-ja","buttonMediaPositionRightJa":"fr-ec-button--media-position-right-ja","button--media-position-left-ja":"fr-ec-button--media-position-left-ja","buttonMediaPositionLeftJa":"fr-ec-button--media-position-left-ja","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","collection-list-horizontal--normal":"fr-ec-collection-list-horizontal--normal","collectionListHorizontalNormal":"fr-ec-collection-list-horizontal--normal","image--fixed-height":"fr-ec-image--fixed-height","imageFixedHeight":"fr-ec-image--fixed-height","button--variant-primary":"fr-ec-button--variant-primary","buttonVariantPrimary":"fr-ec-button--variant-primary","label--standard-emphasized-color-primary-dark":"fr-ec-label--standard-emphasized-color-primary-dark","labelStandardEmphasizedColorPrimaryDark":"fr-ec-label--standard-emphasized-color-primary-dark","label--standard-color-primary-dark":"fr-ec-label--standard-color-primary-dark","labelStandardColorPrimaryDark":"fr-ec-label--standard-color-primary-dark","button--ec-renewal":"fr-ec-button--ec-renewal","buttonEcRenewal":"fr-ec-button--ec-renewal","button--fit-to-content-small":"fr-ec-button--fit-to-content-small","buttonFitToContentSmall":"fr-ec-button--fit-to-content-small","button--fit-to-content":"fr-ec-button--fit-to-content","buttonFitToContent":"fr-ec-button--fit-to-content","button--half-width":"fr-ec-button--half-width","buttonHalfWidth":"fr-ec-button--half-width","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","button--variant-transactional":"fr-ec-button--variant-transactional","buttonVariantTransactional":"fr-ec-button--variant-transactional","button--variant-secondary":"fr-ec-button--variant-secondary","buttonVariantSecondary":"fr-ec-button--variant-secondary","button--ec-renewal-secondary-small":"fr-ec-button--ec-renewal-secondary-small","buttonEcRenewalSecondarySmall":"fr-ec-button--ec-renewal-secondary-small","label":"fr-ec-label","icon":"fr-ec-icon","button--variant-third-party":"fr-ec-button--variant-third-party","buttonVariantThirdParty":"fr-ec-button--variant-third-party","button__icon":"fr-ec-button__icon","buttonIcon":"fr-ec-button__icon","button-max-width-reset":"fr-ec-button-max-width-reset","buttonMaxWidthReset":"fr-ec-button-max-width-reset","button--double-text":"fr-ec-button--double-text","buttonDoubleText":"fr-ec-button--double-text"};

var variantToStyle = {
  primary: buttonStyles.buttonVariantPrimary,
  secondary: buttonStyles.buttonVariantSecondary,
  thirdParty: buttonStyles.buttonVariantThirdParty,
  transactional: buttonStyles.buttonVariantTransactional
};
var Button = function Button(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'button' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'primary' : _c,
    children = _a.children,
    className = _a.className,
    isSmall = _a.isSmall,
    icon = _a.icon,
    width = _a.width,
    href = _a.href,
    _d = _a.target,
    target = _d === void 0 ? '_self' : _d,
    to = _a.to,
    disabled = _a.disabled,
    _e = _a.textTransform,
    textTransform = _e === void 0 ? 'all-caps' : _e,
    _f = _a.gaCategory,
    gaCategory = _f === void 0 ? '' : _f,
    _g = _a.gaLabel,
    gaLabel = _g === void 0 ? '' : _g,
    gaAction = _a.gaAction,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    emphasized = _a.emphasized,
    mediaPosition = _a.mediaPosition,
    _h = _a.wordBreak,
    wordBreak = _h === void 0 ? 'none' : _h,
    isDoubleText = _a.isDoubleText,
    iconBrand = _a.iconBrand,
    thirdPartyBackground = _a.thirdPartyBackground,
    _j = _a.ecRenewal,
    ecRenewal = _j === void 0 ? true : _j,
    props = __rest$1(_a, ["element", "variant", "children", "className", "isSmall", "icon", "width", "href", "target", "to", "disabled", "textTransform", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "emphasized", "mediaPosition", "wordBreak", "isDoubleText", "iconBrand", "thirdPartyBackground", "ecRenewal"]);
  var absoluteUrlPattern = href && isAbsoluteUrl(href);
  var attributes = {};
  if (absoluteUrlPattern) {
    Element = 'a';
    attributes = {
      href: href,
      target: target || '_blank'
    };
  } else if (href) {
    Element = Link$1;
    // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore
    attributes.to = href;
    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }
  var buttonStyles$1 = isSmall ? joinClasses(buttonStyles.buttonSmall, typographyStyles.buttonSmall) : typographyStyles.buttonLarge;
  var buttonWidthStyles = width === 'fitContent' ? joinClasses(buttonStyles.buttonFitToContent, isSmall && buttonStyles.buttonFitToContentSmall) : width === 'halfWidth' ? buttonStyles.buttonHalfWidth : '';
  var thirdPartyButtonStyles = variant === 'thirdParty' ? {
    backgroundColor: "#".concat(thirdPartyBackground)
  } : '';
  var getPositionClasses = function getPositionClasses(mediaPositionProp) {
    if (_typeof(mediaPositionProp) === 'object') {
      return joinClasses.apply(void 0, Object.keys(mediaPositionProp).reduce(function (acc, language) {
        var positionClassName = buttonStyles["button--media-position-".concat(mediaPositionProp[language], "-").concat(language)];
        return __spreadArray(__spreadArray([], acc, true), [positionClassName], false);
      }, []));
    }
    return buttonStyles["button--media-position-".concat(mediaPositionProp)];
  };
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var onClickHandler = function onClickHandler(e) {
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(buttonStyles.button, mediaPosition && getPositionClasses(mediaPosition), buttonStyles$1, variantToStyle[variant], buttonWidthStyles, interactionsStyles.cursorPointer, buttonStyles.buttonMaxWidthReset, textTransformStyles["text-transform-".concat(textTransform)], emphasized && typographyStyles.buttonEmphasized, addWordBreak(wordBreak === 'break-word'), isDoubleText && buttonStyles.buttonDoubleText, ecRenewal && variant !== 'thirdParty' && buttonStyles.buttonEcRenewal, ecRenewal && variant === 'secondary' && isSmall && buttonStyles.buttonEcRenewalSecondarySmall, className),
      style: __assign$1({}, thirdPartyButtonStyles),
      onClick: onClickHandler
    }, !disabled ? {
      href: href,
      target: target,
      to: to
    } : {}, {
      disabled: disabled
    }, gaProps, props, attributes), icon && (/*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
      variant: "inline",
      className: buttonStyles.buttonIcon
    })), /*#__PURE__*/createElement("span", {
      className: buttonStyles.buttonTextWrap
    }, children))
  );
};
Button.displayName = 'CoreButton';
Button.defaultProps = {
  emphasized: false,
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  isSmall: false,
  variant: 'primary',
  width: 'fullWidth'
};

var styles$e = {"button-floating":"fr-ec-button-floating","buttonFloating":"fr-ec-button-floating","button-floating__icon":"fr-ec-button-floating__icon","buttonFloatingIcon":"fr-ec-button-floating__icon","button-floating__label":"fr-ec-button-floating__label","buttonFloatingLabel":"fr-ec-button-floating__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","button-floating__icon-container":"fr-ec-button-floating__icon-container","buttonFloatingIconContainer":"fr-ec-button-floating__icon-container"};

var ButtonFloating = function ButtonFloating(_a) {
  var ariaLabel = _a.ariaLabel,
    children = _a.children,
    className = _a.className,
    Element = _a.element,
    icon = _a.icon,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["ariaLabel", "children", "className", "element", "icon", "iconBrand"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$e.buttonFloating, interactionsStyles.cursorPointer, className)
    }, props), /*#__PURE__*/createElement("div", {
      className: styles$e.buttonFloatingIconContainer
    }, /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
      className: styles$e.buttonFloatingIcon
    })), /*#__PURE__*/createElement(Caption, {
      element: "span",
      textTransform: "all-caps",
      variant: "small",
      className: styles$e.buttonFloatingLabel,
      "aria-label": ariaLabel
    }, children))
  );
};
ButtonFloating.displayName = 'CoreButtonFloating';

var styles$f = {"label":"fr-ec-label","label--color-primary-dark":"fr-ec-label--color-primary-dark","labelColorPrimaryDark":"fr-ec-label--color-primary-dark","label--color-primary-light":"fr-ec-label--color-primary-light","labelColorPrimaryLight":"fr-ec-label--color-primary-light","label--color-disabled":"fr-ec-label--color-disabled","labelColorDisabled":"fr-ec-label--color-disabled","label--color-secondary":"fr-ec-label--color-secondary","labelColorSecondary":"fr-ec-label--color-secondary"};

var labelStyles = {
  'extra-small': 'labelExtraSmall',
  large: 'labelLarge',
  small: 'labelSmall',
  'small-emphasized': 'labelSmallEmphasized',
  standard: 'labelStandard',
  'standard-emphasized': 'labelStandardEmphasized'
};
var alignmentClass$3 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Label = function Label(_a) {
  var Element = _a.element,
    _b = _a.variant,
    variant = _b === void 0 ? 'standard' : _b,
    _c = _a.color,
    color = _c === void 0 ? 'primary-dark' : _c,
    _d = _a.textAlign,
    textAlign = _d === void 0 ? 'left' : _d,
    className = _a.className,
    _e = _a.textTransform,
    textTransform = _e === void 0 ? 'normal' : _e,
    _f = _a.wordBreak,
    wordBreak = _f === void 0 ? 'none' : _f,
    strikethrough = _a.strikethrough,
    props = __rest$1(_a, ["element", "variant", "color", "textAlign", "className", "textTransform", "wordBreak", "strikethrough"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$f.label, styles$f["label--color-".concat(color)], typographyStyles[labelStyles[variant]], textAlignStyles[alignmentClass$3[textAlign]], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props, {
    "aria-disabled": color === 'disabled'
  }));
};
Label.displayName = 'CoreLabel';

var styles$g = {"button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","button-icon--dark":"fr-ec-button-icon--dark","buttonIconDark":"fr-ec-button-icon--dark","button-icon--light":"fr-ec-button-icon--light","buttonIconLight":"fr-ec-button-icon--light","button-icon--with-label":"fr-ec-button-icon--with-label","buttonIconWithLabel":"fr-ec-button-icon--with-label","button-icon__icon":"fr-ec-button-icon__icon","buttonIconIcon":"fr-ec-button-icon__icon","button-icon__icon-container":"fr-ec-button-icon__icon-container","buttonIconIconContainer":"fr-ec-button-icon__icon-container","button-icon__badge":"fr-ec-button-icon__badge","buttonIconBadge":"fr-ec-button-icon__badge","button-icon--disabled":"fr-ec-button-icon--disabled","buttonIconDisabled":"fr-ec-button-icon--disabled","button-icon__label":"fr-ec-button-icon__label","buttonIconLabel":"fr-ec-button-icon__label","button-icon__label--country-selector":"fr-ec-button-icon__label--country-selector","buttonIconLabelCountrySelector":"fr-ec-button-icon__label--country-selector","button-icon__label--country-selector-shadow":"fr-ec-button-icon__label--country-selector-shadow","buttonIconLabelCountrySelectorShadow":"fr-ec-button-icon__label--country-selector-shadow"};

var ButtonIcon = /*#__PURE__*/forwardRef(function (_a, ref) {
  var Element = _a.element,
    label = _a.label,
    icon = _a.icon,
    badge = _a.badge,
    _b = _a.variant,
    variant = _b === void 0 ? 'dark' : _b,
    hideLabel = _a.hideLabel,
    title = _a.title,
    disabled = _a.disabled,
    className = _a.className,
    iconSize = _a.iconSize,
    iconBrand = _a.iconBrand,
    iconColor = _a.iconColor,
    _c = _a.countrySelectorLabel,
    countrySelectorLabel = _c === void 0 ? false : _c,
    props = __rest$1(_a, ["element", "label", "icon", "badge", "variant", "hideLabel", "title", "disabled", "className", "iconSize", "iconBrand", "iconColor", "countrySelectorLabel"]);
  var showBadge = !disabled && badge;
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$g.buttonIcon, styles$g["button-icon--".concat(variant)], interactionsStyles.cursorPointer, disabled ? styles$g.buttonIconDisabled : '', hideLabel && label ? '' : styles$g.buttonIconWithLabel, className),
      title: title,
      ref: ref,
      "aria-label": hideLabel && label ? label : undefined,
      "aria-disabled": disabled,
      disabled: disabled
    }, props), /*#__PURE__*/createElement("div", {
      className: styles$g.buttonIconIconContainer
    }, /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
      className: styles$g.buttonIconIcon,
      title: title,
      size: iconSize,
      color: iconColor
    }), Boolean(showBadge) && (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Badge, {
      content: badge,
      iconBrand: iconBrand,
      className: styles$g.buttonIconBadge
    }))), !hideLabel && label && (countrySelectorLabel ? (/*#__PURE__*/createElement(Caption, {
      element: "span",
      textTransform: "all-caps",
      variant: "media-banner-copyright",
      color: disabled ? 'disabled' : variant === 'light' ? 'primary-light' : 'primary-dark',
      className: joinClasses(styles$g.buttonIconLabel, styles$g.buttonIconLabelCountrySelector, variant === 'light' && !disabled && styles$g.buttonIconLabelCountrySelectorShadow)
    }, label)) : (/*#__PURE__*/createElement(Label, {
      element: "span",
      variant: "extra-small",
      color: disabled ? 'disabled' : variant === 'light' ? 'primary-light' : 'primary-dark',
      className: styles$g.buttonIconLabel
    }, label))))
  );
});
ButtonIcon.displayName = 'CoreButtonIcon';
ButtonIcon.defaultProps = {
  disabled: false,
  hideLabel: false,
  title: '',
  variant: 'dark'
};

var styles$h = {"button-layout":"fr-ec-button-layout","buttonLayout":"fr-ec-button-layout","button-layout--small":"fr-ec-button-layout--small","buttonLayoutSmall":"fr-ec-button-layout--small","button-layout--button-plus-toggle":"fr-ec-button-layout--button-plus-toggle","buttonLayoutButtonPlusToggle":"fr-ec-button-layout--button-plus-toggle","button-layout--fluid":"fr-ec-button-layout--fluid","buttonLayoutFluid":"fr-ec-button-layout--fluid","button-layout--vertical":"fr-ec-button-layout--vertical","buttonLayoutVertical":"fr-ec-button-layout--vertical","button":"fr-ec-button","button-layout--horizontal":"fr-ec-button-layout--horizontal","buttonLayoutHorizontal":"fr-ec-button-layout--horizontal","button-layout--with-single-button":"fr-ec-button-layout--with-single-button","buttonLayoutWithSingleButton":"fr-ec-button-layout--with-single-button","button-layout--alignment-center":"fr-ec-button-layout--alignment-center","buttonLayoutAlignmentCenter":"fr-ec-button-layout--alignment-center","button-layout--alignment-left":"fr-ec-button-layout--alignment-left","buttonLayoutAlignmentLeft":"fr-ec-button-layout--alignment-left"};

var ButtonLayout = function ButtonLayout(_a) {
  var children = _a.children,
    _b = _a.variant,
    variant = _b === void 0 ? 'fluid' : _b,
    _c = _a.reverseOnVertical,
    reverseOnVertical = _c === void 0 ? false : _c,
    _d = _a.alignment,
    alignment = _d === void 0 ? 'center' : _d,
    className = _a.className,
    props = __rest$1(_a, ["children", "variant", "reverseOnVertical", "alignment", "className"]);
  var smallButtons = Children.toArray(children).filter(isValidElement).some(function (child) {
    return Boolean(child && child.props.isSmall);
  });
  var _e = useState(0),
    parentWidth = _e[0],
    setParentWidth = _e[1];
  return /*#__PURE__*/createElement(Measure, {
    bounds: true,
    onResize: function onResize(contentRect) {
      if (contentRect.bounds) {
        setParentWidth(contentRect.bounds.width);
      }
    }
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/createElement("div", __assign$1({}, props, {
      ref: measureRef
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$h.buttonLayout, styles$h["button-layout--".concat(variant !== 'buttonPlusToggle' ? variant : 'button-plus-toggle')], styles$h["button-layout--alignment-".concat(alignment)], smallButtons ? styles$h.buttonLayoutSmall : '', parentWidth < 504 && styles$h.buttonLayoutWithSingleButton, className)
    }, reverseOnVertical ? Children.toArray(children).reverse() : children));
  });
};
ButtonLayout.displayName = 'CoreButtonLayout';
ButtonLayout.defaultProps = {
  alignment: 'center',
  reverseOnVertical: false,
  variant: 'fluid'
};

var styles$i = {"icon-toggle":"fr-ec-icon-toggle","iconToggle":"fr-ec-icon-toggle","icon-toggle--heart-filled":"fr-ec-icon-toggle--heart-filled","iconToggleHeartFilled":"fr-ec-icon-toggle--heart-filled","icon-state--on":"fr-ec-icon-state--on","iconStateOn":"fr-ec-icon-state--on","icon-toggle-heart":"fr-ec-icon-toggle-heart","iconToggleHeart":"fr-ec-icon-toggle-heart","icon-state--disabled":"fr-ec-icon-state--disabled","iconStateDisabled":"fr-ec-icon-state--disabled","icon-toggle--heart-toggle":"fr-ec-icon-toggle--heart-toggle","iconToggleHeartToggle":"fr-ec-icon-toggle--heart-toggle","icon-toggle--thumbs-up-toggle":"fr-ec-icon-toggle--thumbs-up-toggle","iconToggleThumbsUpToggle":"fr-ec-icon-toggle--thumbs-up-toggle"};

var IconToggle = function IconToggle(_a) {
  var name = _a.name,
    className = _a.className,
    _b = _a.disabled,
    disabled = _b === void 0 ? false : _b,
    _c = _a.isToggled,
    isToggled = _c === void 0 ? false : _c,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["name", "className", "disabled", "isToggled", "iconBrand"]);
  var icon = name === 'heart' ? isToggled ? 'heart-filled' : name : name;
  var iconClassName = styles$i["icon-toggle--".concat(icon)];
  var classNames = joinClasses(styles$i.iconToggle, iconClassName, disabled ? styles$i.iconStateDisabled : '', isToggled ? styles$i.iconStateOn : '', className);
  return /*#__PURE__*/createElement(Icon, __assign$1({
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
    className: classNames
  }, props));
};

var styles$j = {"button-toggle":"fr-ec-button-toggle","buttonToggle":"fr-ec-button-toggle","button--variant-secondary":"fr-ec-button--variant-secondary","buttonVariantSecondary":"fr-ec-button--variant-secondary","button-toggle--with-icon-wrapper":"fr-ec-button-toggle--with-icon-wrapper","buttonToggleWithIconWrapper":"fr-ec-button-toggle--with-icon-wrapper","button-toggle--with-icon":"fr-ec-button-toggle--with-icon","buttonToggleWithIcon":"fr-ec-button-toggle--with-icon","button-toggle--with--count-center":"fr-ec-button-toggle--with--count-center","buttonToggleWithCountCenter":"fr-ec-button-toggle--with--count-center","button-toggle--icon":"fr-ec-button-toggle--icon","buttonToggleIcon":"fr-ec-button-toggle--icon","button-toggle--with-label":"fr-ec-button-toggle--with-label","buttonToggleWithLabel":"fr-ec-button-toggle--with-label","button-toggle--with-label-selected":"fr-ec-button-toggle--with-label-selected","buttonToggleWithLabelSelected":"fr-ec-button-toggle--with-label-selected","button-toggle--text":"fr-ec-button-toggle--text","buttonToggleText":"fr-ec-button-toggle--text","button-toggle-ec-renewal":"fr-ec-button-toggle-ec-renewal","buttonToggleEcRenewal":"fr-ec-button-toggle-ec-renewal","button-tooggle--on-state":"fr-ec-button-tooggle--on-state","buttonTooggleOnState":"fr-ec-button-tooggle--on-state","button-toggle__count-text":"fr-ec-button-toggle__count-text","buttonToggleCountText":"fr-ec-button-toggle__count-text","button-toggle--icon-only":"fr-ec-button-toggle--icon-only","buttonToggleIconOnly":"fr-ec-button-toggle--icon-only","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","button-toggle--label-text":"fr-ec-button-toggle--label-text","buttonToggleLabelText":"fr-ec-button-toggle--label-text","label":"fr-ec-label","borderIn":"fr-ec-borderIn","button-toggle__count-text--bottom":"fr-ec-button-toggle__count-text--bottom","buttonToggleCountTextBottom":"fr-ec-button-toggle__count-text--bottom","button-toggle--label-with-icon":"fr-ec-button-toggle--label-with-icon","buttonToggleLabelWithIcon":"fr-ec-button-toggle--label-with-icon","button-toggle--label-with-icon-label":"fr-ec-button-toggle--label-with-icon-label","buttonToggleLabelWithIconLabel":"fr-ec-button-toggle--label-with-icon-label","button-toggle--label-with-icon-icon":"fr-ec-button-toggle--label-with-icon-icon","buttonToggleLabelWithIconIcon":"fr-ec-button-toggle--label-with-icon-icon","button-toogle--icon-toggle-all":"fr-ec-button-toogle--icon-toggle-all","buttonToogleIconToggleAll":"fr-ec-button-toogle--icon-toggle-all","button-toggle__alignment-center":"fr-ec-button-toggle__alignment-center","buttonToggleAlignmentCenter":"fr-ec-button-toggle__alignment-center","button-layout":"fr-ec-button-layout","buttonLayout":"fr-ec-button-layout","icon-toggle":"fr-ec-icon-toggle","iconToggle":"fr-ec-icon-toggle","icon-state--disabled":"fr-ec-icon-state--disabled","iconStateDisabled":"fr-ec-icon-state--disabled","icon-toggle--heart-filled":"fr-ec-icon-toggle--heart-filled","iconToggleHeartFilled":"fr-ec-icon-toggle--heart-filled","icon":"fr-ec-icon"};

var iconVariation = function iconVariation(_a, hasLabel, iconWithCount) {
  var className = _a.className,
    icon = _a.icon,
    text = _a.text,
    isToggled = _a.isToggled,
    iconTitle = _a.iconTitle,
    ariaLabel = _a.ariaLabel,
    count = _a.count,
    _b = _a.alignment,
    alignment = _b === void 0 ? 'none' : _b,
    props = __rest$1(_a, ["className", "icon", "text", "isToggled", "children", "iconTitle", "ariaLabel", "count", "alignment"]);
  return /*#__PURE__*/createElement("button", __assign$1({
    className: joinClasses(styles$j.buttonToggle, styles$j.buttonToggleWithIcon, !hasLabel && styles$j.buttonToggleIconOnly, interactionsStyles.cursorPointer, count && styles$j.buttonToogleIconToggleAll, alignment === 'center' && styles$j.buttonToggleAlignmentCenter, iconWithCount && styles$j.buttonToggleWithCountCenter, className)
  }, props, {
    "aria-label": ariaLabel || text,
    "aria-pressed": isToggled
  }), /*#__PURE__*/createElement(IconToggle, {
    name: icon,
    disabled: props.disabled,
    isToggled: isToggled,
    title: iconTitle,
    className: styles$j.buttonToggleIcon,
    iconBrand: props.iconBrand
  }), hasLabel && text && (/*#__PURE__*/createElement(Label, {
    element: "span",
    variant: isToggled ? 'small-emphasized' : 'small',
    className: styles$j.buttonToggleLabelText,
    title: typeof text === 'string' ? text : ''
  }, text)), count && (/*#__PURE__*/createElement(Label, {
    element: "span",
    variant: iconWithCount ? 'extra-small' : 'small',
    className: joinClasses(styles$j.buttonToggleCountText, iconWithCount && styles$j.buttonToggleCountTextBottom)
  }, count)));
};
var buttonVariation = function buttonVariation(_a, hasLabel) {
  var className = _a.className,
    icon = _a.icon,
    text = _a.text,
    isToggled = _a.isToggled,
    iconTitle = _a.iconTitle,
    ariaLabel = _a.ariaLabel,
    id = _a.id,
    props = __rest$1(_a, ["className", "icon", "text", "isToggled", "children", "iconTitle", "ariaLabel", "id"]);
  var labelId = id ? "".concat(id, "-label") : 'button-toggle-label';
  return /*#__PURE__*/createElement("button", __assign$1({
    className: joinClasses(styles$j.buttonToggle, buttonStyles.button, buttonStyles.buttonVariantSecondary, interactionsStyles.cursorPointer, !hasLabel && styles$j.buttonToggleWithIconWrapper, className),
    id: id
  }, props, {
    "aria-pressed": isToggled
  }, Boolean(ariaLabel) && {
    'aria-label': ariaLabel
  } || {
    'aria-labelledby': labelId
  }), /*#__PURE__*/createElement(IconToggle, {
    name: icon,
    disabled: props.disabled,
    isToggled: isToggled,
    title: iconTitle,
    className: styles$j.buttonToggleWithIcon,
    iconBrand: props.iconBrand
  }), text && hasLabel && (/*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "large",
    className: styles$j.buttonToggleText,
    id: labelId
  }, text)));
};
var getVariant = {
  button: function button(props) {
    return buttonVariation(props, true);
  },
  buttonSquare: function buttonSquare(props) {
    return buttonVariation(props, false);
  },
  icon: function icon(props) {
    return iconVariation(props, false, true);
  },
  iconToggleAll: function iconToggleAll(props) {
    return iconVariation(props, true, false);
  },
  iconWithLabel: function iconWithLabel(props) {
    return iconVariation(props, true, false);
  },
  labelWithIcon: function labelWithIcon(_a) {
    var className = _a.className,
      text = _a.text,
      icon = _a.icon,
      iconTitle = _a.iconTitle,
      isToggled = _a.isToggled,
      ariaLabel = _a.ariaLabel,
      props = __rest$1(_a, ["className", "text", "icon", "iconTitle", "isToggled", "ariaLabel", "id"]);
    return /*#__PURE__*/createElement("button", __assign$1({
      className: joinClasses(styles$j.buttonToggle, styles$j.buttonToggleWithIcon, interactionsStyles.cursorPointer, styles$j.buttonToggleLabelWithIcon, className)
    }, props, {
      "aria-label": ariaLabel || text,
      "aria-pressed": isToggled
    }), /*#__PURE__*/createElement("span", {
      className: joinClasses(styles$j.buttonToggleLabelWithIconLabel, typographyStyles.chipStandard)
    }, typeof text === 'string' ? text : ''), /*#__PURE__*/createElement(IconToggle, {
      name: icon,
      disabled: props.disabled,
      isToggled: isToggled,
      title: iconTitle,
      className: styles$j.buttonToggleLabelWithIconIcon,
      iconBrand: props.iconBrand
    }));
  },
  toggleWithOnlyLabel: function toggleWithOnlyLabel(_a) {
    var className = _a.className,
      text = _a.text,
      isToggled = _a.isToggled,
      ariaLabel = _a.ariaLabel,
      count = _a.count,
      id = _a.id,
      _b = _a.ecRenewal,
      ecRenewal = _b === void 0 ? false : _b,
      props = __rest$1(_a, ["className", "text", "isToggled", "children", "ariaLabel", "count", "id", "ecRenewal"]);
    var labelId = id ? "".concat(id, "-label") : 'button-toggle-label';
    return /*#__PURE__*/createElement("button", __assign$1({
      className: joinClasses(styles$j.buttonToggle, styles$j.buttonToggleWithLabel, !ecRenewal && isToggled && styles$j.buttonTooggleOnState, buttonStyles.button, !ecRenewal && !isToggled && buttonStyles.buttonVariantSecondary, !ecRenewal && isToggled && buttonStyles.buttonVariantPrimary, ecRenewal && buttonStyles.buttonVariantSecondary, ecRenewal && isToggled && styles$j.buttonToggleWithLabelSelected, interactionsStyles.cursorPointer, ecRenewal && styles$j.buttonToggleEcRenewal, className),
      id: id
    }, props, {
      "aria-pressed": isToggled
    }, Boolean(ariaLabel) && {
      'aria-label': ariaLabel
    } || {
      'aria-labelledby': labelId
    }), text && (/*#__PURE__*/createElement(Label, {
      element: "span",
      variant: ecRenewal ? 'small' : 'small-emphasized',
      className: styles$j.buttonToggleText,
      id: labelId
    }, text)), count && (/*#__PURE__*/createElement(Label, {
      element: "span",
      variant: "small",
      className: styles$j.buttonToggleCountText
    }, count)));
  }
};
var ButtonToggle = function ButtonToggle(_a) {
  var variant = _a.variant,
    props = __rest$1(_a, ["variant"]);
  return getVariant[variant](props);
};
ButtonToggle.displayName = 'CoreButtonToggle';
ButtonToggle.defaultProps = {
  variant: 'button'
};

var styles$k = {"card":"fr-ec-card","card--border-normal":"fr-ec-card--border-normal","cardBorderNormal":"fr-ec-card--border-normal","card--border-strong":"fr-ec-card--border-strong","cardBorderStrong":"fr-ec-card--border-strong","card--background":"fr-ec-card--background","cardBackground":"fr-ec-card--background"};

var Card = function Card(_a) {
  var className = _a.className,
    Element = _a.element,
    children = _a.children,
    variant = _a.variant,
    _b = _a.borderColor,
    borderColor = _b === void 0 ? 'normal' : _b,
    props = __rest$1(_a, ["className", "element", "children", "variant", "borderColor"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({}, props, {
      className: joinClasses(styles$k.card, variant === 'background' ? styles$k.cardBackground : styles$k["card--border-".concat(borderColor)], className)
    }), children)
  );
};
Card.displayName = 'CoreCard';
Card.defaultProps = {
  variant: 'border'
};

var styles$l = {"icon-typography__icon--attention":"fr-ec-icon-typography__icon--attention","iconTypographyIconAttention":"fr-ec-icon-typography__icon--attention","icon-typography__icon--disabled":"fr-ec-icon-typography__icon--disabled","iconTypographyIconDisabled":"fr-ec-icon-typography__icon--disabled","icon-typography__icon--positive":"fr-ec-icon-typography__icon--positive","iconTypographyIconPositive":"fr-ec-icon-typography__icon--positive","icon-typography__icon--start":"fr-ec-icon-typography__icon--start","iconTypographyIconStart":"fr-ec-icon-typography__icon--start","icon-typography__icon--end":"fr-ec-icon-typography__icon--end","iconTypographyIconEnd":"fr-ec-icon-typography__icon--end","icon-typography__content-spacing--with-tooltip":"fr-ec-icon-typography__content-spacing--with-tooltip","iconTypographyContentSpacingWithTooltip":"fr-ec-icon-typography__content-spacing--with-tooltip"};

var IconTypography = function IconTypography(_a) {
  var icon = _a.icon,
    _b = _a.iconPosition,
    iconPosition = _b === void 0 ? 'start' : _b,
    _c = _a.iconColor,
    iconColor = _c === void 0 ? 'standard' : _c,
    children = _a.children,
    toolTip = _a.toolTip,
    className = _a.className,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["icon", "iconPosition", "iconColor", "children", "toolTip", "className", "iconBrand"]);
  var iconTemplate = icon ? (/*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
    size: "24",
    className: joinClasses(styles$l["icon-typography__icon--".concat(iconPosition)], styles$l["icon-typography__icon--".concat(iconColor)])
  })) : toolTip;
  var renderChildren = /*#__PURE__*/createElement("div", {
    className: icon ? '' : styles$l.iconTypographyContentSpacingWithTooltip
  }, children);
  var renderedItems = iconPosition === 'end' ? (/*#__PURE__*/createElement(Fragment, null, renderChildren, " ", iconTemplate)) : (/*#__PURE__*/createElement(Fragment, null, iconTemplate, " ", renderChildren));
  var iconTypography = toolTip ? (/*#__PURE__*/createElement(ContentAlignment, __assign$1({
    className: className,
    element: "span",
    direction: "row",
    alignment: "center"
  }, props), renderedItems)) : (/*#__PURE__*/createElement(ContentAlignment, __assign$1({
    className: className,
    element: "span",
    direction: "row",
    alignment: "flex-start"
  }, props), renderedItems));
  return iconTypography;
};
IconTypography.displayName = 'CoreIconTypography';
IconTypography.defaultProps = {
  iconColor: 'standard',
  iconPosition: 'start'
};

var styles$m = {"store-bar":"fr-ec-store-bar","storeBar":"fr-ec-store-bar","store-bar__wrapper":"fr-ec-store-bar__wrapper","storeBarWrapper":"fr-ec-store-bar__wrapper","store-bar--ec-renewal":"fr-ec-store-bar--ec-renewal","storeBarEcRenewal":"fr-ec-store-bar--ec-renewal","store-bar__search":"fr-ec-store-bar__search","storeBarSearch":"fr-ec-store-bar__search","store-bar__icon-typography":"fr-ec-store-bar__icon-typography","storeBarIconTypography":"fr-ec-store-bar__icon-typography","store-bar__store-name":"fr-ec-store-bar__store-name","storeBarStoreName":"fr-ec-store-bar__store-name"};

var StoreBar = function StoreBar(_a) {
  var searchLabel = _a.searchLabel,
    placeholder = _a.placeholder,
    icon = _a.icon,
    storeName = _a.storeName,
    onClick = _a.onClick,
    iconBrand = _a.iconBrand,
    ecRenewal = _a.ecRenewal;
  var storeNameField = /*#__PURE__*/createElement(Caption, {
    color: "primary-dark",
    element: "p",
    textAlign: "left",
    textTransform: "normal",
    variant: "standard",
    className: styles$m.storeBarStoreName
  }, storeName);
  var placeholderField = /*#__PURE__*/createElement(Caption, {
    color: "secondary",
    element: "p",
    textAlign: "left",
    textTransform: "normal",
    variant: "standard"
  }, placeholder);
  return /*#__PURE__*/createElement("div", {
    className: styles$m.storeBar
  }, /*#__PURE__*/createElement(Card, {
    element: "div",
    variant: "background",
    borderColor: "normal",
    className: joinClasses(styles$m.storeBarWrapper, ecRenewal && styles$m.storeBarEcRenewal)
  }, /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    justifyContent: "space-between"
  }, (ecRenewal ? icon : storeName) && (/*#__PURE__*/createElement(IconTypography, {
    icon: icon,
    iconBrand: iconBrand,
    iconPosition: "start",
    className: styles$m.storeBarIconTypography
  }, ecRenewal ? storeName ? storeNameField : placeholder && placeholderField : storeName && storeNameField)), !ecRenewal && !storeName && placeholder && placeholderField, /*#__PURE__*/createElement(Body, {
    variant: ecRenewal ? 'small' : 'small-underlined',
    element: "button",
    onClick: onClick,
    className: joinClasses(styles$m.storeBarSearch, resetStyles.buttonReset)
  }, searchLabel))));
};
StoreBar.displayName = 'CoreStoreBar';

var swiper = createCommonjsModule(function (module, exports) {
  /**
   * Swiper 4.5.1
   * Most modern mobile touch slider and framework with hardware accelerated transitions
   * http://www.idangero.us/swiper/
   *
   * Copyright 2014-2019 Vladimir Kharlampidi
   *
   * Released under the MIT License
   *
   * Released on: September 13, 2019
   */

  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {

    /**
     * SSR Window 1.0.1
     * Better handling for window object in SSR environment
     * https://github.com/nolimits4web/ssr-window
     *
     * Copyright 2018, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: July 18, 2018
     */
    var doc = typeof document === 'undefined' ? {
      body: {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {},
      activeElement: {
        blur: function blur() {},
        nodeName: ''
      },
      querySelector: function querySelector() {
        return null;
      },
      querySelectorAll: function querySelectorAll() {
        return [];
      },
      getElementById: function getElementById() {
        return null;
      },
      createEvent: function createEvent() {
        return {
          initEvent: function initEvent() {}
        };
      },
      createElement: function createElement() {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute: function setAttribute() {},
          getElementsByTagName: function getElementsByTagName() {
            return [];
          }
        };
      },
      location: {
        hash: ''
      }
    } : document; // eslint-disable-line

    var win = typeof window === 'undefined' ? {
      document: doc,
      navigator: {
        userAgent: ''
      },
      location: {},
      history: {},
      CustomEvent: function CustomEvent() {
        return this;
      },
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {},
      getComputedStyle: function getComputedStyle() {
        return {
          getPropertyValue: function getPropertyValue() {
            return '';
          }
        };
      },
      Image: function Image() {},
      Date: function Date() {},
      screen: {},
      setTimeout: function setTimeout() {},
      clearTimeout: function clearTimeout() {}
    } : window; // eslint-disable-line

    /**
     * Dom7 2.1.3
     * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
     * http://framework7.io/docs/dom.html
     *
     * Copyright 2019, Vladimir Kharlampidi
     * The iDangero.us
     * http://www.idangero.us/
     *
     * Licensed under MIT
     *
     * Released on: February 11, 2019
     */

    var Dom7 = function Dom7(arr) {
      var self = this;
      // Create array-like object
      for (var i = 0; i < arr.length; i += 1) {
        self[i] = arr[i];
      }
      self.length = arr.length;
      // Return collection with methods
      return this;
    };
    function $(selector, context) {
      var arr = [];
      var i = 0;
      if (selector && !context) {
        if (selector instanceof Dom7) {
          return selector;
        }
      }
      if (selector) {
        // String
        if (typeof selector === 'string') {
          var els;
          var tempParent;
          var html = selector.trim();
          if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            var toCreate = 'div';
            if (html.indexOf('<li') === 0) {
              toCreate = 'ul';
            }
            if (html.indexOf('<tr') === 0) {
              toCreate = 'tbody';
            }
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) {
              toCreate = 'tr';
            }
            if (html.indexOf('<tbody') === 0) {
              toCreate = 'table';
            }
            if (html.indexOf('<option') === 0) {
              toCreate = 'select';
            }
            tempParent = doc.createElement(toCreate);
            tempParent.innerHTML = html;
            for (i = 0; i < tempParent.childNodes.length; i += 1) {
              arr.push(tempParent.childNodes[i]);
            }
          } else {
            if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
              // Pure ID selector
              els = [doc.getElementById(selector.trim().split('#')[1])];
            } else {
              // Other selectors
              els = (context || doc).querySelectorAll(selector.trim());
            }
            for (i = 0; i < els.length; i += 1) {
              if (els[i]) {
                arr.push(els[i]);
              }
            }
          }
        } else if (selector.nodeType || selector === win || selector === doc) {
          // Node/element
          arr.push(selector);
        } else if (selector.length > 0 && selector[0].nodeType) {
          // Array of elements or instance of Dom
          for (i = 0; i < selector.length; i += 1) {
            arr.push(selector[i]);
          }
        }
      }
      return new Dom7(arr);
    }
    $.fn = Dom7.prototype;
    $.Class = Dom7;
    $.Dom7 = Dom7;
    function unique(arr) {
      var uniqueArray = [];
      for (var i = 0; i < arr.length; i += 1) {
        if (uniqueArray.indexOf(arr[i]) === -1) {
          uniqueArray.push(arr[i]);
        }
      }
      return uniqueArray;
    }

    // Classes and attributes
    function addClass(className) {
      if (typeof className === 'undefined') {
        return this;
      }
      var classes = className.split(' ');
      for (var i = 0; i < classes.length; i += 1) {
        for (var j = 0; j < this.length; j += 1) {
          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
            this[j].classList.add(classes[i]);
          }
        }
      }
      return this;
    }
    function removeClass(className) {
      var classes = className.split(' ');
      for (var i = 0; i < classes.length; i += 1) {
        for (var j = 0; j < this.length; j += 1) {
          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
            this[j].classList.remove(classes[i]);
          }
        }
      }
      return this;
    }
    function hasClass(className) {
      if (!this[0]) {
        return false;
      }
      return this[0].classList.contains(className);
    }
    function toggleClass(className) {
      var classes = className.split(' ');
      for (var i = 0; i < classes.length; i += 1) {
        for (var j = 0; j < this.length; j += 1) {
          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
            this[j].classList.toggle(classes[i]);
          }
        }
      }
      return this;
    }
    function attr(attrs, value) {
      var arguments$1 = arguments;
      if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) {
          return this[0].getAttribute(attrs);
        }
        return undefined;
      }

      // Set attrs
      for (var i = 0; i < this.length; i += 1) {
        if (arguments$1.length === 2) {
          // String
          this[i].setAttribute(attrs, value);
        } else {
          // Object
          // eslint-disable-next-line
          for (var attrName in attrs) {
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
          }
        }
      }
      return this;
    }
    // eslint-disable-next-line
    function removeAttr(attr) {
      for (var i = 0; i < this.length; i += 1) {
        this[i].removeAttribute(attr);
      }
      return this;
    }
    function data(key, value) {
      var el;
      if (typeof value === 'undefined') {
        el = this[0];
        // Get value
        if (el) {
          if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
            return el.dom7ElementDataStorage[key];
          }
          var dataKey = el.getAttribute("data-" + key);
          if (dataKey) {
            return dataKey;
          }
          return undefined;
        }
        return undefined;
      }

      // Set value
      for (var i = 0; i < this.length; i += 1) {
        el = this[i];
        if (!el.dom7ElementDataStorage) {
          el.dom7ElementDataStorage = {};
        }
        el.dom7ElementDataStorage[key] = value;
      }
      return this;
    }
    // Transforms
    // eslint-disable-next-line
    function transform(transform) {
      for (var i = 0; i < this.length; i += 1) {
        var elStyle = this[i].style;
        elStyle.webkitTransform = transform;
        elStyle.transform = transform;
      }
      return this;
    }
    function transition(duration) {
      if (typeof duration !== 'string') {
        duration = duration + "ms"; // eslint-disable-line
      }
      for (var i = 0; i < this.length; i += 1) {
        var elStyle = this[i].style;
        elStyle.webkitTransitionDuration = duration;
        elStyle.transitionDuration = duration;
      }
      return this;
    }
    // Events
    function on() {
      var assign;
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];
      var eventType = args[0];
      var targetSelector = args[1];
      var listener = args[2];
      var capture = args[3];
      if (typeof args[1] === 'function') {
        assign = args, eventType = assign[0], listener = assign[1], capture = assign[2];
        targetSelector = undefined;
      }
      if (!capture) {
        capture = false;
      }
      function handleLiveEvent(e) {
        var target = e.target;
        if (!target) {
          return;
        }
        var eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        if ($(target).is(targetSelector)) {
          listener.apply(target, eventData);
        } else {
          var parents = $(target).parents(); // eslint-disable-line
          for (var k = 0; k < parents.length; k += 1) {
            if ($(parents[k]).is(targetSelector)) {
              listener.apply(parents[k], eventData);
            }
          }
        }
      }
      function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }
        listener.apply(this, eventData);
      }
      var events = eventType.split(' ');
      var j;
      for (var i = 0; i < this.length; i += 1) {
        var el = this[i];
        if (!targetSelector) {
          for (j = 0; j < events.length; j += 1) {
            var event = events[j];
            if (!el.dom7Listeners) {
              el.dom7Listeners = {};
            }
            if (!el.dom7Listeners[event]) {
              el.dom7Listeners[event] = [];
            }
            el.dom7Listeners[event].push({
              listener: listener,
              proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
          }
        } else {
          // Live events
          for (j = 0; j < events.length; j += 1) {
            var event$1 = events[j];
            if (!el.dom7LiveListeners) {
              el.dom7LiveListeners = {};
            }
            if (!el.dom7LiveListeners[event$1]) {
              el.dom7LiveListeners[event$1] = [];
            }
            el.dom7LiveListeners[event$1].push({
              listener: listener,
              proxyListener: handleLiveEvent
            });
            el.addEventListener(event$1, handleLiveEvent, capture);
          }
        }
      }
      return this;
    }
    function off() {
      var assign;
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];
      var eventType = args[0];
      var targetSelector = args[1];
      var listener = args[2];
      var capture = args[3];
      if (typeof args[1] === 'function') {
        assign = args, eventType = assign[0], listener = assign[1], capture = assign[2];
        targetSelector = undefined;
      }
      if (!capture) {
        capture = false;
      }
      var events = eventType.split(' ');
      for (var i = 0; i < events.length; i += 1) {
        var event = events[i];
        for (var j = 0; j < this.length; j += 1) {
          var el = this[j];
          var handlers = void 0;
          if (!targetSelector && el.dom7Listeners) {
            handlers = el.dom7Listeners[event];
          } else if (targetSelector && el.dom7LiveListeners) {
            handlers = el.dom7LiveListeners[event];
          }
          if (handlers && handlers.length) {
            for (var k = handlers.length - 1; k >= 0; k -= 1) {
              var handler = handlers[k];
              if (listener && handler.listener === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (!listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              }
            }
          }
        }
      }
      return this;
    }
    function trigger() {
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];
      var events = args[0].split(' ');
      var eventData = args[1];
      for (var i = 0; i < events.length; i += 1) {
        var event = events[i];
        for (var j = 0; j < this.length; j += 1) {
          var el = this[j];
          var evt = void 0;
          try {
            evt = new win.CustomEvent(event, {
              detail: eventData,
              bubbles: true,
              cancelable: true
            });
          } catch (e) {
            evt = doc.createEvent('Event');
            evt.initEvent(event, true, true);
            evt.detail = eventData;
          }
          // eslint-disable-next-line
          el.dom7EventData = args.filter(function (data, dataIndex) {
            return dataIndex > 0;
          });
          el.dispatchEvent(evt);
          el.dom7EventData = [];
          delete el.dom7EventData;
        }
      }
      return this;
    }
    function transitionEnd(callback) {
      var events = ['webkitTransitionEnd', 'transitionend'];
      var dom = this;
      var i;
      function fireCallBack(e) {
        /* jshint validthis:true */
        if (e.target !== this) {
          return;
        }
        callback.call(this, e);
        for (i = 0; i < events.length; i += 1) {
          dom.off(events[i], fireCallBack);
        }
      }
      if (callback) {
        for (i = 0; i < events.length; i += 1) {
          dom.on(events[i], fireCallBack);
        }
      }
      return this;
    }
    function outerWidth(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          // eslint-disable-next-line
          var styles = this.styles();
          return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
      }
      return null;
    }
    function outerHeight(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          // eslint-disable-next-line
          var styles = this.styles();
          return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
      }
      return null;
    }
    function offset() {
      if (this.length > 0) {
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = doc.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === win ? win.scrollY : el.scrollTop;
        var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
        return {
          top: box.top + scrollTop - clientTop,
          left: box.left + scrollLeft - clientLeft
        };
      }
      return null;
    }
    function styles() {
      if (this[0]) {
        return win.getComputedStyle(this[0], null);
      }
      return {};
    }
    function css(props, value) {
      var i;
      if (arguments.length === 1) {
        if (typeof props === 'string') {
          if (this[0]) {
            return win.getComputedStyle(this[0], null).getPropertyValue(props);
          }
        } else {
          for (i = 0; i < this.length; i += 1) {
            // eslint-disable-next-line
            for (var prop in props) {
              this[i].style[prop] = props[prop];
            }
          }
          return this;
        }
      }
      if (arguments.length === 2 && typeof props === 'string') {
        for (i = 0; i < this.length; i += 1) {
          this[i].style[props] = value;
        }
        return this;
      }
      return this;
    }
    // Iterate over the collection passing elements to `callback`
    function each(callback) {
      // Don't bother continuing without a callback
      if (!callback) {
        return this;
      }
      // Iterate over the current collection
      for (var i = 0; i < this.length; i += 1) {
        // If the callback returns false
        if (callback.call(this[i], i, this[i]) === false) {
          // End the loop early
          return this;
        }
      }
      // Return `this` to allow chained DOM operations
      return this;
    }
    // eslint-disable-next-line
    function html(html) {
      if (typeof html === 'undefined') {
        return this[0] ? this[0].innerHTML : undefined;
      }
      for (var i = 0; i < this.length; i += 1) {
        this[i].innerHTML = html;
      }
      return this;
    }
    // eslint-disable-next-line
    function text(text) {
      if (typeof text === 'undefined') {
        if (this[0]) {
          return this[0].textContent.trim();
        }
        return null;
      }
      for (var i = 0; i < this.length; i += 1) {
        this[i].textContent = text;
      }
      return this;
    }
    function is(selector) {
      var el = this[0];
      var compareWith;
      var i;
      if (!el || typeof selector === 'undefined') {
        return false;
      }
      if (typeof selector === 'string') {
        if (el.matches) {
          return el.matches(selector);
        } else if (el.webkitMatchesSelector) {
          return el.webkitMatchesSelector(selector);
        } else if (el.msMatchesSelector) {
          return el.msMatchesSelector(selector);
        }
        compareWith = $(selector);
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) {
            return true;
          }
        }
        return false;
      } else if (selector === doc) {
        return el === doc;
      } else if (selector === win) {
        return el === win;
      }
      if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [selector] : selector;
        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) {
            return true;
          }
        }
        return false;
      }
      return false;
    }
    function index() {
      var child = this[0];
      var i;
      if (child) {
        i = 0;
        // eslint-disable-next-line
        while ((child = child.previousSibling) !== null) {
          if (child.nodeType === 1) {
            i += 1;
          }
        }
        return i;
      }
      return undefined;
    }
    // eslint-disable-next-line
    function eq(index) {
      if (typeof index === 'undefined') {
        return this;
      }
      var length = this.length;
      var returnIndex;
      if (index > length - 1) {
        return new Dom7([]);
      }
      if (index < 0) {
        returnIndex = length + index;
        if (returnIndex < 0) {
          return new Dom7([]);
        }
        return new Dom7([this[returnIndex]]);
      }
      return new Dom7([this[index]]);
    }
    function append() {
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];
      var newChild;
      for (var k = 0; k < args.length; k += 1) {
        newChild = args[k];
        for (var i = 0; i < this.length; i += 1) {
          if (typeof newChild === 'string') {
            var tempDiv = doc.createElement('div');
            tempDiv.innerHTML = newChild;
            while (tempDiv.firstChild) {
              this[i].appendChild(tempDiv.firstChild);
            }
          } else if (newChild instanceof Dom7) {
            for (var j = 0; j < newChild.length; j += 1) {
              this[i].appendChild(newChild[j]);
            }
          } else {
            this[i].appendChild(newChild);
          }
        }
      }
      return this;
    }
    function prepend(newChild) {
      var i;
      var j;
      for (i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;
          for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
          }
        } else if (newChild instanceof Dom7) {
          for (j = 0; j < newChild.length; j += 1) {
            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
          }
        } else {
          this[i].insertBefore(newChild, this[i].childNodes[0]);
        }
      }
      return this;
    }
    function next(selector) {
      if (this.length > 0) {
        if (selector) {
          if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
            return new Dom7([this[0].nextElementSibling]);
          }
          return new Dom7([]);
        }
        if (this[0].nextElementSibling) {
          return new Dom7([this[0].nextElementSibling]);
        }
        return new Dom7([]);
      }
      return new Dom7([]);
    }
    function nextAll(selector) {
      var nextEls = [];
      var el = this[0];
      if (!el) {
        return new Dom7([]);
      }
      while (el.nextElementSibling) {
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
          if ($(next).is(selector)) {
            nextEls.push(next);
          }
        } else {
          nextEls.push(next);
        }
        el = next;
      }
      return new Dom7(nextEls);
    }
    function prev(selector) {
      if (this.length > 0) {
        var el = this[0];
        if (selector) {
          if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
            return new Dom7([el.previousElementSibling]);
          }
          return new Dom7([]);
        }
        if (el.previousElementSibling) {
          return new Dom7([el.previousElementSibling]);
        }
        return new Dom7([]);
      }
      return new Dom7([]);
    }
    function prevAll(selector) {
      var prevEls = [];
      var el = this[0];
      if (!el) {
        return new Dom7([]);
      }
      while (el.previousElementSibling) {
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
          if ($(prev).is(selector)) {
            prevEls.push(prev);
          }
        } else {
          prevEls.push(prev);
        }
        el = prev;
      }
      return new Dom7(prevEls);
    }
    function parent(selector) {
      var parents = []; // eslint-disable-line
      for (var i = 0; i < this.length; i += 1) {
        if (this[i].parentNode !== null) {
          if (selector) {
            if ($(this[i].parentNode).is(selector)) {
              parents.push(this[i].parentNode);
            }
          } else {
            parents.push(this[i].parentNode);
          }
        }
      }
      return $(unique(parents));
    }
    function parents(selector) {
      var parents = []; // eslint-disable-line
      for (var i = 0; i < this.length; i += 1) {
        var parent = this[i].parentNode; // eslint-disable-line
        while (parent) {
          if (selector) {
            if ($(parent).is(selector)) {
              parents.push(parent);
            }
          } else {
            parents.push(parent);
          }
          parent = parent.parentNode;
        }
      }
      return $(unique(parents));
    }
    function closest(selector) {
      var closest = this; // eslint-disable-line
      if (typeof selector === 'undefined') {
        return new Dom7([]);
      }
      if (!closest.is(selector)) {
        closest = closest.parents(selector).eq(0);
      }
      return closest;
    }
    function find(selector) {
      var foundElements = [];
      for (var i = 0; i < this.length; i += 1) {
        var found = this[i].querySelectorAll(selector);
        for (var j = 0; j < found.length; j += 1) {
          foundElements.push(found[j]);
        }
      }
      return new Dom7(foundElements);
    }
    function children(selector) {
      var children = []; // eslint-disable-line
      for (var i = 0; i < this.length; i += 1) {
        var childNodes = this[i].childNodes;
        for (var j = 0; j < childNodes.length; j += 1) {
          if (!selector) {
            if (childNodes[j].nodeType === 1) {
              children.push(childNodes[j]);
            }
          } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
            children.push(childNodes[j]);
          }
        }
      }
      return new Dom7(unique(children));
    }
    function remove() {
      for (var i = 0; i < this.length; i += 1) {
        if (this[i].parentNode) {
          this[i].parentNode.removeChild(this[i]);
        }
      }
      return this;
    }
    function add() {
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];
      var dom = this;
      var i;
      var j;
      for (i = 0; i < args.length; i += 1) {
        var toAdd = $(args[i]);
        for (j = 0; j < toAdd.length; j += 1) {
          dom[dom.length] = toAdd[j];
          dom.length += 1;
        }
      }
      return dom;
    }
    var Methods = {
      addClass: addClass,
      removeClass: removeClass,
      hasClass: hasClass,
      toggleClass: toggleClass,
      attr: attr,
      removeAttr: removeAttr,
      data: data,
      transform: transform,
      transition: transition,
      on: on,
      off: off,
      trigger: trigger,
      transitionEnd: transitionEnd,
      outerWidth: outerWidth,
      outerHeight: outerHeight,
      offset: offset,
      css: css,
      each: each,
      html: html,
      text: text,
      is: is,
      index: index,
      eq: eq,
      append: append,
      prepend: prepend,
      next: next,
      nextAll: nextAll,
      prev: prev,
      prevAll: prevAll,
      parent: parent,
      parents: parents,
      closest: closest,
      find: find,
      children: children,
      remove: remove,
      add: add,
      styles: styles
    };
    Object.keys(Methods).forEach(function (methodName) {
      $.fn[methodName] = $.fn[methodName] || Methods[methodName];
    });
    var Utils = {
      deleteProps: function deleteProps(obj) {
        var object = obj;
        Object.keys(object).forEach(function (key) {
          try {
            object[key] = null;
          } catch (e) {
            // no getter for object
          }
          try {
            delete object[key];
          } catch (e) {
            // something got wrong
          }
        });
      },
      nextTick: function nextTick(callback, delay) {
        if (delay === void 0) delay = 0;
        return setTimeout(callback, delay);
      },
      now: function now() {
        return Date.now();
      },
      getTranslate: function getTranslate(el, axis) {
        if (axis === void 0) axis = 'x';
        var matrix;
        var curTransform;
        var transformMatrix;
        var curStyle = win.getComputedStyle(el, null);
        if (win.WebKitCSSMatrix) {
          curTransform = curStyle.transform || curStyle.webkitTransform;
          if (curTransform.split(',').length > 6) {
            curTransform = curTransform.split(', ').map(function (a) {
              return a.replace(',', '.');
            }).join(', ');
          }
          // Some old versions of Webkit choke when 'none' is passed; pass
          // empty string instead in this case
          transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
        } else {
          transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
          matrix = transformMatrix.toString().split(',');
        }
        if (axis === 'x') {
          // Latest Chrome and webkits Fix
          if (win.WebKitCSSMatrix) {
            curTransform = transformMatrix.m41;
          }
          // Crazy IE10 Matrix
          else if (matrix.length === 16) {
            curTransform = parseFloat(matrix[12]);
          }
          // Normal Browsers
          else {
            curTransform = parseFloat(matrix[4]);
          }
        }
        if (axis === 'y') {
          // Latest Chrome and webkits Fix
          if (win.WebKitCSSMatrix) {
            curTransform = transformMatrix.m42;
          }
          // Crazy IE10 Matrix
          else if (matrix.length === 16) {
            curTransform = parseFloat(matrix[13]);
          }
          // Normal Browsers
          else {
            curTransform = parseFloat(matrix[5]);
          }
        }
        return curTransform || 0;
      },
      parseUrlQuery: function parseUrlQuery(url) {
        var query = {};
        var urlToParse = url || win.location.href;
        var i;
        var params;
        var param;
        var length;
        if (typeof urlToParse === 'string' && urlToParse.length) {
          urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
          params = urlToParse.split('&').filter(function (paramsPart) {
            return paramsPart !== '';
          });
          length = params.length;
          for (i = 0; i < length; i += 1) {
            param = params[i].replace(/#\S+/g, '').split('=');
            query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
          }
        }
        return query;
      },
      isObject: function isObject(o) {
        return _typeof(o) === 'object' && o !== null && o.constructor && o.constructor === Object;
      },
      extend: function extend() {
        var args = [],
          len$1 = arguments.length;
        while (len$1--) args[len$1] = arguments[len$1];
        var to = Object(args[0]);
        for (var i = 1; i < args.length; i += 1) {
          var nextSource = args[i];
          if (nextSource !== undefined && nextSource !== null) {
            var keysArray = Object.keys(Object(nextSource));
            for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
              var nextKey = keysArray[nextIndex];
              var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
              if (desc !== undefined && desc.enumerable) {
                if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                  Utils.extend(to[nextKey], nextSource[nextKey]);
                } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                  to[nextKey] = {};
                  Utils.extend(to[nextKey], nextSource[nextKey]);
                } else {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
        }
        return to;
      }
    };
    var Support = function Support() {
      var testDiv = doc.createElement('div');
      return {
        touch: win.Modernizr && win.Modernizr.touch === true || function checkTouch() {
          return !!(win.navigator.maxTouchPoints > 0 || 'ontouchstart' in win || win.DocumentTouch && doc instanceof win.DocumentTouch);
        }(),
        pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || 'maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0),
        prefixedPointerEvents: !!win.navigator.msPointerEnabled,
        transition: function checkTransition() {
          var style = testDiv.style;
          return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
        }(),
        transforms3d: win.Modernizr && win.Modernizr.csstransforms3d === true || function checkTransforms3d() {
          var style = testDiv.style;
          return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
        }(),
        flexbox: function checkFlexbox() {
          var style = testDiv.style;
          var styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');
          for (var i = 0; i < styles.length; i += 1) {
            if (styles[i] in style) {
              return true;
            }
          }
          return false;
        }(),
        observer: function checkObserver() {
          return 'MutationObserver' in win || 'WebkitMutationObserver' in win;
        }(),
        passiveListener: function checkPassiveListener() {
          var supportsPassive = false;
          try {
            var opts = Object.defineProperty({}, 'passive', {
              // eslint-disable-next-line
              get: function get() {
                supportsPassive = true;
              }
            });
            win.addEventListener('testPassiveListener', null, opts);
          } catch (e) {
            // No support
          }
          return supportsPassive;
        }(),
        gestures: function checkGestures() {
          return 'ongesturestart' in win;
        }()
      };
    }();
    var Browser = function Browser() {
      function isSafari() {
        var ua = win.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
      }
      return {
        isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
        isEdge: !!win.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent)
      };
    }();
    var SwiperClass = function SwiperClass(params) {
      if (params === void 0) params = {};
      var self = this;
      self.params = params;

      // Events
      self.eventsListeners = {};
      if (self.params && self.params.on) {
        Object.keys(self.params.on).forEach(function (eventName) {
          self.on(eventName, self.params.on[eventName]);
        });
      }
    };
    var staticAccessors = {
      components: {
        configurable: true
      }
    };
    SwiperClass.prototype.on = function on(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') {
        return self;
      }
      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) {
          self.eventsListeners[event] = [];
        }
        self.eventsListeners[event][method](handler);
      });
      return self;
    };
    SwiperClass.prototype.once = function once(events, handler, priority) {
      var self = this;
      if (typeof handler !== 'function') {
        return self;
      }
      function onceHandler() {
        var args = [],
          len = arguments.length;
        while (len--) args[len] = arguments[len];
        handler.apply(self, args);
        self.off(events, onceHandler);
        if (onceHandler.f7proxy) {
          delete onceHandler.f7proxy;
        }
      }
      onceHandler.f7proxy = handler;
      return self.on(events, onceHandler, priority);
    };
    SwiperClass.prototype.off = function off(events, handler) {
      var self = this;
      if (!self.eventsListeners) {
        return self;
      }
      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    };
    SwiperClass.prototype.emit = function emit() {
      var args = [],
        len = arguments.length;
      while (len--) args[len] = arguments[len];
      var self = this;
      if (!self.eventsListeners) {
        return self;
      }
      var events;
      var data;
      var context;
      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }
      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    };
    SwiperClass.prototype.useModulesParams = function useModulesParams(instanceParams) {
      var instance = this;
      if (!instance.modules) {
        return;
      }
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        // Extend params
        if (module.params) {
          Utils.extend(instanceParams, module.params);
        }
      });
    };
    SwiperClass.prototype.useModules = function useModules(modulesParams) {
      if (modulesParams === void 0) modulesParams = {};
      var instance = this;
      if (!instance.modules) {
        return;
      }
      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {};
        // Extend instance methods and props
        if (module.instance) {
          Object.keys(module.instance).forEach(function (modulePropName) {
            var moduleProp = module.instance[modulePropName];
            if (typeof moduleProp === 'function') {
              instance[modulePropName] = moduleProp.bind(instance);
            } else {
              instance[modulePropName] = moduleProp;
            }
          });
        }
        // Add event listeners
        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        }

        // Module create callback
        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    };
    staticAccessors.components.set = function (components) {
      var Class = this;
      if (!Class.use) {
        return;
      }
      Class.use(components);
    };
    SwiperClass.installModule = function installModule(module) {
      var params = [],
        len = arguments.length - 1;
      while (len-- > 0) params[len] = arguments[len + 1];
      var Class = this;
      if (!Class.prototype.modules) {
        Class.prototype.modules = {};
      }
      var name = module.name || Object.keys(Class.prototype.modules).length + "_" + Utils.now();
      Class.prototype.modules[name] = module;
      // Prototype
      if (module.proto) {
        Object.keys(module.proto).forEach(function (key) {
          Class.prototype[key] = module.proto[key];
        });
      }
      // Class
      if (module["static"]) {
        Object.keys(module["static"]).forEach(function (key) {
          Class[key] = module["static"][key];
        });
      }
      // Callback
      if (module.install) {
        module.install.apply(Class, params);
      }
      return Class;
    };
    SwiperClass.use = function use(module) {
      var params = [],
        len = arguments.length - 1;
      while (len-- > 0) params[len] = arguments[len + 1];
      var Class = this;
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Class.installModule(m);
        });
        return Class;
      }
      return Class.installModule.apply(Class, [module].concat(params));
    };
    Object.defineProperties(SwiperClass, staticAccessors);
    function updateSize() {
      var swiper = this;
      var width;
      var height;
      var $el = swiper.$el;
      if (typeof swiper.params.width !== 'undefined') {
        width = swiper.params.width;
      } else {
        width = $el[0].clientWidth;
      }
      if (typeof swiper.params.height !== 'undefined') {
        height = swiper.params.height;
      } else {
        height = $el[0].clientHeight;
      }
      if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
        return;
      }

      // Subtract paddings
      width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
      height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
      Utils.extend(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
      });
    }
    function updateSlides() {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperSize = swiper.size;
      var rtl = swiper.rtlTranslate;
      var wrongRTL = swiper.wrongRTL;
      var isVirtual = swiper.virtual && params.virtual.enabled;
      var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
      var slides = $wrapperEl.children("." + swiper.params.slideClass);
      var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
      var snapGrid = [];
      var slidesGrid = [];
      var slidesSizesGrid = [];
      var offsetBefore = params.slidesOffsetBefore;
      if (typeof offsetBefore === 'function') {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
      }
      var offsetAfter = params.slidesOffsetAfter;
      if (typeof offsetAfter === 'function') {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
      }
      var previousSnapGridLength = swiper.snapGrid.length;
      var previousSlidesGridLength = swiper.snapGrid.length;
      var spaceBetween = params.spaceBetween;
      var slidePosition = -offsetBefore;
      var prevSlideSize = 0;
      var index = 0;
      if (typeof swiperSize === 'undefined') {
        return;
      }
      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
      }
      swiper.virtualSize = -spaceBetween;

      // reset margins
      if (rtl) {
        slides.css({
          marginLeft: '',
          marginTop: ''
        });
      } else {
        slides.css({
          marginRight: '',
          marginBottom: ''
        });
      }
      var slidesNumberEvenToRows;
      if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
          slidesNumberEvenToRows = slidesLength;
        } else {
          slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        }
        if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
          slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
        }
      }

      // Calc slides
      var slideSize;
      var slidesPerColumn = params.slidesPerColumn;
      var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
      var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);
      for (var i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        var slide = slides.eq(i);
        if (params.slidesPerColumn > 1) {
          // Set slides order
          var newSlideOrderIndex = void 0;
          var column = void 0;
          var row = void 0;
          if (params.slidesPerColumnFill === 'column' || params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
            if (params.slidesPerColumnFill === 'column') {
              column = Math.floor(i / slidesPerColumn);
              row = i - column * slidesPerColumn;
              if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                row += 1;
                if (row >= slidesPerColumn) {
                  row = 0;
                  column += 1;
                }
              }
            } else {
              var groupIndex = Math.floor(i / params.slidesPerGroup);
              row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
              column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
            }
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
            slide.css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex
            });
          } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
          }
          slide.css("margin-" + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + "px").attr('data-swiper-column', column).attr('data-swiper-row', row);
        }
        if (slide.css('display') === 'none') {
          continue;
        } // eslint-disable-line

        if (params.slidesPerView === 'auto') {
          var slideStyles = win.getComputedStyle(slide[0], null);
          var currentTransform = slide[0].style.transform;
          var currentWebKitTransform = slide[0].style.webkitTransform;
          if (currentTransform) {
            slide[0].style.transform = 'none';
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = 'none';
          }
          if (params.roundLengths) {
            slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
          } else {
            // eslint-disable-next-line
            if (swiper.isHorizontal()) {
              var width = parseFloat(slideStyles.getPropertyValue('width'));
              var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
              var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
              var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
              var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
              var boxSizing = slideStyles.getPropertyValue('box-sizing');
              if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
                slideSize = width + marginLeft + marginRight;
              } else {
                slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
              }
            } else {
              var height = parseFloat(slideStyles.getPropertyValue('height'));
              var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
              var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
              var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
              var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
              var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');
              if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
                slideSize = height + marginTop + marginBottom;
              } else {
                slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
              }
            }
          }
          if (currentTransform) {
            slide[0].style.transform = currentTransform;
          }
          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = currentWebKitTransform;
          }
          if (params.roundLengths) {
            slideSize = Math.floor(slideSize);
          }
        } else {
          slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
          if (params.roundLengths) {
            slideSize = Math.floor(slideSize);
          }
          if (slides[i]) {
            if (swiper.isHorizontal()) {
              slides[i].style.width = slideSize + "px";
            } else {
              slides[i].style.height = slideSize + "px";
            }
          }
        }
        if (slides[i]) {
          slides[i].swiperSlideSize = slideSize;
        }
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
          slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
          if (prevSlideSize === 0 && i !== 0) {
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          }
          if (i === 0) {
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          }
          if (Math.abs(slidePosition) < 1 / 1000) {
            slidePosition = 0;
          }
          if (params.roundLengths) {
            slidePosition = Math.floor(slidePosition);
          }
          if (index % params.slidesPerGroup === 0) {
            snapGrid.push(slidePosition);
          }
          slidesGrid.push(slidePosition);
        } else {
          if (params.roundLengths) {
            slidePosition = Math.floor(slidePosition);
          }
          if (index % params.slidesPerGroup === 0) {
            snapGrid.push(slidePosition);
          }
          slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
      }
      swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
      var newSlidesGrid;
      if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
        $wrapperEl.css({
          width: swiper.virtualSize + params.spaceBetween + "px"
        });
      }
      if (!Support.flexbox || params.setWrapperSize) {
        if (swiper.isHorizontal()) {
          $wrapperEl.css({
            width: swiper.virtualSize + params.spaceBetween + "px"
          });
        } else {
          $wrapperEl.css({
            height: swiper.virtualSize + params.spaceBetween + "px"
          });
        }
      }
      if (params.slidesPerColumn > 1) {
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
        if (swiper.isHorizontal()) {
          $wrapperEl.css({
            width: swiper.virtualSize + params.spaceBetween + "px"
          });
        } else {
          $wrapperEl.css({
            height: swiper.virtualSize + params.spaceBetween + "px"
          });
        }
        if (params.centeredSlides) {
          newSlidesGrid = [];
          for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
            var slidesGridItem = snapGrid[i$1];
            if (params.roundLengths) {
              slidesGridItem = Math.floor(slidesGridItem);
            }
            if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) {
              newSlidesGrid.push(slidesGridItem);
            }
          }
          snapGrid = newSlidesGrid;
        }
      }

      // Remove last grid elements depending on width
      if (!params.centeredSlides) {
        newSlidesGrid = [];
        for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
          var slidesGridItem$1 = snapGrid[i$2];
          if (params.roundLengths) {
            slidesGridItem$1 = Math.floor(slidesGridItem$1);
          }
          if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
            newSlidesGrid.push(slidesGridItem$1);
          }
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
          snapGrid.push(swiper.virtualSize - swiperSize);
        }
      }
      if (snapGrid.length === 0) {
        snapGrid = [0];
      }
      if (params.spaceBetween !== 0) {
        if (swiper.isHorizontal()) {
          if (rtl) {
            slides.css({
              marginLeft: spaceBetween + "px"
            });
          } else {
            slides.css({
              marginRight: spaceBetween + "px"
            });
          }
        } else {
          slides.css({
            marginBottom: spaceBetween + "px"
          });
        }
      }
      if (params.centerInsufficientSlides) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function (slideSizeValue) {
          allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
          var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
          snapGrid.forEach(function (snap, snapIndex) {
            snapGrid[snapIndex] = snap - allSlidesOffset;
          });
          slidesGrid.forEach(function (snap, snapIndex) {
            slidesGrid[snapIndex] = snap + allSlidesOffset;
          });
        }
      }
      Utils.extend(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
      });
      if (slidesLength !== previousSlidesLength) {
        swiper.emit('slidesLengthChange');
      }
      if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        }
        swiper.emit('snapGridLengthChange');
      }
      if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit('slidesGridLengthChange');
      }
      if (params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateSlidesOffset();
      }
    }
    function updateAutoHeight(speed) {
      var swiper = this;
      var activeSlides = [];
      var newHeight = 0;
      var i;
      if (typeof speed === 'number') {
        swiper.setTransition(speed);
      } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
      }
      // Find slides currently in view
      if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
          var index = swiper.activeIndex + i;
          if (index > swiper.slides.length) {
            break;
          }
          activeSlides.push(swiper.slides.eq(index)[0]);
        }
      } else {
        activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
      }

      // Find new height from highest slide in view
      for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== 'undefined') {
          var height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      }

      // Update Height
      if (newHeight) {
        swiper.$wrapperEl.css('height', newHeight + "px");
      }
    }
    function updateSlidesOffset() {
      var swiper = this;
      var slides = swiper.slides;
      for (var i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
      }
    }
    function updateSlidesProgress(translate) {
      if (translate === void 0) translate = this && this.translate || 0;
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;
      if (slides.length === 0) {
        return;
      }
      if (typeof slides[0].swiperSlideOffset === 'undefined') {
        swiper.updateSlidesOffset();
      }
      var offsetCenter = -translate;
      if (rtl) {
        offsetCenter = translate;
      }

      // Visible Slides
      slides.removeClass(params.slideVisibleClass);
      swiper.visibleSlidesIndexes = [];
      swiper.visibleSlides = [];
      for (var i = 0; i < slides.length; i += 1) {
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        if (params.watchSlidesVisibility) {
          var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
          var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
          var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
          if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
          }
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
      }
      swiper.visibleSlides = $(swiper.visibleSlides);
    }
    function updateProgress(translate) {
      if (translate === void 0) translate = this && this.translate || 0;
      var swiper = this;
      var params = swiper.params;
      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      var progress = swiper.progress;
      var isBeginning = swiper.isBeginning;
      var isEnd = swiper.isEnd;
      var wasBeginning = isBeginning;
      var wasEnd = isEnd;
      if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
      } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
      }
      Utils.extend(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
      });
      if (params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateSlidesProgress(translate);
      }
      if (isBeginning && !wasBeginning) {
        swiper.emit('reachBeginning toEdge');
      }
      if (isEnd && !wasEnd) {
        swiper.emit('reachEnd toEdge');
      }
      if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
        swiper.emit('fromEdge');
      }
      swiper.emit('progress', progress);
    }
    function updateSlidesClasses() {
      var swiper = this;
      var slides = swiper.slides;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var activeIndex = swiper.activeIndex;
      var realIndex = swiper.realIndex;
      var isVirtual = swiper.virtual && params.virtual.enabled;
      slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
      var activeSlide;
      if (isVirtual) {
        activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
      } else {
        activeSlide = slides.eq(activeIndex);
      }

      // Active classes
      activeSlide.addClass(params.slideActiveClass);
      if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        }
      }
      // Next Slide
      var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);
      if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
      }
      // Prev Slide
      var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);
      if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
      }
      if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        }
        if (prevSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        }
      }
    }
    function updateActiveIndex(newActiveIndex) {
      var swiper = this;
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      var slidesGrid = swiper.slidesGrid;
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      var previousIndex = swiper.activeIndex;
      var previousRealIndex = swiper.realIndex;
      var previousSnapIndex = swiper.snapIndex;
      var activeIndex = newActiveIndex;
      var snapIndex;
      if (typeof activeIndex === 'undefined') {
        for (var i = 0; i < slidesGrid.length; i += 1) {
          if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
              activeIndex = i;
            } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
              activeIndex = i + 1;
            }
          } else if (translate >= slidesGrid[i]) {
            activeIndex = i;
          }
        }
        // Normalize slideIndex
        if (params.normalizeSlideIndex) {
          if (activeIndex < 0 || typeof activeIndex === 'undefined') {
            activeIndex = 0;
          }
        }
      }
      if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
      } else {
        snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
      }
      if (snapIndex >= snapGrid.length) {
        snapIndex = snapGrid.length - 1;
      }
      if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
          swiper.snapIndex = snapIndex;
          swiper.emit('snapIndexChange');
        }
        return;
      }

      // Get real index
      var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
      Utils.extend(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
      });
      swiper.emit('activeIndexChange');
      swiper.emit('snapIndexChange');
      if (previousRealIndex !== realIndex) {
        swiper.emit('realIndexChange');
      }
      if (swiper.initialized || swiper.runCallbacksOnInit) {
        swiper.emit('slideChange');
      }
    }
    function updateClickedSlide(e) {
      var swiper = this;
      var params = swiper.params;
      var slide = $(e.target).closest("." + params.slideClass)[0];
      var slideFound = false;
      if (slide) {
        for (var i = 0; i < swiper.slides.length; i += 1) {
          if (swiper.slides[i] === slide) {
            slideFound = true;
          }
        }
      }
      if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) {
          swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
        } else {
          swiper.clickedIndex = $(slide).index();
        }
      } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
      }
      if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
        swiper.slideToClickedSlide();
      }
    }
    var update = {
      updateSize: updateSize,
      updateSlides: updateSlides,
      updateAutoHeight: updateAutoHeight,
      updateSlidesOffset: updateSlidesOffset,
      updateSlidesProgress: updateSlidesProgress,
      updateProgress: updateProgress,
      updateSlidesClasses: updateSlidesClasses,
      updateActiveIndex: updateActiveIndex,
      updateClickedSlide: updateClickedSlide
    };
    function getTranslate(axis) {
      if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
      var swiper = this;
      var params = swiper.params;
      var rtl = swiper.rtlTranslate;
      var translate = swiper.translate;
      var $wrapperEl = swiper.$wrapperEl;
      if (params.virtualTranslate) {
        return rtl ? -translate : translate;
      }
      var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);
      if (rtl) {
        currentTranslate = -currentTranslate;
      }
      return currentTranslate || 0;
    }
    function setTranslate(translate, byController) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var progress = swiper.progress;
      var x = 0;
      var y = 0;
      var z = 0;
      if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
      } else {
        y = translate;
      }
      if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
      }
      if (!params.virtualTranslate) {
        if (Support.transforms3d) {
          $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
        } else {
          $wrapperEl.transform("translate(" + x + "px, " + y + "px)");
        }
      }
      swiper.previousTranslate = swiper.translate;
      swiper.translate = swiper.isHorizontal() ? x : y;

      // Check if we need to update progress
      var newProgress;
      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
      }
      if (newProgress !== progress) {
        swiper.updateProgress(translate);
      }
      swiper.emit('setTranslate', swiper.translate, byController);
    }
    function minTranslate() {
      return -this.snapGrid[0];
    }
    function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    }
    var translate = {
      getTranslate: getTranslate,
      setTranslate: setTranslate,
      minTranslate: minTranslate,
      maxTranslate: maxTranslate
    };
    function setTransition(duration, byController) {
      var swiper = this;
      swiper.$wrapperEl.transition(duration);
      swiper.emit('setTransition', duration, byController);
    }
    function transitionStart(runCallbacks, direction) {
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var params = swiper.params;
      var previousIndex = swiper.previousIndex;
      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }
      var dir = direction;
      if (!dir) {
        if (activeIndex > previousIndex) {
          dir = 'next';
        } else if (activeIndex < previousIndex) {
          dir = 'prev';
        } else {
          dir = 'reset';
        }
      }
      swiper.emit('transitionStart');
      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
          swiper.emit('slideResetTransitionStart');
          return;
        }
        swiper.emit('slideChangeTransitionStart');
        if (dir === 'next') {
          swiper.emit('slideNextTransitionStart');
        } else {
          swiper.emit('slidePrevTransitionStart');
        }
      }
    }
    function transitionEnd$1(runCallbacks, direction) {
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var previousIndex = swiper.previousIndex;
      swiper.animating = false;
      swiper.setTransition(0);
      var dir = direction;
      if (!dir) {
        if (activeIndex > previousIndex) {
          dir = 'next';
        } else if (activeIndex < previousIndex) {
          dir = 'prev';
        } else {
          dir = 'reset';
        }
      }
      swiper.emit('transitionEnd');
      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
          swiper.emit('slideResetTransitionEnd');
          return;
        }
        swiper.emit('slideChangeTransitionEnd');
        if (dir === 'next') {
          swiper.emit('slideNextTransitionEnd');
        } else {
          swiper.emit('slidePrevTransitionEnd');
        }
      }
    }
    var transition$1 = {
      setTransition: setTransition,
      transitionStart: transitionStart,
      transitionEnd: transitionEnd$1
    };
    function slideTo(index, speed, runCallbacks, internal) {
      if (index === void 0) index = 0;
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var slideIndex = index;
      if (slideIndex < 0) {
        slideIndex = 0;
      }
      var params = swiper.params;
      var snapGrid = swiper.snapGrid;
      var slidesGrid = swiper.slidesGrid;
      var previousIndex = swiper.previousIndex;
      var activeIndex = swiper.activeIndex;
      var rtl = swiper.rtlTranslate;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }
      var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);
      if (snapIndex >= snapGrid.length) {
        snapIndex = snapGrid.length - 1;
      }
      if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
        swiper.emit('beforeSlideChangeStart');
      }
      var translate = -snapGrid[snapIndex];

      // Update progress
      swiper.updateProgress(translate);

      // Normalize slideIndex
      if (params.normalizeSlideIndex) {
        for (var i = 0; i < slidesGrid.length; i += 1) {
          if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
            slideIndex = i;
          }
        }
      }
      // Directions locks
      if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
          return false;
        }
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
          if ((activeIndex || 0) !== slideIndex) {
            return false;
          }
        }
      }
      var direction;
      if (slideIndex > activeIndex) {
        direction = 'next';
      } else if (slideIndex < activeIndex) {
        direction = 'prev';
      } else {
        direction = 'reset';
      }

      // Update Index
      if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') {
          swiper.setTranslate(translate);
        }
        if (direction !== 'reset') {
          swiper.transitionStart(runCallbacks, direction);
          swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
      }
      if (speed === 0 || !Support.transition) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        if (!swiper.animating) {
          swiper.animating = true;
          if (!swiper.onSlideToWrapperTransitionEnd) {
            swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
              if (!swiper || swiper.destroyed) {
                return;
              }
              if (e.target !== this) {
                return;
              }
              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
              swiper.onSlideToWrapperTransitionEnd = null;
              delete swiper.onSlideToWrapperTransitionEnd;
              swiper.transitionEnd(runCallbacks, direction);
            };
          }
          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        }
      }
      return true;
    }
    function slideToLoop(index, speed, runCallbacks, internal) {
      if (index === void 0) index = 0;
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var newIndex = index;
      if (swiper.params.loop) {
        newIndex += swiper.loopedSlides;
      }
      return swiper.slideTo(newIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideNext(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var params = swiper.params;
      var animating = swiper.animating;
      if (params.loop) {
        if (animating) {
          return false;
        }
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
      }
      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slidePrev(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var params = swiper.params;
      var animating = swiper.animating;
      var snapGrid = swiper.snapGrid;
      var slidesGrid = swiper.slidesGrid;
      var rtlTranslate = swiper.rtlTranslate;
      if (params.loop) {
        if (animating) {
          return false;
        }
        swiper.loopFix();
        // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }
      var translate = rtlTranslate ? swiper.translate : -swiper.translate;
      function normalize(val) {
        if (val < 0) {
          return -Math.floor(Math.abs(val));
        }
        return Math.floor(val);
      }
      var normalizedTranslate = normalize(translate);
      var normalizedSnapGrid = snapGrid.map(function (val) {
        return normalize(val);
      });
      var normalizedSlidesGrid = slidesGrid.map(function (val) {
        return normalize(val);
      });
      var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
      var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
      var prevIndex;
      if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) {
          prevIndex = swiper.activeIndex - 1;
        }
      }
      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideReset(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
    }

    /* eslint no-unused-vars: "off" */
    function slideToClosest(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var index = swiper.activeIndex;
      var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);
      if (snapIndex < swiper.snapGrid.length - 1) {
        var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) / 2) {
          index = swiper.params.slidesPerGroup;
        }
      }
      return swiper.slideTo(index, speed, runCallbacks, internal);
    }
    function slideToClickedSlide() {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
      var slideToIndex = swiper.clickedIndex;
      var realIndex;
      if (params.loop) {
        if (swiper.animating) {
          return;
        }
        realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
          if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
            Utils.nextTick(function () {
              swiper.slideTo(slideToIndex);
            });
          } else {
            swiper.slideTo(slideToIndex);
          }
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else {
        swiper.slideTo(slideToIndex);
      }
    }
    var slide = {
      slideTo: slideTo,
      slideToLoop: slideToLoop,
      slideNext: slideNext,
      slidePrev: slidePrev,
      slideReset: slideReset,
      slideToClosest: slideToClosest,
      slideToClickedSlide: slideToClickedSlide
    };
    function loopCreate() {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      // Remove duplicated slides
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
      var slides = $wrapperEl.children("." + params.slideClass);
      if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
          for (var i = 0; i < blankSlidesNum; i += 1) {
            var blankNode = $(doc.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
            $wrapperEl.append(blankNode);
          }
          slides = $wrapperEl.children("." + params.slideClass);
        }
      }
      if (params.slidesPerView === 'auto' && !params.loopedSlides) {
        params.loopedSlides = slides.length;
      }
      swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
      swiper.loopedSlides += params.loopAdditionalSlides;
      if (swiper.loopedSlides > slides.length) {
        swiper.loopedSlides = slides.length;
      }
      var prependSlides = [];
      var appendSlides = [];
      slides.each(function (index, el) {
        var slide = $(el);
        if (index < swiper.loopedSlides) {
          appendSlides.push(el);
        }
        if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
          prependSlides.push(el);
        }
        slide.attr('data-swiper-slide-index', index);
      });
      for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
        $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
      }
      for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
        $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
      }
    }
    function loopFix() {
      var swiper = this;
      var params = swiper.params;
      var activeIndex = swiper.activeIndex;
      var slides = swiper.slides;
      var loopedSlides = swiper.loopedSlides;
      var allowSlidePrev = swiper.allowSlidePrev;
      var allowSlideNext = swiper.allowSlideNext;
      var snapGrid = swiper.snapGrid;
      var rtl = swiper.rtlTranslate;
      var newIndex;
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      var snapTranslate = -snapGrid[activeIndex];
      var diff = snapTranslate - swiper.getTranslate();

      // Fix For Negative Oversliding
      if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      } else if (params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2 || activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged$1 && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      }
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
    }
    function loopDestroy() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var params = swiper.params;
      var slides = swiper.slides;
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
      slides.removeAttr('data-swiper-slide-index');
    }
    var loop = {
      loopCreate: loopCreate,
      loopFix: loopFix,
      loopDestroy: loopDestroy
    };
    function setGrabCursor(moving) {
      var swiper = this;
      if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked) {
        return;
      }
      var el = swiper.el;
      el.style.cursor = 'move';
      el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
      el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
      el.style.cursor = moving ? 'grabbing' : 'grab';
    }
    function unsetGrabCursor() {
      var swiper = this;
      if (Support.touch || swiper.params.watchOverflow && swiper.isLocked) {
        return;
      }
      swiper.el.style.cursor = '';
    }
    var grabCursor = {
      setGrabCursor: setGrabCursor,
      unsetGrabCursor: unsetGrabCursor
    };
    function appendSlide(slides) {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var params = swiper.params;
      if (params.loop) {
        swiper.loopDestroy();
      }
      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) {
            $wrapperEl.append(slides[i]);
          }
        }
      } else {
        $wrapperEl.append(slides);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
    }
    function prependSlide(slides) {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var activeIndex = swiper.activeIndex;
      if (params.loop) {
        swiper.loopDestroy();
      }
      var newActiveIndex = activeIndex + 1;
      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) {
            $wrapperEl.prepend(slides[i]);
          }
        }
        newActiveIndex = activeIndex + slides.length;
      } else {
        $wrapperEl.prepend(slides);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
      swiper.slideTo(newActiveIndex, 0, false);
    }
    function addSlide(index, slides) {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var params = swiper.params;
      var activeIndex = swiper.activeIndex;
      var activeIndexBuffer = activeIndex;
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
      }
      var baseLength = swiper.slides.length;
      if (index <= 0) {
        swiper.prependSlide(slides);
        return;
      }
      if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
      }
      var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
      var slidesBuffer = [];
      for (var i = baseLength - 1; i >= index; i -= 1) {
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
      }
      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
          if (slides[i$1]) {
            $wrapperEl.append(slides[i$1]);
          }
        }
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
      } else {
        $wrapperEl.append(slides);
      }
      for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
        $wrapperEl.append(slidesBuffer[i$2]);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }
    function removeSlide(slidesIndexes) {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var activeIndex = swiper.activeIndex;
      var activeIndexBuffer = activeIndex;
      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
      }
      var newActiveIndex = activeIndexBuffer;
      var indexToRemove;
      if (_typeof(slidesIndexes) === 'object' && 'length' in slidesIndexes) {
        for (var i = 0; i < slidesIndexes.length; i += 1) {
          indexToRemove = slidesIndexes[i];
          if (swiper.slides[indexToRemove]) {
            swiper.slides.eq(indexToRemove).remove();
          }
          if (indexToRemove < newActiveIndex) {
            newActiveIndex -= 1;
          }
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
      } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) {
          swiper.slides.eq(indexToRemove).remove();
        }
        if (indexToRemove < newActiveIndex) {
          newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
      }
      if (params.loop) {
        swiper.loopCreate();
      }
      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }
    function removeAllSlides() {
      var swiper = this;
      var slidesIndexes = [];
      for (var i = 0; i < swiper.slides.length; i += 1) {
        slidesIndexes.push(i);
      }
      swiper.removeSlide(slidesIndexes);
    }
    var manipulation = {
      appendSlide: appendSlide,
      prependSlide: prependSlide,
      addSlide: addSlide,
      removeSlide: removeSlide,
      removeAllSlides: removeAllSlides
    };
    var Device = function Device() {
      var ua = win.navigator.userAgent;
      var device = {
        ios: false,
        android: false,
        androidChrome: false,
        desktop: false,
        windows: false,
        iphone: false,
        ipod: false,
        ipad: false,
        cordova: win.cordova || win.phonegap,
        phonegap: win.cordova || win.phonegap
      };
      var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line
      var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);

      // Windows
      if (windows) {
        device.os = 'windows';
        device.osVersion = windows[2];
        device.windows = true;
      }
      // Android
      if (android && !windows) {
        device.os = 'android';
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
      }
      if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
      }
      // iOS
      if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, '.');
        device.iphone = true;
      }
      if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, '.');
        device.ipad = true;
      }
      if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
        device.iphone = true;
      }
      // iOS 8+ changed UA
      if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
        if (device.osVersion.split('.')[0] === '10') {
          device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
        }
      }

      // Desktop
      device.desktop = !(device.os || device.android || device.webView);

      // Webview
      device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i);

      // Minimal UI
      if (device.os && device.os === 'ios') {
        var osVersionArr = device.osVersion.split('.');
        var metaViewport = doc.querySelector('meta[name="viewport"]');
        device.minimalUi = !device.webView && (ipod || iphone) && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
      }

      // Pixel Ratio
      device.pixelRatio = win.devicePixelRatio || 1;

      // Export object
      return device;
    }();
    function onTouchStart(event) {
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params;
      var touches = swiper.touches;
      if (swiper.animating && params.preventInteractionOnTransition) {
        return;
      }
      var e = event;
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      data.isTouchEvent = e.type === 'touchstart';
      if (!data.isTouchEvent && 'which' in e && e.which === 3) {
        return;
      }
      if (!data.isTouchEvent && 'button' in e && e.button > 0) {
        return;
      }
      if (data.isTouched && data.isMoved) {
        return;
      }
      if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
        swiper.allowClick = true;
        return;
      }
      if (params.swipeHandler) {
        if (!$(e).closest(params.swipeHandler)[0]) {
          return;
        }
      }
      touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      var startX = touches.currentX;
      var startY = touches.currentY;

      // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

      var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
      var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
      if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= win.screen.width - edgeSwipeThreshold)) {
        return;
      }
      Utils.extend(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
      });
      touches.startX = startX;
      touches.startY = startY;
      data.touchStartTime = Utils.now();
      swiper.allowClick = true;
      swiper.updateSize();
      swiper.swipeDirection = undefined;
      if (params.threshold > 0) {
        data.allowThresholdMove = false;
      }
      if (e.type !== 'touchstart') {
        var preventDefault = true;
        if ($(e.target).is(data.formElements)) {
          preventDefault = false;
        }
        if (doc.activeElement && $(doc.activeElement).is(data.formElements) && doc.activeElement !== e.target) {
          doc.activeElement.blur();
        }
        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if (params.touchStartForcePreventDefault || shouldPreventDefault) {
          e.preventDefault();
        }
      }
      swiper.emit('touchStart', e);
    }
    function onTouchMove(event) {
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params;
      var touches = swiper.touches;
      var rtl = swiper.rtlTranslate;
      var e = event;
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
          swiper.emit('touchMoveOpposite', e);
        }
        return;
      }
      if (data.isTouchEvent && e.type === 'mousemove') {
        return;
      }
      var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
      if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
      }
      if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;
        if (data.isTouched) {
          Utils.extend(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY
          });
          data.touchStartTime = Utils.now();
        }
        return;
      }
      if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
          // Vertical
          if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
            data.isTouched = false;
            data.isMoved = false;
            return;
          }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
          return;
        }
      }
      if (data.isTouchEvent && doc.activeElement) {
        if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
          data.isMoved = true;
          swiper.allowClick = false;
          return;
        }
      }
      if (data.allowTouchCallbacks) {
        swiper.emit('touchMove', e);
      }
      if (e.targetTouches && e.targetTouches.length > 1) {
        return;
      }
      touches.currentX = pageX;
      touches.currentY = pageY;
      var diffX = touches.currentX - touches.startX;
      var diffY = touches.currentY - touches.startY;
      if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) {
        return;
      }
      if (typeof data.isScrolling === 'undefined') {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
          data.isScrolling = false;
        } else {
          // eslint-disable-next-line
          if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
          }
        }
      }
      if (data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }
      if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
          data.startMoving = true;
        }
      }
      if (data.isScrolling) {
        data.isTouched = false;
        return;
      }
      if (!data.startMoving) {
        return;
      }
      swiper.allowClick = false;
      e.preventDefault();
      if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
      }
      if (!data.isMoved) {
        if (params.loop) {
          swiper.loopFix();
        }
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
          swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
          swiper.setGrabCursor(true);
        }
        swiper.emit('sliderFirstMove', e);
      }
      swiper.emit('sliderMove', e);
      data.isMoved = true;
      var diff = swiper.isHorizontal() ? diffX : diffY;
      touches.diff = diff;
      diff *= params.touchRatio;
      if (rtl) {
        diff = -diff;
      }
      swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
      data.currentTranslate = diff + data.startTranslate;
      var disableParentSwiper = true;
      var resistanceRatio = params.resistanceRatio;
      if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
      }
      if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
      } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) {
          data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
      }
      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      }

      // Directions locks
      if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }
      if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }

      // Threshold
      if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
          if (!data.allowThresholdMove) {
            data.allowThresholdMove = true;
            touches.startX = touches.currentX;
            touches.startY = touches.currentY;
            data.currentTranslate = data.startTranslate;
            touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
            return;
          }
        } else {
          data.currentTranslate = data.startTranslate;
          return;
        }
      }
      if (!params.followFinger) {
        return;
      }

      // Update active index in free mode
      if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      if (params.freeMode) {
        // Velocity
        if (data.velocities.length === 0) {
          data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
          });
        }
        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
          time: Utils.now()
        });
      }
      // Update progress
      swiper.updateProgress(data.currentTranslate);
      // Update translate
      swiper.setTranslate(data.currentTranslate);
    }
    function onTouchEnd(event) {
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params;
      var touches = swiper.touches;
      var rtl = swiper.rtlTranslate;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesGrid = swiper.slidesGrid;
      var snapGrid = swiper.snapGrid;
      var e = event;
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      if (data.allowTouchCallbacks) {
        swiper.emit('touchEnd', e);
      }
      data.allowTouchCallbacks = false;
      if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
          swiper.setGrabCursor(false);
        }
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      // Return Grab Cursor
      if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(false);
      }

      // Time diff
      var touchEndTime = Utils.now();
      var timeDiff = touchEndTime - data.touchStartTime;

      // Tap, doubleTap, Click
      if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit('tap', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime > 300) {
          if (data.clickTimeout) {
            clearTimeout(data.clickTimeout);
          }
          data.clickTimeout = Utils.nextTick(function () {
            if (!swiper || swiper.destroyed) {
              return;
            }
            swiper.emit('click', e);
          }, 300);
        }
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
          if (data.clickTimeout) {
            clearTimeout(data.clickTimeout);
          }
          swiper.emit('doubleTap', e);
        }
      }
      data.lastClickTime = Utils.now();
      Utils.nextTick(function () {
        if (!swiper.destroyed) {
          swiper.allowClick = true;
        }
      });
      if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
      }
      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      var currentPos;
      if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
      } else {
        currentPos = -data.currentTranslate;
      }
      if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (currentPos > -swiper.maxTranslate()) {
          if (swiper.slides.length < snapGrid.length) {
            swiper.slideTo(snapGrid.length - 1);
          } else {
            swiper.slideTo(swiper.slides.length - 1);
          }
          return;
        }
        if (params.freeModeMomentum) {
          if (data.velocities.length > 1) {
            var lastMoveEvent = data.velocities.pop();
            var velocityEvent = data.velocities.pop();
            var distance = lastMoveEvent.position - velocityEvent.position;
            var time = lastMoveEvent.time - velocityEvent.time;
            swiper.velocity = distance / time;
            swiper.velocity /= 2;
            if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
              swiper.velocity = 0;
            }
            // this implies that the user stopped moving a finger then released.
            // There would be no events with distance zero, so the last event is stale.
            if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
              swiper.velocity = 0;
            }
          } else {
            swiper.velocity = 0;
          }
          swiper.velocity *= params.freeModeMomentumVelocityRatio;
          data.velocities.length = 0;
          var momentumDuration = 1000 * params.freeModeMomentumRatio;
          var momentumDistance = swiper.velocity * momentumDuration;
          var newPosition = swiper.translate + momentumDistance;
          if (rtl) {
            newPosition = -newPosition;
          }
          var doBounce = false;
          var afterBouncePosition;
          var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
          var needsLoopFix;
          if (newPosition < swiper.maxTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                newPosition = swiper.maxTranslate() - bounceAmount;
              }
              afterBouncePosition = swiper.maxTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.maxTranslate();
            }
            if (params.loop && params.centeredSlides) {
              needsLoopFix = true;
            }
          } else if (newPosition > swiper.minTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition - swiper.minTranslate() > bounceAmount) {
                newPosition = swiper.minTranslate() + bounceAmount;
              }
              afterBouncePosition = swiper.minTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.minTranslate();
            }
            if (params.loop && params.centeredSlides) {
              needsLoopFix = true;
            }
          } else if (params.freeModeSticky) {
            var nextSlide;
            for (var j = 0; j < snapGrid.length; j += 1) {
              if (snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }
            if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
              newPosition = snapGrid[nextSlide];
            } else {
              newPosition = snapGrid[nextSlide - 1];
            }
            newPosition = -newPosition;
          }
          if (needsLoopFix) {
            swiper.once('transitionEnd', function () {
              swiper.loopFix();
            });
          }
          // Fix duration
          if (swiper.velocity !== 0) {
            if (rtl) {
              momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
            } else {
              momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
            }
          } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
          }
          if (params.freeModeMomentumBounce && doBounce) {
            swiper.updateProgress(afterBouncePosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed || !data.allowMomentumBounce) {
                return;
              }
              swiper.emit('momentumBounce');
              swiper.setTransition(params.speed);
              swiper.setTranslate(afterBouncePosition);
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) {
                  return;
                }
                swiper.transitionEnd();
              });
            });
          } else if (swiper.velocity) {
            swiper.updateProgress(newPosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            if (!swiper.animating) {
              swiper.animating = true;
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) {
                  return;
                }
                swiper.transitionEnd();
              });
            }
          } else {
            swiper.updateProgress(newPosition);
          }
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }
        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
        return;
      }

      // Find current slide
      var stopIndex = 0;
      var groupSize = swiper.slidesSizesGrid[0];
      for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
        if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
          if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
            stopIndex = i;
            groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
          }
        } else if (currentPos >= slidesGrid[i]) {
          stopIndex = i;
          groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
      }

      // Find current slide size
      var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
      if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (swiper.swipeDirection === 'next') {
          if (ratio >= params.longSwipesRatio) {
            swiper.slideTo(stopIndex + params.slidesPerGroup);
          } else {
            swiper.slideTo(stopIndex);
          }
        }
        if (swiper.swipeDirection === 'prev') {
          if (ratio > 1 - params.longSwipesRatio) {
            swiper.slideTo(stopIndex + params.slidesPerGroup);
          } else {
            swiper.slideTo(stopIndex);
          }
        }
      } else {
        // Short swipes
        if (!params.shortSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }
        if (swiper.swipeDirection === 'next') {
          swiper.slideTo(stopIndex + params.slidesPerGroup);
        }
        if (swiper.swipeDirection === 'prev') {
          swiper.slideTo(stopIndex);
        }
      }
    }
    function onResize() {
      var swiper = this;
      var params = swiper.params;
      var el = swiper.el;
      if (el && el.offsetWidth === 0) {
        return;
      }

      // Breakpoints
      if (params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Save locks
      var allowSlideNext = swiper.allowSlideNext;
      var allowSlidePrev = swiper.allowSlidePrev;
      var snapGrid = swiper.snapGrid;

      // Disable locks on resize
      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      swiper.updateSize();
      swiper.updateSlides();
      if (params.freeMode) {
        var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        swiper.updateSlidesClasses();
        if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
      }
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.run();
      }
      // Return locks after resize
      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
    }
    function onClick(e) {
      var swiper = this;
      if (!swiper.allowClick) {
        if (swiper.params.preventClicks) {
          e.preventDefault();
        }
        if (swiper.params.preventClicksPropagation && swiper.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    }
    function attachEvents() {
      var swiper = this;
      var params = swiper.params;
      var touchEvents = swiper.touchEvents;
      var el = swiper.el;
      var wrapperEl = swiper.wrapperEl;
      {
        swiper.onTouchStart = onTouchStart.bind(swiper);
        swiper.onTouchMove = onTouchMove.bind(swiper);
        swiper.onTouchEnd = onTouchEnd.bind(swiper);
      }
      swiper.onClick = onClick.bind(swiper);
      var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
      var capture = !!params.nested;

      // Touch Events
      {
        if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
          target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
          doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
          doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
        } else {
          if (Support.touch) {
            var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? {
              passive: true,
              capture: false
            } : false;
            target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? {
              passive: false,
              capture: capture
            } : capture);
            target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
          }
          if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
            target.addEventListener('mousedown', swiper.onTouchStart, false);
            doc.addEventListener('mousemove', swiper.onTouchMove, capture);
            doc.addEventListener('mouseup', swiper.onTouchEnd, false);
          }
        }
        // Prevent Links Clicks
        if (params.preventClicks || params.preventClicksPropagation) {
          target.addEventListener('click', swiper.onClick, true);
        }
      }

      // Resize handler
      swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
    }
    function detachEvents() {
      var swiper = this;
      var params = swiper.params;
      var touchEvents = swiper.touchEvents;
      var el = swiper.el;
      var wrapperEl = swiper.wrapperEl;
      var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
      var capture = !!params.nested;

      // Touch Events
      {
        if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
          doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
        } else {
          if (Support.touch) {
            var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? {
              passive: true,
              capture: false
            } : false;
            target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
            target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
          }
          if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
            target.removeEventListener('mousedown', swiper.onTouchStart, false);
            doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
            doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
          }
        }
        // Prevent Links Clicks
        if (params.preventClicks || params.preventClicksPropagation) {
          target.removeEventListener('click', swiper.onClick, true);
        }
      }

      // Resize handler
      swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
    }
    var events = {
      attachEvents: attachEvents,
      detachEvents: detachEvents
    };
    function setBreakpoint() {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var initialized = swiper.initialized;
      var loopedSlides = swiper.loopedSlides;
      if (loopedSlides === void 0) loopedSlides = 0;
      var params = swiper.params;
      var breakpoints = params.breakpoints;
      if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) {
        return;
      }

      // Set breakpoint for window width and update parameters
      var breakpoint = swiper.getBreakpoint(breakpoints);
      if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
        var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
        if (breakpointOnlyParams) {
          ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
            var paramValue = breakpointOnlyParams[param];
            if (typeof paramValue === 'undefined') {
              return;
            }
            if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
              breakpointOnlyParams[param] = 'auto';
            } else if (param === 'slidesPerView') {
              breakpointOnlyParams[param] = parseFloat(paramValue);
            } else {
              breakpointOnlyParams[param] = parseInt(paramValue, 10);
            }
          });
        }
        var breakpointParams = breakpointOnlyParams || swiper.originalParams;
        var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
        var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
        if (directionChanged && initialized) {
          swiper.changeDirection();
        }
        Utils.extend(swiper.params, breakpointParams);
        Utils.extend(swiper, {
          allowTouchMove: swiper.params.allowTouchMove,
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev
        });
        swiper.currentBreakpoint = breakpoint;
        if (needsReLoop && initialized) {
          swiper.loopDestroy();
          swiper.loopCreate();
          swiper.updateSlides();
          swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
        }
        swiper.emit('breakpoint', breakpointParams);
      }
    }
    function getBreakpoint(breakpoints) {
      var swiper = this;
      // Get breakpoint for window width
      if (!breakpoints) {
        return undefined;
      }
      var breakpoint = false;
      var points = [];
      Object.keys(breakpoints).forEach(function (point) {
        points.push(point);
      });
      points.sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });
      for (var i = 0; i < points.length; i += 1) {
        var point = points[i];
        if (swiper.params.breakpointsInverse) {
          if (point <= win.innerWidth) {
            breakpoint = point;
          }
        } else if (point >= win.innerWidth && !breakpoint) {
          breakpoint = point;
        }
      }
      return breakpoint || 'max';
    }
    var breakpoints = {
      setBreakpoint: setBreakpoint,
      getBreakpoint: getBreakpoint
    };
    function addClasses() {
      var swiper = this;
      var classNames = swiper.classNames;
      var params = swiper.params;
      var rtl = swiper.rtl;
      var $el = swiper.$el;
      var suffixes = [];
      suffixes.push('initialized');
      suffixes.push(params.direction);
      if (params.freeMode) {
        suffixes.push('free-mode');
      }
      if (!Support.flexbox) {
        suffixes.push('no-flexbox');
      }
      if (params.autoHeight) {
        suffixes.push('autoheight');
      }
      if (rtl) {
        suffixes.push('rtl');
      }
      if (params.slidesPerColumn > 1) {
        suffixes.push('multirow');
      }
      if (Device.android) {
        suffixes.push('android');
      }
      if (Device.ios) {
        suffixes.push('ios');
      }
      // WP8 Touch Events Fix
      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        suffixes.push("wp8-" + params.direction);
      }
      suffixes.forEach(function (suffix) {
        classNames.push(params.containerModifierClass + suffix);
      });
      $el.addClass(classNames.join(' '));
    }
    function removeClasses() {
      var swiper = this;
      var $el = swiper.$el;
      var classNames = swiper.classNames;
      $el.removeClass(classNames.join(' '));
    }
    var classes = {
      addClasses: addClasses,
      removeClasses: removeClasses
    };
    function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
      var image;
      function onReady() {
        if (callback) {
          callback();
        }
      }
      if (!imageEl.complete || !checkForComplete) {
        if (src) {
          image = new win.Image();
          image.onload = onReady;
          image.onerror = onReady;
          if (sizes) {
            image.sizes = sizes;
          }
          if (srcset) {
            image.srcset = srcset;
          }
          if (src) {
            image.src = src;
          }
        } else {
          onReady();
        }
      } else {
        // image already loaded...
        onReady();
      }
    }
    function preloadImages() {
      var swiper = this;
      swiper.imagesToLoad = swiper.$el.find('img');
      function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) {
          return;
        }
        if (swiper.imagesLoaded !== undefined) {
          swiper.imagesLoaded += 1;
        }
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
          if (swiper.params.updateOnImagesReady) {
            swiper.update();
          }
          swiper.emit('imagesReady');
        }
      }
      for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
      }
    }
    var images = {
      loadImage: loadImage,
      preloadImages: preloadImages
    };
    function checkOverflow() {
      var swiper = this;
      var wasLocked = swiper.isLocked;
      swiper.isLocked = swiper.snapGrid.length === 1;
      swiper.allowSlideNext = !swiper.isLocked;
      swiper.allowSlidePrev = !swiper.isLocked;

      // events
      if (wasLocked !== swiper.isLocked) {
        swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
      }
      if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        swiper.navigation.update();
      }
    }
    var checkOverflow$1 = {
      checkOverflow: checkOverflow
    };
    var defaults = {
      init: true,
      direction: 'horizontal',
      touchEventsTarget: 'container',
      initialSlide: 0,
      speed: 300,
      //
      preventInteractionOnTransition: false,
      // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,
      // Free mode
      freeMode: false,
      freeModeMomentum: true,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: true,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: false,
      freeModeMinimumVelocity: 0.02,
      // Autoheight
      autoHeight: false,
      // Set wrapper width
      setWrapperSize: false,
      // Virtual Translate
      virtualTranslate: false,
      // Effects
      effect: 'slide',
      // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

      // Breakpoints
      breakpoints: undefined,
      breakpointsInverse: false,
      // Slides grid
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: 'column',
      slidesPerGroup: 1,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      // in px
      slidesOffsetAfter: 0,
      // in px
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,
      // Disable swiper and hide navigation when container not overflow
      watchOverflow: false,
      // Round length
      roundLengths: false,
      // Touches
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 0,
      touchMoveStopPropagation: true,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,
      // Unique Navigation Elements
      uniqueNavElements: true,
      // Resistance
      resistance: true,
      resistanceRatio: 0.85,
      // Progress
      watchSlidesProgress: false,
      watchSlidesVisibility: false,
      // Cursor
      grabCursor: false,
      // Clicks
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      // Images
      preloadImages: true,
      updateOnImagesReady: true,
      // loop
      loop: false,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: false,
      // Swiping/no swiping
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null,
      // '.swipe-handler',
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      noSwipingSelector: null,
      // Passive Listeners
      passiveListeners: true,
      // NS
      containerModifierClass: 'swiper-container-',
      // NEW
      slideClass: 'swiper-slide',
      slideBlankClass: 'swiper-slide-invisible-blank',
      slideActiveClass: 'swiper-slide-active',
      slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
      slideVisibleClass: 'swiper-slide-visible',
      slideDuplicateClass: 'swiper-slide-duplicate',
      slideNextClass: 'swiper-slide-next',
      slideDuplicateNextClass: 'swiper-slide-duplicate-next',
      slidePrevClass: 'swiper-slide-prev',
      slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
      wrapperClass: 'swiper-wrapper',
      // Callbacks
      runCallbacksOnInit: true
    };

    /* eslint no-param-reassign: "off" */

    var prototypes = {
      update: update,
      translate: translate,
      transition: transition$1,
      slide: slide,
      loop: loop,
      grabCursor: grabCursor,
      manipulation: manipulation,
      events: events,
      breakpoints: breakpoints,
      checkOverflow: checkOverflow$1,
      classes: classes,
      images: images
    };
    var extendedDefaults = {};
    var Swiper = /*@__PURE__*/function (SwiperClass) {
      function Swiper() {
        var assign;
        var args = [],
          len = arguments.length;
        while (len--) args[len] = arguments[len];
        var el;
        var params;
        if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
          params = args[0];
        } else {
          assign = args, el = assign[0], params = assign[1];
        }
        if (!params) {
          params = {};
        }
        params = Utils.extend({}, params);
        if (el && !params.el) {
          params.el = el;
        }
        SwiperClass.call(this, params);
        Object.keys(prototypes).forEach(function (prototypeGroup) {
          Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
            if (!Swiper.prototype[protoMethod]) {
              Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
            }
          });
        });

        // Swiper Instance
        var swiper = this;
        if (typeof swiper.modules === 'undefined') {
          swiper.modules = {};
        }
        Object.keys(swiper.modules).forEach(function (moduleName) {
          var module = swiper.modules[moduleName];
          if (module.params) {
            var moduleParamName = Object.keys(module.params)[0];
            var moduleParams = module.params[moduleParamName];
            if (_typeof(moduleParams) !== 'object' || moduleParams === null) {
              return;
            }
            if (!(moduleParamName in params && 'enabled' in moduleParams)) {
              return;
            }
            if (params[moduleParamName] === true) {
              params[moduleParamName] = {
                enabled: true
              };
            }
            if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
              params[moduleParamName].enabled = true;
            }
            if (!params[moduleParamName]) {
              params[moduleParamName] = {
                enabled: false
              };
            }
          }
        });

        // Extend defaults with modules params
        var swiperParams = Utils.extend({}, defaults);
        swiper.useModulesParams(swiperParams);

        // Extend defaults with passed params
        swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = Utils.extend({}, swiper.params);
        swiper.passedParams = Utils.extend({}, params);

        // Save Dom lib
        swiper.$ = $;

        // Find el
        var $el = $(swiper.params.el);
        el = $el[0];
        if (!el) {
          return undefined;
        }
        if ($el.length > 1) {
          var swipers = [];
          $el.each(function (index, containerEl) {
            var newParams = Utils.extend({}, params, {
              el: containerEl
            });
            swipers.push(new Swiper(newParams));
          });
          return swipers;
        }
        el.swiper = swiper;
        $el.data('swiper', swiper);

        // Find Wrapper
        var $wrapperEl = $el.children("." + swiper.params.wrapperClass);

        // Extend Swiper
        Utils.extend(swiper, {
          $el: $el,
          el: el,
          $wrapperEl: $wrapperEl,
          wrapperEl: $wrapperEl[0],
          // Classes
          classNames: [],
          // Slides
          slides: $(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          // isDirection
          isHorizontal: function isHorizontal() {
            return swiper.params.direction === 'horizontal';
          },
          isVertical: function isVertical() {
            return swiper.params.direction === 'vertical';
          },
          // RTL
          rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
          rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
          wrongRTL: $wrapperEl.css('display') === '-webkit-box',
          // Indexes
          activeIndex: 0,
          realIndex: 0,
          //
          isBeginning: true,
          isEnd: false,
          // Props
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,
          // Locks
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,
          // Touch Events
          touchEvents: function touchEvents() {
            var touch = ['touchstart', 'touchmove', 'touchend'];
            var desktop = ['mousedown', 'mousemove', 'mouseup'];
            if (Support.pointerEvents) {
              desktop = ['pointerdown', 'pointermove', 'pointerup'];
            } else if (Support.prefixedPointerEvents) {
              desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
            }
            swiper.touchEventsTouch = {
              start: touch[0],
              move: touch[1],
              end: touch[2]
            };
            swiper.touchEventsDesktop = {
              start: desktop[0],
              move: desktop[1],
              end: desktop[2]
            };
            return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
          }(),
          touchEventsData: {
            isTouched: undefined,
            isMoved: undefined,
            allowTouchCallbacks: undefined,
            touchStartTime: undefined,
            isScrolling: undefined,
            currentTranslate: undefined,
            startTranslate: undefined,
            allowThresholdMove: undefined,
            // Form elements to match
            formElements: 'input, select, option, textarea, button, video',
            // Last click time
            lastClickTime: Utils.now(),
            clickTimeout: undefined,
            // Velocities
            velocities: [],
            allowMomentumBounce: undefined,
            isTouchEvent: undefined,
            startMoving: undefined
          },
          // Clicks
          allowClick: true,
          // Touches
          allowTouchMove: swiper.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
          },
          // Images
          imagesToLoad: [],
          imagesLoaded: 0
        });

        // Install Modules
        swiper.useModules();

        // Init
        if (swiper.params.init) {
          swiper.init();
        }

        // Return app instance
        return swiper;
      }
      if (SwiperClass) Swiper.__proto__ = SwiperClass;
      Swiper.prototype = Object.create(SwiperClass && SwiperClass.prototype);
      Swiper.prototype.constructor = Swiper;
      var staticAccessors = {
        extendedDefaults: {
          configurable: true
        },
        defaults: {
          configurable: true
        },
        Class: {
          configurable: true
        },
        $: {
          configurable: true
        }
      };
      Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic() {
        var swiper = this;
        var params = swiper.params;
        var slides = swiper.slides;
        var slidesGrid = swiper.slidesGrid;
        var swiperSize = swiper.size;
        var activeIndex = swiper.activeIndex;
        var spv = 1;
        if (params.centeredSlides) {
          var slideSize = slides[activeIndex].swiperSlideSize;
          var breakLoop;
          for (var i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) {
                breakLoop = true;
              }
            }
          }
          for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
            if (slides[i$1] && !breakLoop) {
              slideSize += slides[i$1].swiperSlideSize;
              spv += 1;
              if (slideSize > swiperSize) {
                breakLoop = true;
              }
            }
          }
        } else {
          for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
            if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
              spv += 1;
            }
          }
        }
        return spv;
      };
      Swiper.prototype.update = function update() {
        var swiper = this;
        if (!swiper || swiper.destroyed) {
          return;
        }
        var snapGrid = swiper.snapGrid;
        var params = swiper.params;
        // Breakpoints
        if (params.breakpoints) {
          swiper.setBreakpoint();
        }
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
          var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
          var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }
        var translated;
        if (swiper.params.freeMode) {
          setTranslate();
          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
            translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }
          if (!translated) {
            setTranslate();
          }
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }
        swiper.emit('update');
      };
      Swiper.prototype.changeDirection = function changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        var swiper = this;
        var currentDirection = swiper.params.direction;
        if (!newDirection) {
          // eslint-disable-next-line
          newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        }
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
          return swiper;
        }
        swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection + " wp8-" + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
        if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
          swiper.$el.addClass(swiper.params.containerModifierClass + "wp8-" + newDirection);
        }
        swiper.params.direction = newDirection;
        swiper.slides.each(function (slideIndex, slideEl) {
          if (newDirection === 'vertical') {
            slideEl.style.width = '';
          } else {
            slideEl.style.height = '';
          }
        });
        swiper.emit('changeDirection');
        if (needUpdate) {
          swiper.update();
        }
        return swiper;
      };
      Swiper.prototype.init = function init() {
        var swiper = this;
        if (swiper.initialized) {
          return;
        }
        swiper.emit('beforeInit');

        // Set breakpoint
        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        }

        // Add Classes
        swiper.addClasses();

        // Create loop
        if (swiper.params.loop) {
          swiper.loopCreate();
        }

        // Update size
        swiper.updateSize();

        // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        }

        // Set Grab Cursor
        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }
        if (swiper.params.preloadImages) {
          swiper.preloadImages();
        }

        // Slide To Initial Slide
        if (swiper.params.loop) {
          swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
        } else {
          swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
        }

        // Attach events
        swiper.attachEvents();

        // Init Flag
        swiper.initialized = true;

        // Emit
        swiper.emit('init');
      };
      Swiper.prototype.destroy = function destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        var swiper = this;
        var params = swiper.params;
        var $el = swiper.$el;
        var $wrapperEl = swiper.$wrapperEl;
        var slides = swiper.slides;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
          return null;
        }
        swiper.emit('beforeDestroy');

        // Init Flag
        swiper.initialized = false;

        // Detach events
        swiper.detachEvents();

        // Destroy loop
        if (params.loop) {
          swiper.loopDestroy();
        }

        // Cleanup styles
        if (cleanStyles) {
          swiper.removeClasses();
          $el.removeAttr('style');
          $wrapperEl.removeAttr('style');
          if (slides && slides.length) {
            slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index').removeAttr('data-swiper-column').removeAttr('data-swiper-row');
          }
        }
        swiper.emit('destroy');

        // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach(function (eventName) {
          swiper.off(eventName);
        });
        if (deleteInstance !== false) {
          swiper.$el[0].swiper = null;
          swiper.$el.data('swiper', null);
          Utils.deleteProps(swiper);
        }
        swiper.destroyed = true;
        return null;
      };
      Swiper.extendDefaults = function extendDefaults(newDefaults) {
        Utils.extend(extendedDefaults, newDefaults);
      };
      staticAccessors.extendedDefaults.get = function () {
        return extendedDefaults;
      };
      staticAccessors.defaults.get = function () {
        return defaults;
      };
      staticAccessors.Class.get = function () {
        return SwiperClass;
      };
      staticAccessors.$.get = function () {
        return $;
      };
      Object.defineProperties(Swiper, staticAccessors);
      return Swiper;
    }(SwiperClass);
    var Device$1 = {
      name: 'device',
      proto: {
        device: Device
      },
      "static": {
        device: Device
      }
    };
    var Support$1 = {
      name: 'support',
      proto: {
        support: Support
      },
      "static": {
        support: Support
      }
    };
    var Browser$1 = {
      name: 'browser',
      proto: {
        browser: Browser
      },
      "static": {
        browser: Browser
      }
    };
    var Resize = {
      name: 'resize',
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          resize: {
            resizeHandler: function resizeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) {
                return;
              }
              swiper.emit('beforeResize');
              swiper.emit('resize');
            },
            orientationChangeHandler: function orientationChangeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) {
                return;
              }
              swiper.emit('orientationchange');
            }
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          // Emit resize
          win.addEventListener('resize', swiper.resize.resizeHandler);

          // Emit orientationchange
          win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        },
        destroy: function destroy() {
          var swiper = this;
          win.removeEventListener('resize', swiper.resize.resizeHandler);
          win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        }
      }
    };
    var Observer = {
      func: win.MutationObserver || win.WebkitMutationObserver,
      attach: function attach(target, options) {
        if (options === void 0) options = {};
        var swiper = this;
        var ObserverFunc = Observer.func;
        var observer = new ObserverFunc(function (mutations) {
          // The observerUpdate event should only be triggered
          // once despite the number of mutations.  Additional
          // triggers are redundant and are very costly
          if (mutations.length === 1) {
            swiper.emit('observerUpdate', mutations[0]);
            return;
          }
          var observerUpdate = function observerUpdate() {
            swiper.emit('observerUpdate', mutations[0]);
          };
          if (win.requestAnimationFrame) {
            win.requestAnimationFrame(observerUpdate);
          } else {
            win.setTimeout(observerUpdate, 0);
          }
        });
        observer.observe(target, {
          attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
          childList: typeof options.childList === 'undefined' ? true : options.childList,
          characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
      },
      init: function init() {
        var swiper = this;
        if (!Support.observer || !swiper.params.observer) {
          return;
        }
        if (swiper.params.observeParents) {
          var containerParents = swiper.$el.parents();
          for (var i = 0; i < containerParents.length; i += 1) {
            swiper.observer.attach(containerParents[i]);
          }
        }
        // Observe container
        swiper.observer.attach(swiper.$el[0], {
          childList: swiper.params.observeSlideChildren
        });

        // Observe wrapper
        swiper.observer.attach(swiper.$wrapperEl[0], {
          attributes: false
        });
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.observers.forEach(function (observer) {
          observer.disconnect();
        });
        swiper.observer.observers = [];
      }
    };
    var Observer$1 = {
      name: 'observer',
      params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          observer: {
            init: Observer.init.bind(swiper),
            attach: Observer.attach.bind(swiper),
            destroy: Observer.destroy.bind(swiper),
            observers: []
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.observer.init();
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.observer.destroy();
        }
      }
    };
    var Virtual = {
      update: function update(force) {
        var swiper = this;
        var ref = swiper.params;
        var slidesPerView = ref.slidesPerView;
        var slidesPerGroup = ref.slidesPerGroup;
        var centeredSlides = ref.centeredSlides;
        var ref$1 = swiper.params.virtual;
        var addSlidesBefore = ref$1.addSlidesBefore;
        var addSlidesAfter = ref$1.addSlidesAfter;
        var ref$2 = swiper.virtual;
        var previousFrom = ref$2.from;
        var previousTo = ref$2.to;
        var slides = ref$2.slides;
        var previousSlidesGrid = ref$2.slidesGrid;
        var renderSlide = ref$2.renderSlide;
        var previousOffset = ref$2.offset;
        swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) {
          offsetProp = 'right';
        } else {
          offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        }
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
          slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
          slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
        } else {
          slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
          slidesBefore = slidesPerGroup + addSlidesAfter;
        }
        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Utils.extend(swiper.virtual, {
          from: from,
          to: to,
          offset: offset,
          slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
          swiper.updateSlides();
          swiper.updateProgress();
          swiper.updateSlidesClasses();
          if (swiper.lazy && swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        }
        if (previousFrom === from && previousTo === to && !force) {
          if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
            swiper.slides.css(offsetProp, offset + "px");
          }
          swiper.updateProgress();
          return;
        }
        if (swiper.params.virtual.renderExternal) {
          swiper.params.virtual.renderExternal.call(swiper, {
            offset: offset,
            from: from,
            to: to,
            slides: function getSlides() {
              var slidesToRender = [];
              for (var i = from; i <= to; i += 1) {
                slidesToRender.push(slides[i]);
              }
              return slidesToRender;
            }()
          });
          onRendered();
          return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        if (force) {
          swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
        } else {
          for (var i = previousFrom; i <= previousTo; i += 1) {
            if (i < from || i > to) {
              swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
            }
          }
        }
        for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
          if (i$1 >= from && i$1 <= to) {
            if (typeof previousTo === 'undefined' || force) {
              appendIndexes.push(i$1);
            } else {
              if (i$1 > previousTo) {
                appendIndexes.push(i$1);
              }
              if (i$1 < previousFrom) {
                prependIndexes.push(i$1);
              }
            }
          }
        }
        appendIndexes.forEach(function (index) {
          swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function (a, b) {
          return b - a;
        }).forEach(function (index) {
          swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
        onRendered();
      },
      renderSlide: function renderSlide(slide, index) {
        var swiper = this;
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) {
          return swiper.virtual.cache[index];
        }
        var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");
        if (!$slideEl.attr('data-swiper-slide-index')) {
          $slideEl.attr('data-swiper-slide-index', index);
        }
        if (params.cache) {
          swiper.virtual.cache[index] = $slideEl;
        }
        return $slideEl;
      },
      appendSlide: function appendSlide(slides) {
        var swiper = this;
        if (_typeof(slides) === 'object' && 'length' in slides) {
          for (var i = 0; i < slides.length; i += 1) {
            if (slides[i]) {
              swiper.virtual.slides.push(slides[i]);
            }
          }
        } else {
          swiper.virtual.slides.push(slides);
        }
        swiper.virtual.update(true);
      },
      prependSlide: function prependSlide(slides) {
        var swiper = this;
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
          for (var i = 0; i < slides.length; i += 1) {
            if (slides[i]) {
              swiper.virtual.slides.unshift(slides[i]);
            }
          }
          newActiveIndex = activeIndex + slides.length;
          numberOfNewSlides = slides.length;
        } else {
          swiper.virtual.slides.unshift(slides);
        }
        if (swiper.params.virtual.cache) {
          var cache = swiper.virtual.cache;
          var newCache = {};
          Object.keys(cache).forEach(function (cachedIndex) {
            newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
          });
          swiper.virtual.cache = newCache;
        }
        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
      },
      removeSlide: function removeSlide(slidesIndexes) {
        var swiper = this;
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) {
          return;
        }
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) {
          for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) {
              delete swiper.virtual.cache[slidesIndexes[i]];
            }
            if (slidesIndexes[i] < activeIndex) {
              activeIndex -= 1;
            }
            activeIndex = Math.max(activeIndex, 0);
          }
        } else {
          swiper.virtual.slides.splice(slidesIndexes, 1);
          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes];
          }
          if (slidesIndexes < activeIndex) {
            activeIndex -= 1;
          }
          activeIndex = Math.max(activeIndex, 0);
        }
        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
      },
      removeAllSlides: function removeAllSlides() {
        var swiper = this;
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) {
          swiper.virtual.cache = {};
        }
        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
      }
    };
    var Virtual$1 = {
      name: 'virtual',
      params: {
        virtual: {
          enabled: false,
          slides: [],
          cache: true,
          renderSlide: null,
          renderExternal: null,
          addSlidesBefore: 0,
          addSlidesAfter: 0
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          virtual: {
            update: Virtual.update.bind(swiper),
            appendSlide: Virtual.appendSlide.bind(swiper),
            prependSlide: Virtual.prependSlide.bind(swiper),
            removeSlide: Virtual.removeSlide.bind(swiper),
            removeAllSlides: Virtual.removeAllSlides.bind(swiper),
            renderSlide: Virtual.renderSlide.bind(swiper),
            slides: swiper.params.virtual.slides,
            cache: {}
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          if (!swiper.params.virtual.enabled) {
            return;
          }
          swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
          var overwriteParams = {
            watchSlidesProgress: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
          if (!swiper.params.initialSlide) {
            swiper.virtual.update();
          }
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          if (!swiper.params.virtual.enabled) {
            return;
          }
          swiper.virtual.update();
        }
      }
    };
    var Keyboard = {
      handle: function handle(event) {
        var swiper = this;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) {
          e = e.originalEvent;
        } // jquery fix
        var kc = e.keyCode || e.charCode;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40 || kc === 34)) {
          return false;
        }
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38 || kc === 33)) {
          return false;
        }
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
          return undefined;
        }
        if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
          return undefined;
        }
        if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
          var inView = false;
          // Check that swiper should be inside of visible area of window
          if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
            return undefined;
          }
          var windowWidth = win.innerWidth;
          var windowHeight = win.innerHeight;
          var swiperOffset = swiper.$el.offset();
          if (rtl) {
            swiperOffset.left -= swiper.$el[0].scrollLeft;
          }
          var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];
          for (var i = 0; i < swiperCoord.length; i += 1) {
            var point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
              inView = true;
            }
          }
          if (!inView) {
            return undefined;
          }
        }
        if (swiper.isHorizontal()) {
          if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
            if (e.preventDefault) {
              e.preventDefault();
            } else {
              e.returnValue = false;
            }
          }
          if ((kc === 34 || kc === 39) && !rtl || (kc === 33 || kc === 37) && rtl) {
            swiper.slideNext();
          }
          if ((kc === 33 || kc === 37) && !rtl || (kc === 34 || kc === 39) && rtl) {
            swiper.slidePrev();
          }
        } else {
          if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
            if (e.preventDefault) {
              e.preventDefault();
            } else {
              e.returnValue = false;
            }
          }
          if (kc === 34 || kc === 40) {
            swiper.slideNext();
          }
          if (kc === 33 || kc === 38) {
            swiper.slidePrev();
          }
        }
        swiper.emit('keyPress', kc);
        return undefined;
      },
      enable: function enable() {
        var swiper = this;
        if (swiper.keyboard.enabled) {
          return;
        }
        $(doc).on('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
      },
      disable: function disable() {
        var swiper = this;
        if (!swiper.keyboard.enabled) {
          return;
        }
        $(doc).off('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
      }
    };
    var Keyboard$1 = {
      name: 'keyboard',
      params: {
        keyboard: {
          enabled: false,
          onlyInViewport: true
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          keyboard: {
            enabled: false,
            enable: Keyboard.enable.bind(swiper),
            disable: Keyboard.disable.bind(swiper),
            handle: Keyboard.handle.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          if (swiper.params.keyboard.enabled) {
            swiper.keyboard.enable();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          if (swiper.keyboard.enabled) {
            swiper.keyboard.disable();
          }
        }
      }
    };
    function isEventSupported() {
      var eventName = 'onwheel';
      var isSupported = eventName in doc;
      if (!isSupported) {
        var element = doc.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
      }
      if (!isSupported && doc.implementation && doc.implementation.hasFeature
      // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true) {
        // This is the only way to test support for the `wheel` event in IE9+.
        isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
      }
      return isSupported;
    }
    var Mousewheel = {
      lastScrollTime: Utils.now(),
      event: function getEvent() {
        if (win.navigator.userAgent.indexOf('firefox') > -1) {
          return 'DOMMouseScroll';
        }
        return isEventSupported() ? 'wheel' : 'mousewheel';
      }(),
      normalize: function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY

        // Legacy
        if ('detail' in e) {
          sY = e.detail;
        }
        if ('wheelDelta' in e) {
          sY = -e.wheelDelta / 120;
        }
        if ('wheelDeltaY' in e) {
          sY = -e.wheelDeltaY / 120;
        }
        if ('wheelDeltaX' in e) {
          sX = -e.wheelDeltaX / 120;
        }

        // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
          sX = sY;
          sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) {
          pY = e.deltaY;
        }
        if ('deltaX' in e) {
          pX = e.deltaX;
        }
        if ((pX || pY) && e.deltaMode) {
          if (e.deltaMode === 1) {
            // delta in LINE units
            pX *= LINE_HEIGHT;
            pY *= LINE_HEIGHT;
          } else {
            // delta in PAGE units
            pX *= PAGE_HEIGHT;
            pY *= PAGE_HEIGHT;
          }
        }

        // Fall-back if spin cannot be determined
        if (pX && !sX) {
          sX = pX < 1 ? -1 : 1;
        }
        if (pY && !sY) {
          sY = pY < 1 ? -1 : 1;
        }
        return {
          spinX: sX,
          spinY: sY,
          pixelX: pX,
          pixelY: pY
        };
      },
      handleMouseEnter: function handleMouseEnter() {
        var swiper = this;
        swiper.mouseEntered = true;
      },
      handleMouseLeave: function handleMouseLeave() {
        var swiper = this;
        swiper.mouseEntered = false;
      },
      handle: function handle(event) {
        var e = event;
        var swiper = this;
        var params = swiper.params.mousewheel;
        if (!swiper.mouseEntered && !params.releaseOnEdges) {
          return true;
        }
        if (e.originalEvent) {
          e = e.originalEvent;
        } // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = Mousewheel.normalize(e);
        if (params.forceToAxis) {
          if (swiper.isHorizontal()) {
            if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) {
              delta = data.pixelX * rtlFactor;
            } else {
              return true;
            }
          } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) {
            delta = data.pixelY;
          } else {
            return true;
          }
        } else {
          delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        }
        if (delta === 0) {
          return true;
        }
        if (params.invert) {
          delta = -delta;
        }
        if (!swiper.params.freeMode) {
          if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
            if (delta < 0) {
              if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                swiper.emit('scroll', e);
              } else if (params.releaseOnEdges) {
                return true;
              }
            } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
              swiper.slidePrev();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) {
              return true;
            }
          }
          swiper.mousewheel.lastScrollTime = new win.Date().getTime();
        } else {
          // Freemode or scrollContainer:
          if (swiper.params.loop) {
            swiper.loopFix();
          }
          var position = swiper.getTranslate() + delta * params.sensitivity;
          var wasBeginning = swiper.isBeginning;
          var wasEnd = swiper.isEnd;
          if (position >= swiper.minTranslate()) {
            position = swiper.minTranslate();
          }
          if (position <= swiper.maxTranslate()) {
            position = swiper.maxTranslate();
          }
          swiper.setTransition(0);
          swiper.setTranslate(position);
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
          if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
            swiper.updateSlidesClasses();
          }
          if (swiper.params.freeModeSticky) {
            clearTimeout(swiper.mousewheel.timeout);
            swiper.mousewheel.timeout = Utils.nextTick(function () {
              swiper.slideToClosest();
            }, 300);
          }
          // Emit event
          swiper.emit('scroll', e);

          // Stop autoplay
          if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) {
            swiper.autoplay.stop();
          }
          // Return page scroll on edge positions
          if (position === swiper.minTranslate() || position === swiper.maxTranslate()) {
            return true;
          }
        }
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
        return false;
      },
      enable: function enable() {
        var swiper = this;
        if (!Mousewheel.event) {
          return false;
        }
        if (swiper.mousewheel.enabled) {
          return false;
        }
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarged);
        }
        target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
        target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
        target.on(Mousewheel.event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
      },
      disable: function disable() {
        var swiper = this;
        if (!Mousewheel.event) {
          return false;
        }
        if (!swiper.mousewheel.enabled) {
          return false;
        }
        var target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarged !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarged);
        }
        target.off(Mousewheel.event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
      }
    };
    var Mousewheel$1 = {
      name: 'mousewheel',
      params: {
        mousewheel: {
          enabled: false,
          releaseOnEdges: false,
          invert: false,
          forceToAxis: false,
          sensitivity: 1,
          eventsTarged: 'container'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          mousewheel: {
            enabled: false,
            enable: Mousewheel.enable.bind(swiper),
            disable: Mousewheel.disable.bind(swiper),
            handle: Mousewheel.handle.bind(swiper),
            handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
            handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
            lastScrollTime: Utils.now()
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          if (swiper.params.mousewheel.enabled) {
            swiper.mousewheel.enable();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          if (swiper.mousewheel.enabled) {
            swiper.mousewheel.disable();
          }
        }
      }
    };
    var Navigation = {
      update: function update() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;
        if (swiper.params.loop) {
          return;
        }
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            $prevEl.addClass(params.disabledClass);
          } else {
            $prevEl.removeClass(params.disabledClass);
          }
          $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            $nextEl.addClass(params.disabledClass);
          } else {
            $nextEl.removeClass(params.disabledClass);
          }
          $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
      },
      onPrevClick: function onPrevClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop) {
          return;
        }
        swiper.slidePrev();
      },
      onNextClick: function onNextClick(e) {
        var swiper = this;
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop) {
          return;
        }
        swiper.slideNext();
      },
      init: function init() {
        var swiper = this;
        var params = swiper.params.navigation;
        if (!(params.nextEl || params.prevEl)) {
          return;
        }
        var $nextEl;
        var $prevEl;
        if (params.nextEl) {
          $nextEl = $(params.nextEl);
          if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
            $nextEl = swiper.$el.find(params.nextEl);
          }
        }
        if (params.prevEl) {
          $prevEl = $(params.prevEl);
          if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
            $prevEl = swiper.$el.find(params.prevEl);
          }
        }
        if ($nextEl && $nextEl.length > 0) {
          $nextEl.on('click', swiper.navigation.onNextClick);
        }
        if ($prevEl && $prevEl.length > 0) {
          $prevEl.on('click', swiper.navigation.onPrevClick);
        }
        Utils.extend(swiper.navigation, {
          $nextEl: $nextEl,
          nextEl: $nextEl && $nextEl[0],
          $prevEl: $prevEl,
          prevEl: $prevEl && $prevEl[0]
        });
      },
      destroy: function destroy() {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if ($nextEl && $nextEl.length) {
          $nextEl.off('click', swiper.navigation.onNextClick);
          $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
          $prevEl.off('click', swiper.navigation.onPrevClick);
          $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
      }
    };
    var Navigation$1 = {
      name: 'navigation',
      params: {
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
          hiddenClass: 'swiper-button-hidden',
          lockClass: 'swiper-button-lock'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          navigation: {
            init: Navigation.init.bind(swiper),
            update: Navigation.update.bind(swiper),
            destroy: Navigation.destroy.bind(swiper),
            onNextClick: Navigation.onNextClick.bind(swiper),
            onPrevClick: Navigation.onPrevClick.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.navigation.init();
          swiper.navigation.update();
        },
        toEdge: function toEdge() {
          var swiper = this;
          swiper.navigation.update();
        },
        fromEdge: function fromEdge() {
          var swiper = this;
          swiper.navigation.update();
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.navigation.destroy();
        },
        click: function click(e) {
          var swiper = this;
          var ref = swiper.navigation;
          var $nextEl = ref.$nextEl;
          var $prevEl = ref.$prevEl;
          if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
            var isHidden;
            if ($nextEl) {
              isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            } else if ($prevEl) {
              isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            }
            if (isHidden === true) {
              swiper.emit('navigationShow', swiper);
            } else {
              swiper.emit('navigationHide', swiper);
            }
            if ($nextEl) {
              $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
            if ($prevEl) {
              $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
          }
        }
      }
    };
    var Pagination = {
      update: function update() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
          return;
        }
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        // Current/Total
        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
          current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
          if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
            current -= slidesLength - swiper.loopedSlides * 2;
          }
          if (current > total - 1) {
            current -= total;
          }
          if (current < 0 && swiper.params.paginationType !== 'bullets') {
            current = total + current;
          }
        } else if (typeof swiper.snapIndex !== 'undefined') {
          current = swiper.snapIndex;
        } else {
          current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
          var bullets = swiper.pagination.bullets;
          var firstIndex;
          var lastIndex;
          var midIndex;
          if (params.dynamicBullets) {
            swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
            $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");
            if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
              swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;
              if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
                swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
              } else if (swiper.pagination.dynamicBulletIndex < 0) {
                swiper.pagination.dynamicBulletIndex = 0;
              }
            }
            firstIndex = current - swiper.pagination.dynamicBulletIndex;
            lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
            midIndex = (lastIndex + firstIndex) / 2;
          }
          bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");
          if ($el.length > 1) {
            bullets.each(function (index, bullet) {
              var $bullet = $(bullet);
              var bulletIndex = $bullet.index();
              if (bulletIndex === current) {
                $bullet.addClass(params.bulletActiveClass);
              }
              if (params.dynamicBullets) {
                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                  $bullet.addClass(params.bulletActiveClass + "-main");
                }
                if (bulletIndex === firstIndex) {
                  $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                }
                if (bulletIndex === lastIndex) {
                  $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                }
              }
            });
          } else {
            var $bullet = bullets.eq(current);
            $bullet.addClass(params.bulletActiveClass);
            if (params.dynamicBullets) {
              var $firstDisplayedBullet = bullets.eq(firstIndex);
              var $lastDisplayedBullet = bullets.eq(lastIndex);
              for (var i = firstIndex; i <= lastIndex; i += 1) {
                bullets.eq(i).addClass(params.bulletActiveClass + "-main");
              }
              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }
          if (params.dynamicBullets) {
            var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
            var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
            var offsetProp = rtl ? 'right' : 'left';
            bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
          }
        }
        if (params.type === 'fraction') {
          $el.find("." + params.currentClass).text(params.formatFractionCurrent(current + 1));
          $el.find("." + params.totalClass).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
          var progressbarDirection;
          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
          } else {
            progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
          }
          var scale = (current + 1) / total;
          var scaleX = 1;
          var scaleY = 1;
          if (progressbarDirection === 'horizontal') {
            scaleX = scale;
          } else {
            scaleY = scale;
          }
          $el.find("." + params.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
          $el.html(params.renderCustom(swiper, current + 1, total));
          swiper.emit('paginationRender', swiper, $el[0]);
        } else {
          swiper.emit('paginationUpdate', swiper, $el[0]);
        }
        $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      },
      render: function render() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
          return;
        }
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = '';
        if (params.type === 'bullets') {
          var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
          for (var i = 0; i < numberOfBullets; i += 1) {
            if (params.renderBullet) {
              paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            } else {
              paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
            }
          }
          $el.html(paginationHTML);
          swiper.pagination.bullets = $el.find("." + params.bulletClass);
        }
        if (params.type === 'fraction') {
          if (params.renderFraction) {
            paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
          } else {
            paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + "<span class=\"" + params.totalClass + "\"></span>";
          }
          $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
          if (params.renderProgressbar) {
            paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
          } else {
            paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
          }
          $el.html(paginationHTML);
        }
        if (params.type !== 'custom') {
          swiper.emit('paginationRender', swiper.pagination.$el[0]);
        }
      },
      init: function init() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el) {
          return;
        }
        var $el = $(params.el);
        if ($el.length === 0) {
          return;
        }
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && swiper.$el.find(params.el).length === 1) {
          $el = swiper.$el.find(params.el);
        }
        if (params.type === 'bullets' && params.clickable) {
          $el.addClass(params.clickableClass);
        }
        $el.addClass(params.modifierClass + params.type);
        if (params.type === 'bullets' && params.dynamicBullets) {
          $el.addClass("" + params.modifierClass + params.type + "-dynamic");
          swiper.pagination.dynamicBulletIndex = 0;
          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) {
          $el.addClass(params.progressbarOppositeClass);
        }
        if (params.clickable) {
          $el.on('click', "." + params.bulletClass, function onClick(e) {
            e.preventDefault();
            var index = $(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) {
              index += swiper.loopedSlides;
            }
            swiper.slideTo(index);
          });
        }
        Utils.extend(swiper.pagination, {
          $el: $el,
          el: $el[0]
        });
      },
      destroy: function destroy() {
        var swiper = this;
        var params = swiper.params.pagination;
        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
          return;
        }
        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        if (swiper.pagination.bullets) {
          swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        }
        if (params.clickable) {
          $el.off('click', "." + params.bulletClass);
        }
      }
    };
    var Pagination$1 = {
      name: 'pagination',
      params: {
        pagination: {
          el: null,
          bulletElement: 'span',
          clickable: false,
          hideOnClick: false,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: false,
          type: 'bullets',
          // 'bullets' or 'progressbar' or 'fraction' or 'custom'
          dynamicBullets: false,
          dynamicMainBullets: 1,
          formatFractionCurrent: function formatFractionCurrent(number) {
            return number;
          },
          formatFractionTotal: function formatFractionTotal(number) {
            return number;
          },
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          modifierClass: 'swiper-pagination-',
          // NEW
          currentClass: 'swiper-pagination-current',
          totalClass: 'swiper-pagination-total',
          hiddenClass: 'swiper-pagination-hidden',
          progressbarFillClass: 'swiper-pagination-progressbar-fill',
          progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
          clickableClass: 'swiper-pagination-clickable',
          // NEW
          lockClass: 'swiper-pagination-lock'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          pagination: {
            init: Pagination.init.bind(swiper),
            render: Pagination.render.bind(swiper),
            update: Pagination.update.bind(swiper),
            destroy: Pagination.destroy.bind(swiper),
            dynamicBulletIndex: 0
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.pagination.init();
          swiper.pagination.render();
          swiper.pagination.update();
        },
        activeIndexChange: function activeIndexChange() {
          var swiper = this;
          if (swiper.params.loop) {
            swiper.pagination.update();
          } else if (typeof swiper.snapIndex === 'undefined') {
            swiper.pagination.update();
          }
        },
        snapIndexChange: function snapIndexChange() {
          var swiper = this;
          if (!swiper.params.loop) {
            swiper.pagination.update();
          }
        },
        slidesLengthChange: function slidesLengthChange() {
          var swiper = this;
          if (swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        snapGridLengthChange: function snapGridLengthChange() {
          var swiper = this;
          if (!swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.pagination.destroy();
        },
        click: function click(e) {
          var swiper = this;
          if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
            var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) {
              swiper.emit('paginationShow', swiper);
            } else {
              swiper.emit('paginationHide', swiper);
            }
            swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
          }
        }
      }
    };
    var Scrollbar = {
      setTranslate: function setTranslate() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
          return;
        }
        var scrollbar = swiper.scrollbar;
        var rtl = swiper.rtlTranslate;
        var progress = swiper.progress;
        var dragSize = scrollbar.dragSize;
        var trackSize = scrollbar.trackSize;
        var $dragEl = scrollbar.$dragEl;
        var $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
          newPos = -newPos;
          if (newPos > 0) {
            newSize = dragSize - newPos;
            newPos = 0;
          } else if (-newPos + dragSize > trackSize) {
            newSize = trackSize + newPos;
          }
        } else if (newPos < 0) {
          newSize = dragSize + newPos;
          newPos = 0;
        } else if (newPos + dragSize > trackSize) {
          newSize = trackSize - newPos;
        }
        if (swiper.isHorizontal()) {
          if (Support.transforms3d) {
            $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
          } else {
            $dragEl.transform("translateX(" + newPos + "px)");
          }
          $dragEl[0].style.width = newSize + "px";
        } else {
          if (Support.transforms3d) {
            $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
          } else {
            $dragEl.transform("translateY(" + newPos + "px)");
          }
          $dragEl[0].style.height = newSize + "px";
        }
        if (params.hide) {
          clearTimeout(swiper.scrollbar.timeout);
          $el[0].style.opacity = 1;
          swiper.scrollbar.timeout = setTimeout(function () {
            $el[0].style.opacity = 0;
            $el.transition(400);
          }, 1000);
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
          return;
        }
        swiper.scrollbar.$dragEl.transition(duration);
      },
      updateSize: function updateSize() {
        var swiper = this;
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
          return;
        }
        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl;
        var $el = scrollbar.$el;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        var divider = swiper.size / swiper.virtualSize;
        var moveDivider = divider * (trackSize / swiper.size);
        var dragSize;
        if (swiper.params.scrollbar.dragSize === 'auto') {
          dragSize = trackSize * divider;
        } else {
          dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        }
        if (swiper.isHorizontal()) {
          $dragEl[0].style.width = dragSize + "px";
        } else {
          $dragEl[0].style.height = dragSize + "px";
        }
        if (divider >= 1) {
          $el[0].style.display = 'none';
        } else {
          $el[0].style.display = '';
        }
        if (swiper.params.scrollbar.hide) {
          $el[0].style.opacity = 0;
        }
        Utils.extend(scrollbar, {
          trackSize: trackSize,
          divider: divider,
          moveDivider: moveDivider,
          dragSize: dragSize
        });
        scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
      },
      getPointerPosition: function getPointerPosition(e) {
        var swiper = this;
        if (swiper.isHorizontal()) {
          return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX || e.clientX;
        }
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY || e.clientY;
      },
      setDragPosition: function setDragPosition(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar;
        var rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el;
        var dragSize = scrollbar.dragSize;
        var trackSize = scrollbar.trackSize;
        var dragStartPos = scrollbar.dragStartPos;
        var positionRatio;
        positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) {
          positionRatio = 1 - positionRatio;
        }
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      },
      onDragStart: function onDragStart(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar;
        var $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        var $dragEl = scrollbar.$dragEl;
        swiper.scrollbar.isTouched = true;
        swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        scrollbar.setDragPosition(e);
        clearTimeout(swiper.scrollbar.dragTimeout);
        $el.transition(0);
        if (params.hide) {
          $el.css('opacity', 1);
        }
        swiper.emit('scrollbarDragStart', e);
      },
      onDragMove: function onDragMove(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar;
        var $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        var $dragEl = scrollbar.$dragEl;
        if (!swiper.scrollbar.isTouched) {
          return;
        }
        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }
        scrollbar.setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        swiper.emit('scrollbarDragMove', e);
      },
      onDragEnd: function onDragEnd(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar;
        var $el = scrollbar.$el;
        if (!swiper.scrollbar.isTouched) {
          return;
        }
        swiper.scrollbar.isTouched = false;
        if (params.hide) {
          clearTimeout(swiper.scrollbar.dragTimeout);
          swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
            $el.css('opacity', 0);
            $el.transition(400);
          }, 1000);
        }
        swiper.emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) {
          swiper.slideToClosest();
        }
      },
      enableDraggable: function enableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) {
          return;
        }
        var scrollbar = swiper.scrollbar;
        var touchEventsTouch = swiper.touchEventsTouch;
        var touchEventsDesktop = swiper.touchEventsDesktop;
        var params = swiper.params;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = Support.passiveListener && params.passiveListeners ? {
          passive: false,
          capture: false
        } : false;
        var passiveListener = Support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        if (!Support.touch) {
          target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
          doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
          doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
          target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
          target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
          target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
      },
      disableDraggable: function disableDraggable() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) {
          return;
        }
        var scrollbar = swiper.scrollbar;
        var touchEventsTouch = swiper.touchEventsTouch;
        var touchEventsDesktop = swiper.touchEventsDesktop;
        var params = swiper.params;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = Support.passiveListener && params.passiveListeners ? {
          passive: false,
          capture: false
        } : false;
        var passiveListener = Support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;
        if (!Support.touch) {
          target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
          doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
          doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
          target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
          target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
          target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.scrollbar.el) {
          return;
        }
        var scrollbar = swiper.scrollbar;
        var $swiperEl = swiper.$el;
        var params = swiper.params.scrollbar;
        var $el = $(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
          $el = $swiperEl.find(params.el);
        }
        var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);
        if ($dragEl.length === 0) {
          $dragEl = $("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
          $el.append($dragEl);
        }
        Utils.extend(scrollbar, {
          $el: $el,
          el: $el[0],
          $dragEl: $dragEl,
          dragEl: $dragEl[0]
        });
        if (params.draggable) {
          scrollbar.enableDraggable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.disableDraggable();
      }
    };
    var Scrollbar$1 = {
      name: 'scrollbar',
      params: {
        scrollbar: {
          el: null,
          dragSize: 'auto',
          hide: false,
          draggable: false,
          snapOnRelease: true,
          lockClass: 'swiper-scrollbar-lock',
          dragClass: 'swiper-scrollbar-drag'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          scrollbar: {
            init: Scrollbar.init.bind(swiper),
            destroy: Scrollbar.destroy.bind(swiper),
            updateSize: Scrollbar.updateSize.bind(swiper),
            setTranslate: Scrollbar.setTranslate.bind(swiper),
            setTransition: Scrollbar.setTransition.bind(swiper),
            enableDraggable: Scrollbar.enableDraggable.bind(swiper),
            disableDraggable: Scrollbar.disableDraggable.bind(swiper),
            setDragPosition: Scrollbar.setDragPosition.bind(swiper),
            getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
            onDragStart: Scrollbar.onDragStart.bind(swiper),
            onDragMove: Scrollbar.onDragMove.bind(swiper),
            onDragEnd: Scrollbar.onDragEnd.bind(swiper),
            isTouched: false,
            timeout: null,
            dragTimeout: null
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.scrollbar.init();
          swiper.scrollbar.updateSize();
          swiper.scrollbar.setTranslate();
        },
        update: function update() {
          var swiper = this;
          swiper.scrollbar.updateSize();
        },
        resize: function resize() {
          var swiper = this;
          swiper.scrollbar.updateSize();
        },
        observerUpdate: function observerUpdate() {
          var swiper = this;
          swiper.scrollbar.updateSize();
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          swiper.scrollbar.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          swiper.scrollbar.setTransition(duration);
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.scrollbar.destroy();
        }
      }
    };
    var Parallax = {
      setTransform: function setTransform(el, progress) {
        var swiper = this;
        var rtl = swiper.rtl;
        var $el = $(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr('data-swiper-parallax') || '0';
        var x = $el.attr('data-swiper-parallax-x');
        var y = $el.attr('data-swiper-parallax-y');
        var scale = $el.attr('data-swiper-parallax-scale');
        var opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
          x = x || '0';
          y = y || '0';
        } else if (swiper.isHorizontal()) {
          x = p;
          y = '0';
        } else {
          y = p;
          x = '0';
        }
        if (x.indexOf('%') >= 0) {
          x = parseInt(x, 10) * progress * rtlFactor + "%";
        } else {
          x = x * progress * rtlFactor + "px";
        }
        if (y.indexOf('%') >= 0) {
          y = parseInt(y, 10) * progress + "%";
        } else {
          y = y * progress + "px";
        }
        if (typeof opacity !== 'undefined' && opacity !== null) {
          var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
          $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) {
          $el.transform("translate3d(" + x + ", " + y + ", 0px)");
        } else {
          var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
          $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el;
        var slides = swiper.slides;
        var progress = swiper.progress;
        var snapGrid = swiper.snapGrid;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
        slides.each(function (slideIndex, slideEl) {
          var slideProgress = slideEl.progress;
          if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
            slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
          }
          slideProgress = Math.min(Math.max(slideProgress, -1), 1);
          $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
        });
      },
      setTransition: function setTransition(duration) {
        if (duration === void 0) duration = this.params.speed;
        var swiper = this;
        var $el = swiper.$el;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
          if (duration === 0) {
            parallaxDuration = 0;
          }
          $parallaxEl.transition(parallaxDuration);
        });
      }
    };
    var Parallax$1 = {
      name: 'parallax',
      params: {
        parallax: {
          enabled: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          parallax: {
            setTransform: Parallax.setTransform.bind(swiper),
            setTranslate: Parallax.setTranslate.bind(swiper),
            setTransition: Parallax.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          if (!swiper.params.parallax.enabled) {
            return;
          }
          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        init: function init() {
          var swiper = this;
          if (!swiper.params.parallax.enabled) {
            return;
          }
          swiper.parallax.setTranslate();
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          if (!swiper.params.parallax.enabled) {
            return;
          }
          swiper.parallax.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          if (!swiper.params.parallax.enabled) {
            return;
          }
          swiper.parallax.setTransition(duration);
        }
      }
    };
    var Zoom = {
      // Calc Scale From Multi-touches
      getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) {
          return 1;
        }
        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
      },
      // Events
      onGestureStart: function onGestureStart(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;
        if (!Support.gestures) {
          if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
            return;
          }
          zoom.fakeGestureTouched = true;
          gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
          gesture.$slideEl = $(e.target).closest('.swiper-slide');
          if (gesture.$slideEl.length === 0) {
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          }
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
          gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
          if (gesture.$imageWrapEl.length === 0) {
            gesture.$imageEl = undefined;
            return;
          }
        }
        gesture.$imageEl.transition(0);
        swiper.zoom.isScaling = true;
      },
      onGestureChange: function onGestureChange(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!Support.gestures) {
          if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
            return;
          }
          zoom.fakeGestureMoved = true;
          gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }
        if (Support.gestures) {
          zoom.scale = e.scale * zoom.currentScale;
        } else {
          zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
        }
        if (zoom.scale > gesture.maxRatio) {
          zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        }
        if (zoom.scale < params.minRatio) {
          zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        }
        gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      },
      onGestureEnd: function onGestureEnd(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (!Support.gestures) {
          if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
            return;
          }
          if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
            return;
          }
          zoom.fakeGestureTouched = false;
          zoom.fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;
        if (zoom.scale === 1) {
          gesture.$slideEl = undefined;
        }
      },
      onTouchStart: function onTouchStart(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }
        if (image.isTouched) {
          return;
        }
        if (Device.android) {
          e.preventDefault();
        }
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      },
      onTouchMove: function onTouchMove(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;
        var velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) {
          return;
        }
        if (!image.isMoved) {
          image.width = gesture.$imageEl[0].offsetWidth;
          image.height = gesture.$imageEl[0].offsetHeight;
          image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
          image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
          gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
          gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
          gesture.$imageWrapEl.transition(0);
          if (swiper.rtl) {
            image.startX = -image.startX;
            image.startY = -image.startY;
          }
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) {
          return;
        }
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !zoom.isScaling) {
          if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
            image.isTouched = false;
            return;
          }
          if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
            image.isTouched = false;
            return;
          }
        }
        e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) {
          image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        }
        if (image.currentX > image.maxX) {
          image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        }
        if (image.currentY < image.minY) {
          image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        }
        if (image.currentY > image.maxY) {
          image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        }

        // Velocity
        if (!velocity.prevPositionX) {
          velocity.prevPositionX = image.touchesCurrent.x;
        }
        if (!velocity.prevPositionY) {
          velocity.prevPositionY = image.touchesCurrent.y;
        }
        if (!velocity.prevTime) {
          velocity.prevTime = Date.now();
        }
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) {
          velocity.x = 0;
        }
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) {
          velocity.y = 0;
        }
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
      },
      onTouchEnd: function onTouchEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;
        var velocity = zoom.velocity;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }
        if (!image.isTouched || !image.isMoved) {
          image.isTouched = false;
          image.isMoved = false;
          return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;

        // Fix duration
        if (velocity.x !== 0) {
          momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        }
        if (velocity.y !== 0) {
          momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        }
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;

        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
      },
      onTransitionEnd: function onTransitionEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
          gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
          gesture.$imageWrapEl.transform('translate3d(0,0,0)');
          zoom.scale = 1;
          zoom.currentScale = 1;
          gesture.$slideEl = undefined;
          gesture.$imageEl = undefined;
          gesture.$imageWrapEl = undefined;
        }
      },
      // Toggle Zoom
      toggle: function toggle(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) {
          // Zoom Out
          zoom.out();
        } else {
          // Zoom In
          zoom["in"](e);
        }
      },
      "in": function in$1(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;
        if (!gesture.$slideEl) {
          gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }
        gesture.$slideEl.addClass("" + params.zoomedSlideClass);
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
          touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
          touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
          touchX = image.touchesStart.x;
          touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
          slideWidth = gesture.$slideEl[0].offsetWidth;
          slideHeight = gesture.$slideEl[0].offsetHeight;
          offsetX = gesture.$slideEl.offset().left;
          offsetY = gesture.$slideEl.offset().top;
          diffX = offsetX + slideWidth / 2 - touchX;
          diffY = offsetY + slideHeight / 2 - touchY;
          imageWidth = gesture.$imageEl[0].offsetWidth;
          imageHeight = gesture.$imageEl[0].offsetHeight;
          scaledWidth = imageWidth * zoom.scale;
          scaledHeight = imageHeight * zoom.scale;
          translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
          translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
          translateMaxX = -translateMinX;
          translateMaxY = -translateMinY;
          translateX = diffX * zoom.scale;
          translateY = diffY * zoom.scale;
          if (translateX < translateMinX) {
            translateX = translateMinX;
          }
          if (translateX > translateMaxX) {
            translateX = translateMaxX;
          }
          if (translateY < translateMinY) {
            translateY = translateMinY;
          }
          if (translateY > translateMaxY) {
            translateY = translateMaxY;
          }
        } else {
          translateX = 0;
          translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      },
      out: function out() {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
        if (!gesture.$slideEl) {
          gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }
        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
        gesture.$slideEl = undefined;
      },
      // Attach/Detach Events
      enable: function enable() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (zoom.enabled) {
          return;
        }
        zoom.enabled = true;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;

        // Scale image
        if (Support.gestures) {
          swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
          swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        }

        // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove);
      },
      disable: function disable() {
        var swiper = this;
        var zoom = swiper.zoom;
        if (!zoom.enabled) {
          return;
        }
        swiper.zoom.enabled = false;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;

        // Scale image
        if (Support.gestures) {
          swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
          swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        }

        // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove);
      }
    };
    var Zoom$1 = {
      name: 'zoom',
      params: {
        zoom: {
          enabled: false,
          maxRatio: 3,
          minRatio: 1,
          toggle: true,
          containerClass: 'swiper-zoom-container',
          zoomedSlideClass: 'swiper-slide-zoomed'
        }
      },
      create: function create() {
        var swiper = this;
        var zoom = {
          enabled: false,
          scale: 1,
          currentScale: 1,
          isScaling: false,
          gesture: {
            $slideEl: undefined,
            slideWidth: undefined,
            slideHeight: undefined,
            $imageEl: undefined,
            $imageWrapEl: undefined,
            maxRatio: 3
          },
          image: {
            isTouched: undefined,
            isMoved: undefined,
            currentX: undefined,
            currentY: undefined,
            minX: undefined,
            minY: undefined,
            maxX: undefined,
            maxY: undefined,
            width: undefined,
            height: undefined,
            startX: undefined,
            startY: undefined,
            touchesStart: {},
            touchesCurrent: {}
          },
          velocity: {
            x: undefined,
            y: undefined,
            prevPositionX: undefined,
            prevPositionY: undefined,
            prevTime: undefined
          }
        };
        'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
          zoom[methodName] = Zoom[methodName].bind(swiper);
        });
        Utils.extend(swiper, {
          zoom: zoom
        });
        var scale = 1;
        Object.defineProperty(swiper.zoom, 'scale', {
          get: function get() {
            return scale;
          },
          set: function set(value) {
            if (scale !== value) {
              var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
              var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
              swiper.emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          if (swiper.params.zoom.enabled) {
            swiper.zoom.enable();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.zoom.disable();
        },
        touchStart: function touchStart(e) {
          var swiper = this;
          if (!swiper.zoom.enabled) {
            return;
          }
          swiper.zoom.onTouchStart(e);
        },
        touchEnd: function touchEnd(e) {
          var swiper = this;
          if (!swiper.zoom.enabled) {
            return;
          }
          swiper.zoom.onTouchEnd(e);
        },
        doubleTap: function doubleTap(e) {
          var swiper = this;
          if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
            swiper.zoom.toggle(e);
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;
          if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
            swiper.zoom.onTransitionEnd();
          }
        }
      }
    };
    var Lazy = {
      loadInSlide: function loadInSlide(index, loadInDuplicate) {
        if (loadInDuplicate === void 0) loadInDuplicate = true;
        var swiper = this;
        var params = swiper.params.lazy;
        if (typeof index === 'undefined') {
          return;
        }
        if (swiper.slides.length === 0) {
          return;
        }
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
        var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
          $images = $images.add($slideEl[0]);
        }
        if ($images.length === 0) {
          return;
        }
        $images.each(function (imageIndex, imageEl) {
          var $imageEl = $(imageEl);
          $imageEl.addClass(params.loadingClass);
          var background = $imageEl.attr('data-background');
          var src = $imageEl.attr('data-src');
          var srcset = $imageEl.attr('data-srcset');
          var sizes = $imageEl.attr('data-sizes');
          swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
            if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) {
              return;
            }
            if (background) {
              $imageEl.css('background-image', "url(\"" + background + "\")");
              $imageEl.removeAttr('data-background');
            } else {
              if (srcset) {
                $imageEl.attr('srcset', srcset);
                $imageEl.removeAttr('data-srcset');
              }
              if (sizes) {
                $imageEl.attr('sizes', sizes);
                $imageEl.removeAttr('data-sizes');
              }
              if (src) {
                $imageEl.attr('src', src);
                $imageEl.removeAttr('data-src');
              }
            }
            $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
            $slideEl.find("." + params.preloaderClass).remove();
            if (swiper.params.loop && loadInDuplicate) {
              var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
              if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
                swiper.lazy.loadInSlide(originalSlide.index(), false);
              } else {
                var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
                swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
              }
            }
            swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
          });
          swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
      },
      load: function load() {
        var swiper = this;
        var $wrapperEl = swiper.$wrapperEl;
        var swiperParams = swiper.params;
        var slides = swiper.slides;
        var activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') {
          slidesPerView = 0;
        }
        function slideExist(index) {
          if (isVirtual) {
            if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
              return true;
            }
          } else if (slides[index]) {
            return true;
          }
          return false;
        }
        function slideIndex(slideEl) {
          if (isVirtual) {
            return $(slideEl).attr('data-swiper-slide-index');
          }
          return $(slideEl).index();
        }
        if (!swiper.lazy.initialImageLoaded) {
          swiper.lazy.initialImageLoaded = true;
        }
        if (swiper.params.watchSlidesVisibility) {
          $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (elIndex, slideEl) {
            var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
            swiper.lazy.loadInSlide(index);
          });
        } else if (slidesPerView > 1) {
          for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
            if (slideExist(i)) {
              swiper.lazy.loadInSlide(i);
            }
          }
        } else {
          swiper.lazy.loadInSlide(activeIndex);
        }
        if (params.loadPrevNext) {
          if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
            var amount = params.loadPrevNextAmount;
            var spv = slidesPerView;
            var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
            var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0);
            // Next Slides
            for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
              if (slideExist(i$1)) {
                swiper.lazy.loadInSlide(i$1);
              }
            }
            // Prev Slides
            for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
              if (slideExist(i$2)) {
                swiper.lazy.loadInSlide(i$2);
              }
            }
          } else {
            var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);
            if (nextSlide.length > 0) {
              swiper.lazy.loadInSlide(slideIndex(nextSlide));
            }
            var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);
            if (prevSlide.length > 0) {
              swiper.lazy.loadInSlide(slideIndex(prevSlide));
            }
          }
        }
      }
    };
    var Lazy$1 = {
      name: 'lazy',
      params: {
        lazy: {
          enabled: false,
          loadPrevNext: false,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: false,
          elementClass: 'swiper-lazy',
          loadingClass: 'swiper-lazy-loading',
          loadedClass: 'swiper-lazy-loaded',
          preloaderClass: 'swiper-lazy-preloader'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          lazy: {
            initialImageLoaded: false,
            load: Lazy.load.bind(swiper),
            loadInSlide: Lazy.loadInSlide.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
            swiper.params.preloadImages = false;
          }
        },
        init: function init() {
          var swiper = this;
          if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
            swiper.lazy.load();
          }
        },
        scroll: function scroll() {
          var swiper = this;
          if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
            swiper.lazy.load();
          }
        },
        resize: function resize() {
          var swiper = this;
          if (swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        },
        scrollbarDragMove: function scrollbarDragMove() {
          var swiper = this;
          if (swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        },
        transitionStart: function transitionStart() {
          var swiper = this;
          if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
              swiper.lazy.load();
            }
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;
          if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            swiper.lazy.load();
          }
        }
      }
    };

    /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

    var Controller = {
      LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function search() {
          var maxIndex;
          var minIndex;
          var guess;
          return function (array, val) {
            minIndex = -1;
            maxIndex = array.length;
            while (maxIndex - minIndex > 1) {
              guess = maxIndex + minIndex >> 1;
              if (array[guess] <= val) {
                minIndex = guess;
              } else {
                maxIndex = guess;
              }
            }
            return maxIndex;
          };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
          if (!x2) {
            return 0;
          }

          // Get the indexes of x1 and x3 (the array indexes before and after given x2):
          i3 = binarySearch(this.x, x2);
          i1 = i3 - 1;

          // We have our indexes i1 & i3, so we can calculate already:
          // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
          return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
      },
      // xxx: for now i will just save one spline function to to
      getInterpolateFunction: function getInterpolateFunction(c) {
        var swiper = this;
        if (!swiper.controller.spline) {
          swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
        }
      },
      setTranslate: function setTranslate(setTranslate$1, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        function setControlledTranslate(c) {
          // this will create an Interpolate function based on the snapGrids
          // x is the Grid of the scrolled scroller and y will be the controlled scroller
          // it makes sense to create this only once and recall it for the interpolation
          // the function does a lot of value caching for performance
          var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
          if (swiper.params.controller.by === 'slide') {
            swiper.controller.getInterpolateFunction(c);
            // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
            // but it did not work out
            controlledTranslate = -swiper.controller.spline.interpolate(-translate);
          }
          if (!controlledTranslate || swiper.params.controller.by === 'container') {
            multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
            controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
          }
          if (swiper.params.controller.inverse) {
            controlledTranslate = c.maxTranslate() - controlledTranslate;
          }
          c.updateProgress(controlledTranslate);
          c.setTranslate(controlledTranslate, swiper);
          c.updateActiveIndex();
          c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
          for (var i = 0; i < controlled.length; i += 1) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTranslate(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTranslate(controlled);
        }
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
          c.setTransition(duration, swiper);
          if (duration !== 0) {
            c.transitionStart();
            if (c.params.autoHeight) {
              Utils.nextTick(function () {
                c.updateAutoHeight();
              });
            }
            c.$wrapperEl.transitionEnd(function () {
              if (!controlled) {
                return;
              }
              if (c.params.loop && swiper.params.controller.by === 'slide') {
                c.loopFix();
              }
              c.transitionEnd();
            });
          }
        }
        if (Array.isArray(controlled)) {
          for (i = 0; i < controlled.length; i += 1) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTransition(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTransition(controlled);
        }
      }
    };
    var Controller$1 = {
      name: 'controller',
      params: {
        controller: {
          control: undefined,
          inverse: false,
          by: 'slide' // or 'container'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          controller: {
            control: swiper.params.controller.control,
            getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
            setTranslate: Controller.setTranslate.bind(swiper),
            setTransition: Controller.setTransition.bind(swiper)
          }
        });
      },
      on: {
        update: function update() {
          var swiper = this;
          if (!swiper.controller.control) {
            return;
          }
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        resize: function resize() {
          var swiper = this;
          if (!swiper.controller.control) {
            return;
          }
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        observerUpdate: function observerUpdate() {
          var swiper = this;
          if (!swiper.controller.control) {
            return;
          }
          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        setTranslate: function setTranslate(translate, byController) {
          var swiper = this;
          if (!swiper.controller.control) {
            return;
          }
          swiper.controller.setTranslate(translate, byController);
        },
        setTransition: function setTransition(duration, byController) {
          var swiper = this;
          if (!swiper.controller.control) {
            return;
          }
          swiper.controller.setTransition(duration, byController);
        }
      }
    };
    var a11y = {
      makeElFocusable: function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
        return $el;
      },
      addElRole: function addElRole($el, role) {
        $el.attr('role', role);
        return $el;
      },
      addElLabel: function addElLabel($el, label) {
        $el.attr('aria-label', label);
        return $el;
      },
      disableEl: function disableEl($el) {
        $el.attr('aria-disabled', true);
        return $el;
      },
      enableEl: function enableEl($el) {
        $el.attr('aria-disabled', false);
        return $el;
      },
      onEnterKey: function onEnterKey(e) {
        var swiper = this;
        var params = swiper.params.a11y;
        if (e.keyCode !== 13) {
          return;
        }
        var $targetEl = $(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
          if (!(swiper.isEnd && !swiper.params.loop)) {
            swiper.slideNext();
          }
          if (swiper.isEnd) {
            swiper.a11y.notify(params.lastSlideMessage);
          } else {
            swiper.a11y.notify(params.nextSlideMessage);
          }
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
          if (!(swiper.isBeginning && !swiper.params.loop)) {
            swiper.slidePrev();
          }
          if (swiper.isBeginning) {
            swiper.a11y.notify(params.firstSlideMessage);
          } else {
            swiper.a11y.notify(params.prevSlideMessage);
          }
        }
        if (swiper.pagination && $targetEl.is("." + swiper.params.pagination.bulletClass)) {
          $targetEl[0].click();
        }
      },
      notify: function notify(message) {
        var swiper = this;
        var notification = swiper.a11y.liveRegion;
        if (notification.length === 0) {
          return;
        }
        notification.html('');
        notification.html(message);
      },
      updateNavigation: function updateNavigation() {
        var swiper = this;
        if (swiper.params.loop) {
          return;
        }
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;
        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            swiper.a11y.disableEl($prevEl);
          } else {
            swiper.a11y.enableEl($prevEl);
          }
        }
        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            swiper.a11y.disableEl($nextEl);
          } else {
            swiper.a11y.enableEl($nextEl);
          }
        }
      },
      updatePagination: function updatePagination() {
        var swiper = this;
        var params = swiper.params.a11y;
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
            var $bulletEl = $(bulletEl);
            swiper.a11y.makeElFocusable($bulletEl);
            swiper.a11y.addElRole($bulletEl, 'button');
            swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
          });
        }
      },
      init: function init() {
        var swiper = this;
        swiper.$el.append(swiper.a11y.liveRegion);

        // Navigation
        var params = swiper.params.a11y;
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl) {
          swiper.a11y.makeElFocusable($nextEl);
          swiper.a11y.addElRole($nextEl, 'button');
          swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
          $nextEl.on('keydown', swiper.a11y.onEnterKey);
        }
        if ($prevEl) {
          swiper.a11y.makeElFocusable($prevEl);
          swiper.a11y.addElRole($prevEl, 'button');
          swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
          $prevEl.on('keydown', swiper.a11y.onEnterKey);
        }

        // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.$el.on('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) {
          swiper.a11y.liveRegion.remove();
        }
        var $nextEl;
        var $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }
        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }
        if ($nextEl) {
          $nextEl.off('keydown', swiper.a11y.onEnterKey);
        }
        if ($prevEl) {
          $prevEl.off('keydown', swiper.a11y.onEnterKey);
        }

        // Pagination
        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.$el.off('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
        }
      }
    };
    var A11y = {
      name: 'a11y',
      params: {
        a11y: {
          enabled: true,
          notificationClass: 'swiper-notification',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          a11y: {
            liveRegion: $("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
          }
        });
        Object.keys(a11y).forEach(function (methodName) {
          swiper.a11y[methodName] = a11y[methodName].bind(swiper);
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          if (!swiper.params.a11y.enabled) {
            return;
          }
          swiper.a11y.init();
          swiper.a11y.updateNavigation();
        },
        toEdge: function toEdge() {
          var swiper = this;
          if (!swiper.params.a11y.enabled) {
            return;
          }
          swiper.a11y.updateNavigation();
        },
        fromEdge: function fromEdge() {
          var swiper = this;
          if (!swiper.params.a11y.enabled) {
            return;
          }
          swiper.a11y.updateNavigation();
        },
        paginationUpdate: function paginationUpdate() {
          var swiper = this;
          if (!swiper.params.a11y.enabled) {
            return;
          }
          swiper.a11y.updatePagination();
        },
        destroy: function destroy() {
          var swiper = this;
          if (!swiper.params.a11y.enabled) {
            return;
          }
          swiper.a11y.destroy();
        }
      }
    };
    var History = {
      init: function init() {
        var swiper = this;
        if (!swiper.params.history) {
          return;
        }
        if (!win.history || !win.history.pushState) {
          swiper.params.history.enabled = false;
          swiper.params.hashNavigation.enabled = true;
          return;
        }
        var history = swiper.history;
        history.initialized = true;
        history.paths = History.getPathValues();
        if (!history.paths.key && !history.paths.value) {
          return;
        }
        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) {
          win.addEventListener('popstate', swiper.history.setHistoryPopState);
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (!swiper.params.history.replaceState) {
          win.removeEventListener('popstate', swiper.history.setHistoryPopState);
        }
      },
      setHistoryPopState: function setHistoryPopState() {
        var swiper = this;
        swiper.history.paths = History.getPathValues();
        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
      },
      getPathValues: function getPathValues() {
        var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) {
          return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
          key: key,
          value: value
        };
      },
      setHistory: function setHistory(key, index) {
        var swiper = this;
        if (!swiper.history.initialized || !swiper.params.history.enabled) {
          return;
        }
        var slide = swiper.slides.eq(index);
        var value = History.slugify(slide.attr('data-history'));
        if (!win.location.pathname.includes(key)) {
          value = key + "/" + value;
        }
        var currentState = win.history.state;
        if (currentState && currentState.value === value) {
          return;
        }
        if (swiper.params.history.replaceState) {
          win.history.replaceState({
            value: value
          }, null, value);
        } else {
          win.history.pushState({
            value: value
          }, null, value);
        }
      },
      slugify: function slugify(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
      },
      scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
        var swiper = this;
        if (value) {
          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
            var slide = swiper.slides.eq(i);
            var slideHistory = History.slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
              var index = slide.index();
              swiper.slideTo(index, speed, runCallbacks);
            }
          }
        } else {
          swiper.slideTo(0, speed, runCallbacks);
        }
      }
    };
    var History$1 = {
      name: 'history',
      params: {
        history: {
          enabled: false,
          replaceState: false,
          key: 'slides'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          history: {
            init: History.init.bind(swiper),
            setHistory: History.setHistory.bind(swiper),
            setHistoryPopState: History.setHistoryPopState.bind(swiper),
            scrollToSlide: History.scrollToSlide.bind(swiper),
            destroy: History.destroy.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          if (swiper.params.history.enabled) {
            swiper.history.init();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          if (swiper.params.history.enabled) {
            swiper.history.destroy();
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;
          if (swiper.history.initialized) {
            swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
          }
        }
      }
    };
    var HashNavigation = {
      onHashCange: function onHashCange() {
        var swiper = this;
        var newHash = doc.location.hash.replace('#', '');
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
          var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();
          if (typeof newIndex === 'undefined') {
            return;
          }
          swiper.slideTo(newIndex);
        }
      },
      setHash: function setHash() {
        var swiper = this;
        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) {
          return;
        }
        if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
          win.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
        } else {
          var slide = swiper.slides.eq(swiper.activeIndex);
          var hash = slide.attr('data-hash') || slide.attr('data-history');
          doc.location.hash = hash || '';
        }
      },
      init: function init() {
        var swiper = this;
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) {
          return;
        }
        swiper.hashNavigation.initialized = true;
        var hash = doc.location.hash.replace('#', '');
        if (hash) {
          var speed = 0;
          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
            var slide = swiper.slides.eq(i);
            var slideHash = slide.attr('data-hash') || slide.attr('data-history');
            if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
              var index = slide.index();
              swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
            }
          }
        }
        if (swiper.params.hashNavigation.watchState) {
          $(win).on('hashchange', swiper.hashNavigation.onHashCange);
        }
      },
      destroy: function destroy() {
        var swiper = this;
        if (swiper.params.hashNavigation.watchState) {
          $(win).off('hashchange', swiper.hashNavigation.onHashCange);
        }
      }
    };
    var HashNavigation$1 = {
      name: 'hash-navigation',
      params: {
        hashNavigation: {
          enabled: false,
          replaceState: false,
          watchState: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          hashNavigation: {
            initialized: false,
            init: HashNavigation.init.bind(swiper),
            destroy: HashNavigation.destroy.bind(swiper),
            setHash: HashNavigation.setHash.bind(swiper),
            onHashCange: HashNavigation.onHashCange.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.init();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.destroy();
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;
          if (swiper.hashNavigation.initialized) {
            swiper.hashNavigation.setHash();
          }
        }
      }
    };

    /* eslint no-underscore-dangle: "off" */

    var Autoplay = {
      run: function run() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) {
          delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        }
        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = Utils.nextTick(function () {
          if (swiper.params.autoplay.reverseDirection) {
            if (swiper.params.loop) {
              swiper.loopFix();
              swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else if (!swiper.isBeginning) {
              swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else {
              swiper.autoplay.stop();
            }
          } else if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isEnd) {
            swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(0, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        }, delay);
      },
      start: function start() {
        var swiper = this;
        if (typeof swiper.autoplay.timeout !== 'undefined') {
          return false;
        }
        if (swiper.autoplay.running) {
          return false;
        }
        swiper.autoplay.running = true;
        swiper.emit('autoplayStart');
        swiper.autoplay.run();
        return true;
      },
      stop: function stop() {
        var swiper = this;
        if (!swiper.autoplay.running) {
          return false;
        }
        if (typeof swiper.autoplay.timeout === 'undefined') {
          return false;
        }
        if (swiper.autoplay.timeout) {
          clearTimeout(swiper.autoplay.timeout);
          swiper.autoplay.timeout = undefined;
        }
        swiper.autoplay.running = false;
        swiper.emit('autoplayStop');
        return true;
      },
      pause: function pause(speed) {
        var swiper = this;
        if (!swiper.autoplay.running) {
          return;
        }
        if (swiper.autoplay.paused) {
          return;
        }
        if (swiper.autoplay.timeout) {
          clearTimeout(swiper.autoplay.timeout);
        }
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
          swiper.autoplay.paused = false;
          swiper.autoplay.run();
        } else {
          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
        }
      }
    };
    var Autoplay$1 = {
      name: 'autoplay',
      params: {
        autoplay: {
          enabled: false,
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: true,
          stopOnLastSlide: false,
          reverseDirection: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          autoplay: {
            running: false,
            paused: false,
            run: Autoplay.run.bind(swiper),
            start: Autoplay.start.bind(swiper),
            stop: Autoplay.stop.bind(swiper),
            pause: Autoplay.pause.bind(swiper),
            onTransitionEnd: function onTransitionEnd(e) {
              if (!swiper || swiper.destroyed || !swiper.$wrapperEl) {
                return;
              }
              if (e.target !== this) {
                return;
              }
              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
              swiper.autoplay.paused = false;
              if (!swiper.autoplay.running) {
                swiper.autoplay.stop();
              } else {
                swiper.autoplay.run();
              }
            }
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          if (swiper.params.autoplay.enabled) {
            swiper.autoplay.start();
          }
        },
        beforeTransitionStart: function beforeTransitionStart(speed, internal) {
          var swiper = this;
          if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.pause(speed);
            } else {
              swiper.autoplay.stop();
            }
          }
        },
        sliderFirstMove: function sliderFirstMove() {
          var swiper = this;
          if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.pause();
            }
          }
        },
        destroy: function destroy() {
          var swiper = this;
          if (swiper.autoplay.running) {
            swiper.autoplay.stop();
          }
        }
      }
    };
    var Fade = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;
        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = swiper.slides.eq(i);
          var offset = $slideEl[0].swiperSlideOffset;
          var tx = -offset;
          if (!swiper.params.virtualTranslate) {
            tx -= swiper.translate;
          }
          var ty = 0;
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
          }
          var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
          $slideEl.css({
            opacity: slideOpacity
          }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides;
        var $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
          var eventTriggered = false;
          slides.transitionEnd(function () {
            if (eventTriggered) {
              return;
            }
            if (!swiper || swiper.destroyed) {
              return;
            }
            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
            for (var i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      }
    };
    var EffectFade = {
      name: 'effect-fade',
      params: {
        fadeEffect: {
          crossFade: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          fadeEffect: {
            setTranslate: Fade.setTranslate.bind(swiper),
            setTransition: Fade.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          if (swiper.params.effect !== 'fade') {
            return;
          }
          swiper.classNames.push(swiper.params.containerModifierClass + "fade");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          if (swiper.params.effect !== 'fade') {
            return;
          }
          swiper.fadeEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          if (swiper.params.effect !== 'fade') {
            return;
          }
          swiper.fadeEffect.setTransition(duration);
        }
      }
    };
    var Cube = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el;
        var $wrapperEl = swiper.$wrapperEl;
        var slides = swiper.slides;
        var swiperWidth = swiper.width;
        var swiperHeight = swiper.height;
        var rtl = swiper.rtlTranslate;
        var swiperSize = swiper.size;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;
        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $wrapperEl.append($cubeShadowEl);
            }
            $cubeShadowEl.css({
              height: swiperWidth + "px"
            });
          } else {
            $cubeShadowEl = $el.find('.swiper-cube-shadow');
            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $el.append($cubeShadowEl);
            }
          }
        }
        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = slides.eq(i);
          var slideIndex = i;
          if (isVirtual) {
            slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
          }
          var slideAngle = slideIndex * 90;
          var round = Math.floor(slideAngle / 360);
          if (rtl) {
            slideAngle = -slideAngle;
            round = Math.floor(-slideAngle / 360);
          }
          var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          var tx = 0;
          var ty = 0;
          var tz = 0;
          if (slideIndex % 4 === 0) {
            tx = -round * 4 * swiperSize;
            tz = 0;
          } else if ((slideIndex - 1) % 4 === 0) {
            tx = 0;
            tz = -round * 4 * swiperSize;
          } else if ((slideIndex - 2) % 4 === 0) {
            tx = swiperSize + round * 4 * swiperSize;
            tz = swiperSize;
          } else if ((slideIndex - 3) % 4 === 0) {
            tx = -swiperSize;
            tz = 3 * swiperSize + swiperSize * 4 * round;
          }
          if (rtl) {
            tx = -tx;
          }
          if (!isHorizontal) {
            ty = tx;
            tx = 0;
          }
          var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";
          if (progress <= 1 && progress > -1) {
            wrapperRotate = slideIndex * 90 + progress * 90;
            if (rtl) {
              wrapperRotate = -slideIndex * 90 - progress * 90;
            }
          }
          $slideEl.transform(transform);
          if (params.slideShadows) {
            // Set shadows
            var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
            if (shadowBefore.length === 0) {
              shadowBefore = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
              $slideEl.append(shadowBefore);
            }
            if (shadowAfter.length === 0) {
              shadowAfter = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append(shadowAfter);
            }
            if (shadowBefore.length) {
              shadowBefore[0].style.opacity = Math.max(-progress, 0);
            }
            if (shadowAfter.length) {
              shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
          }
        }
        $wrapperEl.css({
          '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
        });
        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
          } else {
            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
            var scale1 = params.shadowScale;
            var scale2 = params.shadowScale / multiplier;
            var offset = params.shadowOffset;
            $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
          }
        }
        var zFactor = Browser.isSafari || Browser.isUiWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var $el = swiper.$el;
        var slides = swiper.slides;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
          $el.find('.swiper-cube-shadow').transition(duration);
        }
      }
    };
    var EffectCube = {
      name: 'effect-cube',
      params: {
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 20,
          shadowScale: 0.94
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          cubeEffect: {
            setTranslate: Cube.setTranslate.bind(swiper),
            setTransition: Cube.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          if (swiper.params.effect !== 'cube') {
            return;
          }
          swiper.classNames.push(swiper.params.containerModifierClass + "cube");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: false,
            virtualTranslate: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          if (swiper.params.effect !== 'cube') {
            return;
          }
          swiper.cubeEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          if (swiper.params.effect !== 'cube') {
            return;
          }
          swiper.cubeEffect.setTransition(duration);
        }
      }
    };
    var Flip = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;
        var rtl = swiper.rtlTranslate;
        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = slides.eq(i);
          var progress = $slideEl[0].progress;
          if (swiper.params.flipEffect.limitRotation) {
            progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          }
          var offset = $slideEl[0].swiperSlideOffset;
          var rotate = -180 * progress;
          var rotateY = rotate;
          var rotateX = 0;
          var tx = -offset;
          var ty = 0;
          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
            rotateX = -rotateY;
            rotateY = 0;
          } else if (rtl) {
            rotateY = -rotateY;
          }
          $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
          if (swiper.params.flipEffect.slideShadows) {
            // Set shadows
            var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
            if (shadowBefore.length === 0) {
              shadowBefore = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
              $slideEl.append(shadowBefore);
            }
            if (shadowAfter.length === 0) {
              shadowAfter = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append(shadowAfter);
            }
            if (shadowBefore.length) {
              shadowBefore[0].style.opacity = Math.max(-progress, 0);
            }
            if (shadowAfter.length) {
              shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
          }
          $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides;
        var activeIndex = swiper.activeIndex;
        var $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.virtualTranslate && duration !== 0) {
          var eventTriggered = false;
          // eslint-disable-next-line
          slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
            if (eventTriggered) {
              return;
            }
            if (!swiper || swiper.destroyed) {
              return;
            }
            // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;
            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];
            for (var i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      }
    };
    var EffectFlip = {
      name: 'effect-flip',
      params: {
        flipEffect: {
          slideShadows: true,
          limitRotation: true
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          flipEffect: {
            setTranslate: Flip.setTranslate.bind(swiper),
            setTransition: Flip.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          if (swiper.params.effect !== 'flip') {
            return;
          }
          swiper.classNames.push(swiper.params.containerModifierClass + "flip");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          if (swiper.params.effect !== 'flip') {
            return;
          }
          swiper.flipEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          if (swiper.params.effect !== 'flip') {
            return;
          }
          swiper.flipEffect.setTransition(duration);
        }
      }
    };
    var Coverflow = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var swiperWidth = swiper.width;
        var swiperHeight = swiper.height;
        var slides = swiper.slides;
        var $wrapperEl = swiper.$wrapperEl;
        var slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        // Each slide offset from center
        for (var i = 0, length = slides.length; i < length; i += 1) {
          var $slideEl = slides.eq(i);
          var slideSize = slidesSizesGrid[i];
          var slideOffset = $slideEl[0].swiperSlideOffset;
          var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
          var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
          var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
          // var rotateZ = 0
          var translateZ = -translate * Math.abs(offsetMultiplier);
          var translateY = isHorizontal ? 0 : params.stretch * offsetMultiplier;
          var translateX = isHorizontal ? params.stretch * offsetMultiplier : 0;

          // Fix for ultra small values
          if (Math.abs(translateX) < 0.001) {
            translateX = 0;
          }
          if (Math.abs(translateY) < 0.001) {
            translateY = 0;
          }
          if (Math.abs(translateZ) < 0.001) {
            translateZ = 0;
          }
          if (Math.abs(rotateY) < 0.001) {
            rotateY = 0;
          }
          if (Math.abs(rotateX) < 0.001) {
            rotateX = 0;
          }
          var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
          $slideEl.transform(slideTransform);
          $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
          if (params.slideShadows) {
            // Set shadows
            var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
            if ($shadowBeforeEl.length === 0) {
              $shadowBeforeEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
              $slideEl.append($shadowBeforeEl);
            }
            if ($shadowAfterEl.length === 0) {
              $shadowAfterEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append($shadowAfterEl);
            }
            if ($shadowBeforeEl.length) {
              $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
            }
            if ($shadowAfterEl.length) {
              $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
          }
        }

        // Set correct perspective for IE10
        if (Support.pointerEvents || Support.prefixedPointerEvents) {
          var ws = $wrapperEl[0].style;
          ws.perspectiveOrigin = center + "px 50%";
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
      }
    };
    var EffectCoverflow = {
      name: 'effect-coverflow',
      params: {
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          coverflowEffect: {
            setTranslate: Coverflow.setTranslate.bind(swiper),
            setTransition: Coverflow.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          if (swiper.params.effect !== 'coverflow') {
            return;
          }
          swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          if (swiper.params.effect !== 'coverflow') {
            return;
          }
          swiper.coverflowEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          if (swiper.params.effect !== 'coverflow') {
            return;
          }
          swiper.coverflowEffect.setTransition(duration);
        }
      }
    };
    var Thumbs = {
      init: function init() {
        var swiper = this;
        var ref = swiper.params;
        var thumbsParams = ref.thumbs;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
          swiper.thumbs.swiper = thumbsParams.swiper;
          Utils.extend(swiper.thumbs.swiper.originalParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
          Utils.extend(swiper.thumbs.swiper.params, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
        } else if (Utils.isObject(thumbsParams.swiper)) {
          swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideToClickedSlide: false
          }));
          swiper.thumbs.swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
      },
      onThumbClick: function onThumbClick() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) {
          return;
        }
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) {
          return;
        }
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) {
          return;
        }
        var slideToIndex;
        if (thumbsSwiper.params.loop) {
          slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        } else {
          slideToIndex = clickedIndex;
        }
        if (swiper.params.loop) {
          var currentIndex = swiper.activeIndex;
          if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
            swiper.loopFix();
            // eslint-disable-next-line
            swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
            currentIndex = swiper.activeIndex;
          }
          var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
          var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
          if (typeof prevIndex === 'undefined') {
            slideToIndex = nextIndex;
          } else if (typeof nextIndex === 'undefined') {
            slideToIndex = prevIndex;
          } else if (nextIndex - currentIndex < currentIndex - prevIndex) {
            slideToIndex = nextIndex;
          } else {
            slideToIndex = prevIndex;
          }
        }
        swiper.slideTo(slideToIndex);
      },
      update: function update(initial) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper) {
          return;
        }
        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        if (swiper.realIndex !== thumbsSwiper.realIndex) {
          var currentThumbsIndex = thumbsSwiper.activeIndex;
          var newThumbsIndex;
          if (thumbsSwiper.params.loop) {
            if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
              thumbsSwiper.loopFix();
              // eslint-disable-next-line
              thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
              currentThumbsIndex = thumbsSwiper.activeIndex;
            }
            // Find actual thumbs index to slide to
            var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
            var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
            if (typeof prevThumbsIndex === 'undefined') {
              newThumbsIndex = nextThumbsIndex;
            } else if (typeof nextThumbsIndex === 'undefined') {
              newThumbsIndex = prevThumbsIndex;
            } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
              newThumbsIndex = currentThumbsIndex;
            } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
              newThumbsIndex = nextThumbsIndex;
            } else {
              newThumbsIndex = prevThumbsIndex;
            }
          } else {
            newThumbsIndex = swiper.realIndex;
          }
          if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
            if (thumbsSwiper.params.centeredSlides) {
              if (newThumbsIndex > currentThumbsIndex) {
                newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
              } else {
                newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
              }
            } else if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - slidesPerView + 1;
            }
            thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
          }
        }

        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
          thumbsToActivate = swiper.params.slidesPerView;
        }
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
          for (var i = 0; i < thumbsToActivate; i += 1) {
            thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
          }
        } else {
          for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
            thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
          }
        }
      }
    };
    var Thumbs$1 = {
      name: 'thumbs',
      params: {
        thumbs: {
          swiper: null,
          slideThumbActiveClass: 'swiper-slide-thumb-active',
          thumbsContainerClass: 'swiper-container-thumbs'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          thumbs: {
            swiper: null,
            init: Thumbs.init.bind(swiper),
            update: Thumbs.update.bind(swiper),
            onThumbClick: Thumbs.onThumbClick.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          var ref = swiper.params;
          var thumbs = ref.thumbs;
          if (!thumbs || !thumbs.swiper) {
            return;
          }
          swiper.thumbs.init();
          swiper.thumbs.update(true);
        },
        slideChange: function slideChange() {
          var swiper = this;
          if (!swiper.thumbs.swiper) {
            return;
          }
          swiper.thumbs.update();
        },
        update: function update() {
          var swiper = this;
          if (!swiper.thumbs.swiper) {
            return;
          }
          swiper.thumbs.update();
        },
        resize: function resize() {
          var swiper = this;
          if (!swiper.thumbs.swiper) {
            return;
          }
          swiper.thumbs.update();
        },
        observerUpdate: function observerUpdate() {
          var swiper = this;
          if (!swiper.thumbs.swiper) {
            return;
          }
          swiper.thumbs.update();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          var thumbsSwiper = swiper.thumbs.swiper;
          if (!thumbsSwiper) {
            return;
          }
          thumbsSwiper.setTransition(duration);
        },
        beforeDestroy: function beforeDestroy() {
          var swiper = this;
          var thumbsSwiper = swiper.thumbs.swiper;
          if (!thumbsSwiper) {
            return;
          }
          if (swiper.thumbs.swiperCreated && thumbsSwiper) {
            thumbsSwiper.destroy();
          }
        }
      }
    };

    // Swiper Class

    var components = [Device$1, Support$1, Browser$1, Resize, Observer$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];
    if (typeof Swiper.use === 'undefined') {
      Swiper.use = Swiper.Class.use;
      Swiper.installModule = Swiper.Class.installModule;
    }
    Swiper.use(components);
    return Swiper;
  });
});

var styles$n = {"collection-list-horizontal":"fr-ec-collection-list-horizontal","collectionListHorizontal":"fr-ec-collection-list-horizontal","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","collection-list-horizontal--no-wrap":"fr-ec-collection-list-horizontal--no-wrap","collectionListHorizontalNoWrap":"fr-ec-collection-list-horizontal--no-wrap","collection-list-horizontal--align-center":"fr-ec-collection-list-horizontal--align-center","collectionListHorizontalAlignCenter":"fr-ec-collection-list-horizontal--align-center","collection-list-horizontal--divider":"fr-ec-collection-list-horizontal--divider","collectionListHorizontalDivider":"fr-ec-collection-list-horizontal--divider","collection-list-horizontal--swipeable":"fr-ec-collection-list-horizontal--swipeable","collectionListHorizontalSwipeable":"fr-ec-collection-list-horizontal--swipeable","collection-list-horizontal--normal":"fr-ec-collection-list-horizontal--normal","collectionListHorizontalNormal":"fr-ec-collection-list-horizontal--normal","flag-text":"fr-ec-flag-text","flagText":"fr-ec-flag-text","collection-list-horizontal--divider-small":"fr-ec-collection-list-horizontal--divider-small","collectionListHorizontalDividerSmall":"fr-ec-collection-list-horizontal--divider-small","collection-list-horizontal--divider-normal":"fr-ec-collection-list-horizontal--divider-normal","collectionListHorizontalDividerNormal":"fr-ec-collection-list-horizontal--divider-normal","collection-list-horizontal--divider-mid":"fr-ec-collection-list-horizontal--divider-mid","collectionListHorizontalDividerMid":"fr-ec-collection-list-horizontal--divider-mid","collection-list-horizontal--divider-large":"fr-ec-collection-list-horizontal--divider-large","collectionListHorizontalDividerLarge":"fr-ec-collection-list-horizontal--divider-large","collection-list-horizontal--divider-x-large":"fr-ec-collection-list-horizontal--divider-x-large","collectionListHorizontalDividerXLarge":"fr-ec-collection-list-horizontal--divider-x-large","collection-list-horizontal--small":"fr-ec-collection-list-horizontal--small","collectionListHorizontalSmall":"fr-ec-collection-list-horizontal--small","collection-list-horizontal--mid":"fr-ec-collection-list-horizontal--mid","collectionListHorizontalMid":"fr-ec-collection-list-horizontal--mid","collection-list-horizontal--large":"fr-ec-collection-list-horizontal--large","collectionListHorizontalLarge":"fr-ec-collection-list-horizontal--large","collection-list-horizontal--x-large":"fr-ec-collection-list-horizontal--x-large","collectionListHorizontalXLarge":"fr-ec-collection-list-horizontal--x-large","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","collection-list-horizontal--initial-padding":"fr-ec-collection-list-horizontal--initial-padding","collectionListHorizontalInitialPadding":"fr-ec-collection-list-horizontal--initial-padding"};

var CollectionListHorizontal = /** @class */function (_super) {
  __extends(CollectionListHorizontal, _super);
  function CollectionListHorizontal(props) {
    var _this = _super.call(this, props) || this;
    _this.onWindowSize = debounce(100, function (_) {
      _this.setState({
        breakpoint: getCurrentMediaQueryBreakpoint()
      });
    });
    _this.onSwiperResize = function () {
      if (_this.swiperInstance && _this.swiperRef.current) {
        _this.swiperRef.current.classList.toggle('fr-ec-swiper--overflow', _this.swiperInstance.virtualSize > _this.swiperInstance.size);
      }
    };
    // @ts-ignore
    _this.getClassName = function (spacing) {
      var spacingVal = typeof spacing !== 'string' ? spacing[_this.state.breakpoint] : spacing;
      switch (spacingVal) {
        case '4':
          return 'small';
        case '8':
          return 'normal';
        case '12':
          return 'mid';
        case '16':
          return 'large';
        case '24':
          return 'x-large';
      }
    };
    _this.handleItemClick = function (index) {
      return function (event) {
        if (_this.swiperInstance) {
          _this.swiperInstance.slideTo(Number(index));
          _this.swiperInstance.update();
        }
      };
    };
    _this.state = {
      breakpoint: getCurrentMediaQueryBreakpoint()
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }
  CollectionListHorizontal.prototype.componentDidMount = function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', this.onWindowSize);
    }
    if (this.props.swipeable) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        freeMode: true,
        observeParents: true,
        observer: true,
        slidesPerView: 'auto',
        spaceBetween: 0,
        watchOverflow: true,
        initialSlide: this.props.initialSlide || 0
      });
    }
  };
  CollectionListHorizontal.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      _b = _a.swipeable,
      swipeable = _b === void 0 ? false : _b,
      _c = _a.alignment,
      alignment = _c === void 0 ? 'stretch' : _c,
      children = _a.children,
      _d = _a.divider,
      divider = _d === void 0 ? false : _d,
      _e = _a.spacingValue,
      spacingValue = _e === void 0 ? '8' : _e,
      className = _a.className,
      _f = _a.swipeableInitialPadding,
      swipeableInitialPadding = _f === void 0 ? true : _f,
      _g = _a.wrap,
      wrap = _g === void 0 ? true : _g,
      props = __rest$1(_a, ["swipeable", "alignment", "children", "divider", "spacingValue", "className", "swipeableInitialPadding", "wrap"]);
    var childrenWithProps = Children.toArray(this.props.children).map(function (item, index) {
      return /*#__PURE__*/createElement("div", {
        tabIndex: 0,
        key: index,
        className: joinClasses('swiper-slide', styles$n.collectionListHorizontalItem),
        onClick: _this.handleItemClick(index)
      }, /*#__PURE__*/cloneElement(item, {
        index: index
      }));
    });
    var shouldRender = function shouldRender(swipeableBreakPoint, BP) {
      if (typeof swipeableBreakPoint === 'boolean') {
        if (swipeableBreakPoint) {
          return true;
        } else {
          return false;
        }
      }
      if (_typeof(swipeableBreakPoint) === 'object') {
        if (swipeableBreakPoint.sm && BP === 'sm' || swipeableBreakPoint.md && BP === 'md' || swipeableBreakPoint.lg && BP === 'lg') {
          return true;
        }
      }
      return false;
    };
    var shouldRenderChildren = shouldRender(swipeable, this.state.breakpoint);
    return /*#__PURE__*/createElement(Fragment, null, shouldRenderChildren ? (/*#__PURE__*/createElement(Measure, {
      onResize: debounce(100, function () {
        return _this.onSwiperResize();
      })
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef,
        className: className
      }, /*#__PURE__*/createElement("div", __assign$1({
        className: joinClasses('swiper-container', styles$n.collectionListHorizontalSwipeable, swipeableInitialPadding && styles$n.collectionListHorizontalInitialPadding, styles$n.collectionListHorizontal, divider && styles$n.collectionListHorizontalDivider, divider && "".concat(styles$n.collectionListHorizontalDivider, "-").concat(_this.getClassName(spacingValue)), !divider && "".concat(styles$n.collectionListHorizontal, "--").concat(_this.getClassName(spacingValue)))
      }, props, {
        ref: _this.swiperRef
      }), /*#__PURE__*/createElement("div", {
        className: joinClasses('swiper-wrapper')
      }, childrenWithProps)));
    })) : (/*#__PURE__*/createElement(ContentAlignment, __assign$1({
      element: "ul",
      direction: "row",
      alignment: alignment,
      className: joinClasses(styles$n.collectionListHorizontal, divider && styles$n.collectionListHorizontalDivider, divider && "".concat(styles$n.collectionListHorizontalDivider, "-").concat(this.getClassName(spacingValue)), !divider && "".concat(styles$n.collectionListHorizontal, "--").concat(this.getClassName(spacingValue)), !wrap && styles$n.collectionListHorizontalNoWrap, alignment === 'center' && styles$n.collectionListHorizontalAlignCenter, className)
    }, props), Children.toArray(children).filter(isValidElement).map(function (child, i) {
      return /*#__PURE__*/createElement("li", {
        className: styles$n.collectionListHorizontalItem,
        key: child.key || i
      }, child);
    }))));
  };
  CollectionListHorizontal.displayName = 'CoreCollectionListHorizontal';
  CollectionListHorizontal.defaultProps = {
    alignment: 'stretch',
    divider: false,
    spacingValue: '8',
    swipeable: false,
    swipeableInitialPadding: true
  };
  return CollectionListHorizontal;
}(Component);

var keylineStyles = {"keyline-bottom":"fr-ec-keyline-bottom","keylineBottom":"fr-ec-keyline-bottom"};

var styles$o = {"flyout-select":"fr-ec-flyout-select","flyoutSelect":"fr-ec-flyout-select","flyout-select__list":"fr-ec-flyout-select__list","flyoutSelectList":"fr-ec-flyout-select__list","flyout-select__list-item":"fr-ec-flyout-select__list-item","flyoutSelectListItem":"fr-ec-flyout-select__list-item","flyout-select__list-item--hover":"fr-ec-flyout-select__list-item--hover","flyoutSelectListItemHover":"fr-ec-flyout-select__list-item--hover","flyout-select__list-item--active":"fr-ec-flyout-select__list-item--active","flyoutSelectListItemActive":"fr-ec-flyout-select__list-item--active","flyout-select__list-item-selected-icon":"fr-ec-flyout-select__list-item-selected-icon","flyoutSelectListItemSelectedIcon":"fr-ec-flyout-select__list-item-selected-icon"};

var FlyoutSelect = function FlyoutSelect(_a) {
  var className = _a.className,
    onHideVisibility = _a.onHideVisibility,
    visible = _a.visible,
    iconBrand = _a.iconBrand,
    firstElementRef = _a.firstElementRef,
    props = __rest$1(_a, ["className", "onHideVisibility", "visible", "iconBrand", "firstElementRef"]);
  var getSelectedValue = function getSelectedValue() {
    var _a = props.value,
      value = _a === void 0 ? '' : _a,
      _b = props.options,
      options = _b === void 0 ? [] : _b;
    if (value) {
      var selectedOption = options.find(function (item) {
        return item.value === value;
      });
      return selectedOption || {
        label: '',
        value: ''
      };
    }
    return {
      label: '',
      value: ''
    };
  };
  var _b = useState(getSelectedValue()),
    selected = _b[0],
    setSelected = _b[1];
  var _c = useState(getSelectedValue()),
    hoverItem = _c[0],
    setHoverItem = _c[1];
  var onEscClick = function onEscClick(event) {
    if (event.keyCode === 27) {
      if (onHideVisibility) {
        onHideVisibility();
      }
    }
  };
  useEffect(function () {
    document.addEventListener('keydown', onEscClick, false);
    return function () {
      document.removeEventListener('keydown', onEscClick, false);
    };
  }, []);
  useEffect(function () {
    setHoverItem(getSelectedValue());
    setSelected(getSelectedValue());
  }, [props.value]);
  useEffect(function () {
    setHoverItem(getSelectedValue());
    setSelected(getSelectedValue());
  }, [props.options]);
  var handleFlyoutChange = function handleFlyoutChange(option) {
    return function (event) {
      event.preventDefault();
      setSelected(option);
      setHoverItem(option);
      onHideVisibility();
      if (props.onSelect) {
        props.onSelect(event, option.value);
      }
    };
  };
  var handleKeyPress = function handleKeyPress(event) {
    var _a, _b;
    var options = props.options;
    event.stopPropagation();
    var renderOptions = options;
    var hoverIndex = renderOptions.findIndex(function (option) {
      return option.value === hoverItem.value;
    });
    if (event.keyCode === KEYCODE.TAB) {
      event.preventDefault();
    }
    if (event.keyCode === KEYCODE.ESC) {
      setHoverItem(selected);
      onHideVisibility();
    }
    if (event.keyCode === KEYCODE.ENTER) {
      setSelected(hoverItem);
      onHideVisibility();
      if (props.onSelect) {
        props.onSelect(event, hoverItem.value);
      }
    }
    if (event.keyCode === KEYCODE.DOWN) {
      if (hoverIndex + 1 < renderOptions.length) {
        setHoverItem(renderOptions[hoverIndex + 1]);
        (_a = document.querySelector("#option-".concat(hoverIndex + 1))) === null || _a === void 0 ? void 0 : _a.focus();
      }
    }
    if (event.keyCode === KEYCODE.UP && hoverIndex - 1 >= 0) {
      setHoverItem(renderOptions[hoverIndex - 1]);
      (_b = document.querySelector("#option-".concat(hoverIndex - 1))) === null || _b === void 0 ? void 0 : _b.focus();
    }
    return true;
  };
  return /*#__PURE__*/createElement(Fragment, null, visible ? (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$o.flyoutSelect, className)
  }, /*#__PURE__*/createElement("ul", {
    role: "listbox",
    className: joinClasses(styles$o.flyoutSelectList)
  }, props.options.map(function (item, index) {
    return /*#__PURE__*/createElement("li", {
      className: joinClasses(styles$o.flyoutSelectListItem, selected.label === item.label && selected.value === item.value && styles$o.flyoutSelectListItemActive, hoverItem.label === item.label && hoverItem.value === item.value && styles$o.flyoutSelectListItemHover),
      onMouseDown: handleFlyoutChange(item),
      onClick: handleFlyoutChange(item),
      role: "option",
      "aria-selected": selected.label === item.label,
      key: item.value,
      value: item.value,
      tabIndex: 0,
      id: "option-".concat(index),
      onKeyDown: handleKeyPress,
      ref: index === 0 && firstElementRef ? firstElementRef : undefined
    }, /*#__PURE__*/createElement(Icon, {
      className: styles$o.flyoutSelectListItemSelectedIcon,
      name: iconBrand ? "".concat(iconBrand, "check-large") : 'check-large',
      size: "24",
      variant: "default"
    }), /*#__PURE__*/createElement(Body, {
      element: "span",
      variant: selected.label === item.label && selected.value === item.value ? 'standard-emphasized' : 'standard'
    }, item.label));
  })))) : null);
};
FlyoutSelect.displayName = 'CoreFlyoutSelect';

var styles$p = {"overlay-content":"fr-ec-overlay-content","overlayContent":"fr-ec-overlay-content","carousel__frame--ec-renewal":"fr-ec-carousel__frame--ec-renewal","carouselFrameEcRenewal":"fr-ec-carousel__frame--ec-renewal"};

var OverlayContent = function OverlayContent(_a) {
  var className = _a.className,
    props = __rest$1(_a, ["className"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$p.overlayContent, className)
  }, props));
};
OverlayContent.displayName = 'CoreOverlayContent';

var styles$q = {"overlay-body":"fr-ec-overlay-body","overlayBody":"fr-ec-overlay-body","overlay-body__footer":"fr-ec-overlay-body__footer","overlayBodyFooter":"fr-ec-overlay-body__footer","overlay-body__hide-footer":"fr-ec-overlay-body__hide-footer","overlayBodyHideFooter":"fr-ec-overlay-body__hide-footer","overlay-body__display-footer":"fr-ec-overlay-body__display-footer","overlayBodyDisplayFooter":"fr-ec-overlay-body__display-footer"};

var OverlayBody = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
    children = _a.children,
    footer = _a.footer,
    onHeightChange = _a.onHeightChange,
    _b = _a.isModal,
    isModal = _b === void 0 ? false : _b,
    props = __rest$1(_a, ["className", "children", "footer", "onHeightChange", "isModal"]);
  var isKeyboardOpenState;
  var isAndroidMobile;
  var footerRef = useRef(null);
  if (isInBrowser$1()) {
    isKeyboardOpenState = isKeyboardOpen();
    isAndroidMobile = getOS() === 'android' && getCurrentMediaQueryBreakpoint() === 'sm';
  }
  useEffect(function () {
    if (onHeightChange && footerRef.current) {
      if (footerRef.current) {
        onHeightChange(footerRef.current.clientHeight);
      }
    }
  }, []);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$q.overlayBody, className)
  }, props, {
    ref: ref
  }), /*#__PURE__*/createElement(OverlayContent, null, children), footer && (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$q.overlayBodyFooter, isAndroidMobile && isModal ? isKeyboardOpenState !== true || isKeyboardOpenState === undefined ? styles$q.overlayBodyDisplayFooter : styles$q.overlayBodyHideFooter : ''),
    ref: footerRef
  }, footer)));
});
OverlayBody.displayName = 'CoreOverlayBody';

var styles$r = {"overlay-wrapper":"fr-ec-overlay-wrapper","overlayWrapper":"fr-ec-overlay-wrapper"};

var OverlayWrapper = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
    props = __rest$1(_a, ["className"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$r.overlayWrapper, className)
  }, props, {
    ref: ref
  }));
});
OverlayWrapper.displayName = 'CoreOverlayWrapper';

var styles$s = {"sticky-container":"fr-ec-sticky-container","stickyContainer":"fr-ec-sticky-container","sticky-empty-div--with-block":"fr-ec-sticky-empty-div--with-block","stickyEmptyDivWithBlock":"fr-ec-sticky-empty-div--with-block","sticky-extra-wrapper":"fr-ec-sticky-extra-wrapper","stickyExtraWrapper":"fr-ec-sticky-extra-wrapper","sticky-container--without-nav-header":"fr-ec-sticky-container--without-nav-header","stickyContainerWithoutNavHeader":"fr-ec-sticky-container--without-nav-header","sticky-container--with-sticky-tab-without-nav-header":"fr-ec-sticky-container--with-sticky-tab-without-nav-header","stickyContainerWithStickyTabWithoutNavHeader":"fr-ec-sticky-container--with-sticky-tab-without-nav-header","sticky-container--with-sticky-tab":"fr-ec-sticky-container--with-sticky-tab","stickyContainerWithStickyTab":"fr-ec-sticky-container--with-sticky-tab","sticky-container--with-sticky-utility-bar":"fr-ec-sticky-container--with-sticky-utility-bar","stickyContainerWithStickyUtilityBar":"fr-ec-sticky-container--with-sticky-utility-bar","utility-bar--overlay":"fr-ec-utility-bar--overlay","utilityBarOverlay":"fr-ec-utility-bar--overlay"};

var ThemeContext = /*#__PURE__*/createContext({
  isNavHeader: true,
  scrollValue: 0
});
var StickyContainer = function StickyContainer(_a) {
  var children = _a.children,
    className = _a.className,
    _b = _a.stickySection,
    stickySection = _b === void 0 ? 'utilityBar' : _b,
    _c = _a.isNavHeader,
    isNavHeader = _c === void 0 ? true : _c,
    onSticky = _a.onSticky,
    stickOnLargeDevice = _a.stickOnLargeDevice,
    _d = _a.stickyHidingOffset,
    stickyHidingOffset = _d === void 0 ? 0 : _d,
    _e = _a.insideTemplateBase,
    insideTemplateBase = _e === void 0 ? false : _e,
    props = __rest$1(_a, ["children", "className", "stickySection", "isNavHeader", "onSticky", "stickOnLargeDevice", "stickyHidingOffset", "insideTemplateBase"]);
  var _f = useState(0),
    scrollValue = _f[0],
    setScrollValue = _f[1];
  var stickyRef = useRef(null);
  var plpPageLayout = isInBrowser$1() ? document.querySelector('.fr-ec-template-plp') : undefined;
  var navHeaderEcElement = isInBrowser$1() ? insideTemplateBase ? document.getElementsByClassName('navigation-header') : plpPageLayout ? plpPageLayout.getElementsByClassName('fr-ec-navigation-header--variant-ecrenewal') : document.getElementsByClassName('fr-ec-navigation-header--variant-ecrenewal') : undefined;
  var isNavHeaderEc = navHeaderEcElement && navHeaderEcElement.length > 0;
  var stickyExtraRef = useRef(null);
  var tabsEcElement = isInBrowser$1() ? document.querySelector('.fr-ec-sticky-tabs:not(.fr-ec-sticky-tabs-hide)') : undefined;
  var isTabEc = tabsEcElement !== null;
  var promotionalBannerElement = isInBrowser$1() ? document.querySelector('.fr-ec-navigation-header--promotion-banner') : undefined;
  var isPromotionalBanner = promotionalBannerElement !== null;
  var handleScroll = function handleScroll() {
    var _a, _b, _c, _d;
    var screenSize = getCurrentMediaQueryBreakpoint();
    var shouldActiveScrollHandler = screenSize === 'lg' ? stickOnLargeDevice : true;
    // setHeight is used to add a dummy height to avoid jumping of the content while making Tab or UtilityBar fixed at top.
    var scrollPageYOffset = isInBrowser$1() ? isTabEc && isPromotionalBanner ? window.pageYOffset + 44 : isTabEc ? window.pageYOffset + 88 : window.pageYOffset : 0;
    // set parent element
    var ecRenewalParentElement = (_a = stickyRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
    // if the offsetParent have top value we have to add that to the current value
    var parentContainer = ecRenewalParentElement === null || ecRenewalParentElement === void 0 ? void 0 : ecRenewalParentElement.offsetParent;
    var offsetValue = isPromotionalBanner ? -(((_b = stickyRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0) : 0;
    var ecRenewalScrollPosition = isNavHeaderEc ? ((ecRenewalParentElement === null || ecRenewalParentElement === void 0 ? void 0 : ecRenewalParentElement.offsetTop) || 0) + (parentContainer === null || parentContainer === void 0 ? void 0 : parentContainer.offsetTop) + offsetValue : scrollValue;
    if (stickyRef.current) {
      var hasNotReachedBottom = stickyHidingOffset ? scrollPageYOffset < stickyHidingOffset + scrollValue : true;
      if (ecRenewalScrollPosition && scrollPageYOffset >= ecRenewalScrollPosition && scrollValue && scrollPageYOffset !== 0 && hasNotReachedBottom && shouldActiveScrollHandler) {
        if (stickyExtraRef.current) {
          stickyExtraRef.current.style.height = "".concat((_c = stickyRef.current) === null || _c === void 0 ? void 0 : _c.offsetHeight, "px");
        }
        stickySection === 'utilityBar' ? isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');
        if (isNavHeaderEc) {
          updateEcRenewalLayout();
        }
        if (stickyRef.current && stickyExtraRef.current && stickOnLargeDevice) {
          stickyRef.current.style.width = "".concat((_d = stickyExtraRef.current) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect().width, "px") || "inherit";
        }
      } else {
        if (stickyExtraRef.current) {
          stickyExtraRef.current.style.height = "0px";
        }
        stickySection === 'utilityBar' ? stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');
        if (isNavHeaderEc) {
          stickyRef.current.style.top = "0px";
        }
      }
    }
  };
  var handleResize = function handleResize() {
    var _a;
    if (stickyRef.current && stickyExtraRef.current && stickOnLargeDevice) {
      stickyRef.current.style.width = "".concat((_a = stickyExtraRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width, "px") || "inherit";
    }
    handleScroll();
  };
  var updateEcRenewalLayout = function updateEcRenewalLayout() {
    var _a, _b;
    var topBanner = insideTemplateBase ? document.querySelector('.template-base__top-banner') : null;
    var topBannerHeight = topBanner ? topBanner.clientHeight : 0;
    if (stickyRef && stickyRef.current && isNavHeaderEc) {
      stickyRef.current.style.top = "".concat(((_a = navHeaderEcElement[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) + topBannerHeight, "px");
    }
    if (isInBrowser$1()) {
      var tabsEcElement_1 = document.querySelector('.fr-ec-sticky-tabs:not(.fr-ec-sticky-tabs-hide)');
      var isTabEc_1 = tabsEcElement_1 !== null;
      if (stickyRef && stickyRef.current && isTabEc_1 && isNavHeaderEc) {
        var stickyTabHeight = 44;
        stickyRef.current.style.top = "".concat(stickyTabHeight + ((_b = navHeaderEcElement[0]) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) + topBannerHeight, "px");
      }
    }
  };
  useEffect(function () {
    var _a, _b, _c, _d, _e, _f, _g;
    var screenSize = getCurrentMediaQueryBreakpoint();
    if (isInBrowser$1()) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);
      window.addEventListener('load', function () {
        setTimeout(function () {
          handleScroll();
        }, 100);
      });
    }
    var scrollPageYOffset = isInBrowser$1() ? window.pageYOffset : 0;
    var stickyTopPosition;
    // stickyTopPosition is used to findout howmuch scroll need to make the stickyContainer to be fixed
    // stickyTopPosition 73 means margin top value for making the first content(TabGroup) to be sticky inside Tablet view.
    // The value 73 is the height of Navigation Header in Tablet view.
    // stickyTopPosition 139 means margin top value for making the second content(UtlityBar) to be sticky inside Tab view.
    // The value 139 is the sum of height of Navigation Header and the first sticky Content(TabGroup) height in Tablet view.
    // stickyTopPosition values 73 and 139 will be replaced by 65 and 131 respectively for mobile view.
    stickyTopPosition = isNavHeader ? stickySection === 'utilityBar' ? screenSize === 'md' || screenSize === 'lg' ? 73 : 65 : screenSize === 'md' ? 126 : 118 : stickySection === 'utilityBar' ? 0 : 53;
    if (stickyRef.current) {
      var hasNotReachedBottom = stickyHidingOffset ? scrollPageYOffset < stickyHidingOffset : true;
      if (scrollPageYOffset >= scrollValue && scrollPageYOffset !== 0 && scrollValue !== 0 && hasNotReachedBottom) {
        if (stickyRef.current.offsetTop && stickyRef.current.offsetTop <= scrollPageYOffset + stickyTopPosition) {
          if (onSticky) {
            onSticky(true);
          }
          handleResize();
          stickySection === 'utilityBar' ? isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');
          if (isNavHeaderEc) {
            updateEcRenewalLayout();
          }
        }
      } else {
        if (stickyRef.current.offsetTop && stickyRef.current.offsetTop > scrollPageYOffset + stickyTopPosition) {
          if (onSticky) {
            onSticky(false);
          }
          if (stickyExtraRef.current) {
            stickyExtraRef.current.style.height = "0px";
          }
          stickySection === 'utilityBar' ? stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');
        }
        if (isNavHeaderEc) {
          stickyRef.current.style.top = "0px";
        }
      }
      // To handle if the sticky container is opening in some other position other than relative position in the screen
      if (((_a = stickyRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) === stickyTopPosition && ((_c = (_b = stickyRef.current) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.offsetTop)) {
        setScrollValue(((_e = (_d = stickyRef.current) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.offsetTop) - stickyTopPosition);
      } else if (stickyRef.current.getBoundingClientRect().top) {
        setScrollValue(stickyRef.current.getBoundingClientRect().top - stickyTopPosition);
      } else if ((_f = stickyRef.current) === null || _f === void 0 ? void 0 : _f.offsetTop) {
        setScrollValue(((_g = stickyRef.current) === null || _g === void 0 ? void 0 : _g.offsetTop) - stickyTopPosition);
      }
    }
    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [scrollValue, isNavHeader, stickyRef, stickyExtraRef]);
  useEffect(function () {
    var _a;
    if (isInBrowser$1()) {
      var currentliveStationElement = isInBrowser$1() ? document.querySelector('.fr-ec-navigation-header--promotion-banner') : undefined;
      var isCurrentLiveStation = currentliveStationElement !== null;
      var tabsEcElement_2 = document.querySelector('.fr-ec-sticky-tabs:not(.fr-ec-sticky-tabs-hide)');
      var isTabEc_2 = tabsEcElement_2 !== null;
      if (stickyRef && stickyRef.current && isTabEc_2 && isNavHeaderEc && isCurrentLiveStation !== isPromotionalBanner) {
        stickyRef.current.style.top = "".concat((tabsEcElement_2 === null || tabsEcElement_2 === void 0 ? void 0 : tabsEcElement_2.getBoundingClientRect().height) + ((_a = navHeaderEcElement[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height), "px");
      }
    }
  });
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$s.stickyContainer, className),
    ref: stickyRef
  }, /*#__PURE__*/createElement(ThemeContext.Provider, {
    value: {
      isNavHeader: isNavHeader,
      scrollValue: scrollValue
    }
  }, children)), /*#__PURE__*/createElement("div", {
    className: styles$s.stickyExtraWrapper,
    ref: stickyExtraRef
  }));
};
StickyContainer.displayName = 'CoreStickyContainer';

var styles$t = {"filter-bar":"fr-ec-filter-bar","filterBar":"fr-ec-filter-bar","filter-bar--pills":"fr-ec-filter-bar--pills","filterBarPills":"fr-ec-filter-bar--pills","filter-pill":"fr-ec-filter-pill","filterPill":"fr-ec-filter-pill","filter-bar--swipeable__overlay-right":"fr-ec-filter-bar--swipeable__overlay-right","filterBarSwipeableOverlayRight":"fr-ec-filter-bar--swipeable__overlay-right","filter-bar--swipeable__overlay-left":"fr-ec-filter-bar--swipeable__overlay-left","filterBarSwipeableOverlayLeft":"fr-ec-filter-bar--swipeable__overlay-left","filter-bar--swipeable__navigation-btn-left":"fr-ec-filter-bar--swipeable__navigation-btn-left","filterBarSwipeableNavigationBtnLeft":"fr-ec-filter-bar--swipeable__navigation-btn-left","filter-bar--swiper-button-disabled":"fr-ec-filter-bar--swiper-button-disabled","filterBarSwiperButtonDisabled":"fr-ec-filter-bar--swiper-button-disabled","filter-bar--swipeable__navigation-btn":"fr-ec-filter-bar--swipeable__navigation-btn","filterBarSwipeableNavigationBtn":"fr-ec-filter-bar--swipeable__navigation-btn","filter-bar--swipeable__navigation-btn-right":"fr-ec-filter-bar--swipeable__navigation-btn-right","filterBarSwipeableNavigationBtnRight":"fr-ec-filter-bar--swipeable__navigation-btn-right","filter-bar--filter-icon-wrapper":"fr-ec-filter-bar--filter-icon-wrapper","filterBarFilterIconWrapper":"fr-ec-filter-bar--filter-icon-wrapper","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","filter-bar--filter-icon-badge":"fr-ec-filter-bar--filter-icon-badge","filterBarFilterIconBadge":"fr-ec-filter-bar--filter-icon-badge"};

var FilterBar = /** @class */function (_super) {
  __extends(FilterBar, _super);
  function FilterBar(props) {
    var _this = _super.call(this, props) || this;
    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', _this.onTouchMove);
      }
    };
    _this.onTouchMove = function () {
      if (_this.swiperInstance && _this.swiperInstance.update) {
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    _this.controlNavigation = function (direction) {
      if (_this.swiperInstance) {
        var slides = _this.swiperInstance.slides || 0;
        var _a = _this.swiperInstance,
          activeIndex = _a.activeIndex,
          isBeginning = _a.isBeginning,
          isEnd = _a.isEnd;
        var nextSlide = direction === 'NEXT' ? isEnd ? slides.length : activeIndex + 1 : isBeginning ? 0 : activeIndex - 1;
        if (direction === 'NEXT') {
          _this.swiperInstance.slideTo(nextSlide);
        } else {
          _this.swiperInstance.slideTo(nextSlide);
        }
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    _this.onClick = function (pillOnclick) {
      return function (event) {
        var ActivePillIndex = event.currentTarget.getAttribute('id');
        if (_this.swiperInstance) {
          _this.swiperInstance.slideTo(Number(ActivePillIndex));
          _this.swiperInstance.update();
        }
        if (pillOnclick) {
          pillOnclick(event);
        }
        _this.onTouchMove();
      };
    };
    _this.state = {
      isBeginning: true,
      isEnd: false
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }
  FilterBar.prototype.componentDidMount = function () {
    var _this = this;
    var slidesOffsetBefore = this.props.slidesOffsetBefore;
    this.swiperInstance = new swiper(this.swiperRef.current, {
      freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      observeParents: true,
      observer: true,
      on: {
        sliderMove: function sliderMove() {
          return _this.onTouchMove();
        }
      },
      slidesPerView: 'auto',
      spaceBetween: 0,
      slidesOffsetBefore: slidesOffsetBefore ? 24 : 0,
      breakpoints: {
        599: {
          slidesOffsetBefore: slidesOffsetBefore ? 16 : 0
        }
      }
    });
    this.setState({
      isBeginning: this.swiperInstance.isBeginning,
      isEnd: this.swiperInstance.isEnd
    });
    if (isInBrowser$1()) {
      window.addEventListener('resize', this.onTouchMove);
    }
  };
  FilterBar.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      _b = _a.isOverlay,
      isOverlay = _b === void 0 ? false : _b,
      iconBrand = _a.iconBrand,
      filterIcon = _a.filterIcon,
      onClickFilterIcon = _a.onClickFilterIcon,
      badgeCount = _a.badgeCount,
      ecRenewal = _a.ecRenewal;
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var filterBar = /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-container', styles$t.filterBar),
      ref: this.swiperRef
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-wrapper', styles$t.filterBarPills)
    }, Children.map(children, function (child, i) {
      return /*#__PURE__*/createElement("div", {
        key: i,
        className: joinClasses('swiper-slide')
      }, /*#__PURE__*/cloneElement(child, {
        id: String(i),
        onClick: _this.onClick(child.props.onClick)
      }));
    })), breakpoint === 'lg' ? (/*#__PURE__*/createElement(Fragment, null, !this.state.isEnd && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$t.filterBarSwipeableOverlayRight
    }), /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "chevron-right",
      iconBrand: iconBrand,
      label: "arrow right",
      hideLabel: true,
      className: joinClasses('swiper-button-next', styles$t.filterBarSwipeableNavigationBtn, styles$t.filterBarSwipeableNavigationBtnRight),
      onClick: function onClick() {
        return _this.controlNavigation('NEXT');
      }
    }))), !this.state.isBeginning && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$t.filterBarSwipeableOverlayLeft
    }), /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "chevron-left",
      iconBrand: iconBrand,
      label: "arrow left",
      hideLabel: true,
      className: joinClasses('swiper-button-prev', styles$t.filterBarSwipeableNavigationBtn, styles$t.filterBarSwipeableNavigationBtnLeft),
      onClick: function onClick() {
        return _this.controlNavigation('PREV');
      }
    }))))) : isOverlay ? (/*#__PURE__*/createElement(Fragment, null, !this.state.isEnd && /*#__PURE__*/createElement("div", {
      className: styles$t.filterBarSwipeableOverlayRight
    }), !this.state.isBeginning && /*#__PURE__*/createElement("div", {
      className: styles$t.filterBarSwipeableOverlayLeft
    }))) : null);
    return filterIcon && ecRenewal ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$t.filterBarFilterIconWrapper
    }, /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      label: "filter",
      hideLabel: true,
      icon: filterIcon,
      variant: 'dark',
      onClick: onClickFilterIcon,
      iconBrand: iconBrand
    }), badgeCount && /*#__PURE__*/createElement(Badge, {
      content: badgeCount,
      className: styles$t.filterBarFilterIconBadge
    })), filterBar)) : filterBar;
  };
  return FilterBar;
}(Component);

var styles$u = {"filter-pill":"fr-ec-filter-pill","filterPill":"fr-ec-filter-pill","filter-pill--icon":"fr-ec-filter-pill--icon","filterPillIcon":"fr-ec-filter-pill--icon","filter-pill--selected":"fr-ec-filter-pill--selected","filterPillSelected":"fr-ec-filter-pill--selected","body":"fr-ec-body","filter-pill--modal":"fr-ec-filter-pill--modal","filterPillModal":"fr-ec-filter-pill--modal","filter-pill-ellipsis":"fr-ec-filter-pill-ellipsis","filterPillEllipsis":"fr-ec-filter-pill-ellipsis"};

var FilterPill = function FilterPill(_a) {
  var label = _a.label,
    isSelected = _a.isSelected,
    isOpen = _a.isOpen,
    onClick = _a.onClick,
    className = _a.className,
    gender = _a.gender,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["label", "isSelected", "isOpen", "onClick", "className", "gender", "iconBrand"]);
  var _b = useState(isOpen || false),
    isToggledOpen = _b[0],
    setIsToggled = _b[1];
  var handleClick = function handleClick(e) {
    setIsToggled(!isToggledOpen);
    if (onClick) {
      onClick(e);
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    if (e.code == 'Enter') {
      setIsToggled(!isToggledOpen);
      if (onClick) {
        onClick(e);
      }
    }
  };
  useEffect(function () {
    setIsToggled(isOpen || false);
  }, [isOpen]);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", __assign$1({
    onClick: handleClick,
    className: joinClasses(styles$u.filterPill, isSelected && styles$u.filterPillSelected, className)
  }, props, {
    tabIndex: 0,
    onKeyDown: handleKeyDown
  }), /*#__PURE__*/createElement(Body, {
    variant: isOpen ? 'small-emphasized' : 'small',
    element: "div",
    title: typeof label === 'string' ? gender ? "".concat(gender, " > ").concat(label) : label : label
  }, gender ? "".concat(gender, " > ").concat(label) : label), /*#__PURE__*/createElement(Icon, {
    name: isOpen ? iconBrand ? "".concat(iconBrand, "chevron-up") : 'chevron-up' : iconBrand ? "".concat(iconBrand, "chevron-down") : 'chevron-down',
    className: styles$u.filterPillIcon
  })));
};
FilterPill.displayName = 'CoreFilterPill';

var styles$v = {"utility-bar":"fr-ec-utility-bar","utilityBar":"fr-ec-utility-bar","utility-bar--ec-renewal":"fr-ec-utility-bar--ec-renewal","utilityBarEcRenewal":"fr-ec-utility-bar--ec-renewal","utility-bar-wrapper":"fr-ec-utility-bar-wrapper","utilityBarWrapper":"fr-ec-utility-bar-wrapper","utility-bar-wrapper--ec-renewal":"fr-ec-utility-bar-wrapper--ec-renewal","utilityBarWrapperEcRenewal":"fr-ec-utility-bar-wrapper--ec-renewal","utility-bar--keyline-top":"fr-ec-utility-bar--keyline-top","utilityBarKeylineTop":"fr-ec-utility-bar--keyline-top","utility-bar__filter-badge-count":"fr-ec-utility-bar__filter-badge-count","utilityBarFilterBadgeCount":"fr-ec-utility-bar__filter-badge-count","utility-bar__flyout-select-card":"fr-ec-utility-bar__flyout-select-card","utilityBarFlyoutSelectCard":"fr-ec-utility-bar__flyout-select-card","utility-bar__flyout-select-card-show":"fr-ec-utility-bar__flyout-select-card-show","utilityBarFlyoutSelectCardShow":"fr-ec-utility-bar__flyout-select-card-show","utility-bar__flyout-select":"fr-ec-utility-bar__flyout-select","utilityBarFlyoutSelect":"fr-ec-utility-bar__flyout-select","flyout-select__list":"fr-ec-flyout-select__list","flyoutSelectList":"fr-ec-flyout-select__list","utility-bar__collection-list-horizontal":"fr-ec-utility-bar__collection-list-horizontal","utilityBarCollectionListHorizontal":"fr-ec-utility-bar__collection-list-horizontal","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","button-toggle":"fr-ec-button-toggle","buttonToggle":"fr-ec-button-toggle","label":"fr-ec-label","utility-bar--filter-bar--label":"fr-ec-utility-bar--filter-bar--label","utilityBarFilterBarLabel":"fr-ec-utility-bar--filter-bar--label","utility-bar--filter-bar":"fr-ec-utility-bar--filter-bar","utilityBarFilterBar":"fr-ec-utility-bar--filter-bar","utility-bar--filter-bar-with-icon":"fr-ec-utility-bar--filter-bar-with-icon","utilityBarFilterBarWithIcon":"fr-ec-utility-bar--filter-bar-with-icon","sticky-container--with-sticky-tab":"fr-ec-sticky-container--with-sticky-tab","stickyContainerWithStickyTab":"fr-ec-sticky-container--with-sticky-tab","utility-bar--keyline":"fr-ec-utility-bar--keyline","utilityBarKeyline":"fr-ec-utility-bar--keyline","utility-bar--filter-wrapper":"fr-ec-utility-bar--filter-wrapper","utilityBarFilterWrapper":"fr-ec-utility-bar--filter-wrapper","utility-bar--filter-panel":"fr-ec-utility-bar--filter-panel","utilityBarFilterPanel":"fr-ec-utility-bar--filter-panel","utility-bar--modal":"fr-ec-utility-bar--modal","utilityBarModal":"fr-ec-utility-bar--modal","utility-bar__modal__close-icon":"fr-ec-utility-bar__modal__close-icon","utilityBarModalCloseIcon":"fr-ec-utility-bar__modal__close-icon","utility-bar--body":"fr-ec-utility-bar--body","utilityBarBody":"fr-ec-utility-bar--body","dropdown__list":"fr-ec-dropdown__list","dropdownList":"fr-ec-dropdown__list","modal-open":"fr-ec-modal-open","modalOpen":"fr-ec-modal-open","utility-bar--filter-panel--modal-open":"fr-ec-utility-bar--filter-panel--modal-open","utilityBarFilterPanelModalOpen":"fr-ec-utility-bar--filter-panel--modal-open","utility-bar--modal-backdrop":"fr-ec-utility-bar--modal-backdrop","utilityBarModalBackdrop":"fr-ec-utility-bar--modal-backdrop","utility-bar--overlay":"fr-ec-utility-bar--overlay","utilityBarOverlay":"fr-ec-utility-bar--overlay","utility-bar--extra-wrapper":"fr-ec-utility-bar--extra-wrapper","utilityBarExtraWrapper":"fr-ec-utility-bar--extra-wrapper","utility-bar--overlay--visibility-hide":"fr-ec-utility-bar--overlay--visibility-hide","utilityBarOverlayVisibilityHide":"fr-ec-utility-bar--overlay--visibility-hide","overlay-content":"fr-ec-overlay-content","overlayContent":"fr-ec-overlay-content","utility-bar--filter-bar--modal":"fr-ec-utility-bar--filter-bar--modal","utilityBarFilterBarModal":"fr-ec-utility-bar--filter-bar--modal","radio-group":"fr-ec-radio-group","radioGroup":"fr-ec-radio-group","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","hint-text":"fr-ec-hint-text","hintText":"fr-ec-hint-text","filter-bar":"fr-ec-filter-bar","filterBar":"fr-ec-filter-bar","utility-bar--filter-bar--ec-renewal":"fr-ec-utility-bar--filter-bar--ec-renewal","utilityBarFilterBarEcRenewal":"fr-ec-utility-bar--filter-bar--ec-renewal","utility-bar--filter-panel--padding":"fr-ec-utility-bar--filter-panel--padding","utilityBarFilterPanelPadding":"fr-ec-utility-bar--filter-panel--padding","store-bar__wrapper":"fr-ec-store-bar__wrapper","storeBarWrapper":"fr-ec-store-bar__wrapper"};

var DropDownContext = /*#__PURE__*/createContext(false);
var filterPillLabelVal = [];
var UtilityBar = function UtilityBar(_a) {
  var className = _a.className,
    resultDetailsSection = _a.resultDetailsSection,
    collapseFilterLabel = _a.collapseFilterLabel,
    sortLabel = _a.sortLabel,
    _b = _a.toggleFilter,
    toggleFilter = _b === void 0 ? false : _b,
    onToggleFilter = _a.onToggleFilter,
    handleChangeSort = _a.handleChangeSort,
    currentSortValue = _a.currentSortValue,
    sortOptions = _a.sortOptions,
    filterBadgeCount = _a.filterBadgeCount,
    _c = _a.toggleSort,
    sortEnable = _c === void 0 ? true : _c,
    _d = _a.keyline,
    keyline = _d === void 0 ? 'none' : _d,
    badgeCount = _a.badgeCount,
    filterPillContent = _a.filterPillContent,
    closeLabel = _a.closeLabel,
    storeIcon = _a.storeIcon,
    storeBarPlaceholder = _a.storeBarPlaceholder,
    storeSearchLabel = _a.storeSearchLabel,
    storeName = _a.storeName,
    _e = _a.withFilterCount,
    withFilterCount = _e === void 0 ? true : _e,
    _f = _a.isNavHeader,
    isNavHeader = _f === void 0 ? true : _f,
    _g = _a.stickOnLargeDevice,
    stickOnLargeDevice = _g === void 0 ? false : _g,
    onClickStoreSearch = _a.onClickStoreSearch,
    _h = _a.stickOnSmallDevice,
    stickOnSmallDevice = _h === void 0 ? true : _h,
    _j = _a.stickOnClick,
    stickOnClick = _j === void 0 ? true : _j,
    iconBrand = _a.iconBrand,
    filterIcon = _a.filterIcon,
    onClickFilterIcon = _a.onClickFilterIcon,
    _k = _a.ecRenewal,
    ecRenewal = _k === void 0 ? false : _k,
    _l = _a.trapFocus,
    trapFocus = _l === void 0 ? true : _l,
    _m = _a.insideTemplateBase,
    insideTemplateBase = _m === void 0 ? false : _m;
  var containerRef = useRef(null);
  var extraContainerRef = useRef(null);
  var modalRef = useRef(null);
  var filterBarRef = useRef(null);
  var flyoutFirstElementRef = useRef(null);
  var sortFlyoutRef = useRef(null);
  var _o = useState(false),
    toggleSort = _o[0],
    setToggleSort = _o[1];
  var _p = useState(currentSortValue || '1'),
    flyoutSelectValue = _p[0],
    setFlyoutSelectValue = _p[1];
  var _q = useState(-1),
    activeIndex = _q[0],
    setActiveIndex = _q[1];
  var _r = useState(false),
    isOpen = _r[0],
    setOpenState = _r[1];
  var value = useContext(ThemeContext);
  var _s = useState(false),
    hasMounted = _s[0],
    setHasMounted = _s[1];
  useEffect(function () {
    setHasMounted(true);
  }, []);
  var screenSize = getCurrentMediaQueryBreakpoint();
  var stickyTopPosition = isNavHeader ? screenSize === 'md' || screenSize === 'lg' ? 73 : 65 : 0;
  if (insideTemplateBase) {
    stickyTopPosition = isNavHeader ? 64 : 0;
  }
  var isSticky = screenSize === 'md' || screenSize === 'lg' ? stickOnLargeDevice : stickOnSmallDevice;
  var onToggleSort = function onToggleSort(event) {
    event.stopPropagation();
    setToggleSort(!toggleSort);
  };
  var handleKeyPress = function handleKeyPress(event) {
    if ((event.keyCode === KEYCODE.ENTER || event.keyCode === KEYCODE.SPACE) && flyoutFirstElementRef.current) {
      setTimeout(function () {
        var _a;
        return (_a = flyoutFirstElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      }, 100);
    }
  };
  var onHideSort = function onHideSort() {
    return setToggleSort(false);
  };
  var handleResize = function handleResize() {
    if (modalRef.current) {
      modalRef.current.style.maxHeight = "calc(100vh - (".concat(modalRef.current.getBoundingClientRect().top, "px + 1px))");
    }
  };
  var initializeLabelVal = function initializeLabelVal(content) {
    if (content) {
      content.map(function (_a) {
        var label = _a.label;
        if (label) {
          filterPillLabelVal.push(label);
        }
      });
    }
  };
  var scrollUtiltiybarToTop = function scrollUtiltiybarToTop() {
    if (containerRef && containerRef.current && stickOnClick) {
      var promotionalBannerElement = isInBrowser$1() ? document.querySelector('.fr-ec-navigation-header--promotion-banner') : undefined;
      var isPromotionalBanner = promotionalBannerElement !== null;
      var offsetValue = ecRenewal && !isPromotionalBanner ? 72 : 52;
      var scrollVal = containerRef.current.offsetTop + containerRef.current.offsetHeight - (stickyTopPosition + (!insideTemplateBase ? offsetValue : 0));
      if (scrollVal < 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: scrollVal,
          behavior: 'smooth'
        });
      }
    }
  };
  var disableScroll = function disableScroll(event) {
    event.preventDefault();
  };
  useEffect(function () {
    var _a;
    if (isInBrowser$1()) {
      window.addEventListener('resize', handleResize);
      window.addEventListener('scroll', handleResize);
      (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('touchmove', disableScroll);
    }
    var handleClickOutside = function handleClickOutside(event) {
      if (sortFlyoutRef.current && !sortFlyoutRef.current.contains(event.target)) {
        setToggleSort(false);
      }
      if (event.target !== modalRef.current && modalRef.current && !modalRef.current.contains(event.target) && filterBarRef.current && !filterBarRef.current.contains(event.target)) {
        setOpenState(false);
      }
    };
    document.addEventListener('click', handleClickOutside, true);
    handleResize();
    if (!filterPillLabelVal.length) {
      initializeLabelVal(filterPillContent);
    }
    if (filterPillContent && filterPillContent[activeIndex]) {
      if (filterPillLabelVal[activeIndex] && filterPillLabelVal[activeIndex] !== filterPillContent[activeIndex].label) {
        scrollUtiltiybarToTop();
        filterPillLabelVal[activeIndex] = filterPillContent[activeIndex].label;
      }
    }
    return function () {
      var _a;
      document.removeEventListener('click', handleClickOutside, true);
      if (isInBrowser$1()) {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('scroll', handleResize);
      }
      (_a = modalRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('touchmove', disableScroll);
    };
  }, [sortFlyoutRef, isOpen, modalRef, filterBarRef, filterPillContent]);
  var setModalStatus = function setModalStatus(index) {
    scrollUtiltiybarToTop();
    if (index === activeIndex) {
      setOpenState(!isOpen);
    } else {
      setOpenState(true);
    }
    setActiveIndex(index);
    if (filterBarRef && filterBarRef.current && modalRef && modalRef.current) {
      modalRef.current.style.top = "".concat(filterBarRef.current.getBoundingClientRect().bottom, "px");
    }
  };
  var toggleFilterContent = function toggleFilterContent() {
    setOpenState(false);
    if (onToggleFilter) {
      onToggleFilter();
    }
  };
  var handleChangeSortHandler = function handleChangeSortHandler(event, selectValue) {
    setFlyoutSelectValue(selectValue);
    if (handleChangeSort) {
      handleChangeSort(event, selectValue);
    }
  };
  var handleFallbackFocus = function handleFallbackFocus() {
    var element = document.activeElement;
    return element;
  };
  var width = getViewportWidth();
  var toggleButtonFilter = width > designTokens_3.mqMediumScreenMaxWidthLimit ? toggleFilter || filterBadgeCount : false;
  var utilityBarContent = /*#__PURE__*/createElement(ContentAlignment, {
    className: joinClasses(styles$v.utilityBarWrapper, ecRenewal && styles$v.utilityBarWrapperEcRenewal, keyline !== 'none' && keylineStyles.keylineBottom, keyline === 'bottom-top' && styles$v.utilityBarKeylineTop, className),
    element: 'div',
    direction: 'row'
  }, /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    justifyContent: "space-between",
    alignment: "center",
    element: "section",
    className: joinClasses(styles$v.utilityBar, ecRenewal && styles$v.utilityBarEcRenewal)
  }, filterPillContent ? withFilterCount && resultDetailsSection : resultDetailsSection, (sortEnable || collapseFilterLabel) && (/*#__PURE__*/createElement(CollectionListHorizontal, {
    divider: false,
    spacingValue: "16",
    className: styles$v.utilityBarCollectionListHorizontal
  }, sortEnable && (/*#__PURE__*/createElement("div", {
    ref: sortFlyoutRef
  }, /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    alignment: "center"
  }, /*#__PURE__*/createElement(ButtonToggle, {
    icon: "sort",
    variant: 'iconWithLabel',
    text: sortLabel,
    onClick: onToggleSort,
    isToggled: toggleSort,
    alignment: "center",
    iconBrand: iconBrand,
    onKeyDown: handleKeyPress
  }), sortOptions && (/*#__PURE__*/createElement(Card, {
    element: "div",
    className: joinClasses(styles$v.utilityBarFlyoutSelectCard, toggleSort && styles$v.utilityBarFlyoutSelectCardShow)
  }, /*#__PURE__*/createElement(FlyoutSelect, {
    visible: true,
    onHideVisibility: onHideSort,
    value: currentSortValue || flyoutSelectValue,
    onSelect: handleChangeSortHandler,
    options: sortOptions,
    className: styles$v.utilityBarFlyoutSelect,
    iconBrand: iconBrand,
    firstElementRef: flyoutFirstElementRef
  })))))), collapseFilterLabel && !filterPillContent && (/*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    alignment: "center"
  }, /*#__PURE__*/createElement(ButtonToggle, {
    icon: toggleButtonFilter ? 'filter-opened' : 'filter',
    variant: 'iconWithLabel',
    text: collapseFilterLabel,
    onClick: onToggleFilter,
    isToggled: toggleButtonFilter ? true : false,
    alignment: "center",
    iconBrand: iconBrand
  }), filterBadgeCount && (/*#__PURE__*/createElement(Badge, {
    content: filterBadgeCount,
    className: styles$v.utilityBarFilterBadgeCount
  }))))))));
  var getFilterBarSection = function getFilterBarSection() {
    return filterPillContent && (/*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$v.utilityBarFilterBar, ecRenewal && styles$v.utilityBarFilterBarEcRenewal, ecRenewal && filterIcon && styles$v.utilityBarFilterBarWithIcon),
      ref: filterBarRef
    }, collapseFilterLabel && (/*#__PURE__*/createElement(CollectionListHorizontal, {
      alignment: "center",
      divider: false,
      spacingValue: "8",
      className: styles$v.utilityBarFilterBarLabel
    }, /*#__PURE__*/createElement(Body, {
      variant: "small-underlined",
      element: "h5",
      onClick: toggleFilterContent
    }, collapseFilterLabel), badgeCount && /*#__PURE__*/createElement(Badge, {
      content: badgeCount
    }))), /*#__PURE__*/createElement(FilterBar, {
      iconBrand: iconBrand,
      filterIcon: filterIcon,
      onClickFilterIcon: onClickFilterIcon,
      badgeCount: badgeCount,
      ecRenewal: ecRenewal
    }, filterPillContent && filterPillContent.map(function (_a, i) {
      var props = __rest$1(_a, []);
      return /*#__PURE__*/createElement(FilterPill, __assign$1({
        key: i,
        iconBrand: iconBrand
      }, props, {
        isOpen: i === activeIndex ? isOpen : false,
        onClick: function onClick() {
          return setModalStatus(i);
        }
      }));
    }))), /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(FocusTrap, {
      active: trapFocus && isOpen,
      focusTrapOptions: {
        clickOutsideDeactivates: true,
        escapeDeactivates: false,
        fallbackFocus: handleFallbackFocus,
        returnFocusOnDeactivate: true
      }
    }, /*#__PURE__*/createElement(OverlayWrapper, {
      role: "dialog",
      "aria-modal": true,
      tabIndex: -1,
      "aria-labelledby": 'titleId',
      className: joinClasses(styles$v.utilityBarOverlay, !isOpen && styles$v.utilityBarOverlayVisibilityHide)
    }, /*#__PURE__*/createElement("div", {
      className: styles$v.utilityBarModal
    }, resultDetailsSection, closeLabel && (/*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "close-big",
      iconBrand: iconBrand,
      label: closeLabel,
      className: styles$v.utilityBarModalCloseIcon,
      variant: "dark",
      onClick: function onClick() {
        return setOpenState(false);
      }
    }))), /*#__PURE__*/createElement(OverlayBody, {
      isModal: false,
      className: styles$v.utilityBarBody
    }, /*#__PURE__*/createElement("div", {
      ref: modalRef,
      className: styles$v.utilityBarFilterBarModal
    }, /*#__PURE__*/createElement(DropDownContext.Provider, {
      value: true
    }, filterPillContent[activeIndex] && filterPillContent[activeIndex].children)))))), /*#__PURE__*/createElement("div", {
      className: styles$v.utilityBarKeyline
    })));
  };
  return filterPillContent ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$v.utilityBarFilterPanel, ecRenewal && styles$v.utilityBarFilterPanelPadding, isOpen && styles$v.utilityBarFilterPanelModalOpen),
    ref: containerRef
  }, storeSearchLabel && (/*#__PURE__*/createElement(StoreBar, {
    icon: storeIcon,
    iconBrand: iconBrand,
    placeholder: storeBarPlaceholder,
    searchLabel: storeSearchLabel,
    storeName: storeName,
    onClick: onClickStoreSearch,
    ecRenewal: ecRenewal
  })), hasMounted ? isSticky ? (/*#__PURE__*/createElement(StickyContainer, {
    isNavHeader: isNavHeader,
    insideTemplateBase: insideTemplateBase,
    stickOnLargeDevice: stickOnLargeDevice
  }, getFilterBarSection())) : (/*#__PURE__*/createElement(Fragment, null, getFilterBarSection())) : (/*#__PURE__*/createElement("div", {
    className: styles$v.utilityBarFilterWrapper
  })), (sortEnable || collapseFilterLabel || withFilterCount && resultDetailsSection) && utilityBarContent), /*#__PURE__*/createElement("div", {
    className: styles$v.utilityBarExtraWrapper,
    ref: extraContainerRef
  }))) : utilityBarContent;
};
UtilityBar.displayName = 'CoreUtilityBar';

var styles$w = {"carousel-arrow":"fr-ec-carousel-arrow","carouselArrow":"fr-ec-carousel-arrow","carousel-arrow--left":"fr-ec-carousel-arrow--left","carouselArrowLeft":"fr-ec-carousel-arrow--left","carousel-arrow--right":"fr-ec-carousel-arrow--right","carouselArrowRight":"fr-ec-carousel-arrow--right","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn"};

var ARROW_DIRECTION_PREV = 'prev';
var ARROW_DIRECTION_NEXT = 'next';

var CarouselArrow = function CarouselArrow(_a) {
  var _b, _c;
  var direction = _a.direction,
    onClick = _a.onClick,
    topOffset = _a.topOffset,
    keyboardNavigation = _a.keyboardNavigation,
    onArrowTrigger = _a.onArrowTrigger,
    carouselVariant = _a.carouselVariant,
    displayCount = _a.displayCount,
    ecRenewal = _a.ecRenewal,
    iconBrand = _a.iconBrand;
  var arrowStyles = (_b = {}, _b[ARROW_DIRECTION_NEXT] = joinClasses(styles$w.carouselArrow, styles$w.carouselArrowRight), _b[ARROW_DIRECTION_PREV] = joinClasses(styles$w.carouselArrow, styles$w.carouselArrowLeft), _b);
  var arrowIcon = (_c = {}, _c[ARROW_DIRECTION_NEXT] = 'chevron-right', _c[ARROW_DIRECTION_PREV] = 'chevron-left', _c);
  var offsetStyles = topOffset !== undefined ? {
    top: topOffset + 'px'
  } : undefined;
  var handleClick = function handleClick(event) {
    onClick(direction);
    if (onArrowTrigger) {
      onArrowTrigger(event);
    }
  };
  var handleClickButton = function handleClickButton(e) {
    if (e.keyCode === KEYCODE.LEFT || e.keyCode === KEYCODE.RIGHT) {
      onClick(direction);
    }
  };
  var displayCountCheck = displayCount === 1;
  var isMediaGallerySP = carouselVariant && carouselVariant === 'media-gallery' ? true : false;
  var enableArrows = ecRenewal && !displayCountCheck && Number(getViewportWidth()) < designTokens_3.mqLargeScreenMinWidthLimit ? false : !ecRenewal && Number(getViewportWidth()) < designTokens_3.mqMediumScreenMinWidthLimit ? !isMediaGallerySP && displayCountCheck : true;
  return enableArrows ? (/*#__PURE__*/createElement("button", {
    tabIndex: keyboardNavigation === 'item' ? -1 : 0,
    "aria-hidden": true,
    className: carouselVariant && carouselVariant === 'media-gallery' ? arrowStyles[direction] : joinClasses(arrowStyles[direction]),
    onClick: handleClick,
    style: offsetStyles,
    onKeyDown: handleClickButton
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(arrowIcon[direction]) : arrowIcon[direction]
  }))) : (/*#__PURE__*/createElement("span", null));
};
CarouselArrow.displayName = 'CoreCarouselArrow';

var styles$x = {"hint-text":"fr-ec-hint-text","hintText":"fr-ec-hint-text","hint-text--color-primary-dark":"fr-ec-hint-text--color-primary-dark","hintTextColorPrimaryDark":"fr-ec-hint-text--color-primary-dark","hint-text--color-primary-light":"fr-ec-hint-text--color-primary-light","hintTextColorPrimaryLight":"fr-ec-hint-text--color-primary-light","hint-text--color-secondary":"fr-ec-hint-text--color-secondary","hintTextColorSecondary":"fr-ec-hint-text--color-secondary","hint-text--color-disabled":"fr-ec-hint-text--color-disabled","hintTextColorDisabled":"fr-ec-hint-text--color-disabled","hint-text--color-error":"fr-ec-hint-text--color-error","hintTextColorError":"fr-ec-hint-text--color-error"};

var alignmentClass$4 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var HintText = function HintText(_a) {
  var Element = _a.element,
    children = _a.children,
    _b = _a.color,
    color = _b === void 0 ? 'secondary' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'standard' : _c,
    _d = _a.textAlign,
    textAlign = _d === void 0 ? 'left' : _d,
    id = _a.id,
    className = _a.className,
    _e = _a.textTransform,
    textTransform = _e === void 0 ? 'normal' : _e,
    _f = _a.wordBreak,
    wordBreak = _f === void 0 ? 'none' : _f,
    strikethrough = _a.strikethrough,
    props = __rest$1(_a, ["element", "children", "color", "variant", "textAlign", "id", "className", "textTransform", "wordBreak", "strikethrough"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    id: id,
    "aria-live": color === 'error' ? 'polite' : undefined,
    "aria-disabled": color === 'disabled',
    className: joinClasses(styles$x.hintText, variant === 'standard' ? typographyStyles.hintTextStandard : '', styles$x["hint-text--color-".concat(color)], textAlignStyles[alignmentClass$4[textAlign]], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props), children);
};
HintText.displayName = 'CoreHintText';

var styles$y = {"carousel-page":"fr-ec-carousel-page","carouselPage":"fr-ec-carousel-page","carousel-page--current":"fr-ec-carousel-page--current","carouselPageCurrent":"fr-ec-carousel-page--current","carousel-pagination-number":"fr-ec-carousel-pagination-number","carouselPaginationNumber":"fr-ec-carousel-pagination-number","carousel-pagination-number-count":"fr-ec-carousel-pagination-number-count","carouselPaginationNumberCount":"fr-ec-carousel-pagination-number-count","carousel-pagination-number-divider":"fr-ec-carousel-pagination-number-divider","carouselPaginationNumberDivider":"fr-ec-carousel-pagination-number-divider"};

var CarouselPagination = function CarouselPagination(_a) {
  var currentIndex = _a.currentIndex,
    total = _a.total,
    itemsPerPage = _a.itemsPerPage,
    indicatorType = _a.indicatorType,
    _b = _a.forceLast,
    forceLast = _b === void 0 ? false : _b,
    autoSlide = _a.autoSlide,
    carouselVariant = _a.carouselVariant;
  var pageCount = Math.ceil(total / itemsPerPage);
  var currentPage = forceLast ? pageCount - 1 : Math.ceil(currentIndex / itemsPerPage);
  currentPage = currentPage < 0 && autoSlide ? Math.floor(currentIndex % total) + total : currentPage;
  if (indicatorType === 'pages') {
    if (pageCount <= 1) {
      return null;
    }
    var pageButtons = count(pageCount).map(function (_, i) {
      return /*#__PURE__*/createElement("div", {
        key: i,
        tabIndex: -1,
        className: i === currentPage % total ? styles$y.carouselPageCurrent : styles$y.carouselPage,
        "aria-hidden": true
      });
    });
    if (currentPage > pageCount) {
      currentPage = 0;
    }
    return /*#__PURE__*/createElement("div", null, pageButtons);
  }
  if (indicatorType === 'number') {
    var numberIndicator = currentIndex >= 0 ? currentPage % total + 1 : Math.floor(currentIndex % total) + total + 1;
    numberIndicator = currentIndex % total === 0 && currentIndex < 0 ? 1 : numberIndicator;
    return carouselVariant && (carouselVariant === 'media-gallery' || carouselVariant === 'ecRenewal') ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(HintText, {
      element: "span",
      color: "primary-light",
      className: joinClasses(!autoSlide && styles$y.carouselPaginationNumber, styles$y.carouselPaginationNumberCount)
    }, autoSlide ? numberIndicator : currentIndex + 1), /*#__PURE__*/createElement(HintText, {
      element: "span",
      color: "primary-light",
      className: joinClasses(!autoSlide && styles$y.carouselPaginationNumber, styles$y.carouselPaginationNumberDivider)
    }, "|"), /*#__PURE__*/createElement(HintText, {
      element: "span",
      color: "primary-light",
      className: joinClasses(!autoSlide && styles$y.carouselPaginationNumber, styles$y.carouselPaginationNumberCount)
    }, total))) : (/*#__PURE__*/createElement(Body, {
      element: "span",
      className: joinClasses(!autoSlide && styles$y.carouselPaginationNumber)
    }, autoSlide ? numberIndicator : currentIndex + 1, "/", total));
  }
  return null;
};
CarouselPagination.displayName = 'CoreCarouselPagination';

var styles$z = {"carousel-slide":"fr-ec-carousel-slide","carouselSlide":"fr-ec-carousel-slide","carousel-slide--padded":"fr-ec-carousel-slide--padded","carouselSlidePadded":"fr-ec-carousel-slide--padded","carousel-slide__container":"fr-ec-carousel-slide__container","carouselSlideContainer":"fr-ec-carousel-slide__container","carousel-slide--looped":"fr-ec-carousel-slide--looped","carouselSlideLooped":"fr-ec-carousel-slide--looped","carousel-slide--styling-variant-sm":"fr-ec-carousel-slide--styling-variant-sm","carouselSlideStylingVariantSm":"fr-ec-carousel-slide--styling-variant-sm"};

var MIN_LIMIT = 5;
var PADDING_MOBILE = 16;
var PADDING_IPAD = 24;
var CarouselSlides = function CarouselSlides(_a) {
  var children = _a.children,
    displayCount = _a.displayCount,
    currentIndex = _a.currentIndex,
    placeholder = _a.placeholder,
    noPadding = _a.noPadding,
    slideWidth = _a.slideWidth,
    isMobile = _a.isMobile,
    isMedium = _a.isMedium,
    carouselVariant = _a.carouselVariant,
    getClickedSlideIndex = _a.getClickedSlideIndex,
    enablePinchZoom = _a.enablePinchZoom,
    _b = _a.ecRenewal,
    ecRenewal = _b === void 0 ? false : _b;
  var validChildren = Children.toArray(children);
  var limit = placeholder ? Math.max(MIN_LIMIT, Math.ceil(displayCount) * 2) : -1;
  var lowerBound = limit >= 0 ? currentIndex - limit : 0;
  var upperBound = limit >= 0 ? currentIndex + Math.ceil(displayCount) + limit : validChildren.length;
  var slideStyle = {
    width: isInBrowser$1() ? slideWidth + 'px' : '100%'
  };
  var firstSlide = {
    width: slideWidth + (noPadding ? 0 : PADDING_MOBILE) + 'px'
  };
  var firstSlideImagePlusText = {
    paddingLeft: isMedium ? PADDING_IPAD : isMobile ? PADDING_MOBILE : 0 + 'px',
    marginLeft: isMedium ? -PADDING_IPAD : isMobile ? -PADDING_MOBILE : 0 + 'px',
    width: slideWidth + (isMedium ? PADDING_IPAD : isMobile ? PADDING_MOBILE : 0) + 'px'
  };
  var lastSlideImagePlusText = {
    width: isInBrowser$1() ? slideWidth + 'px' : '100%',
    marginRight: isMedium ? PADDING_IPAD : isMobile ? PADDING_MOBILE : 0 + 'px'
  };
  var handleClick = function handleClick(index) {
    if (getClickedSlideIndex) {
      getClickedSlideIndex(index);
    }
  };
  var slides = validChildren.map(function (child, index) {
    var key = isOfType(child, 'key') && child.key;
    return /*#__PURE__*/createElement("li", __assign$1({
      key: key || index,
      style: carouselVariant && carouselVariant === 'media-gallery' ? slideStyle : index === 0 && displayCount !== 1 && isMobile && !ecRenewal && (carouselVariant === 'default' || carouselVariant === 'styling') ? firstSlide : index === 0 && carouselVariant === 'ecRenewal' || index === 0 && ecRenewal && carouselVariant === 'styling' ? firstSlideImagePlusText : index === validChildren.length - 1 && carouselVariant === 'ecRenewal' || index === validChildren.length - 1 && ecRenewal && carouselVariant === 'styling' ? lastSlideImagePlusText : slideStyle,
      className: joinClasses(noPadding ? styles$z.carouselSlide : styles$z.carouselSlidePadded, carouselVariant === 'styling' && !ecRenewal && styles$z.carouselSlideStylingVariantSm)
    }, enablePinchZoom && {
      onClick: function onClick() {
        return handleClick(index);
      }
    }), /*#__PURE__*/createElement("div", {
      className: styles$z.carouselSlideContainer
    }, index >= lowerBound && index <= upperBound ? child : placeholder));
  });
  return /*#__PURE__*/createElement(Fragment, null, slides);
};
CarouselSlides.displayName = 'CoreCarouselSlides';

var styles$A = {"overlay-backdrop":"fr-ec-overlay-backdrop","overlayBackdrop":"fr-ec-overlay-backdrop","overlayEase":"fr-ec-overlayEase","overlay-wrapper":"fr-ec-overlay-wrapper","overlayWrapper":"fr-ec-overlay-wrapper"};

var OverlayBackdrop = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
    props = __rest$1(_a, ["className"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$A.overlayBackdrop, className)
  }, props, {
    ref: ref
  }));
});
OverlayBackdrop.displayName = 'CoreOverlayBackdrop';

var HintError = function HintError(_a) {
  var _b = _a.element,
    element = _b === void 0 ? 'p' : _b,
    errorProp = _a.error,
    hint = _a.hint,
    className = _a.className,
    _c = _a.disabled,
    disabled = _c === void 0 ? false : _c,
    _d = _a.textAlign,
    textAlign = _d === void 0 ? 'left' : _d,
    _e = _a.wordBreak,
    wordBreak = _e === void 0 ? 'none' : _e,
    props = __rest$1(_a, ["element", "error", "hint", "className", "disabled", "textAlign", "wordBreak"]);
  var error = disabled ? undefined : errorProp;
  var color = error ? 'error' : 'secondary';
  return /*#__PURE__*/createElement(HintText, __assign$1({
    element: element,
    className: joinClasses(addWordBreak(wordBreak === 'break-word'), className)
  }, props, {
    color: disabled ? 'disabled' : color,
    textAlign: textAlign
  }), error ? error : hint);
};
HintError.displayName = 'CoreHintError';

var styles$B = {"checkbox-group":"fr-ec-checkbox-group","checkboxGroup":"fr-ec-checkbox-group","checkbox-group__legend":"fr-ec-checkbox-group__legend","checkboxGroupLegend":"fr-ec-checkbox-group__legend","checkbox-group__checkbox-wrapper_margin-bottom":"fr-ec-checkbox-group__checkbox-wrapper_margin-bottom","checkboxGroupCheckboxWrapperMarginBottom":"fr-ec-checkbox-group__checkbox-wrapper_margin-bottom","checkbox-group__checkboxes":"fr-ec-checkbox-group__checkboxes","checkboxGroupCheckboxes":"fr-ec-checkbox-group__checkboxes","checkbox-group__required-badge":"fr-ec-checkbox-group__required-badge","checkboxGroupRequiredBadge":"fr-ec-checkbox-group__required-badge","lang-ja":"fr-ec-lang-ja","langJa":"fr-ec-lang-ja","checkbox-group__checkbox-wrapper":"fr-ec-checkbox-group__checkbox-wrapper","checkboxGroupCheckboxWrapper":"fr-ec-checkbox-group__checkbox-wrapper","checkbox-group__hint-text":"fr-ec-checkbox-group__hint-text","checkboxGroupHintText":"fr-ec-checkbox-group__hint-text"};

var CheckboxGroup = function CheckboxGroup(_a) {
  var id = _a.id,
    legend = _a.legend,
    error = _a.error,
    hint = _a.hint,
    children = _a.children,
    required = _a.required,
    className = _a.className,
    _b = _a.columnCount,
    columnCount = _b === void 0 ? 1 : _b,
    props = __rest$1(_a, ["id", "legend", "error", "hint", "children", "required", "className", "columnCount"]);
  var _c = useState(getCurrentMediaQueryBreakpoint()),
    breakpoint = _c[0],
    setBreakPointValue = _c[1];
  var hintErrorId = error || hint ? "".concat(id, "-hint-error") : undefined;
  var checkboxes = React__default.Children.map(children, function (child) {
    if (child.props !== undefined) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: "checkbox-".concat(child.props.id),
        className: joinClasses(styles$B.checkboxGroupCheckboxWrapper, !(hint || error) && styles$B.checkboxGroupCheckboxWrapperMarginBottom)
      }, child);
    }
    return null;
  });
  var onWindowSize = debounce(100, function (_) {
    setBreakPointValue(getCurrentMediaQueryBreakpoint());
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onWindowSize);
    }
    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', onWindowSize);
      }
    };
  }, []);
  var columnCountProp = Math.max(typeof columnCount === 'number' ? columnCount : columnCount[breakpoint], 1);
  return /*#__PURE__*/React__default.createElement("fieldset", __assign$1({
    id: id,
    className: joinClasses(styles$B.checkboxGroup, resetStyles.fieldsetReset, className),
    "aria-describedby": hintErrorId
  }, props), legend && (/*#__PURE__*/React__default.createElement(Title, {
    element: "legend",
    variant: "standard",
    className: styles$B.checkboxGroupLegend
  }, legend, required && /*#__PURE__*/React__default.createElement("span", {
    className: styles$B.checkboxGroupRequiredBadge
  }))), columnCountProp === 1 ? checkboxes : /*#__PURE__*/React__default.createElement("div", {
    className: styles$B.checkboxGroupCheckboxes
  }, checkboxes), hint || error ? typeof hint !== 'string' && !error ? hint === null || hint === void 0 ? void 0 : hint.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(HintError, {
      className: styles$B.checkboxGroupHintText,
      key: index,
      hint: item,
      id: hintErrorId
    });
  }) : (/*#__PURE__*/React__default.createElement(HintError, {
    error: error,
    hint: hint,
    id: hintErrorId
  })) : null);
};
CheckboxGroup.displayName = 'CoreCheckboxGroup';
CheckboxGroup.defaultProps = {
  error: '',
  hint: '',
  required: false
};

var _line, _line2;
var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var SvgStrikethrough = function SvgStrikethrough(_ref) {
  var title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), title ? /*#__PURE__*/React__default.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React__default.createElement("line", {
    y1: "100%",
    x2: "100%",
    stroke: "#DADADA"
  })), _line2 || (_line2 = /*#__PURE__*/React__default.createElement("line", {
    y1: "100%",
    x2: "100%",
    stroke: "#1B1B1B",
    strokeOpacity: 0.6,
    transform: "translate(.5 .5)"
  })));
};

var styles$C = {"chip":"fr-ec-chip","chip__default-image":"fr-ec-chip__default-image","chipDefaultImage":"fr-ec-chip__default-image","chip--short":"fr-ec-chip--short","chipShort":"fr-ec-chip--short","chip--default":"fr-ec-chip--default","chipDefault":"fr-ec-chip--default","chip--long-text":"fr-ec-chip--long-text","chipLongText":"fr-ec-chip--long-text","chip--long":"fr-ec-chip--long","chipLong":"fr-ec-chip--long","chip--product-tile":"fr-ec-chip--product-tile","chipProductTile":"fr-ec-chip--product-tile","chip--ec-renewal":"fr-ec-chip--ec-renewal","chipEcRenewal":"fr-ec-chip--ec-renewal","chip__label-text":"fr-ec-chip__label-text","chipLabelText":"fr-ec-chip__label-text","chip__input":"fr-ec-chip__input","chipInput":"fr-ec-chip__input","chip__input--product-tile":"fr-ec-chip__input--product-tile","chipInputProductTile":"fr-ec-chip__input--product-tile","chip__label":"fr-ec-chip__label","chipLabel":"fr-ec-chip__label","chip__label--long-text":"fr-ec-chip__label--long-text","chipLabelLongText":"fr-ec-chip__label--long-text","chip__label--long":"fr-ec-chip__label--long","chipLabelLong":"fr-ec-chip__label--long","chip__label--product-tile":"fr-ec-chip__label--product-tile","chipLabelProductTile":"fr-ec-chip__label--product-tile","chip__label--default":"fr-ec-chip__label--default","chipLabelDefault":"fr-ec-chip__label--default","chip__input--with-icon":"fr-ec-chip__input--with-icon","chipInputWithIcon":"fr-ec-chip__input--with-icon","chip__label--short":"fr-ec-chip__label--short","chipLabelShort":"fr-ec-chip__label--short","chip__input--disabled":"fr-ec-chip__input--disabled","chipInputDisabled":"fr-ec-chip__input--disabled","chip__label--with-image":"fr-ec-chip__label--with-image","chipLabelWithImage":"fr-ec-chip__label--with-image","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","chip__input--product-tile-selected":"fr-ec-chip__input--product-tile-selected","chipInputProductTileSelected":"fr-ec-chip__input--product-tile-selected","chip__strikethrough":"fr-ec-chip__strikethrough","chipStrikethrough":"fr-ec-chip__strikethrough","chip__strikethrough--default":"fr-ec-chip__strikethrough--default","chipStrikethroughDefault":"fr-ec-chip__strikethrough--default","chip__strikethrough--short":"fr-ec-chip__strikethrough--short","chipStrikethroughShort":"fr-ec-chip__strikethrough--short","chip__strikethrough--long":"fr-ec-chip__strikethrough--long","chipStrikethroughLong":"fr-ec-chip__strikethrough--long","chip__strikethrough--product-tile":"fr-ec-chip__strikethrough--product-tile","chipStrikethroughProductTile":"fr-ec-chip__strikethrough--product-tile","chip__default-icon-container":"fr-ec-chip__default-icon-container","chipDefaultIconContainer":"fr-ec-chip__default-icon-container","chip__label-disabled":"fr-ec-chip__label-disabled","chipLabelDisabled":"fr-ec-chip__label-disabled"};

var Chip = /** @class */function (_super) {
  __extends(Chip, _super);
  function Chip(props) {
    var _this = _super.call(this, props) || this;
    _this.handleImageErrored = function (event) {
      var noImage = _this.props.noImage;
      if (isInBrowser() && window.onMediaError && typeof window.onMediaError === 'function') {
        window.onMediaError(event, _this.state.imageUrl);
      }
      if (noImage && event.currentTarget.src !== noImage) {
        _this.setState({
          imageUrl: noImage
        });
      } else {
        _this.setState({
          bgColor: true
        });
      }
    };
    _this.state = {
      bgColor: false,
      imageUrl: props.image
    };
    return _this;
  }
  Chip.prototype.render = function () {
    var _a = this.props,
      _b = _a.ecRenewal,
      ecRenewal = _b === void 0 ? false : _b,
      image = _a.image,
      _c = _a.variant,
      variant = _c === void 0 ? 'default' : _c,
      label = _a.label,
      _d = _a.unavailable,
      unavailable = _d === void 0 ? false : _d,
      type = _a.type,
      name = _a.name,
      _e = _a.className,
      className = _e === void 0 ? '' : _e,
      _f = _a.disabled,
      disabled = _f === void 0 ? false : _f,
      icon = _a.icon,
      onChange = _a.onChange,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      selected = _a.selected,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      iconBrand = _a.iconBrand,
      props = __rest$1(_a, ["ecRenewal", "image", "variant", "noImage", "label", "unavailable", "type", "name", "id", "className", "disabled", "icon", "onChange", "gaCategory", "gaLabel", "gaValue", "selected", "onMouseEnter", "onMouseLeave", "iconBrand"]);
    var isDisabled = disabled || !label && !image && !icon;
    var withImageClassName = this.props.image ? styles$C.chipLabelWithImage : '';
    var disabledStyles = isDisabled ? styles$C.chipInputDisabled : '';
    var disabledLabelStyles = isDisabled ? styles$C.chipLabelDisabled : '';
    var productTileStyles = variant === 'product-tile' ? styles$C.chipInputProductTile : '';
    var isCheckedProductTile = !isDisabled && variant === 'product-tile' && this.props.checked ? styles$C.chipInputProductTileSelected : '';
    var inputId = this.props.id;
    var labelId = "".concat(inputId, "-label");
    var chipLabel = this.props.unavailable ? "".concat(this.props.label, " (unavailable)") : this.props.label;
    var gaProps = {};
    var isLongText = !icon && variant === 'default' && label.length > 3;
    if (gaCategory && gaLabel) {
      gaProps = {
        'data-category': gaCategory,
        'data-label': gaLabel
      };
      if (gaValue) {
        gaProps['data-value'] = gaValue;
      }
    }
    return /*#__PURE__*/createElement("div", __assign$1({
      className: joinClasses(styles$C.chip, styles$C["chip--".concat(variant)], ecRenewal && styles$C.chipEcRenewal, isLongText && styles$C.chipLongText, className)
    }, gaProps), image ? (/*#__PURE__*/createElement("img", {
      className: styles$C.chipDefaultImage,
      src: this.state.imageUrl,
      onError: this.handleImageErrored,
      alt: "default image"
    })) : null, /*#__PURE__*/createElement("input", __assign$1({
      className: joinClasses(styles$C.chipInput, icon && styles$C.chipInputWithIcon, disabledStyles, interactionsStyles.cursorPointer, productTileStyles, isCheckedProductTile),
      id: inputId,
      type: type,
      name: name,
      "aria-label": chipLabel,
      disabled: isDisabled,
      onChange: onChange,
      checked: selected,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, props)), /*#__PURE__*/createElement(Label, {
      element: "label",
      variant: "standard",
      id: labelId,
      color: "secondary",
      className: joinClasses(styles$C.chipLabel, styles$C["chip__label--".concat(variant)], withImageClassName, typographyStyles.chipStandard, isLongText && styles$C.chipLabelLongText, disabledLabelStyles),
      style: this.state.bgColor ? {
        backgroundColor: '#DADADA'
      } : {
        backgroundImage: image ? "url(".concat(this.state.imageUrl, ")") : undefined
      }
    }, !ecRenewal && (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$C.chipStrikethrough, styles$C["chip__strikethrough--".concat(variant)]),
      hidden: !unavailable
    }, /*#__PURE__*/createElement(SvgStrikethrough, {
      width: "100%",
      height: "100%"
    }))), icon ? (/*#__PURE__*/createElement("div", {
      className: styles$C.chipDefaultIconContainer
    }, /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand).concat(icon) : icon
    }))) : image ? null : (/*#__PURE__*/createElement("p", {
      className: styles$C.chipLabelText
    }, label))));
  };
  Chip.displayName = 'CoreChip';
  Chip.defaultProps = {
    disabled: false,
    unavailable: false,
    ecRenewal: false
  };
  return Chip;
}(Component);

var styles$D = {"flag-text":"fr-ec-flag-text","flagText":"fr-ec-flag-text","flag-text--color-secondary":"fr-ec-flag-text--color-secondary","flagTextColorSecondary":"fr-ec-flag-text--color-secondary","flag-text--color-promotional":"fr-ec-flag-text--color-promotional","flagTextColorPromotional":"fr-ec-flag-text--color-promotional","flag-text--color-placeholder":"fr-ec-flag-text--color-placeholder","flagTextColorPlaceholder":"fr-ec-flag-text--color-placeholder","flag-text--color-primary-dark":"fr-ec-flag-text--color-primary-dark","flagTextColorPrimaryDark":"fr-ec-flag-text--color-primary-dark","flag-text--color-primary-light":"fr-ec-flag-text--color-primary-light","flagTextColorPrimaryLight":"fr-ec-flag-text--color-primary-light"};

var alignmentClass$5 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var FlagText = function FlagText(_a) {
  var Element = _a.element,
    className = _a.className,
    _b = _a.variant,
    variant = _b === void 0 ? 'standard' : _b,
    _c = _a.textAlign,
    textAlign = _c === void 0 ? 'left' : _c,
    _d = _a.color,
    color = _d === void 0 ? 'secondary' : _d,
    _e = _a.textTransform,
    textTransform = _e === void 0 ? 'normal' : _e,
    _f = _a.wordBreak,
    wordBreak = _f === void 0 ? 'none' : _f,
    strikethrough = _a.strikethrough,
    props = __rest$1(_a, ["element", "className", "variant", "textAlign", "color", "textTransform", "wordBreak", "strikethrough"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$D.flagText, typographyStyles["flag--".concat(variant)], textAlignStyles[alignmentClass$5[textAlign]], color && styles$D["flag-text--color-".concat(color)], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props));
};
FlagText.displayName = 'CoreFlagText';

var styles$E = {"chip-group":"fr-ec-chip-group","chipGroup":"fr-ec-chip-group","chip-group__legend":"fr-ec-chip-group__legend","chipGroupLegend":"fr-ec-chip-group__legend","chip-group-product-tile-er":"fr-ec-chip-group-product-tile-er","chipGroupProductTileEr":"fr-ec-chip-group-product-tile-er","chip-group__value":"fr-ec-chip-group__value","chipGroupValue":"fr-ec-chip-group__value","chip-group__chips":"fr-ec-chip-group__chips","chipGroupChips":"fr-ec-chip-group__chips","chip-group__chips--bottom-spacing":"fr-ec-chip-group__chips--bottom-spacing","chipGroupChipsBottomSpacing":"fr-ec-chip-group__chips--bottom-spacing","chip":"fr-ec-chip","chip-group__extra":"fr-ec-chip-group__extra","chipGroupExtra":"fr-ec-chip-group__extra","collection-list-horizontal--swipeable":"fr-ec-collection-list-horizontal--swipeable","collectionListHorizontalSwipeable":"fr-ec-collection-list-horizontal--swipeable","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","chip-group-product-tile-er__chip-hidden":"fr-ec-chip-group-product-tile-er__chip-hidden","chipGroupProductTileErChipHidden":"fr-ec-chip-group-product-tile-er__chip-hidden","chip-group-product-tile-er__chip":"fr-ec-chip-group-product-tile-er__chip","chipGroupProductTileErChip":"fr-ec-chip-group-product-tile-er__chip","chip-group-product-tile-er__fieldset":"fr-ec-chip-group-product-tile-er__fieldset","chipGroupProductTileErFieldset":"fr-ec-chip-group-product-tile-er__fieldset","chip-group-product-tile-er__toggle-button-icon":"fr-ec-chip-group-product-tile-er__toggle-button-icon","chipGroupProductTileErToggleButtonIcon":"fr-ec-chip-group-product-tile-er__toggle-button-icon","chip-group-product-tile-er__button-wrapper":"fr-ec-chip-group-product-tile-er__button-wrapper","chipGroupProductTileErButtonWrapper":"fr-ec-chip-group-product-tile-er__button-wrapper","chip-group-product-tile-er__toggle-button":"fr-ec-chip-group-product-tile-er__toggle-button","chipGroupProductTileErToggleButton":"fr-ec-chip-group-product-tile-er__toggle-button","collection-list-horizontal--mid":"fr-ec-collection-list-horizontal--mid","collectionListHorizontalMid":"fr-ec-collection-list-horizontal--mid","collection-list-horizontal":"fr-ec-collection-list-horizontal","collectionListHorizontal":"fr-ec-collection-list-horizontal","chip-group-variant-long":"fr-ec-chip-group-variant-long","chipGroupVariantLong":"fr-ec-chip-group-variant-long","collection-list-horizontal--initial-padding":"fr-ec-collection-list-horizontal--initial-padding","collectionListHorizontalInitialPadding":"fr-ec-collection-list-horizontal--initial-padding","chip-group__label":"fr-ec-chip-group__label","chipGroupLabel":"fr-ec-chip-group__label"};

var ChipGroup = function ChipGroup(_a) {
  var _b = _a.ecRenewal,
    ecRenewal = _b === void 0 ? false : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'productSelector' : _c,
    label = _a.label,
    legend = _a.legend,
    value = _a.value,
    hoverValue = _a.hoverValue,
    error = _a.error,
    id = _a.id,
    children = _a.children,
    className = _a.className,
    topRightContent = _a.topRightContent,
    gaCategory = _a.gaCategory,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    iconBrand = _a.iconBrand,
    _d = _a.swipeable,
    swipeable = _d === void 0 ? {
      sm: true,
      md: false,
      lg: false
    } : _d,
    props = __rest$1(_a, ["ecRenewal", "variant", "label", "legend", "value", "hoverValue", "error", "id", "children", "className", "topRightContent", "gaCategory", "gaLabel", "gaValue", "iconBrand", "swipeable"]);
  var hintErrorId = "".concat(id, "-hint-error");
  var chipWithMargin = productTileERChipWidth + productTileERChipMargin;
  var _e = useState({
      height: -1,
      width: -1
    }),
    chipGroupDimensions = _e[0],
    setChipGroupDimensions = _e[1];
  var _f = useState(0),
    activeChipIndex = _f[0],
    setActiveChipIndex = _f[1];
  var chipCount = Children.toArray(children).length;
  var doChipsOverflowGroup = function doChipsOverflowGroup(chipCount, chipWidth, chipGroupWidth) {
    return chipCount * chipWidth > chipGroupWidth;
  };
  var isOverflowing = doChipsOverflowGroup(chipCount, chipWithMargin, Math.floor(chipGroupDimensions.width));
  var doesChipOverflowGroup = function doesChipOverflowGroup(isOverflowing, i, chipGroupDimensions) {
    return isOverflowing && i >= Math.floor((Math.floor(chipGroupDimensions.width) - 16) / chipWithMargin);
  };
  var shouldHideChip = function shouldHideChip(isOverflowing, i, chipGroupDimensions) {
    return doesChipOverflowGroup(isOverflowing, i, chipGroupDimensions);
  };
  var chipChildren = Children.toArray(children).map(function (chip, i) {
    var chipHidden = shouldHideChip(isOverflowing, i, chipGroupDimensions);
    var hideChipClass = chipHidden ? styles$E.chipGroupProductTileErChipHidden : '';
    return /*#__PURE__*/cloneElement(chip, {
      className: joinClasses(chip.props.className, styles$E.chipGroupProductTileErChip, hideChipClass),
      disabled: true,
      hidden: chipHidden,
      variant: 'product-tile'
    });
  });
  var onResize = function onResize(contentRect) {
    if (isOfType(contentRect.bounds, 'height')) {
      var _a = contentRect.bounds,
        height = _a.height,
        width = _a.width;
      setChipGroupDimensions({
        height: height,
        width: width
      });
    }
  };
  var gaProps = {};
  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var curValue = hoverValue || value;
  if (variant === 'productTile' && ecRenewal) {
    return /*#__PURE__*/createElement(Measure, {
      bounds: true,
      onResize: debounce(100, onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", __assign$1({
        ref: measureRef,
        className: joinClasses(styles$E.chipGroupProductTileEr, ecRenewal && className)
      }, gaProps, props), /*#__PURE__*/createElement("div", {
        className: styles$E.chipGroupProductTileErButtonWrapper
      }, /*#__PURE__*/createElement("div", {
        hidden: !isOverflowing,
        className: joinClasses(styles$E.chipGroupProductTileErToggleButton, resetStyles.buttonReset)
      }, /*#__PURE__*/createElement(Icon, {
        name: iconBrand ? "".concat(iconBrand, "plus") : 'plus',
        className: styles$E.chipGroupProductTileErToggleButtonIcon
      }))), /*#__PURE__*/createElement("fieldset", {
        id: id,
        className: joinClasses(styles$E.chipGroupProductTileErFieldset, resetStyles.fieldsetReset)
      }, chipChildren));
    });
  }
  var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
    if (child.props.type === 'radio' && child.props.selected && index !== activeChipIndex) {
      setActiveChipIndex(index);
    }
    return /*#__PURE__*/cloneElement(child);
  });
  var getChilds = Children.toArray(children).filter(isValidElement);
  var _g = getChilds[0].props,
    icon = _g.icon,
    childVariant = _g.variant;
  var isChildLong = getChilds.some(function (child) {
    return child.props.label.length > 3;
  });
  var isLongText = !icon && childVariant === 'default' && isChildLong;
  var _h = useState(getCurrentMediaQueryBreakpoint()),
    breakpoint = _h[0],
    setBreakPointValue = _h[1];
  var onWindowSize = debounce(100, function (_) {
    setBreakPointValue(getCurrentMediaQueryBreakpoint());
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onWindowSize);
    }
    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', onWindowSize);
      }
    };
  }, []);
  var isSwipeable = typeof swipeable === 'boolean' ? swipeable : swipeable[breakpoint];
  return /*#__PURE__*/createElement("fieldset", __assign$1({
    id: id,
    className: joinClasses(styles$E.chipGroup, resetStyles.fieldsetReset, className),
    "aria-describedby": hintErrorId
  }, gaProps, props), !ecRenewal && legend && (/*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    justifyContent: "space-between",
    direction: "row",
    alignment: "center"
  }, /*#__PURE__*/createElement("legend", {
    className: styles$E.chipGroupLegend
  }, /*#__PURE__*/createElement(Label, {
    element: "label",
    variant: "large"
  }, legend, ":"), /*#__PURE__*/createElement(Label, {
    element: "label",
    variant: "large",
    className: styles$E.chipGroupValue
  }, curValue)), topRightContent && /*#__PURE__*/createElement("div", {
    className: styles$E.chipGroupExtra
  }, topRightContent))), ecRenewal && variant === 'productSelector' ? (/*#__PURE__*/createElement(CollectionListHorizontal, {
    alignment: "center",
    divider: false,
    spacingValue: "12",
    swipeable: swipeable,
    initialSlide: activeChipIndex,
    style: {
      paddingTop: '4px'
    }
  }, childrenWithProps)) : variant === 'productSelector' && !isLongText ? (/*#__PURE__*/createElement(CollectionListHorizontal, {
    className: childVariant === 'long' ? styles$E.chipGroupVariantLong : '',
    alignment: "center",
    divider: false,
    spacingValue: "12"
  }, children)) : (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$E.chipGroupChips, styles$E.chipGroupChipsBottomSpacing)
  }, children)), label && (typeof label === 'string' ? (/*#__PURE__*/createElement(FlagText, {
    variant: "standard",
    element: "p",
    className: joinClasses(ecRenewal && isSwipeable && styles$E.chipGroupLabel, spacingStyles.mtSpacing02)
  }, label)) : (/*#__PURE__*/createElement("div", {
    className: joinClasses(ecRenewal && isSwipeable && styles$E.chipGroupLabel, spacingStyles.mtSpacing02)
  }, label))), /*#__PURE__*/createElement(HintError, {
    error: error,
    id: hintErrorId
  }));
};
ChipGroup.displayName = 'CoreChipGroup';

var styles$F = {"chip-group-product-tile":"fr-ec-chip-group-product-tile","chipGroupProductTile":"fr-ec-chip-group-product-tile","chip-group-product-tile__fieldset":"fr-ec-chip-group-product-tile__fieldset","chipGroupProductTileFieldset":"fr-ec-chip-group-product-tile__fieldset","chip-group-product-tile__fieldset--expanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chipGroupProductTileFieldsetExpanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chip--product-tile":"fr-ec-chip--product-tile","chipProductTile":"fr-ec-chip--product-tile","chip-group-product-tile__legend":"fr-ec-chip-group-product-tile__legend","chipGroupProductTileLegend":"fr-ec-chip-group-product-tile__legend","chip-group-product-tile__toggle-button":"fr-ec-chip-group-product-tile__toggle-button","chipGroupProductTileToggleButton":"fr-ec-chip-group-product-tile__toggle-button","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","chip-group-product-tile__toggle-button-icon":"fr-ec-chip-group-product-tile__toggle-button-icon","chipGroupProductTileToggleButtonIcon":"fr-ec-chip-group-product-tile__toggle-button-icon","chip-group-product-tile__chip-hidden":"fr-ec-chip-group-product-tile__chip-hidden","chipGroupProductTileChipHidden":"fr-ec-chip-group-product-tile__chip-hidden","chip-group-product-tile__button-wrapper":"fr-ec-chip-group-product-tile__button-wrapper","chipGroupProductTileButtonWrapper":"fr-ec-chip-group-product-tile__button-wrapper","chip-group-product-tile__chip":"fr-ec-chip-group-product-tile__chip","chipGroupProductTileChip":"fr-ec-chip-group-product-tile__chip"};

var chipWithMargin = productTileChipWidth + productTileChipMargin;
var chipSmallWithMargin = productTileChipSmallWidth + productTileChipSmallMargin;
var ChipGroupProductTile = /** @class */function (_super) {
  __extends(ChipGroupProductTile, _super);
  function ChipGroupProductTile(props) {
    var _this = _super.call(this, props) || this;
    _this.toggleExpanded = function (event) {
      _this.setState({
        expanded: !_this.isExpanded
      });
      if (_this.props.onExpandedToggle) {
        _this.props.onExpandedToggle(!_this.isExpanded, event);
      }
    };
    _this.setChipGroupWidth = function (contentRect) {
      if (isOfType(contentRect.bounds, 'height')) {
        var _a = contentRect.bounds,
          height = _a.height,
          width = _a.width;
        _this.setState({
          chipGroupDimensions: {
            height: height,
            width: width
          }
        });
      }
    };
    _this.doChipsOverflowGroup = function (chipCount, chipWidth, chipGroupWidth) {
      return chipCount * chipWidth > chipGroupWidth - _this.offset;
    };
    _this.shouldHideChip = function (expanded, isOverflowing, i, chipGroupDimensions) {
      return !expanded && _this.doesChipOverflowGroup(isOverflowing, i, chipGroupDimensions);
    };
    _this.state = {
      chipGroupDimensions: {
        height: -1,
        width: -1
      },
      expanded: _this.props.expanded || false
    };
    _this.offset = 2; // An offset value to stop overflow, if there is any margin or border is applied through css
    return _this;
  }
  Object.defineProperty(ChipGroupProductTile.prototype, "isExpanded", {
    get: function get() {
      return this.props.expanded !== undefined ? this.props.expanded : this.state.expanded;
    },
    enumerable: false,
    configurable: true
  });
  ChipGroupProductTile.prototype.doesChipOverflowGroup = function (isOverflowing, i, chipGroupDimensions) {
    var chipWidth = this.props.containerWidth === 'small' ? productTileChipSmallWidth : productTileChipWidth;
    var chipWithMarginWidth = this.props.containerWidth === 'small' ? chipSmallWithMargin : chipWithMargin;
    return isOverflowing && i >= Math.floor((Math.floor(chipGroupDimensions.width) - chipWidth - this.offset) / chipWithMarginWidth);
  };
  ChipGroupProductTile.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      title = _a.title,
      children = _a.children,
      id = _a.id,
      className = _a.className,
      onFocus = _a.onFocus,
      onBlur = _a.onBlur,
      expandButtonAlt = _a.expandButtonAlt,
      collapseButtonAlt = _a.collapseButtonAlt,
      iconBrand = _a.iconBrand,
      _b = _a.enableInteraction,
      enableInteraction = _b === void 0 ? false : _b,
      props = __rest$1(_a, ["title", "children", "id", "className", "onFocus", "onBlur", "expandButtonAlt", "collapseButtonAlt", "expanded", "onExpandedToggle", "iconBrand", "enableInteraction"]);
    var chipGroupDimensions = this.state.chipGroupDimensions;
    var chipCount = children.length;
    var isOverflowing = this.doChipsOverflowGroup(chipCount, chipWithMargin, Math.floor(chipGroupDimensions.width - this.offset));
    var chipChildren = children.map(function (chip, i) {
      var chipHidden = _this.shouldHideChip(_this.isExpanded, isOverflowing, i, chipGroupDimensions);
      var hideChipClass = chipHidden ? styles$F.chipGroupProductTileChipHidden : '';
      return /*#__PURE__*/cloneElement(chip, {
        className: joinClasses(chip.props.className, styles$F.chipGroupProductTileChip, hideChipClass),
        disabled: !enableInteraction,
        hidden: chipHidden,
        variant: 'product-tile'
      });
    });
    var buttonIcon = this.isExpanded ? 'minus' : 'plus';
    var legendId = "".concat(id, "-legend");
    return /*#__PURE__*/createElement(Measure, {
      bounds: true,
      onResize: this.setChipGroupWidth
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", __assign$1({
        ref: measureRef,
        className: joinClasses(styles$F.chipGroupProductTile, className)
      }, props), /*#__PURE__*/createElement("div", {
        className: styles$F.chipGroupProductTileButtonWrapper
      }, /*#__PURE__*/createElement("button", {
        hidden: !isOverflowing,
        className: joinClasses(styles$F.chipGroupProductTileToggleButton, interactionsStyles.cursorPointer, resetStyles.buttonReset),
        onClick: _this.toggleExpanded,
        "aria-expanded": _this.isExpanded,
        "aria-controls": id,
        "aria-describedby": legendId,
        onFocus: onFocus,
        onBlur: onBlur
      }, /*#__PURE__*/createElement(Icon, {
        title: _this.isExpanded ? collapseButtonAlt : expandButtonAlt,
        name: iconBrand ? "".concat(iconBrand).concat(buttonIcon) : buttonIcon,
        className: styles$F.chipGroupProductTileToggleButtonIcon
      }))), /*#__PURE__*/createElement("fieldset", {
        id: id,
        className: joinClasses(styles$F.chipGroupProductTileFieldset, _this.isExpanded ? styles$F.chipGroupProductTileFieldsetExpanded : '', resetStyles.fieldsetReset)
      }, /*#__PURE__*/createElement("legend", {
        id: legendId,
        className: styles$F.chipGroupProductTileLegend
      }, title), chipChildren));
    });
  };
  ChipGroupProductTile.displayName = 'CoreChipGroupProductTile';
  return ChipGroupProductTile;
}(Component);

var styles$G = {"collection-grid-item":"fr-ec-collection-grid-item","collectionGridItem":"fr-ec-collection-grid-item","collection-grid-item--with-keyline":"fr-ec-collection-grid-item--with-keyline","collectionGridItemWithKeyline":"fr-ec-collection-grid-item--with-keyline","collection-grid-item--with-keyline-left":"fr-ec-collection-grid-item--with-keyline-left","collectionGridItemWithKeylineLeft":"fr-ec-collection-grid-item--with-keyline-left","collection-grid-item--with-keyline-top":"fr-ec-collection-grid-item--with-keyline-top","collectionGridItemWithKeylineTop":"fr-ec-collection-grid-item--with-keyline-top","collection-grid-item--with-keyline-right":"fr-ec-collection-grid-item--with-keyline-right","collectionGridItemWithKeylineRight":"fr-ec-collection-grid-item--with-keyline-right","collection-grid-item--with-keyline-bottom":"fr-ec-collection-grid-item--with-keyline-bottom","collectionGridItemWithKeylineBottom":"fr-ec-collection-grid-item--with-keyline-bottom","collection-grid-item-contents":"fr-ec-collection-grid-item-contents","collectionGridItemContents":"fr-ec-collection-grid-item-contents"};

var getBorderClasses = function getBorderClasses(rowIndex, colIndex) {
  return joinClasses(styles$G.collectionGridItemWithKeyline, colIndex > 0 && styles$G.collectionGridItemWithKeylineLeft, rowIndex > 0 && styles$G.collectionGridItemWithKeylineTop);
};
var CollectionGridItem = function CollectionGridItem(_a) {
  var children = _a.children,
    rowIndex = _a.rowIndex,
    colIndex = _a.colIndex,
    inlineStyles = _a.inlineStyles,
    margin = _a.margin,
    withKeyline = _a.withKeyline;
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$G.collectionGridItem),
    style: __assign$1({}, inlineStyles)
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$G.collectionGridItemContents, withKeyline && getBorderClasses(rowIndex, colIndex)),
    style: {
      margin: margin
    }
  }, children));
};
CollectionGridItem.displayName = 'CoreCollectionGridItem';

var styles$H = {"collection-grid":"fr-ec-collection-grid","collectionGrid":"fr-ec-collection-grid"};

var CollectionGridItemManager = /** @class */function () {
  function CollectionGridItemManager(columns, rowHeightDecimal, spacingInfo) {
    var _this = this;
    // Create a new empty row with length = columns
    this.getNewRow = function () {
      return new Array(_this.columns).fill(-1);
    };
    // Add the specified number of empty rows to the row matrix
    this.addRows = function (amount) {
      _this.rows = __spreadArray(__spreadArray([], _this.rows, true), count(amount).map(function (_) {
        return _this.getNewRow();
      }), true);
    };
    // Updates the row matrix with the slots taken up by the new item
    this.updateRows = function (columnIndex, rowIndex, colSpan, rowSpan) {
      _this.rows = _this.rows.map(function (row, index) {
        var startRow = index === rowIndex;
        var spannedRow = rowSpan > 1 && index > rowIndex && index < rowIndex + rowSpan;
        return startRow || spannedRow ? __spreadArray([], row.fill(1, columnIndex, columnIndex + colSpan), true) : __spreadArray([], row, true);
      });
    };
    /**
     * Determines where the item can fit, given its row- and col-span
     * This method will iterate through the row matrix to find a row with
     * a slot >= colSpan.
     * Then it checks how many new rows must be added to the row matrix
     * to accomodate the item, adds the required number of rows, and marks
     * the required slots as filled.
     */
    this.positionItem = function (colSpan, rowSpan) {
      var freeSlotIndex = 0;
      // Find first existing row with a slot big enough for the items colSpan
      var rowIndex = _this.rows.findIndex(function (row, index) {
        var _a = _this.findLongestFreeSlot(row),
          localFreeSlotIndex = _a.freeSlotIndex,
          globalSum = _a.globalSum;
        freeSlotIndex = localFreeSlotIndex;
        var isRowSpanFree = true;
        if (globalSum >= colSpan && rowSpan > 1) {
          isRowSpanFree = __spreadArray([], _this.rows.slice(index + 1, index + rowSpan), true).map(function (nextRow) {
            return __spreadArray([], nextRow.slice(freeSlotIndex, freeSlotIndex + colSpan), true).every(function (item) {
              return item < 0;
            });
          }).every(function (rowHasFreeSlot) {
            return rowHasFreeSlot === true;
          });
        }
        return globalSum >= colSpan && isRowSpanFree;
      });
      var remainingRowCount = _this.rows.length - rowIndex;
      // If no existing row found, add the required number of rows (as per rowSpan)
      if (rowIndex < 0) {
        rowIndex = _this.rows.length;
        _this.addRows(rowSpan);
        freeSlotIndex = 0;
      } else if (rowSpan > remainingRowCount) {
        // If there is space in an exisiting make sure there are enough rows to accommodate the items rowSpan
        _this.addRows(rowSpan - remainingRowCount);
      }
      // Update the row matrix
      _this.updateRows(freeSlotIndex, rowIndex, colSpan, rowSpan);
      return {
        rowIndex: rowIndex,
        freeSlotIndex: freeSlotIndex
      };
    };
    // Iterate through the row to find the longest, consecutive run of empty slots
    this.findLongestFreeSlot = function (row) {
      return row.reduce(function (_a, item, index) {
        var freeSlotIndex = _a.freeSlotIndex,
          localSum = _a.localSum,
          globalSum = _a.globalSum;
        return item < 0 ? {
          freeSlotIndex: localSum + 1 > globalSum ? index - localSum : freeSlotIndex,
          globalSum: Math.max(globalSum, localSum + 1),
          localSum: localSum + 1
        } : {
          freeSlotIndex: freeSlotIndex,
          localSum: 0,
          globalSum: globalSum
        };
      }, {
        freeSlotIndex: -1,
        globalSum: 0,
        localSum: 0
      });
    };
    /**
     * Calculates the position and size of a grid item given it's row- and col-span, starting
     * col index, and starting row index
     */
    this.calculateItemStyles = function (colSpan, rowSpan, colIndex, rowIndex) {
      var _a = _this.spacingInfo,
        spacingValue = _a.spacingValue,
        spacingUnits = _a.spacingUnits;
      return {
        left: _this.calculateLeftValue(colIndex, spacingValue, spacingUnits),
        marginTop: _this.calculateMarginTopValue(rowIndex, spacingValue, spacingUnits),
        paddingTop: _this.calculatePaddingTopValue(rowSpan),
        width: _this.calculateWidthValue(colSpan, spacingValue, spacingUnits)
      };
    };
    /**
     * Calculates the left value for a grid item given it's col index.
     * Optionally takes spacing in to account.
     */
    this.calculateLeftValue = function (colIndex, spacingValue, spacingUnits) {
      return spacingValue && spacingValue > 0 ? "calc(".concat(_this.calculateBaseLeftValue(colIndex), " - ").concat(spacingValue / 2).concat(spacingUnits, " + ").concat(spacingValue / _this.columns * colIndex).concat(spacingUnits, ")") : _this.calculateBaseLeftValue(colIndex);
    };
    /**
     * Calculates the margin-top for a grid item given it's row index.
     */
    this.calculateBaseMarginTopValue = function (rowIndex) {
      return "".concat(rowIndex / _this.columns * _this.rowHeightDecimal * 100, "%");
    };
    /**
     * Calculates the width of a grid item given it's col-span.
     */
    this.calculateBaseWidthValue = function (colSpan) {
      return "".concat(colSpan / _this.columns * 100, "%");
    };
    /**
     * Calculates the left value for a grid item given it's col index.
     */
    this.calculateBaseLeftValue = function (colIndex) {
      return "".concat(colIndex / _this.columns * 100, "%");
    };
    /**
     * Calculates the width of a grid item given it's col-span.
     * Optionally takes spacing in to account.
     */
    this.calculateWidthValue = function (colSpan, spacingValue, spacingUnits) {
      return spacingValue && spacingValue > 0 ? "calc(".concat(_this.calculateBaseWidthValue(colSpan), " + ").concat(spacingValue / _this.columns * colSpan).concat(spacingUnits, ")") : _this.calculateBaseWidthValue(colSpan);
    };
    /**
     * Calculates the padding-top (i.e. height) of a grid item given it's row-span.
     */
    this.calculatePaddingTopValue = function (rowSpan) {
      return "".concat(rowSpan / _this.columns * _this.rowHeightDecimal * 100, "%");
    };
    /**
     * Calculates the margin-top for a grid item given it's row index.
     * Optionally takes spacing in to account.
     */
    this.calculateMarginTopValue = function (rowIndex, spacingValue, spacingUnits) {
      return spacingValue && spacingValue > 0 ? "calc(".concat(_this.calculateBaseMarginTopValue(rowIndex), " - ").concat(spacingValue / 2).concat(spacingUnits, ")") : _this.calculateBaseMarginTopValue(rowIndex);
    };
    this.columns = columns;
    this.rowHeightDecimal = rowHeightDecimal;
    this.spacingInfo = spacingInfo;
    // Create the first row of the CollectionGrid
    this.rows = [this.getNewRow()];
  }
  return CollectionGridItemManager;
}();

var parseBreakPointProps = function parseBreakPointProps(gridItems, screenSize) {
  return gridItems.map(function (item) {
    return Object.keys(item).filter(function (key) {
      return key !== 'children';
    }).reduce(function (acc, key) {
      var _a, _b;
      return isOfType(item[key], 'toExponential') ? __assign$1(__assign$1({}, acc), (_a = {}, _a[key] = item[key], _a)) : __assign$1(__assign$1({}, acc), (_b = {}, _b[key] = item[key][screenSize], _b));
    }, {
      children: item.children,
      colSpan: 0,
      rowSpan: 0
    });
  });
};

var STARTING_NUMBER_REGEXP = '^[0-9.]*';
var ENDING_NUMBER_REGEXP = '[0-9.]*$';
var parseRatio = function parseRatio(ratioString) {
  return [ratioString.match(new RegExp(STARTING_NUMBER_REGEXP)), ratioString.match(new RegExp(ENDING_NUMBER_REGEXP))].map(function (item) {
    return Number(item);
  });
};

var ENDING_STRING_REGEXP = '[a-z%]*$';
var parseSpacingProp = function parseSpacingProp(spacingProp) {
  var unitRegExp = spacingProp.match(new RegExp(ENDING_STRING_REGEXP));
  var spacingRegExp = spacingProp.match(new RegExp(STARTING_NUMBER_REGEXP));
  return {
    spacingUnits: unitRegExp ? unitRegExp[0] : undefined,
    spacingValue: spacingRegExp ? Number(spacingRegExp[0]) : undefined
  };
};

var sortGridItems = function sortGridItems(items) {
  return items.map(function (item, index) {
    return {
      index: index,
      item: item
    };
  }).sort(function (_a, _b) {
    var aIndex = _a.index,
      aOrderProp = _a.item.order;
    var bIndex = _b.index,
      bOrderProp = _b.item.order;
    var aOrder = typeof aOrderProp !== 'undefined' ? aOrderProp : aIndex + 0.1;
    var bOrder = typeof bOrderProp !== 'undefined' ? bOrderProp : bIndex + 0.1;
    return aOrder - bOrder;
  }).map(function (indexedItem) {
    return indexedItem.item;
  });
};

var ROW_HEIGHT_FORMAT = '[0-9]:[0-9]';
var createCollectionGridItem = function createCollectionGridItem(_a, rowMonitor, withKeyline) {
  var colSpan = _a.colSpan,
    rowSpan = _a.rowSpan,
    children = _a.children;
  var _b = rowMonitor.positionItem(colSpan, rowSpan),
    rowIndex = _b.rowIndex,
    colIndex = _b.freeSlotIndex;
  var gridItemStyles = rowMonitor.calculateItemStyles(colSpan, rowSpan, colIndex, rowIndex);
  var _c = rowMonitor.spacingInfo,
    spacingValue = _c.spacingValue,
    spacingUnits = _c.spacingUnits;
  var margin = spacingValue && spacingValue > 0 ? "".concat(spacingValue / 2).concat(spacingUnits) : undefined;
  var gridItemComponent = /*#__PURE__*/createElement(CollectionGridItem, {
    key: "row-".concat(rowIndex, "-col-").concat(colIndex),
    rowIndex: rowIndex,
    colIndex: colIndex,
    inlineStyles: gridItemStyles,
    margin: margin,
    withKeyline: withKeyline
  }, children);
  return gridItemComponent;
};
var CollectionGrid = function CollectionGrid(_a) {
  var className = _a.className,
    columns = _a.columns,
    gridItems = _a.gridItems,
    _b = _a.spacing,
    spacing = _b === void 0 ? '' : _b,
    withKeyline = _a.withKeyline,
    _c = _a.rowHeight,
    rowHeight = _c === void 0 ? '1:1' : _c,
    props = __rest$1(_a, ["className", "columns", "gridItems", "spacing", "withKeyline", "rowHeight"]);
  var screenSize = getCurrentMediaQueryBreakpoint();
  var parsedColumns = typeof columns === 'number' ? columns : columns[screenSize];
  var parsedGridItems = parseBreakPointProps(gridItems, screenSize);
  var sortedGridItems = sortGridItems(parsedGridItems);
  var spacingParsed = typeof spacing === 'string' ? spacing : spacing[screenSize];
  var rowHeightParsed = typeof rowHeight === 'string' ? rowHeight : rowHeight[screenSize];
  var withKeylineParsed = typeof withKeyline === 'boolean' ? withKeyline : withKeyline && withKeyline[screenSize];
  // Check if colSpan > columns, throw error if true
  if (sortedGridItems.some(function (item) {
    return item.colSpan > columns;
  })) {
    throw new Error('CollectionGridItem.colSpan cannot be > CollectionGrid columns');
  }
  if (rowHeightParsed.match(new RegExp(ROW_HEIGHT_FORMAT)) === null) {
    throw new Error("CollectrionGrid.rowHeight must be in format ".concat(ROW_HEIGHT_FORMAT, ", width:height"));
  }
  var spacingInfo = parseSpacingProp(spacingParsed);
  var spacingValue = spacingInfo.spacingValue,
    spacingUnits = spacingInfo.spacingUnits;
  var _d = parseRatio(rowHeightParsed),
    ratioDenominator = _d[0],
    ratioNumerator = _d[1];
  var rowHeightDecimal = ratioNumerator / ratioDenominator;
  var rowMonitor = new CollectionGridItemManager(parsedColumns, rowHeightDecimal, spacingInfo);
  var children = sortedGridItems.map(function (item) {
    return createCollectionGridItem(item, rowMonitor, withKeylineParsed);
  });
  var collectionGridHeight = spacingValue && spacingValue > 0 ? "calc(".concat(rowMonitor.rows.length / parsedColumns * rowHeightDecimal * 100, "% - ").concat(spacingValue).concat(spacingUnits, ")") : "".concat(rowMonitor.rows.length / parsedColumns * rowHeightDecimal * 100, "%");
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$H.collectionGrid, className),
    style: {
      paddingBottom: collectionGridHeight
    }
  }, props), children);
};
CollectionGrid.displayName = 'CoreCollectionGrid';
CollectionGrid.defaultProps = {
  rowHeight: '1:1',
  spacing: ''
};

var styles$I = {"collection-list":"fr-ec-collection-list","collectionList":"fr-ec-collection-list","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","collection-list__item--spacing":"fr-ec-collection-list__item--spacing","collectionListItemSpacing":"fr-ec-collection-list__item--spacing","collection-list__item-spacing-16":"fr-ec-collection-list__item-spacing-16","collectionListItemSpacing16":"fr-ec-collection-list__item-spacing-16","collection-list__item-spacing-24":"fr-ec-collection-list__item-spacing-24","collectionListItemSpacing24":"fr-ec-collection-list__item-spacing-24","collection-list__item-spacing-32":"fr-ec-collection-list__item-spacing-32","collectionListItemSpacing32":"fr-ec-collection-list__item-spacing-32","collection-list__item--no-keylines-spacing-16":"fr-ec-collection-list__item--no-keylines-spacing-16","collectionListItemNoKeylinesSpacing16":"fr-ec-collection-list__item--no-keylines-spacing-16","collection-list__item--no-keylines-spacing-24":"fr-ec-collection-list__item--no-keylines-spacing-24","collectionListItemNoKeylinesSpacing24":"fr-ec-collection-list__item--no-keylines-spacing-24","collection-list__item--no-keylines-spacing-32":"fr-ec-collection-list__item--no-keylines-spacing-32","collectionListItemNoKeylinesSpacing32":"fr-ec-collection-list__item--no-keylines-spacing-32","collection-list__item--no-keylines-spacing":"fr-ec-collection-list__item--no-keylines-spacing","collectionListItemNoKeylinesSpacing":"fr-ec-collection-list__item--no-keylines-spacing","collection-list__item--keylines-top":"fr-ec-collection-list__item--keylines-top","collectionListItemKeylinesTop":"fr-ec-collection-list__item--keylines-top","collection-list__item--keylines-bottom":"fr-ec-collection-list__item--keylines-bottom","collectionListItemKeylinesBottom":"fr-ec-collection-list__item--keylines-bottom","collection-list__item--keylines-bottom-top":"fr-ec-collection-list__item--keylines-bottom-top","collectionListItemKeylinesBottomTop":"fr-ec-collection-list__item--keylines-bottom-top","collection-list__item--keylines-between-items":"fr-ec-collection-list__item--keylines-between-items","collectionListItemKeylinesBetweenItems":"fr-ec-collection-list__item--keylines-between-items","collection-list__item--remove-edge-padding":"fr-ec-collection-list__item--remove-edge-padding","collectionListItemRemoveEdgePadding":"fr-ec-collection-list__item--remove-edge-padding","collection-list__item--keylines-resticted":"fr-ec-collection-list__item--keylines-resticted","collectionListItemKeylinesResticted":"fr-ec-collection-list__item--keylines-resticted"};

var _a;
var MB_SPACING_04 = '16';
var MB_SPACING_05 = '24';
var MB_SPACING_06 = '32';
var variantSpacing = (_a = {}, _a[MB_SPACING_04] = spacingStyles.mbSpacing04, _a[MB_SPACING_05] = spacingStyles.mbSpacing05, _a[MB_SPACING_06] = spacingStyles.mbSpacing06, _a);
var getChild = function getChild(restrictedKeyline) {
  var childType;
  if (/*#__PURE__*/isValidElement(restrictedKeyline)) {
    Children.forEach(restrictedKeyline, function (child) {
      var _a, _b;
      if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'LinkCell' || ((_b = child.type) === null || _b === void 0 ? void 0 : _b.displayName) === 'CoreLinkCell') {
        childType = 'LinkCell';
      } else {
        childType = '';
      }
    });
  }
  return childType;
};
var CollectionList = function CollectionList(_a) {
  var children = _a.children,
    id = _a.id,
    _b = _a.keylines,
    keylines = _b === void 0 ? 'none' : _b,
    spacing = _a.spacing,
    _c = _a.removeEdgePadding,
    removeEdgePadding = _c === void 0 ? false : _c,
    className = _a.className,
    props = __rest$1(_a, ["children", "id", "keylines", "spacing", "removeEdgePadding", "className"]);
  return /*#__PURE__*/createElement("ul", __assign$1({
    id: id,
    className: joinClasses(styles$I.collectionList, className)
  }, props), Children.toArray(children).filter(isValidElement).map(function (child, i) {
    return /*#__PURE__*/createElement("li", {
      className: joinClasses(styles$I.collectionListItem, styles$I["collection-list__item--spacing-".concat(spacing)], keylines === 'none' && spacing !== 'none' && styles$I["collection-list__item--no-keylines-spacing-".concat(spacing)], keylines === 'none' && spacing !== 'none' && styles$I.collectionListItemNoKeylinesSpacing, spacing !== 'none' && styles$I["collection-list__item-spacing-".concat(spacing)], styles$I["collection-list__item--keylines-".concat(keylines)], keylines !== 'none' && removeEdgePadding && styles$I.collectionListItemRemoveEdgePadding, getChild(child) && styles$I.collectionListItemKeylinesResticted),
      key: child.key || i
    }, child);
  }));
};
CollectionList.displayName = 'CoreCollectionList';
CollectionList.defaultProps = {
  keylines: 'none',
  removeEdgePadding: false,
  spacing: 'none'
};

var styles$J = {"layout":"fr-ec-layout","layout--gutter-sm":"fr-ec-layout--gutter-sm","layoutGutterSm":"fr-ec-layout--gutter-sm","layout--inset-left-sm":"fr-ec-layout--inset-left-sm","layoutInsetLeftSm":"fr-ec-layout--inset-left-sm","layout--inset-right-sm":"fr-ec-layout--inset-right-sm","layoutInsetRightSm":"fr-ec-layout--inset-right-sm","layout--span-1-sm":"fr-ec-layout--span-1-sm","layoutSpan1Sm":"fr-ec-layout--span-1-sm","layout--span-2-sm":"fr-ec-layout--span-2-sm","layoutSpan2Sm":"fr-ec-layout--span-2-sm","layout--span-3-sm":"fr-ec-layout--span-3-sm","layoutSpan3Sm":"fr-ec-layout--span-3-sm","layout--span-4-sm":"fr-ec-layout--span-4-sm","layoutSpan4Sm":"fr-ec-layout--span-4-sm","layout--gutter-md":"fr-ec-layout--gutter-md","layoutGutterMd":"fr-ec-layout--gutter-md","layout--inset-left-md":"fr-ec-layout--inset-left-md","layoutInsetLeftMd":"fr-ec-layout--inset-left-md","layout--inset-right-md":"fr-ec-layout--inset-right-md","layoutInsetRightMd":"fr-ec-layout--inset-right-md","layout--span-1-md":"fr-ec-layout--span-1-md","layoutSpan1Md":"fr-ec-layout--span-1-md","layout--span-2-md":"fr-ec-layout--span-2-md","layoutSpan2Md":"fr-ec-layout--span-2-md","layout--span-3-md":"fr-ec-layout--span-3-md","layoutSpan3Md":"fr-ec-layout--span-3-md","layout--span-4-md":"fr-ec-layout--span-4-md","layoutSpan4Md":"fr-ec-layout--span-4-md","layout--span-5-md":"fr-ec-layout--span-5-md","layoutSpan5Md":"fr-ec-layout--span-5-md","layout--span-6-md":"fr-ec-layout--span-6-md","layoutSpan6Md":"fr-ec-layout--span-6-md","layout--span-7-md":"fr-ec-layout--span-7-md","layoutSpan7Md":"fr-ec-layout--span-7-md","layout--span-8-md":"fr-ec-layout--span-8-md","layoutSpan8Md":"fr-ec-layout--span-8-md","layout--span-9-md":"fr-ec-layout--span-9-md","layoutSpan9Md":"fr-ec-layout--span-9-md","layout--span-10-md":"fr-ec-layout--span-10-md","layoutSpan10Md":"fr-ec-layout--span-10-md","layout--span-11-md":"fr-ec-layout--span-11-md","layoutSpan11Md":"fr-ec-layout--span-11-md","layout--span-12-md":"fr-ec-layout--span-12-md","layoutSpan12Md":"fr-ec-layout--span-12-md","layout--gutter-lg":"fr-ec-layout--gutter-lg","layoutGutterLg":"fr-ec-layout--gutter-lg","layout--inset-left-lg":"fr-ec-layout--inset-left-lg","layoutInsetLeftLg":"fr-ec-layout--inset-left-lg","layout--inset-right-lg":"fr-ec-layout--inset-right-lg","layoutInsetRightLg":"fr-ec-layout--inset-right-lg","layout--span-1-lg":"fr-ec-layout--span-1-lg","layoutSpan1Lg":"fr-ec-layout--span-1-lg","layout--span-2-lg":"fr-ec-layout--span-2-lg","layoutSpan2Lg":"fr-ec-layout--span-2-lg","layout--span-3-lg":"fr-ec-layout--span-3-lg","layoutSpan3Lg":"fr-ec-layout--span-3-lg","layout--span-4-lg":"fr-ec-layout--span-4-lg","layoutSpan4Lg":"fr-ec-layout--span-4-lg","layout--span-5-lg":"fr-ec-layout--span-5-lg","layoutSpan5Lg":"fr-ec-layout--span-5-lg","layout--span-6-lg":"fr-ec-layout--span-6-lg","layoutSpan6Lg":"fr-ec-layout--span-6-lg","layout--span-7-lg":"fr-ec-layout--span-7-lg","layoutSpan7Lg":"fr-ec-layout--span-7-lg","layout--span-8-lg":"fr-ec-layout--span-8-lg","layoutSpan8Lg":"fr-ec-layout--span-8-lg","layout--span-9-lg":"fr-ec-layout--span-9-lg","layoutSpan9Lg":"fr-ec-layout--span-9-lg","layout--span-10-lg":"fr-ec-layout--span-10-lg","layoutSpan10Lg":"fr-ec-layout--span-10-lg","layout--span-11-lg":"fr-ec-layout--span-11-lg","layoutSpan11Lg":"fr-ec-layout--span-11-lg","layout--span-12-lg":"fr-ec-layout--span-12-lg","layoutSpan12Lg":"fr-ec-layout--span-12-lg"};

var getGutterClasses = function getGutterClasses(gutterProp) {
  if (typeof gutterProp === 'boolean') {
    if (gutterProp) {
      return joinClasses(styles$J.layoutGutterSm, styles$J.layoutGutterMd, styles$J.layoutGutterLg);
    } else {
      return '';
    }
  }
  return joinClasses.apply(void 0, Object.keys(gutterProp).reduce(function (acc, size) {
    return gutterProp[size] ? __spreadArray(__spreadArray([], acc, true), [styles$J["layout--gutter-".concat(size)]], false) : acc;
  }, []));
};
var getSpanClasses = function getSpanClasses(colSpanProp) {
  if (typeof colSpanProp === 'boolean' && !colSpanProp) {
    return '';
  }
  return joinClasses.apply(void 0, Object.keys(colSpanProp).reduce(function (acc, size) {
    return _typeof(colSpanProp[size]) !== undefined ? __spreadArray(__spreadArray([], acc, true), [styles$J["layout--span-".concat(colSpanProp[size], "-").concat(size)]], false) : acc;
  }, []));
};
var getInsetClass = function getInsetClass(insetProp) {
  if (typeof insetProp === 'boolean') {
    if (insetProp) {
      return joinClasses(styles$J.layoutInsetLeftSm, styles$J.layoutInsetRightSm, styles$J.layoutInsetLeftMd, styles$J.layoutInsetRightMd, styles$J.layoutInsetLeftLg, styles$J.layoutInsetRightLg);
    } else {
      return '';
    }
  }
  return joinClasses.apply(void 0, Object.keys(insetProp).map(function (side) {
    var insetSide = insetProp[side];
    if (typeof insetSide === 'boolean' && insetSide) {
      return joinClasses(styles$J["layout--inset-".concat(side, "-sm")], styles$J["layout--inset-".concat(side, "-md")], styles$J["layout--inset-".concat(side, "-lg")]);
    }
    return Object.keys(insetSide).reduce(function (acc, breakpoint) {
      if (insetSide[breakpoint]) {
        return __spreadArray(__spreadArray([], acc, true), [styles$J["layout--inset-".concat(side, "-").concat(breakpoint)]], false);
      }
      return acc;
    }, []).join(' ');
  }));
};
var LayoutComponent = function LayoutComponent(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    _c = _a.gutter,
    gutter = _c === void 0 ? false : _c,
    _d = _a.colSpan,
    colSpan = _d === void 0 ? {
      sm: 4,
      md: 12,
      lg: 12
    } : _d,
    _e = _a.inset,
    inset = _e === void 0 ? false : _e,
    className = _a.className,
    props = __rest$1(_a, ["element", "gutter", "colSpan", "inset", "className"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$J.layout, getGutterClasses(gutter), getSpanClasses(colSpan), getInsetClass(inset), className)
    }, props))
  );
};
LayoutComponent.displayName = 'CoreLayout';
LayoutComponent.defaultProps = {
  colSpan: {
    sm: 4,
    md: 12,
    lg: 12
  },
  element: 'div',
  gutter: false,
  inset: false
};
var Layout = isViewport(LayoutComponent);

var styles$K = {"contents-card":"fr-ec-contents-card","contentsCard":"fr-ec-contents-card","contents-card--plp-fullscreen":"fr-ec-contents-card--plp-fullscreen","contentsCardPlpFullscreen":"fr-ec-contents-card--plp-fullscreen","contents-card--plp-contained":"fr-ec-contents-card--plp-contained","contentsCardPlpContained":"fr-ec-contents-card--plp-contained","contents-card--plp-centered":"fr-ec-contents-card--plp-centered","contentsCardPlpCentered":"fr-ec-contents-card--plp-centered","content-alignment":"fr-ec-content-alignment","contentAlignment":"fr-ec-content-alignment"};

var ContentsCard = function ContentsCard(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'navigation-fullscreen' : _b,
    content = _a.content,
    className = _a.className,
    _c = _a.alignment,
    alignment = _c === void 0 ? 'left' : _c,
    props = __rest$1(_a, ["variant", "content", "className", "alignment"]);
  var contentAlignment = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  };
  var getColSpan = function getColSpan(variant) {
    if (variant === 'plp-centered') {
      return {
        lg: 6,
        md: 6,
        sm: 4
      };
    } else if (variant === 'plp-fullscreen' || variant === 'plp-contained') {
      return {
        lg: 12,
        md: 12,
        sm: 4
      };
    } else {
      return {
        lg: 10,
        md: 12,
        sm: 4
      };
    }
  };
  if (variant === 'navigation-contained' || variant === 'navigation-fullscreen') {
    return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
      justifyContent: "center",
      direction: "row",
      className: joinClasses(className, styles$K.contentsCard),
      element: "div"
    }, props), /*#__PURE__*/createElement(Layout, {
      colSpan: {
        lg: 10,
        md: 12,
        sm: 4
      },
      gutter: {
        sm: variant === 'navigation-contained' ? true : false,
        md: true,
        lg: true
      }
    }, content));
  }
  return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
    justifyContent: "center",
    direction: "row",
    className: joinClasses(className, styles$K.contentsCard),
    element: "div"
  }, props), /*#__PURE__*/createElement(Layout, {
    colSpan: getColSpan(variant),
    gutter: variant === 'plp-fullscreen' ? {
      sm: false,
      md: false,
      lg: true
    } : {
      sm: false,
      md: true,
      lg: true
    },
    className: joinClasses(styles$K.contentsCard, variant === 'plp-fullscreen' && styles$K.contentsCardPlpFullscreen, variant === 'plp-contained' && styles$K.contentsCardPlpContained, variant === 'plp-centered' && styles$K.contentsCardPlpCentered)
  }, /*#__PURE__*/createElement(ContentAlignment, {
    alignment: contentAlignment[alignment],
    direction: "column",
    element: "div"
  }, content)));
};
ContentsCard.displayName = 'CoreContentsCard';

var styles$L = {"pill-form":"fr-ec-pill-form","pillForm":"fr-ec-pill-form","pill-form--color-primary-dark":"fr-ec-pill-form--color-primary-dark","pillFormColorPrimaryDark":"fr-ec-pill-form--color-primary-dark","pill-form--color-placeholder":"fr-ec-pill-form--color-placeholder","pillFormColorPlaceholder":"fr-ec-pill-form--color-placeholder","pill-form--color-disabled":"fr-ec-pill-form--color-disabled","pillFormColorDisabled":"fr-ec-pill-form--color-disabled"};

var testId$2 = {
  'data-testid': 'CorePillForm'
};
var pillFormStyles = {
  standard: 'standard',
  emphasized: 'emphasized'
};
var alignmentClass$6 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var PillForm = function PillForm(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'standard' : _c,
    _d = _a.color,
    color = _d === void 0 ? 'primary-dark' : _d,
    _e = _a.textAlign,
    textAlign = _e === void 0 ? 'left' : _e,
    className = _a.className,
    _f = _a.textTransform,
    textTransform = _f === void 0 ? 'normal' : _f,
    _g = _a.wordBreak,
    wordBreak = _g === void 0 ? 'none' : _g,
    strikethrough = _a.strikethrough,
    props = __rest$1(_a, ["element", "variant", "color", "textAlign", "className", "textTransform", "wordBreak", "strikethrough"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$L.pillForm, styles$L["pill-form--color-".concat(color)], typographyStyles[pillFormStyles[variant]], typographyStyles["pill-form--".concat(variant)], textAlignStyles[alignmentClass$6[textAlign]], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className),
    "aria-disabled": color === 'disabled'
  }, props, testId$2));
};
PillForm.displayName = 'CorePillForm';

var styles$M = {"counter":"fr-ec-counter","counter__button":"fr-ec-counter__button","counterButton":"fr-ec-counter__button","counter__minus":"fr-ec-counter__minus","counterMinus":"fr-ec-counter__minus","counter__plus":"fr-ec-counter__plus","counterPlus":"fr-ec-counter__plus","counter__value":"fr-ec-counter__value","counterValue":"fr-ec-counter__value"};

var testId$3 = {
  'data-testid': 'CoreCounter'
};
var Counter = function Counter(_a) {
  var _b = _a.value,
    value = _b === void 0 ? 1 : _b,
    _c = _a.callbackOnIncrement,
    callbackOnIncrement = _c === void 0 ? function (event) {
      return event;
    } : _c,
    _d = _a.callbackOnDecrement,
    callbackOnDecrement = _d === void 0 ? function (event) {
      return event;
    } : _d,
    _e = _a.disabled,
    disabled = _e === void 0 ? false : _e,
    _f = _a.min,
    min = _f === void 0 ? 1 : _f,
    _g = _a.max,
    max = _g === void 0 ? 10 : _g,
    description = _a.description,
    error = _a.error,
    className = _a.className,
    props = __rest$1(_a, ["value", "callbackOnIncrement", "callbackOnDecrement", "disabled", "min", "max", "description", "error", "className"]);
  var handleDecrement = function handleDecrement(event) {
    event.preventDefault();
    if (callbackOnDecrement) {
      callbackOnDecrement(event);
    }
  };
  var handleIncrement = function handleIncrement(event) {
    event.preventDefault();
    if (callbackOnIncrement) {
      callbackOnIncrement(event);
    }
  };
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$M.counter, spacingStyles.mbSpacing02, className)
  }, props, testId$3), /*#__PURE__*/createElement(ButtonIcon, {
    label: "Decrease ".concat(value, " to ").concat(value - 1, " Button"),
    element: "button",
    onClick: handleDecrement,
    hideLabel: true,
    icon: "minus",
    disabled: disabled || value <= min,
    className: joinClasses(styles$M.counterButton, styles$M.counterMinus)
  }), /*#__PURE__*/createElement(PillForm, {
    element: "div",
    className: styles$M.counterValue,
    color: disabled ? 'disabled' : 'primary-dark'
  }, value), /*#__PURE__*/createElement(ButtonIcon, {
    label: "Increase ".concat(value, " to ").concat(value + 1, " Button"),
    element: "button",
    onClick: handleIncrement,
    hideLabel: true,
    icon: "plus",
    disabled: disabled || value >= max,
    className: joinClasses(styles$M.counterButton, styles$M.counterPlus)
  })), description || error ? /*#__PURE__*/createElement(HintError, {
    error: error,
    hint: description
  }) : null);
};
Counter.displayName = 'Counter';

var styles$N = {"description-list-item-dt":"fr-ec-description-list-item-dt","descriptionListItemDt":"fr-ec-description-list-item-dt","description-list-item-dd":"fr-ec-description-list-item-dd","descriptionListItemDd":"fr-ec-description-list-item-dd","description-list-item-dd__max-width":"fr-ec-description-list-item-dd__max-width","descriptionListItemDdMaxWidth":"fr-ec-description-list-item-dd__max-width"};

var DescriptionListItem = function DescriptionListItem(_a) {
  var title = _a.title,
    content = _a.content,
    className = _a.className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("dt", {
    className: joinClasses(styles$N.descriptionListItemDt, className)
  }, /*#__PURE__*/createElement(Label, {
    element: "p",
    variant: "large"
  }, title)), /*#__PURE__*/createElement("dd", {
    className: styles$N.descriptionListItemDd
  }, typeof content === 'string' ? (/*#__PURE__*/createElement(Body, {
    element: "p",
    variant: "standard",
    className: styles$N.descriptionListItemDdMaxWidth
  }, content)) : content.map(function (item) {
    return /*#__PURE__*/createElement(Body, {
      key: item,
      element: "p",
      variant: "standard",
      className: styles$N.descriptionListItemDdMaxWidth
    }, item);
  })));
};

var styles$O = {"description-list":"fr-ec-description-list","descriptionList":"fr-ec-description-list"};

var DescriptionList = function DescriptionList(_a) {
  var items = _a.items,
    className = _a.className,
    props = __rest$1(_a, ["items", "className"]);
  return /*#__PURE__*/createElement("dl", __assign$1({
    className: joinClasses(styles$O.descriptionList, className)
  }, props), items.map(function (item, index) {
    return /*#__PURE__*/createElement(DescriptionListItem, {
      key: index,
      title: item.title,
      content: item.content
    });
  }));
};
DescriptionList.displayName = 'CoreDescriptionList';

var styles$P = {"display":"fr-ec-display","display--display4":"fr-ec-display--display4","displayDisplay4":"fr-ec-display--display4","display--color-primary-dark":"fr-ec-display--color-primary-dark","displayColorPrimaryDark":"fr-ec-display--color-primary-dark","display--color-primary-light":"fr-ec-display--color-primary-light","displayColorPrimaryLight":"fr-ec-display--color-primary-light","display--color-disabled":"fr-ec-display--color-disabled","displayColorDisabled":"fr-ec-display--color-disabled"};

var alignmentClass$7 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Display = function Display(_a) {
  var Element = _a.element,
    _b = _a.variant,
    variant = _b === void 0 ? 'display1' : _b,
    _c = _a.color,
    color = _c === void 0 ? 'primary-dark' : _c,
    _d = _a.textAlign,
    textAlign = _d === void 0 ? 'left' : _d,
    className = _a.className,
    _e = _a.textTransform,
    textTransform = _e === void 0 ? 'normal' : _e,
    _f = _a.wordBreak,
    wordBreak = _f === void 0 ? 'none' : _f,
    _g = _a.maxLinesEllipsis,
    maxLinesEllipsis = _g === void 0 ? 0 : _g,
    strikethrough = _a.strikethrough,
    props = __rest$1(_a, ["element", "variant", "color", "textAlign", "className", "textTransform", "wordBreak", "maxLinesEllipsis", "strikethrough"]);
  var width = getViewportWidth();
  var isWidthLessthanMediumDevicewidth = width <= designTokens_3.mqSmallScreenMaxWidthLimit;
  var dynamicVariantClassName = isWidthLessthanMediumDevicewidth ? typographyStyles.displayDisplay5 : typographyStyles.displayDisplay3;
  return /*#__PURE__*/createElement(Element, __assign$1({
    style: {
      WebkitLineClamp: maxLinesEllipsis
    },
    className: joinClasses(styles$P.display, styles$P["display--color-".concat(color)], variant === 'display1' ? typographyStyles.displayDisplay1 : '', variant === 'display2' ? typographyStyles.displayDisplay2 : '', variant === 'display3' ? typographyStyles.displayDisplay3 : '', variant === 'display4' ? typographyStyles.displayDisplay4 : '', variant === 'display5' ? typographyStyles.displayDisplay5 : '', variant === 'dynamic' ? dynamicVariantClassName : '', variant === 'display1-ER' ? typographyStyles.displayDisplay1Er : '', variant === 'display1-MediaBanner_Title' ? typographyStyles.displayDisplay1MediaBannerTitle : '', textAlignStyles[alignmentClass$7[textAlign]], textTransformStyles["text-transform-".concat(textTransform)], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className),
    "aria-disabled": color === 'disabled'
  }, props));
};
Display.displayName = 'CoreDisplay';

var styles$Q = {"header-overlay":"fr-ec-header-overlay","headerOverlay":"fr-ec-header-overlay","header-overlay__title":"fr-ec-header-overlay__title","headerOverlayTitle":"fr-ec-header-overlay__title","display":"fr-ec-display","header-overlay__item-count":"fr-ec-header-overlay__item-count","headerOverlayItemCount":"fr-ec-header-overlay__item-count","header-overlay__sub-title":"fr-ec-header-overlay__sub-title","headerOverlaySubTitle":"fr-ec-header-overlay__sub-title","header-overlay__error":"fr-ec-header-overlay__error","headerOverlayError":"fr-ec-header-overlay__error","header-overlay__button":"fr-ec-header-overlay__button","headerOverlayButton":"fr-ec-header-overlay__button","header-overlay--hide":"fr-ec-header-overlay--hide","headerOverlayHide":"fr-ec-header-overlay--hide","header-overlay--display":"fr-ec-header-overlay--display","headerOverlayDisplay":"fr-ec-header-overlay--display"};

var HeaderOverlay = /*#__PURE__*/forwardRef(function (_a, ref) {
  var errors = _a.errors,
    title = _a.title,
    titleId = _a.titleId,
    subtitle = _a.subtitle,
    subtitleExtra = _a.subtitleExtra,
    closeLabel = _a.closeLabel,
    closeTitle = _a.closeTitle,
    onRequestClose = _a.onRequestClose,
    hideKeyline = _a.hideKeyline,
    _b = _a.labelElement,
    labelElement = _b === void 0 ? 'h5' : _b,
    _c = _a.isModal,
    isModal = _c === void 0 ? false : _c,
    className = _a.className,
    itemCount = _a.itemCount,
    iconBrand = _a.iconBrand,
    _d = _a.hideCloseIconLabel,
    hideCloseIconLabel = _d === void 0 ? false : _d,
    props = __rest$1(_a, ["errors", "title", "titleId", "subtitle", "subtitleExtra", "closeLabel", "closeTitle", "onRequestClose", "hideKeyline", "labelElement", "isModal", "className", "itemCount", "iconBrand", "hideCloseIconLabel"]);
  var isKeyboardOpenState;
  var isAndroidMobile;
  if (isInBrowser$1()) {
    isKeyboardOpenState = isKeyboardOpen();
    isAndroidMobile = getOS() === 'android' && getCurrentMediaQueryBreakpoint() === 'sm';
  }
  var getText = function getText(text) {
    return text && text.replace(/\\n|\n/g, '\n');
  };
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$Q.headerOverlay, isAndroidMobile && isModal ? isKeyboardOpenState !== true || isKeyboardOpenState === undefined ? styles$Q.headerOverlayDisplay : styles$Q.headerOverlayHide : '', !hideKeyline && keylineStyles.keylineBottom, className),
    ref: ref
  }, props), /*#__PURE__*/createElement("div", {
    id: titleId
  }, /*#__PURE__*/createElement("div", {
    className: styles$Q.headerOverlayTitle
  }, /*#__PURE__*/createElement(Display, {
    element: labelElement,
    variant: "display4"
  }, getText(title)), itemCount && (/*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "standard",
    className: styles$Q.headerOverlayItemCount
  }, itemCount))), subtitle && (/*#__PURE__*/createElement("div", {
    className: styles$Q.headerOverlaySubTitle
  }, /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "standard"
  }, subtitle, ' '), /*#__PURE__*/createElement(Caption, {
    element: "span"
  }, subtitleExtra))), errors && Array.isArray(errors) && errors.length > 0 && errors.map(function (error) {
    return error && (/*#__PURE__*/createElement(Caption, {
      key: error,
      className: styles$Q.headerOverlayError,
      element: "p",
      variant: "standard",
      color: "error"
    }, error));
  })), onRequestClose && closeLabel && (/*#__PURE__*/createElement(ButtonIcon, {
    element: "button",
    icon: "close-big",
    label: closeLabel,
    title: closeTitle || closeLabel,
    variant: "dark",
    onClick: onRequestClose,
    className: styles$Q.headerOverlayButton,
    iconBrand: iconBrand,
    hideLabel: hideCloseIconLabel
  })));
});
HeaderOverlay.displayName = 'CoreHeaderOverlay';
HeaderOverlay.defaultProps = {
  hideKeyline: false,
  labelElement: 'h5'
};

var styles$R = {"keyline":"fr-ec-keyline"};

var Keyline = function Keyline(_a) {
  var className = _a.className;
  return /*#__PURE__*/createElement("hr", {
    className: joinClasses(styles$R.keyline, keylineStyles.keylineBottom, className)
  });
};
Keyline.displayName = 'CoreKeyline';

var styles$S = {"pinned-container":"fr-ec-pinned-container","pinnedContainer":"fr-ec-pinned-container","pinned-container--top":"fr-ec-pinned-container--top","pinnedContainerTop":"fr-ec-pinned-container--top","pinned-container--end":"fr-ec-pinned-container--end","pinnedContainerEnd":"fr-ec-pinned-container--end","pinned-container--bottom":"fr-ec-pinned-container--bottom","pinnedContainerBottom":"fr-ec-pinned-container--bottom","pinned-container--start":"fr-ec-pinned-container--start","pinnedContainerStart":"fr-ec-pinned-container--start","pinned-container--top-sm":"fr-ec-pinned-container--top-sm","pinnedContainerTopSm":"fr-ec-pinned-container--top-sm","pinned-container--end-sm":"fr-ec-pinned-container--end-sm","pinnedContainerEndSm":"fr-ec-pinned-container--end-sm","pinned-container--bottom-sm":"fr-ec-pinned-container--bottom-sm","pinnedContainerBottomSm":"fr-ec-pinned-container--bottom-sm","pinned-container--start-sm":"fr-ec-pinned-container--start-sm","pinnedContainerStartSm":"fr-ec-pinned-container--start-sm","pinned-container--top-md":"fr-ec-pinned-container--top-md","pinnedContainerTopMd":"fr-ec-pinned-container--top-md","pinned-container--end-md":"fr-ec-pinned-container--end-md","pinnedContainerEndMd":"fr-ec-pinned-container--end-md","pinned-container--bottom-md":"fr-ec-pinned-container--bottom-md","pinnedContainerBottomMd":"fr-ec-pinned-container--bottom-md","pinned-container--start-md":"fr-ec-pinned-container--start-md","pinnedContainerStartMd":"fr-ec-pinned-container--start-md","pinned-container--top-lg":"fr-ec-pinned-container--top-lg","pinnedContainerTopLg":"fr-ec-pinned-container--top-lg","pinned-container--end-lg":"fr-ec-pinned-container--end-lg","pinnedContainerEndLg":"fr-ec-pinned-container--end-lg","pinned-container--bottom-lg":"fr-ec-pinned-container--bottom-lg","pinnedContainerBottomLg":"fr-ec-pinned-container--bottom-lg","pinned-container--start-lg":"fr-ec-pinned-container--start-lg","pinnedContainerStartLg":"fr-ec-pinned-container--start-lg"};

var getPositionClasses = function getPositionClasses(positionProp) {
  if (_typeof(positionProp) === 'object') {
    return joinClasses.apply(void 0, Object.keys(positionProp).reduce(function (acc, size) {
      var positionClassName = styles$S["pinned-container--".concat(positionProp[size], "-").concat(size)];
      return __spreadArray(__spreadArray([], acc, true), [positionClassName], false);
    }, []));
  }
  return styles$S["pinned-container--".concat(positionProp)];
};
var PinnedContainerComponent = function PinnedContainerComponent(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    position = _a.position,
    className = _a.className,
    props = __rest$1(_a, ["element", "position", "visible", "className"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$S.pinnedContainer, className, getPositionClasses(position))
    }, props))
  );
};
PinnedContainerComponent.displayName = 'CorePinnedContainer';
PinnedContainerComponent.defaultProps = {
  element: 'div'
};
var PinnedContainer = withVisibility(PinnedContainerComponent);

var styles$T = {"drawer":"fr-ec-drawer","drawer__body":"fr-ec-drawer__body","drawerBody":"fr-ec-drawer__body","drawer__content":"fr-ec-drawer__content","drawerContent":"fr-ec-drawer__content","drawer__footer":"fr-ec-drawer__footer","drawerFooter":"fr-ec-drawer__footer","drawer--start":"fr-ec-drawer--start","drawerStart":"fr-ec-drawer--start","drawer--end":"fr-ec-drawer--end","drawerEnd":"fr-ec-drawer--end","drawer--open":"fr-ec-drawer--open","drawerOpen":"fr-ec-drawer--open","drawer--full-width":"fr-ec-drawer--full-width","drawerFullWidth":"fr-ec-drawer--full-width","drawer--close":"fr-ec-drawer--close","drawerClose":"fr-ec-drawer--close","slideInFromLeft":"fr-ec-slideInFromLeft"};

var Drawer = function Drawer(_a) {
  var isOpen = _a.isOpen,
    children = _a.children,
    title = _a.title,
    subtitle = _a.subtitle,
    subtitleExtra = _a.subtitleExtra,
    closeLabel = _a.closeLabel,
    closeTitle = _a.closeTitle,
    footer = _a.footer,
    _b = _a.titleId,
    titleId = _b === void 0 ? 'drawer-title' : _b,
    _c = _a.trapFocus,
    trapFocus = _c === void 0 ? true : _c,
    onRequestClose = _a.onRequestClose,
    onBackdropClick = _a.onBackdropClick,
    _d = _a.visible,
    visible = _d === void 0 ? {
      sm: true,
      md: true,
      lg: false
    } : _d,
    _e = _a.position,
    position = _e === void 0 ? 'start' : _e,
    backgroundScroll = _a.backgroundScroll,
    className = _a.className,
    scrollDisableElement = _a.scrollDisableElement,
    _f = _a.labelElement,
    labelElement = _f === void 0 ? 'h5' : _f,
    itemCount = _a.itemCount,
    _g = _a.variant,
    variant = _g === void 0 ? 'default' : _g,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["isOpen", "children", "title", "subtitle", "subtitleExtra", "closeLabel", "closeTitle", "footer", "titleId", "trapFocus", "onRequestClose", "onBackdropClick", "visible", "position", "backgroundScroll", "className", "scrollDisableElement", "labelElement", "itemCount", "variant", "iconBrand"]);
  var _h = useState(false),
    isClosing = _h[0],
    setIsClosing = _h[1];
  var currentPosition = 0;
  useEffect(function () {
    if (isOpen && isInBrowser$1()) {
      handleAddEventListeners();
      if (!backgroundScroll) {
        scrollRemoval(true);
      }
    }
    return function () {
      if (isInBrowser$1()) {
        handleRemoveEventListeners();
      }
    };
  }, []);
  useEffect(function () {
    if (isInBrowser$1()) {
      if (isOpen) {
        handleAddEventListeners();
        if (!backgroundScroll) {
          scrollRemoval(true);
        }
      } else if (!isOpen) {
        handleRemoveEventListeners();
        if (!backgroundScroll) {
          scrollRemoval(false);
        }
      }
    }
    return function () {
      if (!backgroundScroll) {
        scrollRemoval(false);
      }
    };
  }, [isOpen]);
  var handleAddEventListeners = function handleAddEventListeners() {
    document.addEventListener('keydown', handleKeydown);
  };
  var handleRemoveEventListeners = function handleRemoveEventListeners() {
    document.removeEventListener('keydown', handleKeydown);
  };
  var handleKeydown = function handleKeydown(event) {
    if (event.keyCode === KEYCODE.ESC) {
      if (typeof onBackdropClick === 'function') {
        onBackdropClick(event);
      } else {
        handleCloseDrawer(event);
      }
    }
  };
  var handleSwipe = function handleSwipe(_a) {
    var event = _a.event;
    if (isOpen) {
      handleCloseDrawer(event);
    }
  };
  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target === event.currentTarget) {
      setIsClosing(true);
      setTimeout(function () {
        if (typeof onBackdropClick === 'function') {
          onBackdropClick(event);
        } else {
          handleCloseDrawer(event);
        }
      }, 315);
    } else {
      handleCloseDrawer(event);
    }
  };
  var handleCloseDrawer = function handleCloseDrawer(event) {
    handleRemoveEventListeners();
    if (!backgroundScroll) {
      scrollRemoval(false);
    }
    setIsClosing(true);
    setTimeout(function () {
      return onRequestClose(event);
    }, 315);
  };
  var handleFallbackFocus = function handleFallbackFocus() {
    var element = document.activeElement;
    return element;
  };
  var scrollRemoval = function scrollRemoval(disable) {
    if (isInBrowser$1()) {
      if (typeof document === 'undefined') {
        return;
      }
      var docElement = document.querySelector(scrollDisableElement || 'body');
      if (disable) {
        currentPosition = window.pageYOffset;
        docElement.classList.add(interactionsStyles.scrollDisabled);
        docElement.style.top = "".concat(-currentPosition, "px");
      } else {
        docElement.classList.remove(interactionsStyles.scrollDisabled);
        docElement.style.top = '';
        window.scrollTo(0, currentPosition);
      }
    }
  };
  var swipeFunctions = {
    'end': 'onSwiped',
    'start': 'onSwipeStart'
  };
  var drawerStyle = joinClasses(styles$T.drawer, variant === 'fullWidth' && styles$T.drawerFullWidth, styles$T["drawer--".concat(position)], isOpen && styles$T.drawerOpen, variant === 'default' && isClosing && styles$T.drawerClose, className);
  var swipeHandlers = useSwipeable({
    onSwipeStart: handleSwipe,
    onSwiped: handleSwipe
  });
  return /*#__PURE__*/createElement(PinnedContainer, {
    element: "div",
    visible: visible,
    position: position
  }, /*#__PURE__*/createElement("div", __assign$1({}, swipeHandlers[swipeFunctions[position]]), /*#__PURE__*/createElement(OverlayBackdrop, {
    hidden: !isOpen,
    tabIndex: -1,
    onClick: handleBackdropClick
  }), /*#__PURE__*/createElement(FocusTrap, {
    active: trapFocus && isOpen,
    focusTrapOptions: {
      clickOutsideDeactivates: true,
      escapeDeactivates: false,
      fallbackFocus: handleFallbackFocus,
      returnFocusOnDeactivate: true
    }
  }, /*#__PURE__*/createElement("div", __assign$1({
    className: drawerStyle,
    tabIndex: -1
  }, props), /*#__PURE__*/createElement(HeaderOverlay, {
    title: title,
    subtitle: subtitle,
    subtitleExtra: subtitleExtra,
    closeLabel: closeLabel,
    onRequestClose: handleCloseDrawer,
    titleId: titleId,
    closeTitle: closeTitle,
    labelElement: labelElement,
    itemCount: itemCount,
    iconBrand: iconBrand
  }), /*#__PURE__*/createElement("div", {
    className: styles$T.drawerBody
  }, /*#__PURE__*/createElement("div", {
    className: styles$T.drawerContent
  }, children), footer && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Keyline, null), /*#__PURE__*/createElement("div", {
    className: styles$T.drawerFooter
  }, footer))))))));
};
Drawer.displayName = 'CoreDrawer';
Drawer.defaultProps = {
  backgroundScroll: false,
  labelElement: 'h5',
  position: 'start',
  scrollDisableElement: 'body',
  titleId: 'drawer-title',
  trapFocus: true,
  visible: {
    sm: true,
    md: true,
    lg: false
  }
};

var styles$U = {"link":"fr-ec-link","link--default":"fr-ec-link--default","linkDefault":"fr-ec-link--default","link--fill":"fr-ec-link--fill","linkFill":"fr-ec-link--fill","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border"};

var Link = function Link(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'a' : _b,
    url = _a.url,
    _c = _a.gaCategory,
    gaCategory = _c === void 0 ? '' : _c,
    _d = _a.gaLabel,
    gaLabel = _d === void 0 ? '' : _d,
    gaAction = _a.gaAction,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    target = _a.target,
    className = _a.className,
    _e = _a.variant,
    variant = _e === void 0 ? 'default' : _e,
    onClick = _a.onClick,
    _f = _a.activeTabName,
    activeTabName = _f === void 0 ? '' : _f,
    props = __rest$1(_a, ["element", "url", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "target", "className", "variant", "onClick", "activeTabName"]);
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};
  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    Element = Link$1;
    // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore
    attributes.to = url;
    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }
  var onClickHandler = function onClickHandler(e) {
    // For callback
    if (onClick) {
      onClick(e, activeTabName);
    }
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel, gaAction);
    }
  };
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$U.link, Element === 'button' && resetStyles.buttonReset, styles$U["link--".concat(variant)], interactionsStyles.cursorPointer, className),
      href: url,
      onClick: onClickHandler
    }, gaProps, attributes, props))
  );
};
Link.displayName = 'CoreLink';
Link.defaultProps = {
  activeTabName: '',
  element: 'a',
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  variant: 'default'
};

var styles$V = {"expand-utility__alpha-gradient":"fr-ec-expand-utility__alpha-gradient","expandUtilityAlphaGradient":"fr-ec-expand-utility__alpha-gradient","expand-utility__alpha-gradient-overlay":"fr-ec-expand-utility__alpha-gradient-overlay","expandUtilityAlphaGradientOverlay":"fr-ec-expand-utility__alpha-gradient-overlay"};

var ExpandUtility = function ExpandUtility(_a) {
  var children = _a.children,
    isExpanded = _a.isExpanded,
    _b = _a.collapsedHeight,
    collapsedHeight = _b === void 0 ? 0 : _b,
    className = _a.className,
    _c = _a.alphaGradient,
    alphaGradient = _c === void 0 ? false : _c;
  var height = isExpanded === true ? 'auto' : collapsedHeight;
  return /*#__PURE__*/createElement("div", {
    style: {
      'position': 'relative'
    }
  }, alphaGradient && !isExpanded && /*#__PURE__*/createElement("div", {
    className: styles$V.expandUtilityAlphaGradientOverlay
  }), /*#__PURE__*/createElement(AnimateHeight, {
    className: joinClasses(alphaGradient && styles$V.expandUtilityAlphaGradient, className),
    easing: designTokens_2.animateEaseInOut,
    duration: 400,
    height: height
  }, children));
};
ExpandUtility.displayName = 'CoreExpandUtility';
ExpandUtility.defaultProps = {
  collapsedHeight: 0,
  isExpanded: false
};

var styles$W = {"accordion__heading":"fr-ec-accordion__heading","accordionHeading":"fr-ec-accordion__heading","accordion__control":"fr-ec-accordion__control","accordionControl":"fr-ec-accordion__control","accordion__label":"fr-ec-accordion__label","accordionLabel":"fr-ec-accordion__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","accordion__icon":"fr-ec-accordion__icon","accordionIcon":"fr-ec-accordion__icon","accordion__label-main":"fr-ec-accordion__label-main","accordionLabelMain":"fr-ec-accordion__label-main","accordion__label-children":"fr-ec-accordion__label-children","accordionLabelChildren":"fr-ec-accordion__label-children","accordion--variant-large":"fr-ec-accordion--variant-large","accordionVariantLarge":"fr-ec-accordion--variant-large","accordion--variant-small":"fr-ec-accordion--variant-small","accordionVariantSmall":"fr-ec-accordion--variant-small","accordion--variant-dynamic":"fr-ec-accordion--variant-dynamic","accordionVariantDynamic":"fr-ec-accordion--variant-dynamic","accordion__expand-close-icon":"fr-ec-accordion__expand-close-icon","accordionExpandCloseIcon":"fr-ec-accordion__expand-close-icon","accordion__content--large":"fr-ec-accordion__content--large","accordionContentLarge":"fr-ec-accordion__content--large"};

var variantStyles = {
  dynamic: styles$W.accordionVariantDynamic,
  large: styles$W.accordionVariantLarge,
  small: styles$W.accordionVariantSmall
};
var Accordion = /** @class */function (_super) {
  __extends(Accordion, _super);
  function Accordion(props) {
    var _this = _super.call(this, props) || this;
    _this.onClick = function (event) {
      var _a = _this.props,
        expanded = _a.expanded,
        onExpand = _a.onExpand,
        onClose = _a.onClose,
        gaCallback = _a.gaCallback,
        gaLabel = _a.gaLabel;
      if (gaCallback) {
        gaCallback(event.currentTarget, gaLabel);
      }
      if (expanded || _this.state.isExpanded) {
        if (onClose !== undefined) {
          onClose(event);
        }
      } else {
        if (onExpand !== undefined) {
          onExpand(event);
        }
      }
      if (expanded === undefined) {
        _this.setState({
          isExpanded: !_this.state.isExpanded
        });
      }
    };
    _this.state = {
      isExpanded: _this.props.defaultExpanded || false
    };
    return _this;
  }
  Accordion.prototype.render = function () {
    var _a = this.props,
      disabled = _a.disabled,
      _b = _a.element,
      Element = _b === void 0 ? 'div' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'large' : _c,
      _d = _a.labelElement,
      LabelElement = _d === void 0 ? 'legend' : _d,
      icon = _a.icon,
      label = _a.label,
      labelChildren = _a.labelChildren,
      expanded = _a.expanded,
      children = _a.children,
      id = _a.id,
      className = _a.className,
      ariaLabel = _a.ariaLabel,
      _e = _a.gaAction,
      gaAction = _e === void 0 ? 'click' : _e,
      _f = _a.gaCategory,
      gaCategory = _f === void 0 ? '' : _f,
      _g = _a.gaLabel,
      gaLabel = _g === void 0 ? '' : _g,
      _h = _a.gaValue,
      gaValue = _h === void 0 ? '' : _h,
      iconBrand = _a.iconBrand,
      props = __rest$1(_a, ["disabled", "element", "variant", "labelElement", "icon", "label", "labelChildren", "expanded", "children", "id", "className", "ariaLabel", "gaAction", "gaCategory", "gaLabel", "gaValue", "iconBrand"]);
    var gaProps = {};
    if (gaCategory && gaAction && gaLabel) {
      gaProps = {
        'data-action': gaAction,
        'data-category': gaCategory,
        'data-label': gaLabel
      };
      if (gaValue) {
        gaProps['data-value'] = gaValue;
      }
    }
    var isExpanded = expanded === undefined ? this.state.isExpanded : expanded;
    var expandCloseIcon = isExpanded ? iconBrand ? "".concat(iconBrand, "minus") : 'minus' : iconBrand ? "".concat(iconBrand, "plus") : 'plus';
    return /*#__PURE__*/createElement(Element, __assign$1({
      className: joinClasses(className, Element === 'fieldset' && resetStyles.fieldsetReset)
    }, gaProps, props), /*#__PURE__*/createElement(LabelElement, {
      className: joinClasses(styles$W.accordionHeading, variantStyles[variant])
    }, /*#__PURE__*/createElement("button", {
      className: joinClasses(styles$W.accordionControl, interactionsStyles.cursorPointer),
      disabled: disabled,
      id: id,
      "aria-expanded": isExpanded,
      "aria-controls": "".concat(id, "-content"),
      onClick: this.onClick,
      "aria-label": ariaLabel || undefined
    }, /*#__PURE__*/createElement("div", {
      className: styles$W.accordionLabel
    }, icon ? (/*#__PURE__*/createElement(Icon, {
      className: styles$W.accordionIcon,
      name: iconBrand ? "".concat(iconBrand).concat(icon) : icon
    })) : '', /*#__PURE__*/createElement(Body, {
      element: "span",
      variant: isExpanded ? 'standard-emphasized' : 'standard',
      className: styles$W.accordionLabelMain
    }, label), labelChildren && (/*#__PURE__*/createElement(Body, {
      element: "span",
      className: styles$W.accordionLabelChildren
    }, labelChildren))), /*#__PURE__*/createElement(Icon, {
      name: expandCloseIcon,
      className: styles$W.accordionExpandCloseIcon
    }))), /*#__PURE__*/createElement(ExpandUtility, {
      isExpanded: isExpanded,
      "aria-hidden": !isExpanded
    }, /*#__PURE__*/createElement("div", {
      id: "".concat(id, "-content"),
      className: styles$W["accordion__content--".concat(variant)]
    }, children)));
  };
  Accordion.displayName = 'CoreAccordion';
  Accordion.defaultProps = {
    disabled: false,
    variant: 'large'
  };
  return Accordion;
}(Component);

var styles$X = {"ticker":"fr-ec-ticker","ticker--attention":"fr-ec-ticker--attention","tickerAttention":"fr-ec-ticker--attention","ticker__body--attention":"fr-ec-ticker__body--attention","tickerBodyAttention":"fr-ec-ticker__body--attention","ticker__body":"fr-ec-ticker__body","tickerBody":"fr-ec-ticker__body","ticker__body--primary":"fr-ec-ticker__body--primary","tickerBodyPrimary":"fr-ec-ticker__body--primary","ticker__button":"fr-ec-ticker__button","tickerButton":"fr-ec-ticker__button"};

var Ticker = function Ticker(_a) {
  var variant = _a.variant,
    children = _a.children,
    onDismiss = _a.onDismiss,
    closeButton = _a.closeButton,
    _b = _a.gaAction,
    gaAction = _b === void 0 ? 'click' : _b,
    _c = _a.gaCategory,
    gaCategory = _c === void 0 ? '' : _c,
    _d = _a.gaLabel,
    gaLabel = _d === void 0 ? '' : _d,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    className = _a.className,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["variant", "children", "onDismiss", "closeButton", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "className", "iconBrand"]);
  var role = 'status';
  var tickerAttentionClass = '';
  if (variant === 'attention') {
    role = 'alert';
    tickerAttentionClass = styles$X.tickerAttention;
  }
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var onClickHandler = function onClickHandler(e) {
    // For callback
    if (onDismiss) {
      onDismiss(e);
    }
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$X.ticker, tickerAttentionClass, className)
  }, gaProps, props), /*#__PURE__*/createElement(Caption, {
    element: "p",
    className: joinClasses(styles$X.tickerBody, styles$X["ticker__body--".concat(variant)], resetStyles.maxWidthReset),
    role: role
  }, children), closeButton && (/*#__PURE__*/createElement(ButtonIcon, {
    element: "button",
    icon: "close",
    label: "Dismiss",
    variant: variant === 'attention' ? 'light' : 'dark',
    hideLabel: true,
    onClick: onClickHandler,
    className: styles$X.tickerButton,
    iconBrand: iconBrand,
    tabIndex: -1
  })));
};
Ticker.displayName = 'CoreTicker';
Ticker.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$Y = {"layout-wrapper":"fr-ec-layout-wrapper","layoutWrapper":"fr-ec-layout-wrapper"};

var LayoutWrapper = /*#__PURE__*/forwardRef(function (_a, ref) {
  var Element = _a.element,
    className = _a.className,
    props = __rest$1(_a, ["element", "className"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$Y.layoutWrapper, className),
    ref: ref
  }, props));
});
LayoutWrapper.displayName = 'CoreLayoutWrapper';

var styles$Z = {"flyout":"fr-ec-flyout","flyout__column-layout":"fr-ec-flyout__column-layout","flyoutColumnLayout":"fr-ec-flyout__column-layout","flyout__column-layout--overflow-visible":"fr-ec-flyout__column-layout--overflow-visible","flyoutColumnLayoutOverflowVisible":"fr-ec-flyout__column-layout--overflow-visible","flyout__collection-list":"fr-ec-flyout__collection-list","flyoutCollectionList":"fr-ec-flyout__collection-list","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation"};

var Flyout = function Flyout(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    _c = _a.colSpan,
    colSpan = _c === void 0 ? {
      md: 4,
      lg: 4
    } : _c,
    children = _a.children,
    className = _a.className,
    props = __rest$1(_a, ["element", "colSpan", "children", "className"]);
  var layoutColSpan = __assign$1(__assign$1({}, colSpan), {
    sm: 4
  });
  var width = getViewportWidth();
  return /*#__PURE__*/createElement(LayoutWrapper, {
    element: "section",
    className: styles$Z.flyout
  }, /*#__PURE__*/createElement(Layout, __assign$1({
    element: Element,
    colSpan: layoutColSpan,
    className: joinClasses(styles$Z.flyoutColumnLayout, className)
  }, props), /*#__PURE__*/createElement(CollectionList, {
    spacing: "16",
    keylines: width < designTokens_3.mqLargeScreenMinWidthLimit ? 'top' : 'none',
    className: styles$Z.flyoutCollectionList
  }, children)));
};
Flyout.displayName = 'CoreFlyout';
Flyout.defaultProps = {
  colSpan: {
    md: 4,
    lg: 4
  },
  element: 'div'
};

var styles$_ = {"footer":"fr-ec-footer","footer--white":"fr-ec-footer--white","footerWhite":"fr-ec-footer--white","footer--copyrights-only-border":"fr-ec-footer--copyrights-only-border","footerCopyrightsOnlyBorder":"fr-ec-footer--copyrights-only-border","footer--default":"fr-ec-footer--default","footerDefault":"fr-ec-footer--default","keyline":"fr-ec-keyline","footer-margin-bottom":"fr-ec-footer-margin-bottom","footerMarginBottom":"fr-ec-footer-margin-bottom","footer--content-wrapper":"fr-ec-footer--content-wrapper","footerContentWrapper":"fr-ec-footer--content-wrapper","content-alignment--direction-column":"fr-ec-content-alignment--direction-column","contentAlignmentDirectionColumn":"fr-ec-content-alignment--direction-column","link-navigation-group__list":"fr-ec-link-navigation-group__list","linkNavigationGroupList":"fr-ec-link-navigation-group__list","brand-title":"fr-ec-brand-title","brandTitle":"fr-ec-brand-title","footer-brand--container":"fr-ec-footer-brand--container","footerBrandContainer":"fr-ec-footer-brand--container","caption":"fr-ec-caption","footer--contents":"fr-ec-footer--contents","footerContents":"fr-ec-footer--contents","footer-copyrights-text":"fr-ec-footer-copyrights-text","footerCopyrightsText":"fr-ec-footer--copyrights-text","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","footer__right-aligned":"fr-ec-footer__right-aligned","footerRightAligned":"fr-ec-footer__right-aligned","footer--copy-right-contents":"fr-ec-footer--copy-right-contents","footerCopyRightContents":"fr-ec-footer--copy-right-contents","footer--copyrights-text":"fr-ec-footer--copyrights-text","footer__language-section":"fr-ec-footer__language-section","footerLanguageSection":"fr-ec-footer__language-section","collection-list-horizontal--small":"fr-ec-collection-list-horizontal--small","collectionListHorizontalSmall":"fr-ec-collection-list-horizontal--small","footer-legal-with-language-container":"fr-ec-footer-legal-with-language-container","footerLegalWithLanguageContainer":"fr-ec-footer-legal-with-language-container","link-navigation-group__item--horizontal":"fr-ec-link-navigation-group__item--horizontal","linkNavigationGroupItemHorizontal":"fr-ec-link-navigation-group__item--horizontal","link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation","footer--language-container":"fr-ec-footer--language-container","footerLanguageContainer":"fr-ec-footer--language-container","overlay-backdrop":"fr-ec-overlay-backdrop","overlayBackdrop":"fr-ec-overlay-backdrop","footer-sns-container":"fr-ec-footer-sns-container","footerSnsContainer":"fr-ec-footer-sns-container","footer--flex-content-wrapper":"fr-ec-footer--flex-content-wrapper","footerFlexContentWrapper":"fr-ec-footer--flex-content-wrapper","footer--key-line":"fr-ec-footer--key-line","footerKeyLine":"fr-ec-footer--key-line"};

var renderFooterContainer = function renderFooterContainer(copyrightRow, footerSNSContainer) {
  var copyrightRowType = _typeof(copyrightRow);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/React__default.createElement(Layout, {
    gutter: {
      sm: true,
      md: false,
      lg: true
    }
  }, /*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "center",
    direction: "row",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerCopyRightContents
  }, !Array.isArray(copyrightRow) && copyrightRowType !== 'string' && copyrightRow, Array.isArray(copyrightRow) && (/*#__PURE__*/React__default.createElement(ContentAlignment, {
    element: "ul",
    direction: "row",
    className: styles$_.footerCopyrightsText
  }, copyrightRow.map(function (item) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: item
    }, /*#__PURE__*/React__default.createElement(Caption, {
      color: "secondary",
      element: "span"
    }, item));
  }))), copyrightRowType === 'string' && (/*#__PURE__*/React__default.createElement(CollectionListHorizontal, {
    divider: true,
    spacingValue: "16",
    className: styles$_.footerCopyrightsText
  }, /*#__PURE__*/React__default.createElement(Caption, {
    variant: "standard",
    color: "secondary",
    element: "span"
  }, copyrightRow))), footerSNSContainer && (/*#__PURE__*/React__default.createElement(ContentAlignment, {
    direction: "row",
    justifyContent: "flex-end",
    element: "div",
    className: styles$_.footerSnsContainer
  }, footerSNSContainer))))));
};
var Footer = function Footer(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'footer' : _b,
    footerLinksContainer = _a.footerLinksContainer,
    footerBrandsContainer = _a.footerBrandsContainer,
    footerItemsContainer = _a.footerItemsContainer,
    footerLegalContainer = _a.footerLegalContainer,
    footerSNSContainer = _a.footerSNSContainer,
    languageContainer = _a.languageContainer,
    copyrightRow = _a.copyrightRow,
    className = _a.className,
    marginBottom = _a.marginBottom,
    _c = _a.variant,
    variant = _c === void 0 ? 'grey' : _c,
    props = __rest$1(_a, ["element", "footerLinksContainer", "footerBrandsContainer", "footerItemsContainer", "footerLegalContainer", "footerSNSContainer", "languageContainer", "copyrightRow", "className", "marginBottom", "variant"]);
  var isFirstContentsPresent = footerBrandsContainer || footerItemsContainer || footerLegalContainer;
  var copyrightRowOnly = !(footerLinksContainer || languageContainer || isFirstContentsPresent);
  return /*#__PURE__*/React__default.createElement(Element, __assign$1({
    className: joinClasses(className, styles$_.footer, styles$_.footerDefault, copyrightRowOnly && styles$_.footerCopyrightsOnlyBorder, variant === 'white' && styles$_.footerWhite)
  }, props), /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(marginBottom && styles$_.footerMarginBottom)
  }, (isFirstContentsPresent || footerLinksContainer || languageContainer) && (/*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/React__default.createElement(Layout, {
    gutter: {
      sm: true,
      md: false,
      lg: true
    }
  }, /*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "flex-start",
    direction: "column",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerFlexContentWrapper
  }, footerLinksContainer, (isFirstContentsPresent || languageContainer) && (/*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "flex-end",
    direction: "row",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerContentWrapper
  }, isFirstContentsPresent && (/*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "flex-start",
    direction: "column",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerContents
  }, footerBrandsContainer, footerItemsContainer, footerLegalContainer)), languageContainer && /*#__PURE__*/React__default.createElement("div", {
    className: styles$_.footerLanguageSection
  }, languageContainer)))))), /*#__PURE__*/React__default.createElement(Keyline, {
    className: styles$_.footerKeyLine
  }))), renderFooterContainer(copyrightRow, footerSNSContainer)));
};
Footer.displayName = 'CoreFooter';

var styles$$ = {"link-image":"fr-ec-link-image","linkImage":"fr-ec-link-image","link-image--with-image":"fr-ec-link-image--with-image","linkImageWithImage":"fr-ec-link-image--with-image","link-image__image":"fr-ec-link-image__image","linkImageImage":"fr-ec-link-image__image"};

var LinkImage = function LinkImage(_a) {
  var Element = _a.element,
    className = _a.className,
    _b = _a.tabIndex,
    tabIndex = _b === void 0 ? 0 : _b,
    src = _a.src,
    alt = _a.alt,
    children = _a.children,
    gaCategory = _a.gaCategory,
    gaAction = _a.gaAction,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    onClick = _a.onClick,
    ariaLabel = _a.ariaLabel,
    _c = _a.loading,
    loading = _c === void 0 ? 'eager' : _c,
    props = __rest$1(_a, ["element", "className", "tabIndex", "src", "alt", "children", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "onClick", "ariaLabel", "loading"]);
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var handleClick = function handleClick(e) {
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
    if (onClick) {
      onClick(e);
    }
  };
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      onClick: handleClick,
      className: joinClasses(styles$$.linkImage, src && styles$$.linkImageWithImage, className)
    }, props, gaProps, {
      tabIndex: tabIndex,
      "aria-label": ariaLabel
    }), src && /*#__PURE__*/createElement("img", {
      className: styles$$.linkImageImage,
      src: src,
      alt: alt,
      loading: loading
    }), children)
  );
};
LinkImage.displayName = 'CoreLinkImage';
LinkImage.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$10 = {"form-row":"fr-ec-form-row","formRow":"fr-ec-form-row","form-row__margin-bottom-32":"fr-ec-form-row__margin-bottom-32","formRowMarginBottom32":"fr-ec-form-row__margin-bottom-32","form-row__margin-bottom-24":"fr-ec-form-row__margin-bottom-24","formRowMarginBottom24":"fr-ec-form-row__margin-bottom-24","form-row--hint-error-hide-label":"fr-ec-form-row--hint-error-hide-label","formRowHintErrorHideLabel":"fr-ec-form-row--hint-error-hide-label","hint-text":"fr-ec-hint-text","hintText":"fr-ec-hint-text","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","form-row--variant-fluid":"fr-ec-form-row--variant-fluid","formRowVariantFluid":"fr-ec-form-row--variant-fluid","form-row__field":"fr-ec-form-row__field","formRowField":"fr-ec-form-row__field","form-row__field--width-3-field":"fr-ec-form-row__field--width-3-field","formRowFieldWidth3Field":"fr-ec-form-row__field--width-3-field","form-row__field--width-2-field":"fr-ec-form-row__field--width-2-field","formRowFieldWidth2Field":"fr-ec-form-row__field--width-2-field","form-row__field--width-1-field":"fr-ec-form-row__field--width-1-field","formRowFieldWidth1Field":"fr-ec-form-row__field--width-1-field","form-row__hint-error":"fr-ec-form-row__hint-error","formRowHintError":"fr-ec-form-row__hint-error","form-row--two-field-medium-viewPort-horizontal":"fr-ec-form-row--two-field-medium-viewPort-horizontal","formRowTwoFieldMediumViewPortHorizontal":"fr-ec-form-row--two-field-medium-viewPort-horizontal","form-row--two-field-medium-viewPort-vertical":"fr-ec-form-row--two-field-medium-viewPort-vertical","formRowTwoFieldMediumViewPortVertical":"fr-ec-form-row--two-field-medium-viewPort-vertical","form-row--two-field-small-viewPort-horizontal":"fr-ec-form-row--two-field-small-viewPort-horizontal","formRowTwoFieldSmallViewPortHorizontal":"fr-ec-form-row--two-field-small-viewPort-horizontal","form-row--two-field-small-viewPort-vertical":"fr-ec-form-row--two-field-small-viewPort-vertical","formRowTwoFieldSmallViewPortVertical":"fr-ec-form-row--two-field-small-viewPort-vertical"};

var getChildrens = function getChildrens(items, count) {
  if (items.length === count) {
    return items;
  }
  return items.concat(Array(count - items.length)).fill(/*#__PURE__*/createElement(Fragment, null), items.length, count);
};
var FormRow = function FormRow(_a) {
  var children = _a.children,
    className = _a.className,
    _b = _a.fieldCount,
    fieldCount = _b === void 0 ? 1 : _b,
    _c = _a.fluid,
    fluid = _c === void 0 ? false : _c,
    _d = _a.twoFieldSmallViewport,
    twoFieldSmallViewport = _d === void 0 ? 'horizontal' : _d,
    _e = _a.twoFieldMediumViewport,
    twoFieldMediumViewport = _e === void 0 ? 'horizontal' : _e,
    helptext = _a.helptext,
    error = _a.error,
    _f = _a.marginBottom,
    marginBottom = _f === void 0 ? '32px' : _f,
    props = __rest$1(_a, ["children", "className", "fieldCount", "fluid", "twoFieldSmallViewport", "twoFieldMediumViewport", "helptext", "error", "marginBottom"]);
  var formRowValidChildrens = Children.toArray(children).filter(isValidElement).slice(0, fieldCount);
  var formRowChild = getChildrens(formRowValidChildrens, fieldCount).map(function (child, index) {
    return /*#__PURE__*/createElement("div", {
      key: index,
      className: joinClasses(styles$10.formRowField, !fluid && styles$10["form-row__field--width-".concat(fieldCount, "-field")])
    }, child);
  });
  var hintErrorFlag = error || helptext ? true : '';
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$10.formRow, fluid ? styles$10.formRowVariantFluid : '', twoFieldSmallViewport === 'horizontal' ? styles$10.formRowTwoFieldSmallViewPortHorizontal : styles$10.formRowTwoFieldSmallViewPortVertical, twoFieldMediumViewport === 'horizontal' ? styles$10.formRowTwoFieldMediumViewPortHorizontal : styles$10.formRowTwoFieldMediumViewPortVertical, hintErrorFlag ? styles$10.formRowHintErrorHideLabel : '', marginBottom === '32px' ? styles$10.formRowMarginBottom32 : styles$10.formRowMarginBottom24, className)
  }, props), formRowChild), hintErrorFlag && /*#__PURE__*/createElement(HintError, {
    error: error,
    hint: helptext,
    className: styles$10.formRowHintError
  }));
};
FormRow.displayName = 'CoreFormRow';
FormRow.defaultProps = {
  fieldCount: 1,
  fluid: false,
  marginBottom: '32px'
};

var styles$11 = {"form-row-group":"fr-ec-form-row-group","formRowGroup":"fr-ec-form-row-group"};

var FormRowGroup = function FormRowGroup(_a) {
  var className = _a.className,
    children = _a.children,
    props = __rest$1(_a, ["className", "children"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$11.formRowGroup, className)
  }, props), children);
};
FormRowGroup.displayName = 'CoreFormRowGroup';

var styles$12 = {"grid":"fr-ec-grid","column":"fr-ec-column","grid-wrapper":"fr-ec-grid-wrapper","gridWrapper":"fr-ec-grid-wrapper"};

var Grid = function Grid(_a) {
  var children = _a.children,
    element = _a.element,
    className = _a.className,
    props = __rest$1(_a, ["children", "element", "className"]);
  var Element = element;
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$12.grid, className)
  }, props), children);
};
Grid.displayName = 'CoreGrid';

var styles$13 = {"header-page":"fr-ec-header-page","headerPage":"fr-ec-header-page","header-page__title-container":"fr-ec-header-page__title-container","headerPageTitleContainer":"fr-ec-header-page__title-container","header-page__title-container-label":"fr-ec-header-page__title-container-label","headerPageTitleContainerLabel":"fr-ec-header-page__title-container-label","header-page__caption":"fr-ec-header-page__caption","headerPageCaption":"fr-ec-header-page__caption","header-page__margin-top":"fr-ec-header-page__margin-top","headerPageMarginTop":"fr-ec-header-page__margin-top","header-page__tooltip":"fr-ec-header-page__tooltip","headerPageTooltip":"fr-ec-header-page__tooltip","header-page__textlink":"fr-ec-header-page__textlink","headerPageTextlink":"fr-ec-header-page__textlink","header-page__textlink-container":"fr-ec-header-page__textlink-container","headerPageTextlinkContainer":"fr-ec-header-page__textlink-container","header-page__caption-container":"fr-ec-header-page__caption-container","headerPageCaptionContainer":"fr-ec-header-page__caption-container","header-page__error-container":"fr-ec-header-page__error-container","headerPageErrorContainer":"fr-ec-header-page__error-container"};

var HeaderPage = function HeaderPage(_a) {
  var title = _a.title,
    captions = _a.captions,
    hideKeyline = _a.hideKeyline,
    className = _a.className,
    errors = _a.errors,
    textLink = _a.textLink,
    toolTip = _a.toolTip,
    _b = _a.labelElement,
    labelElement = _b === void 0 ? 'h5' : _b,
    marginTop = _a.marginTop,
    props = __rest$1(_a, ["title", "captions", "hideKeyline", "className", "errors", "textLink", "toolTip", "labelElement", "marginTop"]);
  return /*#__PURE__*/createElement("header", __assign$1({
    className: joinClasses(styles$13.headerPage, !hideKeyline && keylineStyles.keylineBottom, marginTop && styles$13.headerPageMarginTop, className)
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    className: styles$13.headerPageTitleContainer,
    element: "div",
    direction: "row",
    justifyContent: "space-between",
    alignment: "center"
  }, title && /*#__PURE__*/createElement(Display, {
    element: labelElement,
    variant: "display2",
    className: styles$13.headerPageTitleContainerLabel
  }, title), toolTip && /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageTooltip
  }, toolTip)), Array.isArray(errors) && (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageErrorContainer
  }, errors.map(function (error) {
    return /*#__PURE__*/createElement(Caption, {
      key: error,
      element: "p",
      variant: "standard",
      color: "error"
    }, error);
  })))), Array.isArray(captions) && (captions === null || captions === void 0 ? void 0 : captions.length) > 0 && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageCaptionContainer
  }, captions.map(function (caption) {
    return /*#__PURE__*/createElement(Body, {
      key: caption,
      element: "p",
      className: styles$13.headerPageCaption
    }, caption);
  })))), textLink && /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageTextlinkContainer
  }, textLink));
};
HeaderPage.displayName = 'CoreHeaderPage';
HeaderPage.defaultProps = {
  hideKeyline: false,
  labelElement: 'h5'
};

var styles$14 = {"header-section":"fr-ec-header-section","headerSection":"fr-ec-header-section","header-section--start":"fr-ec-header-section--start","headerSectionStart":"fr-ec-header-section--start","header-section__icon":"fr-ec-header-section__icon","headerSectionIcon":"fr-ec-header-section__icon","header-section__icon--check-large":"fr-ec-header-section__icon--check-large","headerSectionIconCheckLarge":"fr-ec-header-section__icon--check-large","header-section--with-keyline":"fr-ec-header-section--with-keyline","headerSectionWithKeyline":"fr-ec-header-section--with-keyline","header-section__extra":"fr-ec-header-section__extra","headerSectionExtra":"fr-ec-header-section__extra","header-section__extra--start":"fr-ec-header-section__extra--start","headerSectionExtraStart":"fr-ec-header-section__extra--start"};

var HeaderSection = function HeaderSection(_a) {
  var element = _a.element,
    title = _a.title,
    _b = _a.titleMaxLineEllipsis,
    titleMaxLineEllipsis = _b === void 0 ? 1 : _b,
    subTitle = _a.subTitle,
    _c = _a.subTitleMaxLineEllipsis,
    subTitleMaxLineEllipsis = _c === void 0 ? 1 : _c,
    variant = _a.variant,
    className = _a.className,
    children = _a.children,
    _d = _a.hideKeyline,
    hideKeyline = _d === void 0 ? false : _d,
    icon = _a.icon,
    toolTip = _a.toolTip,
    iconBrand = _a.iconBrand,
    _e = _a.alignment,
    alignment = _e === void 0 ? 'center' : _e,
    props = __rest$1(_a, ["element", "title", "titleMaxLineEllipsis", "subTitle", "subTitleMaxLineEllipsis", "variant", "className", "children", "hideKeyline", "icon", "toolTip", "iconBrand", "alignment"]);
  var wrapperClasses = joinClasses(styles$14.headerSection, alignment === 'flex-start' && styles$14.headerSectionStart, !hideKeyline && joinClasses(styles$14.headerSectionWithKeyline, keylineStyles.keylineBottom), className);
  var iconTemplate = icon ? (/*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
    size: "24",
    className: joinClasses(styles$14.headerSectionIcon, icon === 'check-large' && styles$14.headerSectionIconCheckLarge)
  })) : toolTip;
  var titleType = _typeof(title);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: wrapperClasses
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    alignment: alignment
  }, subTitle ? (/*#__PURE__*/createElement("div", null, titleType === 'string' ? (/*#__PURE__*/createElement(Display, {
    element: element,
    variant: variant,
    style: {
      WebkitLineClamp: titleMaxLineEllipsis,
      lineClamp: titleMaxLineEllipsis
    }
  }, title)) : title, /*#__PURE__*/createElement(Display, {
    element: element,
    variant: variant,
    style: {
      WebkitLineClamp: subTitleMaxLineEllipsis,
      lineClamp: subTitleMaxLineEllipsis
    }
  }, subTitle))) : titleType === 'string' ? (/*#__PURE__*/createElement(Display, {
    element: element,
    variant: variant,
    style: {
      WebkitLineClamp: titleMaxLineEllipsis,
      lineClamp: titleMaxLineEllipsis
    }
  }, title)) : title, iconTemplate), children && (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$14.headerSectionExtra, alignment === 'flex-start' && styles$14.headerSectionExtraStart)
  }, children)));
};
HeaderSection.displayName = 'CoreHeaderSection';
HeaderSection.defaultProps = {
  hideKeyline: false
};

var styles$15 = {"image-enhancements":"fr-ec-image-enhancements","imageEnhancements":"fr-ec-image-enhancements","image-enhancements__content-row":"fr-ec-image-enhancements__content-row","imageEnhancementsContentRow":"fr-ec-image-enhancements__content-row","image-enhancements__content-row--padding-reset":"fr-ec-image-enhancements__content-row--padding-reset","imageEnhancementsContentRowPaddingReset":"fr-ec-image-enhancements__content-row--padding-reset","image-enhancements__content-row--bottom":"fr-ec-image-enhancements__content-row--bottom","imageEnhancementsContentRowBottom":"fr-ec-image-enhancements__content-row--bottom","image-enhancements__content-row--top":"fr-ec-image-enhancements__content-row--top","imageEnhancementsContentRowTop":"fr-ec-image-enhancements__content-row--top","image-enhancements__content":"fr-ec-image-enhancements__content","imageEnhancementsContent":"fr-ec-image-enhancements__content","image-enhancements__content--right":"fr-ec-image-enhancements__content--right","imageEnhancementsContentRight":"fr-ec-image-enhancements__content--right","image-enhancements__content--left":"fr-ec-image-enhancements__content--left","imageEnhancementsContentLeft":"fr-ec-image-enhancements__content--left","image-enhancements__content--text":"fr-ec-image-enhancements__content--text","imageEnhancementsContentText":"fr-ec-image-enhancements__content--text","body":"fr-ec-body","image-enhancements__content--text-white":"fr-ec-image-enhancements__content--text-white","imageEnhancementsContentTextWhite":"fr-ec-image-enhancements__content--text-white","image-enhancements__content--prioritized":"fr-ec-image-enhancements__content--prioritized","imageEnhancementsContentPrioritized":"fr-ec-image-enhancements__content--prioritized","image-enhancements__botton-center-content":"fr-ec-image-enhancements__botton-center-content","imageEnhancementsBottonCenterContent":"fr-ec-image-enhancements__botton-center-content"};

var prioritizedContentMap = {
  bottomLeft: 0,
  bottomRight: 1,
  topLeft: 0,
  topRight: 1
};
var contentGroup = function contentGroup(contentLeft, contentRight, textColor, prioritizedContent) {
  if (textColor === void 0) {
    textColor = {};
  }
  if (prioritizedContent === void 0) {
    prioritizedContent = [];
  }
  var isLeftContentString = contentLeft && contentLeft.type && (
  // @ts-ignore
  contentLeft.type.displayName === 'CoreBody' || contentLeft.type.displayName === 'Body');
  var isRightContentString = contentRight && contentRight.type && (
  // @ts-ignore
  contentRight.type.displayName === 'CoreBody' || contentRight.type.displayName === 'Body');
  var isPrioritizedLeft = prioritizedContent.some(function (item) {
    return prioritizedContentMap[item] === 0;
  });
  var isPrioritizedRight = prioritizedContent.some(function (item) {
    return prioritizedContentMap[item] === 1;
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, contentLeft && (/*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$15.imageEnhancementsContent, styles$15.imageEnhancementsContentLeft, isPrioritizedLeft && styles$15.imageEnhancementsContentPrioritized, isLeftContentString && [styles$15.imageEnhancementsContentText, styles$15["image-enhancements__content--text-".concat(textColor.left || 'Black')]].join(' '))
  }, contentLeft)), contentRight && (/*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$15.imageEnhancementsContent, styles$15.imageEnhancementsContentRight, isPrioritizedRight && styles$15.imageEnhancementsContentPrioritized, isRightContentString && [styles$15.imageEnhancementsContentText, styles$15["image-enhancements__content--text-".concat(textColor.right || 'Black')]].join(' '))
  }, contentRight)));
};
var ImageEnhancements = function ImageEnhancements(_a) {
  var className = _a.className,
    children = _a.children,
    topLeftContent = _a.topLeftContent,
    topRightContent = _a.topRightContent,
    bottomLeftContent = _a.bottomLeftContent,
    bottomRightContent = _a.bottomRightContent,
    prioritizedContent = _a.prioritizedContent,
    topTextColor = _a.topTextColor,
    bottomTextColor = _a.bottomTextColor,
    _b = _a.padding,
    padding = _b === void 0 ? true : _b,
    absolutePositionContent = _a.absolutePositionContent,
    bottomCenterContent = _a.bottomCenterContent,
    props = __rest$1(_a, ["className", "children", "topLeftContent", "topRightContent", "bottomLeftContent", "bottomRightContent", "prioritizedContent", "topTextColor", "bottomTextColor", "padding", "absolutePositionContent", "bottomCenterContent"]);
  var _c = useState(0),
    minHeight = _c[0],
    updateMinHeight = _c[1];
  var imageEnhancementContentsRef = React__default.useRef(null);
  useEffect(function () {
    var contentsElement = imageEnhancementContentsRef === null || imageEnhancementContentsRef === void 0 ? void 0 : imageEnhancementContentsRef.current;
    if (contentsElement) {
      var contentMinHeight = contentsElement.clientHeight - contentsElement.clientWidth;
      updateMinHeight(contentMinHeight);
    }
  }, []);
  var onResize = function onResize(contentRect) {
    var contentsElement = imageEnhancementContentsRef === null || imageEnhancementContentsRef === void 0 ? void 0 : imageEnhancementContentsRef.current;
    if (contentRect.bounds && contentsElement) {
      var contentMinHeight = contentsElement.clientHeight - contentsElement.clientWidth;
      updateMinHeight(contentMinHeight);
    }
  };
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: debounce(100, onResize)
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", __assign$1({
      ref: measureRef,
      className: joinClasses(styles$15.imageEnhancements, className)
    }, props), /*#__PURE__*/React__default.createElement("div", {
      ref: imageEnhancementContentsRef
    }, children, absolutePositionContent, (topLeftContent || topRightContent) && (/*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$15.imageEnhancementsContentRow, styles$15.imageEnhancementsContentRowTop, !padding && styles$15.imageEnhancementsContentRowPaddingReset)
    }, contentGroup(topLeftContent, topRightContent, topTextColor, prioritizedContent))), (bottomLeftContent || bottomRightContent) && (/*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$15.imageEnhancementsContentRow, styles$15.imageEnhancementsContentRowBottom, !padding && styles$15.imageEnhancementsContentRowPaddingReset)
    }, contentGroup(bottomLeftContent, bottomRightContent, bottomTextColor, prioritizedContent)))), bottomCenterContent && (/*#__PURE__*/React__default.createElement("div", {
      className: styles$15.imageEnhancementsBottonCenterContent,
      style: {
        minHeight: "".concat(minHeight, "px")
      }
    }, bottomCenterContent)));
  });
};
ImageEnhancements.displayName = 'CoreImageEnhancements';
ImageEnhancements.defaultProps = {
  bottomTextColor: {
    left: 'black',
    right: 'black'
  },
  padding: true,
  topTextColor: {
    left: 'black',
    right: 'black'
  }
};

var styles$16 = {"image-overlay":"fr-ec-image-overlay","imageOverlay":"fr-ec-image-overlay","image-overlay__content":"fr-ec-image-overlay__content","imageOverlayContent":"fr-ec-image-overlay__content","image-overlay__content-light":"fr-ec-image-overlay__content-light","imageOverlayContentLight":"fr-ec-image-overlay__content-light","image-overlay--element-div":"fr-ec-image-overlay--element-div","imageOverlayElementDiv":"fr-ec-image-overlay--element-div","image-overlay__label":"fr-ec-image-overlay__label","imageOverlayLabel":"fr-ec-image-overlay__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","image-overlay__label-light":"fr-ec-image-overlay__label-light","imageOverlayLabelLight":"fr-ec-image-overlay__label-light","image-overlay__label--text-align-left":"fr-ec-image-overlay__label--text-align-left","imageOverlayLabelTextAlignLeft":"fr-ec-image-overlay__label--text-align-left","image-overlay__label--text-align-center":"fr-ec-image-overlay__label--text-align-center","imageOverlayLabelTextAlignCenter":"fr-ec-image-overlay__label--text-align-center","image-overlay__label--text-align-right":"fr-ec-image-overlay__label--text-align-right","imageOverlayLabelTextAlignRight":"fr-ec-image-overlay__label--text-align-right"};

var ImageOverlay = function ImageOverlay(_a) {
  var Element = _a.element,
    children = _a.children,
    className = _a.className,
    content = _a.content,
    _b = _a.textAlign,
    textAlign = _b === void 0 ? 'left' : _b,
    _c = _a.typography,
    typography = _c === void 0 ? 'title' : _c,
    _d = _a.imageOverlayType,
    imageOverlayType = _d === void 0 ? 'default' : _d,
    props = __rest$1(_a, ["element", "children", "className", "content", "textAlign", "typography", "imageOverlayType"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$16.imageOverlay, Element === 'button' && resetStyles.buttonReset, Element === 'div' && styles$16.imageOverlayElementDiv, className)
    }, props), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$16.imageOverlayContent, imageOverlayType === 'light' && styles$16.imageOverlayContentLight),
      tabIndex: 0
    }, typography === 'caption' ? (/*#__PURE__*/createElement(Caption, {
      className: joinClasses(styles$16.imageOverlayLabel, imageOverlayType === 'light' && styles$16.imageOverlayLabelLight, styles$16["image-overlay__label--text-align-".concat(textAlign)]),
      element: "span",
      variant: "standard"
    }, content)) : (/*#__PURE__*/createElement(Title, {
      className: joinClasses(styles$16.imageOverlayLabel, imageOverlayType === 'light' && styles$16.imageOverlayLabelLight, styles$16["image-overlay__label--text-align-".concat(textAlign)]),
      element: "span",
      variant: "standard"
    }, content))), children)
  );
};
ImageOverlay.displayName = 'CoreImageOverlay';

var styles$17 = {"image-typography__image-wrapper":"fr-ec-image-typography__image-wrapper","imageTypographyImageWrapper":"fr-ec-image-typography__image-wrapper","image-typography__image-wrapper--8":"fr-ec-image-typography__image-wrapper--8","imageTypographyImageWrapper8":"fr-ec-image-typography__image-wrapper--8","image-typography__image-wrapper--12":"fr-ec-image-typography__image-wrapper--12","imageTypographyImageWrapper12":"fr-ec-image-typography__image-wrapper--12","image-typography__image-wrapper--16":"fr-ec-image-typography__image-wrapper--16","imageTypographyImageWrapper16":"fr-ec-image-typography__image-wrapper--16","image-typography__image--20":"fr-ec-image-typography__image--20","imageTypographyImage20":"fr-ec-image-typography__image--20","image-typography__image--24":"fr-ec-image-typography__image--24","imageTypographyImage24":"fr-ec-image-typography__image--24","image-typography__image--48":"fr-ec-image-typography__image--48","imageTypographyImage48":"fr-ec-image-typography__image--48","image-typography__image--68":"fr-ec-image-typography__image--68","imageTypographyImage68":"fr-ec-image-typography__image--68"};

var ImageTypography = function ImageTypography(_a) {
  var src = _a.src,
    alt = _a.alt,
    _b = _a.spacing,
    spacing = _b === void 0 ? '8' : _b,
    _c = _a.imageHeight,
    imageHeight = _c === void 0 ? '20' : _c,
    _d = _a.alignment,
    alignment = _d === void 0 ? 'flex-start' : _d,
    children = _a.children,
    props = __rest$1(_a, ["src", "alt", "spacing", "imageHeight", "alignment", "children"]);
  return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
    element: "span",
    direction: "row",
    alignment: alignment
  }, props), /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$17.imageTypographyImageWrapper, styles$17["image-typography__image-wrapper--".concat(spacing)])
  }, src && /*#__PURE__*/createElement("img", {
    className: styles$17["image-typography__image--".concat(imageHeight)],
    src: src,
    alt: alt
  })), children));
};
ImageTypography.displayName = 'CoreImageTypography';

var styles$18 = {"link-cell":"fr-ec-link-cell","linkCell":"fr-ec-link-cell","link-cell__variant-small":"fr-ec-link-cell__variant-small","linkCellVariantSmall":"fr-ec-link-cell__variant-small","link-cell__variant-large":"fr-ec-link-cell__variant-large","linkCellVariantLarge":"fr-ec-link-cell__variant-large","link-cell__variant-noPadding":"fr-ec-link-cell__variant-noPadding","linkCellVariantNoPadding":"fr-ec-link-cell__variant-noPadding","link-cell__label-wrapper":"fr-ec-link-cell__label-wrapper","linkCellLabelWrapper":"fr-ec-link-cell__label-wrapper","link-cell__no-padding-wrapper":"fr-ec-link-cell__no-padding-wrapper","linkCellNoPaddingWrapper":"fr-ec-link-cell__no-padding-wrapper","link-cell__with-large-icon-media-wrapper":"fr-ec-link-cell__with-large-icon-media-wrapper","linkCellWithLargeIconMediaWrapper":"fr-ec-link-cell__with-large-icon-media-wrapper","link-cell__with-large-icon-wrapper":"fr-ec-link-cell__with-large-icon-wrapper","linkCellWithLargeIconWrapper":"fr-ec-link-cell__with-large-icon-wrapper","link-cell__icon--start":"fr-ec-link-cell__icon--start","linkCellIconStart":"fr-ec-link-cell__icon--start","link-cell__icon--end":"fr-ec-link-cell__icon--end","linkCellIconEnd":"fr-ec-link-cell__icon--end","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","link-cell__chevron-icon":"fr-ec-link-cell__chevron-icon","linkCellChevronIcon":"fr-ec-link-cell__chevron-icon","link-cell__label":"fr-ec-link-cell__label","linkCellLabel":"fr-ec-link-cell__label"};

var LinkCell = function LinkCell(_a) {
  var _b = _a.chevron,
    chevron = _b === void 0 ? false : _b,
    label = _a.label,
    element = _a.element,
    _c = _a.iconPosition,
    iconPosition = _c === void 0 ? 'start' : _c,
    className = _a.className,
    icon = _a.icon,
    href = _a.href,
    to = _a.to,
    _d = _a.wordBreak,
    wordBreak = _d === void 0 ? 'none' : _d,
    _e = _a.isGenderTypography,
    isGenderTypography = _e === void 0 ? false : _e,
    gaCategory = _a.gaCategory,
    gaAction = _a.gaAction,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    _f = _a.variant,
    variant = _f === void 0 ? 'large' : _f,
    iconBrand = _a.iconBrand,
    onClick = _a.onClick,
    contentWithNoPadding = _a.contentWithNoPadding,
    media = _a.media,
    props = __rest$1(_a, ["chevron", "label", "element", "iconPosition", "className", "icon", "href", "to", "wordBreak", "isGenderTypography", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "variant", "iconBrand", "onClick", "contentWithNoPadding", "media"]);
  var Element = element;
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var handleClick = function handleClick(e) {
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
    // For callback
    if (onClick) {
      onClick(e);
    }
  };
  var iconTemplate = icon ? (/*#__PURE__*/createElement(Icon, {
    className: iconPosition === 'start' ? styles$18.linkCellIconStart : styles$18.linkCellIconEnd,
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
    key: "icon-key",
    size: variant === 'withLargeIcon' ? '68' : '24'
  })) : media ? (/*#__PURE__*/createElement("div", {
    className: styles$18.linkCellWithLargeIconMediaWrapper
  }, media)) : '';
  var content = contentWithNoPadding ? iconPosition === 'end' ? variant !== 'withLargeIcon' ? (/*#__PURE__*/createElement("div", null, contentWithNoPadding, iconTemplate)) : (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", null, contentWithNoPadding), iconTemplate)) : (/*#__PURE__*/createElement("div", null, contentWithNoPadding)) : iconPosition === 'end' ? variant !== 'withLargeIcon' ? (/*#__PURE__*/createElement(Body, {
    className: styles$18.linkCellLabel,
    element: "p"
  }, label, iconTemplate)) : (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Body, {
    className: styles$18.linkCellLabel,
    element: "p"
  }, label), iconTemplate)) : (/*#__PURE__*/createElement(Body, {
    className: styles$18.linkCellLabel,
    element: "p"
  }, label));
  var renderChildren = !isGenderTypography ? iconPosition === 'end' ? (/*#__PURE__*/createElement(Fragment, null, content)) : (/*#__PURE__*/createElement(Fragment, null, iconTemplate, content)) : iconPosition === 'end' ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("span", {
    className: joinClasses(typographyStyles.genderStandard, styles$18.linkCellLabel, textTransformStyles.textTransformAllCaps)
  }, label), iconTemplate)) : (/*#__PURE__*/createElement(Fragment, null, iconTemplate, /*#__PURE__*/createElement("span", {
    className: joinClasses(typographyStyles.genderStandard, styles$18.linkCellLabel, textTransformStyles.textTransformAllCaps)
  }, label)));
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(styles$18.linkCell, styles$18["link-cell__variant-".concat(variant)], interactionsStyles.cursorPointer, addWordBreak(wordBreak === 'break-word'), className),
      onClick: handleClick
    }, !props.disabled ? {
      href: href,
      to: to
    } : {}, gaProps, props), /*#__PURE__*/createElement("div", {
      className: joinClasses(contentWithNoPadding ? styles$18.linkCellNoPaddingWrapper : styles$18.linkCellLabelWrapper, variant === 'withLargeIcon' && styles$18.linkCellWithLargeIconWrapper)
    }, renderChildren), chevron && (/*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand, "chevron-right") : 'chevron-right',
      className: styles$18.linkCellChevronIcon
    })))
  );
};
LinkCell.displayName = 'CoreLinkCell';
LinkCell.defaultProps = {
  disabled: false,
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var LinkImageGroup = function LinkImageGroup(_a) {
  var children = _a.children,
    className = _a.className,
    props = __rest$1(_a, ["children", "className"]);
  return /*#__PURE__*/createElement(CollectionListHorizontal, __assign$1({
    children: children,
    spacingValue: "16",
    className: className
  }, props));
};
LinkImageGroup.displayName = 'CoreLinkImageGroup';

var styles$19 = {"link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","link-navigation__icon--start":"fr-ec-link-navigation__icon--start","linkNavigationIconStart":"fr-ec-link-navigation__icon--start","link-navigation__icon--end":"fr-ec-link-navigation__icon--end","linkNavigationIconEnd":"fr-ec-link-navigation__icon--end","link-navigation__icon--alignment":"fr-ec-link-navigation__icon--alignment","linkNavigationIconAlignment":"fr-ec-link-navigation__icon--alignment"};

var LinkNavigation = function LinkNavigation(_a) {
  var Element = _a.element,
    _b = _a.selected,
    selected = _b === void 0 ? false : _b,
    className = _a.className,
    children = _a.children,
    icon = _a.icon,
    _c = _a.iconPosition,
    iconPosition = _c === void 0 ? 'end' : _c,
    gaCategory = _a.gaCategory,
    gaAction = _a.gaAction,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    onClick = _a.onClick,
    _d = _a.variant,
    variant = _d === void 0 ? 'TitleStandard' : _d,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["element", "selected", "className", "children", "icon", "iconPosition", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "onClick", "variant", "iconBrand"]);
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var titleVariant = {
    TitleSmall: selected ? 'small-emphasized' : 'small',
    TitleStandard: selected ? 'standard-emphasized' : 'standard'
  };
  var iconTemplate = icon && (/*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
    className: joinClasses(styles$19["link-navigation__icon--".concat(iconPosition)], styles$19["link-navigation__icon--alignment"]),
    key: "icon-key"
  }));
  var renderChildren = /*#__PURE__*/createElement(Title, {
    element: "p",
    variant: titleVariant[variant],
    key: "child-key"
  }, children);
  var childrenWithIcon = /*#__PURE__*/createElement(Title, {
    element: "p",
    variant: selected ? 'standard-emphasized' : 'standard'
  }, iconPosition === 'end' ? [children, iconTemplate] : [iconTemplate, children]);
  var handleClick = function handleClick(e) {
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
    if (onClick) {
      onClick(e);
    }
  };
  return (
    /*#__PURE__*/
    // @ts-ignore-next-line
    createElement(Element, __assign$1({
      className: joinClasses(styles$19.linkNavigation, Element === 'button' && resetStyles.buttonReset, interactionsStyles.cursorPointer, className),
      // @ts-ignore-next-line
      onClick: handleClick
    }, gaProps, props), icon ? (/*#__PURE__*/createElement(ContentAlignment, {
      element: "span",
      direction: "row",
      alignment: "center"
    }, childrenWithIcon)) : renderChildren)
  );
};
LinkNavigation.displayName = 'CoreLinkNavigation';
LinkNavigation.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  iconPosition: 'end',
  selected: false,
  variant: 'TitleStandard'
};

var styles$1a = {"link-navigation-group__list":"fr-ec-link-navigation-group__list","linkNavigationGroupList":"fr-ec-link-navigation-group__list","link-navigation-group__list--horizontal":"fr-ec-link-navigation-group__list--horizontal","linkNavigationGroupListHorizontal":"fr-ec-link-navigation-group__list--horizontal","link-navigation-group__list--indented":"fr-ec-link-navigation-group__list--indented","linkNavigationGroupListIndented":"fr-ec-link-navigation-group__list--indented","link-navigation-group__item--vertical":"fr-ec-link-navigation-group__item--vertical","linkNavigationGroupItemVertical":"fr-ec-link-navigation-group__item--vertical","link-navigation-group__item--vertical-large":"fr-ec-link-navigation-group__item--vertical-large","linkNavigationGroupItemVerticalLarge":"fr-ec-link-navigation-group__item--vertical-large","link-navigation-group__legend-vertical":"fr-ec-link-navigation-group__legend-vertical","linkNavigationGroupLegendVertical":"fr-ec-link-navigation-group__legend-vertical","link-navigation-group__legend-vertical-large":"fr-ec-link-navigation-group__legend-vertical-large","linkNavigationGroupLegendVerticalLarge":"fr-ec-link-navigation-group__legend-vertical-large","link-navigation-group__legend-dynamic":"fr-ec-link-navigation-group__legend-dynamic","linkNavigationGroupLegendDynamic":"fr-ec-link-navigation-group__legend-dynamic","link-navigation-group__legend-horizontal":"fr-ec-link-navigation-group__legend-horizontal","linkNavigationGroupLegendHorizontal":"fr-ec-link-navigation-group__legend-horizontal","link-navigation-group__item--horizontal":"fr-ec-link-navigation-group__item--horizontal","linkNavigationGroupItemHorizontal":"fr-ec-link-navigation-group__item--horizontal","link-navigation-group__list--horizontal-small":"fr-ec-link-navigation-group__list--horizontal-small","linkNavigationGroupListHorizontalSmall":"fr-ec-link-navigation-group__list--horizontal-small","link-navigation-group__item--dynamic":"fr-ec-link-navigation-group__item--dynamic","linkNavigationGroupItemDynamic":"fr-ec-link-navigation-group__item--dynamic","link-navigation-group__list--dynamic":"fr-ec-link-navigation-group__list--dynamic","linkNavigationGroupListDynamic":"fr-ec-link-navigation-group__list--dynamic"};

var LinkNavigationGroup = function LinkNavigationGroup(_a) {
  var children = _a.children,
    legend = _a.legend,
    indented = _a.indented,
    _b = _a.variant,
    variant = _b === void 0 ? 'vertical' : _b,
    className = _a.className,
    labelId = _a.labelId,
    props = __rest$1(_a, ["children", "legend", "indented", "variant", "className", "labelId"]);
  return /*#__PURE__*/createElement(Fragment, null, legend && (/*#__PURE__*/createElement(Title, {
    element: "h5",
    variant: "large",
    id: labelId,
    className: styles$1a["link-navigation-group__legend-".concat(variant)]
  }, legend)), /*#__PURE__*/createElement("ul", __assign$1({
    className: joinClasses(styles$1a.linkNavigationGroupList, (variant === 'vertical' || variant === 'vertical-large') && indented && styles$1a.linkNavigationGroupListIndented, styles$1a["link-navigation-group__list--".concat(variant)], className)
  }, legend && {
    'aria-labelledby': labelId
  }, props), Children.map(children, function (child, i) {
    var variantType = variant === 'vertical-large' ? 'TitleStandard' : 'TitleSmall';
    return /*#__PURE__*/createElement("li", {
      key: child.key || i,
      className: joinClasses(styles$1a["link-navigation-group__item--".concat(variant)])
    }, /*#__PURE__*/cloneElement(child, {
      variant: variantType
    }));
  })));
};
LinkNavigationGroup.displayName = 'CoreLinkNavigationGroup';
LinkNavigationGroup.defaultProps = {
  indented: false
};

var styles$1b = {"link-primary-nav":"fr-ec-link-primary-nav","linkPrimaryNav":"fr-ec-link-primary-nav","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","link-primary-nav__text-wrapper":"fr-ec-link-primary-nav__text-wrapper","linkPrimaryNavTextWrapper":"fr-ec-link-primary-nav__text-wrapper","label":"fr-ec-label"};

var LinkPrimaryNav = function LinkPrimaryNav(_a) {
  var Element = _a.element,
    children = _a.children,
    className = _a.className,
    onClick = _a.onClick,
    onMouseEnter = _a.onMouseEnter,
    onMouseLeave = _a.onMouseLeave,
    _b = _a.isHeader,
    isHeader = _b === void 0 ? false : _b,
    props = __rest$1(_a, ["element", "children", "className", "onClick", "onMouseEnter", "onMouseLeave", "isHeader"]);
  var isTouchDevices = isTouchDevice('touchPoints');
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(resetStyles.buttonReset, styles$1b.linkPrimaryNav, className)
    }, isHeader ? !isTouchDevices ? {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: onClick
    } : {
      onClick: onClick
    } : {
      onClick: onClick
    }, props), /*#__PURE__*/createElement(Label, {
      element: "span",
      className: joinClasses(styles$1b.linkPrimaryNavTextWrapper, typographyStyles.genderStandard)
    }, children))
  );
};
LinkPrimaryNav.displayName = 'CoreLinkPrimaryNav';

var styles$1c = {"collection-list-horizontal--large":"fr-ec-collection-list-horizontal--large","collectionListHorizontalLarge":"fr-ec-collection-list-horizontal--large","link-text-group":"fr-ec-link-text-group","linkTextGroup":"fr-ec-link-text-group","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","collection-list-horizontal--divider":"fr-ec-collection-list-horizontal--divider","collectionListHorizontalDivider":"fr-ec-collection-list-horizontal--divider"};

var LinkTextGroup = function LinkTextGroup(_a) {
  var children = _a.children,
    className = _a.className,
    _b = _a.variant,
    variant = _b === void 0 ? 'horizontal' : _b,
    props = __rest$1(_a, ["children", "className", "variant"]);
  return /*#__PURE__*/createElement(CollectionListHorizontal, __assign$1({
    children: children,
    divider: variant === 'divided',
    spacingValue: variant === 'divided' ? '8' : '16',
    className: joinClasses(styles$1c.linkTextGroup, className)
  }, props));
};
LinkTextGroup.displayName = 'CoreLinkTextGroup';
LinkTextGroup.defaultProps = {
  variant: 'horizontal'
};

var styles$1d = {"list":"fr-ec-list","list--secondary":"fr-ec-list--secondary","listSecondary":"fr-ec-list--secondary","list--has-spacing":"fr-ec-list--has-spacing","listHasSpacing":"fr-ec-list--has-spacing"};

var List = function List(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'primary' : _b,
    Element = _a.element,
    className = _a.className,
    children = _a.children,
    _c = _a.start,
    start = _c === void 0 ? 1 : _c,
    _d = _a.spacing,
    spacing = _d === void 0 ? true : _d,
    props = __rest$1(_a, ["variant", "element", "className", "children", "start", "spacing"]);
  var childElement = Children.map(children, function (listItem, i) {
    return /*#__PURE__*/cloneElement(listItem, {
      className: listItem.type === 'li' ? typographyStyles.bodyStandard : ''
    });
  });
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$1d.list, bodyStyles.body, variant === 'secondary' && styles$1d.listSecondary, spacing && styles$1d.listHasSpacing, className),
    style: Element === 'ol' ? {
      '--li-counter': start - 1
    } : {}
  }, props), childElement);
};
List.displayName = 'CoreList';
List.defaultProps = {
  start: 1,
  variant: 'primary'
};

var styles$1e = {"tile":"fr-ec-tile","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","tile--default":"fr-ec-tile--default","tileDefault":"fr-ec-tile--default","tile--fill":"fr-ec-tile--fill","tileFill":"fr-ec-tile--fill"};

var Tile = function Tile(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'a' : _b,
    className = _a.className,
    _c = _a.variant,
    variant = _c === void 0 ? 'default' : _c,
    gaAction = _a.gaAction,
    gaCategory = _a.gaCategory,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    onClick = _a.onClick,
    _d = _a.activeTabName,
    activeTabName = _d === void 0 ? '' : _d,
    props = __rest$1(_a, ["element", "className", "variant", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "onClick", "activeTabName"]);
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var onClickHandler = function onClickHandler(e) {
    // For callback
    if (onClick) {
      onClick(e, activeTabName);
    }
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel, gaAction);
    }
  };
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      tabIndex: 0,
      className: joinClasses(styles$1e.tile, Element === 'button' && resetStyles.buttonReset, styles$1e["tile--".concat(variant)], interactionsStyles.cursorPointer, className),
      onClick: onClickHandler
    }, gaProps, props))
  );
};
Tile.displayName = 'CoreTile';
Tile.defaultProps = {
  activeTabName: '',
  element: 'a',
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  variant: 'default'
};

var styles$1f = {"loading-indicator":"fr-ec-loading-indicator","loadingIndicator":"fr-ec-loading-indicator","loading-indicator--normal":"fr-ec-loading-indicator--normal","loadingIndicatorNormal":"fr-ec-loading-indicator--normal","loading-indicator__spinner-container":"fr-ec-loading-indicator__spinner-container","loadingIndicatorSpinnerContainer":"fr-ec-loading-indicator__spinner-container","loading-indicator__spinner-container--small":"fr-ec-loading-indicator__spinner-container--small","loadingIndicatorSpinnerContainerSmall":"fr-ec-loading-indicator__spinner-container--small","loading-indicator--first-logo":"fr-ec-loading-indicator--first-logo","loadingIndicatorFirstLogo":"fr-ec-loading-indicator--first-logo","loading-indicator--jp-logo-third":"fr-ec-loading-indicator--jp-logo-third","loadingIndicatorJpLogoThird":"fr-ec-loading-indicator--jp-logo-third","logo-translate":"fr-ec-logo-translate","logoTranslate":"fr-ec-logo-translate","loading-indicator--jp-logo-first":"fr-ec-loading-indicator--jp-logo-first","loadingIndicatorJpLogoFirst":"fr-ec-loading-indicator--jp-logo-first","logo-translate-down":"fr-ec-logo-translate-down","logoTranslateDown":"fr-ec-logo-translate-down","loading-indicator--jp-logo-second":"fr-ec-loading-indicator--jp-logo-second","loadingIndicatorJpLogoSecond":"fr-ec-loading-indicator--jp-logo-second","loading-indicator__container":"fr-ec-loading-indicator__container","loadingIndicatorContainer":"fr-ec-loading-indicator__container","loading-indicator__container-uq-logos":"fr-ec-loading-indicator__container-uq-logos","loadingIndicatorContainerUqLogos":"fr-ec-loading-indicator__container-uq-logos","loading-indicator--full-screen":"fr-ec-loading-indicator--full-screen","loadingIndicatorFullScreen":"fr-ec-loading-indicator--full-screen","loading-indicator--overlay":"fr-ec-loading-indicator--overlay","loadingIndicatorOverlay":"fr-ec-loading-indicator--overlay","loading-indicator--overlay-l1":"fr-ec-loading-indicator--overlay-l1","loadingIndicatorOverlayL1":"fr-ec-loading-indicator--overlay-l1","loading-indicator__spinner":"fr-ec-loading-indicator__spinner","loadingIndicatorSpinner":"fr-ec-loading-indicator__spinner","loader-spin":"fr-ec-loader-spin","loaderSpin":"fr-ec-loader-spin","loading-indicator__spinner-2":"fr-ec-loading-indicator__spinner-2","loadingIndicatorSpinner2":"fr-ec-loading-indicator__spinner-2","loading-indicator--l1-single-logo":"fr-ec-loading-indicator--l1-single-logo","loadingIndicatorL1SingleLogo":"fr-ec-loading-indicator--l1-single-logo","logo-opacity":"fr-ec-logo-opacity","logoOpacity":"fr-ec-logo-opacity"};

var UNIQLO_LOGO_JP = /*#__PURE__*/React__default.createElement("svg", {
  id: "loading-indicator-jp-logo",
  width: "45",
  height: "45",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "40",
  height: "40",
  fill: "#FF0000"
}), /*#__PURE__*/React__default.createElement("path", {
  id: "loading-indicator-jp-logo-path",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.7399 5.47021H7.14988V8.00021H12.2099V15.1602H5.89988V17.6802H17.2599V15.1602H14.7399V5.47021ZM32.8399 5.47021H23.9999V8.00021H32.8399V5.47021ZM34.0999 15.1602H22.7399V17.6802H34.0999V15.1602ZM22.7399 34.5302V22.3102H34.0999V34.5302H22.7399ZM31.5699 32.0002H25.2599V24.8402H31.5699V32.0002ZM5.86988 28.4302L7.14988 22.3102H17.2599L14.7399 34.5302H4.62988L5.13988 32.0002H12.7299L14.2199 24.8402H9.14988L8.38988 28.4302H5.86988Z",
  fill: "white"
}));
var UNIQLO_LOGO_EN = /*#__PURE__*/React__default.createElement("svg", {
  id: "loading-indicator-en-logo",
  width: "45",
  height: "45",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "40",
  height: "40",
  fill: "#FF0000"
}), /*#__PURE__*/React__default.createElement("path", {
  id: "loading-indicator-en-logo-path",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.21001 18.1061C11.5335 18.1061 13.4177 16.2237 13.42 13.9002V5.47021H10.89V13.9002C10.89 14.828 10.1378 15.5802 9.21001 15.5802C8.28221 15.5802 7.53001 14.828 7.53001 13.9002V5.47021H5.00001V13.9002C5.00231 16.2237 6.88651 18.1061 9.21001 18.1061ZM31.96 5.47021H29.43V18.1102H31.96V5.47021ZM25.21 34.5302H16.79V21.8902H19.32V32.0002H25.21V34.5302ZM22.68 18.1102H25.21V5.47021H22.68V12.6902L19.32 5.47021H16.79V18.1102H19.32V10.8902L22.68 18.1102ZM9.21001 21.8902C8.09171 21.8902 7.01941 22.3351 6.22951 23.1268C5.43971 23.9185 4.99731 24.9919 5.00001 26.1102V30.3202C5.00001 32.6453 6.88491 34.5302 9.21001 34.5302C9.48491 34.5329 9.75951 34.5095 10.03 34.4602L10.89 37.0602H13.42L12.17 33.3102C12.9724 32.5185 13.4228 31.4374 13.42 30.3102V26.1102C13.4227 24.9919 12.9803 23.9185 12.1905 23.1268C11.4006 22.3351 10.3283 21.8902 9.21001 21.8902ZM9.21001 32.0002C10.1378 32.0002 10.89 31.248 10.89 30.3202V26.1102C10.89 25.1824 10.1378 24.4302 9.21001 24.4302C8.28221 24.4302 7.53001 25.1824 7.53001 26.1102V30.3202C7.53001 31.248 8.28221 32.0002 9.21001 32.0002ZM30.685 21.8902C28.3567 21.8929 26.47 23.7813 26.47 26.1102V30.3202C26.47 32.6453 28.3549 34.5302 30.68 34.5302C33.0051 34.5302 34.89 32.6453 34.89 30.3202V26.1102C34.8926 24.9919 34.4503 23.9185 33.6605 23.1268C32.8718 22.3363 31.8015 21.8915 30.685 21.8902ZM30.685 21.8902L30.68 21.8902H30.69L30.685 21.8902ZM30.675 32.0052C31.6056 32.0052 32.36 31.2508 32.36 30.3202V26.1102C32.36 25.1796 31.6056 24.4252 30.675 24.4252C29.7444 24.4252 28.99 25.1796 28.99 26.1102V30.3202C28.99 31.2508 29.7444 32.0052 30.675 32.0052Z",
  fill: "white"
}));
var LIFE_WEAR_LOGO = /*#__PURE__*/React__default.createElement("svg", {
  id: "loading-indicator-LW-logo",
  width: "70",
  height: "14",
  viewBox: "0 0 70 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "70",
  height: "14",
  fill: "#fff"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M1.43816 0V11.4891H8.67768V12.9175H0V0H1.43816Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.2591 1.55828H10.6846V0H12.2591V1.55828ZM12.126 12.9207H10.7982V3.76585H12.126V12.9207Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M17.1194 12.9177H15.7884V5.37951H14.7041V4.06147H15.7884V2.39281C15.787 2.07022 15.8522 1.75082 15.9799 1.45459C16.0972 1.168 16.2717 0.908391 16.4929 0.691688C16.7179 0.468618 16.985 0.292587 17.2788 0.173864C17.5725 0.0551418 17.8869 -0.00389612 18.2037 0.000199376H19.2913V1.31824H18.2102C18.0673 1.31333 17.925 1.33769 17.7918 1.38982C17.6587 1.44196 17.5376 1.52077 17.4361 1.62141C17.3345 1.72206 17.2546 1.84241 17.2013 1.97506C17.1479 2.10772 17.1223 2.24988 17.1259 2.39281V4.06147H18.9959V5.37951H17.1259L17.1194 12.9177Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22.2462 9.50225C22.2453 9.79585 22.3084 10.0861 22.4312 10.3528C22.5431 10.6121 22.7015 10.8486 22.8987 11.0508C23.1056 11.2611 23.3531 11.4271 23.6263 11.5386C23.8994 11.6501 24.1924 11.7048 24.4874 11.6994C24.7824 11.6939 25.0731 11.6284 25.342 11.5068C25.6108 11.3853 25.852 11.2102 26.051 10.9924L26.9892 11.9436C26.6629 12.2909 26.2668 12.5653 25.827 12.7487C25.3882 12.9285 24.9182 13.0201 24.444 13.0181C23.9708 13.0206 23.5023 12.9255 23.0675 12.7389C22.6493 12.562 22.2691 12.3063 21.9475 11.9858C21.6211 11.6615 21.3625 11.2754 21.1869 10.8501C21.0114 10.4249 20.9223 9.96884 20.9249 9.50874V7.18755C20.9281 6.60782 21.0743 6.03784 21.3504 5.52808C21.6265 5.01832 22.024 4.58452 22.5078 4.26509C22.9916 3.94566 23.5467 3.75046 24.124 3.69679C24.7012 3.64311 25.2828 3.73261 25.8172 3.95736C26.2362 4.13458 26.6174 4.39022 26.9405 4.71053C27.256 5.02687 27.5103 5.39891 27.6904 5.80782C27.8793 6.23858 27.9755 6.70423 27.9728 7.17456V8.49585H22.2462V9.50225ZM26.645 7.22975C26.6467 6.92418 26.586 6.62148 26.4665 6.34023C26.3556 6.07559 26.1972 5.83352 25.999 5.62602C25.8047 5.41932 25.5676 5.25756 25.3043 5.15204C25.0346 5.04087 24.7454 4.98459 24.4537 4.98648C24.1638 4.97627 23.8751 5.02705 23.6061 5.13554C23.3371 5.24403 23.0939 5.40782 22.8922 5.61628C22.4774 6.05519 22.2452 6.63558 22.2429 7.23949L26.645 7.22975Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M39.7425 10.4697L42.661 0H44.1024L40.3983 12.9175H38.9764L36.5837 2.70751L34.1879 12.9175H32.7627L29.0391 0H30.4805L33.399 10.4697L35.8695 0H37.2915L39.7425 10.4697Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M46.5339 9.50271C46.5319 9.79364 46.5928 10.0816 46.7124 10.3468C46.8243 10.606 46.9828 10.8426 47.1799 11.0448C47.5882 11.456 48.1425 11.6894 48.722 11.694C49.0276 11.7003 49.3309 11.6403 49.6112 11.5181C49.8914 11.3959 50.1418 11.2145 50.3452 10.9863L51.2802 11.9375C50.9557 12.2855 50.5605 12.56 50.1212 12.7426C49.6813 12.9228 49.2103 13.0143 48.735 13.0121C48.2629 13.0146 47.7954 12.9195 47.3617 12.7329C46.9387 12.5564 46.5539 12.2996 46.2287 11.9765C45.9023 11.6522 45.6438 11.2662 45.4682 10.8409C45.2926 10.4156 45.2035 9.95956 45.2061 9.49946V7.17827C45.2094 6.59854 45.3555 6.02856 45.6316 5.5188C45.9077 5.00904 46.3053 4.57524 46.7891 4.25581C47.2729 3.93638 47.828 3.74118 48.4052 3.68751C48.9825 3.63383 49.5641 3.72333 50.0985 3.94808C50.5178 4.12459 50.8992 4.38032 51.2217 4.70125C51.5393 5.02036 51.7947 5.39576 51.9749 5.80828C52.1612 6.23974 52.2562 6.70507 52.2541 7.17503V8.49632H46.5339V9.50271ZM50.9328 7.23021C50.9361 6.92449 50.8753 6.62147 50.7542 6.34069C50.6422 6.07669 50.4839 5.83482 50.2868 5.62648C50.0922 5.42156 49.8566 5.26004 49.5953 5.1525C49.3243 5.04166 49.0342 4.98539 48.7415 4.98694C48.4516 4.97673 48.1628 5.02751 47.8938 5.136C47.6248 5.2445 47.3816 5.40828 47.1799 5.61674C46.7651 6.05565 46.533 6.63604 46.5306 7.23995L50.9328 7.23021Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M59.8943 7.1815C59.8952 6.89034 59.8332 6.60243 59.7125 6.33744C59.5979 6.07809 59.4374 5.84162 59.2386 5.63945C59.0347 5.44126 58.7973 5.28079 58.5373 5.16548C58.2668 5.05249 57.9767 4.99402 57.6835 4.99342C57.2541 4.9905 56.834 5.11846 56.4791 5.36026C56.1184 5.59852 55.8351 5.93705 55.6643 6.33419L54.4306 5.83424C54.7026 5.18333 55.1612 4.62754 55.7487 4.237C56.3254 3.85387 57.0042 3.65361 57.6965 3.66239C58.1664 3.65817 58.6319 3.75217 59.0633 3.93833C59.4784 4.11739 59.8561 4.37288 60.1768 4.6915C60.4969 5.0104 60.7536 5.38716 60.9332 5.80177C61.1221 6.23254 61.2183 6.69818 61.2156 7.16852V12.9179H59.8684V11.7882C59.6221 12.1439 59.2917 12.4333 58.9065 12.6304C58.5214 12.8275 58.0934 12.9263 57.6608 12.9179H56.8752C56.5102 12.9219 56.1485 12.8489 55.8136 12.7037C55.4935 12.5693 55.2024 12.3741 54.9565 12.129C54.7088 11.8852 54.5114 11.5951 54.3754 11.2752C54.2324 10.9454 54.1595 10.5894 54.1612 10.2299C54.1592 9.86719 54.2321 9.50799 54.3754 9.1748C54.5131 8.85679 54.7103 8.56807 54.9565 8.32424C55.2041 8.08124 55.4948 7.88638 55.8136 7.74963C56.1485 7.6044 56.5102 7.5314 56.8752 7.53537H59.8879L59.8943 7.1815ZM56.8817 8.85666C56.7009 8.85308 56.5214 8.88636 56.3539 8.95445C56.1865 9.02254 56.0347 9.12403 55.9077 9.25272C55.65 9.51133 55.5053 9.86155 55.5053 10.2266C55.5053 10.5917 55.65 10.942 55.9077 11.2006C56.035 11.3291 56.1868 11.4307 56.3541 11.4993C56.5214 11.5679 56.7008 11.6021 56.8817 11.5999H57.6673C57.9731 11.5996 58.2745 11.5273 58.5471 11.3889C58.8207 11.2476 59.0617 11.0508 59.2548 10.811C59.4633 10.5544 59.6229 10.2617 59.7255 9.94745C59.8401 9.59529 59.8971 9.22697 59.8943 8.85666H56.8817Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M63.9502 3.76599H65.2812V4.6198C65.8721 4.05994 66.6586 3.7535 67.4726 3.76599C68.4193 3.76482 69.3278 4.13965 69.9983 4.80809L69.0438 5.78202C68.8464 5.56206 68.6038 5.38729 68.3326 5.26964C68.0614 5.15198 67.7681 5.09422 67.4726 5.10027C67.1791 5.09772 66.8883 5.15632 66.6188 5.27233C66.3615 5.38582 66.1272 5.54534 65.9273 5.74306C65.7325 5.94717 65.5744 6.18327 65.4598 6.44104C65.3405 6.7075 65.2796 6.99641 65.2812 7.28835V12.9176H63.9502V3.76599Z",
  fill: "black"
}));
var UNIQLO_LOGO_SINGLE_EN = /*#__PURE__*/React__default.createElement("svg", {
  width: "60",
  height: "60",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "40",
  height: "40",
  fill: "#FF0000"
}), /*#__PURE__*/React__default.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.21001 18.1061C11.5335 18.1061 13.4177 16.2237 13.42 13.9002V5.47021H10.89V13.9002C10.89 14.828 10.1378 15.5802 9.21001 15.5802C8.28221 15.5802 7.53001 14.828 7.53001 13.9002V5.47021H5.00001V13.9002C5.00231 16.2237 6.88651 18.1061 9.21001 18.1061ZM31.96 5.47021H29.43V18.1102H31.96V5.47021ZM25.21 34.5302H16.79V21.8902H19.32V32.0002H25.21V34.5302ZM22.68 18.1102H25.21V5.47021H22.68V12.6902L19.32 5.47021H16.79V18.1102H19.32V10.8902L22.68 18.1102ZM9.21001 21.8902C8.09171 21.8902 7.01941 22.3351 6.22951 23.1268C5.43971 23.9185 4.99731 24.9919 5.00001 26.1102V30.3202C5.00001 32.6453 6.88491 34.5302 9.21001 34.5302C9.48491 34.5329 9.75951 34.5095 10.03 34.4602L10.89 37.0602H13.42L12.17 33.3102C12.9724 32.5185 13.4228 31.4374 13.42 30.3102V26.1102C13.4227 24.9919 12.9803 23.9185 12.1905 23.1268C11.4006 22.3351 10.3283 21.8902 9.21001 21.8902ZM9.21001 32.0002C10.1378 32.0002 10.89 31.248 10.89 30.3202V26.1102C10.89 25.1824 10.1378 24.4302 9.21001 24.4302C8.28221 24.4302 7.53001 25.1824 7.53001 26.1102V30.3202C7.53001 31.248 8.28221 32.0002 9.21001 32.0002ZM30.685 21.8902C28.3567 21.8929 26.47 23.7813 26.47 26.1102V30.3202C26.47 32.6453 28.3549 34.5302 30.68 34.5302C33.0051 34.5302 34.89 32.6453 34.89 30.3202V26.1102C34.8926 24.9919 34.4503 23.9185 33.6605 23.1268C32.8718 22.3363 31.8015 21.8915 30.685 21.8902ZM30.685 21.8902L30.68 21.8902H30.69L30.685 21.8902ZM30.675 32.0052C31.6056 32.0052 32.36 31.2508 32.36 30.3202V26.1102C32.36 25.1796 31.6056 24.4252 30.675 24.4252C29.7444 24.4252 28.99 25.1796 28.99 26.1102V30.3202C28.99 31.2508 29.7444 32.0052 30.675 32.0052Z",
  fill: "white"
}));
var LIFE_WEAR_SINGLE_LOGO = /*#__PURE__*/React__default.createElement("svg", {
  width: "60",
  height: "12",
  viewBox: "0 0 70 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "70",
  height: "14",
  fill: "#fff"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M1.43816 0V11.4891H8.67768V12.9175H0V0H1.43816Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.2591 1.55828H10.6846V0H12.2591V1.55828ZM12.126 12.9207H10.7982V3.76585H12.126V12.9207Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M17.1194 12.9177H15.7884V5.37951H14.7041V4.06147H15.7884V2.39281C15.787 2.07022 15.8522 1.75082 15.9799 1.45459C16.0972 1.168 16.2717 0.908391 16.4929 0.691688C16.7179 0.468618 16.985 0.292587 17.2788 0.173864C17.5725 0.0551418 17.8869 -0.00389612 18.2037 0.000199376H19.2913V1.31824H18.2102C18.0673 1.31333 17.925 1.33769 17.7918 1.38982C17.6587 1.44196 17.5376 1.52077 17.4361 1.62141C17.3345 1.72206 17.2546 1.84241 17.2013 1.97506C17.1479 2.10772 17.1223 2.24988 17.1259 2.39281V4.06147H18.9959V5.37951H17.1259L17.1194 12.9177Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22.2462 9.50225C22.2453 9.79585 22.3084 10.0861 22.4312 10.3528C22.5431 10.6121 22.7015 10.8486 22.8987 11.0508C23.1056 11.2611 23.3531 11.4271 23.6263 11.5386C23.8994 11.6501 24.1924 11.7048 24.4874 11.6994C24.7824 11.6939 25.0731 11.6284 25.342 11.5068C25.6108 11.3853 25.852 11.2102 26.051 10.9924L26.9892 11.9436C26.6629 12.2909 26.2668 12.5653 25.827 12.7487C25.3882 12.9285 24.9182 13.0201 24.444 13.0181C23.9708 13.0206 23.5023 12.9255 23.0675 12.7389C22.6493 12.562 22.2691 12.3063 21.9475 11.9858C21.6211 11.6615 21.3625 11.2754 21.1869 10.8501C21.0114 10.4249 20.9223 9.96884 20.9249 9.50874V7.18755C20.9281 6.60782 21.0743 6.03784 21.3504 5.52808C21.6265 5.01832 22.024 4.58452 22.5078 4.26509C22.9916 3.94566 23.5467 3.75046 24.124 3.69679C24.7012 3.64311 25.2828 3.73261 25.8172 3.95736C26.2362 4.13458 26.6174 4.39022 26.9405 4.71053C27.256 5.02687 27.5103 5.39891 27.6904 5.80782C27.8793 6.23858 27.9755 6.70423 27.9728 7.17456V8.49585H22.2462V9.50225ZM26.645 7.22975C26.6467 6.92418 26.586 6.62148 26.4665 6.34023C26.3556 6.07559 26.1972 5.83352 25.999 5.62602C25.8047 5.41932 25.5676 5.25756 25.3043 5.15204C25.0346 5.04087 24.7454 4.98459 24.4537 4.98648C24.1638 4.97627 23.8751 5.02705 23.6061 5.13554C23.3371 5.24403 23.0939 5.40782 22.8922 5.61628C22.4774 6.05519 22.2452 6.63558 22.2429 7.23949L26.645 7.22975Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M39.7425 10.4697L42.661 0H44.1024L40.3983 12.9175H38.9764L36.5837 2.70751L34.1879 12.9175H32.7627L29.0391 0H30.4805L33.399 10.4697L35.8695 0H37.2915L39.7425 10.4697Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M46.5339 9.50271C46.5319 9.79364 46.5928 10.0816 46.7124 10.3468C46.8243 10.606 46.9828 10.8426 47.1799 11.0448C47.5882 11.456 48.1425 11.6894 48.722 11.694C49.0276 11.7003 49.3309 11.6403 49.6112 11.5181C49.8914 11.3959 50.1418 11.2145 50.3452 10.9863L51.2802 11.9375C50.9557 12.2855 50.5605 12.56 50.1212 12.7426C49.6813 12.9228 49.2103 13.0143 48.735 13.0121C48.2629 13.0146 47.7954 12.9195 47.3617 12.7329C46.9387 12.5564 46.5539 12.2996 46.2287 11.9765C45.9023 11.6522 45.6438 11.2662 45.4682 10.8409C45.2926 10.4156 45.2035 9.95956 45.2061 9.49946V7.17827C45.2094 6.59854 45.3555 6.02856 45.6316 5.5188C45.9077 5.00904 46.3053 4.57524 46.7891 4.25581C47.2729 3.93638 47.828 3.74118 48.4052 3.68751C48.9825 3.63383 49.5641 3.72333 50.0985 3.94808C50.5178 4.12459 50.8992 4.38032 51.2217 4.70125C51.5393 5.02036 51.7947 5.39576 51.9749 5.80828C52.1612 6.23974 52.2562 6.70507 52.2541 7.17503V8.49632H46.5339V9.50271ZM50.9328 7.23021C50.9361 6.92449 50.8753 6.62147 50.7542 6.34069C50.6422 6.07669 50.4839 5.83482 50.2868 5.62648C50.0922 5.42156 49.8566 5.26004 49.5953 5.1525C49.3243 5.04166 49.0342 4.98539 48.7415 4.98694C48.4516 4.97673 48.1628 5.02751 47.8938 5.136C47.6248 5.2445 47.3816 5.40828 47.1799 5.61674C46.7651 6.05565 46.533 6.63604 46.5306 7.23995L50.9328 7.23021Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M59.8943 7.1815C59.8952 6.89034 59.8332 6.60243 59.7125 6.33744C59.5979 6.07809 59.4374 5.84162 59.2386 5.63945C59.0347 5.44126 58.7973 5.28079 58.5373 5.16548C58.2668 5.05249 57.9767 4.99402 57.6835 4.99342C57.2541 4.9905 56.834 5.11846 56.4791 5.36026C56.1184 5.59852 55.8351 5.93705 55.6643 6.33419L54.4306 5.83424C54.7026 5.18333 55.1612 4.62754 55.7487 4.237C56.3254 3.85387 57.0042 3.65361 57.6965 3.66239C58.1664 3.65817 58.6319 3.75217 59.0633 3.93833C59.4784 4.11739 59.8561 4.37288 60.1768 4.6915C60.4969 5.0104 60.7536 5.38716 60.9332 5.80177C61.1221 6.23254 61.2183 6.69818 61.2156 7.16852V12.9179H59.8684V11.7882C59.6221 12.1439 59.2917 12.4333 58.9065 12.6304C58.5214 12.8275 58.0934 12.9263 57.6608 12.9179H56.8752C56.5102 12.9219 56.1485 12.8489 55.8136 12.7037C55.4935 12.5693 55.2024 12.3741 54.9565 12.129C54.7088 11.8852 54.5114 11.5951 54.3754 11.2752C54.2324 10.9454 54.1595 10.5894 54.1612 10.2299C54.1592 9.86719 54.2321 9.50799 54.3754 9.1748C54.5131 8.85679 54.7103 8.56807 54.9565 8.32424C55.2041 8.08124 55.4948 7.88638 55.8136 7.74963C56.1485 7.6044 56.5102 7.5314 56.8752 7.53537H59.8879L59.8943 7.1815ZM56.8817 8.85666C56.7009 8.85308 56.5214 8.88636 56.3539 8.95445C56.1865 9.02254 56.0347 9.12403 55.9077 9.25272C55.65 9.51133 55.5053 9.86155 55.5053 10.2266C55.5053 10.5917 55.65 10.942 55.9077 11.2006C56.035 11.3291 56.1868 11.4307 56.3541 11.4993C56.5214 11.5679 56.7008 11.6021 56.8817 11.5999H57.6673C57.9731 11.5996 58.2745 11.5273 58.5471 11.3889C58.8207 11.2476 59.0617 11.0508 59.2548 10.811C59.4633 10.5544 59.6229 10.2617 59.7255 9.94745C59.8401 9.59529 59.8971 9.22697 59.8943 8.85666H56.8817Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M63.9502 3.76599H65.2812V4.6198C65.8721 4.05994 66.6586 3.7535 67.4726 3.76599C68.4193 3.76482 69.3278 4.13965 69.9983 4.80809L69.0438 5.78202C68.8464 5.56206 68.6038 5.38729 68.3326 5.26964C68.0614 5.15198 67.7681 5.09422 67.4726 5.10027C67.1791 5.09772 66.8883 5.15632 66.6188 5.27233C66.3615 5.38582 66.1272 5.54534 65.9273 5.74306C65.7325 5.94717 65.5744 6.18327 65.4598 6.44104C65.3405 6.7075 65.2796 6.99641 65.2812 7.28835V12.9176H63.9502V3.76599Z",
  fill: "black"
}));
var LoadingIndicator = function LoadingIndicator(_a) {
  var variant = _a.variant,
    override = _a.override,
    _b = _a.iconBrand,
    iconBrand = _b === void 0 ? 'uq-ec-' : _b,
    props = __rest$1(_a, ["variant", "override", "iconBrand"]);
  var width = getViewportWidth();
  var getOverrideVariant = function getOverrideVariant(breakpoint) {
    return override && override.hasOwnProperty(breakpoint) && override[breakpoint];
  };
  var activeFullScreen = function activeFullScreen() {
    if (typeof override !== 'undefined') {
      if (width >= designTokens_3.mqLargeScreenMinWidthLimit) {
        return getOverrideVariant(BP_LARGE);
      } else if (width >= designTokens_3.mqMediumScreenMinWidthLimit && width <= designTokens_3.mqMediumScreenMaxWidthLimit) {
        return getOverrideVariant(BP_MEDIUM);
      } else if (width <= designTokens_3.mqSmallScreenMaxWidthLimit) {
        return getOverrideVariant(BP_SMALL);
      }
    }
    return false;
  };
  var currentVariant = activeFullScreen() || variant;
  var hasOverlay = currentVariant === 'full-screen' || currentVariant === 'L1' || currentVariant === 'L1-single';
  var spinningLoader = /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1f.loadingIndicatorSpinnerContainer, variant === 'small' && styles$1f.loadingIndicatorSpinnerContainerSmall)
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1f.loadingIndicatorSpinner
  }), /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1f.loadingIndicatorSpinner, styles$1f.loadingIndicatorSpinner2)
  }));
  var getLoader = function getLoader() {
    if (variant === 'L1') {
      return /*#__PURE__*/React__default.createElement(ContentAlignment, {
        element: 'div',
        direction: 'column',
        className: styles$1f.loadingIndicatorContainer,
        alignment: "center"
      }, /*#__PURE__*/React__default.createElement(ContentAlignment, {
        element: 'div',
        direction: 'row',
        className: styles$1f.loadingIndicatorContainerUqLogos,
        alignment: "stretch"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorFirstLogo
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoFirst
      }, UNIQLO_LOGO_JP), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoSecond
      }, UNIQLO_LOGO_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoThird
      }, UNIQLO_LOGO_JP)), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorFirstLogo
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoFirst
      }, UNIQLO_LOGO_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoSecond
      }, UNIQLO_LOGO_JP), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoThird
      }, UNIQLO_LOGO_EN))), LIFE_WEAR_LOGO);
    } else if (variant === 'L1-single') {
      return /*#__PURE__*/React__default.createElement(ContentAlignment, {
        element: 'div',
        direction: 'column',
        className: styles$1f.loadingIndicatorContainer,
        alignment: "center"
      }, iconBrand === 'uq-ec-' ? (/*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorL1SingleLogo
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoFirst
      }, UNIQLO_LOGO_SINGLE_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoSecond
      }, UNIQLO_LOGO_SINGLE_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoThird
      }, UNIQLO_LOGO_SINGLE_EN)), LIFE_WEAR_SINGLE_LOGO)) : spinningLoader);
    }
    return spinningLoader;
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", __assign$1({
    className: joinClasses(styles$1f.loadingIndicator, styles$1f["loading-indicator--".concat(currentVariant)])
  }, props), getLoader()), hasOverlay && (/*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1f.loadingIndicatorOverlay, (currentVariant === 'L1' || currentVariant === 'L1-single') && styles$1f.loadingIndicatorOverlayL1)
  })));
};
LoadingIndicator.displayName = 'CoreLoadingIndicator';

var priceTextStyles = {"price-text--small":"fr-ec-price-text--small","priceTextSmall":"fr-ec-price-text--small","price-text--large":"fr-ec-price-text--large","priceTextLarge":"fr-ec-price-text--large","price-text--l1":"fr-ec-price-text--l1","priceTextL1":"fr-ec-price-text--l1","price-text--extra-small":"fr-ec-price-text--extra-small","priceTextExtraSmall":"fr-ec-price-text--extra-small","price-text--middle":"fr-ec-price-text--middle","priceTextMiddle":"fr-ec-price-text--middle"};

var styles$1g = {"price-text":"fr-ec-price-text","priceText":"fr-ec-price-text","price-text--color-primary-dark":"fr-ec-price-text--color-primary-dark","priceTextColorPrimaryDark":"fr-ec-price-text--color-primary-dark","price-text--color-primary-light":"fr-ec-price-text--color-primary-light","priceTextColorPrimaryLight":"fr-ec-price-text--color-primary-light","price-text--color-promotional":"fr-ec-price-text--color-promotional","priceTextColorPromotional":"fr-ec-price-text--color-promotional"};

var variants = {
  extraSmall: 'extra-small',
  l1: 'l1',
  large: 'large',
  small: 'small',
  middle: 'middle'
};
var PriceText = function PriceText(_a) {
  var Element = _a.element,
    _b = _a.variant,
    variant = _b === void 0 ? 'small' : _b,
    _c = _a.color,
    color = _c === void 0 ? 'primary-dark' : _c,
    className = _a.className,
    _d = _a.textTransform,
    textTransform = _d === void 0 ? 'normal' : _d,
    props = __rest$1(_a, ["element", "variant", "color", "className", "textTransform"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$1g.priceText, priceTextStyles["price-text--".concat(variants[variant])], styles$1g["price-text--color-".concat(color)], textTransformStyles["text-transform-".concat(textTransform)], className)
  }, props));
};
PriceText.displayName = 'CorePriceText';

var styles$1h = {"price":"fr-ec-price","price__wrapper":"fr-ec-price__wrapper","priceWrapper":"fr-ec-price__wrapper","price__children":"fr-ec-price__children","priceChildren":"fr-ec-price__children","price__original-price":"fr-ec-price__original-price","priceOriginalPrice":"fr-ec-price__original-price","price__mrp-prefix":"fr-ec-price__mrp-prefix","priceMrpPrefix":"fr-ec-price__mrp-prefix","price__amount":"fr-ec-price__amount","priceAmount":"fr-ec-price__amount","price__tax":"fr-ec-price__tax","priceTax":"fr-ec-price__tax","price__strike-through":"fr-ec-price__strike-through","priceStrikeThrough":"fr-ec-price__strike-through","price__discount":"fr-ec-price__discount","priceDiscount":"fr-ec-price__discount","price__amount--large":"fr-ec-price__amount--large","priceAmountLarge":"fr-ec-price__amount--large"};

var Price = function Price(_a) {
  var _b = _a.element,
    element = _b === void 0 ? 'span' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'standard' : _c,
    size = _a.size,
    className = _a.className,
    children = _a.children,
    tax = _a.tax,
    _d = _a.ariaLabel,
    ariaLabel = _d === void 0 ? "price is ".concat(children).concat(tax ? ' plus tax' : '') : _d,
    _e = _a.wordBreak,
    wordBreak = _e === void 0 ? 'none' : _e,
    _f = _a.strikeThrough,
    strikeThrough = _f === void 0 ? false : _f,
    discount = _a.discount,
    originalPrice = _a.originalPrice,
    _g = _a.mrp,
    mrp = _g === void 0 ? false : _g,
    props = __rest$1(_a, ["element", "variant", "size", "className", "children", "tax", "ariaLabel", "wordBreak", "strikeThrough", "discount", "originalPrice", "mrp"]);
  var color = {
    light: 'primary-light',
    promotional: 'promotional',
    standard: 'primary-dark'
  }[variant];
  if (originalPrice) {
    return /*#__PURE__*/createElement("div", __assign$1({
      className: joinClasses(styles$1h.price, addWordBreak(wordBreak === 'break-word'), className),
      "aria-label": ariaLabel
    }, props), /*#__PURE__*/createElement(ContentAlignment, {
      direction: "row",
      element: "div",
      alignment: "baseline",
      className: styles$1h.priceWrapper
    }, /*#__PURE__*/createElement(PriceText, {
      element: element,
      variant: size,
      color: color,
      className: styles$1h.priceChildren
    }, children), originalPrice && (/*#__PURE__*/createElement("div", {
      className: styles$1h.priceOriginalPrice
    }, mrp && (/*#__PURE__*/createElement(PriceText, {
      element: element,
      variant: 'extraSmall',
      color: 'primary-dark',
      className: styles$1h.priceMrpPrefix
    }, "MRP")), /*#__PURE__*/createElement(PriceText, {
      element: element,
      variant: 'extraSmall',
      color: 'primary-dark',
      className: joinClasses(styles$1h.priceStrikeThrough, discount && styles$1h.priceDiscount)
    }, originalPrice), discount && (/*#__PURE__*/createElement(Caption, {
      variant: "small",
      element: 'div'
    }, discount))))));
  }
  // Need to remove below code after EcRnewal phase 3
  // since dual price is expected everywhere
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$1h.price, addWordBreak(wordBreak === 'break-word'), className),
    "aria-label": ariaLabel
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    alignment: "baseline"
  }, /*#__PURE__*/createElement(PriceText, {
    element: element,
    variant: size,
    color: color,
    className: joinClasses(strikeThrough && styles$1h.priceStrikeThrough, discount && styles$1h.priceDiscount)
  }, children), discount && (/*#__PURE__*/createElement(Caption, {
    variant: "small",
    element: 'div'
  }, discount)), tax && /*#__PURE__*/createElement(HintError, {
    className: styles$1h.priceTax,
    hint: tax,
    key: "tax"
  })));
};
Price.displayName = 'CorePrice';

var styles$1i = {"media-enhancements":"fr-ec-media-enhancements","mediaEnhancements":"fr-ec-media-enhancements","media-enhancements__content-row":"fr-ec-media-enhancements__content-row","mediaEnhancementsContentRow":"fr-ec-media-enhancements__content-row","media-enhancements__content-container":"fr-ec-media-enhancements__content-container","mediaEnhancementsContentContainer":"fr-ec-media-enhancements__content-container","media-enhancements__content-container--main-content":"fr-ec-media-enhancements__content-container--main-content","mediaEnhancementsContentContainerMainContent":"fr-ec-media-enhancements__content-container--main-content","media-enhancements__content-container--main-content-padding-reset":"fr-ec-media-enhancements__content-container--main-content-padding-reset","mediaEnhancementsContentContainerMainContentPaddingReset":"fr-ec-media-enhancements__content-container--main-content-padding-reset","media-enhancements__content-container-bottom-content":"fr-ec-media-enhancements__content-container-bottom-content","mediaEnhancementsContentContainerBottomContent":"fr-ec-media-enhancements__content-container-bottom-content","media-enhancements__content-row--padding-reset":"fr-ec-media-enhancements__content-row--padding-reset","mediaEnhancementsContentRowPaddingReset":"fr-ec-media-enhancements__content-row--padding-reset","media-enhancements__content-row--top":"fr-ec-media-enhancements__content-row--top","mediaEnhancementsContentRowTop":"fr-ec-media-enhancements__content-row--top","media-enhancements__content":"fr-ec-media-enhancements__content","mediaEnhancementsContent":"fr-ec-media-enhancements__content","media-enhancements__content--right":"fr-ec-media-enhancements__content--right","mediaEnhancementsContentRight":"fr-ec-media-enhancements__content--right","media-enhancements__content--left":"fr-ec-media-enhancements__content--left","mediaEnhancementsContentLeft":"fr-ec-media-enhancements__content--left","media-enhancements__content--text":"fr-ec-media-enhancements__content--text","mediaEnhancementsContentText":"fr-ec-media-enhancements__content--text","body":"fr-ec-body","media-enhancements__content--text-white":"fr-ec-media-enhancements__content--text-white","mediaEnhancementsContentTextWhite":"fr-ec-media-enhancements__content--text-white","media-enhancements__content--prioritized":"fr-ec-media-enhancements__content--prioritized","mediaEnhancementsContentPrioritized":"fr-ec-media-enhancements__content--prioritized","media-enhancements__botton-center-content":"fr-ec-media-enhancements__botton-center-content","mediaEnhancementsBottonCenterContent":"fr-ec-media-enhancements__botton-center-content"};

var prioritizedContentMap$1 = {
  bottomLeft: 0,
  bottomRight: 1,
  topLeft: 0,
  topRight: 1
};
var contentGroup$1 = function contentGroup(contentLeft, contentRight, textColor, prioritizedContent) {
  if (textColor === void 0) {
    textColor = {};
  }
  if (prioritizedContent === void 0) {
    prioritizedContent = [];
  }
  var isLeftContentString = contentLeft && contentLeft.type && (
  // @ts-ignore
  contentLeft.type.displayName === 'CoreBody' || contentLeft.type.displayName === 'Body');
  var isRightContentString = contentRight && contentRight.type && (
  // @ts-ignore
  contentRight.type.displayName === 'CoreBody' || contentRight.type.displayName === 'Body');
  var isPrioritizedLeft = prioritizedContent.some(function (item) {
    return prioritizedContentMap$1[item] === 0;
  });
  var isPrioritizedRight = prioritizedContent.some(function (item) {
    return prioritizedContentMap$1[item] === 1;
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, contentLeft && (/*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1i.mediaEnhancementsContent, styles$1i.mediaEnhancementsContentLeft, isPrioritizedLeft && styles$1i.mediaEnhancementsContentPrioritized, isLeftContentString && [styles$1i.mediaEnhancementsContentText, styles$1i["media-enhancements__content--text-".concat(textColor.left || 'Black')]].join(' '))
  }, contentLeft)), contentRight && (/*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1i.mediaEnhancementsContent, styles$1i.mediaEnhancementsContentRight, isPrioritizedRight && styles$1i.mediaEnhancementsContentPrioritized, isRightContentString && [styles$1i.mediaEnhancementsContentText, styles$1i["media-enhancements__content--text-".concat(textColor.right || 'Black')]].join(' '))
  }, contentRight)));
};
var MediaEnhancements = function MediaEnhancements(_a) {
  var className = _a.className,
    children = _a.children,
    topLeftContent = _a.topLeftContent,
    topRightContent = _a.topRightContent,
    bottomLeftContent = _a.bottomLeftContent,
    bottomRightContent = _a.bottomRightContent,
    prioritizedContent = _a.prioritizedContent,
    topTextColor = _a.topTextColor,
    bottomTextColor = _a.bottomTextColor,
    _b = _a.padding,
    padding = _b === void 0 ? true : _b,
    absolutePositionContent = _a.absolutePositionContent,
    bottomCenterContent = _a.bottomCenterContent,
    mainContent = _a.mainContent,
    props = __rest$1(_a, ["className", "children", "topLeftContent", "topRightContent", "bottomLeftContent", "bottomRightContent", "prioritizedContent", "topTextColor", "bottomTextColor", "padding", "absolutePositionContent", "bottomCenterContent", "mainContent"]);
  var _c = useState(0),
    minHeight = _c[0],
    updateMinHeight = _c[1];
  var mediaEnhancementContentsRef = React__default.useRef(null);
  useEffect(function () {
    var contentsElement = mediaEnhancementContentsRef === null || mediaEnhancementContentsRef === void 0 ? void 0 : mediaEnhancementContentsRef.current;
    if (contentsElement) {
      var contentMinHeight = contentsElement.clientHeight - contentsElement.clientWidth;
      updateMinHeight(contentMinHeight);
    }
  }, []);
  var onResize = function onResize(contentRect) {
    var contentsElement = mediaEnhancementContentsRef === null || mediaEnhancementContentsRef === void 0 ? void 0 : mediaEnhancementContentsRef.current;
    if (contentRect.bounds && contentsElement) {
      var contentMinHeight = contentsElement.clientHeight - contentsElement.clientWidth;
      updateMinHeight(contentMinHeight);
    }
  };
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: debounce(100, onResize)
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", __assign$1({
      ref: measureRef,
      className: joinClasses(styles$1i.mediaEnhancements, className)
    }, props), /*#__PURE__*/React__default.createElement("div", {
      ref: mediaEnhancementContentsRef
    }, children, absolutePositionContent, (topLeftContent || topRightContent) && (/*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$1i.mediaEnhancementsContentRow, styles$1i.mediaEnhancementsContentRowTop, !padding && styles$1i.mediaEnhancementsContentRowPaddingReset)
    }, contentGroup$1(topLeftContent, topRightContent, topTextColor, prioritizedContent))), (bottomLeftContent || bottomRightContent || mainContent) && (/*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$1i.mediaEnhancementsContentContainer, !padding && styles$1i.mediaEnhancementsContentRowPaddingReset)
    }, mainContent && (/*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$1i.mediaEnhancementsContentContainerMainContent, !padding && styles$1i.mediaEnhancementsContentContainerMainContentPaddingReset)
    }, mainContent)), /*#__PURE__*/React__default.createElement("div", {
      className: styles$1i.mediaEnhancementsContentContainerBottomContent
    }, contentGroup$1(bottomLeftContent, bottomRightContent, bottomTextColor, prioritizedContent))))), bottomCenterContent && (/*#__PURE__*/React__default.createElement("div", {
      className: styles$1i.mediaEnhancementsBottonCenterContent,
      style: {
        minHeight: "".concat(minHeight, "px")
      }
    }, bottomCenterContent)));
  });
};
MediaEnhancements.displayName = 'CoreMediaEnhancements';
MediaEnhancements.defaultProps = {
  bottomTextColor: {
    left: 'black',
    right: 'black'
  },
  padding: true,
  topTextColor: {
    left: 'black',
    right: 'black'
  }
};

var styles$1j = {"media-object":"fr-ec-media-object","mediaObject":"fr-ec-media-object","media-object__media":"fr-ec-media-object__media","mediaObjectMedia":"fr-ec-media-object__media","media-object__media--right":"fr-ec-media-object__media--right","mediaObjectMediaRight":"fr-ec-media-object__media--right","media-object__media--large":"fr-ec-media-object__media--large","mediaObjectMediaLarge":"fr-ec-media-object__media--large","media-object__media--small":"fr-ec-media-object__media--small","mediaObjectMediaSmall":"fr-ec-media-object__media--small","media-object__content":"fr-ec-media-object__content","mediaObjectContent":"fr-ec-media-object__content","media-object__small-container--vertical-wrapper":"fr-ec-media-object__small-container--vertical-wrapper","mediaObjectSmallContainerVerticalWrapper":"fr-ec-media-object__small-container--vertical-wrapper","media-object__small-container--vertical":"fr-ec-media-object__small-container--vertical","mediaObjectSmallContainerVertical":"fr-ec-media-object__small-container--vertical"};

var MediaObject = function MediaObject(_a) {
  var media = _a.media,
    children = _a.children,
    variation = _a.variation,
    _b = _a.mediaPosition,
    mediaPosition = _b === void 0 ? 'left' : _b,
    _c = _a.smallContainer,
    smallContainer = _c === void 0 ? 'horizontal' : _c,
    className = _a.className,
    props = __rest$1(_a, ["media", "children", "variation", "mediaPosition", "smallContainer", "className"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$1j.mediaObject, mediaPosition === 'right' && styles$1j.mediaObjectMediaRight, smallContainer === 'vertical' && styles$1j.mediaObjectSmallContainerVerticalWrapper, className)
  }, props), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1j.mediaObjectMedia, smallContainer !== 'vertical' ? styles$1j["media-object__media--".concat(variation)] : styles$1j.mediaObjectSmallContainerVertical)
  }, media), /*#__PURE__*/createElement("div", {
    className: styles$1j.mediaObjectContent
  }, children));
};
MediaObject.displayName = 'CoreMediaObject';

var styles$1k = {"modal-backdrop":"fr-ec-modal-backdrop","modalBackdrop":"fr-ec-modal-backdrop","modal-backdrop--filter":"fr-ec-modal-backdrop--filter","modalBackdropFilter":"fr-ec-modal-backdrop--filter","modal-backdrop--hidden":"fr-ec-modal-backdrop--hidden","modalBackdropHidden":"fr-ec-modal-backdrop--hidden","modal-backdrop--modal":"fr-ec-modal-backdrop--modal","modalBackdropModal":"fr-ec-modal-backdrop--modal","modal--small":"fr-ec-modal--small","modalSmall":"fr-ec-modal--small","modal--large":"fr-ec-modal--large","modalLarge":"fr-ec-modal--large","modal--full-width":"fr-ec-modal--full-width","modalFullWidth":"fr-ec-modal--full-width","modal--full":"fr-ec-modal--full","modalFull":"fr-ec-modal--full","slideUp":"fr-ec-slideUp","modal--full-content":"fr-ec-modal--full-content","modalFullContent":"fr-ec-modal--full-content","overlay-content":"fr-ec-overlay-content","overlayContent":"fr-ec-overlay-content","overlay-wrapper":"fr-ec-overlay-wrapper","overlayWrapper":"fr-ec-overlay-wrapper","overlay-body":"fr-ec-overlay-body","overlayBody":"fr-ec-overlay-body","modal--overlay--full-width-top":"fr-ec-modal--overlay--full-width-top","modalOverlayFullWidthTop":"fr-ec-modal--overlay--full-width-top","modal--overlay--full-width":"fr-ec-modal--overlay--full-width","modalOverlayFullWidth":"fr-ec-modal--overlay--full-width","modal__overlay--footer-large":"fr-ec-modal__overlay--footer-large","modalOverlayFooterLarge":"fr-ec-modal__overlay--footer-large","overlay-body__footer":"fr-ec-overlay-body__footer","overlayBodyFooter":"fr-ec-overlay-body__footer","keyline":"fr-ec-keyline","modal__overlay--footer-large-relative":"fr-ec-modal__overlay--footer-large-relative","modalOverlayFooterLargeRelative":"fr-ec-modal__overlay--footer-large-relative","modal__overlay--no-footer":"fr-ec-modal__overlay--no-footer","modalOverlayNoFooter":"fr-ec-modal__overlay--no-footer","modal--large-relative":"fr-ec-modal--large-relative","modalLargeRelative":"fr-ec-modal--large-relative","modal--backdrop--large":"fr-ec-modal--backdrop--large","modalBackdropLarge":"fr-ec-modal--backdrop--large","modal__header--sticky":"fr-ec-modal__header--sticky","modalHeaderSticky":"fr-ec-modal__header--sticky","modal__container--with-sticky-header":"fr-ec-modal__container--with-sticky-header","modalContainerWithStickyHeader":"fr-ec-modal__container--with-sticky-header","header-overlay":"fr-ec-header-overlay","headerOverlay":"fr-ec-header-overlay","modal--filter":"fr-ec-modal--filter","modalFilter":"fr-ec-modal--filter","header-overlay__button":"fr-ec-header-overlay__button","headerOverlayButton":"fr-ec-header-overlay__button","flyout-select":"fr-ec-flyout-select","flyoutSelect":"fr-ec-flyout-select","flyout-select__list":"fr-ec-flyout-select__list","flyoutSelectList":"fr-ec-flyout-select__list"};

var variantStyles$1 = {
  filter: styles$1k.modalFilter,
  fullwidth: styles$1k.modalFullWidth,
  large: styles$1k.modalLarge,
  small: styles$1k.modalSmall,
  full: styles$1k.modalFull
};
var Modal = /** @class */function (_super) {
  __extends(Modal, _super);
  function Modal(props) {
    var _this = _super.call(this, props) || this;
    _this.currentPosition = 0;
    _this.currentPositionVal = 0;
    _this.iterateOverChildren = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      var el = (_a = _this.swiperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.fr-ec-toast');
      if (el) {
        var r1 = el.closest('.fr-ec-overlay-content');
        if (Boolean(r1)) {
          if ((_b = _this.bodyRef) === null || _b === void 0 ? void 0 : _b.current) {
            if ((_e = (_d = (_c = r1 === null || r1 === void 0 ? void 0 : r1.nextElementSibling) === null || _c === void 0 ? void 0 : _c.querySelector('.fr-ec-button')) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect()) === null || _e === void 0 ? void 0 : _e.top) {
              var topMargin = 8;
              el.style.bottom = 'auto';
              el.style.top = "".concat((((_h = (_g = (_f = r1 === null || r1 === void 0 ? void 0 : r1.nextElementSibling) === null || _f === void 0 ? void 0 : _f.querySelector('.fr-ec-button')) === null || _g === void 0 ? void 0 : _g.getBoundingClientRect()) === null || _h === void 0 ? void 0 : _h.top) || 0) - el.clientHeight - topMargin, "px");
            }
          }
        }
      }
    };
    _this.onOpenModal = function () {
      if (isInBrowser$1()) {
        document.addEventListener('keydown', _this.handleDocumentKeyDown);
      }
      if (_this.swiperRef.current) {
        _this.swiperRef.current.addEventListener('scroll', _this.handleScroll);
      }
    };
    _this.handleScroll = function () {
      var _a, _b, _c;
      if (_this.swiperRef.current) {
        // Math.floor() used to avoid flickering issue in android webview due to fractional value for window.innerHeight
        if (((_a = _this.swiperRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) >= Math.floor(window.innerHeight * 0.2)) {
          (_b = _this.swiperRef.current) === null || _b === void 0 ? void 0 : _b.classList.add('fr-ec-modal__container--with-sticky-header');
          if (_this.headerRef.current && _this.bodyRef.current) {
            // tslint:disable-next-line: no-console
            _this.bodyRef.current.style.marginTop = "".concat(_this.headerRef.current.getBoundingClientRect().height, "px");
          }
        } else {
          (_c = _this.swiperRef.current) === null || _c === void 0 ? void 0 : _c.classList.remove('fr-ec-modal__container--with-sticky-header');
          if (_this.bodyRef.current) {
            _this.bodyRef.current.style.marginTop = '0';
          }
        }
      }
    };
    _this.onCloseModal = function () {
      if (isInBrowser$1()) {
        document.removeEventListener('keydown', _this.handleDocumentKeyDown);
      }
    };
    _this.handleCloseModal = function (event) {
      var _a = _this.props,
        onRequestClose = _a.onRequestClose,
        backgroundScroll = _a.backgroundScroll;
      if (onRequestClose) {
        onRequestClose(event);
      }
      if (!backgroundScroll) {
        _this.scrollRemoval(false);
      }
    };
    _this.handleDocumentKeyDown = function (event) {
      if (event.keyCode === KEYCODE.ESC) {
        if (typeof _this.props.onBackdropClick === 'function') {
          _this.props.onBackdropClick(event);
        } else if (_this.props.onRequestClose) {
          _this.props.onRequestClose(event);
        }
      }
    };
    _this.backdropClick = function (event) {
      if (event.target === event.currentTarget) {
        if (typeof _this.props.onBackdropClick === 'function') {
          _this.props.onBackdropClick(event);
        } else if (_this.props.onRequestClose) {
          _this.props.onRequestClose(event);
        }
      }
    };
    _this.scrollRemoval = function (disable) {
      if (isInBrowser$1()) {
        if (typeof document === 'undefined') {
          return;
        }
        var docElement = document.querySelector(_this.props.scrollDisableElement || 'body');
        if (disable) {
          _this.currentPosition = window.pageYOffset;
          docElement.classList.add(interactionsStyles.scrollDisabled);
          docElement.style.top = "".concat(-_this.currentPosition, "px");
        } else {
          docElement.classList.remove(interactionsStyles.scrollDisabled);
          docElement.style.top = '';
          window.scrollTo(0, _this.currentPosition);
        }
      }
    };
    _this.getFooterHeight = function (height) {
      if (_this.bodyExtraRef.current) {
        _this.bodyExtraRef.current.style.height = "".concat(height, "px");
      }
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.headerRef = /*#__PURE__*/createRef();
    _this.bodyRef = /*#__PURE__*/createRef();
    _this.bodyExtraRef = /*#__PURE__*/createRef();
    _this.state = {
      isHydrated: false
    };
    return _this;
  }
  Modal.prototype.componentDidMount = function () {
    var _this = this;
    var _a = this.props,
      isOpen = _a.isOpen,
      backgroundScroll = _a.backgroundScroll;
    // scroll logic will be applied only after isHydrated is true
    this.setState({
      isHydrated: true
    }, function () {
      if (isOpen) {
        _this.onOpenModal();
        if (!backgroundScroll) {
          _this.scrollRemoval(true);
        }
      }
    });
  };
  Modal.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.props.isOpen ? this.onOpenModal() : this.onCloseModal();
      if (!this.props.backgroundScroll) {
        this.scrollRemoval(this.props.isOpen);
      }
    }
    if (isInBrowser$1()) {
      var docElement = document.querySelector(this.props.scrollDisableElement || 'body');
      if (this.props.isOpen && !docElement.classList.contains(interactionsStyles.scrollDisabled)) {
        docElement.classList.add(interactionsStyles.scrollDisabled);
      }
      this.iterateOverChildren();
    }
  };
  Modal.prototype.componentWillUnmount = function () {
    if (isInBrowser$1()) {
      document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }
    if (!this.props.backgroundScroll) {
      this.scrollRemoval(false);
    }
  };
  Modal.prototype.render = function () {
    var _a = this.props,
      errors = _a.errors,
      variant = _a.variant,
      _b = _a.titleId,
      titleId = _b === void 0 ? 'modal-title' : _b,
      closeLabel = _a.closeLabel,
      closeTitle = _a.closeTitle,
      title = _a.title,
      subtitle = _a.subtitle,
      subtitleExtra = _a.subtitleExtra,
      children = _a.children,
      isOpen = _a.isOpen,
      onRequestClose = _a.onRequestClose,
      _c = _a.trapFocus,
      trapFocus = _c === void 0 ? true : _c,
      footer = _a.footer,
      className = _a.className,
      _e = _a.labelElement,
      labelElement = _e === void 0 ? 'h5' : _e,
      itemCount = _a.itemCount,
      fullWidthContent = _a.fullWidthContent,
      iconBrand = _a.iconBrand,
      _f = _a.fullWidthContentPosition,
      fullWidthContentPosition = _f === void 0 ? 'bottom' : _f,
      _g = _a.fixedButtonLayout,
      fixedButtonLayout = _g === void 0 ? false : _g,
      _h = _a.hideCloseIconLabel,
      hideCloseIconLabel = _h === void 0 ? false : _h,
      _j = _a.enableSeo,
      enableSeo = _j === void 0 ? false : _j,
      props = __rest$1(_a, ["errors", "variant", "titleId", "closeLabel", "closeTitle", "title", "subtitle", "subtitleExtra", "children", "isOpen", "onRequestClose", "onBackdropClick", "trapFocus", "footer", "backgroundScroll", "className", "scrollDisableElement", "labelElement", "itemCount", "fullWidthContent", "iconBrand", "fullWidthContentPosition", "fixedButtonLayout", "hideCloseIconLabel", "enableSeo"]);
    var isHydrated = this.state.isHydrated;
    var backdropClass = variant === 'filter' ? joinClasses(styles$1k.modalBackdropFilter, enableSeo && !isOpen && styles$1k.modalBackdropHidden) : joinClasses(styles$1k.modalBackdrop, styles$1k.modalBackdropModal, variant === 'large' && styles$1k.modalBackdropLarge, enableSeo && !isOpen && styles$1k.modalBackdropHidden);
    var isLarge = variant === 'large';
    var footerLayout = fixedButtonLayout ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Keyline, null), " ", footer)) : footer;
    var modalOverlay = /*#__PURE__*/createElement(OverlayBackdrop, {
      className: backdropClass,
      hidden: false,
      "aria-hidden": false,
      role: 'presentation',
      onClick: this.backdropClick,
      ref: this.swiperRef
    }, /*#__PURE__*/createElement(FocusTrap, {
      active: enableSeo ? isOpen && trapFocus : trapFocus,
      focusTrapOptions: {
        clickOutsideDeactivates: true,
        escapeDeactivates: false,
        returnFocusOnDeactivate: true
      }
    }, /*#__PURE__*/createElement(OverlayWrapper, __assign$1({
      role: "dialog",
      "aria-modal": true,
      tabIndex: -1,
      "aria-labelledby": titleId,
      className: joinClasses(variantStyles$1[variant], isLarge && !fixedButtonLayout && styles$1k.modalLargeRelative, className)
    }, props), /*#__PURE__*/createElement(HeaderOverlay, {
      isModal: true,
      itemCount: itemCount,
      title: title,
      subtitle: subtitle,
      subtitleExtra: subtitleExtra,
      closeLabel: closeLabel,
      closeTitle: closeTitle,
      onRequestClose: onRequestClose,
      titleId: titleId,
      labelElement: labelElement,
      errors: errors,
      iconBrand: iconBrand,
      ref: this.headerRef,
      hideCloseIconLabel: hideCloseIconLabel
    }), variant === 'full' ? (/*#__PURE__*/createElement("div", {
      className: styles$1k.modalFullContent
    }, children)) : (/*#__PURE__*/createElement(OverlayBody, {
      className: joinClasses(isLarge && (fixedButtonLayout ? styles$1k.modalOverlayFooterLarge : styles$1k.modalOverlayFooterLargeRelative), !footer && variant !== 'fullwidth' && styles$1k.modalOverlayNoFooter),
      footer: footerLayout,
      isModal: true,
      ref: this.bodyRef,
      onHeightChange: this.getFooterHeight
    }, fullWidthContentPosition === 'top' && (/*#__PURE__*/createElement("div", {
      className: styles$1k.modalOverlayFullWidthTop
    }, fullWidthContent)), children, fullWidthContentPosition === 'bottom' && (/*#__PURE__*/createElement("div", {
      className: styles$1k.modalOverlayFullWidth
    }, fullWidthContent)), isLarge && fixedButtonLayout && /*#__PURE__*/createElement("div", {
      ref: this.bodyExtraRef
    }))))));
    if (isInBrowser$1() && isHydrated) {
      return /*#__PURE__*/ReactDOM.createPortal(enableSeo ? modalOverlay : isOpen && modalOverlay, document.querySelector('body'));
    } else {
      return null;
    }
  };
  Modal.displayName = 'CoreModal';
  Modal.defaultProps = {
    backgroundScroll: false,
    scrollDisableElement: 'body',
    titleId: 'modal-title',
    trapFocus: false
  };
  return Modal;
}(Component);
Modal.defaultProps = {
  labelElement: 'h5',
  titleId: 'modal-title',
  trapFocus: true
};

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

var LayoutHiddenAtSmallMedium = function LayoutHiddenAtSmallMedium(props) {
  return /*#__PURE__*/createElement(Layout, __assign$1({
    visible: {
      sm: false,
      md: false,
      lg: true
    }
  }, props));
};
LayoutHiddenAtSmallMedium.displayName = 'CoreLayoutHiddenAtSmallMedium';

var styles$1l = {"navigation-ribbon":"fr-ec-navigation-ribbon","navigationRibbon":"fr-ec-navigation-ribbon","navigation-ribbon__wrapper":"fr-ec-navigation-ribbon__wrapper","navigationRibbonWrapper":"fr-ec-navigation-ribbon__wrapper","navigation-ribbon__left":"fr-ec-navigation-ribbon__left","navigationRibbonLeft":"fr-ec-navigation-ribbon__left","navigation-ribbon__left-column":"fr-ec-navigation-ribbon__left-column","navigationRibbonLeftColumn":"fr-ec-navigation-ribbon__left-column","navigation-ribbon__right":"fr-ec-navigation-ribbon__right","navigationRibbonRight":"fr-ec-navigation-ribbon__right","navigation-ribbon__right-column":"fr-ec-navigation-ribbon__right-column","navigationRibbonRightColumn":"fr-ec-navigation-ribbon__right-column"};

var NavigationRibbon = function NavigationRibbon(_a) {
  var leftContent = _a.leftContent,
    rightContentOne = _a.rightContentOne,
    rightContentTwo = _a.rightContentTwo,
    className = _a.className,
    props = __rest$1(_a, ["leftContent", "rightContentOne", "rightContentTwo", "className"]);
  return /*#__PURE__*/createElement(LayoutHiddenAtSmallMedium, __assign$1({
    gutter: false,
    className: joinClasses(styles$1l.navigationRibbon, className)
  }, props), /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div",
    className: styles$1l.navigationRibbonWrapper
  }, /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonLeft
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(resetStyles.maxWidthReset, styles$1l.navigationRibbonLeftColumn)
  }, /*#__PURE__*/createElement(Caption, {
    element: "span"
  }, leftContent))), /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonRight
  }, /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonRightColumn
  }, rightContentOne), /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonRightColumn
  }, rightContentTwo))));
};
NavigationRibbon.displayName = 'CoreNavigationRibbon';

var styles$1m = {"order-status-bar-container":"fr-ec-order-status-bar-container","orderStatusBarContainer":"fr-ec-order-status-bar-container","order-status-bar":"fr-ec-order-status-bar","orderStatusBar":"fr-ec-order-status-bar","order-status-bar__progress":"fr-ec-order-status-bar__progress","orderStatusBarProgress":"fr-ec-order-status-bar__progress","order-status-bar__content":"fr-ec-order-status-bar__content","orderStatusBarContent":"fr-ec-order-status-bar__content","hint-text":"fr-ec-hint-text","hintText":"fr-ec-hint-text"};

var OrderStatusBar = function OrderStatusBar(_a) {
  var status = _a.status,
    labels = _a.labels;
  var statusArray = [];
  var divider = labels.length;
  for (var i = 0; i < divider; i++) {
    statusArray.push(i + 1);
  }
  var progressWidth = status === 0 ? 100 / divider : status === labels.length - 1 ? 100 : statusArray[status] / divider * 100;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: styles$1m.orderStatusBar
  }, /*#__PURE__*/createElement("div", {
    className: styles$1m.orderStatusBarProgress,
    style: {
      width: progressWidth + '%'
    }
  })), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    justifyContent: "space-between",
    className: styles$1m.orderStatusBarContent
  }, labels.map(function (label, index) {
    return /*#__PURE__*/createElement(HintText, {
      key: label,
      element: "span",
      color: index <= status ? 'primary-dark' : 'disabled'
    }, label);
  })));
};
OrderStatusBar.displayName = 'OrderStatusBar';
OrderStatusBar.defaultProps = {
  labels: [],
  status: 0
};

var styles$1n = {"query-text":"fr-ec-query-text","queryText":"fr-ec-query-text"};

// tslint:disable-next-line: no-var-requires
var Highlighter = require('react-highlight-words'); // ES6 import doesn't work properly. Using 'require' as recommended here - https://github.com/DefinitelyTyped/DefinitelyTyped/issues/33050
var QueryText = function QueryText(_a) {
  var queryWords = _a.queryWords,
    text = _a.text,
    className = _a.className,
    props = __rest$1(_a, ["queryWords", "text", "className"]);
  return /*#__PURE__*/createElement(Highlighter, __assign$1({
    className: joinClasses(bodyStyles.body, typographyStyles.bodyStandard, styles$1n.queryText, className),
    searchWords: queryWords,
    textToHighlight: text,
    highlightClassName: joinClasses(typographyStyles.bodyStandardEmphasized, resetStyles.markReset),
    autoEscape: true
  }, props));
};
QueryText.displayName = 'CoreQueryText';

var styles$1o = {"typeahead":"fr-ec-typeahead","typeahead--focus":"fr-ec-typeahead--focus","typeaheadFocus":"fr-ec-typeahead--focus","typeahead__query-text":"fr-ec-typeahead__query-text","typeaheadQueryText":"fr-ec-typeahead__query-text","typeahead__close-icon":"fr-ec-typeahead__close-icon","typeaheadCloseIcon":"fr-ec-typeahead__close-icon","typeahead__image":"fr-ec-typeahead__image","typeaheadImage":"fr-ec-typeahead__image","typeahead__icon":"fr-ec-typeahead__icon","typeaheadIcon":"fr-ec-typeahead__icon","typeahead__content":"fr-ec-typeahead__content","typeaheadContent":"fr-ec-typeahead__content","typeahead__text-content":"fr-ec-typeahead__text-content","typeaheadTextContent":"fr-ec-typeahead__text-content","typeahead__category":"fr-ec-typeahead__category","typeaheadCategory":"fr-ec-typeahead__category","typeahead__sub-title":"fr-ec-typeahead__sub-title","typeaheadSubTitle":"fr-ec-typeahead__sub-title"};

var Typeahead = function Typeahead(_a) {
  var title = _a.title,
    subtitle = _a.subtitle,
    queryWords = _a.queryWords,
    showIcon = _a.showIcon,
    _b = _a.icon,
    icon = _b === void 0 ? 'close' : _b,
    className = _a.className,
    iconBrand = _a.iconBrand,
    gaAction = _a.gaAction,
    gaCallback = _a.gaCallback,
    gaCategory = _a.gaCategory,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    activeTabName = _a.activeTabName,
    onRequestClose = _a.onRequestClose,
    props = __rest$1(_a, ["title", "subtitle", "queryWords", "showIcon", "icon", "ariaLabel", "className", "iconBrand", "gaAction", "gaCallback", "gaCategory", "gaLabel", "gaValue", "activeTabName", "onRequestClose"]);
  var handleCloseIconClick = function handleCloseIconClick() {
    if (onRequestClose) {
      onRequestClose();
    }
  };
  return /*#__PURE__*/createElement(Tile, __assign$1({
    tabIndex: -1,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    activeTabName: activeTabName
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    className: joinClasses(styles$1o.typeahead, className)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: -1,
    className: joinClasses(styles$1o.typeaheadContent)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: 0,
    className: styles$1o.typeaheadFocus
  }, /*#__PURE__*/createElement("div", {
    className: styles$1o.typeaheadTextContent
  }, /*#__PURE__*/createElement(QueryText, {
    text: title,
    queryWords: queryWords,
    className: styles$1o.typeaheadQueryText
  }), subtitle && (/*#__PURE__*/createElement(Caption, {
    variant: "small",
    className: styles$1o.typeaheadSubTitle,
    element: "div",
    color: "secondary"
  }, subtitle))), showIcon && icon && (/*#__PURE__*/createElement(ButtonIcon, {
    element: "button",
    type: "button",
    icon: icon,
    onMouseDown: handleCloseIconClick,
    onClick: handleCloseIconClick,
    className: styles$1o.typeaheadCloseIcon,
    iconBrand: iconBrand,
    hideLabel: true,
    label: "close"
  }))))));
};
Typeahead.displayName = 'CoreTypeahead';

var styles$1p = {"radio":"fr-ec-radio","radio__wrapper":"fr-ec-radio__wrapper","radioWrapper":"fr-ec-radio__wrapper","radio--full-width":"fr-ec-radio--full-width","radioFullWidth":"fr-ec-radio--full-width","radio__label":"fr-ec-radio__label","radioLabel":"fr-ec-radio__label","radio__children":"fr-ec-radio__children","radioChildren":"fr-ec-radio__children","radio__rating":"fr-ec-radio__rating","radioRating":"fr-ec-radio__rating","radio__input":"fr-ec-radio__input","radioInput":"fr-ec-radio__input","radio__circle":"fr-ec-radio__circle","radioCircle":"fr-ec-radio__circle","radio__input-checked":"fr-ec-radio__input-checked","radioInputChecked":"fr-ec-radio__input-checked","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","radio__image-container":"fr-ec-radio__image-container","radioImageContainer":"fr-ec-radio__image-container","radio__image":"fr-ec-radio__image","radioImage":"fr-ec-radio__image","radio__max-width-reset":"fr-ec-radio__max-width-reset","radioMaxWidthReset":"fr-ec-radio__max-width-reset"};

var Radio = /*#__PURE__*/forwardRef(function (_a, ref) {
  var _b;
  var label = _a.label,
    name = _a.name,
    onChange = _a.onChange,
    value = _a.value,
    id = _a.id,
    disabled = _a.disabled,
    children = _a.children,
    className = _a.className,
    _c = _a.hideLabel,
    hideLabel = _c === void 0 ? false : _c,
    image = _a.image,
    imageAlt = _a.imageAlt,
    _d = _a.labelVariant,
    labelVariant = _d === void 0 ? 'standard' : _d,
    _e = _a.width,
    width = _e === void 0 ? 'fitToContent' : _e,
    checked = _a.checked,
    props = __rest$1(_a, ["label", "name", "onChange", "value", "id", "disabled", "children", "className", "hideLabel", "image", "imageAlt", "labelVariant", "width", "checked"]);
  var hasChildren = Children.toArray(children).length > 0;
  var childrenId = hasChildren ? "".concat(id, "__content") : '';
  var hasImage = image && image.length > 0;
  var imageAltText = Array.isArray(imageAlt) ? __spreadArray([], imageAlt, true) : [imageAlt || label];
  var renderImages = hasImage && (Array.isArray(image) ? image.map(function (img, index) {
    var _a;
    return /*#__PURE__*/createElement("img", {
      key: index,
      src: img,
      alt: typeof label === 'string' ? label : (_a = imageAltText[index]) === null || _a === void 0 ? void 0 : _a.toString(),
      className: joinClasses(styles$1p.radioImage)
    });
  }) : (/*#__PURE__*/createElement("img", {
    src: image,
    alt: (_b = imageAltText[0]) === null || _b === void 0 ? void 0 : _b.toString(),
    className: joinClasses(styles$1p.radioImage)
  })));
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1p.radio, width === 'fullWidth' && styles$1p.radioFullWidth, className)
  }, /*#__PURE__*/createElement("div", {
    className: styles$1p.radioWrapper
  }, /*#__PURE__*/createElement("input", __assign$1({
    type: "radio",
    className: joinClasses(styles$1p.radioInput, checked && styles$1p.radioInputChecked, interactionsStyles.cursorPointer),
    value: value,
    name: name,
    onChange: onChange,
    id: id,
    disabled: disabled,
    "aria-describedby": childrenId,
    "aria-label": typeof label === 'string' ? !hideLabel ? label : undefined : undefined,
    ref: ref,
    checked: checked
  }, props)), /*#__PURE__*/createElement("label", {
    htmlFor: id,
    "aria-hidden": hideLabel,
    className: joinClasses(interactionsStyles.cursorPointer, typographyStyles.labelStandard)
  }, typeof label === 'string' && label), /*#__PURE__*/createElement("div", {
    className: styles$1p.radioCircle
  }), /*#__PURE__*/createElement("span", {
    className: joinClasses(styles$1p.radioLabel, resetStyles.maxWidthReset)
  }, /*#__PURE__*/createElement("div", {
    className: styles$1p.radioImageContainer
  }, renderImages), /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: labelVariant,
    color: disabled ? 'disabled' : 'primary-dark',
    className: styles$1p.radioMaxWidthReset
  }, /*#__PURE__*/createElement("label", {
    htmlFor: id,
    className: styles$1p.radioRating
  }, label)))), hasChildren && (/*#__PURE__*/createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/createElement("div", {
    id: childrenId,
    className: styles$1p.radioChildren
  }, children))));
});
Radio.displayName = 'CoreRadio';
Radio.defaultProps = {
  hideLabel: false
};

var styles$1q = {"selector":"fr-ec-selector","selector__button":"fr-ec-selector__button","selectorButton":"fr-ec-selector__button","selector__tooltip":"fr-ec-selector__tooltip","selectorTooltip":"fr-ec-selector__tooltip","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","selector__button--is-selected":"fr-ec-selector__button--is-selected","selectorButtonIsSelected":"fr-ec-selector__button--is-selected","selector__label-container":"fr-ec-selector__label-container","selectorLabelContainer":"fr-ec-selector__label-container","selector__label-container--with-tooltip":"fr-ec-selector__label-container--with-tooltip","selectorLabelContainerWithTooltip":"fr-ec-selector__label-container--with-tooltip","selector__label-container--with-icon":"fr-ec-selector__label-container--with-icon","selectorLabelContainerWithIcon":"fr-ec-selector__label-container--with-icon","selector__label":"fr-ec-selector__label","selectorLabel":"fr-ec-selector__label","selector__logo-container":"fr-ec-selector__logo-container","selectorLogoContainer":"fr-ec-selector__logo-container","selector__caption":"fr-ec-selector__caption","selectorCaption":"fr-ec-selector__caption","selector__icon":"fr-ec-selector__icon","selectorIcon":"fr-ec-selector__icon"};

var Selector = function Selector(_a) {
  var selected = _a.selected,
    disabled = _a.disabled,
    label = _a.label,
    children = _a.children,
    icon = _a.icon,
    onClick = _a.onClick,
    className = _a.className,
    scrollTo = _a.scrollTo,
    onToolTipOpen = _a.onToolTipOpen,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["selected", "disabled", "label", "children", "icon", "onClick", "className", "scrollTo", "onToolTipOpen", "iconBrand"]);
  var showTooltip =
  // @ts-ignore
  icon && icon.type && (icon.type.displayName === 'CoreTooltip' || icon.type.displayName === 'Tooltip');
  var isValidSelection = !disabled && selected;
  var showIcon = icon && !disabled && !showTooltip;
  var isIconAnAsset = showIcon && typeof icon === 'string';
  var handleClick = function handleClick(event) {
    // Reduce the header height if the header element is present
    if (isInBrowser()) {
      var headerEl = document.getElementsByTagName('header')[0];
      var headerOffset = 0;
      var offsetVal = 16;
      if (headerEl) {
        headerOffset = headerEl.offsetHeight;
      }
      if (scrollTo) {
        event.preventDefault();
        var btn = document.getElementById(scrollTo);
        if (btn) {
          var offset = btn.offsetTop;
          window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: offset - (headerOffset + offsetVal)
          });
        }
      }
    }
    if (onClick) {
      onClick(event);
    }
  };
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1q.selector, className)
  }, /*#__PURE__*/createElement("button", __assign$1({
    type: "button",
    className: joinClasses(styles$1q.selectorButton, isValidSelection && styles$1q.selectorButtonIsSelected, interactionsStyles.cursorPointer),
    onClick: handleClick,
    "aria-pressed": isValidSelection
  }, props, {
    disabled: disabled
  }), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1q.selectorLabelContainer, showIcon && styles$1q.selectorLabelContainerWithIcon, showTooltip && styles$1q.selectorLabelContainerWithTooltip)
  }, /*#__PURE__*/createElement(Body, {
    variant: "standard",
    element: "p",
    className: styles$1q.selectorLabel,
    "aria-disabled": disabled
  }, label), children && (/*#__PURE__*/createElement(Caption, {
    element: "p",
    className: styles$1q.selectorCaption,
    "aria-disabled": disabled
  }, children))), showIcon && (/*#__PURE__*/createElement("div", {
    className: styles$1q.selectorLogoContainer,
    "aria-hidden": "true"
  }, isIconAnAsset ? (/*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
    className: styles$1q.selectorIcon
  })) : icon))), /*#__PURE__*/createElement("span", {
    className: styles$1q.selectorTooltip
  }, showTooltip && /*#__PURE__*/isValidElement(icon) && /*#__PURE__*/cloneElement(icon, {
    icon: disabled ? 'help' : 'information',
    onClick: function onClick() {
      if (onToolTipOpen) {
        onToolTipOpen();
      }
      if (icon.props.onClick) {
        icon.props.onClick();
      }
    }
  })));
};
Selector.displayName = 'CoreSelector';
Selector.defaultProps = {
  disabled: false,
  selected: false
};

var styles$1r = {"selector-group":"fr-ec-selector-group","selectorGroup":"fr-ec-selector-group","selector":"fr-ec-selector","selector-group--active-tooltip":"fr-ec-selector-group--active-tooltip","selectorGroupActiveTooltip":"fr-ec-selector-group--active-tooltip","selector__tooltip":"fr-ec-selector__tooltip","selectorTooltip":"fr-ec-selector__tooltip"};

var SelectorGroup = function SelectorGroup(_a) {
  var children = _a.children,
    className = _a.className,
    props = __rest$1(_a, ["children", "className"]);
  var _b = useState(-1),
    activeToolTip = _b[0],
    updateVal = _b[1];
  var handleToolTipOpen = function handleToolTipOpen(index) {
    updateVal(index);
  };
  var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      className: index === activeToolTip && styles$1r.selectorGroupActiveTooltip || "",
      onToolTipOpen: function onToolTipOpen() {
        handleToolTipOpen(index);
      }
    });
  });
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$1r.selectorGroup, className)
  }, props), childrenWithProps);
};
SelectorGroup.displayName = 'CoreSelectorGroup';

var styles$1s = {"sheet":"fr-ec-sheet","sheet__inner":"fr-ec-sheet__inner","sheetInner":"fr-ec-sheet__inner"};

var Sheet = function Sheet(_a) {
  var children = _a.children,
    closeLabel = _a.closeLabel,
    closeTitle = _a.closeTitle,
    onRequestClose = _a.onRequestClose,
    title = _a.title,
    subtitle = _a.subtitle,
    subtitleExtra = _a.subtitleExtra,
    _b = _a.titleId,
    titleId = _b === void 0 ? 'sheet-title' : _b,
    className = _a.className,
    footer = _a.footer,
    _c = _a.labelElement,
    labelElement = _c === void 0 ? 'h5' : _c,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["children", "closeLabel", "closeTitle", "onRequestClose", "title", "subtitle", "subtitleExtra", "titleId", "className", "footer", "labelElement", "iconBrand"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$1s.sheet, className),
    role: "dialog"
  }, title && {
    'aria-labelledby': titleId
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$1s.sheetInner
  }, /*#__PURE__*/createElement(OverlayWrapper, null, title && (/*#__PURE__*/createElement(HeaderOverlay, {
    title: title,
    subtitle: subtitle,
    subtitleExtra: subtitleExtra,
    closeLabel: closeLabel,
    closeTitle: closeTitle,
    onRequestClose: onRequestClose,
    titleId: titleId,
    labelElement: labelElement,
    iconBrand: iconBrand
  })), /*#__PURE__*/createElement(OverlayBody, {
    footer: footer
  }, children))));
};
Sheet.displayName = 'CoreSheet';
Sheet.defaultProps = {
  labelElement: 'h5',
  titleId: 'sheet-title'
};

var styles$1t = {"show-more":"fr-ec-show-more","showMore":"fr-ec-show-more","show-more__icon":"fr-ec-show-more__icon","showMoreIcon":"fr-ec-show-more__icon"};

var ShowMore = function ShowMore(_a) {
  var element = _a.element,
    className = _a.className,
    label = _a.label,
    href = _a.href,
    to = _a.to,
    _b = _a.arrowDirection,
    arrowDirection = _b === void 0 ? 'bottom' : _b,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["element", "className", "label", "href", "to", "arrowDirection", "iconBrand"]);
  var Element = element;
  var showMoreContent = /*#__PURE__*/createElement(Fragment, null, label, /*#__PURE__*/createElement(Icon, {
    name: arrowDirection === 'bottom' ? iconBrand ? "".concat(iconBrand, "chevron-down") : 'chevron-down' : iconBrand ? "".concat(iconBrand, "chevron-up") : 'chevron-up',
    className: styles$1t.showMoreIcon
  }));
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({}, {
      href: href,
      to: to
    }, {
      className: joinClasses(styles$1t.showMore, Element === 'button' && resetStyles.buttonReset, typographyStyles.buttonLarge, interactionsStyles.cursorPointer, className)
    }, props), /*#__PURE__*/createElement(ContentAlignment, {
      element: "span",
      direction: "row",
      alignment: "center"
    }, showMoreContent))
  );
};
ShowMore.displayName = 'CoreShowMore';

var styles$1u = {"mb-spacer-0":"fr-ec-mb-spacer-0","mbSpacer0":"fr-ec-mb-spacer-0","mb-spacer-4":"fr-ec-mb-spacer-4","mbSpacer4":"fr-ec-mb-spacer-4","mb-spacer-8":"fr-ec-mb-spacer-8","mbSpacer8":"fr-ec-mb-spacer-8","mb-spacer-12":"fr-ec-mb-spacer-12","mbSpacer12":"fr-ec-mb-spacer-12","mb-spacer-16":"fr-ec-mb-spacer-16","mbSpacer16":"fr-ec-mb-spacer-16","mb-spacer-24":"fr-ec-mb-spacer-24","mbSpacer24":"fr-ec-mb-spacer-24","mb-spacer-32":"fr-ec-mb-spacer-32","mbSpacer32":"fr-ec-mb-spacer-32","mb-spacer-52":"fr-ec-mb-spacer-52","mbSpacer52":"fr-ec-mb-spacer-52","mb-spacer-88":"fr-ec-mb-spacer-88","mbSpacer88":"fr-ec-mb-spacer-88","spacer-l--pc-0":"fr-ec-spacer-l--pc-0","spacerLPc0":"fr-ec-spacer-l--pc-0","spacer-l--pc-4":"fr-ec-spacer-l--pc-4","spacerLPc4":"fr-ec-spacer-l--pc-4","spacer-l--pc-8":"fr-ec-spacer-l--pc-8","spacerLPc8":"fr-ec-spacer-l--pc-8","spacer-l--pc-12":"fr-ec-spacer-l--pc-12","spacerLPc12":"fr-ec-spacer-l--pc-12","spacer-l--pc-16":"fr-ec-spacer-l--pc-16","spacerLPc16":"fr-ec-spacer-l--pc-16","spacer-l--pc-24":"fr-ec-spacer-l--pc-24","spacerLPc24":"fr-ec-spacer-l--pc-24","spacer-l--pc-32":"fr-ec-spacer-l--pc-32","spacerLPc32":"fr-ec-spacer-l--pc-32","spacer-l--pc-52":"fr-ec-spacer-l--pc-52","spacerLPc52":"fr-ec-spacer-l--pc-52","spacer-l--pc-88":"fr-ec-spacer-l--pc-88","spacerLPc88":"fr-ec-spacer-l--pc-88","spacer-m--tab-0":"fr-ec-spacer-m--tab-0","spacerMTab0":"fr-ec-spacer-m--tab-0","spacer-m--tab-4":"fr-ec-spacer-m--tab-4","spacerMTab4":"fr-ec-spacer-m--tab-4","spacer-m--tab-8":"fr-ec-spacer-m--tab-8","spacerMTab8":"fr-ec-spacer-m--tab-8","spacer-m--tab-12":"fr-ec-spacer-m--tab-12","spacerMTab12":"fr-ec-spacer-m--tab-12","spacer-m--tab-16":"fr-ec-spacer-m--tab-16","spacerMTab16":"fr-ec-spacer-m--tab-16","spacer-m--tab-24":"fr-ec-spacer-m--tab-24","spacerMTab24":"fr-ec-spacer-m--tab-24","spacer-m--tab-32":"fr-ec-spacer-m--tab-32","spacerMTab32":"fr-ec-spacer-m--tab-32","spacer-m--tab-52":"fr-ec-spacer-m--tab-52","spacerMTab52":"fr-ec-spacer-m--tab-52","spacer-m--tab-88":"fr-ec-spacer-m--tab-88","spacerMTab88":"fr-ec-spacer-m--tab-88","spacer-s--sp-0":"fr-ec-spacer-s--sp-0","spacerSSp0":"fr-ec-spacer-s--sp-0","spacer-s--sp-4":"fr-ec-spacer-s--sp-4","spacerSSp4":"fr-ec-spacer-s--sp-4","spacer-s--sp-8":"fr-ec-spacer-s--sp-8","spacerSSp8":"fr-ec-spacer-s--sp-8","spacer-s--sp-12":"fr-ec-spacer-s--sp-12","spacerSSp12":"fr-ec-spacer-s--sp-12","spacer-s--sp-16":"fr-ec-spacer-s--sp-16","spacerSSp16":"fr-ec-spacer-s--sp-16","spacer-s--sp-24":"fr-ec-spacer-s--sp-24","spacerSSp24":"fr-ec-spacer-s--sp-24","spacer-s--sp-32":"fr-ec-spacer-s--sp-32","spacerSSp32":"fr-ec-spacer-s--sp-32","spacer-s--sp-52":"fr-ec-spacer-s--sp-52","spacerSSp52":"fr-ec-spacer-s--sp-52","spacer-s--sp-88":"fr-ec-spacer-s--sp-88","spacerSSp88":"fr-ec-spacer-s--sp-88"};

var variantSpacing$1 = {
  'spacing-00': styles$1u.mbSpacer0,
  'spacing-01': styles$1u.mbSpacer4,
  'spacing-02': styles$1u.mbSpacer8,
  'spacing-03': styles$1u.mbSpacer12,
  'spacing-04': styles$1u.mbSpacer16,
  'spacing-05': styles$1u.mbSpacer24,
  'spacing-06': styles$1u.mbSpacer32,
  'spacing-07': styles$1u.mbSpacer52,
  'spacing-08': styles$1u.mbSpacer88
};
var pcSpacing = {
  'spacing-00': styles$1u.spacerLPc0,
  'spacing-01': styles$1u.spacerLPc4,
  'spacing-02': styles$1u.spacerLPc8,
  'spacing-03': styles$1u.spacerLPc12,
  'spacing-04': styles$1u.spacerLPc16,
  'spacing-05': styles$1u.spacerLPc24,
  'spacing-06': styles$1u.spacerLPc32,
  'spacing-07': styles$1u.spacerLPc52,
  'spacing-08': styles$1u.spacerLPc88
};
var tabSpacing = {
  'spacing-00': styles$1u.spacerMTab0,
  'spacing-01': styles$1u.spacerMTab4,
  'spacing-02': styles$1u.spacerMTab8,
  'spacing-03': styles$1u.spacerMTab12,
  'spacing-04': styles$1u.spacerMTab16,
  'spacing-05': styles$1u.spacerMTab24,
  'spacing-06': styles$1u.spacerMTab32,
  'spacing-07': styles$1u.spacerMTab52,
  'spacing-08': styles$1u.spacerMTab88
};
var spSpacing = {
  'spacing-00': styles$1u.spacerSSp0,
  'spacing-01': styles$1u.spacerSSp4,
  'spacing-02': styles$1u.spacerSSp8,
  'spacing-03': styles$1u.spacerSSp12,
  'spacing-04': styles$1u.spacerSSp16,
  'spacing-05': styles$1u.spacerSSp24,
  'spacing-06': styles$1u.spacerSSp32,
  'spacing-07': styles$1u.spacerSSp52,
  'spacing-08': styles$1u.spacerSSp88
};
var Spacer = function Spacer(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'spacing-04' : _c,
    children = _a.children,
    pc = _a.pc,
    sp = _a.sp,
    tab = _a.tab,
    className = _a.className,
    props = __rest$1(_a, ["element", "variant", "children", "pc", "sp", "tab", "className"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(variantSpacing$1[variant], pc && pcSpacing[pc], tab && tabSpacing[tab], sp && spSpacing[sp], className)
  }, props), children);
};
Spacer.displayName = 'CoreSpacer';

var styles$1v = {"stepper-group":"fr-ec-stepper-group","stepperGroup":"fr-ec-stepper-group","stepper-group__item":"fr-ec-stepper-group__item","stepperGroupItem":"fr-ec-stepper-group__item","stepper":"fr-ec-stepper"};

var StepperGroup = function StepperGroup(_a) {
  var children = _a.children,
    _b = _a.className,
    className = _b === void 0 ? '' : _b,
    props = __rest$1(_a, ["children", "className"]);
  return /*#__PURE__*/createElement("ul", __assign$1({
    className: joinClasses(styles$1v.stepperGroup, className)
  }, props), Children.map(children, function (child, i) {
    return /*#__PURE__*/createElement("li", {
      className: styles$1v.stepperGroupItem,
      key: i
    }, child);
  }));
};
StepperGroup.displayName = 'CoreStepperGroup';

var styles$1w = {"tab":"fr-ec-tab","tab--boxed":"fr-ec-tab--boxed","tabBoxed":"fr-ec-tab--boxed","tab--gender":"fr-ec-tab--gender","tabGender":"fr-ec-tab--gender","tab--type-gender":"fr-ec-tab--type-gender","tabTypeGender":"fr-ec-tab--type-gender","tab--small-height":"fr-ec-tab--small-height","tabSmallHeight":"fr-ec-tab--small-height","tab--white":"fr-ec-tab--white","tabWhite":"fr-ec-tab--white","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","tab--is-active":"fr-ec-tab--is-active","tabIsActive":"fr-ec-tab--is-active","tab__label":"fr-ec-tab__label","tabLabel":"fr-ec-tab__label","tab--disabled":"fr-ec-tab--disabled","tabDisabled":"fr-ec-tab--disabled"};

var Tab = function Tab(_a) {
  var children = _a.children,
    isActive = _a.isActive,
    onClick = _a.onClick,
    onMouseEnter = _a.onMouseEnter,
    onMouseLeave = _a.onMouseLeave,
    label = _a.label,
    className = _a.className,
    id = _a.id,
    _b = _a.textTransform,
    textTransform = _b === void 0 ? 'normal' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'standard' : _c,
    _d = _a.genderTypography,
    genderTypography = _d === void 0 ? false : _d,
    _e = _a.wordBreak,
    wordBreak = _e === void 0 ? 'none' : _e,
    _f = _a.disabled,
    disabled = _f === void 0 ? false : _f,
    url = _a.url,
    labelImage = _a.labelImage,
    target = _a.target,
    gaAction = _a.gaAction,
    gaCategory = _a.gaCategory,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    _g = _a.labelElement,
    WrapperEl = _g === void 0 ? 'span' : _g,
    _h = _a.type,
    type = _h === void 0 ? 'black' : _h,
    _j = _a.enableHover,
    enableHover = _j === void 0 ? false : _j,
    _k = _a.tabIndex,
    tabIndex = _k === void 0 ? 0 : _k,
    props = __rest$1(_a, ["children", "isActive", "onClick", "onMouseEnter", "onMouseLeave", "label", "className", "id", "textTransform", "variant", "genderTypography", "wordBreak", "disabled", "url", "labelImage", "target", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "labelElement", "type", "enableHover", "tabIndex"]);
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var clickCallback = function clickCallback(e, index) {
    if (onClick) {
      onClick(e, label, index, children);
    }
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };
  var keyUpHandler = function keyUpHandler(e, index) {
    if ((e.keyCode == KEYCODE.ENTER || e.keyCode == KEYCODE.SPACE) && onClick) {
      onClick(e, label, index, children);
    }
  };
  var Element = 'a';
  var absoluteUrlPattern = url && isAbsoluteUrl(url);
  var attributes = {};
  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    Element = Link$1;
    // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore
    attributes.to = url;
    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }
  var typography = {
    gender: typographyStyles.genderSmall,
    small: !genderTypography ? typographyStyles.tabSmall : typographyStyles.genderSmall,
    'small-swipeable': !genderTypography ? typographyStyles.tabSmall : typographyStyles.genderSmall,
    standard: !genderTypography ? typographyStyles.tabStandard : typographyStyles.genderStandard,
    'standard-boxed': !genderTypography ? typographyStyles.tabSmall : typographyStyles.genderStandard,
    'gender-boxed': typographyStyles.genderSmall
  };
  return /*#__PURE__*/createElement(Element, __assign$1({
    id: id,
    className: joinClasses(styles$1w.tab, isActive ? styles$1w.tabIsActive : '', (variant === 'standard-boxed' || variant === 'gender-boxed') && styles$1w.tabBoxed, (variant === 'small' || variant === 'small-swipeable' || variant === 'gender') && styles$1w.tabSmallHeight, variant === 'gender' && styles$1w.tabTypeGender, textTransformStyles["text-transform-".concat(textTransform)], genderTypography && styles$1w.tabGender, addWordBreak(wordBreak === 'break-word'), disabled && styles$1w.tabDisabled, type === 'white' && styles$1w.tabWhite, className),
    role: "tab",
    "aria-selected": isActive,
    onClick: clickCallback,
    onKeyUp: keyUpHandler,
    onMouseEnter: enableHover ? onMouseEnter : undefined,
    onMouseLeave: enableHover ? onMouseLeave : undefined
  }, props, gaProps, attributes, {
    tabIndex: tabIndex
  }), labelImage && variant === 'standard-boxed' ? isActive ? (/*#__PURE__*/createElement(WrapperEl, null, /*#__PURE__*/createElement("img", {
    src: labelImage,
    alt: label
  }))) : (/*#__PURE__*/createElement("img", {
    src: labelImage,
    alt: label
  })) : isActive ? (/*#__PURE__*/createElement(WrapperEl, {
    className: joinClasses(styles$1w.tabLabel, typography["".concat(variant)])
  }, label)) : (/*#__PURE__*/createElement("span", {
    className: joinClasses(styles$1w.tabLabel, typography["".concat(variant)])
  }, label)));
};
Tab.displayName = 'CoreTab';
Tab.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$1x = {"tab-group":"fr-ec-tab-group","tabGroup":"fr-ec-tab-group","tab-group__content":"fr-ec-tab-group__content","tabGroupContent":"fr-ec-tab-group__content","tab--standard-boxed":"fr-ec-tab--standard-boxed","tabStandardBoxed":"fr-ec-tab--standard-boxed","swipeable":"fr-ec-swipeable","tab-group-wrapper":"fr-ec-tab-group-wrapper","tabGroupWrapper":"fr-ec-tab-group-wrapper","swipeable__navigation-btn":"fr-ec-swipeable__navigation-btn","swipeableNavigationBtn":"fr-ec-swipeable__navigation-btn","swipeable__navigation-btn-right":"fr-ec-swipeable__navigation-btn-right","swipeableNavigationBtnRight":"fr-ec-swipeable__navigation-btn-right","swipeable__overlay-right":"fr-ec-swipeable__overlay-right","swipeableOverlayRight":"fr-ec-swipeable__overlay-right","swipeable__overlay-left":"fr-ec-swipeable__overlay-left","swipeableOverlayLeft":"fr-ec-swipeable__overlay-left","swipeable__navigation-btn-left":"fr-ec-swipeable__navigation-btn-left","swipeableNavigationBtnLeft":"fr-ec-swipeable__navigation-btn-left","swiper-button-disabled":"fr-ec-swiper-button-disabled","swiperButtonDisabled":"fr-ec-swiper-button-disabled"};

var TabGroup = /** @class */function (_super) {
  __extends(TabGroup, _super);
  function TabGroup(props) {
    var _this = _super.call(this, props) || this;
    _this.onTouchMove = function () {
      if (_this.swiperInstance) {
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    _this.onClick = function (label, index, child, tabOnclick) {
      return function (event, activeTabLabel) {
        var swipeable = _this.props.variant === 'small-swipeable';
        var ActiveTabIndex = event.currentTarget.getAttribute('tabid');
        _this.setState({
          activeTabId: index,
          activeTabLabel: activeTabLabel
        }, function () {
          if (swipeable) {
            _this.swiperInstance.slideTo(Number(ActiveTabIndex));
            _this.swiperInstance.update();
          }
          if (_this.swiperInstance) {
            _this.setState({
              isBeginning: _this.swiperInstance.isBeginning,
              isEnd: _this.swiperInstance.isEnd
            });
          }
        });
        if (tabOnclick) {
          tabOnclick(event, label, index, child);
        }
      };
    };
    _this.onResize = function () {
      var breakpoint = getCurrentMediaQueryBreakpoint();
      var isDesktop = breakpoint === 'lg';
      _this.setState({
        isLargeScreenDevice: isDesktop
      });
      if (_this.swiperInstance) {
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    _this.controlNavigation = function (direction) {
      if (_this.swiperInstance) {
        var slides = _this.swiperInstance.slides || 0;
        var _a = _this.swiperInstance,
          activeIndex = _a.activeIndex,
          isBeginning = _a.isBeginning,
          isEnd = _a.isEnd;
        var nextSlide = direction === 'NEXT' ? isEnd ? slides.length : activeIndex + 1 : isBeginning ? 0 : activeIndex - 1;
        if (direction === 'NEXT') {
          _this.swiperInstance.slideTo(nextSlide);
        } else {
          _this.swiperInstance.slideTo(nextSlide);
        }
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    var activeChildWithLabel = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildWithLabelProps = activeChildWithLabel ? activeChildWithLabel.props : {};
    _this.state = {
      activeTabId: _this.props.defaultIndex,
      activeTabLabel: activeChildWithLabelProps.label,
      isBeginning: false,
      isEnd: false,
      isLargeScreenDevice: false
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }
  TabGroup.prototype.componentDidMount = function () {
    var _this = this;
    var swipeable = this.props.variant === 'small-swipeable';
    if (swipeable) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observeParents: true,
        observer: true,
        on: {
          sliderMove: function sliderMove() {
            return _this.onTouchMove();
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 0
      });
    }
    if (this.swiperInstance) {
      var activeTabElement = Children.toArray(this.props.children).findIndex(function (child, index) {
        return child.props.isActive !== undefined ? child.props.label === _this.state.activeTabLabel : index === _this.state.activeTabId;
      });
      if (swipeable) {
        this.swiperInstance.slideTo(Number(activeTabElement));
        this.swiperInstance.update();
      }
      this.setState({
        isBeginning: this.swiperInstance.isBeginning,
        isEnd: this.swiperInstance.isEnd
      });
    }
  };
  TabGroup.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.defaultIndex !== this.props.defaultIndex) {
      this.setState({
        activeTabId: this.props.defaultIndex
      });
    }
  };
  TabGroup.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      className = _a.className,
      sticky = _a.sticky,
      variant = _a.variant,
      genderTypography = _a.genderTypography,
      isNavHeader = _a.isNavHeader,
      iconBrand = _a.iconBrand,
      props = __rest$1(_a, ["children", "className", "sticky", "variant", "genderTypography", "isNavHeader", "iconBrand"]);
    var swipeable = variant === 'small-swipeable';
    var _b = this.state,
      activeTabId = _b.activeTabId,
      activeTabLabel = _b.activeTabLabel;
    var activeContent = null;
    var clonedChildren = Children.toArray(children).map(function (item, index) {
      return /*#__PURE__*/cloneElement(item, {
        index: index
      });
    });
    var childrenWithProps = clonedChildren.filter(isValidElement).map(function (child, index) {
      if (child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId) {
        activeContent = child.props.children;
      }
      if (swipeable) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: "swiper-slide"
        }, /*#__PURE__*/cloneElement(child, {
          genderTypography: genderTypography,
          isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
          key: child.props.label,
          onClick: _this.onClick(child.props.label, child.props.index, child, child.props.onClick),
          tabid: index,
          variant: 'small-swipeable'
        }));
      }
      return /*#__PURE__*/cloneElement(child, {
        genderTypography: genderTypography,
        isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
        key: child.props.label,
        onClick: _this.onClick(child.props.label, child.props.index, child, child.props.onClick),
        variant: variant ? variant : 'standard'
      });
    });
    return /*#__PURE__*/createElement(Fragment, null, swipeable ? (/*#__PURE__*/createElement(Measure, {
      onResize: this.onResize
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef
      }, /*#__PURE__*/createElement("div", __assign$1({
        className: joinClasses('swiper-container', styles$1x.swipeable, className),
        ref: _this.swiperRef
      }, props), !_this.state.isBeginning && /*#__PURE__*/createElement("div", {
        className: styles$1x.swipeableOverlayLeft
      }), /*#__PURE__*/createElement("div", {
        role: "tablist",
        className: joinClasses('swiper-wrapper', styles$1x.tabGroupWrapper)
      }, childrenWithProps), !_this.state.isEnd && /*#__PURE__*/createElement("div", {
        className: styles$1x.swipeableOverlayRight
      }), _this.state.isLargeScreenDevice && (/*#__PURE__*/createElement(Fragment, null, !_this.state.isBeginning && (/*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-left",
        label: "arrow left",
        hideLabel: true,
        className: joinClasses('swiper-button-prev', styles$1x.swipeableNavigationBtn, styles$1x.swipeableNavigationBtnLeft),
        iconBrand: iconBrand,
        onClick: function onClick() {
          return _this.controlNavigation('PREV');
        }
      })), !_this.state.isEnd && (/*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-right",
        label: "arrow right",
        hideLabel: true,
        iconBrand: iconBrand,
        className: joinClasses('swiper-button-next', styles$1x.swipeableNavigationBtn, styles$1x.swipeableNavigationBtnRight),
        onClick: function onClick() {
          return _this.controlNavigation('NEXT');
        }
      }))))), /*#__PURE__*/createElement("div", {
        role: "tabpanel",
        className: styles$1x.tabGroupContent
      }, activeContent));
    })) : (/*#__PURE__*/createElement(Fragment, null, sticky ? (/*#__PURE__*/createElement(StickyContainer, {
      stickySection: "utilityBar",
      isNavHeader: isNavHeader
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1x.tabGroup, className),
      role: "tablist"
    }, childrenWithProps))) : (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1x.tabGroup, className),
      role: "tablist"
    }, childrenWithProps)), /*#__PURE__*/createElement("div", {
      role: "tabpanel",
      className: styles$1x.tabGroupContent
    }, activeContent))));
  };
  TabGroup.displayName = 'CoreTabGroup';
  TabGroup.defaultProps = {
    defaultIndex: 0,
    genderTypography: false,
    isNavHeader: true,
    sticky: false,
    swipeable: false,
    variant: 'standard'
  };
  return TabGroup;
}(Component);

var TableCellStyles = {"table-cell":"fr-ec-table-cell","tableCell":"fr-ec-table-cell","table":"fr-ec-table","table-cell--accordion":"fr-ec-table-cell--accordion","tableCellAccordion":"fr-ec-table-cell--accordion","table-cell--text-align-start":"fr-ec-table-cell--text-align-start","tableCellTextAlignStart":"fr-ec-table-cell--text-align-start","table-cell--text-align-center":"fr-ec-table-cell--text-align-center","tableCellTextAlignCenter":"fr-ec-table-cell--text-align-center","table-cell--text-align-end":"fr-ec-table-cell--text-align-end","tableCellTextAlignEnd":"fr-ec-table-cell--text-align-end","table-cell__body--vertical-padding-4":"fr-ec-table-cell__body--vertical-padding-4","tableCellBodyVerticalPadding4":"fr-ec-table-cell__body--vertical-padding-4","table-cell__body--vertical-padding-default":"fr-ec-table-cell__body--vertical-padding-default","tableCellBodyVerticalPaddingDefault":"fr-ec-table-cell__body--vertical-padding-default","table-cell--border-bottom-default":"fr-ec-table-cell--border-bottom-default","tableCellBorderBottomDefault":"fr-ec-table-cell--border-bottom-default","table-cell--border-bottom":"fr-ec-table-cell--border-bottom","tableCellBorderBottom":"fr-ec-table-cell--border-bottom","table-row--with-border":"fr-ec-table-row--with-border","tableRowWithBorder":"fr-ec-table-row--with-border","table-cell--content-alignment":"fr-ec-table-cell--content-alignment","tableCellContentAlignment":"fr-ec-table-cell--content-alignment","content-alignment":"fr-ec-content-alignment","contentAlignment":"fr-ec-content-alignment"};

var TableCell = function TableCell(_a) {
  var Element = _a.element,
    className = _a.className,
    _b = _a.alignment,
    alignment = _b === void 0 ? 'start' : _b,
    width = _a.width,
    props = __rest$1(_a, ["element", "className", "alignment", "width"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(TableCellStyles.tableCell, TableCellStyles["table-cell--text-align-".concat(alignment)], className),
      style: {
        width: width
      }
    }, props))
  );
};
TableCell.displayName = 'CoreTableCell';
TableCell.defaultProps = {
  alignment: 'start'
};

var TableRow = function TableRow(props) {
  return /*#__PURE__*/createElement("tr", __assign$1({}, props));
};
TableRow.displayName = 'CoreTableRow';

var styles$1y = {"comparison-table":"fr-ec-comparison-table","comparisonTable":"fr-ec-comparison-table","comparison-table-heading":"fr-ec-comparison-table-heading","comparisonTableHeading":"fr-ec-comparison-table-heading","comparison-table-content":"fr-ec-comparison-table-content","comparisonTableContent":"fr-ec-comparison-table-content","comparison-table-content-highlighted":"fr-ec-comparison-table-content-highlighted","comparisonTableContentHighlighted":"fr-ec-comparison-table-content-highlighted"};

var ComparisonTable = function ComparisonTable(_a) {
  var _b;
  var headings = _a.headings,
    contents = _a.contents;
  var tableRows = function tableRows() {
    var rowContents = headings || contents;
    if (headings && contents) {
      return headings === null || headings === void 0 ? void 0 : headings.map(function (_, index) {
        return [{
          heading: true,
          content: headings[index]
        }, {
          heading: false,
          content: contents[index]
        }];
      });
    }
    return rowContents === null || rowContents === void 0 ? void 0 : rowContents.map(function (item) {
      return [{
        content: item,
        heading: false
      }];
    });
  };
  return /*#__PURE__*/createElement("div", {
    className: styles$1y.comparisonTable
  }, /*#__PURE__*/createElement("table", null, /*#__PURE__*/createElement("tbody", null, (_b = tableRows()) === null || _b === void 0 ? void 0 : _b.map(function (row, i) {
    return /*#__PURE__*/createElement(TableRow, {
      key: i
    }, row.map(function (cell, j) {
      return /*#__PURE__*/createElement(TableCell, {
        key: j,
        element: "td",
        className: joinClasses(cell.heading ? styles$1y.comparisonTableHeading : styles$1y.comparisonTableContent, _typeof(cell.content) === 'object' && cell.content.common && styles$1y.comparisonTableContentHighlighted)
      }, /*#__PURE__*/createElement(Caption, {
        element: "span",
        variant: 'small'
      }, _typeof(cell.content) === 'object' ? cell.content.label : cell.content));
    }));
  }))));
};
ComparisonTable.displayName = 'CoreComparisonTable';

var styles$1z = {"tag":"fr-ec-tag","tag--gender":"fr-ec-tag--gender","tagGender":"fr-ec-tag--gender","tag--promotional":"fr-ec-tag--promotional","tagPromotional":"fr-ec-tag--promotional","tag--primary":"fr-ec-tag--primary","tagPrimary":"fr-ec-tag--primary","tag--secondary":"fr-ec-tag--secondary","tagSecondary":"fr-ec-tag--secondary","tag__caption":"fr-ec-tag__caption","tagCaption":"fr-ec-tag__caption"};

var variantStyles$2 = {
  gender: {
    tag: styles$1z.tagGender,
    color: 'primary-dark'
  },
  primary: {
    tag: styles$1z.tagPrimary,
    color: 'secondary'
  },
  promotional: {
    tag: styles$1z.tagPromotional,
    color: 'primary-light'
  },
  secondary: {
    tag: styles$1z.tagSecondary,
    color: 'primary-light'
  }
};
var Tag = function Tag(_a) {
  var value = _a.value,
    variant = _a.variant,
    _b = _a.className,
    className = _b === void 0 ? '' : _b,
    _c = _a.wordBreak,
    wordBreak = _c === void 0 ? 'none' : _c,
    props = __rest$1(_a, ["value", "variant", "className", "wordBreak"]);
  var variantStyle = variantStyles$2[variant];
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$1z.tag, variantStyle === null || variantStyle === void 0 ? void 0 : variantStyle.tag, addWordBreak(wordBreak === 'break-word'), className)
  }, props), /*#__PURE__*/createElement(Caption, {
    color: variantStyle === null || variantStyle === void 0 ? void 0 : variantStyle.color,
    variant: "standard",
    element: "span",
    className: joinClasses(styles$1z.tagCaption)
  }, value));
};
Tag.displayName = 'CoreTag';

var LayoutGutterHiddenAtSmall = function LayoutGutterHiddenAtSmall(props) {
  return /*#__PURE__*/createElement(Layout, __assign$1({
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, props));
};
LayoutGutterHiddenAtSmall.displayName = 'CoreLayoutGutterHiddenAtSmall';

var styles$1A = {"template-cart__right":"fr-ec-template-cart__right","templateCartRight":"fr-ec-template-cart__right","template-cart__order-summary":"fr-ec-template-cart__order-summary","templateCartOrderSummary":"fr-ec-template-cart__order-summary","template-cart--min-height":"fr-ec-template-cart--min-height","templateCartMinHeight":"fr-ec-template-cart--min-height","breadcrump-wrapper":"fr-ec-breadcrump-wrapper","breadcrumpWrapper":"fr-ec-breadcrump-wrapper","breadcrumb-group":"fr-ec-breadcrumb-group","breadcrumbGroup":"fr-ec-breadcrumb-group","template-cart-reset-margin":"fr-ec-template-cart-reset-margin","templateCartResetMargin":"fr-ec-template-cart-reset-margin"};

var navigationHeaderHeight = 73;
var TemplateCart = function TemplateCart(_a) {
  var navigationPath = _a.navigationPath,
    pageHeading = _a.pageHeading,
    carouselSection = _a.carouselSection,
    pickupCartPageContent = _a.pickupCartPageContent,
    onlineCartPageContent = _a.onlineCartPageContent,
    pickupCartOrderSummary = _a.pickupCartOrderSummary,
    pickupCartCoupon = _a.pickupCartCoupon,
    pickupCartCTA = _a.pickupCartCTA,
    pickupCartBanner = _a.pickupCartBanner,
    onlineCartOrderSummary = _a.onlineCartOrderSummary,
    onlineCartCoupon = _a.onlineCartCoupon,
    onlineCartCTA = _a.onlineCartCTA,
    onlineCartBanner = _a.onlineCartBanner,
    className = _a.className,
    _b = _a.cartPageContentHeight,
    cartPageContentHeight = _b === void 0 ? false : _b,
    _c = _a.toggleMinHeight,
    toggleMinHeight = _c === void 0 ? true : _c;
  var scrollValues = {
    scrollTop_1: window.pageYOffset,
    scrollTop_2: window.pageYOffset
  };
  var isDesktopMedia = isInBrowser$1() && window.matchMedia('(min-width: 960px)');
  useEffect(function () {
    if (isDesktopMedia && isDesktopMedia.matches) {
      window.addEventListener('scroll', trackScroll);
      trackScroll();
    }
  }, [cartPageContentHeight]);
  var trackScroll = function trackScroll() {
    var cartOrderSummaryClasses = document.getElementsByClassName('fr-ec-template-cart__right');
    var cartContentClasses = document.getElementsByClassName('fr-ec-template-cart__left');
    if (cartOrderSummaryClasses.length > 0 && cartContentClasses.length > 0) {
      for (var i = 0; i < cartOrderSummaryClasses.length; i++) {
        var cartOrderSummaryElementClass = cartOrderSummaryClasses[i];
        var cartContentElementClass = cartContentClasses[i];
        var cartContentElementClassHeight = cartContentElementClass.getBoundingClientRect().height;
        var cartOrderSummaryElementClassHeight = cartOrderSummaryElementClass.getBoundingClientRect().height;
        if (isDesktopMedia && isDesktopMedia.matches && cartContentElementClassHeight > cartOrderSummaryElementClassHeight) {
          var currScroll = window.pageYOffset;
          if (currScroll > scrollValues["scrollTop_".concat(i)] || scrollValues["scrollTop_".concat(i)] === undefined) {
            if (currScroll === 0 && scrollValues["scrollTop_".concat(i)] === undefined) {
              cartOrderSummaryElementClass.style.position = 'relative';
            } else if (window.innerHeight >= cartContentElementClass.getBoundingClientRect().bottom) {
              cartOrderSummaryElementClass.style.position = 'relative';
              cartOrderSummaryElementClass.style.top = "".concat(cartContentElementClassHeight - cartOrderSummaryElementClassHeight, "px");
            } else if (cartOrderSummaryElementClass.getBoundingClientRect().bottom <= window.innerHeight) {
              cartOrderSummaryElementClass.style.position = 'fixed';
              cartOrderSummaryElementClass.style.top = 'auto';
              cartOrderSummaryElementClass.style.bottom = "".concat(0, "px");
            }
          } else {
            if (cartContentElementClass.getBoundingClientRect().top >= navigationHeaderHeight) {
              cartOrderSummaryElementClass.style.position = 'relative';
              cartOrderSummaryElementClass.style.top = '0';
            } else if (cartContentElementClass.getBoundingClientRect().top >= navigationHeaderHeight || cartOrderSummaryElementClass.getBoundingClientRect().top >= navigationHeaderHeight) {
              cartOrderSummaryElementClass.style.position = 'fixed';
              cartOrderSummaryElementClass.style.top = "".concat(navigationHeaderHeight, "px");
              cartOrderSummaryElementClass.style.bottom = 'auto';
            } else if (cartOrderSummaryElementClass.style.position === 'fixed') {
              var top_1 = cartContentElementClass.getBoundingClientRect().top;
              var elemTop = cartOrderSummaryElementClass.getBoundingClientRect().top;
              cartOrderSummaryElementClass.style.position = 'relative';
              cartOrderSummaryElementClass.style.top = "".concat(-1 * top_1 + elemTop, "px");
            }
          }
          scrollValues["scrollTop_".concat(i)] = currScroll;
        } else {
          cartOrderSummaryElementClass.style.position = 'relative';
          cartOrderSummaryElementClass.style.top = '0px';
        }
      }
    }
  };
  return /*#__PURE__*/React__default.createElement("main", null, /*#__PURE__*/React__default.createElement(LayoutWrapper, {
    className: joinClasses(toggleMinHeight && styles$1A.templateCartMinHeight, spacingStyles.mtSpacing05, className),
    element: "section"
  }, /*#__PURE__*/React__default.createElement(LayoutGutterHiddenAtSmall, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    element: "section"
  }, pageHeading), pickupCartPageContent && (/*#__PURE__*/React__default.createElement(LayoutGutterHiddenAtSmall, {
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    className: "fr-ec-template-cart__left"
  }, pickupCartPageContent)), (pickupCartOrderSummary || pickupCartCoupon || pickupCartCTA || pickupCartBanner) && (/*#__PURE__*/React__default.createElement(LayoutGutterHiddenAtSmall, {
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    className: styles$1A.templateCartRight,
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    }
  }, pickupCartOrderSummary && (/*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: false,
      md: false,
      lg: true
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pickupCartOrderSummary)), pickupCartCoupon && (/*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    className: styles$1A.templateCartResetMargin
  }, pickupCartCoupon)), pickupCartOrderSummary && (/*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: true,
      md: true,
      lg: false
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    className: styles$1A.templateCartResetMargin
  }, pickupCartOrderSummary)), pickupCartCTA && (/*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    className: styles$1A.templateCartResetMargin
  }, pickupCartCTA)), pickupCartBanner)), /*#__PURE__*/React__default.createElement(LayoutGutterHiddenAtSmall, {
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    className: "fr-ec-template-cart__left",
    visible: {
      sm: onlineCartPageContent ? true : false,
      md: onlineCartPageContent ? true : false,
      lg: true
    }
  }, /*#__PURE__*/React__default.createElement(Layout, {
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    },
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, onlineCartPageContent)), (onlineCartOrderSummary || onlineCartCoupon || onlineCartCTA || onlineCartBanner) && (/*#__PURE__*/React__default.createElement(LayoutGutterHiddenAtSmall, {
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    className: styles$1A.templateCartRight,
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    }
  }, onlineCartOrderSummary && (/*#__PURE__*/React__default.createElement(Layout, {
    className: styles$1A.templateCartOrderSummary,
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: false,
      md: false,
      lg: true
    },
    gutter: {
      sm: false,
      md: false,
      lg: true
    }
  }, onlineCartOrderSummary)), onlineCartCoupon && (/*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    className: styles$1A.templateCartResetMargin
  }, onlineCartCoupon)), onlineCartOrderSummary && (/*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: true,
      md: true,
      lg: false
    },
    gutter: {
      sm: true,
      md: false,
      lg: true
    },
    className: styles$1A.templateCartResetMargin
  }, onlineCartOrderSummary)), onlineCartCTA && (/*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    gutter: {
      sm: true,
      md: false,
      lg: true
    },
    className: styles$1A.templateCartResetMargin
  }, onlineCartCTA)), onlineCartBanner)), carouselSection && (/*#__PURE__*/React__default.createElement(LayoutGutterHiddenAtSmall, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    element: "section"
  }, carouselSection))), /*#__PURE__*/React__default.createElement(LayoutWrapper, {
    element: "section",
    className: styles$1A.breadcrumpWrapper
  }, navigationPath && (/*#__PURE__*/React__default.createElement(LayoutGutterHiddenAtSmall, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, navigationPath))));
};
TemplateCart.displayName = 'TemplateCart';
TemplateCart.defaultProps = {
  toggleMinHeight: true
};

var styles$1B = {"template-checkout":"fr-ec-template-checkout","templateCheckout":"fr-ec-template-checkout","template-checkout__left":"fr-ec-template-checkout__left","templateCheckoutLeft":"fr-ec-template-checkout__left","template-checkout__right":"fr-ec-template-checkout__right","templateCheckoutRight":"fr-ec-template-checkout__right","template-checkout__summary-nav":"fr-ec-template-checkout__summary-nav","templateCheckoutSummaryNav":"fr-ec-template-checkout__summary-nav","template-checkout__summary":"fr-ec-template-checkout__summary","templateCheckoutSummary":"fr-ec-template-checkout__summary","template-checkout__wrapper":"fr-ec-template-checkout__wrapper","templateCheckoutWrapper":"fr-ec-template-checkout__wrapper","breadcrump-wrapper":"fr-ec-breadcrump-wrapper","breadcrumpWrapper":"fr-ec-breadcrump-wrapper","breadcrumb-group":"fr-ec-breadcrumb-group","breadcrumbGroup":"fr-ec-breadcrumb-group"};

var navigationHeaderHeight$1 = 73;
var TemplateCheckout = function TemplateCheckout(_a) {
  var pageHeading = _a.pageHeading,
    summarySection = _a.summarySection,
    stepOne = _a.stepOne,
    stepTwo = _a.stepTwo,
    promotionalSection = _a.promotionalSection,
    navigationPath = _a.navigationPath,
    className = _a.className,
    iqChatSection = _a.iqChatSection,
    tlsSection = _a.tlsSection,
    stickySectionZIndex = _a.stickySectionZIndex;
  var scrollTop = isInBrowser$1() ? window.pageYOffset : 0;
  var breakpoint = getCurrentMediaQueryBreakpoint();
  var isDesktopMedia = breakpoint === 'lg';
  var _b = useState(getCurrentMediaQueryBreakpoint());
  useEffect(function () {
    if (isDesktopMedia) {
      window.addEventListener('scroll', trackScroll);
    }
  });
  var trackScroll = function trackScroll() {
    var templateFixedContainer = document.getElementsByClassName('fr-ec-template-checkout-fixed-container');
    var templateContainerClasses = document.getElementsByClassName('fr-ec-template-checkout-details-container');
    if (templateFixedContainer.length > 0 && templateContainerClasses.length > 0) {
      var templateFixedContainerClass = templateFixedContainer[0];
      var templateContainerClass = templateContainerClasses[0];
      var templateContainerHeight = templateContainerClass.getBoundingClientRect().height;
      var templateFixedContainerInnerheight = templateFixedContainerClass.getBoundingClientRect().height;
      var combinedHeight = templateFixedContainerInnerheight + navigationHeaderHeight$1;
      if (isDesktopMedia && templateContainerHeight > templateFixedContainerInnerheight) {
        if (combinedHeight >= window.innerHeight) {
          var currScroll = window.pageYOffset;
          if (currScroll > scrollTop) {
            if (window.innerHeight >= templateContainerClass.getBoundingClientRect().bottom) {
              templateFixedContainerClass.style.position = 'relative';
              templateFixedContainerClass.style.top = "".concat(templateContainerHeight - templateFixedContainerInnerheight, "px");
            } else if (templateFixedContainerClass.getBoundingClientRect().bottom <= window.innerHeight) {
              templateFixedContainerClass.style.position = 'fixed';
              templateFixedContainerClass.style.top = 'auto';
              templateFixedContainerClass.style.bottom = "".concat(0, "px");
            }
          } else {
            if (templateContainerClass.getBoundingClientRect().top >= navigationHeaderHeight$1) {
              templateFixedContainerClass.style.position = 'relative';
              templateFixedContainerClass.style.top = '0';
            } else if (templateContainerClass.getBoundingClientRect().top >= 0 || templateFixedContainerClass.getBoundingClientRect().top >= 0) {
              templateFixedContainerClass.style.position = 'fixed';
              templateFixedContainerClass.style.top = "".concat(navigationHeaderHeight$1, "px");
            } else if (templateFixedContainerClass.style.position === 'fixed') {
              var top_1 = templateContainerClass.getBoundingClientRect().top;
              var elemTop = templateFixedContainerClass.getBoundingClientRect().top;
              templateFixedContainerClass.style.position = 'relative';
              templateFixedContainerClass.style.top = "".concat(-1 * top_1 + elemTop, "px");
            }
          }
          scrollTop = currScroll;
        } else {
          templateFixedContainerClass.style.position = 'sticky';
          templateFixedContainerClass.style.top = "".concat(navigationHeaderHeight$1, "px");
        }
      }
    }
  };
  return /*#__PURE__*/createElement("main", {
    className: joinClasses(className, styles$1B.templateCheckout, spacingStyles.mtSpacing05)
  }, /*#__PURE__*/createElement(LayoutWrapper, {
    element: "section",
    className: styles$1B.templateCheckoutWrapper
  }, /*#__PURE__*/createElement(LayoutGutterHiddenAtSmall, {
    element: "section"
  }, pageHeading), /*#__PURE__*/createElement(Layout, {
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    },
    className: joinClasses('fr-ec-template-checkout-details-container', styles$1B.templateCheckoutLeft),
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    gutter: true
  }, stepOne, /*#__PURE__*/createElement(Layout, {
    visible: {
      sm: true,
      md: true,
      lg: false
    }
  }, promotionalSection), stepTwo, iqChatSection && (/*#__PURE__*/createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 6,
      lg: 4
    },
    visible: {
      sm: true,
      md: true,
      lg: false
    }
  }, iqChatSection)), tlsSection), /*#__PURE__*/createElement(LayoutGutterHiddenAtSmall, {
    visible: {
      sm: false,
      md: false,
      lg: true
    },
    className: joinClasses('fr-ec-template-checkout-fixed-container', styles$1B.templateCheckoutRight),
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    style: {
      zIndex: stickySectionZIndex
    }
  }, summarySection, promotionalSection, iqChatSection), navigationPath && /*#__PURE__*/createElement(LayoutGutterHiddenAtSmall, {
    className: styles$1B.breadcrumpWrapper
  }, navigationPath)));
};
TemplateCheckout.displayName = 'TemplateCheckout';

var styles$1C = {"template-fixed-panel--min-height":"fr-ec-template-fixed-panel--min-height","templateFixedPanelMinHeight":"fr-ec-template-fixed-panel--min-height","breadcrump-wrapper":"fr-ec-breadcrump-wrapper","breadcrumpWrapper":"fr-ec-breadcrump-wrapper","breadcrumb-group":"fr-ec-breadcrumb-group","breadcrumbGroup":"fr-ec-breadcrumb-group"};

var LayoutGutter = function LayoutGutter(props) {
  return /*#__PURE__*/createElement(Layout, __assign$1({
    gutter: true
  }, props));
};
var TemplateFixedPanel = function TemplateFixedPanel(_a) {
  var navigationPath = _a.navigationPath,
    pageHeading = _a.pageHeading,
    sectionHeading = _a.sectionHeading,
    pageContent = _a.pageContent,
    sidePanel = _a.sidePanel,
    _b = _a.toggleMinHeight,
    toggleMinHeight = _b === void 0 ? true : _b,
    className = _a.className,
    props = __rest$1(_a, ["navigationPath", "pageHeading", "sectionHeading", "pageContent", "sidePanel", "toggleMinHeight", "className"]);
  var showSidePanel = sidePanel !== undefined;
  return /*#__PURE__*/createElement(LayoutWrapper, __assign$1({
    className: joinClasses(className, spacingStyles.mtSpacing05),
    element: "section"
  }, props), pageHeading && /*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pageHeading), sidePanel && (/*#__PURE__*/createElement(LayoutGutter, {
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 0
    },
    visible: {
      sm: showSidePanel,
      md: showSidePanel,
      lg: false
    }
  }, sidePanel)), /*#__PURE__*/createElement(Layout, {
    element: "section"
  }, /*#__PURE__*/createElement(LayoutGutter, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, sectionHeading, /*#__PURE__*/createElement("div", {
    className: toggleMinHeight ? styles$1C.templateFixedPanelMinHeight : ''
  }, pageContent)), sidePanel && (/*#__PURE__*/createElement(LayoutGutter, {
    element: "div",
    colSpan: {
      sm: 0,
      md: 0,
      lg: 4
    },
    visible: {
      sm: false,
      md: false,
      lg: showSidePanel
    }
  }, sidePanel))), navigationPath && /*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: styles$1C.breadcrumpWrapper
  }, navigationPath));
};
TemplateFixedPanel.displayName = 'CoreTemplateFixedPanel';
TemplateFixedPanel.defaultProps = {
  toggleMinHeight: true
};

var styles$1D = {"template-information--min-height":"fr-ec-template-information--min-height","templateInformationMinHeight":"fr-ec-template-information--min-height","breadcrump-wrapper":"fr-ec-breadcrump-wrapper","breadcrumpWrapper":"fr-ec-breadcrump-wrapper","breadcrumb-group":"fr-ec-breadcrumb-group","breadcrumbGroup":"fr-ec-breadcrumb-group"};

var SecondaryNav = function SecondaryNav(props) {
  return /*#__PURE__*/createElement(Layout, __assign$1({
    element: "nav",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 3
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    },
    gutter: true
  }, props));
};
var TemplateInformation = function TemplateInformation(_a) {
  var navigationPath = _a.navigationPath,
    pageHeading = _a.pageHeading,
    mainContent = _a.mainContent,
    secondaryNavigation = _a.secondaryNavigation,
    tabContent = _a.tabContent,
    _b = _a.hideSecondaryNavigationOnSmall,
    hideSecondaryNavigationOnSmall = _b === void 0 ? true : _b,
    _c = _a.hideSecondaryNavigationOnMedium,
    hideSecondaryNavigationOnMedium = _c === void 0 ? true : _c,
    _d = _a.toggleMinHeight,
    toggleMinHeight = _d === void 0 ? true : _d,
    _e = _a.toggleMinHeightforTab,
    toggleMinHeightforTab = _e === void 0 ? true : _e,
    mainContentFullWidthonSmall = _a.mainContentFullWidthonSmall,
    props = __rest$1(_a, ["navigationPath", "pageHeading", "mainContent", "secondaryNavigation", "tabContent", "hideSecondaryNavigationOnSmall", "hideSecondaryNavigationOnMedium", "toggleMinHeight", "toggleMinHeightforTab", "mainContentFullWidthonSmall"]);
  return /*#__PURE__*/createElement(LayoutWrapper, __assign$1({
    element: "section"
  }, props, {
    className: spacingStyles.mtSpacing05
  }), /*#__PURE__*/createElement(Layout, {
    element: "section"
  }, /*#__PURE__*/createElement(SecondaryNav, {
    visible: {
      sm: false,
      md: false,
      lg: true
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, secondaryNavigation), /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    }
  }, pageHeading && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pageHeading)), tabContent && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: toggleMinHeightforTab ? styles$1D.templateInformationMinHeight : ''
  }, tabContent)), mainContent && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    },
    gutter: {
      sm: !mainContentFullWidthonSmall,
      md: true,
      lg: true
    },
    className: toggleMinHeight ? styles$1D.templateInformationMinHeight : ''
  }, mainContent)))), /*#__PURE__*/createElement(SecondaryNav, {
    visible: {
      sm: !hideSecondaryNavigationOnSmall,
      md: !hideSecondaryNavigationOnMedium,
      lg: false
    }
  }, secondaryNavigation), navigationPath && (/*#__PURE__*/createElement(Layout, {
    element: "nav",
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: styles$1D.breadcrumpWrapper
  }, navigationPath)));
};
TemplateInformation.displayName = 'CoreTemplateInformation';
TemplateInformation.defaultProps = {
  hideSecondaryNavigationOnMedium: true,
  hideSecondaryNavigationOnSmall: true,
  mainContentFullWidthonSmall: false,
  toggleMinHeight: true,
  toggleMinHeightforTab: true
};

var styles$1E = {"tooltip":"fr-ec-tooltip","tooltip__bubble":"fr-ec-tooltip__bubble","tooltipBubble":"fr-ec-tooltip__bubble","tooltip__image":"fr-ec-tooltip__image","tooltipImage":"fr-ec-tooltip__image","image":"fr-ec-image","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","tooltip__bubble__image":"fr-ec-tooltip__bubble__image","tooltipBubbleImage":"fr-ec-tooltip__bubble__image","tooltip__bubble--popup-size-small":"fr-ec-tooltip__bubble--popup-size-small","tooltipBubblePopupSizeSmall":"fr-ec-tooltip__bubble--popup-size-small","tooltip__bubble-content":"fr-ec-tooltip__bubble-content","tooltipBubbleContent":"fr-ec-tooltip__bubble-content","tooltip__bubble--hidden":"fr-ec-tooltip__bubble--hidden","tooltipBubbleHidden":"fr-ec-tooltip__bubble--hidden","tooltip__arrow":"fr-ec-tooltip__arrow","tooltipArrow":"fr-ec-tooltip__arrow","tooltip__bubble--variant-top":"fr-ec-tooltip__bubble--variant-top","tooltipBubbleVariantTop":"fr-ec-tooltip__bubble--variant-top","bounceToBottom":"fr-ec-bounceToBottom","tooltip__bubble--variant-bottom":"fr-ec-tooltip__bubble--variant-bottom","tooltipBubbleVariantBottom":"fr-ec-tooltip__bubble--variant-bottom","bounceToTop":"fr-ec-bounceToTop","tooltip__bubble--variant-left":"fr-ec-tooltip__bubble--variant-left","tooltipBubbleVariantLeft":"fr-ec-tooltip__bubble--variant-left","bounceStart":"fr-ec-bounceStart","tooltip__bubble--variant-right":"fr-ec-tooltip__bubble--variant-right","tooltipBubbleVariantRight":"fr-ec-tooltip__bubble--variant-right","bounceEnd":"fr-ec-bounceEnd"};

var variantStyles$3 = {
  bottom: styles$1E.tooltipBubbleVariantBottom,
  bottomLeft: styles$1E.tooltipBubbleVariantBottom,
  bottomRight: styles$1E.tooltipBubbleVariantBottom,
  end: styles$1E.tooltipBubbleVariantLeft,
  endBottom: styles$1E.tooltipBubbleVariantLeft,
  endTop: styles$1E.tooltipBubbleVariantLeft,
  start: styles$1E.tooltipBubbleVariantRight,
  startBottom: styles$1E.tooltipBubbleVariantRight,
  startTop: styles$1E.tooltipBubbleVariantRight,
  top: styles$1E.tooltipBubbleVariantTop,
  topLeft: styles$1E.tooltipBubbleVariantTop,
  topRight: styles$1E.tooltipBubbleVariantTop
};
var arrowSize = 0;
var windowMargins = {
  lg: designTokens_15.spacingGutterLg,
  md: designTokens_15.spacingGutterMd,
  sm: designTokens_15.spacingGutterSm / 2
};
var TooltipComponent = /** @class */function (_super) {
  __extends(TooltipComponent, _super);
  function TooltipComponent(props) {
    var _this = _super.call(this, props) || this;
    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        document.removeEventListener('touchend', _this.handleClickOutside);
        document.removeEventListener('mousedown', _this.handleClickOutside);
        document.removeEventListener('blur', _this.handleClickOutside);
        document.removeEventListener('scroll', _this.handleClickOutside);
      }
    };
    _this.handleClickOutside = function (event) {
      var tooltipOuterNode = _this.tooltipOuterRef.current;
      var target = event.target;
      if (tooltipOuterNode && target instanceof Node && _this.state.isOpen && !tooltipOuterNode.contains(target)) {
        setTimeout(function () {
          _this.hideTooltip();
        }, 200);
      }
    };
    _this.hideTooltip = function () {
      _this.setState(function (prevState) {
        return __assign$1(__assign$1({}, prevState), {
          isOpen: false
        });
      });
    };
    _this.hideTooltipWithTimeout = function () {
      if (_this.props.variant === 'icon') {
        _this.timeoutID = window.setTimeout(function () {
          _this.hideTooltip();
        }, _this.props.timeout || 1500);
      }
    };
    _this.cancelHideTooltip = function () {
      if (_this.props.variant === 'icon') {
        clearTimeout(_this.timeoutID);
      }
    };
    _this.onUpdateTooltip = function (event) {
      event.preventDefault();
      if (_this.props.onClick) {
        _this.props.onClick();
      }
      if (!_this.state.isOpen) {
        var tooltipBubbleNode = _this.tooltipBubbleRef.current;
        var tooltipOuterNode = _this.tooltipOuterRef.current;
        var breakpoint = getCurrentMediaQueryBreakpoint();
        var windowMargin = windowMargins[breakpoint];
        if (tooltipBubbleNode && tooltipOuterNode) {
          var fallback = _this.state.fallback;
          var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];
          positionTooltip(fallbackArray[0] || DIRECTION_TOP, tooltipBubbleNode, windowMargin, tooltipOuterNode.getBoundingClientRect());
          _this.setState({
            direction: fallbackArray[0] || DIRECTION_TOP,
            fallback: fallback,
            isOpen: true
          });
        }
      } else {
        _this.hideTooltip();
      }
    };
    _this.tooltipBubbleRef = /*#__PURE__*/createRef();
    _this.tooltipOuterRef = /*#__PURE__*/createRef();
    var fallback = getFallback(_this.props.direction);
    _this.state = {
      direction: fallback[0] || DIRECTION_TOP,
      fallback: fallback,
      isOpen: false
    };
    return _this;
  }
  TooltipComponent.getDerivedStateFromProps = function (props, state) {
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var fallback = getFallback(props.direction);
    var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];
    var isUpdatedFallBack = JSON.stringify(state.fallback) !== JSON.stringify(fallback);
    if (state.direction !== fallbackArray[0] || isUpdatedFallBack) {
      return {
        direction: fallbackArray[0] || DIRECTION_TOP,
        fallback: fallback
      };
    }
    return null;
  };
  TooltipComponent.prototype.componentDidMount = function () {
    var tooltipBubbleNode = this.tooltipBubbleRef.current;
    var tooltipOuterNode = this.tooltipOuterRef.current;
    if (tooltipBubbleNode && tooltipOuterNode) {
      var breakpoint = getCurrentMediaQueryBreakpoint();
      var windowMargin = windowMargins[breakpoint];
      var fallback = this.state.fallback;
      var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];
      positionTooltip(fallbackArray[0] || DIRECTION_TOP, tooltipBubbleNode, windowMargin, tooltipBubbleNode.getBoundingClientRect());
    }
    if (isInBrowser$1()) {
      document.addEventListener('touchend', this.handleClickOutside);
      document.addEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('blur', this.handleClickOutside);
      document.addEventListener('scroll', this.handleClickOutside);
    }
  };
  TooltipComponent.prototype.componentDidUpdate = function () {
    var tooltipBubbleNode = this.tooltipBubbleRef.current;
    var tooltipOuterNode = this.tooltipOuterRef.current;
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var windowMargin = windowMargins[breakpoint];
    var fallback = this.state.fallback;
    var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];
    if (tooltipBubbleNode && tooltipOuterNode) {
      positionTooltip(fallbackArray[0] || DIRECTION_TOP, tooltipBubbleNode, windowMargin, tooltipOuterNode.getBoundingClientRect());
    }
    /*
    if tooltip comes inside flyout and flyout have a overflow
    set flyout overflow as visible
    */
    if (isInBrowser$1()) {
      if (this.tooltipBubbleRef.current) {
        var flyoutWrapper = this.tooltipBubbleRef.current.closest('.fr-ec-flyout__column-layout');
        if (flyoutWrapper) {
          var scrollHeight = flyoutWrapper === null || flyoutWrapper === void 0 ? void 0 : flyoutWrapper.scrollHeight;
          var clientHeight = flyoutWrapper === null || flyoutWrapper === void 0 ? void 0 : flyoutWrapper.clientHeight;
          if (scrollHeight && clientHeight) {
            if (scrollHeight > clientHeight) {
              flyoutWrapper === null || flyoutWrapper === void 0 ? void 0 : flyoutWrapper.classList.add('fr-ec-flyout__column-layout--overflow-visible');
            } else {
              flyoutWrapper === null || flyoutWrapper === void 0 ? void 0 : flyoutWrapper.classList.remove('fr-ec-flyout__column-layout--overflow-visible');
            }
          }
        }
      }
    }
  };
  TooltipComponent.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      content = _a.content,
      ariaLabel = _a.ariaLabel,
      id = _a.id,
      className = _a.className,
      _b = _a.icon,
      icon = _b === void 0 ? 'information' : _b,
      _c = _a.popupSize,
      popupSize = _c === void 0 ? 'default' : _c,
      iconBrand = _a.iconBrand,
      _d = _a.variant,
      variant = _d === void 0 ? 'icon' : _d,
      imageChild = _a.imageChild;
    var contentId = "".concat(id, "-content");
    var bubbleId = "".concat(id, "-bubble");
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1E.tooltip, className),
      // tslint:disable:react-a11y-event-has-role
      onMouseLeave: this.hideTooltipWithTimeout,
      onMouseOver: this.cancelHideTooltip
    }, content && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1E.tooltipBubble, variant === 'image' && styles$1E.tooltipBubbleImage, variantStyles$3[this.state.direction], !this.state.isOpen && styles$1E.tooltipBubbleHidden, popupSize === 'small' && styles$1E.tooltipBubblePopupSizeSmall),
      ref: this.tooltipBubbleRef,
      role: "tooltip",
      id: bubbleId
    }, /*#__PURE__*/createElement(Caption, {
      element: "div",
      id: contentId,
      className: styles$1E.tooltipBubbleContent
    }, content)), /*#__PURE__*/createElement("div", {
      className: styles$1E.tooltipArrow
    }))), /*#__PURE__*/createElement("div", {
      ref: this.tooltipOuterRef,
      className: variant === 'image' && styles$1E.tooltipImage || ''
    }, variant === 'icon' ? (/*#__PURE__*/createElement(ButtonIcon, {
      id: id,
      element: "button",
      type: "button",
      icon: icon,
      iconBrand: iconBrand,
      label: ariaLabel,
      hideLabel: true,
      onMouseDown: this.onUpdateTooltip,
      onKeyDown: function onKeyDown(event) {
        if (event.keyCode === KEYCODE.ENTER || event.keyCode === KEYCODE.SPACE) {
          _this.onUpdateTooltip(event);
        }
      },
      onTouchEnd: this.onUpdateTooltip,
      "aria-describedby": contentId
    })) : Children.toArray(imageChild).filter(isValidElement).map(function (child) {
      return /*#__PURE__*/cloneElement(child, {
        onClick: _this.onUpdateTooltip
      });
    })));
  };
  TooltipComponent.displayName = 'CoreTooltip';
  TooltipComponent.defaultProps = {
    disable: false,
    timeout: 1500
  };
  return TooltipComponent;
}(Component);
var createFallbackArray = function createFallbackArray(direction) {
  var clockwiseFallback = [DIRECTION_TOP, DIRECTION_START, DIRECTION_BOTTOM, DIRECTION_END, DIRECTION_START_TOP, DIRECTION_END_TOP, DIRECTION_TOP_LEFT, DIRECTION_BOTTOM_LEFT, DIRECTION_START_BOTTOM, DIRECTION_END_BOTTOM, DIRECTION_TOP_RIGHT, DIRECTION_BOTTOM_RIGHT];
  var index = clockwiseFallback.indexOf(direction);
  return clockwiseFallback.slice(index).concat(clockwiseFallback.slice(0, index));
};
var getFallback = function getFallback(direction) {
  if (typeof direction === 'string') {
    return createFallbackArray(direction);
  }
  if (Array.isArray(direction)) {
    return direction;
  }
  // Breakpoint object
  Object.keys(direction).map(function (breakpoint) {
    var breakpointValue = direction[breakpoint];
    return direction[breakpoint] = typeof breakpointValue === 'string' ? createFallbackArray(breakpointValue) : breakpointValue;
  });
  return direction;
};
var positionTooltip = function positionTooltip(direction, tooltipBubbleNode, windowMargin, tooltipOuterNode) {
  // tooltip bubble width values
  var _a = [252, 296],
    smallTooltipBubbleWidth = _a[0],
    largeTooltipBubbleWidth = _a[1];
  var left = tooltipOuterNode.left,
    right = tooltipOuterNode.right;
  var bubblePlacementStyle = "calc(100% + ".concat(arrowSize, "px)");
  Object.assign(tooltipBubbleNode.style, {
    bottom: '',
    top: '',
    left: '',
    right: '',
    transform: 'none'
  });
  if (direction === DIRECTION_START || direction === DIRECTION_END) {
    var bubblePositionMap = {
      centre: {
        top: '50%',
        transform: 'translateY(-50%)'
      }
    };
    Object.assign(tooltipBubbleNode.style, bubblePositionMap.centre);
    tooltipBubbleNode.style[direction === DIRECTION_END ? 'right' : 'left'] = bubblePlacementStyle;
  } else if (direction === DIRECTION_TOP || direction === DIRECTION_BOTTOM) {
    var bubblePositionMap = {
      centre: {
        left: '50%',
        transform: 'translateX(-50%)'
      }
    };
    Object.assign(tooltipBubbleNode.style, bubblePositionMap.centre);
    tooltipBubbleNode.style[direction === DIRECTION_TOP ? 'bottom' : 'top'] = bubblePlacementStyle;
  } else if (direction === DIRECTION_START_TOP || direction === DIRECTION_START_BOTTOM) {
    tooltipBubbleNode.style.left = bubblePlacementStyle;
    tooltipBubbleNode.style.bottom = direction === DIRECTION_START_BOTTOM ? '0' : '';
  } else if (direction === DIRECTION_END_TOP || direction === DIRECTION_END_BOTTOM) {
    tooltipBubbleNode.style.right = bubblePlacementStyle;
    tooltipBubbleNode.style.bottom = direction === DIRECTION_END_BOTTOM ? '0' : '';
  } else {
    var windowWidth = document.documentElement.clientWidth;
    var tooltipBubbleWidth = windowWidth <= 360 ? smallTooltipBubbleWidth : largeTooltipBubbleWidth;
    var position = direction === DIRECTION_BOTTOM_LEFT || direction === DIRECTION_BOTTOM_RIGHT ? 'top' : 'bottom';
    tooltipBubbleNode.style[position] = bubblePlacementStyle;
    if (direction === DIRECTION_BOTTOM_LEFT || direction === DIRECTION_TOP_LEFT) {
      if (windowWidth - (left + tooltipBubbleWidth + windowMargin) < 0) {
        var tooltipPosition = windowWidth - (left + tooltipBubbleWidth + windowMargin);
        tooltipBubbleNode.style.left = tooltipPosition + 'px';
      }
    } else if (right < tooltipBubbleWidth) {
      var tooltipPosition = right - (tooltipBubbleWidth + windowMargin);
      tooltipBubbleNode.style.right = tooltipPosition + 'px';
    } else {
      tooltipBubbleNode.style.right = '0px';
    }
  }
};
var Tooltip = WithClonedTooltip(TooltipComponent);

var styles$1F = {"cms-floating-tickers-wrapper":"fr-ec-cms-floating-tickers-wrapper","cmsFloatingTickersWrapper":"fr-ec-cms-floating-tickers-wrapper","cms-floating-tickers-container":"fr-ec-cms-floating-tickers-container","cmsFloatingTickersContainer":"fr-ec-cms-floating-tickers-container","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item"};

var CmsFloatingTickers = function CmsFloatingTickers(_a) {
  var items = _a.items,
    className = _a.className,
    props = __rest$1(_a, ["items", "className"]);
  var childTickers = Children.toArray(items).map(function (ticker, index) {
    return /*#__PURE__*/cloneElement(ticker, {
      itemId: index,
      key: index
    });
  });
  return /*#__PURE__*/createElement(LayoutWrapper, __assign$1({
    className: className,
    element: "div"
  }, props), /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: joinClasses(styles$1F.cmsFloatingTickersWrapper)
  }, /*#__PURE__*/createElement(CollectionList, {
    className: joinClasses(styles$1F.cmsFloatingTickersContainer),
    keylines: "none",
    spacing: "none"
  }, childTickers)));
};
CmsFloatingTickers.displayName = 'CoreCmsFloatingTickers';

var styles$1G = {"cms-vertical-scroll":"fr-ec-cms-vertical-scroll","cmsVerticalScroll":"fr-ec-cms-vertical-scroll","cms-vertical-scroll--with-fixed-gender-tabs":"fr-ec-cms-vertical-scroll--with-fixed-gender-tabs","cmsVerticalScrollWithFixedGenderTabs":"fr-ec-cms-vertical-scroll--with-fixed-gender-tabs","media-carousel":"fr-ec-media-carousel","mediaCarousel":"fr-ec-media-carousel","media-banner--full-stretch":"fr-ec-media-banner--full-stretch","mediaBannerFullStretch":"fr-ec-media-banner--full-stretch","media-banner__full-stretch-container":"fr-ec-media-banner__full-stretch-container","mediaBannerFullStretchContainer":"fr-ec-media-banner__full-stretch-container","cms-vertical-container":"fr-ec-cms-vertical-container","cmsVerticalContainer":"fr-ec-cms-vertical-container","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","swiper-container-vertical":"fr-ec-swiper-container-vertical","swiperContainerVertical":"fr-ec-swiper-container-vertical","swiper-pagination-bullets":"fr-ec-swiper-pagination-bullets","swiperPaginationBullets":"fr-ec-swiper-pagination-bullets","swiper-vertical-pagination-bullet":"fr-ec-swiper-vertical-pagination-bullet","swiperVerticalPaginationBullet":"fr-ec-swiper-vertical-pagination-bullet","swiper-vertical-pagination-bullet-active":"fr-ec-swiper-vertical-pagination-bullet-active","swiperVerticalPaginationBulletActive":"fr-ec-swiper-vertical-pagination-bullet-active","swiper-slide-without-padding-top":"fr-ec-swiper-slide-without-padding-top","swiperSlideWithoutPaddingTop":"fr-ec-swiper-slide-without-padding-top","swiper-container":"fr-ec-swiper-container","swiperContainer":"fr-ec-swiper-container","gender-tabs--vertical-carousel":"fr-ec-gender-tabs--vertical-carousel","genderTabsVerticalCarousel":"fr-ec-gender-tabs--vertical-carousel","promotion-banner--vertical-carousel":"fr-ec-promotion-banner--vertical-carousel","promotionBannerVerticalCarousel":"fr-ec-promotion-banner--vertical-carousel","swiper-wrapper":"fr-ec-swiper-wrapper","swiperWrapper":"fr-ec-swiper-wrapper","swiper-slide-with-promotion-banner":"fr-ec-swiper-slide-with-promotion-banner","swiperSlideWithPromotionBanner":"fr-ec-swiper-slide-with-promotion-banner","cms-media-banner":"fr-ec-cms-media-banner","cmsMediaBanner":"fr-ec-cms-media-banner","cms-media-banner__logo-container--with-separate-full-screen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cmsMediaBannerLogoContainerWithSeparateFullScreen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cms-media-banner__separate-type-full-screen":"fr-ec-cms-media-banner__separate-type-full-screen","cmsMediaBannerSeparateTypeFullScreen":"fr-ec-cms-media-banner__separate-type-full-screen","cms-media-banner__model-name":"fr-ec-cms-media-banner__model-name","cmsMediaBannerModelName":"fr-ec-cms-media-banner__model-name","cms-media-banner__model-name--with-fullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cmsMediaBannerModelNameWithFullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cms-media-banner__logo-container--with-full-screen":"fr-ec-cms-media-banner__logo-container--with-full-screen","cmsMediaBannerLogoContainerWithFullScreen":"fr-ec-cms-media-banner__logo-container--with-full-screen","gender-tabs":"fr-ec-gender-tabs","genderTabs":"fr-ec-gender-tabs","promotion-banner--vertical-carousel-without-tabs":"fr-ec-promotion-banner--vertical-carousel-without-tabs","promotionBannerVerticalCarouselWithoutTabs":"fr-ec-promotion-banner--vertical-carousel-without-tabs","promotion-banner--vertical-carousel-without-tabs-and-header":"fr-ec-promotion-banner--vertical-carousel-without-tabs-and-header","promotionBannerVerticalCarouselWithoutTabsAndHeader":"fr-ec-promotion-banner--vertical-carousel-without-tabs-and-header","floating-tickers-vertical-carousel":"fr-ec-floating-tickers-vertical-carousel","floatingTickersVerticalCarousel":"fr-ec-floating-tickers-vertical-carousel","floating-tickers-vertical-carousel-with-fixed-tabs":"fr-ec-floating-tickers-vertical-carousel-with-fixed-tabs","floatingTickersVerticalCarouselWithFixedTabs":"fr-ec-floating-tickers-vertical-carousel-with-fixed-tabs","swiper-slide-with-toggle-gender-tabs":"fr-ec-swiper-slide-with-toggle-gender-tabs","swiperSlideWithToggleGenderTabs":"fr-ec-swiper-slide-with-toggle-gender-tabs","swiper-slide-with-padding-top":"fr-ec-swiper-slide-with-padding-top","swiperSlideWithPaddingTop":"fr-ec-swiper-slide-with-padding-top","cms-vertical-scroll-wrapper":"fr-ec-cms-vertical-scroll-wrapper","cmsVerticalScrollWrapper":"fr-ec-cms-vertical-scroll-wrapper","ticker-wraper":"fr-ec-ticker-wraper","tickerWraper":"fr-ec-ticker-wraper","ticker-container":"fr-ec-ticker-container","tickerContainer":"fr-ec-ticker-container","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","cms-vertical-scroll-with-overflow":"fr-ec-cms-vertical-scroll-with-overflow","cmsVerticalScrollWithOverflow":"fr-ec-cms-vertical-scroll-with-overflow","cms-vertical-scroll-without-overflow":"fr-ec-cms-vertical-scroll-without-overflow","cmsVerticalScrollWithoutOverflow":"fr-ec-cms-vertical-scroll-without-overflow"};

var CmsVerticalScroll = /** @class */function (_super) {
  __extends(CmsVerticalScroll, _super);
  function CmsVerticalScroll(props) {
    var _this = _super.call(this, props) || this;
    _this.enableSwiper = function () {
      _this.swiperInstance.mousewheel.enable();
      _this.swiperInstance.allowTouchMove = true;
      _this.swiperInstance.keyboard.enable();
      _this.scrollTopValue = window.pageYOffset;
    };
    _this.componentDidUpdate = function (prevProps) {
      if (_this.swiperInstance) {
        if (prevProps.resetTrigger !== _this.props.resetTrigger) {
          _this.swiperInstance.slideTo(0);
          _this.enableSwiper();
        }
        _this.swiperInstance.update();
      }
    };
    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.addEventListener('scroll', _this.detectScroll);
        document.getElementsByTagName('body')[0].style.overflow = '';
        document.getElementsByTagName('body')[0].classList.remove(styles$1G.cmsVerticalScrollWithOverflow, styles$1G.cmsVerticalScrollWithoutOverflow);
      }
    };
    _this.reSizeHandler = function () {
      if (_this.swiperRef.current) {
        var headerElem = document.querySelector(_this.headerClassName);
        _this.setState({
          headerHeight: headerElem && headerElem.offsetHeight || 0,
          isReRender: !_this.state.isReRender
        });
        _this.swiperInstance.update();
      }
    };
    _this.beforeResize = function () {
      if (getOS() === 'iOS' && getCurrentMediaQueryBreakpoint() === 'sm' && _this.swiperInstance.swipeDirection && _this.swiperInstance.swipeDirection === 'next') {
        _this.setState({
          isIosScrollResize: true
        });
      }
    };
    _this.onSlideTransitionEnd = function () {
      if (_this.state.isIosScrollResize) {
        _this.setState({
          isIosScrollResize: false
        });
      }
    };
    _this.detectScroll = function () {
      var headerHeight = _this.state.headerHeight;
      var wDelta = window.pageYOffset > _this.scrollTopValue ? 'down' : 'up';
      if (_this.swiperRef && _this.swiperRef.current) {
        if (wDelta === 'up' && _this.props.toggleGenderTabs) {
          var tabEle = _this.genderTabRef.current;
          var slideEle = _this.swiperSlideRef;
          var tickerEle = _this.floatingTickersRef.current;
          slideEle.forEach(function (item) {
            item.classList.add('swiper-slide-with-padding-top');
            item.classList.remove('swiper-slide-without-padding-top');
          });
          if (_this.genderTabRef.current) {
            tabEle.style.top = "".concat(headerHeight, "px");
          }
          if (_this.promotionBannerRef.current && _this.swiperInstance.activeIndex === 0) {
            _this.promotionBannerRef.current.style.top = "".concat(headerHeight + tabEle.clientHeight, "px");
          }
          if (tickerEle) {
            tickerEle.style.top = "".concat(tabEle.clientHeight, "px");
          }
        } else if (wDelta === 'down' && _this.props.toggleGenderTabs) {
          var slideEle = _this.swiperSlideRef;
          var tabEle = _this.genderTabRef.current;
          slideEle.forEach(function (item) {
            item.classList.remove('swiper-slide-with-padding-top');
            item.classList.add('swiper-slide-without-padding-top');
          });
          if (_this.genderTabRef.current) {
            tabEle.style.top = "".concat(headerHeight - tabEle.clientHeight, "px");
          }
          if (_this.promotionBannerRef.current) {
            _this.promotionBannerRef.current.style.top = "".concat(headerHeight - _this.promotionBannerRef.current.clientHeight, "px");
          }
        }
        _this.scrollTopValue = window.pageYOffset;
      }
      if (_this.swiperRef.current) {
        if (_this.scrollTopValue <= 0 && wDelta === 'up' && !_this.swiperInstance.mousewheel.disabled && _this.swiperInstance.slides.length - 1 === _this.swiperInstance.activeIndex) {
          _this.enableSwiper();
        } else if (_this.scrollTopValue > 0 && wDelta === 'down' && !_this.swiperInstance.mousewheel.disabled && _this.swiperInstance.slides.length - 1 === _this.swiperInstance.activeIndex) {
          _this.swiperInstance.mousewheel.disable();
          _this.swiperInstance.allowTouchMove = false;
          _this.swiperInstance.keyboard.disable();
          document.getElementsByTagName('body')[0].style.overflow = 'auto';
          document.getElementsByTagName('body')[0].classList.remove(styles$1G.cmsVerticalScrollWithoutOverflow);
          document.getElementsByTagName('body')[0].classList.add(styles$1G.cmsVerticalScrollWithOverflow);
          _this.scrollTopValue = window.pageYOffset;
        }
      }
    };
    _this.onSlideChange = function () {
      var swiperInstance = _this.swiperInstance;
      if (swiperInstance) {
        var activeSlide_1 = swiperInstance.activeIndex;
        var prevSlide = swiperInstance.previousIndex;
        var slideWrapper = Array.from(swiperInstance.$wrapperEl)[0];
        var slides_1 = Array.from(swiperInstance.slides || []);
        var videos = Array.from(slideWrapper.getElementsByTagName('video') || []);
        _this.setState({
          activeSection: activeSlide_1
        });
        videos.forEach(function (video, index) {
          video.muted = true; // eslint-disable-line no-param-reassign
          var isVisible = slides_1[activeSlide_1].contains(video);
          if (video.readyState !== 0) {
            if (!isVisible) {
              video.pause();
            } else if (video.paused) {
              video.classList.remove('played');
              video.play();
            }
          }
        });
        if (_this.props.toggleGenderTabs) {
          var slideEle = _this.swiperSlideRef;
          if (prevSlide < activeSlide_1 && slideEle) {
            slideEle.forEach(function (item) {
              item.classList.remove('swiper-slide-with-padding-top');
              item.classList.add('swiper-slide-without-padding-top');
            });
          } else if (slideEle) {
            slideEle.forEach(function (item) {
              item.classList.add('swiper-slide-with-padding-top');
              item.classList.remove('swiper-slide-without-padding-top');
            });
          }
        }
        if (prevSlide === slides_1.length - 1) {
          setTimeout(function () {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            document.getElementsByTagName('body')[0].classList.remove(styles$1G.cmsVerticalScrollWithOverflow);
            document.getElementsByTagName('body')[0].classList.add(styles$1G.cmsVerticalScrollWithoutOverflow);
          }, 1000);
        }
        var wDelta = prevSlide < activeSlide_1 ? 'down' : 'up';
        if (wDelta === 'down' && window.innerHeight - _this.state.headerHeight > swiperInstance.height || wDelta === 'up' && swiperInstance.height > window.innerHeight - _this.state.headerHeight) {
          _this.setState({
            isReRender: !_this.state.isReRender
          });
          swiperInstance.update();
        }
      }
    };
    _this.reachEnd = function () {
      setTimeout(function () {
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
        document.getElementsByTagName('body')[0].classList.remove(styles$1G.cmsVerticalScrollWithoutOverflow);
        document.getElementsByTagName('body')[0].classList.add(styles$1G.cmsVerticalScrollWithOverflow);
      }, 1000);
    };
    _this.onSlideNext = function () {
      // console.log('next...');
      var headerHeight = _this.state.headerHeight;
      var tabEle = _this.genderTabRef.current;
      var promotionBannerRef = _this.promotionBannerRef.current;
      var tickerEle = _this.floatingTickersRef.current;
      if (_this.genderTabRef.current && _this.props.toggleGenderTabs) {
        if (tabEle) {
          tabEle.style.top = "".concat(headerHeight - tabEle.clientHeight, "px");
        }
        if (tickerEle) {
          tickerEle.style.top = "0px";
        }
      }
      if (promotionBannerRef) {
        promotionBannerRef.style.top = "".concat(headerHeight - promotionBannerRef.clientHeight, "px");
      }
    };
    _this.onSlidePrev = function () {
      var tabEle = _this.genderTabRef.current;
      var promotionBannerRef = _this.promotionBannerRef.current;
      var tickerEle = _this.floatingTickersRef.current;
      if (_this.props.toggleGenderTabs) {
        if (tabEle) {
          tabEle.style.top = '';
        }
        if (tickerEle) {
          tickerEle.style.top = "".concat(tabEle.clientHeight, "px");
        }
      }
      if (promotionBannerRef && _this.swiperInstance.activeIndex === 0) {
        promotionBannerRef.style.top = '';
      }
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.genderTabRef = /*#__PURE__*/createRef();
    _this.promotionBannerRef = /*#__PURE__*/createRef();
    _this.floatingTickersRef = /*#__PURE__*/createRef();
    _this.swiperSlideRef = [];
    _this.swiperInstance = null;
    _this.scrollTopValue = 0;
    _this.headerClassName = '.fr-ec-navigation-header';
    _this.state = {
      activeSection: 0,
      headerHeight: 0,
      isIosScrollResize: false,
      isReRender: false
    };
    return _this;
  }
  CmsVerticalScroll.prototype.componentDidMount = function () {
    var _this = this;
    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByTagName('body')[0].classList.add(styles$1G.cmsVerticalScrollWithoutOverflow);
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 2000);
    var headerElem = document.querySelector(this.headerClassName);
    this.setState({
      headerHeight: headerElem && headerElem.offsetHeight || 0
    });
    this.swiperInstance = new swiper(this.swiperRef.current, {
      centeredSlides: true,
      direction: 'vertical',
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      mousewheel: {
        forceToAxis: true,
        invert: true,
        releaseOnEdges: true
      },
      on: {
        beforeResize: function beforeResize() {
          return _this.beforeResize();
        },
        reachEnd: function reachEnd() {
          return _this.reachEnd();
        },
        slideChange: function slideChange() {
          return _this.onSlideChange();
        },
        slideNextTransitionEnd: function slideNextTransitionEnd() {
          return _this.onSlideTransitionEnd();
        },
        slideNextTransitionStart: function slideNextTransitionStart() {
          return _this.onSlideNext();
        },
        slidePrevTransitionEnd: function slidePrevTransitionEnd() {
          return _this.onSlideTransitionEnd();
        },
        slidePrevTransitionStart: function slidePrevTransitionStart() {
          return _this.onSlidePrev();
        }
      },
      pagination: {
        bulletActiveClass: 'swiper-vertical-pagination-bullet-active',
        bulletClass: 'swiper-vertical-pagination-bullet',
        bulletElement: 'span',
        clickable: false,
        el: '.swiper-pagination-v',
        type: 'bullets'
      },
      releaseOnEdges: true,
      slidesPerView: 1,
      speed: getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400,
      touchReleaseOnEdges: true
    });
    // initialise the overflow condition to hidden.
    if (isInBrowser$1()) {
      window.addEventListener('scroll', this.detectScroll);
      window.addEventListener('resize', this.reSizeHandler);
    }
    if (document.getElementsByTagName('body')[0] && this.swiperRef.current) {
      var element = this.swiperRef.current.getBoundingClientRect();
      if (Math.round(element.bottom) === window.innerHeight + (headerElem && Math.round(headerElem.offsetHeight) || 73) && this.scrollTopValue === 0) {
        this.swiperInstance.mousewheel.enable();
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        document.getElementsByTagName('body')[0].classList.add(styles$1G.cmsVerticalScrollWithoutOverflow);
        this.swiperInstance.allowTouchMove = true;
        this.swiperInstance.keyboard.enable();
      }
    }
  };
  CmsVerticalScroll.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      items = _b.items,
      className = _b.className,
      floatingTickers = _b.floatingTickers,
      genderTabs = _b.genderTabs,
      toggleGenderTabs = _b.toggleGenderTabs,
      gaLabel = _b.gaLabel,
      gaCategory = _b.gaCategory,
      _c = _b.showTicker,
      showTicker = _c === void 0 ? true : _c,
      onTickerClose = _b.onTickerClose,
      promotionBanner = _b.promotionBanner,
      props = __rest$1(_b, ["items", "className", "defaultIndex", "floatingTickers", "genderTabs", "toggleGenderTabs", "gaLabel", "gaCategory", "showTicker", "onTickerClose", "promotionBanner"]);
    var _d = this.state,
      headerHeight = _d.headerHeight,
      activeSection = _d.activeSection;
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var styleWithWindow = {
      height: isInBrowser$1() ? this.props.toggleGenderTabs ? this.state.isIosScrollResize ? "calc(100vh - ".concat(headerHeight, "px") : "".concat(window.innerHeight - headerHeight, "px") : "".concat(window.innerHeight - headerHeight - (genderTabs && breakpoint === 'sm' ? 44 : 0), "px") : 0
    };
    var childTickers = floatingTickers && Array.isArray(floatingTickers) ? floatingTickers.length > 0 && floatingTickers.map(function (ticker, index) {
      return /*#__PURE__*/cloneElement(ticker, {
        itemId: index,
        key: index,
        onClose: onTickerClose
      });
    }) : floatingTickers && /*#__PURE__*/cloneElement(floatingTickers, {
      onClose: onTickerClose
    });
    var styleWithoutWindow = {
      height: "calc(100vh - ".concat(headerHeight, "px)")
    };
    var isPromotionBannerRendered = promotionBanner && this.promotionBannerRef && this.promotionBannerRef.current && ((_a = this.promotionBannerRef.current.childNodes) === null || _a === void 0 ? void 0 : _a.length);
    var childrenWithProps = Children.toArray(items).filter(isValidElement).map(function (child, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses('swiper-slide', genderTabs && toggleGenderTabs ? 'swiper-slide-with-toggle-gender-tabs' : '', isPromotionBannerRendered && index === 0 ? 'swiper-slide-with-promotion-banner' : ''),
        ref: function ref(_ref) {
          return _this.swiperSlideRef[index] = _ref;
        }
      }, /*#__PURE__*/cloneElement(child, {
        parentActiveIndex: activeSection,
        parentGaCategory: 'L1'
      }));
    });
    var gaProps = {};
    if (gaCategory && gaLabel) {
      gaProps = {
        'data-category': gaCategory,
        'data-label': gaLabel
      };
    }
    return /*#__PURE__*/createElement("div", __assign$1({
      className: joinClasses(styles$1G.cmsVerticalScrollWrapper, className)
    }, gaProps, props), /*#__PURE__*/createElement("div", {
      ref: this.genderTabRef,
      className: styles$1G.genderTabsVerticalCarousel
    }, genderTabs && /*#__PURE__*/cloneElement(genderTabs[0], {
      enableAutoHide: false
    })), /*#__PURE__*/createElement("div", {
      ref: this.promotionBannerRef,
      className: joinClasses(styles$1G.promotionBannerVerticalCarousel, (!genderTabs || genderTabs.length === 0) && styles$1G.promotionBannerVerticalCarouselWithoutTabs, this.state.headerHeight === 0 && styles$1G.promotionBannerVerticalCarouselWithoutTabsAndHeader)
    }, promotionBanner), showTicker && floatingTickers && (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1G.floatingTickersVerticalCarousel, (!genderTabs || !toggleGenderTabs) && styles$1G.floatingTickersVerticalCarouselWithFixedTabs),
      ref: this.floatingTickersRef
    }, /*#__PURE__*/createElement(CmsFloatingTickers, {
      items: childTickers
    }))), /*#__PURE__*/createElement("div", {
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1G.cmsVerticalScroll, genderTabs && !toggleGenderTabs && styles$1G.cmsVerticalScrollWithFixedGenderTabs, className),
      style: isInBrowser$1() ? __assign$1({}, styleWithWindow) : __assign$1({}, styleWithoutWindow)
    }, /*#__PURE__*/createElement("div", {
      ref: this.swiperRef,
      className: joinClasses(styles$1G.cmsVerticalContainer, 'swiper-container-v', className)
    }, /*#__PURE__*/createElement("div", {
      className: "swiper-wrapper"
    }, childrenWithProps), /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-pagination', 'swiper-pagination-v')
    })))));
  };
  CmsVerticalScroll.displayName = 'CoreCmsVerticalScroll';
  CmsVerticalScroll.defaultProps = {
    toggleGenderTabs: true
  };
  return CmsVerticalScroll;
}(Component);

var styles$1H = {"styling-grid__container--5-column":"fr-ec-styling-grid__container--5-column","stylingGridContainer5Column":"fr-ec-styling-grid__container--5-column","styling-grid__container--4-column":"fr-ec-styling-grid__container--4-column","stylingGridContainer4Column":"fr-ec-styling-grid__container--4-column","styling-grid__container--3-column":"fr-ec-styling-grid__container--3-column","stylingGridContainer3Column":"fr-ec-styling-grid__container--3-column","styling-grid__container--2-column":"fr-ec-styling-grid__container--2-column","stylingGridContainer2Column":"fr-ec-styling-grid__container--2-column","styling-grid__items-has-user-info":"fr-ec-styling-grid__items-has-user-info","stylingGridItemsHasUserInfo":"fr-ec-styling-grid__items-has-user-info","styling-grid__item":"fr-ec-styling-grid__item","stylingGridItem":"fr-ec-styling-grid__item","cms-image-plus-text":"fr-ec-cms-image-plus-text","cmsImagePlusText":"fr-ec-cms-image-plus-text","cms-image-plus-text__media":"fr-ec-cms-image-plus-text__media","cmsImagePlusTextMedia":"fr-ec-cms-image-plus-text__media","cms-image-plus-text__content":"fr-ec-cms-image-plus-text__content","cmsImagePlusTextContent":"fr-ec-cms-image-plus-text__content"};

var StylingGrid = function StylingGrid(_a) {
  var gridItems = _a.gridItems,
    _b = _a.variant,
    variant = _b === void 0 ? 'default' : _b,
    specialItems = _a.specialItems,
    className = _a.className,
    itemHasUserInfo = _a.itemHasUserInfo;
  var _c = React__default.useState(2),
    gridColumns = _c[0],
    updateGridColumns = _c[1];
  var _d = useState(__spreadArray([], gridItems, true)),
    gridElements = _d[0],
    setGridElements = _d[1];
  // viewport limits
  var twoColumnUpperLimit = 453;
  var threeColumnUpperLimit = 720;
  var fourColumnUpperLimit = 876;
  // const values for numbers. used to set special images grid-row attribute for grid items.
  var two = 2;
  var four = 4;
  // special images position in l viewport.
  var specialImageRowNoRight = 1;
  var specialImageRowNoLeft = 3;
  var specialImageIndex = 0;
  useEffect(function () {
    setGridElements(getGridItems(gridColumns));
  }, [gridColumns, gridItems, variant]);
  var onResize = function onResize(contentRect) {
    if (contentRect.bounds) {
      var width = contentRect.bounds.width;
      if (width <= twoColumnUpperLimit) {
        updateGridColumns(2);
      } else if (width > twoColumnUpperLimit && width <= threeColumnUpperLimit) {
        updateGridColumns(3);
      } else if (width > threeColumnUpperLimit && width <= fourColumnUpperLimit) {
        updateGridColumns(4);
      } else {
        updateGridColumns(5);
      }
    }
  };
  var addSpecialImage = function addSpecialImage(index, row, column) {
    var specialImages = specialItems;
    return /*#__PURE__*/React__default.createElement("div", {
      key: "specialItems-".concat(index),
      style: {
        gridColumn: column ? "".concat(column, " / span ").concat(two) : 'auto',
        gridRow: row ? "".concat(row, " / span ").concat(two) : 'auto'
      },
      className: styles$1H.stylingGridItem
    }, specialImages[index], ' ');
  };
  var isRenderSpecialImages = function isRenderSpecialImages(index, columns) {
    return index > 0 && (index + 1) % columns === 0 && (index + 1) / columns % two !== 0;
  };
  var getGridItems = function getGridItems(columns) {
    var items = gridItems.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$1H.stylingGridItem,
        key: index
      }, item);
    });
    if (variant !== 'default' && specialItems) {
      for (var index = 0; index < gridItems.length; index++) {
        if (specialImageIndex < specialItems.length) {
          var isLastItem = index === gridItems.length - 1;
          var isImagePlusText = variant === 'imagePlusText';
          if (columns === 2 && (index + 1) % four === 0) {
            var specialItem = addSpecialImage(specialImageIndex, isImagePlusText ? 'auto' : '', isImagePlusText ? 'auto' : '');
            items.splice(index + specialImageIndex + 1, 0, specialItem);
            specialImageIndex += 1;
          } else if (columns === 3 && (index === 1 || (index - 1) % four === 0)) {
            var specialItemRight = addSpecialImage(specialImageIndex, isImagePlusText ? index.toString() : '', isImagePlusText ? '2' : '');
            if (!isLastItem && specialImageIndex + 1 < specialItems.length) {
              var specialItemLeft = addSpecialImage(specialImageIndex + 1, isImagePlusText ? (index + two).toString() : '', isImagePlusText ? '1' : '');
              items.splice(index + specialImageIndex + 1, 0, specialItemRight, specialItemLeft);
              specialImageIndex += two;
            } else {
              items.splice(index + specialImageIndex + 1, 0, specialItemRight);
              specialImageIndex += 1;
            }
          } else if (columns === four && isRenderSpecialImages(index, four)) {
            var gridRow = (index + 1) / four * two - 1;
            var specialItemRight = addSpecialImage(specialImageIndex, gridRow.toString(), '3');
            if (!isLastItem && specialImageIndex + 1 < specialItems.length) {
              var specialItemLeft = addSpecialImage(specialImageIndex + 1, (gridRow + two).toString(), '1');
              items.splice(index + specialImageIndex + 1, 0, specialItemRight, specialItemLeft);
              specialImageIndex += two;
            } else {
              items.splice(index + specialImageIndex + 1, 0, specialItemRight);
              specialImageIndex += 1;
            }
          } else if (columns === 5 && isRenderSpecialImages(index, 6)) {
            var specialImageRight = addSpecialImage(specialImageIndex, specialImageRowNoRight.toString(), four.toString());
            if (!isLastItem && specialImageIndex + 1 < specialItems.length) {
              var specialImageLeft = addSpecialImage(specialImageIndex + 1, specialImageRowNoLeft.toString(), '1');
              items.splice(index + specialImageIndex + 1, 0, specialImageRight, specialImageLeft);
              specialImageRowNoRight += four;
              specialImageRowNoLeft += four;
              specialImageIndex += two;
            } else {
              items.splice(index + specialImageIndex + 1, 0, specialImageRight);
              specialImageIndex += 1;
            }
          }
        }
      }
    }
    return items;
  };
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: onResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", {
      ref: measureRef,
      className: joinClasses(className, styles$1H["styling-grid__container--".concat(gridColumns, "-column")], gridColumns === 2 && itemHasUserInfo && styles$1H.stylingGridItemsHasUserInfo)
    }, gridElements);
  });
};
StylingGrid.displayName = 'CoreStylingGrid';

var styles$1I = {"gutter-container":"fr-ec-gutter-container","gutterContainer":"fr-ec-gutter-container","gutter-container--padding":"fr-ec-gutter-container--padding","gutterContainerPadding":"fr-ec-gutter-container--padding"};

var GutterContainer = function GutterContainer(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    _c = _a.padding,
    padding = _c === void 0 ? {
      sm: true,
      md: false,
      lg: false
    } : _c,
    className = _a.className,
    props = __rest$1(_a, ["element", "padding", "className"]);
  var _d = useState(getCurrentMediaQueryBreakpoint()),
    breakpoint = _d[0],
    setBreakPointValue = _d[1];
  var onWindowSize = debounce(100, function (_) {
    setBreakPointValue(getCurrentMediaQueryBreakpoint());
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onWindowSize);
    }
    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', onWindowSize);
      }
    };
  }, []);
  var shouldHavePadding = function shouldHavePadding(padding, BP) {
    if (typeof padding === 'boolean') {
      if (padding) {
        return true;
      } else {
        return false;
      }
    }
    if (_typeof(padding) === 'object') {
      if (padding.sm && BP === 'sm' || padding.md && BP === 'md' || padding.lg && BP === 'lg') {
        return true;
      }
    }
    return false;
  };
  var shouldHavePaddingChildren = shouldHavePadding(padding, breakpoint);
  return /*#__PURE__*/React__default.createElement(Element, __assign$1({
    className: joinClasses(styles$1I.gutterContainer, shouldHavePaddingChildren && styles$1I.gutterContainerPadding, className)
  }, props));
};
GutterContainer.displayName = 'CoreGutterContainer';

var styles$1J = {"tag-filter":"fr-ec-tag-filter","tagFilter":"fr-ec-tag-filter","tag-filter__max-width":"fr-ec-tag-filter__max-width","tagFilterMaxWidth":"fr-ec-tag-filter__max-width","tag-filter__label":"fr-ec-tag-filter__label","tagFilterLabel":"fr-ec-tag-filter__label","tag-filter__label-left":"fr-ec-tag-filter__label-left","tagFilterLabelLeft":"fr-ec-tag-filter__label-left","tag-filter__label-right":"fr-ec-tag-filter__label-right","tagFilterLabelRight":"fr-ec-tag-filter__label-right","tag-filter__label--disabled":"fr-ec-tag-filter__label--disabled","tagFilterLabelDisabled":"fr-ec-tag-filter__label--disabled","tag-filter__icon":"fr-ec-tag-filter__icon","tagFilterIcon":"fr-ec-tag-filter__icon","tag-filter__static-icon":"fr-ec-tag-filter__static-icon","tagFilterStaticIcon":"fr-ec-tag-filter__static-icon","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","tag-filter--on-touch":"fr-ec-tag-filter--on-touch","tagFilterOnTouch":"fr-ec-tag-filter--on-touch"};

var TagFilter = function TagFilter(_a) {
  var value = _a.value,
    onClick = _a.onClick,
    className = _a.className,
    _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? "".concat(value, " filter tag") : _b,
    // This prop is deprecated because buttonIcon is not used in this component.
    _c = _a.disabled,
    // This prop is deprecated because buttonIcon is not used in this component.
    disabled = _c === void 0 ? false : _c,
    _d = _a.dismissable,
    dismissable = _d === void 0 ? true : _d,
    iconBrand = _a.iconBrand,
    staticIcon = _a.staticIcon,
    _e = _a.staticIconPosition,
    staticIconPosition = _e === void 0 ? 'left' : _e,
    props = __rest$1(_a, ["value", "onClick", "className", "ariaLabel", "onDismiss", "disabled", "dismissable", "iconBrand", "staticIcon", "staticIconPosition"]);
  var onTouchStartHandler = function onTouchStartHandler(event) {
    var elm = event.currentTarget;
    var tagElements = document.getElementsByClassName(styles$1J.tagFilterOnTouch);
    [].forEach.call(tagElements, function (el) {
      el.classList.remove(styles$1J.tagFilterOnTouch);
    });
    if (elm) {
      elm.classList.add(styles$1J.tagFilterOnTouch);
    }
  };
  var onFocusOutHandler = function onFocusOutHandler(event) {
    var elm = event.currentTarget;
    elm.classList.remove(styles$1J.tagFilterOnTouch);
  };
  var isStaticIconPositionLeft = staticIcon && staticIconPosition === 'left';
  var offset = staticIcon ? 15 : 18;
  var updatedValue = value.length > offset ? "".concat(value.substring(0, offset), "...") : value.substring(0, offset);
  var staticIconElement = staticIcon && (/*#__PURE__*/createElement("div", {
    className: styles$1J.tagFilterIcon
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(staticIcon) : staticIcon
  })));
  return /*#__PURE__*/createElement("button", __assign$1({
    className: joinClasses(styles$1J.tagFilter, dismissable && styles$1J.tagFilterMaxWidth, interactionsStyles.cursorPointer, isStaticIconPositionLeft ? styles$1J.tagFilterLabelLeft : styles$1J.tagFilterLabelRight, className),
    "aria-label": ariaLabel,
    onClick: onClick,
    disabled: disabled,
    onTouchStart: onTouchStartHandler,
    onBlur: onFocusOutHandler
  }, props), isStaticIconPositionLeft && staticIconElement, /*#__PURE__*/createElement(Caption, {
    element: "span",
    variant: "standard",
    className: joinClasses(styles$1J.tagFilterLabel, (disabled || !dismissable) && styles$1J.tagFilterLabelDisabled, staticIcon && isStaticIconPositionLeft && styles$1J.tagFilterStaticIcon)
  }, updatedValue), dismissable && !staticIcon && (/*#__PURE__*/createElement("div", {
    className: styles$1J.tagFilterIcon
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand, "close") : "close"
  }))), !isStaticIconPositionLeft && staticIconElement);
};
TagFilter.displayName = 'CoreTagFilter';
TagFilter.defaultProps = {
  disabled: false
};

var styles$1K = {"cms-spacer-xxs":"fr-ec-cms-spacer-xxs","cmsSpacerXxs":"fr-ec-cms-spacer-xxs","cms-spacer-xs":"fr-ec-cms-spacer-xs","cmsSpacerXs":"fr-ec-cms-spacer-xs","cms-spacer-s":"fr-ec-cms-spacer-s","cmsSpacerS":"fr-ec-cms-spacer-s","cms-spacer-m":"fr-ec-cms-spacer-m","cmsSpacerM":"fr-ec-cms-spacer-m","cms-spacer-l":"fr-ec-cms-spacer-l","cmsSpacerL":"fr-ec-cms-spacer-l","cms-spacer-xl":"fr-ec-cms-spacer-xl","cmsSpacerXl":"fr-ec-cms-spacer-xl","cms-spacer-xxl":"fr-ec-cms-spacer-xxl","cmsSpacerXxl":"fr-ec-cms-spacer-xxl","cms-spacer-xxxl":"fr-ec-cms-spacer-xxxl","cmsSpacerXxxl":"fr-ec-cms-spacer-xxxl"};

var CmsSpacer = function CmsSpacer(_a) {
  var spaces = _a.spaces,
    className = _a.className,
    props = __rest$1(_a, ["spaces", "className"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(className, styles$1K["cms-spacer-".concat(spaces)])
  }, props));
};
CmsSpacer.displayName = 'CoreCmsSpacer';

var styles$1L = {"cms-link":"fr-ec-cms-link","cmsLink":"fr-ec-cms-link"};

var CmsLink = function CmsLink(_a) {
  var url = _a.url,
    _b = _a.gaCategory,
    gaCategory = _b === void 0 ? '' : _b,
    _c = _a.gaLabel,
    gaLabel = _c === void 0 ? '' : _c,
    gaAction = _a.gaAction,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    target = _a.target,
    className = _a.className,
    props = __rest$1(_a, ["url", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "target", "className"]);
  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};
  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1;
    // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore
    attributes.to = url;
    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }
  return /*#__PURE__*/createElement(Tile, __assign$1({
    className: joinClasses(className, styles$1L.cmsLink),
    variant: "default",
    element: rootTag,
    href: url,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaLabel: gaLabel,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, attributes, props));
};
CmsLink.displayName = 'CoreCmsLink';
CmsLink.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$1M = {"cms-image-plus-text-collection":"fr-ec-cms-image-plus-text-collection","cmsImagePlusTextCollection":"fr-ec-cms-image-plus-text-collection","cms-image-plus-text-collection--4-column":"fr-ec-cms-image-plus-text-collection--4-column","cmsImagePlusTextCollection4Column":"fr-ec-cms-image-plus-text-collection--4-column","cms-image-plus-text-collection--4-column-small":"fr-ec-cms-image-plus-text-collection--4-column-small","cmsImagePlusTextCollection4ColumnSmall":"fr-ec-cms-image-plus-text-collection--4-column-small","cms-image-plus-text-collection--4-column-vertical":"fr-ec-cms-image-plus-text-collection--4-column-vertical","cmsImagePlusTextCollection4ColumnVertical":"fr-ec-cms-image-plus-text-collection--4-column-vertical","cms-image-plus-text__media":"fr-ec-cms-image-plus-text__media","cmsImagePlusTextMedia":"fr-ec-cms-image-plus-text__media","cms-image-plus-text":"fr-ec-cms-image-plus-text","cmsImagePlusText":"fr-ec-cms-image-plus-text","cms-image-plus-text-collection--2-column":"fr-ec-cms-image-plus-text-collection--2-column","cmsImagePlusTextCollection2Column":"fr-ec-cms-image-plus-text-collection--2-column","cms-image-plus-text-collection--3-column":"fr-ec-cms-image-plus-text-collection--3-column","cmsImagePlusTextCollection3Column":"fr-ec-cms-image-plus-text-collection--3-column","cms-image-plus-text-collection--3-column-small":"fr-ec-cms-image-plus-text-collection--3-column-small","cmsImagePlusTextCollection3ColumnSmall":"fr-ec-cms-image-plus-text-collection--3-column-small","cms-image-plus-text-collection--with-product-collection":"fr-ec-cms-image-plus-text-collection--with-product-collection","cmsImagePlusTextCollectionWithProductCollection":"fr-ec-cms-image-plus-text-collection--with-product-collection","cms-image-plus-text-collection--single-media":"fr-ec-cms-image-plus-text-collection--single-media","cmsImagePlusTextCollectionSingleMedia":"fr-ec-cms-image-plus-text-collection--single-media","cms-image-plus-text__content":"fr-ec-cms-image-plus-text__content","cmsImagePlusTextContent":"fr-ec-cms-image-plus-text__content","tile":"fr-ec-tile","cms-image-plus-text-Wrapper":"fr-ec-cms-image-plus-text-Wrapper","cmsImagePlusTextWrapper":"fr-ec-cms-image-plus-text-Wrapper","cms-image-plus-text-collection--3-colum-small":"fr-ec-cms-image-plus-text-collection--3-colum-small","cmsImagePlusTextCollection3ColumSmall":"fr-ec-cms-image-plus-text-collection--3-colum-small"};

var CmsImagePlusTextCollection = function CmsImagePlusTextCollection(_a) {
  var layout = _a.layout,
    items = _a.items,
    className = _a.className,
    props = __rest$1(_a, ["layout", "items", "className"]);
  var layoutMap = {
    fourColumn: styles$1M.cmsImagePlusTextCollection4Column,
    fourColumnSmall: styles$1M.cmsImagePlusTextCollection4ColumnSmall,
    fourColumnVertical: styles$1M.cmsImagePlusTextCollection4ColumnVertical,
    singleMedia: styles$1M.cmsImagePlusTextCollectionSingleMedia,
    threeColumn: styles$1M.cmsImagePlusTextCollection3Column,
    threeColumnSmall: styles$1M.cmsImagePlusTextCollection3ColumnSmall,
    twoColumn: styles$1M.cmsImagePlusTextCollection2Column,
    withProductCollection: styles$1M.cmsImagePlusTextCollectionWithProductCollection
  };
  var imagePlusText = Children.map(items, function (child, i) {
    return /*#__PURE__*/createElement(Fragment, {
      key: i
    }, child);
  });
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$1M.cmsImagePlusTextCollection, layoutMap[layout], className)
  }, props), imagePlusText);
};
CmsImagePlusTextCollection.displayName = 'CoreCmsImagePlusTextCollection';

var styles$1N = {"cms-media-banner":"fr-ec-cms-media-banner","cmsMediaBanner":"fr-ec-cms-media-banner","cms-media-banner__container":"fr-ec-cms-media-banner__container","cmsMediaBannerContainer":"fr-ec-cms-media-banner__container","cms-media-banner--full-stretch":"fr-ec-cms-media-banner--full-stretch","cmsMediaBannerFullStretch":"fr-ec-cms-media-banner--full-stretch","cms-media-banner__full-stretch-container":"fr-ec-cms-media-banner__full-stretch-container","cmsMediaBannerFullStretchContainer":"fr-ec-cms-media-banner__full-stretch-container","cms-media-banner__separate-container":"fr-ec-cms-media-banner__separate-container","cmsMediaBannerSeparateContainer":"fr-ec-cms-media-banner__separate-container","cms-media-banner__child-container--non-full-screen":"fr-ec-cms-media-banner__child-container--non-full-screen","cmsMediaBannerChildContainerNonFullScreen":"fr-ec-cms-media-banner__child-container--non-full-screen","cms-media-banner__separate-type":"fr-ec-cms-media-banner__separate-type","cmsMediaBannerSeparateType":"fr-ec-cms-media-banner__separate-type","cms-media-banner__separate-type-full-screen":"fr-ec-cms-media-banner__separate-type-full-screen","cmsMediaBannerSeparateTypeFullScreen":"fr-ec-cms-media-banner__separate-type-full-screen","cms-media-banner__separate-type-full-screen-container":"fr-ec-cms-media-banner__separate-type-full-screen-container","cmsMediaBannerSeparateTypeFullScreenContainer":"fr-ec-cms-media-banner__separate-type-full-screen-container","image--ratio-1x1":"fr-ec-image--ratio-1x1","imageRatio1X1":"fr-ec-image--ratio-1x1","image__no-image-container":"fr-ec-image__no-image-container","imageNoImageContainer":"fr-ec-image__no-image-container","cms-media-banner--bg-with-white-text":"fr-ec-cms-media-banner--bg-with-white-text","cmsMediaBannerBgWithWhiteText":"fr-ec-cms-media-banner--bg-with-white-text","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","no-image__video":"fr-ec-no-image__video","noImageVideo":"fr-ec-no-image__video","no-image__label":"fr-ec-no-image__label","noImageLabel":"fr-ec-no-image__label","no-image__icon":"fr-ec-no-image__icon","noImageIcon":"fr-ec-no-image__icon","cms-media-banner--crop-image-middle":"fr-ec-cms-media-banner--crop-image-middle","cmsMediaBannerCropImageMiddle":"fr-ec-cms-media-banner--crop-image-middle","cms-media-banner__logo-container":"fr-ec-cms-media-banner__logo-container","cmsMediaBannerLogoContainer":"fr-ec-cms-media-banner__logo-container","cms-media-banner__logo-container--with-full-screen":"fr-ec-cms-media-banner__logo-container--with-full-screen","cmsMediaBannerLogoContainerWithFullScreen":"fr-ec-cms-media-banner__logo-container--with-full-screen","cms-media-banner__logo-container--with-separate-full-screen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cmsMediaBannerLogoContainerWithSeparateFullScreen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cms-media-banner__separate-full-screen-layout-wrapper":"fr-ec-cms-media-banner__separate-full-screen-layout-wrapper","cmsMediaBannerSeparateFullScreenLayoutWrapper":"fr-ec-cms-media-banner__separate-full-screen-layout-wrapper","image":"fr-ec-image","image__img":"fr-ec-image__img","imageImg":"fr-ec-image__img","medi-banner__model-name-white":"fr-ec-medi-banner__model-name-white","mediBannerModelNameWhite":"fr-ec-medi-banner__model-name-white","medi-banner__model-name-black":"fr-ec-medi-banner__model-name-black","mediBannerModelNameBlack":"fr-ec-medi-banner__model-name-black","cms-media-banner__model-name":"fr-ec-cms-media-banner__model-name","cmsMediaBannerModelName":"fr-ec-cms-media-banner__model-name","cms-media-banner__model-name--with-fullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cmsMediaBannerModelNameWithFullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cms-media-banner__model-name--without-fullscreen":"fr-ec-cms-media-banner__model-name--without-fullscreen","cmsMediaBannerModelNameWithoutFullscreen":"fr-ec-cms-media-banner__model-name--without-fullscreen","cms-media-banner__layout-wrapper--full-screen":"fr-ec-cms-media-banner__layout-wrapper--full-screen","cmsMediaBannerLayoutWrapperFullScreen":"fr-ec-cms-media-banner__layout-wrapper--full-screen","cms-media-banner__layout-wrapper":"fr-ec-cms-media-banner__layout-wrapper","cmsMediaBannerLayoutWrapper":"fr-ec-cms-media-banner__layout-wrapper","cms-media-banner__button":"fr-ec-cms-media-banner__button","cmsMediaBannerButton":"fr-ec-cms-media-banner__button","cms-media-banner__separate-type-button":"fr-ec-cms-media-banner__separate-type-button","cmsMediaBannerSeparateTypeButton":"fr-ec-cms-media-banner__separate-type-button","cms-media-banner--full-screen__button":"fr-ec-cms-media-banner--full-screen__button","cmsMediaBannerFullScreenButton":"fr-ec-cms-media-banner--full-screen__button","cms-media-banner__text-container":"fr-ec-cms-media-banner__text-container","cmsMediaBannerTextContainer":"fr-ec-cms-media-banner__text-container","cms-media-banner__text-container--normal-full-screen":"fr-ec-cms-media-banner__text-container--normal-full-screen","cmsMediaBannerTextContainerNormalFullScreen":"fr-ec-cms-media-banner__text-container--normal-full-screen","cms-media-banner__text-container--normal-non-full-screen":"fr-ec-cms-media-banner__text-container--normal-non-full-screen","cmsMediaBannerTextContainerNormalNonFullScreen":"fr-ec-cms-media-banner__text-container--normal-non-full-screen","cms-media-banner--full-screen__overlay":"fr-ec-cms-media-banner--full-screen__overlay","cmsMediaBannerFullScreenOverlay":"fr-ec-cms-media-banner--full-screen__overlay","cms-media-banner--full-screen__overlay--left":"fr-ec-cms-media-banner--full-screen__overlay--left","cmsMediaBannerFullScreenOverlayLeft":"fr-ec-cms-media-banner--full-screen__overlay--left","cms-media-banner--full-screen__overlay--right":"fr-ec-cms-media-banner--full-screen__overlay--right","cmsMediaBannerFullScreenOverlayRight":"fr-ec-cms-media-banner--full-screen__overlay--right","cms-media-banner__separate_text-container":"fr-ec-cms-media-banner__separate_text-container","cmsMediaBannerSeparateTextContainer":"fr-ec-cms-media-banner__separate_text-container","cms-media-banner__separate-type-fullscreen_text-container":"fr-ec-cms-media-banner__separate-type-fullscreen_text-container","cmsMediaBannerSeparateTypeFullscreenTextContainer":"fr-ec-cms-media-banner__separate-type-fullscreen_text-container","cms-media-banner__text-container--with-price-full-screen":"fr-ec-cms-media-banner__text-container--with-price-full-screen","cmsMediaBannerTextContainerWithPriceFullScreen":"fr-ec-cms-media-banner__text-container--with-price-full-screen","cms-media-banner__copy-right-text":"fr-ec-cms-media-banner__copy-right-text","cmsMediaBannerCopyRightText":"fr-ec-cms-media-banner__copy-right-text","cms-media-banner__separate-copy-right-text":"fr-ec-cms-media-banner__separate-copy-right-text","cmsMediaBannerSeparateCopyRightText":"fr-ec-cms-media-banner__separate-copy-right-text","cms-media-banner__separate-copy-right-text-normal":"fr-ec-cms-media-banner__separate-copy-right-text-normal","cmsMediaBannerSeparateCopyRightTextNormal":"fr-ec-cms-media-banner__separate-copy-right-text-normal","cms-media-banner__category-text":"fr-ec-cms-media-banner__category-text","cmsMediaBannerCategoryText":"fr-ec-cms-media-banner__category-text","cms-media-banner__title":"fr-ec-cms-media-banner__title","cmsMediaBannerTitle":"fr-ec-cms-media-banner__title","cms-media-banner__separate-title":"fr-ec-cms-media-banner__separate-title","cmsMediaBannerSeparateTitle":"fr-ec-cms-media-banner__separate-title","cms-media-banner__margin-top":"fr-ec-cms-media-banner__margin-top","cmsMediaBannerMarginTop":"fr-ec-cms-media-banner__margin-top","cms-media-banner__description":"fr-ec-cms-media-banner__description","cmsMediaBannerDescription":"fr-ec-cms-media-banner__description","cms-media-banner__product-name":"fr-ec-cms-media-banner__product-name","cmsMediaBannerProductName":"fr-ec-cms-media-banner__product-name","cms-media-banner--text-black":"fr-ec-cms-media-banner--text-black","cmsMediaBannerTextBlack":"fr-ec-cms-media-banner--text-black","cms-media-banner--text-white":"fr-ec-cms-media-banner--text-white","cmsMediaBannerTextWhite":"fr-ec-cms-media-banner--text-white","cms-media-banner__flag-text":"fr-ec-cms-media-banner__flag-text","cmsMediaBannerFlagText":"fr-ec-cms-media-banner__flag-text","cms-media-banner__flag-text--label":"fr-ec-cms-media-banner__flag-text--label","cmsMediaBannerFlagTextLabel":"fr-ec-cms-media-banner__flag-text--label","cms-media-banner__flag-text--label-white":"fr-ec-cms-media-banner__flag-text--label-white","cmsMediaBannerFlagTextLabelWhite":"fr-ec-cms-media-banner__flag-text--label-white","cms-media-banner__flag-text--label-black":"fr-ec-cms-media-banner__flag-text--label-black","cmsMediaBannerFlagTextLabelBlack":"fr-ec-cms-media-banner__flag-text--label-black","cms-media-banner__flag-text--label--separate-type":"fr-ec-cms-media-banner__flag-text--label--separate-type","cmsMediaBannerFlagTextLabelSeparateType":"fr-ec-cms-media-banner__flag-text--label--separate-type","cms-media-banner__separate-price-container":"fr-ec-cms-media-banner__separate-price-container","cmsMediaBannerSeparatePriceContainer":"fr-ec-cms-media-banner__separate-price-container","cms-media-banner__price":"fr-ec-cms-media-banner__price","cmsMediaBannerPrice":"fr-ec-cms-media-banner__price","price-text--l1":"fr-ec-price-text--l1","priceTextL1":"fr-ec-price-text--l1","cms-media-banner__price--separate":"fr-ec-cms-media-banner__price--separate","cmsMediaBannerPriceSeparate":"fr-ec-cms-media-banner__price--separate","price-text--large":"fr-ec-price-text--large","priceTextLarge":"fr-ec-price-text--large","cms-media-banner__price-white":"fr-ec-cms-media-banner__price-white","cmsMediaBannerPriceWhite":"fr-ec-cms-media-banner__price-white","cms-media-banner__price-black":"fr-ec-cms-media-banner__price-black","cmsMediaBannerPriceBlack":"fr-ec-cms-media-banner__price-black","content-alignment--alignment-baseline":"fr-ec-content-alignment--alignment-baseline","contentAlignmentAlignmentBaseline":"fr-ec-content-alignment--alignment-baseline","cms-media-banner__copy-right-text-white":"fr-ec-cms-media-banner__copy-right-text-white","cmsMediaBannerCopyRightTextWhite":"fr-ec-cms-media-banner__copy-right-text-white","cms-media-banner__copy-right-text-black":"fr-ec-cms-media-banner__copy-right-text-black","cmsMediaBannerCopyRightTextBlack":"fr-ec-cms-media-banner__copy-right-text-black","cms-media-banner__separate-product-name":"fr-ec-cms-media-banner__separate-product-name","cmsMediaBannerSeparateProductName":"fr-ec-cms-media-banner__separate-product-name","cms-media-banner--no-text-shadow":"fr-ec-cms-media-banner--no-text-shadow","cmsMediaBannerNoTextShadow":"fr-ec-cms-media-banner--no-text-shadow","cms-media-banner__description-separate-type":"fr-ec-cms-media-banner__description-separate-type","cmsMediaBannerDescriptionSeparateType":"fr-ec-cms-media-banner__description-separate-type","cms-media-banner__button-wrapper":"fr-ec-cms-media-banner__button-wrapper","cmsMediaBannerButtonWrapper":"fr-ec-cms-media-banner__button-wrapper","cms-media-banner__text-container--with-price-non-full-screen":"fr-ec-cms-media-banner__text-container--with-price-non-full-screen","cmsMediaBannerTextContainerWithPriceNonFullScreen":"fr-ec-cms-media-banner__text-container--with-price-non-full-screen","cms-media-banner__separate-copy-right-text-non-full-screen":"fr-ec-cms-media-banner__separate-copy-right-text-non-full-screen","cmsMediaBannerSeparateCopyRightTextNonFullScreen":"fr-ec-cms-media-banner__separate-copy-right-text-non-full-screen","cms-media-banner__flag-text__separate":"fr-ec-cms-media-banner__flag-text__separate","cmsMediaBannerFlagTextSeparate":"fr-ec-cms-media-banner__flag-text__separate","cms-media-banner__separate-button-wrapper":"fr-ec-cms-media-banner__separate-button-wrapper","cmsMediaBannerSeparateButtonWrapper":"fr-ec-cms-media-banner__separate-button-wrapper","cms-media-banner--right-top":"fr-ec-cms-media-banner--right-top","cmsMediaBannerRightTop":"fr-ec-cms-media-banner--right-top","cms-media-banner--right-middle":"fr-ec-cms-media-banner--right-middle","cmsMediaBannerRightMiddle":"fr-ec-cms-media-banner--right-middle","cms-media-banner--right-bottom":"fr-ec-cms-media-banner--right-bottom","cmsMediaBannerRightBottom":"fr-ec-cms-media-banner--right-bottom","cms-media-banner__price--separate-full-screen":"fr-ec-cms-media-banner__price--separate-full-screen","cmsMediaBannerPriceSeparateFullScreen":"fr-ec-cms-media-banner__price--separate-full-screen","cms-media-banner__separate-button-wrapper-full-screen":"fr-ec-cms-media-banner__separate-button-wrapper-full-screen","cmsMediaBannerSeparateButtonWrapperFullScreen":"fr-ec-cms-media-banner__separate-button-wrapper-full-screen","cms-media-banner__separate-button-full-screen":"fr-ec-cms-media-banner__separate-button-full-screen","cmsMediaBannerSeparateButtonFullScreen":"fr-ec-cms-media-banner__separate-button-full-screen","cms-media-banner__description-separate-type--full-screen":"fr-ec-cms-media-banner__description-separate-type--full-screen","cmsMediaBannerDescriptionSeparateTypeFullScreen":"fr-ec-cms-media-banner__description-separate-type--full-screen","cms-media-banner__separate-type-non-full-screen":"fr-ec-cms-media-banner__separate-type-non-full-screen","cmsMediaBannerSeparateTypeNonFullScreen":"fr-ec-cms-media-banner__separate-type-non-full-screen","cms-media-banner--normal":"fr-ec-cms-media-banner--normal","cmsMediaBannerNormal":"fr-ec-cms-media-banner--normal","cms-media-banner__button-wrapper-normal":"fr-ec-cms-media-banner__button-wrapper-normal","cmsMediaBannerButtonWrapperNormal":"fr-ec-cms-media-banner__button-wrapper-normal","cms-media-banner__description--normal":"fr-ec-cms-media-banner__description--normal","cmsMediaBannerDescriptionNormal":"fr-ec-cms-media-banner__description--normal"};

var _a$1, _b, _c;
var BLACK = 'black';
var WHITE = 'white';
var copyrighTextColorStyle = (_a$1 = {}, _a$1[WHITE] = styles$1N.cmsMediaBannerCopyRightTextWhite, _a$1[BLACK] = styles$1N.cmsMediaBannerCopyRightTextBlack, _a$1);
var mediaBannerModelTextColor = (_b = {}, _b[BLACK] = styles$1N.mediBannerModelNameBlack, _b[WHITE] = styles$1N.mediBannerModelNameWhite, _b);
var mediaBannerFlagTextStyles = (_c = {}, _c[BLACK] = styles$1N.cmsMediaBannerFlagTextLabelBlack, _c[WHITE] = styles$1N.cmsMediaBannerFlagTextLabelWhite, _c);

var styles$1O = {"cms-ticker":"fr-ec-cms-ticker","cmsTicker":"fr-ec-cms-ticker","caption":"fr-ec-caption","link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","cms-ticker-primary":"fr-ec-cms-ticker-primary","cmsTickerPrimary":"fr-ec-cms-ticker-primary","cms-ticker-secondary":"fr-ec-cms-ticker-secondary","cmsTickerSecondary":"fr-ec-cms-ticker-secondary","cms-ticker-attention":"fr-ec-cms-ticker-attention","cmsTickerAttention":"fr-ec-cms-ticker-attention","title":"fr-ec-title","button-icon--light":"fr-ec-button-icon--light","buttonIconLight":"fr-ec-button-icon--light"};

var CmsTicker = function CmsTicker(_a) {
  var messageOne = _a.messageOne,
    _b = _a.typeOne,
    typeOne = _b === void 0 ? 'primary' : _b,
    _c = _a.variant,
    variant = _c === void 0 ? 'static' : _c,
    toggleCloseButton = _a.toggleCloseButton,
    url = _a.url,
    iconBrand = _a.iconBrand,
    className = _a.className,
    props = __rest$1(_a, ["messageOne", "typeOne", "variant", "toggleCloseButton", "url", "iconBrand", "className"]);
  var _d = useState(false),
    closeTicker = _d[0],
    setCloseTickerValue = _d[1];
  var color = typeOne === 'secondary' ? 'primary-dark' : 'primary-light';
  var buttonIconColor = typeOne === 'secondary' ? 'dark' : 'light';
  var CmsTickerComponent = /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(className, styles$1O.cmsTicker, styles$1O["cms-ticker-".concat(typeOne)])
  }, props), toggleCloseButton && (/*#__PURE__*/createElement(ButtonIcon, {
    element: 'button',
    icon: "close",
    label: "Close",
    hideLabel: true,
    onClick: function onClick() {
      return setCloseTickerValue(true);
    },
    variant: buttonIconColor,
    iconBrand: iconBrand
  })), variant === 'withLink' && url ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(LinkNavigation, {
    element: 'a',
    href: url
  }, /*#__PURE__*/createElement(Caption, {
    color: color,
    element: "p",
    textAlign: "left"
  }, messageOne)), /*#__PURE__*/createElement(ButtonIcon, {
    element: 'a',
    icon: "chevron-right",
    label: "Go to",
    hideLabel: true,
    href: url,
    variant: buttonIconColor,
    iconBrand: iconBrand
  }))) : (/*#__PURE__*/createElement(Caption, {
    color: color,
    element: "p",
    textAlign: "center"
  }, messageOne)));
  return closeTicker ? null : CmsTickerComponent;
};
CmsTicker.displayName = 'CoreCmsTicker';

var styles$1P = {"cms-contents-card":"fr-ec-cms-contents-card","cmsContentsCard":"fr-ec-cms-contents-card"};

var CmsContentsCard = function CmsContentsCard(_a) {
  var _b = _a.type,
    type = _b === void 0 ? 'fullscreen' : _b,
    content = _a.content,
    className = _a.className,
    props = __rest$1(_a, ["type", "content", "className"]);
  var colSpan = function colSpan() {
    if (type === 'fullscreen' || type === 'contained') {
      return {
        lg: 12,
        sm: 4,
        md: 12
      };
    } else if (type === 'centered') {
      return {
        lg: 10,
        sm: 4,
        md: 10
      };
    } else {
      return {
        lg: 8,
        sm: 4,
        md: 8
      };
    }
  };
  return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
    justifyContent: "center",
    direction: "row",
    className: joinClasses(className, styles$1P.cmsContentsCard),
    element: "div"
  }, props), /*#__PURE__*/createElement(Layout, {
    colSpan: colSpan(),
    gutter: {
      sm: type === 'fullscreen' ? false : true,
      md: true,
      lg: true
    }
  }, content));
};
CmsContentsCard.displayName = 'CoreCmsContentsCard';

var styles$1Q = {"accordion-tab-group-wrapper":"fr-ec-accordion-tab-group-wrapper","accordionTabGroupWrapper":"fr-ec-accordion-tab-group-wrapper","accordion-tab-group":"fr-ec-accordion-tab-group","accordionTabGroup":"fr-ec-accordion-tab-group","accordion-tab-group__content":"fr-ec-accordion-tab-group__content","accordionTabGroupContent":"fr-ec-accordion-tab-group__content"};

var AccordionTabGroup = /** @class */function (_super) {
  __extends(AccordionTabGroup, _super);
  function AccordionTabGroup(props) {
    var _this = _super.call(this, props) || this;
    _this.onClick = function (label, child, tabOnclick) {
      return function (event, activeTabId) {
        _this.setState({
          activeTabId: activeTabId
        });
        if (tabOnclick) {
          tabOnclick(event, label, child);
        }
      };
    };
    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    var activeChild = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildProps = activeChild ? activeChild.props : {};
    _this.state = {
      activeTabId: activeChildProps.headingText
    };
    return _this;
  }
  AccordionTabGroup.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      className = _a.className,
      props = __rest$1(_a, ["children", "className"]);
    var activeTabId = this.state.activeTabId;
    var activeContent = null;
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child) {
      if (child.props.headingText === activeTabId) {
        activeContent = child.props.children;
      }
      return /*#__PURE__*/cloneElement(child, {
        accordionType: 'nav',
        isActive: child.props.headingText === activeTabId,
        key: child.props.headingText,
        onClick: _this.onClick(child.props.headingText, child, child.props.onClick)
      });
    });
    return /*#__PURE__*/createElement("div", __assign$1({
      className: joinClasses(styles$1Q.accordionTabGroupWrapper, className)
    }, props), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1Q.accordionTabGroup),
      role: "tablist"
    }, childrenWithProps), /*#__PURE__*/createElement("div", {
      role: "tabpanel",
      className: styles$1Q.accordionTabGroupContent
    }, activeContent));
  };
  AccordionTabGroup.displayName = 'CoreAccordionTabGroup';
  AccordionTabGroup.defaultProps = {};
  return AccordionTabGroup;
}(Component);

var styles$1R = {"cms-heading--color-normal":"fr-ec-cms-heading--color-normal","cmsHeadingColorNormal":"fr-ec-cms-heading--color-normal","cms-heading--color-weak":"fr-ec-cms-heading--color-weak","cmsHeadingColorWeak":"fr-ec-cms-heading--color-weak","cms-heading--color-caution":"fr-ec-cms-heading--color-caution","cmsHeadingColorCaution":"fr-ec-cms-heading--color-caution"};

var CmsHeading = function CmsHeading(_a) {
  var content = _a.content,
    _b = _a.type,
    type = _b === void 0 ? 'display1' : _b,
    _c = _a.htmlTag,
    htmlTag = _c === void 0 ? 'h1' : _c,
    _d = _a.align,
    align = _d === void 0 ? 'left' : _d,
    _e = _a.color,
    color = _e === void 0 ? 'normal' : _e,
    _f = _a.margins,
    margins = _f === void 0 ? 'withMargin' : _f,
    id = _a.id,
    gaLabel = _a.gaLabel,
    gaCategory = _a.gaCategory,
    className = _a.className,
    subContent = _a.subContent,
    props = __rest$1(_a, ["content", "type", "htmlTag", "align", "color", "margins", "id", "gaLabel", "gaCategory", "className", "subContent"]);
  var gaProps = {};
  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };
  }
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(className, margins === 'withMargin' ? spacingStyles.mbSpacing04 : '')
  }, props), /*#__PURE__*/createElement(Display, __assign$1({
    element: htmlTag === 'none' ? 'div' : htmlTag,
    id: id,
    variant: type,
    textAlign: align,
    className: styles$1R["cms-heading--color-".concat(color)]
  }, gaProps), content), /*#__PURE__*/createElement(Body, {
    element: "p",
    variant: "standard",
    className: spacingStyles.mtSpacing03,
    textAlign: align
  }, subContent));
};
CmsHeading.displayName = 'CoreCmsHeading';

var contentChild = function contentChild(props) {
  return /*#__PURE__*/createElement(Fragment, __assign$1({}, props));
};
var ContentVisibilityHoc = isViewport(contentChild);
var CmsContentVisibility = function CmsContentVisibility(_a) {
  var _b = _a.mobileVisibility,
    mobileVisibility = _b === void 0 ? true : _b,
    _c = _a.tabletVisibility,
    tabletVisibility = _c === void 0 ? true : _c,
    _d = _a.pcVisibility,
    pcVisibility = _d === void 0 ? true : _d,
    props = __rest$1(_a, ["mobileVisibility", "tabletVisibility", "pcVisibility"]);
  var visibilityProp = {
    lg: pcVisibility,
    md: tabletVisibility,
    sm: mobileVisibility
  };
  return /*#__PURE__*/createElement(ContentVisibilityHoc, __assign$1({
    visible: visibilityProp
  }, props));
};
ContentVisibilityHoc.displayName = 'CoreCmsContentVisibility';

var styles$1S = {"cms-text":"fr-ec-cms-text","cmsText":"fr-ec-cms-text"};

var CmsText = function CmsText(_a) {
  var content = _a.content,
    _b = _a.type,
    type = _b === void 0 ? 'normal' : _b,
    centered = _a.centered,
    className = _a.className,
    props = __rest$1(_a, ["content", "type", "centered", "className"]);
  var color = {
    normal: 'primary-dark',
    caution: 'error',
    weak: 'secondary'
  };
  return /*#__PURE__*/createElement(Body, __assign$1({
    element: "p",
    className: joinClasses(className, styles$1S.cmsText),
    textAlign: centered ? 'center' : 'left',
    color: color[type]
  }, props), content);
};
CmsText.displayName = 'CoreCmsText';

var styles$1T = {"search-history-item":"fr-ec-search-history-item","searchHistoryItem":"fr-ec-search-history-item","search-history-item--focus":"fr-ec-search-history-item--focus","searchHistoryItemFocus":"fr-ec-search-history-item--focus","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","search-history-item__icon":"fr-ec-search-history-item__icon","searchHistoryItemIcon":"fr-ec-search-history-item__icon","search-history-item__content":"fr-ec-search-history-item__content","searchHistoryItemContent":"fr-ec-search-history-item__content","search-history-item__title":"fr-ec-search-history-item__title","searchHistoryItemTitle":"fr-ec-search-history-item__title"};

var SearchHistoryItem = function SearchHistoryItem(_a) {
  var title = _a.title,
    onDismiss = _a.onDismiss,
    className = _a.className,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["title", "onDismiss", "className", "iconBrand"]);
  var onClose = function onClose(event) {
    event.stopPropagation();
    if (onDismiss) {
      onDismiss(event);
    }
  };
  return /*#__PURE__*/createElement(Tile, __assign$1({
    tabIndex: -1
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    className: joinClasses(styles$1T.searchHistoryItem, className)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: -1,
    className: joinClasses(styles$1T.searchHistoryItemContent, styles$1T.searchHistoryItem)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: 0,
    className: styles$1T.searchHistoryItemFocus
  }, /*#__PURE__*/createElement(Body, {
    className: styles$1T.searchHistoryItemTitle,
    element: 'p'
  }, title), /*#__PURE__*/createElement(ButtonIcon, {
    type: "button",
    element: "button",
    icon: "close",
    variant: "dark",
    hideLabel: true,
    onMouseDown: onClose,
    tabIndex: -1,
    label: 'Close',
    iconBrand: iconBrand
  })))));
};
SearchHistoryItem.displayName = 'CoreSearchHistoryItem';

var styles$1U = {"fixed-panel":"fr-ec-fixed-panel","fixedPanel":"fr-ec-fixed-panel","fixed-panel--hide":"fr-ec-fixed-panel--hide","fixedPanelHide":"fr-ec-fixed-panel--hide","fixed-panel__first-row":"fr-ec-fixed-panel__first-row","fixedPanelFirstRow":"fr-ec-fixed-panel__first-row","body":"fr-ec-body","fixed-panel__second-row":"fr-ec-fixed-panel__second-row","fixedPanelSecondRow":"fr-ec-fixed-panel__second-row","fixed-panel__price-label":"fr-ec-fixed-panel__price-label","fixedPanelPriceLabel":"fr-ec-fixed-panel__price-label","fixed-panel__btn-container":"fr-ec-fixed-panel__btn-container","fixedPanelBtnContainer":"fr-ec-fixed-panel__btn-container","fixed-panel__button-layout-wrapper":"fr-ec-fixed-panel__button-layout-wrapper","fixedPanelButtonLayoutWrapper":"fr-ec-fixed-panel__button-layout-wrapper","fixed-panel__button-layout":"fr-ec-fixed-panel__button-layout","fixedPanelButtonLayout":"fr-ec-fixed-panel__button-layout","fixed-panel--hidden":"fr-ec-fixed-panel--hidden","fixedPanelHidden":"fr-ec-fixed-panel--hidden","fixed-panel__inner":"fr-ec-fixed-panel__inner","fixedPanelInner":"fr-ec-fixed-panel__inner","fixed-panel__price-container":"fr-ec-fixed-panel__price-container","fixedPanelPriceContainer":"fr-ec-fixed-panel__price-container","button":"fr-ec-button"};

var FixedPanel = function FixedPanel(_a) {
  var description = _a.description,
    TotalLabel = _a.TotalLabel,
    TotalPrice = _a.TotalPrice,
    Button = _a.Button,
    className = _a.className,
    _b = _a.variant,
    variant = _b === void 0 ? 'default' : _b,
    _c = _a.idToHidePanel,
    idToHidePanel = _c === void 0 ? '' : _c,
    _d = _a.hideFixedPanel,
    hideFixedPanel = _d === void 0 ? false : _d,
    content = _a.content;
  var _e = useState(false),
    isHidden = _e[0],
    setIsHidden = _e[1];
  var _f = useState(false),
    removeFixedPanel = _f[0],
    setFixedPanelDisplay = _f[1];
  var _g = useState(true),
    isHiddenOnScroll = _g[0],
    setIsHiddenOnScroll = _g[1];
  var _h = useState(false),
    isMounted = _h[0],
    setIsMounted = _h[1];
  var scrollTop = isInBrowser$1() ? window.pageYOffset : 0;
  var options = {
    threshold: 0.5
  };
  var callIntersectionObserver = function callIntersectionObserver(entries) {
    var entry = entries[0];
    var element = document.getElementById(idToHidePanel);
    var rootElement = entry === null || entry === void 0 ? void 0 : entry.rootBounds;
    if (element && rootElement) {
      var _a = element.getBoundingClientRect(),
        height = _a.height,
        top_1 = _a.top;
      var viewportHeight = rootElement.height;
      if (variant === 'default' || variant === 'showInAllDevices') {
        setIsHidden(entry.isIntersecting);
        if (!entry.isIntersecting) {
          var bodyHeight = Math.floor(document.body.getBoundingClientRect().height);
          if (window.innerHeight + window.scrollY >= bodyHeight) {
            setIsHiddenOnScroll(true);
          } else {
            setIsHiddenOnScroll(false);
          }
        }
      } else if (variant === 'ScrollDownToHide') {
        setIsHidden(entry.isIntersecting || viewportHeight >= height / 2 + top_1);
      }
    }
  };
  var handleScroll = function handleScroll() {
    if (variant === 'ScrollDownToHide') {
      var currScroll = window.pageYOffset;
      if (currScroll > 0) {
        if (currScroll > scrollTop) {
          setIsHiddenOnScroll(true);
        } else if (currScroll < scrollTop) {
          setIsHiddenOnScroll(false);
        }
        scrollTop = currScroll;
      }
    } else if (variant === 'default' || variant === 'showInAllDevices') {
      var bodyHeight = Math.floor(document.body.getBoundingClientRect().height);
      if (window.innerHeight + window.scrollY >= bodyHeight) {
        setIsHiddenOnScroll(true);
      } else {
        setIsHiddenOnScroll(false);
      }
    }
  };
  useEffect(function () {
    var element = document.getElementById(idToHidePanel);
    var observer = new IntersectionObserver(callIntersectionObserver, options);
    if (element) {
      observer.observe(element);
    }
    return function () {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [options]);
  useEffect(function () {
    if (isInBrowser$1()) {
      if (isMounted) {
        window.addEventListener('scroll', handleScroll);
      } else {
        setIsMounted(true);
      }
    }
    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      var element = document.getElementById(idToHidePanel);
      if (!element) {
        handleScroll();
      }
    }
  }, []);
  useEffect(function () {
    setFixedPanelDisplay(hideFixedPanel);
  }, [hideFixedPanel]);
  return Button ? variant === 'default' ? (/*#__PURE__*/React__default.createElement(Layout, {
    visible: {
      sm: true,
      md: true,
      lg: false
    },
    element: "div",
    className: joinClasses(className, styles$1U.fixedPanel, isHidden ? styles$1U.fixedPanelHidden : isHiddenOnScroll ? styles$1U.fixedPanelHidden : '', removeFixedPanel && styles$1U.fixedPanelHide)
  }, /*#__PURE__*/React__default.createElement(Keyline, null), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1U.fixedPanelInner
  }, (content || description) && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$1U.fixedPanelFirstRow
  }, typeof description === 'string' ? (/*#__PURE__*/React__default.createElement(Body, {
    element: "p",
    variant: "standard"
  }, description)) : description === null || description === void 0 ? void 0 : description.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Body, {
      element: "p",
      variant: "standard",
      key: index
    }, item);
  }), content)), /*#__PURE__*/React__default.createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    className: styles$1U.fixedPanelSecondRow,
    justifyContent: "center"
  }, TotalLabel && TotalPrice && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$1U.fixedPanelPriceContainer
  }, /*#__PURE__*/React__default.createElement(Body, {
    element: "p",
    variant: "small",
    textAlign: "center",
    className: styles$1U.fixedPanelPriceLabel
  }, TotalLabel), /*#__PURE__*/React__default.createElement(Title, {
    element: "p",
    variant: "large-emphasized",
    textAlign: "center"
  }, TotalPrice))), /*#__PURE__*/React__default.createElement("div", {
    className: styles$1U.fixedPanelBtnContainer
  }, Button))))) : (/*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1U.fixedPanelButtonLayoutWrapper, isHidden ? styles$1U.fixedPanelHidden : isHiddenOnScroll ? styles$1U.fixedPanelHidden : '', removeFixedPanel && styles$1U.fixedPanelHide)
  }, /*#__PURE__*/React__default.createElement(Keyline, null), /*#__PURE__*/React__default.createElement(Layout, {
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    element: "div",
    className: joinClasses(className, styles$1U.fixedPanelButtonLayout)
  }, description && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$1U.fixedPanelFirstRow
  }, typeof description === 'string' ? (/*#__PURE__*/React__default.createElement(Body, {
    element: "p",
    variant: "standard"
  }, description)) : description === null || description === void 0 ? void 0 : description.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Body, {
      element: "p",
      variant: "standard",
      key: index
    }, item);
  }))), Button))) : null;
};
FixedPanel.displayName = 'CoreFixedPanel';

var styles$1V = {"balloon-tip":"fr-ec-balloon-tip","balloonTip":"fr-ec-balloon-tip","balloon-tip__icon":"fr-ec-balloon-tip__icon","balloonTipIcon":"fr-ec-balloon-tip__icon","balloon-tip__content":"fr-ec-balloon-tip__content","balloonTipContent":"fr-ec-balloon-tip__content","balloon-tip__arrow-top-center":"fr-ec-balloon-tip__arrow-top-center","balloonTipArrowTopCenter":"fr-ec-balloon-tip__arrow-top-center","balloon-tip__arrow-top-left":"fr-ec-balloon-tip__arrow-top-left","balloonTipArrowTopLeft":"fr-ec-balloon-tip__arrow-top-left","balloon-tip__arrow-top-right":"fr-ec-balloon-tip__arrow-top-right","balloonTipArrowTopRight":"fr-ec-balloon-tip__arrow-top-right","bounceTop":"fr-ec-bounceTop","balloon-tip__arrow-bottom-center":"fr-ec-balloon-tip__arrow-bottom-center","balloonTipArrowBottomCenter":"fr-ec-balloon-tip__arrow-bottom-center","balloon-tip__arrow-bottom-left":"fr-ec-balloon-tip__arrow-bottom-left","balloonTipArrowBottomLeft":"fr-ec-balloon-tip__arrow-bottom-left","balloon-tip__arrow-bottom-right":"fr-ec-balloon-tip__arrow-bottom-right","balloonTipArrowBottomRight":"fr-ec-balloon-tip__arrow-bottom-right","bounceBottom":"fr-ec-bounceBottom","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon"};

var BalloonTip = function BalloonTip(_a) {
  var content = _a.content,
    ariaLabel = _a.ariaLabel,
    id = _a.id,
    onClick = _a.onClick,
    _b = _a.top,
    top = _b === void 0 ? 0 : _b,
    left = _a.left,
    right = _a.right,
    iconBrand = _a.iconBrand,
    _c = _a.arrowPosition,
    arrowPosition = _c === void 0 ? 'bottom-center' : _c,
    tabIndex = _a.tabIndex;
  var leftVal = left !== undefined ? "".concat(left, "px") : 'auto';
  var rightVal = right !== undefined ? "".concat(right, "px") : 'auto';
  return /*#__PURE__*/createElement(ContentAlignment, {
    alignment: "center",
    direction: "row",
    element: "div",
    fluidHeight: false,
    justifyContent: "flex-start",
    className: joinClasses(styles$1V.balloonTip, "".concat(styles$1V.balloonTip, "__arrow-").concat(arrowPosition)),
    "aria-label": ariaLabel,
    id: id,
    style: {
      top: "".concat(top, "px"),
      left: leftVal,
      right: rightVal
    }
  }, /*#__PURE__*/createElement(Caption, {
    color: "primary-light",
    element: "p",
    variant: "standard",
    className: styles$1V.balloonTipContent
  }, content), /*#__PURE__*/createElement(ButtonIcon, {
    id: id,
    element: "button",
    type: "button",
    icon: 'close',
    hideLabel: true,
    onMouseDown: onClick,
    onClick: onClick,
    label: ariaLabel || 'close',
    className: styles$1V.balloonTipIcon,
    iconBrand: iconBrand,
    tabIndex: tabIndex
  }));
};
BalloonTip.displayName = 'CoreBalloonTip';

var styles$1W = {"balloon-tip-container":"fr-ec-balloon-tip-container","balloonTipContainer":"fr-ec-balloon-tip-container"};

var BalloonTipContainer = /*#__PURE__*/forwardRef(function (_a, ref) {
  var children = _a.children;
  return /*#__PURE__*/createElement("div", {
    className: styles$1W.balloonTipContainer,
    ref: ref
  }, children);
});
BalloonTipContainer.displayName = 'CoreBalloonTipContainer';

var styles$1X = {"bottom-navigation--keyboard-open":"fr-ec-bottom-navigation--keyboard-open","bottomNavigationKeyboardOpen":"fr-ec-bottom-navigation--keyboard-open","bottom-navigation--with-smart-banner":"fr-ec-bottom-navigation--with-smart-banner","bottomNavigationWithSmartBanner":"fr-ec-bottom-navigation--with-smart-banner","bottom-navigation":"fr-ec-bottom-navigation","bottomNavigation":"fr-ec-bottom-navigation","bottom-navigation__container-search":"fr-ec-bottom-navigation__container-search","bottomNavigationContainerSearch":"fr-ec-bottom-navigation__container-search","bottom-navigation-bg":"fr-ec-bottom-navigation-bg","bottomNavigationBg":"fr-ec-bottom-navigation-bg","bottom-navigation--column":"fr-ec-bottom-navigation--column","bottomNavigationColumn":"fr-ec-bottom-navigation--column","bottom-navigation--flyout-area":"fr-ec-bottom-navigation--flyout-area","bottomNavigationFlyoutArea":"fr-ec-bottom-navigation--flyout-area","flyoutOpen":"fr-ec-flyoutOpen","template-navigation__bottom-nav-container-keyboard-open":"fr-ec-template-navigation__bottom-nav-container-keyboard-open","templateNavigationBottomNavContainerKeyboardOpen":"fr-ec-template-navigation__bottom-nav-container-keyboard-open","bottom-navigation--flyout-area--search-history-layout":"fr-ec-bottom-navigation--flyout-area--search-history-layout","bottomNavigationFlyoutAreaSearchHistoryLayout":"fr-ec-bottom-navigation--flyout-area--search-history-layout","bottom-navigation--flyout-area-close":"fr-ec-bottom-navigation--flyout-area-close","bottomNavigationFlyoutAreaClose":"fr-ec-bottom-navigation--flyout-area-close","flyoutClose":"fr-ec-flyoutClose","bottom-navigation-wrapper":"fr-ec-bottom-navigation-wrapper","bottomNavigationWrapper":"fr-ec-bottom-navigation-wrapper","bottom-navigation__iq-area":"fr-ec-bottom-navigation__iq-area","bottomNavigationIqArea":"fr-ec-bottom-navigation__iq-area","bottom-navigation__iq-container":"fr-ec-bottom-navigation__iq-container","bottomNavigationIqContainer":"fr-ec-bottom-navigation__iq-container","bottom-navigation__iq-container-buttons":"fr-ec-bottom-navigation__iq-container-buttons","bottomNavigationIqContainerButtons":"fr-ec-bottom-navigation__iq-container-buttons","iconsFadeIn":"fr-ec-iconsFadeIn","bottom-navigation__iq-button":"fr-ec-bottom-navigation__iq-button","bottomNavigationIqButton":"fr-ec-bottom-navigation__iq-button","bottom-navigation__iq-container-fade-out":"fr-ec-bottom-navigation__iq-container-fade-out","bottomNavigationIqContainerFadeOut":"fr-ec-bottom-navigation__iq-container-fade-out","iconsFadeOut":"fr-ec-iconsFadeOut","bottom-navigation__wrapper-default":"fr-ec-bottom-navigation__wrapper-default","bottomNavigationWrapperDefault":"fr-ec-bottom-navigation--wrapper-default","bottom-navigation__search-wrapper":"fr-ec-bottom-navigation__search-wrapper","bottomNavigationSearchWrapper":"fr-ec-bottom-navigation__search-wrapper","bottom-navigation__toggle-arrow-add":"fr-ec-bottom-navigation__toggle-arrow-add","bottomNavigationToggleArrowAdd":"fr-ec-bottom-navigation__toggle-arrow-add","arrowFadeIn":"fr-ec-arrowFadeIn","bottom-navigation__toggle-arrow-remove":"fr-ec-bottom-navigation__toggle-arrow-remove","bottomNavigationToggleArrowRemove":"fr-ec-bottom-navigation__toggle-arrow-remove","arrowFadeOut":"fr-ec-arrowFadeOut","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","image":"fr-ec-image","bottom-navigation_wrapper-membership":"fr-ec-bottom-navigation_wrapper-membership","bottomNavigationWrapperMembership":"fr-ec-bottom-navigation_wrapper-membership","bottom-navigation__container-membership":"fr-ec-bottom-navigation__container-membership","bottomNavigationContainerMembership":"fr-ec-bottom-navigation__container-membership","bottom-navigation__icon":"fr-ec-bottom-navigation__icon","bottomNavigationIcon":"fr-ec-bottom-navigation__icon","bottom-navigation__container":"fr-ec-bottom-navigation__container","bottomNavigationContainer":"fr-ec-bottom-navigation__container","bottom-navigation__container-default":"fr-ec-bottom-navigation__container-default","bottomNavigationContainerDefault":"fr-ec-bottom-navigation__container-default","bottom-navigation__icon-container-default":"fr-ec-bottom-navigation__icon-container-default","bottomNavigationIconContainerDefault":"fr-ec-bottom-navigation__icon-container-default","balloon-tip-container":"fr-ec-balloon-tip-container","balloonTipContainer":"fr-ec-balloon-tip-container","bottom-navigation__flyout-open":"fr-ec-bottom-navigation__flyout-open","bottomNavigationFlyoutOpen":"fr-ec-bottom-navigation__flyout-open","bottom-navigation__button-membership":"fr-ec-bottom-navigation__button-membership","bottomNavigationButtonMembership":"fr-ec-bottom-navigation__button-membership","button--text-wrap":"fr-ec-button--text-wrap","buttonTextWrap":"fr-ec-button--text-wrap","search-wrapper":"fr-ec-search-wrapper","searchWrapper":"fr-ec-search-wrapper","bottom-navigation__icon-wrapper":"fr-ec-bottom-navigation__icon-wrapper","bottomNavigationIconWrapper":"fr-ec-bottom-navigation__icon-wrapper","bottom-navigation__icon-wrapper-center":"fr-ec-bottom-navigation__icon-wrapper-center","bottomNavigationIconWrapperCenter":"fr-ec-bottom-navigation__icon-wrapper-center","bottom-navigation__icon-center":"fr-ec-bottom-navigation__icon-center","bottomNavigationIconCenter":"fr-ec-bottom-navigation__icon-center","bottom-navigation--layout-wrapper":"fr-ec-bottom-navigation--layout-wrapper","bottomNavigationLayoutWrapper":"fr-ec-bottom-navigation--layout-wrapper","bottom-navigation__search-history__delete-icon--disabled":"fr-ec-bottom-navigation__search-history__delete-icon--disabled","bottomNavigationSearchHistoryDeleteIconDisabled":"fr-ec-bottom-navigation__search-history__delete-icon--disabled","bottom-navigation__search-history-collection":"fr-ec-bottom-navigation__search-history-collection","bottomNavigationSearchHistoryCollection":"fr-ec-bottom-navigation__search-history-collection","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","bottom-navigation__search-history-collection__items":"fr-ec-bottom-navigation__search-history-collection__items","bottomNavigationSearchHistoryCollectionItems":"fr-ec-bottom-navigation__search-history-collection__items","tag-filter-group":"fr-ec-tag-filter-group","tagFilterGroup":"fr-ec-tag-filter-group","tag-filter-group__no-wrap-container":"fr-ec-tag-filter-group__no-wrap-container","tagFilterGroupNoWrapContainer":"fr-ec-tag-filter-group__no-wrap-container","bottom-navigation--wrapper-default":"fr-ec-bottom-navigation--wrapper-default","cms-smart-banner":"fr-ec-cms-smart-banner","cmsSmartBanner":"fr-ec-cms-smart-banner","balloon-tip":"fr-ec-balloon-tip","balloonTip":"fr-ec-balloon-tip","bottom-navigation__no-search-history--section":"fr-ec-bottom-navigation__no-search-history--section","bottomNavigationNoSearchHistorySection":"fr-ec-bottom-navigation__no-search-history--section","bottom-navigation--layout-wrapper-without-icon":"fr-ec-bottom-navigation--layout-wrapper-without-icon","bottomNavigationLayoutWrapperWithoutIcon":"fr-ec-bottom-navigation--layout-wrapper-without-icon","layout-wrapper":"fr-ec-layout-wrapper","layoutWrapper":"fr-ec-layout-wrapper"};

var BottomNavigation = function BottomNavigation(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'nav' : _b,
    iqChatBotArea = _a.iqChatBotArea,
    searchFocused = _a.searchFocused,
    hasSearchValue = _a.hasSearchValue,
    primaryOptionsIcon = _a.primaryOptionsIcon,
    primaryOptionsLabel = _a.primaryOptionsLabel,
    primaryOptionsAriaLabel = _a.primaryOptionsAriaLabel,
    primaryOptionsCallback = _a.primaryOptionsCallback,
    primaryOptionsBalloonTip = _a.primaryOptionsBalloonTip,
    searchArea = _a.searchArea,
    secondaryOptionsIcon = _a.secondaryOptionsIcon,
    secondaryOptionsCallback = _a.secondaryOptionsCallback,
    _c = _a.variant,
    variant = _c === void 0 ? 'default' : _c,
    searchFlyoutArea = _a.searchFlyoutArea,
    searchHistoryItems = _a.searchHistoryItems,
    showSearchHistory = _a.showSearchHistory,
    searchHistoryLabel = _a.searchHistoryLabel,
    noSearchHistorySection = _a.noSearchHistorySection,
    onDeleteSearchHistory = _a.onDeleteSearchHistory,
    _d = _a.showTrendingWords,
    showTrendingWords = _d === void 0 ? false : _d,
    trendingWordsLabel = _a.trendingWordsLabel,
    trendingWords = _a.trendingWords,
    iconBrand = _a.iconBrand,
    onArrowClick = _a.onArrowClick,
    onRequestCloseFlyout = _a.onRequestCloseFlyout,
    smartBannerSection = _a.smartBannerSection;
  var _e = useState(searchFocused),
    toggleArrow = _e[0],
    setToggleArrow = _e[1];
  var _f = useState(hasSearchValue),
    hasValue = _f[0],
    setValueStatus = _f[1];
  var _g = useState(0),
    bottomVal = _g[0],
    setBottomVal = _g[1];
  var _h = useState(false),
    displayFlyout = _h[0],
    setDisplayFlyout = _h[1];
  var _j = useState(true),
    displayIcons = _j[0],
    setDisplayIcons = _j[1];
  var _k = useState(false),
    displayToggleArrow = _k[0],
    setDisplayToggleArrow = _k[1];
  var bottomRef = useRef(null);
  var searchWrapperRef = useRef(null);
  var _l = useState(isTouchDevice('touchPoints')),
    isTouchDevices = _l[0],
    setTouchDevices = _l[1];
  var _m = useState(false),
    isMobileDevice = _m[0],
    setIsMobileDevice = _m[1];
  var isKeyboardOpenState = isKeyboardOpen();
  var width = getViewportWidth();
  var isArrowVisible = toggleArrow ? width > designTokens_3.mqMediumScreenMaxWidthLimit : true;
  var searchWrapper = typeof document !== 'undefined' ? document.getElementsByClassName(styles$1X.bottomNavigationSearchWrapper) : null;
  var searchWrapperHeight = searchWrapper && searchWrapper[0] && searchWrapper[0].getBoundingClientRect().height;
  var _o = useState(false),
    isTouched = _o[0],
    setIsTouched = _o[1];
  var balloonRef = useRef(null);
  var _p = useState(0),
    ballonHeight = _p[0],
    setBalloonHeight = _p[1];
  useEffect(function () {
    if (!isTouched) {
      setToggleArrow(searchFocused);
    }
    setValueStatus(hasSearchValue);
    if (bottomRef && bottomRef.current) {
      setBottomVal(bottomRef.current.getBoundingClientRect().height);
    }
    if (searchFocused && !isTouched) {
      setDisplayFlyout(true);
      setDisplayToggleArrow(true);
    }
    if (isKeyboardOpenState) {
      isInBrowser() && window.scroll(0, 0);
    } else if (isMobileDevice && !isKeyboardOpenState) {
      if (!isTouched) {
        setDisplayFlyout(false);
        setDisplayToggleArrow(false);
        setToggleArrow(false);
      }
    }
    if (!toggleArrow) {
      setDisplayIcons(true);
    }
  }, [searchFocused, hasSearchValue, bottomRef.current, toggleArrow, isKeyboardOpenState]);
  useEffect(function () {
    setTouchDevices(isTouchDevice('userAgent'));
    var isRealDevice = (navigator === null || navigator === void 0 ? void 0 : navigator.maxTouchPoints) > 2;
    setIsMobileDevice(isRealDevice);
  }, []);
  useEffect(function () {
    var updateBalloonHeight = function updateBalloonHeight() {
      var _a;
      var ballonHeight = balloonRef.current && ((_a = balloonRef.current.querySelector('.fr-ec-balloon-tip')) === null || _a === void 0 ? void 0 : _a.clientHeight);
      if (ballonHeight) {
        setBalloonHeight(ballonHeight + 12); // ballonHeight + arrow height (12)
      }
    };
    setTimeout(function () {
      return updateBalloonHeight();
    }, 0);
    window.addEventListener('resize', updateBalloonHeight);
    window.addEventListener('popstate', updateBalloonHeight);
    return function () {
      window.removeEventListener('resize', updateBalloonHeight);
      window.removeEventListener('popstate', updateBalloonHeight);
    };
  }, []);
  var isSecondaryIconVisible = toggleArrow || hasValue && !searchFocused;
  var onMouseDown = function onMouseDown(event) {
    var _a;
    onDeleteSearchHistory && onDeleteSearchHistory(event);
    var searchInput = (_a = bottomRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByClassName('fr-ec-search__input');
    setTimeout(function () {
      if (searchInput && searchInput[0]) {
        searchInput[0].focus();
      }
    });
  };
  var onTouchStart = function onTouchStart() {
    setIsTouched(true);
  };
  var getSearchHistoryTitle = function getSearchHistoryTitle(label, iconBrandVal) {
    if (label === void 0) {
      label = '';
    }
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Title, {
      element: "p",
      variant: "standard"
    }, label || 'Search History'), /*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "delete",
      iconBrand: iconBrandVal,
      hideLabel: true,
      onMouseDown: onMouseDown,
      tabIndex: -1,
      label: "Delete",
      disabled: searchHistoryItems && searchHistoryItems.length > 0 ? false : true,
      className: searchHistoryItems && searchHistoryItems.length > 0 ? '' : styles$1X.bottomNavigationSearchHistoryDeleteIconDisabled
    }));
  };
  var onAnimationEnd = function onAnimationEnd() {
    if (isSecondaryIconVisible) {
      setDisplayIcons(false);
    }
  };
  var handleClick = function handleClick(event) {
    var target = event.target;
    if (target.classList.contains('fr-ec-bottom-navigation--flyout-area') || target.classList.contains('fr-ec-layout-wrapper') || target.classList.contains('fr-ec-bottom-navigation-bg')) {
      if (onRequestCloseFlyout) {
        onRequestCloseFlyout();
      }
    }
  };
  var onArrowAnimationEnd = function onArrowAnimationEnd() {
    if (!toggleArrow) {
      setDisplayToggleArrow(false);
    }
  };
  var showPrimaryIcons = width > designTokens_3.mqMediumScreenMaxWidthLimit ? isArrowVisible || hasValue && !searchFocused : isArrowVisible || !isTouchDevices || !isKeyboardOpenState;
  var keyboardViewCheck = isTouched ? true : isKeyboardOpenState;
  return /*#__PURE__*/createElement("div", {
    className: isMobileDevice && keyboardViewCheck && styles$1X.bottomNavigationKeyboardOpen
  }, displayFlyout && !isKeyboardOpenState && !isMobileDevice && (/*#__PURE__*/createElement("div", {
    ref: searchWrapperRef,
    role: "button",
    onClick: function onClick(e) {
      return handleClick(e);
    },
    className: joinClasses(styles$1X.bottomNavigationFlyoutArea, searchFlyoutArea || showSearchHistory ? '' : styles$1X.bottomNavigationFlyoutAreaClose),
    style: {
      paddingBottom: "".concat(bottomVal + 12, "px")
    }
  }, searchFlyoutArea && Children.map(searchFlyoutArea, function (item, i) {
    return /*#__PURE__*/cloneElement(item, {
      onTouchStart: onTouchStart
    });
  }), !searchFlyoutArea && showSearchHistory && (/*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      lg: true,
      sm: false,
      md: true
    },
    colSpan: {
      lg: 10,
      sm: 12,
      md: 12
    },
    className: styles$1X.bottomNavigationFlyoutAreaSearchHistoryLayout
  }, /*#__PURE__*/createElement(CollectionList, {
    spacing: "none",
    role: "dialog",
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: joinClasses(styles$1X.bottomNavigationSearchHistoryCollection, showTrendingWords && trendingWordsLabel && styles$1X.bottomNavigationSearchHistoryCollectionItems)
  }, showTrendingWords && trendingWordsLabel && (/*#__PURE__*/createElement(Title, {
    variant: "standard",
    element: "h5"
  }, trendingWordsLabel)), showTrendingWords && trendingWords, getSearchHistoryTitle(searchHistoryLabel, iconBrand), searchHistoryItems && searchHistoryItems.length > 0 ? searchHistoryItems : (/*#__PURE__*/createElement("div", {
    className: styles$1X.bottomNavigationNoSearchHistorySection
  }, noSearchHistorySection ? noSearchHistorySection : (/*#__PURE__*/createElement(Body, {
    variant: "standard",
    element: "p"
  }, "If there is a search history, it will be displayed here.")))))))))), /*#__PURE__*/createElement(Element, {
    ref: bottomRef,
    className: joinClasses(styles$1X.bottomNavigation, smartBannerSection && styles$1X.bottomNavigationWithSmartBanner, variant === 'search' ? styles$1X.bottomNavigationContainerSearch : styles$1X.bottomNavigationContainerDefault, variant === 'membership' && styles$1X.bottomNavigationContainerMembership, showSearchHistory && styles$1X.bottomNavigationFlyoutOpen),
    onClick: function onClick(e) {
      return handleClick(e);
    }
  }, variant === 'search' && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: joinClasses(variant === 'search' && styles$1X.bottomNavigationBg)
  }), /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      sm: !toggleArrow,
      md: !toggleArrow,
      lg: true
    },
    className: joinClasses(styles$1X.bottomNavigationLayoutWrapper, toggleArrow && styles$1X.bottomNavigationLayoutWrapperWithoutIcon)
  }, displayToggleArrow && (/*#__PURE__*/createElement("div", {
    className: joinClasses(!toggleArrow ? styles$1X.bottomNavigationToggleArrowRemove : styles$1X.bottomNavigationToggleArrowAdd),
    onAnimationEnd: onArrowAnimationEnd
  }, /*#__PURE__*/createElement(ButtonIcon, {
    icon: "chevron-left",
    label: "",
    element: "button",
    onClick: function onClick(event) {
      setToggleArrow(!toggleArrow);
      setIsTouched(false);
      if (onArrowClick) {
        onArrowClick(event);
      }
    }
  }))), /*#__PURE__*/createElement("div", {
    className: styles$1X.bottomNavigationSearchWrapper
  }, searchArea), displayIcons && secondaryOptionsIcon && (secondaryOptionsIcon === null || secondaryOptionsIcon === void 0 ? void 0 : secondaryOptionsIcon.length) > 0 && iqChatBotArea && (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1X.bottomNavigationIqContainer
    // toggleArrow && styles.bottomNavigationIqContainerFadeOut
    )
  }, iqChatBotArea && /*#__PURE__*/createElement("div", {
    className: styles$1X.bottomNavigationIqArea
  }, iqChatBotArea), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1X.bottomNavigationIqContainerButtons, toggleArrow && styles$1X.bottomNavigationIqContainerFadeOut),
    onAnimationEnd: onAnimationEnd
  }, secondaryOptionsIcon && secondaryOptionsIcon.map(function (item, index) {
    return /*#__PURE__*/createElement("button", {
      className: styles$1X.bottomNavigationIqButton,
      key: index,
      onClick: function onClick(e) {
        var _a;
        return item && secondaryOptionsCallback && secondaryOptionsCallback[index] && ((_a = secondaryOptionsCallback[index]) === null || _a === void 0 ? void 0 : _a.call(secondaryOptionsCallback, e));
      },
      "aria-hidden": true,
      tabIndex: -1
    }, item);
  })))))))), variant === 'membership' ? (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1X.bottomNavigationWrapper, styles$1X.bottomNavigationWrapperMembership)
  }, /*#__PURE__*/createElement(Button, {
    element: 'button',
    isSmall: false,
    className: styles$1X.bottomNavigationButtonMembership,
    onClick: function onClick(e) {
      var _a;
      return primaryOptionsCallback && primaryOptionsCallback[1] && ((_a = primaryOptionsCallback[1]) === null || _a === void 0 ? void 0 : _a.call(primaryOptionsCallback, e));
    }
  }, /*#__PURE__*/createElement(Fragment, null, primaryOptionsIcon && primaryOptionsIcon[1], primaryOptionsLabel === null || primaryOptionsLabel === void 0 ? void 0 : primaryOptionsLabel[1])))) : showPrimaryIcons && !isKeyboardOpenState && (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1X.bottomNavigationWrapper, variant === 'default' && styles$1X.bottomNavigationWrapperDefault)
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1X.bottomNavigationContainer, variant === 'default' && styles$1X.bottomNavigationIconContainerDefault)
  }, primaryOptionsIcon && primaryOptionsIcon.map(function (item, index) {
    var isCenterIcon = index === 1;
    return primaryOptionsBalloonTip && primaryOptionsBalloonTip[index] !== null ? (/*#__PURE__*/createElement(BalloonTipContainer, {
      ref: balloonRef
    }, /*#__PURE__*/cloneElement(primaryOptionsBalloonTip[index], {
      top: -ballonHeight
    }), /*#__PURE__*/createElement("button", {
      key: "".concat(index, "icon"),
      className: joinClasses(item ? styles$1X.bottomNavigationIconWrapper : '', isCenterIcon && styles$1X.bottomNavigationIconWrapperCenter),
      onClick: function onClick(e) {
        var _a;
        return item && primaryOptionsCallback && primaryOptionsCallback[index] && ((_a = primaryOptionsCallback[index]) === null || _a === void 0 ? void 0 : _a.call(primaryOptionsCallback, e));
      },
      "aria-label": primaryOptionsAriaLabel ? primaryOptionsAriaLabel[index] : ''
    }, item || /*#__PURE__*/createElement("div", {
      className: styles$1X.bottomNavigationIcon
    })))) : (/*#__PURE__*/createElement("button", {
      key: "".concat(index, "icon"),
      className: joinClasses(item ? styles$1X.bottomNavigationIconWrapper : '', isCenterIcon && styles$1X.bottomNavigationIconWrapperCenter),
      onClick: function onClick(e) {
        var _a;
        return item && primaryOptionsCallback && primaryOptionsCallback[index] && ((_a = primaryOptionsCallback[index]) === null || _a === void 0 ? void 0 : _a.call(primaryOptionsCallback, e));
      },
      "aria-label": primaryOptionsAriaLabel ? primaryOptionsAriaLabel[index] : ''
    }, item || /*#__PURE__*/createElement("div", {
      className: styles$1X.bottomNavigationIcon
    })));
  })))), !isKeyboardOpenState && smartBannerSection), displayFlyout && keyboardViewCheck && isMobileDevice && (/*#__PURE__*/createElement("div", {
    ref: searchWrapperRef,
    className: joinClasses(styles$1X.bottomNavigationFlyoutArea, searchFlyoutArea || showSearchHistory ? '' : styles$1X.bottomNavigationFlyoutAreaClose),
    style: {
      paddingBottom: "".concat(bottomVal + 12, "px"),
      top: "".concat(searchWrapperHeight, "px")
    }
  }, searchFlyoutArea && Children.map(searchFlyoutArea, function (item, i) {
    return /*#__PURE__*/cloneElement(item, {
      onTouchStart: onTouchStart
    });
  }), !searchFlyoutArea && showSearchHistory && (/*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      lg: true,
      sm: false,
      md: true
    },
    colSpan: {
      lg: 10,
      sm: 12,
      md: 12
    },
    className: styles$1X.bottomNavigationFlyoutAreaSearchHistoryLayout
  }, /*#__PURE__*/createElement(CollectionList, {
    spacing: "none",
    role: "dialog",
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: joinClasses(styles$1X.bottomNavigationSearchHistoryCollection, showTrendingWords && trendingWordsLabel && styles$1X.bottomNavigationSearchHistoryCollectionItems)
  }, showTrendingWords && trendingWordsLabel && (/*#__PURE__*/createElement(Title, {
    variant: "standard",
    element: "h5"
  }, trendingWordsLabel)), showTrendingWords && trendingWords, getSearchHistoryTitle(searchHistoryLabel, iconBrand), searchHistoryItems && searchHistoryItems.length > 0 ? searchHistoryItems : (/*#__PURE__*/createElement("div", {
    className: styles$1X.bottomNavigationNoSearchHistorySection
  }, noSearchHistorySection ? noSearchHistorySection : (/*#__PURE__*/createElement(Body, {
    variant: "standard",
    element: "p"
  }, "If there is a search history, it will be displayed here.")))))))))));
};
BottomNavigation.displayName = 'BottomNavigation';

var styles$1Y = {"product-table":"fr-ec-product-table","productTable":"fr-ec-product-table","comparison-table":"fr-ec-comparison-table","comparisonTable":"fr-ec-comparison-table","product-table-current-product":"fr-ec-product-table-current-product","productTableCurrentProduct":"fr-ec-product-table-current-product","product-table-similar-product":"fr-ec-product-table-similar-product","productTableSimilarProduct":"fr-ec-product-table-similar-product","carousel-slide":"fr-ec-carousel-slide","carouselSlide":"fr-ec-carousel-slide","product-tile-resize-wrapper":"fr-ec-product-tile-resize-wrapper","productTileResizeWrapper":"fr-ec-product-tile-resize-wrapper","title":"fr-ec-title","product-tile__product-info":"fr-ec-product-tile__product-info","productTileProductInfo":"fr-ec-product-tile__product-info","product-tile__product-info--ec-renewal":"fr-ec-product-tile__product-info--ec-renewal","productTileProductInfoEcRenewal":"fr-ec-product-tile__product-info--ec-renewal","product-tile__end":"fr-ec-product-tile__end","productTileEnd":"fr-ec-product-tile__end","product-tile__end--padding-vertical-small":"fr-ec-product-tile__end--padding-vertical-small","productTileEndPaddingVerticalSmall":"fr-ec-product-tile__end--padding-vertical-small","data-table":"fr-ec-data-table","dataTable":"fr-ec-data-table","carousel":"fr-ec-carousel","carousel__scrollbar-hide":"fr-ec-carousel__scrollbar-hide","carouselScrollbarHide":"fr-ec-carousel__scrollbar-hide","carousel__container":"fr-ec-carousel__container","carouselContainer":"fr-ec-carousel__container","carousel__frame":"fr-ec-carousel__frame","carouselFrame":"fr-ec-carousel__frame","carousel-slide__container":"fr-ec-carousel-slide__container","carouselSlideContainer":"fr-ec-carousel-slide__container","comparison-table-heading":"fr-ec-comparison-table-heading","comparisonTableHeading":"fr-ec-comparison-table-heading","comparison-table-content":"fr-ec-comparison-table-content","comparisonTableContent":"fr-ec-comparison-table-content","caption":"fr-ec-caption","product-table-similar-product--no-overflow":"fr-ec-product-table-similar-product--no-overflow","productTableSimilarProductNoOverflow":"fr-ec-product-table-similar-product--no-overflow","content-alignment--direction-column":"fr-ec-content-alignment--direction-column","contentAlignmentDirectionColumn":"fr-ec-content-alignment--direction-column","product-table--no-border":"fr-ec-product-table--no-border","productTableNoBorder":"fr-ec-product-table--no-border","product-table-inner-container":"fr-ec-product-table-inner-container","productTableInnerContainer":"fr-ec-product-table-inner-container","product-table-ec-renewal":"fr-ec-product-table-ec-renewal","productTableEcRenewal":"fr-ec-product-table-ec-renewal"};

var ProductTable = function ProductTable(_a) {
  var _b = _a.currentProductLabel,
    currentProductLabel = _b === void 0 ? 'The product you are viewing' : _b,
    _c = _a.similarProductsLabel,
    similarProductsLabel = _c === void 0 ? 'Similar products' : _c,
    currentProductDetails = _a.currentProductDetails,
    similarProductsCarousel = _a.similarProductsCarousel,
    _d = _a.ecRenewal,
    ecRenewal = _d === void 0 ? false : _d,
    _f = _a.arrowPositionSelector,
    arrowPositionSelector = _f === void 0 ? '.fr-ec-image' : _f;
  var displayCount = {
    lg: 3,
    md: 3.6,
    sm: 1.5
  };
  var _g = useState(getCurrentMediaQueryBreakpoint()),
    screenSize = _g[0],
    setScreenSize = _g[1];
  var _h = useState(0),
    productWidth = _h[0],
    setProductWidth = _h[1];
  var onResize = function onResize(contentRect) {
    setScreenSize(getCurrentMediaQueryBreakpoint());
    if (contentRect.bounds) {
      var containerWidth = contentRect.bounds.width;
      var itemWidth = containerWidth / (displayCount[screenSize] + 1);
      if (itemWidth) {
        setProductWidth(itemWidth);
      }
    }
  };
  var carouselDefaultProps = __assign$1({
    arrowPositionSelector: arrowPositionSelector,
    displayCount: displayCount[screenSize],
    indicator: 'none',
    noPadding: true
  }, screenSize === 'md' && {
    hasArrows: false
  });
  var similarProductsArray = React__default.Children.toArray(similarProductsCarousel);
  var similarProductsChild = /*#__PURE__*/React__default.isValidElement(similarProductsArray[0]) ? similarProductsArray[0].props.children : [];
  var similarProductsWithoutCarousel = React__default.Children.map(similarProductsChild, function (item) {
    return /*#__PURE__*/React__default.createElement(ContentAlignment, {
      element: 'div',
      direction: 'column'
    }, item);
  });
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: onResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$1Y.productTable, ecRenewal && styles$1Y.productTableEcRenewal, similarProductsChild.length < displayCount[screenSize] && styles$1Y.productTableNoBorder),
      ref: measureRef
    }, /*#__PURE__*/React__default.createElement(ContentAlignment, __assign$1({
      element: 'div',
      direction: 'column'
    }, similarProductsChild.length < displayCount[screenSize] && {
      className: styles$1Y.productTableInnerContainer
    }), !ecRenewal && (/*#__PURE__*/React__default.createElement(ContentAlignment, {
      element: 'div',
      direction: 'row'
    }, currentProductLabel && (/*#__PURE__*/React__default.createElement(Title, {
      className: styles$1Y.productTableCurrentProduct,
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? "calc(".concat(100 / (displayCount[screenSize] + 1), "% + 1px)") : "".concat(productWidth, "px")
      },
      element: 'h1'
    }, currentProductLabel)), similarProductsLabel && (/*#__PURE__*/React__default.createElement(Title, {
      className: styles$1Y.productTableSimilarProduct,
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? "calc(".concat(100 - 100 / (displayCount[screenSize] + 1), "% - 1px)") : "".concat(similarProductsChild.length * productWidth, "px")
      },
      element: 'h1'
    }, similarProductsLabel)))), /*#__PURE__*/React__default.createElement(ContentAlignment, {
      element: 'div',
      direction: 'row'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$1Y.productTableCurrentProduct,
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? "calc(".concat(100 / (displayCount[screenSize] + 1), "% + 1px)") : "".concat(productWidth, "px")
      }
    }, currentProductDetails), /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$1Y.productTableSimilarProduct, similarProductsChild.length <= displayCount[screenSize] && styles$1Y.productTableSimilarProductNoOverflow),
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? "calc(".concat(100 - 100 / (displayCount[screenSize] + 1), "% - 1px)") : "".concat(similarProductsChild.length * productWidth, "px")
      }
    }, similarProductsChild.length > displayCount[screenSize] ? /*#__PURE__*/React__default.cloneElement(similarProductsCarousel, __assign$1({}, carouselDefaultProps)) : similarProductsWithoutCarousel))));
  });
};
ProductTable.displayName = 'CoreProductTable';

var styles$1Z = {"button-toggle-group":"fr-ec-button-toggle-group","buttonToggleGroup":"fr-ec-button-toggle-group","button-toggle-group-single-column":"fr-ec-button-toggle-group-single-column","buttonToggleGroupSingleColumn":"fr-ec-button-toggle-group-single-column","button-toggle--with-icon":"fr-ec-button-toggle--with-icon","buttonToggleWithIcon":"fr-ec-button-toggle--with-icon","button-toggle--label-with-icon-icon":"fr-ec-button-toggle--label-with-icon-icon","buttonToggleLabelWithIconIcon":"fr-ec-button-toggle--label-with-icon-icon"};

var ButtonToggleGroup = function ButtonToggleGroup(_a) {
  var children = _a.children,
    columnCount = _a.columnCount,
    keyLines = _a.keyLines,
    props = __rest$1(_a, ["children", "columnCount", "keyLines"]);
  var arrayChildren = Children.toArray(children);
  return /*#__PURE__*/createElement("div", __assign$1({}, props, {
    className: columnCount === 1 ? styles$1Z.buttonToggleGroupSingleColumn : styles$1Z.buttonToggleGroup
  }), Children.map(arrayChildren, function (child, i) {
    return /*#__PURE__*/createElement("div", null, keyLines === true ? i === 0 || (columnCount === 2 ? i === 1 : i === 0) ? /*#__PURE__*/createElement(Keyline, null) : '' : '', child, keyLines === true ? /*#__PURE__*/createElement(Keyline, null) : '');
  }));
};
ButtonToggleGroup.displayName = 'CoreButtonToggleGroup';
ButtonToggleGroup.defaultProps = {
  columnCount: 2,
  keyLines: true
};

var styles$1_ = {"typeahead-group":"fr-ec-typeahead-group","typeaheadGroup":"fr-ec-typeahead-group","typeahead-group__tab":"fr-ec-typeahead-group__tab","typeaheadGroupTab":"fr-ec-typeahead-group__tab","tab--is-active":"fr-ec-tab--is-active","tabIsActive":"fr-ec-tab--is-active","typeahead-group__tab-group":"fr-ec-typeahead-group__tab-group","typeaheadGroupTabGroup":"fr-ec-typeahead-group__tab-group","typeahead-group__sections":"fr-ec-typeahead-group__sections","typeaheadGroupSections":"fr-ec-typeahead-group__sections","typeahead-group__typeahead":"fr-ec-typeahead-group__typeahead","typeaheadGroupTypeahead":"fr-ec-typeahead-group__typeahead","typeahead-group__all-section":"fr-ec-typeahead-group__all-section","typeaheadGroupAllSection":"fr-ec-typeahead-group__all-section"};

var TypeaheadGroup = function TypeaheadGroup(_a) {
  var className = _a.className,
    _b = _a.allLabel,
    allLabel = _b === void 0 ? 'All' : _b,
    typeaheads = _a.typeaheads,
    _c = _a.sections,
    sections = _c === void 0 ? [] : _c,
    sectionTypeaheads = _a.sectionTypeaheads,
    typeaheadsCount = _a.typeaheadsCount,
    allTabSectionsCount = _a.allTabSectionsCount,
    gaAction = _a.gaAction,
    gaCallback = _a.gaCallback,
    gaCategory = _a.gaCategory,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    allTabOnClick = _a.allTabOnClick,
    sectionTabsOnClick = _a.sectionTabsOnClick,
    iconBrand = _a.iconBrand,
    _d = _a.variant,
    variant = _d === void 0 ? "default" : _d;
  var tabLabelArray = __spreadArray([allLabel], sections, true);
  var sectionsLength = sections.length;
  var allTabSectionsCountArray = [];
  var renewalVariant = variant === "ec-renewal";
  for (var i = 0; i < sectionsLength; i++) {
    allTabSectionsCountArray.push(5);
  }
  var tabs = sections && sections.map(function (section, index) {
    return /*#__PURE__*/createElement(Tab, {
      label: section,
      key: section,
      gaAction: gaAction === null || gaAction === void 0 ? void 0 : gaAction[index + 1],
      gaCallback: gaCallback,
      gaLabel: gaLabel === null || gaLabel === void 0 ? void 0 : gaLabel[index + 1],
      gaValue: gaValue === null || gaValue === void 0 ? void 0 : gaValue[index + 1],
      gaCategory: gaCategory === null || gaCategory === void 0 ? void 0 : gaCategory[index + 1],
      onClick: sectionTabsOnClick === null || sectionTabsOnClick === void 0 ? void 0 : sectionTabsOnClick[index],
      className: renewalVariant ? styles$1_.typeaheadGroupTab : ""
    }, /*#__PURE__*/createElement("div", {
      className: styles$1_.typeaheadGroupTypeahead
    }, sectionTypeaheads && sectionTypeaheads[index].map(function (item) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(item, {
        activeTabName: tabLabelArray[index + 1]
      }));
    })));
  });
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1_.typeaheadGroup, className)
  }, /*#__PURE__*/createElement(TabGroup, {
    variant: "small",
    iconBrand: iconBrand,
    className: renewalVariant ? styles$1_.typeaheadGroupTabGroup : ""
  }, /*#__PURE__*/createElement(Tab, {
    label: allLabel,
    gaAction: gaAction === null || gaAction === void 0 ? void 0 : gaAction[0],
    gaCallback: gaCallback,
    gaLabel: gaLabel === null || gaLabel === void 0 ? void 0 : gaLabel[0],
    gaValue: gaValue === null || gaValue === void 0 ? void 0 : gaValue[0],
    gaCategory: gaCategory === null || gaCategory === void 0 ? void 0 : gaCategory[0],
    onClick: allTabOnClick,
    className: renewalVariant ? styles$1_.typeaheadGroupTab : ""
  }, /*#__PURE__*/createElement(Fragment, null, typeaheads && (/*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1_.typeaheadGroupAllSection, spacingStyles.mbSpacing05)
  }, typeaheads && typeaheads.slice(0, typeaheadsCount).map(function (item, index) {
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, /*#__PURE__*/cloneElement(item, {
      activeTabName: tabLabelArray[0]
    }));
  }))), sectionTypeaheads && sectionTypeaheads.map(function (/* tslint:disable */
  item, index) {
    var items = item.slice(0, allTabSectionsCount !== undefined ? allTabSectionsCount[index] : allTabSectionsCountArray[index]);
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, /*#__PURE__*/createElement(Title, {
      element: "h1",
      color: "primary-dark",
      className: styles$1_.typeaheadGroupSections
    }, sections[index]), /*#__PURE__*/createElement("div", {
      className: styles$1_.typeaheadGroupTypeahead
    }, items.map(function (item) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(item, {
        activeTabName: tabLabelArray[0]
      }));
    })));
  }))), tabs));
};
TypeaheadGroup.displayName = 'CoreTypeaheadGroup';

var DataTableCellStyles = {"data-table-cell":"fr-ec-data-table-cell","dataTableCell":"fr-ec-data-table-cell","data-table-cell--image":"fr-ec-data-table-cell--image","dataTableCellImage":"fr-ec-data-table-cell--image","data-table-cell--tool-tip":"fr-ec-data-table-cell--tool-tip","dataTableCellToolTip":"fr-ec-data-table-cell--tool-tip","data-table-cell--button":"fr-ec-data-table-cell--button","dataTableCellButton":"fr-ec-data-table-cell--button","data-table-cell--text-align-start":"fr-ec-data-table-cell--text-align-start","dataTableCellTextAlignStart":"fr-ec-data-table-cell--text-align-start","data-table-cell--empty":"fr-ec-data-table-cell--empty","dataTableCellEmpty":"fr-ec-data-table-cell--empty","image-overlay":"fr-ec-image-overlay","imageOverlay":"fr-ec-image-overlay","image-overlay__content":"fr-ec-image-overlay__content","imageOverlayContent":"fr-ec-image-overlay__content","image-overlay__label":"fr-ec-image-overlay__label","imageOverlayLabel":"fr-ec-image-overlay__label","image--ratio-1x1":"fr-ec-image--ratio-1x1","imageRatio1X1":"fr-ec-image--ratio-1x1","data-table-cell--text-align-center":"fr-ec-data-table-cell--text-align-center","dataTableCellTextAlignCenter":"fr-ec-data-table-cell--text-align-center","data-table-cell--text-align-end":"fr-ec-data-table-cell--text-align-end","dataTableCellTextAlignEnd":"fr-ec-data-table-cell--text-align-end","data-table-cell--highlighted":"fr-ec-data-table-cell--highlighted","dataTableCellHighlighted":"fr-ec-data-table-cell--highlighted","data-table-cell--no-wrap":"fr-ec-data-table-cell--no-wrap","dataTableCellNoWrap":"fr-ec-data-table-cell--no-wrap","data-table-cell--multi-lines":"fr-ec-data-table-cell--multi-lines","dataTableCellMultiLines":"fr-ec-data-table-cell--multi-lines"};

var DataTableCell = function DataTableCell(_a) {
  var Element = _a.element,
    className = _a.className,
    _b = _a.alignment,
    alignment = _b === void 0 ? 'start' : _b,
    width = _a.width,
    props = __rest$1(_a, ["element", "className", "alignment", "width"]);
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign$1({
      className: joinClasses(DataTableCellStyles.dataTableCell, DataTableCellStyles["data-table-cell--text-align-".concat(alignment)], className),
      style: {
        width: width
      }
    }, props))
  );
};
DataTableCell.displayName = 'CoreDataTableCell';
DataTableCell.defaultProps = {
  alignment: 'start'
};

var DataTableRowStyles = {"data-table-row":"fr-ec-data-table-row","dataTableRow":"fr-ec-data-table-row","data-table-row--highlighted":"fr-ec-data-table-row--highlighted","dataTableRowHighlighted":"fr-ec-data-table-row--highlighted","data-table-row--heading":"fr-ec-data-table-row--heading","dataTableRowHeading":"fr-ec-data-table-row--heading","data-table-cell":"fr-ec-data-table-cell","dataTableCell":"fr-ec-data-table-cell"};

var DataTableRow = function DataTableRow(_a) {
  var className = _a.className,
    props = __rest$1(_a, ["className"]);
  return /*#__PURE__*/createElement("tr", __assign$1({
    className: joinClasses(DataTableRowStyles.dataTableRow, className)
  }, props));
};
DataTableRow.displayName = 'CoreDataTableRow';

var scrollbarStyles = {"data-table-scroll__container":"fr-ec-data-table-scroll__container","dataTableScrollContainer":"fr-ec-data-table-scroll__container","data-table-container":"fr-ec-data-table-container","dataTableContainer":"fr-ec-data-table-container","data-table":"fr-ec-data-table","dataTable":"fr-ec-data-table","data-table-scroll__scrollbar":"fr-ec-data-table-scroll__scrollbar","dataTableScrollScrollbar":"fr-ec-data-table-scroll__scrollbar","data-table-scroll__button":"fr-ec-data-table-scroll__button","dataTableScrollButton":"fr-ec-data-table-scroll__button","data-table-scroll__track-and-thumb":"fr-ec-data-table-scroll__track-and-thumb","dataTableScrollTrackAndThumb":"fr-ec-data-table-scroll__track-and-thumb","data-table-scroll__track":"fr-ec-data-table-scroll__track","dataTableScrollTrack":"fr-ec-data-table-scroll__track","data-table-scroll__thumb":"fr-ec-data-table-scroll__thumb","dataTableScrollThumb":"fr-ec-data-table-scroll__thumb","data-table-show-more":"fr-ec-data-table-show-more","dataTableShowMore":"fr-ec-data-table-show-more"};

var DataTableScrollContainer = function DataTableScrollContainer(_a) {
  var children = _a.children,
    className = _a.className,
    iconBrand = _a.iconBrand,
    showMore = _a.showMore,
    rows = _a.rows,
    props = __rest$1(_a, ["children", "className", "iconBrand", "showMore", "rows"]);
  var TRACK_WIDTH = 30;
  var SCROLL_JITTER = 1;
  var tableRef = useRef(null);
  var scrollContainerRef = useRef(null);
  var scrollTrackRef = useRef(null);
  var scrollThumbRef = useRef(null);
  var _b = useState(TRACK_WIDTH),
    thumbWidth = _b[0],
    setThumbWidth = _b[1];
  var _c = useState(null),
    scrollStartPosition = _c[0],
    setScrollStartPosition = _c[1];
  var _d = useState(0),
    initialScrollLeft = _d[0],
    setInitialScrollLeft = _d[1];
  var _e = useState(false),
    isDragging = _e[0],
    setIsDragging = _e[1];
  var _f = useState(null),
    isOverflowing = _f[0],
    setIsOverflowing = _f[1];
  var _g = useState(isTouchDevice('touchPoints')),
    isTouchDevices = _g[0],
    setTouchDevices = _g[1];
  var _h = useState('body'),
    touchElement = _h[0],
    setTouchElement = _h[1];
  var _j = useState(0),
    currentScrollLeft = _j[0],
    setCurrentScrollLeft = _j[1];
  var _k = useState(0),
    scrollDeltaX = _k[0],
    setScrollDeltaX = _k[1];
  var scrollTouchTimerRef = useRef(null);
  /**
   * Set states to show scroll arrows
   */
  var setScrollArrows = function setScrollArrows() {
    if (tableRef.current) {
      var _a = tableRef.current,
        tableScrollWidth = _a.scrollWidth,
        tableClientWidth = _a.clientWidth,
        scrollLeft = _a.scrollLeft;
      setScrollDeltaX(tableScrollWidth - tableClientWidth - scrollLeft);
      setCurrentScrollLeft(scrollLeft || 0);
    }
  };
  /**
   * Function to show and hide scroll, true will show the scroll
   */
  var toggleScroll = function toggleScroll(show, grab) {
    var isDragged = grab !== undefined ? grab : isDragging;
    if (scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current) {
      if (show || isDragged) {
        scrollContainerRef.current.style.opacity = '1';
        scrollContainerRef.current.style.transition = 'opacity 0.6s linear';
      } else {
        scrollContainerRef.current.style.opacity = '0';
      }
    }
  };
  var onTouchAndMouseDown = useCallback(function (e, touchEl) {
    var _a;
    e.stopPropagation();
    var touch = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0];
    // touch event related conditions
    if (touchEl) {
      clearTimeout(scrollTouchTimerRef.current);
      setTouchElement(touchEl);
      toggleScroll(true, true);
    }
    setScrollStartPosition(e.clientX || touch.clientX);
    if (tableRef.current) {
      setInitialScrollLeft(tableRef.current.scrollLeft);
    }
    setIsDragging(true);
  }, []);
  var onTouchAndMouseUp = useCallback(function (e) {
    var scrollContainerNode = scrollContainerRef.current;
    var tableNode = tableRef.current;
    setScrollArrows();
    if (isDragging) {
      if (!(scrollContainerNode && scrollContainerNode.contains(e.target)) && !(tableNode && tableNode.contains(e.target))) {
        toggleScroll(false, false);
      }
      setIsDragging(false);
    }
    if (e.type === 'touchend') {
      scrollTouchTimerRef.current = setTimeout(function () {
        return toggleScroll(false, false);
      }, 1000);
    }
  }, [isDragging]);
  var onMouseMove = useCallback(function (e) {
    if (isDragging) {
      var _a = tableRef.current,
        tableScrollWidth = _a.scrollWidth,
        tableOffsetWidth = _a.offsetWidth;
      var deltaX = (e.clientX - (scrollStartPosition || 0)) * (tableOffsetWidth / thumbWidth);
      var newScrollLeft = Math.min(initialScrollLeft + deltaX, tableScrollWidth - tableOffsetWidth);
      if (tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) {
        tableRef.current.scrollLeft = newScrollLeft;
      }
    }
  }, [isDragging, scrollStartPosition, thumbWidth]);
  var onTouchMove = useCallback(function (e) {
    var _a;
    var touch = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0];
    if (isDragging) {
      var _b = tableRef.current,
        tableScrollWidth = _b.scrollWidth,
        tableOffsetWidth = _b.offsetWidth;
      var deltaX = (touch.clientX - (scrollStartPosition || 0)) * (tableOffsetWidth / thumbWidth);
      var newScrollLeft = 0;
      if (touchElement === 'body') {
        newScrollLeft = -1 * (-1 * initialScrollLeft + deltaX);
      } else if (touchElement === 'thumb') {
        newScrollLeft = Math.min(initialScrollLeft + deltaX, tableScrollWidth - tableOffsetWidth);
      }
      if (tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) {
        tableRef.current.scrollLeft = newScrollLeft;
      }
    }
  }, [isDragging, scrollStartPosition, thumbWidth]);
  var onScreenResize = function onScreenResize() {
    setTouchDevices(isTouchDevice('userAgent'));
    if (tableRef.current) {
      var _a = tableRef.current,
        clientWidth = _a.clientWidth,
        scrollWidth = _a.scrollWidth;
      if (scrollTrackRef.current) {
        var trackSize = scrollTrackRef.current.clientWidth;
        setThumbWidth(Math.max(clientWidth / scrollWidth * trackSize, TRACK_WIDTH));
      }
      if (scrollWidth > clientWidth) {
        setIsOverflowing(true);
      } else {
        setIsOverflowing(false);
      }
    }
    setScrollArrows();
    toggleScroll(false);
  };
  var onScrollButtonClick = function onScrollButtonClick(direction) {
    var current = tableRef.current;
    if (current) {
      var scrollAmount = direction === 'right' ? TRACK_WIDTH : -1 * TRACK_WIDTH;
      current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  var onTrackClick = useCallback(function (e) {
    var _a;
    var touch = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0];
    e.preventDefault();
    e.stopPropagation();
    var trackElement = scrollTrackRef.current;
    var tableElement = tableRef.current;
    if (trackElement && tableElement) {
      var target = e.target;
      var rect = target.getBoundingClientRect();
      var trackLeft = rect.left;
      var thumbOffset = -(thumbWidth / 2);
      var clickRatio = ((e.clientX || touch.clientX) - trackLeft + thumbOffset) / trackElement.clientWidth;
      var scrollAmount = Math.floor(clickRatio * tableElement.scrollWidth);
      tableElement.scrollTo({
        behavior: 'smooth',
        left: scrollAmount
      });
    }
  }, [thumbWidth]);
  var setThumbPosition = useCallback(function () {
    if (!tableRef.current || !scrollTrackRef.current || !scrollThumbRef.current) {
      return;
    }
    var _a = tableRef.current,
      scrollLeft = _a.scrollLeft,
      scrollWidth = _a.scrollWidth;
    var clientWidth = scrollTrackRef.current.clientWidth;
    var newLeft = +scrollLeft / +scrollWidth * clientWidth;
    newLeft = Math.min(newLeft, clientWidth - thumbWidth);
    var thumb = scrollThumbRef.current;
    thumb.style.left = "".concat(newLeft, "px");
  }, []);
  useEffect(function () {
    return function () {
      return clearTimeout(scrollTouchTimerRef.current);
    };
  }, []);
  /**
   * Mouse click events
   */
  useEffect(function () {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onTouchAndMouseUp);
    document.addEventListener('mouseleave', onTouchAndMouseUp);
    return function () {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onTouchAndMouseUp);
      document.removeEventListener('mouseleave', onTouchAndMouseUp);
    };
  }, [onMouseMove, onTouchAndMouseUp]);
  /**
   * Touch events
   */
  useEffect(function () {
    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchcancel', onTouchAndMouseUp);
    document.addEventListener('touchend', onTouchAndMouseUp);
    return function () {
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchcancel', onTouchAndMouseUp);
      document.removeEventListener('touchend', onTouchAndMouseUp);
    };
  }, [onMouseMove, onTouchAndMouseUp]);
  useEffect(function () {
    onScreenResize();
  }, [rows]);
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: onScreenResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return isOverflowing || isOverflowing === null ? (/*#__PURE__*/React__default.createElement("div", {
      className: className
    }, /*#__PURE__*/React__default.createElement("div", __assign$1({
      className: scrollbarStyles.dataTableScrollContainer,
      onMouseOver: function onMouseOver() {
        return toggleScroll(true);
      },
      onMouseLeave: function onMouseLeave() {
        return toggleScroll(false);
      },
      onTouchStart: function onTouchStart(e) {
        return onTouchAndMouseDown(e, 'body');
      },
      role: "table",
      ref: measureRef
    }, props), /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableContainer,
      ref: tableRef,
      onScroll: setThumbPosition
    }, children), /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollScrollbar,
      ref: scrollContainerRef
    }, /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollTrackAndThumb
    }, /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollTrack,
      ref: scrollTrackRef,
      onClick: onTrackClick,
      style: {
        cursor: isDragging ? 'grabbing' : ''
      },
      role: "button"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollThumb,
      ref: scrollThumbRef,
      onMouseDown: onTouchAndMouseDown,
      onTouchStart: function onTouchStart(e) {
        return onTouchAndMouseDown(e, 'thumb');
      },
      style: {
        cursor: isDragging ? 'grabbing' : 'grab',
        width: "".concat(thumbWidth, "px")
      },
      role: "button"
    })), !isTouchDevices && (/*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
      element: "button",
      hideLabel: true,
      icon: "chevron-left",
      iconBrand: iconBrand,
      label: "left-arrow",
      className: scrollbarStyles.dataTableScrollButton,
      onClick: function onClick() {
        return onScrollButtonClick('left');
      },
      disabled: currentScrollLeft === 0
    }), /*#__PURE__*/React__default.createElement(ButtonIcon, {
      element: "button",
      hideLabel: true,
      icon: "chevron-right",
      iconBrand: iconBrand,
      label: "right-arrow",
      className: scrollbarStyles.dataTableScrollButton,
      onClick: function onClick() {
        return onScrollButtonClick('right');
      },
      disabled: scrollDeltaX <= SCROLL_JITTER
    }))))), showMore && (/*#__PURE__*/React__default.createElement(ContentAlignment, {
      direction: "column",
      element: 'div',
      alignment: "center",
      className: scrollbarStyles.dataTableShowMore
    }, showMore)))) : (/*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(scrollbarStyles.dataTableContainer, className),
      ref: tableRef
    }, showMore ? (/*#__PURE__*/React__default.createElement(ContentAlignment, {
      style: {
        width: 'fit-content'
      },
      direction: "column",
      element: 'div',
      alignment: "center"
    }, children, /*#__PURE__*/React__default.cloneElement(showMore, {
      className: joinClasses(showMore.props.className, scrollbarStyles.dataTableShowMore)
    }))) : children));
  });
};

var styles$1$ = {"media-object-layout":"fr-ec-media-object-layout","mediaObjectLayout":"fr-ec-media-object-layout","media-object-layout__media-object":"fr-ec-media-object-layout__media-object","mediaObjectLayoutMediaObject":"fr-ec-media-object-layout__media-object","media-object__media":"fr-ec-media-object__media","mediaObjectMedia":"fr-ec-media-object__media","media-object-layout__icon":"fr-ec-media-object-layout__icon","mediaObjectLayoutIcon":"fr-ec-media-object-layout__icon"};

var MediaObjectLayout = function MediaObjectLayout(_a) {
  var children = _a.children;
  var _b = useState(0),
    mediaHeight = _b[0],
    setMediaHeight = _b[1];
  var arrowIconHeight = 32;
  var getMediaHeight = function getMediaHeight() {
    var _a, _b;
    var imageHeight = isInBrowser() ? ((_a = document.querySelectorAll('.fr-ec-media-object-layout .fr-ec-image-overlay')[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().height) || ((_b = document.querySelectorAll('.fr-ec-media-object-layout .fr-ec-image')[0]) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().height) : 0;
    setMediaHeight(imageHeight);
  };
  useEffect(function () {
    getMediaHeight();
  }, [mediaHeight]);
  return /*#__PURE__*/createElement("div", {
    className: styles$1$.mediaObjectLayout
  }, Children.map(children, function (child, i) {
    if (i === 1) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("span", {
        style: {
          marginTop: "".concat((mediaHeight - arrowIconHeight) / 2, "px")
        }
      }, /*#__PURE__*/createElement(Icon, {
        name: "chevron-right",
        className: styles$1$.mediaObjectLayoutIcon
      })), /*#__PURE__*/cloneElement(child, {
        className: styles$1$.mediaObjectLayoutMediaObject,
        key: i
      }));
    }
    return /*#__PURE__*/cloneElement(child, {
      className: styles$1$.mediaObjectLayoutMediaObject,
      key: i
    });
  }));
};
MediaObjectLayout.displayName = 'MediaObjectLayout';

var styles$20 = {"template-login":"fr-ec-template-login","templateLogin":"fr-ec-template-login","footer":"fr-ec-footer","footer-not-fixed":"fr-ec-footer-not-fixed","footerNotFixed":"fr-ec-footer-not-fixed"};

var LayoutGutter$1 = function LayoutGutter(props) {
  return /*#__PURE__*/createElement(Layout, __assign$1({
    gutter: true
  }, props));
};
var TemplateLogin = function TemplateLogin(_a) {
  var mainContent = _a.mainContent,
    pageHeading = _a.pageHeading,
    subContent = _a.subContent,
    subHeading = _a.subHeading,
    className = _a.className,
    _b = _a.ecRenewal,
    ecRenewal = _b === void 0 ? false : _b,
    props = __rest$1(_a, ["mainContent", "pageHeading", "subContent", "subHeading", "className", "ecRenewal"]);
  var onResize = useCallback(function () {
    if (isInBrowser() && ecRenewal) {
      var templateLoginEl = document.getElementsByClassName(styles$20.templateLogin);
      var footerEl = document.getElementsByClassName('fr-ec-footer');
      if (templateLoginEl && templateLoginEl[0] && footerEl && footerEl[0]) {
        if (Math.round(templateLoginEl[0].getBoundingClientRect().bottom) + footerEl[0].clientHeight >= window.innerHeight) {
          footerEl[0].classList.add('fr-ec-footer-not-fixed');
        } else {
          footerEl[0].classList.remove('fr-ec-footer-not-fixed');
        }
      }
    }
  }, [ecRenewal]);
  var templateLoginRef = useRef(null);
  useEffect(function () {
    if (isInBrowser()) {
      onResize();
      window.addEventListener('resize', onResize);
    }
    var targetNode = templateLoginRef.current;
    var observer = new MutationObserver(function () {
      onResize();
    });
    if (targetNode) {
      observer.observe(targetNode, {
        childList: true,
        subtree: true
      });
    }
    return function () {
      if (isInBrowser()) {
        window.removeEventListener('resize', onResize);
      }
      observer.disconnect();
    };
  }, []);
  if (ecRenewal) {
    return /*#__PURE__*/createElement(LayoutWrapper, __assign$1({
      className: joinClasses(styles$20.templateLogin, className),
      element: "section",
      ref: templateLoginRef
    }, props), pageHeading && (/*#__PURE__*/createElement(Layout, {
      gutter: {
        sm: false,
        md: true,
        lg: true
      },
      visible: {
        sm: true,
        md: true,
        lg: true
      }
    }, pageHeading)), mainContent && (/*#__PURE__*/createElement(LayoutGutter$1, {
      element: "div",
      colSpan: {
        sm: 4,
        md: 12,
        lg: 0
      },
      visible: {
        sm: true,
        md: false,
        lg: false
      },
      gutter: {
        sm: true,
        md: true,
        lg: false
      }
    }, mainContent)), /*#__PURE__*/createElement(Layout, {
      element: "section"
    }, mainContent && (/*#__PURE__*/createElement(LayoutGutter$1, {
      element: "div",
      colSpan: {
        sm: 4,
        md: 12,
        lg: 5
      },
      visible: {
        sm: false,
        md: true,
        lg: true
      },
      inset: {
        right: false
      }
    }, mainContent)), subHeading && (/*#__PURE__*/createElement(Layout, {
      colSpan: {
        sm: 4,
        md: 12,
        lg: 6
      },
      visible: {
        sm: true,
        md: false,
        lg: false
      },
      gutter: {
        sm: false,
        md: true,
        lg: true
      }
    }, subHeading)), subContent && (/*#__PURE__*/createElement(Layout, {
      colSpan: {
        sm: 4,
        md: 12,
        lg: 6
      },
      visible: {
        sm: true,
        md: false,
        lg: false
      },
      gutter: {
        sm: true,
        md: true,
        lg: true
      }
    }, subContent)), /*#__PURE__*/createElement(LayoutGutter$1, {
      element: "section",
      colSpan: {
        sm: 4,
        md: 12,
        lg: 7
      },
      gutter: {
        sm: false,
        md: true,
        lg: true
      },
      visible: {
        sm: false,
        md: true,
        lg: true
      },
      inset: {
        left: {
          sm: false,
          md: false,
          lg: true
        }
      }
    }, /*#__PURE__*/createElement(Layout, {
      colSpan: {
        sm: 4,
        md: 12,
        lg: 6
      },
      visible: {
        sm: false,
        md: true,
        lg: false
      },
      gutter: false
    }, subHeading), /*#__PURE__*/createElement("div", null, subContent))));
  }
  return /*#__PURE__*/createElement(LayoutWrapper, __assign$1({
    className: className,
    element: "section",
    ref: templateLoginRef
  }, props), pageHeading && (/*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: false,
      lg: false
    },
    visible: {
      sm: true,
      md: false,
      lg: false
    }
  }, pageHeading)), mainContent && (/*#__PURE__*/createElement(LayoutGutter$1, {
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 0
    },
    visible: {
      sm: true,
      md: false,
      lg: false
    },
    gutter: {
      sm: true,
      md: true,
      lg: false
    }
  }, mainContent)), /*#__PURE__*/createElement(Layout, {
    element: "section"
  }, mainContent && (/*#__PURE__*/createElement(LayoutGutter$1, {
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 6
    },
    visible: {
      sm: false,
      md: true,
      lg: true
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, pageHeading, mainContent)), subHeading && (/*#__PURE__*/createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 6
    },
    visible: {
      sm: true,
      md: false,
      lg: false
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, subHeading)), subContent && (/*#__PURE__*/createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 6
    },
    visible: {
      sm: true,
      md: false,
      lg: false
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    }
  }, subContent)), /*#__PURE__*/createElement(LayoutGutter$1, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 6
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    visible: {
      sm: false,
      md: true,
      lg: true
    },
    inset: {
      left: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, subHeading, /*#__PURE__*/createElement("div", null, subContent))));
};
TemplateLogin.displayName = 'CoreTemplateLogin';
TemplateLogin.defaultProps = {
  toggleMinHeight: true
};

var styles$21 = {"image-plus-text":"fr-ec-image-plus-text","imagePlusText":"fr-ec-image-plus-text","image-plus-text--vertical":"fr-ec-image-plus-text--vertical","imagePlusTextVertical":"fr-ec-image-plus-text--vertical","image-plus-text--class-category-item":"fr-ec-image-plus-text--class-category-item","imagePlusTextClassCategoryItem":"fr-ec-image-plus-text--class-category-item","image-plus-text__media":"fr-ec-image-plus-text__media","imagePlusTextMedia":"fr-ec-image-plus-text__media","image-plus-text--line-up__media":"fr-ec-image-plus-text--line-up__media","imagePlusTextLineUpMedia":"fr-ec-image-plus-text--line-up__media","image-plus-text__title":"fr-ec-image-plus-text__title","imagePlusTextTitle":"fr-ec-image-plus-text__title","image-plus-text__wrapper":"fr-ec-image-plus-text__wrapper","imagePlusTextWrapper":"fr-ec-image-plus-text__wrapper","image-plus-text--horizontal-large__texts":"fr-ec-image-plus-text--horizontal-large__texts","imagePlusTextHorizontalLargeTexts":"fr-ec-image-plus-text--horizontal-large__texts","image-plus-text--horizontal-small__texts":"fr-ec-image-plus-text--horizontal-small__texts","imagePlusTextHorizontalSmallTexts":"fr-ec-image-plus-text--horizontal-small__texts","image-plus-text--horizontal-extra-small__texts":"fr-ec-image-plus-text--horizontal-extra-small__texts","imagePlusTextHorizontalExtraSmallTexts":"fr-ec-image-plus-text--horizontal-extra-small__texts","image-plus-text--horizontal-large__media":"fr-ec-image-plus-text--horizontal-large__media","imagePlusTextHorizontalLargeMedia":"fr-ec-image-plus-text--horizontal-large__media","image-plus-text--horizontal-large__title":"fr-ec-image-plus-text--horizontal-large__title","imagePlusTextHorizontalLargeTitle":"fr-ec-image-plus-text--horizontal-large__title","image-plus-text--horizontal-large__description":"fr-ec-image-plus-text--horizontal-large__description","imagePlusTextHorizontalLargeDescription":"fr-ec-image-plus-text--horizontal-large__description","image-plus-text--horizontal-small__media":"fr-ec-image-plus-text--horizontal-small__media","imagePlusTextHorizontalSmallMedia":"fr-ec-image-plus-text--horizontal-small__media","image-plus-text--horizontal-small__title":"fr-ec-image-plus-text--horizontal-small__title","imagePlusTextHorizontalSmallTitle":"fr-ec-image-plus-text--horizontal-small__title","image-plus-text--horizontal-small__description":"fr-ec-image-plus-text--horizontal-small__description","imagePlusTextHorizontalSmallDescription":"fr-ec-image-plus-text--horizontal-small__description","image-plus-text--horizontal-extra-small__media":"fr-ec-image-plus-text--horizontal-extra-small__media","imagePlusTextHorizontalExtraSmallMedia":"fr-ec-image-plus-text--horizontal-extra-small__media","image-plus-text--horizontal-extra-small__title":"fr-ec-image-plus-text--horizontal-extra-small__title","imagePlusTextHorizontalExtraSmallTitle":"fr-ec-image-plus-text--horizontal-extra-small__title","image-plus-text--image-position-right":"fr-ec-image-plus-text--image-position-right","imagePlusTextImagePositionRight":"fr-ec-image-plus-text--image-position-right","image-plus-text__class-item-title":"fr-ec-image-plus-text__class-item-title","imagePlusTextClassItemTitle":"fr-ec-image-plus-text__class-item-title"};

var testId$4 = {
  'data-testid': 'CoreImagePlusText'
};
var ImagePlusText = function ImagePlusText(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'carouselGrid' : _b,
    media = _a.media,
    _c = _a.title,
    title = _c === void 0 ? '' : _c,
    description = _a.description,
    className = _a.className,
    linkText = _a.linkText,
    caption = _a.caption,
    flag = _a.flag,
    _d = _a.imagePosition,
    imagePosition = _d === void 0 ? 'left' : _d,
    children = _a.children,
    props = __rest$1(_a, ["variant", "media", "title", "description", "className", "linkText", "caption", "flag", "imagePosition", "children"]);
  var renderComponent = function renderComponent() {
    if (variant === 'classCategoryItem') {
      return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        direction: "row",
        element: "div",
        alignment: "center",
        className: joinClasses(className, styles$21.imagePlusText, styles$21.imagePlusTextClassCategoryItem)
      }, props, testId$4), /*#__PURE__*/createElement("div", {
        className: styles$21.imagePlusTextMedia
      }, media), title && (/*#__PURE__*/createElement("div", {
        className: joinClasses(typographyStyles.classItem, styles$21.imagePlusTextClassItemTitle)
      }, title)), children);
    }
    if (variant === 'lineup') {
      return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        direction: "column",
        element: "div",
        className: joinClasses(className, styles$21.imagePlusText)
      }, props), /*#__PURE__*/createElement("div", {
        className: styles$21.imagePlusTextLineUpMedia
      }, media), title && (/*#__PURE__*/createElement(Caption, {
        variant: "standard",
        element: "span",
        wordBreak: "break-word",
        className: styles$21.imagePlusTextTitle
      }, title)), children);
    }
    if (variant === 'horizontalLarge') {
      return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        direction: "row",
        element: "div",
        className: joinClasses(className, styles$21.imagePlusText, imagePosition == 'right' ? styles$21.imagePlusTextImagePositionRight : '')
      }, props, testId$4), /*#__PURE__*/createElement("div", {
        className: styles$21.imagePlusTextHorizontalLargeMedia
      }, media), /*#__PURE__*/createElement(ContentAlignment, {
        direction: "column",
        element: "div",
        className: styles$21.imagePlusTextHorizontalLargeTexts
      }, title && (/*#__PURE__*/createElement(Title, {
        className: styles$21.imagePlusTextHorizontalLargeTitle,
        variant: "large",
        element: "span",
        wordBreak: "break-word"
      }, title)), description && (/*#__PURE__*/createElement(Body, {
        className: styles$21.imagePlusTextHorizontalLargeDescription,
        variant: "small",
        element: "span",
        wordBreak: "break-word"
      }, description)), linkText, children));
    }
    if (variant === 'horizontalSmall') {
      return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        direction: "row",
        element: "div",
        className: joinClasses(className, styles$21.imagePlusText, imagePosition == 'right' ? styles$21.imagePlusTextImagePositionRight : '')
      }, props, testId$4), /*#__PURE__*/createElement("div", {
        className: styles$21.imagePlusTextHorizontalSmallMedia
      }, media), /*#__PURE__*/createElement(ContentAlignment, {
        direction: "column",
        element: "div",
        className: styles$21.imagePlusTextHorizontalSmallTexts
      }, title && (/*#__PURE__*/createElement(Title, {
        className: styles$21.imagePlusTextHorizontalSmallTitle,
        variant: "large",
        element: "span",
        wordBreak: "break-word"
      }, title)), description && (/*#__PURE__*/createElement(Body, {
        className: styles$21.imagePlusTextHorizontalSmallDescription,
        variant: "small",
        element: "span",
        wordBreak: "break-word"
      }, description)), /*#__PURE__*/createElement(ContentAlignment, {
        direction: "row",
        element: "div",
        gap: 8
      }, caption && (/*#__PURE__*/createElement(Caption, {
        variant: "extra-small",
        element: "div",
        wordBreak: "break-word"
      }, caption)), flag && (/*#__PURE__*/createElement(FlagText, {
        element: "p",
        variant: "standard",
        color: "promotional"
      }, flag))), children));
    }
    if (variant === 'horizontalExtraSmall') {
      return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        direction: "row",
        element: "div",
        className: joinClasses(className, styles$21.imagePlusText, imagePosition == 'right' ? styles$21.imagePlusTextImagePositionRight : '')
      }, props, testId$4), /*#__PURE__*/createElement("div", {
        className: styles$21.imagePlusTextHorizontalExtraSmallMedia
      }, media), /*#__PURE__*/createElement(ContentAlignment, {
        direction: "column",
        element: "div",
        className: styles$21.imagePlusTextHorizontalExtraSmallTexts
      }, title && (/*#__PURE__*/createElement(Title, {
        className: styles$21.imagePlusTextHorizontalExtraSmallTitle,
        variant: "large",
        element: "span",
        wordBreak: "break-word"
      }, title)), description && (/*#__PURE__*/createElement(Body, {
        variant: "small",
        element: "span",
        wordBreak: "break-word"
      }, description)), children));
    }
    if (variant === 'vertical') {
      return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        direction: "column",
        element: "div",
        className: joinClasses(className, styles$21.imagePlusText, styles$21.imagePlusTextVertical)
      }, props, testId$4), media, title && (/*#__PURE__*/createElement(Body, {
        variant: "standard",
        textAlign: "center",
        wordBreak: "break-word",
        className: spacingStyles.mtSpacing04
      }, title)), description && (/*#__PURE__*/createElement(Body, {
        variant: "standard",
        textAlign: "center",
        wordBreak: "break-word",
        className: spacingStyles.mtSpacing02
      }, description)), caption && (/*#__PURE__*/createElement(Caption, {
        variant: "small",
        color: "secondary",
        textAlign: "center",
        wordBreak: "break-word",
        className: spacingStyles.mtSpacing02
      }, caption)));
    }
    return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
      direction: "column",
      element: "div",
      className: joinClasses(className, styles$21.imagePlusText)
    }, props, testId$4), media, /*#__PURE__*/createElement("div", {
      className: styles$21.imagePlusTextWrapper
    }, title && (/*#__PURE__*/createElement(Title, {
      variant: "small",
      element: "div",
      wordBreak: "break-word",
      className: spacingStyles.mtSpacing03
    }, title)), description && (/*#__PURE__*/createElement(Caption, {
      variant: "small",
      color: "secondary",
      element: "div",
      wordBreak: "break-word",
      className: spacingStyles.mtSpacing01
    }, description)), children));
  };
  return /*#__PURE__*/createElement(Fragment, null, renderComponent());
};
ImagePlusText.displayName = 'CoreImagePlusText';

var ScrollDirectionContext = /*#__PURE__*/createContext(undefined);

var styles$22 = {"no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","no-image__video":"fr-ec-no-image__video","noImageVideo":"fr-ec-no-image__video","no-image__icon":"fr-ec-no-image__icon","noImageIcon":"fr-ec-no-image__icon","no-image__icon--video":"fr-ec-no-image__icon--video","noImageIconVideo":"fr-ec-no-image__icon--video","no-image__label":"fr-ec-no-image__label","noImageLabel":"fr-ec-no-image__label","no-image__label--label-only":"fr-ec-no-image__label--label-only","noImageLabelLabelOnly":"fr-ec-no-image__label--label-only","no-image__label--large":"fr-ec-no-image__label--large","noImageLabelLarge":"fr-ec-no-image__label--large","no-image__video-label":"fr-ec-no-image__video-label","noImageVideoLabel":"fr-ec-no-image__video-label","no-image__video-subtitle":"fr-ec-no-image__video-subtitle","noImageVideoSubtitle":"fr-ec-no-image__video-subtitle","no-image__icon--user":"fr-ec-no-image__icon--user","noImageIconUser":"fr-ec-no-image__icon--user"};

var NoImage = function NoImage(_a) {
  var _b = _a.imageType,
    imageType = _b === void 0 ? 'normal' : _b,
    _c = _a.noImageLabel,
    noImageLabel = _c === void 0 ? '' : _c,
    className = _a.className,
    _d = _a.imageSize,
    imageSize = _d === void 0 ? 'default' : _d,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["imageType", "noImageLabel", "className", "imageSize", "iconBrand"]);
  var noImageWrappeRef = useRef(null);
  var _e = useState(0),
    width = _e[0],
    setWidth = _e[1];
  useEffect(function () {
    if (noImageWrappeRef.current) {
      setWidth(noImageWrappeRef.current.offsetWidth);
    }
  }, []);
  var getTextSize = function getTextSize() {
    var textSize = width * 18 / 250;
    return textSize;
  };
  var noImageLabelStyle = getTextSize() !== 0 ? {
    fontSize: "".concat(getTextSize(), "px")
  } : {};
  var breakPoint = getViewportWidth() > 600 ? 'largeAndMedium' : 'small';
  var getSize = {
    "default": '28%',
    euro: '13px',
    large: '20%',
    small: '48%',
    smallest: '56%'
  };
  var getIcons = function getIcons(imageTypes) {
    var iconName = {
      euro: 'euro',
      icon: 'prohibited',
      product: 'product'
    };
    return iconBrand ? "".concat(iconBrand).concat(iconName[imageTypes]) : "".concat(iconName[imageTypes]);
  };
  switch (imageType) {
    case 'normal':
      return /*#__PURE__*/createElement("div", __assign$1({
        className: joinClasses(styles$22.noImage, className)
      }, props));
    case 'labelonly':
      return /*#__PURE__*/createElement("div", {
        ref: noImageWrappeRef
      }, /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        element: "div",
        justifyContent: "center",
        direction: "row",
        alignment: "center",
        className: joinClasses(styles$22.noImage, className)
      }, props), (imageSize === 'large' || imageSize === 'default') && noImageLabel && (breakPoint === 'largeAndMedium' ? (/*#__PURE__*/createElement(FlagText, {
        className: joinClasses(styles$22.noImageLabelLabelOnly),
        variant: "large",
        element: "p",
        textAlign: "center",
        style: noImageLabelStyle
      }, noImageLabel)) : (/*#__PURE__*/createElement(FlagText, {
        className: joinClasses(styles$22.noImageLabelLabelOnly),
        variant: "standard",
        element: "p",
        textAlign: "center",
        style: noImageLabelStyle
      }, noImageLabel)))));
    case 'video':
      {
        return /*#__PURE__*/createElement("div", {
          ref: noImageWrappeRef
        }, /*#__PURE__*/createElement(ContentAlignment, __assign$1({
          element: "div",
          justifyContent: "center",
          direction: "column",
          alignment: "center",
          className: joinClasses(styles$22.noImageVideo, className)
        }, props), /*#__PURE__*/createElement(Icon, {
          name: iconBrand ? "".concat(iconBrand, "no-video") : 'no-video',
          className: joinClasses(styles$22.noImageIcon, styles$22.noImageIconVideo),
          size: getSize["default"]
        }), noImageLabel && typeof noImageLabel === 'string' && (/*#__PURE__*/createElement(Body, {
          element: "p",
          className: joinClasses(styles$22.noImageLabel, styles$22.noImageLabelLarge),
          style: noImageLabelStyle
        }, noImageLabel)), _typeof(noImageLabel) === 'object' && (/*#__PURE__*/createElement(Fragment, null, noImageLabel.text_error_failed_to_get_pdp_movie && (/*#__PURE__*/createElement("div", {
          className: styles$22.noImageVideoLabel,
          style: noImageLabelStyle
        }, noImageLabel.text_error_failed_to_get_pdp_movie)), noImageLabel.text_error_failed_to_get_pdp_movie_instruction_01 && (/*#__PURE__*/createElement(Body, {
          element: "p",
          className: joinClasses(styles$22.noImageLabel, styles$22.noImageLabelLarge, styles$22.noImageVideoSubtitle),
          style: noImageLabelStyle
        }, noImageLabel.text_error_failed_to_get_pdp_movie_instruction_01))))));
      }
    case 'user':
      return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        element: "div",
        justifyContent: "center",
        direction: "row",
        alignment: "center",
        className: joinClasses(styles$22.noImage, className)
      }, props), /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$22.noImageIcon)
      }, /*#__PURE__*/createElement("div", {
        className: styles$22.noImageIconUser
      }, /*#__PURE__*/createElement("img", {
        src: "https://asset.uniqlo.com/g/pictures/user-profile.svg",
        alt: "user profile"
      }))));
    default:
      return /*#__PURE__*/createElement("div", {
        ref: noImageWrappeRef
      }, /*#__PURE__*/createElement(ContentAlignment, __assign$1({
        element: "div",
        justifyContent: "center",
        direction: "column",
        alignment: "center",
        className: joinClasses(styles$22.noImage, className, 'test')
      }, props), /*#__PURE__*/createElement(Icon, {
        name: getIcons(imageType),
        className: styles$22.noImageIcon,
        size: getSize[imageType === 'euro' ? 'euro' : imageSize]
      }), (imageSize === 'large' || imageSize === 'default') && noImageLabel && (/*#__PURE__*/createElement(Body, {
        element: "p",
        className: joinClasses(styles$22.noImageLabel, imageSize === 'large' && styles$22.noImageLabelLarge),
        style: noImageLabelStyle
      }, noImageLabel))));
  }
};
NoImage.displayName = 'CoreNoImage';

var styles$1$3 = {"video-inline":"fr-ec-video-inline","videoInline":"fr-ec-video-inline","video-inline--with-poster-image":"fr-ec-video-inline--with-poster-image","videoInlineWithPosterImage":"fr-ec-video-inline--with-poster-image","video-inline--1x1":"fr-ec-video-inline--1x1","videoInline1X1":"fr-ec-video-inline--1x1","video-inline--2x1":"fr-ec-video-inline--2x1","videoInline2X1":"fr-ec-video-inline--2x1","video-inline--2x3":"fr-ec-video-inline--2x3","videoInline2X3":"fr-ec-video-inline--2x3","video-inline--3x1":"fr-ec-video-inline--3x1","videoInline3X1":"fr-ec-video-inline--3x1","video-inline--3x2":"fr-ec-video-inline--3x2","videoInline3X2":"fr-ec-video-inline--3x2","video-inline--3x4":"fr-ec-video-inline--3x4","videoInline3X4":"fr-ec-video-inline--3x4","video-inline--5x2":"fr-ec-video-inline--5x2","videoInline5X2":"fr-ec-video-inline--5x2","video-inline--16x9":"fr-ec-video-inline--16x9","videoInline16X9":"fr-ec-video-inline--16x9","video-inline--9x16":"fr-ec-video-inline--9x16","videoInline9X16":"fr-ec-video-inline--9x16","video-inline__video":"fr-ec-video-inline__video","videoInlineVideo":"fr-ec-video-inline__video","poster-image":"fr-ec-poster-image","posterImage":"fr-ec-poster-image","controls":"fr-ec-controls","default-controls":"fr-ec-default-controls","defaultControls":"fr-ec-default-controls","button-icon__icon-container":"fr-ec-button-icon__icon-container","buttonIconIconContainer":"fr-ec-button-icon__icon-container","controls__progress-bar":"fr-ec-controls__progress-bar","controlsProgressBar":"fr-ec-controls__progress-bar","controls__progress-bar--fill":"fr-ec-controls__progress-bar--fill","controlsProgressBarFill":"fr-ec-controls__progress-bar--fill","button-icon--light":"fr-ec-button-icon--light","buttonIconLight":"fr-ec-button-icon--light","image-plus-text-collection":"fr-ec-image-plus-text-collection","imagePlusTextCollection":"fr-ec-image-plus-text-collection","video-inline--video-paused":"fr-ec-video-inline--video-paused","videoInlineVideoPaused":"fr-ec-video-inline--video-paused","video-inline--video-played":"fr-ec-video-inline--video-played","videoInlineVideoPlayed":"fr-ec-video-inline--video-played","pause":"fr-ec-pause"};

var CoreVideoInline = function CoreVideoInline(_a) {
  var _b = _a.variant,
    variant = _b === void 0 ? 'default' : _b,
    _c = _a.src,
    src = _c === void 0 ? '' : _c,
    loop = _a.loop,
    _d = _a.posterImage,
    posterImage = _d === void 0 ? '' : _d,
    autoPlay = _a.autoPlay,
    muted = _a.muted,
    altText = _a.altText,
    className = _a.className,
    onError = _a.onError,
    onInitialPlay = _a.onInitialPlay,
    onPlay = _a.onPlay,
    onPause = _a.onPause,
    _e = _a.noVideoLabel,
    noVideoLabel = _e === void 0 ? '' : _e,
    _f = _a.videoRatio,
    videoRatio = _f === void 0 ? '2x1' : _f,
    _g = _a.videoType,
    videoType = _g === void 0 ? 'normal' : _g,
    iconBrand = _a.iconBrand,
    progressBar = _a.progressBar,
    gaCallback = _a.gaCallback,
    _h = _a.gaCategory,
    gaCategory = _h === void 0 ? '' : _h,
    _j = _a.gaLabel,
    gaLabel = _j === void 0 ? '' : _j,
    gaValue = _a.gaValue,
    props = __rest$1(_a, ["variant", "src", "loop", "posterImage", "autoPlay", "muted", "altText", "className", "onEnded", "onError", "onInitialPlay", "onPlay", "onPause", "noVideoLabel", "videoRatio", "videoType", "iconBrand", "progressBar", "gaCallback", "gaCategory", "gaLabel", "gaValue"]);
  var videoRef = React__default.useRef(null);
  var posterImageRef = React__default.useRef(null);
  var posterImageParentRef = React__default.useRef(null);
  var progressRef = React__default.useRef(null);
  var _k = React__default.useState(true),
    validPosterImage = _k[0],
    setValidPosterImage = _k[1];
  var _l = React__default.useState(false),
    inValidVideo = _l[0],
    setInValidVideo = _l[1];
  var _m = React__default.useState(false),
    videoErrorImage = _m[0],
    setVideoErrorImage = _m[1];
  var _o = React__default.useState(true),
    showVideoProgressBar = _o[0],
    setVideoProgressBar = _o[1];
  var _p = React__default.useState(false),
    initialPlay = _p[0],
    setInitialPlay = _p[1];
  var _q = React__default.useState(false),
    isPlaying = _q[0],
    setIsPlaying = _q[1];
  var _r = React__default.useState(false),
    isEnded = _r[0],
    setIsEnded = _r[1];
  var options = {
    threshold: 0.1
  };
  var gaProps = {};
  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var usePrevious = function usePrevious(value) {
    var ref = React__default.useRef();
    React__default.useEffect(function () {
      ref.current = value;
    });
    return ref.current;
  };
  var previousSrc = usePrevious(src);
  React__default.useEffect(function () {
    var _a;
    if (videoRef.current && autoPlay && !muted) {
      videoRef.current.muted = true;
    }
    if (previousSrc !== src) {
      (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.load();
    }
  }, [videoRef, autoPlay, src]);
  var callIntersectionObserver = function callIntersectionObserver(entries) {
    var entry = entries[0];
    if (videoRef.current && entry.isIntersecting) {
      if (posterImageRef.current && posterImageParentRef.current && !posterImageRef.current.src) {
        posterImageRef.current.src = posterImage;
        posterImageParentRef.current.style.backgroundImage = "url(".concat(posterImage, ")");
      }
      if (!videoRef.current.src) {
        videoRef.current.src = src;
      }
    }
  };
  React__default.useEffect(function () {
    var _a, _b;
    var verticalScroll = (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.closest('.fr-ec-template-home');
    var navWrapper = (_b = videoRef.current) === null || _b === void 0 ? void 0 : _b.closest('.fr-ec-template-navigation--hide');
    var observer;
    if (videoRef.current) {
      if (verticalScroll || navWrapper) {
        observer = new IntersectionObserver(callIntersectionObserver, options);
        observer.observe(videoRef.current);
      } else {
        videoRef.current.src = src;
        if (posterImageRef.current && posterImageParentRef.current && !posterImageRef.current.src) {
          posterImageRef.current.src = posterImage;
          posterImageParentRef.current.style.backgroundImage = "url(".concat(posterImage, ")");
        }
      }
    }
    return function () {
      if (videoRef.current && (verticalScroll || navWrapper)) {
        observer.unobserve(videoRef.current);
      }
    };
  }, []);
  var onVideoError = function onVideoError(event) {
    setVideoProgressBar(false);
    if (isInBrowser$1() && window.onMediaError && typeof window.onMediaError === 'function') {
      window.onMediaError(event, src);
    }
    if (onError) {
      onError(event);
    }
    // networkState - Represents the current network state of the video element.
    // when it's value is 3 - no video source found.
    if (videoRef.current && videoRef.current.networkState === 3 && !inValidVideo) {
      setInValidVideo(true);
    }
  };
  var onVideoEnd = function onVideoEnd() {
    setIsEnded(true);
    if (videoRef.current) {
      if (validPosterImage || videoType !== 'product') {
        videoRef.current.autoplay = false;
      }
      videoRef.current.classList.add('played');
      // Fix for IE to pause video on end for non looped videos
      if (!loop) {
        videoRef.current.pause();
      }
    }
  };
  var onPosterImageError = function onPosterImageError(event) {
    setValidPosterImage(!validPosterImage);
    if (isInBrowser$1() && window.onMediaError && typeof window.onMediaError === 'function') {
      window.onMediaError(event);
    }
  };
  // Set error image when video and poster image is invalid
  React__default.useEffect(function () {
    if (videoRef.current && videoRef.current.networkState === 3 && inValidVideo && (!validPosterImage && videoType === 'normal' || videoType === 'product')) {
      setVideoErrorImage(true);
    }
  }, [validPosterImage, inValidVideo]);
  var onVideoPlay = function onVideoPlay(event) {
    setIsPlaying(true);
    setIsEnded(false);
    if (onPlay) {
      onPlay(event);
    }
    if (!initialPlay && onInitialPlay) {
      onInitialPlay(event);
      setInitialPlay(true);
    }
  };
  var ratioToStyle = {
    '1x1': styles$1$3.videoInline1X1,
    '2x1': styles$1$3.videoInline2X1,
    '2x3': styles$1$3.videoInline2X3,
    '3x1': styles$1$3.videoInline3X1,
    '3x2': styles$1$3.videoInline3X2,
    '3x4': styles$1$3.videoInline3X4,
    '5x2': styles$1$3.videoInline5X2,
    // tslint:disable-next-line: object-literal-sort-keys
    '16x9': styles$1$3.videoInline16X9,
    '9x16': styles$1$3.videoInline9X16
  };
  var onTimeUpdate = function onTimeUpdate(event) {
    var video = event.currentTarget;
    var currentPercentage = video.currentTime / video.duration * 100;
    if (progressRef.current) {
      progressRef.current.style.width = "".concat(currentPercentage, "%");
    }
  };
  var videoSeek = function videoSeek(event) {
    var rect = event.currentTarget.getBoundingClientRect();
    var x = event.clientX - rect.left;
    var percentage = x / rect.width * 100;
    if (videoRef.current) {
      videoRef.current.currentTime = videoRef.current.duration / 100 * percentage;
    }
  };
  var videoPausePlay = function videoPausePlay() {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
        videoRef.current.classList.remove('fr-ec-pause');
        videoRef.current.removeAttribute('data-pauseTime');
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
        videoRef.current.classList.add('fr-ec-pause');
        videoRef.current.setAttribute('data-pauseTime', "".concat(videoRef.current.currentTime));
      }
    }
  };
  var videoPausePlayHandler = function videoPausePlayHandler(event) {
    event.stopPropagation();
    event.preventDefault();
    videoPausePlay();
    if (gaCallback) {
      gaCallback(event.currentTarget, gaLabel);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", {
    ref: posterImageParentRef,
    className: joinClasses(styles$1$3.videoInline, ratioToStyle[videoRatio], className, videoType === 'normal' && styles$1$3.videoInlineWithPosterImage)
  }, !videoErrorImage ? (/*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("video", __assign$1({
    poster: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20"><rect fill="none" width="20" height="20" /></svg>',
    "aria-label": altText,
    controls: variant === 'progressBarWithOptions' && !progressBar ? true : false,
    loop: loop,
    autoPlay: autoPlay,
    muted: muted,
    onEnded: onVideoEnd,
    className: styles$1$3.videoInlineVideo,
    ref: videoRef,
    onError: onVideoError,
    playsInline: true,
    preload: 'metadata',
    onPlay: onVideoPlay,
    onPause: onPause,
    onTimeUpdate: onTimeUpdate,
    controlsList: "nodownload",
    "data-src": src
  }, props, gaProps), /*#__PURE__*/React__default.createElement("source", {
    type: "video/mp4"
  }), altText), /*#__PURE__*/React__default.createElement("img", {
    ref: posterImageRef,
    className: styles$1$3.posterImage,
    onError: onPosterImageError,
    alt: "poster-image"
  }), !progressBar && variant === 'default' && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$1$3.defaultControls
  }, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    className: styles$1$3.videoInlineVideoPaused,
    element: 'button',
    icon: 'pause',
    label: "pause",
    hideLabel: true,
    variant: "light",
    onClick: function onClick(e) {
      return videoPausePlayHandler(e);
    },
    iconBrand: iconBrand
  }), /*#__PURE__*/React__default.createElement(ButtonIcon, {
    className: styles$1$3.videoInlineVideoPlayed,
    element: 'button',
    icon: 'play',
    label: "play",
    hideLabel: true,
    variant: "light",
    onClick: function onClick(e) {
      return videoPausePlayHandler(e);
    },
    iconBrand: iconBrand
  }))), showVideoProgressBar && (variant === 'progressBar' || progressBar === true) && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$1$3.controls
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1$3.controlsProgressBar,
    onClick: function onClick(e) {
      return videoSeek(e);
    },
    role: "progressbar",
    "aria-label": "progress bar for video"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1$3.controlsProgressBarFill,
    ref: progressRef
  })), /*#__PURE__*/React__default.createElement(ButtonIcon, {
    element: 'button',
    icon: isPlaying && !isEnded ? 'pause' : 'play',
    label: isPlaying && !isEnded ? 'pause' : 'play',
    hideLabel: true,
    variant: "light",
    onClick: function onClick() {
      return videoPausePlay();
    },
    iconBrand: iconBrand
  }))))) : (/*#__PURE__*/React__default.createElement(NoImage, {
    imageType: 'video',
    noImageLabel: noVideoLabel,
    iconBrand: iconBrand
  })));
};
var VideoInline = function VideoInline(_a) {
  var variant = _a.variant,
    src = _a.src,
    posterImage = _a.posterImage,
    videoRatio = _a.videoRatio,
    smallMediumVideoUrl = _a.smallMediumVideoUrl,
    largeVideoUrl = _a.largeVideoUrl,
    smallMediumPosterImage = _a.smallMediumPosterImage,
    largePosterImage = _a.largePosterImage,
    smallMediumVideoRatio = _a.smallMediumVideoRatio,
    largeVideoRatio = _a.largeVideoRatio,
    alt = _a.alt,
    altText = _a.altText,
    loop = _a.loop,
    height = _a.height,
    className = _a.className,
    videoWidth = _a.width,
    iconBrand = _a.iconBrand,
    progressBar = _a.progressBar,
    gaCallback = _a.gaCallback,
    _b = _a.gaCategory,
    gaCategory = _b === void 0 ? '' : _b,
    _c = _a.gaLabel,
    gaLabel = _c === void 0 ? '' : _c,
    gaValue = _a.gaValue,
    props = __rest$1(_a, ["variant", "src", "posterImage", "videoRatio", "smallMediumVideoUrl", "largeVideoUrl", "smallMediumPosterImage", "largePosterImage", "smallMediumVideoRatio", "largeVideoRatio", "alt", "altText", "loop", "height", "className", "width", "iconBrand", "progressBar", "gaCallback", "gaCategory", "gaLabel", "gaValue"]);
  var width = getViewportWidth();
  var isWidthLessthanLargeDevicewidth = width < designTokens_3.mqMediumScreenMaxWidthLimit;
  var smallMediumVideoUrlValue = src || smallMediumVideoUrl || largeVideoUrl || '';
  var largeVideoUrlValue = src || largeVideoUrl || smallMediumVideoUrl || '';
  var smallMediumVideoRatioValue = videoRatio || smallMediumVideoRatio || largeVideoRatio || '1x1';
  var largeVideoValue = videoRatio || largeVideoRatio || smallMediumVideoRatio || '2x1';
  var largePosterImageValue = posterImage || largePosterImage || smallMediumPosterImage || '';
  var smallMediumPosterImageValue = posterImage || smallMediumPosterImage || largePosterImage || '';
  if (isWidthLessthanLargeDevicewidth || src) {
    return /*#__PURE__*/React__default.createElement(CoreVideoInline, __assign$1({
      variant: variant,
      key: 0,
      loop: loop,
      src: smallMediumVideoUrlValue,
      posterImage: smallMediumPosterImageValue,
      autoPlay: true,
      muted: true,
      altText: alt || altText,
      videoRatio: smallMediumVideoRatioValue,
      className: className,
      width: videoWidth,
      height: height,
      iconBrand: iconBrand,
      progressBar: progressBar,
      gaCallback: gaCallback,
      gaCategory: gaCategory,
      gaLabel: gaLabel,
      gaValue: gaValue
    }, props));
  } else {
    return /*#__PURE__*/React__default.createElement(CoreVideoInline, __assign$1({
      variant: variant,
      key: 1,
      loop: loop,
      src: largeVideoUrlValue,
      posterImage: largePosterImageValue,
      autoPlay: true,
      muted: true,
      altText: alt || altText,
      width: videoWidth,
      height: height,
      className: className,
      videoRatio: largeVideoValue,
      iconBrand: iconBrand,
      progressBar: progressBar,
      gaCallback: gaCallback,
      gaCategory: gaCategory,
      gaLabel: gaLabel,
      gaValue: gaValue
    }, props));
  }
};
VideoInline.displayName = 'CoreVideoInline';
VideoInline.defaultProps = {
  autoPlay: true,
  loop: true,
  muted: true,
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$2$1 = {"media-carousel":"fr-ec-media-carousel","mediaCarousel":"fr-ec-media-carousel","media-carousel__navigation-btn":"fr-ec-media-carousel__navigation-btn","mediaCarouselNavigationBtn":"fr-ec-media-carousel__navigation-btn","media-carousel-arrow-container--with-pinch-zoom":"fr-ec-media-carousel-arrow-container--with-pinch-zoom","mediaCarouselArrowContainerWithPinchZoom":"fr-ec-media-carousel-arrow-container--with-pinch-zoom","pagination-pinch-zoom-wrapper":"fr-ec-pagination-pinch-zoom-wrapper","paginationPinchZoomWrapper":"fr-ec-pagination-pinch-zoom-wrapper","swiper-pagination-pinch-zoom":"fr-ec-swiper-pagination-pinch-zoom","swiperPaginationPinchZoom":"fr-ec-swiper-pagination-pinch-zoom","swiper-current-slide":"fr-ec-swiper-current-slide","swiperCurrentSlide":"fr-ec-swiper-current-slide","swiper-total-slide":"fr-ec-swiper-total-slide","swiperTotalSlide":"fr-ec-swiper-total-slide","swiper-slash":"fr-ec-swiper-slash","swiperSlash":"fr-ec-swiper-slash","pinch-zoom-carousel-close":"fr-ec-pinch-zoom-carousel-close","pinchZoomCarouselClose":"fr-ec-pinch-zoom-carousel-close","hide-pagination-pinch-zoom":"fr-ec-hide-pagination-pinch-zoom","hidePaginationPinchZoom":"fr-ec-hide-pagination-pinch-zoom","media-carousel__pagination":"fr-ec-media-carousel__pagination","mediaCarouselPagination":"fr-ec-media-carousel__pagination","media-carousel__pagination-overlay":"fr-ec-media-carousel__pagination-overlay","mediaCarouselPaginationOverlay":"fr-ec-media-carousel__pagination-overlay","media-carousel__button-prev":"fr-ec-media-carousel__button-prev","mediaCarouselButtonPrev":"fr-ec-media-carousel__button-prev","media-carousel__button-next":"fr-ec-media-carousel__button-next","mediaCarouselButtonNext":"fr-ec-media-carousel__button-next","media-carousel__navigation-btn-label":"fr-ec-media-carousel__navigation-btn-label","mediaCarouselNavigationBtnLabel":"fr-ec-media-carousel__navigation-btn-label","media-carousel__icon":"fr-ec-media-carousel__icon","mediaCarouselIcon":"fr-ec-media-carousel__icon","media-carousel__pause-icon":"fr-ec-media-carousel__pause-icon","mediaCarouselPauseIcon":"fr-ec-media-carousel__pause-icon","media-carousel__icon-button":"fr-ec-media-carousel__icon-button","mediaCarouselIconButton":"fr-ec-media-carousel__icon-button","swiper-container-horizontal":"fr-ec-swiper-container-horizontal","swiperContainerHorizontal":"fr-ec-swiper-container-horizontal","swiper-pagination":"fr-ec-swiper-pagination","swiperPagination":"fr-ec-swiper-pagination","swiper-pagination-bullet":"fr-ec-swiper-pagination-bullet","swiperPaginationBullet":"fr-ec-swiper-pagination-bullet","swiper-pagination-bullet-active":"fr-ec-swiper-pagination-bullet-active","swiperPaginationBulletActive":"fr-ec-swiper-pagination-bullet-active","swiper-pagination-bullets":"fr-ec-swiper-pagination-bullets","swiperPaginationBullets":"fr-ec-swiper-pagination-bullets","loader-wrapper":"fr-ec-loader-wrapper","loaderWrapper":"fr-ec-loader-wrapper","swiper-pagination-bullet--non-auto":"fr-ec-swiper-pagination-bullet--non-auto","swiperPaginationBulletNonAuto":"fr-ec-swiper-pagination-bullet--non-auto","swiper-pagination-h":"fr-ec-swiper-pagination-h","swiperPaginationH":"fr-ec-swiper-pagination-h","swiper-pagination-fraction":"fr-ec-swiper-pagination-fraction","swiperPaginationFraction":"fr-ec-swiper-pagination-fraction","pagination-loader":"fr-ec-pagination-loader","paginationLoader":"fr-ec-pagination-loader","complete-progress":"fr-ec-complete-progress","completeProgress":"fr-ec-complete-progress","pagination-loader__half-circle":"fr-ec-pagination-loader__half-circle","paginationLoaderHalfCircle":"fr-ec-pagination-loader__half-circle","pagination-loader__half-circle--left":"fr-ec-pagination-loader__half-circle--left","paginationLoaderHalfCircleLeft":"fr-ec-pagination-loader__half-circle--left","left-spin":"fr-ec-left-spin","leftSpin":"fr-ec-left-spin","pagination-loader__half-circle--right":"fr-ec-pagination-loader__half-circle--right","paginationLoaderHalfCircleRight":"fr-ec-pagination-loader__half-circle--right","right-spin":"fr-ec-right-spin","rightSpin":"fr-ec-right-spin","loader-common-animation":"fr-ec-loader-common-animation","loaderCommonAnimation":"fr-ec-loader-common-animation","loader-track":"fr-ec-loader-track","loaderTrack":"fr-ec-loader-track","media-carousel__arrow-container":"fr-ec-media-carousel__arrow-container","mediaCarouselArrowContainer":"fr-ec-media-carousel__arrow-container","media-carousel__arrows":"fr-ec-media-carousel__arrows","mediaCarouselArrows":"fr-ec-media-carousel__arrows","media-carousel__arrows--prev-arrow":"fr-ec-media-carousel__arrows--prev-arrow","mediaCarouselArrowsPrevArrow":"fr-ec-media-carousel__arrows--prev-arrow","media-carousel__arrows--next-arrow":"fr-ec-media-carousel__arrows--next-arrow","mediaCarouselArrowsNextArrow":"fr-ec-media-carousel__arrows--next-arrow","swiper-wrapper":"fr-ec-swiper-wrapper","swiperWrapper":"fr-ec-swiper-wrapper","media-carousel-progress-circle":"fr-ec-media-carousel-progress-circle","mediaCarouselProgressCircle":"fr-ec-media-carousel-progress-circle","stroke":"fr-ec-stroke","media-carousel__carousel-indicator":"fr-ec-media-carousel__carousel-indicator","mediaCarouselCarouselIndicator":"fr-ec-media-carousel__carousel-indicator","media-carousel__carousel-arrow":"fr-ec-media-carousel__carousel-arrow","mediaCarouselCarouselArrow":"fr-ec-media-carousel__carousel-arrow","media-carousel-arrow":"fr-ec-media-carousel-arrow","mediaCarouselArrow":"fr-ec-media-carousel-arrow","swiper-button-next":"fr-ec-swiper-button-next","swiperButtonNext":"fr-ec-swiper-button-next","swiper-button-prev":"fr-ec-swiper-button-prev","swiperButtonPrev":"fr-ec-swiper-button-prev","borderIn":"fr-ec-borderIn","media-carousel--wrapper":"fr-ec-media-carousel--wrapper","mediaCarouselWrapper":"fr-ec-media-carousel--wrapper","video-inline":"fr-ec-video-inline","videoInline":"fr-ec-video-inline","image":"fr-ec-image","media-carousel--boxed-grey":"fr-ec-media-carousel--boxed-grey","mediaCarouselBoxedGrey":"fr-ec-media-carousel--boxed-grey","carousel-indicator":"fr-ec-carousel-indicator","carouselIndicator":"fr-ec-carousel-indicator"};

var styles$3$1 = {"carousel-indicator":"fr-ec-carousel-indicator","carouselIndicator":"fr-ec-carousel-indicator","carousel-indicator-number":"fr-ec-carousel-indicator-number","carouselIndicatorNumber":"fr-ec-carousel-indicator-number","carousel-indicator-vertical":"fr-ec-carousel-indicator-vertical","carouselIndicatorVertical":"fr-ec-carousel-indicator-vertical","carousel-indicator-freeScroll":"fr-ec-carousel-indicator-freeScroll","carouselIndicatorFreeScroll":"fr-ec-carousel-indicator-freeScroll","carousel-indicator-item":"fr-ec-carousel-indicator-item","carouselIndicatorItem":"fr-ec-carousel-indicator-item","carousel-indicator-item--active":"fr-ec-carousel-indicator-item--active","carouselIndicatorItemActive":"fr-ec-carousel-indicator-item--active","carousel-indicator-item-white":"fr-ec-carousel-indicator-item-white","carouselIndicatorItemWhite":"fr-ec-carousel-indicator-item-white","carousel-indicator-item--small":"fr-ec-carousel-indicator-item--small","carouselIndicatorItemSmall":"fr-ec-carousel-indicator-item--small","carousel-indicator-item--micro":"fr-ec-carousel-indicator-item--micro","carouselIndicatorItemMicro":"fr-ec-carousel-indicator-item--micro","carousel-indicator-item--hidden":"fr-ec-carousel-indicator-item--hidden","carouselIndicatorItemHidden":"fr-ec-carousel-indicator-item--hidden"};

var usePrevious = function usePrevious(value) {
  var ref = useRef();
  useEffect(function () {
    ref.current = value;
  });
  return ref.current;
};
var testId$5 = {
  'data-testid': 'CoreCarouselIndicator'
};
var CarouselIndicator = function CarouselIndicator(_a) {
  var activeIndex = _a.activeIndex,
    indicatorLength = _a.indicatorLength,
    _b = _a.direction,
    direction = _b === void 0 ? 'horizontal' : _b,
    spacing = _a.spacing,
    _c = _a.freeScroll,
    freeScroll = _c === void 0 ? false : _c,
    className = _a.className,
    _d = _a.variant,
    variant = _d === void 0 ? 'default' : _d,
    _e = _a.backgroundColor,
    backgroundColor = _e === void 0 ? 'black' : _e,
    props = __rest$1(_a, ["activeIndex", "indicatorLength", "direction", "spacing", "freeScroll", "className", "variant", "backgroundColor"]);
  var visibleIndicatorsBreakLimit = 5;
  var translateBaseValue = 4;
  var _f = useState(0),
    translateX = _f[0],
    setTranslateX = _f[1];
  var prevIndex = usePrevious(activeIndex);
  useEffect(function () {
    if (!freeScroll) {
      if (activeIndex !== undefined && prevIndex !== undefined && indicatorLength > visibleIndicatorsBreakLimit) {
        if (prevIndex > activeIndex && activeIndex === 0 && translateX) {
          // looping to first
          setTranslateX(0);
        } else if (prevIndex < activeIndex && prevIndex == 0 && indicatorLength - activeIndex < 3) {
          // looping to last
          var translateValue = (activeIndex - (indicatorLength - visibleIndicatorsBreakLimit)) * translateBaseValue;
          setTranslateX(translateX - translateValue);
        }
        if (activeIndex && prevIndex && activeIndex <= indicatorLength) {
          if (activeIndex >= visibleIndicatorsBreakLimit) {
            // forward
            if (activeIndex > prevIndex) {
              setTranslateX(translateX - translateBaseValue);
            }
            // backward
            if (prevIndex > activeIndex) {
              setTranslateX(translateX + translateBaseValue);
            }
          } else {
            setTranslateX(0);
          }
        }
      }
    }
  }, [activeIndex]);
  var getClass = function getClass(index) {
    if (index === activeIndex) {
      return 'active';
    }
    if (indicatorLength <= visibleIndicatorsBreakLimit) {
      if (index !== activeIndex) {
        return 'std';
      }
    }
    if (indicatorLength > visibleIndicatorsBreakLimit) {
      if (activeIndex < visibleIndicatorsBreakLimit - 2) {
        if (index >= 0 && index <= visibleIndicatorsBreakLimit - 2) {
          return 'std';
        }
        if (index > 0 && index <= visibleIndicatorsBreakLimit - 1) {
          return 'small';
        }
      }
      if (activeIndex >= visibleIndicatorsBreakLimit - 2 && activeIndex <= indicatorLength) {
        if (index >= activeIndex - 3 && index <= activeIndex + 1) {
          return 'std';
        }
        if (index >= activeIndex - 4 && index <= activeIndex + 2) {
          return 'small';
        }
      }
    }
    return 'hidden';
  };
  var getChildren = function getChildren() {
    return count(indicatorLength).map(function (_, index) {
      return !freeScroll ? (/*#__PURE__*/createElement("span", {
        style: {
          transform: "translate(".concat(translateX, "px)")
        },
        className: joinClasses(styles$3$1['carousel-indicator-item'], styles$3$1["carousel-indicator-item--".concat(getClass(index))], backgroundColor === 'white' ? styles$3$1['carousel-indicator-item-white'] : styles$3$1['carousel-indicator-item-black']),
        key: index
      })) : (/*#__PURE__*/createElement("span", {
        className: joinClasses(styles$3$1['carousel-indicator-item'], backgroundColor === 'white' ? styles$3$1['carousel-indicator-item-white'] : styles$3$1['carousel-indicator-item-black'], index === activeIndex && styles$3$1.carouselIndicatorItemActive),
        key: index
      }));
    });
  };
  var spacingStyle = spacing ? direction === 'horizontal' ? {
    bottom: "".concat(spacing, "px")
  } : {
    marginLeft: "-".concat(spacing, "px")
  } : {};
  return /*#__PURE__*/createElement("div", __assign$1({
    style: spacingStyle,
    className: joinClasses(styles$3$1.carouselIndicator, styles$3$1["carousel-indicator-".concat(direction)], freeScroll && styles$3$1.carouselIndicatorFreeScroll, variant === 'number' && styles$3$1.carouselIndicatorNumber, className)
  }, testId$5, props), variant === 'default' ? getChildren() : (/*#__PURE__*/createElement(CarouselPagination, {
    currentIndex: activeIndex,
    total: indicatorLength,
    itemsPerPage: 1,
    indicatorType: 'number',
    carouselVariant: 'ecRenewal'
  })));
};
CarouselIndicator.displayName = 'CarouselIndicator';

var MediaCarousel = /** @class */function (_super) {
  __extends(MediaCarousel, _super);
  function MediaCarousel(props) {
    var _this = _super.call(this, props) || this;
    _this.onSlideChange = function () {
      var swiperInstance = _this.swiperInstance;
      var isPlaying = _this.state.isPlaying;
      if (swiperInstance) {
        var activeSlide = swiperInstance.realIndex;
        var slideWrapper = Array.from(swiperInstance.$wrapperEl)[0];
        var videos = Array.from(slideWrapper.getElementsByTagName('video') || []);
        var progress = Array.from(document.getElementsByClassName(styles$2$1.mediaCarouselProgressCircle) || []);
        if (progress.length > 0) {
          progress.forEach(function (circle) {
            circle.classList.remove(styles$2$1.mediaCarouselProgressCircle);
            var animateTimeout = setTimeout(function () {
              circle.classList.add(styles$2$1.mediaCarouselProgressCircle);
              circle.style.animationPlayState = isPlaying === null || isPlaying ? 'running' : 'paused';
              clearTimeout(animateTimeout);
            }, 0);
          });
        }
        _this.setState({
          activeSlide: activeSlide
        });
        if (!_this.props.enablePinchZoom && !_this.props.ecRenewal) {
          setTimeout(function () {
            swiperInstance.loopDestroy();
            swiperInstance.loopCreate();
          });
        }
      }
    };
    _this.onSlideTransitionEnd = function () {
      var swiperInstance = _this.swiperInstance;
      if (_this.swiperInstance && !_this.props.enablePinchZoom && _this.props.ecRenewal) {
        setTimeout(function () {
          swiperInstance.loopDestroy();
          swiperInstance.loopCreate();
        });
      }
    };
    _this.onKeyBoardPress = function (e) {
      if (e.key === 'ArrowRight') {
        _this.swiperInstance.slideNext();
      }
      if (e.key === 'ArrowLeft') {
        _this.swiperInstance.slidePrev();
      }
    };
    _this.handleZoomChange = function (scale, imageEl) {
      var swiperInstance = _this.swiperInstance;
      if (imageEl.alt !== 'poster-image') {
        if (scale > 1) {
          _this.setState({
            isZoomed: true
          });
          swiperInstance.allowTouchMove = false;
        } else {
          _this.setState({
            isZoomed: false
          });
          swiperInstance.allowTouchMove = true;
        }
      }
    };
    _this.componentDidUpdate = function (prevProps) {
      if (_this.swiperInstance) {
        if (_this.props.ecRenewal && prevProps.activeSlideIndex !== _this.props.activeSlideIndex) {
          _this.swiperInstance.slideToLoop(_this.props.activeSlideIndex);
        }
        _this.swiperInstance.update();
      }
    };
    _this.onSlideClick = function (e) {
      var _a, _b;
      if (_this.props.onClick) {
        var clickedItem = e.target;
        var activeSlidePosition = (_a = _this.swiperInstance) === null || _a === void 0 ? void 0 : _a.realIndex;
        var mediaType = null;
        mediaType = (clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.querySelector('source')) ? 'video' : 'image';
        var fileUrl = (_b = clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.dataset.src) !== null && _b !== void 0 ? _b : undefined;
        var fileName = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.split('/').pop().split('.')[0];
        _this.props.onClick(e, fileName, mediaType, activeSlidePosition);
      }
    };
    _this.realIndexChange = function () {
      var _a, _b, _c, _d, _e;
      if (_this.swiperInstance) {
        var activeSlide = _this.swiperInstance.activeIndex;
        var activeSlidePosition = _this.swiperInstance.realIndex;
        if (_this.props.onMediaView) {
          var mediaType = null;
          mediaType = ((_a = _this.swiperInstance.slides[activeSlide]) === null || _a === void 0 ? void 0 : _a.querySelector('source')) ? 'video' : 'image';
          var fileUrl = mediaType === 'image' ? (_c = (_b = _this.swiperInstance.slides[activeSlide].querySelector('img')) === null || _b === void 0 ? void 0 : _b.dataset.src) !== null && _c !== void 0 ? _c : undefined : (_e = (_d = _this.swiperInstance.slides[activeSlide].querySelector('video')) === null || _d === void 0 ? void 0 : _d.dataset.src) !== null && _e !== void 0 ? _e : undefined;
          var fileName = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.split('/').pop().split('.')[0];
          if (mediaType && fileName) {
            _this.props.onMediaView(_this.swiperInstance.slides[activeSlide], fileName, mediaType, activeSlidePosition);
          }
        }
        if (_this.props.onIndexChange) {
          _this.props.onIndexChange(activeSlidePosition);
        }
      }
    };
    _this.handleToggle = function () {
      if (_this.swiperInstance.autoplay.running) {
        _this.swiperInstance.autoplay.stop();
        _this.setState({
          isPlaying: false
        });
      } else {
        _this.swiperInstance.autoplay.start();
        _this.setState({
          isPlaying: true
        });
      }
    };
    _this.onCloseButtonClick = function () {
      if (_this.props.onPinchZoomCloseClick) {
        _this.props.onPinchZoomCloseClick(_this.state.activeSlide);
      }
    };
    _this.progressCircle = function () {
      var isPlaying = _this.state.isPlaying;
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        focusable: "false",
        role: "presentation",
        style: {
          width: '25px',
          height: '25px',
          position: 'absolute',
          zIndex: 21
        }
      }, /*#__PURE__*/createElement("path", {
        style: {
          animationPlayState: isPlaying === null || isPlaying ? 'running' : 'paused'
        },
        "stroke-width": "1.5",
        className: styles$2$1.mediaCarouselProgressCircle,
        d: "M9,16.457 C4.889,16.457 1.543,13.112 1.543,9 C1.543,4.888 4.889,1.543 9,1.543 C13.111,1.543 16.457,4.888 16.457,9 C16.457,13.112 13.111,16.457 9,16.4579"
      })), isPlaying === null || isPlaying ? (/*#__PURE__*/createElement(Icon, {
        name: _this.props.iconBrand ? "".concat(_this.props.iconBrand, "pause") : 'pause',
        className: styles$2$1.mediaCarouselPauseIcon,
        size: "24"
      })) : (/*#__PURE__*/createElement(Icon, {
        name: _this.props.iconBrand ? "".concat(_this.props.iconBrand, "play") : 'play',
        className: styles$2$1.mediaCarouselPauseIcon,
        size: "24"
      })));
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    _this.state = {
      activeSlide: _this.props.activeSlideIndex || 0,
      isPlaying: _this.swiperInstance && _this.swiperInstance.autoplay.running,
      isZoomed: false
    };
    return _this;
  }
  MediaCarousel.prototype.componentDidMount = function () {
    var _this = this;
    var pinchZoomSettings = this.props.enablePinchZoom ? {
      pagination: !this.props.ecRenewal ? {
        clickable: true,
        currentClass: 'swiper-current-slide',
        el: '.swiper-pagination',
        renderFraction: function renderFraction(currentClass, totalClass) {
          return "<span class=\"".concat(joinClasses(currentClass, typographyStyles.hintTextStandard), "\"></span><span class=\"").concat(joinClasses('swiper-slash', typographyStyles.hintTextStandard), "\">|</span><span class=\"").concat(joinClasses(totalClass, typographyStyles.hintTextStandard), "\"></span>");
        },
        totalClass: 'swiper-total-slide',
        type: 'fraction'
      } : false,
      passiveListeners: false,
      zoom: {
        maxRatio: 3,
        minRatio: 1
      }
    } : {
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
        type: 'bullets'
      }
    };
    this.swiperInstance = new swiper(this.swiperRef.current, __assign$1(__assign$1({
      autoplay: this.props.autoplay ? {
        delay: this.props.delay || 3400,
        disableOnInteraction: false
      } : false,
      direction: 'horizontal',
      initialSlide: this.props.activeSlideIndex || 0,
      keyboard: {
        enabled: false
      }
    }, pinchZoomSettings), {
      mousewheel: {
        forceToAxis: true,
        invert: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      observeParents: true,
      observer: true,
      on: {
        slideChange: function slideChange() {
          return _this.onSlideChange();
        },
        zoomChange: function zoomChange(scale, imageEl) {
          return _this.handleZoomChange(scale, imageEl);
        },
        realIndexChange: function realIndexChange() {
          return _this.realIndexChange();
        },
        slideNextTransitionEnd: function slideNextTransitionEnd() {
          return _this.onSlideTransitionEnd();
        },
        slidePrevTransitionEnd: function slidePrevTransitionEnd() {
          return _this.onSlideTransitionEnd();
        }
      },
      parallax: true,
      slidesPerView: 1,
      speed: getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400,
      touchReleaseOnEdges: true,
      centeredSlides: true,
      loop: this.props.enablePinchZoom ? false : true
    }));
    if (this.swiperInstance) {
      document.addEventListener('keydown', this.onKeyBoardPress);
    }
    if (this.swiperRef.current) {
      this.swiperRef.current.addEventListener('click', function (e) {
        _this.onSlideClick(e);
      });
      this.realIndexChange();
    }
  };
  MediaCarousel.prototype.componentWillUnmount = function () {
    document.removeEventListener('keydown', this.onKeyBoardPress);
  };
  MediaCarousel.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      autoplay = _a.autoplay,
      id = _a.id,
      _b = _a.hasArrows,
      hasArrows = _b === void 0 ? true : _b,
      _c = _a.enablePinchZoom,
      enablePinchZoom = _c === void 0 ? false : _c,
      pinchZoomItems = _a.pinchZoomItems,
      _d = _a.pinchZoomCloseLabel,
      pinchZoomCloseLabel = _d === void 0 ? '' : _d,
      className = _a.className,
      iconBrand = _a.iconBrand,
      parentActiveIndex = _a.parentActiveIndex,
      parentGaCategory = _a.parentGaCategory,
      _e = _a.ecRenewal,
      ecRenewal = _e === void 0 ? false : _e,
      _f = _a.arrowVariant,
      arrowVariant = _f === void 0 ? 'longWhite' : _f,
      _g = _a.ecRenewalpagination,
      ecRenewalpagination = _g === void 0 ? 'default' : _g,
      props = __rest$1(_a, ["children", "autoplay", "id", "hasArrows", "enablePinchZoom", "pinchZoomItems", "pinchZoomCloseLabel", "className", "iconBrand", "gaCategory", "gaLabel", "parentActiveIndex", "parentGaCategory", "ecRenewal", "arrowVariant", "ecRenewalpagination"]);
    var _h = this.state,
      isZoomed = _h.isZoomed,
      activeSlide = _h.activeSlide;
    var childrenWithProps = enablePinchZoom ? pinchZoomItems === null || pinchZoomItems === void 0 ? void 0 : pinchZoomItems.map(function (item, index) {
      return item.isVideo ? (/*#__PURE__*/createElement("div", {
        key: index,
        className: "swiper-slide"
      }, /*#__PURE__*/createElement(VideoInline, {
        posterImage: item.posterImage,
        loop: true,
        src: item.src,
        muted: false,
        videoRatio: "1x1",
        videoType: 'product',
        key: item.key
      }))) : (/*#__PURE__*/createElement("div", {
        key: index,
        className: "swiper-slide"
      }, /*#__PURE__*/createElement("div", {
        className: "swiper-zoom-container"
      }, /*#__PURE__*/createElement("img", {
        src: item.src,
        alt: item.alt,
        key: item.key
      }))));
    }) : Children.toArray(children).map(function (child, index) {
      var childGAProps = {};
      childGAProps = {
        'data-gtm-action': 'Read',
        'data-gtm-category': parentGaCategory,
        'data-gtm-event-name': 'ua_event',
        'data-gtm-label': "".concat(parentActiveIndex, "_").concat(index + 1),
        'data-gtm-trigger': 'inView',
        id: "cms-link-".concat(parentActiveIndex, "_").concat(index + 1)
      };
      return parentActiveIndex !== undefined ? (/*#__PURE__*/createElement("div", __assign$1({
        key: index,
        className: "swiper-slide"
      }, childGAProps), /*#__PURE__*/cloneElement(child, {
        gaCategory: parentGaCategory,
        gaLabel: "".concat(parentActiveIndex, "_").concat(index + 1),
        key: child.props.label
      }))) : (/*#__PURE__*/createElement("div", {
        key: index,
        className: "swiper-slide"
      }, /*#__PURE__*/cloneElement(child, {
        key: child.props.label
      })));
    });
    var gaProps = {};
    if (this.props.gaCategory && this.props.gaLabel) {
      gaProps = {
        'data-category': this.props.gaCategory,
        'data-label': this.props.gaLabel
      };
    }
    var renderChild = function renderChild() {
      return /*#__PURE__*/createElement(Fragment, null, enablePinchZoom && !isZoomed && (/*#__PURE__*/createElement("div", {
        className: styles$2$1.pinchZoomCarouselClose
      }, /*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "close-big",
        label: pinchZoomCloseLabel,
        variant: "dark",
        onClick: _this.onCloseButtonClick,
        iconBrand: iconBrand
      }))), /*#__PURE__*/createElement("div", __assign$1({
        className: joinClasses('swiper-container', styles$2$1.mediaCarousel, ecRenewal && styles$2$1.mediaCarouselWrapper, className),
        id: id,
        ref: _this.swiperRef
      }, gaProps, props), /*#__PURE__*/createElement("div", {
        className: 'swiper-wrapper'
      }, childrenWithProps), (ecRenewal ? arrowVariant === 'longWhite' : hasArrows) && !enablePinchZoom && (/*#__PURE__*/createElement("div", {
        className: styles$2$1.mediaCarouselArrowContainer
      }, /*#__PURE__*/createElement(Fragment, null, children && children.length > 1 && (/*#__PURE__*/createElement("button", {
        className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-prev', styles$2$1.mediaCarouselButtonPrev, ecRenewal && styles$2$1.mediaCarouselCarouselArrow),
        "aria-label": "Previous Slide"
      }, /*#__PURE__*/createElement("span", {
        className: joinClasses(styles$2$1.mediaCarouselIcon, styles$2$1.mediaCarouselArrows, styles$2$1.mediaCarouselArrowsPrevArrow)
      }))), children && children.length > 1 && (/*#__PURE__*/createElement("button", {
        className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-next', styles$2$1.mediaCarouselButtonNext, ecRenewal && styles$2$1.mediaCarouselCarouselArrow),
        "aria-label": "Next Slide"
      }, /*#__PURE__*/createElement("span", {
        className: joinClasses(styles$2$1.mediaCarouselIcon, styles$2$1.mediaCarouselArrows, styles$2$1.mediaCarouselArrowsNextArrow)
      })))))), arrowVariant === 'boxedGrey' && ecRenewal && children && children.length > 1 && (/*#__PURE__*/createElement("div", {
        className: styles$2$1.mediaCarouselArrowContainer
      }, /*#__PURE__*/createElement("button", {
        tabIndex: 0,
        className: joinClasses(styles$2$1.mediaCarouselArrow, 'swiper-button-prev')
      }, /*#__PURE__*/createElement(Icon, {
        name: 'chevron-left'
      })), /*#__PURE__*/createElement("button", {
        tabIndex: 0,
        className: joinClasses(styles$2$1.mediaCarouselArrow, 'swiper-button-next')
      }, /*#__PURE__*/createElement(Icon, {
        name: 'chevron-right'
      })))), ecRenewal && arrowVariant === 'longWhite' && (/*#__PURE__*/createElement(CarouselIndicator, {
        spacing: ecRenewalpagination === 'number' ? '8' : '12',
        activeIndex: activeSlide,
        indicatorLength: children.length || 0,
        className: styles$2$1.mediaCarouselCarouselIndicator,
        variant: ecRenewalpagination
      })), !ecRenewal && enablePinchZoom && (/*#__PURE__*/createElement("div", {
        className: joinClasses(styles$2$1.mediaCarouselArrowContainer, styles$2$1.mediaCarouselArrowContainerWithPinchZoom, isZoomed && styles$2$1.hidePaginationPinchZoom)
      }, /*#__PURE__*/createElement("button", {
        className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-prev', styles$2$1.mediaCarouselButtonPrev)
      }, /*#__PURE__*/createElement(Icon, {
        name: iconBrand ? "".concat(iconBrand, "chevron-left") : 'chevron-left'
      })), /*#__PURE__*/createElement("button", {
        className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-next', styles$2$1.mediaCarouselButtonNext)
      }, /*#__PURE__*/createElement(Icon, {
        name: iconBrand ? "".concat(iconBrand, "chevron-right") : 'chevron-right'
      })))), !ecRenewal && (!enablePinchZoom ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: styles$2$1.mediaCarouselPagination
      }, /*#__PURE__*/createElement("div", {
        className: joinClasses('swiper-pagination', 'swiper-pagination-h')
      }), autoplay && (/*#__PURE__*/createElement("button", {
        onClick: _this.handleToggle,
        className: styles$2$1.mediaCarouselIconButton
      }, _this.progressCircle()))), /*#__PURE__*/createElement("div", {
        className: styles$2$1.mediaCarouselPaginationOverlay
      }))) : (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$2$1.paginationPinchZoomWrapper, isZoomed && styles$2$1.hidePaginationPinchZoom)
      }, /*#__PURE__*/createElement("div", {
        className: joinClasses('swiper-pagination', 'swiper-pagination-pinch-zoom')
      })))))), ecRenewal && arrowVariant === 'boxedGrey' && (/*#__PURE__*/createElement(CarouselIndicator, {
        spacing: "auto",
        activeIndex: activeSlide,
        indicatorLength: children.length || 0,
        className: styles$2$1.mediaCarouselCarouselIndicator,
        variant: ecRenewalpagination
      })));
    };
    return ecRenewal && arrowVariant === 'boxedGrey' ? (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$2$1.mediaCarouselWrapper, styles$2$1.mediaCarouselBoxedGrey)
    }, renderChild())) : renderChild();
  };
  MediaCarousel.displayName = 'CoreMediaCarousel';
  return MediaCarousel;
}(Component);

var ARROW_INCREMENT_NONE = 'none';
var ARROW_INCREMENT_SINGLE = 'single';
var ARROW_INCREMENT_PAGE = 'page';

var INDICATOR_NONE = 'none';
var INDICATOR_PAGES = 'pages';

var getElementVerticalCenterInParent = function getElementVerticalCenterInParent(element, parent) {
  var elementRect = element.getBoundingClientRect();
  var parentRect = parent.getBoundingClientRect();
  return elementRect.top - parentRect.top + elementRect.height / 2;
};

var styles$4$1 = {"carousel":"fr-ec-carousel","carousel__scrollbar-hide":"fr-ec-carousel__scrollbar-hide","carouselScrollbarHide":"fr-ec-carousel__scrollbar-hide","carousel__container":"fr-ec-carousel__container","carouselContainer":"fr-ec-carousel__container","video-inline":"fr-ec-video-inline","videoInline":"fr-ec-video-inline","carousel__frame":"fr-ec-carousel__frame","carouselFrame":"fr-ec-carousel__frame","carousel__frame--padded":"fr-ec-carousel__frame--padded","carouselFramePadded":"fr-ec-carousel__frame--padded","carousel__frame--shifting":"fr-ec-carousel__frame--shifting","carouselFrameShifting":"fr-ec-carousel__frame--shifting","carousel--with-pinch-zoom":"fr-ec-carousel--with-pinch-zoom","carouselWithPinchZoom":"fr-ec-carousel--with-pinch-zoom","pinch-zoom-carousel-indicator":"fr-ec-pinch-zoom-carousel-indicator","pinchZoomCarouselIndicator":"fr-ec-pinch-zoom-carousel-indicator","pinch-zoom-carousel-wrapper":"fr-ec-pinch-zoom-carousel-wrapper","pinchZoomCarouselWrapper":"fr-ec-pinch-zoom-carousel-wrapper","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","media-carousel":"fr-ec-media-carousel","mediaCarousel":"fr-ec-media-carousel","carousel--loop":"fr-ec-carousel--loop","carouselLoop":"fr-ec-carousel--loop","carousel-arrow":"fr-ec-carousel-arrow","carouselArrow":"fr-ec-carousel-arrow","carousel__overlay":"fr-ec-carousel__overlay","carouselOverlay":"fr-ec-carousel__overlay","carousel__skip":"fr-ec-carousel__skip","carouselSkip":"fr-ec-carousel__skip","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","carousel__bottom-section":"fr-ec-carousel__bottom-section","carouselBottomSection":"fr-ec-carousel__bottom-section","carousel__bottom-section--none":"fr-ec-carousel__bottom-section--none","carouselBottomSectionNone":"fr-ec-carousel__bottom-section--none","carousel__bottom-section--with-number":"fr-ec-carousel__bottom-section--with-number","carouselBottomSectionWithNumber":"fr-ec-carousel__bottom-section--with-number","carousel__bottom-section--with-number-bottom":"fr-ec-carousel__bottom-section--with-number-bottom","carouselBottomSectionWithNumberBottom":"fr-ec-carousel__bottom-section--with-number-bottom","actionable-content--with-link-text":"fr-ec-actionable-content--with-link-text","actionableContentWithLinkText":"fr-ec-actionable-content--with-link-text","link-text--standalone-primary":"fr-ec-link-text--standalone-primary","linkTextStandalonePrimary":"fr-ec-link-text--standalone-primary","caption":"fr-ec-caption","carousel__model-details-wrapper":"fr-ec-carousel__model-details-wrapper","carouselModelDetailsWrapper":"fr-ec-carousel__model-details-wrapper","actionable-content__content--link-text":"fr-ec-actionable-content__content--link-text","actionableContentContentLinkText":"fr-ec-actionable-content__content--link-text","actionable-content__actions--link-text":"fr-ec-actionable-content__actions--link-text","actionableContentActionsLinkText":"fr-ec-actionable-content__actions--link-text","carousel__model-details--with-auto-slide":"fr-ec-carousel__model-details--with-auto-slide","carouselModelDetailsWithAutoSlide":"fr-ec-carousel__model-details--with-auto-slide","carousel__autoplay-button":"fr-ec-carousel__autoplay-button","carouselAutoplayButton":"fr-ec-carousel__autoplay-button","carousel-medium":"fr-ec-carousel-medium","carouselMedium":"fr-ec-carousel-medium","carousel__frame--ec-renewal":"fr-ec-carousel__frame--ec-renewal","carouselFrameEcRenewal":"fr-ec-carousel__frame--ec-renewal","carousel-mobile":"fr-ec-carousel-mobile","carouselMobile":"fr-ec-carousel-mobile","carousel_frame--display-count-one":"fr-ec-carousel_frame--display-count-one","carouselFrameDisplayCountOne":"fr-ec-carousel_frame--display-count-one","carousel__frame--styling-variant-sm":"fr-ec-carousel__frame--styling-variant-sm","carouselFrameStylingVariantSm":"fr-ec-carousel__frame--styling-variant-sm","carousel__bottom-section--with-number-top":"fr-ec-carousel__bottom-section--with-number-top","carouselBottomSectionWithNumberTop":"fr-ec-carousel__bottom-section--with-number-top"};

var SCROLL_JITTER = 1;
var RE_SCROLL_ATTEMPTS = 2;
var PADDING_MOBILE$1 = 16;
var PADDING_IPAD$1 = 24;
var CarouselBase = /** @class */function (_super) {
  __extends(CarouselBase, _super);
  function CarouselBase(props) {
    var _this = _super.call(this, props) || this;
    _this.frameRef = /*#__PURE__*/createRef();
    _this.lastElementRef = /*#__PURE__*/createRef();
    _this.isTouching = false;
    _this.scrollLeft = 0;
    _this.frameWidth = 0;
    _this.isMaxScroll = false;
    _this.reScrollAttempts = 0;
    _this.timer = 0;
    _this.mouseDown = false;
    _this.componentDidMount = function () {
      // TODO: Remove this if this is breaking some where, commenting this to fix UXDS-3813
      // if (isInBrowser()) {
      //   document.addEventListener('mousedown', this.handleMouseDown, true);
      //   document.addEventListener('focus', this.handleDocumentFocus, true);
      // }
      if (_this.props.autoSlide) {
        _this.timer = window.setInterval(_this.onAutoScroll('next'), _this.props.autoSlideInterval);
        var element_1 = _this.frameRef.current;
        var frameWidth = element_1.getBoundingClientRect().width;
        var slideWidth = Math.round(frameWidth / _this.props.displayCount);
        _this.setState({
          slideWidth: slideWidth
        });
        if (element_1.lastElementChild && element_1.firstElementChild) {
          if (_this.props.maxIndex <= 1) {
            var firstElementChild = element_1.firstElementChild.cloneNode(true);
            var lastElementChild = element_1.lastElementChild.cloneNode(true);
            firstElementChild.style.width = "".concat(slideWidth, "px");
            lastElementChild.style.width = "".concat(slideWidth, "px");
            element_1.insertBefore(lastElementChild, element_1.firstElementChild);
            element_1.appendChild(firstElementChild);
          } else {
            element_1.insertBefore(element_1.lastElementChild, element_1.firstElementChild);
          }
          element_1.style.width = "".concat(slideWidth, "px");
          element_1.style.marginLeft = "-".concat(slideWidth, "px");
          setTimeout(function () {
            return element_1.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
          });
        }
      }
    };
    _this.componentDidUpdate = function (prevProps) {
      if (prevProps.arrowPositionSelector !== _this.props.arrowPositionSelector) {
        _this.updateArrowOffset();
      }
      if (prevProps.index !== _this.props.index) {
        _this.scrollToIndex(_this.props.index, false);
      }
      if (_this.props.slidesTotal !== prevProps.slidesTotal || _this.props.displayCount !== prevProps.displayCount) {
        _this.onResize(false);
      }
    };
    _this.componentWillUnmount = function () {
      // TODO: Remove this if this is breaking some where, commenting this to fix UXDS-3813
      // if (isInBrowser()) {
      //   document.removeEventListener('mousedown', this.handleMouseDown, true);
      //   document.removeEventListener('focus', this.handleDocumentFocus, true);
      // }
      if (_this.timer) {
        clearInterval(_this.timer);
      }
    };
    _this.onAutoScroll = function (direction) {
      return function () {
        var element = _this.frameRef.current;
        if (!element) {
          return;
        }
        if (direction === 'next') {
          element.style.transform = "translate(-".concat(_this.state.slideWidth, "px)");
          setTimeout(function () {
            if (element && element.firstElementChild) {
              element.appendChild(element.firstElementChild);
              element.style.transition = 'none';
              element.style.transform = 'translate(0)';
              setTimeout(function () {
                return element.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
              }, 30);
              _this.onIndexChange(_this.state.index >= _this.props.slidesTotal - 1 ? 0 : _this.state.index + 1);
            }
          }, 600);
        } else {
          element.style.transform = "translate(".concat(_this.state.slideWidth, "px)");
          setTimeout(function () {
            if (element && element.lastElementChild) {
              element.insertBefore(element.lastElementChild, element.firstElementChild);
              element.style.transition = 'none';
              element.style.transform = 'translate(0)';
              setTimeout(function () {
                return element.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
              }, 30);
              _this.onIndexChange(_this.state.index - 1);
            }
          }, 600);
        }
      };
    };
    _this.updateScrollValues = function () {
      var frameElement = _this.frameRef.current;
      _this.scrollLeft = frameElement ? frameElement.scrollLeft : 0;
      var frameScrollWidth = frameElement ? frameElement.scrollWidth : 0;
      _this.isMaxScroll = Math.abs(frameScrollWidth - _this.frameWidth - _this.scrollLeft) < SCROLL_JITTER;
    };
    _this.updateArrowOffset = function () {
      var frameElement = _this.frameRef.current;
      var offset;
      var video = 'video';
      var container = _this.frameRef.current;
      if (frameElement) {
        var childElements = Array.from(container.getElementsByTagName('li') || []);
        var firstElement = childElements[0];
        var videoElement = firstElement && firstElement.querySelector(video);
        var arrowPositionSelector = _this.props.arrowPositionSelector;
        if (videoElement) {
          arrowPositionSelector = video;
        }
        if (frameElement && arrowPositionSelector) {
          var element = frameElement.querySelector(arrowPositionSelector);
          if (element) {
            offset = getElementVerticalCenterInParent(element, frameElement);
          }
        }
        if (offset !== _this.state.arrowOffset) {
          _this.setState({
            arrowOffset: offset
          });
        }
      }
    };
    _this.scrollToIndex = function (index, instant) {
      if (instant === void 0) {
        instant = false;
      }
      var left = _this.state.slideWidth * index;
      if (Math.abs(_this.scrollLeft - left) < SCROLL_JITTER) {
        // Already there.
        if (_this.state.index !== index) {
          _this.onIndexChange(index);
        }
        return;
      }
      var element = _this.frameRef.current;
      if (!element) {
        return;
      }
      if (element.scrollTo && !instant) {
        element.scrollTo({
          behavior: 'smooth',
          left: left
        });
      } else {
        element.scrollLeft = left;
      }
    };
    _this.handleOnScroll = function (_) {
      _this.updateScrollValues();
      if (_this.isTouching) {
        return;
      }
      var index = _this.isMaxScroll ? _this.props.maxIndex : Math.round(_this.scrollLeft / _this.state.slideWidth);
      var isSnapped = Math.abs(index * _this.state.slideWidth - _this.scrollLeft) < SCROLL_JITTER;
      if (!_this.isMaxScroll && !isSnapped && _this.reScrollAttempts <= RE_SCROLL_ATTEMPTS) {
        /* For the browsers that do not support scroll snapping we need to manually run scroll to closest index, and hope it will get there */
        _this.reScrollAttempts++;
        _this.scrollToIndex(index);
      } else {
        _this.reScrollAttempts = 0;
        if (index === _this.userRequestedIndex) {
          _this.onIndexChange(index);
          _this.userRequestedIndex = undefined;
        } else if (_this.state.index !== index) {
          _this.onIndexChange(index);
        }
      }
    };
    // TODO: Remove this if this is breaking some where, commenting this to fix UXDS-3813
    // handleMouseDown = (_: MouseEvent) => {
    //   this.mouseDown = true;
    // };
    // handleDocumentFocus = (_: FocusEvent) => {
    //   // console.log('focus', this.mouseDown);
    //   if (!this.mouseDown) {
    //     const frameElement = this.frameRef.current;
    //     const activeElement = document.activeElement;
    //     if (frameElement && activeElement && frameElement.contains(activeElement)) {
    //       const box = activeElement.getBoundingClientRect();
    //       if (Math.round(this.props.slidesPerPage * this.state.slideWidth) <= Math.round(box.left)) {
    //         this.userRequestedIndex = this.state.index + 1;
    //         this.scrollToIndex(this.userRequestedIndex, true);
    //         // console.log('focus', 'slide');
    //       }
    //     }
    //   }
    //   this.mouseDown = false;
    // };
    _this.onPageClick = function (index) {
      _this.userRequestedIndex = index;
      _this.scrollToIndex(index);
    };
    _this.onSkipClick = function (_) {
      var lastElementRef = _this.lastElementRef.current;
      if (lastElementRef) {
        lastElementRef.focus();
      }
    };
    // Function to handle video pause and play when sliding in carousel
    _this.handleVideoChange = function (index) {
      if (_this.props.autoSlide) {
        var element = _this.frameRef.current;
        var childElements_1 = Array.from(element.getElementsByTagName('li') || []);
        var videos = Array.from(element.getElementsByTagName('video') || []);
        videos.forEach(function (video) {
          var isVisible = childElements_1[1].contains(video);
          if (video.readyState !== 0) {
            if (!isVisible) {
              video.pause();
            } else if (video.paused) {
              video.classList.remove('played');
              video.play();
              video.style.zIndex = '1';
            }
          }
        });
      } else {
        var _a = _this.props,
          displayCount = _a.displayCount,
          slidesTotal = _a.slidesTotal;
        var element = _this.frameRef.current;
        var childElements_2 = Array.from(element.getElementsByTagName('li') || []);
        var videos = Array.from(element.getElementsByTagName('video') || []);
        var videoIndexes_1 = __spreadArray([], _this.state.videoIndexes, true);
        var visibleIndexes_1 = __spreadArray([], range(index, index + displayCount > slidesTotal ? slidesTotal : index + displayCount), true);
        videos.forEach(function (video, ind) {
          var isVisible = visibleIndexes_1.some(function (indx) {
            return childElements_2[indx].contains(video);
          });
          if (video.readyState !== 0) {
            if (childElements_2[index].contains(video) || isVisible) {
              if (video.classList.contains('played')) {
                video.classList.remove('played');
                video.play();
              } else if (video.paused && videoIndexes_1.findIndex(function (it) {
                return it === ind;
              }) !== -1) {
                video.play();
                videoIndexes_1 = videoIndexes_1.filter(function (it) {
                  return it !== ind;
                });
              }
              video.style.zIndex = '1';
            } else if (video && !video.paused && !isVisible) {
              videoIndexes_1 = __spreadArray(__spreadArray([], videoIndexes_1, true), [ind], false);
              video.pause();
            }
          }
        });
        _this.setState({
          videoIndexes: videoIndexes_1
        });
      }
    };
    _this.onIndexChange = function (index) {
      _this.setState({
        index: index
      });
      _this.handleVideoChange(index);
      if (_this.props.onIndexChange) {
        _this.props.onIndexChange(index);
      }
    };
    _this.onResize = function (isDomUpdate) {
      if (isDomUpdate === void 0) {
        isDomUpdate = true;
      }
      var frameElement = _this.frameRef.current;
      var isMobileWidth = getCurrentMediaQueryBreakpoint() === BP_SMALL;
      var isMediumWidth = getCurrentMediaQueryBreakpoint() === BP_MEDIUM;
      if (frameElement && frameElement) {
        _this.frameWidth = frameElement.getBoundingClientRect().width;
        if (_this.props.autoSlide) {
          var slideWidth = Math.round(_this.frameWidth / _this.props.displayCount);
          frameElement.style.width = "".concat(slideWidth, "px");
          frameElement.style.marginLeft = "-".concat(slideWidth, "px");
        }
        _this.setState({
          isMedium: isMediumWidth,
          isMobile: isMobileWidth,
          slideWidth: Math.round(_this.frameWidth / _this.props.displayCount)
        }, function () {
          _this.updateScrollValues();
          _this.updateArrowOffset();
          _this.scrollToIndex(isDomUpdate ? _this.state.index : _this.props.index, true);
        });
      }
    };
    _this.onArrowClick = function (direction) {
      if (_this.props.autoSlide) {
        _this.onAutoScroll(direction)();
      } else {
        var arrowIncrement = _this.props.arrowIncrement;
        _this.userRequestedIndex = direction === ARROW_DIRECTION_NEXT ? _this.getNextIndex(_this.state.index, arrowIncrement) : _this.getPrevIndex(_this.state.index, arrowIncrement);
        _this.scrollToIndex(_this.userRequestedIndex);
      }
    };
    _this.getPrevIndex = function (index, arrowsIncrementType) {
      switch (arrowsIncrementType) {
        case ARROW_INCREMENT_SINGLE:
          return Math.max(index - 1, 0);
        case ARROW_INCREMENT_PAGE:
          return Math.max(index - _this.props.slidesPerPage, 0);
        case ARROW_INCREMENT_NONE:
        default:
          return 0;
      }
    };
    _this.getNextIndex = function (index, arrowsIncrementType) {
      switch (arrowsIncrementType) {
        case ARROW_INCREMENT_SINGLE:
          return Math.min(index + 1, _this.props.maxIndex);
        case ARROW_INCREMENT_PAGE:
          return Math.min(index + _this.props.slidesPerPage, _this.props.maxIndex);
        case ARROW_INCREMENT_NONE:
        default:
          return _this.props.maxIndex;
      }
    };
    _this.getTouchEvents = function () {
      return {
        onTouchCancel: function onTouchCancel(_) {
          _this.isTouching = false;
        },
        onTouchEnd: function onTouchEnd(_) {
          _this.isTouching = false;
        },
        onTouchStart: function onTouchStart(_) {
          _this.isTouching = true;
        }
      };
    };
    _this.onAutoSlidePauseButtonClick = function (event) {
      if (_this.state.autoSlide) {
        _this.setState({
          autoSlide: !_this.state.autoSlide
        });
        clearInterval(_this.timer);
      } else {
        _this.setState({
          autoSlide: !_this.state.autoSlide
        });
        _this.timer = window.setInterval(_this.onAutoScroll('next'), _this.props.autoSlideInterval);
      }
      if (_this.props.onAutoSlideTrigger) {
        _this.props.onAutoSlideTrigger(event);
      }
    };
    _this.getClickedSlideIndex = function (slideIndex) {
      _this.setState({
        clickedSlideIndex: slideIndex,
        isOpen: true
      });
    };
    _this.onRequestClose = function (activeSlide) {
      _this.setState({
        isOpen: false
      });
      if (_this.state.index !== activeSlide) {
        _this.onIndexChange(activeSlide);
      }
    };
    _this.state = {
      autoSlide: _this.props.autoSlide,
      clickedSlideIndex: 0,
      index: _this.props.index,
      isMedium: false,
      isMobile: false,
      isOpen: false,
      slideWidth: 0,
      videoIndexes: []
    };
    return _this;
  }
  CarouselBase.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      indicator = _a.indicator,
      arrowIncrement = _a.arrowIncrement,
      slidesTotal = _a.slidesTotal,
      displayCount = _a.displayCount,
      slidesPerPage = _a.slidesPerPage,
      noPadding = _a.noPadding,
      slidePlaceholder = _a.slidePlaceholder,
      _b = _a.skipLinkText,
      skipLinkText = _b === void 0 ? 'SKIP' : _b,
      carouselAriaLabel = _a.carouselAriaLabel,
      skipToId = _a.skipToId,
      autoSlide = _a.autoSlide,
      className = _a.className,
      keyboardNavigation = _a.keyboardNavigation,
      modelDetailsText = _a.modelDetailsText,
      modelDetailsLink = _a.modelDetailsLink,
      onArrowTrigger = _a.onArrowTrigger,
      _c = _a.hasArrows,
      hasArrows = _c === void 0 ? true : _c,
      _d = _a.variant,
      variant = _d === void 0 ? 'default' : _d,
      pinchZoomItems = _a.pinchZoomItems,
      enablePinchZoom = _a.enablePinchZoom,
      pinchZoomCloseLabel = _a.pinchZoomCloseLabel,
      iconBrand = _a.iconBrand,
      _e = _a.ecRenewal,
      ecRenewal = _e === void 0 ? false : _e,
      rest = __rest$1(_a, ["children", "indicator", "arrowIncrement", "slidesTotal", "displayCount", "slidesPerPage", "maxIndex", "noPadding", "slidePlaceholder", "skipLinkText", "carouselAriaLabel", "arrowPositionSelector", "onIndexChange", "skipToId", "autoSlide", "autoSlideInterval", "className", "keyboardNavigation", "modelDetailsText", "modelDetailsLink", "onAutoSlideTrigger", "onArrowTrigger", "hasArrows", "variant", "pinchZoomItems", "enablePinchZoom", "pinchZoomCloseLabel", "iconBrand", "ecRenewal"]);
    var _f = this.state,
      index = _f.index,
      clickedSlideIndex = _f.clickedSlideIndex,
      arrowOffset = _f.arrowOffset,
      isOpen = _f.isOpen;
    var showPrevArrow = arrowIncrement !== ARROW_INCREMENT_NONE && this.getPrevIndex(index, arrowIncrement) < index;
    var showNextArrow = arrowIncrement !== ARROW_INCREMENT_NONE && this.getNextIndex(index, arrowIncrement) > index;
    var skipLinkProps = skipToId ? {
      href: "#".concat(skipToId),
      element: 'a'
    } : {
      onClick: this.onSkipClick,
      element: 'button'
    };
    var carouselDisplayCount = this.props.autoSlide ? 1 : displayCount;
    var paddingMobile = noPadding ? 0 : PADDING_MOBILE$1;
    var paddingSize = this.state.isMedium ? PADDING_IPAD$1 : this.state.isMobile ? PADDING_MOBILE$1 : 0;
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Measure, {
      onResize: debounce(100, function () {
        return _this.onResize(true);
      })
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", __assign$1({
        className: joinClasses(styles$4$1.carousel, className),
        ref: measureRef,
        "aria-label": carouselAriaLabel
      }, rest), keyboardNavigation === 'item' && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Button, __assign$1({}, skipLinkProps, {
        className: styles$4$1.carouselSkip,
        variant: "secondary",
        isSmall: true,
        iconBrand: iconBrand
      }), skipLinkText), /*#__PURE__*/createElement(OverlayBackdrop, {
        className: styles$4$1.carouselOverlay
      }))), /*#__PURE__*/createElement("div", {
        className: styles$4$1.carouselScrollbarHide
      }, /*#__PURE__*/createElement("div", {
        className: styles$4$1.carouselContainer
      }, /*#__PURE__*/createElement("ul", __assign$1({
        className: joinClasses(noPadding ? styles$4$1.carouselFrame : styles$4$1.carouselFramePadded, noPadding && variant === 'ecRenewal' ? styles$4$1.carouselFrameEcRenewal : '', autoSlide && styles$4$1.carouselFrameShifting, variant === 'styling' && styles$4$1.carouselFrameStylingVariantSm, displayCount === 1 && styles$4$1.carouselFrameDisplayCountOne),
        ref: _this.frameRef,
        onScroll: debounce(100, _this.handleOnScroll)
      }, _this.getTouchEvents(), {
        tabIndex: -1
      }), /*#__PURE__*/createElement(CarouselSlides, {
        currentIndex: index,
        displayCount: carouselDisplayCount,
        placeholder: slidePlaceholder,
        noPadding: noPadding,
        isMobile: _this.state.isMobile,
        isMedium: _this.state.isMedium,
        slideWidth: carouselDisplayCount !== 1 && _this.state.isMobile && !ecRenewal && (variant === 'default' || variant === 'styling') ? _this.state.slideWidth - paddingMobile / carouselDisplayCount : variant === 'ecRenewal' || ecRenewal && variant === 'styling' ? _this.state.slideWidth - paddingSize / carouselDisplayCount : _this.state.slideWidth,
        carouselVariant: variant,
        getClickedSlideIndex: _this.getClickedSlideIndex,
        enablePinchZoom: enablePinchZoom ? true : false,
        ecRenewal: ecRenewal
      }, children)), showPrevArrow && hasArrows && (/*#__PURE__*/createElement(CarouselArrow, {
        displayCount: displayCount,
        keyboardNavigation: autoSlide ? 'arrow' : keyboardNavigation,
        direction: ARROW_DIRECTION_PREV,
        topOffset: arrowOffset,
        onClick: _this.onArrowClick,
        onArrowTrigger: onArrowTrigger,
        carouselVariant: variant,
        iconBrand: iconBrand,
        ecRenewal: ecRenewal
      })), showNextArrow && hasArrows && (/*#__PURE__*/createElement(CarouselArrow, {
        displayCount: displayCount,
        keyboardNavigation: autoSlide ? 'arrow' : keyboardNavigation,
        direction: ARROW_DIRECTION_NEXT,
        topOffset: arrowOffset,
        onClick: _this.onArrowClick,
        onArrowTrigger: onArrowTrigger,
        carouselVariant: variant,
        iconBrand: iconBrand,
        ecRenewal: ecRenewal
      })))), variant && variant === 'media-gallery' ? (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$4$1.carouselBottomSection, styles$4$1.carouselBottomSectionWithNumberTop)
      }, /*#__PURE__*/createElement(CarouselPagination, {
        currentIndex: index,
        total: slidesTotal,
        itemsPerPage: slidesPerPage,
        indicatorType: indicator,
        forceLast: _this.isMaxScroll,
        autoSlide: autoSlide,
        carouselVariant: variant
      })), /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$4$1.carouselBottomSection, styles$4$1.carouselBottomSectionWithNumberBottom)
      }, autoSlide && (/*#__PURE__*/createElement(ButtonIcon, {
        className: styles$4$1.carouselAutoplayButton,
        "aria-label": _this.state.autoSlide ? 'pause' : 'play',
        element: "button",
        icon: _this.state.autoSlide ? 'pause' : 'play',
        onClick: _this.onAutoSlidePauseButtonClick,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      })), modelDetailsText && indicator === 'number' && !modelDetailsLink && (/*#__PURE__*/createElement(Caption, {
        element: "span",
        variant: "small",
        color: "secondary",
        className: joinClasses(autoSlide && styles$4$1.carouselModelDetailsWithAutoSlide)
      }, modelDetailsText)), modelDetailsText && indicator === 'number' && modelDetailsLink && (/*#__PURE__*/createElement(ActionableContent, {
        className: styles$4$1.carouselModelDetailsWrapper,
        variant: "link-text",
        actions: modelDetailsLink,
        content: /*#__PURE__*/createElement(Caption, {
          element: "span",
          className: joinClasses(autoSlide && styles$4$1.carouselModelDetailsWithAutoSlide),
          variant: "small",
          color: "secondary"
        }, modelDetailsText)
      })), !modelDetailsText && indicator === 'number' && modelDetailsLink && modelDetailsLink))) : ecRenewal ? null : (/*#__PURE__*/createElement("div", {
        className: joinClasses(styles$4$1.carouselBottomSection, indicator === 'number' && styles$4$1.carouselBottomSectionWithNumber, variant !== 'default' && styles$4$1.carouselMobile, variant === 'ecRenewal' && styles$4$1.carouselMedium, (indicator === 'none' || ecRenewal) && styles$4$1.carouselBottomSectionNone, indicator === 'pages' && Math.ceil(slidesTotal / slidesPerPage) <= 1 && styles$4$1.carouselBottomSectionNone)
      }, /*#__PURE__*/createElement(CarouselPagination, {
        currentIndex: index,
        total: slidesTotal,
        itemsPerPage: slidesPerPage,
        indicatorType: indicator,
        forceLast: _this.isMaxScroll,
        autoSlide: autoSlide,
        carouselVariant: variant
      }), autoSlide && (/*#__PURE__*/createElement(ButtonIcon, {
        className: styles$4$1.carouselAutoplayButton,
        "aria-label": _this.state.autoSlide ? 'pause' : 'play',
        element: "button",
        icon: _this.state.autoSlide ? 'pause' : 'play',
        onClick: _this.onAutoSlidePauseButtonClick,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      })), modelDetailsText && indicator === 'number' && !modelDetailsLink && (/*#__PURE__*/createElement(Body, {
        element: "span",
        color: "secondary",
        variant: "small",
        className: joinClasses(autoSlide && styles$4$1.carouselModelDetailsWithAutoSlide)
      }, modelDetailsText)), modelDetailsText && indicator === 'number' && modelDetailsLink && (/*#__PURE__*/createElement(ActionableContent, {
        className: styles$4$1.carouselModelDetailsWrapper,
        variant: "link-text",
        actions: modelDetailsLink,
        content: /*#__PURE__*/createElement(Body, {
          element: "span",
          color: "secondary",
          variant: "small",
          className: joinClasses(autoSlide && styles$4$1.carouselModelDetailsWithAutoSlide)
        }, modelDetailsText)
      })), !modelDetailsText && indicator === 'number' && modelDetailsLink && modelDetailsLink)), !skipToId && /*#__PURE__*/createElement("div", {
        ref: _this.lastElementRef,
        tabIndex: -1,
        "aria-hidden": "true"
      }));
    }), isOpen && (/*#__PURE__*/createElement("div", {
      className: styles$4$1.carouselWithPinchZoom
    }, /*#__PURE__*/createElement("div", {
      className: styles$4$1.pinchZoomCarouselWrapper
    }, /*#__PURE__*/createElement(MediaCarousel, {
      activeSlideIndex: clickedSlideIndex,
      children: [],
      enablePinchZoom: enablePinchZoom,
      pinchZoomItems: pinchZoomItems,
      onPinchZoomCloseClick: this.onRequestClose,
      pinchZoomCloseLabel: pinchZoomCloseLabel,
      iconBrand: iconBrand
    })))));
  };
  return CarouselBase;
}(Component);

var Carousel = /** @class */function (_super) {
  __extends(Carousel, _super);
  function Carousel(props) {
    var _this = _super.call(this, props) || this;
    _this.onWindowSize = debounce(100, function (_) {
      _this.setState({
        breakpoint: getCurrentMediaQueryBreakpoint()
      });
    });
    _this.componentDidMount = function () {
      if (isInBrowser$1()) {
        window.addEventListener('resize', _this.onWindowSize);
      }
    };
    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', _this.onWindowSize);
      }
    };
    _this.state = {
      breakpoint: getCurrentMediaQueryBreakpoint()
    };
    return _this;
  }
  Carousel.prototype.render = function () {
    var _a = this.props,
      _b = _a.displayCount,
      displayCount = _b === void 0 ? 1 : _b,
      _c = _a.indicator,
      indicator = _c === void 0 ? INDICATOR_PAGES : _c,
      _d = _a.index,
      index = _d === void 0 ? 0 : _d,
      children = _a.children,
      _e = _a.arrowsIncrement,
      arrowsIncrement = _e === void 0 ? ARROW_INCREMENT_PAGE : _e,
      _f = _a.autoSlide,
      autoSlide = _f === void 0 ? false : _f,
      _g = _a.autoSlideInterval,
      autoSlideInterval = _g === void 0 ? 6000 : _g,
      _h = _a.keyboardNavigation,
      keyboardNavigation = _h === void 0 ? 'item' : _h,
      _j = _a.variant,
      variant = _j === void 0 ? 'default' : _j,
      hasArrows = _a.hasArrows,
      pinchZoomItems = _a.pinchZoomItems,
      _k = _a.enablePinchZoom,
      enablePinchZoom = _k === void 0 ? false : _k,
      _l = _a.pinchZoomCloseLabel,
      pinchZoomCloseLabel = _l === void 0 ? '' : _l,
      iconBrand = _a.iconBrand,
      _m = _a.ecRenewal,
      ecRenewal = _m === void 0 ? false : _m,
      _o = _a.loop,
      loop = _o === void 0 ? false : _o,
      skipLinkText = _a.skipLinkText,
      rest = __rest$1(_a, ["displayCount", "indicator", "index", "children", "arrowsIncrement", "autoSlide", "autoSlideInterval", "keyboardNavigation", "variant", "hasArrows", "pinchZoomItems", "enablePinchZoom", "pinchZoomCloseLabel", "iconBrand", "ecRenewal", "loop", "skipLinkText"]);
    var displayCountProp = Math.max(typeof displayCount === 'number' ? displayCount : displayCount[this.state.breakpoint], 1);
    var slidesPerPage = Math.floor(displayCountProp);
    var indicatorProp = typeof indicator === 'string' ? indicator : indicator[this.state.breakpoint];
    var arrowsIncrementProp = typeof arrowsIncrement === 'string' ? arrowsIncrement : arrowsIncrement[this.state.breakpoint];
    var slidesTotal = Children.toArray(children).length;
    var maxIndex = Math.max(slidesTotal - slidesPerPage, 0);
    var indexProp = index < 0 ? 0 : Math.min(maxIndex, index);
    // const noPaddingProp = noPadding || displayCountProp === 1;
    var noPaddingProp = displayCountProp === 1;
    var slideInterval = autoSlideInterval < 0 ? 0 : autoSlideInterval;
    var gaProps = {};
    if (this.props.gaCategory && this.props.gaLabel) {
      gaProps = {
        'data-category': this.props.gaCategory,
        'data-label': this.props.gaLabel
      };
    }
    return /*#__PURE__*/createElement(CarouselBase, __assign$1({
      displayCount: displayCountProp,
      indicator: indicatorProp,
      index: indexProp,
      maxIndex: maxIndex,
      slidesTotal: slidesTotal,
      arrowIncrement: arrowsIncrementProp,
      slidesPerPage: slidesPerPage,
      noPadding: noPaddingProp,
      autoSlide: autoSlide,
      autoSlideInterval: slideInterval,
      keyboardNavigation: keyboardNavigation,
      variant: variant,
      hasArrows: hasArrows,
      pinchZoomItems: pinchZoomItems,
      enablePinchZoom: enablePinchZoom,
      pinchZoomCloseLabel: pinchZoomCloseLabel,
      iconBrand: iconBrand,
      ecRenewal: ecRenewal,
      loop: loop,
      skipLinkText: skipLinkText
    }, gaProps, rest), children);
  };
  Carousel.displayName = 'CoreCarousel';
  Carousel.defaultProps = {
    arrowsIncrement: ARROW_INCREMENT_PAGE,
    displayCount: 1,
    index: 0,
    indicator: INDICATOR_PAGES,
    noPadding: false
  };
  return Carousel;
}(Component);

var styles$5$1 = {"checkbox":"fr-ec-checkbox","checkbox__label":"fr-ec-checkbox__label","checkboxLabel":"fr-ec-checkbox__label","checkbox__required-badge":"fr-ec-checkbox__required-badge","checkboxRequiredBadge":"fr-ec-checkbox__required-badge","lang-ja":"fr-ec-lang-ja","langJa":"fr-ec-lang-ja","checkbox__input":"fr-ec-checkbox__input","checkboxInput":"fr-ec-checkbox__input","checkbox__children":"fr-ec-checkbox__children","checkboxChildren":"fr-ec-checkbox__children","checkbox__image":"fr-ec-checkbox__image","checkboxImage":"fr-ec-checkbox__image","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","checkbox__input--image":"fr-ec-checkbox__input--image","checkboxInputImage":"fr-ec-checkbox__input--image","checkbox__check":"fr-ec-checkbox__check","checkboxCheck":"fr-ec-checkbox__check","checkbox__input--default":"fr-ec-checkbox__input--default","checkboxInputDefault":"fr-ec-checkbox__input--default","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","checkbox__input--white":"fr-ec-checkbox__input--white","checkboxInputWhite":"fr-ec-checkbox__input--white","checkbox__input--gray":"fr-ec-checkbox__input--gray","checkboxInputGray":"fr-ec-checkbox__input--gray","checkbox__input--black":"fr-ec-checkbox__input--black","checkboxInputBlack":"fr-ec-checkbox__input--black","checkbox__input--pink":"fr-ec-checkbox__input--pink","checkboxInputPink":"fr-ec-checkbox__input--pink","checkbox__input--red":"fr-ec-checkbox__input--red","checkboxInputRed":"fr-ec-checkbox__input--red","checkbox__input--orange":"fr-ec-checkbox__input--orange","checkboxInputOrange":"fr-ec-checkbox__input--orange","checkbox__input--beige":"fr-ec-checkbox__input--beige","checkboxInputBeige":"fr-ec-checkbox__input--beige","checkbox__input--brown":"fr-ec-checkbox__input--brown","checkboxInputBrown":"fr-ec-checkbox__input--brown","checkbox__input--yellow":"fr-ec-checkbox__input--yellow","checkboxInputYellow":"fr-ec-checkbox__input--yellow","checkbox__input--green":"fr-ec-checkbox__input--green","checkboxInputGreen":"fr-ec-checkbox__input--green","checkbox__input--blue":"fr-ec-checkbox__input--blue","checkboxInputBlue":"fr-ec-checkbox__input--blue","checkbox__input--purple":"fr-ec-checkbox__input--purple","checkboxInputPurple":"fr-ec-checkbox__input--purple"};

var Checkbox = /*#__PURE__*/forwardRef(function (_a, ref) {
  var label = _a.label,
    name = _a.name,
    checked = _a.checked,
    onChange = _a.onChange,
    value = _a.value,
    color = _a.color,
    id = _a.id,
    disabled = _a.disabled,
    children = _a.children,
    className = _a.className,
    labelVariant = _a.labelVariant,
    iconBrand = _a.iconBrand,
    image = _a.image,
    required = _a.required,
    props = __rest$1(_a, ["label", "name", "checked", "onChange", "value", "color", "id", "disabled", "children", "className", "labelVariant", "iconBrand", "image", "required"]);
  var hasChildren = Children.toArray(children).length > 0;
  var childrenId = hasChildren ? "".concat(id, "__content") : '';
  var _b = useState(false),
    noImage = _b[0],
    toggleNoImage = _b[1];
  var handleImageErrored = function handleImageErrored(event) {
    toggleNoImage(true);
  };
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$5$1.checkbox, className)
  }, /*#__PURE__*/createElement("input", __assign$1({
    type: "checkbox",
    className: joinClasses(styles$5$1.checkboxInput, image ? styles$5$1["checkbox__input--image"] : styles$5$1["checkbox__input--".concat(color)] || styles$5$1.checkboxInputDefault, interactionsStyles.cursorPointer),
    value: value,
    name: name,
    checked: checked,
    onChange: onChange,
    id: id,
    disabled: disabled,
    "aria-describedby": childrenId,
    ref: ref,
    required: required
  }, props)), /*#__PURE__*/createElement("label", {
    htmlFor: id,
    className: joinClasses(styles$5$1.checkboxLabel, resetStyles.maxWidthReset, interactionsStyles.cursorPointer)
  }, image ? !noImage ? (/*#__PURE__*/createElement("img", {
    className: styles$5$1.checkboxImage,
    src: image,
    onError: handleImageErrored,
    alt: "default image"
  })) : (/*#__PURE__*/createElement(NoImage, {
    className: styles$5$1.checkboxImage,
    iconBrand: iconBrand,
    imageSize: "small",
    imageType: "icon"
  })) : null, checked ? (/*#__PURE__*/createElement(Icon, {
    className: styles$5$1.checkboxCheck,
    name: iconBrand ? "".concat(iconBrand, "check-large") : 'check-large'
  })) : null, /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: labelVariant,
    color: disabled ? 'disabled' : 'primary-dark'
  }, label, required && /*#__PURE__*/createElement("span", {
    className: styles$5$1.checkboxRequiredBadge
  }))), hasChildren && (/*#__PURE__*/createElement("div", {
    id: childrenId,
    className: styles$5$1.checkboxChildren
  }, children)));
});
Checkbox.displayName = 'CoreCheckbox';
Checkbox.defaultProps = {
  disabled: false,
  labelVariant: 'standard'
};

var styles$6$1 = {"dropdown":"fr-ec-dropdown","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","dropdown-ec-renewal":"fr-ec-dropdown-ec-renewal","dropdownEcRenewal":"fr-ec-dropdown-ec-renewal","dropdown__input":"fr-ec-dropdown__input","dropdownInput":"fr-ec-dropdown__input","dropdown__container--fit-to-content":"fr-ec-dropdown__container--fit-to-content","dropdownContainerFitToContent":"fr-ec-dropdown__container--fit-to-content","dropdown__option":"fr-ec-dropdown__option","dropdownOption":"fr-ec-dropdown__option","dropdown-ec-renewal__form-text":"fr-ec-dropdown-ec-renewal__form-text","dropdownEcRenewalFormText":"fr-ec-dropdown-ec-renewal__form-text","dropdown-ec-renewal__dropdown-list":"fr-ec-dropdown-ec-renewal__dropdown-list","dropdownEcRenewalDropdownList":"fr-ec-dropdown-ec-renewal__dropdown-list","dropdown__list--show":"fr-ec-dropdown__list--show","dropdownListShow":"fr-ec-dropdown__list--show","dropdown-ec-renewal__dropdown-list--without-label":"fr-ec-dropdown-ec-renewal__dropdown-list--without-label","dropdownEcRenewalDropdownListWithoutLabel":"fr-ec-dropdown-ec-renewal__dropdown-list--without-label","dropdown__option-positioning-top":"fr-ec-dropdown__option-positioning-top","dropdownOptionPositioningTop":"fr-ec-dropdown__option-positioning-top","dropdown__icon":"fr-ec-dropdown__icon","dropdownIcon":"fr-ec-dropdown__icon","dropdown__list":"fr-ec-dropdown__list","dropdownList":"fr-ec-dropdown__list","dropdown__pill-form-label":"fr-ec-dropdown__pill-form-label","dropdownPillFormLabel":"fr-ec-dropdown__pill-form-label","dropdown__pill-form-input":"fr-ec-dropdown__pill-form-input","dropdownPillFormInput":"fr-ec-dropdown__pill-form-input","dropdown__hidden-options":"fr-ec-dropdown__hidden-options","dropdownHiddenOptions":"fr-ec-dropdown__hidden-options","dropdown__input-container":"fr-ec-dropdown__input-container","dropdownInputContainer":"fr-ec-dropdown__input-container","dropdown__input-container--fit-to-content":"fr-ec-dropdown__input-container--fit-to-content","dropdownInputContainerFitToContent":"fr-ec-dropdown__input-container--fit-to-content","dropdown__input-inner-container":"fr-ec-dropdown__input-inner-container","dropdownInputInnerContainer":"fr-ec-dropdown__input-inner-container","dropdown__hidden-option":"fr-ec-dropdown__hidden-option","dropdownHiddenOption":"fr-ec-dropdown__hidden-option","dropdown__list--max-height":"fr-ec-dropdown__list--max-height","dropdownListMaxHeight":"fr-ec-dropdown__list--max-height","dropdown__list--option-position-top":"fr-ec-dropdown__list--option-position-top","dropdownListOptionPositionTop":"fr-ec-dropdown__list--option-position-top","dropdown__option--with-link":"fr-ec-dropdown__option--with-link","dropdownOptionWithLink":"fr-ec-dropdown__option--with-link","dropdown__link":"fr-ec-dropdown__link","dropdownLink":"fr-ec-dropdown__link","dropdown__option-selected-icon":"fr-ec-dropdown__option-selected-icon","dropdownOptionSelectedIcon":"fr-ec-dropdown__option-selected-icon","dropdown__option--active":"fr-ec-dropdown__option--active","dropdownOptionActive":"fr-ec-dropdown__option--active","dropdown__option--required-placeholder":"fr-ec-dropdown__option--required-placeholder","dropdownOptionRequiredPlaceholder":"fr-ec-dropdown__option--required-placeholder","dropdown__option-media":"fr-ec-dropdown__option-media","dropdownOptionMedia":"fr-ec-dropdown__option-media","dropdown__option--ecrenwal-autofill":"fr-ec-dropdown__option--ecrenwal-autofill","dropdownOptionEcrenwalAutofill":"fr-ec-dropdown__option--ecrenwal-autofill","dropdown__label":"fr-ec-dropdown__label","dropdownLabel":"fr-ec-dropdown__label","dropdown__input--has-value":"fr-ec-dropdown__input--has-value","dropdownInputHasValue":"fr-ec-dropdown__input--has-value","dropdown__input--error":"fr-ec-dropdown__input--error","dropdownInputError":"fr-ec-dropdown__input--error","dropdown__input--with-placeholder":"fr-ec-dropdown__input--with-placeholder","dropdownInputWithPlaceholder":"fr-ec-dropdown__input--with-placeholder","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","dropdown__mobile-wrapper":"fr-ec-dropdown__mobile-wrapper","dropdownMobileWrapper":"fr-ec-dropdown__mobile-wrapper","dropdown__icon-mobile":"fr-ec-dropdown__icon-mobile","dropdownIconMobile":"fr-ec-dropdown__icon-mobile","dropdown__search-wrapper":"fr-ec-dropdown__search-wrapper","dropdownSearchWrapper":"fr-ec-dropdown__search-wrapper","search__input":"fr-ec-search__input","searchInput":"fr-ec-search__input","search__input-rounded":"fr-ec-search__input-rounded","searchInputRounded":"fr-ec-search__input-rounded","dropdown__search-focussed":"fr-ec-dropdown__search-focussed","dropdownSearchFocussed":"fr-ec-dropdown__search-focussed","search__icon_rounded":"fr-ec-search__icon_rounded","searchIconRounded":"fr-ec-search__icon_rounded","search__clear-button":"fr-ec-search__clear-button","searchClearButton":"fr-ec-search__clear-button","icon":"fr-ec-icon","search__input-rounded-active":"fr-ec-search__input-rounded-active","searchInputRoundedActive":"fr-ec-search__input-rounded-active"};

var DropdownComponent = /** @class */function (_super) {
  __extends(DropdownComponent, _super);
  function DropdownComponent(props) {
    var _this = _super.call(this, props) || this;
    _this.getSelectedValue = function () {
      var _a = _this.props,
        _b = _a.value,
        value = _b === void 0 ? '' : _b,
        _c = _a.options,
        options = _c === void 0 ? [] : _c,
        _d = _a.placeholder,
        placeholder = _d === void 0 ? '' : _d;
      if (value) {
        var selectedOption = options.find(function (item) {
          return item.value === value;
        });
        return selectedOption || {
          label: '',
          value: ''
        };
      } else {
        return placeholder ? {
          label: placeholder,
          media: undefined,
          value: ''
        } : __assign$1({}, options[0]);
      }
    };
    _this.getRenderOptions = function () {
      var mediaProps = {
        className: styles$6$1.dropdownOptionMedia,
        noImage: {
          imageType: 'euro'
        }
      };
      var _a = _this.props,
        placeholder = _a.placeholder,
        options = _a.options,
        placeHolderUrl = _a.placeHolderUrl;
      var modifiedOptions = options.map(function (item) {
        var _a;
        return item.media ? __assign$1(__assign$1({}, item), {
          media: (_a = Children.map(item.media, function (child, i) {
            return /*#__PURE__*/cloneElement(child, mediaProps);
          })) === null || _a === void 0 ? void 0 : _a[0]
        }) : item;
      });
      return placeholder ? __spreadArray([{
        label: placeholder,
        value: '',
        url: placeHolderUrl
      }], modifiedOptions, true) : modifiedOptions;
    };
    _this.globalClickListener = function () {
      if (_this.state.dropDownMenuVisible) {
        _this.setState({
          show: true,
          dropDownMenuVisible: false
        });
      } else {
        _this.setState({
          show: false,
          dropDownMenuVisible: false
        });
      }
    };
    _this.handleDropdownChange = function (item, notSelectable) {
      return function (event) {
        event.preventDefault();
        _this.setState({
          isSearchFocused: false
        });
        if (!notSelectable) {
          _this.setState({
            hoverItem: item,
            selected: item,
            selectedValue: item,
            show: false
          });
          if (_this.props.onChange) {
            _this.props.onChange(event, item.value);
          }
        }
      };
    };
    _this.setOptionsPostion = function () {
      var _a, _b;
      if (isInBrowser$1()) {
        var dropdownPosition = (_a = _this.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var dropdownListPosition = (_b = _this.dropdownListRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();
        if (dropdownListPosition && dropdownPosition) {
          var isVisible = dropdownPosition.bottom + 44 + dropdownListPosition.height <= window.innerHeight;
          if (isVisible) {
            _this.setState({
              showOptionBelow: true
            });
          } else {
            _this.setState({
              showOptionBelow: false
            });
          }
          if (_this.context) {
            /*
            this is for fixed positioned dropdown
            top value of the dropdown is added with the height of the dropdown input and the padding.
            Added width for dropdown select menu based on dropdown input width
             */
            var bottomVal = "calc(".concat(dropdownPosition.top, "px + 44px + 8px)");
            _this.setState({
              bottomVal: isVisible ? bottomVal : "calc(".concat(window.innerHeight - dropdownPosition.bottom, "px)"),
              selectMenuWidth: "".concat(dropdownPosition.width, "px")
            });
          }
        }
      }
    };
    _this.handleInputClick = function (event) {
      _this.setOptionsPostion();
      if (!_this.state.dropDownMenuVisible && _this.state.show) {
        _this.setState({
          dropDownMenuVisible: false,
          show: false
        });
      } else {
        _this.setState(function (prevState) {
          return {
            dropDownMenuVisible: !prevState.dropDownMenuVisible,
            hoverItem: _this.state.selected,
            show: !prevState.show
          };
        }, function () {
          if (_this.state.show) {
            document.addEventListener('click', _this.globalClickListener);
          }
        });
      }
      if (_this.props.onClick) {
        _this.props.onClick(event, _this.state.selected.value);
      }
    };
    _this.handleMouseDown = function (event) {
      if (event.keyCode === KEYCODE.TAB && !_this.state.show) {
        return false;
      }
      var hoverItem = _this.state.hoverItem;
      var _a = _this.props,
        placeholder = _a.placeholder,
        required = _a.required;
      var renderOptions = _this.getRenderOptions();
      var hoverIndex = renderOptions.findIndex(function (option) {
        return option.label === hoverItem.label;
      });
      if (event.keyCode === KEYCODE.ESC || event.keyCode === KEYCODE.TAB) {
        _this.setState({
          show: false,
          hoverItem: _this.state.selected
        });
      }
      if (event.keyCode === KEYCODE.ENTER) {
        if (!_this.state.show) {
          _this.setOptionsPostion();
          _this.setState({
            show: true
          });
        } else if (!(required && placeholder && placeholder === hoverItem.label)) {
          _this.setState({
            show: false,
            selected: hoverItem
          });
          if (_this.props.onChange) {
            _this.props.onChange(event, hoverItem.value);
          }
        }
      }
      if (event.keyCode === KEYCODE.DOWN) {
        if (!_this.state.show) {
          _this.setOptionsPostion();
          _this.setState({
            show: true
          });
        } else if (hoverIndex + 1 < renderOptions.length && _this.dropdownListRef.current) {
          _this.setState({
            hoverItem: renderOptions[hoverIndex + 1]
          }, function () {
            var _a, _b;
            return (_b = (_a = _this.dropdownListRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("#option-".concat(hoverIndex + 1))) === null || _b === void 0 ? void 0 : _b.focus();
          });
        }
      }
      if (event.keyCode === KEYCODE.UP && hoverIndex - 1 >= 0 && _this.dropdownListRef.current) {
        _this.setState({
          hoverItem: renderOptions[hoverIndex - 1]
        }, function () {
          var _a, _b;
          return (_b = (_a = _this.dropdownListRef.current) === null || _a === void 0 ? void 0 : _a.querySelector("#option-".concat(hoverIndex - 1))) === null || _b === void 0 ? void 0 : _b.focus();
        });
      }
      return true;
    };
    _this.handleInputBlur = function (event) {
      var hasClass = event.relatedTarget !== null ? event.relatedTarget.classList.contains(styles$6$1.dropdownInput) : false;
      if (!_this.state.dropDownMenuVisible && !_this.state.show && event.relatedTarget !== null && !hasClass) {
        _this.setState({
          show: false,
          hoverItem: _this.state.selected
        });
      }
      if (_this.props.onBlur) {
        _this.props.onBlur(event, _this.state.selected.value);
      }
    };
    _this.handleChange = function (event) {
      _this.setState({
        hoverItem: {
          value: event.target.value,
          label: event.target.value
        },
        selected: {
          value: event.target.value,
          label: event.target.value
        }
      });
      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    };
    _this.handleSelectBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event, _this.state.selected.value);
      }
    };
    _this.handleSearchFocus = function () {
      _this.setState({
        isSearchFocused: true
      });
    };
    _this.handleSearchBlur = function () {
      _this.setState({
        isSearchFocused: false
      });
    };
    _this.getMenuItemContent = function (menuItem) {
      var _a = _this.props,
        ecRenewal = _a.ecRenewal,
        iconBrand = _a.iconBrand;
      var selected = _this.state.selected;
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Icon, {
        className: styles$6$1.dropdownOptionSelectedIcon,
        name: iconBrand ? "".concat(iconBrand, "check-large") : 'check-large',
        size: "24",
        variant: "default"
      }), menuItem.media ? (/*#__PURE__*/createElement(ContentAlignment, {
        element: 'div',
        direction: 'row',
        alignment: "center"
      }, menuItem.media, /*#__PURE__*/createElement("span", {
        className: typographyStyles.bodyStandard
      }, menuItem.label))) : (/*#__PURE__*/createElement("span", {
        className: joinClasses(typographyStyles.bodyStandard, ecRenewal && styles$6$1.dropdownEcRenewalFormText)
      }, ecRenewal == true ? (/*#__PURE__*/createElement(PillForm, {
        variant: selected.label === menuItem.label && selected.value === menuItem.value ? 'emphasized' : 'standard'
      }, menuItem.label)) : menuItem.label)));
    };
    _this.onLinkClick = function (e) {
      e.preventDefault();
    };
    _this.state = {
      bottomVal: 'auto',
      dropDownMenuVisible: false,
      hoverItem: _this.getSelectedValue(),
      selectMenuWidth: '0px',
      selected: _this.getSelectedValue(),
      selectedValue: _this.getSelectedValue(),
      show: false,
      showOptionBelow: true,
      ecRenewal: false,
      isSearchFocused: false
    };
    _this.dropdownRef = props.forwardRef || /*#__PURE__*/createRef();
    _this.dropdownListRef = /*#__PURE__*/createRef();
    return _this;
  }
  DropdownComponent.prototype.componentDidMount = function () {
    document.addEventListener('click', this.globalClickListener);
    window.addEventListener('scroll', this.setOptionsPostion);
    window.addEventListener('resize', this.setOptionsPostion);
  };
  DropdownComponent.prototype.componentWillUnmount = function () {
    document.removeEventListener('click', this.globalClickListener);
    window.removeEventListener('scroll', this.setOptionsPostion);
    window.removeEventListener('resize', this.setOptionsPostion);
  };
  DropdownComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a;
    if (prevProps.value !== this.props.value || prevProps.options !== this.props.options) {
      this.setState({
        selected: this.getSelectedValue()
      });
    }
    var dropdownPosition = (_a = this.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    if (prevState.selectMenuWidth !== "".concat(dropdownPosition === null || dropdownPosition === void 0 ? void 0 : dropdownPosition.width, "px")) {
      this.setState({
        selectMenuWidth: "".concat(dropdownPosition === null || dropdownPosition === void 0 ? void 0 : dropdownPosition.width, "px")
      });
    }
  };
  DropdownComponent.prototype.render = function () {
    var _this = this;
    var _a;
    var _b = this.props,
      placeholder = _b.placeholder,
      _c = _b.options,
      options = _c === void 0 ? [] : _c,
      hideLabel = _b.hideLabel,
      id = _b.id,
      label = _b.label,
      disabled = _b.disabled,
      required = _b.required,
      error = _b.error,
      helptext = _b.helptext,
      _d = _b.updateMaxHeight,
      updateMaxHeight = _d === void 0 ? false : _d,
      fitToContent = _b.fitToContent,
      className = _b.className,
      _e = _b.isNative,
      isNative = _e === void 0 ? false : _e,
      iconBrand = _b.iconBrand,
      dropdownMenuWidth = _b.dropdownMenuWidth,
      _g = _b.ecRenewal,
      ecRenewal = _g === void 0 ? false : _g,
      searchArea = _b.searchArea,
      other = __rest$1(_b, ["placeholder", "options", "hideLabel", "id", "label", "disabled", "required", "onChange", "onBlur", "onClick", "forwardRef", "error", "helptext", "updateMaxHeight", "value", "fitToContent", "className", "isNative", "iconBrand", "dropdownMenuWidth", "optionPosition", "ecRenewal", "searchArea", "placeHolderUrl"]);
    var _h = this.state,
      selected = _h.selected,
      selectedValue = _h.selectedValue;
    var iOSOrAndroid = getOS() === 'android' || getOS() === 'iOS';
    var hintErrorId = helptext || error ? "".concat(id, "-hint-error") : undefined;
    var renderOptions = this.getRenderOptions();
    var dropdownContainerClasses = joinClasses(styles$6$1.dropdownContainer, fitToContent ? styles$6$1.dropdownContainerFitToContent : '');
    var inputClasses = joinClasses(resetStyles.maxWidthReset, styles$6$1.dropdownInput, typographyStyles.formText, selected.label === placeholder && !selected.value ? styles$6$1.dropdownInputWithPlaceholder : styles$6$1.dropdownInputHasValue, error ? styles$6$1.dropdownInputError : '');
    var dropDownPositioning = this.props.optionPosition === 'top' && this.props.updateMaxHeight ? {
      bottom: '79px',
      width: this.state.selectMenuWidth
    } : this.context ? this.state.showOptionBelow ? {
      top: this.state.bottomVal,
      width: this.state.selectMenuWidth
    } : {
      bottom: this.state.bottomVal,
      width: this.state.selectMenuWidth
    } : dropdownMenuWidth ? {
      width: "".concat(dropdownMenuWidth, "px")
    } : {};
    var dropdownPosition = (_a = this.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var isElementVisible = false;
    if (dropdownPosition) {
      isElementVisible = dropdownPosition.top >= 0 && dropdownPosition.left >= 0 && dropdownPosition.bottom <= (window.innerHeight || document.documentElement.clientHeight) && dropdownPosition.right <= (window.innerWidth || document.documentElement.clientWidth);
    }
    var isSearchFocused = this.state.isSearchFocused;
    var emojiRegex = /(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEDC-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDDFF\uDE70-\uDE7C\uDE80-\uDE89\uDE8F-\uDEC6\uDECE-\uDEDC\uDEDF-\uDEE9\uDEF0-\uDEF8])/;
    return /*#__PURE__*/createElement(Fragment, null, !(isNative && iOSOrAndroid) ? (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$6$1.dropdown, ecRenewal && styles$6$1.dropdownEcRenewal, className)
    }, /*#__PURE__*/createElement("div", {
      className: dropdownContainerClasses
    }, !hideLabel && label && (/*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      element: "label",
      className: joinClasses(styles$6$1.dropdownLabel, resetStyles.maxWidthReset),
      disabled: disabled,
      required: required
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$6$1.dropdownInputContainer, fitToContent && styles$6$1.dropdownInputContainerFitToContent)
    }, /*#__PURE__*/createElement("select", __assign$1({
      className: joinClasses(inputClasses, styles$6$1.dropdownHiddenOptions),
      ref: this.dropdownRef,
      required: required,
      value: selected.value,
      // tslint:disable-next-line
      onChange: function onChange() {}
    }, other), placeholder && (
    /*#__PURE__*/
    // tslint:disable-next-line:react-a11y-role-has-required-aria-props
    createElement("option", {
      value: "",
      className: styles$6$1.dropdownHiddenOption,
      disabled: required
    }, placeholder)), options.map(function (option, index) {
      return /*#__PURE__*/createElement("option", {
        value: option.value,
        key: index,
        className: styles$6$1.dropdownHiddenOption,
        "aria-selected": selected.value === option.value
      }, option.label);
    })), /*#__PURE__*/createElement("div", {
      className: styles$6$1.dropdownInputInnerContainer
    }, ecRenewal == true ? (/*#__PURE__*/createElement(PillForm, {
      className: styles$6$1.dropdownPillFormLabel
    }, selected.media ? (/*#__PURE__*/createElement(Fragment, null, selected.label && renderOptions.filter(function (item) {
      return item.value === selected.value;
    })[0].media, /*#__PURE__*/createElement("input", {
      value: selected.label,
      className: joinClasses(inputClasses, interactionsStyles.cursorPointer, styles$6$1.dropdownPillFormInput),
      onClick: this.handleInputClick,
      onKeyDown: this.handleMouseDown,
      disabled: disabled,
      required: required,
      onBlur: this.handleInputBlur,
      readOnly: true,
      "aria-label": "".concat(label, " dropdown input")
    }))) : (/*#__PURE__*/createElement("input", {
      value: selected.label,
      className: joinClasses(inputClasses, interactionsStyles.cursorPointer, styles$6$1.dropdownPillFormInput),
      onClick: this.handleInputClick,
      onKeyDown: this.handleMouseDown,
      disabled: disabled,
      required: required,
      onBlur: this.handleInputBlur,
      readOnly: true,
      "aria-label": "".concat(label, " dropdown input")
    })), /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand, "arrow-down") : 'arrow-down',
      className: styles$6$1.dropdownIcon
    }))) : (/*#__PURE__*/createElement(Fragment, null, selected.media ? (/*#__PURE__*/createElement(Fragment, null, selected.label && renderOptions.filter(function (item) {
      return item.value === selected.value;
    })[0].media, /*#__PURE__*/createElement("input", {
      value: selected.label,
      className: joinClasses(inputClasses, interactionsStyles.cursorPointer),
      onClick: this.handleInputClick,
      onKeyDown: this.handleMouseDown,
      disabled: disabled,
      required: required,
      onBlur: this.handleInputBlur,
      readOnly: true,
      "aria-label": "".concat(label, " dropdown input")
    }))) : (/*#__PURE__*/createElement("input", {
      value: searchArea ? selectedValue.label : selected.label,
      className: joinClasses(inputClasses, interactionsStyles.cursorPointer),
      onClick: this.handleInputClick,
      onKeyDown: this.handleMouseDown,
      disabled: disabled,
      required: required,
      onBlur: this.handleInputBlur,
      readOnly: true,
      "aria-label": "".concat(label, " dropdown input")
    })), /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand, "arrow-down") : 'arrow-down',
      className: styles$6$1.dropdownIcon
    })))))), /*#__PURE__*/createElement("ul", {
      role: "listbox",
      className: joinClasses(styles$6$1.dropdownList, ecRenewal && styles$6$1.dropdownEcRenewalDropdownList, searchArea && isSearchFocused && styles$6$1.dropdownSearchFocussed, this.props.optionPosition === 'top' && this.props.updateMaxHeight ? styles$6$1.dropdownListOptionPositionTop : '', !this.state.showOptionBelow && styles$6$1.dropdownOptionPositioningTop, updateMaxHeight && styles$6$1.dropdownListMaxHeight, ecRenewal && !label && styles$6$1.dropdownEcRenewalDropdownListWithoutLabel, this.state.show ? this.context ? isElementVisible && styles$6$1.dropdownListShow : styles$6$1.dropdownListShow : ''),
      style: dropDownPositioning,
      ref: this.dropdownListRef,
      "aria-label": "".concat(label, " dropdown list")
    }, searchArea ? (/*#__PURE__*/createElement("li", {
      className: styles$6$1.dropdownSearchWrapper,
      onFocus: this.handleSearchFocus,
      onBlur: this.handleSearchBlur
    }, searchArea)) : '', renderOptions.map(function (item, index) {
      return /*#__PURE__*/createElement("li", {
        className: joinClasses(styles$6$1.dropdownOption, item.url && styles$6$1.dropdownOptionWithLink, required && placeholder && index === 0 && styles$6$1.dropdownOptionRequiredPlaceholder, selected.label === item.label && selected.value === item.value && styles$6$1.dropdownOptionActive, emojiRegex.test(item.label) && styles$6$1.dropdownOptionEcrenwalAutofill, !emojiRegex.test(item.label) && 'fr-ec-dropdown__option-label-without-flag'),
        onMouseDown: _this.handleDropdownChange(item, Boolean(required && placeholder && index === 0)),
        role: "option",
        // aria-selected={selected.label === item.label}
        key: item.value,
        value: item.value,
        tabIndex: 0,
        id: "option-".concat(index),
        onKeyDown: _this.handleMouseDown
      }, item.url ? (/*#__PURE__*/createElement(Link, {
        element: "a",
        className: styles$6$1.dropdownLink,
        url: item.url,
        onClick: _this.onLinkClick
      }, _this.getMenuItemContent(item))) : (/*#__PURE__*/createElement(Fragment, null, _this.getMenuItemContent(item))));
    })), helptext || error ? (/*#__PURE__*/createElement(HintError, {
      error: error,
      hint: helptext,
      id: hintErrorId,
      disabled: disabled
    })) : null)) : (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$6$1.dropdown, className)
    }, /*#__PURE__*/createElement("div", {
      className: dropdownContainerClasses
    }, !hideLabel && label && (/*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      element: "label",
      className: joinClasses(styles$6$1.dropdownLabel, resetStyles.maxWidthReset),
      disabled: disabled,
      required: required
    })), /*#__PURE__*/createElement("div", {
      className: styles$6$1.dropdownMobileWrapper
    }, /*#__PURE__*/createElement("select", __assign$1({
      className: joinClasses(inputClasses),
      ref: this.dropdownRef,
      required: required,
      value: this.state.selected.value,
      disabled: disabled,
      // tslint:disable-next-line
      onChange: this.handleChange,
      onBlur: this.handleSelectBlur
    }, other), placeholder && (
    /*#__PURE__*/
    // tslint:disable-next-line:react-a11y-role-has-required-aria-props
    createElement("option", {
      value: "",
      disabled: required
    }, placeholder)), options.map(function (option, index) {
      return /*#__PURE__*/createElement("option", {
        value: option.value,
        key: index,
        className: styles$6$1.dropdownHiddenOption,
        "aria-selected": selected.value === option.value
      }, option.label);
    })), /*#__PURE__*/createElement(Icon, {
      name: "arrow-down",
      className: joinClasses(styles$6$1.dropdownIcon, styles$6$1.dropdownIconMobile)
    }))), helptext || error ? (/*#__PURE__*/createElement(HintError, {
      error: error,
      hint: helptext,
      id: hintErrorId,
      disabled: disabled
    })) : null)));
  };
  DropdownComponent.contextType = DropDownContext;
  return DropdownComponent;
}(Component);
var Dropdown = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(DropdownComponent, __assign$1({
    forwardRef: ref
  }, props));
});
Dropdown.defaultProps = {
  hideLabel: false,
  isNative: false
};
Dropdown.displayName = 'CoreDropdown';

var styles$8$1 = {"flyout-navigation__column-wrapper":"fr-ec-flyout-navigation__column-wrapper","flyoutNavigationColumnWrapper":"fr-ec-flyout-navigation__column-wrapper","flyout-navigation__content-column-wrapper":"fr-ec-flyout-navigation__content-column-wrapper","flyoutNavigationContentColumnWrapper":"fr-ec-flyout-navigation__content-column-wrapper","flyout-navigation__content":"fr-ec-flyout-navigation__content","flyoutNavigationContent":"fr-ec-flyout-navigation__content","flyout-navigation__featured-column":"fr-ec-flyout-navigation__featured-column","flyoutNavigationFeaturedColumn":"fr-ec-flyout-navigation__featured-column","flyout-navigation":"fr-ec-flyout-navigation","flyoutNavigation":"fr-ec-flyout-navigation"};

var FlyoutNavigation = function FlyoutNavigation(_a) {
  var content = _a.content,
    aside = _a.aside,
    main = _a.main,
    className = _a.className,
    _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    onDismiss = _a.onDismiss,
    _c = _a.modalCloseLabel,
    modalCloseLabel = _c === void 0 ? '' : _c,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["content", "aside", "main", "className", "element", "onDismiss", "modalCloseLabel", "iconBrand"]);
  return /*#__PURE__*/createElement(Element, __assign$1({
    className: joinClasses(styles$8$1.flyoutNavigation, className)
  }, props), /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, null, /*#__PURE__*/createElement("div", {
    className: styles$8$1.flyoutNavigationContent
  }, content, /*#__PURE__*/createElement(ButtonIcon, {
    iconSize: "24px",
    icon: "close-big",
    label: modalCloseLabel,
    element: "button",
    variant: "dark",
    onClick: onDismiss,
    iconBrand: iconBrand
  })), /*#__PURE__*/createElement("div", {
    className: styles$8$1.flyoutNavigationColumnWrapper
  }, /*#__PURE__*/createElement("div", {
    className: styles$8$1.flyoutNavigationContentColumnWrapper
  }, main), /*#__PURE__*/createElement("div", {
    className: styles$8$1.flyoutNavigationFeaturedColumn
  }, aside)))));
};
FlyoutNavigation.displayName = 'CoreFlyoutNavigation';
FlyoutNavigation.defaultProps = {
  element: 'div'
};

var styles$9$1 = {"image":"fr-ec-image","image__img":"fr-ec-image__img","imageImg":"fr-ec-image__img","image__no-image-container":"fr-ec-image__no-image-container","imageNoImageContainer":"fr-ec-image__no-image-container","image--ratio-1x1":"fr-ec-image--ratio-1x1","imageRatio1X1":"fr-ec-image--ratio-1x1","image--ratio-16x9":"fr-ec-image--ratio-16x9","imageRatio16X9":"fr-ec-image--ratio-16x9","image--ratio-4x3":"fr-ec-image--ratio-4x3","imageRatio4X3":"fr-ec-image--ratio-4x3","image--ratio-3x4":"fr-ec-image--ratio-3x4","imageRatio3X4":"fr-ec-image--ratio-3x4","image--ratio-3x1":"fr-ec-image--ratio-3x1","imageRatio3X1":"fr-ec-image--ratio-3x1","image--ratio-5x2":"fr-ec-image--ratio-5x2","imageRatio5X2":"fr-ec-image--ratio-5x2","image--ratio-6x1":"fr-ec-image--ratio-6x1","imageRatio6X1":"fr-ec-image--ratio-6x1","image--ratio-2x1":"fr-ec-image--ratio-2x1","imageRatio2X1":"fr-ec-image--ratio-2x1","image--full-width":"fr-ec-image--full-width","imageFullWidth":"fr-ec-image--full-width","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","image--bg-none":"fr-ec-image--bg-none","imageBgNone":"fr-ec-image--bg-none","image--fixed-height":"fr-ec-image--fixed-height","imageFixedHeight":"fr-ec-image--fixed-height","image__img--fixed-height":"fr-ec-image__img--fixed-height","imageImgFixedHeight":"fr-ec-image__img--fixed-height"};

var IMAGE_RATIO_1X1 = '1x1';
var IMAGE_RATIO_16X9 = '16x9';
var IMAGE_RATIO_3X4 = '3x4';
var IMAGE_RATIO_4X3 = '4x3';
var IMAGE_RATIO_2X1 = '2x1';
var IMAGE_RATIO_6X1 = '6x1';
var IMAGE_RATIO_3X1 = '3x1';
var IMAGE_RATIO_5X2 = '5x2';
var IMAGE_FULL_WIDTH = 'full-width';

var BaseImage = /** @class */function (_super) {
  __extends(BaseImage, _super);
  function BaseImage(props) {
    var _this = _super.call(this, props) || this;
    _this.elementRef = /*#__PURE__*/React__default.createRef();
    _this.observer = null;
    _this.createObserver = function () {
      var options = {
        threshold: 0.1
      };
      if (_this.elementRef.current) {
        _this.observer = new IntersectionObserver(_this.callIntersectionObserver, options);
        _this.observer.observe(_this.elementRef.current);
      }
    };
    _this.callIntersectionObserver = function (entries) {
      var entry = entries[0];
      if (_this.elementRef.current && entry.isIntersecting && !_this.elementRef.current.src) {
        _this.elementRef.current.src = _this.props.src || '';
        _this.elementRef.current.parentElement.style.backgroundImage = "url(".concat(_this.props.src, ")");
      }
    };
    _this.onErrorHandler = function (event) {
      var noImage = _this.props.noImage;
      if (isInBrowser() && window.onMediaError && typeof window.onMediaError === 'function') {
        window.onMediaError(event, _this.props.src);
      }
      if (noImage && event.currentTarget.src !== noImage && typeof noImage === 'string') {
        // noImage will be updated to src of img tag, if noImage is string
        if (_this.elementRef.current) {
          _this.elementRef.current.src = noImage;
          _this.elementRef.current.parentElement.style.backgroundImage = "url(".concat(noImage, ")");
        }
      } else {
        _this.setState({
          bgColor: true
        });
      }
      if (_this.props.onError) {
        _this.props.onError(event);
      } else {
        _this.setState({
          error: true
        });
      }
    };
    _this.onLoadHandler = function (event) {
      var bgColor = _this.state.bgColor;
      if (bgColor) {
        _this.setState({
          bgColor: false
        });
      }
      if (_this.props.onLoad) {
        _this.props.onLoad(event);
      }
      if (_this.elementRef && _this.elementRef.current && _this.props.src && _this.elementRef.current.naturalWidth) {
        _this.setState({
          loadingComplete: true
        });
      }
    };
    _this.state = {
      bgColor: false,
      error: false,
      imageSrc: ''
    };
    return _this;
  }
  BaseImage.prototype.componentDidMount = function () {
    var _a;
    var verticalScroll = (_a = this.elementRef.current) === null || _a === void 0 ? void 0 : _a.closest('.fr-ec-vertical-scroll');
    if (verticalScroll) {
      this.createObserver();
    } else {
      // Adding src will be handle from here and will be removed from render function for lazy loading functionality
      if (this.elementRef && this.elementRef.current) {
        this.elementRef.current.src = this.props.src || '';
        this.elementRef.current.parentElement.style.backgroundImage = "url(".concat(this.props.src, ")");
      }
    }
  };
  BaseImage.prototype.componentDidUpdate = function (prevProps) {
    var _this = this;
    if (this.props.src !== prevProps.src) {
      this.setState({
        error: false,
        imageSrc: this.props.src
      }, function () {
        if (_this.elementRef && _this.elementRef.current) {
          _this.elementRef.current.src = _this.props.src || '';
          _this.elementRef.current.parentElement.style.backgroundImage = "url(".concat(_this.props.src, ")");
        }
      });
    }
  };
  BaseImage.prototype.componentWillUnmount = function () {
    if (this.observer && this.elementRef.current) {
      this.observer.unobserve(this.elementRef.current);
    }
  };
  BaseImage.prototype.render = function () {
    var _a;
    var _b = this.props,
      _c = _b.alt,
      alt = _c === void 0 ? '' : _c,
      _d = _b.loading,
      loading = _d === void 0 ? 'lazy' : _d,
      _e = _b.ratio,
      ratio = _e === void 0 ? IMAGE_RATIO_1X1 : _e,
      className = _b.className,
      noImage = _b.noImage,
      iconBrand = _b.iconBrand,
      src = _b.src,
      _f = _b.heightInPx,
      heightInPx = _f === void 0 ? 20 : _f,
      props = __rest$1(_b, ["alt", "loading", "ratio", "className", "noImage", "iconBrand", "src", "heightInPx"]);
    var imgProps = {
      alt: alt,
      className: ratio !== 'fixed-height' ? styles$9$1.imageImg : styles$9$1.imageImgFixedHeight,
      loading: loading,
      onError: this.onErrorHandler,
      onLoad: this.onLoadHandler
    };
    var ratioToStyle = (_a = {}, _a[IMAGE_RATIO_16X9] = styles$9$1.imageRatio16X9, _a[IMAGE_RATIO_1X1] = styles$9$1.imageRatio1X1, _a[IMAGE_RATIO_3X4] = styles$9$1.imageRatio3X4, _a[IMAGE_RATIO_4X3] = styles$9$1.imageRatio4X3, _a[IMAGE_RATIO_3X1] = styles$9$1.imageRatio3X1, _a[IMAGE_RATIO_2X1] = styles$9$1.imageRatio2X1, _a[IMAGE_RATIO_6X1] = styles$9$1.imageRatio6X1, _a[IMAGE_RATIO_5X2] = styles$9$1.imageRatio5X2, _a[IMAGE_FULL_WIDTH] = styles$9$1.imageFullWidth, _a);
    var imageContainerStyle = this.state.bgColor ? joinClasses(styles$9$1.image, styles$9$1.imageNoImageContainer, ratioToStyle[ratio], className) : joinClasses(styles$9$1.image, ratioToStyle[ratio], className);
    var fixedHeight = ratio === 'fixed-height' && "".concat(heightInPx, "px");
    var renderImage = this.state.error && _typeof(noImage) === 'object' ? (/*#__PURE__*/React__default.createElement("div", __assign$1({
      className: joinClasses(styles$9$1.image, ratioToStyle[ratio], className)
    }, props), /*#__PURE__*/React__default.createElement(NoImage, __assign$1({
      iconBrand: iconBrand
    }, noImage)))) : fixedHeight ? (/*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$9$1.imageFixedHeight, className),
      style: {
        height: fixedHeight
      }
    }, /*#__PURE__*/React__default.createElement("img", __assign$1({
      "data-src": src
    }, imgProps, {
      ref: this.elementRef
    })))) : (/*#__PURE__*/React__default.createElement("div", __assign$1({
      style: this.state.bgColor ? {
        backgroundColor: '#DADADA'
      } : {},
      className: joinClasses(imageContainerStyle, this.state.loadingComplete && styles$9$1.imageBgNone)
    }, props), /*#__PURE__*/React__default.createElement("img", __assign$1({
      "data-src": src
    }, imgProps, {
      ref: this.elementRef
    }))));
    return renderImage;
  };
  BaseImage.displayName = 'CoreImage';
  BaseImage.defaultProps = {
    disabled: false,
    loadingComplete: false,
    unavailable: false
  };
  return BaseImage;
}(Component);
var Image = function Image(_a) {
  var src = _a.src,
    ratio = _a.ratio,
    noImage = _a.noImage,
    alt = _a.alt,
    altText = _a.altText,
    className = _a.className,
    _b = _a.noImageLabel,
    noImageLabel = _b === void 0 ? '' : _b,
    smallMediumImageRatio = _a.smallMediumImageRatio,
    smallMediumImageUrl = _a.smallMediumImageUrl,
    largeImageRatio = _a.largeImageRatio,
    largeImageUrl = _a.largeImageUrl,
    _c = _a.heightInPx,
    heightInPx = _c === void 0 ? 20 : _c,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["src", "ratio", "noImage", "alt", "altText", "className", "noImageLabel", "smallMediumImageRatio", "smallMediumImageUrl", "largeImageRatio", "largeImageUrl", "heightInPx", "iconBrand"]);
  var width = getViewportWidth();
  var smallMediumImageRatioValue = smallMediumImageRatio || largeImageRatio || '1x1';
  var largeImageRatioValue = largeImageRatio || smallMediumImageRatio || '2x1';
  var smallMediumImageUrlValue = smallMediumImageUrl || largeImageUrl || '';
  var largeImageUrlValue = largeImageUrl || smallMediumImageUrl || '';
  if (src !== undefined) {
    return /*#__PURE__*/React__default.createElement(BaseImage, __assign$1({
      src: src,
      ratio: ratio,
      alt: alt || altText,
      className: className,
      noImage: noImage,
      key: 'image-key',
      iconBrand: iconBrand,
      heightInPx: heightInPx
    }, props));
  } else if (width > designTokens_3.mqMediumScreenMaxWidthLimit) {
    return /*#__PURE__*/React__default.createElement(BaseImage, __assign$1({
      src: largeImageUrlValue,
      ratio: largeImageRatioValue,
      alt: alt || altText,
      className: className,
      noImage: {
        imageSize: 'large',
        imageType: 'icon',
        noImageLabel: noImageLabel
      },
      key: 'large-image-key',
      iconBrand: iconBrand
    }, props));
  } else {
    return /*#__PURE__*/React__default.createElement(BaseImage, __assign$1({
      src: smallMediumImageUrlValue,
      ratio: smallMediumImageRatioValue,
      alt: alt || altText,
      noImage: {
        imageSize: 'default',
        imageType: 'icon',
        noImageLabel: noImageLabel
      },
      className: className,
      key: 'small-medium-image-key',
      iconBrand: iconBrand
    }, props));
  }
};
Image.displayName = 'CoreImage';
Image.defaultProps = {
  disabled: false,
  loadingComplete: false,
  unavailable: false
};

var styles$a$1 = {"label-input":"fr-ec-label-input","labelInput":"fr-ec-label-input","label-input__required-badge":"fr-ec-label-input__required-badge","labelInputRequiredBadge":"fr-ec-label-input__required-badge","lang-ja":"fr-ec-lang-ja","langJa":"fr-ec-lang-ja"};

var LabelInput = function LabelInput(_a) {
  var children = _a.children,
    label = _a.label,
    required = _a.required,
    className = _a.className,
    disabled = _a.disabled,
    _b = _a.element,
    element = _b === void 0 ? 'label' : _b,
    props = __rest$1(_a, ["children", "label", "required", "className", "disabled", "element"]);
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(className, styles$a$1.labelInput)
  }, element === 'label' ? (/*#__PURE__*/createElement(Label, __assign$1({
    element: "label",
    variant: "standard"
  }, props, {
    color: disabled ? 'disabled' : 'primary-dark'
  }), label, required && /*#__PURE__*/createElement("span", {
    className: styles$a$1.labelInputRequiredBadge
  }))) : (/*#__PURE__*/createElement(Body, __assign$1({
    element: "span",
    variant: "standard"
  }, props, {
    color: disabled ? 'disabled' : 'primary-dark'
  }), label, required && /*#__PURE__*/createElement("span", {
    className: styles$a$1.labelInputRequiredBadge
  }))), children);
};
LabelInput.displayName = 'CoreLabelInput';
LabelInput.defaultProps = {
  element: 'label'
};

var styles$b$1 = {"link-text":"fr-ec-link-text","linkText":"fr-ec-link-text","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","link-text--standalone-primary":"fr-ec-link-text--standalone-primary","linkTextStandalonePrimary":"fr-ec-link-text--standalone-primary","link-text__icon--start":"fr-ec-link-text__icon--start","linkTextIconStart":"fr-ec-link-text__icon--start","link-text__icon--end":"fr-ec-link-text__icon--end","linkTextIconEnd":"fr-ec-link-text__icon--end","link-text--inline":"fr-ec-link-text--inline","linkTextInline":"fr-ec-link-text--inline","link-text--inline-secondary":"fr-ec-link-text--inline-secondary","linkTextInlineSecondary":"fr-ec-link-text--inline-secondary","body":"fr-ec-body","link-text-ec-renewal":"fr-ec-link-text-ec-renewal","linkTextEcRenewal":"fr-ec-link-text-ec-renewal","link-text--standalone-secondary":"fr-ec-link-text--standalone-secondary","linkTextStandaloneSecondary":"fr-ec-link-text--standalone-secondary","link-text--standalone":"fr-ec-link-text--standalone","linkTextStandalone":"fr-ec-link-text--standalone","link-text--disabled":"fr-ec-link-text--disabled","linkTextDisabled":"fr-ec-link-text--disabled","link-text--with-icon":"fr-ec-link-text--with-icon","linkTextWithIcon":"fr-ec-link-text--with-icon","link-text--noticeable-blue":"fr-ec-link-text--noticeable-blue","linkTextNoticeableBlue":"fr-ec-link-text--noticeable-blue","link-text--primary-dark":"fr-ec-link-text--primary-dark","linkTextPrimaryDark":"fr-ec-link-text--primary-dark"};

var iconPositionStyle = {
  end: styles$b$1.linkTextIconEnd,
  start: styles$b$1.linkTextIconStart
};
var LinkText = function LinkText(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'a' : _b,
    _c = _a.ecRenewal,
    ecRenewal = _c === void 0 ? false : _c,
    _d = _a.position,
    position = _d === void 0 ? 'standalone' : _d,
    _e = _a.typography,
    typography = _e === void 0 ? 'bodyStandard' : _e,
    _f = _a.typographyColor,
    typographyColor = _f === void 0 ? 'noticeableBlue' : _f,
    _g = _a.variant,
    variant = _g === void 0 ? 'standalone-primary' : _g,
    className = _a.className,
    children = _a.children,
    icon = _a.icon,
    disabled = _a.disabled,
    ariaLabel = _a.ariaLabel,
    href = _a.href,
    to = _a.to,
    _h = _a.iconPosition,
    iconPosition = _h === void 0 ? 'start' : _h,
    gaAction = _a.gaAction,
    gaCategory = _a.gaCategory,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    onClick = _a.onClick,
    _j = _a.wordBreak,
    wordBreak = _j === void 0 ? 'none' : _j,
    iconBrand = _a.iconBrand,
    _k = _a.target,
    target = _k === void 0 ? '_self' : _k,
    props = __rest$1(_a, ["element", "ecRenewal", "position", "typography", "typographyColor", "variant", "className", "children", "icon", "disabled", "ariaLabel", "href", "to", "iconPosition", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "onClick", "wordBreak", "iconBrand", "target"]);
  var color = {
    noticeableBlue: 'noticeable-blue',
    primaryDark: 'primary-dark'
  }[typographyColor];
  var gaProps = {};
  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };
    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }
  var iconTemplate = icon && (/*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon,
    key: iconPosition,
    className: joinClasses(disabled && styles$b$1.linkTextDisabled, iconPositionStyle[iconPosition])
  }));
  var renderChildrenWithoutStandaloneSecondaryText = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "underlined",
    key: "child-label"
  }, children);
  var renderChildrenWithInlineSecondaryText = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "small",
    key: "child-label"
  }, children);
  var renderChildrenWithStandaloneSecondaryText = /*#__PURE__*/createElement(Body, {
    element: "span",
    className: disabled ? styles$b$1.linkTextDisabled : '',
    variant: "standard",
    key: "child-label"
  }, children);
  var renderChildrenWithStandaloneSmallText = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "small-underlined",
    key: "child-label"
  }, children);
  var renderChildrenWithStandaloneTitleLarge = /*#__PURE__*/createElement(Title, {
    element: "span",
    variant: "large-underlined",
    key: "child-label"
  }, children);
  var renderEcRenewalWithPositionStandalone = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "standard",
    key: "child-label"
  }, children);
  var renderEcRenewalWithPositionInline = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "standard",
    key: "child-label"
  }, children);
  var renderEcRenewalWithBodyStandard = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "standard",
    key: "child-label"
  }, children);
  var renderEcRenewalWithBodySmall = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "small",
    key: "child-label"
  }, children);
  var onClickHandler = function onClickHandler(e) {
    // Reduce the header height if the header element is present
    if (isInBrowser()) {
      var headerEl = document.getElementsByTagName('header')[0];
      var headerOffset = 0;
      var offsetVal = 16;
      if (headerEl) {
        headerOffset = headerEl.offsetHeight;
      }
      if (href && href[0] === '#') {
        e.preventDefault();
        var btn = document.getElementById(href.slice(1));
        if (btn) {
          var offset = btn.offsetTop;
          window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: offset - (headerOffset + offsetVal)
          });
        }
      }
    }
    // For callback
    if (onClick) {
      onClick(e);
    }
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };
  var renderChildren = variant === 'standalone-secondary' ? renderChildrenWithStandaloneSecondaryText : variant === 'standalone-small' ? renderChildrenWithStandaloneSmallText : variant === 'inline-secondary' ? renderChildrenWithInlineSecondaryText : variant === 'standalone-title-large' ? renderChildrenWithStandaloneTitleLarge : renderChildrenWithoutStandaloneSecondaryText;
  var renderEcRenewalChildren = position === 'standalone' ? renderEcRenewalWithPositionStandalone : renderEcRenewalWithPositionInline;
  var renderEcRenewalTypography = typography === 'bodyStandard' ? renderEcRenewalWithBodyStandard : renderEcRenewalWithBodySmall;
  if (ecRenewal === true) {
    return (
      /*#__PURE__*/
      // @ts-ignore
      createElement(Element, __assign$1({
        className: joinClasses(ecRenewal && styles$b$1.linkTextEcRenewal, styles$b$1["link-text--".concat(position)], styles$b$1["link-text--".concat(color)], styles$b$1.linkText, icon && styles$b$1.linkTextWithIcon, disabled && styles$b$1.linkTextDisabled, interactionsStyles.cursorPointer, Element === 'button' && resetStyles.buttonReset, addWordBreak(wordBreak === 'break-word'), className),
        role: "link",
        "aria-label": ariaLabel || children,
        "aria-disabled": disabled,
        disabled: disabled,
        onClick: onClickHandler
      }, !disabled ? {
        href: href,
        to: to
      } : {}, Element !== 'button' && {
        target: target
      }, props, gaProps), position === 'standalone' && (typography === 'bodyStandard' || typography === 'bodySmall') ? icon ? (/*#__PURE__*/createElement(ContentAlignment, {
        element: "span",
        direction: "row",
        alignment: "center"
      }, iconPosition === 'end' ? [renderEcRenewalTypography, iconTemplate] : [iconTemplate, renderEcRenewalTypography])) : renderEcRenewalTypography : icon ? (/*#__PURE__*/createElement(ContentAlignment, {
        element: "span",
        direction: "row",
        alignment: "center"
      }, iconPosition === 'end' ? [renderEcRenewalChildren, iconTemplate] : [iconTemplate, renderEcRenewalChildren])) : renderEcRenewalChildren)
    );
  } else {
    return (
      /*#__PURE__*/
      // @ts-ignore
      createElement(Element, __assign$1({
        className: joinClasses(styles$b$1.linkText, styles$b$1["link-text--".concat(variant)], icon && styles$b$1.linkTextWithIcon, disabled && styles$b$1.linkTextDisabled, interactionsStyles.cursorPointer, Element === 'button' && resetStyles.buttonReset, addWordBreak(wordBreak === 'break-word'), className),
        role: "link",
        "aria-label": ariaLabel || children,
        "aria-disabled": disabled,
        disabled: disabled,
        onClick: onClickHandler
      }, !disabled ? {
        href: href,
        to: to
      } : {}, Element !== 'button' && {
        target: target
      }, props, gaProps), icon ? (/*#__PURE__*/createElement(ContentAlignment, {
        element: "span",
        direction: "row",
        alignment: "center"
      }, iconPosition === 'end' ? [renderChildren, iconTemplate] : [iconTemplate, renderChildren])) : renderChildren)
    );
  }
};
LinkText.displayName = 'CoreLinkText';
LinkText.defaultProps = {
  disabled: false,
  element: 'a',
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  iconPosition: 'start',
  variant: 'standalone-primary',
  ecRenewal: false,
  position: 'standalone',
  typography: 'bodyStandard',
  typographyColor: 'noticeableBlue'
};

var styles$c$1 = {"link-region__text":"fr-ec-link-region__text","linkRegionText":"fr-ec-link-region__text","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","link-region__text-disabled":"fr-ec-link-region__text-disabled","linkRegionTextDisabled":"fr-ec-link-region__text-disabled"};

var LinkRegion = function LinkRegion(_a) {
  var label = _a.label,
    _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? "Selected region ".concat(label) : _b,
    gaAction = _a.gaAction,
    gaCategory = _a.gaCategory,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    className = _a.className,
    iconBrand = _a.iconBrand,
    disabled = _a.disabled,
    target = _a.target,
    props = __rest$1(_a, ["label", "ariaLabel", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "className", "iconBrand", "disabled", "target"]);
  return /*#__PURE__*/createElement(ContentAlignment, {
    element: "span",
    direction: "row",
    alignment: "center",
    className: className
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand, "global") : 'global',
    className: joinClasses(disabled && styles$c$1.linkRegionTextDisabled)
  }), /*#__PURE__*/createElement(LinkText, __assign$1({
    className: joinClasses(styles$c$1.linkRegionText, disabled && styles$c$1.linkRegionTextDisabled),
    "aria-label": ariaLabel,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, target && {
    target: target
  }, props), label));
};
LinkRegion.displayName = 'CoreLinkRegion';
LinkRegion.defaultProps = {
  disabled: false,
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$d$1 = {"style-user-info":"fr-ec-style-user-info","styleUserInfo":"fr-ec-style-user-info","style-user-info-large":"fr-ec-style-user-info-large","styleUserInfoLarge":"fr-ec-style-user-info-large","style-user-info-container":"fr-ec-style-user-info-container","styleUserInfoContainer":"fr-ec-style-user-info-container","style-user-info-image":"fr-ec-style-user-info-image","styleUserInfoImage":"fr-ec-style-user-info-image","style-user-info-large-container":"fr-ec-style-user-info-large-container","styleUserInfoLargeContainer":"fr-ec-style-user-info-large-container","style-user-info-link":"fr-ec-style-user-info-link","styleUserInfoLink":"fr-ec-style-user-info-link","tile":"fr-ec-tile","caption":"fr-ec-caption","style-user-info-name":"fr-ec-style-user-info-name","styleUserInfoName":"fr-ec-style-user-info-name","style-user-info-image--small":"fr-ec-style-user-info-image--small","styleUserInfoImageSmall":"fr-ec-style-user-info-image--small","style-user-info-image--large":"fr-ec-style-user-info-image--large","styleUserInfoImageLarge":"fr-ec-style-user-info-image--large","style-user-info-image--default":"fr-ec-style-user-info-image--default","styleUserInfoImageDefault":"fr-ec-style-user-info-image--default","style-user-info-instaImage--small":"fr-ec-style-user-info-instaImage--small","styleUserInfoInstaImageSmall":"fr-ec-style-user-info-instaImage--small","style-user-info-instaImage--large":"fr-ec-style-user-info-instaImage--large","styleUserInfoInstaImageLarge":"fr-ec-style-user-info-instaImage--large","style-user-info-instaImage--default":"fr-ec-style-user-info-instaImage--default","styleUserInfoInstaImageDefault":"fr-ec-style-user-info-instaImage--default","style-user-info-size-wrapper":"fr-ec-style-user-info-size-wrapper","styleUserInfoSizeWrapper":"fr-ec-style-user-info-size-wrapper","style-user-info-section":"fr-ec-style-user-info-section","styleUserInfoSection":"fr-ec-style-user-info-section","style-user-info-section--small":"fr-ec-style-user-info-section--small","styleUserInfoSectionSmall":"fr-ec-style-user-info-section--small","style-user-info-section--default":"fr-ec-style-user-info-section--default","styleUserInfoSectionDefault":"fr-ec-style-user-info-section--default","style-user-info-name--default":"fr-ec-style-user-info-name--default","styleUserInfoNameDefault":"fr-ec-style-user-info-name--default","style-user-info-name--small":"fr-ec-style-user-info-name--small","styleUserInfoNameSmall":"fr-ec-style-user-info-name--small","style-user-info-profile_name":"fr-ec-style-user-info-profile_name","styleUserInfoProfileName":"fr-ec-style-user-info-profile_name","style-user-info-profile_name--with-icon":"fr-ec-style-user-info-profile_name--with-icon","styleUserInfoProfileNameWithIcon":"fr-ec-style-user-info-profile_name--with-icon","style-user-info-profile_name--without-icon":"fr-ec-style-user-info-profile_name--without-icon","styleUserInfoProfileNameWithoutIcon":"fr-ec-style-user-info-profile_name--without-icon","style-user-info-size":"fr-ec-style-user-info-size","styleUserInfoSize":"fr-ec-style-user-info-size","style-user-info-profile-image":"fr-ec-style-user-info-profile-image","styleUserInfoProfileImage":"fr-ec-style-user-info-profile-image","style-user-info-date":"fr-ec-style-user-info-date","styleUserInfoDate":"fr-ec-style-user-info-date","style-user-info-review":"fr-ec-style-user-info-review","styleUserInfoReview":"fr-ec-style-user-info-review","style-user-info-review--large":"fr-ec-style-user-info-review--large","styleUserInfoReviewLarge":"fr-ec-style-user-info-review--large","style-user-info-date--large":"fr-ec-style-user-info-date--large","styleUserInfoDateLarge":"fr-ec-style-user-info-date--large","style-user-info-review--small":"fr-ec-style-user-info-review--small","styleUserInfoReviewSmall":"fr-ec-style-user-info-review--small","style-user-info-date--small":"fr-ec-style-user-info-date--small","styleUserInfoDateSmall":"fr-ec-style-user-info-date--small","style-user-info__carousel-image":"fr-ec-style-user-info__carousel-image","styleUserInfoCarouselImage":"fr-ec-style-user-info__carousel-image","style-user-info__carousel-profile-name":"fr-ec-style-user-info__carousel-profile-name","styleUserInfoCarouselProfileName":"fr-ec-style-user-info__carousel-profile-name","style-user-info__carousel-size":"fr-ec-style-user-info__carousel-size","styleUserInfoCarouselSize":"fr-ec-style-user-info__carousel-size","style-user-info-icon":"fr-ec-style-user-info-icon","styleUserInfoIcon":"fr-ec-style-user-info-icon","style-user-info__carousel-size-details":"fr-ec-style-user-info__carousel-size-details","styleUserInfoCarouselSizeDetails":"fr-ec-style-user-info__carousel-size-details","style-user-info__carousel-name":"fr-ec-style-user-info__carousel-name","styleUserInfoCarouselName":"fr-ec-style-user-info__carousel-name","style-user-info__carousel-section":"fr-ec-style-user-info__carousel-section","styleUserInfoCarouselSection":"fr-ec-style-user-info__carousel-section","style-user-info-carousel-size-width":"fr-ec-style-user-info-carousel-size-width","styleUserInfoCarouselSizeWidth":"fr-ec-style-user-info-carousel-size-width"};

var StyleUserInfo = function StyleUserInfo(_a) {
  var className = _a.className,
    profileImage = _a.profileImage,
    _b = _a.userName,
    userName = _b === void 0 ? '' : _b,
    storeInfo = _a.storeInfo,
    approvedDate = _a.approvedDate,
    heightUnit = _a.heightUnit,
    modelHeight = _a.modelHeight,
    _c = _a.variant,
    variant = _c === void 0 ? 'default' : _c,
    userReview = _a.userReview,
    size = _a.size,
    sizeText = _a.sizeText,
    approvedDateText = _a.approvedDateText,
    _d = _a.isBadge,
    isBadge = _d === void 0 ? false : _d,
    storeLink = _a.storeLink,
    personalPageLink = _a.personalPageLink,
    _e = _a.labelElement,
    labelElement = _e === void 0 ? 'span' : _e,
    userNameGaAction = _a.userNameGaAction,
    storeNameGaAction = _a.storeNameGaAction,
    gaCategory = _a.gaCategory,
    userNameGaLabel = _a.userNameGaLabel,
    storeNameGaLabel = _a.storeNameGaLabel,
    gaCallback = _a.gaCallback,
    gaValue = _a.gaValue,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["className", "profileImage", "userName", "storeInfo", "approvedDate", "heightUnit", "modelHeight", "variant", "userReview", "size", "sizeText", "approvedDateText", "isBadge", "storeLink", "personalPageLink", "labelElement", "userNameGaAction", "storeNameGaAction", "gaCategory", "userNameGaLabel", "storeNameGaLabel", "gaCallback", "gaValue", "iconBrand"]);
  var captionVariant = {
    "default": 'small',
    large: 'large',
    small: 'standard'
  };
  var instaImage = /*#__PURE__*/createElement(Image, {
    key: "0",
    alt: "Accessibility",
    ratio: "1x1",
    src: "https://asset.uniqlo.com/g/pictures/instagram-gradient.png",
    noImage: {
      imageSize: 'smallest',
      imageType: 'user'
    },
    iconBrand: iconBrand
  });
  var isDefault = variant === 'default';
  var isLarge = variant === 'large';
  var image = profileImage ? profileImage : instaImage;
  var profileImageContainer = personalPageLink ? (/*#__PURE__*/createElement(Tile, {
    className: styles$d$1.styleUserInfoLink,
    gaLabel: userNameGaLabel,
    gaCategory: gaCategory,
    gaAction: userNameGaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    href: personalPageLink,
    target: "_self"
  }, /*#__PURE__*/createElement("div", {
    className: profileImage ? joinClasses(styles$d$1.styleUserInfoImage, styles$d$1["style-user-info-image--".concat(variant)]) : joinClasses(styles$d$1.styleUserInfoImage, styles$d$1["style-user-info-image--".concat(variant)], styles$d$1["style-user-info-instaImage--".concat(variant)])
  }, image))) : (/*#__PURE__*/createElement("div", {
    className: styles$d$1.styleUserInfoLink
  }, /*#__PURE__*/createElement("div", {
    className: profileImage ? joinClasses(styles$d$1.styleUserInfoImage, styles$d$1["style-user-info-image--".concat(variant)]) : joinClasses(styles$d$1.styleUserInfoImage, styles$d$1["style-user-info-image--".concat(variant)], styles$d$1["style-user-info-instaImage--".concat(variant)])
  }, image)));
  var profileNameSection = function profileNameSection() {
    return /*#__PURE__*/createElement(ContentAlignment, {
      element: "div",
      direction: "row",
      alignment: "baseline",
      className: joinClasses(styles$d$1.styleUserInfoName, styles$d$1["style-user-info-name--".concat(variant)])
    }, personalPageLink ? (/*#__PURE__*/createElement(Tile, {
      className: styles$d$1.styleUserInfoLink,
      gaLabel: userNameGaLabel,
      gaCategory: gaCategory,
      gaAction: userNameGaAction,
      gaValue: gaValue,
      gaCallback: gaCallback,
      href: personalPageLink,
      target: "_self"
    }, /*#__PURE__*/createElement(Caption, {
      variant: captionVariant[variant],
      element: labelElement,
      className: joinClasses(styles$d$1.styleUserInfoProfileName, isBadge && !isDefault ? styles$d$1.styleUserInfoProfileNameWithIcon : styles$d$1.styleUserInfoProfileNameWithoutIcon)
    }, userName))) : (/*#__PURE__*/createElement("div", {
      className: styles$d$1.styleUserInfoLink
    }, /*#__PURE__*/createElement(Caption, {
      variant: captionVariant[variant],
      element: labelElement,
      className: joinClasses(styles$d$1.styleUserInfoProfileName, isBadge && !isDefault ? styles$d$1.styleUserInfoProfileNameWithIcon : styles$d$1.styleUserInfoProfileNameWithoutIcon)
    }, userName))), isBadge && !isDefault && (/*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "".concat(iconBrand, "verified-badge") : 'verified-badge',
      className: styles$d$1.styleUserInfoIcon
    })), modelHeight && (personalPageLink ? (/*#__PURE__*/createElement(Tile, {
      className: joinClasses(styles$d$1.styleUserInfoLink, styles$d$1.styleUserInfoSizeWrapper),
      gaLabel: userNameGaLabel,
      gaCategory: gaCategory,
      gaAction: userNameGaAction,
      gaValue: gaValue,
      gaCallback: gaCallback,
      href: personalPageLink,
      target: "_self"
    }, /*#__PURE__*/createElement(Caption, {
      element: "p",
      variant: captionVariant[variant],
      className: joinClasses(styles$d$1.styleUserInfoSize, modelHeight === '-' ? styles$d$1.styleUserInfoCarouselSizeWidth : null)
    }, "".concat(modelHeight || '-').concat(heightUnit || '')))) : (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$d$1.styleUserInfoLink, styles$d$1.styleUserInfoSizeWrapper)
    }, /*#__PURE__*/createElement(Caption, {
      element: "p",
      variant: captionVariant[variant],
      className: joinClasses(styles$d$1.styleUserInfoSize, modelHeight === '-' ? styles$d$1.styleUserInfoCarouselSizeWidth : null)
    }, "".concat(modelHeight || '-').concat(heightUnit || ''))))));
  };
  var imageSection = /*#__PURE__*/createElement(ContentAlignment, {
    element: "section",
    direction: "row",
    className: styles$d$1.styleUserInfoContainer
  }, !isLarge && profileImageContainer, /*#__PURE__*/createElement("section", {
    className: joinClasses(styles$d$1.styleUserInfoSection, styles$d$1["style-user-info-section--".concat(variant)])
  }, profileNameSection(), storeInfo && (storeLink ? (/*#__PURE__*/createElement(Tile, {
    className: styles$d$1.styleUserInfoLink,
    gaLabel: storeNameGaLabel,
    gaCategory: gaCategory,
    gaAction: storeNameGaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    href: storeLink,
    target: "_self"
  }, /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "small",
    color: "secondary"
  }, storeInfo))) : (/*#__PURE__*/createElement("div", {
    className: styles$d$1.styleUserInfoLink
  }, /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "small",
    color: "secondary"
  }, storeInfo)))), isDefault && size && (/*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "extra-small",
    className: styles$d$1.styleUserInfoCarouselSizeDetails
  }, "".concat(sizeText || '').concat(size || '-')))));
  return /*#__PURE__*/createElement(ContentAlignment, __assign$1({
    element: "section",
    direction: "column",
    className: joinClasses(styles$d$1.styleUserInfo, isLarge && styles$d$1.styleUserInfoLarge, className)
  }, props), isLarge && profileImageContainer, /*#__PURE__*/createElement("div", {
    className: isLarge && styles$d$1.styleUserInfoLargeContainer || ''
  }, imageSection, !isDefault && userReview && (/*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "standard",
    className: joinClasses(styles$d$1.styleUserInfoReview, styles$d$1["style-user-info-review--".concat(variant)])
  }, userReview)), !isDefault && approvedDate && (/*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "small",
    className: joinClasses(styles$d$1.styleUserInfoDate, styles$d$1["style-user-info-date--".concat(variant)])
  }, "".concat(approvedDate, " ").concat(approvedDateText || '')))));
};
StyleUserInfo.displayName = 'CoreStyleUserInfo';
StyleUserInfo.defaultProps = {
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaValue: null,
  storeNameGaAction: 'click',
  storeNameGaLabel: '',
  userName: '',
  userNameGaAction: 'click',
  userNameGaLabel: ''
};

var styles$f$1 = {"navigation-header":"fr-ec-navigation-header","navigationHeader":"fr-ec-navigation-header","link-primary-nav":"fr-ec-link-primary-nav","linkPrimaryNav":"fr-ec-link-primary-nav","link-primary-nav__text-wrapper":"fr-ec-link-primary-nav__text-wrapper","linkPrimaryNavTextWrapper":"fr-ec-link-primary-nav__text-wrapper","navigation-header__overlay":"fr-ec-navigation-header__overlay","navigationHeaderOverlay":"fr-ec-navigation-header__overlay","overlay-backdrop":"fr-ec-overlay-backdrop","overlayBackdrop":"fr-ec-overlay-backdrop","navigation-header__overlay-with-flyout-nav":"fr-ec-navigation-header__overlay-with-flyout-nav","navigationHeaderOverlayWithFlyoutNav":"fr-ec-navigation-header__overlay-with-flyout-nav","navigation-header-menu":"fr-ec-navigation-header-menu","navigationHeaderMenu":"fr-ec-navigation-header-menu","navigation-header__search-wrapper":"fr-ec-navigation-header__search-wrapper","navigationHeaderSearchWrapper":"fr-ec-navigation-header__search-wrapper","search-wrapper":"fr-ec-search-wrapper","searchWrapper":"fr-ec-search-wrapper","search-wrapper__icon":"fr-ec-search-wrapper__icon","searchWrapperIcon":"fr-ec-search-wrapper__icon","navigation-header__wrapper":"fr-ec-navigation-header__wrapper","navigationHeaderWrapper":"fr-ec-navigation-header__wrapper","navigation-header-with-empty-space":"fr-ec-navigation-header-with-empty-space","navigationHeaderWithEmptySpace":"fr-ec-navigation-header-with-empty-space","navigation-header__left":"fr-ec-navigation-header__left","navigationHeaderLeft":"fr-ec-navigation-header__left","navigation-header__right":"fr-ec-navigation-header__right","navigationHeaderRight":"fr-ec-navigation-header__right","navigation-header__center":"fr-ec-navigation-header__center","navigationHeaderCenter":"fr-ec-navigation-header__center","navigation-header__gender-tab__center":"fr-ec-navigation-header__gender-tab__center","navigationHeaderGenderTabCenter":"fr-ec-navigation-header__gender-tab__center","navigation-header__column":"fr-ec-navigation-header__column","navigationHeaderColumn":"fr-ec-navigation-header__column","navigation-header__column--content":"fr-ec-navigation-header__column--content","navigationHeaderColumnContent":"fr-ec-navigation-header__column--content","navigation-header__column--nav":"fr-ec-navigation-header__column--nav","navigationHeaderColumnNav":"fr-ec-navigation-header__column--nav","navigation-header__column--search":"fr-ec-navigation-header__column--search","navigationHeaderColumnSearch":"fr-ec-navigation-header__column--search","navigation-header__dropdown-wrapper":"fr-ec-navigation-header__dropdown-wrapper","navigationHeaderDropdownWrapper":"fr-ec-navigation-header__dropdown-wrapper","navigation-header--with-dropdown":"fr-ec-navigation-header--with-dropdown","navigationHeaderWithDropdown":"fr-ec-navigation-header--with-dropdown","navigation-header--with-sticky":"fr-ec-navigation-header--with-sticky","navigationHeaderWithSticky":"fr-ec-navigation-header--with-sticky","navigation-header--updated-height":"fr-ec-navigation-header--updated-height","navigationHeaderUpdatedHeight":"fr-ec-navigation-header--updated-height","navigation-header__logo":"fr-ec-navigation-header__logo","navigationHeaderLogo":"fr-ec-navigation-header__logo","link-image":"fr-ec-link-image","linkImage":"fr-ec-link-image","navigation-header-with-empty-space--updated-height":"fr-ec-navigation-header-with-empty-space--updated-height","navigationHeaderWithEmptySpaceUpdatedHeight":"fr-ec-navigation-header-with-empty-space--updated-height","navigation-header--promotion-banner":"fr-ec-navigation-header--promotion-banner","navigationHeaderPromotionBanner":"fr-ec-navigation-header--promotion-banner","navigation-header-notdefault-with-empty-space":"fr-ec-navigation-header-notdefault-with-empty-space","navigationHeaderNotdefaultWithEmptySpace":"fr-ec-navigation-header-notdefault-with-empty-space","search__typeahead-collection":"fr-ec-search__typeahead-collection","searchTypeaheadCollection":"fr-ec-search__typeahead-collection","search-history-collection":"fr-ec-search-history-collection","searchHistoryCollection":"fr-ec-search-history-collection","navigation-header--checkout-menu":"fr-ec-navigation-header--checkout-menu","navigationHeaderCheckoutMenu":"fr-ec-navigation-header--checkout-menu","navigation-header--checkout-flyout":"fr-ec-navigation-header--checkout-flyout","navigationHeaderCheckoutFlyout":"fr-ec-navigation-header--checkout-flyout","navigation-header__column--checkout":"fr-ec-navigation-header__column--checkout","navigationHeaderColumnCheckout":"fr-ec-navigation-header__column--checkout","navigation-header__checkout-wrap-content":"fr-ec-navigation-header__checkout-wrap-content","navigationHeaderCheckoutWrapContent":"fr-ec-navigation-header__checkout-wrap-content","navigation-header__checkout-spacing":"fr-ec-navigation-header__checkout-spacing","navigationHeaderCheckoutSpacing":"fr-ec-navigation-header__checkout-spacing","navigation-header__checkout--dropdown-wrapper":"fr-ec-navigation-header__checkout--dropdown-wrapper","navigationHeaderCheckoutDropdownWrapper":"fr-ec-navigation-header__checkout--dropdown-wrapper","navigation-header--flyout-padding":"fr-ec-navigation-header--flyout-padding","navigationHeaderFlyoutPadding":"fr-ec-navigation-header--flyout-padding","navigation-header--checkout-icon":"fr-ec-navigation-header--checkout-icon","navigationHeaderCheckoutIcon":"fr-ec-navigation-header--checkout-icon","navigation-header__uq-icon":"fr-ec-navigation-header__uq-icon","navigationHeaderUqIcon":"fr-ec-navigation-header__uq-icon","navigation-header--variant-ecrenewal":"fr-ec-navigation-header--variant-ecrenewal","navigationHeaderVariantEcrenewal":"fr-ec-navigation-header--variant-ecrenewal","layout-wrapper":"fr-ec-layout-wrapper","layoutWrapper":"fr-ec-layout-wrapper","navigation-header--variant-ecrenewal-black":"fr-ec-navigation-header--variant-ecrenewal-black","navigationHeaderVariantEcrenewalBlack":"fr-ec-navigation-header--variant-ecrenewal-black","navigation-header-with-gender-tabs":"fr-ec-navigation-header-with-gender-tabs","navigationHeaderWithGenderTabs":"fr-ec-navigation-header-with-gender-tabs","navigation-header-with-gender-tabs--open":"fr-ec-navigation-header-with-gender-tabs--open","navigationHeaderWithGenderTabsOpen":"fr-ec-navigation-header-with-gender-tabs--open","button-icon__icon-container":"fr-ec-button-icon__icon-container","buttonIconIconContainer":"fr-ec-button-icon__icon-container","navigation-header__gender-section":"fr-ec-navigation-header__gender-section","navigationHeaderGenderSection":"fr-ec-navigation-header__gender-section","tabs":"fr-ec-tabs","tabs__content":"fr-ec-tabs__content","tabsContent":"fr-ec-tabs__content","gender-section-with-promotion-banner":"fr-ec-gender-section-with-promotion-banner","genderSectionWithPromotionBanner":"fr-ec-gender-section-with-promotion-banner","flyout-search-area":"fr-ec-flyout-search-area","flyoutSearchArea":"fr-ec-flyout-search-area","flyout-search-area__content":"fr-ec-flyout-search-area__content","flyoutSearchAreaContent":"fr-ec-flyout-search-area__content","navigation-header__gender-section--open":"fr-ec-navigation-header__gender-section--open","navigationHeaderGenderSectionOpen":"fr-ec-navigation-header__gender-section--open","flyout-search-area--open":"fr-ec-flyout-search-area--open","flyoutSearchAreaOpen":"fr-ec-flyout-search-area--open","navigation-header-menu-ec-renewal":"fr-ec-navigation-header-menu-ec-renewal","navigationHeaderMenuEcRenewal":"fr-ec-navigation-header-menu-ec-renewal","button":"fr-ec-button","button--text-wrap":"fr-ec-button--text-wrap","buttonTextWrap":"fr-ec-button--text-wrap","navigation-header-with-gender-tabs--close":"fr-ec-navigation-header-with-gender-tabs--close","navigationHeaderWithGenderTabsClose":"fr-ec-navigation-header-with-gender-tabs--close","overlay-backdrop--close":"fr-ec-overlay-backdrop--close","overlayBackdropClose":"fr-ec-overlay-backdrop--close","navHeaderFadeOut":"fr-ec-navHeaderFadeOut","tab":"fr-ec-tab","tabColor":"fr-ec-tabColor","tab--is-active":"fr-ec-tab--is-active","tabIsActive":"fr-ec-tab--is-active","tab__label":"fr-ec-tab__label","tabLabel":"fr-ec-tab__label","button-icon--dark":"fr-ec-button-icon--dark","buttonIconDark":"fr-ec-button-icon--dark","activeTabColor":"fr-ec-activeTabColor","buttonIconColor":"fr-ec-buttonIconColor","tabs__active-style":"fr-ec-tabs__active-style","tabsActiveStyle":"fr-ec-tabs__active-style","activeTabBarColor":"fr-ec-activeTabBarColor","flyoutFadeIn":"fr-ec-flyoutFadeIn","flyout-search-area--close":"fr-ec-flyout-search-area--close","flyoutSearchAreaClose":"fr-ec-flyout-search-area--close","navigation-header__gender-section--close":"fr-ec-navigation-header__gender-section--close","navigationHeaderGenderSectionClose":"fr-ec-navigation-header__gender-section--close","flyoutFadeOut":"fr-ec-flyoutFadeOut","class-list__children":"fr-ec-class-list__children","classListChildren":"fr-ec-class-list__children","classListfadeIn":"fr-ec-classListfadeIn"};

var NavigationHeader = function NavigationHeader(_a) {
  var _b = _a.element,
    Element = _b === void 0 ? 'div' : _b,
    linkImageArea = _a.linkImageArea,
    contentArea = _a.contentArea,
    searchArea = _a.searchArea,
    primaryMenuArea = _a.primaryMenuArea,
    _c = _a.enableDropdown,
    enableDropdown = _c === void 0 ? false : _c,
    dropdownButtonIcon = _a.dropdownButtonIcon,
    dropdownButtonlabel = _a.dropdownButtonlabel,
    flyoutChildren = _a.flyoutChildren,
    className = _a.className,
    _d = _a.toggleFlyout,
    toggleFlyout = _d === void 0 ? false : _d,
    _e = _a.sticky,
    sticky = _e === void 0 ? true : _e,
    featureImage = _a.featureImage,
    onToggleFlyout = _a.onToggleFlyout,
    searchLabel = _a.searchLabel,
    searchDismissLabel = _a.searchDismissLabel,
    itemCount = _a.itemCount,
    itemLabel = _a.itemLabel,
    totalPrice = _a.totalPrice,
    _f = _a.flyoutChildrenPadding,
    flyoutChildrenPadding = _f === void 0 ? false : _f,
    _g = _a.type,
    type = _g === void 0 ? 'default' : _g,
    iconBrand = _a.iconBrand,
    _h = _a.variant,
    variant = _h === void 0 ? 'default' : _h,
    promotionBannerSection = _a.promotionBannerSection,
    taxLabel = _a.taxLabel,
    genderTabsSection = _a.genderTabsSection,
    flyoutSearchArea = _a.flyoutSearchArea,
    _j = _a.ecRenewal,
    ecRenewal = _j === void 0 ? false : _j,
    props = __rest$1(_a, ["element", "linkImageArea", "contentArea", "searchArea", "primaryMenuArea", "enableDropdown", "dropdownButtonIcon", "dropdownButtonlabel", "flyoutChildren", "className", "toggleFlyout", "sticky", "featureImage", "onToggleFlyout", "searchLabel", "searchDismissLabel", "itemCount", "itemLabel", "totalPrice", "flyoutChildrenPadding", "type", "iconBrand", "variant", "promotionBannerSection", "taxLabel", "genderTabsSection", "flyoutSearchArea", "ecRenewal"]);
  var width = getViewportWidth();
  var _k = useState(getCurrentMediaQueryBreakpoint()),
    screenSize = _k[0],
    setScreenSize = _k[1];
  var _l = useState(toggleFlyout),
    flyoutToggler = _l[0],
    setFlyoutToggler = _l[1];
  var _m = useState(false),
    activeSearch = _m[0],
    setActiveSearch = _m[1];
  var _o = useState(false),
    isTouchDevices = _o[0],
    setIsTouchDevices = _o[1];
  var headerContainerRef = useRef(null);
  var genderSectionRef = useRef(null);
  var _p = useState(0),
    navHeaderHeight = _p[0],
    setNavHeaderHeight = _p[1];
  var _q = useState(false),
    hasCloseClass = _q[0],
    setCloseClass = _q[1];
  var smallMediumDevice = width < designTokens_3.mqMediumScreenMaxWidthLimit;
  var showCheckoutContent = type === 'orderSummary' && smallMediumDevice;
  var toggleFlyoutOpen = type === 'orderSummary' ? toggleFlyout && smallMediumDevice : toggleFlyout;
  var handleSearch = function handleSearch() {
    setActiveSearch(true);
    if (isInBrowser$1()) {
      setTimeout(function () {
        var searchEle = document.querySelector('.fr-ec-navigation-header form[role="search"] > input');
        searchEle.focus();
      }, 500);
    }
  };
  useEffect(function () {
    var searchEle = document.querySelector('.fr-ec-navigation-header form[role="search"] > input');
    if (isInBrowser$1() && searchEle) {
      var tempInput_1 = document.createElement('input');
      tempInput_1.style.position = 'absolute';
      tempInput_1.style.top = searchEle.getBoundingClientRect().top + 'px';
      tempInput_1.style.left = searchEle.getBoundingClientRect().left + 'px';
      tempInput_1.style.height = '0';
      tempInput_1.style.opacity = '0';
      document.forms[0].appendChild(tempInput_1);
      tempInput_1.focus();
      setTimeout(function () {
        searchEle.focus();
        searchEle.click();
        document.forms[0].removeChild(tempInput_1);
      }, 500);
    }
  }, [activeSearch]);
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onResize);
    }
    var observer = new index(function (entries) {
      entries.forEach(function (entry) {
        var _a;
        if (((_a = entry.borderBoxSize) === null || _a === void 0 ? void 0 : _a.length) > 0) {
          setNavHeaderHeight(entry.borderBoxSize[0].blockSize);
        }
      });
    });
    if (headerContainerRef.current) {
      observer.observe(headerContainerRef.current);
    }
    updateTabAnimation();
    return function () {
      window.removeEventListener('resize', onResize);
      observer.disconnect();
    };
  }, [promotionBannerSection]);
  var closeSearch = function closeSearch() {
    return setActiveSearch(false);
  };
  var dropdownList = /*#__PURE__*/createElement(Flyout, {
    className: joinClasses(showCheckoutContent ? styles$f$1.navigationHeaderCheckoutFlyout : '', flyoutChildrenPadding && styles$f$1.navigationHeaderFlyoutPadding),
    colSpan: {
      md: 12,
      lg: 4
    }
  }, Children.toArray(flyoutChildren).filter(isValidElement).map(function (child) {
    return child && child.props && child.props.children;
  }));
  useEffect(function () {
    if (isInBrowser$1()) {
      setIsTouchDevices(isTouchDevice('touchPoints'));
    }
  }, []);
  var dropdownTemplate = /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$f$1.navigationHeaderDropdownWrapper, type === 'orderSummary' && styles$f$1.navigationHeaderCheckoutDropdownWrapper)
  }, !isTouchDevices && {
    onMouseLeave: function onMouseLeave() {
      return setFlyoutToggler(false);
    }
  }), dropdownButtonIcon && dropdownButtonlabel && (/*#__PURE__*/createElement(ButtonIcon, __assign$1({
    icon: dropdownButtonIcon,
    label: dropdownButtonlabel,
    element: "button",
    variant: "dark",
    iconBrand: iconBrand
  }, !isTouchDevices ? {
    onMouseEnter: function onMouseEnter() {
      return setFlyoutToggler(true);
    }
  } : {
    onClick: onToggleFlyout
  }))), (flyoutToggler || toggleFlyout) && dropdownList);
  var iconsArray = Children.toArray(contentArea);
  var contentAreaIcons = Children.toArray(contentArea).map(function (child, index) {
    if (index < iconsArray.length - 1 || featureImage && index < iconsArray.length) {
      return /*#__PURE__*/createElement(Fragment, {
        key: index
      }, child);
    } else {
      return /*#__PURE__*/cloneElement(child, {
        className: joinClasses(styles$f$1.navigationHeaderMenu, variant !== 'default' && styles$f$1.navigationHeaderMenuEcRenewal),
        key: index
      });
    }
  });
  var onResize = function onResize() {
    setScreenSize(getCurrentMediaQueryBreakpoint());
  };
  var updateTabAnimation = function updateTabAnimation() {
    if (isInBrowser$1()) {
      if (genderTabsSection && genderSectionRef && genderSectionRef.current) {
        var tabsActiveStyleClasses = genderSectionRef.current.getElementsByClassName('fr-ec-tabs__active-style');
        var tabsActiveStyleClass = tabsActiveStyleClasses[0];
        if (!toggleFlyoutOpen) {
          tabsActiveStyleClass.style.transition = 'none';
        }
      }
    }
  };
  var animatedFlyoutClose = function animatedFlyoutClose() {
    if (toggleFlyoutOpen) {
      setCloseClass(true);
      setTimeout(function () {
        setCloseClass(false);
        if (onToggleFlyout) {
          onToggleFlyout();
        }
      }, 350);
    }
  };
  var isGenderSection = screenSize !== 'sm' && genderTabsSection;
  var ecRenewalVariants = variant === 'default' ? 'default' : 'ecrenewal';
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("header", __assign$1({
    ref: headerContainerRef,
    className: joinClasses(styles$f$1.navigationHeader, className, enableDropdown && styles$f$1.navigationHeaderWithDropdown, sticky && styles$f$1.navigationHeaderWithSticky, promotionBannerSection && styles$f$1.navigationHeaderPromotionBanner, styles$f$1["navigation-header--variant-".concat(ecRenewalVariants)], variant === 'black' && styles$f$1.navigationHeaderVariantEcrenewalBlack, isGenderSection && styles$f$1.navigationHeaderWithGenderTabs, isGenderSection && toggleFlyoutOpen && styles$f$1.navigationHeaderWithGenderTabsOpen, isGenderSection && hasCloseClass && styles$f$1.navigationHeaderWithGenderTabsClose, ecRenewal && styles$f$1.navigationHeaderUpdatedHeight)
  }, props, {
    onMouseLeave: animatedFlyoutClose
  }), promotionBannerSection, /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      sm: variant === 'default',
      md: true,
      lg: true
    },
    className: styles$f$1.navigationHeaderWrapper
  }, !activeSearch && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Element, {
    className: styles$f$1.navigationHeaderLeft
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$f$1.navigationHeaderColumn, featureImage ? styles$f$1.navigationHeaderUqIcon : styles$f$1.navigationHeaderLogo)
  }, linkImageArea.map(function (item, index) {
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, item);
  })), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$f$1.navigationHeaderColumn, styles$f$1.navigationHeaderColumnNav)
  }, primaryMenuArea)), featureImage && /*#__PURE__*/createElement(Element, {
    className: styles$f$1.navigationHeaderCenter
  }, featureImage), /*#__PURE__*/createElement(Element, {
    className: styles$f$1.navigationHeaderRight
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$f$1.navigationHeaderColumn, showCheckoutContent ? styles$f$1.navigationHeaderColumnCheckout : styles$f$1.navigationHeaderColumnContent)
  }, searchArea && !activeSearch && (/*#__PURE__*/createElement(ButtonIcon, __assign$1({
    icon: 'search',
    element: "button",
    variant: "dark",
    onClick: handleSearch,
    iconBrand: iconBrand
  }, searchLabel ? {
    label: searchLabel
  } : {
    label: ''
  }))), contentAreaIcons, showCheckoutContent && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: styles$f$1.navigationHeaderCheckoutWrapContent
  }, /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "small",
    className: styles$f$1.navigationHeaderCheckoutSpacing
  }, "".concat(itemCount, " ").concat(itemLabel)), /*#__PURE__*/createElement(ContentAlignment, {
    alignment: "center",
    direction: "row",
    element: "div"
  }, /*#__PURE__*/createElement(Title, {
    element: "span",
    variant: "large-emphasized",
    className: !taxLabel ? styles$f$1.navigationHeaderCheckoutSpacing : ''
  }, totalPrice), taxLabel && (/*#__PURE__*/createElement(Caption, {
    element: "span",
    variant: "extra-small",
    className: styles$f$1.navigationHeaderCheckoutSpacing,
    style: {
      marginLeft: '4px'
    }
  }, taxLabel)))), /*#__PURE__*/createElement(ButtonIcon, {
    className: styles$f$1.navigationHeaderCheckoutIcon,
    onClick: onToggleFlyout,
    key: "[object Object]-0",
    disabled: false,
    element: "a",
    hideLabel: false,
    href: "#",
    icon: toggleFlyoutOpen ? 'chevron-up' : 'chevron-down',
    label: "",
    title: "",
    variant: "dark",
    iconBrand: iconBrand,
    "aria-label": toggleFlyoutOpen ? 'up' : 'down'
  }))), enableDropdown && dropdownTemplate)))), searchArea && activeSearch && (/*#__PURE__*/createElement("div", {
    className: styles$f$1.navigationHeaderSearchWrapper
  }, searchArea, /*#__PURE__*/createElement(ButtonIcon, __assign$1({
    className: styles$f$1.searchWrapperIcon,
    element: "button",
    icon: "close-big",
    variant: "dark",
    onClick: closeSearch,
    iconBrand: iconBrand
  }, searchDismissLabel ? {
    label: searchDismissLabel
  } : {
    label: ''
  })))))), screenSize === 'lg' && (/*#__PURE__*/createElement(LayoutWrapper, {
    element: "div",
    className: joinClasses(styles$f$1.flyoutSearchArea, toggleFlyoutOpen && styles$f$1.flyoutSearchAreaOpen, hasCloseClass && styles$f$1.flyoutSearchAreaClose)
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      sm: variant === 'default',
      md: true,
      lg: true
    },
    className: styles$f$1.flyoutSearchAreaContent
  }, flyoutSearchArea))), isGenderSection && (/*#__PURE__*/createElement(Element, {
    className: joinClasses(styles$f$1.navigationHeaderGenderTabCenter, styles$f$1.navigationHeaderGenderSection, toggleFlyoutOpen && styles$f$1.navigationHeaderGenderSectionOpen, hasCloseClass && styles$f$1.navigationHeaderGenderSectionClose, promotionBannerSection && styles$f$1.genderSectionWithPromotionBanner),
    ref: genderSectionRef
  }, genderTabsSection))), sticky && (/*#__PURE__*/createElement("div", {
    className: joinClasses(variant === 'default' ? styles$f$1.navigationHeaderWithEmptySpace : styles$f$1.navigationHeaderNotdefaultWithEmptySpace, ecRenewal && styles$f$1.navigationHeaderWithEmptySpaceUpdatedHeight),
    style: {
      height: variant === 'black' && navHeaderHeight > 0 ? navHeaderHeight : ''
    }
  })), toggleFlyoutOpen && (/*#__PURE__*/createElement(OverlayBackdrop, {
    className: joinClasses(styles$f$1.navigationHeaderOverlay, interactionsStyles.cursorPointer, isGenderSection && styles$f$1.navigationHeaderOverlayWithFlyoutNav, isGenderSection && hasCloseClass && styles$f$1.overlayBackdropClose),
    onClick: isGenderSection ? animatedFlyoutClose : onToggleFlyout
  })));
};
NavigationHeader.displayName = 'CoreNavigationHeader';
NavigationHeader.defaultProps = {
  sticky: true,
  toggleFlyout: false
};

var styles$g$1 = {"radio-group":"fr-ec-radio-group","radioGroup":"fr-ec-radio-group","radio-group__legend":"fr-ec-radio-group__legend","radioGroupLegend":"fr-ec-radio-group__legend","radio-group__radios":"fr-ec-radio-group__radios","radioGroupRadios":"fr-ec-radio-group__radios","radio-group--wrapper":"fr-ec-radio-group--wrapper","radioGroupWrapper":"fr-ec-radio-group--wrapper","radio-group__radio-wrapper":"fr-ec-radio-group__radio-wrapper","radioGroupRadioWrapper":"fr-ec-radio-group__radio-wrapper","radio-group--last-child":"fr-ec-radio-group--last-child","radioGroupLastChild":"fr-ec-radio-group--last-child"};

var RadioGroup = function RadioGroup(_a) {
  var id = _a.id,
    legend = _a.legend,
    error = _a.error,
    hint = _a.hint,
    children = _a.children,
    required = _a.required,
    className = _a.className,
    _b = _a.columnCount,
    columnCount = _b === void 0 ? 1 : _b,
    props = __rest$1(_a, ["id", "legend", "error", "hint", "children", "required", "className", "columnCount"]);
  var _c = useState(getCurrentMediaQueryBreakpoint()),
    breakpoint = _c[0],
    setBreakPointValue = _c[1];
  var hintErrorId = error || hint ? "".concat(id, "-hint-error") : undefined;
  var columnCountProp = Math.max(typeof columnCount === 'number' ? columnCount : columnCount[breakpoint], 1);
  var childCount = Array.isArray(children) && children.length || 0;
  var radios = React__default.Children.map(children, function (child, index) {
    if (child.props !== undefined) {
      var lastChildColumn = childCount - index <= columnCountProp;
      return /*#__PURE__*/React__default.createElement("div", {
        key: "radio-".concat(child.props.id),
        className: joinClasses(styles$g$1.radioGroupRadioWrapper, lastChildColumn && styles$g$1.radioGroupLastChild)
      }, child);
    }
    return null;
  });
  var onWindowSize = debounce(100, function (_) {
    setBreakPointValue(getCurrentMediaQueryBreakpoint());
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onWindowSize);
    }
    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', onWindowSize);
      }
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("fieldset", __assign$1({
    id: id,
    className: joinClasses(styles$g$1.radioGroup, resetStyles.fieldsetReset, legend && styles$g$1.radioGroupWrapper, className),
    "aria-describedby": hintErrorId
  }, props), legend && /*#__PURE__*/React__default.createElement(LabelInput, {
    label: legend,
    element: "legend",
    required: required,
    className: styles$g$1.radioGroupLegend
  }), columnCountProp === 1 ? radios : /*#__PURE__*/React__default.createElement("div", {
    className: styles$g$1.radioGroupRadios
  }, radios), hint || error ? /*#__PURE__*/React__default.createElement(HintError, {
    error: error,
    id: hintErrorId,
    hint: hint
  }) : null);
};
RadioGroup.displayName = 'CoreRadioGroup';
RadioGroup.defaultProps = {
  required: false
};

var styles$h$1 = {"scale-input__label":"fr-ec-scale-input__label","scaleInputLabel":"fr-ec-scale-input__label","scale-input__label-input":"fr-ec-scale-input__label-input","scaleInputLabelInput":"fr-ec-scale-input__label-input","scale-input__container":"fr-ec-scale-input__container","scaleInputContainer":"fr-ec-scale-input__container","scale-input__option":"fr-ec-scale-input__option","scaleInputOption":"fr-ec-scale-input__option","scale-input__radio":"fr-ec-scale-input__radio","scaleInputRadio":"fr-ec-scale-input__radio","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","radio__label":"fr-ec-radio__label","radioLabel":"fr-ec-radio__label","radio__wrapper":"fr-ec-radio__wrapper","radioWrapper":"fr-ec-radio__wrapper","radio__input":"fr-ec-radio__input","radioInput":"fr-ec-radio__input","radio__circle":"fr-ec-radio__circle","radioCircle":"fr-ec-radio__circle"};

var ScaleInput = /*#__PURE__*/forwardRef(function (_a, ref) {
  var legend = _a.legend,
    error = _a.error,
    hint = _a.hint,
    children = _a.children,
    id = _a.id,
    className = _a.className,
    required = _a.required,
    props = __rest$1(_a, ["legend", "error", "hint", "children", "id", "className", "required"]);
  var hintErrorId = "".concat(id, "-hint-error");
  var radioChildren = Children.map(children, function (child, i) {
    var showLabel = !child.props.hideLabel;
    return /*#__PURE__*/createElement("div", {
      key: child.key || i,
      className: styles$h$1.scaleInputOption
    }, /*#__PURE__*/cloneElement(child, {
      className: joinClasses(child.props.className, styles$h$1.scaleInputRadio),
      hideLabel: true
    }), showLabel ? (/*#__PURE__*/createElement(Label, {
      element: "label",
      variant: "standard",
      "aria-hidden": true,
      className: styles$h$1.scaleInputLabel
    }, child.props.label)) : null);
  });
  return /*#__PURE__*/createElement("fieldset", __assign$1({
    id: id,
    className: joinClasses(resetStyles.fieldsetReset, className),
    "aria-describedby": hintErrorId
  }, props), /*#__PURE__*/createElement(LabelInput, {
    label: legend,
    element: "label",
    required: required,
    className: styles$h$1.scaleInputLabelInput
  }), /*#__PURE__*/createElement("div", {
    className: styles$h$1.scaleInputContainer,
    ref: ref
  }, radioChildren), hint || error ? /*#__PURE__*/createElement(HintError, {
    error: error,
    hint: hint,
    id: hintErrorId
  }) : null);
});
ScaleInput.displayName = 'CoreScaleInput';
ScaleInput.defaultProps = {
  required: false
};

var styles$i$1 = {"search-wrapper":"fr-ec-search-wrapper","searchWrapper":"fr-ec-search-wrapper","search":"fr-ec-search","caption--standard":"fr-ec-caption--standard","captionStandard":"fr-ec-caption--standard","search__form":"fr-ec-search__form","searchForm":"fr-ec-search__form","search__input":"fr-ec-search__input","searchInput":"fr-ec-search__input","search__input-rounded":"fr-ec-search__input-rounded","searchInputRounded":"fr-ec-search__input-rounded","search__input-rounded-without-search":"fr-ec-search__input-rounded-without-search","searchInputRoundedWithoutSearch":"fr-ec-search__input-rounded-without-search","search__input-rounded-active":"fr-ec-search__input-rounded-active","searchInputRoundedActive":"fr-ec-search__input-rounded-active","search__input-rounded_image":"fr-ec-search__input-rounded_image","searchInputRoundedImage":"fr-ec-search__input-rounded_image","body--standard":"fr-ec-body--standard","bodyStandard":"fr-ec-body--standard","search__input--no-value":"fr-ec-search__input--no-value","searchInputNoValue":"fr-ec-search__input--no-value","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","search__input--status-error":"fr-ec-search__input--status-error","searchInputStatusError":"fr-ec-search__input--status-error","search__clear-button":"fr-ec-search__clear-button","searchClearButton":"fr-ec-search__clear-button","icon":"fr-ec-icon","search__button":"fr-ec-search__button","searchButton":"fr-ec-search__button","search__label":"fr-ec-search__label","searchLabel":"fr-ec-search__label","search__hint-error":"fr-ec-search__hint-error","searchHintError":"fr-ec-search__hint-error","search__hint-error--disabled":"fr-ec-search__hint-error--disabled","searchHintErrorDisabled":"fr-ec-search__hint-error--disabled","search__button--status-error":"fr-ec-search__button--status-error","searchButtonStatusError":"fr-ec-search__button--status-error","search__typeahead-collection":"fr-ec-search__typeahead-collection","searchTypeaheadCollection":"fr-ec-search__typeahead-collection","search-history-collection":"fr-ec-search-history-collection","searchHistoryCollection":"fr-ec-search-history-collection","typeahead__content":"fr-ec-typeahead__content","typeaheadContent":"fr-ec-typeahead__content","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","search-history-collection__items":"fr-ec-search-history-collection__items","searchHistoryCollectionItems":"fr-ec-search-history-collection__items","search-history__delete-icon--disabled":"fr-ec-search-history__delete-icon--disabled","searchHistoryDeleteIconDisabled":"fr-ec-search-history__delete-icon--disabled","search__input-rounded--image-search":"fr-ec-search__input-rounded--image-search","searchInputRoundedImageSearch":"fr-ec-search__input-rounded--image-search","no-search-history--section":"fr-ec-no-search-history--section","noSearchHistorySection":"fr-ec-no-search-history--section","search__image-search-icon":"fr-ec-search__image-search-icon","searchImageSearchIcon":"fr-ec-search__image-search-icon","search__icon_rounded":"fr-ec-search__icon_rounded","searchIconRounded":"fr-ec-search__icon_rounded","search__icon_rounded-error":"fr-ec-search__icon_rounded-error","searchIconRoundedError":"fr-ec-search__icon_rounded-error","search__input--status-error-rounded":"fr-ec-search__input--status-error-rounded","searchInputStatusErrorRounded":"fr-ec-search__input--status-error-rounded","search-wrapper__is-full-screen":"fr-ec-search-wrapper__is-full-screen","searchWrapperIsFullScreen":"fr-ec-search-wrapper__is-full-screen","search-wrapper__icon-is-full-screen":"fr-ec-search-wrapper__icon-is-full-screen","searchWrapperIconIsFullScreen":"fr-ec-search-wrapper__icon-is-full-screen","search__icon_rounded-disabled":"fr-ec-search__icon_rounded-disabled","searchIconRoundedDisabled":"fr-ec-search__icon_rounded-disabled","tab-group":"fr-ec-tab-group","tabGroup":"fr-ec-tab-group"};

// This will remove the element's keyboard focus.
// Mouse click and all the other features will continue to work.
// This should be temporary, so we gradually fix accessibility on the page.
var disableFocusableElements = function disableFocusableElements(ref) {
  var focusableElements = ref.current.querySelectorAll('a, button, input');
  focusableElements.forEach(function (element) {
    element.setAttribute('tabindex', '-1');
  });
};

var SearchComponent = /** @class */function (_super) {
  __extends(SearchComponent, _super);
  function SearchComponent(props) {
    var _this = _super.call(this, props) || this;
    _this.handleClickOutside = function (event) {
      if (event.target !== _this.searchWrapperRef.current && _this.searchWrapperRef.current && !_this.searchWrapperRef.current.contains(event.target) && _this.props.onBlur && _this.state.isFocused) {
        _this.onSearchBlur(event);
      }
    };
    _this.handleValueChange = function (event) {
      _this.setState({
        value: event.target.value
      });
      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };
    _this.handleClearValue = function (event) {
      _this.setState({
        value: ''
      });
      if (_this.props.onClear) {
        _this.props.onClear(event);
      }
      _this.focusSearchField();
    };
    _this.handleSubmit = function (event) {
      if (_this.props.onSearch) {
        _this.props.onSearch(_this.currentValue);
      }
      var node = _this.searchFieldRef.current;
      if (node) {
        node.blur();
      }
      event.preventDefault();
    };
    _this.focusSearchField = function () {
      var node = _this.searchFieldRef.current;
      if (node) {
        node.focus();
      }
    };
    _this.blurSearchField = function () {
      var node = _this.searchFieldRef.current;
      if (node) {
        node.blur();
      }
    };
    _this.onSearchFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
      _this.setState({
        isFocused: true
      }, function () {
        return _this.focusSearchField();
      });
    };
    _this.onSearchBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
      _this.setState({
        isFocused: false
      });
    };
    _this.getSearchHistoryTitle = function (label, iconBrand) {
      if (label === void 0) {
        label = '';
      }
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Title, {
        element: "p",
        variant: "standard"
      }, label || 'Search History'), /*#__PURE__*/createElement(ButtonIcon, {
        type: "button",
        element: "button",
        icon: "delete",
        iconBrand: iconBrand,
        hideLabel: true,
        onMouseDown: _this.props.onDeleteSearchHistory,
        tabIndex: -1,
        label: "Delete",
        disabled: _this.props.searchHistoryItems && _this.props.searchHistoryItems.length > 0 ? false : true,
        className: _this.props.searchHistoryItems && _this.props.searchHistoryItems.length > 0 ? '' : styles$i$1.searchHistoryDeleteIconDisabled
      }));
    };
    _this.state = {
      isFocused: false,
      value: _this.props.value || ''
    };
    _this.searchFieldRef = props.forwardRef || /*#__PURE__*/createRef();
    _this.searchWrapperRef = props.forwardRef || /*#__PURE__*/createRef();
    return _this;
  }
  SearchComponent.prototype.componentDidMount = function () {
    if (isInBrowser$1()) {
      document.addEventListener('click', this.handleClickOutside, true);
    }
    disableFocusableElements(this.searchWrapperRef);
  };
  Object.defineProperty(SearchComponent.prototype, "currentValue", {
    get: function get() {
      return this.props.value !== undefined ? this.props.value : this.state.value;
    },
    enumerable: false,
    configurable: true
  });
  SearchComponent.prototype.render = function () {
    var _a = this.props,
      _b = _a.autoComplete,
      autoComplete = _b === void 0 ? 'on' : _b,
      id = _a.id,
      label = _a.label,
      _c = _a.imageSearchButtonLabel,
      imageSearchButtonLabel = _c === void 0 ? '' : _c,
      clearButtonLabel = _a.clearButtonLabel,
      _d = _a.searchButtonLabel,
      searchButtonLabel = _d === void 0 ? "" : _d,
      error = _a.error,
      helptext = _a.helptext,
      placeholder = _a.placeholder,
      disabled = _a.disabled,
      required = _a.required,
      className = _a.className,
      ariaLabel = _a.ariaLabel,
      typeaheadItems = _a.typeaheadItems,
      searchHistoryItems = _a.searchHistoryItems,
      showSearchHistory = _a.showSearchHistory,
      searchHistoryLabel = _a.searchHistoryLabel,
      noSearchHistorySection = _a.noSearchHistorySection,
      imageSearchLink = _a.imageSearchLink,
      _e = _a.showTrendingWords,
      showTrendingWords = _e === void 0 ? false : _e,
      trendingWordsLabel = _a.trendingWordsLabel,
      trendingWords = _a.trendingWords,
      iconBrand = _a.iconBrand,
      isFullscreen = _a.isFullscreen,
      _f = _a.variant,
      variant = _f === void 0 ? 'default' : _f,
      other = __rest$1(_a, ["autoComplete", "id", "label", "imageSearchButtonLabel", "clearButtonLabel", "searchButtonLabel", "onFocus", "onBlur", "error", "helptext", "placeholder", "disabled", "required", "forwardRef", "onClear", "onSearch", "onChange", "className", "ariaLabel", "typeaheadItems", "searchHistoryItems", "showSearchHistory", "searchHistoryLabel", "noSearchHistorySection", "onDeleteSearchHistory", "imageSearchLink", "showTrendingWords", "trendingWordsLabel", "trendingWords", "iconBrand", "isFullscreen", "variant"]);
    var hintErrorId = error || helptext ? "".concat(id, "-hint-error") : undefined;
    var labelId = 'search-label';
    var isRounded = variant === 'rounded';
    var searchComponent =
    /*#__PURE__*/
    // (a11y) aria-hidden temporary until Search keyboard issues are not fixed.
    createElement("div", {
      className: joinClasses(styles$i$1.searchWrapper, className),
      ref: this.searchWrapperRef,
      "aria-hidden": true
    }, /*#__PURE__*/createElement("div", {
      className: styles$i$1.search
    }, /*#__PURE__*/createElement("form", {
      className: joinClasses(styles$i$1.searchForm, (error || helptext) && spacingStyles.mbSpacing02),
      onSubmit: this.handleSubmit,
      action: ""
    }, isRounded && !this.state.isFocused && (/*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "search",
      className: styles$i$1.searchInputRoundedImage,
      variant: "dark",
      label: imageSearchButtonLabel,
      hideLabel: true,
      disabled: disabled,
      tabIndex: -1,
      iconBrand: iconBrand
    })), /*#__PURE__*/createElement("input", __assign$1({
      type: "search",
      id: id,
      className: joinClasses(styles$i$1.searchInput, error && styles$i$1.searchInputStatusError, bodyStyles.body, typographyStyles.captionStandard, resetStyles.textinputReset, !this.currentValue ? styles$i$1.searchInputNoValue : '', isRounded && styles$i$1.searchInputRounded, isRounded && error && (imageSearchLink ? styles$i$1.searchInputStatusErrorRounded : ''), isRounded && this.state.isFocused && styles$i$1.searchInputRoundedActive, !imageSearchLink && isRounded && styles$i$1.searchInputRoundedWithoutSearch, isRounded && imageSearchLink && styles$i$1.searchInputRoundedImageSearch),
      placeholder: placeholder
    }, label ? {
      'aria-labelledby': labelId
    } : {
      'aria-label': ariaLabel
    }, {
      "aria-describedby": hintErrorId,
      onChange: this.handleValueChange,
      onFocus: this.onSearchFocus,
      value: this.currentValue,
      ref: this.searchFieldRef,
      autoComplete: autoComplete,
      disabled: disabled,
      required: required
    }, other, {
      tabIndex: -1
    })), imageSearchLink && !this.currentValue && (/*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "visual-search",
      className: joinClasses(styles$i$1.searchImageSearchIcon, isRounded && styles$i$1.searchIconRounded, !disabled && error && isRounded && styles$i$1.searchIconRoundedError, isRounded && disabled && styles$i$1.searchIconRoundedDisabled),
      variant: "dark",
      label: imageSearchButtonLabel,
      hideLabel: true,
      onClick: function onClick() {
        return window.location.href = imageSearchLink;
      },
      disabled: disabled,
      tabIndex: -1,
      iconBrand: iconBrand
    })), !isRounded && (/*#__PURE__*/createElement(ButtonIcon, {
      type: "submit",
      element: "button",
      icon: "search",
      className: joinClasses(styles$i$1.searchButton, error && styles$i$1.searchButtonStatusError),
      label: searchButtonLabel,
      variant: "light",
      hideLabel: true,
      onClick: this.handleSubmit,
      disabled: disabled,
      tabIndex: error ? -1 : 0,
      iconBrand: iconBrand
    })), this.currentValue && (/*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "close",
      className: joinClasses(styles$i$1.searchClearButton, isRounded && styles$i$1.searchIconRounded, isRounded && disabled && styles$i$1.searchIconRoundedDisabled, !disabled && error && isRounded && styles$i$1.searchIconRoundedError),
      label: clearButtonLabel,
      variant: "dark",
      hideLabel: true,
      onClick: this.handleClearValue,
      disabled: disabled,
      tabIndex: error ? -1 : 0,
      iconBrand: iconBrand
    }))), label && (/*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      id: labelId,
      element: "label",
      className: joinClasses(styles$i$1.searchLabel, resetStyles.maxWidthReset),
      required: required
    })), (error || helptext) && (/*#__PURE__*/createElement(HintError, {
      error: error,
      hint: helptext,
      id: hintErrorId,
      className: joinClasses(styles$i$1.searchHintError, disabled && styles$i$1.searchHintErrorDisabled)
    }))), this.state.isFocused && this.currentValue && typeaheadItems && (/*#__PURE__*/createElement(CollectionList, {
      spacing: "none",
      role: "dialog",
      "aria-live": "assertive",
      "aria-atomic": "true",
      className: styles$i$1.searchTypeaheadCollection,
      onTouchMove: this.blurSearchField
    }, typeaheadItems)), showSearchHistory && (/*#__PURE__*/createElement(CollectionList, {
      spacing: "none",
      role: "dialog",
      "aria-live": "assertive",
      "aria-atomic": "true",
      className: joinClasses(styles$i$1.searchHistoryCollection, showTrendingWords && trendingWordsLabel && styles$i$1.searchHistoryCollectionItems),
      onTouchMove: this.blurSearchField
    }, showTrendingWords && trendingWordsLabel && (/*#__PURE__*/createElement(Title, {
      variant: "standard",
      element: "h5"
    }, trendingWordsLabel)), showTrendingWords && trendingWords, this.getSearchHistoryTitle(searchHistoryLabel, iconBrand), searchHistoryItems && searchHistoryItems.length > 0 ? searchHistoryItems : (/*#__PURE__*/createElement("div", {
      className: styles$i$1.noSearchHistorySection
    }, noSearchHistorySection ? noSearchHistorySection : (/*#__PURE__*/createElement(Body, {
      variant: "standard",
      element: "p"
    }, "If there is a search history, it will be displayed here.")))))));
    return isFullscreen && getCurrentMediaQueryBreakpoint() === 'sm' && (this.state.isFocused || showSearchHistory) ? (/*#__PURE__*/createElement("div", {
      className: styles$i$1.searchWrapperIsFullScreen
    }, searchComponent, /*#__PURE__*/createElement(ButtonIcon, __assign$1({
      className: styles$i$1.searchWrapperIconIsFullScreen,
      element: "button",
      icon: "close-big",
      variant: "dark",
      onClick: this.handleClickOutside,
      iconBrand: iconBrand
    }, clearButtonLabel ? {
      label: clearButtonLabel
    } : {
      label: ''
    })))) : searchComponent;
  };
  return SearchComponent;
}(Component);
var Search = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(SearchComponent, __assign$1({
    forwardRef: ref
  }, props));
});
Search.displayName = 'CoreSearch';

var styles$j$1 = {"stepper":"fr-ec-stepper","stepper__step":"fr-ec-stepper__step","stepperStep":"fr-ec-stepper__step","stepper--active":"fr-ec-stepper--active","stepperActive":"fr-ec-stepper--active","label":"fr-ec-label","caption":"fr-ec-caption","stepper-static":"fr-ec-stepper-static","stepperStatic":"fr-ec-stepper-static"};

var Stepper = function Stepper(_a) {
  var _b = _a.isActive,
    isActive = _b === void 0 ? false : _b,
    children = _a.children,
    label = _a.label,
    onClick = _a.onClick,
    props = __rest$1(_a, ["isActive", "children", "label", "onClick"]);
  return /*#__PURE__*/createElement("button", __assign$1({
    className: joinClasses(styles$j$1.stepper, isActive && styles$j$1.stepperActive, !onClick && styles$j$1.stepperStatic),
    onClick: onClick
  }, props, {
    "aria-label": "Step ".concat(children, ", ").concat(label)
  }), /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "standard",
    className: styles$j$1.stepperStep
  }, children), /*#__PURE__*/createElement(Caption, {
    element: "span"
  }, label));
};
Stepper.displayName = 'CoreStepper';

var TableRowStyles = {"table-row--with-border":"fr-ec-table-row--with-border","tableRowWithBorder":"fr-ec-table-row--with-border"};

var textAlign = function textAlign(align) {
  switch (align) {
    case 'center':
      return 'center';
    case 'end':
      return 'right';
    default:
      return 'left';
  }
};
var TableBody = function TableBody(_a) {
  var rows = _a.rows,
    columnStyles = _a.columnStyles,
    spacing = _a.spacing,
    rest = __rest$1(_a, ["rows", "columnStyles", "spacing"]);
  var getTypography = function getTypography(typography, emphasized, cellIndex, cell) {
    switch (typography) {
      case 'title':
        return /*#__PURE__*/createElement(Title, {
          element: "div",
          variant: emphasized ? 'large-emphasized' : 'large',
          textAlign: textAlign(columnStyles[cellIndex].alignment)
        }, cell);
      default:
        return /*#__PURE__*/createElement(Body, {
          element: "span",
          variant: emphasized ? 'standard-emphasized' : 'standard',
          textAlign: textAlign(columnStyles[cellIndex].alignment)
        }, cell);
    }
  };
  var getChildType = function getChildType(dtCell) {
    var childType;
    if (/*#__PURE__*/isValidElement(dtCell)) {
      Children.forEach(dtCell, function (child) {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'CoreAccordion' || ((_b = child.type) === null || _b === void 0 ? void 0 : _b.displayName) === 'Accordion') {
          childType = 'Accordion';
        } else if (((_c = child.type) === null || _c === void 0 ? void 0 : _c.displayName) === 'CoreIconTypography' || ((_d = child.type) === null || _d === void 0 ? void 0 : _d.displayName) === 'IconTypography') {
          childType = 'IconTypography';
        } else if (((_e = child.type) === null || _e === void 0 ? void 0 : _e.displayName) === 'ContentAlignment' || ((_f = child.type) === null || _f === void 0 ? void 0 : _f.displayName) === 'CoreContentAlignment') {
          childType = 'ContentAlignment';
        } else {
          childType = '';
        }
      });
    }
    return childType;
  };
  var accordionAttributes = {
    colspan: '2',
    width: '100%'
  };
  return /*#__PURE__*/createElement("tbody", __assign$1({}, rest), rows.map(function (_a, i) {
    var content = _a.content,
      _b = _a.bottomKeyline,
      bottomKeyline = _b === void 0 ? false : _b,
      _c = _a.typography,
      typography = _c === void 0 ? 'body' : _c,
      _d = _a.emphasized,
      emphasized = _d === void 0 ? false : _d,
      contentClassName = _a.contentClassName,
      props = __rest$1(_a, ["content", "bottomKeyline", "typography", "emphasized", "contentClassName"]);
    return /*#__PURE__*/createElement(TableRow, {
      key: i,
      className: bottomKeyline ? TableRowStyles['table-row--with-border'] : ''
    }, Children.toArray(content).map(function (cell, j) {
      return columnStyles[j] && (/*#__PURE__*/createElement(TableCell, __assign$1({}, getChildType(cell) === 'Accordion' && accordionAttributes, {
        key: j,
        element: "td",
        className: joinClasses(spacing === '8px' ? TableCellStyles.tableCellBodyVerticalPaddingDefault : TableCellStyles.tableCellBodyVerticalPadding4, bottomKeyline && (spacing === '8px' ? TableCellStyles.tableCellBorderBottomDefault : TableCellStyles.tableCellBorderBottom), contentClassName && contentClassName[j], getChildType(cell) === 'Accordion' && TableCellStyles.tableCellAccordion, getChildType(cell) === 'ContentAlignment' && TableCellStyles.tableCellContentAlignment)
      }, columnStyles[j], props), typeof cell === 'string' ? getTypography(typography, emphasized, j, cell) : cell));
    }));
  }));
};
TableBody.defaultProps = {
  spacing: '8px'
};
TableBody.displayName = 'CoreTableBody';

var styles$k$1 = {"table":"fr-ec-table","table--with-footer":"fr-ec-table--with-footer","tableWithFooter":"fr-ec-table--with-footer","table-cell":"fr-ec-table-cell","tableCell":"fr-ec-table-cell","table-container":"fr-ec-table-container","tableContainer":"fr-ec-table-container","table-container--background-white":"fr-ec-table-container--background-white","tableContainerBackgroundWhite":"fr-ec-table-container--background-white"};

var Table = function Table(_a) {
  var rows = _a.rows,
    columnStyles = _a.columnStyles,
    className = _a.className,
    background = _a.background,
    spacing = _a.spacing,
    props = __rest$1(_a, ["rows", "columnStyles", "className", "background", "spacing"]);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(background === 'grey' ? styles$k$1.tableContainer : styles$k$1.tableContainerBackgroundWhite, className)
  }, props), /*#__PURE__*/createElement("table", {
    className: styles$k$1.table
  }, /*#__PURE__*/createElement(TableBody, {
    rows: rows,
    columnStyles: columnStyles,
    spacing: spacing
  })));
};
Table.defaultProps = {
  background: 'grey',
  spacing: '8px'
};
Table.displayName = 'CoreTable';

var styles$l$1 = {"text-area":"fr-ec-text-area","textArea":"fr-ec-text-area","text-area__input":"fr-ec-text-area__input","textAreaInput":"fr-ec-text-area__input","text-area__label":"fr-ec-text-area__label","textAreaLabel":"fr-ec-text-area__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","text-area__input--error":"fr-ec-text-area__input--error","textAreaInputError":"fr-ec-text-area__input--error","text-area__info-wrapper":"fr-ec-text-area__info-wrapper","textAreaInfoWrapper":"fr-ec-text-area__info-wrapper","text-area__character-count-wrapper":"fr-ec-text-area__character-count-wrapper","textAreaCharacterCountWrapper":"fr-ec-text-area__character-count-wrapper","text-area__character-count":"fr-ec-text-area__character-count","textAreaCharacterCount":"fr-ec-text-area__character-count"};

var testId$1$1 = {
  'data-testid': 'CoreTextArea'
};
var formatPxStringAsNumber = function formatPxStringAsNumber(pxString) {
  return parseInt(pxString.replace('px', ''), 10);
};
var getNonContentHeight = function getNonContentHeight(el) {
  var computedStyle = getComputedStyle(el);
  return ['padding-top', 'padding-bottom', 'border-top-width', 'border-bottom-width'].reduce(function (total, prop) {
    return total + formatPxStringAsNumber(computedStyle.getPropertyValue(prop));
  }, 0);
};
var adjustElementLineCount = function adjustElementLineCount(el, minLines, maxLines) {
  if (minLines === void 0) {
    minLines = TextAreaComponent.defaultProps.minLines;
  }
  if (maxLines === void 0) {
    maxLines = TextAreaComponent.defaultProps.maxLines;
  }
  el.style.height = 'inherit';
  var computedStyle = getComputedStyle(el);
  var lineHeight = formatPxStringAsNumber(computedStyle.getPropertyValue('line-height'));
  var currentLines = Math.floor(el.scrollHeight / lineHeight);
  var newLines = Math.max(minLines, Math.min(maxLines, currentLines));
  var newHeight = newLines * lineHeight + (getBrowser() === 'firefox' ? getNonContentHeight(el) : 0);
  el.style.height = "".concat(newHeight, "px");
};
var TextAreaComponent = /** @class */function (_super) {
  __extends(TextAreaComponent, _super);
  function TextAreaComponent(props) {
    var _this = _super.call(this, props) || this;
    _this.onChange = function (event) {
      var currentTarget = event.currentTarget;
      var _a = _this.props,
        onChange = _a.onChange,
        value = _a.value;
      if (typeof value === 'undefined') {
        _this.setState({
          characterCount: currentTarget.value.length
        });
      }
      adjustElementLineCount(currentTarget);
      if (onChange) {
        onChange(event);
      }
    };
    _this.state = {
      characterCount: props.value ? props.value.length : 0
    };
    _this.textareaRef = props.forwardRef || /*#__PURE__*/createRef();
    return _this;
  }
  TextAreaComponent.prototype.componentDidUpdate = function (_a) {
    var oldValue = _a.value;
    var newValue = this.props.value;
    if (oldValue !== newValue) {
      this.setState({
        characterCount: newValue ? newValue.length : 0
      });
    }
  };
  TextAreaComponent.prototype.componentDidMount = function () {
    var current = this.textareaRef.current;
    if (current) {
      adjustElementLineCount(current);
    }
  };
  TextAreaComponent.prototype.render = function () {
    var _a = this.props,
      maxCharacters = _a.maxCharacters,
      description = _a.description,
      label = _a.label,
      id = _a.id,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      error = _a.error,
      required = _a.required,
      charCountAriaLabel = _a.charCountAriaLabel,
      className = _a.className,
      props = __rest$1(_a, ["maxCharacters", "description", "label", "id", "disabled", "error", "required", "onChange", "charCountAriaLabel", "forwardRef", "className"]);
    var characterCount = this.state.characterCount;
    var hintErrorId = error || description ? "".concat(id, "-hint-error") : '';
    var countId = maxCharacters ? "".concat(id, "-char-count") : '';
    var characterCountError = Boolean(maxCharacters && characterCount > maxCharacters);
    return /*#__PURE__*/createElement("div", __assign$1({
      className: joinClasses(styles$l$1.textArea, className)
    }, testId$1$1), /*#__PURE__*/createElement("textarea", __assign$1({
      ref: this.textareaRef,
      id: id,
      className: joinClasses(styles$l$1.textAreaInput, bodyStyles.body, typographyStyles.formText, error && styles$l$1.textAreaInputError),
      disabled: disabled,
      "aria-describedby": "".concat(countId, " ").concat(hintErrorId),
      onChange: this.onChange
    }, props)), /*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      element: "label",
      className: joinClasses(styles$l$1.textAreaLabel, resetStyles.maxWidthReset),
      disabled: disabled,
      required: required
    }), description || error || maxCharacters ? (/*#__PURE__*/createElement("div", {
      className: styles$l$1.textAreaInfoWrapper
    }, description || error ? (/*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement(HintError, {
      error: error,
      hint: description,
      id: hintErrorId,
      disabled: disabled
    }))) : null, maxCharacters && (/*#__PURE__*/createElement("div", {
      className: styles$l$1.textAreaCharacterCountWrapper
    }, /*#__PURE__*/createElement(HintError, {
      id: countId,
      className: styles$l$1.textAreaCharacterCount,
      "aria-label": "".concat(charCountAriaLabel, ": ").concat(maxCharacters - characterCount),
      hint: "".concat(characterCount, "/").concat(maxCharacters),
      error: characterCountError ? "".concat(characterCount, "/").concat(maxCharacters) : undefined,
      disabled: disabled
    }))))) : null);
  };
  TextAreaComponent.defaultProps = {
    disabled: false,
    maxLines: 6,
    minLines: 3
  };
  return TextAreaComponent;
}(Component);
var TextArea = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(TextAreaComponent, __assign$1({
    forwardRef: ref
  }, props));
});
TextArea.displayName = 'CoreTextArea';
TextArea.defaultProps = {
  disabled: false
};

var styles$m$1 = {"text-field":"fr-ec-text-field","textField":"fr-ec-text-field","text-field__input-wrapper":"fr-ec-text-field__input-wrapper","textFieldInputWrapper":"fr-ec-text-field__input-wrapper","text-field__input-focus":"fr-ec-text-field__input-focus","textFieldInputFocus":"fr-ec-text-field__input-focus","text-field__input-focus-error":"fr-ec-text-field__input-focus-error","textFieldInputFocusError":"fr-ec-text-field__input-focus-error","text-field__input":"fr-ec-text-field__input","textFieldInput":"fr-ec-text-field__input","text-field__wrapper-class":"fr-ec-text-field__wrapper-class","textFieldWrapperClass":"fr-ec-text-field__wrapper-class","text-field__data-list-arrow-icon":"fr-ec-text-field__data-list-arrow-icon","textFieldDataListArrowIcon":"fr-ec-text-field__data-list-arrow-icon","text-field__input--status-error":"fr-ec-text-field__input--status-error","textFieldInputStatusError":"fr-ec-text-field__input--status-error","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","text-field__data-list":"fr-ec-text-field__data-list","textFieldDataList":"fr-ec-text-field__data-list","text-field__data-list-options":"fr-ec-text-field__data-list-options","textFieldDataListOptions":"fr-ec-text-field__data-list-options","text-field__input-affix--dropdown":"fr-ec-text-field__input-affix--dropdown","textFieldInputAffixDropdown":"fr-ec-text-field__input-affix--dropdown","dropdown":"fr-ec-dropdown","dropdown__list":"fr-ec-dropdown__list","dropdownList":"fr-ec-dropdown__list","dropdown__option":"fr-ec-dropdown__option","dropdownOption":"fr-ec-dropdown__option","dropdown__option-label-without-flag":"fr-ec-dropdown__option-label-without-flag","dropdownOptionLabelWithoutFlag":"fr-ec-dropdown__option-label-without-flag","body--standard":"fr-ec-body--standard","bodyStandard":"fr-ec-body--standard","text-field__input-value":"fr-ec-text-field__input-value","textFieldInputValue":"fr-ec-text-field__input-value","text-field__input-affix":"fr-ec-text-field__input-affix","textFieldInputAffix":"fr-ec-text-field__input-affix","text-field__label":"fr-ec-text-field__label","textFieldLabel":"fr-ec-text-field__label","text-field__label-text":"fr-ec-text-field__label-text","textFieldLabelText":"fr-ec-text-field__label-text","text-field__label-sub":"fr-ec-text-field__label-sub","textFieldLabelSub":"fr-ec-text-field__label-sub","text-field__hint-error":"fr-ec-text-field__hint-error","textFieldHintError":"fr-ec-text-field__hint-error","text-field__input-affix--status-error":"fr-ec-text-field__input-affix--status-error","textFieldInputAffixStatusError":"fr-ec-text-field__input-affix--status-error","text-field__input-prefix":"fr-ec-text-field__input-prefix","textFieldInputPrefix":"fr-ec-text-field__input-prefix","text-field__input-suffix":"fr-ec-text-field__input-suffix","textFieldInputSuffix":"fr-ec-text-field__input-suffix","text-field__input-affix--image-wrapper":"fr-ec-text-field__input-affix--image-wrapper","textFieldInputAffixImageWrapper":"fr-ec-text-field__input-affix--image-wrapper","text-field__input-affix--dropdown-wrapper":"fr-ec-text-field__input-affix--dropdown-wrapper","textFieldInputAffixDropdownWrapper":"fr-ec-text-field__input-affix--dropdown-wrapper","text-field__input-affix-image":"fr-ec-text-field__input-affix-image","textFieldInputAffixImage":"fr-ec-text-field__input-affix-image","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","dropdown__input":"fr-ec-dropdown__input","dropdownInput":"fr-ec-dropdown__input","dropdown__icon":"fr-ec-dropdown__icon","dropdownIcon":"fr-ec-dropdown__icon","dropdown__option--active":"fr-ec-dropdown__option--active","dropdownOptionActive":"fr-ec-dropdown__option--active","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","text-field__input-affix--button-icon":"fr-ec-text-field__input-affix--button-icon","textFieldInputAffixButtonIcon":"fr-ec-text-field__input-affix--button-icon","text-field__input--affix-prefix":"fr-ec-text-field__input--affix-prefix","textFieldInputAffixPrefix":"fr-ec-text-field__input--affix-prefix","text-field__input--affix-suffix":"fr-ec-text-field__input--affix-suffix","textFieldInputAffixSuffix":"fr-ec-text-field__input--affix-suffix","text-field__input--distinct-prefix":"fr-ec-text-field__input--distinct-prefix","textFieldInputDistinctPrefix":"fr-ec-text-field__input--distinct-prefix","text-field__input--distinct-suffix":"fr-ec-text-field__input--distinct-suffix","textFieldInputDistinctSuffix":"fr-ec-text-field__input--distinct-suffix","text-field__input--no-prefix":"fr-ec-text-field__input--no-prefix","textFieldInputNoPrefix":"fr-ec-text-field__input--no-prefix","text-field__input--no-suffix":"fr-ec-text-field__input--no-suffix","textFieldInputNoSuffix":"fr-ec-text-field__input--no-suffix"};

var statusToInputFieldPrefixSuffix = {
  combinedPrefix: styles$m$1.textFieldInputAffixPrefix,
  combinedSuffix: styles$m$1.textFieldInputAffixSuffix,
  distinctPrefix: styles$m$1.textFieldInputDistinctPrefix,
  distinctSuffix: styles$m$1.textFieldInputDistinctSuffix,
  normalPrefix: styles$m$1.textFieldInputNoPrefix,
  normalSuffix: styles$m$1.textFieldInputNoSuffix
};
polyfillCountryFlagEmojis();
var TextFieldComponent = /** @class */function (_super) {
  __extends(TextFieldComponent, _super);
  function TextFieldComponent(props) {
    var _this = _super.call(this, props) || this;
    _this.handleFocus = function (event) {
      _this.setState({
        isFocus: true,
        isActive: true
      });
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };
    _this.handleBlur = function (event) {
      _this.setState({
        isFocus: false,
        isActive: false
      });
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };
    _this.onResize = function (contentRect) {
      if (contentRect.bounds) {
        var viewPortWidth = contentRect.bounds.width;
        _this.setState({
          viewPortWidth: viewPortWidth
        });
      }
    };
    _this.handleArrowClick = function () {
      _this.setState({
        isActive: !_this.state.isActive
      });
    };
    _this.handleOptionClick = function (event, item) {
      _this.setState({
        isActive: false,
        inputValue: item.label
      });
      if (_this.props.onChange) {
        _this.props.onChange(event, item.value);
      }
    };
    _this.onInputChangeHandler = function (event) {
      _this.setState({
        inputValue: event.target.value
      });
      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    };
    _this.renderAffix = function (affix, isPrefix) {
      var _a = _this.props,
        error = _a.error,
        _b = _a.disabled,
        disabled = _b === void 0 ? false : _b;
      var affixClassNames = joinClasses(styles$m$1.textFieldInputAffix, error && !disabled && styles$m$1.textFieldInputAffixStatusError);
      var affixNoIconClass = isPrefix ? styles$m$1.textFieldInputPrefix : styles$m$1.textFieldInputSuffix;
      if (typeof affix === 'string') {
        return /*#__PURE__*/createElement(Body, {
          element: "span",
          className: joinClasses(affixClassNames, affixNoIconClass)
        }, affix);
      } else if (affix.type && /*#__PURE__*/isValidElement(affix) && (
      // @ts-ignore
      affix.type.displayName === 'CoreImage' || affix.type.displayName === 'Image')) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$m$1.textFieldInputAffixImageWrapper, affixClassNames, affixNoIconClass)
        }, /*#__PURE__*/cloneElement(affix, {
          className: styles$m$1.textFieldInputAffixImage
        }));
      } else if (affix.type && /*#__PURE__*/isValidElement(affix) && (
      // @ts-ignore
      affix.type.displayName === 'CoreDropdown' || affix.type.displayName === 'Dropdown')) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$m$1.textFieldInputAffixDropdownWrapper, affixClassNames, affixNoIconClass)
        }, /*#__PURE__*/cloneElement(affix, {
          className: styles$m$1.textFieldInputAffixDropdown,
          dropdownMenuWidth: _this.state.viewPortWidth
        }));
      }
      return /*#__PURE__*/createElement("div", {
        className: joinClasses(affixClassNames, styles$m$1.textFieldInputAffixButtonIcon)
      }, /*#__PURE__*/cloneElement(affix, __assign$1({}, disabled ? {
        disabled: disabled,
        href: undefined,
        to: undefined
      } : {})));
    };
    _this.getAffixType = function (affix) {
      if (!affix) {
        return 'normal';
      }
      if (typeof affix === 'string' ||
      // @ts-ignore
      affix.type && (affix.type.displayName === 'CoreImage' || affix.type.displayName === 'Image')) {
        return 'combined';
      }
      return 'distinct';
    };
    _this.state = {
      inputValue: '',
      isActive: false,
      isFocus: false,
      viewPortWidth: 0
    };
    return _this;
  }
  TextFieldComponent.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      id = _a.id,
      label = _a.label,
      title = _a.title,
      subLabel = _a.subLabel,
      helptext = _a.helptext,
      error = _a.error,
      value = _a.value,
      required = _a.required,
      disabled = _a.disabled,
      prefixContent = _a.prefixContent,
      suffixContent = _a.suffixContent,
      className = _a.className,
      forwardRef = _a.forwardRef,
      options = _a.options,
      errorStatus = _a.errorStatus,
      iconBrand = _a.iconBrand,
      props = __rest$1(_a, ["id", "label", "title", "subLabel", "helptext", "error", "value", "onChange", "onFocus", "onBlur", "required", "disabled", "prefixContent", "suffixContent", "className", "forwardRef", "options", "errorStatus", "iconBrand"]);
    var isFocus = this.state.isFocus;
    var hintErrorId = error || helptext ? "".concat(id, "-hint-error") : undefined;
    var textFieldContent = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$m$1.textFieldInputWrapper, !disabled && isFocus && styles$m$1.textFieldInputFocus, !disabled && Boolean(value) && styles$m$1.textFieldInputValue, (errorStatus || error) && styles$m$1.textFieldInputStatusError, (errorStatus || error) && !disabled && isFocus && styles$m$1.textFieldInputFocusError)
    }, prefixContent && this.renderAffix(prefixContent, true), /*#__PURE__*/createElement("input", __assign$1({
      id: id,
      className: joinClasses(styles$m$1.textFieldInput, statusToInputFieldPrefixSuffix["".concat(this.getAffixType(prefixContent), "Prefix")], statusToInputFieldPrefixSuffix["".concat(this.getAffixType(suffixContent), "Suffix")], typographyStyles.formText, resetStyles.textinputReset)
    }, props, {
      "aria-describedby": hintErrorId,
      onChange: this.onInputChangeHandler,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      required: required,
      value: !(options && Boolean(options.length)) ? value : this.state.inputValue,
      disabled: disabled,
      ref: forwardRef,
      title: title
    })), suffixContent && this.renderAffix(suffixContent, false)), options && Boolean(options.length) && (/*#__PURE__*/createElement(ButtonIcon, {
      className: styles$m$1.textFieldDataListArrowIcon,
      element: "button",
      icon: "arrow-down",
      iconBrand: iconBrand,
      label: "arrow down",
      hideLabel: true,
      onClick: this.handleArrowClick
    })), options && Boolean(options.length) && this.state.isActive && (/*#__PURE__*/createElement("ul", {
      className: styles$m$1.textFieldDataList
    }, options.filter(function (item) {
      if (!_this.state.inputValue) {
        return true;
      }
      if (item.label.toLocaleLowerCase().includes(_this.state.inputValue.toLocaleLowerCase())) {
        return true;
      }
      return false;
    }).map(function (item) {
      return (
        /*#__PURE__*/
        // tslint:disable-next-line:react-a11y-role-has-required-aria-props
        createElement("li", {
          value: item.value,
          role: "option",
          onMouseDown: function onMouseDown(event) {
            return _this.handleOptionClick(event, item);
          },
          tabIndex: 0,
          className: styles$m$1.textFieldDataListOptions
        }, /*#__PURE__*/createElement(Body, {
          element: "span",
          variant: "standard"
        }, item.label))
      );
    }))));
    return /*#__PURE__*/createElement(Measure, {
      bounds: true,
      onResize: debounce(100, this.onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef,
        className: joinClasses(styles$m$1.textField, className)
      }, options && Boolean(options.length) ? (/*#__PURE__*/createElement("div", {
        className: styles$m$1.textFieldWrapperClass
      }, textFieldContent)) : textFieldContent, /*#__PURE__*/createElement(ContentAlignment, {
        element: "div",
        direction: "row",
        alignment: "baseline",
        className: styles$m$1.textFieldLabel
      }, label && (/*#__PURE__*/createElement(LabelInput, {
        htmlFor: id,
        label: label,
        element: "label",
        className: joinClasses(styles$m$1.textFieldLabelText, resetStyles.maxWidthReset),
        disabled: disabled,
        required: required
      })), label && subLabel && (/*#__PURE__*/createElement(HintError, {
        hint: subLabel,
        id: hintErrorId,
        className: styles$m$1.textFieldLabelSub,
        disabled: disabled
      }))), helptext || error ? (/*#__PURE__*/createElement(HintError, {
        error: error,
        hint: helptext,
        id: hintErrorId,
        className: styles$m$1.textFieldHintError,
        disabled: disabled
      })) : null);
    });
  };
  return TextFieldComponent;
}(Component);
var TextField = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(TextFieldComponent, __assign$1({
    forwardRef: ref
  }, props));
});
TextField.displayName = 'CoreTextField';

var styles$n$1 = {"toast":"fr-ec-toast","toast--attention":"fr-ec-toast--attention","toastAttention":"fr-ec-toast--attention","toast__icon":"fr-ec-toast__icon","toastIcon":"fr-ec-toast__icon","toast__caption":"fr-ec-toast__caption","toastCaption":"fr-ec-toast__caption","toast__button-container":"fr-ec-toast__button-container","toastButtonContainer":"fr-ec-toast__button-container","toast--close-button":"fr-ec-toast--close-button","toastCloseButton":"fr-ec-toast--close-button"};

var Toast = function Toast(_a) {
  var icon = _a.icon,
    children = _a.children,
    className = _a.className,
    linkTextLabel = _a.linkTextLabel,
    linkTextIcon = _a.linkTextIcon,
    element = _a.element,
    _b = _a.variant,
    variant = _b === void 0 ? 'dark' : _b,
    _c = _a.autoClose,
    autoClose = _c === void 0 ? false : _c,
    _d = _a.autoCloseDelay,
    autoCloseDelay = _d === void 0 ? 5000 : _d,
    _e = _a.enableCloseButton,
    enableCloseButton = _e === void 0 ? false : _e,
    onClose = _a.onClose,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["icon", "children", "className", "linkTextLabel", "linkTextIcon", "element", "variant", "autoClose", "autoCloseDelay", "enableCloseButton", "onClose", "iconBrand"]);
  var _f = useState(autoClose),
    showAutoHideToaster = _f[0],
    setHideToaster = _f[1];
  var _g = useState(false),
    closeToaster = _g[0],
    setCloseToasterValue = _g[1];
  var closeToast = function closeToast() {
    setCloseToasterValue(true);
    if (onClose) {
      onClose();
    }
  };
  var ToastComponent = /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$n$1.toast, styles$n$1["toast--".concat(variant)], className)
  }, icon && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$n$1.toastIcon
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: iconBrand ? "".concat(iconBrand).concat(icon) : icon
  }))), /*#__PURE__*/React__default.createElement(Caption, {
    element: "p",
    className: joinClasses(styles$n$1.toastCaption, resetStyles.maxWidthReset),
    color: "primary-light"
  }, children), linkTextLabel && element && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$n$1.toastButtonContainer
  },
  /*#__PURE__*/
  // @ts-ignore
  React__default.createElement(LinkText, __assign$1({
    element: element,
    icon: linkTextIcon,
    iconBrand: iconBrand
  }, props), linkTextLabel))), enableCloseButton && (/*#__PURE__*/React__default.createElement("div", {
    className: styles$n$1.toastCloseButton
  }, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    hideLabel: true,
    onClick: closeToast,
    element: "button",
    label: "close",
    icon: "close-big",
    variant: "light",
    iconBrand: iconBrand
  }))));
  useEffect(function () {
    setTimeout(function () {
      if (showAutoHideToaster) {
        setHideToaster(false);
        if (onClose) {
          onClose();
        }
      }
    }, autoCloseDelay);
  }, [showAutoHideToaster]);
  return showAutoHideToaster ? ToastComponent : !autoClose && !closeToaster ? ToastComponent : null;
};
Toast.displayName = 'CoreToast';

var styles$p$1 = {"product-tile":"fr-ec-product-tile","productTile":"fr-ec-product-tile","product-tile__horizontal":"fr-ec-product-tile__horizontal","productTileHorizontal":"fr-ec-product-tile__horizontal","product-tile__rank":"fr-ec-product-tile__rank","productTileRank":"fr-ec-product-tile__rank","badge-ranking":"fr-ec-badge-ranking","badgeRanking":"fr-ec-badge-ranking","product-tile__vertical":"fr-ec-product-tile__vertical","productTileVertical":"fr-ec-product-tile__vertical","product-tile__horizontal_spacing":"fr-ec-product-tile__horizontal_spacing","productTileHorizontalSpacing":"fr-ec-product-tile__horizontal_spacing","product-tile__horizontal-spacing-ec-renewal":"fr-ec-product-tile__horizontal-spacing-ec-renewal","productTileHorizontalSpacingEcRenewal":"fr-ec-product-tile__horizontal-spacing-ec-renewal","product-tile__horizontal-small-spacing-ec-renewal":"fr-ec-product-tile__horizontal-small-spacing-ec-renewal","productTileHorizontalSmallSpacingEcRenewal":"fr-ec-product-tile__horizontal-small-spacing-ec-renewal","product-tile__toggle":"fr-ec-product-tile__toggle","productTileToggle":"fr-ec-product-tile__toggle","product-tile__toggle--ec-renewal":"fr-ec-product-tile__toggle--ec-renewal","productTileToggleEcRenewal":"fr-ec-product-tile__toggle--ec-renewal","product-tile__image":"fr-ec-product-tile__image","productTileImage":"fr-ec-product-tile__image","product-tile__chip-group":"fr-ec-product-tile__chip-group","productTileChipGroup":"fr-ec-product-tile__chip-group","chip-group-product-tile__toggle-button":"fr-ec-chip-group-product-tile__toggle-button","chipGroupProductTileToggleButton":"fr-ec-chip-group-product-tile__toggle-button","chip-group-product-tile-er__toggle-button":"fr-ec-chip-group-product-tile-er__toggle-button","chipGroupProductTileErToggleButton":"fr-ec-chip-group-product-tile-er__toggle-button","product-tile__product-info":"fr-ec-product-tile__product-info","productTileProductInfo":"fr-ec-product-tile__product-info","product-tile__product-info--full-width":"fr-ec-product-tile__product-info--full-width","productTileProductInfoFullWidth":"fr-ec-product-tile__product-info--full-width","chip-group-product-tile-er":"fr-ec-chip-group-product-tile-er","chipGroupProductTileEr":"fr-ec-chip-group-product-tile-er","product-tile__product-info--ec-renewal":"fr-ec-product-tile__product-info--ec-renewal","productTileProductInfoEcRenewal":"fr-ec-product-tile__product-info--ec-renewal","product-tile__status-flags-list":"fr-ec-product-tile__status-flags-list","productTileStatusFlagsList":"fr-ec-product-tile__status-flags-list","product-tile__specs":"fr-ec-product-tile__specs","productTileSpecs":"fr-ec-product-tile__specs","product-tile__status-flags-list-item":"fr-ec-product-tile__status-flags-list-item","productTileStatusFlagsListItem":"fr-ec-product-tile__status-flags-list-item","product-tile__end":"fr-ec-product-tile__end","productTileEnd":"fr-ec-product-tile__end","product-tile__end--padding":"fr-ec-product-tile__end--padding","productTileEndPadding":"fr-ec-product-tile__end--padding","product-tile__end--padding-vertical-small":"fr-ec-product-tile__end--padding-vertical-small","productTileEndPaddingVerticalSmall":"fr-ec-product-tile__end--padding-vertical-small","product-tile__end-product-name":"fr-ec-product-tile__end-product-name","productTileEndProductName":"fr-ec-product-tile__end-product-name","product-tile__end-product-id":"fr-ec-product-tile__end-product-id","productTileEndProductId":"fr-ec-product-tile__end-product-id","product-tile__end-info-block":"fr-ec-product-tile__end-info-block","productTileEndInfoBlock":"fr-ec-product-tile__end-info-block","product-tile__end-info-block-flags":"fr-ec-product-tile__end-info-block-flags","productTileEndInfoBlockFlags":"fr-ec-product-tile__end-info-block-flags","product-tile__end-info-block-price":"fr-ec-product-tile__end-info-block-price","productTileEndInfoBlockPrice":"fr-ec-product-tile__end-info-block-price","product-tile__end-info-block-price-flags":"fr-ec-product-tile__end-info-block-price-flags","productTileEndInfoBlockPriceFlags":"fr-ec-product-tile__end-info-block-price-flags","rating-static__reviews":"fr-ec-rating-static__reviews","ratingStaticReviews":"fr-ec-rating-static__reviews","link-text":"fr-ec-link-text","linkText":"fr-ec-link-text","body":"fr-ec-body","product-tile__end-info-block-tags":"fr-ec-product-tile__end-info-block-tags","productTileEndInfoBlockTags":"fr-ec-product-tile__end-info-block-tags","tag":"fr-ec-tag","product-tile--width-small":"fr-ec-product-tile--width-small","productTileWidthSmall":"fr-ec-product-tile--width-small","chip-group-product-tile__fieldset":"fr-ec-chip-group-product-tile__fieldset","chipGroupProductTileFieldset":"fr-ec-chip-group-product-tile__fieldset","chip-group-product-tile__chip":"fr-ec-chip-group-product-tile__chip","chipGroupProductTileChip":"fr-ec-chip-group-product-tile__chip","chip__input--product-tile":"fr-ec-chip__input--product-tile","chipInputProductTile":"fr-ec-chip__input--product-tile","chip__label--product-tile":"fr-ec-chip__label--product-tile","chipLabelProductTile":"fr-ec-chip__label--product-tile","chip-group-product-tile__fieldset--expanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chipGroupProductTileFieldsetExpanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chip--product-tile":"fr-ec-chip--product-tile","chipProductTile":"fr-ec-chip--product-tile","product-tile-resize-wrapper":"fr-ec-product-tile-resize-wrapper","productTileResizeWrapper":"fr-ec-product-tile-resize-wrapper","product-tile__category-section":"fr-ec-product-tile__category-section","productTileCategorySection":"fr-ec-product-tile__category-section","product-tile__category-section-horizontal":"fr-ec-product-tile__category-section-horizontal","productTileCategorySectionHorizontal":"fr-ec-product-tile__category-section-horizontal","product-tile__category-first-item":"fr-ec-product-tile__category-first-item","productTileCategoryFirstItem":"fr-ec-product-tile__category-first-item","product-tile__category-item":"fr-ec-product-tile__category-item","productTileCategoryItem":"fr-ec-product-tile__category-item","button-toggle":"fr-ec-button-toggle","buttonToggle":"fr-ec-button-toggle","product-tile__horizontal-small":"fr-ec-product-tile__horizontal-small","productTileHorizontalSmall":"fr-ec-product-tile__horizontal-small","product-tile__end--padding-horizontal-small":"fr-ec-product-tile__end--padding-horizontal-small","productTileEndPaddingHorizontalSmall":"fr-ec-product-tile__end--padding-horizontal-small","product-tile__end--padding-horizontal":"fr-ec-product-tile__end--padding-horizontal","productTileEndPaddingHorizontal":"fr-ec-product-tile__end--padding-horizontal","product-tile__horizontal-small-chip-group":"fr-ec-product-tile__horizontal-small-chip-group","productTileHorizontalSmallChipGroup":"fr-ec-product-tile__horizontal-small-chip-group","link-text--disabled":"fr-ec-link-text--disabled","linkTextDisabled":"fr-ec-link-text--disabled","product-tile__product-info--no-left-padding":"fr-ec-product-tile__product-info--no-left-padding","productTileProductInfoNoLeftPadding":"fr-ec-product-tile__product-info--no-left-padding","product-tile__original-price":"fr-ec-product-tile__original-price","productTileOriginalPrice":"fr-ec-product-tile__original-price"};

// Flag variants
var FlagUITypes = {
  GENDER: 'gender',
  LIMITED: 'limited',
  LIMITED_GREY: 'limited-grey',
  NORMAL: 'normal'
};
var containerSizeSmall = 'small';
var containerSizeLarge = 'large';
var isLimitedFlag = function isLimitedFlag(_a) {
  var type = _a.type;
  return type === FlagUITypes.LIMITED || type === FlagUITypes.LIMITED_GREY;
};
var createStringFromFlagsList = function createStringFromFlagsList(flags) {
  return flags && flags.length > 0 ? flags.map(function (_a) {
    var flag = _a.flag;
    return flag;
  }).join(', ') : '';
};
var convertFlagTypeToColor = function convertFlagTypeToColor(type) {
  switch (type) {
    case FlagUITypes.LIMITED:
      return 'promotional';
    case FlagUITypes.NORMAL:
      return 'placeholder';
    default:
      return 'placeholder';
  }
};
var StatusFlags = function StatusFlags(_a) {
  var className = _a.className,
    flags = _a.flags;
  var highlightedFlags = flags.filter(isLimitedFlag);
  var normalFlags = flags.filter(function (flag) {
    return !isLimitedFlag(flag);
  });
  var combinedFlags = createStringFromFlagsList(normalFlags);
  return /*#__PURE__*/createElement("ul", {
    className: joinClasses(styles$p$1.productTileStatusFlagsList, className)
  }, highlightedFlags && highlightedFlags.map(function (_a) {
    var flag = _a.flag,
      type = _a.type;
    return /*#__PURE__*/createElement("li", {
      key: flag,
      className: styles$p$1.productTileStatusFlagsListItem
    }, /*#__PURE__*/createElement(FlagText, {
      element: "p",
      variant: "large",
      color: convertFlagTypeToColor(type)
    }, flag));
  }), combinedFlags && (/*#__PURE__*/createElement("li", null, /*#__PURE__*/createElement(FlagText, {
    element: "p",
    variant: "large",
    color: "placeholder",
    className: styles$p$1.productTileStatusFlagsListItem
  }, combinedFlags))));
};
var ProductPrice = function ProductPrice(_a) {
  var price = _a.price,
    originalPrice = _a.originalPrice,
    _b = _a.highlighted,
    highlighted = _b === void 0 ? false : _b,
    tax = _a.tax,
    multiBuy = _a.multiBuy,
    _c = _a.multiPrice,
    multiPrice = _c === void 0 ? false : _c,
    items = _a.items,
    discount = _a.discount,
    _d = _a.priceTypographyVariant,
    priceTypographyVariant = _d === void 0 ? 'small' : _d,
    _e = _a.ecRenewal,
    ecRenewal = _e === void 0 ? false : _e;
  return /*#__PURE__*/createElement("div", {
    className: styles$p$1.productTileEndInfoBlockPrice
  }, /*#__PURE__*/createElement("div", null, originalPrice && (/*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "standard",
    size: "extraSmall",
    strikeThrough: true,
    discount: discount,
    className: styles$p$1.productTileOriginalPrice
  }, originalPrice)), multiBuy && !multiPrice && (/*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "promotional",
    size: ecRenewal ? 'middle' : priceTypographyVariant === 'large' ? 'large' : 'small'
  }, multiBuy)), highlighted && price && (/*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "promotional",
    size: ecRenewal ? 'middle' : priceTypographyVariant === 'large' ? 'large' : 'small'
  }, price)), !highlighted && price && (/*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "standard",
    size: ecRenewal ? 'middle' : priceTypographyVariant === 'large' ? 'large' : 'small'
  }, price)), tax && (/*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "standard",
    size: ecRenewal ? 'middle' : priceTypographyVariant === 'large' ? 'large' : 'small'
  }, tax)), multiBuy && multiPrice && (/*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "promotional",
    size: ecRenewal ? 'middle' : priceTypographyVariant === 'large' ? 'large' : 'small'
  }, multiBuy))), items && /*#__PURE__*/createElement(StatusFlags, {
    className: styles$p$1.productTileEndInfoBlockPriceFlags,
    flags: items
  }));
};
var ProductTile = /** @class */function (_super) {
  __extends(ProductTile, _super);
  function ProductTile(props) {
    var _this = _super.call(this, props) || this;
    _this.linkEnabled = true;
    _this.onToggle = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var onClickFavorite = _this.props.onClickFavorite;
      if (onClickFavorite) {
        onClickFavorite(!_this.props.favorite, event);
      }
    };
    _this.onExpandedToggle = function (isExpanded) {
      _this.setState({
        isExpanded: isExpanded
      });
    };
    _this.onChipClick = function (index) {
      _this.setState({
        currentChip: index,
        // fallthrough to default main image
        imagePreview: _this.props.images && _this.props.images[index] || _this.props.imageUrl || _this.props.images && _this.props.images[0]
      });
    };
    _this.onChipPreviewSet = function (index) {
      _this.setState({
        imageHover: _this.props.images && _this.props.images[index]
      });
    };
    _this.onChipPreviewClose = function () {
      _this.setState({
        imageHover: undefined
      });
    };
    // Disabled to enable click to trigger tile link
    _this.onReviewClick = function () {
      // e.preventDefault();
      // if (this.props.reviewUrl) {
      //   const route = `/${country}/${language}${this.props.reviewUrl}`;
      //   window.location.href = route;
      // }
    };
    _this.onResize = function (contentRect) {
      if (contentRect.bounds) {
        var width = contentRect.bounds.width;
        // Check if the container width matches the small breakpoint
        if (width <= 125) {
          _this.setState({
            containerSize: containerSizeSmall
          });
        }
        // Check if the container width matches the large breakpoint
        else {
          _this.setState({
            containerSize: containerSizeLarge
          });
        }
      }
    };
    _this.disableLink = _this.disableLink.bind(_this);
    _this.enableLink = _this.enableLink.bind(_this);
    _this.enableLinkOnMouseLeave = _this.enableLinkOnMouseLeave.bind(_this);
    _this.onTileClick = _this.onTileClick.bind(_this);
    _this.state = {
      containerSize: containerSizeLarge,
      currentChip: props.currentChip || 0,
      imageHover: undefined,
      imagePreview: props.imageUrl || props.images && props.images[0],
      isExpanded: false
    };
    return _this;
  }
  ProductTile.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.imageUrl && this.props.imageUrl !== prevProps.imageUrl) {
      this.setState({
        imagePreview: this.props.imageUrl
      });
    }
    if (prevProps.currentChip !== this.props.currentChip) {
      this.setState({
        currentChip: Number(this.props.currentChip)
      });
    }
  };
  ProductTile.prototype.onTileClick = function (e) {
    if (!this.linkEnabled) {
      e.preventDefault();
    }
  };
  /**
   * When a user clicks on an internal button (from the chip group) it will
   * click through to the anchor underneath.
   * To get around this anytime the mouse enters the ChipGroupProductTile, we
   * disable the link, and anytime it exits, we enable it.
   */
  ProductTile.prototype.disableLink = function () {
    this.linkEnabled = false;
  };
  ProductTile.prototype.enableLink = function () {
    this.linkEnabled = true;
  };
  /**
   * When mousing over interactive elements inside the tile (i.e. ButtonToggle, ChipGroup), we disable the underlying link.
   * On `mouseleave`, we want to re-enable the link.
   * `mouseleave` however triggers when even entering nested DOM nodes.
   * So rather than using the native event target, we check to ensure that
   * the pointer is fact not within the clientBoundingRect of the node we
   * have the `mouseleave` event on
   */
  ProductTile.prototype.enableLinkOnMouseLeave = function (e) {
    var target = e.target,
      screenX = e.screenX,
      screenY = e.screenY;
    // @ts-ignore
    var clientRect = target.getBoundingClientRect();
    var isNotWithinElementBounds = !isPointInClientRect(clientRect, screenX, screenY);
    if (isNotWithinElementBounds) {
      this.enableLink();
    }
  };
  ProductTile.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      _b = _a.ecRenewal,
      ecRenewal = _b === void 0 ? false : _b,
      _c = _a.type,
      type = _c === void 0 ? 'wishlist' : _c,
      id = _a.id,
      className = _a.className,
      name = _a.name,
      _d = _a.nameTypographyVariant,
      nameTypographyVariant = _d === void 0 ? 'TitleStandard' : _d,
      favorite = _a.favorite,
      _e = _a.favoriteButtonHidden,
      favoriteButtonHidden = _e === void 0 ? false : _e,
      _f = _a.favoriteIconAlt,
      favoriteIconAlt = _f === void 0 ? '' : _f,
      _g = _a.chipImages,
      chipImages = _g === void 0 ? [] : _g,
      chipGroup = _a.chipGroup,
      rank = _a.rank,
      _h = _a.sizeRange,
      sizeRange = _h === void 0 ? [] : _h,
      _j = _a.genderName,
      genderName = _j === void 0 ? [] : _j,
      _k = _a.flags,
      flags = _k === void 0 ? [] : _k,
      currentPrice = _a.currentPrice,
      priceHighlighted = _a.priceHighlighted,
      _l = _a.productLink,
      productLink = _l === void 0 ? '' : _l,
      _m = _a.tax,
      tax = _m === void 0 ? '' : _m,
      _o = _a.priceFlags,
      priceFlags = _o === void 0 ? [] : _o,
      ratingCount = _a.ratingCount,
      _p = _a.ratingAverage,
      ratingAverage = _p === void 0 ? '' : _p,
      _q = _a.promotionText,
      promotionText = _q === void 0 ? '' : _q,
      _r = _a.productId,
      productId = _r === void 0 ? '' : _r,
      _s = _a.gaCategory,
      gaCategory = _s === void 0 ? '' : _s,
      _t = _a.gaCallback,
      gaCallback = _t === void 0 ? function () {
        return null;
      } : _t,
      _u = _a.l1Id,
      l1Id = _u === void 0 ? '' : _u,
      _v = _a.noImageLabel,
      noImageLabel = _v === void 0 ? '' : _v,
      _w = _a.maxLinesEllipsis,
      maxLinesEllipsis = _w === void 0 ? 0 : _w,
      _x = _a.productCollectionType,
      productCollectionType = _x === void 0 ? 'grid' : _x,
      iconBrand = _a.iconBrand,
      _y = _a.variant,
      variant = _y === void 0 ? 'vertical' : _y,
      target = _a.target,
      originalPrice = _a.originalPrice,
      discount = _a.discount,
      tags = _a.tags,
      _z = _a.imageRatio,
      imageRatio = _z === void 0 ? '1x1' : _z,
      _0 = _a.enableChipInteraction,
      enableChipInteraction = _0 === void 0 ? false : _0,
      informationContent = _a.informationContent,
      buttonToggle = _a.buttonToggle,
      media = _a.media;
    var _1 = this.state,
      currentChip = _1.currentChip,
      imagePreview = _1.imagePreview,
      imageHover = _1.imageHover,
      isExpanded = _1.isExpanded;
    var gaProps = {
      gaCallback: gaCallback,
      gaCategory: gaCategory,
      gaLabel: l1Id || 'l1-id'
    };
    var onClick = function onClick(event) {
      _this.onTileClick(event);
    };
    var mappedChipImages = chipImages ? chipImages.map(function (chipItem, i) {
      return {
        image: chipItem.url,
        label: chipItem.alt,
        name: 'product-chips',
        type: 'radio',
        value: "".concat(i),
        variant: 'short'
      };
    }) : [];
    var rootTag = 'a';
    var absoluteUrlPattern = isAbsoluteUrl(productLink);
    var attributes = {};
    if (absoluteUrlPattern) {
      attributes = {
        href: productLink,
        target: target || '_self'
      };
    } else if (productLink) {
      rootTag = Link$1;
      // Default target behaviour of Link is similar to that of '_self'.
      // But if you specify target property explicitly, it refreshes the page.
      // @ts-ignore
      attributes.to = productLink;
      if (target && target !== '_self') {
        // @ts-ignore
        attributes.target = target;
      }
    }
    var imageProps = {
      alt: name,
      iconBrand: iconBrand,
      noImage: {
        imageSize: 'default',
        imageType: 'product',
        noImageLabel: noImageLabel
      },
      ratio: imageRatio,
      src: imageHover || imagePreview || ''
    };
    var genderNames = genderName && genderName.join(', ');
    var sizeRanges = sizeRange && sizeRange.join('-');
    var categories = genderNames && sizeRanges ? "".concat(genderNames, ", ").concat(sizeRanges) : genderNames || sizeRanges;
    var showCategory = categories ? productCollectionType && (productCollectionType === 'grid' || productCollectionType === 'setup') ? true : false : false;
    var showRating = ratingCount && ratingCount > 0 ? productCollectionType && (productCollectionType === 'grid' || productCollectionType === 'setup') ? true : false : false;
    var productTags = tags && tags.length ? tags.map(function (item, i) {
      return /*#__PURE__*/createElement(Tag, {
        key: i,
        variant: item.variant,
        value: item.tag
      });
    }) : null;
    var nameTitleVariant = nameTypographyVariant === 'TitleLarge' ? 'large' : 'standard';
    var productTileContent = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses((variant === 'horizontal' || variant === 'horizontal-small') && !ecRenewal ? styles$p$1.productTileHorizontalSpacing : '', variant === 'horizontal' && ecRenewal ? styles$p$1.productTileHorizontalSpacingEcRenewal : '', variant === 'horizontal-small' && ecRenewal ? styles$p$1.productTileHorizontalSmallSpacingEcRenewal : '')
    }, /*#__PURE__*/createElement("div", {
      className: styles$p$1.productTileImage
    }, ecRenewal ? media : /*#__PURE__*/createElement(Image, __assign$1({}, imageProps)), !favoriteButtonHidden && !ecRenewal && (/*#__PURE__*/createElement(ButtonToggle, {
      icon: "heart",
      variant: "icon",
      text: "favorite icon",
      iconTitle: favoriteIconAlt,
      isToggled: favorite,
      className: styles$p$1.productTileToggle,
      onClick: this.onToggle,
      onMouseLeave: this.enableLinkOnMouseLeave,
      onMouseEnter: this.disableLink,
      onFocus: this.disableLink,
      onBlur: this.enableLink,
      iconBrand: iconBrand
    }))), (chipImages.length > 0 || showCategory) && !ecRenewal && (/*#__PURE__*/createElement(ContentAlignment, {
      className: joinClasses(styles$p$1.productTileProductInfo),
      element: "div",
      direction: type === 'large' ? 'row' : 'column',
      alignment: 'stretch',
      justifyContent: "space-between"
    }, chipImages.length > 0 && (/*#__PURE__*/createElement(ChipGroupProductTile, {
      title: [name, 'chipgroup'].join('-'),
      id: [id, 'chipgroup'].join('-'),
      onMouseLeave: this.enableLinkOnMouseLeave,
      onMouseEnter: this.disableLink,
      onFocus: this.disableLink,
      onBlur: this.enableLink,
      onExpandedToggle: this.onExpandedToggle,
      expanded: isExpanded,
      expandButtonAlt: "See more chips.",
      collapseButtonAlt: "See fewer chips.",
      className: styles$p$1.productTileChipGroup,
      containerWidth: this.state.containerSize,
      enableInteraction: enableChipInteraction
    }, chipImages && mappedChipImages ? mappedChipImages.map(function (_a, i) {
      var chipGroupName = _a.name,
        chipProps = __rest$1(_a, ["name"]);
      return /*#__PURE__*/createElement(Chip, __assign$1({
        checked: chipProps.value === String(currentChip),
        key: [name, 'chip', i].join('-'),
        id: [id, 'chip', i].join('-'),
        variant: "product-tile",
        onChange: function onChange() {
          return _this.onChipClick(i);
        },
        onMouseOver: function onMouseOver() {
          return _this.onChipPreviewSet(i);
        },
        onMouseLeave: _this.onChipPreviewClose,
        onFocus: function onFocus() {
          _this.disableLink();
          _this.onChipPreviewSet(i);
        },
        onBlur: function onBlur() {
          _this.enableLink();
          _this.onChipPreviewClose();
        },
        name: [id, chipGroupName].join('-'),
        iconBrand: iconBrand
      }, chipProps));
    }) : [])), showCategory && (/*#__PURE__*/createElement(ContentAlignment, {
      className: styles$p$1['product-tile__specs'],
      element: "div",
      direction: "row",
      justifyContent: "space-between"
    }, /*#__PURE__*/createElement(FlagText, {
      element: "p",
      className: 'product-tile__categories',
      variant: "standard"
    }, categories))))), ecRenewal && variant !== 'horizontal' && variant !== 'horizontal-small' && (chipGroup || buttonToggle) && (/*#__PURE__*/createElement(ContentAlignment, {
      className: joinClasses(styles$p$1.productTileProductInfo, ecRenewal && styles$p$1.productTileProductInfoEcRenewal, ecRenewal && variant === 'vertical-small' && styles$p$1.productTileProductInfoNoLeftPadding),
      element: "div",
      direction: type === 'large' || ecRenewal ? 'row' : 'column',
      alignment: ecRenewal ? 'center' : 'stretch',
      justifyContent: "space-between"
    }, chipGroup ? chipGroup : null, buttonToggle && /*#__PURE__*/cloneElement(buttonToggle, {
      onMouseLeave: this.enableLinkOnMouseLeave,
      onMouseEnter: this.disableLink,
      onFocus: this.disableLink,
      onBlur: this.enableLink,
      ariaLabel: 'favorite icon'
    })))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$p$1.productTileEnd, ecRenewal && variant === 'vertical' && styles$p$1.productTileEndPadding, ecRenewal && variant === 'vertical-small' && styles$p$1.productTileEndPaddingVerticalSmall, ecRenewal && variant === 'horizontal' && styles$p$1.productTileEndPaddingHorizontal, ecRenewal && variant === 'horizontal-small' && styles$p$1.productTileEndPaddingHorizontalSmall)
    }, ecRenewal && variant === 'horizontal' && (chipGroup || buttonToggle) && (/*#__PURE__*/createElement(ContentAlignment, {
      className: joinClasses(styles$p$1.productTileProductInfo, styles$p$1.productTileProductInfoFullWidth),
      element: "div",
      direction: type === 'large' || ecRenewal ? 'row' : 'column',
      alignment: ecRenewal ? 'center' : 'stretch',
      justifyContent: "space-between"
    }, chipGroup ? chipGroup : null, buttonToggle && /*#__PURE__*/cloneElement(buttonToggle, {
      onMouseLeave: this.enableLinkOnMouseLeave,
      onMouseEnter: this.disableLink,
      onFocus: this.disableLink,
      onBlur: this.enableLink,
      ariaLabel: 'favorite icon'
    }))), ecRenewal && variant === 'horizontal-small' && chipGroup && /*#__PURE__*/isValidElement(chipGroup) ? (/*#__PURE__*/createElement("div", {
      className: styles$p$1.productTileHorizontalSmallChipGroup
    }, chipGroup)) : null, ecRenewal && (variant === 'vertical' || variant === 'vertical-small') && (genderNames || sizeRanges) && (/*#__PURE__*/createElement("div", {
      className: styles$p$1.productTileCategorySection
    }, /*#__PURE__*/createElement(FlagText, {
      element: "p",
      variant: "standard"
    }, categories))), ecRenewal && (variant === 'horizontal' || variant === 'horizontal-small') && (genderNames || sizeRanges) && (/*#__PURE__*/createElement("div", {
      className: styles$p$1.productTileCategorySectionHorizontal
    }, /*#__PURE__*/createElement(FlagText, {
      element: "p",
      variant: "standard"
    }, categories))), name && (/*#__PURE__*/createElement(Title, {
      style: {
        WebkitLineClamp: maxLinesEllipsis
      },
      variant: ecRenewal ? 'product-tile-horizontal' : nameTitleVariant,
      element: "h3",
      className: joinClasses(styles$p$1.productTileEndProductName, ecRenewal && variant === 'horizontal' ? typographyStyles.titleProductTileHorizontal : '')
    }, name)), informationContent ? (/*#__PURE__*/createElement("div", null, informationContent)) : (/*#__PURE__*/createElement(Fragment, null, productId && (/*#__PURE__*/createElement(Body, {
      element: "p",
      variant: "small",
      className: styles$p$1.productTileEndProductId
    }, productId)), /*#__PURE__*/createElement(ContentAlignment, {
      element: "div",
      direction: "column",
      justifyContent: "space-between",
      className: styles$p$1.productTileEndInfoBlock
    }, !!flags.length && /*#__PURE__*/createElement(StatusFlags, {
      flags: flags,
      className: styles$p$1.productTileEndInfoBlockFlags
    }), /*#__PURE__*/createElement(ProductPrice, {
      price: currentPrice,
      highlighted: priceHighlighted,
      tax: tax,
      items: priceFlags,
      originalPrice: originalPrice,
      discount: discount,
      priceTypographyVariant: nameTypographyVariant === 'TitleLarge' ? 'large' : 'small',
      ecRenewal: ecRenewal
    }), promotionText && (/*#__PURE__*/createElement(Caption, {
      element: "p",
      color: "secondary"
    }, promotionText)), showRating && !ecRenewal && (/*#__PURE__*/createElement(RatingStatic, {
      ariaLabel: name,
      reviews: ratingCount,
      value: parseFloat(ratingAverage),
      iconBrand: iconBrand
    }, /*#__PURE__*/createElement(LinkText, {
      element: "button",
      variant: "standalone-small",
      onClick: this.onReviewClick
    }, "(".concat(ratingCount && ratingCount > 999 ? '999+' : ratingCount, ")")))), productTags && /*#__PURE__*/createElement("div", {
      className: styles$p$1.productTileEndInfoBlockTags
    }, productTags))))), ecRenewal && variant === 'horizontal-small' && buttonToggle ? /*#__PURE__*/cloneElement(buttonToggle, {
      onMouseLeave: this.enableLinkOnMouseLeave,
      onMouseEnter: this.disableLink,
      onFocus: this.disableLink,
      onBlur: this.enableLink,
      ariaLabel: 'favorite icon'
    }) : null);
    return /*#__PURE__*/createElement(Measure, {
      bounds: true,
      onResize: debounce(100, this.onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef,
        className: styles$p$1.productTileResizeWrapper
      }, ecRenewal && rank && variant === 'vertical' && (/*#__PURE__*/createElement("div", {
        className: styles$p$1.productTileRank
      }, /*#__PURE__*/createElement(BadgeRanking, {
        ariaLabel: "Rank".concat(rank),
        rank: rank
      }))), productLink ? (/*#__PURE__*/createElement(Tile, __assign$1({
        tabIndex: 0,
        className: joinClasses(className, styles$p$1.productTile, styles$p$1["product-tile--variant-".concat(type)], styles$p$1["product-tile--width-".concat(_this.state.containerSize)], variant === 'horizontal' || variant === 'horizontal-small' ? styles$p$1.productTileHorizontal : styles$p$1.productTileVertical, variant === 'horizontal-small' ? styles$p$1.productTileHorizontalSmall : ''),
        id: id !== null && id !== void 0 ? id : productId,
        onClick: onClick,
        element: rootTag
      }, attributes, gaProps), productTileContent)) : (/*#__PURE__*/createElement("div", __assign$1({
        className: joinClasses(className, styles$p$1.productTile, styles$p$1["product-tile--variant-".concat(type)], styles$p$1["product-tile--width-".concat(_this.state.containerSize)], variant === 'horizontal' || variant === 'horizontal-small' ? styles$p$1.productTileHorizontal : styles$p$1.productTileVertical, variant === 'horizontal-small' ? styles$p$1.productTileHorizontalSmall : ''),
        id: id !== null && id !== void 0 ? id : productId
      }, gaProps), productTileContent)));
    });
  };
  return ProductTile;
}(Component);

var styles$q$1 = {"tag-filter-group":"fr-ec-tag-filter-group","tagFilterGroup":"fr-ec-tag-filter-group","tag-filter-group__no-wrap-container":"fr-ec-tag-filter-group__no-wrap-container","tagFilterGroupNoWrapContainer":"fr-ec-tag-filter-group__no-wrap-container","tag-filter-group__inner-container":"fr-ec-tag-filter-group__inner-container","tagFilterGroupInnerContainer":"fr-ec-tag-filter-group__inner-container","tag-filter-group--no-wrap":"fr-ec-tag-filter-group--no-wrap","tagFilterGroupNoWrap":"fr-ec-tag-filter-group--no-wrap","swiper-container":"fr-ec-swiper-container","swiperContainer":"fr-ec-swiper-container","tag-filter-group__tag-filter__label":"fr-ec-tag-filter-group__tag-filter__label","tagFilterGroupTagFilterLabel":"fr-ec-tag-filter-group__tag-filter__label","tag-filter__label":"fr-ec-tag-filter__label","tagFilterLabel":"fr-ec-tag-filter__label","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","tag-filter-clear-all-label":"fr-ec-tag-filter-clear-all-label","tagFilterClearAllLabel":"fr-ec-tag-filter-clear-all-label"};

var TagFilterGroup = function TagFilterGroup(_a) {
  var children = _a.children,
    onClear = _a.onClear,
    clearLabel = _a.clearLabel,
    className = _a.className,
    _b = _a.wrap,
    wrap = _b === void 0 ? true : _b,
    _c = _a.ecRenewal,
    ecRenewal = _c === void 0 ? true : _c,
    props = __rest$1(_a, ["children", "onClear", "clearLabel", "className", "wrap", "ecRenewal"]);
  var _d = useState(getCurrentMediaQueryBreakpoint()),
    breakpoint = _d[0],
    setBreakPointValue = _d[1];
  var onWindowSize = debounce(100, function (_) {
    setBreakPointValue(getCurrentMediaQueryBreakpoint());
  });
  var clickCallback = function clickCallback(e) {
    return onClear && onClear(e, children);
  };
  var showClearAll = Children.toArray(children).filter(isValidElement).filter(function (child) {
    return Boolean(child && !child.props.disabled);
  }).length > 1;
  var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child) {
    return /*#__PURE__*/cloneElement(child, {
      className: styles$q$1.tagFilterGroupTagFilterLabel
    });
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onWindowSize);
    }
    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', onWindowSize);
      }
    };
  }, []);
  var wrapProp = typeof wrap === 'boolean' ? wrap : wrap[breakpoint];
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(styles$q$1.tagFilterGroup, !wrapProp && styles$q$1.tagFilterGroupNoWrapContainer, className)
  }, props), /*#__PURE__*/createElement(CollectionListHorizontal, {
    spacingValue: "16",
    divider: false,
    className: joinClasses(styles$q$1.tagFilterGroupInnerContainer, !wrapProp && styles$q$1.tagFilterGroupNoWrap, showClearAll && clearLabel && styles$q$1.tagFilterClearAllLabel)
  }, wrapProp ? children : (/*#__PURE__*/createElement(FilterBar, {
    isOverlay: false,
    slidesOffsetBefore: true
  }, childrenWithProps)), showClearAll && clearLabel && (/*#__PURE__*/createElement(LinkText, {
    element: "button",
    emphasize: false,
    onClick: clickCallback,
    variant: "standalone-primary",
    key: clearLabel,
    ecRenewal: ecRenewal,
    position: "standalone",
    typography: "bodyStandard",
    typographyColor: "noticeableBlue"
  }, clearLabel))));
};
TagFilterGroup.displayName = 'CoreTagFilterGroup';

var styles$r$1 = {"rating-input__caption":"fr-ec-rating-input__caption","ratingInputCaption":"fr-ec-rating-input__caption","rating-input__caption--inactive":"fr-ec-rating-input__caption--inactive","ratingInputCaptionInactive":"fr-ec-rating-input__caption--inactive","rating-input__group":"fr-ec-rating-input__group","ratingInputGroup":"fr-ec-rating-input__group","rating-input__radio":"fr-ec-rating-input__radio","ratingInputRadio":"fr-ec-rating-input__radio","rating-input__label":"fr-ec-rating-input__label","ratingInputLabel":"fr-ec-rating-input__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","rating-input__star":"fr-ec-rating-input__star","ratingInputStar":"fr-ec-rating-input__star","rating-input__star--active":"fr-ec-rating-input__star--active","ratingInputStarActive":"fr-ec-rating-input__star--active","rating-input__star--inactive":"fr-ec-rating-input__star--inactive","ratingInputStarInactive":"fr-ec-rating-input__star--inactive"};

var SIZE_ICON = '24';
var getIdForInput = function getIdForInput(parentId, value) {
  return "".concat(parentId, "-input-").concat(value);
};
var getValueMapFromOptions = function getValueMapFromOptions(options, id) {
  return options.reduce(function (acc, option) {
    var _a;
    var inputId = getIdForInput(id, option.value);
    return __assign$1(__assign$1({}, acc), (_a = {}, _a[inputId] = option.value, _a));
  }, {});
};
var RatingInputComponent = /** @class */function (_super) {
  __extends(RatingInputComponent, _super);
  function RatingInputComponent(props) {
    var _this = _super.call(this, props) || this;
    _this.onMouseEnterLabel = function (event) {
      var id = event.currentTarget.getAttribute('for');
      var value = id && _this.valueMap[id];
      _this.setState({
        highlighted: value,
        hovered: value
      });
      if (_this.props.onMouseEnterOption) {
        _this.props.onMouseEnterOption(event);
      }
    };
    _this.onMouseLeaveLabel = function (event) {
      var focused = _this.state.focused;
      var selected = _this.props.selected;
      var value = focused === undefined ? selected : focused;
      _this.setState({
        highlighted: value,
        hovered: undefined
      });
      if (_this.props.onMouseLeaveOption) {
        _this.props.onMouseLeaveOption(event);
      }
    };
    _this.onFocusInput = function (event) {
      var targetValue = event.currentTarget.value;
      _this.setState({
        highlighted: Number(targetValue),
        focused: Number(targetValue)
      });
      if (_this.props.onFocusOption) {
        _this.props.onFocusOption(event);
      }
    };
    _this.onBlurInput = function (event) {
      var hovered = _this.state.hovered;
      var selected = _this.props.selected;
      var value = hovered === undefined ? selected : hovered;
      _this.setState({
        highlighted: value,
        focused: undefined
      });
      if (_this.props.onBlurOption) {
        _this.props.onBlurOption(event);
      }
    };
    var _a = _this.props,
      selected = _a.selected,
      id = _a.id,
      options = _a.options;
    _this.valueMap = getValueMapFromOptions(options, id);
    _this.state = {
      focused: undefined,
      highlighted: selected,
      hovered: undefined
    };
    return _this;
  }
  RatingInputComponent.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
      id = _a.id,
      options = _a.options,
      selected = _a.selected;
    var focused = this.state.focused;
    this.valueMap = getValueMapFromOptions(options, id);
    var value = focused === undefined ? selected : focused;
    if (selected !== prevProps.selected) {
      this.setState({
        highlighted: value,
        hovered: value
      });
    }
  };
  RatingInputComponent.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      legend = _a.legend,
      options = _a.options,
      description = _a.description,
      error = _a.error,
      className = _a.className,
      id = _a.id,
      selected = _a.selected,
      _b = _a.required,
      required = _b === void 0 ? false : _b,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      onChangeOption = _a.onChangeOption,
      forwardRef = _a.forwardRef,
      iconBrand = _a.iconBrand,
      props = __rest$1(_a, ["legend", "options", "description", "error", "className", "id", "selected", "required", "disabled", "onChangeOption", "onMouseEnterOption", "onMouseLeaveOption", "onFocusOption", "onBlurOption", "forwardRef", "iconBrand"]);
    var highlighted = this.state.highlighted;
    var hintErrorId = error && !disabled || description ? "".concat(id, "-hint-error") : undefined;
    var optionIsHighlighted = function optionIsHighlighted(o) {
      return o.value === highlighted;
    };
    var currentOption = options.find(optionIsHighlighted);
    var ratingCaption = currentOption && currentOption.label;
    var highlightedIndex = options.findIndex(optionIsHighlighted);
    return /*#__PURE__*/createElement("fieldset", __assign$1({
      className: joinClasses(resetStyles.fieldsetReset, className),
      id: id,
      disabled: disabled,
      "aria-describedby": hintErrorId
    }, props), /*#__PURE__*/createElement(LabelInput, {
      label: legend,
      element: "label",
      required: required,
      disabled: disabled
    }, !disabled && ratingCaption && (/*#__PURE__*/createElement(Caption, {
      element: "span",
      className: joinClasses(styles$r$1.ratingInputCaption, highlighted !== selected && styles$r$1.ratingInputCaptionInactive)
    }, ratingCaption))), /*#__PURE__*/createElement("div", {
      className: styles$r$1.ratingInputGroup,
      ref: forwardRef
    }, options.map(function (option, index) {
      var radioId = getIdForInput(id, option.value);
      var filled = !disabled && highlightedIndex >= index;
      return /*#__PURE__*/createElement(Fragment, {
        key: radioId
      }, /*#__PURE__*/createElement("input", {
        type: "radio",
        value: option.value,
        checked: option.value === selected,
        className: styles$r$1.ratingInputRadio,
        id: radioId,
        name: id,
        onFocus: _this.onFocusInput,
        onBlur: _this.onBlurInput,
        onChange: onChangeOption
      }), /*#__PURE__*/createElement("label", {
        key: option.value,
        className: joinClasses(styles$r$1.ratingInputLabel, !disabled && interactionsStyles.cursorPointer),
        htmlFor: radioId,
        onMouseEnter: _this.onMouseEnterLabel,
        onMouseLeave: _this.onMouseLeaveLabel
      }, /*#__PURE__*/createElement(Icon, {
        name: iconBrand ? "".concat(iconBrand, "star-filled") : 'star-filled',
        size: SIZE_ICON,
        className: joinClasses(styles$r$1.ratingInputStar, filled ? styles$r$1.ratingInputStarActive : styles$r$1.ratingInputStarInactive)
      }), /*#__PURE__*/createElement("span", null, option.label)));
    })), /*#__PURE__*/createElement(HintError, {
      error: error,
      hint: description,
      id: hintErrorId,
      disabled: disabled
    }));
  };
  return RatingInputComponent;
}(Component);
var RatingInput = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(RatingInputComponent, __assign$1({
    forwardRef: ref
  }, props));
});
RatingInput.displayName = 'CoreRatingInput';
RatingInput.defaultProps = {
  disabled: false,
  required: false
};

var styles$s$1 = {"media-gallery--ec-renewal__slide":"fr-ec-media-gallery--ec-renewal__slide","mediaGalleryEcRenewalSlide":"fr-ec-media-gallery--ec-renewal__slide","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","media-gallery--ec-renewal":"fr-ec-media-gallery--ec-renewal","mediaGalleryEcRenewal":"fr-ec-media-gallery--ec-renewal","video-inline":"fr-ec-video-inline","videoInline":"fr-ec-video-inline","media-gallery--ec-renewal--normal":"fr-ec-media-gallery--ec-renewal--normal","mediaGalleryEcRenewalNormal":"fr-ec-media-gallery--ec-renewal--normal","swiper-pagination":"fr-ec-swiper-pagination","swiperPagination":"fr-ec-swiper-pagination","carousel-indicator-freeScroll":"fr-ec-carousel-indicator-freeScroll","carouselIndicatorFreeScroll":"fr-ec-carousel-indicator-freeScroll","media-gallery--ec-renewal__silde":"fr-ec-media-gallery--ec-renewal__silde","mediaGalleryEcRenewalSilde":"fr-ec-media-gallery--ec-renewal__silde","media-gallery--ec-renewal__container":"fr-ec-media-gallery--ec-renewal__container","mediaGalleryEcRenewalContainer":"fr-ec-media-gallery--ec-renewal__container","media-gallery--ec-renewal--toggle-icon-container":"fr-ec-media-gallery--ec-renewal--toggle-icon-container","mediaGalleryEcRenewalToggleIconContainer":"fr-ec-media-gallery--ec-renewal--toggle-icon-container","media-gallery--ec-renewal--toggle-icon":"fr-ec-media-gallery--ec-renewal--toggle-icon","mediaGalleryEcRenewalToggleIcon":"fr-ec-media-gallery--ec-renewal--toggle-icon","media-enhancements__content--left":"fr-ec-media-enhancements__content--left","mediaEnhancementsContentLeft":"fr-ec-media-enhancements__content--left","button":"fr-ec-button","media-gallery--ec-renewal__button":"fr-ec-media-gallery--ec-renewal__button","mediaGalleryEcRenewalButton":"fr-ec-media-gallery--ec-renewal__button","media-gallery--ec-renewal__arrow-container":"fr-ec-media-gallery--ec-renewal__arrow-container","mediaGalleryEcRenewalArrowContainer":"fr-ec-media-gallery--ec-renewal__arrow-container","media-gallery--ec-renewal__arrows":"fr-ec-media-gallery--ec-renewal__arrows","mediaGalleryEcRenewalArrows":"fr-ec-media-gallery--ec-renewal__arrows","media-gallery--ec-renewal__navigation-btn":"fr-ec-media-gallery--ec-renewal__navigation-btn","mediaGalleryEcRenewalNavigationBtn":"fr-ec-media-gallery--ec-renewal__navigation-btn","media-gallery--ec-renewal--zoomed-view-wrapper":"fr-ec-media-gallery--ec-renewal--zoomed-view-wrapper","mediaGalleryEcRenewalZoomedViewWrapper":"fr-ec-media-gallery--ec-renewal--zoomed-view-wrapper","media-gallery--ec-renewal__button-prev":"fr-ec-media-gallery--ec-renewal__button-prev","mediaGalleryEcRenewalButtonPrev":"fr-ec-media-gallery--ec-renewal__button-prev","media-gallery--ec-renewal__button-next":"fr-ec-media-gallery--ec-renewal__button-next","mediaGalleryEcRenewalButtonNext":"fr-ec-media-gallery--ec-renewal__button-next","media-gallery--ec-renewal__arrows--prev-arrow":"fr-ec-media-gallery--ec-renewal__arrows--prev-arrow","mediaGalleryEcRenewalArrowsPrevArrow":"fr-ec-media-gallery--ec-renewal__arrows--prev-arrow","media-gallery--ec-renewal__arrows--next-arrow":"fr-ec-media-gallery--ec-renewal__arrows--next-arrow","mediaGalleryEcRenewalArrowsNextArrow":"fr-ec-media-gallery--ec-renewal__arrows--next-arrow","media-gallery--ec-renewal-zoom-modal":"fr-ec-media-gallery--ec-renewal-zoom-modal","mediaGalleryEcRenewalZoomModal":"fr-ec-media-gallery--ec-renewal-zoom-modal","swiper-zoom-container":"fr-ec-swiper-zoom-container","swiperZoomContainer":"fr-ec-swiper-zoom-container","media-gallery--ec-renewal-media-ratio-1x1":"fr-ec-media-gallery--ec-renewal-media-ratio-1x1","mediaGalleryEcRenewalMediaRatio1X1":"fr-ec-media-gallery--ec-renewal-media-ratio-1x1","media-gallery--ec-renewal-media-ratio-3x4":"fr-ec-media-gallery--ec-renewal-media-ratio-3x4","mediaGalleryEcRenewalMediaRatio3X4":"fr-ec-media-gallery--ec-renewal-media-ratio-3x4","media-gallery--ec-renewal--close-button":"fr-ec-media-gallery--ec-renewal--close-button","mediaGalleryEcRenewalCloseButton":"fr-ec-media-gallery--ec-renewal--close-button","media-gallery--ec-renewal-header-overlay--close-button":"fr-ec-media-gallery--ec-renewal-header-overlay--close-button","mediaGalleryEcRenewalHeaderOverlayCloseButton":"fr-ec-media-gallery--ec-renewal-header-overlay--close-button","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","media-gallery--ec-renewal--close-button-container":"fr-ec-media-gallery--ec-renewal--close-button-container","mediaGalleryEcRenewalCloseButtonContainer":"fr-ec-media-gallery--ec-renewal--close-button-container","carousel-pagination-number-count":"fr-ec-carousel-pagination-number-count","carouselPaginationNumberCount":"fr-ec-carousel-pagination-number-count","media-gallery--ec-renewal-product-Id":"fr-ec-media-gallery--ec-renewal-product-Id","mediaGalleryEcRenewalProductId":"fr-ec-media-gallery--ec-renewal-product-Id","media-gallery--ec-renewal--zoomed":"fr-ec-media-gallery--ec-renewal--zoomed","mediaGalleryEcRenewalZoomed":"fr-ec-media-gallery--ec-renewal--zoomed","media-enhancements":"fr-ec-media-enhancements","mediaEnhancements":"fr-ec-media-enhancements","media-gallery--ec-renewal--grid":"fr-ec-media-gallery--ec-renewal--grid","mediaGalleryEcRenewalGrid":"fr-ec-media-gallery--ec-renewal--grid","carousel":"fr-ec-carousel","media-gallery--ec-renewal-full-screen-container":"fr-ec-media-gallery--ec-renewal-full-screen-container","mediaGalleryEcRenewalFullScreenContainer":"fr-ec-media-gallery--ec-renewal-full-screen-container","media-gallery--ec-renewal-no-loop-container":"fr-ec-media-gallery--ec-renewal-no-loop-container","mediaGalleryEcRenewalNoLoopContainer":"fr-ec-media-gallery--ec-renewal-no-loop-container","image":"fr-ec-image","image--ratio-3x4":"fr-ec-image--ratio-3x4","imageRatio3X4":"fr-ec-image--ratio-3x4","video-inline--3x4":"fr-ec-video-inline--3x4","videoInline3X4":"fr-ec-video-inline--3x4","carousel-indicator":"fr-ec-carousel-indicator","carouselIndicator":"fr-ec-carousel-indicator","media-gallery--ec-renewal-nav-header-zoom-in":"fr-ec-media-gallery--ec-renewal-nav-header-zoom-in","mediaGalleryEcRenewalNavHeaderZoomIn":"fr-ec-media-gallery--ec-renewal-nav-header-zoom-in","navHeaderZoomIn":"fr-ec-navHeaderZoomIn","media-gallery--ec-renewal-nav-header-zoom-out":"fr-ec-media-gallery--ec-renewal-nav-header-zoom-out","mediaGalleryEcRenewalNavHeaderZoomOut":"fr-ec-media-gallery--ec-renewal-nav-header-zoom-out","navHeaderZoomOut":"fr-ec-navHeaderZoomOut","media-gallery--ec-renewal-bottom-drawer-zoom-in":"fr-ec-media-gallery--ec-renewal-bottom-drawer-zoom-in","mediaGalleryEcRenewalBottomDrawerZoomIn":"fr-ec-media-gallery--ec-renewal-bottom-drawer-zoom-in","bottomDrawerZoomIn":"fr-ec-bottomDrawerZoomIn","media-gallery--ec-renewal-bottom-drawer-zoom-out":"fr-ec-media-gallery--ec-renewal-bottom-drawer-zoom-out","mediaGalleryEcRenewalBottomDrawerZoomOut":"fr-ec-media-gallery--ec-renewal-bottom-drawer-zoom-out","bottomDrawerZoomOut":"fr-ec-bottomDrawerZoomOut","media-gallery--ec-renewal-animate-zoom-in":"fr-ec-media-gallery--ec-renewal-animate-zoom-in","mediaGalleryEcRenewalAnimateZoomIn":"fr-ec-media-gallery--ec-renewal-animate-zoom-in","modalZoomIn":"fr-ec-modalZoomIn","media-gallery--ec-renewal-animate-zoom-out":"fr-ec-media-gallery--ec-renewal-animate-zoom-out","mediaGalleryEcRenewalAnimateZoomOut":"fr-ec-media-gallery--ec-renewal-animate-zoom-out","modalZoomOut":"fr-ec-modalZoomOut","media-gallery--ec-renewal__arrows--phase-3":"fr-ec-media-gallery--ec-renewal__arrows--phase-3","mediaGalleryEcRenewalArrowsPhase3":"fr-ec-media-gallery--ec-renewal__arrows--phase-3","button-arrow-overlay":"fr-ec-button-arrow-overlay","buttonArrowOverlay":"fr-ec-button-arrow-overlay"};

var styles$t$1 = {"media-gallery":"fr-ec-media-gallery","mediaGallery":"fr-ec-media-gallery","media-gallery__preview":"fr-ec-media-gallery__preview","mediaGalleryPreview":"fr-ec-media-gallery__preview","media-gallery__carousel":"fr-ec-media-gallery__carousel","mediaGalleryCarousel":"fr-ec-media-gallery__carousel","media-gallery__preview-chip-container":"fr-ec-media-gallery__preview-chip-container","mediaGalleryPreviewChipContainer":"fr-ec-media-gallery__preview-chip-container","media-gallery__preview-chip-container-inner":"fr-ec-media-gallery__preview-chip-container-inner","mediaGalleryPreviewChipContainerInner":"fr-ec-media-gallery__preview-chip-container-inner","chip--short":"fr-ec-chip--short","chipShort":"fr-ec-chip--short","chip--default":"fr-ec-chip--default","chipDefault":"fr-ec-chip--default","chip":"fr-ec-chip","chip__label":"fr-ec-chip__label","chipLabel":"fr-ec-chip__label","chip__input":"fr-ec-chip__input","chipInput":"fr-ec-chip__input","chip__input--product-tile":"fr-ec-chip__input--product-tile","chipInputProductTile":"fr-ec-chip__input--product-tile","chip__label--product-tile":"fr-ec-chip__label--product-tile","chipLabelProductTile":"fr-ec-chip__label--product-tile","chip__default-icon-container":"fr-ec-chip__default-icon-container","chipDefaultIconContainer":"fr-ec-chip__default-icon-container","media-gallery__preview-button-area":"fr-ec-media-gallery__preview-button-area","mediaGalleryPreviewButtonArea":"fr-ec-media-gallery__preview-button-area","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","pdp-carousel__frame":"fr-ec-pdp-carousel__frame","pdpCarouselFrame":"fr-ec-pdp-carousel__frame","pdp-carousel__frame--padded":"fr-ec-pdp-carousel__frame--padded","pdpCarouselFramePadded":"fr-ec-pdp-carousel__frame--padded"};

var ECRenewalMediaGallery = /** @class */function (_super) {
  __extends(ECRenewalMediaGallery, _super);
  function ECRenewalMediaGallery(props) {
    var _this = _super.call(this, props) || this;
    _this.activeIndexVerticalScroll = 0;
    _this.currentPosition = 0;
    _this.onWindowSize = debounce(100, function (_) {
      _this.setState({
        breakpoint: getCurrentMediaQueryBreakpoint()
      });
    });
    _this.onWindowClick = function (e) {
      if (e.target.alt) {
        var _a = e.target.alt.split('-'),
          indexValue = _a[1];
        _this.handleMediaItemClick(Number(indexValue), e);
      } else if (e.target.id) {
        var _b = e.target.id.split('-'),
          indexValue = _b[1];
        _this.handleMediaItemClick(Number(indexValue), e);
      }
    };
    _this.componentDidMount = function () {
      if (isInBrowser$1()) {
        window.addEventListener('resize', _this.onWindowSize);
        window.addEventListener('click', _this.handleClickOutSide);
      }
    };
    _this.realIndexChange = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h;
      if (_this.swiperInstance) {
        var realSlide = _this.swiperInstance.realIndex;
        if (_this.props.setIndex) {
          _this.props.setIndex(realSlide);
        }
        if (getCurrentMediaQueryBreakpoint() === 'sm') {
          var activeSlide = _this.swiperInstance.activeIndex;
          var activeSlidePosition = _this.swiperInstance.realIndex;
          if (_this.props.onMediaView && activeSlide) {
            var mediaType = null;
            mediaType = ((_b = (_a = _this.swiperInstance) === null || _a === void 0 ? void 0 : _a.slides[activeSlide]) === null || _b === void 0 ? void 0 : _b.querySelector('source')) ? 'video' : 'image';
            var fileUrl = mediaType === 'image' ? (_e = (_d = (_c = _this.swiperInstance.slides[activeSlide]) === null || _c === void 0 ? void 0 : _c.querySelector('img')) === null || _d === void 0 ? void 0 : _d.dataset.src) !== null && _e !== void 0 ? _e : undefined : (_h = (_g = (_f = _this.swiperInstance.slides[activeSlide]) === null || _f === void 0 ? void 0 : _f.querySelector('video')) === null || _g === void 0 ? void 0 : _g.dataset.src) !== null && _h !== void 0 ? _h : undefined;
            var fileName = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.split('/').pop().split('.')[0];
            if (mediaType && fileName) {
              _this.props.onMediaView(_this.swiperInstance.slides[activeSlide], fileName, mediaType, activeSlidePosition);
            }
          }
        }
      }
    };
    _this.handleClickOutSide = function (e) {
      var _a;
      if (_this.swiperInstance) {
        var currentSlide = _this.swiperInstance.clickedSlide;
        var clickedIndex = currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.getAttribute('data-swiper-slide-index');
        if ((_a = currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.querySelector('.fr-ec-default-controls')) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
          var currentEl_1 = currentSlide === null || currentSlide === void 0 ? void 0 : currentSlide.querySelector('video');
          if (currentEl_1) {
            var videoList = _this.swiperInstance.$wrapperEl.children("[data-swiper-slide-index=\"".concat(clickedIndex, "\"]"));
            if (currentEl_1.classList.contains('fr-ec-pause')) {
              currentEl_1.play();
              currentEl_1.classList.remove('fr-ec-pause');
              currentEl_1.removeAttribute('data-pauseTime');
              videoList.each(function (index, item) {
                var currentvideo = item.querySelector('video');
                if (currentvideo) {
                  currentvideo.play();
                  currentvideo.classList.remove('fr-ec-pause');
                  currentvideo.removeAttribute('data-pauseTime');
                }
              });
            } else {
              currentEl_1.pause();
              currentEl_1.classList.add('fr-ec-pause');
              currentEl_1.setAttribute('data-pauseTime', "".concat(currentEl_1.currentTime));
              videoList.each(function (index, item) {
                var currentvideo = item.querySelector('video');
                if (currentvideo) {
                  currentvideo.pause();
                  currentvideo.classList.add('fr-ec-pause');
                  currentvideo.setAttribute('data-pauseTime', "".concat(currentEl_1.currentTime));
                }
              });
            }
          }
        }
      }
    };
    _this.handleZoomChange = function (scale, imageEl) {
      if (imageEl.alt !== 'poster-image' && getCurrentMediaQueryBreakpoint() !== 'lg') {
        if (scale > 1) {
          _this.setState({
            isSlideZoomed: true
          });
        } else {
          _this.setState({
            isSlideZoomed: false
          });
        }
      }
    };
    _this.handleSlideChange = function () {
      var swiperInstance = _this.swiperInstance;
      if (_this.swiperInstance) {
        if (_this.swiperInstance.zoom.scale > 1) {
          _this.swiperInstance.zoom.toggle();
          _this.swiperInstance.update();
          _this.setState({
            isSlideZoomed: false
          });
        }
        var activeIndex = swiperInstance.realIndex;
        _this.setState({
          activeIndex: activeIndex
        });
        var slideWrapper = Array.from(swiperInstance.$wrapperEl)[0];
        var slides = Array.from(slideWrapper.getElementsByClassName('swiper-slide') || []);
        var videos = Array.from(slideWrapper.getElementsByTagName('video') || []);
        setTimeout(function () {
          _this.swiperInstance.loopDestroy();
          _this.swiperInstance.loopCreate();
          setTimeout(function () {
            if (_this.swiperInstance && _this.swiperInstance.slides) {
              var videos_1 = Array.from(_this.swiperInstance.slides, function (el) {
                return el.querySelector('video');
              });
              videos_1 = videos_1.filter(function (el) {
                return el != null;
              });
              if (videos_1) {
                videos_1.map(function (video) {
                  if (video.getAttribute('data-pauseTime')) {
                    var val = video.getAttribute('data-pauseTime');
                    video.pause();
                    video.currentTime = Number(val);
                  }
                });
              }
            }
          }, 50);
        });
      }
    };
    _this.scrollRemoval = function (disable) {
      if (isInBrowser$1()) {
        if (typeof document === 'undefined') {
          return;
        }
        var docElement = document.querySelector('body');
        if (disable) {
          _this.currentPosition = window.pageYOffset;
          docElement.classList.add(interactionsStyles.scrollDisabled);
          docElement.style.top = "".concat(-_this.currentPosition, "px");
        } else {
          docElement.classList.remove(interactionsStyles.scrollDisabled);
          docElement.style.top = '';
          window.scrollTo(0, _this.currentPosition);
        }
      }
    };
    _this.zoomAnimations = function () {
      var navHeaderClass = '.fr-ec-navigation-header';
      var bottomDrawerClass = '.fr-ec-bottom-modal-sheet';
      var zoomedInDiv = '.fr-ec-media-gallery--ec-renewal--zoomed';
      var zoomedOutDiv = '.swiper-slide-active';
      if (isInBrowser$1()) {
        var navHeaderElement = document.querySelector(navHeaderClass);
        var bottomDrawerElement = document.querySelector(bottomDrawerClass);
        var zoomedInDivElement = document.querySelector(zoomedInDiv);
        var zoomedOutDivElement = document.querySelector(zoomedOutDiv);
        if (_this.state.isZoomed) {
          if (navHeaderElement) {
            navHeaderElement.classList.remove(styles$s$1.mediaGalleryEcRenewalNavHeaderZoomOut);
            navHeaderElement.classList.add(styles$s$1.mediaGalleryEcRenewalNavHeaderZoomIn);
          }
          if (bottomDrawerElement) {
            bottomDrawerElement.classList.remove(styles$s$1.mediaGalleryEcRenewalBottomDrawerZoomOut);
            bottomDrawerElement.classList.add(styles$s$1.mediaGalleryEcRenewalBottomDrawerZoomIn);
          }
          if (zoomedInDivElement) {
            zoomedInDivElement.classList.add(styles$s$1.mediaGalleryEcRenewalAnimateZoomIn);
          }
        } else {
          if (navHeaderElement) {
            navHeaderElement.classList.remove(styles$s$1.mediaGalleryEcRenewalNavHeaderZoomIn);
            navHeaderElement.classList.add(styles$s$1.mediaGalleryEcRenewalNavHeaderZoomOut);
          }
          if (bottomDrawerElement) {
            bottomDrawerElement.classList.remove(styles$s$1.mediaGalleryEcRenewalBottomDrawerZoomIn);
            bottomDrawerElement.classList.add(styles$s$1.mediaGalleryEcRenewalBottomDrawerZoomOut);
          }
          if (zoomedOutDivElement) {
            zoomedOutDivElement.classList.add(styles$s$1.mediaGalleryEcRenewalAnimateZoomOut);
          }
        }
      }
    };
    _this.handleMediaItemClick = function (index, e) {
      var _a, _b, _c, _d, _e, _f;
      _this.scrollRemoval(true);
      if (_this.props.fullScreenOnOpen) {
        _this.props.fullScreenOnOpen(e);
      }
      if (_this.props.onClick && getCurrentMediaQueryBreakpoint() !== 'sm') {
        var clickedItem = e.currentTarget;
        var mediaType = null;
        mediaType = (clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.querySelector('source')) ? 'video' : 'image';
        var fileUrl = mediaType === 'image' ? (_b = (_a = clickedItem.querySelector('img')) === null || _a === void 0 ? void 0 : _a.dataset.src) !== null && _b !== void 0 ? _b : undefined : (_d = (_c = clickedItem.querySelector('video')) === null || _c === void 0 ? void 0 : _c.dataset.src) !== null && _d !== void 0 ? _d : undefined;
        var fileName = (_f = (_e = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.split('/')) === null || _e === void 0 ? void 0 : _e.pop()) === null || _f === void 0 ? void 0 : _f.split('.')[0];
        _this.props.onClick(e, fileName, mediaType);
      }
      if (_this.state.breakpoint !== 'sm') {
        _this.setState({
          activeIndex: index,
          isZoomed: true
        });
      } else {
        _this.setState({
          activeIndexSmall: index,
          activeIndex: index,
          isZoomed: true
        }, function () {
          _this.activeIndexVerticalScroll = index;
        });
      }
    };
    _this.handleShowAllClick = function (e) {
      _this.setState({
        enableShowAll: !_this.state.enableShowAll
      });
      if (_this.props.showAllOnClick && _this.state.enableShowAll) {
        _this.props.showAllOnClick(e);
      }
      if (!_this.state.enableShowAll) {
        setTimeout(function () {
          var element = _this.showMoreRef.current;
          if (element) {
            var bottomVal = element.offsetTop - 150;
            window.scrollTo({
              top: bottomVal,
              left: 0,
              behavior: 'smooth'
            });
          }
          if (_this.props.showLessOnClick) {
            _this.props.showLessOnClick(e);
          }
        }, 100);
      }
    };
    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', _this.onWindowSize);
        _this.scrollRemoval(false);
      }
    };
    _this.handleImageErrored = function (event, src) {
      if (isInBrowser$1() && window.onMediaError && typeof window.onMediaError === 'function') {
        window.onMediaError(event, src);
      }
    };
    _this.renderImages = function (mediaCollection, fullScreenItems) {
      var isZoomed = _this.state.isZoomed;
      var getChild = function getChild(slideItem) {
        var childType;
        if (/*#__PURE__*/isValidElement(slideItem)) {
          Children.forEach(slideItem, function (child) {
            var _a, _b, _c, _d;
            if (((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'VideoInline' || ((_b = child.type) === null || _b === void 0 ? void 0 : _b.displayName) === 'CoreVideoInline') {
              childType = 'VideoInline';
            } else if (((_c = child.type) === null || _c === void 0 ? void 0 : _c.displayName) === 'MediaEnhancements' || ((_d = child.type) === null || _d === void 0 ? void 0 : _d.displayName) === 'CoreMediaEnhancements') {
              childType = 'MediaEnhancements';
            } else {
              childType = '';
            }
          });
        }
        return childType;
      };
      var getImages = [];
      var mediaCollectionList = mediaCollection.map(function (item, index) {
        return Children.map(item, function (child) {
          if (getChild(item) === 'MediaEnhancements') {
            getImages.push(index);
          }
          return getChild(item) === 'VideoInline' ? (/*#__PURE__*/createElement("div", {
            key: index,
            className: "swiper-slide"
          }, /*#__PURE__*/cloneElement(child, {
            onClick: function onClick(e) {
              return _this.state.breakpoint !== 'sm' && _this.handleMediaItemClick(index, e);
            }
          }))) : (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(child, {
            onClick: function onClick(e) {
              return _this.state.breakpoint !== 'sm' && _this.handleMediaItemClick(index, e);
            }
          }), _this.props.productId && _this.state.breakpoint === 'sm' && index === getImages[0] && (/*#__PURE__*/createElement(Caption, {
            className: styles$s$1.mediaGalleryEcRenewalProductId,
            variant: "extra-small",
            element: "span",
            color: "secondary",
            style: {
              bottom: _this.props.bottomCaptionMargin || '11vw'
            }
          }, _this.props.productId))));
        });
      });
      if (isZoomed && fullScreenItems) {
        var isLarge_1 = _this.state.breakpoint === 'lg';
        var windowHeight = isInBrowser$1() ? window.innerHeight || document.documentElement.clientHeight : 0;
        var windowWidth = isInBrowser$1() ? window.innerWidth || document.documentElement.clientWidth : 0;
        var slideWidth = _this.props.mediaRatio === '1x1' ? windowHeight * 0.55 : windowHeight * 0.55 * 3 / 4;
        if (slideWidth * fullScreenItems.length < windowWidth && isLarge_1) {
          return fullScreenItems === null || fullScreenItems === void 0 ? void 0 : fullScreenItems.map(function (item, index) {
            return item.isVideo ? (/*#__PURE__*/createElement("div", {
              key: index
            }, /*#__PURE__*/createElement(VideoInline, {
              posterImage: item.posterImage,
              loop: true,
              src: item.src,
              muted: false,
              videoRatio: _this.props.mediaRatio,
              videoType: 'product',
              key: item.key
            }))) : (/*#__PURE__*/createElement("div", {
              key: index
            }, /*#__PURE__*/createElement("div", {
              className: joinClasses('swiper-zoom-container', styles$s$1.mediaGalleryEcRenewalZoomModal)
            }, /*#__PURE__*/createElement(Image, {
              src: item.src,
              alt: item.alt,
              key: item.key,
              loading: "lazy",
              ratio: _this.props.mediaRatio
            }))));
          });
        }
        return fullScreenItems === null || fullScreenItems === void 0 ? void 0 : fullScreenItems.map(function (item, index) {
          return item.isVideo ? (/*#__PURE__*/createElement("div", {
            key: index,
            className: "swiper-slide"
          }, /*#__PURE__*/createElement(VideoInline, {
            posterImage: item.posterImage,
            loop: true,
            src: item.src,
            muted: false,
            videoRatio: _this.props.mediaRatio,
            videoType: 'product',
            key: item.key
          }))) : isLarge_1 ? (/*#__PURE__*/createElement("div", {
            key: index,
            className: "swiper-slide"
          }, /*#__PURE__*/createElement("div", {
            className: joinClasses('swiper-zoom-container', styles$s$1.mediaGalleryEcRenewalZoomModal)
          }, /*#__PURE__*/createElement(Image, {
            src: item.src,
            alt: item.alt,
            key: item.key,
            loading: "lazy",
            ratio: _this.props.mediaRatio
          })))) : (/*#__PURE__*/createElement("div", {
            key: index,
            className: "swiper-slide"
          }, /*#__PURE__*/createElement("div", {
            className: joinClasses('swiper-zoom-container', styles$s$1.mediaGalleryEcRenewalZoomModal)
          }, /*#__PURE__*/createElement("img", {
            src: item.src,
            "data-src": item.src,
            alt: item.alt,
            key: item.key,
            onError: function onError(event) {
              return _this.handleImageErrored(event, item === null || item === void 0 ? void 0 : item.src);
            },
            loading: "lazy",
            className: styles$s$1["media-gallery--ec-renewal-media-ratio-".concat(_this.props.mediaRatio)]
          }))));
        });
      }
      return mediaCollectionList;
    };
    _this.handleCloseDrawer = function (event) {
      _this.setState({
        isZoomed: false
      }, function () {
        _this.scrollRemoval(false);
        _this.zoomAnimations();
      });
      if (_this.props.fullScreenOnClose) {
        _this.props.fullScreenOnClose(event);
      }
      if (_this.state.breakpoint === 'sm') {
        _this.setState({
          activeIndexSmall: _this.activeIndexVerticalScroll
        });
      }
    };
    _this.renderChildContent = function () {
      var _a;
      var enableShowAll = _this.state.enableShowAll;
      var _b = _this.props,
        mediaCollection = _b.mediaCollection,
        fullScreenItems = _b.fullScreenItems,
        showAllLabel = _b.showAllLabel,
        showLessLabel = _b.showLessLabel;
      var mediaArrayValues = enableShowAll ? mediaCollection === null || mediaCollection === void 0 ? void 0 : mediaCollection.slice(0, 8) : mediaCollection;
      var zoomedArrayValues = enableShowAll ? fullScreenItems === null || fullScreenItems === void 0 ? void 0 : fullScreenItems.slice(0, 8) : fullScreenItems;
      var showEnableShowAllButton = _this.props.mediaCollection ? ((_a = _this.props.mediaCollection) === null || _a === void 0 ? void 0 : _a.length) > 8 : false;
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: styles$s$1.mediaGalleryEcRenewalGrid
      }, _this.renderImages(mediaArrayValues, zoomedArrayValues)), showEnableShowAllButton && (/*#__PURE__*/createElement("div", {
        ref: _this.showMoreRef
      }, /*#__PURE__*/createElement(ContentAlignment, {
        justifyContent: "center",
        element: "div",
        direction: "row",
        alignment: "flex-end",
        onClick: _this.handleShowAllClick,
        className: styles$s$1.mediaGalleryEcRenewalCloseButtonContainer
      }, /*#__PURE__*/createElement(Button, {
        className: styles$s$1.mediaGalleryEcRenewalButton,
        width: "fitContent",
        element: 'button',
        variant: "secondary",
        isSmall: false
      }, enableShowAll ? showAllLabel || 'SHOW ALL' : showLessLabel || 'SHOW LESS'), /*#__PURE__*/createElement(Icon, {
        name: enableShowAll ? 'chevron-down' : 'chevron-up'
      })))));
    };
    _this.state = {
      activeIndex: _this.props.index || 0,
      isZoomed: false,
      breakpoint: getCurrentMediaQueryBreakpoint(),
      enableShowAll: true,
      isPlaying: false,
      activeIndexSmall: _this.props.updateIndex,
      isSlideZoomed: false
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.showMoreRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }
  ECRenewalMediaGallery.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;
    var _a;
    if (prevProps.updateIndex !== this.props.updateIndex) {
      this.setState({
        activeIndex: this.props.index,
        activeIndexSmall: this.props.updateIndex
      });
    }
    if (prevState.isZoomed !== this.state.isZoomed) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        autoplay: false,
        freeMode: false,
        direction: 'horizontal',
        keyboard: {
          enabled: true
        },
        mousewheel: {
          forceToAxis: true,
          invert: true
        },
        a11y: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        slidesPerView: getCurrentMediaQueryBreakpoint() !== 'lg' ? '1' : 'auto',
        speed: getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400,
        touchReleaseOnEdges: true,
        loop: true,
        observer: true,
        observeParents: true,
        centeredSlides: true,
        centeredSlidesBounds: true,
        on: {
          slideChange: function slideChange() {
            return _this.handleSlideChange();
          },
          realIndexChange: function realIndexChange() {
            return _this.realIndexChange();
          },
          zoomChange: function zoomChange(scale, imageEl) {
            return _this.handleZoomChange(scale, imageEl);
          },
          slideChangeTransitionStart: function slideChangeTransitionStart(swiper) {
            if (swiper) {
              var $wrapperEl_1 = swiper.$wrapperEl;
              var params_1 = swiper.params;
              $wrapperEl_1.children('.' + params_1.slideClass + '.' + params_1.slideDuplicateClass).each(function (item) {
                var idx = item.getAttribute('data-swiper-slide-index');
                item.innerHTML = $wrapperEl_1.children('.' + params_1.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params_1.slideDuplicateClass + ')').html();
              });
            }
          }
        },
        initialSlide: this.state.activeIndex,
        loopedSlides: (_a = this.props.mediaCollection) === null || _a === void 0 ? void 0 : _a.length,
        zoom: {
          maxRatio: 3,
          minRatio: 1
        }
      });
      if (isInBrowser$1()) {
        var docElement = document.querySelector('body');
        if (getCurrentMediaQueryBreakpoint() === 'lg' && !docElement.classList.contains(interactionsStyles.scrollDisabled)) {
          docElement.classList.add(interactionsStyles.scrollDisabled);
          docElement.style.top = "".concat(-this.currentPosition, "px");
        }
      }
      setTimeout(function () {
        if (_this.swiperInstance && _this.state.isZoomed) {
          _this.swiperInstance.loopDestroy();
          _this.swiperInstance.loopCreate();
        }
      });
    }
  };
  ECRenewalMediaGallery.prototype.render = function () {
    var _this = this;
    var _a = this.state,
      isZoomed = _a.isZoomed;
    var isSmall = this.state.breakpoint === 'sm';
    var isMedium = this.state.breakpoint === 'md';
    var isLarge = this.state.breakpoint === 'lg';
    var _b = this.props,
      mediaCollection = _b.mediaCollection,
      fullScreenItems = _b.fullScreenItems,
      className = _b.className,
      onMediaView = _b.onMediaView,
      onClick = _b.onClick;
    var Element = isZoomed ? 'div' : Fragment;
    var windowHeight = isInBrowser$1() ? window.innerHeight || document.documentElement.clientHeight : 0;
    var windowWidth = isInBrowser$1() ? window.innerWidth || document.documentElement.clientWidth : 0;
    var slideWidth = this.props.mediaRatio === '1x1' ? windowHeight * 0.55 : windowHeight * 0.55 * 3 / 4;
    var noLoopCondition = fullScreenItems ? slideWidth * fullScreenItems.length < windowWidth && isLarge : false;
    var onMediaClick = function onMediaClick(event, id, mediaType, position) {
      if (onClick && id && mediaType) {
        onClick(event, id, mediaType, position);
      }
      if (!isZoomed) {
        _this.onWindowClick(event);
      }
    };
    var swippeableChildrens = /*#__PURE__*/createElement(Fragment, null, !this.state.isSlideZoomed && getCurrentMediaQueryBreakpoint() === 'lg' && (/*#__PURE__*/createElement(ButtonIcon, {
      label: "close",
      hideLabel: true,
      element: "button",
      icon: "close-big",
      onClick: function onClick(event) {
        return _this.handleCloseDrawer(event);
      },
      className: styles$s$1.mediaGalleryEcRenewalHeaderOverlayCloseButton
    })), noLoopCondition ? (/*#__PURE__*/createElement("div", {
      className: styles$s$1.mediaGalleryEcRenewalNoLoopContainer
    }, this.renderImages(this.props.mediaCollection, fullScreenItems))) : (/*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-container', styles$s$1.mediaGalleryEcRenewalFullScreenContainer),
      ref: this.swiperRef
    }, !this.state.isSlideZoomed && getCurrentMediaQueryBreakpoint() !== 'lg' && (/*#__PURE__*/createElement(ButtonIcon, {
      label: "close",
      hideLabel: true,
      element: "button",
      icon: "close-big",
      onClick: function onClick(event) {
        return _this.handleCloseDrawer(event);
      },
      className: styles$s$1.mediaGalleryEcRenewalHeaderOverlayCloseButton
    })), /*#__PURE__*/createElement("div", {
      className: "swiper-wrapper"
    }, this.renderImages(this.props.mediaCollection, fullScreenItems)), getCurrentMediaQueryBreakpoint() === 'lg' && !noLoopCondition ? (/*#__PURE__*/createElement("div", {
      className: styles$s$1.mediaGalleryEcRenewalArrowContainer
    }, /*#__PURE__*/createElement("button", {
      tabIndex: 0,
      "aria-hidden": true,
      className: joinClasses(styles$s$1.mediaGalleryEcRenewalArrows, styles$s$1.mediaGalleryEcRenewalArrowsPrevArrow, 'swiper-button-prev', this.props.mediaRatio === '3x4' && styles$s$1.mediaGalleryEcRenewalArrowsPhase3)
    }), /*#__PURE__*/createElement("div", {
      className: styles$s$1.buttonArrowOverlay
    }), /*#__PURE__*/createElement("button", {
      tabIndex: 0,
      "aria-hidden": true,
      className: joinClasses(styles$s$1.mediaGalleryEcRenewalArrows, styles$s$1.mediaGalleryEcRenewalArrowsNextArrow, 'swiper-button-next', this.props.mediaRatio === '3x4' && styles$s$1.mediaGalleryEcRenewalArrowsPhase3)
    }), /*#__PURE__*/createElement("div", {
      className: styles$s$1.buttonArrowOverlay
    }))) : null)), !this.state.isSlideZoomed && !noLoopCondition && (/*#__PURE__*/createElement(CarouselIndicator, {
      variant: "number",
      spacing: this.state.breakpoint !== 'lg' ? '20' : '8',
      activeIndex: this.state.activeIndex,
      indicatorLength: (mediaCollection === null || mediaCollection === void 0 ? void 0 : mediaCollection.length) || 0
    })));
    var renderChildren = function renderChildren() {
      if (isSmall || isMedium && isZoomed) {
        return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Element, {
          className: isZoomed ? styles$s$1.mediaGalleryEcRenewalZoomed : ''
        }, isSmall && !isZoomed && (/*#__PURE__*/createElement(MediaCarousel, {
          ecRenewal: true,
          activeSlideIndex: _this.state.activeIndex,
          children: _this.renderImages(mediaCollection, fullScreenItems),
          ecRenewalpagination: "number",
          onIndexChange: function onIndexChange(index) {
            _this.props.setIndex(index);
          },
          onMediaView: onMediaView,
          onClick: onMediaClick
        })), isZoomed && swippeableChildrens));
      }
      return /*#__PURE__*/createElement("div", {
        className: isZoomed && fullScreenItems ? styles$s$1.mediaGalleryEcRenewalZoomedViewWrapper : ''
      }, !isZoomed ? _this.renderChildContent() : swippeableChildrens);
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$t$1.mediaGallery, styles$s$1.mediaGalleryEcRenewal, className)
    }, renderChildren());
  };
  return ECRenewalMediaGallery;
}(Component);

var MediaGallery = /** @class */function (_super) {
  __extends(MediaGallery, _super);
  function MediaGallery() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.activeIndex = _this.props.index || 0;
    _this.state = {
      currentButton: 0,
      index: _this.props.index || 0,
      isDesktop: false,
      isTouchDevices: false,
      numberOfScroll: 1,
      scrollValue: 0,
      updateIndex: undefined
    };
    _this.decrementItem = function () {
      if (_this.state.currentButton > 0) {
        _this.setState(function (prevState) {
          return {
            currentButton: prevState.currentButton - 1,
            scrollValue: prevState.scrollValue + 48
          };
        });
      }
    };
    _this.incrementItem = function () {
      var chipsPerPage = 6;
      var totalChips = _this.props.imageCollection ? _this.props.imageCollection.length : 0;
      var numberOfScroll = totalChips - chipsPerPage;
      if (_this.state.currentButton < numberOfScroll) {
        _this.setState(function (prevState) {
          return {
            currentButton: prevState.currentButton + 1,
            numberOfScroll: numberOfScroll,
            scrollValue: prevState.scrollValue - 48
          };
        });
      }
    };
    _this.setIndex = function (index) {
      return function () {
        _this.setState({
          index: index
        });
      };
    };
    _this.onResize = function () {
      if (isInBrowser$1()) {
        var breakpoint = getCurrentMediaQueryBreakpoint();
        var isDesktop = breakpoint === 'lg';
        _this.setState({
          currentButton: isDesktop ? 0 : _this.state.currentButton,
          isDesktop: isDesktop,
          isTouchDevices: isTouchDevice('userAgent'),
          scrollValue: isDesktop ? 0 : _this.state.scrollValue
        });
      }
    };
    _this.indexChange = function (index) {
      _this.setState({
        index: index
      });
      if (_this.props.onIndexChange) {
        _this.props.onIndexChange(index);
      }
    };
    return _this;
  }
  MediaGallery.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.index !== this.props.index) {
      this.setState({
        index: this.props.index || 0,
        updateIndex: this.props.index
      });
    }
  };
  MediaGallery.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      className = _a.className,
      carouselAriaLabel = _a.carouselAriaLabel,
      slidePlaceholder = _a.slidePlaceholder,
      skipToId = _a.skipToId,
      skipLinkText = _a.skipLinkText,
      imageCollection = _a.imageCollection,
      pinchZoomItems = _a.pinchZoomItems,
      children = _a.children,
      _b = _a.pinchZoomCloseLabel,
      pinchZoomCloseLabel = _b === void 0 ? '' : _b,
      _c = _a.enablePinchZoom,
      enablePinchZoom = _c === void 0 ? false : _c,
      iconBrand = _a.iconBrand,
      _d = _a.ecRenewal,
      ecRenewal = _d === void 0 ? false : _d,
      productId = _a.productId,
      _e = _a.mediaRatio,
      mediaRatio = _e === void 0 ? '1x1' : _e,
      other = __rest$1(_a, ["className", "carouselAriaLabel", "slidePlaceholder", "skipToId", "skipLinkText", "imageCollection", "pinchZoomItems", "onIndexChange", "children", "pinchZoomCloseLabel", "enablePinchZoom", "iconBrand", "ecRenewal", "productId", "mediaRatio"]);
    var _f = this.state,
      currentButton = _f.currentButton,
      numberOfScroll = _f.numberOfScroll,
      index = _f.index,
      isTouchDevices = _f.isTouchDevices;
    var chipsPerPage = 6;
    var totalChips = imageCollection ? imageCollection.length : 0;
    var showPreviewButtons = totalChips <= chipsPerPage;
    var disableLeftButton = currentButton <= 0;
    var disableRightButton = currentButton === numberOfScroll;
    var translateStyle = {
      transform: "translateY(".concat(this.state.scrollValue, "px)")
    };
    var getChips = function getChips(chips) {
      return chips.map(function (chip, i) {
        return chip.isVideo ? (/*#__PURE__*/createElement(Chip, {
          key: chip.key,
          label: "Video, ".concat(i + 1, " out of ").concat(totalChips, " media preview in gallery"),
          id: "chip-test".concat(i),
          variant: "short",
          type: 'radio',
          name: "chip-test".concat(i),
          checked: i === index,
          onChange: _this.setIndex(i),
          icon: "play",
          iconBrand: iconBrand
        })) : (/*#__PURE__*/createElement(Chip, {
          key: chip.key,
          label: "Image, ".concat(i + 1, " out of ").concat(totalChips, " media preview in gallery"),
          id: "chip-test".concat(i),
          image: chip.src === '' ? '/invalid-url' : chip.src,
          noImage: chip.noImage,
          variant: "short",
          type: 'radio',
          name: "chip-test".concat(i),
          checked: i === index,
          onChange: _this.setIndex(i),
          iconBrand: iconBrand
        }));
      });
    };
    if (ecRenewal) {
      return /*#__PURE__*/createElement(ECRenewalMediaGallery, __assign$1({}, this.props, {
        setIndex: function setIndex(index) {
          _this.indexChange(index);
        },
        updateIndex: this.state.updateIndex,
        productId: productId,
        mediaRatio: mediaRatio
      }));
    }
    return /*#__PURE__*/createElement(Measure, {
      onResize: debounce(100, this.onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$t$1.mediaGallery, className),
        ref: measureRef
      }, /*#__PURE__*/createElement(ContentAlignment, {
        element: "div",
        justifyContent: "flex-start",
        direction: "row",
        alignment: "flex-start"
      }, /*#__PURE__*/createElement("div", {
        className: styles$t$1.mediaGalleryPreview
      }, /*#__PURE__*/createElement("div", {
        className: styles$t$1.mediaGalleryPreviewChipContainer
      }, imageCollection && (/*#__PURE__*/createElement("div", {
        className: styles$t$1.mediaGalleryPreviewChipContainerInner,
        style: translateStyle
      }, getChips(imageCollection)))), !showPreviewButtons && (/*#__PURE__*/createElement("div", {
        className: styles$t$1.mediaGalleryPreviewButtonArea
      }, /*#__PURE__*/createElement(Keyline, null), /*#__PURE__*/createElement(ContentAlignment, {
        element: "div",
        justifyContent: "center",
        direction: "column",
        alignment: "center"
      }, /*#__PURE__*/createElement(ButtonIcon, {
        "aria-label": "Scroll Up",
        element: "button",
        icon: "chevron-up",
        disabled: disableLeftButton,
        onClick: _this.decrementItem,
        tabIndex: -1,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      }), /*#__PURE__*/createElement(ButtonIcon, {
        "aria-label": "Scroll Down",
        element: "button",
        icon: "chevron-down",
        disabled: disableRightButton,
        onClick: _this.incrementItem,
        tabIndex: -1,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      }))))), /*#__PURE__*/createElement("div", {
        className: styles$t$1.mediaGalleryCarousel
      }, /*#__PURE__*/createElement(Carousel, __assign$1({}, other, {
        index: index,
        indicator: 'number',
        skipLinkText: skipLinkText,
        skipToId: skipToId,
        carouselAriaLabel: carouselAriaLabel,
        arrowPositionSelector: "img",
        slidePlaceholder: slidePlaceholder,
        displayCount: 1,
        onIndexChange: _this.indexChange,
        keyboardNavigation: "arrow",
        variant: "media-gallery",
        pinchZoomItems: pinchZoomItems
      }, isTouchDevices && {
        enablePinchZoom: enablePinchZoom
      }, {
        pinchZoomCloseLabel: pinchZoomCloseLabel,
        iconBrand: iconBrand
      }), children))));
    });
  };
  MediaGallery.displayName = 'CoreMediaGallery';
  return MediaGallery;
}(Component);

var styles$u$1 = {"cms-link-text--align-left":"fr-ec-cms-link-text--align-left","cmsLinkTextAlignLeft":"fr-ec-cms-link-text--align-left","cms-link-text--align-center":"fr-ec-cms-link-text--align-center","cmsLinkTextAlignCenter":"fr-ec-cms-link-text--align-center","cms-link-text--align-right":"fr-ec-cms-link-text--align-right","cmsLinkTextAlignRight":"fr-ec-cms-link-text--align-right","cms-link-text":"fr-ec-cms-link-text","cmsLinkText":"fr-ec-cms-link-text","body":"fr-ec-body"};

var cmsLinkTexttypes = {
  colored: 'standalone-secondary',
  underlined: 'standalone-primary'
};
var CmsLinkText = function CmsLinkText(_a) {
  var url = _a.url,
    label = _a.label,
    iconName = _a.iconName,
    iconPosition = _a.iconPosition,
    type = _a.type,
    _b = _a.gaCategory,
    gaCategory = _b === void 0 ? '' : _b,
    _c = _a.gaLabel,
    gaLabel = _c === void 0 ? '' : _c,
    gaAction = _a.gaAction,
    gaValue = _a.gaValue,
    className = _a.className,
    gaCallback = _a.gaCallback,
    target = _a.target,
    _d = _a.alignment,
    alignment = _d === void 0 ? 'left' : _d,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["url", "label", "iconName", "iconPosition", "type", "gaCategory", "gaLabel", "gaAction", "gaValue", "className", "gaCallback", "target", "alignment", "iconBrand"]);
  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};
  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1;
    // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore
    attributes.to = url;
    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }
  return /*#__PURE__*/createElement(LinkText, __assign$1({
    className: joinClasses(className, styles$u$1.cmsLinkText, styles$u$1["cms-link-text--align-".concat(alignment)]),
    element: rootTag,
    icon: iconName,
    iconPosition: iconPosition,
    variant: cmsLinkTexttypes[type],
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    target: target,
    iconBrand: iconBrand
  }, attributes, props), label);
};
CmsLinkText.displayName = 'CoreCmsLinkText';
CmsLinkText.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  iconName: '',
  iconPosition: 'start',
  type: 'underlined'
};

var styles$v$1 = {"cms-image-plus-text-Wrapper":"fr-ec-cms-image-plus-text-Wrapper","cmsImagePlusTextWrapper":"fr-ec-cms-image-plus-text-Wrapper","cms-image-plus-text":"fr-ec-cms-image-plus-text","cmsImagePlusText":"fr-ec-cms-image-plus-text","cms-image-plus-text__media":"fr-ec-cms-image-plus-text__media","cmsImagePlusTextMedia":"fr-ec-cms-image-plus-text__media","cms-image-plus-text__content":"fr-ec-cms-image-plus-text__content","cmsImagePlusTextContent":"fr-ec-cms-image-plus-text__content","cms-image-plus-text__view-item-button":"fr-ec-cms-image-plus-text__view-item-button","cmsImagePlusTextViewItemButton":"fr-ec-cms-image-plus-text__view-item-button","cms-image-plus-text__text-with-price":"fr-ec-cms-image-plus-text__text-with-price","cmsImagePlusTextTextWithPrice":"fr-ec-cms-image-plus-text__text-with-price","cms-image-plus-text__description":"fr-ec-cms-image-plus-text__description","cmsImagePlusTextDescription":"fr-ec-cms-image-plus-text__description"};

var CmsImagePlusText = function CmsImagePlusText(_a) {
  var children = _a.children,
    head = _a.head,
    title = _a.title,
    description = _a.description,
    flag = _a.flag,
    link = _a.link,
    _b = _a.linkTarget,
    linkTarget = _b === void 0 ? '_self' : _b,
    linkText = _a.linkText,
    _c = _a.headColor,
    headColor = _c === void 0 ? 'normal' : _c,
    _d = _a.flagColor,
    flagColor = _d === void 0 ? 'normal' : _d,
    _e = _a.priceColor,
    priceColor = _e === void 0 ? 'black' : _e,
    productPrice = _a.productPrice,
    gaCategory = _a.gaCategory,
    gaAction = _a.gaAction,
    gaLabel = _a.gaLabel,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    className = _a.className,
    displayViewItemButton = _a.displayViewItemButton,
    viewItemButtonText = _a.viewItemButtonText,
    _f = _a.textTransform,
    textTransform = _f === void 0 ? 'normal' : _f,
    textWithProductPrice = _a.textWithProductPrice,
    textWithProductPriceSecond = _a.textWithProductPriceSecond,
    productPriceSecond = _a.productPriceSecond,
    _g = _a.priceSize,
    priceSize = _g === void 0 ? 'large' : _g,
    props = __rest$1(_a, ["children", "head", "title", "description", "flag", "link", "linkTarget", "linkText", "headColor", "flagColor", "priceColor", "productPrice", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "className", "displayViewItemButton", "viewItemButtonText", "textTransform", "textWithProductPrice", "textWithProductPriceSecond", "productPriceSecond", "priceSize"]);
  var headColorTypes = {
    caution: 'promotional',
    normal: 'primary-dark',
    weak: 'secondary'
  };
  var getText = function getText(text) {
    return text && text.replace(/\\n|\n/g, '\n');
  };
  var width = getViewportWidth();
  var isButtonVisible = width < designTokens_3.mqMediumScreenMinWidthLimit;
  var imagePlusTextChildCompWithButton = /*#__PURE__*/createElement(ImageEnhancements, {
    absolutePositionContent: /*#__PURE__*/createElement("span", {
      className: styles$v$1.cmsImagePlusTextViewItemButton
    }, viewItemButtonText)
  }, children);
  var imagePlusTextTemplate = /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$v$1.cmsImagePlusText)
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$v$1.cmsImagePlusTextMedia, className)
  }, isButtonVisible && displayViewItemButton && viewItemButtonText ? imagePlusTextChildCompWithButton : children), /*#__PURE__*/createElement("div", {
    className: styles$v$1.cmsImagePlusTextContent
  }, head && (/*#__PURE__*/createElement(FlagText, {
    className: spacingStyles.mbSpacing01,
    color: headColorTypes[headColor],
    element: "p",
    variant: "standard"
  }, head)), title && (/*#__PURE__*/createElement(Title, {
    className: spacingStyles.mbSpacing01,
    variant: "large",
    textTransform: textTransform,
    element: "p",
    wordBreak: "break-word"
  }, title)), description && (/*#__PURE__*/createElement(Body, {
    className: styles$v$1.cmsImagePlusTextDescription,
    variant: "small",
    element: "p",
    wordBreak: "break-word"
  }, getText(description))), productPrice && (/*#__PURE__*/createElement(Price, {
    variant: priceColor === 'red' ? 'promotional' : 'standard',
    size: priceSize,
    element: textWithProductPrice ? 'span' : 'p'
  }, textWithProductPrice && (/*#__PURE__*/createElement(Body, {
    className: styles$v$1.cmsImagePlusTextTextWithPrice,
    color: priceColor === 'red' ? 'promotional' : 'primary-dark',
    variant: "standard-emphasized",
    element: "span"
  }, textWithProductPrice)), productPrice)), productPriceSecond && (/*#__PURE__*/createElement(Price, {
    variant: priceColor === 'red' ? 'promotional' : 'standard',
    size: priceSize,
    element: textWithProductPriceSecond ? 'span' : 'p'
  }, textWithProductPriceSecond && (/*#__PURE__*/createElement(Body, {
    className: styles$v$1.cmsImagePlusTextTextWithPrice,
    color: priceColor === 'red' ? 'promotional' : 'primary-dark',
    variant: "standard-emphasized",
    element: "span"
  }, textWithProductPriceSecond)), productPriceSecond)), flag && (/*#__PURE__*/createElement(FlagText, {
    className: spacingStyles.mbSpacing02,
    variant: "large",
    color: flagColor === 'limited' ? 'promotional' : 'secondary',
    element: "p"
  }, flag)), linkText && (/*#__PURE__*/createElement(LinkText, {
    element: "a",
    href: link,
    target: linkTarget
  }, linkText))));
  return link ? (/*#__PURE__*/createElement(CmsLink, __assign$1({}, props, {
    url: link,
    target: linkTarget,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback
  }), imagePlusTextTemplate)) : (/*#__PURE__*/createElement("div", __assign$1({}, props, {
    className: styles$v$1.cmsImagePlusTextWrapper
  }), imagePlusTextTemplate));
};
CmsImagePlusText.displayName = 'CoreCmsImagePlusText';

var CmsImage = function CmsImage(_a) {
  var altText = _a.altText,
    className = _a.className,
    _b = _a.noImageLabel,
    noImageLabel = _b === void 0 ? '' : _b,
    smallMediumImageRatio = _a.smallMediumImageRatio,
    _c = _a.smallMediumImageUrl,
    smallMediumImageUrl = _c === void 0 ? '' : _c,
    largeImageRatio = _a.largeImageRatio,
    _d = _a.largeImageUrl,
    largeImageUrl = _d === void 0 ? '' : _d,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["altText", "className", "noImageLabel", "smallMediumImageRatio", "smallMediumImageUrl", "largeImageRatio", "largeImageUrl", "iconBrand"]);
  var width = getViewportWidth();
  var smallMediumImageRatioValue = smallMediumImageRatio || largeImageRatio || '1x1';
  var largeImageRatioValue = largeImageRatio || smallMediumImageRatio || '2x1';
  var smallMediumImageUrlValue = smallMediumImageUrl || largeImageUrl || '';
  var largeImageUrlValue = largeImageUrl || smallMediumImageUrl || '';
  var renderImage = width > designTokens_3.mqMediumScreenMaxWidthLimit ? (/*#__PURE__*/React__default.createElement(Image, __assign$1({
    src: largeImageUrlValue,
    ratio: largeImageRatioValue,
    alt: altText,
    className: className,
    noImage: {
      imageSize: 'large',
      imageType: 'icon',
      noImageLabel: noImageLabel
    },
    key: 'large-image-key',
    iconBrand: iconBrand
  }, props))) : (/*#__PURE__*/React__default.createElement(Image, {
    src: smallMediumImageUrlValue,
    ratio: smallMediumImageRatioValue,
    alt: altText,
    noImage: {
      imageSize: 'default',
      imageType: 'icon',
      noImageLabel: noImageLabel
    },
    className: className,
    key: 'small-medium-image-key',
    iconBrand: iconBrand
  }));
  return renderImage;
};
CmsImage.displayName = 'CoreCmsImage';
CmsImage.defaultProps = {
  largeImageUrl: '',
  smallMediumImageUrl: ''
};

var styles$x$1 = {"cms-video-inline":"fr-ec-cms-video-inline","cmsVideoInline":"fr-ec-cms-video-inline"};

var CmsVideoInline = function CmsVideoInline(_a) {
  var noImageLabel = _a.noImageLabel,
    smallMediumVideoUrl = _a.smallMediumVideoUrl,
    largeVideoUrl = _a.largeVideoUrl,
    smallMediumPosterImage = _a.smallMediumPosterImage,
    largePosterImage = _a.largePosterImage,
    smallMediumVideoRatio = _a.smallMediumVideoRatio,
    largeVideoRatio = _a.largeVideoRatio,
    altText = _a.altText,
    loop = _a.loop,
    height = _a.height,
    className = _a.className,
    videoWidth = _a.width,
    progressBar = _a.progressBar,
    iconBrand = _a.iconBrand,
    props = __rest$1(_a, ["noImageLabel", "smallMediumVideoUrl", "largeVideoUrl", "smallMediumPosterImage", "largePosterImage", "smallMediumVideoRatio", "largeVideoRatio", "altText", "loop", "height", "className", "width", "progressBar", "iconBrand"]);
  var width = getViewportWidth();
  var isWidthLessthanLargeDevicewidth = width < designTokens_3.mqMediumScreenMaxWidthLimit;
  var smallMediumVideoUrlValue = smallMediumVideoUrl || largeVideoUrl || '';
  var largeVideoUrlValue = largeVideoUrl || smallMediumVideoUrl || '';
  var smallMediumVideoRatioValue = smallMediumVideoRatio || largeVideoRatio || '1x1';
  var largeVideoValue = largeVideoRatio || smallMediumVideoRatio || '2x1';
  var largePosterImageValue = largePosterImage || smallMediumPosterImage || '';
  var smallMediumPosterImageValue = smallMediumPosterImage || largePosterImage || '';
  if (isWidthLessthanLargeDevicewidth) {
    return /*#__PURE__*/createElement(VideoInline, __assign$1({
      key: 0,
      loop: loop,
      src: smallMediumVideoUrlValue,
      posterImage: smallMediumPosterImageValue,
      autoPlay: true,
      muted: true,
      altText: altText,
      videoRatio: smallMediumVideoRatioValue,
      className: joinClasses(className, styles$x$1.cmsVideoInline),
      noVideoLabel: noImageLabel,
      width: videoWidth,
      height: height,
      progressBar: progressBar,
      iconBrand: iconBrand
    }, props));
  } else {
    return /*#__PURE__*/createElement(VideoInline, __assign$1({
      key: 1,
      loop: loop,
      src: largeVideoUrlValue,
      posterImage: largePosterImageValue,
      autoPlay: true,
      muted: true,
      altText: altText,
      noVideoLabel: noImageLabel,
      width: videoWidth,
      height: height,
      className: joinClasses(className, styles$x$1.cmsVideoInline),
      videoRatio: largeVideoValue,
      progressBar: progressBar,
      iconBrand: iconBrand
    }, props));
  }
};
CmsVideoInline.displayName = 'CoreCmsVideoInline';

var styles$y$1 = {"product-collection":"fr-ec-product-collection","productCollection":"fr-ec-product-collection","product-collection--type-grid":"fr-ec-product-collection--type-grid","productCollectionTypeGrid":"fr-ec-product-collection--type-grid","product-collection--type-ranking":"fr-ec-product-collection--type-ranking","productCollectionTypeRanking":"fr-ec-product-collection--type-ranking","product-collection--ecrenewal-grid":"fr-ec-product-collection--ecrenewal-grid","productCollectionEcrenewalGrid":"fr-ec-product-collection--ecrenewal-grid","product-collection--ecrenewal-ranking":"fr-ec-product-collection--ecrenewal-ranking","productCollectionEcrenewalRanking":"fr-ec-product-collection--ecrenewal-ranking","product-collection--type-three-column":"fr-ec-product-collection--type-three-column","productCollectionTypeThreeColumn":"fr-ec-product-collection--type-three-column","product-tile-ranking-wrapper":"fr-ec-product-tile-ranking-wrapper","productTileRankingWrapper":"fr-ec-product-tile-ranking-wrapper","badge-ranking":"fr-ec-badge-ranking","badgeRanking":"fr-ec-badge-ranking","product-collection--type-grid-medium":"fr-ec-product-collection--type-grid-medium","productCollectionTypeGridMedium":"fr-ec-product-collection--type-grid-medium","product-collection--type-grid-small":"fr-ec-product-collection--type-grid-small","productCollectionTypeGridSmall":"fr-ec-product-collection--type-grid-small","product-tile__end":"fr-ec-product-tile__end","productTileEnd":"fr-ec-product-tile__end","product-tile-resize-wrapper":"fr-ec-product-tile-resize-wrapper","productTileResizeWrapper":"fr-ec-product-tile-resize-wrapper","product-tile__product-info":"fr-ec-product-tile__product-info","productTileProductInfo":"fr-ec-product-tile__product-info","tile":"fr-ec-tile","product-collection--type-ranking-carousel":"fr-ec-product-collection--type-ranking-carousel","productCollectionTypeRankingCarousel":"fr-ec-product-collection--type-ranking-carousel","product-tile":"fr-ec-product-tile","productTile":"fr-ec-product-tile","product-collection--type-setup":"fr-ec-product-collection--type-setup","productCollectionTypeSetup":"fr-ec-product-collection--type-setup","product-tile__horizontal_spacing":"fr-ec-product-tile__horizontal_spacing","productTileHorizontalSpacing":"fr-ec-product-tile__horizontal_spacing","product-collection--type-setup-small":"fr-ec-product-collection--type-setup-small","productCollectionTypeSetupSmall":"fr-ec-product-collection--type-setup-small","product-collection--type-carousel":"fr-ec-product-collection--type-carousel","productCollectionTypeCarousel":"fr-ec-product-collection--type-carousel","carousel-slide--padded":"fr-ec-carousel-slide--padded","carouselSlidePadded":"fr-ec-carousel-slide--padded","carousel__bottom-section":"fr-ec-carousel__bottom-section","carouselBottomSection":"fr-ec-carousel__bottom-section","carousel-slide":"fr-ec-carousel-slide","carouselSlide":"fr-ec-carousel-slide"};

var SMALL = 'SMALL';
var MEDIUM = 'MEDIUM';
var LARGE = 'LARGE';
var ProductCollection = function ProductCollection(_a) {
  var _b;
  var _c = _a.type,
    type = _c === void 0 ? 'grid' : _c,
    products = _a.products,
    iconBrand = _a.iconBrand,
    _d = _a.variant,
    variant = _d === void 0 ? 'useType' : _d,
    _e = _a.ecRenewal,
    ecRenewal = _e === void 0 ? false : _e,
    skipLinkText = _a.skipLinkText,
    props = __rest$1(_a, ["type", "products", "iconBrand", "variant", "ecRenewal", "skipLinkText"]);
  var deviceType = React__default.useContext(DeviceTypeContext);
  var _f = useState(deviceType === DeviceType.Desktop ? LARGE : deviceType === DeviceType.Tablet ? MEDIUM : SMALL),
    gridColumns = _f[0],
    setGridColumns = _f[1];
  var width = getViewportWidth();
  var mainStyles = __assign$1({
    carousel: variant === 'useType' && styles$y$1.productCollectionTypeCarousel,
    grid: styles$y$1.productCollectionTypeGrid,
    ranking: styles$y$1.productCollectionTypeRanking
  }, variant === 'useType' && {
    threeColumn: styles$y$1.productCollectionTypeThreeColumn
  });
  var mainTypes = variant === 'useType' ? type : variant;
  var gridColumnStyle = (_b = {}, _b[MEDIUM] = mainTypes === 'grid' ? styles$y$1.productCollectionTypeGridMedium : styles$y$1.productCollectionTypeSetup, _b[SMALL] = mainTypes === 'grid' ? styles$y$1.productCollectionTypeGridSmall : styles$y$1.productCollectionTypeSetupSmall, _b[LARGE] = mainTypes === 'grid' ? styles$y$1.productCollectionTypeGrid : styles$y$1.productCollectionTypeSetup, _b);
  var childWrapper = function childWrapper(productTileChild, index) {
    var productTile = /*#__PURE__*/React__default.cloneElement(productTileChild, __assign$1(__assign$1({
      iconBrand: iconBrand
    }, props), {
      maxLinesEllipsis: mainTypes === 'grid' ? 0 : 2,
      productCollectionType: mainTypes === 'list' ? 'grid' : mainTypes
    }));
    return (mainTypes === 'ranking' || mainTypes === 'rankingCarousel') && variant === 'useType' ? (/*#__PURE__*/React__default.createElement("div", {
      className: styles$y$1.productTileRankingWrapper
    }, /*#__PURE__*/React__default.createElement(BadgeRanking, {
      ariaLabel: "Rank".concat(index),
      rank: index + 1
    }), productTile)) : productTile;
  };
  var productTiles = React__default.Children.map(products, function (child, index) {
    return /*#__PURE__*/React__default.cloneElement(childWrapper(child, index));
  });
  var onResizeGrid = function onResizeGrid(contentRect) {
    if (contentRect.bounds) {
      var width_1 = contentRect.bounds.width;
      // Check if the container width matches the small breakpoint
      if (width_1 <= 599) {
        setGridColumns(SMALL);
      }
      // Check if the container width matches the medium breakpoint
      else if (width_1 >= 600 && width_1 <= 959) {
        setGridColumns(MEDIUM);
      }
      // Check if the container width matches the large breakpoint
      else {
        setGridColumns(LARGE);
      }
    }
  };
  var productCollectionComp = /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$y$1.productCollection, mainStyles[mainTypes], variant === 'ranking' && styles$y$1.productCollectionEcrenewalRanking)
  }, variant === 'useType' ? productTiles : mainTypes === 'ranking' ? React__default.Children.map(productTiles, function (child, i) {
    return /*#__PURE__*/React__default.cloneElement(child, {
      rank: i + 1
    });
  }) : productTiles);
  if (mainTypes === 'carousel' || mainTypes === 'rankingCarousel') {
    productCollectionComp = /*#__PURE__*/React__default.createElement(Carousel, {
      className: joinClasses(mainStyles[mainTypes]),
      variant: variant !== 'useType' ? 'ecRenewal' : 'default',
      arrowPositionSelector: "img",
      displayCount: {
        lg: 4,
        md: variant !== 'useType' ? ecRenewal ? 3.1 : 2.5 : 4,
        sm: variant !== 'useType' ? 2.3 : 2.4
      },
      indicator: {
        lg: variant !== 'useType' ? INDICATOR_NONE : INDICATOR_PAGES,
        md: variant !== 'useType' ? INDICATOR_NONE : INDICATOR_PAGES,
        sm: INDICATOR_NONE
      },
      iconBrand: iconBrand,
      noPadding: variant !== 'useType',
      arrowsIncrement: variant !== 'useType' ? {
        lg: 'page',
        md: 'none',
        sm: 'none'
      } : undefined,
      skipLinkText: skipLinkText
    }, variant === 'useType' ? productTiles : mainTypes === 'rankingCarousel' ? React__default.Children.map(productTiles, function (child, i) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        rank: i + 1
      });
    }) : productTiles);
  } else if (variant === 'useType' && mainTypes === 'setup' && products.length >= 4) {
    productCollectionComp = /*#__PURE__*/React__default.createElement(Measure, {
      bounds: true,
      onResize: onResizeGrid
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/React__default.createElement("div", {
        ref: measureRef
      }, /*#__PURE__*/React__default.createElement(Carousel, {
        className: joinClasses(mainStyles[mainTypes]),
        variant: "default",
        arrowPositionSelector: "img",
        displayCount: variant === 'useType' ? {
          lg: gridColumns === 'SMALL' ? 2.4 : 4,
          md: gridColumns === 'SMALL' ? 2.4 : 4,
          sm: gridColumns === 'SMALL' ? 2.4 : 4
        } : {
          lg: gridColumns !== 'LARGE' ? 2.4 : 4,
          md: gridColumns !== 'LARGE' ? 2.4 : 4,
          sm: gridColumns !== 'LARGE' ? 2.4 : 4
        },
        indicator: {
          lg: variant !== 'useType' ? INDICATOR_NONE : INDICATOR_PAGES,
          md: variant !== 'useType' ? INDICATOR_NONE : INDICATOR_PAGES,
          sm: INDICATOR_NONE
        },
        iconBrand: iconBrand,
        noPadding: variant !== 'useType',
        arrowsIncrement: variant !== 'useType' ? {
          lg: 'page',
          md: 'none',
          sm: 'none'
        } : undefined
      }, productTiles));
    });
  } else if (mainTypes === 'grid' || variant === 'useType' && mainTypes === 'setup' && products.length <= 3) {
    productCollectionComp = /*#__PURE__*/React__default.createElement(Measure, {
      bounds: true,
      onResize: onResizeGrid
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/React__default.createElement("div", {
        ref: measureRef
      }, /*#__PURE__*/React__default.createElement("div", {
        className: joinClasses(styles$y$1.productCollection, gridColumnStyle[gridColumns], variant !== 'useType' && styles$y$1.productCollectionEcrenewalGrid)
      }, mainTypes === 'grid' ? productTiles : React__default.Children.map(productTiles, function (child) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          variant: 'horizontal'
        });
      })));
    });
  } else if (mainTypes === 'setup' && variant !== 'useType' && products.length > 1) {
    productCollectionComp = /*#__PURE__*/React__default.createElement(Carousel, {
      variant: "ecRenewal",
      arrowPositionSelector: "img",
      displayCount: {
        lg: 4,
        md: ecRenewal ? 3.1 : 2.5,
        sm: 2.4
      },
      indicator: 'none',
      iconBrand: iconBrand,
      noPadding: true,
      arrowsIncrement: {
        lg: 'page',
        md: 'none',
        sm: 'none'
      }
    }, React__default.Children.map(productTiles, function (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        variant: 'vertical-small'
      });
    }));
  } else if (mainTypes === 'setup' && variant !== 'useType' && products.length === 1) {
    if (width > designTokens_3.mqMediumScreenMaxWidthLimit || width < designTokens_3.mqSmallScreenMaxWidthLimit) {
      productCollectionComp = /*#__PURE__*/React__default.createElement(Layout, {
        element: "div",
        gutter: {
          lg: false,
          md: false,
          sm: true
        },
        colSpan: {
          lg: 8,
          sm: 4,
          md: 12
        }
      }, React__default.Children.map(productTiles, function (child) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          variant: 'horizontal'
        });
      }));
    } else {
      productCollectionComp = /*#__PURE__*/React__default.createElement(GutterContainer, {
        padding: {
          lg: false,
          md: true,
          sm: false
        }
      }, React__default.Children.map(productTiles, function (child) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          variant: 'horizontal'
        });
      }));
    }
  } else if (mainTypes === 'list') {
    productCollectionComp = /*#__PURE__*/React__default.createElement(CollectionList, {
      spacing: "24"
    }, React__default.Children.map(productTiles, function (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        variant: 'horizontal-small'
      });
    }));
  }
  return productCollectionComp;
};
ProductCollection.displayName = 'CoreProductCollection';

var styles$A$1 = {"cms-tab-group":"fr-ec-cms-tab-group","cmsTabGroup":"fr-ec-cms-tab-group","cms-tab-group__content":"fr-ec-cms-tab-group__content","cmsTabGroupContent":"fr-ec-cms-tab-group__content","cms-tabs__container":"fr-ec-cms-tabs__container","cmsTabsContainer":"fr-ec-cms-tabs__container","tab--standard-boxed":"fr-ec-tab--standard-boxed","tabStandardBoxed":"fr-ec-tab--standard-boxed","swipeable":"fr-ec-swipeable","cms-tabs-wrapper-class":"fr-ec-cms-tabs-wrapper-class","cmsTabsWrapperClass":"fr-ec-cms-tabs-wrapper-class","swipeable__navigation-btn":"fr-ec-swipeable__navigation-btn","swipeableNavigationBtn":"fr-ec-swipeable__navigation-btn","swipeable__navigation-btn-right":"fr-ec-swipeable__navigation-btn-right","swipeableNavigationBtnRight":"fr-ec-swipeable__navigation-btn-right","swipeable__overlay-right":"fr-ec-swipeable__overlay-right","swipeableOverlayRight":"fr-ec-swipeable__overlay-right","swipeable__overlay-left":"fr-ec-swipeable__overlay-left","swipeableOverlayLeft":"fr-ec-swipeable__overlay-left","swipeable__navigation-btn-left":"fr-ec-swipeable__navigation-btn-left","swipeableNavigationBtnLeft":"fr-ec-swipeable__navigation-btn-left","swiper-button-disabled":"fr-ec-swiper-button-disabled","swiperButtonDisabled":"fr-ec-swiper-button-disabled","cms-tab-group--vertical-scroll-gender":"fr-ec-cms-tab-group--vertical-scroll-gender","cmsTabGroupVerticalScrollGender":"fr-ec-cms-tab-group--vertical-scroll-gender","tab":"fr-ec-tab","cms-tab":"fr-ec-cms-tab","cmsTab":"fr-ec-cms-tab","cms-tabs":"fr-ec-cms-tabs","cmsTabs":"fr-ec-cms-tabs"};

var CmsTabGroup = /** @class */function (_super) {
  __extends(CmsTabGroup, _super);
  function CmsTabGroup(props) {
    var _this = _super.call(this, props) || this;
    _this.onTouchMove = function () {
      if (_this.swiperInstance) {
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    _this.onClick = function (label, index, child, tabOnclick) {
      return function (event, activeTabLabel) {
        var ActiveTabIndex = event.currentTarget.getAttribute('index');
        _this.setState({
          activeTabId: index,
          activeTabLabel: activeTabLabel
        }, function () {
          if (_this.props.swipeable) {
            _this.swiperInstance.slideTo(Number(ActiveTabIndex));
            _this.swiperInstance.update();
          }
          if (_this.swiperInstance) {
            _this.setState({
              isBeginning: _this.swiperInstance.isBeginning,
              isEnd: _this.swiperInstance.isEnd
            });
          }
        });
        if (tabOnclick) {
          tabOnclick(event, label, index, child);
        }
      };
    };
    _this.onResize = function () {
      var breakpoint = getCurrentMediaQueryBreakpoint();
      var isDesktop = breakpoint === 'lg';
      _this.setState({
        isLargeScreenDevice: isDesktop
      });
      if (_this.swiperInstance) {
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    _this.controlNavigation = function (direction) {
      if (_this.swiperInstance) {
        var slides = _this.swiperInstance.slides || 0;
        var _a = _this.swiperInstance,
          activeIndex = _a.activeIndex,
          isBeginning = _a.isBeginning,
          isEnd = _a.isEnd;
        var nextSlide = direction === 'NEXT' ? isEnd ? slides.length : activeIndex + 1 : isBeginning ? 0 : activeIndex - 1;
        if (direction === 'NEXT') {
          _this.swiperInstance.slideTo(nextSlide);
        } else {
          _this.swiperInstance.slideTo(nextSlide);
        }
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    var activeChild = tabChilds.find(function (tabItem, index) {
      return Boolean(tabItem.props && index === _this.props.defaultIndex);
    }) || tabChilds[0];
    var activeChildProps = activeChild ? activeChild.props : {};
    var activeChildWithLabel = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildWithLabelProps = activeChildWithLabel ? activeChildWithLabel.props : {};
    _this.state = {
      activeTabId: activeChildProps.index ? activeChildProps.index : 0,
      activeTabLabel: activeChildWithLabelProps.label,
      isBeginning: false,
      isEnd: false,
      isLargeScreenDevice: false
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }
  CmsTabGroup.prototype.componentDidMount = function () {
    var _this = this;
    if (this.props.swipeable) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observeParents: true,
        observer: true,
        on: {
          sliderMove: function sliderMove() {
            return _this.onTouchMove();
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 0
      });
    }
    if (this.swiperInstance) {
      var activeTabElement = Children.toArray(this.props.children).findIndex(function (child, index) {
        return child.props.isActive !== undefined ? child.props.label === _this.state.activeTabLabel : index === _this.state.activeTabId;
      });
      if (this.props.swipeable) {
        this.swiperInstance.slideTo(Number(activeTabElement));
        this.swiperInstance.update();
      }
      this.setState({
        isBeginning: this.swiperInstance.isBeginning,
        isEnd: this.swiperInstance.isEnd
      });
    }
  };
  CmsTabGroup.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.defaultIndex !== this.props.defaultIndex) {
      this.setState({
        activeTabId: Number(this.props.defaultIndex)
      });
    }
  };
  CmsTabGroup.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      className = _a.className,
      sticky = _a.sticky,
      id = _a.id,
      _b = _a.tabsType,
      tabsType = _b === void 0 ? 'normal' : _b,
      isNavHeader = _a.isNavHeader,
      iconBrand = _a.iconBrand,
      wording = _a.wording;
    var swipeable = this.props.swipeable;
    var _c = this.state,
      activeTabId = _c.activeTabId,
      activeTabLabel = _c.activeTabLabel;
    var activeContent = null;
    var typeMap = {
      'boxed-gender': 'standard-boxed',
      'boxed-normal': 'standard-boxed',
      gender: 'standard',
      normal: 'small',
      'normal-swipeable': 'small-swipeable',
      'verticalscroll-gender': 'small'
    };
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
      var tabLabel = wording && child.props.type !== 'normal' ? wording["text_".concat(child.props.type)] : child.props.label ? child.props.label : '';
      if (child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId) {
        activeContent = child.props.content;
      }
      if (swipeable) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: "swiper-slide"
        }, /*#__PURE__*/cloneElement(child, {
          genderTypography: tabsType === 'normal' ? false : tabsType === 'boxed-normal' ? false : tabsType === 'normal-swipeable' ? false : true,
          isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
          key: tabLabel.toUpperCase(),
          label: tabLabel,
          onClick: _this.onClick(tabLabel, child.props.index, child, child.props.onClick),
          variant: typeMap[tabsType],
          wording: wording
        }));
      }
      return /*#__PURE__*/cloneElement(child, {
        genderTypography: tabsType === 'normal' ? false : tabsType === 'boxed-normal' ? false : tabsType === 'normal-swipeable' ? false : true,
        isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
        key: tabLabel.toUpperCase(),
        label: tabLabel,
        onClick: _this.onClick(tabLabel, child.props.index, child, child.props.onClick),
        variant: typeMap[tabsType],
        wording: wording
      });
    });
    var childrenWithPropsWrapper = /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$A$1.cmsTabGroup, tabsType === 'verticalscroll-gender' && styles$A$1.cmsTabGroupVerticalScrollGender, className),
      role: "tablist"
    }, childrenWithProps);
    var withSticky = sticky ? (/*#__PURE__*/createElement(StickyContainer, {
      stickySection: 'utilityBar',
      isNavHeader: isNavHeader
    }, childrenWithPropsWrapper)) : childrenWithPropsWrapper;
    return /*#__PURE__*/createElement(Fragment, null, swipeable ? (/*#__PURE__*/createElement(Measure, {
      onResize: this.onResize
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef,
        key: id
      }, /*#__PURE__*/createElement("div", {
        className: styles$A$1.cmsTabsContainer
      }, /*#__PURE__*/createElement("div", {
        className: joinClasses('swiper-container', styles$A$1.swipeable, tabsType === 'verticalscroll-gender' && styles$A$1.cmsTabGroupVerticalScrollGender, className),
        ref: _this.swiperRef
      }, /*#__PURE__*/createElement("div", {
        role: "tablist",
        className: joinClasses('swiper-wrapper', styles$A$1.cmsTabsWrapperClass)
      }, childrenWithProps)), !_this.state.isBeginning && /*#__PURE__*/createElement("div", {
        className: styles$A$1.swipeableOverlayLeft
      }), !_this.state.isEnd && /*#__PURE__*/createElement("div", {
        className: styles$A$1.swipeableOverlayRight
      }), _this.state.isLargeScreenDevice && (/*#__PURE__*/createElement(Fragment, null, !_this.state.isBeginning && (/*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-left",
        label: "arrow left",
        hideLabel: true,
        className: joinClasses('swiper-button-prev', styles$A$1.swipeableNavigationBtn, styles$A$1.swipeableNavigationBtnLeft),
        iconBrand: iconBrand,
        onClick: function onClick() {
          return _this.controlNavigation('PREV');
        }
      })), !_this.state.isEnd && (/*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-right",
        label: "arrow right",
        hideLabel: true,
        iconBrand: iconBrand,
        className: joinClasses('swiper-button-next', styles$A$1.swipeableNavigationBtn, styles$A$1.swipeableNavigationBtnRight),
        onClick: function onClick() {
          return _this.controlNavigation('NEXT');
        }
      }))))), /*#__PURE__*/createElement("div", {
        role: "tabpanel",
        className: styles$A$1.cmsTabGroupContent
      }, activeContent));
    })) : (/*#__PURE__*/createElement(Fragment, {
      key: id
    }, withSticky, /*#__PURE__*/createElement("div", {
      role: "tabpanel",
      className: styles$A$1.cmsTabGroupContent
    }, activeContent))));
  };
  CmsTabGroup.displayName = 'CoreCmsTabGroup';
  CmsTabGroup.defaultProps = {
    defaultIndex: 0,
    isNavHeader: true,
    sticky: false,
    swipeable: false,
    tabsType: 'normal',
    wording: {
      text_baby: 'baby',
      text_boys: 'boys',
      text_carry_kids_baby: 'kids ･ baby',
      text_girls: 'girls',
      text_kids: 'kids',
      text_men: 'men',
      text_women: 'women'
    }
  };
  return CmsTabGroup;
}(Component);

var CmsBreadcrumb = function CmsBreadcrumb(_a) {
  var label = _a.label,
    url = _a.url,
    _b = _a.gaCategory,
    gaCategory = _b === void 0 ? '' : _b,
    _c = _a.gaLabel,
    gaLabel = _c === void 0 ? '' : _c,
    gaAction = _a.gaAction,
    gaValue = _a.gaValue,
    gaCallback = _a.gaCallback,
    target = _a.target,
    className = _a.className,
    props = __rest$1(_a, ["label", "url", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "target", "className"]);
  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url || '');
  var attributes = {};
  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1;
    // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore
    attributes.to = url;
    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }
  return /*#__PURE__*/createElement(Breadcrumb, __assign$1({
    element: rootTag,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, attributes, {
    className: className
  }, props), label);
};
CmsBreadcrumb.displayName = 'CoreCmsBreadcrumb';
CmsBreadcrumb.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var CmsAnnotation = function CmsAnnotation(_a) {
  var content = _a.content,
    _b = _a.type,
    type = _b === void 0 ? 'normal' : _b,
    _c = _a.centered,
    centered = _c === void 0 ? false : _c,
    className = _a.className,
    id = _a.id;
  var color = {
    normal: 'primary-dark',
    weak: 'secondary',
    caution: 'error'
  };
  return /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "standard",
    textAlign: centered ? 'center' : 'left',
    color: color[type],
    className: className,
    id: id
  }, content);
};
CmsAnnotation.displayName = 'CoreCmsAnnotation';

var DataTableBody = function DataTableBody(_a) {
  var rows = _a.rows,
    columnStyles = _a.columnStyles,
    rest = __rest$1(_a, ["rows", "columnStyles", "iconBrand"]);
  var _b = useState([]),
    oddRows = _b[0],
    setOddRows = _b[1];
  useEffect(function () {
    setOddRows(getOddRows());
  }, [rows]);
  var getOddRows = function getOddRows() {
    var headerRows = function headerRows() {
      var rowItem = [];
      rows.forEach(function (item, key) {
        return item.heading && rowItem.push(key);
      });
      return rowItem;
    };
    var rowIndexs = Array(rows.length).fill(null).map(function (_, i) {
      return i;
    });
    var subArrays = [];
    headerRows().forEach(function (item1, index) {
      var lastIndex = index === headerRows().length - 1 ? rows.length - 1 : headerRows()[item1 + 1];
      subArrays.push(rowIndexs.slice(item1, lastIndex));
    });
    var oddItems = subArrays.map(function (subs) {
      return subs.filter(function (_, index) {
        return index !== 0 && index % 2 === 0;
      });
    });
    return oddItems.reduce(function (acc, val) {
      return acc.concat(val);
    }, []);
  };
  var getChild = function getChild(dtCell) {
    var childType;
    if (/*#__PURE__*/isValidElement(dtCell)) {
      Children.forEach(dtCell, function (child) {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'ButtonIcon' || ((_b = child.type) === null || _b === void 0 ? void 0 : _b.displayName) === 'CoreButtonIcon') {
          childType = 'ButtonIcon';
        } else if (((_c = child.type) === null || _c === void 0 ? void 0 : _c.displayName) === 'ImageOverlay' || ((_d = child.type) === null || _d === void 0 ? void 0 : _d.displayName) === 'CoreImageOverlay') {
          childType = 'ImageOverlay';
        } else if (((_e = child.type) === null || _e === void 0 ? void 0 : _e.displayName) === 'ContentAlignment' || ((_f = child.type) === null || _f === void 0 ? void 0 : _f.displayName) === 'CoreContentAlignment') {
          childType = 'ContentAlignment';
        } else {
          childType = '';
        }
      });
    }
    return childType;
  };
  var addChildClass = function addChildClass(dtCell) {
    var childClass;
    if (getChild(dtCell) === 'ButtonIcon') {
      childClass = DataTableCellStyles.dataTableCellButton;
    } else if (getChild(dtCell) === 'ImageOverlay') {
      childClass = DataTableCellStyles.dataTableCellImage;
    } else if (getChild(dtCell) === 'ContentAlignment') {
      childClass = DataTableCellStyles.dataTableCellToolTip;
    } else {
      childClass = '';
    }
    return childClass;
  };
  var getToolTipIndex = function getToolTipIndex() {
    var toolTipIndex = [];
    rows.forEach(function (_a, i) {
      var content = _a.content;
      content.forEach(function (cell, j) {
        if (getChild(cell) === 'ContentAlignment') {
          toolTipIndex.push(j);
        }
      });
    });
    var uniqIndex = toolTipIndex.reduce(function (acc, item) {
      if (acc.indexOf(item) < 0) {
        acc.push(item);
      }
      return acc;
    }, []);
    return uniqIndex;
  };
  return /*#__PURE__*/createElement("tbody", __assign$1({}, rest), rows.map(function (_a, i) {
    var content = _a.content,
      actions = _a.actions,
      _b = _a.typography,
      typography = _b === void 0 ? 'body' : _b,
      emphasized = _a.emphasized,
      contentClassName = _a.contentClassName,
      _c = _a.heading,
      heading = _c === void 0 ? false : _c,
      props = __rest$1(_a, ["content", "actions", "typography", "emphasized", "contentClassName", "heading"]);
    return /*#__PURE__*/createElement(DataTableRow, {
      key: i,
      className: joinClasses(oddRows.length > 0 && oddRows.includes(i) && DataTableRowStyles.dataTableRowHighlighted, heading && DataTableRowStyles.dataTableRowHeading)
    }, content.map(function (cell, j) {
      return /*#__PURE__*/createElement(DataTableCell, __assign$1({
        key: j,
        element: j === 0 ? 'th' : 'td',
        className: joinClasses(contentClassName && contentClassName[j], addChildClass(cell), cell.noWrap && DataTableCellStyles.dataTableCellNoWrap, (typeof cell === 'string' || cell.label) && (cell.label || cell).includes('<br>') && DataTableCellStyles.dataTableCellMultiLines)
      }, getToolTipIndex().includes(j) ? {
        alignment: 'start'
      } : (columnStyles === null || columnStyles === void 0 ? void 0 : columnStyles[j]) || {
        alignment: 'start'
      }, props), cell && (typeof cell === 'string' || cell.label ? ((cell === null || cell === void 0 ? void 0 : cell.typography) || typography) === 'body' ? (/*#__PURE__*/createElement(Body, {
        element: "span",
        variant: (cell === null || cell === void 0 ? void 0 : cell.emphasized) || emphasized ? 'small-emphasized' : 'small'
      }, Parser(cell.label || cell))) : (/*#__PURE__*/createElement(Title, {
        element: "span",
        variant: (cell === null || cell === void 0 ? void 0 : cell.emphasized) || emphasized ? 'small-emphasized' : 'small'
      }, Parser(cell.label || cell))) : Children.map(cell, function (child) {
        return getChild(cell) === 'ButtonIcon' ? /*#__PURE__*/cloneElement(child, {
          onClick: function onClick() {
            return (actions === null || actions === void 0 ? void 0 : actions.onClick) && (actions === null || actions === void 0 ? void 0 : actions.onClick(i, j));
          }
        }) : child;
      })));
    }));
  }));
};
DataTableBody.displayName = 'CoreDataTableBody';

var dataStyles = {"data-table":"fr-ec-data-table","dataTable":"fr-ec-data-table","data-table--with-footer":"fr-ec-data-table--with-footer","dataTableWithFooter":"fr-ec-data-table--with-footer","data-table-cell":"fr-ec-data-table-cell","dataTableCell":"fr-ec-data-table-cell"};

var DataTable = function DataTable(_a) {
  var rows = _a.rows,
    columnStyles = _a.columnStyles,
    className = _a.className,
    iconBrand = _a.iconBrand,
    showMore = _a.showMore,
    props = __rest$1(_a, ["rows", "columnStyles", "className", "iconBrand", "showMore"]);
  var _b = useState(rows),
    dtRows = _b[0],
    setRows = _b[1];
  var getModifiedRows = function getModifiedRows() {
    var modifiedRow = [];
    var isActions = dtRows.some(function (item) {
      var _a;
      return (_a = item.actions) === null || _a === void 0 ? void 0 : _a.icon;
    });
    if (isActions) {
      dtRows.forEach(function (item, index) {
        var _a, _b, _c, _d;
        return item.actions && ((_a = item.actions) === null || _a === void 0 ? void 0 : _a.icon) && ((_b = item.actions) === null || _b === void 0 ? void 0 : _b.label) ? modifiedRow.push(__assign$1(__assign$1({}, dtRows[index]), {
          content: dtRows[index].content.concat(/*#__PURE__*/createElement(ButtonIcon, {
            key: index,
            element: "button",
            icon: (_c = item.actions) === null || _c === void 0 ? void 0 : _c.icon,
            iconBrand: iconBrand,
            label: (_d = item.actions) === null || _d === void 0 ? void 0 : _d.label
          }))
        })) : modifiedRow.push(__assign$1(__assign$1({}, dtRows[index]), {
          content: dtRows[index].content.concat(''),
          contentClassName: Array(dtRows[index].content.length).fill('').concat(DataTableCellStyles.dataTableCellEmpty)
        }));
      });
      return modifiedRow;
    }
    return dtRows;
  };
  useEffect(function () {
    setRows(rows);
  }, [rows]);
  return /*#__PURE__*/createElement(DataTableScrollContainer, {
    rows: getModifiedRows(),
    iconBrand: iconBrand,
    showMore: showMore,
    className: className
  }, /*#__PURE__*/createElement("table", __assign$1({
    className: dataStyles.dataTable
  }, props), /*#__PURE__*/createElement(DataTableBody, {
    rows: getModifiedRows(),
    columnStyles: columnStyles,
    iconBrand: iconBrand
  })));
};
DataTable.displayName = 'CoreDataTable';

var styles$I$1 = {"skeleton":"fr-ec-skeleton","skeleton__pulse":"fr-ec-skeleton__pulse","skeletonPulse":"fr-ec-skeleton__pulse","pulse":"fr-ec-pulse","skeleton__breadcrumb":"fr-ec-skeleton__breadcrumb","skeletonBreadcrumb":"fr-ec-skeleton__breadcrumb","skeleton__heading":"fr-ec-skeleton__heading","skeletonHeading":"fr-ec-skeleton__heading","skeleton__banner":"fr-ec-skeleton__banner","skeletonBanner":"fr-ec-skeleton__banner","skeleton__product-collection-wrapper":"fr-ec-skeleton__product-collection-wrapper","skeletonProductCollectionWrapper":"fr-ec-skeleton__product-collection-wrapper","skeleton__product-collection":"fr-ec-skeleton__product-collection","skeletonProductCollection":"fr-ec-skeleton__product-collection","skeleton__product":"fr-ec-skeleton__product","skeletonProduct":"fr-ec-skeleton__product","skeleton__product-item1":"fr-ec-skeleton__product-item1","skeletonProductItem1":"fr-ec-skeleton__product-item1","skeleton__text-wrapper":"fr-ec-skeleton__text-wrapper","skeletonTextWrapper":"fr-ec-skeleton__text-wrapper","skeleton__product-item2":"fr-ec-skeleton__product-item2","skeletonProductItem2":"fr-ec-skeleton__product-item2","skeleton__product-item3":"fr-ec-skeleton__product-item3","skeletonProductItem3":"fr-ec-skeleton__product-item3","skeleton__product-item-mobile-only":"fr-ec-skeleton__product-item-mobile-only","skeletonProductItemMobileOnly":"fr-ec-skeleton__product-item-mobile-only","skeleton__featured-heading":"fr-ec-skeleton__featured-heading","skeletonFeaturedHeading":"fr-ec-skeleton__featured-heading","skeleton__sub-text":"fr-ec-skeleton__sub-text","skeletonSubText":"fr-ec-skeleton__sub-text","skeleton__sub-text1":"fr-ec-skeleton__sub-text1","skeletonSubText1":"fr-ec-skeleton__sub-text1","skeleton__sub-text2":"fr-ec-skeleton__sub-text2","skeletonSubText2":"fr-ec-skeleton__sub-text2","skeleton__tab":"fr-ec-skeleton__tab","skeletonTab":"fr-ec-skeleton__tab","skeleton__tab--margin":"fr-ec-skeleton__tab--margin","skeletonTabMargin":"fr-ec-skeleton__tab--margin","skeleton__product-collection-heading":"fr-ec-skeleton__product-collection-heading","skeletonProductCollectionHeading":"fr-ec-skeleton__product-collection-heading","skeleton__featured-wrapper":"fr-ec-skeleton__featured-wrapper","skeletonFeaturedWrapper":"fr-ec-skeleton__featured-wrapper","skeleton__featured-product-collection":"fr-ec-skeleton__featured-product-collection","skeletonFeaturedProductCollection":"fr-ec-skeleton__featured-product-collection","skeleton__featured-product":"fr-ec-skeleton__featured-product","skeletonFeaturedProduct":"fr-ec-skeleton__featured-product","skeleton__featured-product-item1":"fr-ec-skeleton__featured-product-item1","skeletonFeaturedProductItem1":"fr-ec-skeleton__featured-product-item1","skeleton__featured-text-wrapper":"fr-ec-skeleton__featured-text-wrapper","skeletonFeaturedTextWrapper":"fr-ec-skeleton__featured-text-wrapper","skeleton__featured-product-item2":"fr-ec-skeleton__featured-product-item2","skeletonFeaturedProductItem2":"fr-ec-skeleton__featured-product-item2","skeleton__featured-product-item3":"fr-ec-skeleton__featured-product-item3","skeletonFeaturedProductItem3":"fr-ec-skeleton__featured-product-item3","skeleton__featured-filter-bar-container":"fr-ec-skeleton__featured-filter-bar-container","skeletonFeaturedFilterBarContainer":"fr-ec-skeleton__featured-filter-bar-container","skeleton__featured-filter-bar":"fr-ec-skeleton__featured-filter-bar","skeletonFeaturedFilterBar":"fr-ec-skeleton__featured-filter-bar","skeleton__featured--first-row":"fr-ec-skeleton__featured--first-row","skeletonFeaturedFirstRow":"fr-ec-skeleton__featured--first-row","skeleton__l2-heading":"fr-ec-skeleton__l2-heading","skeletonL2Heading":"fr-ec-skeleton__l2-heading","skeleton__l2-home-slider":"fr-ec-skeleton__l2-home-slider","skeletonL2HomeSlider":"fr-ec-skeleton__l2-home-slider","skeleton__l2-banner":"fr-ec-skeleton__l2-banner","skeletonL2Banner":"fr-ec-skeleton__l2-banner","skeleton__l2-banner--margin":"fr-ec-skeleton__l2-banner--margin","skeletonL2BannerMargin":"fr-ec-skeleton__l2-banner--margin","skeleton__l2-category-heading":"fr-ec-skeleton__l2-category-heading","skeletonL2CategoryHeading":"fr-ec-skeleton__l2-category-heading","skeleton__l2-category-heading--margin":"fr-ec-skeleton__l2-category-heading--margin","skeletonL2CategoryHeadingMargin":"fr-ec-skeleton__l2-category-heading--margin","skeleton__l2-category-wrapper":"fr-ec-skeleton__l2-category-wrapper","skeletonL2CategoryWrapper":"fr-ec-skeleton__l2-category-wrapper","skeleton__l2-category-collection":"fr-ec-skeleton__l2-category-collection","skeletonL2CategoryCollection":"fr-ec-skeleton__l2-category-collection","skeleton__l2-category-collection--margin":"fr-ec-skeleton__l2-category-collection--margin","skeletonL2CategoryCollectionMargin":"fr-ec-skeleton__l2-category-collection--margin","skeleton__l2-category-items":"fr-ec-skeleton__l2-category-items","skeletonL2CategoryItems":"fr-ec-skeleton__l2-category-items","skeleton__l2-category-item1":"fr-ec-skeleton__l2-category-item1","skeletonL2CategoryItem1":"fr-ec-skeleton__l2-category-item1","skeleton__l2-category-item2":"fr-ec-skeleton__l2-category-item2","skeletonL2CategoryItem2":"fr-ec-skeleton__l2-category-item2","skeleton__l2-view-more":"fr-ec-skeleton__l2-view-more","skeletonL2ViewMore":"fr-ec-skeleton__l2-view-more","skeleton__l2-view-more--margin":"fr-ec-skeleton__l2-view-more--margin","skeletonL2ViewMoreMargin":"fr-ec-skeleton__l2-view-more--margin","skeleton__l2-view-more--margin88":"fr-ec-skeleton__l2-view-more--margin88","skeletonL2ViewMoreMargin88":"fr-ec-skeleton__l2-view-more--margin88","skeleton__l2-topics":"fr-ec-skeleton__l2-topics","skeletonL2Topics":"fr-ec-skeleton__l2-topics","skeleton__l2-topics-section-wrapper":"fr-ec-skeleton__l2-topics-section-wrapper","skeletonL2TopicsSectionWrapper":"fr-ec-skeleton__l2-topics-section-wrapper","skeleton__l2-topics-section-wrapper-margin":"fr-ec-skeleton__l2-topics-section-wrapper-margin","skeletonL2TopicsSectionWrapperMargin":"fr-ec-skeleton__l2-topics-section-wrapper-margin","skeleton__l2-topics-collection":"fr-ec-skeleton__l2-topics-collection","skeletonL2TopicsCollection":"fr-ec-skeleton__l2-topics-collection","skeleton__l2-topics-section":"fr-ec-skeleton__l2-topics-section","skeletonL2TopicsSection":"fr-ec-skeleton__l2-topics-section","skeleton__l2-topic1":"fr-ec-skeleton__l2-topic1","skeletonL2Topic1":"fr-ec-skeleton__l2-topic1","skeleton__l2-topics-wrapper":"fr-ec-skeleton__l2-topics-wrapper","skeletonL2TopicsWrapper":"fr-ec-skeleton__l2-topics-wrapper","skeleton__l2-topic2":"fr-ec-skeleton__l2-topic2","skeletonL2Topic2":"fr-ec-skeleton__l2-topic2","skeleton__l2-topic3":"fr-ec-skeleton__l2-topic3","skeletonL2Topic3":"fr-ec-skeleton__l2-topic3","skeleton__l2-topic4":"fr-ec-skeleton__l2-topic4","skeletonL2Topic4":"fr-ec-skeleton__l2-topic4","skeleton__l2-new-arrivals":"fr-ec-skeleton__l2-new-arrivals","skeletonL2NewArrivals":"fr-ec-skeleton__l2-new-arrivals","skeleton__l2-new-arrivals-description":"fr-ec-skeleton__l2-new-arrivals-description","skeletonL2NewArrivalsDescription":"fr-ec-skeleton__l2-new-arrivals-description","skeleton__l2-with-product-collection":"fr-ec-skeleton__l2-with-product-collection","skeletonL2WithProductCollection":"fr-ec-skeleton__l2-with-product-collection","skeleton__l2-with-large-product":"fr-ec-skeleton__l2-with-large-product","skeletonL2WithLargeProduct":"fr-ec-skeleton__l2-with-large-product","skeleton__l2-large-product-item1":"fr-ec-skeleton__l2-large-product-item1","skeletonL2LargeProductItem1":"fr-ec-skeleton__l2-large-product-item1","skeleton__l2-large-product-item2":"fr-ec-skeleton__l2-large-product-item2","skeletonL2LargeProductItem2":"fr-ec-skeleton__l2-large-product-item2","skeleton__l2-large-product-item3":"fr-ec-skeleton__l2-large-product-item3","skeletonL2LargeProductItem3":"fr-ec-skeleton__l2-large-product-item3","skeleton__l2-with-small-product-collection":"fr-ec-skeleton__l2-with-small-product-collection","skeletonL2WithSmallProductCollection":"fr-ec-skeleton__l2-with-small-product-collection","skeleton__l2-small-product1":"fr-ec-skeleton__l2-small-product1","skeletonL2SmallProduct1":"fr-ec-skeleton__l2-small-product1","skeleton__l2-small-product2":"fr-ec-skeleton__l2-small-product2","skeletonL2SmallProduct2":"fr-ec-skeleton__l2-small-product2","skeleton__l2-small-product3":"fr-ec-skeleton__l2-small-product3","skeletonL2SmallProduct3":"fr-ec-skeleton__l2-small-product3","skeleton__l2-new-arrivals-you":"fr-ec-skeleton__l2-new-arrivals-you","skeletonL2NewArrivalsYou":"fr-ec-skeleton__l2-new-arrivals-you","skeleton__l2-new-arrivals-you-wrapper":"fr-ec-skeleton__l2-new-arrivals-you-wrapper","skeletonL2NewArrivalsYouWrapper":"fr-ec-skeleton__l2-new-arrivals-you-wrapper","skeleton__l2-new-arrivals-you-collection":"fr-ec-skeleton__l2-new-arrivals-you-collection","skeletonL2NewArrivalsYouCollection":"fr-ec-skeleton__l2-new-arrivals-you-collection","skeleton__l2-new-arrival-items":"fr-ec-skeleton__l2-new-arrival-items","skeletonL2NewArrivalItems":"fr-ec-skeleton__l2-new-arrival-items","skeleton__l2-new-arrival-item1":"fr-ec-skeleton__l2-new-arrival-item1","skeletonL2NewArrivalItem1":"fr-ec-skeleton__l2-new-arrival-item1","skeleton__l2-new-arrival-item2":"fr-ec-skeleton__l2-new-arrival-item2","skeletonL2NewArrivalItem2":"fr-ec-skeleton__l2-new-arrival-item2","skeleton__l2-new-arrival-item3":"fr-ec-skeleton__l2-new-arrival-item3","skeletonL2NewArrivalItem3":"fr-ec-skeleton__l2-new-arrival-item3","skeleton__l2-styling-wrapper":"fr-ec-skeleton__l2-styling-wrapper","skeletonL2StylingWrapper":"fr-ec-skeleton__l2-styling-wrapper","skeleton__l2-styling-collection":"fr-ec-skeleton__l2-styling-collection","skeletonL2StylingCollection":"fr-ec-skeleton__l2-styling-collection","skeleton__l2-styling-item":"fr-ec-skeleton__l2-styling-item","skeletonL2StylingItem":"fr-ec-skeleton__l2-styling-item","skeleton__l2-life-wear-wrapper":"fr-ec-skeleton__l2-life-wear-wrapper","skeletonL2LifeWearWrapper":"fr-ec-skeleton__l2-life-wear-wrapper","skeleton__l2-life-wear-collection":"fr-ec-skeleton__l2-life-wear-collection","skeletonL2LifeWearCollection":"fr-ec-skeleton__l2-life-wear-collection","skeleton__l2-life-wear-items":"fr-ec-skeleton__l2-life-wear-items","skeletonL2LifeWearItems":"fr-ec-skeleton__l2-life-wear-items","skeleton__l2-life-wear-item1":"fr-ec-skeleton__l2-life-wear-item1","skeletonL2LifeWearItem1":"fr-ec-skeleton__l2-life-wear-item1","skeleton__l2-life-wear-item2":"fr-ec-skeleton__l2-life-wear-item2","skeletonL2LifeWearItem2":"fr-ec-skeleton__l2-life-wear-item2","skeleton__l2-life-wear-item3":"fr-ec-skeleton__l2-life-wear-item3","skeletonL2LifeWearItem3":"fr-ec-skeleton__l2-life-wear-item3","skeleton__l2-search-category1":"fr-ec-skeleton__l2-search-category1","skeletonL2SearchCategory1":"fr-ec-skeleton__l2-search-category1","skeleton__l2-search-category2":"fr-ec-skeleton__l2-search-category2","skeletonL2SearchCategory2":"fr-ec-skeleton__l2-search-category2","skeleton__l2-search-category3":"fr-ec-skeleton__l2-search-category3","skeletonL2SearchCategory3":"fr-ec-skeleton__l2-search-category3","skeleton__l2-home-slider-full-width":"fr-ec-skeleton__l2-home-slider-full-width","skeletonL2HomeSliderFullWidth":"fr-ec-skeleton__l2-home-slider-full-width","skeleton__l2-home-slider-height-112":"fr-ec-skeleton__l2-home-slider-height-112","skeletonL2HomeSliderHeight112":"fr-ec-skeleton__l2-home-slider-height-112","skeleton__l3--full-width":"fr-ec-skeleton__l3--full-width","skeletonL3FullWidth":"fr-ec-skeleton__l3--full-width","skeleton__l4-heading":"fr-ec-skeleton__l4-heading","skeletonL4Heading":"fr-ec-skeleton__l4-heading","skeleton__pdp-container":"fr-ec-skeleton__pdp-container","skeletonPdpContainer":"fr-ec-skeleton__pdp-container","skeleton__pdp-left-container":"fr-ec-skeleton__pdp-left-container","skeletonPdpLeftContainer":"fr-ec-skeleton__pdp-left-container","skeleton__chip-container":"fr-ec-skeleton__chip-container","skeletonChipContainer":"fr-ec-skeleton__chip-container","skeleton__chip":"fr-ec-skeleton__chip","skeletonChip":"fr-ec-skeleton__chip","skeletonCarousel":"fr-ec-skeletonCarousel","skeleton__pdp-right-container":"fr-ec-skeleton__pdp-right-container","skeletonPdpRightContainer":"fr-ec-skeleton__pdp-right-container","skeleton__label-value":"fr-ec-skeleton__label-value","skeletonLabelValue":"fr-ec-skeleton__label-value","skeleton__chip-container--horizontal":"fr-ec-skeleton__chip-container--horizontal","skeletonChipContainerHorizontal":"fr-ec-skeleton__chip-container--horizontal","skeleton__my-size-assist":"fr-ec-skeleton__my-size-assist","skeletonMySizeAssist":"fr-ec-skeleton__my-size-assist","skeleton__label-value--height-32":"fr-ec-skeleton__label-value--height-32","skeletonLabelValueHeight32":"fr-ec-skeleton__label-value--height-32","skeleton__my-size-assist--height-20":"fr-ec-skeleton__my-size-assist--height-20","skeletonMySizeAssistHeight20":"fr-ec-skeleton__my-size-assist--height-20","skeleton__my-size-assist--width-241":"fr-ec-skeleton__my-size-assist--width-241","skeletonMySizeAssistWidth241":"fr-ec-skeleton__my-size-assist--width-241","skeleton__my-size-assist--width-301":"fr-ec-skeleton__my-size-assist--width-301","skeletonMySizeAssistWidth301":"fr-ec-skeleton__my-size-assist--width-301","skeleton__my-size-assist--width-376":"fr-ec-skeleton__my-size-assist--width-376","skeletonMySizeAssistWidth376":"fr-ec-skeleton__my-size-assist--width-376","skeleton__carousel-bottom-content1":"fr-ec-skeleton__carousel-bottom-content1","skeletonCarouselBottomContent1":"fr-ec-skeleton__carousel-bottom-content1","skeleton__carousel-bottom-content2":"fr-ec-skeleton__carousel-bottom-content2","skeletonCarouselBottomContent2":"fr-ec-skeleton__carousel-bottom-content2","skeleton__carousel-bottom-content2--width-496":"fr-ec-skeleton__carousel-bottom-content2--width-496","skeletonCarouselBottomContent2Width496":"fr-ec-skeleton__carousel-bottom-content2--width-496","skeleton__carousel-bottom-content2--width-621":"fr-ec-skeleton__carousel-bottom-content2--width-621","skeletonCarouselBottomContent2Width621":"fr-ec-skeleton__carousel-bottom-content2--width-621","skeleton__styling-container":"fr-ec-skeleton__styling-container","skeletonStylingContainer":"fr-ec-skeleton__styling-container","skeleton__styling-container--margin":"fr-ec-skeleton__styling-container--margin","skeletonStylingContainerMargin":"fr-ec-skeleton__styling-container--margin","skeleton__styling-item":"fr-ec-skeleton__styling-item","skeletonStylingItem":"fr-ec-skeleton__styling-item","skeleton__view-more-styling":"fr-ec-skeleton__view-more-styling","skeletonViewMoreStyling":"fr-ec-skeleton__view-more-styling","skeleton__user-info-wrapper":"fr-ec-skeleton__user-info-wrapper","skeletonUserInfoWrapper":"fr-ec-skeleton__user-info-wrapper","skeleton__user-info-profile":"fr-ec-skeleton__user-info-profile","skeletonUserInfoProfile":"fr-ec-skeleton__user-info-profile","skeleton__user-info-profile-info":"fr-ec-skeleton__user-info-profile-info","skeletonUserInfoProfileInfo":"fr-ec-skeleton__user-info-profile-info","skeleton__l4-banner":"fr-ec-skeleton__l4-banner","skeletonL4Banner":"fr-ec-skeleton__l4-banner","skeleton__container-125":"fr-ec-skeleton__container-125","skeletonContainer125":"fr-ec-skeleton__container-125","skeleton__tab-bottom":"fr-ec-skeleton__tab-bottom","skeletonTabBottom":"fr-ec-skeleton__tab-bottom","skeleton__product-collection-wrapper_fixed_height":"fr-ec-skeleton__product-collection-wrapper_fixed_height","skeletonProductCollectionWrapperFixedHeight":"fr-ec-skeleton__product-collection-wrapper_fixed_height","skeleton__product-collection_fixed_height":"fr-ec-skeleton__product-collection_fixed_height","skeletonProductCollectionFixedHeight":"fr-ec-skeleton__product-collection_fixed_height","skeleton__product_fixed_height":"fr-ec-skeleton__product_fixed_height","skeletonProductFixedHeight":"fr-ec-skeleton__product_fixed_height","skeleton__product_fixed_height-image":"fr-ec-skeleton__product_fixed_height-image","skeletonProductFixedHeightImage":"fr-ec-skeleton__product_fixed_height-image","skeleton__product_fixed_height-text-wrapper":"fr-ec-skeleton__product_fixed_height-text-wrapper","skeletonProductFixedHeightTextWrapper":"fr-ec-skeleton__product_fixed_height-text-wrapper","skeleton__product_fixed_height-chip":"fr-ec-skeleton__product_fixed_height-chip","skeletonProductFixedHeightChip":"fr-ec-skeleton__product_fixed_height-chip","skeleton__product_fixed_height-item1":"fr-ec-skeleton__product_fixed_height-item1","skeletonProductFixedHeightItem1":"fr-ec-skeleton__product_fixed_height-item1","skeleton__product_fixed_height-item2":"fr-ec-skeleton__product_fixed_height-item2","skeletonProductFixedHeightItem2":"fr-ec-skeleton__product_fixed_height-item2","skeleton__product_fixed_height-item3":"fr-ec-skeleton__product_fixed_height-item3","skeletonProductFixedHeightItem3":"fr-ec-skeleton__product_fixed_height-item3","skeleton__product_fixed_height-mobile-only":"fr-ec-skeleton__product_fixed_height-mobile-only","skeletonProductFixedHeightMobileOnly":"fr-ec-skeleton__product_fixed_height-mobile-only","skeleton__fixed-height-cms-styling-item":"fr-ec-skeleton__fixed-height-cms-styling-item","skeletonFixedHeightCmsStylingItem":"fr-ec-skeleton__fixed-height-cms-styling-item","skeleton__fixed-height-cms-styling-indicator":"fr-ec-skeleton__fixed-height-cms-styling-indicator","skeletonFixedHeightCmsStylingIndicator":"fr-ec-skeleton__fixed-height-cms-styling-indicator","skeleton__navigation-wrapper":"fr-ec-skeleton__navigation-wrapper","skeletonNavigationWrapper":"fr-ec-skeleton__navigation-wrapper","skeleton__navigation-class-list":"fr-ec-skeleton__navigation-class-list","skeletonNavigationClassList":"fr-ec-skeleton__navigation-class-list","skeleton__navigation-class-list-item":"fr-ec-skeleton__navigation-class-list-item","skeletonNavigationClassListItem":"fr-ec-skeleton__navigation-class-list-item","skeleton__navigation-class-list-item-media":"fr-ec-skeleton__navigation-class-list-item-media","skeletonNavigationClassListItemMedia":"fr-ec-skeleton__navigation-class-list-item-media","skeleton__navigation-class-list-item-text":"fr-ec-skeleton__navigation-class-list-item-text","skeletonNavigationClassListItemText":"fr-ec-skeleton__navigation-class-list-item-text","skeleton__navigation-products":"fr-ec-skeleton__navigation-products","skeletonNavigationProducts":"fr-ec-skeleton__navigation-products","skeleton__navigation-product-heading":"fr-ec-skeleton__navigation-product-heading","skeletonNavigationProductHeading":"fr-ec-skeleton__navigation-product-heading","skeleton__navigation-product-banner-heading":"fr-ec-skeleton__navigation-product-banner-heading","skeletonNavigationProductBannerHeading":"fr-ec-skeleton__navigation-product-banner-heading","skeleton__navigation-product-banner":"fr-ec-skeleton__navigation-product-banner","skeletonNavigationProductBanner":"fr-ec-skeleton__navigation-product-banner","skeleton__navigation-product":"fr-ec-skeleton__navigation-product","skeletonNavigationProduct":"fr-ec-skeleton__navigation-product","skeleton__navigation-product-media":"fr-ec-skeleton__navigation-product-media","skeletonNavigationProductMedia":"fr-ec-skeleton__navigation-product-media","skeleton__navigation-product-title":"fr-ec-skeleton__navigation-product-title","skeletonNavigationProductTitle":"fr-ec-skeleton__navigation-product-title","skeleton__navigation-product-sub-title":"fr-ec-skeleton__navigation-product-sub-title","skeletonNavigationProductSubTitle":"fr-ec-skeleton__navigation-product-sub-title","skeleton__navigation-product-description":"fr-ec-skeleton__navigation-product-description","skeletonNavigationProductDescription":"fr-ec-skeleton__navigation-product-description","skeleton--navigation":"fr-ec-skeleton--navigation","skeletonNavigation":"fr-ec-skeleton--navigation","skeleton__login-item1":"fr-ec-skeleton__login-item1","skeletonLoginItem1":"fr-ec-skeleton__login-item1","skeleton__login-item2":"fr-ec-skeleton__login-item2","skeletonLoginItem2":"fr-ec-skeleton__login-item2","skeleton__login-item2-sub-item1":"fr-ec-skeleton__login-item2-sub-item1","skeletonLoginItem2SubItem1":"fr-ec-skeleton__login-item2-sub-item1","skeleton__login-item2-sub-item2":"fr-ec-skeleton__login-item2-sub-item2","skeletonLoginItem2SubItem2":"fr-ec-skeleton__login-item2-sub-item2","skeleton__login-item2-sub-item3":"fr-ec-skeleton__login-item2-sub-item3","skeletonLoginItem2SubItem3":"fr-ec-skeleton__login-item2-sub-item3","skeleton__login-item2-sub-item3-last":"fr-ec-skeleton__login-item2-sub-item3-last","skeletonLoginItem2SubItem3Last":"fr-ec-skeleton__login-item2-sub-item3-last","skeleton__login-item2-sub-item4":"fr-ec-skeleton__login-item2-sub-item4","skeletonLoginItem2SubItem4":"fr-ec-skeleton__login-item2-sub-item4","skeleton__login-item2-sub-item4-last":"fr-ec-skeleton__login-item2-sub-item4-last","skeletonLoginItem2SubItem4Last":"fr-ec-skeleton__login-item2-sub-item4-last","skeleton__login-item2-sub-item5":"fr-ec-skeleton__login-item2-sub-item5","skeletonLoginItem2SubItem5":"fr-ec-skeleton__login-item2-sub-item5","skeleton__login-item2-sub-item6":"fr-ec-skeleton__login-item2-sub-item6","skeletonLoginItem2SubItem6":"fr-ec-skeleton__login-item2-sub-item6","skeleton__login-item2-sub-item7":"fr-ec-skeleton__login-item2-sub-item7","skeletonLoginItem2SubItem7":"fr-ec-skeleton__login-item2-sub-item7","skeleton__pdp-wrapper":"fr-ec-skeleton__pdp-wrapper","skeletonPdpWrapper":"fr-ec-skeleton__pdp-wrapper","skeleton__pdp-first-item":"fr-ec-skeleton__pdp-first-item","skeletonPdpFirstItem":"fr-ec-skeleton__pdp-first-item","skeleton__pdp-first-left-group":"fr-ec-skeleton__pdp-first-left-group","skeletonPdpFirstLeftGroup":"fr-ec-skeleton__pdp-first-left-group","skeleton__pdp-first-left-group-item":"fr-ec-skeleton__pdp-first-left-group-item","skeletonPdpFirstLeftGroupItem":"fr-ec-skeleton__pdp-first-left-group-item","skeleton__pdp-first-left-item":"fr-ec-skeleton__pdp-first-left-item","skeletonPdpFirstLeftItem":"fr-ec-skeleton__pdp-first-left-item","skeleton__pdp-first-right-item-textlist-first":"fr-ec-skeleton__pdp-first-right-item-textlist-first","skeletonPdpFirstRightItemTextlistFirst":"fr-ec-skeleton__pdp-first-right-item-textlist-first","skeleton__pdp-first-right-item-textlist-second":"fr-ec-skeleton__pdp-first-right-item-textlist-second","skeletonPdpFirstRightItemTextlistSecond":"fr-ec-skeleton__pdp-first-right-item-textlist-second","skeleton__pdp-first-right-item-textlist-third":"fr-ec-skeleton__pdp-first-right-item-textlist-third","skeletonPdpFirstRightItemTextlistThird":"fr-ec-skeleton__pdp-first-right-item-textlist-third","skeleton__pdp-first-right-item-textlist-fourth":"fr-ec-skeleton__pdp-first-right-item-textlist-fourth","skeletonPdpFirstRightItemTextlistFourth":"fr-ec-skeleton__pdp-first-right-item-textlist-fourth","skeleton__pdp-first-right-item-chip-group":"fr-ec-skeleton__pdp-first-right-item-chip-group","skeletonPdpFirstRightItemChipGroup":"fr-ec-skeleton__pdp-first-right-item-chip-group","skeleton__pdp-first-right-item-chip-item":"fr-ec-skeleton__pdp-first-right-item-chip-item","skeletonPdpFirstRightItemChipItem":"fr-ec-skeleton__pdp-first-right-item-chip-item","skeleton__pdp-first-right-item-chip-item-square":"fr-ec-skeleton__pdp-first-right-item-chip-item-square","skeletonPdpFirstRightItemChipItemSquare":"fr-ec-skeleton__pdp-first-right-item-chip-item-square","skeleton__pdp-first-right-item-pill":"fr-ec-skeleton__pdp-first-right-item-pill","skeletonPdpFirstRightItemPill":"fr-ec-skeleton__pdp-first-right-item-pill","skeleton__pdp-second-item-text-first":"fr-ec-skeleton__pdp-second-item-text-first","skeletonPdpSecondItemTextFirst":"fr-ec-skeleton__pdp-second-item-text-first","skeleton__pdp-second-item-text-second":"fr-ec-skeleton__pdp-second-item-text-second","skeletonPdpSecondItemTextSecond":"fr-ec-skeleton__pdp-second-item-text-second","skeleton__pdp-second-item-text-third":"fr-ec-skeleton__pdp-second-item-text-third","skeletonPdpSecondItemTextThird":"fr-ec-skeleton__pdp-second-item-text-third","skeleton__pdp-second-item-text-fourth":"fr-ec-skeleton__pdp-second-item-text-fourth","skeletonPdpSecondItemTextFourth":"fr-ec-skeleton__pdp-second-item-text-fourth","skeleton__pdp-styling-carousel-text":"fr-ec-skeleton__pdp-styling-carousel-text","skeletonPdpStylingCarouselText":"fr-ec-skeleton__pdp-styling-carousel-text","skeleton__pdp-styling-carousel-group":"fr-ec-skeleton__pdp-styling-carousel-group","skeletonPdpStylingCarouselGroup":"fr-ec-skeleton__pdp-styling-carousel-group","skeleton__pdp-styling-carousel-item":"fr-ec-skeleton__pdp-styling-carousel-item","skeletonPdpStylingCarouselItem":"fr-ec-skeleton__pdp-styling-carousel-item","skeleton__pdp-styling-carousel-third-group":"fr-ec-skeleton__pdp-styling-carousel-third-group","skeletonPdpStylingCarouselThirdGroup":"fr-ec-skeleton__pdp-styling-carousel-third-group","skeleton__pdp-styling-carousel-third-item":"fr-ec-skeleton__pdp-styling-carousel-third-item","skeletonPdpStylingCarouselThirdItem":"fr-ec-skeleton__pdp-styling-carousel-third-item","skeleton__pdp-image-plus-text-heading":"fr-ec-skeleton__pdp-image-plus-text-heading","skeletonPdpImagePlusTextHeading":"fr-ec-skeleton__pdp-image-plus-text-heading","skeleton__pdp-image-plus-text-container":"fr-ec-skeleton__pdp-image-plus-text-container","skeletonPdpImagePlusTextContainer":"fr-ec-skeleton__pdp-image-plus-text-container","skeleton__pdp-image-plus-text-item":"fr-ec-skeleton__pdp-image-plus-text-item","skeletonPdpImagePlusTextItem":"fr-ec-skeleton__pdp-image-plus-text-item","skeleton__pdp-image-plus-text-item-img":"fr-ec-skeleton__pdp-image-plus-text-item-img","skeletonPdpImagePlusTextItemImg":"fr-ec-skeleton__pdp-image-plus-text-item-img","skeleton__pdp-image-plus-text-item-text-first":"fr-ec-skeleton__pdp-image-plus-text-item-text-first","skeletonPdpImagePlusTextItemTextFirst":"fr-ec-skeleton__pdp-image-plus-text-item-text-first","skeleton__pdp-image-plus-text-item-text-second":"fr-ec-skeleton__pdp-image-plus-text-item-text-second","skeletonPdpImagePlusTextItemTextSecond":"fr-ec-skeleton__pdp-image-plus-text-item-text-second","skeleton__pdp-last-item":"fr-ec-skeleton__pdp-last-item","skeletonPdpLastItem":"fr-ec-skeleton__pdp-last-item","skeleton__pdp-image-plus-text-wrapper":"fr-ec-skeleton__pdp-image-plus-text-wrapper","skeletonPdpImagePlusTextWrapper":"fr-ec-skeleton__pdp-image-plus-text-wrapper","skeleton__pdp-first-left-item-grab-bar":"fr-ec-skeleton__pdp-first-left-item-grab-bar","skeletonPdpFirstLeftItemGrabBar":"fr-ec-skeleton__pdp-first-left-item-grab-bar","skeleton__pdp-carousel-wrapper":"fr-ec-skeleton__pdp-carousel-wrapper","skeletonPdpCarouselWrapper":"fr-ec-skeleton__pdp-carousel-wrapper","skeleton__plp-full-width-bar":"fr-ec-skeleton__plp-full-width-bar","skeletonPlpFullWidthBar":"fr-ec-skeleton__plp-full-width-bar","skeleton__plp-media-banner":"fr-ec-skeleton__plp-media-banner","skeletonPlpMediaBanner":"fr-ec-skeleton__plp-media-banner","skeleton__plp-gender-tabs":"fr-ec-skeleton__plp-gender-tabs","skeletonPlpGenderTabs":"fr-ec-skeleton__plp-gender-tabs","skeleton__plp-gender-tabs-content":"fr-ec-skeleton__plp-gender-tabs-content","skeletonPlpGenderTabsContent":"fr-ec-skeleton__plp-gender-tabs-content","skeleton__plp-filter-bar":"fr-ec-skeleton__plp-filter-bar","skeletonPlpFilterBar":"fr-ec-skeleton__plp-filter-bar","skeleton__plp-filter-pill":"fr-ec-skeleton__plp-filter-pill","skeletonPlpFilterPill":"fr-ec-skeleton__plp-filter-pill","skeleton__plp-title-center":"fr-ec-skeleton__plp-title-center","skeletonPlpTitleCenter":"fr-ec-skeleton__plp-title-center","skeleton__plp-title-left":"fr-ec-skeleton__plp-title-left","skeletonPlpTitleLeft":"fr-ec-skeleton__plp-title-left","skeleton__plp-items":"fr-ec-skeleton__plp-items","skeletonPlpItems":"fr-ec-skeleton__plp-items","skeleton__plp-item":"fr-ec-skeleton__plp-item","skeletonPlpItem":"fr-ec-skeleton__plp-item","skeleton__plp-item-image":"fr-ec-skeleton__plp-item-image","skeletonPlpItemImage":"fr-ec-skeleton__plp-item-image","skeleton__plp-item-name":"fr-ec-skeleton__plp-item-name","skeletonPlpItemName":"fr-ec-skeleton__plp-item-name","skeleton__plp-button":"fr-ec-skeleton__plp-button","skeletonPlpButton":"fr-ec-skeleton__plp-button","skeleton__plp-media-carousel":"fr-ec-skeleton__plp-media-carousel","skeletonPlpMediaCarousel":"fr-ec-skeleton__plp-media-carousel","skeleton__plp-product-list":"fr-ec-skeleton__plp-product-list","skeletonPlpProductList":"fr-ec-skeleton__plp-product-list","skeleton__plp-product-list-item":"fr-ec-skeleton__plp-product-list-item","skeletonPlpProductListItem":"fr-ec-skeleton__plp-product-list-item","skeleton__plp-product-list-item-image":"fr-ec-skeleton__plp-product-list-item-image","skeletonPlpProductListItemImage":"fr-ec-skeleton__plp-product-list-item-image","skeleton__plp-product-list-item-details":"fr-ec-skeleton__plp-product-list-item-details","skeletonPlpProductListItemDetails":"fr-ec-skeleton__plp-product-list-item-details","skeleton__plp-product-list-item-name":"fr-ec-skeleton__plp-product-list-item-name","skeletonPlpProductListItemName":"fr-ec-skeleton__plp-product-list-item-name","skeleton__plp-product-list-item-price":"fr-ec-skeleton__plp-product-list-item-price","skeletonPlpProductListItemPrice":"fr-ec-skeleton__plp-product-list-item-price","skeleton__plp-button-large":"fr-ec-skeleton__plp-button-large","skeletonPlpButtonLarge":"fr-ec-skeleton__plp-button-large","skeleton__plp-bottom-bar":"fr-ec-skeleton__plp-bottom-bar","skeletonPlpBottomBar":"fr-ec-skeleton__plp-bottom-bar","skeleton-sm-fluid":"fr-ec-skeleton-sm-fluid","skeletonSmFluid":"fr-ec-skeleton-sm-fluid","skeleton__wishlist-title":"fr-ec-skeleton__wishlist-title","skeletonWishlistTitle":"fr-ec-skeleton__wishlist-title","skeleton__wishlist-wrapper":"fr-ec-skeleton__wishlist-wrapper","skeletonWishlistWrapper":"fr-ec-skeleton__wishlist-wrapper","skeleton__wishlist-sidebar":"fr-ec-skeleton__wishlist-sidebar","skeletonWishlistSidebar":"fr-ec-skeleton__wishlist-sidebar","skeleton__wishlist-side-navigation-title":"fr-ec-skeleton__wishlist-side-navigation-title","skeletonWishlistSideNavigationTitle":"fr-ec-skeleton__wishlist-side-navigation-title","skeleton__wishlist-side-navigation-item":"fr-ec-skeleton__wishlist-side-navigation-item","skeletonWishlistSideNavigationItem":"fr-ec-skeleton__wishlist-side-navigation-item","skeleton__wishlist-main":"fr-ec-skeleton__wishlist-main","skeletonWishlistMain":"fr-ec-skeleton__wishlist-main","skeleton__wishlist-title-bar":"fr-ec-skeleton__wishlist-title-bar","skeletonWishlistTitleBar":"fr-ec-skeleton__wishlist-title-bar","skeleton__wishlist-desc-bar":"fr-ec-skeleton__wishlist-desc-bar","skeletonWishlistDescBar":"fr-ec-skeleton__wishlist-desc-bar","skeleton__wishlist-item-inner":"fr-ec-skeleton__wishlist-item-inner","skeletonWishlistItemInner":"fr-ec-skeleton__wishlist-item-inner","skeleton__wishlist-item-image":"fr-ec-skeleton__wishlist-item-image","skeletonWishlistItemImage":"fr-ec-skeleton__wishlist-item-image","skeleton__wishlist-item-bar1":"fr-ec-skeleton__wishlist-item-bar1","skeletonWishlistItemBar1":"fr-ec-skeleton__wishlist-item-bar1","skeleton__wishlist-item-bar2":"fr-ec-skeleton__wishlist-item-bar2","skeletonWishlistItemBar2":"fr-ec-skeleton__wishlist-item-bar2","skeleton__wishlist-item-bar3":"fr-ec-skeleton__wishlist-item-bar3","skeletonWishlistItemBar3":"fr-ec-skeleton__wishlist-item-bar3","skeleton__wishlist-item-button-wrapper":"fr-ec-skeleton__wishlist-item-button-wrapper","skeletonWishlistItemButtonWrapper":"fr-ec-skeleton__wishlist-item-button-wrapper","skeleton__wishlist-item-button":"fr-ec-skeleton__wishlist-item-button","skeletonWishlistItemButton":"fr-ec-skeleton__wishlist-item-button","skeleton__wishlist-styling-tiles":"fr-ec-skeleton__wishlist-styling-tiles","skeletonWishlistStylingTiles":"fr-ec-skeleton__wishlist-styling-tiles","skeleton__wishlist-styling-tile":"fr-ec-skeleton__wishlist-styling-tile","skeletonWishlistStylingTile":"fr-ec-skeleton__wishlist-styling-tile","skeleton__wishlist-items":"fr-ec-skeleton__wishlist-items","skeletonWishlistItems":"fr-ec-skeleton__wishlist-items","skeleton__ranking-title":"fr-ec-skeleton__ranking-title","skeletonRankingTitle":"fr-ec-skeleton__ranking-title","skeleton__ranking-desc":"fr-ec-skeleton__ranking-desc","skeletonRankingDesc":"fr-ec-skeleton__ranking-desc","skeleton__ranking-items-title":"fr-ec-skeleton__ranking-items-title","skeletonRankingItemsTitle":"fr-ec-skeleton__ranking-items-title","skeleton__ranking-items":"fr-ec-skeleton__ranking-items","skeletonRankingItems":"fr-ec-skeleton__ranking-items","skeleton__ranking-item-num":"fr-ec-skeleton__ranking-item-num","skeletonRankingItemNum":"fr-ec-skeleton__ranking-item-num","skeleton__ranking-item-image":"fr-ec-skeleton__ranking-item-image","skeletonRankingItemImage":"fr-ec-skeleton__ranking-item-image","skeleton__ranking-item-title":"fr-ec-skeleton__ranking-item-title","skeletonRankingItemTitle":"fr-ec-skeleton__ranking-item-title","skeleton__ranking-item-desc":"fr-ec-skeleton__ranking-item-desc","skeletonRankingItemDesc":"fr-ec-skeleton__ranking-item-desc","skeleton__breadcrumbs":"fr-ec-skeleton__breadcrumbs","skeletonBreadcrumbs":"fr-ec-skeleton__breadcrumbs","skeleton__container":"fr-ec-skeleton__container","skeletonContainer":"fr-ec-skeleton__container","skeleton__search-title":"fr-ec-skeleton__search-title","skeletonSearchTitle":"fr-ec-skeleton__search-title","skeleton__search-desc-bar":"fr-ec-skeleton__search-desc-bar","skeletonSearchDescBar":"fr-ec-skeleton__search-desc-bar","skeleton__search-input":"fr-ec-skeleton__search-input","skeletonSearchInput":"fr-ec-skeleton__search-input","skeleton__search-results-title":"fr-ec-skeleton__search-results-title","skeletonSearchResultsTitle":"fr-ec-skeleton__search-results-title","skeleton__search-results-wrap":"fr-ec-skeleton__search-results-wrap","skeletonSearchResultsWrap":"fr-ec-skeleton__search-results-wrap","skeleton__search-results":"fr-ec-skeleton__search-results","skeletonSearchResults":"fr-ec-skeleton__search-results","skeleton__search-result-image":"fr-ec-skeleton__search-result-image","skeletonSearchResultImage":"fr-ec-skeleton__search-result-image","skeleton__search-result-title":"fr-ec-skeleton__search-result-title","skeletonSearchResultTitle":"fr-ec-skeleton__search-result-title","skeleton__search-result-desc":"fr-ec-skeleton__search-result-desc","skeletonSearchResultDesc":"fr-ec-skeleton__search-result-desc","skeleton__search-result-partial":"fr-ec-skeleton__search-result-partial","skeletonSearchResultPartial":"fr-ec-skeleton__search-result-partial","skeleton__styling-book-title":"fr-ec-skeleton__styling-book-title","skeletonStylingBookTitle":"fr-ec-skeleton__styling-book-title","skeleton__styling-book-main":"fr-ec-skeleton__styling-book-main","skeletonStylingBookMain":"fr-ec-skeleton__styling-book-main","skeleton__styling-book-main-image":"fr-ec-skeleton__styling-book-main-image","skeletonStylingBookMainImage":"fr-ec-skeleton__styling-book-main-image","skeleton__styling-book-items-title":"fr-ec-skeleton__styling-book-items-title","skeletonStylingBookItemsTitle":"fr-ec-skeleton__styling-book-items-title","skeleton__styling-book-items-desc":"fr-ec-skeleton__styling-book-items-desc","skeletonStylingBookItemsDesc":"fr-ec-skeleton__styling-book-items-desc","skeleton__styling-book-item":"fr-ec-skeleton__styling-book-item","skeletonStylingBookItem":"fr-ec-skeleton__styling-book-item","skeleton__styling-book-item-image":"fr-ec-skeleton__styling-book-item-image","skeletonStylingBookItemImage":"fr-ec-skeleton__styling-book-item-image","skeleton__styling-book-item-title":"fr-ec-skeleton__styling-book-item-title","skeletonStylingBookItemTitle":"fr-ec-skeleton__styling-book-item-title","skeleton__styling-book-item-desc":"fr-ec-skeleton__styling-book-item-desc","skeletonStylingBookItemDesc":"fr-ec-skeleton__styling-book-item-desc","skeleton__styling-book-item-desc2":"fr-ec-skeleton__styling-book-item-desc2","skeletonStylingBookItemDesc2":"fr-ec-skeleton__styling-book-item-desc2","skeleton__styling-book-pill":"fr-ec-skeleton__styling-book-pill","skeletonStylingBookPill":"fr-ec-skeleton__styling-book-pill","skeleton__stylehint-profile":"fr-ec-skeleton__stylehint-profile","skeletonStylehintProfile":"fr-ec-skeleton__stylehint-profile","skeleton__stylehint-profile-image":"fr-ec-skeleton__stylehint-profile-image","skeletonStylehintProfileImage":"fr-ec-skeleton__stylehint-profile-image","skeleton__stylehint-profile-name":"fr-ec-skeleton__stylehint-profile-name","skeletonStylehintProfileName":"fr-ec-skeleton__stylehint-profile-name","skeleton__stylehint-bar1":"fr-ec-skeleton__stylehint-bar1","skeletonStylehintBar1":"fr-ec-skeleton__stylehint-bar1","skeleton__stylehint-bar2":"fr-ec-skeleton__stylehint-bar2","skeletonStylehintBar2":"fr-ec-skeleton__stylehint-bar2","skeleton__stylehint-bar3":"fr-ec-skeleton__stylehint-bar3","skeletonStylehintBar3":"fr-ec-skeleton__stylehint-bar3","skeleton__styling-list-title":"fr-ec-skeleton__styling-list-title","skeletonStylingListTitle":"fr-ec-skeleton__styling-list-title","skeleton__styling-list-items":"fr-ec-skeleton__styling-list-items","skeletonStylingListItems":"fr-ec-skeleton__styling-list-items","skeleton__styling-list-item":"fr-ec-skeleton__styling-list-item","skeletonStylingListItem":"fr-ec-skeleton__styling-list-item","skeleton__stylehint-full-width-bar":"fr-ec-skeleton__stylehint-full-width-bar","skeletonStylehintFullWidthBar":"fr-ec-skeleton__stylehint-full-width-bar","skeleton__styling-hint-list-items":"fr-ec-skeleton__styling-hint-list-items","skeletonStylingHintListItems":"fr-ec-skeleton__styling-hint-list-items","skeleton__breadcrumb-fluid":"fr-ec-skeleton__breadcrumb-fluid","skeletonBreadcrumbFluid":"fr-ec-skeleton__breadcrumb-fluid","skeleton__styling-book-top-page-items-wrap":"fr-ec-skeleton__styling-book-top-page-items-wrap","skeletonStylingBookTopPageItemsWrap":"fr-ec-skeleton__styling-book-top-page-items-wrap","skeleton__styling-book-top-page-items":"fr-ec-skeleton__styling-book-top-page-items","skeletonStylingBookTopPageItems":"fr-ec-skeleton__styling-book-top-page-items","skeleton__styling-book-top-page-item":"fr-ec-skeleton__styling-book-top-page-item","skeletonStylingBookTopPageItem":"fr-ec-skeleton__styling-book-top-page-item","skeleton__styling-book-top-page-featured-wrap":"fr-ec-skeleton__styling-book-top-page-featured-wrap","skeletonStylingBookTopPageFeaturedWrap":"fr-ec-skeleton__styling-book-top-page-featured-wrap","skeleton__styling-book-top-page-featured-image":"fr-ec-skeleton__styling-book-top-page-featured-image","skeletonStylingBookTopPageFeaturedImage":"fr-ec-skeleton__styling-book-top-page-featured-image","skeleton__styling-book-top-page-featured-bar1":"fr-ec-skeleton__styling-book-top-page-featured-bar1","skeletonStylingBookTopPageFeaturedBar1":"fr-ec-skeleton__styling-book-top-page-featured-bar1","skeleton__styling-book-top-page-featured-bar2":"fr-ec-skeleton__styling-book-top-page-featured-bar2","skeletonStylingBookTopPageFeaturedBar2":"fr-ec-skeleton__styling-book-top-page-featured-bar2","skeleton__styling-book-top-page-featured-bar3":"fr-ec-skeleton__styling-book-top-page-featured-bar3","skeletonStylingBookTopPageFeaturedBar3":"fr-ec-skeleton__styling-book-top-page-featured-bar3","skeleton__styling-book-top-page-with-sidebar-wrap":"fr-ec-skeleton__styling-book-top-page-with-sidebar-wrap","skeletonStylingBookTopPageWithSidebarWrap":"fr-ec-skeleton__styling-book-top-page-with-sidebar-wrap","skeleton__styling-book-sidebar":"fr-ec-skeleton__styling-book-sidebar","skeletonStylingBookSidebar":"fr-ec-skeleton__styling-book-sidebar","skeleton__styling-side-bar-fw-bar":"fr-ec-skeleton__styling-side-bar-fw-bar","skeletonStylingSideBarFwBar":"fr-ec-skeleton__styling-side-bar-fw-bar","skeleton__styling-side-bar-pill":"fr-ec-skeleton__styling-side-bar-pill","skeletonStylingSideBarPill":"fr-ec-skeleton__styling-side-bar-pill","skeleton__styling-side-bar-item":"fr-ec-skeleton__styling-side-bar-item","skeletonStylingSideBarItem":"fr-ec-skeleton__styling-side-bar-item","skeleton__stylehint-top-page":"fr-ec-skeleton__stylehint-top-page","skeletonStylehintTopPage":"fr-ec-skeleton__stylehint-top-page","skeleton__styling-detail-page-items-title":"fr-ec-skeleton__styling-detail-page-items-title","skeletonStylingDetailPageItemsTitle":"fr-ec-skeleton__styling-detail-page-items-title","skeleton__styling-detail-page":"fr-ec-skeleton__styling-detail-page","skeletonStylingDetailPage":"fr-ec-skeleton__styling-detail-page","skeleton__styling-filters":"fr-ec-skeleton__styling-filters","skeletonStylingFilters":"fr-ec-skeleton__styling-filters","skeleton__styling-filter":"fr-ec-skeleton__styling-filter","skeletonStylingFilter":"fr-ec-skeleton__styling-filter","skeleton__styling-book-items":"fr-ec-skeleton__styling-book-items","skeletonStylingBookItems":"fr-ec-skeleton__styling-book-items","skeleton__stylehint-profile-wrap":"fr-ec-skeleton__stylehint-profile-wrap","skeletonStylehintProfileWrap":"fr-ec-skeleton__stylehint-profile-wrap","skeleton__styling-secondary":"fr-ec-skeleton__styling-secondary","skeletonStylingSecondary":"fr-ec-skeleton__styling-secondary"};

var Skeleton = function Skeleton(_a) {
  var className = _a.className,
    variant = _a.variant,
    _b = _a.productCollectionCount,
    productCollectionCount = _b === void 0 ? 6 : _b,
    _c = _a.mediaRatio,
    mediaRatio = _c === void 0 ? '1x1' : _c;
  var ratio1x1 = '100%';
  var ratio3x4 = '133.33%';
  var paddingTopVal = mediaRatio === '1x1' ? ratio1x1 : ratio3x4;
  if (variant === 'L2.5-lineup') {
    var productCollection = function productCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItem1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonTextWrapper
        }, /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: true,
          tabletVisibility: false,
          pcVisibility: false
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItemMobileOnly, styles$I$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItem3, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumb, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonHeading, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBanner, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonProductCollectionWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonProductCollection
    }, productCollection(9))), /*#__PURE__*/createElement("div", null));
  } else if (variant === 'L2.5-featured') {
    var featuredProductCollection = function featuredProductCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonFeaturedProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonFeaturedProductItem1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonFeaturedTextWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonFeaturedProductItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonFeaturedProductItem3, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeleton, className)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumb, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedHeading, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSubText, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSubText1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSubText2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonTab, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonProductCollectionHeading, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonFeaturedWrapper
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedProductCollection, styles$I$1.skeletonFeaturedFirstRow)
    }, featuredProductCollection(3))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedProductCollection, styles$I$1.skeletonFeaturedFirstRow)
    }, featuredProductCollection(4))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonTab, styles$I$1.skeletonTabMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedFilterBarContainer)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedFilterBar, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedFilterBar, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonFeaturedProductCollection
    }, featuredProductCollection(16))));
  } else if (variant === 'L2') {
    var skeletonL2Category = function skeletonL2Category(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonL2CategoryItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2CategoryItem1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2CategoryItem2, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }));
      });
    };
    var skeletonL2Topics = function skeletonL2Topics(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonL2TopicsSection,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2Topic1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonL2TopicsWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2Topic2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2Topic3, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2Topic4, styles$I$1.skeletonPulse)
        })));
      });
    };
    var skeletonL2WithSmallProducts = function skeletonL2WithSmallProducts(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2SmallProduct1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2SmallProduct2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2SmallProduct3, styles$I$1.skeletonPulse)
        })));
      });
    };
    var skeletonL2NewArrivals = function skeletonL2NewArrivals(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonL2NewArrivalItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2NewArrivalItem1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2NewArrivalItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2NewArrivalItem3, styles$I$1.skeletonPulse)
        }));
      });
    };
    var skeletonL2Styling = function skeletonL2Styling(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2StylingItem, styles$I$1.skeletonPulse),
          key: index
        });
      });
    };
    var skeletonL2LifeWear = function skeletonL2LifeWear(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonL2LifeWearItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2LifeWearItem1, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2LifeWearItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2LifeWearItem3, styles$I$1.skeletonPulse)
        }));
      });
    };
    var width = getViewportWidth();
    var skeletonL2NewArrival = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2NewArrivals(3) : skeletonL2NewArrivals(4);
    var skeletonL2Categorys = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2Category(3) : skeletonL2Category(4);
    var skeletonL2Stylings = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2Styling(3) : skeletonL2Styling(4);
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeleton, className)
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedHeading, styles$I$1.skeletonL2Heading, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2HomeSlider, styles$I$1.skeletonL2HomeSliderFullWidth, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Banner, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2CategoryHeading, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2CategoryWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2CategoryCollection
    }, skeletonL2Category(12))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2TopicsSectionWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivals, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsDescription, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem1, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYou, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Banner, styles$I$1.skeletonL2BannerMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYou, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivals, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsDescription, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem1, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2CategoryHeading, styles$I$1.skeletonL2CategoryHeadingMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2CategoryWrapper
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2CategoryCollection, styles$I$1.skeletonL2CategoryCollectionMargin)
    }, skeletonL2Categorys)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Banner, styles$I$1.skeletonL2BannerMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYou, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivals, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsDescription, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem1, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYou, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivals, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsDescription, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem1, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYou, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Banner, styles$I$1.skeletonL2BannerMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2TopicsSectionWrapper, styles$I$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivals, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsDescription, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem1, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2LargeProductItem3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYou, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Banner, styles$I$1.skeletonL2BannerMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYou, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2HomeSlider, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2HomeSlider, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2StylingWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2StylingCollection
    }, skeletonL2Stylings)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Banner, styles$I$1.skeletonL2BannerMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2LifeWearWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2LifeWearCollection
    }, skeletonL2LifeWear(3)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2TopicsSectionWrapper, styles$I$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3)))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2LifeWearWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2LifeWearCollection
    }, skeletonL2LifeWear(3)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2TopicsSectionWrapper, styles$I$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3)))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2TopicsSectionWrapper, styles$I$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2SearchCategory1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2SearchCategory2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2SearchCategory3, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2Topics, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2HomeSlider, styles$I$1.skeletonL2HomeSliderHeight112, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2ViewMore, styles$I$1.skeletonL2ViewMoreMargin88, styles$I$1.skeletonPulse)
    }));
  } else if (variant === 'L3') {
    var featuredProductCollection = function featuredProductCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonFeaturedProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonFeaturedProductItem1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonFeaturedTextWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonFeaturedProductItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonFeaturedProductItem3, styles$I$1.skeletonPulse, spacingStyles.mbSpacing06)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeleton, className)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumb, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonHeading, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL3FullWidth, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL3FullWidth, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedFilterBarContainer)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedFilterBar, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFeaturedFilterBar, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonFeaturedProductCollection
    }, featuredProductCollection(16)));
  } else if (variant === 'L4') {
    var getChips = function getChips(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonChip, styles$I$1.skeletonPulse)
        });
      });
    };
    var width = getViewportWidth();
    var skeletonL2NewArrivals = function skeletonL2NewArrivals(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonL2NewArrivalItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2NewArrivalItem1, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2NewArrivalItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonL2NewArrivalItem3, styles$I$1.skeletonPulse)
        }));
      });
    };
    var skeletonL2NewArrival = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2NewArrivals(3) : skeletonL2NewArrivals(4);
    var getStylingItem = function getStylingItem(times, userInfo) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingItem, styles$I$1.skeletonPulse)
        }), userInfo ? (/*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonUserInfoWrapper)
        }, /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: false,
          tabletVisibility: true,
          pcVisibility: true
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonUserInfoProfile, styles$I$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonUserInfoProfileInfo, styles$I$1.skeletonPulse)
        }))) : null);
      });
    };
    var carouselRightContent = /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpRightContainer)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLabelValue, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonChipContainer, styles$I$1.skeletonChipContainerHorizontal, spacingStyles.mbSpacing05)
    }, getChips(6)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLabelValue, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonChipContainer, styles$I$1.skeletonChipContainerHorizontal, spacingStyles.mbSpacing05)
    }, getChips(6)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLabelValue, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonChipContainer, styles$I$1.skeletonChipContainerHorizontal, spacingStyles.mbSpacing05)
    }, getChips(6)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLabelValue, styles$I$1.skeletonLabelValueHeight32, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonMySizeAssistHeight20, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonMySizeAssistWidth241, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonMySizeAssistWidth301, styles$I$1.skeletonPulse, spacingStyles.mbSpacing06)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonMySizeAssistWidth376, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLabelValue, styles$I$1.skeletonLabelValueHeight32, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonMySizeAssistHeight20, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonMySizeAssistWidth241, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonMySizeAssist, styles$I$1.skeletonMySizeAssistWidth301, styles$I$1.skeletonPulse)
    }));
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeleton, className)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumb, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonHeading, styles$I$1.skeletonPulse, styles$I$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSubText, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSubText1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSubText2, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpContainer)
    }, /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpLeftContainer)
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonChipContainer)
    }, getChips(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarousel, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: true,
      pcVisibility: false
    }, carouselRightContent), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: true,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonContainer125, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07, spacingStyles.mtSpacing07)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent1, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent2, styles$I$1.skeletonCarouselBottomContent2Width496, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent2, styles$I$1.skeletonCarouselBottomContent2Width621, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent1, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingContainer, styles$I$1.skeletonStylingContainerMargin)
    }, getStylingItem(3, false)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonViewMoreStyling, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent1, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingContainer, styles$I$1.skeletonStylingContainerMargin)
    }, getStylingItem(3, true)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonViewMoreStyling, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent1, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent2, styles$I$1.skeletonCarouselBottomContent2Width496, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonCarouselBottomContent2, styles$I$1.skeletonCarouselBottomContent2Width621, styles$I$1.skeletonPulse, spacingStyles.mbSpacing06)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonViewMoreStyling, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonHeading, styles$I$1.skeletonPulse, styles$I$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: false,
      pcVisibility: true
    }, carouselRightContent)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYouWrapper, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonHeading, styles$I$1.skeletonPulse, styles$I$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYouWrapper, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonHeading, styles$I$1.skeletonPulse, styles$I$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL2NewArrivalsYouWrapper, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonL4Banner, styles$I$1.skeletonPulse, spacingStyles.mbSpacing08)
    }));
  } else if (variant === 'Spl') {
    var width = getViewportWidth();
    var productCollectionParent = function productCollectionParent(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonBanner, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonProductCollectionWrapper
        }, /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonProductCollection
        }, productCollection_1(6))));
      });
    };
    var productCollection_1 = function productCollection_1(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItem1, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonTextWrapper
        }, /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: true,
          tabletVisibility: false,
          pcVisibility: false
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItemMobileOnly, styles$I$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductItem3, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumb, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonHeading, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonTab, styles$I$1.skeletonPulse)
    }), width < designTokens_3.mqMediumScreenMinWidthLimit ? (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonTabBottom, styles$I$1.skeletonPulse)
    })) : '', productCollectionParent(3), /*#__PURE__*/createElement("div", null));
  } else if (variant === 'fixed-height-product-collection') {
    var productCollection = function productCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonProductFixedHeight,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductFixedHeightImage, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonProductFixedHeightTextWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductFixedHeightChip, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductFixedHeightItem1, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: true,
          tabletVisibility: false,
          pcVisibility: false
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductFixedHeightMobileOnly, styles$I$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductFixedHeightItem2, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonProductFixedHeightItem3, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonProductCollectionWrapperFixedHeight
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonProductCollectionFixedHeight
    }, productCollection(productCollectionCount || 6))), /*#__PURE__*/createElement("div", null));
  } else if (variant === 'fixed-height-cms-styling') {
    var width = getViewportWidth();
    var skeletonL2Styling = function skeletonL2Styling(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonFixedHeightCmsStylingItem, styles$I$1.skeletonPulse),
          key: index
        });
      });
    };
    var skeletonL2Stylings = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2Styling(3) : skeletonL2Styling(4);
    return /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2StylingWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonL2StylingCollection
    }, skeletonL2Stylings), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonFixedHeightCmsStylingIndicator, styles$I$1.skeletonPulse)
    }))));
  } else if (variant === 'navigation') {
    var width_1 = getViewportWidth();
    var skeletonClassListItem = function skeletonClassListItem(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationClassListItem),
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationClassListItemMedia, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationClassListItemText, styles$I$1.skeletonPulse)
        }));
      });
    };
    var skeletonNavigationProduct_1 = function skeletonNavigationProduct_1(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProduct),
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductMedia, styles$I$1.skeletonPulse, spacingStyles.mbSpacing01)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing01)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductSubTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing01)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductDescription, styles$I$1.skeletonPulse)
        }));
      });
    };
    var skeletonClassListItems = skeletonClassListItem(16);
    var skeletonNavigationProducts_1 = function skeletonNavigationProducts_1(count) {
      return width_1 <= designTokens_3.mqMediumScreenMaxWidthLimit ? width_1 < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonNavigationProduct_1(3) : skeletonNavigationProduct_1(count) : skeletonNavigationProduct_1(count);
    };
    var skeletonNavigationProductsSection1 = function skeletonNavigationProductsSection1(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement(Fragment, {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductHeading, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonNavigationProducts
        }, skeletonNavigationProducts_1(7)));
      });
    };
    var skeletonNavigationProductsSection2 = function skeletonNavigationProductsSection2(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement(Fragment, {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductHeading, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonNavigationProducts
        }, skeletonNavigationProducts_1(9)));
      });
    };
    var skeletonNavigationProductsSection3 = function skeletonNavigationProductsSection3(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement(Fragment, {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductHeading, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonNavigationProducts
        }, skeletonNavigationProducts_1(8)));
      });
    };
    var skeletonNavigationProductsSection4 = function skeletonNavigationProductsSection4(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement(Fragment, {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonNavigationProductHeading, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonNavigationProducts
        }, skeletonNavigationProducts_1(1)));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeleton, styles$I$1.skeletonNavigation)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonNavigationWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonNavigationClassList
    }, skeletonClassListItems), /*#__PURE__*/createElement(Fragment, null, skeletonNavigationProductsSection1(1)), /*#__PURE__*/createElement(Fragment, null, skeletonNavigationProductsSection2(1)), /*#__PURE__*/createElement(Fragment, null, skeletonNavigationProductsSection3(1)), /*#__PURE__*/createElement("div", {
      className: spacingStyles.mbSpacing07
    }, skeletonNavigationProductsSection4(1))));
  } else if (variant === 'login') {
    return /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonLoginItem2
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: true,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem3, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem4, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem4, styles$I$1.skeletonLoginItem2SubItem4Last, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem3, styles$I$1.skeletonLoginItem2SubItem3Last, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem5, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem6, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem7, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: false,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem3, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem4, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem4, styles$I$1.skeletonLoginItem2SubItem4Last, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem3, styles$I$1.skeletonLoginItem2SubItem3Last, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem5, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem6, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonLoginItem2SubItem7, styles$I$1.skeletonPulse)
    })))));
  } else if (variant === 'pdp') {
    var rightContainerFirstItem = /*#__PURE__*/createElement("div", {
      className: spacingStyles.mbSpacing05
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistFirst, styles$I$1.skeletonPulse)
    }));
    var rightContainerSecondItem = /*#__PURE__*/createElement("div", {
      className: spacingStyles.mbSpacing05
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPdpFirstRightItemChipGroup
    }, count(6).map(function (_, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses(styles$I$1.skeletonPdpFirstRightItemChipItem, styles$I$1.skeletonPulse)
      });
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistFourth, styles$I$1.skeletonPulse)
    }));
    var rightContainerThirdItem = /*#__PURE__*/createElement("div", {
      className: spacingStyles.mbSpacing05
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPdpFirstRightItemChipGroup
    }, count(6).map(function (_, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses(styles$I$1.skeletonPdpFirstRightItemChipItemSquare, styles$I$1.skeletonPulse)
      });
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistFourth, styles$I$1.skeletonPulse)
    }));
    var textListContainer = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpSecondItemTextFirst, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpSecondItemTextSecond, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpSecondItemTextThird, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpSecondItemTextFourth, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07Sm)
    }));
    var productListContainer = function productListContainer(index) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$I$1.skeletonPdpImagePlusTextHeading, styles$I$1.skeletonPulse)
      }), /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$I$1.skeletonPdpImagePlusTextContainer, index === 1 && spacingStyles.mbSpacing06Sm)
      }, count(4).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonPdpImagePlusTextItem)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPdpImagePlusTextItemImg, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPdpImagePlusTextItemTextFirst, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPdpImagePlusTextItemTextSecond, styles$I$1.skeletonPulse)
        }));
      })));
    };
    var carouselWrapper = /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPdpCarouselWrapper
    }, textListContainer, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpStylingCarouselText, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpStylingCarouselGroup, spacingStyles.mbSpacing07)
    }, count(3).map(function (_, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses(styles$I$1.skeletonPdpStylingCarouselItem, styles$I$1.skeletonPulse),
        style: {
          paddingTop: paddingTopVal
        }
      });
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpStylingCarouselText, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpStylingCarouselGroup, spacingStyles.mbSpacing04)
    }, count(3).map(function (_, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses(styles$I$1.skeletonPdpStylingCarouselItem, styles$I$1.skeletonPulse),
        style: {
          paddingTop: paddingTopVal
        }
      });
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPdpStylingCarouselThirdGroup
    }, count(3).map(function (_, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses(styles$I$1.skeletonPdpStylingCarouselThirdItem, styles$I$1.skeletonPulse)
      });
    })), textListContainer);
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftItem, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeleton, styles$I$1.skeletonPdpWrapper, className)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPdpFirstItem
    }, /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: false,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftGroup)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftGroupItem)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftItem, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftItem, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftGroupItem)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftItem, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftItem, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstLeftItem, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, carouselWrapper)), /*#__PURE__*/createElement("div", null, rightContainerFirstItem, rightContainerSecondItem, rightContainerThirdItem, /*#__PURE__*/createElement("div", {
      className: spacingStyles.mbSpacing06
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistSecond, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistThird, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistFourth, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemPill, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistFirst, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistSecond, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistThird, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpFirstRightItemTextlistFourth, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07Sm)
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: false,
      pcVisibility: true
    }, productListContainer(), productListContainer(), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpLastItem, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, carouselWrapper), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: true,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPdpImagePlusTextWrapper
    }, productListContainer(1), productListContainer(), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPdpLastItem, styles$I$1.skeletonPulse)
    }))));
  } else if (variant === 'PLP-featured') {
    var itemCollection = function itemCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonPlpItem)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpItemImage, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpItemName, styles$I$1.skeletonPulse)
        }));
      });
    };
    var productCollection = function productCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: styles$I$1.skeletonPlpProductListItem
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpProductListItemImage, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonPlpProductListItemDetails
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpProductListItemName, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpProductListItemPrice, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02, spacingStyles.mtSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpMediaBanner, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement(LayoutWrapper, {
      element: "div"
    }, /*#__PURE__*/createElement(Layout, {
      gutter: {
        lg: false,
        md: true,
        sm: false
      }
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpGenderTabs, styles$I$1.skeletonPulse, spacingStyles.mbSpacing06)
    }), /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpGenderTabsContent, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFullWidthBar, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterBar, spacingStyles.mbSpacing06)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpTitleCenter, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpItems, spacingStyles.mbSpacing05)
    }, itemCollection(5))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: false,
      mobileVisibility: true
    }, /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpItems, spacingStyles.mbSpacing05)
    }, itemCollection(3)))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpButton, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpTitleLeft, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpMediaCarousel, styles$I$1.skeletonPulse, spacingStyles.mbSpacing06)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpProductList, spacingStyles.mbSpacing06)
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: false,
      mobileVisibility: false
    }, productCollection(4)), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: false
    }, productCollection(3)), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: false,
      mobileVisibility: true
    }, productCollection(2))), /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpButtonLarge, styles$I$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpBottomBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    })))));
  } else if (variant === 'PLP' || variant === 'skeleton-2.5') {
    var productList_1 = function productList_1(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: styles$I$1.skeletonPlpProductListItem
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpProductListItemImage, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonPlpProductListItemDetails
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpProductListItemName, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonPlpProductListItemPrice, styles$I$1.skeletonPulse)
        })));
      });
    };
    var productCollection = function productCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonPlpProductList, spacingStyles.mbSpacing05)
        }, /*#__PURE__*/createElement(CmsContentVisibility, {
          pcVisibility: true,
          tabletVisibility: false,
          mobileVisibility: false
        }, productList_1(4)), /*#__PURE__*/createElement(CmsContentVisibility, {
          pcVisibility: false,
          tabletVisibility: true,
          mobileVisibility: false
        }, productList_1(3)), /*#__PURE__*/createElement(CmsContentVisibility, {
          pcVisibility: false,
          tabletVisibility: false,
          mobileVisibility: true
        }, productList_1(2)));
      });
    };
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04, spacingStyles.mtSpacing02)
    }), /*#__PURE__*/createElement(LayoutWrapper, {
      element: "div"
    }, /*#__PURE__*/createElement(Layout, {
      gutter: {
        lg: false,
        md: true,
        sm: false
      }
    }, /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpGenderTabsContent, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFullWidthBar, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterBar)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }))), productCollection(5))));
  } else if (variant === 'wishlist-product') {
    var sideBarItems = function sideBarItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonWishlistSideNavigationItem, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
        });
      });
    };
    var wishlistItems = function wishlistItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: spacingStyles.mbSpacing04
        }, /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonWishlistItemInner
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonWishlistItemImage, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonWishlistItemBar1, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonWishlistItemBar2, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonWishlistItemBar3, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }))), /*#__PURE__*/createElement("div", {
          className: styles$I$1.skeletonWishlistItemButtonWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonWishlistItemButton, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, spacingStyles.mtSpacing04)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistWrapper
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: false,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistSidebar
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistSideNavigationTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(8), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistSideNavigationTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04, spacingStyles.mtSpacing06)
    }), sideBarItems(8))), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistMain
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistTitleBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistDescBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistDescBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistItems
    }, wishlistItems(6)))));
  } else if (variant === 'wishlist-styling') {
    var sideBarItems = function sideBarItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonWishlistSideNavigationItem, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
        });
      });
    };
    var wishlistTiles = function wishlistTiles(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonWishlistStylingTile, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        });
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, spacingStyles.mtSpacing04)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistWrapper
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: false,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistSidebar
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistSideNavigationTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(8), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistSideNavigationTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04, spacingStyles.mtSpacing06)
    }), sideBarItems(8))), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistMain
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistTitleBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonWishlistDescBar, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPlpFilterBar
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonWishlistStylingTiles
    }, wishlistTiles(16)))));
  } else if (variant === 'ranking') {
    var rankingItems = function rankingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonRankingItemNum, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonRankingItemImage, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonRankingItemTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonRankingItemDesc, styles$I$1.skeletonPulse)
        }));
      });
    };
    return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, spacingStyles.mtSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonRankingTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonRankingDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonRankingItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonRankingItems
    }, rankingItems(12)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonRankingItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04, spacingStyles.mtSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonRankingItems
    }, rankingItems(12))), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumbs, styles$I$1.skeletonPulse, spacingStyles.mtSpacing07, spacingStyles.mbSpacing05)
    })));
  } else if (variant === 'search') {
    var searchResults = function searchResults(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: index >= 2 ? styles$I$1.skeletonSearchResultPartial : ''
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonSearchResultImage, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonSearchResultTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonSearchResultDesc, styles$I$1.skeletonPulse)
        }));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(spacingStyles.mtSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSearchTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSearchInput, styles$I$1.skeletonPulse, spacingStyles.mbSpacing06)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSearchResultsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonSearchResultsWrap
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonSearchResults
    }, searchResults(4))), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumbs, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    })));
  } else if (variant === 'search-result') {
    var searchResults = function searchResults(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonSearchResultImage, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonSearchResultTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonSearchResultDesc, styles$I$1.skeletonPulse)
        }));
      });
    };
    return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSearchTitle, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSearchInput, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSearchDescBar, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPlpFilterBar
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonSmFluid
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonSearchResults
    }, searchResults(24))));
  } else if (variant === 'styling-book') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookItem, spacingStyles.mbSpacing04)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemImage, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc2, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: spacingStyles.mbSpacing07
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTitle, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookMain
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookMainImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookItemsDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookItems
    }, stylingItems(4), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookPill, styles$I$1.skeletonPulse, spacingStyles.mtSpacing06, spacingStyles.mbSpacing04)
    })))));
  } else if (variant === 'stylehint') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookItem, spacingStyles.mbSpacing04)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemImage, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc2, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: spacingStyles.mbSpacing07
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTitle, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookMain
    }, /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookMainImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylehintProfileWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintProfile, spacingStyles.mtSpacing05, spacingStyles.mbSpacing04)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintProfileImage, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintProfileName, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintBar1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintBar3, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookItemsDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookItems
    }, stylingItems(4), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookPill, styles$I$1.skeletonPulse, spacingStyles.mtSpacing06, spacingStyles.mbSpacing04)
    })))));
  } else if (variant === 'official-styling-list') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingListItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        });
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, spacingStyles.mtSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingListTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingListItems
    }, stylingItems(20)));
  } else if (variant === 'styling-hint-list') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingListItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylehintProfile, spacingStyles.mtSpacing02)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylehintProfileImage, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylehintProfileName, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, spacingStyles.mtSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingListTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonPlpFilterBar
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonPlpFilterPill, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingListItems, styles$I$1.skeletonStylingHintListItems)
    }, stylingItems(20)));
  } else if (variant === 'styling-book-top-page') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookTopPageItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        });
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, spacingStyles.mtSpacing04, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumbFluid, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    })))));
  } else if (variant === 'styling-book-top-page-with-sidebar') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookTopPageItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        });
      });
    };
    var sideBarItems = function sideBarItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingSideBarItem, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
        });
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, spacingStyles.mtSpacing04, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumbFluid, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: false,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageWithSidebarWrap
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookSidebar
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarPill, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarPill, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarPill, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarItem, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(10), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(10), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(10)), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    }))))))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar1, styles$I$1.skeletonPulse, spacingStyles.mtSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedBar3, styles$I$1.skeletonPulse)
    }))))));
  } else if (variant === 'stylehint-top-page') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookTopPageItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        });
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, styles$I$1.skeletonStylehintTopPage, spacingStyles.mtSpacing04, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumbFluid, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })))));
  } else if (variant === 'stylehint-top-page-with-sidebar') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookTopPageItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        });
      });
    };
    var sideBarItems = function sideBarItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingSideBarItem, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
        });
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonSmFluid, styles$I$1.skeletonStylehintTopPage, spacingStyles.mtSpacing04, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumbFluid, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: false,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageWithSidebarWrap
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookSidebar
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarPill, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarPill, styles$I$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarPill, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarItem, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(10), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(10), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingSideBarFwBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), sideBarItems(10)), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }))))))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintFullWidthBar, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap, spacingStyles.mbSpacing05)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageItemsWrap)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageItems
    }, stylingItems(6)), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookTopPageFeaturedWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTopPageFeaturedImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }))))));
  } else if (variant === 'styling-book-detail-page') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookItem, spacingStyles.mbSpacing04)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemImage, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc2, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        })));
      });
    };
    var stylingItemsSecondary = function stylingItemsSecondary(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingListItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        });
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingDetailPage, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumb, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTitle, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookMain, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookMainImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    })), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookItems
    }, stylingItems(5)))), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingDetailPageItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: false,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingListItems, styles$I$1.skeletonStylingHintListItems)
    }, stylingItemsSecondary(10))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingListItems, styles$I$1.skeletonStylingHintListItems)
    }, stylingItemsSecondary(12))));
  } else if (variant === 'stylehint-detail-page') {
    var stylingItems = function stylingItems(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingBookItem, spacingStyles.mbSpacing04)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemImage, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingBookItemDesc2, styles$I$1.skeletonPulse, spacingStyles.mbSpacing03)
        })));
      });
    };
    var stylingFilters = function stylingFilters(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylingFilter, styles$I$1.skeletonPulse)
        });
      });
    };
    var stylingItemsSecondary = function stylingItemsSecondary(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$I$1.skeletonStylingListItem, styles$I$1.skeletonPulse),
          style: {
            paddingTop: paddingTopVal
          }
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylehintProfile, spacingStyles.mtSpacing02)
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylehintProfileImage, styles$I$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$I$1.skeletonStylehintProfileName, styles$I$1.skeletonPulse)
        })));
      });
    };
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingDetailPage, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonBreadcrumb, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookTitle, styles$I$1.skeletonPulse, spacingStyles.mtSpacing05, spacingStyles.mbSpacing05)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookMain
    }, /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookMainImage, styles$I$1.skeletonPulse),
      style: {
        paddingTop: paddingTopVal
      }
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylehintProfileWrap
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintProfile, spacingStyles.mtSpacing05, spacingStyles.mbSpacing04)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintProfileImage, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintProfileName, styles$I$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintBar1, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintBar2, styles$I$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylehintBar3, styles$I$1.skeletonPulse)
    }))), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingBookItemsDesc, styles$I$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingBookItems
    }, stylingItems(5)))), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonContainer
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingDetailPageItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingFilters, spacingStyles.mbSpacing07)
    }, stylingFilters(7)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingDetailPageItemsTitle, styles$I$1.skeletonPulse, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement("div", {
      className: styles$I$1.skeletonStylingSecondary
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: true,
      tabletVisibility: false,
      mobileVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingListItems, styles$I$1.skeletonStylingHintListItems)
    }, stylingItemsSecondary(10))), /*#__PURE__*/createElement(CmsContentVisibility, {
      pcVisibility: false,
      tabletVisibility: true,
      mobileVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$I$1.skeletonStylingListItems, styles$I$1.skeletonStylingHintListItems)
    }, stylingItemsSecondary(12)))));
  }
  return null;
};
Skeleton.displayName = 'CoreSkeleton';

var styles$J$1 = {"template-store-locator__result-details":"fr-ec-template-store-locator__result-details","templateStoreLocatorResultDetails":"fr-ec-template-store-locator__result-details","template-store-locator__filter-badge":"fr-ec-template-store-locator__filter-badge","templateStoreLocatorFilterBadge":"fr-ec-template-store-locator__filter-badge","template-store-locator--min-height":"fr-ec-template-store-locator--min-height","templateStoreLocatorMinHeight":"fr-ec-template-store-locator--min-height","breadcrump-wrapper":"fr-ec-breadcrump-wrapper","breadcrumpWrapper":"fr-ec-breadcrump-wrapper","breadcrumb-group":"fr-ec-breadcrumb-group","breadcrumbGroup":"fr-ec-breadcrumb-group"};

var TemplateStoreLocator = function TemplateStoreLocator(_a) {
  var navigationPath = _a.navigationPath,
    pageHeading = _a.pageHeading,
    searchSection = _a.searchSection,
    map = _a.map,
    promotionalSection = _a.promotionalSection,
    searchResult = _a.searchResult,
    searchFilter = _a.searchFilter,
    searchOption = _a.searchOption,
    resultDetails = _a.resultDetails,
    filterLabel = _a.filterLabel,
    filterBadgeCount = _a.filterBadgeCount,
    resultDetailsCount = _a.resultDetailsCount,
    className = _a.className,
    _b = _a.toggleMinHeight,
    toggleMinHeight = _b === void 0 ? true : _b,
    props = __rest$1(_a, ["navigationPath", "pageHeading", "searchSection", "map", "promotionalSection", "searchResult", "searchFilter", "searchOption", "resultDetails", "filterLabel", "filterBadgeCount", "resultDetailsCount", "className", "toggleMinHeight"]);
  var resultDetailSection = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    alignment: "center",
    justifyContent: "space-between",
    className: styles$J$1.templateStoreLocatorResultDetails
  }, resultDetailsCount && /*#__PURE__*/createElement(Body, {
    element: "h2"
  }, resultDetailsCount), /*#__PURE__*/createElement(CmsContentVisibility, {
    mobileVisibility: true,
    tabletVisibility: true,
    pcVisibility: false
  }, filterLabel && (/*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    alignment: "center"
  }, resultDetails, filterBadgeCount && (/*#__PURE__*/createElement(Badge, {
    content: filterBadgeCount,
    className: styles$J$1.templateStoreLocatorFilterBadge
  })))))), /*#__PURE__*/createElement(Keyline, null));
  return /*#__PURE__*/createElement(LayoutWrapper, __assign$1({
    element: "section",
    className: joinClasses(className, spacingStyles.mtSpacing05)
  }, props), pageHeading && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 12
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pageHeading)), searchSection && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    }
  }, searchSection)), /*#__PURE__*/createElement(Layout, {
    element: "section"
  }, /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 5
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, map && map, searchFilter && (/*#__PURE__*/createElement(CmsContentVisibility, {
    mobileVisibility: false,
    tabletVisibility: false,
    pcVisibility: true
  }, searchFilter))), /*#__PURE__*/createElement(CmsContentVisibility, {
    mobileVisibility: false,
    tabletVisibility: true,
    pcVisibility: true
  }, /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 7
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    inset: {
      left: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, promotionalSection, searchOption, resultDetails && resultDetailSection, searchResult && (/*#__PURE__*/createElement("div", {
    className: toggleMinHeight ? styles$J$1.templateStoreLocatorMinHeight : ''
  }, searchResult)))), /*#__PURE__*/createElement(CmsContentVisibility, {
    mobileVisibility: true,
    tabletVisibility: false,
    pcVisibility: false
  }, /*#__PURE__*/createElement(Fragment, null, (promotionalSection || searchOption) && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 7
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    inset: {
      left: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, promotionalSection, searchOption)), resultDetails && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 7
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    inset: {
      left: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, resultDetailSection)), searchResult && (/*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 7
    },
    gutter: {
      sm: true,
      md: true,
      lg: true
    },
    inset: {
      left: {
        sm: false,
        md: false,
        lg: true
      }
    },
    className: toggleMinHeight ? styles$J$1.templateStoreLocatorMinHeight : ''
  }, searchResult))))), navigationPath && (/*#__PURE__*/createElement(Layout, {
    element: "nav",
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: styles$J$1.breadcrumpWrapper
  }, navigationPath)));
};
TemplateStoreLocator.displayName = 'CoreTemplateStoreLocator';

var styles$K$1 = {"image-plus-text-collection":"fr-ec-image-plus-text-collection","imagePlusTextCollection":"fr-ec-image-plus-text-collection","image-plus-text-collection--content":"fr-ec-image-plus-text-collection--content","imagePlusTextCollectionContent":"fr-ec-image-plus-text-collection--content","carousel-indicator":"fr-ec-carousel-indicator","carouselIndicator":"fr-ec-carousel-indicator","image-plus-text-collection--lineup-indicator":"fr-ec-image-plus-text-collection--lineup-indicator","imagePlusTextCollectionLineupIndicator":"fr-ec-image-plus-text-collection--lineup-indicator","image-plus-text-collection__wrapper":"fr-ec-image-plus-text-collection__wrapper","imagePlusTextCollectionWrapper":"fr-ec-image-plus-text-collection__wrapper","swiper-wrapper":"fr-ec-swiper-wrapper","swiperWrapper":"fr-ec-swiper-wrapper","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","image-plus-text-collection--selected":"fr-ec-image-plus-text-collection--selected","imagePlusTextCollectionSelected":"fr-ec-image-plus-text-collection--selected","caption":"fr-ec-caption","image-plus-text-collection__children":"fr-ec-image-plus-text-collection__children","imagePlusTextCollectionChildren":"fr-ec-image-plus-text-collection__children","image-plus-text-collection--horizontal-small":"fr-ec-image-plus-text-collection--horizontal-small","imagePlusTextCollectionHorizontalSmall":"fr-ec-image-plus-text-collection--horizontal-small","image-plus-text-collection--horizontal-extra-small":"fr-ec-image-plus-text-collection--horizontal-extra-small","imagePlusTextCollectionHorizontalExtraSmall":"fr-ec-image-plus-text-collection--horizontal-extra-small","carousel-slide":"fr-ec-carousel-slide","carouselSlide":"fr-ec-carousel-slide","image-plus-text-collection--lineup__arrow-container":"fr-ec-image-plus-text-collection--lineup__arrow-container","imagePlusTextCollectionLineupArrowContainer":"fr-ec-image-plus-text-collection--lineup__arrow-container","image-plus-text-collection--lineup-arrow":"fr-ec-image-plus-text-collection--lineup-arrow","imagePlusTextCollectionLineupArrow":"fr-ec-image-plus-text-collection--lineup-arrow","image-swiper-button-next":"fr-ec-image-swiper-button-next","imageSwiperButtonNext":"fr-ec-image-swiper-button-next","image-swiper-button-prev":"fr-ec-image-swiper-button-prev","imageSwiperButtonPrev":"fr-ec-image-swiper-button-prev","swiper-button-disabled":"fr-ec-swiper-button-disabled","swiperButtonDisabled":"fr-ec-swiper-button-disabled"};

var testId$2$1 = {
  'data-testid': 'CoreImagePlusTextCollection'
};
var ImagePlusTextCollection = /** @class */function (_super) {
  __extends(ImagePlusTextCollection, _super);
  function ImagePlusTextCollection(props) {
    var _this = _super.call(this, props) || this;
    _this.loopSlider = false;
    _this.handleSlideChange = function () {
      var swiperInstance = _this.swiperInstance;
      if (_this.swiperInstance) {
        var activeIndex = swiperInstance.realIndex;
        _this.setState({
          activeIndex: activeIndex
        });
      }
    };
    _this.handleSnapIndexChange = function () {
      if (_this.swiperInstance) {
        _this.setState({
          snapGridIndex: _this.swiperInstance.snapIndex
        });
      }
    };
    _this.onResize = function () {
      var _a;
      if (isInBrowser$1()) {
        var breakpoint = getCurrentMediaQueryBreakpoint();
        _this.setState({
          isScreenView: breakpoint
        });
        if (_this.swiperInstance) {
          _this.swiperInstance.update();
          _this.setState({
            snapGridLength: (_a = _this.swiperInstance.snapGrid) === null || _a === void 0 ? void 0 : _a.length
          });
        }
      }
    };
    _this.togglePagination = function () {
      if (_this.swiperInstance) {
        return _this.swiperInstance.width < _this.swiperInstance.virtualSize && !(_this.swiperInstance.isBeginning && _this.swiperInstance.isEnd);
      }
      return false;
    };
    _this.state = {
      isScreenView: getCurrentMediaQueryBreakpoint(),
      activeIndex: 0,
      snapGridIndex: 0,
      snapGridLength: 0
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }
  ImagePlusTextCollection.prototype.componentDidMount = function () {
    var _a;
    if (this.props.variant === 'lineup') {
      this.initializeSwiper(this.state.isScreenView === 'sm');
    }
    if (this.swiperInstance) {
      this.setState({
        snapGridIndex: this.swiperInstance.snapIndex,
        snapGridLength: (_a = this.swiperInstance.snapGrid) === null || _a === void 0 ? void 0 : _a.length
      });
    }
  };
  ImagePlusTextCollection.prototype.initializeSwiper = function (loop) {
    var _this = this;
    if (this.swiperInstance) {
      this.swiperInstance.destroy();
    }
    this.swiperInstance = new swiper(this.swiperRef.current, {
      freeMode: true,
      navigation: {
        nextEl: '.image-swiper-button-next',
        prevEl: '.image-swiper-button-prev'
      },
      slidesPerView: 'auto',
      spaceBetween: 24,
      on: {
        slideChange: function slideChange() {
          return _this.handleSlideChange();
        },
        snapIndexChange: function snapIndexChange() {
          return _this.handleSnapIndexChange();
        }
      },
      loop: false,
      breakpoints: {
        959: {
          slidesOffsetBefore: 24
        },
        599: {
          slidesOffsetBefore: 16
        }
      }
    });
  };
  ImagePlusTextCollection.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      _b = _a.variant,
      variant = _b === void 0 ? 'navigationDetails' : _b,
      className = _a.className,
      selectedIndex = _a.selectedIndex,
      props = __rest$1(_a, ["children", "variant", "className", "loop", "selectedIndex"]);
    var lineUpChildren = Children.map(children, function (child, i) {
      return /*#__PURE__*/createElement(Fragment, {
        key: i
      }, /*#__PURE__*/cloneElement(child, __assign$1({
        className: joinClasses(i === selectedIndex && styles$K$1.imagePlusTextCollectionSelected, 'swiper-slide', child.className)
      }, child.props)));
    });
    var getContent = function getContent() {
      var isPagination = _this.togglePagination();
      var isLarge = _this.state.isScreenView === 'lg';
      switch (variant) {
        case 'lineup':
          return /*#__PURE__*/createElement("div", {
            className: styles$K$1.imagePlusTextCollectionContent
          }, /*#__PURE__*/createElement("div", {
            className: joinClasses('swiper-container'),
            ref: _this.swiperRef
          }, /*#__PURE__*/createElement("div", {
            className: joinClasses('swiper-wrapper')
          }, lineUpChildren)), lineUpChildren && lineUpChildren.length > 1 && isLarge && (/*#__PURE__*/createElement("div", {
            className: styles$K$1.imagePlusTextCollectionLineupArrowContainer
          }, /*#__PURE__*/createElement("button", {
            tabIndex: 0,
            className: joinClasses(styles$K$1.imagePlusTextCollectionLineupArrow, 'image-swiper-button-prev'),
            "aria-label": 'Previous Slide'
          }, /*#__PURE__*/createElement(Icon, {
            name: 'chevron-left'
          })), /*#__PURE__*/createElement("button", {
            tabIndex: 0,
            className: joinClasses(styles$K$1.imagePlusTextCollectionLineupArrow, 'image-swiper-button-next'),
            "aria-label": 'Next Slide'
          }, /*#__PURE__*/createElement(Icon, {
            name: 'chevron-right'
          })))), isPagination && (/*#__PURE__*/createElement(CarouselIndicator, {
            spacing: "auto",
            activeIndex: _this.state.snapGridIndex,
            indicatorLength: _this.state.snapGridLength,
            className: styles$K$1.imagePlusTextCollectionLineupIndicator
          })));
        case 'horizontalLarge':
          return /*#__PURE__*/createElement(CollectionList, {
            spacing: "24"
          }, children);
        case 'horizontalSmall':
          return /*#__PURE__*/createElement("div", {
            className: styles$K$1.imagePlusTextCollectionHorizontalSmall
          }, children);
        case 'horizontalExtraSmall':
          return /*#__PURE__*/createElement("div", {
            className: styles$K$1.imagePlusTextCollectionHorizontalExtraSmall
          }, children);
        default:
          return _this.state.isScreenView !== 'sm' ? (/*#__PURE__*/createElement("div", __assign$1({
            className: joinClasses(className, styles$K$1.imagePlusTextCollectionChildren)
          }, props), children)) : (/*#__PURE__*/createElement(Carousel, {
            hasArrows: false,
            variant: "ecRenewal",
            displayCount: {
              lg: 4.8,
              md: 4.8,
              sm: 2.35
            },
            noPadding: true
          }, children));
      }
    };
    return /*#__PURE__*/createElement(Measure, {
      onResize: debounce(100, this.onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", __assign$1({
        className: joinClasses(className, styles$K$1.imagePlusTextCollection)
      }, props, testId$2$1, {
        ref: measureRef
      }), getContent());
    });
  };
  ImagePlusTextCollection.displayName = 'CoreImagePlusTextCollection';
  ImagePlusTextCollection.defaultProps = {
    variant: 'navigationDetails',
    loop: false
  };
  return ImagePlusTextCollection;
}(Component);

var styles$M$1 = {"vertical-scroll":"fr-ec-vertical-scroll","verticalScroll":"fr-ec-vertical-scroll","vertical-container":"fr-ec-vertical-container","verticalContainer":"fr-ec-vertical-container","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","swiper-container-vertical":"fr-ec-swiper-container-vertical","swiperContainerVertical":"fr-ec-swiper-container-vertical","swiper-pagination-bullets":"fr-ec-swiper-pagination-bullets","swiperPaginationBullets":"fr-ec-swiper-pagination-bullets","swiper-vertical-pagination-bullet":"fr-ec-swiper-vertical-pagination-bullet","swiperVerticalPaginationBullet":"fr-ec-swiper-vertical-pagination-bullet","swiper-vertical-pagination-bullet-active":"fr-ec-swiper-vertical-pagination-bullet-active","swiperVerticalPaginationBulletActive":"fr-ec-swiper-vertical-pagination-bullet-active","swiper-container":"fr-ec-swiper-container","swiperContainer":"fr-ec-swiper-container","carousel-indicator-vertical":"fr-ec-carousel-indicator-vertical","carouselIndicatorVertical":"fr-ec-carousel-indicator-vertical","default-controls":"fr-ec-default-controls","defaultControls":"fr-ec-default-controls","default-controls-white":"fr-ec-default-controls-white","defaultControlsWhite":"fr-ec-default-controls-white","default-controls-black":"fr-ec-default-controls-black","defaultControlsBlack":"fr-ec-default-controls-black","vertical-scroll-wrapper":"fr-ec-vertical-scroll-wrapper","verticalScrollWrapper":"fr-ec-vertical-scroll-wrapper","vertical-scroll-without-overflow":"fr-ec-vertical-scroll-without-overflow","verticalScrollWithoutOverflow":"fr-ec-vertical-scroll-without-overflow"};

var VerticalScroll = /** @class */function (_super) {
  __extends(VerticalScroll, _super);
  function VerticalScroll(props) {
    var _this = _super.call(this, props) || this;
    _this.initializeSwiper = function (isDefault) {
      var children = _this.props.children;
      var childrenWithProps = Children.toArray(children).filter(isValidElement);
      _this.swiperInstance = new swiper(_this.swiperRef.current, {
        freeMode: isDefault ? false : true,
        initialSlide: _this.props.activeIndex || 0,
        centeredSlides: isDefault,
        direction: 'vertical',
        keyboard: {
          enabled: true,
          onlyInViewport: false
        },
        loop: true,
        mousewheel: {
          forceToAxis: true,
          invert: true,
          releaseOnEdges: true
        },
        on: {
          beforeResize: function beforeResize() {
            return _this.beforeResize();
          },
          slideChange: function slideChange() {
            return _this.onSlideChange();
          },
          slideNextTransitionEnd: function slideNextTransitionEnd() {
            return _this.onSlideTransitionEnd();
          },
          slideNextTransitionStart: function slideNextTransitionStart() {
            return _this.onSlideNext();
          },
          slidePrevTransitionEnd: function slidePrevTransitionEnd() {
            return _this.onSlideTransitionEnd();
          },
          slidePrevTransitionStart: function slidePrevTransitionStart() {
            return _this.onSlidePrev();
          },
          realIndexChange: function realIndexChange() {
            return _this.realIndexChange();
          }
        },
        pagination: isDefault ? {
          bulletActiveClass: 'swiper-vertical-pagination-bullet-active',
          bulletClass: 'swiper-vertical-pagination-bullet',
          bulletElement: 'span',
          clickable: false,
          el: '.swiper-pagination-v',
          type: 'bullets'
        } : {
          bulletActiveClass: 'fr-ec-carousel-indicator-item--active',
          bulletClass: 'fr-ec-carousel-indicator-item',
          bulletElement: 'p',
          clickable: false,
          el: 'swiper-pagination-v',
          type: 'bullets'
        },
        releaseOnEdges: isDefault,
        slidesPerView: isDefault ? 1 : 'auto',
        speed: isDefault ? getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400 : 800,
        touchReleaseOnEdges: isDefault,
        zoom: _this.props.enablePinchZoom ? {
          maxRatio: 3,
          minRatio: 1
        } : false,
        preloadImages: false
      });
    };
    _this.enableSwiper = function () {
      _this.swiperInstance.mousewheel.enable();
      _this.swiperInstance.allowTouchMove = true;
      _this.swiperInstance.keyboard.enable();
      _this.scrollTopValue = window.pageYOffset;
    };
    _this.componentDidUpdate = function (prevProps) {
      if (_this.swiperInstance) {
        if (prevProps.resetTrigger !== _this.props.resetTrigger) {
          _this.swiperInstance.slideToLoop(0);
          _this.enableSwiper();
        }
        if (_this.props.variant === 'ec-renewal-media-gallery' && prevProps.activeIndex !== _this.props.activeIndex) {
          _this.swiperInstance.slideToLoop(_this.props.activeIndex);
        }
        _this.swiperInstance.update();
      }
    };
    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', _this.reSizeHandler);
        document.getElementsByTagName('body')[0].classList.remove(styles$M$1.verticalScrollWithoutOverflow);
      }
      // Remove event listener of Arrow key-down event for making play-pause button fade effect
      document.removeEventListener('keydown', _this.handleKeyDown);
    };
    _this.reSizeHandler = function () {
      if (isInBrowser$1()) {
        _this.initialSwiperRender();
        _this.setState({
          isTouchDevice: isTouchDevice('touchPoints')
        });
      }
      if (_this.swiperRef.current) {
        var headerElem = document.querySelector(_this.headerClassName);
        _this.setState({
          headerHeight: headerElem && headerElem.offsetHeight || 0,
          isReRender: !_this.state.isReRender
        });
        _this.swiperInstance.update();
      }
    };
    _this.beforeResize = function () {
      if (getOS() === 'iOS' && getCurrentMediaQueryBreakpoint() === 'sm' && _this.swiperInstance.swipeDirection && _this.swiperInstance.swipeDirection === 'next') {
        _this.setState({
          isIosScrollResize: true
        });
      }
    };
    _this.onSlideTransitionEnd = function () {
      if (_this.state.isIosScrollResize) {
        _this.setState({
          isIosScrollResize: false
        });
      }
      // Below code is used to handle live station banner hide and show in iOS and android devices.
      // swiper slide height will be adjusted based on user interaction (swiping down or up)
      // Related changes are added in onSlideNext and onSlidePrev functions as well
      var homeWithBanner = document.querySelector('.fr-ec-template-home.fr-ec-template-home--with-live-station .fr-ec-template-home--promotion-banner-wrapper');
      if (_this.swiperInstance && homeWithBanner && _this.state.isTouchDevice) {
        var updateDivWithBanner = document.querySelector('.fr-ec-template-home.fr-ec-template-home--with-promotion-banner .fr-ec-vertical-scroll-group');
        var updateDivWithOutBanner = document.querySelector('.fr-ec-template-home .fr-ec-vertical-scroll-group');
        var index = 0;
        var updateSwipperDiv = document.querySelectorAll('.fr-ec-template-home .fr-ec-vertical-scroll');
        if (_this.state.isReRenderBanner) {
          if (updateDivWithOutBanner) {
            updateDivWithOutBanner.style.height = "".concat(window.innerHeight, "px");
          }
          if (updateSwipperDiv) {
            if (index < updateSwipperDiv.length) {
              for (index = 0; index < updateSwipperDiv.length; index++) {
                updateSwipperDiv[index].style.height = "".concat(window.innerHeight, "px");
              }
            }
          }
          _this.swiperInstance.update();
        } else {
          if (updateDivWithBanner) {
            updateDivWithBanner.style.height = "".concat(window.innerHeight - 45, "px");
          }
          if (updateSwipperDiv) {
            if (index < updateSwipperDiv.length) {
              for (index = 0; index < updateSwipperDiv.length; index++) {
                updateSwipperDiv[index].style.height = "".concat(window.innerHeight - 45, "px");
              }
            }
          }
          _this.swiperInstance.update();
        }
      }
      // loop condition, in which swiper will be showing slide with realindex instead of duplicate slide
      if (_this.swiperInstance) {
        if (_this.swiperInstance.realIndex === 0 || _this.swiperInstance.realIndex === _this.props.children.length - 1) {
          _this.swiperInstance.slideToLoop(_this.swiperInstance.realIndex, 0, false);
        }
      }
    };
    _this.onSlideChange = function () {
      var swiperInstance = _this.swiperInstance;
      if (swiperInstance) {
        var activeSlide = swiperInstance.realIndex;
        var prevSlide = swiperInstance.previousIndex;
        var slideWrapper = Array.from(swiperInstance.$wrapperEl)[0];
        var videos = Array.from(slideWrapper.getElementsByTagName('video') || []);
        _this.setState({
          activeSection: activeSlide
        });
        var wDelta = prevSlide < activeSlide ? 'down' : 'up';
        if (wDelta === 'down' && window.innerHeight - _this.state.headerHeight > swiperInstance.height || wDelta === 'up' && swiperInstance.height > window.innerHeight - _this.state.headerHeight) {
          _this.setState({
            isReRender: !_this.state.isReRender
          });
          swiperInstance.update();
        }
        if (_this.props.onScrollDirection && _this.props.variant === 'ec-renewal-media-gallery') {
          _this.props.onScrollDirection(_this.swiperInstance.realIndex + 1, wDelta, true);
        }
      }
    };
    _this.realIndexChange = function () {
      if (_this.swiperInstance) {
        var activeSlide = _this.swiperInstance.activeIndex;
        if (_this.props.onMediaView) {
          var mediaType = _this.swiperInstance.slides[activeSlide].dataset.mediaType;
          var fileName = _this.swiperInstance.slides[activeSlide].dataset.id;
          if (mediaType && fileName) {
            _this.props.onMediaView(_this.swiperInstance.slides[activeSlide], fileName, mediaType);
          }
        }
      }
    };
    // Below code changes are used to determine vertical scroll height in the initial render.
    _this.initialSwiperRender = function () {
      var updateDivWithBanner = document.querySelector('.fr-ec-template-home.fr-ec-template-home--with-promotion-banner .fr-ec-vertical-scroll-group');
      var updateDivWithNoBanner = document.querySelector('.fr-ec-template-home .fr-ec-vertical-scroll-group');
      if (updateDivWithBanner) {
        var updateSwipperDiv = document.querySelectorAll('.fr-ec-template-home .fr-ec-vertical-scroll');
        updateDivWithBanner.style.height = "".concat(window.innerHeight - 45, "px");
        if (updateSwipperDiv) {
          var index = 0;
          if (index < updateSwipperDiv.length) {
            for (index = 0; index < updateSwipperDiv.length; index++) {
              updateSwipperDiv[index].style.height = "".concat(window.innerHeight - 45, "px");
            }
          }
        }
      } else {
        var updateSwipperDiv = document.querySelectorAll('.fr-ec-template-home .fr-ec-vertical-scroll');
        if (updateDivWithNoBanner) {
          updateDivWithNoBanner.style.height = "".concat(window.innerHeight, "px");
        }
        if (updateSwipperDiv) {
          var index = 0;
          if (index < updateSwipperDiv.length) {
            for (index = 0; index < updateSwipperDiv.length; index++) {
              updateSwipperDiv[index].style.height = "".concat(window.innerHeight, "px");
            }
          }
        }
      }
      _this.setState({
        isReRenderBanner: true
      });
    };
    _this.onSlideNext = function () {
      if (!_this.state.isReRenderBanner && _this.state.isTouchDevice) {
        _this.initialSwiperRender();
      }
      if (_this.swiperRef && _this.swiperRef.current) {
        if (_this.swiperInstance && _this.props.onScrollDirection) {
          var scrollDirection = 'up';
          _this.props.onScrollDirection(_this.swiperInstance.realIndex, scrollDirection);
        }
      }
      if (_this.context && _this.context.setScrollDirection) {
        _this.context.setScrollDirection('up');
      }
      _this.copyRealSlidetoDuplicate();
    };
    _this.onSlidePrev = function () {
      if (_this.state.isReRenderBanner && _this.state.isTouchDevice) {
        _this.setState({
          isReRenderBanner: false
        });
      }
      if (_this.swiperRef && _this.swiperRef.current) {
        if (_this.swiperInstance && _this.props.onScrollDirection) {
          var scrollDirection = 'down';
          _this.props.onScrollDirection(_this.swiperInstance.realIndex, scrollDirection);
        }
      }
      if (_this.context && _this.context.setScrollDirection) {
        _this.context.setScrollDirection('down');
      }
      _this.copyRealSlidetoDuplicate();
    };
    _this.copyRealSlidetoDuplicate = function () {
      // on looping content of original slide will be copied to the duplicate slides at the moment of slide transition start
      if (_this.swiperInstance) {
        if (_this.swiperInstance.realIndex === 0 || _this.swiperInstance.realIndex === _this.props.children.length - 1) {
          var $wrapperEl_1 = _this.swiperInstance.$wrapperEl;
          var params_1 = _this.swiperInstance.params;
          var dupilcates_1 = $wrapperEl_1.children('.' + params_1.slideClass + '.' + params_1.slideDuplicateClass);
          dupilcates_1.each(function (i) {
            var idx = dupilcates_1[i].getAttribute('data-swiper-slide-index');
            var mediaElement = dupilcates_1[i].querySelector('img') || dupilcates_1[i].querySelector('video');
            var isSrcLoaded = mediaElement ? mediaElement.getAttribute('src') : null;
            if (!isSrcLoaded) {
              dupilcates_1[i].innerHTML = $wrapperEl_1.children('.' + params_1.slideClass + '[data-swiper-slide-index="' + idx + '"]:not(.' + params_1.slideDuplicateClass + ')').html();
            }
          });
        }
      }
    };
    _this.onSlideClick = function (e) {
      var _a, _b;
      if (_this.props.onClick) {
        var clickedItem = e.target;
        var mediaType = null;
        mediaType = (clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.querySelector('source')) ? 'video' : 'image';
        var fileUrl = mediaType === 'image' ? (_a = clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.dataset.src) !== null && _a !== void 0 ? _a : undefined : (_b = clickedItem === null || clickedItem === void 0 ? void 0 : clickedItem.dataset.src) !== null && _b !== void 0 ? _b : undefined;
        var fileName = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.split('/').pop().split('.')[0];
        _this.props.onClick(e, fileName, mediaType);
      }
    };
    _this.buttonFadeEffect = function () {
      if (isInBrowser$1()) {
        var hasPlayPauseButton = document.querySelectorAll('.fr-ec-default-controls');
        // Set opacity to 0 to hide the pla-pause button on swipe start
        hasPlayPauseButton.forEach(function (buttonControl) {
          var playPauseButtonControl = buttonControl;
          playPauseButtonControl.style.transition = 'opacity 0.2s';
          playPauseButtonControl.style.opacity = '0';
          // Set opacity to 1 after 300ms
          setTimeout(function () {
            playPauseButtonControl.style.opacity = '1';
          }, 300);
        });
      }
    };
    // To handle touch event for play-pause button fade effect
    _this.handlePointerDown = function () {
      _this.buttonFadeEffect();
    };
    // To handle Mouse wheel event for play-pause button fade effect
    _this.handleOnMouseWheel = function () {
      _this.buttonFadeEffect();
    };
    // To handle Arrow keydown event for play-pause button fade effect
    _this.handleKeyDown = function (e) {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        _this.buttonFadeEffect();
      }
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperSlideRef = [];
    _this.swiperInstance = null;
    _this.scrollTopValue = 0;
    _this.headerClassName = '.fr-ec-cms-promotion-banner--back-ground-black';
    _this.state = {
      activeSection: _this.props.activeIndex || 0,
      headerHeight: 0,
      isIosScrollResize: false,
      isReRender: false,
      isReRenderBanner: false,
      isTouchDevice: isTouchDevice('touchPoints')
    };
    return _this;
  }
  VerticalScroll.prototype.componentDidMount = function () {
    var _this = this;
    var headerElem = document.querySelector(this.headerClassName);
    if (isInBrowser$1()) {
      document.getElementsByTagName('body')[0].classList.add(styles$M$1.verticalScrollWithoutOverflow);
    }
    this.setState({
      headerHeight: headerElem && headerElem.offsetHeight || 0
    });
    var isDefault = this.props.variant === 'default';
    this.initializeSwiper(isDefault);
    // initialise the overflow condition to hidden.
    if (isInBrowser$1()) {
      window.addEventListener('resize', this.reSizeHandler);
    }
    if (document.getElementsByTagName('body')[0] && this.swiperRef.current) {
      var element = this.swiperRef.current.getBoundingClientRect();
      if (Math.round(element.bottom) === window.innerHeight + (headerElem && Math.round(headerElem.offsetHeight) || 73) && this.scrollTopValue === 0) {
        this.swiperInstance.mousewheel.enable();
        this.swiperInstance.allowTouchMove = true;
        this.swiperInstance.keyboard.enable();
      }
    }
    if (this.context && this.context.setScrollDirection) {
      this.context.setScrollDirection('down');
    }
    if (this.swiperRef.current) {
      this.swiperRef.current.addEventListener('click', function (e) {
        _this.onSlideClick(e);
      });
    }
    // To make the color of play-pause button with the carousel indicator color
    var hasPlayPauseButton = document.querySelectorAll('.fr-ec-default-controls');
    var hasWhiteCarouselIndicator = document.querySelector('.fr-ec-carousel-indicator-item-white');
    if (hasWhiteCarouselIndicator) {
      hasPlayPauseButton.forEach(function (element) {
        element.classList.add('fr-ec-default-controls-white');
      });
    } else {
      hasPlayPauseButton.forEach(function (element) {
        element.classList.add('fr-ec-default-controls-black');
      });
    }
    // To align the videoinline play-pause button 20px below the carousel indicator
    if (hasPlayPauseButton) {
      var hasCarouselIndicator = document.querySelector('.fr-ec-carousel-indicator');
      var carouselIndicatorHeight_1 = hasCarouselIndicator ? hasCarouselIndicator.getBoundingClientRect().height : 0;
      hasPlayPauseButton.forEach(function (playPauseButton) {
        playPauseButton.style.marginTop = "".concat(carouselIndicatorHeight_1, "px");
      });
      // Add event listener of Arrow key-down event for making play-pause button fade effect
      document.addEventListener('keydown', this.handleKeyDown);
    }
    if (isTouchDevice('touchPoints')) {
      this.initialSwiperRender();
    }
    disableFocusableElements(this.swiperRef);
  };
  VerticalScroll.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      className = _a.className,
      gaLabel = _a.gaLabel,
      gaCategory = _a.gaCategory,
      activeTabId = _a.activeTabId,
      props = __rest$1(_a, ["children", "className", "gaLabel", "gaCategory", "activeTabId", "onMediaView"]);
    var _b = this.state,
      activeSection = _b.activeSection;
    // since activeSection is taken from realIndex, which start from 0
    // we MUST increase it by 1 when we're sending it to GA
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
      var _a, _b, _c, _d, _e;
      var childGAProps = {};
      var mediaType = null;
      var slide = _this.swiperSlideRef[index];
      var videoElement = slide === null || slide === void 0 ? void 0 : slide.querySelector('video');
      mediaType = videoElement ? 'video' : 'image';
      var fileUrl = mediaType === 'image' ? (_b = (_a = _this.swiperSlideRef[index]) === null || _a === void 0 ? void 0 : _a.querySelector('img')) === null || _b === void 0 ? void 0 : _b.dataset.src : (_e = (_d = (_c = _this.swiperInstance) === null || _c === void 0 ? void 0 : _c.slides[index]) === null || _d === void 0 ? void 0 : _d.querySelector('video')) === null || _e === void 0 ? void 0 : _e.dataset.src;
      var fileName = fileUrl === null || fileUrl === void 0 ? void 0 : fileUrl.split('/').pop().split('.')[0];
      childGAProps = {
        'data-gtm-action': 'Read',
        'data-gtm-category': 'L1',
        'data-gtm-event-name': 'ua_event',
        'data-gtm-label': activeTabId !== undefined ? "".concat(activeTabId, "_").concat(activeSection + 1) : "".concat(activeSection + 1),
        'data-gtm-trigger': 'inView',
        'data-id': fileName,
        'data-media-type': mediaType,
        id: activeTabId !== undefined ? "cms-link-".concat(activeTabId, "_").concat(activeSection + 1) : "cms-link-".concat(activeSection + 1)
      };
      return /*#__PURE__*/createElement("div", __assign$1({
        key: index,
        className: joinClasses('swiper-slide'),
        ref: function ref(_ref) {
          return _this.swiperSlideRef[index] = _ref;
        }
      }, childGAProps, {
        onPointerDown: _this.handlePointerDown,
        onWheel: _this.handleOnMouseWheel
      }), /*#__PURE__*/cloneElement(child, {
        gaCategory: 'L1',
        gaLabel: activeTabId !== undefined ? "".concat(activeTabId, "_").concat(activeSection + 1) : "".concat(activeSection + 1)
      }));
    });
    var gaProps = {};
    if (gaCategory && gaLabel) {
      gaProps = {
        'data-category': gaCategory,
        'data-label': gaLabel
      };
    }
    var isDefault = this.props.variant === 'default';
    return /*#__PURE__*/createElement("div", __assign$1({
      className: joinClasses(styles$M$1.verticalScrollWrapper, className)
    }, gaProps, props), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$M$1.verticalScroll, className)
    }, /*#__PURE__*/createElement("div", {
      ref: this.swiperRef,
      className: joinClasses(styles$M$1.verticalContainer, 'swiper-container-v', className),
      "aria-hidden": "true"
    }, /*#__PURE__*/createElement("div", {
      className: "swiper-wrapper"
    }, childrenWithProps), isDefault ? (/*#__PURE__*/createElement(CarouselIndicator, {
      spacing: '15',
      activeIndex: this.state.activeSection,
      indicatorLength: childrenWithProps.length,
      direction: "vertical",
      backgroundColor: "white"
    })) : (/*#__PURE__*/createElement(CarouselIndicator, {
      spacing: '15',
      freeScroll: true,
      direction: "vertical",
      activeIndex: this.state.activeSection,
      indicatorLength: childrenWithProps.length,
      backgroundColor: "black"
    })))));
  };
  VerticalScroll.displayName = 'CoreVerticalScroll';
  VerticalScroll.defaultProps = {
    variant: 'default'
  };
  VerticalScroll.contextType = ScrollDirectionContext;
  return VerticalScroll;
}(Component);

var styles$N$1 = {"tabs":"fr-ec-tabs","tabs__content-wrapper":"fr-ec-tabs__content-wrapper","tabsContentWrapper":"fr-ec-tabs__content-wrapper","tabs--fit-content":"fr-ec-tabs--fit-content","tabsFitContent":"fr-ec-tabs--fit-content","tab":"fr-ec-tab","tab__label":"fr-ec-tab__label","tabLabel":"fr-ec-tab__label","tabs__active-style-hidden":"fr-ec-tabs__active-style-hidden","tabsActiveStyleHidden":"fr-ec-tabs__active-style-hidden","tabs__active-style-animated":"fr-ec-tabs__active-style-animated","tabsActiveStyleAnimated":"fr-ec-tabs__active-style-animated","tabs--with-active-style":"fr-ec-tabs--with-active-style","tabsWithActiveStyle":"fr-ec-tabs--with-active-style","tabs__active-style":"fr-ec-tabs__active-style","tabsActiveStyle":"fr-ec-tabs__active-style","tabs__black":"fr-ec-tabs__black","tabsBlack":"fr-ec-tabs__black","tab--is-active":"fr-ec-tab--is-active","tabIsActive":"fr-ec-tab--is-active","tab--type-gender":"fr-ec-tab--type-gender","tabTypeGender":"fr-ec-tab--type-gender","tabs__content":"fr-ec-tabs__content","tabsContent":"fr-ec-tabs__content","tabs__item":"fr-ec-tabs__item","tabsItem":"fr-ec-tabs__item","vertical-scroll-wrapper":"fr-ec-vertical-scroll-wrapper","verticalScrollWrapper":"fr-ec-vertical-scroll-wrapper","swipeable":"fr-ec-swipeable","tabs--boxed":"fr-ec-tabs--boxed","tabsBoxed":"fr-ec-tabs--boxed","tabs--small":"fr-ec-tabs--small","tabsSmall":"fr-ec-tabs--small","tabs--gender":"fr-ec-tabs--gender","tabsGender":"fr-ec-tabs--gender","tabs-hide":"fr-ec-tabs-hide","tabsHide":"fr-ec-tabs-hide","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","tabs-wrapper-class":"fr-ec-tabs-wrapper-class","tabsWrapperClass":"fr-ec-tabs-wrapper-class","tabs__swipeable-wrapper":"fr-ec-tabs__swipeable-wrapper","tabsSwipeableWrapper":"fr-ec-tabs__swipeable-wrapper","swipeable-tab":"fr-ec-swipeable-tab","swipeableTab":"fr-ec-swipeable-tab","tabs--swipeable__overlay-right":"fr-ec-tabs--swipeable__overlay-right","tabsSwipeableOverlayRight":"fr-ec-tabs--swipeable__overlay-right","tabs--swipeable__overlay-left":"fr-ec-tabs--swipeable__overlay-left","tabsSwipeableOverlayLeft":"fr-ec-tabs--swipeable__overlay-left","tabs--swipeable__navigation-btn-left":"fr-ec-tabs--swipeable__navigation-btn-left","tabsSwipeableNavigationBtnLeft":"fr-ec-tabs--swipeable__navigation-btn-left","tabs--swiper-button-disabled":"fr-ec-tabs--swiper-button-disabled","tabsSwiperButtonDisabled":"fr-ec-tabs--swiper-button-disabled","tabs--swipeable__navigation-btn":"fr-ec-tabs--swipeable__navigation-btn","tabsSwipeableNavigationBtn":"fr-ec-tabs--swipeable__navigation-btn","tabs--swipeable__navigation-btn-right":"fr-ec-tabs--swipeable__navigation-btn-right","tabsSwipeableNavigationBtnRight":"fr-ec-tabs--swipeable__navigation-btn-right","sticky-container":"fr-ec-sticky-container","stickyContainer":"fr-ec-sticky-container","sticky-tabs":"fr-ec-sticky-tabs","stickyTabs":"fr-ec-sticky-tabs","sticky-tabs-hide":"fr-ec-sticky-tabs-hide","stickyTabsHide":"fr-ec-sticky-tabs-hide","tabs__content--transition":"fr-ec-tabs__content--transition","tabsContentTransition":"fr-ec-tabs__content--transition","tab--boxed":"fr-ec-tab--boxed","tabBoxed":"fr-ec-tab--boxed","tabs-sticky-sp-md":"fr-ec-tabs-sticky-sp-md","tabsStickySpMd":"fr-ec-tabs-sticky-sp-md","tabs--no-padding":"fr-ec-tabs--no-padding","tabsNoPadding":"fr-ec-tabs--no-padding","tabs--two-child":"fr-ec-tabs--two-child","tabsTwoChild":"fr-ec-tabs--two-child"};

var Tabs = /** @class */function (_super) {
  __extends(Tabs, _super);
  function Tabs(props) {
    var _this = _super.call(this, props) || this;
    _this.onSlideChange = function () {
      if (_this.swiperInstance) {
        _this.setState({
          activeTabId: _this.swiperInstance.activeIndex,
          swipeValue: _this.swiperInstance.touches.diff
        }, function () {
          var _a, _b, _c, _d, _e;
          if (_this.tabsRef && _this.tabsRef.current) {
            var activeTabWidthValue = (_a = _this.tabsRef.current.querySelector('.fr-ec-tab--is-active .fr-ec-tab__label')) === null || _a === void 0 ? void 0 : _a.offsetWidth;
            var activeTabLeftValue = Number((_d = (_c = (_b = _this.tabsRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.querySelector('.fr-ec-tab--is-active')) === null || _d === void 0 ? void 0 : _d.offsetLeft) + Number((_e = _this.tabsRef.current.querySelector('.fr-ec-tab--is-active .fr-ec-tab__label')) === null || _e === void 0 ? void 0 : _e.offsetLeft);
            _this.setState({
              activeTabWidth: activeTabWidthValue !== undefined ? activeTabWidthValue : 0,
              activeTabLeft: activeTabLeftValue !== undefined ? activeTabLeftValue : 0
            });
          }
        });
        if (getCurrentMediaQueryBreakpoint() !== 'sm' && _this.state.swipeValue !== _this.swiperInstance.touches.diff) {
          _this.onSlideChangeCallBack();
        }
      }
    };
    _this.onSlideChangeCallBack = function () {
      if (_this.props.onSwipeChange && _this.swiperInstance) {
        _this.props.onSwipeChange(_this.swiperInstance.activeIndex, 'swipe');
      }
    };
    _this.updateActiveTabstyle = function () {
      var _a, _b, _c, _d, _e;
      if (_this.tabsRef && _this.tabsRef.current) {
        var activeTabWidthValue = (_a = _this.tabsRef.current.querySelector('.fr-ec-tab--is-active .fr-ec-tab__label')) === null || _a === void 0 ? void 0 : _a.offsetWidth;
        var activeTabLeftValue = Number((_d = (_c = (_b = _this.tabsRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.querySelector('.fr-ec-tab--is-active')) === null || _d === void 0 ? void 0 : _d.offsetLeft) + Number((_e = _this.tabsRef.current.querySelector('.fr-ec-tab--is-active .fr-ec-tab__label')) === null || _e === void 0 ? void 0 : _e.offsetLeft);
        _this.setState({
          activeTabWidth: activeTabWidthValue !== undefined ? activeTabWidthValue : 0,
          activeTabLeft: activeTabLeftValue !== undefined ? activeTabLeftValue : 0
        });
      }
    };
    _this.handleResize = function () {
      if (_this.props.stickyTabSpMd) {
        var checkSmallMediumViewport = getCurrentMediaQueryBreakpoint() === 'md' || getCurrentMediaQueryBreakpoint() === 'sm';
        _this.setState({
          isSmallMedium: checkSmallMediumViewport
        });
      }
      _this.updateActiveTabstyle();
      if (_this.swiperInstance) {
        _this.swiperInstance.update();
      }
    };
    _this.onTouchMove = function () {
      if (_this.swiperInstance) {
        _this.swiperInstance.update();
      }
    };
    _this.setSlideCentered = function () {
      if (isInBrowser$1() && (getCurrentMediaQueryBreakpoint() === 'lg' || getCurrentMediaQueryBreakpoint() === 'md') && _this.swiperInstance) {
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
      if (isInBrowser$1() && getCurrentMediaQueryBreakpoint() === 'sm' && _this.swiperInstance) {
        var swiperContainerWidth = _this.swiperInstance.width;
        var swiperSlide = _this.swiperInstance.slides[0];
        var possibleNumberOfSlides = Math.round(swiperContainerWidth / swiperSlide.clientWidth);
        var firstPossibleSlide = _this.state.activeTabId - possibleNumberOfSlides / 2;
        var lastPossibleSlide = _this.state.activeTabId + possibleNumberOfSlides / 2;
        var _a = _this.swiperInstance,
          slides = _a.slides,
          isBeginning = _a.isBeginning,
          isEnd = _a.isEnd;
        if (firstPossibleSlide >= 0 && lastPossibleSlide <= slides.length - 1 && !isBeginning && !isEnd) {
          _this.swiperInstance.params.centeredSlides = true;
        } else {
          _this.swiperInstance.params.centeredSlides = false;
        }
        _this.swiperInstance.update();
      }
    };
    _this.controlNavigation = function (direction) {
      if (_this.swiperInstance) {
        var slides = _this.swiperInstance.slides || 0;
        var _a = _this.swiperInstance,
          activeIndex = _a.activeIndex,
          isBeginning = _a.isBeginning,
          isEnd = _a.isEnd;
        var nextSlide = direction === 'NEXT' ? isEnd ? slides.length : activeIndex + 1 : isBeginning ? 0 : activeIndex - 1;
        if (direction === 'NEXT') {
          _this.swiperInstance.slideTo(nextSlide);
        } else {
          _this.swiperInstance.slideTo(nextSlide);
        }
        _this.swiperInstance.update();
        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };
    _this.handleScroll = function () {
      var _a;
      var offset = window.scrollY;
      var stickyTabsLastChildContent = document === null || document === void 0 ? void 0 : document.querySelector('.fr-ec-swipeable-tab-content >:last-child');
      if (_this.props.swipeable && isInBrowser$1()) {
        (_a = document === null || document === void 0 ? void 0 : document.querySelector('.fr-ec-swipeable-tab-content')) === null || _a === void 0 ? void 0 : _a.classList.add('fr-ec-tabs__content--transition');
        if (_this.props.enableAutoHide) {
          if (_this.state.hideTabs) {
            stickyTabsLastChildContent.style.marginBottom = "0px";
          } else {
            stickyTabsLastChildContent.style.marginBottom = "45px";
          }
        }
      }
      if (offset > _this.state.stickyTop) {
        _this.setState({
          isSticky: true
        });
      } else {
        _this.setState({
          isSticky: false
        });
      }
      _this.setState({
        hideTabs: offset > _this.state.prevScrollPos,
        prevScrollPos: offset > 0 ? offset : 0
      });
    };
    _this.handleFocus = function () {
      var _a, _b;
      var focusedElement = document.activeElement;
      (focusedElement.parentElement === ((_a = _this.tabsWrapperRef) === null || _a === void 0 ? void 0 : _a.current) || focusedElement.parentElement === ((_b = _this.swiperSlideRef) === null || _b === void 0 ? void 0 : _b.current)) && _this.setState({
        hideTabs: false
      });
    };
    _this.getVisibilityStyles = function () {
      if (isInBrowser$1() && _this.swiperInstance && _this.props.scrollContent) {
        for (var i = 0; i < _this.swiperInstance.slides.length; i++) {
          _this.swiperInstance.slides[i].style.visibility = 'visible';
        }
      }
    };
    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', _this.onTouchMove);
        window.removeEventListener('scroll', _this.handleScroll);
        window.addEventListener('keyup', _this.handleFocus);
      }
    };
    _this.onClick = function (label, index, child, tabOnclick) {
      return function (event, activeTabLabel) {
        _this.setState({
          activeTabId: index,
          activeTabLabel: activeTabLabel
        }, function () {
          var _a, _b, _c, _d, _e;
          if (_this.tabsRef && _this.tabsRef.current) {
            var activeTabWidthValue = (_a = _this.tabsRef.current.querySelector('.fr-ec-tab--is-active .fr-ec-tab__label')) === null || _a === void 0 ? void 0 : _a.offsetWidth;
            var activeTabLeftValue = Number((_d = (_c = (_b = _this.tabsRef) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.querySelector('.fr-ec-tab--is-active')) === null || _d === void 0 ? void 0 : _d.offsetLeft) + Number((_e = _this.tabsRef.current.querySelector('.fr-ec-tab--is-active .fr-ec-tab__label')) === null || _e === void 0 ? void 0 : _e.offsetLeft);
            _this.setState({
              activeTabWidth: activeTabWidthValue !== undefined ? activeTabWidthValue : 0,
              activeTabLeft: activeTabLeftValue !== undefined ? activeTabLeftValue : 0
            });
          }
        });
        if (_this.swiperInstance && _this.props.scrollContent || _this.props.swipeable) {
          _this.swiperInstance.slideTo(Number(index));
        }
        if (tabOnclick) {
          tabOnclick(event, label, index, child);
        }
      };
    };
    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    tabChilds = tabChilds.map(function (child, index) {
      return /*#__PURE__*/cloneElement(child, {
        index: index
      });
    });
    var activeChild = tabChilds.find(function (tabItem, index) {
      return Boolean(tabItem.props && index === _this.props.defaultIndex);
    }) || tabChilds[0];
    var activeChildProps = activeChild ? activeChild.props : {};
    var activeChildWithLabel = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildWithLabelProps = activeChildWithLabel ? activeChildWithLabel.props : {};
    _this.state = {
      activeTabId: activeChildProps.index ? activeChildProps.index : 0,
      activeTabLabel: activeChildWithLabelProps.label,
      swipeValue: 0,
      isBeginning: true,
      isEnd: false,
      stickyTop: 0,
      stickyTabSmMdTop: 0,
      isSticky: false,
      prevScrollPos: 0,
      hideTabs: false,
      activeTabWidth: 0,
      activeTabLeft: 0,
      isSmallMedium: false,
      touchDiffAfterTransition: 0
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperSlideRef = /*#__PURE__*/createRef();
    _this.tabsRef = /*#__PURE__*/createRef();
    _this.tabsWrapperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }
  Tabs.prototype.componentDidMount = function () {
    var _this = this;
    var tabChilds = Children.toArray(this.props.children).filter(isValidElement);
    var previousIndexVal = this.props.previousIndex;
    if (this.props.scrollContent) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        centeredSlides: true,
        initialSlide: previousIndexVal !== undefined ? previousIndexVal : this.state.activeTabId,
        keyboard: {
          enabled: true,
          onlyInViewport: false
        },
        loop: false,
        mousewheel: {
          forceToAxis: true,
          invert: true,
          releaseOnEdges: true
        },
        on: {
          slideChange: function slideChange() {
            return _this.onSlideChange();
          },
          transitionEnd: function transitionEnd() {
            var swiperInstance = _this.swiperInstance;
            if (swiperInstance) {
              _this.setState({
                touchDiffAfterTransition: swiperInstance.touches.diff
              });
              getCurrentMediaQueryBreakpoint() === 'sm' && swiperInstance && _this.state.touchDiffAfterTransition !== swiperInstance.touches.diff && _this.onSlideChangeCallBack();
            }
          },
          scroll: function scroll() {
            _this.props.onSwipeChange && _this.props.onSwipeChange(_this.swiperInstance.activeIndex, 'swipe');
          },
          keyPress: function keyPress(keyCode) {
            if ((keyCode === KEYCODE.LEFT || keyCode === KEYCODE.RIGHT) && _this.state.activeTabId !== _this.swiperInstance.realIndex) {
              _this.props.onSwipeChange && _this.props.onSwipeChange(_this.swiperInstance.activeIndex, 'swipe');
            }
          }
        },
        releaseOnEdges: true,
        slidesPerView: 1,
        touchReleaseOnEdges: true,
        speed: getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400
      });
      setTimeout(function () {
        if (_this.swiperInstance && _this.props.scrollContent) {
          _this.swiperInstance.slideTo(Number(_this.state.activeTabId));
        }
      }, 50);
      // Issue - https://jira.fastretailing.com/browse/UXDS-9908
      // During the SSR rendering the swiper is not getting initialized and the CSS styles are not there.
      // So the static HTML content will be available from the SSR response.
      // Based on the HTML structure, the Women's content is at the top level so when Swiper gets initialized in CSR it will show women's content first and
      // then only move to the corresponding index passed from SPA.
      // Solution mentioned below
      // We will initially set visibility: hidden to all non-active swiper slides and visibility: visible to active slide.
      // Later when it comes to CSR render we will update both to visibility: visible
      // Need to add same code inside componentDidUpdate to avoid white screen appearing issue in Home screen
      // https://jira.fastretailing.com/browse/UXDS-10062
      this.getVisibilityStyles();
    }
    if (this.props.swipeable) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next-tabs',
          prevEl: '.swiper-button-prev-tabs'
        },
        observeParents: true,
        observer: true,
        on: {
          sliderMove: function sliderMove() {
            return _this.onTouchMove();
          },
          slideChange: function slideChange() {
            _this.setState({
              isBeginning: _this.swiperInstance.isBeginning,
              isEnd: _this.swiperInstance.isEnd
            });
          },
          slideChangeTransitionEnd: function slideChangeTransitionEnd() {
            return _this.setSlideCentered();
          },
          reachEnd: function reachEnd() {
            return _this.setSlideCentered();
          },
          reachBeginning: function reachBeginning() {
            return _this.setSlideCentered();
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 0,
        centeredSlides: getCurrentMediaQueryBreakpoint() === 'sm' && this.state.activeTabId > 1 && this.state.activeTabId < tabChilds.length - 2 ? true : false
      });
      if (isInBrowser$1()) {
        window.addEventListener('resize', this.onTouchMove);
      }
      setTimeout(function () {
        if (_this.swiperInstance && _this.props.swipeable) {
          _this.swiperInstance.slideTo(Number(_this.state.activeTabId));
        }
      }, 50);
    }
    if (isInBrowser$1()) {
      var withNavHeader = this.props.isNavHeader ? document.querySelector('.fr-ec-navigation-header') : null;
      var stickySmMdTopValue = withNavHeader ? withNavHeader.clientHeight : 0;
      this.setState({
        stickyTabSmMdTop: stickySmMdTopValue
      });
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('keyup', this.handleFocus);
      this.updateActiveTabstyle();
    }
    if (isInBrowser$1()) {
      var templateHomeTabEl = document.querySelector('.fr-ec-template-home .fr-ec-tabs');
      var navWrapperTabEl = document.querySelector('.fr-ec-template-navigation--hide .fr-ec-tabs');
      if (navWrapperTabEl && templateHomeTabEl) {
        navWrapperTabEl.style.top = "".concat(templateHomeTabEl === null || templateHomeTabEl === void 0 ? void 0 : templateHomeTabEl.getBoundingClientRect().top, "px");
      }
    }
  };
  Tabs.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;
    var _a;
    var activeTabWidthValue;
    if (this.tabsRef && this.tabsRef.current) {
      activeTabWidthValue = (_a = this.tabsRef.current.querySelector('.fr-ec-tab--is-active .fr-ec-tab__label')) === null || _a === void 0 ? void 0 : _a.offsetWidth;
    }
    // prevState.activeTabWidth !== activeTabWidthValue
    // Above check is used to fix tab active border style issues while SPA conditionally render a <Tab> based on a flag
    if (prevProps.defaultIndex !== this.props.defaultIndex) {
      this.setState({
        activeTabId: Number(this.props.defaultIndex)
      }, function () {
        _this.updateActiveTabstyle();
        if (_this.swiperInstance && _this.props.scrollContent || _this.props.swipeable) {
          _this.swiperInstance.slideTo(Number(_this.state.activeTabId));
        }
      });
      if (!this.props.defaultIndex && this.swiperInstance) this.swiperInstance.slideToLoop(0);
    }
    if (prevState.activeTabWidth !== activeTabWidthValue && !this.props.swipeable) {
      this.updateActiveTabstyle();
    }
    if (isInBrowser$1()) {
      var navHeader = this.props.isNavHeader ? this.props.insideTemplateBase ? document.querySelector('.navigation-header') : document.querySelector('.fr-ec-navigation-header-wrapper  .fr-ec-navigation-header') : null;
      var topBanner = document.querySelector('.template-base__top-banner');
      var navHeaderHeight = navHeader ? navHeader.clientHeight : 0;
      var topBannerHeight = topBanner ? topBanner.clientHeight : 0;
      var stickyTopValue = navHeaderHeight + topBannerHeight;
      var withNavHeader = this.props.isNavHeader ? this.props.insideTemplateBase ? document.querySelector('.navigation-header') : document.querySelector('.fr-ec-navigation-header') : null;
      var stickySmMdTopValue = withNavHeader ? withNavHeader.clientHeight : 0;
      if (this.state.stickyTabSmMdTop !== stickySmMdTopValue) {
        this.setState({
          stickyTabSmMdTop: stickySmMdTopValue
        });
      }
      if (this.state.stickyTop !== stickyTopValue) {
        this.setState({
          stickyTop: stickyTopValue
        });
      }
      if (this.tabsRef && this.tabsRef.current) {
        var activeStyleIndicator = this.tabsRef.current.querySelector('.fr-ec-tabs__active-style-hidden');
        if (activeStyleIndicator) {
          // display the first active element directly, without initial animation
          activeStyleIndicator.classList.remove('fr-ec-tabs__active-style-hidden');
          activeStyleIndicator.classList.add('fr-ec-tabs__active-style-animated');
        }
      }
    }
    this.getVisibilityStyles();
  };
  Tabs.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      children = _a.children,
      className = _a.className,
      id = _a.id,
      _b = _a.type,
      type = _b === void 0 ? 'black' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'small' : _c,
      scrollContent = _a.scrollContent,
      _d = _a.swipeable,
      swipeable = _d === void 0 ? false : _d,
      sticky = _a.sticky,
      isNavHeader = _a.isNavHeader,
      _e = _a.enableSeo,
      enableSeo = _e === void 0 ? false : _e,
      _f = _a.fitContent,
      fitContent = _f === void 0 ? true : _f,
      _g = _a.enableAutoHide,
      enableAutoHide = _g === void 0 ? false : _g,
      _h = _a.tabIndex,
      tabIndex = _h === void 0 ? 0 : _h,
      tabsAriaLabel = _a.tabsAriaLabel,
      _j = _a.tabpanelRole,
      tabpanelRole = _j === void 0 ? 'tabpanel' : _j,
      _k = _a.stickyTabSpMd,
      stickyTabSpMd = _k === void 0 ? false : _k,
      _l = _a.insideTemplateBase,
      insideTemplateBase = _l === void 0 ? false : _l;
    var _m = this.state,
      activeTabId = _m.activeTabId,
      activeTabLabel = _m.activeTabLabel,
      stickyTop = _m.stickyTop,
      stickyTabSmMdTop = _m.stickyTabSmMdTop,
      isSmallMedium = _m.isSmallMedium;
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var activeContent = null;
    var scrollChildrenWithProps = Children.toArray(this.props.scrollContent).map(function (item, index) {
      if (_this.props.defaultIndex === index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses('swiper-slide', styles$N$1.tabsItem),
          style: {
            visibility: 'visible'
          }
        }, /*#__PURE__*/cloneElement(item, {
          activeTabId: activeTabId
        }));
      }
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses('swiper-slide', styles$N$1.tabsItem),
        style: {
          visibility: 'hidden'
        }
      }, /*#__PURE__*/cloneElement(item, {
        activeTabId: activeTabId
      }));
    });
    var getAllChildren = function getAllChildren() {
      return Children.toArray(children).filter(isValidElement).map(function (child, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: (child.props.isActive !== undefined ? child.props.label === activeTabLabel : index === activeTabId) ? '' : styles$N$1.tabsHide
        }, child.props.children);
      });
    };
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
      var tabLabel = child.props.label;
      if (child.props.isActive !== undefined ? child.props.label === activeTabLabel : index === activeTabId) {
        activeContent = child.props.children;
      }
      return /*#__PURE__*/cloneElement(child, {
        isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : index === activeTabId,
        key: tabLabel ? tabLabel.toUpperCase() + index : index,
        label: tabLabel,
        onClick: _this.onClick(tabLabel, index, child, child.props.onClick),
        textTransform: variant === 'gender' || variant === 'gender-boxed' ? 'all-caps' : 'normal',
        type: type === 'black' ? 'black' : 'white',
        variant: variant,
        tabIndex: tabIndex
      });
    });
    var swipeableChildrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
      var tabLabel = child.props.label;
      if (child.props.isActive !== undefined ? child.props.label === activeTabLabel : index === activeTabId) {
        activeContent = child.props.children;
      }
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: "swiper-slide",
        ref: _this.swiperSlideRef
      }, /*#__PURE__*/cloneElement(child, {
        isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : index === activeTabId,
        key: tabLabel ? tabLabel.toUpperCase() + index : index,
        label: tabLabel,
        onClick: _this.onClick(tabLabel, index, child, child.props.onClick),
        variant: variant,
        className: styles$N$1.swipeableTab
      }));
    });
    var swipeableChildrenWithPropsWrapper = /*#__PURE__*/createElement("nav", {
      className: styles$N$1.tabsSwipeableWrapper,
      "aria-label": tabsAriaLabel,
      ref: this.tabsWrapperRef
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-container', styles$N$1.tabs, styles$N$1.swipeable, fitContent && styles$N$1.tabsFitContent, className),
      ref: this.swiperRef
    }, /*#__PURE__*/createElement("div", {
      role: "tablist",
      className: joinClasses('swiper-wrapper', styles$N$1.tabsWrapperClass)
    }, swipeableChildrenWithProps)), breakpoint === 'lg' || 'md' ? (/*#__PURE__*/createElement(Fragment, null, !this.state.isEnd && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$N$1.tabsSwipeableOverlayRight
    }), /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "chevron-right",
      label: "arrow right",
      hideLabel: true,
      className: joinClasses('swiper-button-next-tabs', styles$N$1.tabsSwipeableNavigationBtn, styles$N$1.tabsSwipeableNavigationBtnRight),
      onClick: function onClick() {
        return _this.controlNavigation('NEXT');
      }
    }))), !this.state.isBeginning && (/*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$N$1.tabsSwipeableOverlayLeft
    }), /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "chevron-left",
      label: "arrow left",
      hideLabel: true,
      className: joinClasses('swiper-button-prev-tabs', styles$N$1.tabsSwipeableNavigationBtn, styles$N$1.tabsSwipeableNavigationBtnLeft),
      onClick: function onClick() {
        return _this.controlNavigation('PREV');
      }
    }))))) : null);
    var WithStickyTabSmMdTopStyle = {
      top: stickyTabSmMdTop && isNavHeader ? "".concat(stickyTabSmMdTop + 1, "px") : 0
    };
    var isFixedNavHeader = isInBrowser$1() ? insideTemplateBase ? document.querySelector('.navigation-header') : document.querySelector('.fr-ec-template-plp-fixed-header') : undefined;
    var uqProductSelectorContainerClass = '.fr-ec-cms-promotion-banner--back-ground-black';
    var guProductSelectorContainerClass = '.fr-ec-cms-promotion-banner--back-ground-blue';
    var headerFromSPA = isInBrowser$1() ? document.querySelector(uqProductSelectorContainerClass) || document.querySelector(guProductSelectorContainerClass) || document.querySelector('fr-ec-promotion-banner--full-width-ec') || document.querySelector('fr-ec-promotion-banner--wrapper') : undefined;
    var promoBanner = headerFromSPA === null || headerFromSPA === void 0 ? void 0 : headerFromSPA.clientHeight;
    var promoBannerHeight = promoBanner ? promoBanner : 0;
    var stickyTabsStyle = {
      position: 'fixed',
      top: headerFromSPA ? isFixedNavHeader ? "".concat(stickyTop, "px") : promoBannerHeight ? stickyTop + 1 : "".concat(stickyTop + 45, "px") : stickyTop + 1
    };
    var stickyTabContentStyle = {
      top: '45px'
    };
    var stickyTabContentStyleHide = {
      top: isFixedNavHeader ? 0 : "".concat(stickyTop, "px")
    };
    var withSticky = sticky ? (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$N$1.stickyTabs, this.state.hideTabs && styles$N$1.stickyTabsHide),
      style: stickyTabsStyle
    }, /*#__PURE__*/createElement(LayoutWrapper, {
      element: "section"
    }, /*#__PURE__*/createElement(Layout, {
      gutter: {
        sm: false,
        md: false,
        lg: true
      }
    }, swipeableChildrenWithPropsWrapper)))) : swipeableChildrenWithPropsWrapper;
    var childrenWithPropsWrapper = /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$N$1.tabs, stickyTabSpMd && isSmallMedium && styles$N$1.tabsStickySpMd, variant === 'gender' && "".concat(styles$N$1.tabsWithActiveStyle, " ").concat(styles$N$1.tabsGender), variant === 'small' && swipeable === false && styles$N$1.tabsWithActiveStyle, (variant === 'standard-boxed' || variant === 'gender-boxed') && styles$N$1.tabsBoxed, variant === 'small' && styles$N$1.tabsSmall, fitContent && variant !== 'gender-boxed' && variant !== 'standard-boxed' && styles$N$1.tabsFitContent, className, type === 'black' && styles$N$1.tabsBlack, children && children.length < 3 ? "".concat(styles$N$1.tabsNoPadding, " ").concat(styles$N$1.tabsTwoChild) : ''),
      role: "tablist",
      ref: this.tabsRef,
      "aria-label": tabsAriaLabel,
      style: stickyTabSpMd && isSmallMedium ? WithStickyTabSmMdTopStyle : {}
    }, childrenWithProps, (variant === 'gender' || variant === 'small' && swipeable === false) && (/*#__PURE__*/createElement("div", {
      className: joinClasses(styles$N$1.tabsActiveStyle, styles$N$1.tabsActiveStyleHidden),
      style: {
        left: "".concat(this.state.activeTabLeft, "px"),
        width: "".concat(this.state.activeTabWidth, "px")
      }
    })));
    // scrollContent is used only in the case of verticalScrollGroup
    // Which is used to get scrollable tab content
    if (variant === 'gender' && scrollContent) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Fragment, {
        key: id
      }, childrenWithPropsWrapper, /*#__PURE__*/createElement(Measure, {
        onResize: debounce(100, function () {
          return _this.handleResize();
        })
      }, function (_a) {
        var measureRef = _a.measureRef;
        return /*#__PURE__*/createElement("div", {
          ref: measureRef,
          className: styles$N$1.tabsContentWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses('swiper-container', className),
          ref: _this.swiperRef
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses('swiper-wrapper')
        }, scrollChildrenWithProps)));
      })));
    } else if (swipeable) {
      return /*#__PURE__*/createElement(Measure, {
        onResize: debounce(100, function () {
          return _this.handleResize();
        })
      }, function (_a) {
        var measureRef = _a.measureRef;
        return /*#__PURE__*/createElement("div", {
          ref: measureRef,
          key: id
        }, withSticky, /*#__PURE__*/createElement("div", {
          role: tabpanelRole,
          className: joinClasses(styles$N$1.tabsContent, 'fr-ec-swipeable-tab-content'),
          style: enableAutoHide ? !_this.state.hideTabs ? stickyTabContentStyle : stickyTabContentStyleHide : {}
        }, activeContent));
      });
    } else {
      return /*#__PURE__*/createElement(Measure, {
        onResize: debounce(100, function () {
          return _this.handleResize();
        })
      }, function (_a) {
        var measureRef = _a.measureRef;
        return /*#__PURE__*/createElement("div", {
          ref: measureRef,
          key: id
        }, /*#__PURE__*/createElement(Fragment, null, childrenWithPropsWrapper, /*#__PURE__*/createElement("div", {
          role: tabpanelRole,
          className: styles$N$1.tabsContent
        }, enableSeo ? /*#__PURE__*/createElement(Fragment, null, getAllChildren()) : activeContent)));
      });
    }
  };
  Tabs.displayName = 'CoreTabs';
  Tabs.defaultProps = {
    defaultIndex: 0
  };
  return Tabs;
}(Component);

var styles$O$1 = {"heading-link-text--wrap":"fr-ec-heading-link-text--wrap","headingLinkTextWrap":"fr-ec-heading-link-text--wrap","heading--full-width":"fr-ec-heading--full-width","headingFullWidth":"fr-ec-heading--full-width"};

var getText$2 = function getText(text) {
  return text && text.replace(/\\n|\n/g, '\n');
};
var Heading = function Heading(_a) {
  var _b, _c, _d, _e, _f, _g;
  var title = _a.title,
    _h = _a.type,
    type = _h === void 0 ? 'display1' : _h,
    linkText = _a.linkText,
    customContent = _a.customContent,
    url = _a.url,
    target = _a.target,
    _j = _a.htmlTag,
    htmlTag = _j === void 0 ? 'h1' : _j,
    gaLabel = _a.gaLabel,
    gaCategory = _a.gaCategory,
    className = _a.className,
    _k = _a.ecRenewal,
    ecRenewal = _k === void 0 ? true : _k,
    props = __rest$1(_a, ["title", "type", "linkText", "customContent", "url", "target", "htmlTag", "id", "gaLabel", "gaCategory", "className", "ecRenewal"]);
  var gaProps = {};
  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };
  }
  var customContents = customContent;
  var checkCustomContents = Children.toArray(customContent);
  return /*#__PURE__*/createElement("div", __assign$1({
    className: joinClasses(className, spacingStyles.mbSpacing04, customContent && ((_c = (_b = checkCustomContents[0]) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.children) || linkText ? styles$O$1.headingFullWidth : '')
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    justifyContent: "space-between",
    alignment: "center"
  }, /*#__PURE__*/createElement(Display, __assign$1({
    element: htmlTag === 'none' ? 'div' : htmlTag,
    variant: type
  }, gaProps), getText$2(title)), customContent && (/*#__PURE__*/createElement("div", {
    className: ((_d = customContents === null || customContents === void 0 ? void 0 : customContents.type) === null || _d === void 0 ? void 0 : _d.displayName) === 'LinkText' || ((_e = customContents === null || customContents === void 0 ? void 0 : customContents.type) === null || _e === void 0 ? void 0 : _e.displayName) === 'CoreLinkText' ? styles$O$1.headingLinkTextWrap : ''
  }, customContent)), linkText && !(customContent && ((_g = (_f = checkCustomContents[0]) === null || _f === void 0 ? void 0 : _f.props) === null || _g === void 0 ? void 0 : _g.children)) && (/*#__PURE__*/createElement("div", {
    className: styles$O$1.headingLinkTextWrap
  }, /*#__PURE__*/createElement(LinkText, {
    element: "a",
    href: url,
    target: target,
    typography: "bodyStandard",
    typographyColor: "noticeableBlue",
    ecRenewal: ecRenewal
  }, linkText)))));
};
Heading.displayName = 'CoreHeading';

export { Layout as $, ActionableContent as A, Badge as B, Caption as C, DeviceType as D, ExpandUtility as E, FlagText as F, Flyout as G, FlyoutNavigation as H, FlyoutSelect as I, Footer as J, FormRow as K, FormRowGroup as L, HeaderOverlay as M, HeaderPage as N, HeaderSection as O, HintError as P, HintText as Q, Icon as R, IconTypography as S, Image as T, ImageEnhancements as U, ImageOverlay as V, ImageTypography as W, Keyline as X, Label as Y, LabelInput as Z, __assign as _, DeviceTypeContext as a, CmsSpacer as a$, LayoutWrapper as a0, LinkCell as a1, LinkImage as a2, LinkImageGroup as a3, LinkNavigation as a4, LinkNavigationGroup as a5, LinkPrimaryNav as a6, LinkRegion as a7, LinkText as a8, LinkTextGroup as a9, Stepper as aA, StepperGroup as aB, StyleUserInfo as aC, StylingGrid as aD, Tab as aE, TabGroup as aF, Table as aG, Tag as aH, TemplateCart as aI, TemplateCheckout as aJ, TemplateFixedPanel as aK, TemplateInformation as aL, TextArea as aM, TextField as aN, Ticker as aO, Tile as aP, Title as aQ, Toast as aR, Tooltip as aS, Typeahead as aT, TypeaheadGroup as aU, VideoInline as aV, GutterContainer as aW, ProductTile as aX, Accordion as aY, TagFilter as aZ, TagFilterGroup as a_, List as aa, LoadingIndicator as ab, MediaObject as ac, MediaEnhancements as ad, Modal as ae, NavigationHeader as af, NavigationRibbon as ag, NoImage as ah, OrderStatusBar as ai, OverlayBackdrop as aj, OverlayWrapper as ak, OverlayBody as al, PinnedContainer as am, Price as an, QueryText as ao, Radio as ap, RadioGroup as aq, RatingStatic as ar, Review as as, ScaleInput as at, Search as au, Selector as av, SelectorGroup as aw, Sheet as ax, ShowMore as ay, Spacer as az, __rest as b, CmsLinkText as b0, CmsLink as b1, CmsImagePlusText as b2, CmsImagePlusTextCollection as b3, CmsImage as b4, CmsVideoInline as b5, ProductCollection as b6, CmsTicker as b7, CmsContentsCard as b8, CmsBreadcrumb as b9, Tabs as bA, Counter as bB, UtilityBar as bC, StickyContainer as bD, Grid as bE, CmsBreadcrumbs as ba, CmsAnnotation as bb, CmsHeading as bc, CmsText as bd, SearchHistoryItem as be, FixedPanel as bf, BalloonTip as bg, BalloonTipContainer as bh, ProductTable as bi, ButtonToggleGroup as bj, ComparisonTable as bk, DataTableCell as bl, DataTableRow as bm, DataTableBody as bn, DataTable as bo, Skeleton as bp, TemplateStoreLocator as bq, ChipGroup as br, MediaObjectLayout as bs, TemplateLogin as bt, BottomNavigation as bu, Link as bv, ImagePlusText as bw, ImagePlusTextCollection as bx, Heading as by, ContentsCard as bz, BadgeRanking as c, BadgeText as d, Body as e, Breadcrumb as f, BreadcrumbGroup as g, Button as h, ButtonFloating as i, ButtonIcon as j, ButtonLayout as k, ButtonToggle as l, Card as m, Carousel as n, Checkbox as o, CheckboxGroup as p, Chip as q, ChipGroupProductTile as r, CollectionGrid as s, CollectionList as t, CollectionListHorizontal as u, ContentAlignment as v, DescriptionList as w, Display as x, Drawer as y, Dropdown as z };
